(function () {
  'use strict';

  angular
  .module('hmapFront', [
    'ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ngStorage',
    'ui.router',
    'ngCacheBuster',
    'ui.bootstrap',
    'ui.select',
    // 'ui.bootstrap.datetimepicker',
    'ngFileUpload',
    'ngJsTree',
    'angular-loading-bar',
    'ng.ueditor',
    'toastr',
    'datatables',
    'datatables.bootstrap',
    'as.sortable',
    'angular-ladda',
    'chart.js',
    'pascalprecht.translate',
    'ja.qr'
  ])
  //.config(function (cfpLoadingBarProvider) {cfpLoadingBarProvider.includeSpinner = true;
  .run(run);

  run.$inject = ['stateHandler'];

  function run(stateHandler) {
    stateHandler.initialize();
  }
})();


(function() {
  'use strict';
  var templateContent = {
    template: '',
    controller: TemplateContentController,
    controllerAs: 'vm',
    bindings: {
      content: '@',
      contentVar:'='
    }
  };

  angular
    .module('hmapFront')
    .component('templateContent', templateContent);
  TemplateContentController.$inject = ['$compile','$scope','$element','$attrs','$sce','$q'];

  function TemplateContentController($compile,$scope,$element,$attrs,$sce,$q) {
    var vm = this;

    this.$onInit = function () {
      $attrs.$observe('content', function (value) {
        if(value!=undefined && value!=''){
          var regS = new RegExp("\\$\\{[A-Za-z]+\\}","g");
          var arr=value.match(regS);
          var result=value;
          for(var i=0,_length=arr.length;i<_length;i++){
            var _var=arr[i].replace("${","").replace("}","");
            result=result.replace(arr[i],"<input type='text' style='width: 60px;border: 1px solid #b7afaf' ng-model='vm.contentVar."+_var+"'/>");
          }
          var ele =$compile($.parseHTML(result))($scope);
          $element.html(ele);
        }else{
          $element.html("");
        }
      });
    };

  }
})();

/**
 * Created by zhouzy on 2016/11/14 0014.
 */
(function () {
  'use strict';
  var tagPermissionSelector = {
    templateUrl: 'app/tpl/tag-permission-area.html',
    controller: TagPermissionSelectorController,
    controllerAs: 'vm',
    bindings: {
      id: "@",
      name: "@",
      permissionData: '='
    }
  };

  angular
    .module('hmapFront')
    .component('tagPermissionSelector', tagPermissionSelector);
  TagPermissionSelectorController.$inject = ['$uibModal', 'Hmapfe'];

  function TagPermissionSelectorController($uibModal, Hmapfe) {
    var vm = this;
    vm.open = open;

    this.$onInit = function () {
      Hmapfe.log('$onInit');
      Hmapfe.log(vm.permissionData);
    }
    function open() {
      Hmapfe.log(vm.permissionData);
      $uibModal.open({
        templateUrl: 'app/tpl/tag-permission-selector.html',
        controller: TagPermissionSelectorModalController,
        controllerAs: 'vm',
        size: 'md',
        backdrop: 'static',
        resolve: {
          permissionData: function () {
            return vm.permissionData;
          }
        }
      }).result.then(function (result) {
          console.info("I was closed, so do what I need to do myContent's controller now.  Result was->");
          console.info(result);
          vm.permissionData = result;
        }, function (reason) {
          console.info("I was dimissed, so do what I need to do myContent's controller now.  Reason was->" + reason);
        });
    };
  }

  //var permissionModal = {
  //  //templateUrl:'app/tpl/permission-selector.html',
  //  template: '<div class="modal-body"><div>{{$ctrl.greeting}}</div><label>Name To Edit</label> <input ng-model="$ctrl.modalData.name"><br>  <label>Value To Edit</label> <input ng-model="$ctrl.modalData.value"><br><button class="btn btn-warning" type="button" ng-click="$ctrl.handleClose()">Close Modal</button><button class="btn btn-warning" type="button" ng-click="$ctrl.handleDismiss()">Dimiss Modal</button></div>',
  //  controller: PermissionModalController,
  //  controllerAs: '$ctrl',
  //  bindings: {
  //    modalInstance: "<",
  //    resolve: "<"
  //  }
  //};
  //
  //angular
  //  .module('hmapFront')
  //  .component('permissionModal', permissionModal);
  TagPermissionSelectorModalController.$inject = ['$state', 'Contacts', 'paginationConstants', '$log', '$scope','$rootScope', '$uibModal', '$localStorage', 'Hmapfe', '$uibModalInstance', 'permissionData'];

  function TagPermissionSelectorModalController($state, Contacts, paginationConstants, $log, $scope,$rootScope, $uibModal, $localStorage, Hmapfe, $uibModalInstance, permissionData) {
    var vm = this;
    vm.permissionData = permissionData;

    vm.page = 1;
    vm.isStaffShow = false;
    vm.isSpinnerShow = false;
    vm.isOrgShow = true;
    vm.isTagShow = false;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.selectedData = [];
    vm.searchData=[];
    vm.jsTreeData = [];
    vm.deptData = [];
    vm.dept = {};
    vm.treeConfig = {};
    vm.detailTreeConfig = {};
    vm.treeInstance = {};
    vm.memberTreetailInstance = {};
    vm.currentDept = {};
    vm.checkedNodes = [];
    vm.allDepts = [];
    vm.allTags = [];
    vm.allTransferedDepts = [];
    vm.allTransferedTags = [];
    vm.allTransferedStaffs = [];
    vm.staffs = [];
    vm.deptTreeEventsObj = {};
    vm.memberTreeEventsObj = {};

    vm.permissionDataInitialize = permissionDataInitialize;
    vm.initData = initData;
    vm.dataTransfer = dataTransfer;
    vm.getSelectedNode = getSelectedNode;

    vm.selectOrg = selectOrg;
    vm.selectTag = selectTag;
    vm.selectDetail = selectDetail;
    vm.checkedData = checkedData;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.tagDetail = tagDetail;
    vm.onRemoveCallback = onRemoveCallback;
    vm.onSelectCallback=onSelectCallback;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.close = close;
    vm.permissionAutocomplete=permissionAutocomplete;
    vm.permissionDataInitialize();
    vm.initData();
    vm.dataTransfer();


    vm.deptTreeEventsObj = {
      activate_node: selectDeptTree
    };
    vm.memberTreeEventsObj = {
      activate_node: selectMemberTree
    };
    function selectMemberTree(e, i) {
      vm.currentDept.deptNumber = i.node.id;
      vm.currentDept.deptName = i.node.text;
      loadDeptStaff();
    }

    function selectDeptTree(e, i) {
      Hmapfe.log(i);
      var dept = {};
      dept.dataType = 'dept';
      dept.dataValue = i.node.text;
      dept.dataId = i.node.id;
      dept.dataIcon = 'fa fa-folder';
      dept.checked = 'Y';

      if (vm.selectedData.length==0) {
        vm.selectedData.push(dept);
      } else {
        if (!existsInArray(dept, vm.selectedData)) {
          vm.selectedData.splice(getPosInArray(dept, vm.selectedData), 1);
        }else{
          vm.selectedData.push(dept);
        }
      }

    }

    function loadDeptStaff() {
      vm.isStaffShow = false;
      vm.isSpinnerShow = true;
      vm.dept.deptNumber = vm.currentDept.deptNumber;
      vm.dept.page = vm.page;
      vm.dept.pagesize = vm.itemsPerPage;

      Contacts.findDeptStaff().get(vm.dept, onStaffSuccess, onError);
    }

    function permissionDataInitialize() {

      if (vm.permissionData && vm.permissionData.length) {
        for (var i = 0; i < vm.permissionData.length; i++) {
          vm.selectedData.push(vm.permissionData[i]);
        }
      }
    }

    //在初始化数据时，需要把已经选择的数据勾选
    function initializeSelectedData(pendingData) {
      for (var i = 0; i < vm.selectedData.length; i++) {
        if (vm.selectedData[i].dataType == 'tag'||vm.selectedData[i].dataType == 'staff') {
          for (var j = 0; j < pendingData.length; j++) {
            if (vm.selectedData[i].dataId == pendingData[j].dataId && vm.selectedData[i].dataType == pendingData[j].dataType) {
              pendingData[j].checked = 'Y';
              break;
            }
          }
        }
        //如果是部门，需要处理树型结构里面的数据，设置为可选
        //vm.jsTreeData
        else if(vm.selectedData[i].dataType == 'dept'){
          for (var j = 0; j < vm.jsTreeData.length; j++) {
            if(vm.selectedData[i].dataId==vm.jsTreeData[j].id){
              vm.jsTreeData[j].state.open=true;
              vm.jsTreeData[j].state.selected=true;
              break;
            }
          }
        }
      }
    }

    function initData() {
      vm.treeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'checkbox']
      };
      angular.copy($localStorage.deptData,vm.jsTreeData);
      angular.copy($localStorage.deptData,vm.allDepts);
      angular.copy($localStorage.allTags,vm.allTags);
      //将已经选中的数据显示在这里
      initializeSelectedData(vm.jsTreeData);
    }

    function initDetailData() {
      vm.detailTreeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'dnd']
      };
      vm.jsMemberTreeData = $localStorage.deptData;
    }

    function getSelectedNode() {
      vm.checkedNodes = vm.treeInstance.jstree(true).get_selected();
    }

    function onStaffSuccess(data, headers) {
      vm.staffs = data.rows;
      staffsTransfer(vm.staffs);
      vm.totalItems = data.total;
      vm.isStaffShow = true;
      vm.isSpinnerShow = false;
    }

    function onError(error) {
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadDeptStaff();
    };

    function selectTag() {
      vm.isOrgShow = false;
      vm.isTagShow = true;
    }

    function selectOrg() {
      vm.isOrgShow = true;
      vm.isTagShow = false;
      //getAllTags
    }

    function selectDetail() {
      initDetailData();
    }

    function close() {
      if(vm.selectedData != null){
        $rootScope.$broadcast('selectDataToTag',vm.selectedData);
      }
      $uibModalInstance.close(vm.selectedData);
    }

    function clear() {
      Hmapfe.log('clear');
      $uibModalInstance.dismiss('cancel');
    }

    function tagDetail() {
      Hmapfe.log('tagDetail');
    }

    function checkedData(obj, event) {
      var isChecked = event.target.checked;
      if (isChecked) {
        if (existsInArray(obj, vm.selectedData)) {
          vm.selectedData.push(obj);
        }
      }
      else {
        vm.selectedData.splice(getPosInArray(obj, vm.selectedData), 1);
        obj.checked = 'N';
      }
    }


    function dataTransfer() {
      //deptsTransfer();
      tagsTransfer();
    }

    function deptsTransfer() {
      for (var i = 0; i < vm.allDepts.length; i++) {
        var dept = {};
        dept.dataType = 'tag';
        dept.dataValue = vm.allDepts[i].text;
        dept.dataId = vm.allDepts[i].id;
        dept.dataIcon = 'fa fa-folder';
        dept.checked = 'N';
        vm.allTransferedDepts.push(dept);
      }
    }

    function tagsTransfer() {
      for (var i = 0; i < vm.allTags.length; i++) {
        var tag = {};
        tag.dataType = 'tag';
        tag.dataValue = vm.allTags[i].tagName;
        tag.dataId = vm.allTags[i].id;
        tag.dataIcon = 'fa fa-tag';
        tag.checked = 'N';
        vm.allTransferedTags.push(tag);
        initializeSelectedData(vm.allTransferedTags);
      }
    }

    function staffsTransfer(staffs) {
      vm.allTransferedStaffs=[];
      for (var i = 0; i < staffs.length; i++) {
        var staff = {};
        staff.dataType = 'staff';
        staff.dataValue = staffs[i].userName;
        staff.dataId = staffs[i].accountNumber;
        staff.dataIcon = 'fa fa-user';
        staff.checked = 'N';
        vm.allTransferedStaffs.push(staff);
      }
      initializeSelectedData(vm.allTransferedStaffs);
    }

    function existsInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].dataId === obj.dataId && array[i].dataType === obj.dataType)
          return false;
      }
      return true;
    }

    function getPosInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].dataId === obj.dataId && array[i].dataType === obj.dataType)
          return i;
      }
      return 0;
    }

    function onRemoveCallback(item, model) {
      if (item.dataType == 'staff') {
        for (var i = 0; i < vm.allTransferedStaffs.length; i++) {
          if (vm.allTransferedStaffs[i].dataId === item.dataId) {
            vm.allTransferedStaffs[i].checked = 'N';
            return;
          }
        }
      }

      if (item.dataType == 'tag') {
        for (var i = 0; i < vm.allTransferedTags.length; i++) {
          if (vm.allTransferedTags[i].dataId === item.dataId) {
            vm.allTransferedTags[i].checked = 'N';
            return;
          }
        }
      }

      if (item.dataType == 'dept') {
        //需要从树里面设置选中标记
        for (var i = 0; i < vm.jsTreeData.length; i++) {
          if (vm.jsTreeData[i].id == item.dataId) {
            //vm.jsTreeData[i].state=false;
            vm.treeInstance.jstree(true).deselect_node(vm.jsTreeData[i], false);
            return;
          }
        }
      }
    }
    function onSelectCallback(item, model){
      //处理选中时的事件


      if (item.dataType == 'tag') {
        for (var i = 0; i < vm.allTransferedTags.length; i++) {
          if (vm.allTransferedTags[i].dataId === item.dataId) {
            vm.allTransferedTags[i].checked = 'Y';
            return;
          }
        }
      }

      if (item.dataType == 'dept') {
        Hmapfe.log('dept');
        //需要从树里面设置选中标记
        for (var i = 0; i < vm.jsTreeData.length; i++) {
          if (vm.jsTreeData[i].id == item.dataId) {
            //vm.jsTreeData[i].state=false;
            vm.treeInstance.jstree(true).open_node(vm.jsTreeData[i]);
            vm.treeInstance.jstree(true).select_node(vm.jsTreeData[i], false);
            Hmapfe.log('预计选定节点');
            return;
          }
        }
      }
    }
    function permissionAutocomplete(search){
      vm.searchData=[];
      if(search){
        Contacts.contactStaffAndDeptListSearch().search({key:search}, onSearchSuccess, onError);
      }

    }
    function onSearchSuccess(data, headers){
      var searchResult=data.rows;
      vm.searchData = [];
      for(var i=0;i<searchResult.length;i++){

        if(vm.selectedData.length == 0){
          searchResult[i].checked = 'Y';
          vm.searchData.push(searchResult[i]);
        }else{
          var flag =false;
          for(var j=0;j<vm.selectedData.length;j++){
            if(vm.selectedData[j].dataId == searchResult[i].dataId){
              flag = true;
            }
          }
          if(!flag){
            searchResult[i].checked = 'Y';
            vm.searchData.push(searchResult[i]);
          }
        }

        //vm.searchData.push(searchResult[i]);
      }

    }
  }
})();

/**
 * Created by zhouzy on 2016/11/14 0014.
 */
(function () {
  'use strict';
  var staffPermissionSelector = {
    templateUrl: 'app/tpl/staff-permission-area.html',
    controller: StaffPermissionSelectorController,
    controllerAs: 'vm',
    bindings: {
      id: "@",
      name: "@",
      permissionData: '='
    }
  };

  angular
    .module('hmapFront')
    .component('staffPermissionSelector', staffPermissionSelector);
  StaffPermissionSelectorController.$inject = ['$uibModal', 'Hmapfe'];

  function StaffPermissionSelectorController($uibModal, Hmapfe) {
    var vm = this;
    vm.open = open;

    this.$onInit = function () {
      Hmapfe.log('$onInit');
      Hmapfe.log(vm.permissionData);
    }
    function open() {
      Hmapfe.log(vm.permissionData);
      $uibModal.open({
        templateUrl: 'app/tpl/staff-permission-selector.html',
        controller: StaffPermissionModalController,
        controllerAs: 'vm',
        size: 'md',
        backdrop: 'static',
        resolve: {
          permissionData: function () {
            return vm.permissionData;
          }
        }
      }).result.then(function (result) {
          console.info("I was closed, so do what I need to do myContent's controller now.  Result was->");
          console.info(result);
          vm.permissionData = result;
        }, function (reason) {
          console.info("I was dimissed, so do what I need to do myContent's controller now.  Reason was->" + reason);
        });
    };
  }

  //var permissionModal = {
  //  //templateUrl:'app/tpl/permission-selector.html',
  //  template: '<div class="modal-body"><div>{{$ctrl.greeting}}</div><label>Name To Edit</label> <input ng-model="$ctrl.modalData.name"><br>  <label>Value To Edit</label> <input ng-model="$ctrl.modalData.value"><br><button class="btn btn-warning" type="button" ng-click="$ctrl.handleClose()">Close Modal</button><button class="btn btn-warning" type="button" ng-click="$ctrl.handleDismiss()">Dimiss Modal</button></div>',
  //  controller: PermissionModalController,
  //  controllerAs: '$ctrl',
  //  bindings: {
  //    modalInstance: "<",
  //    resolve: "<"
  //  }
  //};
  //
  //angular
  //  .module('hmapFront')
  //  .component('permissionModal', permissionModal);
  StaffPermissionModalController.$inject = ['$state', 'Contacts', 'paginationConstants', '$log', '$scope', '$uibModal', '$localStorage', 'Hmapfe', '$uibModalInstance', 'permissionData'];

  function StaffPermissionModalController($state, Contacts, paginationConstants, $log, $scope, $uibModal, $localStorage, Hmapfe, $uibModalInstance, permissionData) {
    var vm = this;
    vm.permissionData = permissionData;

    vm.page = 1;
    vm.isStaffShow = false;
    vm.isSpinnerShow = false;
    vm.isOrgShow = true;
    vm.isTagShow = false;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.selectedData = [];
    vm.searchData=[];
    vm.jsTreeData = [];
    vm.deptData = [];
    vm.dept = {};
    vm.treeConfig = {};
    vm.detailTreeConfig = {};
    vm.treeInstance = {};
    vm.memberTreetailInstance = {};
    vm.currentDept = {};
    vm.checkedNodes = [];
    vm.allDepts = [];
    vm.allTags = [];
    vm.allTransferedDepts = [];
    vm.allTransferedTags = [];
    vm.allTransferedStaffs = [];
    vm.staffs = [];
    vm.deptTreeEventsObj = {};
    vm.memberTreeEventsObj = {};

    vm.permissionDataInitialize = permissionDataInitialize;
    vm.initData = initData;
    vm.dataTransfer = dataTransfer;
    vm.getSelectedNode = getSelectedNode;

    vm.selectOrg = selectOrg;
    vm.selectTag = selectTag;
    vm.selectDetail = selectDetail;
    vm.checkedData = checkedData;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.tagDetail = tagDetail;
    vm.onRemoveCallback = onRemoveCallback;
    vm.onSelectCallback=onSelectCallback;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.close = close;
    vm.permissionAutocomplete=permissionAutocomplete;
    vm.permissionDataInitialize();
    vm.initData();
    vm.dataTransfer();


    vm.deptTreeEventsObj = {
      activate_node: selectDeptTree
    };
    vm.memberTreeEventsObj = {
      activate_node: selectMemberTree
    };
    function selectMemberTree(e, i) {
      vm.currentDept.deptNumber = i.node.id;
      vm.currentDept.deptName = i.node.text;
      loadDeptStaff();
    }

    function selectDeptTree(e, i) {
      Hmapfe.log(i);
      var dept = {};
      dept.dataType = 'dept';
      dept.dataValue = i.node.text;
      dept.dataId = i.node.id;
      dept.dataIcon = 'fa fa-folder';
      dept.checked = 'Y';
      vm.selectedData.push(dept);

    }

    function loadDeptStaff() {
      vm.isStaffShow = false;
      vm.isSpinnerShow = true;
      vm.dept.deptNumber = vm.currentDept.deptNumber;
      vm.dept.page = vm.page;
      vm.dept.pagesize = vm.itemsPerPage;

      Contacts.findDeptStaff().get(vm.dept, onStaffSuccess, onError);
    }

    function permissionDataInitialize() {

      if (vm.permissionData && vm.permissionData.length) {
        for (var i = 0; i < vm.permissionData.length; i++) {
          vm.selectedData.push(vm.permissionData[i]);
        }
      }
    }

    //在初始化数据时，需要把已经选择的数据勾选
    function initializeSelectedData(pendingData) {
      for (var i = 0; i < vm.selectedData.length; i++) {
        if (vm.selectedData[i].dataType == 'staff') {
          for (var j = 0; j < pendingData.length; j++) {
            if (vm.selectedData[i].dataId == pendingData[j].dataId && vm.selectedData[i].dataType == pendingData[j].dataType) {
              pendingData[j].checked = 'Y';
              break;
            }
          }
        }

      }
    }

    function initData() {
      vm.treeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'checkbox']
      };
      angular.copy($localStorage.deptData,vm.jsTreeData);
      angular.copy($localStorage.deptData,vm.allDepts);
      angular.copy($localStorage.allTags,vm.allTags);
      //将已经选中的数据显示在这里
      initializeSelectedData(vm.jsTreeData);
    }

    function initDetailData() {
      vm.detailTreeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'dnd']
      };
      vm.jsMemberTreeData = $localStorage.deptData;
    }

    function getSelectedNode() {
      vm.checkedNodes = vm.treeInstance.jstree(true).get_selected();
    }

    function onStaffSuccess(data, headers) {
      vm.staffs = data.rows;
      staffsTransfer(vm.staffs);
      vm.totalItems = data.total;
      vm.isStaffShow = true;
      vm.isSpinnerShow = false;
    }

    function onError(error) {
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadDeptStaff();
    };

    function selectTag() {
      vm.isOrgShow = false;
      vm.isTagShow = true;
    }

    function selectOrg() {
      vm.isOrgShow = true;
      vm.isTagShow = false;
      //getAllTags
    }

    function selectDetail() {
      initDetailData();
    }

    function close() {
      $uibModalInstance.close(vm.selectedData);
    }

    function clear() {
      Hmapfe.log('clear');
      $uibModalInstance.dismiss('cancel');
    }

    function tagDetail() {
      Hmapfe.log('tagDetail');
    }

    function checkedData(obj, event) {
      var isChecked = event.target.checked;
      console.log("0000: "+isChecked);

      /*for (var j = 0; j < vm.allTransferedStaffs.length; j++) {
        vm.allTransferedStaffs[j].checked = 'N';
      }*/

      if (isChecked) {
        for (var j = 0; j < vm.allTransferedStaffs.length; j++) {
          if(obj.dataId != vm.allTransferedStaffs[j].dataId){
            vm.allTransferedStaffs[j].checked = 'N';
          }

        }
        if (existsInArray(obj, vm.selectedData)) {
          for (var i = 0; i < vm.selectedData.length; i++) {
            vm.selectedData[i].checked = 'N';
          }
          vm.selectedData=[];

          vm.selectedData.push(obj);
        }
      }
      else {
        vm.selectedData.splice(getPosInArray(obj, vm.selectedData), 1);
        obj.checked = 'N';
      }
    }


    function dataTransfer() {
      //deptsTransfer();
      tagsTransfer();
    }

    function deptsTransfer() {
      for (var i = 0; i < vm.allDepts.length; i++) {
        var dept = {};
        dept.dataType = 'tag';
        dept.dataValue = vm.allDepts[i].text;
        dept.dataId = vm.allDepts[i].id;
        dept.dataIcon = 'fa fa-folder';
        dept.checked = 'N';
        vm.allTransferedDepts.push(dept);
      }
    }

    function tagsTransfer() {
      for (var i = 0; i < vm.allTags.length; i++) {
        var tag = {};
        tag.dataType = 'tag';
        tag.dataValue = vm.allTags[i].tagName;
        tag.dataId = vm.allTags[i].id;
        tag.dataIcon = 'fa fa-tag';
        tag.checked = 'N';
        vm.allTransferedTags.push(tag);
        initializeSelectedData(vm.allTransferedTags);
      }
    }

    function staffsTransfer(staffs) {
      vm.allTransferedStaffs=[];
      for (var i = 0; i < staffs.length; i++) {
        var staff = {};
        staff.dataType = 'staff';
        staff.dataValue = staffs[i].userName;
        staff.dataId = staffs[i].accountNumber;
        staff.dataIcon = 'fa fa-user';
        staff.checked = 'N';
        vm.allTransferedStaffs.push(staff);
      }
      initializeSelectedData(vm.allTransferedStaffs);
    }

    function existsInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].dataId === obj.dataId && array[i].dataType === obj.dataType)
          return false;
      }
      return true;
    }

    function getPosInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].dataId === obj.dataId && array[i].dataType === obj.dataType)
          return i;
      }
      return 0;
    }

    function onRemoveCallback(item, model) {
      console.log("+++++++++++++++++");

      if (item.dataType == 'staff') {
        for (var i = 0; i < vm.allTransferedStaffs.length; i++) {
          if (vm.allTransferedStaffs[i].dataId === item.dataId) {
            vm.allTransferedStaffs[i].checked = 'N';
            return;
          }
        }
      }

      /*if (item.dataType == 'tag') {
        for (var i = 0; i < vm.allTransferedTags.length; i++) {
          if (vm.allTransferedTags[i].dataId === item.dataId) {
            vm.allTransferedTags[i].checked = 'N';
            return;
          }
        }
      }

      if (item.dataType == 'dept') {
        //需要从树里面设置选中标记
        for (var i = 0; i < vm.jsTreeData.length; i++) {
          if (vm.jsTreeData[i].id == item.dataId) {
            //vm.jsTreeData[i].state=false;
            vm.treeInstance.jstree(true).deselect_node(vm.jsTreeData[i], false);
            return;
          }
        }
      }*/
    }
    function onSelectCallback(item, model){
      //处理选中时的事件

      /*if (item.dataType == 'tag') {
        for (var i = 0; i < vm.allTransferedTags.length; i++) {
          if (vm.allTransferedTags[i].dataId === item.dataId) {
            vm.allTransferedTags[i].checked = 'Y';
            return;
          }
        }
      }*/

      /*if (item.dataType == 'dept') {
        Hmapfe.log('dept');
        //需要从树里面设置选中标记
        for (var i = 0; i < vm.jsTreeData.length; i++) {
          if (vm.jsTreeData[i].id == item.dataId) {
            //vm.jsTreeData[i].state=false;
            vm.treeInstance.jstree(true).open_node(vm.jsTreeData[i]);
            vm.treeInstance.jstree(true).select_node(vm.jsTreeData[i], false);
            Hmapfe.log('预计选定节点');
            return;
          }
        }
      }*/
    }
    function permissionAutocomplete(search){
      vm.searchData=[];
      if(search){
        Contacts.contactStaffListSearch().search({key:search}, onSearchSuccess, onError);
      }

    }
    function onSearchSuccess(data, headers){
      var searchResult=data.rows;
      for(var i=0;i<searchResult.length;i++){
        /*searchResult[i].checked = 'N';
        if(vm.selectedData.length == 0){
          vm.searchData.push(searchResult[i]);
        }else{
          for(var j=0;j<vm.selectedData.length;j++){
            if(vm.selectedData[j].dataId != searchResult[i].dataId){
              vm.searchData.push(searchResult[i]);
            }
          }
        }*/

        vm.searchData.push(searchResult[i]);
      }

    }
  }
})();

/**
 * Created by zhouzy on 2016/9/4 0004.
 */
/**
 * Created by zhouzy on 2016/8/4 0004.
 */
(function () {
  'use strict';

  var sideNavigation = {
    //restrict: 'A',
    //transclude:true,
    template: '' +
      '<ul class="nav metismenu" id="side-menu">' +
      ' <li ng-repeat="menu in $ctrl.menu" ng-if="menu.ischecked==true">' +
      '   <a href="" aria-expanded="true" class="menu_disable" aria-disabled="false">' +
      '     <i ng-class="menu.icon"></i>' +
      '     <span class="nav-label">{{menu.text}}</span>' +
      '     <span class="fa arrow"></span>' +
      '   </a>' +
      '   <ul class="nav nav-second-level">' +
      '     <li ng-repeat="child in menu.children" class="in" ng-if="child.ischecked==true">' +
      '       <a href="{{child.url}}">{{child.text}}</a>' +
      '     </li>' +
      '   </ul>' +
      ' </li>' +
      '</ul>',
    //template: '<ul class="nav metismenu" id="side-menu"></ul>',
    controller: SideNavigationController

  };
  angular
    .module('hmapFront')
    .component('sideNavigation', sideNavigation);

  SideNavigationController.$inject = ['$scope', '$element', '$timeout', 'Authority', '$sessionStorage', 'Hmapfe'];
  function SideNavigationController($scope, $element, $timeout, Authority, $sessionStorage, Hmapfe) {

    var vm = this;
    vm.menu = [];
    vm.loadMenu = loadMenu;
    //vm.init=init;
    //vm.init();
    //
    //function init(){
    //  //console.log("metisMenu");
    //  $timeout(function(){
    //    $element.metisMenu();
    //  });
    //  //console.log($element);
    //}

    this.$onInit = function () {
      vm.loadMenu();
    };

    function loadMenu() {
      vm.user = {
        partyId: $sessionStorage.user.partyId
      };
      Authority.queryUserRoles().get({ userId: $sessionStorage.user.partyId }, function (data) {
        Authority.query().get({ roleId: data.rows[0].roleId }, onSuccess, onError);
      }
        , function (error) {//增加日志输出
          console.log('获取用户信息失败');
        });
    }

    function onSuccess(data, headers) {
      vm.menu = data.rows;
      //console.log("begin deal menu-------")
      for (var i = 0; i < vm.menu.length; i++) {
        if ((vm.menu[i].ischecked == false || vm.menu[i].ischecked == null || vm.menu[i].ischecked == undefined) && vm.menu[i].children != null && vm.menu[i].children != undefined) {
          for (var j = 0; j < vm.menu[i].children.length; j++) {
            if (vm.menu[i].children[j].ischecked == true) {
              vm.menu[i].ischecked = true;
              break;
            }
          }
        }
      }
      $timeout(function () {
        $('#side-menu').metisMenu();
        if ($('body').hasClass('mini-navbar')) {
          $('.menu_disable').attr('aria-disabled', 'true');
        }
      }, 0);
    }

    function onError(error) {
      //console.log('error');
    }

  }
})();

(function () {
  'use strict';

  var hmsSelect = {
    template: '<select class="form-control" ng-model="$ctrl.value"><option ng-repeat="option in $ctrl.options" value="{{option.value}}">{{option.value}}</option></select>',
    bindings: {
      code: '@',//单向绑定
      value: '&'
    },
    //replace:true,
    //transclude: true,
    controller: HmsSelectController,
  };

  angular
    .module('hmapFront')
    .component('hmsSelect', hmsSelect);

  HmsSelectController.$inject = ['$scope', '$rootScope', 'CodingValueService'];
  function HmsSelectController($scope, $rootScope, CodingValueService) {
    var vm = this;
    vm.options = [];
    vm.value = "";
    vm.codeEntity = {code: vm.code}
    //vm.value="xxxxxx";
    ////console.log(vm);
    ////console.log($scope);
    //$scope.$parent.value = vm.value;
    loadCodeValues(vm.codeEntity);
    function loadCodeValues(code) {
      CodingValueService.findCodeValues(code).then(function (data) {
        vm.options = data.rows;
      });
    }
  }
})();

/**
 * Created by zhouzy on 2016/11/14 0014.
 */
(function () {
  'use strict';
  var permissionSelector = {
    templateUrl: 'app/tpl/permission-area.html',
    controller: PermissionSelectorController,
    controllerAs: 'vm',
    bindings: {
      id: "@",
      name: "@",
      permissionData: '='
    }
  };

  angular
    .module('hmapFront')
    .component('permissionSelector', permissionSelector);
  PermissionSelectorController.$inject = ['$uibModal', 'Hmapfe'];

  function PermissionSelectorController($uibModal, Hmapfe) {
    var vm = this;
    vm.open = open;

    this.$onInit = function () {
      Hmapfe.log('$onInit');
      Hmapfe.log(vm.permissionData);
    }
    function open() {
      Hmapfe.log(vm.permissionData);
      $uibModal.open({
        templateUrl: 'app/tpl/permission-selector.html',
        controller: PermissionModalController,
        controllerAs: 'vm',
        size: 'md',
        backdrop: 'static',
        resolve: {
          permissionData: function () {
            return vm.permissionData;
          }
        }
      }).result.then(function (result) {
          console.info("I was closed, so do what I need to do myContent's controller now.  Result was->");
          console.info(result);
          vm.permissionData = result;
        }, function (reason) {
          console.info("I was dimissed, so do what I need to do myContent's controller now.  Reason was->" + reason);
        });
    };
  }

  //var permissionModal = {
  //  //templateUrl:'app/tpl/permission-selector.html',
  //  template: '<div class="modal-body"><div>{{$ctrl.greeting}}</div><label>Name To Edit</label> <input ng-model="$ctrl.modalData.name"><br>  <label>Value To Edit</label> <input ng-model="$ctrl.modalData.value"><br><button class="btn btn-warning" type="button" ng-click="$ctrl.handleClose()">Close Modal</button><button class="btn btn-warning" type="button" ng-click="$ctrl.handleDismiss()">Dimiss Modal</button></div>',
  //  controller: PermissionModalController,
  //  controllerAs: '$ctrl',
  //  bindings: {
  //    modalInstance: "<",
  //    resolve: "<"
  //  }
  //};
  //
  //angular
  //  .module('hmapFront')
  //  .component('permissionModal', permissionModal);
  PermissionModalController.$inject = ['$state', 'Contacts', 'paginationConstants', '$log', '$scope', '$uibModal', '$localStorage', 'Hmapfe', '$uibModalInstance', 'permissionData','$filter'];

  function PermissionModalController($state, Contacts, paginationConstants, $log, $scope, $uibModal, $localStorage, Hmapfe, $uibModalInstance, permissionData,$filter) {
    var vm = this;
    vm.permissionData = permissionData;

    vm.page = 1;
    vm.isStaffShow = false;
    vm.isSpinnerShow = false;
    vm.isOrgShow = true;
    vm.isTagShow = false;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.selectedData = [];
    vm.searchData=[];
    vm.jsTreeData = [];
    vm.deptData = [];
    vm.dept = {};
    vm.treeConfig = {};
    vm.detailTreeConfig = {};
    vm.treeInstance = {};
    vm.memberTreetailInstance = {};
    vm.currentDept = {};
    vm.checkedNodes = [];
    vm.allDepts = [];
    vm.allTags = [];
    vm.allTransferedDepts = [];
    vm.allTransferedTags = [];
    vm.allTransferedStaffs = [];
    vm.staffs = [];
    vm.deptTreeEventsObj = {};
    vm.memberTreeEventsObj = {};

    vm.permissionDataInitialize = permissionDataInitialize;
    vm.initData = initData;
    vm.dataTransfer = dataTransfer;
    vm.getSelectedNode = getSelectedNode;

    vm.selectOrg = selectOrg;
    vm.selectTag = selectTag;
    vm.selectDetail = selectDetail;
    vm.checkedData = checkedData;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.tagDetail = tagDetail;
    vm.onRemoveCallback = onRemoveCallback;
    vm.onSelectCallback=onSelectCallback;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.close = close;
    vm.permissionAutocomplete=permissionAutocomplete;
    vm.permissionDataInitialize();
    vm.initData();
    vm.dataTransfer();
    vm.department = $filter('T')('appEdition.department');
    vm.tag = $filter('T')('appEdition.tag');
    vm.member = $filter('T')('appEdition.member');

    vm.deptTreeEventsObj = {
      activate_node: selectDeptTree
    };
    vm.memberTreeEventsObj = {
      activate_node: selectMemberTree
    };
    function selectMemberTree(e, i) {
      vm.currentDept.deptNumber = i.node.id;
      vm.currentDept.deptName = i.node.text;
      loadDeptStaff();
    }

    function selectDeptTree(e, i) {
      Hmapfe.log(i);
      var dept = {};
      dept.dataType = 'dept';
      dept.dataValue = i.node.text;
      dept.dataId = i.node.id;
      dept.dataIcon = 'fa fa-folder';
      dept.checked = 'Y';

      if (vm.selectedData.length==0) {
        vm.selectedData.push(dept);
      } else {
        if (!existsInArray(dept, vm.selectedData)) {
          vm.selectedData.splice(getPosInArray(dept, vm.selectedData), 1);
        }else{
          vm.selectedData.push(dept);
        }
      }

    }

    function loadDeptStaff() {
      vm.isStaffShow = false;
      vm.isSpinnerShow = true;
      vm.dept.deptNumber = vm.currentDept.deptNumber;
      vm.dept.page = vm.page;
      vm.dept.pagesize = vm.itemsPerPage;

      Contacts.findDeptStaff().get(vm.dept, onStaffSuccess, onError);
    }

    function permissionDataInitialize() {

      if (vm.permissionData && vm.permissionData.length) {
        for (var i = 0; i < vm.permissionData.length; i++) {
          vm.selectedData.push(vm.permissionData[i]);
        }
      }
    }

    //在初始化数据时，需要把已经选择的数据勾选
    function initializeSelectedData(pendingData) {
      for (var i = 0; i < vm.selectedData.length; i++) {
        if (vm.selectedData[i].dataType == 'tag'||vm.selectedData[i].dataType == 'staff') {
          for (var j = 0; j < pendingData.length; j++) {
            if (vm.selectedData[i].dataId == pendingData[j].dataId && vm.selectedData[i].dataType == pendingData[j].dataType) {
              pendingData[j].checked = 'Y';
              break;
            }
          }
        }
        //如果是部门，需要处理树型结构里面的数据，设置为可选
        //vm.jsTreeData
        else if(vm.selectedData[i].dataType == 'dept'){
          for (var j = 0; j < vm.jsTreeData.length; j++) {
            if(vm.selectedData[i].dataId==vm.jsTreeData[j].id){
              vm.jsTreeData[j].state.open=true;
              vm.jsTreeData[j].state.selected=true;
              break;
            }
          }
        }
      }
    }

    function initData() {
      vm.treeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'checkbox']
      };
      angular.copy($localStorage.deptData,vm.jsTreeData);
      angular.copy($localStorage.deptData,vm.allDepts);
      angular.copy($localStorage.allTags,vm.allTags);
      //将已经选中的数据显示在这里
      initializeSelectedData(vm.jsTreeData);
    }

    function initDetailData() {
      vm.detailTreeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'dnd']
      };
      vm.jsMemberTreeData = $localStorage.deptData;
    }

    function getSelectedNode() {
      vm.checkedNodes = vm.treeInstance.jstree(true).get_selected();
    }

    function onStaffSuccess(data, headers) {
      vm.staffs = data.rows;
      staffsTransfer(vm.staffs);
      vm.totalItems = data.total;
      vm.isStaffShow = true;
      vm.isSpinnerShow = false;
    }

    function onError(error) {
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadDeptStaff();
    };

    function selectTag() {
      vm.isOrgShow = false;
      vm.isTagShow = true;
    }

    function selectOrg() {
      vm.isOrgShow = true;
      vm.isTagShow = false;
      //getAllTags
    }

    function selectDetail() {
      initDetailData();
    }

    function close() {
      $uibModalInstance.close(vm.selectedData);
    }

    function clear() {
      Hmapfe.log('clear');
      $uibModalInstance.dismiss('cancel');
    }

    function tagDetail() {
      Hmapfe.log('tagDetail');
    }

    function checkedData(obj, event) {
      var isChecked = event.target.checked;
      if (isChecked) {
        if (existsInArray(obj, vm.selectedData)) {
          vm.selectedData.push(obj);
        }
      }
      else {
        vm.selectedData.splice(getPosInArray(obj, vm.selectedData), 1);
        obj.checked = 'N';
      }
    }


    function dataTransfer() {
      //deptsTransfer();
      tagsTransfer();
    }

    function deptsTransfer() {
      for (var i = 0; i < vm.allDepts.length; i++) {
        var dept = {};
        dept.dataType = 'tag';
        dept.dataValue = vm.allDepts[i].text;
        dept.dataId = vm.allDepts[i].id;
        dept.dataIcon = 'fa fa-folder';
        dept.checked = 'N';
        vm.allTransferedDepts.push(dept);
      }
    }

    function tagsTransfer() {
      for (var i = 0; i < vm.allTags.length; i++) {
        var tag = {};
        tag.dataType = 'tag';
        tag.dataValue = vm.allTags[i].tagName;
        tag.dataId = vm.allTags[i].id;
        tag.dataIcon = 'fa fa-tag';
        tag.checked = 'N';
        vm.allTransferedTags.push(tag);
        initializeSelectedData(vm.allTransferedTags);
      }
    }

    function staffsTransfer(staffs) {
      vm.allTransferedStaffs=[];
      for (var i = 0; i < staffs.length; i++) {
        var staff = {};
        staff.dataType = 'staff';
        staff.dataValue = staffs[i].userName;
        staff.dataId = staffs[i].accountNumber;
        staff.dataIcon = 'fa fa-user';
        staff.checked = 'N';
        vm.allTransferedStaffs.push(staff);
      }
      initializeSelectedData(vm.allTransferedStaffs);
    }

    function existsInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].dataId === obj.dataId && array[i].dataType === obj.dataType)
          return false;
      }
      return true;
    }

    function getPosInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].dataId === obj.dataId && array[i].dataType === obj.dataType)
          return i;
      }
      return 0;
    }

    function onRemoveCallback(item, model) {
      if (item.dataType == 'staff') {
        for (var i = 0; i < vm.allTransferedStaffs.length; i++) {
          if (vm.allTransferedStaffs[i].dataId === item.dataId) {
            vm.allTransferedStaffs[i].checked = 'N';
            return;
          }
        }
      }

      if (item.dataType == 'tag') {
        for (var i = 0; i < vm.allTransferedTags.length; i++) {
          if (vm.allTransferedTags[i].dataId === item.dataId) {
            vm.allTransferedTags[i].checked = 'N';
            return;
          }
        }
      }

      if (item.dataType == 'dept') {
        //需要从树里面设置选中标记
        for (var i = 0; i < vm.jsTreeData.length; i++) {
          if (vm.jsTreeData[i].id == item.dataId) {
            //vm.jsTreeData[i].state=false;
            vm.treeInstance.jstree(true).deselect_node(vm.jsTreeData[i], false);
            return;
          }
        }
      }
    }
    function onSelectCallback(item, model){
      //处理选中时的事件


      if (item.dataType == 'tag') {
        for (var i = 0; i < vm.allTransferedTags.length; i++) {
          if (vm.allTransferedTags[i].dataId === item.dataId) {
            vm.allTransferedTags[i].checked = 'Y';
            return;
          }
        }
      }

      if (item.dataType == 'dept') {
        Hmapfe.log('dept');
        //需要从树里面设置选中标记
        for (var i = 0; i < vm.jsTreeData.length; i++) {
          if (vm.jsTreeData[i].id == item.dataId) {
            //vm.jsTreeData[i].state=false;
            vm.treeInstance.jstree(true).open_node(vm.jsTreeData[i]);
            vm.treeInstance.jstree(true).select_node(vm.jsTreeData[i], false);
            Hmapfe.log('预计选定节点');
            return;
          }
        }
      }
    }
    function permissionAutocomplete(search){
      vm.searchData=[];
      if(search){
        Contacts.contactListSearch().search({key:search}, onSearchSuccess, onError);
      }

    }
    function onSearchSuccess(data, headers){
      var searchResult=data.rows;
      for(var i=0;i<searchResult.length;i++){

        if(vm.selectedData.length == 0){
          searchResult[i].checked = 'Y';
          vm.searchData.push(searchResult[i]);
        }else{
          var flag =false;
          for(var j=0;j<vm.selectedData.length;j++){
            if(vm.selectedData[j].dataId == searchResult[i].dataId){
              flag = true;
            }
          }
          if(!flag){
            searchResult[i].checked = 'Y';
            vm.searchData.push(searchResult[i]);
          }
        }


        //vm.searchData.push(searchResult[i]);
      }

    }
  }
})();

/**
 * Created by zhouzy on 2016/9/4 0004.
 */
(function () {
  'use strict';

  var navigation = {
    template: '<ul class="nav nav-second-level" aria-expanded="true"><li  ng-repeat="item in $ctrl.menu" ng-if="item.ischecked==true"><a ng-href="{{item.url}}" aria-expanded="true">{{item.text}}<span class="fa arrow" ng-if="item.children.length>0"></span></a><ul class="nav nav-third-level" aria-expanded="true" ng-if="item.children.length>0"><navigation menu="item.children"></navigation></li></ul>',
    bindings: {
      menu: '<'
    },
    controller: NavigationController
  };

  angular
    .module('hmapFront')
    .component('navigation', navigation);
  NavigationController.$inject = ['$scope', '$rootScope', '$log','$timeout'];

  function NavigationController($scope, $rootScope, $log,$timeout) {
    var vm = this;

    this.$onInit = function () {
      var nav = angular.element(document.querySelector('side-navigation'));
    }
    this.$postLink = function () {
      //angular.element
      var nav = angular.element(document.querySelector('side-navigation'));
      //console.log("nav $postLink");
    }
  }
})();

/**
 * Created by zhouzy on 2016/8/4 0004.
 */
(function () {
  'use strict';


  var minimaliza = {
    //restrict: 'A',
    template: '<span><a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="$ctrl.minimalize()"><i class="fa fa-bars"></i></a></span>',
    controller: MinimalizaController
  }

  angular
    .module('hmapFront')
    .component('minimaliza', minimaliza);

  MinimalizaController.$inject = ['$scope', '$element']
  function MinimalizaController($scope, $element) {
    var vm = this;
    vm.minimalize = minimalize;

    function minimalize() {
      $("body").toggleClass("mini-navbar");
      if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
        // Hide menu in order to smoothly turn on when maximize menu
        $('#side-menu').hide();
        // For smoothly turn on menu
        setTimeout(
          function () {
            $('#side-menu').fadeIn(400);
            $('.menu_disable').attr('aria-disabled', 'false');
          }, 200);
      } else if ($('body').hasClass('fixed-sidebar')) {
        $('#side-menu').hide();
        setTimeout(
          function () {
            $('#side-menu').fadeIn(400);
          }, 100);
      } else {
        // Remove all inline style from jquery fadeIn function to reset menu state
        $('#side-menu').removeAttr('style');
        $('.menu_disable').attr('aria-disabled', 'true');
      }
    }
  }
})();

/**
 * Created by xinming on 2016/9/29.
 */
(function() {
  'use strict';
  var lookupSelect = {
    //template: '<select class="form-control" ng-model="vm.lookupValue" ng-click="vm.change()" ng-options="codeValue.value as codeValue.meaning for codeValue in vm.codeValues"></select>',
    template: '<select class="form-control" ng-model="vm.lookupValue" ng-click="vm.change()" ng-required="vm.required" ng-disabled="vm.disable"><option ng-repeat="x in vm.codeValues" value="{{x.value}}">{{x.meaning}}</option></select>',
    controller: LookupSelectController,
    controllerAs: 'vm',
    replace: true,
    bindings: {
      lookupType: '@',
      lookupValue:'=',
      onChange:"&",
      required:'=',
      disable:'='
    }
  };

  angular
    .module('hmapFront')
    .component('lookupSelect', lookupSelect);
  LookupSelectController.$inject = ['CodingValueService','CodingService','$q'];

  function LookupSelectController(CodingValueService,CodingService,$q) {
    var vm = this;
    vm.change=change;
    this.$onInit = function () {
      var deferred = $q.defer();
      CodingService.findCodes({code:vm.lookupType}, 1, 1)
        .then(function (data) {
          vm.code = data.rows[0];
          deferred.resolve();
        },function(){
          deferred.reject ()
        });
      deferred.promise.then(function(){
        //蛋疼的后台这个地方如果传vm.code对象过去就查不到信息，所以加个临时的对象吧
        CodingValueService.findCodeValuesByCodeValue({codeId:vm.code.codeId})
          .then(function (data) {
            if(!data.rows) {
              return;
            }
            vm.codeValues = [];
            vm.codeValues.push({'meaning': '','value':'','codeId':'','codeValueId':'', 'orderSeq':''});
            for(var i = 0; i < data.rows.length; i++) {
              vm.codeValues.push({'meaning':data.rows[i].meaning,'value':data.rows[i].value,'codeId':data.rows[i].codeId,'codeValueId':data.rows[i].codeValueId, 'orderSeq':data.rows[i].orderSeq})
            }

          })
      },function(){
        //console.log("reject")
      })

    };

    function change(){
      vm.onChange();
    }
  }
})();

(function() {
    'use strict';

    var itemCount = {
        template: '<div class="info">' +
                    '<span translate="page.show"></span> {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.totalItems ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.totalItems}} ' +
                    '<span translate="page.count"></span> <span translate="page.total"></span>{{$ctrl.totalItems}} <span translate="page.count"></span>.' +
                '</div>',
        bindings: {
            page: '<',
            totalItems: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('hmapFront')
        .component('itemCount', itemCount);
})();

/**
 * Created by zhouzy on 2016/8/31 0031.
 */
(function () {
  'use strict';

  var deleteButton = {
    template: '<button type="button" class="btn btn-primary" ng-click="$ctrl.openModal()">' +
    '<span class="glyphicon glyphicon-trash"></span>&nbsp;<span> 删除111</span>' +
    '</button>',
    bindings: {
      confirmMessage: '<',//单向绑定
      confirm: '&'
    },
    //replace:true,
    //transclude: true,
    controller: DeleteButtonController,
  };

  angular
    .module('hmapFront')
    .component('deleteButton', deleteButton);

  DeleteButtonController.$inject = ['$scope', '$uibModal'];
  function DeleteButtonController($scope,$uibModal) {
    var $ctrl = this;

    $ctrl.openModal = function(){
      //console.log($ctrl);
      $ctrl.modalInstance = $uibModal.open({
        template: '<confirm-modal></confirm-modal>',
        appendTo : angular.element(document).find('delete-button')
      });
    }
  }
})();

/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/30 0030.
 */
(function () {
  'use strict';
  var confirmModal = {
    templateUrl: 'app/tpl/deleteConfirmComponent.html',
    //template:function($element, $attrs) {
    //  return '<div class="modal-header"><h3 class="modal-title">删除确认</h3></div>' +
    //    '<div class="modal-body">是否确认删除选定项？</div>' +
    //    '<div class="modal-footer">' +
    //    '<button class="btn btn-primary" type="button" ng-click="$ctrl.ok()">确认</button>' +
    //    '<button class="btn btn-info" type="button" ng-click="$ctrl.cancel()"> 取消</button>' +
    //    '</div>';
    //},
    bindings: {
      //resolve: '<',
      //close: '&',
      //dismiss: '&',
      confirmMessage: '<',//单向绑定
      confirm: '&'
    },
    replace: true,
    require: {
      parent : '^deleteButton'
    },
    //,
    controller: ComfirmModalController
  };
  angular.module('hmapFront').component('confirmModal', confirmModal);

  ComfirmModalController.$inject = ['$scope'];
  function ComfirmModalController($scope) {
    var $ctrl = this;

    $ctrl.$onInit = function(){

      var instance = $ctrl.parent.modalInstance;

      $ctrl.items = ['item1', 'item2', 'item3'];

      $ctrl.selected = {
        item: $ctrl.items[0]
      };

      $ctrl.ok = function () {
        //console.log($ctrl.parent.confirm());
        instance.close($ctrl.selected);
      };

      $ctrl.cancel = function () {
        instance.dismiss('cancel');
      };

      instance.result.then(function (selectedItem) {
        $ctrl.selected = selectedItem;
        //console.log($ctrl.selected );
      }, function () {
        //console.log('Modal dismissed at: ' + new Date());
      });
    };
  }

})();

(function() {
    'use strict';

    angular
        .module('hmapFront')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var alertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: AlertErrorController
    };

    angular.module('hmapFront').component('alertError', alertError);

    AlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function AlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];
        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        //timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        function addInfoAlert (message) {
          vm.alerts.push(
            AlertService.add(
              {
                type: 'info',
                msg: message,
                toast: AlertService.isToast(),
                scoped: true
              },
              vm.alerts
            )
          );
        }

        var cleanHttpErrorListener = $rootScope.$on('hmapFront.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-jhipsterApp-error');
                var entityKey = httpResponse.headers('X-jhipsterApp-params');
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addInfoAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

/**
 * Created by zhouzy on 2016/11/10 0010.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('Hmapfe', Hmapfe);

  Hmapfe.$inject = ['BaseConfig'];

  function Hmapfe(BaseConfig) {
    var service = {
    log:log
    };
    return service;

    function log(msg){
      if(BaseConfig.debugEnable){
        console.log(msg);
      }
    }
  }

})();

/**
 * Created by zhouzy on 2016/8/15 0015.
 */
(function () {
  'use strict';

  angular
  .module('hmapFront')
  .factory('urlInterceptor', urlInterceptor);

  urlInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage', 'BaseConfig'];

  //var backUrls = [
  //  "/api",
  //  "/oauth/token",
  //  "/metrics"
  //];

  function urlInterceptor($rootScope, $q, $location, $localStorage, $sessionStorage, BaseConfig) {
    var service = {
      request: request
    };

    return service;

    function request(config) {
      /*jshint camelcase: false */
      config.url = encodeURI(config.url) || {};

      for (var i = 0; i < BaseConfig.backUrls.length; i++) {
        if (config.url.substr(0, BaseConfig.backUrls[i].length) === BaseConfig.backUrls[i]) {
          if (config.url === '/api/security/jwtToken/refreshKey') {
            config.url = BaseConfig.authorizationUrl + config.url;
          } else if (config.url === '/oauth/token') {
            config.url = BaseConfig.authorizationUrl + config.url;
          } else if (config.url.substr(0,10) === '/api/admin') {
            config.url = $localStorage.b2cConfig + config.url;
          } else {
            config.url = BaseConfig.url + config.url;
          }
        }
        /*else if (config.url.indexOf('.json') >  0){
          console.log('Is this work? url:' + config.url);
          config.url += '?v=20190403';
        }*/
      }
      return config;
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .factory('errorHandlerInterceptor', errorHandlerInterceptor);

  errorHandlerInterceptor.$inject = ['$q', '$rootScope', 'BaseConfig'];

  function errorHandlerInterceptor($q, $rootScope, BaseConfig) {
    var service = {
      response: responseError
    };

    return service;

    function responseError(response) {
      var config = response.config;
      var responseUrl = config.url;
      for (var i = 0; i < BaseConfig.backUrls.length; i++) {
        var apiUrlPrefix = BaseConfig.url + BaseConfig.backUrls[i];
        if (responseUrl.substr(0, apiUrlPrefix.length) == apiUrlPrefix) {
          //console.log('is an api invoke');
          //console.log(response.data.success);
          if (response.status === 200 && response.data != undefined && response.data.success == false) {
            //console.log('broadcast an error');
            $rootScope.$emit('hmapFront.httpError', response);
            //return $q.reject(response);
            return response;
          }
        }
      }
      return response;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .factory('authInterceptor', authInterceptor);

  authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage', 'BaseConfig'];

  //var backUrls = [
  //  "/api",
  //  "/oauth/token",
  //  "/metrics"
  //];

  function authInterceptor($rootScope, $q, $location, $localStorage, $sessionStorage, BaseConfig) {
    var service = {
      request: request
    };

    return service;

    function request(config) {
      /*jshint camelcase: false */
      config.headers = config.headers || {};
      config.url = config.url || {};

      var urlTemp = encodeURI(config.url);

      if(urlTemp&&urlTemp.split("/")[1] == 'job'){
        config.url = urlTemp.substring(4,urlTemp.length);
      }

      for (var i = 0; i < BaseConfig.authenticatedUrls.length; i++) {
        if (config.url.substr(0,BaseConfig.authenticatedUrls[i].length)==BaseConfig.authenticatedUrls[i]) {

          var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
          //console.info("请求api接口的token:"+token.access_token+"------"+token);
          if (token && token.expires_at && token.expires_at*1000 > new Date().getTime()) {
            config.headers["requestFrom"] = 'admin';
            config.headers.Authorization = 'Bearer ' + token.access_token;
            config.headers["Content-Type"]='application/json;charset=UTF-8';
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.headers['X-hmapfront-client'] = 'PC';
            config.headers['X-hmapfront-version'] = BaseConfig.version;
          }
        }
      }

      if(urlTemp&&urlTemp.split("/")[1] == 'job'){
        config.url = urlTemp;
      }

      return config;
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .factory('authExpiredInterceptor', authExpiredInterceptor);


  authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage', 'BaseConfig', '$log'];

  function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage, BaseConfig, $log) {
    return {
      responseError: responseError
    };

    function responseError(response) {
      if (response.status === 401) {
        delete $localStorage.authenticationToken;
        delete $sessionStorage.authenticationToken;
        /*var Principal = $injector.get('Principal');
        if (Principal.isAuthenticated()) {
          var Auth = $injector.get('Auth');
          Auth.authorize(true);
        }*/
        if (BaseConfig.localDebugger) {
          var state = $injector.get('$state');
          state.go("login");
        } else {
          var RedirectUrlService = $injector.get('RedirectUrlService');
          RedirectUrlService.getTenantIdAndClientId().then(function (data) {
            var aadLoginUrl = data.rows[0].aadLoginUrl;
            if (navigator.userAgent.toLowerCase().indexOf("firefox") > 0) {
              window.location.assign(aadLoginUrl);
            } else {
              window.location = aadLoginUrl;
            }
          });
        }
      } else if (response.status === 403) {
        var SweetAlert = $injector.get('SweetAlert');
        var filter = $injector.get('$filter');
        SweetAlert.error(filter('T')("prompt.permissionDenied"), {title: filter('T')("btnTypeName.prompt")});
      } else if (response.status === -1) {
        if (Offline.state === 'up') {
          Offline.check();
          Offline.on('down', function () {
            var SweetAlert = $injector.get('SweetAlert');
            var filter = $injector.get('$filter');
            SweetAlert.error(filter('T')("prompt.offline"), {title: filter('T')("btnTypeName.prompt")});
          }, null);
        }
      }
      return $q.reject(response);
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .factory('stateHandler', stateHandler);

  stateHandler.$inject = ['RedirectUrlService', '$sessionStorage', '$state', '$rootScope', '$localStorage', '$location', '$window', 'Auth', 'Principal', 'BaseConfig'];

  function stateHandler(RedirectUrlService, $sessionStorage, $state, $rootScope, $localStorage, $location, $window, Auth, Principal, BaseConfig) {
    return {
      initialize: initialize
    };

    function initRedir() {
      var access_token = $location.search().access_token;
      var refresh_token = $location.search().refresh_token;
      var expires_in = $location.search().expires_in;
      var token_type = $location.search().token_type;
      var scope = $location.search()['scope'];
      var result = {
        access_token: access_token,
        refresh_token: refresh_token,
        expires_in: expires_in,
        token_type: token_type,
        scope: scope
      };
      var expiredAt = new Date();
      expiredAt.setSeconds(expiredAt.getSeconds() + expires_in);
      result.expires_at = expiredAt.getTime();
      $sessionStorage.authenticationToken = result;
      $localStorage.authenticationToken = result;

      if (!(access_token && refresh_token && expires_in && token_type && scope)) {
        RedirectUrlService.getTenantIdAndClientId().then(function (data) {
          $localStorage.b2cConfig = data.rows[0].authUrl;
          var aadLoginUrl = data.rows[0].aadLoginUrl;
          if (navigator.userAgent.toLowerCase().indexOf("firefox") > 0) {
            window.location.assign(aadLoginUrl);
          } else {
            window.location = aadLoginUrl;
          }
        })
      } else {
        if (navigator.userAgent.toLowerCase().indexOf("firefox") > 0) {
          window.location.reload();
        } else {
          window.location = BaseConfig.localUrl;
        }
      }
      //var session = $sessionStorage.oauth;
    }

    function initialize() {
      $rootScope.VERSION = BaseConfig.version;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      var error = $location.search().error;
      var url = $location.$$url;
      if (url.indexOf("mainPage") > 0 || url.indexOf("appDownload") > 0 || url.indexOf('commercialAppDownload') > 0) {

      } else if (error) {
        window.location = BaseConfig.localUrl.split("#")[0] + "#/mainPage?error=" + error;//"http://localhost:3000/#/mainPage?error="+error;
        // $state.go('mainPage',{errorCode:error});
      } else if (!token || !token.access_token) {
        initRedir();
        url = window.location.href; //把当前页面的地址赋给变量 url
        if(url.indexOf("?")==-1){
           
        }else{
            if(url.indexOf("reloaded")==-1){ //是否有标识
                url += "&reloaded=1"; //把变量 url 的值加入刷新标识
                window.location.href= url;
                window.location.reload();
            }else{
                //重复请求一次后依然失败的话，根据需要添加逻辑。
            }
        }
        
      }

      var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
        $rootScope.toState = toState;
        $rootScope.toStateParams = toStateParams;
        $rootScope.fromState = fromState;
        //增加event事件，用来阻断没有权限的页面跳转，By:xiawang.liu@hand-china.com
        $rootScope.event = event;
        // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
        if (toState.external) {
          event.preventDefault();
          $window.open(toState.url, '_self');
        }
        //console.log('isIdentityResolved');
        //console.log(Principal.isIdentityResolved());

        if (Principal.isIdentityResolved()) {
          Auth.authorize();
        }


      });

      var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        var titleKey = 'KOHLER';

        // Set the page title key to the one configured in state or use default one
        //if (toState.data.pageTitle) {
        //    titleKey = toState.data.pageTitle;
        //}
        $window.document.title = titleKey;
      });

      $rootScope.$on('$destroy', function () {
        if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
          stateChangeStart();
        }
        if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
          stateChangeSuccess();
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .factory('RedirectUrlService', RedirectUrlService);

  RedirectUrlService.$inject = ['$http'];

  function RedirectUrlService($http) {
    return {
      getTenantIdAndClientId: getTenantIdAndClientId
    };

    function getTenantIdAndClientId() {
      var resourceUrl = '/api/public/authConfig';
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

  }
})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .constant('paginationConstants', {
    'itemsPerPage': 10
  });
})();

(function() {
    'use strict';

    angular
        .module('hmapFront')
        .constant('deviceDirectiveConstants', {
            'onekeyWakeup' : 'onekeyWakeup'
        });
})();

angular.module("hmapFront")
.constant("BaseConfig", {"env":"dev","distEnv":"sit","version":"1.0.1-SNAPSHOT","url":"https://api.dev.kohlerkonnect.com.cn/admin","authorizationUrl":"https://api.dev.kohlerkonnect.com.cn/authorization","localUrl":"https://dev.kohlerkonnect.com.cn/admin/#/app/amain","localDebugger":false,"debugEnable":true,"backUrls":["/api","/oauth/token","/metrics","/appDownload","/sys","/common","/inm","/api/admin"],"authenticatedUrls":["/api","/metrics","/sys","/common","/inm"]});

(function() {
    'use strict';

    angular
        .module('hmapFront')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '<<';
        uibPaginationConfig.previousText = '<';
        uibPaginationConfig.nextText = '>';
        uibPaginationConfig.lastText = '>>';
    }
})();

/**
 * Created by zhouzy on 2016/11/13 0013.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(toastrCutomConfig);

  toastrCutomConfig.$inject = ['toastrConfig'];

  function toastrCutomConfig(toastrConfig) {
    toastrConfig.timeOut = 1500;
  }
})();

(function() {
    'use strict';

    angular
        .module('hmapFront')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('hmap-');
        $sessionStorageProvider.setKeyPrefix('hmap-');
    }
})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .config(httpConfig);

  httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

  function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

    //Cache everything except rest api requests
    httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

    $urlRouterProvider.otherwise('/');

    $httpProvider.interceptors.push('errorHandlerInterceptor');
    $httpProvider.interceptors.push('authExpiredInterceptor');
    $httpProvider.interceptors.push('authInterceptor');
    $httpProvider.interceptors.push('urlInterceptor');
    //$httpProvider.interceptors.push('notificationInterceptor');
    // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

    $urlMatcherFactoryProvider.type('boolean', {
      name: 'boolean',
      decode: function (val) {
        return val === true || val === 'true';
      },
      encode: function (val) {
        return val ? 1 : 0;
      },
      equals: function (a, b) {
        return this.is(a) && a === b;
      },
      is: function (val) {
        return [true, false, 0, 1].indexOf(val) >= 0;
      },
      pattern: /bool|true|0|1/
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .run(runBlock);

  /** @ngInject */
  function runBlock(DTDefaultOptions) {

    DTDefaultOptions.setOption('serverSide', true);
    DTDefaultOptions .setLanguage({
        "sEmptyTable":     "表中无数据",
        "sInfo":           "显示 _START_ - _END_ 条 共 _TOTAL_ 条记录",
        "sInfoEmpty":      "显示 0 - 0 条 总共 0 条",
        "sInfoFiltered":   "(数据表中共为 _MAX_ 条记录)",
        "sInfoPostFix":    "",
        "sInfoThousands":  ",",
        "sLengthMenu":     "每页显示 _MENU_ 条",
        "sLoadingRecords": "正在加载中...",
        "sProcessing":     "正在加载中...",
        "sSearch":         "搜索:",
        "sZeroRecords":    "对不起，查询不到任何相关数据",
        "oPaginate": {
          "sFirst":    "首页",
          "sLast":     "末页",
          "sNext":     "下一页",
          "sPrevious": "上一页"
        },
        "oAria": {
          "sSortAscending":  ": activate to sort column ascending",
          "sSortDescending": ": activate to sort column descending"
        }
      });
    DTDefaultOptions .setOption('autoWidth',true);
    DTDefaultOptions .setOption('processing', true);
    DTDefaultOptions .setOption('serverSide', true);
    DTDefaultOptions .setOption('scrollY', '500px');
    DTDefaultOptions .setOption('scrollX', '100%');
    DTDefaultOptions .setOption('scrollCollapse', true);
    DTDefaultOptions .setOption('paging', true);
    DTDefaultOptions .setOption('ordering', true);
    DTDefaultOptions .setOption('searching', true);
    DTDefaultOptions.setDisplayLength(10)

  }

})();

/**
 * Created by zhouzy on 2016/11/28 0028.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(chartConfig);

  chartConfig.$inject = ['ChartJsProvider'];

  function chartConfig(ChartJsProvider) {
    ChartJsProvider.setOptions({
      colors: ['#45b7cd', '#ff6384'],
      legend: {
        display: true,
        position:'top',
        fullWidth:true,
        labels: {
          fontColor: '#000000'
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .factory('Principal', Principal);

  Principal.$inject = ['$q', 'Account', '$localStorage', 'Authority'];

  function Principal($q, Account, $localStorage, Authority) {
    var _identity,
      _authority,
      _authenticated = false,
      _authorized = false;

    var service = {
      authenticate: authenticate,
      authorization: authorization,
      hasAnyAuthority: hasAnyAuthority,
      hasAuthority: hasAuthority,
      identity: identity,
      isAuthenticated: isAuthenticated,
      isIdentityResolved: isIdentityResolved
    };

    return service;

    function authenticate(identity) {
      _identity = identity;
      _authenticated = identity !== null;
    }

    function hasAnyAuthority(authorities) {
      if (!_authenticated || !_identity || !_identity.authorities) {
        return false;
      }

      for (var i = 0; i < authorities.length; i++) {
        if (_identity.authorities.indexOf(authorities[i]) !== -1) {
          return true;
        }
      }

      return false;
    }

    function hasAuthority(authority) {
      if (!_authenticated) {
        return $q.when(false);
      }

      return this.identity().then(function (_id) {
        return _id.authorities && _id.authorities.indexOf(authority) !== -1;
      }, function () {
        return false;
      });
    }


    function identity(force) {
      //console.log('identity');
      var deferred = $q.defer();

      if (force === true) {
        _identity = undefined;
      }

      // check and see if we have retrieved the identity data from the server.
      // if we have, reuse it by immediately resolving

      if (angular.isDefined(_identity)) {
        _authenticated = true;
        deferred.resolve(_identity);
        return deferred.promise;
      }

      ////console.log($localStorage.authenticationToken);
      // retrieve the identity data from the server, update the identity object, and then resolve.
      ////console.log('Account then');
      Account.get().$promise
        .then(getAccountThen)
        .catch(getAccountCatch);

      return deferred.promise;

      function getAccountThen(account) {
        _identity = account.data;
        _authenticated = true;
        deferred.resolve(_identity);
      }

      function getAccountCatch(reason) {
        //console.log('reason');
        //console.log(reason);
        _identity = null;
        _authenticated = false;
        deferred.resolve(_identity);
      }
    }

    function authorization(url) {
      var deferred = $q.defer();
      var resource = {
        url: '#/' + url
      };

      Authority.validateUrl().query(resource).$promise
        .then(getUrlAuthorityThen)
        .catch(getAccountCatch);
      return deferred.promise;

      function getUrlAuthorityThen(data) {
        _authority = data.rows[0];
        _authorized = true;
        deferred.resolve(_authority);
      }

      function getAccountCatch(reason) {
        _identity = null;
        _authorized = false;
        deferred.resolve(_authority);
      }
    }

    function isAuthenticated() {
      return _authenticated;
    }

    function isIdentityResolved() {
      return angular.isDefined(_identity);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .factory('Auth', Auth);

  Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$uibModalStack', 'Principal', 'AuthServerProvider', 'BaseConfig', '$localStorage'];

  function Auth($rootScope, $state, $sessionStorage, $q, $uibModalStack, Principal, AuthServerProvider, BaseConfig, $localStorage) {
    var service = {
      authorize: authorize,
      login: login,
      logout: logout
    };

    return service;


    function login(credentials, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      AuthServerProvider.login(credentials)
        .then(loginThen)
        .catch(function (err) {
          this.logout();
          //console.log("err");
          //console.log(err);
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      function loginThen(data) {
        Principal.identity(true).then(function () {
          deferred.resolve(data);
        });
        return cb();
      }

      return deferred.promise;
    }

    function logout() {
      AuthServerProvider.logout();
      Principal.authenticate(null);
      delete $localStorage.authenticationToken;
      delete $sessionStorage.authenticationToken;
    }


    function authorize(force) {
      var url = $rootScope.toState.parent + $rootScope.toState.url;
      var authReturn = Principal.identity(force).then(authThen);
      // console.log("url:" + url);

      if (url != 'app/accessdenied' && url != 'app/login' && url != 'undefined/login' && url != "app/amain" &&
        url != "app/mainPage" && url != "undefined/mainPage") {
        //异步请求会导致页面一闪之后 再跳转到无权限页面，By:xiawang.liu@hand-china.com
        // var authorityReturn = Principal.authorization(url).then(authorityThen);
        syncAuthorize(url);
      }

      return authReturn;

      function authThen(data) {
        var isAuthenticated = Principal.isAuthenticated();

        if (isAuthenticated) {
          //storeuser into stograge
          if (data && data.rows && data.rows.length > 0) {
            var user = data.rows[0];
            $sessionStorage.user = {
              partyId: user.userId,
              partyAccount: user.userName
            }
          }
        } else {
          //console.log("redirect to login");
          // $state.go('login');
          //   window.location = BaseConfig.redirectUrl;
        }
      }

      function syncAuthorize(url) {
        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        $.ajax({
          type: "POST",
          url: BaseConfig.url + "/api/authority",
          dataType: 'json',
          contentType: 'application/json;charset=utf-8',
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'X-Requested-With': 'XMLHttpRequest',
            'X-hmapfront-client': 'PC',
            'X-hmapfront-version': BaseConfig.version,
            'Strict-Transport-Security': 'max-age=86400;includeSubDomains',
            'requestFrom': 'admin',
            Authorization: 'Bearer ' + token.access_token
          },
          cache: false,
          async: false,
          data: JSON.stringify({url: '#/' + url}),
          success: function (data) {
            authorityThen(data && data.rows && data.rows.length > 0);
          }
        });
      }

      function authorityThen(data) {
        if (!data) {
          $rootScope.event.preventDefault();
          //console.log("Unauthorized to url:" + url);
          $uibModalStack.dismissAll();
          $state.go('accessdenied');
          //$state.go('login');
        }
      }

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .factory('AuthServerProvider', AuthServerProvider);

  AuthServerProvider.$inject = ['$http', '$localStorage','$state'];

  function AuthServerProvider($http, $localStorage, $state) {
    var service = {
      getToken: getToken,
      hasValidToken: hasValidToken,
      login: login,
      logout: logout
    };

    return service;

    function getToken() {
      var token = $localStorage.authenticationToken;
      return token;
    }

    function hasValidToken() {
      var token = this.getToken();
      return !!token;
    }

    function login(credentials) {
      //var data = 'userName=' + encodeURIComponent(credentials.username) +
      //  '&password=' + encodeURIComponent(credentials.password) +
      //  '&verifiCode=' + credentials.verifiCode;


       var data = 'client_id=client&client_secret=secret&grant_type=password'+'&username=' + encodeURIComponent(credentials.username) +
          '&password=' + encodeURIComponent(credentials.password) + '&lang=' + credentials.languageType;
      /*var data = 'client_id=client&client_secret=secret&grant_type=password'+'&username=' + credentials.username +
        '&password=' + credentials.password;*/

        return $http.post('/oauth/token',
          data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          //withCredentials:true
        }).success(function (response) {
          var expiredAt = new Date();
          expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
          response.expires_at = expiredAt.getTime();
          $localStorage.authenticationToken = response;

          //console.log("authenticationToken:" + $localStorage.authenticationToken);
          return response;
        });




      //var data ='&username=' + encodeURIComponent(credentials.username) +
      //  '&password=' + encodeURIComponent(credentials.password)+ '&verifiCode=' + encodeURIComponent(credentials.verifiCode);

    }

    function logout () {
      delete $localStorage.authenticationToken;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .factory('Account', Account);

  Account.$inject = ['$resource'];

    function Account ($resource) {
      var service = $resource('/api/account', {}, {
        'get': { method: 'GET', params: {}, isArray: false,
          interceptor: {
            response: function(response) {
              // expose response
              return response;
            }
          }
        }
      });
      return service;
    }
})();

/*!
 * vConsole v3.3.2 (https://github.com/Tencent/vConsole)
 * 
 * Tencent is pleased to support the open source community by making vConsole available.
 * Copyright (C) 2017 THL A29 Limited, a Tencent company. All rights reserved.
 * Licensed under the MIT License (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at
 * http://opensource.org/licenses/MIT
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("VConsole",[],t):"object"==typeof exports?exports.VConsole=t():e.VConsole=t()}(window,function(){return function(e){var t={};function o(n){if(t[n])return t[n].exports;var r=t[n]={i:n,l:!1,exports:{}};return e[n].call(r.exports,r,r.exports,o),r.l=!0,r.exports}return o.m=e,o.c=t,o.d=function(e,t,n){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,t){if(1&t&&(e=o(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)o.d(n,r,function(t){return e[t]}.bind(null,r));return n},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="",o(o.s=6)}([function(e,t,o){var n,r,i;r=[t],void 0===(i="function"==typeof(n=function(e){"use strict";function t(e){return(t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function o(e){return"[object Number]"==Object.prototype.toString.call(e)}function n(e){return"[object String]"==Object.prototype.toString.call(e)}function r(e){return"[object Array]"==Object.prototype.toString.call(e)}function i(e){return"[object Boolean]"==Object.prototype.toString.call(e)}function a(e){return void 0===e}function l(e){return null===e}function c(e){return"[object Symbol]"==Object.prototype.toString.call(e)}function s(e){return!("[object Object]"!=Object.prototype.toString.call(e)&&(o(e)||n(e)||i(e)||r(e)||l(e)||d(e)||a(e)||c(e)))}function d(e){return"[object Function]"==Object.prototype.toString.call(e)}function u(e){var t=Object.prototype.toString.call(e);return"[object global]"==t||"[object Window]"==t||"[object DOMWindow]"==t}function f(e){if(!s(e)&&!r(e))return[];if(r(e)){var t=[];return e.forEach(function(e,o){t.push(o)}),t}return Object.getOwnPropertyNames(e).sort()}Object.defineProperty(e,"__esModule",{value:!0}),e.getDate=function(e){var t=e>0?new Date(e):new Date,o=t.getDate()<10?"0"+t.getDate():t.getDate(),n=t.getMonth()<9?"0"+(t.getMonth()+1):t.getMonth()+1,r=t.getFullYear(),i=t.getHours()<10?"0"+t.getHours():t.getHours(),a=t.getMinutes()<10?"0"+t.getMinutes():t.getMinutes(),l=t.getSeconds()<10?"0"+t.getSeconds():t.getSeconds(),c=t.getMilliseconds()<10?"0"+t.getMilliseconds():t.getMilliseconds();return c<100&&(c="0"+c),{time:+t,year:r,month:n,day:o,hour:i,minute:a,second:l,millisecond:c}},e.isNumber=o,e.isString=n,e.isArray=r,e.isBoolean=i,e.isUndefined=a,e.isNull=l,e.isSymbol=c,e.isObject=s,e.isFunction=d,e.isElement=function(e){return"object"===("undefined"==typeof HTMLElement?"undefined":t(HTMLElement))?e instanceof HTMLElement:e&&"object"===t(e)&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName},e.isWindow=u,e.isPlainObject=function(e){var o,n=Object.prototype.hasOwnProperty;if(!e||"object"!==t(e)||e.nodeType||u(e))return!1;try{if(e.constructor&&!n.call(e,"constructor")&&!n.call(e.constructor.prototype,"isPrototypeOf"))return!1}catch(e){return!1}for(o in e);return void 0===o||n.call(e,o)},e.htmlEncode=function(e){return document.createElement("a").appendChild(document.createTextNode(e)).parentNode.innerHTML},e.JSONStringify=function(e){if(!s(e)&&!r(e))return JSON.stringify(e);var t="{",o="}";r(e)&&(t="[",o="]");for(var n=t,i=f(e),a=0;a<i.length;a++){var l=i[a],u=e[l];try{r(e)||(s(l)||r(l)||c(l)?n+=Object.prototype.toString.call(l):n+=l,n+=": "),r(u)?n+="Array["+u.length+"]":s(u)||c(u)||d(u)?n+=Object.prototype.toString.call(u):n+=JSON.stringify(u),a<i.length-1&&(n+=", ")}catch(e){continue}}return n+=o},e.getObjAllKeys=f,e.getObjName=function(e){return Object.prototype.toString.call(e).replace("[object ","").replace("]","")},e.setStorage=function(e,t){window.localStorage&&(e="vConsole_"+e,localStorage.setItem(e,t))},e.getStorage=function(e){if(window.localStorage)return e="vConsole_"+e,localStorage.getItem(e)}})?n.apply(t,r):n)||(e.exports=i)},function(e,t,o){var n,r,i;r=[t,o(0),o(10)],void 0===(i="function"==typeof(n=function(o,n,r){"use strict";var i;Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0,r=(i=r)&&i.__esModule?i:{default:i};var a={one:function(e,t){try{return(t||document).querySelector(e)||void 0}catch(e){return}},all:function(e,t){try{var o=(t||document).querySelectorAll(e);return Array.from(o)}catch(e){return[]}},addClass:function(e,t){if(e){(0,n.isArray)(e)||(e=[e]);for(var o=0;o<e.length;o++){var r=e[o].className||"",i=r.split(" ");i.indexOf(t)>-1||(i.push(t),e[o].className=i.join(" "))}}},removeClass:function(e,t){if(e){(0,n.isArray)(e)||(e=[e]);for(var o=0;o<e.length;o++){for(var r=e[o].className.split(" "),i=0;i<r.length;i++)r[i]==t&&(r[i]="");e[o].className=r.join(" ").trim()}}},hasClass:function(e,t){return!(!e||!e.classList)&&e.classList.contains(t)},bind:function(e,t,o,r){e&&((0,n.isArray)(e)||(e=[e]),e.forEach(function(e){e.addEventListener(t,o,!!r)}))},delegate:function(e,t,o,n){e&&e.addEventListener(t,function(t){var r=a.all(o,e);if(r)e:for(var i=0;i<r.length;i++)for(var l=t.target;l;){if(l==r[i]){n.call(l,t);break e}if((l=l.parentNode)==e)break}},!1)}};a.render=r.default;var l=a;o.default=l,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t,o){var n,r,i;r=[t],void 0===(i="function"==typeof(n=function(o){"use strict";function n(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0;var r=function(){function e(t){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"newPlugin";!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.id=t,this.name=o,this.isReady=!1,this.eventList={}}return t=e,(o=[{key:"on",value:function(e,t){return this.eventList[e]=t,this}},{key:"trigger",value:function(e,t){if("function"==typeof this.eventList[e])this.eventList[e].call(this,t);else{var o="on"+e.charAt(0).toUpperCase()+e.slice(1);"function"==typeof this[o]&&this[o].call(this,t)}return this}},{key:"id",get:function(){return this._id},set:function(e){if(!e)throw"Plugin ID cannot be empty";this._id=e.toLowerCase()}},{key:"name",get:function(){return this._name},set:function(e){if(!e)throw"Plugin name cannot be empty";this._name=e}},{key:"vConsole",get:function(){return this._vConsole||void 0},set:function(e){if(!e)throw"vConsole cannot be empty";this._vConsole=e}}])&&n(t.prototype,o),r&&n(t,r),e;var t,o,r}();o.default=r,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t,o){"use strict";e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var o=function(e,t){var o=e[1]||"",n=e[3];if(!n)return o;if(t&&"function"==typeof btoa){var r=(a=n,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),i=n.sources.map(function(e){return"/*# sourceURL="+n.sourceRoot+e+" */"});return[o].concat(i).concat([r]).join("\n")}var a;return[o].join("\n")}(t,e);return t[2]?"@media "+t[2]+"{"+o+"}":o}).join("")},t.i=function(e,o){"string"==typeof e&&(e=[[null,e,""]]);for(var n={},r=0;r<this.length;r++){var i=this[r][0];null!=i&&(n[i]=!0)}for(r=0;r<e.length;r++){var a=e[r];null!=a[0]&&n[a[0]]||(o&&!a[2]?a[2]=o:o&&(a[2]="("+a[2]+") and ("+o+")"),t.push(a))}},t}},function(e,t,o){var n,r,i={},a=(n=function(){return window&&document&&document.all&&!window.atob},function(){return void 0===r&&(r=n.apply(this,arguments)),r}),l=function(e){var t={};return function(e,o){if("function"==typeof e)return e();if(void 0===t[e]){var n=function(e,t){return t?t.querySelector(e):document.querySelector(e)}.call(this,e,o);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(e){n=null}t[e]=n}return t[e]}}(),c=null,s=0,d=[],u=o(13);function f(e,t){for(var o=0;o<e.length;o++){var n=e[o],r=i[n.id];if(r){r.refs++;for(var a=0;a<r.parts.length;a++)r.parts[a](n.parts[a]);for(;a<n.parts.length;a++)r.parts.push(m(n.parts[a],t))}else{var l=[];for(a=0;a<n.parts.length;a++)l.push(m(n.parts[a],t));i[n.id]={id:n.id,refs:1,parts:l}}}}function v(e,t){for(var o=[],n={},r=0;r<e.length;r++){var i=e[r],a=t.base?i[0]+t.base:i[0],l={css:i[1],media:i[2],sourceMap:i[3]};n[a]?n[a].parts.push(l):o.push(n[a]={id:a,parts:[l]})}return o}function p(e,t){var o=l(e.insertInto);if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var n=d[d.length-1];if("top"===e.insertAt)n?n.nextSibling?o.insertBefore(t,n.nextSibling):o.appendChild(t):o.insertBefore(t,o.firstChild),d.push(t);else if("bottom"===e.insertAt)o.appendChild(t);else{if("object"!=typeof e.insertAt||!e.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var r=l(e.insertAt.before,o);o.insertBefore(t,r)}}function b(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e);var t=d.indexOf(e);t>=0&&d.splice(t,1)}function h(e){var t=document.createElement("style");if(void 0===e.attrs.type&&(e.attrs.type="text/css"),void 0===e.attrs.nonce){var n=function(){0;return o.nc}();n&&(e.attrs.nonce=n)}return g(t,e.attrs),p(e,t),t}function g(e,t){Object.keys(t).forEach(function(o){e.setAttribute(o,t[o])})}function m(e,t){var o,n,r,i;if(t.transform&&e.css){if(!(i="function"==typeof t.transform?t.transform(e.css):t.transform.default(e.css)))return function(){};e.css=i}if(t.singleton){var a=s++;o=c||(c=h(t)),n=w.bind(null,o,a,!1),r=w.bind(null,o,a,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(o=function(e){var t=document.createElement("link");return void 0===e.attrs.type&&(e.attrs.type="text/css"),e.attrs.rel="stylesheet",g(t,e.attrs),p(e,t),t}(t),n=function(e,t,o){var n=o.css,r=o.sourceMap,i=void 0===t.convertToAbsoluteUrls&&r;(t.convertToAbsoluteUrls||i)&&(n=u(n));r&&(n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([n],{type:"text/css"}),l=e.href;e.href=URL.createObjectURL(a),l&&URL.revokeObjectURL(l)}.bind(null,o,t),r=function(){b(o),o.href&&URL.revokeObjectURL(o.href)}):(o=h(t),n=function(e,t){var o=t.css,n=t.media;n&&e.setAttribute("media",n);if(e.styleSheet)e.styleSheet.cssText=o;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(o))}}.bind(null,o),r=function(){b(o)});return n(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;n(e=t)}else r()}}e.exports=function(e,t){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");(t=t||{}).attrs="object"==typeof t.attrs?t.attrs:{},t.singleton||"boolean"==typeof t.singleton||(t.singleton=a()),t.insertInto||(t.insertInto="head"),t.insertAt||(t.insertAt="bottom");var o=v(e,t);return f(o,t),function(e){for(var n=[],r=0;r<o.length;r++){var a=o[r];(l=i[a.id]).refs--,n.push(l)}e&&f(v(e,t),t);for(r=0;r<n.length;r++){var l;if(0===(l=n[r]).refs){for(var c=0;c<l.parts.length;c++)l.parts[c]();delete i[l.id]}}}};var y,_=(y=[],function(e,t){return y[e]=t,y.filter(Boolean).join("\n")});function w(e,t,o,n){var r=o?"":n.css;if(e.styleSheet)e.styleSheet.cssText=_(t,r);else{var i=document.createTextNode(r),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(i,a[t]):e.appendChild(i)}}},function(e,t,o){var n,r,i;r=[t,o(0),o(1),o(2),o(20),o(21),o(22)],void 0===(i="function"==typeof(n=function(o,n,r,i,a,l,c){"use strict";function s(e){return e&&e.__esModule?e:{default:e}}function d(e){return(d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function u(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function f(e,t){return!t||"object"!==d(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function v(e){return(v=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function p(e,t){return(p=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0,n=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)if(Object.prototype.hasOwnProperty.call(e,o)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,o):{};n.get||n.set?Object.defineProperty(t,o,n):t[o]=e[o]}return t.default=e,t}(n),r=s(r),i=s(i),a=s(a),l=s(l),c=s(c);var b=1e3,h=[],g={},m=function(e){function t(){var e,o;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var n=arguments.length,r=new Array(n),i=0;i<n;i++)r[i]=arguments[i];return o=f(this,(e=v(t)).call.apply(e,[this].concat(r))),h.push(o.id),o.tplTabbox="",o.allowUnformattedLog=!0,o.isReady=!1,o.isShow=!1,o.$tabbox=null,o.console={},o.logList=[],o.isInBottom=!0,o.maxLogNumber=b,o.logNumber=0,o.mockConsole(),o}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&p(e,t)}(t,e),o=t,(i=[{key:"onInit",value:function(){this.$tabbox=r.default.render(this.tplTabbox,{}),this.updateMaxLogNumber()}},{key:"onRenderTab",value:function(e){e(this.$tabbox)}},{key:"onAddTopBar",value:function(e){for(var t=this,o=["All","Log","Info","Warn","Error"],n=[],i=0;i<o.length;i++)n.push({name:o[i],data:{type:o[i].toLowerCase()},className:"",onClick:function(){if(r.default.hasClass(this,"vc-actived"))return!1;t.showLogType(this.dataset.type||"all")}});n[0].className="vc-actived",e(n)}},{key:"onAddTool",value:function(e){var t=this,o=[{name:"Clear",global:!1,onClick:function(){t.clearLog(),t.vConsole.triggerEvent("clearLog")}}];e(o)}},{key:"onReady",value:function(){var e=this;e.isReady=!0;var t=r.default.all(".vc-subtab",e.$tabbox);r.default.bind(t,"click",function(o){if(o.preventDefault(),r.default.hasClass(this,"vc-actived"))return!1;r.default.removeClass(t,"vc-actived"),r.default.addClass(this,"vc-actived");var n=this.dataset.type,i=r.default.one(".vc-log",e.$tabbox);r.default.removeClass(i,"vc-log-partly-log"),r.default.removeClass(i,"vc-log-partly-info"),r.default.removeClass(i,"vc-log-partly-warn"),r.default.removeClass(i,"vc-log-partly-error"),"all"==n?r.default.removeClass(i,"vc-log-partly"):(r.default.addClass(i,"vc-log-partly"),r.default.addClass(i,"vc-log-partly-"+n))});var o=r.default.one(".vc-content");r.default.bind(o,"scroll",function(t){e.isShow&&(o.scrollTop+o.offsetHeight>=o.scrollHeight?e.isInBottom=!0:e.isInBottom=!1)});for(var n=0;n<e.logList.length;n++)e.printLog(e.logList[n]);e.logList=[]}},{key:"onRemove",value:function(){window.console.log=this.console.log,window.console.info=this.console.info,window.console.warn=this.console.warn,window.console.debug=this.console.debug,window.console.error=this.console.error,window.console.time=this.console.time,window.console.timeEnd=this.console.timeEnd,window.console.clear=this.console.clear,this.console={};var e=h.indexOf(this.id);e>-1&&h.splice(e,1)}},{key:"onShow",value:function(){this.isShow=!0,1==this.isInBottom&&this.autoScrollToBottom()}},{key:"onHide",value:function(){this.isShow=!1}},{key:"onShowConsole",value:function(){1==this.isInBottom&&this.autoScrollToBottom()}},{key:"onUpdateOption",value:function(){this.vConsole.option.maxLogNumber!=this.maxLogNumber&&(this.updateMaxLogNumber(),this.limitMaxLogs())}},{key:"updateMaxLogNumber",value:function(){this.maxLogNumber=this.vConsole.option.maxLogNumber||b,this.maxLogNumber=Math.max(1,this.maxLogNumber)}},{key:"limitMaxLogs",value:function(){if(this.isReady)for(;this.logNumber>this.maxLogNumber;){var e=r.default.one(".vc-item",this.$tabbox);if(!e)break;e.parentNode.removeChild(e),this.logNumber--}}},{key:"showLogType",value:function(e){var t=r.default.one(".vc-log",this.$tabbox);r.default.removeClass(t,"vc-log-partly-log"),r.default.removeClass(t,"vc-log-partly-info"),r.default.removeClass(t,"vc-log-partly-warn"),r.default.removeClass(t,"vc-log-partly-error"),"all"==e?r.default.removeClass(t,"vc-log-partly"):(r.default.addClass(t,"vc-log-partly"),r.default.addClass(t,"vc-log-partly-"+e))}},{key:"autoScrollToBottom",value:function(){this.vConsole.option.disableLogScrolling||this.scrollToBottom()}},{key:"scrollToBottom",value:function(){var e=r.default.one(".vc-content");e&&(e.scrollTop=e.scrollHeight-e.offsetHeight)}},{key:"mockConsole",value:function(){var e=this,t=this,o=["log","info","warn","debug","error"];window.console?(o.map(function(e){t.console[e]=window.console[e]}),t.console.time=window.console.time,t.console.timeEnd=window.console.timeEnd,t.console.clear=window.console.clear):window.console={},o.map(function(t){window.console[t]=function(){for(var o=arguments.length,n=new Array(o),r=0;r<o;r++)n[r]=arguments[r];e.printLog({logType:t,logs:n})}});var n={};window.console.time=function(e){n[e]=Date.now()},window.console.timeEnd=function(e){var t=n[e];t?(console.log(e+":",Date.now()-t+"ms"),delete n[e]):console.log(e+": 0ms")},window.console.clear=function(){t.clearLog();for(var e=arguments.length,o=new Array(e),n=0;n<e;n++)o[n]=arguments[n];t.console.clear.apply(window.console,o)}}},{key:"clearLog",value:function(){r.default.one(".vc-log",this.$tabbox).innerHTML="",this.logNumber=0,g={}}},{key:"printOriginLog",value:function(e){"function"==typeof this.console[e.logType]&&this.console[e.logType].apply(window.console,e.logs)}},{key:"printLog",value:function(e){var t=e.logs||[];if(t.length||e.content){t=[].slice.call(t||[]);var o=/^\[(\w+)\]$/i,r="",i=!1;if(n.isString(t[0])){var a=t[0].match(o);null!==a&&a.length>0&&(r=a[1].toLowerCase(),i=h.indexOf(r)>-1)}if(r===this.id||!0!==i&&"default"===this.id)if(e._id||(e._id="__vc_"+Math.random().toString(36).substring(2,8)),e.date||(e.date=+new Date),this.isReady){n.isString(t[0])&&i&&(t[0]=t[0].replace(o,""),""===t[0]&&t.shift());for(var l={_id:e._id,logType:e.logType,logText:[],hasContent:!!e.content,count:1},c=0;c<t.length;c++)n.isFunction(t[c])?l.logText.push(t[c].toString()):n.isObject(t[c])||n.isArray(t[c])?l.logText.push(n.JSONStringify(t[c])):l.logText.push(t[c]);l.logText=l.logText.join(" "),l.hasContent||g.logType!==l.logType||g.logText!==l.logText?(this.printNewLog(e,t),g=l):this.printRepeatLog(),this.isInBottom&&this.isShow&&this.autoScrollToBottom(),e.noOrigin||this.printOriginLog(e)}else this.logList.push(e);else e.noOrigin||this.printOriginLog(e)}}},{key:"printRepeatLog",value:function(){var e=r.default.one("#"+g._id),t=r.default.one(".vc-item-repeat",e);t||((t=document.createElement("i")).className="vc-item-repeat",e.insertBefore(t,e.lastChild)),g.count,g.count++,t.innerHTML=g.count}},{key:"printNewLog",value:function(e,t){for(var o=r.default.render(a.default,{_id:e._id,logType:e.logType,style:e.style||""}),i=r.default.one(".vc-item-content",o),l=0;l<t.length;l++){var c=void 0;try{if(""===t[l])continue;c=n.isFunction(t[l])?"<span> "+t[l].toString()+"</span>":n.isObject(t[l])||n.isArray(t[l])?this.getFoldedLine(t[l]):"<span> "+n.htmlEncode(t[l]).replace(/\n/g,"<br/>")+"</span>"}catch(e){c="<span> ["+d(t[l])+"]</span>"}c&&("string"==typeof c?i.insertAdjacentHTML("beforeend",c):i.insertAdjacentElement("beforeend",c))}n.isObject(e.content)&&i.insertAdjacentElement("beforeend",e.content),r.default.one(".vc-log",this.$tabbox).insertAdjacentElement("beforeend",o),this.logNumber++,this.limitMaxLogs()}},{key:"getFoldedLine",value:function(e,t){var o=this;if(!t){var i=n.JSONStringify(e),a=i.substr(0,36);t=n.getObjName(e),i.length>36&&(a+="..."),t+=" "+a}var s=r.default.render(l.default,{outer:t,lineType:"obj"});return r.default.bind(r.default.one(".vc-fold-outer",s),"click",function(t){t.preventDefault(),t.stopPropagation(),r.default.hasClass(s,"vc-toggle")?(r.default.removeClass(s,"vc-toggle"),r.default.removeClass(r.default.one(".vc-fold-inner",s),"vc-toggle"),r.default.removeClass(r.default.one(".vc-fold-outer",s),"vc-toggle")):(r.default.addClass(s,"vc-toggle"),r.default.addClass(r.default.one(".vc-fold-inner",s),"vc-toggle"),r.default.addClass(r.default.one(".vc-fold-outer",s),"vc-toggle"));var i=r.default.one(".vc-fold-inner",s);return setTimeout(function(){if(0==i.children.length&&e){for(var t=n.getObjAllKeys(e),a=0;a<t.length;a++){var s=void 0,d="undefined",u="";try{s=e[t[a]]}catch(e){continue}n.isString(s)?(d="string",s='"'+s+'"'):n.isNumber(s)?d="number":n.isBoolean(s)?d="boolean":n.isNull(s)?(d="null",s="null"):n.isUndefined(s)?(d="undefined",s="undefined"):n.isFunction(s)?(d="function",s="function()"):n.isSymbol(s)&&(d="symbol");var f=void 0;if(n.isArray(s)){var v=n.getObjName(s)+"["+s.length+"]";f=o.getFoldedLine(s,r.default.render(c.default,{key:t[a],keyType:u,value:v,valueType:"array"},!0))}else if(n.isObject(s)){var p=n.getObjName(s);f=o.getFoldedLine(s,r.default.render(c.default,{key:n.htmlEncode(t[a]),keyType:u,value:p,valueType:"object"},!0))}else{e.hasOwnProperty&&!e.hasOwnProperty(t[a])&&(u="private");var b={lineType:"kv",key:n.htmlEncode(t[a]),keyType:u,value:n.htmlEncode(s),valueType:d};f=r.default.render(l.default,b)}i.insertAdjacentElement("beforeend",f)}if(n.isObject(e)){var h,g=e.__proto__;h=n.isObject(g)?o.getFoldedLine(g,r.default.render(c.default,{key:"__proto__",keyType:"private",value:n.getObjName(g),valueType:"object"},!0)):r.default.render(c.default,{key:"__proto__",keyType:"private",value:"null",valueType:"null"}),i.insertAdjacentElement("beforeend",h)}}}),!1}),s}}])&&u(o.prototype,i),s&&u(o,s),t;var o,i,s}(i.default);m.AddedLogID=[];var y=m;o.default=y,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t,o){var n,r,i;r=[t,o(7),o(8),o(2)],void 0===(i="function"==typeof(n=function(o,n,r,i){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0,r=a(r),i=a(i),r.default.VConsolePlugin=i.default;var l=r.default;o.default=l,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t,o){var n,r,i;r=[],void 0===(i="function"==typeof(n=function(){"use strict";if("undefined"==typeof Symbol){window.Symbol=function(){};var e="__symbol_iterator_key";window.Symbol.iterator=e,Array.prototype[e]=function(){var e=this,t=0;return{next:function(){return{done:e.length===t,value:e.length===t?void 0:e[t++]}}}}}})?n.apply(t,r):n)||(e.exports=i)},function(e,t,o){var n,r,i;r=[t,o(9),o(0),o(1),o(11),o(14),o(15),o(16),o(17),o(18),o(19),o(25),o(27),o(31),o(38)],void 0===(i="function"==typeof(n=function(o,n,r,i,a,l,c,s,d,u,f,v,p,b,h){"use strict";function g(e){return e&&e.__esModule?e:{default:e}}function m(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0,n=g(n),r=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)if(Object.prototype.hasOwnProperty.call(e,o)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,o):{};n.get||n.set?Object.defineProperty(t,o,n):t[o]=e[o]}return t.default=e,t}(r),i=g(i),l=g(l),c=g(c),s=g(s),d=g(d),u=g(u),f=g(f),v=g(v),p=g(p),b=g(b),h=g(h);var y="#__vconsole",_=function(){function e(t){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),i.default.one(y))console.debug("vConsole is already exists.");else{var o=this;if(this.version=n.default.version,this.$dom=null,this.isInited=!1,this.option={defaultPlugins:["system","network","element","storage"]},this.activedTab="",this.tabList=[],this.pluginList={},this.switchPos={x:10,y:10,startX:0,startY:0,endX:0,endY:0},this.tool=r,this.$=i.default,r.isObject(t))for(var a in t)this.option[a]=t[a];this._addBuiltInPlugins();var l,c=function(){o.isInited||(o._render(),o._mockTap(),o._bindEvent(),o._autoRun())};if(void 0!==document)"complete"==document.readyState?c():i.default.bind(window,"load",c);else l=setTimeout(function e(){document&&"complete"==document.readyState?(l&&clearTimeout(l),c()):l=setTimeout(e,1)},1)}}return t=e,(o=[{key:"_addBuiltInPlugins",value:function(){this.addPlugin(new f.default("default","Log"));var e=this.option.defaultPlugins,t={system:{proto:v.default,name:"System"},network:{proto:p.default,name:"Network"},element:{proto:b.default,name:"Element"},storage:{proto:h.default,name:"Storage"}};if(e&&r.isArray(e))for(var o=0;o<e.length;o++){var n=t[e[o]];n?this.addPlugin(new n.proto(e[o],n.name)):console.debug("Unrecognized default plugin ID:",e[o])}}},{key:"_render",value:function(){if(!i.default.one(y)){var e=document.createElement("div");e.innerHTML=l.default,document.documentElement.insertAdjacentElement("beforeend",e.children[0])}this.$dom=i.default.one(y);var t=i.default.one(".vc-switch",this.$dom),o=1*r.getStorage("switch_x"),n=1*r.getStorage("switch_y");(o||n)&&(o+t.offsetWidth>document.documentElement.offsetWidth&&(o=document.documentElement.offsetWidth-t.offsetWidth),n+t.offsetHeight>document.documentElement.offsetHeight&&(n=document.documentElement.offsetHeight-t.offsetHeight),o<0&&(o=0),n<0&&(n=0),this.switchPos.x=o,this.switchPos.y=n,i.default.one(".vc-switch").style.right=o+"px",i.default.one(".vc-switch").style.bottom=n+"px");var a=window.devicePixelRatio||1,c=document.querySelector('[name="viewport"]');if(c&&c.content){var s=c.content.match(/initial\-scale\=\d+(\.\d+)?/),d=s?parseFloat(s[0].split("=")[1]):1;d<1&&(this.$dom.style.fontSize=13*a+"px")}i.default.one(".vc-mask",this.$dom).style.display="none"}},{key:"_mockTap",value:function(){var e,t,o,n=!1,r=null;this.$dom.addEventListener("touchstart",function(n){if(void 0===e){var i=n.targetTouches[0];t=i.pageX,o=i.pageY,e=n.timeStamp,r=n.target.nodeType===Node.TEXT_NODE?n.target.parentNode:n.target}},!1),this.$dom.addEventListener("touchmove",function(e){var r=e.changedTouches[0];(Math.abs(r.pageX-t)>10||Math.abs(r.pageY-o)>10)&&(n=!0)}),this.$dom.addEventListener("touchend",function(t){if(!1===n&&t.timeStamp-e<700&&null!=r){var o=r.tagName.toLowerCase(),i=!1;switch(o){case"textarea":i=!0;break;case"input":switch(r.type){case"button":case"checkbox":case"file":case"image":case"radio":case"submit":i=!1;break;default:i=!r.disabled&&!r.readOnly}}i?r.focus():t.preventDefault();var a=t.changedTouches[0],l=document.createEvent("MouseEvents");l.initMouseEvent("click",!0,!0,window,1,a.screenX,a.screenY,a.clientX,a.clientY,!1,!1,!1,!1,0,null),l.forwardedTouchEvent=!0,l.initEvent("click",!0,!0),r.dispatchEvent(l)}e=void 0,n=!1,r=null},!1)}},{key:"_bindEvent",value:function(){var e=this,t=i.default.one(".vc-switch",e.$dom);i.default.bind(t,"touchstart",function(t){e.switchPos.startX=t.touches[0].pageX,e.switchPos.startY=t.touches[0].pageY}),i.default.bind(t,"touchend",function(t){e.switchPos.x=e.switchPos.endX,e.switchPos.y=e.switchPos.endY,e.switchPos.startX=0,e.switchPos.startY=0,r.setStorage("switch_x",e.switchPos.x),r.setStorage("switch_y",e.switchPos.y)}),i.default.bind(t,"touchmove",function(o){if(o.touches.length>0){var n=o.touches[0].pageX-e.switchPos.startX,r=o.touches[0].pageY-e.switchPos.startY,i=e.switchPos.x-n,a=e.switchPos.y-r;i+t.offsetWidth>document.documentElement.offsetWidth&&(i=document.documentElement.offsetWidth-t.offsetWidth),a+t.offsetHeight>document.documentElement.offsetHeight&&(a=document.documentElement.offsetHeight-t.offsetHeight),i<0&&(i=0),a<0&&(a=0),t.style.right=i+"px",t.style.bottom=a+"px",e.switchPos.endX=i,e.switchPos.endY=a,o.preventDefault()}}),i.default.bind(i.default.one(".vc-switch",e.$dom),"click",function(){e.show()}),i.default.bind(i.default.one(".vc-hide",e.$dom),"click",function(){e.hide()}),i.default.bind(i.default.one(".vc-mask",e.$dom),"click",function(t){if(t.target!=i.default.one(".vc-mask"))return!1;e.hide()}),i.default.delegate(i.default.one(".vc-tabbar",e.$dom),"click",".vc-tab",function(t){var o=this.dataset.tab;o!=e.activedTab&&e.showTab(o)}),i.default.bind(i.default.one(".vc-panel",e.$dom),"transitionend webkitTransitionEnd oTransitionEnd otransitionend",function(t){if(t.target!=i.default.one(".vc-panel"))return!1;i.default.hasClass(e.$dom,"vc-toggle")||(t.target.style.display="none")});var o=i.default.one(".vc-content",e.$dom),n=!1;i.default.bind(o,"touchstart",function(e){var t=o.scrollTop,r=o.scrollHeight,a=t+o.offsetHeight;0===t?(o.scrollTop=1,0===o.scrollTop&&(i.default.hasClass(e.target,"vc-cmd-input")||(n=!0))):a===r&&(o.scrollTop=t-1,o.scrollTop===t&&(i.default.hasClass(e.target,"vc-cmd-input")||(n=!0)))}),i.default.bind(o,"touchmove",function(e){n&&e.preventDefault()}),i.default.bind(o,"touchend",function(e){n=!1})}},{key:"_autoRun",value:function(){for(var e in this.isInited=!0,this.pluginList)this._initPlugin(this.pluginList[e]);this.tabList.length>0&&this.showTab(this.tabList[0]),this.triggerEvent("ready")}},{key:"triggerEvent",value:function(e,t){e="on"+e.charAt(0).toUpperCase()+e.slice(1),r.isFunction(this.option[e])&&this.option[e].apply(this,t)}},{key:"_initPlugin",value:function(e){var t=this;e.vConsole=this,e.trigger("init"),e.trigger("renderTab",function(o){t.tabList.push(e.id);var n=i.default.render(c.default,{id:e.id,name:e.name});i.default.one(".vc-tabbar",t.$dom).insertAdjacentElement("beforeend",n);var a=i.default.render(s.default,{id:e.id});o&&(r.isString(o)?a.innerHTML+=o:r.isFunction(o.appendTo)?o.appendTo(a):r.isElement(o)&&a.insertAdjacentElement("beforeend",o)),i.default.one(".vc-content",t.$dom).insertAdjacentElement("beforeend",a)}),e.trigger("addTopBar",function(o){if(o)for(var n=i.default.one(".vc-topbar",t.$dom),a=function(t){var a=o[t],l=i.default.render(d.default,{name:a.name||"Undefined",className:a.className||"",pluginID:e.id});if(a.data)for(var c in a.data)l.dataset[c]=a.data[c];r.isFunction(a.onClick)&&i.default.bind(l,"click",function(t){var o=a.onClick.call(l);!1===o||(i.default.removeClass(i.default.all(".vc-topbar-"+e.id),"vc-actived"),i.default.addClass(l,"vc-actived"))}),n.insertAdjacentElement("beforeend",l)},l=0;l<o.length;l++)a(l)}),e.trigger("addTool",function(o){if(o)for(var n=i.default.one(".vc-tool-last",t.$dom),a=function(t){var a=o[t],l=i.default.render(u.default,{name:a.name||"Undefined",pluginID:e.id});1==a.global&&i.default.addClass(l,"vc-global-tool"),r.isFunction(a.onClick)&&i.default.bind(l,"click",function(e){a.onClick.call(l)}),n.parentNode.insertBefore(l,n)},l=0;l<o.length;l++)a(l)}),e.isReady=!0,e.trigger("ready")}},{key:"_triggerPluginsEvent",value:function(e){for(var t in this.pluginList)this.pluginList[t].isReady&&this.pluginList[t].trigger(e)}},{key:"_triggerPluginEvent",value:function(e,t){var o=this.pluginList[e];o&&o.isReady&&o.trigger(t)}},{key:"addPlugin",value:function(e){return void 0!==this.pluginList[e.id]?(console.debug("Plugin "+e.id+" has already been added."),!1):(this.pluginList[e.id]=e,this.isInited&&(this._initPlugin(e),1==this.tabList.length&&this.showTab(this.tabList[0])),!0)}},{key:"removePlugin",value:function(e){e=(e+"").toLowerCase();var t=this.pluginList[e];if(void 0===t)return console.debug("Plugin "+e+" does not exist."),!1;if(t.trigger("remove"),this.isInited){var o=i.default.one("#__vc_tab_"+e);o&&o.parentNode.removeChild(o);for(var n=i.default.all(".vc-topbar-"+e,this.$dom),r=0;r<n.length;r++)n[r].parentNode.removeChild(n[r]);var a=i.default.one("#__vc_log_"+e);a&&a.parentNode.removeChild(a);for(var l=i.default.all(".vc-tool-"+e,this.$dom),c=0;c<l.length;c++)l[c].parentNode.removeChild(l[c])}var s=this.tabList.indexOf(e);s>-1&&this.tabList.splice(s,1);try{delete this.pluginList[e]}catch(t){this.pluginList[e]=void 0}return this.activedTab==e&&this.tabList.length>0&&this.showTab(this.tabList[0]),!0}},{key:"show",value:function(){if(this.isInited){var e=this,t=i.default.one(".vc-panel",this.$dom);t.style.display="block",setTimeout(function(){i.default.addClass(e.$dom,"vc-toggle"),e._triggerPluginsEvent("showConsole");var t=i.default.one(".vc-mask",e.$dom);t.style.display="block"},10)}}},{key:"hide",value:function(){if(this.isInited){i.default.removeClass(this.$dom,"vc-toggle"),this._triggerPluginsEvent("hideConsole");var e=i.default.one(".vc-mask",this.$dom),t=i.default.one(".vc-panel",this.$dom);i.default.bind(e,"transitionend",function(o){e.style.display="none",t.style.display="none"})}}},{key:"showSwitch",value:function(){if(this.isInited){var e=i.default.one(".vc-switch",this.$dom);e.style.display="block"}}},{key:"hideSwitch",value:function(){if(this.isInited){var e=i.default.one(".vc-switch",this.$dom);e.style.display="none"}}},{key:"showTab",value:function(e){if(this.isInited){var t=i.default.one("#__vc_log_"+e);i.default.removeClass(i.default.all(".vc-tab",this.$dom),"vc-actived"),i.default.addClass(i.default.one("#__vc_tab_"+e),"vc-actived"),i.default.removeClass(i.default.all(".vc-logbox",this.$dom),"vc-actived"),i.default.addClass(t,"vc-actived");var o=i.default.all(".vc-topbar-"+e,this.$dom);i.default.removeClass(i.default.all(".vc-toptab",this.$dom),"vc-toggle"),i.default.addClass(o,"vc-toggle"),o.length>0?i.default.addClass(i.default.one(".vc-content",this.$dom),"vc-has-topbar"):i.default.removeClass(i.default.one(".vc-content",this.$dom),"vc-has-topbar"),i.default.removeClass(i.default.all(".vc-tool",this.$dom),"vc-toggle"),i.default.addClass(i.default.all(".vc-tool-"+e,this.$dom),"vc-toggle"),this.activedTab&&this._triggerPluginEvent(this.activedTab,"hide"),this.activedTab=e,this._triggerPluginEvent(this.activedTab,"show")}}},{key:"setOption",value:function(e,t){if(r.isString(e))this.option[e]=t,this._triggerPluginsEvent("updateOption");else if(r.isObject(e)){for(var o in e)this.option[o]=e[o];this._triggerPluginsEvent("updateOption")}else console.debug("The first parameter of vConsole.setOption() must be a string or an object.")}},{key:"destroy",value:function(){if(this.isInited){for(var e=Object.keys(this.pluginList),t=e.length-1;t>=0;t--)this.removePlugin(e[t]);this.$dom.parentNode.removeChild(this.$dom),this.isInited=!1}}}])&&m(t.prototype,o),a&&m(t,a),e;var t,o,a}();o.default=_,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e){e.exports={name:"vconsole",version:"3.3.2",description:"A lightweight, extendable front-end developer tool for mobile web page.",homepage:"https://github.com/Tencent/vConsole",main:"dist/vconsole.min.js",typings:"./index.d.ts",scripts:{test:"mocha",dist:"webpack"},keywords:["console","debug","mobile"],repository:{type:"git",url:"git+https://github.com/Tencent/vConsole.git"},dependencies:{},devDependencies:{"@babel/core":"^7.2.2","@babel/plugin-proposal-class-properties":"^7.3.0","@babel/plugin-proposal-export-namespace-from":"^7.2.0","@babel/plugin-proposal-object-rest-spread":"^7.3.1","@babel/preset-env":"^7.3.1","babel-loader":"^8.0.4","babel-plugin-add-module-exports":"^1.0.0",chai:"^4.2.0","copy-webpack-plugin":"^5.0.3","css-loader":"^2.1.0","html-loader":"^0.5.5",jsdom:"^13.2.0","json-loader":"^0.5.7",less:"^3.9.0","less-loader":"^4.1.0",mocha:"^5.2.0","style-loader":"^0.23.1",webpack:"^4.29.0","webpack-cli":"^3.2.1"},author:"Tencent",license:"MIT"}},function(e,t,o){var n,r,i;r=[t],void 0===(i="function"==typeof(n=function(o){"use strict";Object.defineProperty(o,"__esModule",{value:!0}),o.default=function(e,t,o){var n=/\{\{([^\}]+)\}\}/g,r="",i="",a=0,l=[],c=function(e,t){""!==e&&(t?e.match(/^ ?else/g)?r+="} "+e+" {\n":e.match(/\/(if|for|switch)/g)?r+="}\n":e.match(/^ ?if|for|switch/g)?r+=e+" {\n":e.match(/^ ?(break|continue) ?$/g)?r+=e+";\n":e.match(/^ ?(case|default)/g)?r+=e+":\n":r+="arr.push("+e+");\n":r+='arr.push("'+e.replace(/"/g,'\\"')+'");\n')};for(window.__mito_data=t,window.__mito_code="",window.__mito_result="",e=(e=e.replace(/(\{\{ ?switch(.+?)\}\})[\r\n\t ]+\{\{/g,"$1{{")).replace(/^[\r\n]/,"").replace(/\n/g,"\\\n").replace(/\r/g,"\\\r"),i="(function(){\n",r="var arr = [];\n";l=n.exec(e);)c(e.slice(a,l.index),!1),c(l[1],!0),a=l.index+l[0].length;c(e.substr(a,e.length-a),!1),i+=r="with (__mito_data) {\n"+(r+='__mito_result = arr.join("");')+"\n}",i+="})();";var s=document.getElementsByTagName("script"),d="";s.length>0&&(d=s[0].nonce||"");var u=document.createElement("SCRIPT");u.innerHTML=i,u.setAttribute("nonce",d),document.documentElement.appendChild(u);var f=__mito_result;if(document.documentElement.removeChild(u),!o){var v=document.createElement("DIV");v.innerHTML=f,f=v.children[0]}return f},e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t,o){var n=o(12);"string"==typeof n&&(n=[[e.i,n,""]]);var r={hmr:!0,transform:void 0,insertInto:void 0};o(4)(n,r);n.locals&&(e.exports=n.locals)},function(e,t,o){(e.exports=o(3)(!1)).push([e.i,'#__vconsole {\n  color: #000;\n  font-size: 13px;\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  /* global */\n  /* compoment */\n}\n#__vconsole .vc-max-height {\n  max-height: 19.23076923em;\n}\n#__vconsole .vc-max-height-line {\n  max-height: 3.38461538em;\n}\n#__vconsole .vc-min-height {\n  min-height: 3.07692308em;\n}\n#__vconsole dd,\n#__vconsole dl,\n#__vconsole pre {\n  margin: 0;\n}\n#__vconsole .vc-switch {\n  display: block;\n  position: fixed;\n  right: 0.76923077em;\n  bottom: 0.76923077em;\n  color: #FFF;\n  background-color: #04BE02;\n  line-height: 1;\n  font-size: 1.07692308em;\n  padding: 0.61538462em 1.23076923em;\n  z-index: 10000;\n  border-radius: 0.30769231em;\n  box-shadow: 0 0 0.61538462em rgba(0, 0, 0, 0.4);\n}\n#__vconsole .vc-mask {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0);\n  z-index: 10001;\n  transition: background 0.3s;\n  -webkit-tap-highlight-color: transparent;\n  overflow-y: scroll;\n}\n#__vconsole .vc-panel {\n  display: none;\n  position: fixed;\n  min-height: 85%;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10002;\n  background-color: #EFEFF4;\n  -webkit-transition: -webkit-transform 0.3s;\n  transition: -webkit-transform 0.3s;\n  transition: transform 0.3s;\n  transition: transform 0.3s, -webkit-transform 0.3s;\n  -webkit-transform: translate(0, 100%);\n  transform: translate(0, 100%);\n}\n#__vconsole .vc-tabbar {\n  border-bottom: 1px solid #D9D9D9;\n  overflow-x: auto;\n  height: 3em;\n  width: auto;\n  white-space: nowrap;\n}\n#__vconsole .vc-tabbar .vc-tab {\n  display: inline-block;\n  line-height: 3em;\n  padding: 0 1.15384615em;\n  border-right: 1px solid #D9D9D9;\n  text-decoration: none;\n  color: #000;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n#__vconsole .vc-tabbar .vc-tab:active {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n#__vconsole .vc-tabbar .vc-tab.vc-actived {\n  background-color: #FFF;\n}\n#__vconsole .vc-content {\n  background-color: #FFF;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: absolute;\n  top: 3.07692308em;\n  left: 0;\n  right: 0;\n  bottom: 3.07692308em;\n  -webkit-overflow-scrolling: touch;\n  margin-bottom: constant(safe-area-inset-bottom);\n  margin-bottom: env(safe-area-inset-bottom);\n}\n#__vconsole .vc-content.vc-has-topbar {\n  top: 5.46153846em;\n}\n#__vconsole .vc-topbar {\n  background-color: #FBF9FE;\n  display: flex;\n  display: -webkit-box;\n  flex-direction: row;\n  flex-wrap: wrap;\n  -webkit-box-direction: row;\n  -webkit-flex-wrap: wrap;\n  width: 100%;\n}\n#__vconsole .vc-topbar .vc-toptab {\n  display: none;\n  flex: 1;\n  -webkit-box-flex: 1;\n  line-height: 2.30769231em;\n  padding: 0 1.15384615em;\n  border-bottom: 1px solid #D9D9D9;\n  text-decoration: none;\n  text-align: center;\n  color: #000;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n#__vconsole .vc-topbar .vc-toptab.vc-toggle {\n  display: block;\n}\n#__vconsole .vc-topbar .vc-toptab:active {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n#__vconsole .vc-topbar .vc-toptab.vc-actived {\n  border-bottom: 1px solid #3e82f7;\n}\n#__vconsole .vc-logbox {\n  display: none;\n  position: relative;\n  min-height: 100%;\n}\n#__vconsole .vc-logbox i {\n  font-style: normal;\n}\n#__vconsole .vc-logbox .vc-log {\n  padding-bottom: 3em;\n  -webkit-tap-highlight-color: transparent;\n}\n#__vconsole .vc-logbox .vc-log:empty:before {\n  content: "Empty";\n  color: #999;\n  position: absolute;\n  top: 45%;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  font-size: 1.15384615em;\n  text-align: center;\n}\n#__vconsole .vc-logbox .vc-item {\n  margin: 0;\n  padding: 0.46153846em 0.61538462em;\n  overflow: hidden;\n  line-height: 1.3;\n  border-bottom: 1px solid #EEE;\n  word-break: break-word;\n}\n#__vconsole .vc-logbox .vc-item-info {\n  color: #6A5ACD;\n}\n#__vconsole .vc-logbox .vc-item-debug {\n  color: #DAA520;\n}\n#__vconsole .vc-logbox .vc-item-warn {\n  color: #FFA500;\n  border-color: #FFB930;\n  background-color: #FFFACD;\n}\n#__vconsole .vc-logbox .vc-item-error {\n  color: #DC143C;\n  border-color: #F4A0AB;\n  background-color: #FFE4E1;\n}\n#__vconsole .vc-logbox .vc-log.vc-log-partly .vc-item {\n  display: none;\n}\n#__vconsole .vc-logbox .vc-log.vc-log-partly-log .vc-item-log,\n#__vconsole .vc-logbox .vc-log.vc-log-partly-info .vc-item-info,\n#__vconsole .vc-logbox .vc-log.vc-log-partly-warn .vc-item-warn,\n#__vconsole .vc-logbox .vc-log.vc-log-partly-error .vc-item-error {\n  display: block;\n}\n#__vconsole .vc-logbox .vc-item .vc-item-content {\n  margin-right: 4.61538462em;\n  display: inline-block;\n}\n#__vconsole .vc-logbox .vc-item .vc-item-repeat {\n  display: inline-block;\n  margin-right: 0.30769231em;\n  padding: 0 6.5px;\n  color: #D7E0EF;\n  background-color: #42597F;\n  border-radius: 8.66666667px;\n}\n#__vconsole .vc-logbox .vc-item.vc-item-error .vc-item-repeat {\n  color: #901818;\n  background-color: #DC2727;\n}\n#__vconsole .vc-logbox .vc-item.vc-item-warn .vc-item-repeat {\n  color: #987D20;\n  background-color: #F4BD02;\n}\n#__vconsole .vc-logbox .vc-item .vc-item-code {\n  display: block;\n  white-space: pre-wrap;\n  overflow: auto;\n  position: relative;\n}\n#__vconsole .vc-logbox .vc-item .vc-item-code.vc-item-code-input,\n#__vconsole .vc-logbox .vc-item .vc-item-code.vc-item-code-output {\n  padding-left: 0.92307692em;\n}\n#__vconsole .vc-logbox .vc-item .vc-item-code.vc-item-code-input:before,\n#__vconsole .vc-logbox .vc-item .vc-item-code.vc-item-code-output:before {\n  content: "›";\n  position: absolute;\n  top: -0.23076923em;\n  left: 0;\n  font-size: 1.23076923em;\n  color: #6A5ACD;\n}\n#__vconsole .vc-logbox .vc-item .vc-item-code.vc-item-code-output:before {\n  content: "‹";\n}\n#__vconsole .vc-logbox .vc-item .vc-fold {\n  display: block;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n#__vconsole .vc-logbox .vc-item .vc-fold .vc-fold-outer {\n  display: block;\n  font-style: italic;\n  padding-left: 0.76923077em;\n  position: relative;\n}\n#__vconsole .vc-logbox .vc-item .vc-fold .vc-fold-outer:active {\n  background-color: #E6E6E6;\n}\n#__vconsole .vc-logbox .vc-item .vc-fold .vc-fold-outer:before {\n  content: "";\n  position: absolute;\n  top: 0.30769231em;\n  left: 0.15384615em;\n  width: 0;\n  height: 0;\n  border: transparent solid 0.30769231em;\n  border-left-color: #000;\n}\n#__vconsole .vc-logbox .vc-item .vc-fold .vc-fold-outer.vc-toggle:before {\n  top: 0.46153846em;\n  left: 0;\n  border-top-color: #000;\n  border-left-color: transparent;\n}\n#__vconsole .vc-logbox .vc-item .vc-fold .vc-fold-inner {\n  display: none;\n  margin-left: 0.76923077em;\n}\n#__vconsole .vc-logbox .vc-item .vc-fold .vc-fold-inner.vc-toggle {\n  display: block;\n}\n#__vconsole .vc-logbox .vc-item .vc-fold .vc-fold-inner .vc-code-key {\n  margin-left: 0.76923077em;\n}\n#__vconsole .vc-logbox .vc-item .vc-fold .vc-fold-outer .vc-code-key {\n  margin-left: 0;\n}\n#__vconsole .vc-logbox .vc-code-key {\n  color: #905;\n}\n#__vconsole .vc-logbox .vc-code-private-key {\n  color: #D391B5;\n}\n#__vconsole .vc-logbox .vc-code-function {\n  color: #905;\n  font-style: italic;\n}\n#__vconsole .vc-logbox .vc-code-number,\n#__vconsole .vc-logbox .vc-code-boolean {\n  color: #0086B3;\n}\n#__vconsole .vc-logbox .vc-code-string {\n  color: #183691;\n}\n#__vconsole .vc-logbox .vc-code-null,\n#__vconsole .vc-logbox .vc-code-undefined {\n  color: #666;\n}\n#__vconsole .vc-logbox .vc-cmd {\n  position: absolute;\n  height: 3.07692308em;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-top: 1px solid #D9D9D9;\n  display: block!important;\n}\n#__vconsole .vc-logbox .vc-cmd .vc-cmd-input-wrap {\n  display: block;\n  height: 2.15384615em;\n  margin-right: 3.07692308em;\n  padding: 0.46153846em 0.61538462em;\n}\n#__vconsole .vc-logbox .vc-cmd .vc-cmd-input {\n  width: 100%;\n  border: none;\n  resize: none;\n  outline: none;\n  padding: 0;\n  font-size: 0.92307692em;\n}\n#__vconsole .vc-logbox .vc-cmd .vc-cmd-input::-webkit-input-placeholder {\n  line-height: 2.15384615em;\n}\n#__vconsole .vc-logbox .vc-cmd .vc-cmd-btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 3.07692308em;\n  border: none;\n  background-color: #EFEFF4;\n  outline: none;\n  -webkit-touch-callout: none;\n  font-size: 1em;\n}\n#__vconsole .vc-logbox .vc-cmd .vc-cmd-btn:active {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n#__vconsole .vc-logbox .vc-cmd .vc-cmd-prompted {\n  position: fixed;\n  width: 100%;\n  background-color: #FBF9FE;\n  border: 1px solid #D9D9D9;\n  overflow-x: scroll;\n  display: none;\n}\n#__vconsole .vc-logbox .vc-cmd .vc-cmd-prompted li {\n  list-style: none;\n  line-height: 30px;\n  padding: 0 0.46153846em;\n  border-bottom: 1px solid #D9D9D9;\n}\n#__vconsole .vc-logbox .vc-group .vc-group-preview {\n  -webkit-touch-callout: none;\n}\n#__vconsole .vc-logbox .vc-group .vc-group-preview:active {\n  background-color: #E6E6E6;\n}\n#__vconsole .vc-logbox .vc-group .vc-group-detail {\n  display: none;\n  padding: 0 0 0.76923077em 1.53846154em;\n  border-bottom: 1px solid #EEE;\n}\n#__vconsole .vc-logbox .vc-group.vc-actived .vc-group-detail {\n  display: block;\n  background-color: #FBF9FE;\n}\n#__vconsole .vc-logbox .vc-group.vc-actived .vc-table-row {\n  background-color: #FFF;\n}\n#__vconsole .vc-logbox .vc-group.vc-actived .vc-group-preview {\n  background-color: #FBF9FE;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-row {\n  display: flex;\n  display: -webkit-flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  -webkit-box-direction: row;\n  -webkit-flex-wrap: wrap;\n  overflow: hidden;\n  border-bottom: 1px solid #EEE;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-row.vc-left-border {\n  border-left: 1px solid #EEE;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-col {\n  flex: 1;\n  -webkit-box-flex: 1;\n  padding: 0.23076923em 0.30769231em;\n  border-left: 1px solid #EEE;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n  /*white-space: nowrap;\n        text-overflow: ellipsis;*/\n  -webkit-overflow-scrolling: touch;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-col:first-child {\n  border: none;\n}\n#__vconsole .vc-logbox .vc-table .vc-small .vc-table-col {\n  padding: 0 0.30769231em;\n  font-size: 0.92307692em;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-col-2 {\n  flex: 2;\n  -webkit-box-flex: 2;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-col-3 {\n  flex: 3;\n  -webkit-box-flex: 3;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-col-4 {\n  flex: 4;\n  -webkit-box-flex: 4;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-col-5 {\n  flex: 5;\n  -webkit-box-flex: 5;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-col-6 {\n  flex: 6;\n  -webkit-box-flex: 6;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-row-error {\n  border-color: #F4A0AB;\n  background-color: #FFE4E1;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-row-error .vc-table-col {\n  color: #DC143C;\n  border-color: #F4A0AB;\n}\n#__vconsole .vc-logbox .vc-table .vc-table-col-title {\n  font-weight: bold;\n}\n#__vconsole .vc-logbox.vc-actived {\n  display: block;\n}\n#__vconsole .vc-toolbar {\n  border-top: 1px solid #D9D9D9;\n  line-height: 3em;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  display: -webkit-box;\n  flex-direction: row;\n  -webkit-box-direction: row;\n}\n#__vconsole .vc-toolbar .vc-tool {\n  display: none;\n  text-decoration: none;\n  color: #000;\n  width: 50%;\n  flex: 1;\n  -webkit-box-flex: 1;\n  text-align: center;\n  position: relative;\n  -webkit-touch-callout: none;\n}\n#__vconsole .vc-toolbar .vc-tool.vc-toggle,\n#__vconsole .vc-toolbar .vc-tool.vc-global-tool {\n  display: block;\n}\n#__vconsole .vc-toolbar .vc-tool:active {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n#__vconsole .vc-toolbar .vc-tool:after {\n  content: " ";\n  position: absolute;\n  top: 0.53846154em;\n  bottom: 0.53846154em;\n  right: 0;\n  border-left: 1px solid #D9D9D9;\n}\n#__vconsole .vc-toolbar .vc-tool-last:after {\n  border: none;\n}\n@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {\n  #__vconsole .vc-toolbar,\n  #__vconsole .vc-switch {\n    bottom: constant(safe-area-inset-bottom);\n    bottom: env(safe-area-inset-bottom);\n  }\n}\n#__vconsole.vc-toggle .vc-switch {\n  display: none;\n}\n#__vconsole.vc-toggle .vc-mask {\n  background: rgba(0, 0, 0, 0.6);\n  display: block;\n}\n#__vconsole.vc-toggle .vc-panel {\n  -webkit-transform: translate(0, 0);\n  transform: translate(0, 0);\n}\n',""])},function(e,t){e.exports=function(e){var t="undefined"!=typeof window&&window.location;if(!t)throw new Error("fixUrls requires window.location");if(!e||"string"!=typeof e)return e;var o=t.protocol+"//"+t.host,n=o+t.pathname.replace(/\/[^\/]*$/,"/");return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(e,t){var r,i=t.trim().replace(/^"(.*)"$/,function(e,t){return t}).replace(/^'(.*)'$/,function(e,t){return t});return/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i)?e:(r=0===i.indexOf("//")?i:0===i.indexOf("/")?o+i:n+i.replace(/^\.\//,""),"url("+JSON.stringify(r)+")")})}},function(e,t){e.exports='<div id="__vconsole" class="">\n  <div class="vc-switch">vConsole</div>\n  <div class="vc-mask">\n  </div>\n  <div class="vc-panel">\n    <div class="vc-tabbar">\n    </div>\n    <div class="vc-topbar">\n    </div>\n    <div class="vc-content">\n    </div>\n    <div class="vc-toolbar">\n      <a class="vc-tool vc-global-tool vc-tool-last vc-hide">Hide</a>\n    </div>\n  </div>\n</div>'},function(e,t){e.exports='<a class="vc-tab" data-tab="{{id}}" id="__vc_tab_{{id}}">{{name}}</a>'},function(e,t){e.exports='<div class="vc-logbox" id="__vc_log_{{id}}">\n  \n</div>'},function(e,t){e.exports='<a class="vc-toptab vc-topbar-{{pluginID}}{{if (className)}} {{className}}{{/if}}">{{name}}</a>'},function(e,t){e.exports='<a class="vc-tool vc-tool-{{pluginID}}">{{name}}</a>'},function(module,exports,__webpack_require__){var __WEBPACK_AMD_DEFINE_FACTORY__,__WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__,factory;factory=function(_exports,_query,tool,_log,_tabbox_default,_item_code){"use strict";function _interopRequireWildcard(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)if(Object.prototype.hasOwnProperty.call(e,o)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,o):{};n.get||n.set?Object.defineProperty(t,o,n):t[o]=e[o]}return t.default=e,t}function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _defineProperties(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function _createClass(e,t,o){return t&&_defineProperties(e.prototype,t),o&&_defineProperties(e,o),e}function _possibleConstructorReturn(e,t){return!t||"object"!==_typeof(t)&&"function"!=typeof t?_assertThisInitialized(e):t}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function _get(e,t,o){return(_get="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(e,t,o){var n=_superPropBase(e,t);if(n){var r=Object.getOwnPropertyDescriptor(n,t);return r.get?r.get.call(o):r.value}})(e,t,o||e)}function _superPropBase(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=_getPrototypeOf(e)););return e}function _getPrototypeOf(e){return(_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&_setPrototypeOf(e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}Object.defineProperty(_exports,"__esModule",{value:!0}),_exports.default=void 0,_query=_interopRequireDefault(_query),tool=_interopRequireWildcard(tool),_log=_interopRequireDefault(_log),_tabbox_default=_interopRequireDefault(_tabbox_default),_item_code=_interopRequireDefault(_item_code);var VConsoleDefaultTab=function(_VConsoleLogTab){function VConsoleDefaultTab(){var e,t;_classCallCheck(this,VConsoleDefaultTab);for(var o=arguments.length,n=new Array(o),r=0;r<o;r++)n[r]=arguments[r];return(t=_possibleConstructorReturn(this,(e=_getPrototypeOf(VConsoleDefaultTab)).call.apply(e,[this].concat(n)))).tplTabbox=_tabbox_default.default,t}return _inherits(VConsoleDefaultTab,_VConsoleLogTab),_createClass(VConsoleDefaultTab,[{key:"onReady",value:function onReady(){var that=this;_get(_getPrototypeOf(VConsoleDefaultTab.prototype),"onReady",this).call(this),window.winKeys=Object.getOwnPropertyNames(window).sort(),window.keyTypes={};for(var i=0;i<winKeys.length;i++)keyTypes[winKeys[i]]=_typeof(window[winKeys[i]]);var cacheObj={},ID_REGEX=/[a-zA-Z_0-9\$\-\u00A2-\uFFFF]/,retrievePrecedingIdentifier=function(e,t,o){o=o||ID_REGEX;for(var n=[],r=t-1;r>=0&&o.test(e[r]);r--)n.push(e[r]);if(0==n.length){o=/\./;for(var i=t-1;i>=0&&o.test(e[i]);i--)n.push(e[i])}if(0===n.length){var a=e.match(/[\(\)\[\]\{\}]/gi)||[];return a[a.length-1]}return n.reverse().join("")};_query.default.bind(_query.default.one(".vc-cmd-input"),"keyup",function(e){var isDeleteKeyCode=8===e.keyCode||46===e.keyCode,$prompted=_query.default.one(".vc-cmd-prompted");$prompted.style.display="none",$prompted.innerHTML="";var tempValue=this.value,value=retrievePrecedingIdentifier(this.value,this.value.length);if(value&&value.length>0){if(/\(/.test(value)&&!isDeleteKeyCode)return void(_query.default.one(".vc-cmd-input").value+=")");if(/\[/.test(value)&&!isDeleteKeyCode)return void(_query.default.one(".vc-cmd-input").value+="]");if(/\{/.test(value)&&!isDeleteKeyCode)return void(_query.default.one(".vc-cmd-input").value+="}");if("."===value){var key=retrievePrecedingIdentifier(tempValue,tempValue.length-1);if(!cacheObj[key])try{cacheObj[key]=Object.getOwnPropertyNames(eval("("+key+")")).sort()}catch(e){}try{for(var _i3=0;_i3<cacheObj[key].length;_i3++){var $li=document.createElement("li"),_key=cacheObj[key][_i3];$li.innerHTML=_key,$li.onclick=function(){_query.default.one(".vc-cmd-input").value="",_query.default.one(".vc-cmd-input").value=tempValue+this.innerHTML,$prompted.style.display="none"},$prompted.appendChild($li)}}catch(e){}}else if("."!==value.substring(value.length-1)&&value.indexOf(".")<0){for(var _i4=0;_i4<winKeys.length;_i4++)if(winKeys[_i4].toLowerCase().indexOf(value.toLowerCase())>=0){var _$li=document.createElement("li");_$li.innerHTML=winKeys[_i4],_$li.onclick=function(){_query.default.one(".vc-cmd-input").value="",_query.default.one(".vc-cmd-input").value=this.innerHTML,"function"==keyTypes[this.innerHTML]&&(_query.default.one(".vc-cmd-input").value+="()"),$prompted.style.display="none"},$prompted.appendChild(_$li)}}else{var arr=value.split(".");if(cacheObj[arr[0]]){cacheObj[arr[0]].sort();for(var _i5=0;_i5<cacheObj[arr[0]].length;_i5++){var _$li2=document.createElement("li"),_key3=cacheObj[arr[0]][_i5];_key3.indexOf(arr[1])>=0&&(_$li2.innerHTML=_key3,_$li2.onclick=function(){_query.default.one(".vc-cmd-input").value="",_query.default.one(".vc-cmd-input").value=tempValue+this.innerHTML,$prompted.style.display="none"},$prompted.appendChild(_$li2))}}}if($prompted.children.length>0){var m=Math.min(200,31*$prompted.children.length);$prompted.style.display="block",$prompted.style.height=m+"px",$prompted.style.marginTop=-m+"px"}}else $prompted.style.display="none"}),_query.default.bind(_query.default.one(".vc-cmd",this.$tabbox),"submit",function(e){e.preventDefault();var t=_query.default.one(".vc-cmd-input",e.target),o=t.value;t.value="",""!==o&&that.evalCommand(o);var n=_query.default.one(".vc-cmd-prompted");n&&(n.style.display="none")});var code="";code+="if (!!window) {",code+="window.__vConsole_cmd_result = undefined;",code+="window.__vConsole_cmd_error = false;",code+="}";var scriptList=document.getElementsByTagName("script"),nonce="";scriptList.length>0&&(nonce=scriptList[0].nonce||"");var script=document.createElement("SCRIPT");script.innerHTML=code,script.setAttribute("nonce",nonce),document.documentElement.appendChild(script),document.documentElement.removeChild(script)}},{key:"mockConsole",value:function(){_get(_getPrototypeOf(VConsoleDefaultTab.prototype),"mockConsole",this).call(this);var e=this;tool.isFunction(window.onerror)&&(this.windowOnError=window.onerror),window.onerror=function(t,o,n,r,i){var a=t;o&&(a+="\n"+o.replace(location.origin,"")),(n||r)&&(a+=":"+n+":"+r);var l=!!i&&!!i.stack&&i.stack.toString()||"";e.printLog({logType:"error",logs:[a,l],noOrigin:!0}),tool.isFunction(e.windowOnError)&&e.windowOnError.call(window,t,o,n,r,i)}}},{key:"evalCommand",value:function(e){this.printLog({logType:"log",content:_query.default.render(_item_code.default,{content:e,type:"input"}),style:""});var t,o=void 0;try{o=eval.call(window,"("+e+")")}catch(t){try{o=eval.call(window,e)}catch(e){}}tool.isArray(o)||tool.isObject(o)?t=this.getFoldedLine(o):(tool.isNull(o)?o="null":tool.isUndefined(o)?o="undefined":tool.isFunction(o)?o="function()":tool.isString(o)&&(o='"'+o+'"'),t=_query.default.render(_item_code.default,{content:o,type:"output"})),this.printLog({logType:"log",content:t,style:""}),window.winKeys=Object.getOwnPropertyNames(window).sort()}}]),VConsoleDefaultTab}(_log.default),_default=VConsoleDefaultTab;_exports.default=_default,module.exports=exports.default},__WEBPACK_AMD_DEFINE_ARRAY__=[exports,__webpack_require__(1),__webpack_require__(0),__webpack_require__(5),__webpack_require__(23),__webpack_require__(24)],void 0===(__WEBPACK_AMD_DEFINE_RESULT__="function"==typeof(__WEBPACK_AMD_DEFINE_FACTORY__=factory)?__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__):__WEBPACK_AMD_DEFINE_FACTORY__)||(module.exports=__WEBPACK_AMD_DEFINE_RESULT__)},function(e,t){e.exports='<div id="{{_id}}" class="vc-item vc-item-{{logType}} {{style}}">\n\t<div class="vc-item-content"></div>\n</div>'},function(e,t){e.exports='<div class="vc-fold">\n  {{if (lineType == \'obj\')}}\n    <i class="vc-fold-outer">{{outer}}</i>\n    <div class="vc-fold-inner"></div>\n  {{else if (lineType == \'value\')}}\n    <i class="vc-code-{{valueType}}">{{value}}</i>\n  {{else if (lineType == \'kv\')}}\n    <i class="vc-code-key{{if (keyType)}} vc-code-{{keyType}}-key{{/if}}">{{key}}</i>: <i class="vc-code-{{valueType}}">{{value}}</i>\n  {{/if}}\n</div>'},function(e,t){e.exports='<span>\n  <i class="vc-code-key{{if (keyType)}} vc-code-{{keyType}}-key{{/if}}">{{key}}</i>: <i class="vc-code-{{valueType}}">{{value}}</i>\n</span>'},function(e,t){e.exports='<div>\n  <div class="vc-log"></div>\n  <form class="vc-cmd">\n    <button class="vc-cmd-btn" type="submit">OK</button>\n    <ul class=\'vc-cmd-prompted\'></ul>\n    <div class="vc-cmd-input-wrap">\n      <textarea class="vc-cmd-input" placeholder="command..."></textarea>\n    </div>\n  </form>\n</div>'},function(e,t){e.exports='<pre class="vc-item-code vc-item-code-{{type}}">{{content}}</pre>'},function(e,t,o){var n,r,i;r=[t,o(5),o(26)],void 0===(i="function"==typeof(n=function(o,n,r){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function a(e){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function l(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function c(e,t){return!t||"object"!==a(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function s(e,t,o){return(s="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(e,t,o){var n=function(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=d(e)););return e}(e,t);if(n){var r=Object.getOwnPropertyDescriptor(n,t);return r.get?r.get.call(o):r.value}})(e,t,o||e)}function d(e){return(d=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function u(e,t){return(u=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0,n=i(n),r=i(r);var f=function(e){function t(){var e,o;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var n=arguments.length,i=new Array(n),a=0;a<n;a++)i[a]=arguments[a];return(o=c(this,(e=d(t)).call.apply(e,[this].concat(i)))).tplTabbox=r.default,o.allowUnformattedLog=!1,o}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&u(e,t)}(t,e),o=t,(n=[{key:"onInit",value:function(){s(d(t.prototype),"onInit",this).call(this),this.printSystemInfo()}},{key:"printSystemInfo",value:function(){var e=navigator.userAgent,t="",o=e.match(/(ipod).*\s([\d_]+)/i),n=e.match(/(ipad).*\s([\d_]+)/i),r=e.match(/(iphone)\sos\s([\d_]+)/i),i=e.match(/(android)\s([\d\.]+)/i);t="Unknown",i?t="Android "+i[2]:r?t="iPhone, iOS "+r[2].replace(/_/g,"."):n?t="iPad, iOS "+n[2].replace(/_/g,"."):o&&(t="iPod, iOS "+o[2].replace(/_/g,"."));var a=t,l=e.match(/MicroMessenger\/([\d\.]+)/i);t="Unknown",l&&l[1]?(t=l[1],a+=", WeChat "+t,console.info("[system]","System:",a)):console.info("[system]","System:",a),t="Unknown",t="https:"==location.protocol?"HTTPS":"http:"==location.protocol?"HTTP":location.protocol.replace(":",""),a=t;var c=e.toLowerCase().match(/ nettype\/([^ ]+)/g);t="Unknown",c&&c[0]?(c=c[0].split("/"),t=c[1],a+=", "+t,console.info("[system]","Network:",a)):console.info("[system]","Protocol:",a),console.info("[system]","UA:",e),setTimeout(function(){var e=window.performance||window.msPerformance||window.webkitPerformance;if(e&&e.timing){var t=e.timing;t.navigationStart&&console.info("[system]","navigationStart:",t.navigationStart),t.navigationStart&&t.domainLookupStart&&console.info("[system]","navigation:",t.domainLookupStart-t.navigationStart+"ms"),t.domainLookupEnd&&t.domainLookupStart&&console.info("[system]","dns:",t.domainLookupEnd-t.domainLookupStart+"ms"),t.connectEnd&&t.connectStart&&(t.connectEnd&&t.secureConnectionStart?console.info("[system]","tcp (ssl):",t.connectEnd-t.connectStart+"ms ("+(t.connectEnd-t.secureConnectionStart)+"ms)"):console.info("[system]","tcp:",t.connectEnd-t.connectStart+"ms")),t.responseStart&&t.requestStart&&console.info("[system]","request:",t.responseStart-t.requestStart+"ms"),t.responseEnd&&t.responseStart&&console.info("[system]","response:",t.responseEnd-t.responseStart+"ms"),t.domComplete&&t.domLoading&&(t.domContentLoadedEventStart&&t.domLoading?console.info("[system]","domComplete (domLoaded):",t.domComplete-t.domLoading+"ms ("+(t.domContentLoadedEventStart-t.domLoading)+"ms)"):console.info("[system]","domComplete:",t.domComplete-t.domLoading+"ms")),t.loadEventEnd&&t.loadEventStart&&console.info("[system]","loadEvent:",t.loadEventEnd-t.loadEventStart+"ms"),t.navigationStart&&t.loadEventEnd&&console.info("[system]","total (DOM):",t.loadEventEnd-t.navigationStart+"ms ("+(t.domComplete-t.navigationStart)+"ms)")}},0)}}])&&l(o.prototype,n),i&&l(o,i),t;var o,n,i}(n.default);o.default=f,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t){e.exports='<div>\n  <div class="vc-log"></div>\n</div>'},function(e,t,o){var n,r,i;r=[t,o(1),o(0),o(2),o(28),o(29),o(30)],void 0===(i="function"==typeof(n=function(o,n,r,i,a,l,c){"use strict";function s(e){return e&&e.__esModule?e:{default:e}}function d(e){return(d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function u(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function f(e,t){return!t||"object"!==d(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function v(e){return(v=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function p(e,t){return(p=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0,n=s(n),r=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)if(Object.prototype.hasOwnProperty.call(e,o)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,o):{};n.get||n.set?Object.defineProperty(t,o,n):t[o]=e[o]}return t.default=e,t}(r),i=s(i),a=s(a),l=s(l),c=s(c);var b=function(e){function t(){var e,o;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var r=arguments.length,i=new Array(r),l=0;l<r;l++)i[l]=arguments[l];return(o=f(this,(e=v(t)).call.apply(e,[this].concat(i)))).$tabbox=n.default.render(a.default,{}),o.$header=null,o.reqList={},o.domList={},o.isReady=!1,o.isShow=!1,o.isInBottom=!0,o._open=void 0,o._send=void 0,o.mockAjax(),o}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&p(e,t)}(t,e),o=t,(i=[{key:"onRenderTab",value:function(e){e(this.$tabbox)}},{key:"onAddTool",value:function(e){var t=this,o=[{name:"Clear",global:!1,onClick:function(e){t.clearLog()}}];e(o)}},{key:"onReady",value:function(){var e=this;e.isReady=!0,this.renderHeader(),n.default.delegate(n.default.one(".vc-log",this.$tabbox),"click",".vc-group-preview",function(t){var o=this.dataset.reqid,r=this.parentNode;n.default.hasClass(r,"vc-actived")?(n.default.removeClass(r,"vc-actived"),e.updateRequest(o,{actived:!1})):(n.default.addClass(r,"vc-actived"),e.updateRequest(o,{actived:!0})),t.preventDefault()});var t=n.default.one(".vc-content");for(var o in n.default.bind(t,"scroll",function(o){e.isShow&&(t.scrollTop+t.offsetHeight>=t.scrollHeight?e.isInBottom=!0:e.isInBottom=!1)}),e.reqList)e.updateRequest(o,{})}},{key:"onRemove",value:function(){window.XMLHttpRequest&&(window.XMLHttpRequest.prototype.open=this._open,window.XMLHttpRequest.prototype.send=this._send,this._open=void 0,this._send=void 0)}},{key:"onShow",value:function(){this.isShow=!0,1==this.isInBottom&&this.scrollToBottom()}},{key:"onHide",value:function(){this.isShow=!1}},{key:"onShowConsole",value:function(){1==this.isInBottom&&this.scrollToBottom()}},{key:"scrollToBottom",value:function(){var e=n.default.one(".vc-content");e.scrollTop=e.scrollHeight-e.offsetHeight}},{key:"clearLog",value:function(){for(var e in this.reqList={},this.domList)this.domList[e].remove(),this.domList[e]=void 0;this.domList={},this.renderHeader()}},{key:"renderHeader",value:function(){var e=Object.keys(this.reqList).length,t=n.default.render(l.default,{count:e}),o=n.default.one(".vc-log",this.$tabbox);this.$header?this.$header.parentNode.replaceChild(t,this.$header):o.parentNode.insertBefore(t,o),this.$header=t}},{key:"updateRequest",value:function(e,t){var o=Object.keys(this.reqList).length,i=this.reqList[e]||{};for(var a in t)i[a]=t[a];if(this.reqList[e]=i,this.isReady){var l={id:e,url:i.url,status:i.status,method:i.method||"-",costTime:i.costTime>0?i.costTime+"ms":"-",header:i.header||null,getData:i.getData||null,postData:i.postData||null,response:null,actived:!!i.actived};switch(i.responseType){case"":case"text":if(r.isString(i.response))try{l.response=JSON.parse(i.response),l.response=JSON.stringify(l.response,null,1),l.response=r.htmlEncode(l.response)}catch(e){l.response=r.htmlEncode(i.response)}else void 0!==i.response&&(l.response=Object.prototype.toString.call(i.response));break;case"json":void 0!==i.response&&(l.response=JSON.stringify(i.response,null,1),l.response=r.htmlEncode(l.response));break;case"blob":case"document":case"arraybuffer":default:void 0!==i.response&&(l.response=Object.prototype.toString.call(i.response))}0==i.readyState||1==i.readyState?l.status="Pending":2==i.readyState||3==i.readyState?l.status="Loading":4==i.readyState||(l.status="Unknown");var s=n.default.render(c.default,l),d=this.domList[e];i.status>=400&&n.default.addClass(n.default.one(".vc-group-preview",s),"vc-table-row-error"),d?d.parentNode.replaceChild(s,d):n.default.one(".vc-log",this.$tabbox).insertAdjacentElement("beforeend",s),this.domList[e]=s;var u=Object.keys(this.reqList).length;u!=o&&this.renderHeader(),this.isInBottom&&this.scrollToBottom()}}},{key:"mockAjax",value:function(){var e=window.XMLHttpRequest;if(e){var t=this,o=window.XMLHttpRequest.prototype.open,n=window.XMLHttpRequest.prototype.send;t._open=o,t._send=n,window.XMLHttpRequest.prototype.open=function(){var e=this,n=[].slice.call(arguments),r=n[0],i=n[1],a=t.getUniqueID(),l=null;e._requestID=a,e._method=r,e._url=i;var c=e.onreadystatechange||function(){},s=function(){var o=t.reqList[a]||{};if(o.readyState=e.readyState,o.status=0,e.readyState>1&&(o.status=e.status),o.responseType=e.responseType,0==e.readyState)o.startTime||(o.startTime=+new Date);else if(1==e.readyState)o.startTime||(o.startTime=+new Date);else if(2==e.readyState){o.header={};for(var n=e.getAllResponseHeaders()||"",r=n.split("\n"),i=0;i<r.length;i++){var s=r[i];if(s){var d=s.split(": "),u=d[0],f=d.slice(1).join(": ");o.header[u]=f}}}else 3==e.readyState||(4==e.readyState?(clearInterval(l),o.endTime=+new Date,o.costTime=o.endTime-(o.startTime||o.endTime),o.response=e.response):clearInterval(l));return e._noVConsole||t.updateRequest(a,o),c.apply(e,arguments)};e.onreadystatechange=s;var d=-1;return l=setInterval(function(){d!=e.readyState&&(d=e.readyState,s.call(e))},10),o.apply(e,n)},window.XMLHttpRequest.prototype.send=function(){var e=[].slice.call(arguments),o=e[0],i=t.reqList[this._requestID]||{};i.method=this._method.toUpperCase();var a=this._url.split("?");if(i.url=a.shift(),a.length>0){i.getData={},a=(a=a.join("?")).split("&");var l=!0,c=!1,s=void 0;try{for(var d,u=a[Symbol.iterator]();!(l=(d=u.next()).done);l=!0){var f=d.value;f=f.split("="),i.getData[f[0]]=decodeURIComponent(f[1])}}catch(e){c=!0,s=e}finally{try{l||null==u.return||u.return()}finally{if(c)throw s}}}if("POST"==i.method)if(r.isString(o)){var v=o.split("&");i.postData={};var p=!0,b=!1,h=void 0;try{for(var g,m=v[Symbol.iterator]();!(p=(g=m.next()).done);p=!0){var y=g.value;y=y.split("="),i.postData[y[0]]=y[1]}}catch(e){b=!0,h=e}finally{try{p||null==m.return||m.return()}finally{if(b)throw h}}}else r.isPlainObject(o)&&(i.postData=o);return this._noVConsole||t.updateRequest(this._requestID,i),n.apply(this,e)}}}},{key:"getUniqueID",value:function(){var e="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=16*Math.random()|0,o="x"==e?t:3&t|8;return o.toString(16)});return e}}])&&u(o.prototype,i),s&&u(o,s),t;var o,i,s}(i.default);o.default=b,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t){e.exports='<div class="vc-table">\n  <div class="vc-log"></div>\n</div>'},function(e,t){e.exports='<dl class="vc-table-row">\n  <dd class="vc-table-col vc-table-col-4">Name {{if (count > 0)}}({{count}}){{/if}}</dd>\n  <dd class="vc-table-col">Method</dd>\n  <dd class="vc-table-col">Status</dd>\n  <dd class="vc-table-col">Time</dd>\n</dl>'},function(e,t){e.exports='<div class="vc-group {{actived ? \'vc-actived\' : \'\'}}">\n  <dl class="vc-table-row vc-group-preview" data-reqid="{{id}}">\n    <dd class="vc-table-col vc-table-col-4">{{url}}</dd>\n    <dd class="vc-table-col">{{method}}</dd>\n    <dd class="vc-table-col">{{status}}</dd>\n    <dd class="vc-table-col">{{costTime}}</dd>\n  </dl>\n  <div class="vc-group-detail">\n    {{if (header !== null)}}\n    <div>\n      <dl class="vc-table-row vc-left-border">\n        <dt class="vc-table-col vc-table-col-title">Headers</dt>\n      </dl>\n      {{for (var key in header)}}\n      <div class="vc-table-row vc-left-border vc-small">\n        <div class="vc-table-col vc-table-col-2">{{key}}</div>\n        <div class="vc-table-col vc-table-col-4 vc-max-height-line">{{header[key]}}</div>\n      </div>\n      {{/for}}\n    </div>\n    {{/if}}\n    {{if (getData !== null)}}\n    <div>\n      <dl class="vc-table-row vc-left-border">\n        <dt class="vc-table-col vc-table-col-title">Query String Parameters</dt>\n      </dl>\n      {{for (var key in getData)}}\n      <div class="vc-table-row vc-left-border vc-small">\n        <div class="vc-table-col vc-table-col-2">{{key}}</div>\n        <div class="vc-table-col vc-table-col-4 vc-max-height-line">{{getData[key]}}</div>\n      </div>\n      {{/for}}\n    </div>\n    {{/if}}\n    {{if (postData !== null)}}\n    <div>\n      <dl class="vc-table-row vc-left-border">\n        <dt class="vc-table-col vc-table-col-title">Form Data</dt>\n      </dl>\n      {{for (var key in postData)}}\n      <div class="vc-table-row vc-left-border vc-small">\n        <div class="vc-table-col vc-table-col-2">{{key}}</div>\n        <div class="vc-table-col vc-table-col-4 vc-max-height-line">{{postData[key]}}</div>\n      </div>\n      {{/for}}\n    </div>\n    {{/if}}\n    <div>\n      <dl class="vc-table-row vc-left-border">\n        <dt class="vc-table-col vc-table-col-title">Response</dt>\n      </dl>\n      <div class="vc-table-row vc-left-border vc-small">\n        <pre class="vc-table-col vc-max-height vc-min-height">{{response || \'\'}}</pre>\n      </div>\n    </div>\n  </div>\n</div>'},function(e,t,o){var n,r,i;r=[t,o(32),o(2),o(34),o(35),o(0),o(1)],void 0===(i="function"==typeof(n=function(o,n,r,i,a,l,c){"use strict";function s(e){return e&&e.__esModule?e:{default:e}}function d(e){return(d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function u(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function f(e){return(f=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function v(e,t){return(v=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function p(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0,r=s(r),i=s(i),a=s(a),l=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)if(Object.prototype.hasOwnProperty.call(e,o)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,o):{};n.get||n.set?Object.defineProperty(t,o,n):t[o]=e[o]}return t.default=e,t}(l),c=s(c);var b=function(e){function t(){var e,o,n,r;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var a=arguments.length,l=new Array(a),s=0;s<a;s++)l[s]=arguments[s];n=this,r=(e=f(t)).call.apply(e,[this].concat(l)),o=!r||"object"!==d(r)&&"function"!=typeof r?p(n):r;var u=p(p(o));u.isInited=!1,u.node={},u.$tabbox=c.default.render(i.default,{}),u.nodes=[],u.activedElem={};var v=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver;return u.observer=new v(function(e){for(var t=0;t<e.length;t++){var o=e[t];u._isInVConsole(o.target)||u.onMutation(o)}}),o}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&v(e,t)}(t,e),o=t,(n=[{key:"onRenderTab",value:function(e){e(this.$tabbox)}},{key:"onAddTool",value:function(e){var t=this,o=[{name:"Expand",global:!1,onClick:function(e){if(t.activedElem)if(c.default.hasClass(t.activedElem,"vc-toggle"))for(var o=0;o<t.activedElem.childNodes.length;o++){var n=t.activedElem.childNodes[o];if(c.default.hasClass(n,"vcelm-l")&&!c.default.hasClass(n,"vcelm-noc")&&!c.default.hasClass(n,"vc-toggle")){c.default.one(".vcelm-node",n).click();break}}else c.default.one(".vcelm-node",t.activedElem).click()}},{name:"Collapse",global:!1,onClick:function(e){t.activedElem&&(c.default.hasClass(t.activedElem,"vc-toggle")?c.default.one(".vcelm-node",t.activedElem).click():t.activedElem.parentNode&&c.default.hasClass(t.activedElem.parentNode,"vcelm-l")&&c.default.one(".vcelm-node",t.activedElem.parentNode).click())}}];e(o)}},{key:"onShow",value:function(){if(!this.isInited){this.isInited=!0,this.node=this.getNode(document.documentElement);var e=this.renderView(this.node,c.default.one(".vc-log",this.$tabbox)),t=c.default.one(".vcelm-node",e);t&&t.click(),this.observer.observe(document.documentElement,{attributes:!0,childList:!0,characterData:!0,subtree:!0})}}},{key:"onRemove",value:function(){this.observer.disconnect()}},{key:"onMutation",value:function(e){switch(e.type){case"childList":e.removedNodes.length>0&&this.onChildRemove(e),e.addedNodes.length>0&&this.onChildAdd(e);break;case"attributes":this.onAttributesChange(e);break;case"characterData":this.onCharacterDataChange(e)}}},{key:"onChildRemove",value:function(e){var t=e.target,o=t.__vconsole_node;if(o){for(var n=0;n<e.removedNodes.length;n++){var r=e.removedNodes[n],i=r.__vconsole_node;i&&i.view&&i.view.parentNode.removeChild(i.view)}this.getNode(t)}}},{key:"onChildAdd",value:function(e){var t=e.target,o=t.__vconsole_node;if(o){this.getNode(t),o.view&&c.default.removeClass(o.view,"vcelm-noc");for(var n=0;n<e.addedNodes.length;n++){var r=e.addedNodes[n],i=r.__vconsole_node;if(i)if(null!==e.nextSibling){var a=e.nextSibling.__vconsole_node;a.view&&this.renderView(i,a.view,"insertBefore")}else o.view&&(o.view.lastChild?this.renderView(i,o.view.lastChild,"insertBefore"):this.renderView(i,o.view))}}}},{key:"onAttributesChange",value:function(e){var t=e.target.__vconsole_node;t&&(t=this.getNode(e.target)).view&&this.renderView(t,t.view,!0)}},{key:"onCharacterDataChange",value:function(e){var t=e.target.__vconsole_node;t&&(t=this.getNode(e.target)).view&&this.renderView(t,t.view,!0)}},{key:"renderView",value:function(e,t,o){var n=this,r=new a.default(e).get();switch(e.view=r,c.default.delegate(r,"click",".vcelm-node",function(t){t.stopPropagation();var o=this.parentNode;if(!c.default.hasClass(o,"vcelm-noc")){n.activedElem=o,c.default.hasClass(o,"vc-toggle")?c.default.removeClass(o,"vc-toggle"):c.default.addClass(o,"vc-toggle");for(var r=-1,i=0;i<o.children.length;i++){var a=o.children[i];c.default.hasClass(a,"vcelm-l")&&(r++,a.children.length>0||(e.childNodes[r]?n.renderView(e.childNodes[r],a,"replace"):a.style.display="none"))}}}),o){case"replace":t.parentNode.replaceChild(r,t);break;case"insertBefore":t.parentNode.insertBefore(r,t);break;default:t.appendChild(r)}return r}},{key:"getNode",value:function(e){if(!this._isIgnoredElement(e)){var t=e.__vconsole_node||{};if(t.nodeType=e.nodeType,t.nodeName=e.nodeName,t.tagName=e.tagName||"",t.textContent="",t.nodeType!=e.TEXT_NODE&&t.nodeType!=e.DOCUMENT_TYPE_NODE||(t.textContent=e.textContent),t.id=e.id||"",t.className=e.className||"",t.attributes=[],e.hasAttributes&&e.hasAttributes())for(var o=0;o<e.attributes.length;o++)t.attributes.push({name:e.attributes[o].name,value:e.attributes[o].value||""});if(t.childNodes=[],e.childNodes.length>0)for(var n=0;n<e.childNodes.length;n++){var r=this.getNode(e.childNodes[n]);r&&t.childNodes.push(r)}return e.__vconsole_node=t,t}}},{key:"_isIgnoredElement",value:function(e){return e.nodeType==e.TEXT_NODE&&""==e.textContent.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$|\n+/g,"")}},{key:"_isInVConsole",value:function(e){for(var t=e;null!=t;){if("__vconsole"==t.id)return!0;t=t.parentNode||void 0}return!1}}])&&u(o.prototype,n),r&&u(o,r),t;var o,n,r}(r.default);o.default=b,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t,o){var n=o(33);"string"==typeof n&&(n=[[e.i,n,""]]);var r={hmr:!0,transform:void 0,insertInto:void 0};o(4)(n,r);n.locals&&(e.exports=n.locals)},function(e,t,o){(e.exports=o(3)(!1)).push([e.i,'/* color */\n.vcelm-node {\n  color: #183691;\n}\n.vcelm-k {\n  color: #0086B3;\n}\n.vcelm-v {\n  color: #905;\n}\n/* layout */\n.vcelm-l {\n  padding-left: 8px;\n  position: relative;\n  word-wrap: break-word;\n  line-height: 1;\n}\n/*.vcelm-l.vcelm-noc {\n  padding-left: 0;\n}*/\n.vcelm-l.vc-toggle > .vcelm-node {\n  display: block;\n}\n.vcelm-l .vcelm-node:active {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n.vcelm-l.vcelm-noc .vcelm-node:active {\n  background-color: transparent;\n}\n.vcelm-t {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n/* level */\n.vcelm-l .vcelm-l {\n  display: none;\n}\n.vcelm-l.vc-toggle > .vcelm-l {\n  margin-left: 4px;\n  display: block;\n}\n/* arrow */\n.vcelm-l:before {\n  content: "";\n  display: block;\n  position: absolute;\n  top: 6px;\n  left: 3px;\n  width: 0;\n  height: 0;\n  border: transparent solid 3px;\n  border-left-color: #000;\n}\n.vcelm-l.vc-toggle:before {\n  display: block;\n  top: 6px;\n  left: 0;\n  border-top-color: #000;\n  border-left-color: transparent;\n}\n.vcelm-l.vcelm-noc:before {\n  display: none;\n}\n',""])},function(e,t){e.exports='<div>\n  <div class="vc-log"></div>\n</div>'},function(e,t,o){var n,r,i;r=[t,o(36),o(37),o(0),o(1)],void 0===(i="function"==typeof(n=function(o,n,r,i,a){"use strict";function l(e){return e&&e.__esModule?e:{default:e}}function c(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0,n=l(n),r=l(r),i=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)if(Object.prototype.hasOwnProperty.call(e,o)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,o):{};n.get||n.set?Object.defineProperty(t,o,n):t[o]=e[o]}return t.default=e,t}(i),a=l(a);var s=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.node=t,this.view=this._create(this.node)}return t=e,(o=[{key:"get",value:function(){return this.view}},{key:"_create",value:function(e,t){var o=document.createElement("DIV");switch(a.default.addClass(o,"vcelm-l"),e.nodeType){case o.ELEMENT_NODE:this._createElementNode(e,o);break;case o.TEXT_NODE:this._createTextNode(e,o);break;case o.COMMENT_NODE:case o.DOCUMENT_NODE:case o.DOCUMENT_TYPE_NODE:case o.DOCUMENT_FRAGMENT_NODE:}return o}},{key:"_createTextNode",value:function(e,t){a.default.addClass(t,"vcelm-t vcelm-noc"),e.textContent&&t.appendChild(function(e){return document.createTextNode(e)}(e.textContent.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")))}},{key:"_createElementNode",value:function(e,t){var o,i=(o=(o=e.tagName)?o.toLowerCase():"",["br","hr","img","input","link","meta"].indexOf(o)>-1),l=i;0==e.childNodes.length&&(l=!0);var c=a.default.render(n.default,{node:e}),s=a.default.render(r.default,{node:e});if(l)a.default.addClass(t,"vcelm-noc"),t.appendChild(c),i||t.appendChild(s);else{t.appendChild(c);for(var d=0;d<e.childNodes.length;d++){var u=document.createElement("DIV");a.default.addClass(u,"vcelm-l"),t.appendChild(u)}i||t.appendChild(s)}}}])&&c(t.prototype,o),i&&c(t,i),e;var t,o,i}();o.default=s,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t){e.exports='<span class="vcelm-node">&lt;{{node.tagName.toLowerCase()}}{{if (node.className || node.attributes.length)}}\n  <i class="vcelm-k">\n    {{for (var i = 0; i < node.attributes.length; i++)}}\n      {{if (node.attributes[i].value !== \'\')}}\n        {{node.attributes[i].name}}="<i class="vcelm-v">{{node.attributes[i].value}}</i>"{{else}}\n        {{node.attributes[i].name}}{{/if}}{{/for}}</i>{{/if}}&gt;</span>'},function(e,t){e.exports='<span class="vcelm-node">&lt;/{{node.tagName.toLowerCase()}}&gt;</span>'},function(e,t,o){var n,r,i;r=[t,o(2),o(39),o(40),o(0),o(1)],void 0===(i="function"==typeof(n=function(o,n,r,i,a,l){"use strict";function c(e){return e&&e.__esModule?e:{default:e}}function s(e){return(s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function d(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function u(e,t){return!t||"object"!==s(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function f(e){return(f=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function v(e,t){return(v=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0,n=c(n),r=c(r),i=c(i),a=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)if(Object.prototype.hasOwnProperty.call(e,o)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,o):{};n.get||n.set?Object.defineProperty(t,o,n):t[o]=e[o]}return t.default=e,t}(a),l=c(l);var p=function(e){function t(){var e,o;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var n=arguments.length,i=new Array(n),a=0;a<n;a++)i[a]=arguments[a];return(o=u(this,(e=f(t)).call.apply(e,[this].concat(i)))).$tabbox=l.default.render(r.default,{}),o.currentType="",o.typeNameMap={cookies:"Cookies",localstorage:"LocalStorage",sessionstorage:"SessionStorage"},o}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&v(e,t)}(t,e),o=t,(n=[{key:"onRenderTab",value:function(e){e(this.$tabbox)}},{key:"onAddTopBar",value:function(e){for(var t=this,o=["Cookies","LocalStorage","SessionStorage"],n=[],r=0;r<o.length;r++)n.push({name:o[r],data:{type:o[r].toLowerCase()},className:"",onClick:function(){if(l.default.hasClass(this,"vc-actived"))return!1;t.currentType=this.dataset.type,t.renderStorage()}});n[0].className="vc-actived",e(n)}},{key:"onAddTool",value:function(e){var t=this,o=[{name:"Refresh",global:!1,onClick:function(e){t.renderStorage()}},{name:"Clear",global:!1,onClick:function(e){t.clearLog()}}];e(o)}},{key:"onReady",value:function(){}},{key:"onShow",value:function(){""==this.currentType&&(this.currentType="cookies",this.renderStorage())}},{key:"clearLog",value:function(){if(this.currentType&&window.confirm){var e=window.confirm("Remove all "+this.typeNameMap[this.currentType]+"?");if(!e)return!1}switch(this.currentType){case"cookies":this.clearCookieList();break;case"localstorage":this.clearLocalStorageList();break;case"sessionstorage":this.clearSessionStorageList();break;default:return!1}this.renderStorage()}},{key:"renderStorage",value:function(){var e=[];switch(this.currentType){case"cookies":e=this.getCookieList();break;case"localstorage":e=this.getLocalStorageList();break;case"sessionstorage":e=this.getSessionStorageList();break;default:return!1}var t=l.default.one(".vc-log",this.$tabbox);if(0==e.length)t.innerHTML="";else{for(var o=0;o<e.length;o++)e[o].name=a.htmlEncode(e[o].name),e[o].value=a.htmlEncode(e[o].value);t.innerHTML=l.default.render(i.default,{list:e},!0)}}},{key:"getCookieList",value:function(){if(!document.cookie||!navigator.cookieEnabled)return[];for(var e=[],t=document.cookie.split(";"),o=0;o<t.length;o++){var n=t[o].split("="),r=n.shift().replace(/^ /,""),i=n.join("=");try{r=decodeURIComponent(r),i=decodeURIComponent(i)}catch(e){console.log(e,r,i)}e.push({name:r,value:i})}return e}},{key:"getLocalStorageList",value:function(){if(!window.localStorage)return[];try{for(var e=[],t=0;t<localStorage.length;t++){var o=localStorage.key(t),n=localStorage.getItem(o);e.push({name:o,value:n})}return e}catch(e){return[]}}},{key:"getSessionStorageList",value:function(){if(!window.sessionStorage)return[];try{for(var e=[],t=0;t<sessionStorage.length;t++){var o=sessionStorage.key(t),n=sessionStorage.getItem(o);e.push({name:o,value:n})}return e}catch(e){return[]}}},{key:"clearCookieList",value:function(){if(document.cookie&&navigator.cookieEnabled){for(var e=this.getCookieList(),t=0;t<e.length;t++)document.cookie=e[t].name+"=;expires=Thu, 01 Jan 1970 00:00:00 GMT";this.renderStorage()}}},{key:"clearLocalStorageList",value:function(){if(window.localStorage)try{localStorage.clear(),this.renderStorage()}catch(e){alert("localStorage.clear() fail.")}}},{key:"clearSessionStorageList",value:function(){if(window.sessionStorage)try{sessionStorage.clear(),this.renderStorage()}catch(e){alert("sessionStorage.clear() fail.")}}}])&&d(o.prototype,n),c&&d(o,c),t;var o,n,c}(n.default);o.default=p,e.exports=t.default})?n.apply(t,r):n)||(e.exports=i)},function(e,t){e.exports='<div class="vc-table">\n  <div class="vc-log"></div>\n</div>'},function(e,t){e.exports='<div>\n  <dl class="vc-table-row">\n    <dd class="vc-table-col">Name</dd>\n    <dd class="vc-table-col vc-table-col-2">Value</dd>\n  </dl>\n  {{for (var i = 0; i < list.length; i++)}}\n  <dl class="vc-table-row">\n    <dd class="vc-table-col">{{list[i].name}}</dd>\n    <dd class="vc-table-col vc-table-col-2">{{list[i].value}}</dd>\n  </dl>\n  {{/for}}\n</div>'}])});
/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('jsonTemplate', {
        parent: 'app',
        url: "/jsonTemplate",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/inm/jsonTemplate/html/jsonTemplate.html",
            controller: 'JsonTemplateController',
            controllerAs: 'vm'
          }
        }
      })
      .state('jsonTemplate.add', {
        parent: 'jsonTemplate',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/inm/jsonTemplate/html/addJsonTemplate.html',
            controller: 'AddJsonTemplateController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'xs',
            resolve: {
              entity: function () {
                return {

                };
              }
            }
          }).result.then(function () {
            $state.go('jsonTemplate', null, {reload: true});
          }, function () {
            $state.go('jsonTemplate');
          });
        }]
      })
      .state('jsonTemplate.edit', {
        parent: 'jsonTemplate',
        url: "/edit/:templateId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/inm/jsonTemplate/html/editJsonTemplate.html',
            controller: 'EditJsonTemplateController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  templateId:$stateParams.templateId
                };
              }
            }
          }).result.then(function () {
            $state.go('jsonTemplate', null, {reload: true});
          }, function () {
            $state.go('jsonTemplate');
          });
        }]
      })
      .state('jsonTemplate.remove', {
        parent: 'jsonTemplate',
        url: "/remove/:templateId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/inm/jsonTemplate/html/deleteJsonTemplate.html',
            controller: 'DeleteJsonTemplateController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'xs',
            resolve: {
              entity: function () {
                return {
                  templateId:$stateParams.templateId
                };
              }
            }
          }).result.then(function () {

            $state.go('jsonTemplate', null, {reload: true});
          }, function () {
            $state.go('jsonTemplate');
          });
        }]
      });


  }
})();

/**
 * Created by user on 2017/4/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('JsonTemplateService', JsonTemplateService);

  JsonTemplateService.$inject = ['$resource', '$http', '$state'];

  function JsonTemplateService($resource, $http) {
    var service = {
      findJsonTemplate: findJsonTemplate,
      updateJsonTemplate: updateJsonTemplate,
      addJsonTemplate: addJsonTemplate,
      deleteJsonTemplate:deleteJsonTemplate
    };
    return service;

    function findJsonTemplate(jsonTemplate,page,pagesize) {
      if(page==undefined){
        page = 1;
      }
      if(pagesize == undefined){
        pagesize = 10;
      }
      //console.log("service  code:" + angular.toJson(code));
      var resourceUrl = '/api/inm/JsonTemplate/query?page='+page+'&pageSize='+pagesize;

      var data = jsonTemplate;
      //console.log("data params:"+angular.toJson(data));
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response.data));
        return response.data;
      })
    }

    function updateJsonTemplate(jsonTemplate) {

      var resourceUrl = '/api/inm/JsonTemplate/update';
      var data = jsonTemplate;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });

    };

    function addJsonTemplate(jsonTemplate) {
      var resourceUrl = "/api/inm/JsonTemplate/insert";
      return $http.post(resourceUrl, jsonTemplate, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;

      });
    };

    function deleteJsonTemplate(jsonTemplate){
      var resourceUrl = "/api/inm/JsonTemplate/delete";
      return $http.post(resourceUrl,jsonTemplate ,{
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

  }

})();


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('JsonTemplateController', JsonTemplateController);

  JsonTemplateController.$inject = ['JsonTemplateService', '$state', 'paginationConstants','SweetAlert','$filter'];

  function JsonTemplateController(JsonTemplateService, $state, paginationConstants,SweetAlert,$filter) {
    var vm = this;

    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.delete = deleteJsonTemplate;

    vm.jsonTemplate = {};
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;


    loadAll(vm.jsonTemplate, page, pagesize);


    function loadAll(jsonTemplate, page, pagesize) {
      return JsonTemplateService.findJsonTemplate(jsonTemplate, page, pagesize)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
          //console.log("****");
        })
    }

    function search() {
      var page = vm.page = 1;
      var pagesize = paginationConstants.itemsPerPage;
      if (vm.jsonTemplate.jsonTemplate === null || vm.jsonTemplate.jsonTemplate === "") {
        vm.jsonTemplate.jsonTemplate = undefined;
      }
      if (vm.jsonTemplate.description === null || vm.jsonTemplate.description === "") {
        vm.jsonTemplate.description = undefined;
      }
      loadAll(vm.jsonTemplate, page, pagesize);
    };

    function reset() {
      vm.jsonTemplate.jsonTemplate = undefined;
      vm.jsonTemplate.description = undefined;
    };

    function deleteJsonTemplate(jsonTemplate) {
      SweetAlert.confirm($filter('T')('command.deleteWarning'),{title:$filter('T')('title.confirmTitle')}).then(function(p){
        if(p){
          return JsonTemplateService.deleteJsonTemplate(jsonTemplate)
            .then(function (data) {
              if (data.success) {
                return $state.go('jsonTemplate', null, {reload: true});
              }
            });
        }
      })

    }


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);

      loadAll(vm.jsonTemplate, vm.page, paginationConstants.itemsPerPage);
    };

  }


})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditJsonTemplateController', EditJsonTemplateController);

  EditJsonTemplateController.$inject = ['JsonTemplateService', '$scope', '$state', '$uibModalInstance', 'entity','toastr','$filter'];

  function EditJsonTemplateController(JsonTemplateService, $scope, $state, $uibModalInstance, entity,toastr,$filter) {
    var vm = this;
    vm.jsonTemplate = entity;
    vm.clear = clear;

    vm.update = update;


    var jsonTemplate = vm.jsonTemplate;
    getJsonTemplate(jsonTemplate);
    function getJsonTemplate(jsonTemplate) {
      return JsonTemplateService.findJsonTemplate(jsonTemplate)
        .then(function (data) {
          vm.jsonTemplate = data.rows[0];

        })
    }

    function update() {

      return JsonTemplateService.updateJsonTemplate(vm.jsonTemplate)
        .then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            /*toastr.success('保存成功！','信息提示');*/
            toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
            $uibModalInstance.close();
            return $state.go('jsonTemplate', null, {reload: true});
          }

        })

    }


    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


  }


})();

/**
 * Created by user on 2017/4/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('DeleteJsonTemplateController', DeleteJsonTemplateController);

  DeleteJsonTemplateController.$inject = ['$filter','JsonTemplateService', '$scope', '$state', '$uibModalInstance','entity','toastr'];

  function DeleteJsonTemplateController($filter,JsonTemplateService, $scope, $state, $uibModalInstance,entity,toastr) {
    var vm = this;
    vm.jsonTemplate = entity;
    vm.clear = clear;
    vm.remove = remove;

    var jsonTemplate = vm.jsonTemplate;
    getjonTemplate(jsonTemplate);
    function getjonTemplate(jsonTemplate) {
      return JsonTemplateService.findJsonTemplate(jsonTemplate)
        .then(function (data) {
          vm.jsonTemplate = data.rows[0];

        })
    }
    function remove() {
      return JsonTemplateService.deleteJsonTemplate(vm.jsonTemplate)
        .then(function (data) {
          if (data.success) {
            toastr.success($filter('T')('title.deleteSuccess'),$filter('T')('title.confirmTitle'));
            $uibModalInstance.close();
            return $state.go('jsonTemplate', null, {reload: true});
          }
        });
    }


    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


  }


})();

/**
 * Created by user on 2017/4/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddJsonTemplateController', AddJsonTemplateController);

  AddJsonTemplateController.$inject = ['JsonTemplateService', '$scope', '$state', '$uibModalInstance','toastr','$filter'];

  function AddJsonTemplateController(JsonTemplateService, $scope, $state, $uibModalInstance,toastr,$filter) {
    var vm = this;
    vm.jsonTemplate = {};
    vm.clear = clear;
    vm.isSystem = false;

    vm.add = add;


    function add() {
      return JsonTemplateService.addJsonTemplate(vm.jsonTemplate)
        .then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
       /*     toastr.success('保存成功！','信息提示');*/
            toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
            $uibModalInstance.close();
            return $state.go('jsonTemplate', null, {reload: true});
          }

        });

    };


    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


  }


})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
  .module('hmapFront')
  .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
    .state('user', {
      parent: 'app',
      url: "/user",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/user/html/user.html",
          controller: 'UserController',
          controllerAs: 'vm'
        }
      }
    })
    .state('user.new', {
      parent: 'app',
      url: "/user/new",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/user/html/user-new.html",
          controller: 'UserNewController',
          controllerAs: 'vm',
          resolve: {
            entity: function () {
              return {
                partyId: null,
                partyAccount: null,
                partyType: 'admin',
                emailAddress: null,
                phoneNumber: null,
                password: null,
                partyStatus: 'Y',
                roleId: null
              };
            }
          }
        }
      }
    }).state('user.edit', {
      parent: 'app',
      url: "/user/:partyId/edit",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/user/html/user-edit.html",
          controller: 'UserEditController',
          controllerAs: 'vm',
          resolve: {
            entity: function ($stateParams) {
              return {
                partyId: $stateParams.partyId
              };
            }
          }
        }
      }
    })
  }
})();

(function () {
  "use strict";
  angular.module("hmapFront").factory("User", User);

  User.$inject = ["$resource", "$http"];

  function User($resource, $http) {
    var service = {
      query: query,
      queryRoles: queryRoles,
      deleteUser: deleteUser,
      getByName: getByName,
      queryUsers: queryUsers,
      saveUser: saveUser,
      saveRemoteDiagnosisUser: saveRemoteDiagnosisUser,
      updateUser: updateUser,
      operateUser: operateUser,
      getUser: getUser,
    };
    return service;

    function query() {
      var resourceUrl = "/api/user/:id";
      return $resource(
        resourceUrl,
        {},
        {
          query: { method: "GET", isArray: false },
          get: {
            method: "GET",
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            },
          },
          update: { method: "PUT" },
        }
      );
    }

    function queryRoles() {
      var resourceUrl = "/api/role/queryAll";
      return $resource(
        resourceUrl,
        {},
        {
          query: "GET",
        }
      );
    }

    function getByName() {
      var resourceUrl = "/api/user/queryByName/:user";
      return $resource(
        resourceUrl,
        {},
        {
          query: "GET",
        }
      );
    }

    // 重写
    function queryUsers(data) {
      var resourceUrl =
        "/api/hmsUser/queryUsers?page=" +
        data.page +
        "&pageSize=" +
        data.pageSize;
      return $http
        .post(
          resourceUrl,
          { partyAccount: data.partyAccount },
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        )
        .then(function (response) {
          return response.data;
        });
    }

    function saveUser(data) {
      var resourceUrl = "/api/hmsUser/saveUser";
      return $http
        .post(resourceUrl, data, {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function saveRemoteDiagnosisUser(data) {
      var resourceUrl = "/api/party/remotediagnosis/save";
      return $http
        .post(resourceUrl, data, {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function updateUser(data) {
      var resourceUrl = "/api/hmsUser/updateUser";
      return $http
        .post(resourceUrl, data, {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function operateUser(data) {
      var resourceUrl = "/api/hmsUser/operateUser";
      return $http
        .post(resourceUrl, data, {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getUser(partyId) {
      var resourceUrl = "/api/hmsUser/getUser";
      return $http
        .post(
          resourceUrl,
          { partyId: partyId },
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        )
        .then(function (response) {
          return response.data;
        });
    }

    function deleteUser(user) {
      var resourceUrl = "/api/hmsUser/deleteUser";
      return $http
        .post(
          resourceUrl,
          { partyId: user.partyId, partyAccount: user.partyAccount },
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        )
        .then(function (response) {
          return response.data;
        });
    }
  }
})();

(function () {
  "use strict";

  angular.module("hmapFront").controller("UserController", UserController);
  UserController.$inject = [
    "$filter",
    "$state",
    "User",
    "paginationConstants",
    "PartyService",
    "toastr",
    "toastrConfig",
    "SweetAlert",
    "$sessionStorage",
    "MessageTemplateService",
  ];

  /** @ngInject */
  function UserController(
    $filter,
    $state,
    User,
    paginationConstants,
    PartyService,
    toastr,
    toastrConfig,
    SweetAlert,
    $sessionStorage,
    MessageTemplateService
  ) {
    var vm = this;

    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.queryUsersByCondition = queryUsersByCondition;
    vm.deleteUser = deleteUser;
    vm.initWeidget = initWeidget;

    vm.loginName = $sessionStorage.user
      ? $sessionStorage.user.partyAccount
      : null;
    // query condition
    vm.searchUserName = null;

    vm.users = {};
    vm.roles = [];
    vm.states = [];

    vm.initWeidget();
    vm.queryUsersByCondition();

    function loadAll(condition) {
      User.queryUsers({
        partyAccount: condition == undefined ? null : condition,
        page: vm.page,
        pageSize: paginationConstants.itemsPerPage,
      }).then(
        function (response) {
          vm.users = response.rows;
          vm.totalItems = response.total;
        },
        function () {
          toastr.error($filter("T")("title.loadError"));
        }
      );
    }

    function deleteUser(user) {
      SweetAlert.confirm($filter("T")("plugin.deleteConfirm"), {
        title: $filter("T")("plugin.deletePrompt"),
      }).then(function (p) {
        if (p) {
          User.deleteUser(user).then(
            function (response) {
              if (response.success) {
                var code = response.code;
                if (!code || code === "succ") {
                  toastr.success($filter("T")("title.deleteSuccess"));
                } else if (code === "canNotDelete") {
                  toastr.warning($filter("T")("login.canNotDelete"));
                } else {
                  if (response.message === "permission_denied") {
                    toastr.error($filter("T")("prompt.permissionDenied"));
                  } else if (response.message === "password_error") {
                    toastr.error($filter("T")("login.invalidPwd"));
                  } else {
                    toastr.error($filter("T")("title.deleteFail"));
                  }
                }
                loadAll();
              } else {
                toastr.warning(
                  $filter("T")("title.deleteFail"),
                  $filter("T")("plugin.deleteMessage")
                );
              }
            },
            function (res) {
              tostarErrorMessage(res.data);
            }
          );
        }
      });
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page,
      });
    }

    function pageChanged() {
      queryUsersByCondition();
    }

    function queryUsersByCondition() {
      loadAll(
        vm.searchUserName == null || vm.searchUserName == ""
          ? null
          : vm.searchUserName
      );
    }

    function initWeidget() {
      // state
      MessageTemplateService.getByCode().query(
        { code: "SYS.PROCESSING_STATUS" },
        function (data) {
          vm.partyStatus = data.rows;
        },
        function (error) {}
      );

      // roles
      // remotediagnosis should be { condition1: "kohler,remotediagnosis" } modifyed on 2026-06-17 by Jayson Jia
      PartyService.queryRoles({ condition1: "kohler" }).then(
        function (response) {
          vm.roles = response.rows;
        }
      );
    }

    function tostarErrorMessage(response) {
      if (response.message === "permission_denied") {
        toastr.error($filter("T")("prompt.permissionDenied"));
      } else if (response.message === "password_error") {
        toastr.error($filter("T")("login.invalidPwd"));
      } else if (response.message === "canNotDelete") {
        toastr.warning($filter("T")("login.canNotDelete"));
      } else {
        toastr.error($filter("T")("title.deleteFail"));
      }
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: "toast-container",
      maxOpened: 3,
      newestOnTop: true,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: "body",
    });
  }
})();

/**
 * Created by chenlei on 2016/8/5.
 */
(function () {
  "use strict";

  angular
    .module("hmapFront")
    .controller("UserNewController", UserNewController);

  UserNewController.$inject = [
    "toastrConfig",
    "$filter",
    "$state",
    "User",
    "entity",
    "toastr",
    "PartyService",
    "MessageTemplateService",
    "SweetAlert",
  ];

  function UserNewController(
    toastrConfig,
    $filter,
    $state,
    User,
    entity,
    toastr,
    PartyService,
    MessageTemplateService,
    SweetAlert
  ) {
    var vm = this;
    vm.user = entity;

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: "toast-container",
      maxOpened: 3,
      newestOnTop: true,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: "body",
    });

    vm.initWeidget = initWeidget;
    vm.clear = clear;
    vm.saveUser = saveUser;
    vm.suffix = "";
    vm.required = true;
    vm.showOrHidePwd = showOrHidePwd;
    vm.showPwdEnabled = true;

    vm.validatePwd = validatePwd;

    vm.initWeidget();

    function validatePwd() {
      var passwordEncrypted = $("#passwordInit").val();
      var passwordConfirm = $("#passwordConfirm").val();
      if (passwordEncrypted != "" && passwordConfirm != "") {
        if (passwordEncrypted.indexOf(vm.user.userName) != -1) {
          toastr.warning($filter("T")("userManage.passwordNotContainName"));
          vm.user.userName = undefined;
          return;
        }
        if (passwordEncrypted != passwordConfirm) {
          SweetAlert.error($filter("T")("title.pwdNotSame"), {
            title: $filter("T")("btnTypeName.prompt"),
          });
          $("#passwordConfirm").val("");
          vm.user.passwordConfirm = "";
        }
      }
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query(
        { code: "SYS.PROCESSING_STATUS" },
        function (data) {
          vm.states = data.rows;
        },
        function (error) {}
      );

      MessageTemplateService.getByCode().query(
        { code: "SYS.TIME_ZONE" },
        function (data) {
          vm.timeZone = data.rows;
        },
        function (error) {}
      );

      // roles
      // remotediagnosis should be { condition1: "kohler,remotediagnosis" } modifyed on 2026-06-17 by Jayson Jia
      PartyService.queryRoles({ condition1: "kohler" }).then(
        function (response) {
          vm.roles = response.rows;
        }
      );

      PartyService.querySysConfig().query(
        { configKey: "aad.admin.username.suffix" },
        onSuccess,
        onError
      );
    }

    function onSuccess(data) {
      vm.suffix = "@" + data.rows[0].configValue;
    }

    function onError() {}

    function saveUser() {
      console.log("save user:", vm.roles);
      if (
        (vm.user.phoneNumber || "").trim() &&
        !/^[0-9]+$/.test(vm.user.phoneNumber)
      ) {
        toastr.warning($filter("T")("userManage.validPhone"));
        vm.user.partyAccount = undefined;
        return;
      }
      var mailNickName = vm.user.mailNickname;
      if (mailNickName.indexOf("@") >= 0) {
        toastr.warning($filter("T")("userManage.mailNicknameValid"));
        vm.user.partyAccount = undefined;
        return;
      }

      if (
        (vm.user.password || "").trim() &&
        vm.user.password === vm.user.passwordConfirm
      ) {
        if (vm.user.password.indexOf(vm.user.partyAccount) !== -1) {
          toastr.warning($filter("T")("userManage.passwordNotContainName"));
          vm.user.partyAccount = undefined;
          return;
        }
        vm.user.password = $.trim(vm.user.password);
        vm.user.partyAccount = vm.user.partyAccount + vm.suffix;

        // Added logic to determine user type based on role on 2024-06-12 by Jayson Jia
        const matchedRole = (vm.roles || []).find(function (role) {
          return String(role.roleId) === String(vm.user.roleId);
        });
        const attribute1 = matchedRole ? matchedRole.attribute1 : null;

        if (attribute1 === "remotediagnosis") {
          vm.user.partyType = "remotediagnosis";
          User.saveRemoteDiagnosisUser(vm.user).then(
            function (response) {
              saveUserResponse(response, "user");
            },
            function () {
              toastr.error($filter("T")("title.saveFail"));
              vm.user.partyAccount = undefined;
            }
          );
        } else {
          vm.user.partyType = "admin";
          User.saveUser(vm.user).then(
            function (response) {
              saveUserResponse(response, "user");
            },
            function () {
              toastr.error($filter("T")("title.saveFail"));
              vm.user.partyAccount = undefined;
            }
          );
        }
      } else {
        vm.user.partyAccount = undefined;
        toastr.error(
          $filter("T")("title.pwdNotSame"),
          $filter("T")("btnTypeName.prompt")
        );
      }
    }

    function clear() {
      $state.go("user");
    }

    function saveUserResponse(response, toState) {
      var code = response.code;
      if (!code || code === "succ") {
        toastr.success($filter("T")("title.saveSuccess"));
        $state.go(toState);
      } else if (code === "userNameFormateError") {
        toastr.warning($filter("T")("userManage.validLoginName"));
      } else if (code === "regexFail") {
        toastr.warning($filter("T")("userManage.passwordRegEx"));
      } else if (code === "repeat") {
        toastr.warning($filter("T")("userManage.sameUsername"));
      } else {
        if (response.message === "permission_denied") {
          toastr.error($filter("T")("prompt.permissionDenied"));
        } else if (response.message === "password_error") {
          toastr.error($filter("T")("userManage.invalidAdminPwd"));
        } else {
          toastr.error($filter("T")("title.saveFail"));
        }
      }
      vm.user.partyAccount = undefined;
    }

    function showOrHidePwd() {
      var pwdInput = angular.element("#passwordInit");
      var pwdInputConfirm = angular.element("#passwordConfirm");
      if (vm.showPwdEnabled) {
        pwdInput.prop("type", "text");
        pwdInputConfirm.prop("type", "text");
        vm.showPwdEnabled = false;
      } else {
        pwdInput.prop("type", "password");
        pwdInputConfirm.prop("type", "password");
        vm.showPwdEnabled = true;
      }
    }
  }
})();

/**
 * Created by chenlei on 2016/8/5.
 */
(function () {
  "use strict";

  angular
    .module("hmapFront")
    .controller("UserEditController", UserEditController);

  UserEditController.$inject = [
    "$filter",
    "$timeout",
    "MessageTemplateService",
    "$state",
    "$stateParams",
    "User",
    "entity",
    "uibDateParser",
    "toastr",
    "toastrConfig",
    "SweetAlert",
    "PartyService",
    "$sessionStorage",
  ];

  function UserEditController(
    $filter,
    $timeout,
    MessageTemplateService,
    $state,
    $stateParams,
    User,
    entity,
    uibDateParser,
    toastr,
    toastrConfig,
    SweetAlert,
    PartyService,
    $sessionStorage
  ) {
    var vm = this;
    vm.initWeidget = initWeidget;
    vm.clear = clear;
    vm.saveUser = saveUser;
    vm.operate = operate;
    vm.initData = initData;
    vm.changeUserStatus = changeUserStatus;
    vm.required = true;
    vm.validatePwd = validatePwd;
    vm.showOrHidePwd = showOrHidePwd;
    vm.showPwdEnabled = true;

    vm.loginName = $sessionStorage.user
      ? $sessionStorage.user.partyAccount
      : null;
    vm.user = entity;
    vm.partyStatus = [];
    vm.roles = [];

    vm.operationList = [
      {
        value: "assign_user_admin",
        meaning: $filter("T")("userManage.assignUserAdmin"),
      },
      {
        value: "unassign_user_admin",
        meaning: $filter("T")("userManage.unassignUserAdmin"),
      },
      {
        value: "assign_pwd_admin",
        meaning: $filter("T")("userManage.assignPwdAdmin"),
      },
      {
        value: "unassign_pwd_admin",
        meaning: $filter("T")("userManage.unassignPwdAdmin"),
      },
    ];

    vm.initWeidget();
    vm.initData();

    function validatePwd() {
      var passwordEncrypted = $("#passwordInit").val();
      var passwordConfirm = $("#passwordConfirm").val();
      if (passwordEncrypted != "" && passwordConfirm != "") {
        if (passwordEncrypted.indexOf(vm.user.userName) != -1) {
          toastr.warning($filter("T")("userManage.passwordNotContainName"));
          vm.user.userName = undefined;
          return;
        }
        if (passwordEncrypted != passwordConfirm) {
          SweetAlert.error($filter("T")("title.pwdNotSame"), {
            title: $filter("T")("btnTypeName.prompt"),
          });
          $("#passwordConfirm").val("");
        }
      }
    }

    function initWeidget() {
      // state
      MessageTemplateService.getByCode().query(
        { code: "SYS.PROCESSING_STATUS" },
        function (data) {
          vm.partyStatus = data.rows;
        },
        function (error) {}
      );

      MessageTemplateService.getByCode().query(
        { code: "SYS.TIME_ZONE" },
        function (data) {
          vm.timeZone = data.rows;
        },
        function (error) {}
      );

      // roles
      // remotediagnosis should be { condition1: "kohler,remotediagnosis" } modifyed on 2026-06-17 by Jayson Jia
      PartyService.queryRoles({ condition1: "kohler" }).then(
        function (response) {
          vm.roles = response.rows;
        }
      );
    }

    function initData() {
      User.getUser(vm.user.partyId).then(function (response) {
        if (response.rows.length > 0) {
          vm.user = response.rows[0];
          // clear password info
          vm.user.password = null;
          vm.user.passwordConfirm = null;
        }
      });
    }

    function saveUser() {
      if (
        vm.user.phoneNumber != null &&
        $.trim(vm.user.phoneNumber) != "" &&
        !/^1[3|4|5|8][0-9]\d{4,8}$/.test(vm.user.phoneNumber)
      ) {
        toastr.warning($filter("T")("userManage.validPhone"));
        return;
      }

      var mailNickName = vm.user.mailNickname;
      if (mailNickName.indexOf("@") >= 0) {
        toastr.warning($filter("T")("userManage.mailNicknameValid"));
        return;
      }

      if (
        (vm.user.password == null || $.trim(vm.user.password) == "") &&
        (vm.user.passwordConfirm == null ||
          $.trim(vm.user.passwordConfirm) == "")
      ) {
        vm.user.password = $.trim(vm.user.password);
        SweetAlert.confirm($filter("T")("title.pwdModifyTip"), {
          title: $filter("T")("title.confirmTitle"),
        }).then(function (p) {
          if (p) {
            User.updateUser(vm.user).then(
              function (response) {
                saveUserResponse(response, "user");
              },
              function () {
                toastr.error($filter("T")("title.saveFail"));
              }
            );
          }
        });
      } else {
        if (vm.user.password === vm.user.passwordConfirm) {
          if (vm.user.password.indexOf(vm.user.partyAccount) !== -1) {
            toastr.warning($filter("T")("userManage.passwordNotContainName"));
            return;
          }
          vm.user.password = $.trim(vm.user.password);
          User.updateUser(vm.user).then(
            function (response) {
              saveUserResponse(response, "user");
            },
            function () {
              toastr.error($filter("T")("title.saveFail"));
            }
          );
        } else {
          toastr.error($filter("T")("title.pwdNotSame"));
        }
      }
    }

    function clear() {
      $state.go("user");
    }

    function saveUserResponse(response, toState) {
      var code = response.code;
      if (!code || code === "succ") {
        toastr.success($filter("T")("title.saveSuccess"));
        $state.go(toState);
      } else if (code === "userNameFormateError") {
        toastr.warning($filter("T")("userManage.validLoginName"));
      } else if (code === "regexFail") {
        toastr.warning($filter("T")("userManage.passwordRegEx"));
      } else if (code === "repeat") {
        toastr.warning($filter("T")("userManage.sameUsername"));
      } else {
        if (response.message === "permission_denied") {
          toastr.error($filter("T")("prompt.permissionDenied"));
        } else if (response.message === "password_error") {
          toastr.error($filter("T")("userManage.invalidAdminPwd"));
        } else {
          toastr.error($filter("T")("title.saveFail"));
        }
      }
    }

    function changeUserStatus() {
      if (vm.loginName == vm.user.partyAccount && "N" == vm.user.partyStatus) {
        vm.user.partyStatus = "Y";
        SweetAlert.info($filter("T")("title.statusChangeTip"));
      }
    }

    function showOrHidePwd() {
      var pwdInput = angular.element("#passwordInit");
      var pwdInputConfirm = angular.element("#passwordConfirm");
      if (vm.showPwdEnabled) {
        pwdInput.prop("type", "text");
        pwdInputConfirm.prop("type", "text");
        vm.showPwdEnabled = false;
      } else {
        pwdInput.prop("type", "password");
        pwdInputConfirm.prop("type", "password");
        vm.showPwdEnabled = true;
      }
    }

    function operate() {
      var requestBody = {
        partyId: vm.user.partyId,
        operation: vm.user.operation,
      };
      User.operateUser(requestBody).then(
        function (response) {
          var code = response.code;
          if (!code || code === "succ") {
            toastr.success($filter("T")("title.operationSuccess"));
          } else {
            if (response.message === "permission_denied") {
              toastr.error($filter("T")("prompt.permissionDenied"));
            } else if (response.message === "password_error") {
              toastr.error($filter("T")("userManage.invalidAdminPwd"));
            } else if (response.message === "directory_role_assigned") {
              toastr.success($filter("T")("userManage.roleAssigned"));
            } else if (response.message === "directory_role_unassigned") {
              toastr.success($filter("T")("userManage.roleUnassigned"));
            } else {
              toastr.error($filter("T")("title.operationFailed"));
            }
          }
        },
        function () {
          toastr.error($filter("T")("title.operationFailed"));
        }
      );
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: "toast-container",
      maxOpened: 3,
      newestOnTop: true,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: "body",
    });
  }
})();

/**
 * Created by zyl on 2017/7/3.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('viewRepairCenterController', viewRepairCenterController);

  viewRepairCenterController.$inject = ['repairCenterService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService'];

  function viewRepairCenterController(repairCenterService, $state, $uibModalInstance, toastr, entity, PromptService) {
    var vm = this;
    vm.repairCenter = entity;
    vm.CodeEditable = false;
    vm.isEdit = false;
    vm.page = 1;
    vm.clear = clear;
    vm.getRepairCenter = getRepairCenter;

    vm.getRepairCenter()

    setEdit();

    function setEdit() {
      if (vm.repairCenter.serviceCenterId != null) {
        vm.CodeEditable = true;
      }
      if(vm.repairCenter.isEdit === "true"){
        vm.isEdit = true;
      }
    }

    //get repairCenter
    function getRepairCenter() {
      return repairCenterService.getRepairCenters(vm.repairCenter, vm.page).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.repairCenter = data.rows[0];
      })
    }


    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('servicePhone', {
        parent: 'app',
        url: "/servicePhone",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/sys/html/RegionAndRepairPhone.html",
            controller: 'servicePhoneController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
            };
          }
        }
      })
      .state('servicePhone.add', {
        parent: 'servicePhone',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/sys/html/addCountryAndRegion.html',
            controller: 'AddRegionController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                }
              }
            }
          }).result.then(function () {
            $state.go('servicePhone', null, {reload: 'servicePhone'});
          }, function () {
            $state.go('servicePhone');
          });
        }]
      })
      .state('servicePhone.edit', {
        parent: 'servicePhone',
        url: "/edit/:countryServiceCenterId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/sys/html/addCountryAndRegion.html',
            controller: 'AddRegionController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  countryServiceCenterId: $stateParams.countryServiceCenterId
                }
              }
            }
          }).result.then(function () {
            $state.go('servicePhone', null, {reload: 'servicePhone'});
          }, function () {
            $state.go('servicePhone');
          });
        }]
      })
      .state('repairCenter', {
        parent: 'app',
        url: "/repairCenter",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/sys/html/repairCompanies.html",
            controller: 'repairCenterController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
            };
          }
        }
      })
      .state('repairCenter.add', {
        parent: 'repairCenter',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/sys/html/addCompanies.html',
            controller: 'AddRepairCenterController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  isEdit: "true"
                }
              }
            }
          }).result.then(function () {
            $state.go('repairCenter', null, {reload: 'repairCenter'});
          }, function () {
            $state.go('repairCenter');
          });
        }]
      })
      .state('repairCenter.edit', {
        parent: 'repairCenter',
        url: "/edit/:serviceCenterId&:isEdit",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/sys/html/addCompanies.html',
            controller: 'AddRepairCenterController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  serviceCenterId: $stateParams.serviceCenterId,
                  isEdit: $stateParams.isEdit
                }
              }
            }
          }).result.then(function () {
            $state.go('repairCenter', null, {reload: 'repairCenter'});
          }, function () {
            $state.go('repairCenter');
          });
        }]
      })
      //从维修中心界面进入查看界面
      .state('repairCenter.view', {
        parent: 'repairCenter',
        url: "/view/:serviceCenterId&:isEdit",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/sys/html/addCompanies.html',
            controller: 'viewRepairCenterController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  serviceCenterId: $stateParams.serviceCenterId,
                  isEdit: $stateParams.isEdit
                }
              }
            }
          }).result.then(function () {
            $state.go('repairCenter', null, {reload: 'repairCenter'});
          }, function () {
            $state.go('repairCenter');
          });
        }]
      })

      //从区域维护界面进入查看界面
      .state('servicePhone.view', {
        parent: 'servicePhone',
        url: "/countryRepairCenter/:serviceCenterId&:isEdit",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/sys/html/addCompanies.html',
            controller: 'viewRepairCenterController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  serviceCenterId: $stateParams.serviceCenterId,
                  isEdit: $stateParams.isEdit
                }
              }
            }
          }).result.then(function () {
            $state.go('servicePhone', null, {reload: 'servicePhone'});
          }, function () {
            $state.go('servicePhone');
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('userServicePhoneService', userServicePhoneService);

  userServicePhoneService.$inject = ['$http'];

  function userServicePhoneService($http) {
    return {
      getRegion: getRegion,
      addRegion: addRegion,
      deleteRegion: deleteRegion,
      getRepairCenterLocaleInfo:getRepairCenterLocaleInfo,
      updateRegion:updateRegion
      //getRegionEdit:getRegionEdit
    };

    //get Legions
    function getRegion(entity, page) {
      var resourceUrl = '/api/sys/selectCountryServiceCenterFromKey?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    ////get Legions
    //function getRegionEdit(entity, page) {
    //  var resourceUrl = '/api/sys/selectAllServicePhone?page=' + page;
    //  return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
    //    return response.data;
    //  })
    //}

    //get repairCenter locale info
    function getRepairCenterLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
    //delete Legions
    function deleteRegion(entity) {
      var resourceUrl = '/api/sys/deleteCountryServiceCenter';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }


    //add product
    function addRegion(entity) {
      var resourceUrl = '/api/sys/insertCountryServiceCenter';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //update product
    function updateRegion(entity) {
      var resourceUrl = '/api/sys/updateCountryServiceCenter';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
  }
})();

/**
 * Created by youliang.zhu on 2017/07/02.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('servicePhoneController', servicePhoneController);

  servicePhoneController.$inject = ['userServicePhoneService','MessageTemplateService', 'repairCenterService','paginationConstants', 'entity', 'SweetAlert', '$filter'];

  function servicePhoneController(userServicePhoneService,MessageTemplateService,repairCenterService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.region = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkRegion = checkRegion;
    vm.checkAllRegion = checkAllRegion;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.deleteRegion = deleteRegion;
    vm.deleteRegions = deleteRegions;
    vm.getRegions = getRegions;
    vm.getRepairCenter = getRepairCenter;
    vm.initWidget = initWidget;

    vm.countryRegion = [];

    vm.search();
    vm.initWidget();
    vm.getRepairCenter();
    //get product
    function getRegions() {
      return userServicePhoneService.getRegion(vm.region, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.regions = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    function getRepairCenter() {
      repairCenterService.getAllRepairCenter()
        .then(function (data) {
          if (!data) {
            return;
          }
          vm.repairCenters = data.rows;
        })
    }

    //search product
    function search() {
      if (vm.region.countryCode === null || vm.region.countryCode === "") {
        vm.region.countryCode = undefined;
      }
      if (vm.region.companyName === null || vm.region.companyName === "") {
        vm.region.companyName = undefined;
      }
      vm.getRegions();
    }

    ////reset product
    //function resetProduct() {
    //  vm.legion.productName = undefined;
    //  vm.product.productCode = undefined;
    //  vm.product.referenceSource = undefined;
    //}

    //delete product
    function deleteRegion(region) {
      var regions = new Array()
      regions.push(region);
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var entity = new Object();
          entity.countryServiceCenterId = region.countryServiceCenterId;
          regions.push(entity);
          userServicePhoneService.deleteRegion(regions).then(function (response) {
            if (response.success) {
              vm.getRegions();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete product
    function deleteRegions() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var regions = new Array();
          $(arrChk).each(function() {
            var region = new Object();
            region.countryServiceCenterId = this.value;
            regions.push(region);
          });
          userServicePhoneService.deleteRegion(regions).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getRegions();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getRegions();
    }

    //check or unCheck check product
    function checkRegion() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check product
    function checkAllRegion() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }


    function initWidget() {
      MessageTemplateService.getByCode().query({code: 'IOT.DVM_COUNTRY'}, function (data) {
        vm.countryRegion = data.rows;
      }, function (error) {
      });
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('sysunit', {
        parent: 'app',
        url: "/unit",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/sys/html/unit.html",
            controller: 'UnitController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
            };
          }
        }
      })
      .state('sysunit.add', {
        parent: 'sysunit',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/sys/html/addUnit.html',
            controller: 'AddUnitController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                }
              }
            }
          }).result.then(function () {
            $state.go('sysunit', null, {reload: 'sysunit'});
          }, function () {
            $state.go('sysunit');
          });
        }]
      })
      .state('sysunit.edit', {
        parent: 'sysunit',
        url: "/edit/:unitId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/sys/html/addUnit.html',
            controller: 'AddUnitController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  unitId: $stateParams.unitId
                }
              }
            }
          }).result.then(function () {
            $state.go('sysunit', null, {reload: 'sysunit'});
          }, function () {
            $state.go('sysunit');
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('UnitService', UnitService);

  UnitService.$inject = ['$http'];

  function UnitService($http) {
    return {
      getUnit: getUnit,
      getUnitById:getUnitById,
      deleteUnits: deleteUnits,
      addUnit: addUnit,
      updateUnit:updateUnit,
      getUnitLocaleInfo: getUnitLocaleInfo
    };

    function getUnitById(entity) {
      var resourceUrl = '/api/unit/queryParticular';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get unit
    function getUnit(entity, page) {
      var resourceUrl = '/api/unit/query?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete units
    function deleteUnits(entity) {
      var resourceUrl = '/api/unit/delete';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //add unit
    function addUnit(entity) {
      var resourceUrl = '/api/unit/insert';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //update unit
    function updateUnit(entity) {
      var resourceUrl = '/api/unit/update';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get unit locale info
    function getUnitLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('UnitController', UnitController);

  UnitController.$inject = ['UnitService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

  function UnitController(UnitService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
    var vm = this;
    vm.unit = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkUnit = checkUnit;
    vm.checkAllUnit = checkAllUnit;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetUnit = resetUnit;
    vm.deleteUnit = deleteUnit;
    vm.deleteUnits = deleteUnits;
    vm.getUnit = getUnit;
    vm.initWeidget = initWeidget;

    vm.initWeidget();
    vm.getUnit();

    //get unit
    function getUnit() {
      return UnitService.getUnit(vm.unit, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.units = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search unit
    function search() {
      vm.getUnit();
    }

    //reset unit
    function resetUnit() {
      vm.unit.unitName = undefined;
      vm.unit.unitType = undefined;
    }

    //delete unit
    function deleteUnit(unit) {
      SweetAlert.confirm(unit.unitName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var units = new Array();
          var entity = new Object();
          entity.unitId = unit.unitId;
          units.push(entity);
          UnitService.deleteUnits(units).then(function (response) {
            if (response.success) {
              vm.getUnit();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete unit
    function deleteUnits() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var units = new Array();
          $(arrChk).each(function() {
            var unit = new Object();
            unit.unitId = this.value;
            units.push(unit);
          });
          UnitService.deleteUnits(units).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getUnit();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getUnit();
    }

    //check or unCheck check unit
    function checkUnit() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check unit
    function checkAllUnit() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'IOT.SYS_UNIT_TYPE'},function (data) {
        vm.unitTypes = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'SYS.YES_NO'},function (data) {
        vm.primaryFlagTypes = data.rows;
      },function (error) {
      });
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('repairCenterService', repairCenterService);

  repairCenterService.$inject = ['$http'];

  function repairCenterService($http) {
    return {
      getRepairCenters: getRepairCenters,
      addRepairCenter: addRepairCenter,
      deleteRepairCenter: deleteRepairCenter,
      updateRepairCenter:updateRepairCenter,
      getRepairCenterEdit:getRepairCenterEdit,
      getRepairCenterLocaleInfo:getRepairCenterLocaleInfo,
      getAllRepairCenter:getAllRepairCenter,
      getCodeValueLocaleInfo:getCodeValueLocaleInfo
    };

    //get Legions
    function getRepairCenters(entity, page) {
      var resourceUrl = '/api/sys/selectServiceCenter?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get repairCenter locale info
    function getRepairCenterLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
    //get Legions
    function getRepairCenterEdit(entity, page) {
      var resourceUrl = '/api/sys/selectAllServicePhone?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete Legions
    function deleteRepairCenter(entity) {
      var resourceUrl = '/api/sys/deleteServiceCenter';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }


    //add product
    function addRepairCenter(entity) {
      var resourceUrl = '/api/sys/insertServiceCenter';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function getAllRepairCenter(){
      var resourceUrl = '/api/sys/selectServiceCenter';
      return $http.post(resourceUrl, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //update product
    function updateRepairCenter(entity) {
      var resourceUrl = '/api/sys/updateServiceCenter';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get product locale info
    function getCodeValueLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
  }
})();

/**
 * Created by youliang.zhu on 2017/07/02.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('repairCenterController', repairCenterController);

  repairCenterController.$inject = ['repairCenterService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];

  function repairCenterController(repairCenterService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.repairCenter = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkRepairCenter = checkRepairCenter;
    vm.checkAllRepairCenters = checkAllRepairCenters;
    vm.pageChanged = pageChanged;
    vm.search = search;
    //vm.resetProduct = resetProduct;
    vm.deleteRepairCenter = deleteRepairCenter;
    vm.deleteRepairCenters = deleteRepairCenters;
    vm.getRepairCenter = getRepairCenter;

    vm.getRepairCenter();

    //get product
    function getRepairCenter() {
      return repairCenterService.getRepairCenters(vm.repairCenter, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.repairCenters = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search product
    function search() {
      vm.getRepairCenter();
    }

    ////reset product
    //function resetProduct() {
    //  vm.legion.productName = undefined;
    //  vm.product.productCode = undefined;
    //  vm.product.referenceSource = undefined;
    //}

    //delete product
    function deleteRepairCenter(repairCenter) {
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var entity = new Object();
          var arr = new Array()
          entity.serviceCenterId = repairCenter.serviceCenterId;
          arr.push(entity);
          repairCenterService.deleteRepairCenter(arr).then(function (response) {
            if (response.success) {
              vm.getRepairCenter();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete product
    function deleteRepairCenters() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var repairCenters = new Array();
          $(arrChk).each(function() {
            var repairCenter = new Object();
            repairCenter.serviceCenterId = this.value;
            repairCenters.push(repairCenter);
          });
          repairCenterService.deleteRepairCenter(repairCenters).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getRepairCenter();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element('#chk_all').checked = false;
      vm.getRepairCenter();
    }

    //check or unCheck check product
    function checkRepairCenter() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check product
    function checkAllRepairCenters() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('grayRelease', {
        parent: 'app',
        url: "/grayRelease/residential",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/sys/html/grayRelease.html",
            controller: 'GrayController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                  serviceId: 'residential'
                };
              }
            }
          }
        }
      })
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('GrayService', GrayService);

  GrayService.$inject = ['$http'];

  function GrayService($http) {
    return {
      listProperties: listProperties,
      updateProperties: updateProperties,
      updateStatus: updateStatus,
      updatePercentage: updatePercentage,
      getActiveUser: getActiveUser,
      getGrayUser: getGrayUser,
      resetGrayUser: resetGrayUser
    };

    function listProperties(serviceId) {
      var resourceUrl = '/api/security/gray/release/listProperties?serviceId=' + serviceId;
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    function updateProperties(entity, serviceId) {
      var resourceUrl = '/api/security/gray/release/updateProperties?serviceId=' + serviceId;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function updateStatus(entity, serviceId) {
      var resourceUrl = '/api/security/gray/release/updateStatus?serviceId=' + serviceId;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function updatePercentage(entity, serviceId) {
      var resourceUrl = '/api/security/gray/release/updatePercentage?serviceId=' + serviceId;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function getActiveUser(serviceId) {
      var resourceUrl = '/api/security/gray/release/getActiveUser?serviceId=' + serviceId;
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    function getGrayUser(serviceId) {
      var resourceUrl = '/api/security/gray/release/getGrayUser?serviceId=' + serviceId;
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    function resetGrayUser(serviceId) {
      var resourceUrl = '/api/security/gray/release/resetGrayUser?serviceId=' + serviceId;
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('GrayController', GrayController);

  GrayController.$inject = ['$filter', '$translate', 'entity', 'toastr', 'toastrConfig', 'SweetAlert', 'GrayService'];

  function GrayController($filter, $translate, entity, toastr, toastrConfig, SweetAlert, GrayService) {

    var eContainerTotal = document.getElementById('eContainerTotal');
    var eCharts1 = document.getElementById('pie1');
    var eCharts2 = document.getElementById('pie2');
    var resizeWorldMapContainer = function () {
      eCharts1.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts1.style.height = eContainerTotal.clientHeight + 'px';
      eCharts2.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts2.style.height = eContainerTotal.clientHeight + 'px';
    };
    resizeWorldMapContainer();
    $('#eContainerTotal').resize(function () {
      resizeWorldMapContainer();
      pie1.resize();
      pie2.resize();
    });
    var pie1 = echarts.init(eCharts1);
    var pie2 = echarts.init(eCharts2);

    var vm = this;
    vm.serviceId = entity.serviceId;
    vm.isSaving = false;

    vm.listProperties = listProperties;
    vm.updateApimConfig = updateApimConfig;
    vm.updateBaseInfo = updateBaseInfo;
    vm.updateStatus = updateStatus;
    vm.updatePercentage = updatePercentage;
    vm.getActiveUser = getActiveUser;
    vm.getGrayUser = getGrayUser;
    vm.resetGrayUser = resetGrayUser;

    vm.initData = initData;
    vm.initData();

    function initData() {
      vm.listProperties();
      vm.getActiveUser();
      vm.getGrayUser();
    }

    function listProperties() {
      GrayService.listProperties(vm.serviceId).then(function (response) {
        if (response.success) {
          vm.config = response.rows[0];
          var status = vm.config.status;
          if (!status) status = "OFF";
          vm.old = {
            status: status,
            statusMeaning: $translate.instant("grayRelease.status_" + status),
            percentage: vm.config.percentage,
            minPercentage: status === "OFF" || status === "PREPARE" ? 0 : (vm.config.percentage + 1),
            maxPercentage: status === "ROLLBACK" || status === "HOTFIX" || status === "AUDIT" ? 0 : 100
          };
          vm.config.status = null;
          vm.config.percentage = null;
          if (status === "OFF") {
            vm.nextStatus = [
              {value: "PREPARE", meaning: $translate.instant("grayRelease.status_PREPARE")},
              {value: "AUDIT", meaning: $translate.instant("grayRelease.status_AUDIT")},
            ];
          } else if (status === "PREPARE") {
            vm.nextStatus = [{value: "ON", meaning: $translate.instant("grayRelease.status_ON")}];
          } else if (status === "ON") {
            vm.nextStatus = [
              {value: "ENOUGH", meaning: $translate.instant("grayRelease.status_ENOUGH")},
              {value: "PUBLISHING", meaning: $translate.instant("grayRelease.status_PUBLISHING")},
              {value: "ROLLBACK", meaning: $translate.instant("grayRelease.status_ROLLBACK")},
              {value: "HOTFIX", meaning: $translate.instant("grayRelease.status_HOTFIX")},
            ];
          } else if (status === "ENOUGH") {
            vm.nextStatus = [
              {value: "ON", meaning: $translate.instant("grayRelease.status_ON")},
              {value: "PUBLISHING", meaning: $translate.instant("grayRelease.status_PUBLISHING")},
              {value: "ROLLBACK", meaning: $translate.instant("grayRelease.status_ROLLBACK")},
              {value: "HOTFIX", meaning: $translate.instant("grayRelease.status_HOTFIX")},
            ];
          } else if (status === "PUBLISHING" || status === "ROLLBACK" || status === "AUDIT") {
            vm.nextStatus = [{value: "OFF", meaning: $translate.instant("grayRelease.status_OFF")}];
          } else if (status === "HOTFIX") {
            vm.nextStatus = [
              {value: "ON", meaning: $translate.instant("grayRelease.status_ON")},
              {value: "ROLLBACK", meaning: $translate.instant("grayRelease.status_ROLLBACK")},
            ];
          } else {
            vm.nextStatus = [];
          }
        }
      });
    }

    function updateApimConfig() {
      SweetAlert.confirm($filter('T')("grayRelease.updateApimConfigConfirmTip"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          updateProperties([
            {name: "tenantId", value: vm.config.tenantId},
            {name: "clientId", value: vm.config.clientId},
            {name: "clientSecret", value: vm.config.clientSecret},
            {name: "subscriptionId", value: vm.config.subscriptionId},
            {name: "resourceGroup", value: vm.config.resourceGroup},
            {name: "apiService", value: vm.config.apiService},
          ]);
        }
      });
    }

    function updateBaseInfo() {
      SweetAlert.confirm($filter('T')("grayRelease.updateBaseInfoConfirmTip"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          updateProperties([
            {name: "activeUserTotal", value: vm.config.activeUserTotal},
            {name: "podVersion", value: vm.config.podVersion},
            {name: "appAndroidVersion", value: vm.config.appAndroidVersion},
            {name: "appIosVersion", value: vm.config.appIosVersion},
            {name: "releaseServiceIp", value: vm.config.releaseServiceIp},
            {name: "normalServiceIp", value: vm.config.normalServiceIp},
            {name: "duration", value: vm.config.duration},
            {name: "defaultEnvFlag", value: vm.config.defaultEnvFlag},
          ]);
        }
      });
    }

    function updateProperties(properties) {
      vm.isSaving = true;
      GrayService.updateProperties(properties, vm.serviceId).then(function (response) {
        vm.isSaving = false;
        if (response.success) {
          toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.infoTitle"));
          vm.initData();
        } else {
          toastr.error($filter('T')('title.saveFail'));
        }
      }, function () {
        vm.isSaving = false;
        toastr.error($filter('T')('title.saveFail'));
      });
    }

    function updateStatus() {
      SweetAlert.confirm($filter('T')("grayRelease.updateStatusConfirmTip"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          vm.isSaving = true;
          var property = {value: vm.config.status};
          GrayService.updateStatus(property, vm.serviceId).then(function (response) {
            vm.isSaving = false;
            if (response.success) {
              toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.infoTitle"));
              vm.initData();
            } else {
              toastr.error($filter('T')('title.saveFail'));
            }
          }, function () {
            vm.isSaving = false;
            toastr.error($filter('T')('title.saveFail'));
          });
        }
      });
    }

    function updatePercentage() {
      SweetAlert.confirm($filter('T')("grayRelease.updatePercentageConfirmTip"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          vm.isSaving = true;
          var property = {value: vm.config.percentage};
          GrayService.updatePercentage(property, vm.serviceId).then(function (response) {
            vm.isSaving = false;
            if (response.success) {
              toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.infoTitle"));
              vm.initData();
            } else {
              toastr.error($filter('T')('title.saveFail'));
            }
          }, function () {
            vm.isSaving = false;
            toastr.error($filter('T')('title.saveFail'));
          });
        }
      });
    }

    function resetGrayUser() {
      SweetAlert.confirm($filter('T')("grayRelease.resetConfirmTip"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          GrayService.resetGrayUser(vm.serviceId).then(function (response) {
            if (response.success) {
              toastr.success($filter('T')("title.resetSuccess"), $filter('T')("title.infoTitle"));
              vm.initData();
            } else {
              toastr.error($filter('T')('title.operationFailed'));
            }
          }, function () {
            toastr.error($filter('T')('title.operationFailed'));
          });
        }
      });
    }

    function getActiveUser() {
      return GrayService.getActiveUser(vm.serviceId).then(function (data) {
        if (!data.rows) {
          return;
        }
        var xList = [];
        var yList = [];
        for (var i = 0; i < data.rows.length; i++) {
          var index = data.rows[i].time.indexOf('-') + 1;
          xList.push(data.rows[i].time.substring(index));
          yList.push(data.rows[i].value);
        }
        var seriesList = [];
        var series = {};
        series.name = $filter('T')("grayRelease." + vm.serviceId);
        series.type = 'bar';
        series.barWidth = '45%';
        series.stack = 'TOTAL';
        series.data = yList;
        seriesList.push(series);
        var text = $filter('T')("grayRelease.activeUserEveryDay");
        var option = {
          title: {
            text: text
          },
          tooltip: {
            trigger: 'item',
            formatter: "{b} <br/>{a} : {c}"
          },
          legend: {
            data: [$filter('T')("grayRelease." + vm.serviceId)],
            top: '6%',
            left: '0%'
          },
          grid: {
            bottom: '23px',
            left: '10%',
            top: '30%',
            right: '20%'
          },
          xAxis: {
            data: xList
          },
          yAxis: {
            type: 'value'
          },
          series: seriesList
        };

        if (data.rows.length === 0) {
          var title = $filter('T')("grayRelease.activeUserEveryDay");
          var noData = $filter('T')("alert.noData");
          $("#pie1").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + title + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
          vm.pie1NotData = true;
        } else {
          if (vm.pie1NotData) {
            $("#pie1").empty();
            pie1 = echarts.init(document.getElementById("pie1"));
            vm.pie1NotData = false;
          }
          pie1.setOption(option);
          pie1.on("click", function (param) {
          });
        }
      });
    }

    function getGrayUser() {
      return GrayService.getGrayUser(vm.serviceId).then(function (data) {
        if (!data.rows) {
          return;
        }
        var title = [];
        var dataSmall = [];
        var dataBig = [];
        if (data.rows[0]) {
          var name = $filter('T')("grayRelease.grayUser");
          title.push(name);
          dataSmall.push({name: name, value: data.rows[0].grayUser});
          name = $filter('T')("grayRelease.normalUser");
          title.push(name);
          dataSmall.push({name: name, value: data.rows[0].activeUser - data.rows[0].grayUser});
          name = $filter('T')("grayRelease.activeUser");
          title.push(name);
          dataBig.push({name: name, value: data.rows[0].activeUser});
        }
        var text = $filter('T')("grayRelease.grayUserPercentage");
        var option = {
          title: {
            text: text
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            data: title,
            top: '6%',
            left: '0%'
          },
          grid: {
            top: '10%'
          },
          series: [{
            name: text,
            center: ['40%', '55%'],
            type: 'pie',
            radius: ['45%', '65%'],
            data: dataSmall
          },
            {
              name: text,
              label: {
                normal: {
                  position: 'inner'
                }
              },
              center: ['40%', '55%'],
              type: 'pie',
              radius: ['0%', '35%'],
              data: dataBig
            }]
        };

        if (data.rows.length === 0) {
          var noDataTitle = $filter('T')("grayRelease.grayUserPercentage");
          var noData = $filter('T')("alert.noData");
          $("#pie2").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
          vm.pie2NotData = true;
        } else {
          if (vm.pie2NotData) {
            $("#pie2").empty();
            pie2 = echarts.init(document.getElementById("pie2"));
            vm.pie2NotData = false;
          }
          pie2.setOption(option);
          pie2.on("click", function (param) {
          });
        }
      });
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

//resize of div
(function ($, h, c) {
  var a = $([]),
    e = $.resize = $.extend($.resize, {}),
    i,
    k = "setTimeout",
    j = "resize",
    d = j + "-special-event",
    b = "delay",
    f = "throttleWindow";
  e[b] = 250;
  e[f] = true;
  $.event.special[j] = {
    setup: function () {
      if (!e[f] && this[k]) {
        return false;
      }
      var l = $(this);
      a = a.add(l);
      $.data(this, d, {
        w: l.width(),
        h: l.height()
      });
      if (a.length === 1) {
        g();
      }
    },
    teardown: function () {
      if (!e[f] && this[k]) {
        return false;
      }
      var l = $(this);
      a = a.not(l);
      l.removeData(d);
      if (!a.length) {
        clearTimeout(i);
      }
    },
    add: function (l) {
      if (!e[f] && this[k]) {
        return false;
      }
      var n;

      function m(s, o, p) {
        var q = $(this),
          r = $.data(this, d);
        r.w = o !== c ? o : q.width();
        r.h = p !== c ? p : q.height();
        n.apply(this, arguments);
      }

      if ($.isFunction(l)) {
        n = l;
        return m;
      } else {
        n = l.handler;
        l.handler = m;
      }
    }
  };

  function g() {
    i = h[k](function () {
        a.each(function () {
          var n = $(this),
            m = n.width(),
            l = n.height(),
            o = $.data(this, d);
          if (m !== o.w || l !== o.h) {
            n.trigger(j, [o.w = m, o.h = l]);
          }
        });
        g();
      },
      e[b]);
  }
})(jQuery, this);

/**
 * Created by xiwang.liu on 2016/8/10.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddUnitController', AddUnitController);

  AddUnitController.$inject = ['UnitService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', '$filter', 'toastrConfig', 'SweetAlert'];

  function AddUnitController(UnitService, $state, $uibModalInstance, toastr, entity, PromptService, $filter, toastrConfig, SweetAlert) {
    var vm = this;
    vm.unit = entity;

    vm.clear = clear;
    vm.addUnit = addUnit;
    vm.showUnitName = showUnitName;
    vm.unitNameSure = unitNameSure;
    vm.load = load;
    vm.load();

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#unitNameBtn").attr("disabled", false);
      });
    }
    initLangs();

    function load() {
      if (vm.unit.unitId) {
        UnitService.getUnitById(vm.unit).then(function (result) {
          vm.unit = result.rows[0];
          UnitService.getUnitLocaleInfo(vm.unit.unitId, 'com.iot.portal.admin.sys.unit.entities.UnitMeasureInfoDto', $("#unitNameBtn").val())
            .then(function (data) {
              var unitName = {};
              var __tls = {};
              for (var i in data) {
                unitName[data[i].langCode] = data[i].value;
              }
              __tls[$("#unitNameBtn").val()] = unitName;
              vm.unit.__tls = __tls;
              $("#unitNameBtn").attr("disabled", false);
            })
        })
      }
    }

    //submit add unit
    function addUnit() {
      var reg = /^\+?[0-9]\d*$/;
      if(!reg.test(vm.unit.conversionPrecision)) {
        SweetAlert.error($filter('T')("unit.conversionPrecision"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if(!vm.unit.unitId){
        return UnitService.addUnit(vm.unit).then(function (data) {
          if(data.code=='repeat'){
            toastr.warning($filter('T')('distribution.repeatNot'));
            return ;
          }
          if (data.code=='mainUnit') {
            toastr.warning($filter('T')('unit.repeatMainUnit'));
            return ;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('dvmproduct', null, {reload: 'dvmproduct'});
          }
        });
      } else{
        return UnitService.updateUnit(vm.unit).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('dvmproduct', null, {reload: 'dvmproduct'});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    //show unit name model
    function showUnitName() {
      $("#unitNameModel").modal("show");
      if($.trim($("#unitNameModelBody").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Name' ng-model='vm.unit.__tls." + $("#unitNameBtn").val() + '.' + langs[i].langCode + "'/>");
            $("#unitNameModelBody").append(div);
            if(vm.unit.unitId) {
              $("input[name='" + langs[i].langCode + "Name']").val(vm.unit.__tls[$("#unitNameBtn").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    //save unit name model
    function unitNameSure() {
      var __tls = vm.unit.__tls || {};
      var unitName = {};
      for (var i in langs) {
        unitName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Name']").val();
      }
      var btnValue = $("#unitNameBtn").val();
      vm.unit[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Name']").val();
      $("#unitNameModel").modal("hide");
      __tls[btnValue] = unitName;
      vm.unit.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Created by zyl on 2017/7/3.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddRepairCenterController', AddRepairCenterController);

  AddRepairCenterController.$inject = ['repairCenterService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', '$filter'];

  function AddRepairCenterController(repairCenterService, $state, $uibModalInstance, toastr, entity, PromptService, $filter) {
    var vm = this;
    vm.repairCenter = entity;
    vm.clear = clear;
    vm.addRepairCenter = addRepairCenter;
    vm.showCompanyName = showCompanyName;
    vm.showAddress = showAddress;
    vm.localeSureCompanyName = localeSureCompanyName;
    vm.localeSureAddress = localeSureAddress;
    vm.load = load;


    vm.load();
    var langs = [];
    initLangs();
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn_companyName").attr("disabled", false);
        $("#localeBtn_address").attr("disabled", false);
      });
    }
    //init load
    function load() {
      if(vm.repairCenter.isEdit === "true"){
        vm.isEdit = true;
      }
      if (vm.repairCenter.serviceCenterId) {
        repairCenterService.getRepairCenters(vm.repairCenter, 1).then(function (result) {
          vm.repairCenter = result.rows[0];
          repairCenterService.getRepairCenterLocaleInfo(vm.repairCenter.serviceCenterId, 'com.kohler.iot.integrator.hms.api.dto.ServiceCenterDTO', $("#localeBtn_companyName").val())
            .then(function (data) {
              var __tls = {};
              var companyName = {};
              for (var i in data) {
                companyName[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn_companyName").val()] = companyName;
              vm.repairCenter.__tls = __tls;
              repairCenterService.getRepairCenterLocaleInfo(vm.repairCenter.serviceCenterId, 'com.kohler.iot.integrator.hms.api.dto.ServiceCenterDTO',  $("#localeBtn_address").val())
                .then(function (data) {
                  var address = {};
                  for (var i in data) {
                    address[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#localeBtn_address").val()] = address;
                  vm.repairCenter.__tls = __tls;
                  $("#localeBtn_companyName").attr("disabled", false);
                  $("#localeBtn_address").attr("disabled", false);
                })
            })
        })
      }
    }

    function localeSureAddress() {
      var __tls = vm.repairCenter.__tls || {};
      var address = {};
      for (var i in langs) {
        address[langs[i].langCode] = $("input[name='" + langs[i].langCode + "address']").val();
      }
      var btnValue = $("#localeBtn_address").val();
      vm.repairCenter[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "address']").val();
      $("#localeModal_address").modal("hide");
      __tls[btnValue] = address;
      vm.repairCenter.__tls = __tls;
    }

    function localeSureCompanyName() {
      var __tls = vm.repairCenter.__tls || {};
      var companyName = {};
      for (var i in langs) {
        companyName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "companyName']").val();
      }
      var btnValue = $("#localeBtn_companyName").val();
      vm.repairCenter[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "companyName']").val();
      $("#localeModal_companyName").modal("hide");
      __tls[btnValue] = companyName;
      vm.repairCenter.__tls = __tls;
    }

    function showCompanyName(){
      $("#localeModal_companyName").modal("show");
      if($.trim($("#localeModelBody_companyName").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "companyName' ng-model='vm.repairCenter.__tls." + $("#localeBtn_companyName").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_companyName").append(div);
            if(vm.repairCenter.serviceCenterId){
              $("input[name='" + langs[i].langCode + "companyName']").val(vm.repairCenter.__tls[$("#localeBtn_companyName").val()][langs[i].langCode]);
            }
          }
        }
      }
    }
    function showAddress(){
      $("#localeModal_address").modal("show");
      if($.trim($("#localeModelBody_address").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "address' ng-model='vm.repairCenter.__tls." + $("#localeBtn_address").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_address").append(div);
            if(vm.repairCenter.serviceCenterId){
              $("input[name='" + langs[i].langCode + "address']").val(vm.repairCenter.__tls[$("#localeBtn_address").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function addRepairCenter() {
      var array = new Array();
      array.push(vm.repairCenter);
      if(!vm.repairCenter.serviceCenterId){
        return repairCenterService.addRepairCenter(array).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('repairCenter', null, {reload: 'repairCenter'});
          }
        });
      } else{
        return repairCenterService.updateRepairCenter(array).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('repairCenter', null, {reload: 'repairCenter'});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * Created by youliang.zhu
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddRegionController', AddRegionController);

  AddRegionController.$inject = ['MessageTemplateService', 'repairCenterService', 'userServicePhoneService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService','$filter'];

  function AddRegionController(MessageTemplateService, repairCenterService, userServicePhoneService, $state, $uibModalInstance, toastr, entity, PromptService,$filter) {
    var vm = this;
    vm.region = entity;
    vm.CodeEditable = false;
    vm.clear = clear;
    vm.addRegion = addRegion;
    vm.initWidget = initWidget;
    vm.getRepairCenter = getRepairCenter;
    vm.showRegion = showRegion;
    vm.localeSureRegionCode = localeSureRegionCode;
    vm.load = load;
    initWidget();
    vm.countryRegion = [];
    var langs = [];
    setEdit();
    vm.getRepairCenter();
    vm.load();
    initLangs();
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn_regionCode").attr("disabled", false);
      });
    }
    function setEdit() {
      if (vm.region.countryServiceCenterId != null) {
        vm.CodeEditable = true;
      }
    }

    //init load

    function getRegionEdit() {
      return userServicePhoneService.getRegionEdit()
        .then(function (data) {
          if (!data) {
            return;
          }
          vm.region = data.rows;
        })
    }

    function getRepairCenter() {
      repairCenterService.getAllRepairCenter()
        .then(function (data) {
          if (!data) {
            return;
          }
          vm.repairCenters = data.rows;
        })
    }

    function getRepairCenterName(){
      repairCenterService.getRepairCenterEdit(vm.region.serviceCenterId,1).then(function(data){
        if (!data) {
          return;
        }
        vm.repairCenterName = data.rows[0];
      })
    }
    //submit add product
    function addRegion() {
      var va = new Array();
      va.push(vm.region)
      if (!vm.region.countryServiceCenterId) {
        return userServicePhoneService.addRegion(va).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('servicePhone', null, {reload: 'servicePhone'});
          }
        });
      } else {
        return userServicePhoneService.updateRegion(va).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('servicePhone', null, {reload: 'servicePhone'});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function initWidget() {
      MessageTemplateService.getByCode().query({code: 'IOT.DVM_COUNTRY'}, function (data) {
        vm.countryRegion = data.rows;
      }, function (error) {
      });
    }

    function load() {
      if (vm.region.countryServiceCenterId) {
        userServicePhoneService.getRegion(vm.region, 1).then(function (result) {
          vm.region = result.rows[0];
          userServicePhoneService.getRepairCenterLocaleInfo(vm.region.countryServiceCenterId, 'com.kohler.iot.integrator.hms.api.entities.CountryServiceCenterDTO', $("#localeBtn_regionCode").val())
            .then(function (data) {
              var __tls = {};
              var regionCode = {};
              for (var i in data) {
                regionCode[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn_regionCode").val()] = regionCode;
              vm.region.__tls = __tls;
              $("#localeBtn_regionCode").attr("disabled", false);
            })
        })
      }
    }

    function showRegion(){
      $("#localeModal_regionCode").modal("show");
      if($.trim($("#localeModelBody_regionCode").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "regionCode' ng-model='vm.region.__tls." + $("#localeBtn_regionCode").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_regionCode").append(div);
            if(vm.region.countryServiceCenterId){
              $("input[name='" + langs[i].langCode + "regionCode']").val(vm.region.__tls[$("#localeBtn_regionCode").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function localeSureRegionCode() {
      var __tls = vm.region.__tls || {};
      var regionCode = {};
      for (var i in langs) {
        regionCode[langs[i].langCode] = $("input[name='" + langs[i].langCode + "regionCode']").val();
      }
      var btnValue = $("#localeBtn_regionCode").val();
      vm.region[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "regionCode']").val();
      $("#localeModal_regionCode").modal("hide");
      __tls[btnValue] = regionCode;
      vm.region.__tls = __tls;
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('UnifiedStructureProductDialogController', Controller);

  Controller.$inject = ['$sessionStorage', 'UnifiedStructureProductService', 'paginationConstants', 'SweetAlert', '$filter', '$state', 'CommandMaintenanceService', '$uibModalInstance', 'PromptService', 'toastr', 'entity'];

  function Controller($sessionStorage, UnifiedStructureProductService, paginationConstants, SweetAlert, $filter, $state, CommandMaintenanceService, $uibModalInstance, PromptService, toastr, entity) {
    var vm = this;
    vm.unifiedStructureProduct = entity;

    vm.submit = submit;
    vm.init = init;
    vm.selectCmdSet = selectCmdSet;
    vm.showDescription = showDescription;
    vm.localeSureDescription = localeSureDescription;
    vm.clear = clear;
    vm.initLangs = initLangs;


    vm.init();
    vm.selectCmdSet();
    vm.initLangs();

    function selectCmdSet() {
      CommandMaintenanceService.getCommandSet({}, 1, -1).then(function (data) {
        vm.cmdSets = data.rows;
      })
    }

    function init() {
      if (vm.unifiedStructureProduct.id) {
        UnifiedStructureProductService.query(vm.unifiedStructureProduct, 1, 1)
        .then(function (data) {
          vm.unifiedStructureProduct = data.rows[0];
          UnifiedStructureProductService.getUSProductLocaleInfo(vm.unifiedStructureProduct.id, 'com.iot.portal.admin.scm.dto.ScmUnifiedStructureProductDTO',  angular.element("#localeBtn_description").val())
          .then(function (res) {
            var __tls = {};
            var description = {};
            for (var i in res) {
              description[res[i].langCode] = res[i].value;
            }
            __tls[angular.element("#localeBtn_description").val()] = description;
            vm.unifiedStructureProduct.__tls = __tls;
            angular.element('#localBtn_decription').attr('disabled', false);
          })
        })
      }
    }

    function submit() {
      if (vm.unifiedStructureProduct.id) {
        update();
      } else {
        add();
      }
    }

    function update() {
      UnifiedStructureProductService.update(vm.unifiedStructureProduct)
      .then(function (data) {
        if (data.success) {
          SweetAlert.success($filter('T')("title.saveSuccess"), {title: $filter('T')("btnTypeName.prompt")})
          .then(function () {
              $uibModalInstance.close();
              $state.go('unifiedStructureProduct', null, {reload: true});
            }
          )
        } else {
          SweetAlert.error($filter('T')("title.failed"), {title: $filter('T')("btnTypeName.prompt")})
          .then(function () {
              $uibModalInstance.close();
              $state.go('unifiedStructureProduct', null, {reload: true});
            }
          )
        }
      })
    }

    function add() {
      UnifiedStructureProductService.add(vm.unifiedStructureProduct)
      .then(function (data) {
        if (data.success) {
          toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          $uibModalInstance.close();
          $state.go('unifiedStructureProduct', null, {reload: true});
        } else {
          toastr.success($filter('T')("title.saveFail"), $filter('T')("title.confirmTitle"));
          $uibModalInstance.close();
          $state.go('unifiedStructureProduct', null, {reload: true});
        }
      })
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        angular.element("#localeBtn_description").attr("disabled", false);
      });
    }

    function showDescription() {
      angular.element("#localeModal_description").modal("show");
      if (angular.element("#localeModalBody_description").html().trim() === "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = angular.element("<div class ='form-group'></div>");
            div.append("<lable class = 'control-label'>" + langs[i].description + "</lable>");
            div.append("<input type = 'text' class = 'form-control' name = '" + langs[i].langCode + "description' ng-model='vm.unifiedStructureProduct.__tls.description." + langs[i].langCode + "'/>");
            angular.element("#localeModalBody_description").append(div);
            if (vm.unifiedStructureProduct.id) {
              angular.element("input[name='" + langs[i].langCode + "description']").val(vm.unifiedStructureProduct.__tls[angular.element("#localeBtn_description").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function localeSureDescription() {
      var __tls = vm.unifiedStructureProduct.__tls || {};
      var description = {};

      for (var i in langs) {
        description[langs[i].langCode] = angular.element("input[name = '" + langs[i].langCode + "description']").val();
      }

      var btnValue = angular.element("#localeBtn_description").val();
      vm.unifiedStructureProduct[btnValue] = angular.element("input[name='" + (window.localStorage.lang || 'en_GB') + "description']").val();
      angular.element("#localeModal_description").modal("hide");
      __tls[btnValue] = description;
      vm.unifiedStructureProduct.__tls = __tls;
    }
  }

})();

(function () {
  'use strict';

  angular.module('hmapFront').config(config);

  function config($stateProvider) {
    $stateProvider.state('unifiedStructureProduct', {
      parent: 'app',
      url: '/smartlight',
      views: {
        'body': {
          templateUrl: 'app/iot/portal/admin/scm/html/unifiedStructureProduct.html',
          controller: 'UnifiedStructureProductController',
          controllerAs: 'vm'
        }
      }
    })
    .state('unifiedStructureProduct.add', {
      parent: 'unifiedStructureProduct',
      url: '/add',
      onEnter: ['$uibModal', '$state', function ($uibModal, $state) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/scm/html/unifiedStructureProduct-dialog.html',
          controller: 'UnifiedStructureProductDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {}
            }
          }
        }).result.then(function () {
          $state.go('unifiedStructureProduct', null, {reload: true})
        }, function () {
          $state.go('unifiedStructureProduct', null, {reload: true})
        })
      }]
    })
    .state('unifiedStructureProduct.edit', {
      parent: 'unifiedStructureProduct',
      url: '/edit/:id',
      onEnter: ['$uibModal', '$stateParams', '$state', function ($uibModal, $stateParams, $state) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/scm/html/unifiedStructureProduct-dialog.html',
          controller: 'UnifiedStructureProductDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                id: $stateParams.id
              }
            }
          }
        }).result.then(function () {
          $state.go('unifiedStructureProduct', null, {reload: true})
        }, function () {
          $state.go('unifiedStructureProduct', null, {reload: true})
        })
      }]
    })
  }
})();
(function () {
  'use strict';

  angular.module('hmapFront').factory('UnifiedStructureProductService', service);

  service.$inject = ['$http'];

  function service($http) {
    return {
      query: query,
      add: add,
      update: update,
      deleteAll: deleteAll,
      getUSProductLocaleInfo: getUSProductLocaleInfo,
      queryByType: queryByType
    };

    function query(body, page, pageSize) {
      var resourceUrl = '/api/scm/usp/query?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }

    function queryByType(body, page, pageSize) {
      var resourceUrl = '/api/scm/usp/queryByType?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }

    function add(body) {
      var resourceUrl = '/api/scm/usp/add';
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }

    function update(body) {
      var resourceUrl = '/api/scm/usp/update';
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }


    function deleteAll(body) {
      var resourceUrl = '/api/scm/usp/remove';
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }

    //get unifiedStructureProduct locale info
    function getUSProductLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('UnifiedStructureProductController', UnifiedStructureProductController);

  UnifiedStructureProductController.$inject = ['$sessionStorage', 'UnifiedStructureProductService', 'paginationConstants',
    'SweetAlert', '$filter', 'CommandMaintenanceService','MessageTemplateService'];

  function UnifiedStructureProductController($sessionStorage, UnifiedStructureProductService, paginationConstants,
                                             SweetAlert, $filter, CommandMaintenanceService,MessageTemplateService) {
    var vm = this;
    vm.unifiedStructureProduct = {};
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.cmdSets = [];
    vm.unifiedStructureProduct.type = "SMART_LIGHT";


    vm.checkUnifiedStruectureProduct = checkUnifiedStruectureProduct;
    vm.checkAll = checkAll;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.deleteOne = deleteOne;
    vm.deleteSelects = deleteSelects;
    vm.reset = reset;
    vm.selectCmdSet = selectCmdSet;

    vm.search();
    vm.selectCmdSet();


    function reset() {
      vm.unifiedStructureProduct.type = "SMART_LIGHT";
      vm.unifiedStructureProduct.objectId = undefined;
    }

    function search() {
      getTypee();
      /*if (vm.unifiedStructureProduct && (vm.unifiedStructureProduct.type || "") === "") {
        delete vm.unifiedStructureProduct.type;
      }*/
      if (vm.unifiedStructureProduct.type === null || vm.unifiedStructureProduct.type === ""){
        vm.unifiedStructureProduct.type = "SMART_LIGHT"
      }
      if(vm.unifiedStructureProduct.objectId == ""){
        vm.unifiedStructureProduct.objectId = undefined;
      }
      if (vm.unifiedStructureProduct.type === "SMART_LIGHT"){
        return UnifiedStructureProductService.queryByType(vm.unifiedStructureProduct, vm.page, vm.itemsPerPage).then(function (data) {
          if (!data.rows) {
            return;
          }
          vm.unifiedStructureProducts = data.rows;
          vm.totalItems = data.total;
          vm.pageSize = data.rows.length;
        })
      }else{
        return UnifiedStructureProductService.query(vm.unifiedStructureProduct, vm.page, vm.itemsPerPage).then(function (data) {
          if (!data.rows) {
            return;
          }
          vm.unifiedStructureProducts = data.rows;
          vm.totalItems = data.total;
          vm.pageSize = data.rows.length;
        })
      }
    }

    function deleteOne(unifiedStructureProduct) {
      SweetAlert.confirm(unifiedStructureProduct.type + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          var products = [];
          products.push(unifiedStructureProduct);
          UnifiedStructureProductService.deleteAll(products).then(function (response) {
            if (response.success) {
              vm.search();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    function deleteSelects() {
      var isCheck = angular.element(".chk_list").is(':checked');
      if (!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          var arrChk = angular.element("input[name='chk_list']:checked");
          var usps = [];
          angular.element(arrChk).each(function (item, value) {
            var usp = {};
            usp.id = value.defaultValue;
            usps.push(usp);
          });
          UnifiedStructureProductService.deleteAll(usps).then(function (response) {
            angular.element("chk_all").checked = false;
            var items = angular.element("chk_list");
            for (var j = 0; j < items.length; j++) {
              items[j].checked = false;
            }
            if (response.success) {
              vm.search();
              angular.element(".chk_list").attr('checked', false);
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")}).then(vm.search);
            }
          })
        }
      });
    }

    function selectCmdSet() {
      CommandMaintenanceService.getCommandSet({}, 1, -1).then(function (data) {
        vm.cmdSets = data.rows;
      })
    }

    function pageChanged() {
      angular.element('#chk_all').checked = false;
      vm.search();
    }

    function checkUnifiedStruectureProduct() {
      var arrChk = angular.element("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        angular.element("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        angular.element("chk_all").checked = true;
      }
    }

    function checkAll() {
      var chk_all = angular.element("#chk_all").is(':checked');
      var items = angular.element(".chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    function getTypee() {
      MessageTemplateService.getByCode().query({code: 'SCM.UNIFIED.STRUCTURE.TYPE'}, function (data) {
        vm.types = data.rows;
      }, function (error) {
      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
    .controller('SmallPartsFunctionController', SmallPartsFunctionController);

    SmallPartsFunctionController.$inject = ['SmallPartsService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService', '$sessionStorage'];

    function SmallPartsFunctionController(SmallPartsService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService, $sessionStorage) {
        var vm = this;
        vm.smallPartFunction = entity;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.checkSmallPartFunctions = checkSmallPartFunctions;
        vm.checkAllSmallPartFunctions = checkAllSmallPartFunctions;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.deleteSmallPartFunctions = deleteSmallPartFunctions;
        vm.deleteSmallPartFunctionss = deleteSmallPartFunctionss;
        vm.getSmallPartFunctions = getSmallPartFunctions;
        vm.reset = reset;

        vm.search();

        function reset() {
            vm.smallPartFunction.functionName = undefined;
        }

        function getSmallPartFunctions() {
            return SmallPartsService.getSmallPartFunction(vm.smallPartFunction, vm.page).then(function (data) {
                if (!data.rows) {
                    return;
                }
                vm.smallPartFunctions = data.rows;
                vm.totalItems = data.total;
                vm.pageSize = data.rows.length;
            })
        }

        function search() {
            vm.getSmallPartFunctions();
            vm.smallPartFunction.cmdSetId = $sessionStorage.scm_js_smallPart_cmdSetId;
            vm.smallPartFunction.cmdSetName = $sessionStorage.scm_js_smallPart_cmdSetName;
        }

        function deleteSmallPartFunctions(smallPartFunction) {
            SweetAlert.confirm(smallPartFunction.functionName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if (p) {
                    var smallPartFunctions = new Array();
                    smallPartFunctions.push(smallPartFunction.widgetFunctionId);
                    SmallPartsService.deleteSmallPartFunction(smallPartFunctions).then(function (response) {
                        if (response.success) {
                            vm.getSmallPartFunctions();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }


        function deleteSmallPartFunctionss() {
            var isCheck = $(".chk_list").is(':checked');
            if (!isCheck) {
                SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
                return;
            }
            SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if (p) {
                    var arrChk = $("input[name='chk_list']:checked");
                    var smallPartFunctions = new Array();
                    $(arrChk).each(function () {
                        smallPartFunctions.push(this.value);
                    });
                    SmallPartsService.deleteSmallPartFunction(smallPartFunctions).then(function (response) {
                        document.getElementById("chk_all").checked = false;
                        var items = document.getElementsByName("chk_list");
                        for (var j = 0; j < items.length; j++) {
                            items[j].checked = false;
                        }
                        if (response.success) {
                            vm.getSmallPartFunctions();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        function pageChanged() {
          angular.element("#chk_all").checked = false;
            vm.getSmallPartFunctions(vm.page);
        }

        function checkSmallPartFunctions() {
            var arrChk = $("input[name='chk_list']:checked");
            if (arrChk.length < vm.pageSize) {
                document.getElementById("chk_all").checked = false;
            } else if (arrChk.length === vm.pageSize) {
                document.getElementById("chk_all").checked = true;
            }
        }

        function checkAllSmallPartFunctions() {
            var chk_all = $("#chk_all").is(':checked');
            var items = document.getElementsByName("chk_list");
            if (chk_all) {
                for (var i = 0; i < items.length; i++) {
                    items[i].checked = true;
                }
            } else {
                for (var j = 0; j < items.length; j++) {
                    items[j].checked = false;
                }
            }
        }
    }
})();


(function () {
    'use strict';

    angular.module('hmapFront')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        $stateProvider
            .state('smallPart', {
                parent: 'app',
                url:"/smallPart",
                views:{
                    body:{
                        templateUrl:"app/iot/portal/admin/scm/html/smallParts.html",
                        controller:'SmallPartsController',
                        controllerAs:'vm'
                    }
                },
                resolve:{
                    entity:function () {
                        return {}
                    }
                }
            })
            .state('smallPart.add',{
                parent:'smallPart',
                url:"/add",
                onEnter:['$stateParams','$state','$uibModal',function ($stateParams,$state,$uibModal) {
                    $uibModal.open({
                        templateUrl:"app/iot/portal/admin/scm/html/addSmallParts.html",
                        controller:'AddSmallPartsController',
                        controllerAs:'vm',
                        backdrop:'static',
                        size:'lg',
                        resolve:{
                            entity:function () {
                                return {}
                            }
                        }
                    }).result.then(function () {
                        $state.go('smallPart', null, {reload: true});
                    },function () {
                        $state.go('smallPart');
                    })
                }]
            })
            .state('smallPart.edit',{
                parent:'smallPart',
                url:'/edit/:widgetId',
                onEnter:['$stateParams','$state','$uibModal',function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl:"app/iot/portal/admin/scm/html/addSmallParts.html",
                        controller:'AddSmallPartsController',
                        controllerAs:'vm',
                        backdrop:'static',
                        size:'lg',
                        resolve:{
                            entity:function () {
                                return {widgetId:$stateParams.widgetId}
                            }
                        }
                    }).result.then(function () {
                        $state.go('smallPart', null, {reload: true});
                    },function () {
                        $state.go('smallPart');
                    })
                }]
            })

      //smallPartFunction router
          .state('smallPartFunction', {
            parent: 'app',
            url: "/smallPartFunction/:widgetId",
            views: {
              'body': {
                templateUrl: "app/iot/portal/admin/scm/html/smallPartsFunction.html",
                controller: 'SmallPartsFunctionController',
                controllerAs: 'vm'
              }
            },resolve:{
              entity:function ($stateParams) {
                return {
                  widgetId:$stateParams.widgetId
                }
              }
            }
          })
          .state('smallPartFunction.add',{
            parent:'smallPartFunction',
            url:"/add/:widgetId",
            onEnter:['$stateParams','$state','$uibModal',function ($stateParams,$state,$uibModal) {
              $uibModal.open({
                templateUrl:"app/iot/portal/admin/scm/html/addSmallPartsFunction.html",
                controller:'AddSmallPartsFunctionController',
                controllerAs:'vm',
                backdrop:'static',
                size:'lg',
                resolve:{
                  entity:function () {
                    return {widgetId:$stateParams.widgetId}
                  }
                }
              }).result.then(function () {
                $state.go('smallPartFunction', null, {reload: true});
              },function () {
                $state.go('smallPartFunction');
              })
            }]
          })
          .state('smallPartFunction.edit',{
            parent:'smallPartFunction',
            url:'/edit/:widgetFunctionId',
            onEnter:['$stateParams','$state','$uibModal',function ($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl:"app/iot/portal/admin/scm/html/addSmallPartsFunction.html",
                controller:'AddSmallPartsFunctionController',
                controllerAs:'vm',
                backdrop:'static',
                size:'lg',
                resolve:{
                  entity:function () {
                    return {widgetFunctionId:$stateParams.widgetFunctionId}
                  }
                }
              }).result.then(function () {
                $state.go('smallPartFunction', null, {reload: true});
              },function () {
                $state.go('smallPartFunction');
              })
            }]
          })

    }

})();

(function () {
    'use strict';

    angular.module('hmapFront')
    .factory('SmallPartsService', SmallPartsService);

    SmallPartsService.$inject = ['$http'];

    function SmallPartsService($http) {
        return {
            getProductTypeName: getProductTypeName,
            getSmallPart: getSmallPart,
            deleteSmallPart: deleteSmallPart,
            addSmallPart: addSmallPart,
            updateSmallPart: updateSmallPart,
            getSmallPartInfo: getSmallPartInfo,
            getSmallPartFunction: getSmallPartFunction,
            deleteSmallPartFunction: deleteSmallPartFunction,
            addSmallPartFunction: addSmallPartFunction,
            updateSmallPartFunction: updateSmallPartFunction,
            getCommandSets: getCommandSets
        };

        function getProductTypeName() {
            var resourceUrl = '/api/scm/scenarioProduct/queryProductType';
            return $http.get(resourceUrl, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function getSmallPart(entity, page) {
            var resourceUrl = '/api/sys/widget/query?page=' + page;
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }


        function deleteSmallPart(entity) {
            var resourceUrl = '/api/sys/widget/delete';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function addSmallPart(entity) {
            var resourceUrl = '/api/sys/widget/insertOrUpdate';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function updateSmallPart(entity) {
            var resourceUrl = '/api/sys/widget/insertOrUpdate';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function getSmallPartInfo(code, dto, field) {
            var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
            return $http.get(resourceUrl, {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                }
            }).then(function (response) {
                if (response.status == "200") {
                    return response.data.multiLanguages;
                }
            })
        }


        //function---------------------------
        function getSmallPartFunction(entity, page) {
            var resourceUrl = '/api/sys/widget/function/query?page=' + page;
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function deleteSmallPartFunction(entity) {
            var resourceUrl = '/api/sys/widget/function/delete';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function addSmallPartFunction(entity) {
            var resourceUrl = '/api/sys/widget/function/insertOrUpdate';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function updateSmallPartFunction(entity) {
            var resourceUrl = '/api/sys/widget/function/insertOrUpdate';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function getCommandSets(page, pageSize) {
            var resourceUrl = '/api/inm/commandSet/query?page=' + page + '&pageSize=' + pageSize;
            return $http.post(resourceUrl, {}).then(function (response) {
                return response.data;
            })
        }
    }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
    .controller('SmallPartsController', SmallPartsController);

    SmallPartsController.$inject = ['SmallPartsService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService', '$sessionStorage'];

    function SmallPartsController(SmallPartsService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService, $sessionStorage) {
        var vm = this;
        vm.smallPart = entity;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.checkSmallParts = checkSmallParts;
        vm.checkAllSmallParts = checkAllSmallParts;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.deleteSmallParts = deleteSmallParts;
        vm.deleteSmallPartss = deleteSmallPartss;
        vm.getSmallParts = getSmallParts;
        vm.reset = reset;
        vm.getProductType = getProductType;
        vm.getCommandSets = getCommandSets;


        vm.search();

        function reset() {
            vm.smallPart.cmdSetId = undefined;
            vm.smallPart.cmdSetName = undefined;
        }

        function getSmallParts() {
            return SmallPartsService.getSmallPart(vm.smallPart, vm.page).then(function (data) {
                if (!data.rows) {
                    return;
                }
                vm.smallParts = data.rows;
                vm.totalItems = data.total;
                vm.pageSize = data.rows.length;
            })
        }

        function search() {
            vm.getSmallParts();
            vm.getCommandSets();
        }

        function getProductType(smallPart) {
            $sessionStorage.scm_js_smallPart_cmdSetId = smallPart.cmdSetId;
            $sessionStorage.scm_js_smallPart_cmdSetName = smallPart.cmdSetName;
        }

        function deleteSmallParts(smallPart) {
            SweetAlert.confirm(smallPart.cmdSetName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if (p) {
                    var smallParts = [];
                    smallParts.push(smallPart.widgetId);
                    SmallPartsService.deleteSmallPart(smallParts).then(function (response) {
                        if (response.success) {
                            vm.getSmallParts();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        function deleteSmallPartss() {
            var isCheck = $(".chk_list").is(':checked');
            if (!isCheck) {
                SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
                return;
            }
            SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if (p) {
                    var arrChk = $("input[name='chk_list']:checked");
                    var smallParts = new Array();
                    $(arrChk).each(function () {
                        smallParts.push(this.value);
                    });
                    SmallPartsService.deleteSmallPart(smallParts).then(function (response) {
                        document.getElementById("chk_all").checked = false;
                        var items = document.getElementsByName("chk_list");
                        for (var j = 0; j < items.length; j++) {
                            items[j].checked = false;
                        }
                        if (response.success) {
                            vm.getSmallParts();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        function pageChanged() {
            angular.element("#chk_all").checked = false;
            vm.getSmallParts(vm.page);
        }

        function checkSmallParts() {
            var arrChk = $("input[name='chk_list']:checked");
            if (arrChk.length < vm.pageSize) {
                document.getElementById("chk_all").checked = false;
            } else if (arrChk.length === vm.pageSize) {
                document.getElementById("chk_all").checked = true;
            }
        }

        function checkAllSmallParts() {
            var chk_all = $("#chk_all").is(':checked');
            var items = document.getElementsByName("chk_list");
            if (chk_all) {
                for (var i = 0; i < items.length; i++) {
                    items[i].checked = true;
                }
            } else {
                for (var j = 0; j < items.length; j++) {
                    items[j].checked = false;
                }
            }
        }

        function getCommandSets() {
            SmallPartsService.getCommandSets(1, -1).then(function(data) {
                vm.cmdSetNames = data.rows;
            })
        }
    }
})();


(function () {
    'use strict';
    angular.module('hmapFront')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        $stateProvider
            .state('sceneProduct', {
                parent: 'app',
                url: '/sceneProduct',
                views: {
                    'body': {
                        templateUrl: 'app/iot/portal/admin/scm/html/sceneProduct.html',
                        controller: 'SceneProductController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                        };
                    }
                }
            })
            .state('sceneProduct.add', {
                parent: 'sceneProduct',
                url: '/add',
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/iot/portal/admin/scm/html/addSceneProduct.html',
                        controller: 'AddSceneProductController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {}
                            }
                        }
                    }).result.then(function () {
                        $state.go('sceneProduct', null, {reload: true});
                    }, function () {
                        $state.go('sceneProduct');
                    })
                }]
            })
            .state('sceneProduct.edit', {
                parent: 'sceneProduct',
                url: '/edit/:scenarioProductId',
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/iot/portal/admin/scm/html/addSceneProduct.html',
                        controller: 'AddSceneProductController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    scenarioProductId: $stateParams.scenarioProductId
                                }
                            }
                        }
                    }).result.then(function () {
                        $state.go('sceneProduct', null, {reload: true});
                    }, function () {
                        $state.go('sceneProduct', null, {reload: true})
                    })
                }]
            })

      //actionConfig router
          .state('actionConfig', {
            parent: 'app',
            url: "/actionConfig/:scenarioProductId",
            views: {
              'body': {
                templateUrl: "app/iot/portal/admin/scm/html/actionConfig.html",
                controller: 'ActionConfigControlle',
                controllerAs: 'vm'
              }
            },
            resolve:{
              entity:function ($stateParams) {
                return {
                  scenarioProductId:$stateParams.scenarioProductId
                }
              }
            }
          })
          .state('actionConfig.add', {
            parent: 'actionConfig',
            url: "/add/:scenarioProductId",
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'app/iot/portal/admin/scm/html/addActionConfig.html',
                controller: 'AddActionConfigController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                  entity: function () {
                    return {
                      scenarioProductId:$stateParams.scenarioProductId
                    }
                  }
                }
              }).result.then(function () {
                $state.go('actionConfig', $stateParams.scenarioProductId, {reload: true});
              }, function () {
                $state.go('actionConfig',$stateParams.scenarioProductId);
              });
            }]
          })
          .state('actionConfig.edit', {
            parent: 'actionConfig',
            url: "/edit/:scenarioActionId",
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'app/iot/portal/admin/scm/html/addActionConfig.html',
                controller: 'AddActionConfigController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                  entity: function () {
                    return {
                      scenarioActionId:$stateParams.scenarioActionId,
                    }
                  }
                }
              }).result.then(function () {
                $state.go('actionConfig', null, {reload: true});
              }, function () {
                $state.go('actionConfig');
              });
            }]
          })

      //actionParam router
          .state('actionParams', {
            parent: 'app',
            url: '/actionParams/:scenarioActionId',
            views: {
              'body': {
                templateUrl: 'app/iot/portal/admin/scm/html/actionParams.html',
                controller: 'ActionParamsController',
                controllerAs: 'vm'
              }
            },
            resolve:{
              entity:function ($stateParams) {
                return {scenarioActionId:$stateParams.scenarioActionId}
              }
            }
          })
          .state('actionParams.add', {
            parent: 'actionParams',
            url: '/add/:scenarioActionId',
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'app/iot/portal/admin/scm/html/addActionParams.html',
                controller: 'AddActionParamsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                  entity: function () {
                    return {scenarioActionId:$stateParams.scenarioActionId}
                  }
                }
              }).result.then(function () {
                $state.go('actionParams', null, {reload: true});
              }, function () {
                $state.go('actionParams');
              })
            }]
          })
          .state('actionParams.edit', {
            parent: 'actionParams',
            url: '/edit/:actionParamId',
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'app/iot/portal/admin/scm/html/addActionParams.html',
                controller: 'AddActionParamsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                  entity: function () {
                    return {
                      actionParamId: $stateParams.actionParamId
                    }
                  }
                }
              }).result.then(function () {
                $state.go('actionParams', null, {reload: true});
              }, function () {
                $state.go('actionParams')
              })
            }]
          })
    }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
        .factory('SceneProductService', SceneProductService);

    SceneProductService.$inject = ['$http'];

    function SceneProductService($http) {
      var productTypeName = '';
      var configName = '';
        return {
            getSceneProduct: getSceneProduct,
            deleteSceneProduct: deleteSceneProduct,
            addSceneProduct: addSceneProduct,
            updateSceneProduct:updateSceneProduct,
            getSceneName:getSceneName,
           // getProductType:getProductType,
            getCmdSet : getCmdSet,

         //actionConfig
          getActionConfig: getActionConfig,
          deleteActionConfig: deleteActionConfig,
          addActionConfig: addActionConfig,
          updateActionConfig:updateActionConfig,
          getActionConfigInfo:getActionConfigInfo,
          productTypeName:productTypeName,

          //actionConfigParam
          getActionParam: getActionParam,
          deleteActionParam: deleteActionParam,
          addActionParam: addActionParam,
          updateActionParam:updateActionParam,
          getActionParamInfo:getActionParamInfo,

          configName:configName

        };

        // function getProductType() {
        //     var resourceUrl = '/api/scm/scenarioProduct/queryProductType';
        //     return $http.get(resourceUrl, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        //         return response.data;
        //     })
        // }

      function getCmdSet(cmdSet,page,pagesize) {
        var resourceUrl = '/api/inm/commandSet/query?page='+page+'&pageSize='+pagesize;
            return $http.post(resourceUrl,cmdSet, {headers: {'Content-Type': 'application/json;charset=utf-8'}})
              .then(function (response) {
                return response.data;
            })
      }

        function getSceneName(entity) {
            var resourceUrl = '/api/scm/scenarioProduct/queryMenuName';
            return $http.get(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function getSceneProduct(entity, page) {
            var resourceUrl = '/api/scm/scenarioProduct/query?page=' + page;
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }


        function deleteSceneProduct(entity) {
            var resourceUrl = '/api/scm/scenarioProduct/delete';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function addSceneProduct(entity) {
            var resourceUrl = '/api/scm/scenarioProduct/insert';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function updateSceneProduct(entity) {
            var resourceUrl = '/api/scm/scenarioProduct/update';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }


        //actionConfig
      function getActionConfig(entity, page) {
        var resourceUrl = '/api/scm/scenarioAction/query?page=' + page;
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }


      function deleteActionConfig(entity) {
        var resourceUrl = '/api/scm/scenarioAction/delete';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }


      function addActionConfig(entity) {
        var resourceUrl = '/api/scm/scenarioAction/insert';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function updateActionConfig(entity) {
        var resourceUrl = '/api/scm/scenarioAction/insert';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function getActionConfigInfo(code, dto, field) {
        var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
        return $http.get(resourceUrl, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        }).then(function (response) {
          if (response.status == "200") {
            return response.data.multiLanguages;
          }
        })
      }

      //actionConfigParam
      function getActionParam(entity, page) {
        var resourceUrl = '/api/scm/scenarioActionParam/query?page=' + page;
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }


      function deleteActionParam(entity) {
        var resourceUrl = '/api/scm/scenarioActionParam/delete';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function addActionParam(entity) {
        var resourceUrl = '/api/scm/scenarioActionParam/insert';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function updateActionParam(entity) {
        var resourceUrl = '/api/scm/scenarioActionParam/update';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function getActionParamInfo(code, dto, field) {
        var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
        return $http.get(resourceUrl, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        }).then(function (response) {
          if (response.status == "200") {
            return response.data.multiLanguages;
          }
        })
      }
    }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('SceneProductController', SceneProductController);

    SceneProductController.$inject = ['$sessionStorage','SceneProductService', 'paginationConstants', 'SweetAlert', '$filter', 'MessageTemplateService','entity'];

    function SceneProductController($sessionStorage,SceneProductService, paginationConstants, SweetAlert, $filter, MessageTemplateService,entity) {
        var vm = this;
        vm.sceneProduct = entity;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.checkSceneProduct= checkSceneProduct;
        vm.checkAllSceneProduct = checkAllSceneProduct;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.deleteSceneProduct = deleteSceneProduct;
        vm.deleteSceneProducts = deleteSceneProducts;
        vm.getSceneProduct = getSceneProduct;
        vm.getProductTypeName = getProductTypeName;
        vm.reset = reset;
        vm.search();

        function reset() {
            vm.sceneProduct.menuId = undefined;
            vm.sceneProduct.cmdSetId = undefined;
            vm.sceneProduct.cmdSetName = undefined;
        }

        function getProductTypeName(sceneProduct) {
            $sessionStorage.scm_js_sceneProduct_productTypeName = sceneProduct.productTypeName;
            $sessionStorage.scm_js_sceneProduct_sceneName=sceneProduct.menuName
        }

        function getSceneProduct() {
            return SceneProductService.getSceneProduct(vm.sceneProduct, vm.page).then(function (data) {
                if(!data.rows){
                    return;
                }
                vm.sceneProducts = data.rows;
                vm.totalItems = data.total;
                vm.pageSize = data.rows.length;
                SceneProductService.getSceneName().then(function (data) {
                    vm.menus= data.rows;
                })
            })

        }

        function search() {
            vm.getSceneProduct();
        }

        function deleteSceneProduct(sceneProduct) {
            SweetAlert.confirm(sceneProduct.menuName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var id = [];
                    id.push(sceneProduct.scenarioProductId);
                    SceneProductService.deleteSceneProduct(id).then(function (response) {
                        if (response.success) {
                            vm.getSceneProduct();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        function deleteSceneProducts() {
            var isCheck = $(".chk_list").is(':checked');
            if(!isCheck) {
                SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
                return;
            }
            SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var arrChk = $("input[name='chk_list']:checked");
                    var ids = new Array();
                    $(arrChk).each(function() {
                        ids.push(this.value);
                    });
                    SceneProductService.deleteSceneProduct(ids).then(function (response) {
                        document.getElementById("chk_all").checked = false;
                        var items = document.getElementsByName("chk_list");
                        for(var j = 0; j < items.length; j++){
                            items[j].checked = false;
                        }
                        if (response.success) {
                            vm.getSceneProduct();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        function pageChanged() {
          angular.element("#chk_all").checked = false;
            vm.getSceneProduct(vm.page);
        }

        function checkSceneProduct() {
            var arrChk = $("input[name='chk_list']:checked");
            if(arrChk.length < vm.pageSize) {
                document.getElementById("chk_all").checked = false;
            } else if(arrChk.length === vm.pageSize) {
                document.getElementById("chk_all").checked = true;
            }
        }

        function checkAllSceneProduct() {
            var chk_all = $("#chk_all").is(':checked');
            var items = document.getElementsByName("chk_list");
            if(chk_all) {
                for(var i = 0; i < items.length; i++){
                    items[i].checked = true;
                }
            } else {
                for(var j = 0; j < items.length; j++){
                    items[j].checked = false;
                }
            }
        }
    }
})();


(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('ProductActionParamsController', ProductActionParamsController);

    ProductActionParamsController.$inject = ['$sessionStorage','LinkageProductService', 'paginationConstants', 'SweetAlert', '$filter', 'MessageTemplateService','entity'];

    function ProductActionParamsController($sessionStorage,LinkageProductService, paginationConstants, SweetAlert, $filter, MessageTemplateService,entity) {
        var vm = this;
        vm.productActionParam = entity;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.checkProductActionParam = checkProductActionParam;
        vm.checkAllProductActionParam = checkAllProductActionParam;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.deleteProductActionParam = deleteProductActionParam;
        vm.deleteProductActionParams = deleteProductActionParams;
        vm.getProductActionParam = getProductActionParam;

        vm.search();

        function getProductActionParam() {
            return LinkageProductService.getProductActionParam(vm.productActionParam, vm.page).then(function (data) {
                if(!data.rows){
                    return;
                }
                vm.productActionParams = data.rows;
                vm.totalItems = data.total;
                vm.pageSize = data.rows.length;
            })
        }

        function search() {
            vm.productActionParam.actionName = $sessionStorage.scm_js_productAction_actionName;
            vm.productActionParam.productTypeName = $sessionStorage.scm_js_linkageProduct_ProductTypeName;
            vm.getProductActionParam();
        }

        function deleteProductActionParam(productActionParam) {
            SweetAlert.confirm(productActionParam.paramName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var productActionParams = new Array();
                    productActionParams.push(productActionParam.linkActionParamId);
                  LinkageProductService.deleteProductActionParam(productActionParams).then(function (response) {
                        if (response.success) {
                            vm.getProductActionParam();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }



        function deleteProductActionParams() {
            var isCheck = $(".chk_list").is(':checked');
            if(!isCheck) {
                SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
                return;
            }
            SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var arrChk = $("input[name='chk_list']:checked");
                    var productActionParams = new Array();
                    $(arrChk).each(function() {
                        productActionParams.push(this.value);
                    });
                  LinkageProductService.deleteProductActionParam(productActionParams).then(function (response) {
                        document.getElementById("chk_all").checked = false;
                        var items = document.getElementsByName("chk_list");
                        for(var j = 0; j < items.length; j++){
                            items[j].checked = false;
                        }
                        if (response.success) {
                            vm.getProductActionParam();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        //page changed
        function pageChanged() {
            angular.element("#chk_all").checked = false;
            vm.getProductActionParam(vm.page);
        }

        //check or unCheck check link
        function checkProductActionParam() {
            var arrChk = $("input[name='chk_list']:checked");
            if(arrChk.length < vm.pageSize) {
                document.getElementById("chk_all").checked = false;
            } else if(arrChk.length === vm.pageSize) {
                document.getElementById("chk_all").checked = true;
            }
        }

        //check or unCheck all check link
        function checkAllProductActionParam() {
            var chk_all = $("#chk_all").is(':checked');
            var items = document.getElementsByName("chk_list");
            if(chk_all) {
                for(var i = 0; i < items.length; i++){
                    items[i].checked = true;
                }
            } else {
                for(var j = 0; j < items.length; j++){
                    items[j].checked = false;
                }
            }
        }
    }
})();


(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('ProductActionController', ProductActionController);

    ProductActionController.$inject = ['$sessionStorage','LinkageProductService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

    function ProductActionController($sessionStorage,LinkageProductService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
        var vm = this;
        vm.productAction = entity;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.getProductAndActionName = getProductAndActionName;
        vm.checkProductAction = checkProductAction;
        vm.checkAllProductAction = checkAllProductAction;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.deleteProductAction = deleteProductAction;
        vm.deleteProductActions = deleteProductActions;
        vm.getProductAction = getProductAction;


        vm.search();

        function getProductAndActionName(string) {
            $sessionStorage.scm_js_productAction_actionName = string;
        }

        function getProductAction() {
            return LinkageProductService.getProductAction(vm.productAction, vm.page).then(function (data) {
                if(!data.rows){
                    return;
                }
                vm.productActions = data.rows;
                vm.totalItems = data.total;
                vm.pageSize = data.rows.length;
            })
        }

        function search() {
            vm.productAction.productTypeName=$sessionStorage.scm_js_linkageProduct_ProductTypeName;
            vm.getProductAction();
        }

        function deleteProductAction(productAction) {
            SweetAlert.confirm(productAction.actionName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var productActions = new Array();
                    productActions.push(productAction.linkActionId);
                  LinkageProductService.deleteProductAction(productActions).then(function (response) {
                        if (response.success) {
                            vm.getProductAction();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }


        function deleteProductActions() {
            var isCheck = $(".chk_list").is(':checked');
            if(!isCheck) {
                SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
                return;
            }
            SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var arrChk = $("input[name='chk_list']:checked");
                    var productActions = new Array();
                    $(arrChk).each(function() {
                        productActions.push(this.value);
                    });
                  LinkageProductService.deleteProductAction(productActions).then(function (response) {
                        document.getElementById("chk_all").checked = false;
                        var items = document.getElementsByName("chk_list");
                        for(var j = 0; j < items.length; j++){
                            items[j].checked = false;
                        }
                        if (response.success) {
                            vm.getProductAction();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        //page changed
        function pageChanged() {
            angular.element("#chk_all").checked = false;
            vm.getProductAction(vm.page);
        }

        function checkProductAction() {
            var arrChk = $("input[name='chk_list']:checked");
            if(arrChk.length < vm.pageSize) {
                document.getElementById("chk_all").checked = false;
            } else if(arrChk.length === vm.pageSize) {
                document.getElementById("chk_all").checked = true;
            }
        }

        function checkAllProductAction() {
            var chk_all = $("#chk_all").is(':checked');
            var items = document.getElementsByName("chk_list");
            if(chk_all) {
                for(var i = 0; i < items.length; i++){
                    items[i].checked = true;
                }
            } else {
                for(var j = 0; j < items.length; j++){
                    items[j].checked = false;
                }
            }

        }
    }
})();


(function () {
  'use strict';

  angular.module('hmapFront')
  .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
    .state('linkageProduct', {
      parent: 'app',
      url: "/linkageProduct",
      views: {
        body: {
          templateUrl: "app/iot/portal/admin/scm/html/linkageProduct.html",
          controller: 'LinkageProductController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {}
        }
      }
    })
    .state('linkageProduct.add', {
      parent: 'linkageProduct',
      url: "/add",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: "app/iot/portal/admin/scm/html/addLinkageProduct.html",
          controller: 'AddLinkageProductController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {}
            }
          }
        }).result.then(function () {
          $state.go('linkageProduct', null, {reload: true});
        }, function () {
          $state.go('linkageProduct');
        })
      }]
    })
    .state('linkageProduct.edit', {
      parent: 'linkageProduct',
      url: '/edit/:linkProductId',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: "app/iot/portal/admin/scm/html/addLinkageProduct.html",
          controller: 'AddLinkageProductController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {linkProductId: $stateParams.linkProductId}
            }
          }
        }).result.then(function () {
          $state.go('linkageProduct', null, {reload: true});
        }, function () {
          $state.go('linkageProduct');
        })
      }]
    })

    //productAction router
    .state('productAction', {
      parent: 'app',
      url: "/productAction/:linkProductId",
      views: {
        body: {
          templateUrl: "app/iot/portal/admin/scm/html/productAction.html",
          controller: 'ProductActionController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            linkProductId: $stateParams.linkProductId,
          }
        }
      }
    })
    .state('productAction.add', {
      parent: 'productAction',
      url: "/add/:linkProductId",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: "app/iot/portal/admin/scm/html/addProductAction.html",
          controller: 'AddProductActionController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                linkProductId: $stateParams.linkProductId
              }
            }
          }
        }).result.then(function () {
          $state.go('productAction', null, {reload: true});
        }, function () {
          $state.go('productAction');
        })
      }]
    })
    .state('productAction.edit', {
      parent: 'productAction',
      url: '/edit/:linkActionId',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: "app/iot/portal/admin/scm/html/addProductAction.html",
          controller: 'AddProductActionController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {linkActionId: $stateParams.linkActionId}
            }
          }
        }).result.then(function () {
          $state.go('productAction', null, {reload: true});
        }, function () {
          $state.go('productAction');
        })
      }]
    })

    //productActionParam
    .state('productActionParams', {
      parent: 'app',
      url: '/productActionParams/:linkActionId',
      views: {
        'body': {
          templateUrl: 'app/iot/portal/admin/scm/html/productActionParams.html',
          controller: 'ProductActionParamsController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            linkActionId: $stateParams.linkActionId,
          }
        }
      }
    })
    .state('productActionParams.add', {
      parent: 'productActionParams',
      url: '/add/:linkActionId',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/scm/html/addProductActionParams.html',
          controller: 'AddProductActionParamsController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                linkActionId: $stateParams.linkActionId
              }
            }
          }
        }).result.then(function () {
          $state.go('productActionParams', null, {reload: true});
        }, function () {
          $state.go('productActionParams');
        })
      }]
    })
    .state('productActionParams.edit', {
      parent: 'productActionParams',
      url: '/edit/:linkActionParamId',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/scm/html/addProductActionParams.html',
          controller: 'AddProductActionParamsController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                linkActionParamId: $stateParams.linkActionParamId
              }
            }
          }
        }).result.then(function () {
          $state.go('productActionParams', null, {reload: true});
        }, function () {
          $state.go('productActionParams')
        })
      }]
    })
  }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
        .factory('LinkageProductService', LinkageProductService);

    LinkageProductService.$inject = ['$http'];

    function LinkageProductService($http) {
      var productTypeName = '';
      var actionName = '';
        return {
            getLinkageProduct: getLinkageProduct,
            deleteLinkageProduct: deleteLinkageProduct,
            addLinkageProduct: addLinkageProduct,
            updateLinkageProduct:updateLinkageProduct,
           // getProductType:getProductType,
            getCmdSet : getCmdSet,

          //productAction
          getProductAction: getProductAction,
          deleteProductAction: deleteProductAction,
          addProductAction: addProductAction,
          updateProductAction:updateProductAction,
          getProdcutActionInfo:getProdcutActionInfo,
          productTypeName:productTypeName,

          //productActionParams
          getProductActionParam: getProductActionParam,
          deleteProductActionParam: deleteProductActionParam,
          addProductActionParam: addProductActionParam,
          updateProductActionParam:updateProductActionParam,
          getProductActionParamInfo:getProductActionParamInfo,
          actionName:actionName
        };

        function getLinkageProduct(entity, page) {
            var resourceUrl = '/api/scm/linkProduct/query?page=' + page;
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }


        function deleteLinkageProduct(entity) {
            var resourceUrl = '/api/scm/linkProduct/delete';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function addLinkageProduct(entity) {
            var resourceUrl = '/api/scm/linkProduct/insert';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }

        function updateLinkageProduct(entity) {
            var resourceUrl = '/api/scm/linkProduct/update';
            return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
                return response.data;
            })
        }
        // function getProductType() {
        //   var resourceUrl = '/api/scm/scenarioProduct/queryProductType';
        //   return $http.get(resourceUrl, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        //     return response.data;
        //   })
        // }

      function getCmdSet(cmdSet,page,pagesize) {
        var resourceUrl = '/api/inm/commandSet/query?page='+page+'&pageSize='+pagesize;
        return $http.post(resourceUrl,cmdSet, {headers: {'Content-Type': 'application/json;charset=utf-8'}})
          .then(function (response) {
            return response.data;
          })
      }
        //prodcutAction
      function getProductAction(entity, page) {
        var resourceUrl = '/api/scm/linkAction/query?page=' + page;
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }


      function deleteProductAction(entity) {
        var resourceUrl = '/api/scm/linkAction/delete';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function addProductAction(entity) {
        var resourceUrl = '/api/scm/linkAction/insert';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function updateProductAction(entity) {
        var resourceUrl = '/api/scm/linkAction/insert';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function getProdcutActionInfo(code, dto, field) {
        var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
        return $http.get(resourceUrl, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        }).then(function (response) {
          if (response.status == "200") {
            return response.data.multiLanguages;
          }
        })
      }

      //productActionParams
      function getProductActionParam(entity, page) {
        var resourceUrl = '/api/scm/linkActionParam/query?page=' + page;
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }


      function deleteProductActionParam(entity) {
        var resourceUrl = '/api/scm/linkActionParam/delete';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function addProductActionParam(entity) {
        var resourceUrl = '/api/scm/linkActionParam/insert';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function updateProductActionParam(entity) {
        var resourceUrl = '/api/scm/linkActionParam/insert';
        return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
          return response.data;
        })
      }

      function getProductActionParamInfo(code, dto, field) {
        var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
        return $http.get(resourceUrl, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        }).then(function (response) {
          if (response.status == "200") {
            return response.data.multiLanguages;
          }
        })
      }
    }

})();

(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('LinkageProductController', LinkageProductController);

    LinkageProductController.$inject = ['$sessionStorage','LinkageProductService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

    function LinkageProductController($sessionStorage,LinkageProductService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
        var vm = this;
        vm.linkageProduct = entity;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.cmdSets = {};

        vm.checkLinkageProduct = checkLinkageProduct;
        vm.checkAllLinkageProduct = checkAllLinkageProduct;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.deleteLinkageProduct = deleteLinkageProduct;
        vm.deleteLinkageProducts = deleteLinkageProducts;
        vm.getLinkageProduct = getLinkageProduct;
        vm.getProductTypeName = getProductTypeName;
        vm.reset = reset;
        vm.search();


        function reset() {
            vm.linkageProduct.cmdSetId = undefined;
        }

        function getProductTypeName(string) {
            $sessionStorage.scm_js_linkageProduct_ProductTypeName = string;
        }

        function getLinkageProduct() {
            return LinkageProductService.getLinkageProduct(vm.linkageProduct, vm.page).then(function (data) {
                if(!data.rows){
                    return;
                }
                vm.linkageProducts = data.rows;
                vm.totalItems = data.total;
                vm.pageSize = data.rows.length;
            })
        }

        function search() {
            vm.getLinkageProduct();
            LinkageProductService.getCmdSet(vm.cmdSets,1,-1).then(function (data) {
              vm.cmdSets = data.rows;
            });
        }
        function deleteLinkageProduct(linkageProduct) {
            SweetAlert.confirm(linkageProduct.cmdSetName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var linkageProducts = [];
                    linkageProducts.push(linkageProduct.linkProductId);
                    LinkageProductService.deleteLinkageProduct(linkageProducts).then(function (response) {
                        if (response.success) {
                            vm.getLinkageProduct();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        function deleteLinkageProducts() {
            var isCheck = $(".chk_list").is(':checked');
            if(!isCheck) {
                SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
                return;
            }
            SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var arrChk = $("input[name='chk_list']:checked");
                    var linkageProducts = new Array();
                    $(arrChk).each(function() {
                        linkageProducts.push(this.value);
                    });
                    LinkageProductService.deleteLinkageProduct(linkageProducts).then(function (response) {
                        document.getElementById("chk_all").checked = false;
                        var items = document.getElementsByName("chk_list");
                        for(var j = 0; j < items.length; j++){
                            items[j].checked = false;
                        }
                        if (response.success) {
                            vm.getLinkageProduct();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        function pageChanged() {
            angular.element("#chk_all").checked = false;
            vm.getLinkageProduct(vm.page);
        }

        function checkLinkageProduct() {
            var arrChk = $("input[name='chk_list']:checked");
            if(arrChk.length < vm.pageSize) {
                document.getElementById("chk_all").checked = false;
            } else if(arrChk.length === vm.pageSize) {
                document.getElementById("chk_all").checked = true;
            }
        }

        function checkAllLinkageProduct() {
            var chk_all = $("#chk_all").is(':checked');
            var items = document.getElementsByName("chk_list");
            if(chk_all) {
                for(var i = 0; i < items.length; i++){
                    items[i].checked = true;
                }
            } else {
                for(var j = 0; j < items.length; j++){
                    items[j].checked = false;
                }
            }
        }
    }
})();


(function () {
    'use strict';

    angular.module('hmapFront')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        $stateProvider
            .state('linkageCondition', {
                parent: 'app',
                url:"/linkageCondition",
                views:{
                    body:{
                        templateUrl:"app/iot/portal/admin/scm/html/linkageCondition.html",
                        controller:'LinkageConditionController',
                        controllerAs:'vm'
                    }
                },
                resolve:{
                    entity:function () {
                        return {}
                    }
                }
            })
            .state('linkageCondition.add',{
                parent:'linkageCondition',
                url:"/add",
                onEnter:['$stateParams','$state','$uibModal',function ($stateParams,$state,$uibModal) {
                    $uibModal.open({
                        templateUrl:"app/iot/portal/admin/scm/html/addLinkageCondition.html",
                        controller:'AddLinkageConditionController',
                        controllerAs:'vm',
                        backdrop:'static',
                        size:'lg',
                        resolve:{
                            entity:function () {
                                return {}
                            }
                        }
                    }).result.then(function () {
                        $state.go('linkageCondition', null, {reload: true});
                    },function () {
                        $state.go('linkageCondition');
                    })
                }]
            })
            .state('linkageCondition.edit',{
                parent:'linkageCondition',
                url:'/edit/:linkTriggerId',
                onEnter:['$stateParams','$state','$uibModal',function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl:"app/iot/portal/admin/scm/html/addLinkageCondition.html",
                        controller:'AddLinkageConditionController',
                        controllerAs:'vm',
                        backdrop:'static',
                        size:'lg',
                        resolve:{
                            entity:function () {
                                return {linkTriggerId:$stateParams.linkTriggerId}
                            }
                        }
                    }).result.then(function () {
                        $state.go('linkageCondition', null, {reload: true});
                    },function () {
                        $state.go('linkageCondition');
                    })
                }]
            })
    }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .factory('LinkageConditionService', LinkageConditionService);

  LinkageConditionService.$inject = ['$http'];

  function LinkageConditionService($http) {
    return {
      getCmdSet: getCmdSet,
      getLinkageContidition: getLinkageContidition,
      deleteLinkageContidition: deleteLinkageContidition,
      addLinkageContidition: addLinkageContidition,
      updateLinkageContidition: updateLinkageContidition,
      getLinkageConditionInfo: getLinkageConditionInfo
    };

    function getCmdSet(cmdSet, page, pagesize) {
      var resourceUrl = '/api/inm/commandSet/query?page=' + page + '&pageSize=' + pagesize;
      return $http.post(resourceUrl, cmdSet, {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }

    function getLinkageContidition(entity, page) {
      var resourceUrl = '/api/scm/linkTrigger/query?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function deleteLinkageContidition(entity) {
      var resourceUrl = '/api/scm/linkTrigger/delete';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function addLinkageContidition(entity) {
      var resourceUrl = '/api/scm/linkTrigger/insert';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function updateLinkageContidition(entity) {
      var resourceUrl = '/api/scm/linkTrigger/insert';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function getLinkageConditionInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }

  }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('LinkageConditionController', LinkageConditionController);

    LinkageConditionController.$inject = ['LinkageConditionService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

    function LinkageConditionController(LinkageConditionService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
        var vm = this;
        vm.linkageCondition = entity;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.checkLinkageCondition = checkLinkageCondition;
        vm.checkAllLinkageCondition = checkAllLinkageCondition;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.deleteLinkageCondition = deleteLinkageCondition;
        vm.deleteLinkageConditions = deleteLinkageConditions;
        vm.getLinkageCondition = getLinkageCondition;
        vm.reset = reset;
        vm.search();

        function reset() {
          vm.linkageCondition.cmdSetId = undefined;
          vm.linkageCondition.cmdCode = undefined;
          vm.linkageCondition.triggerName = undefined;
        }

        function getLinkageCondition() {
            return LinkageConditionService.getLinkageContidition(vm.linkageCondition, vm.page).then(function (data) {
                if(!data.rows){
                    return;
                }
                vm.linkageConditions = data.rows;
                vm.totalItems = data.total;
                vm.pageSize = data.rows.length;
            })
        }

        function search() {
            vm.getLinkageCondition();
        }

        function deleteLinkageCondition(linkageCondition) {
            SweetAlert.confirm(linkageCondition.cmdSetName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var linkageConditions = new Array();
                    linkageConditions.push(linkageCondition.linkTriggerId);
                    LinkageConditionService.deleteLinkageContidition(linkageConditions).then(function (response) {
                        if (response.success) {
                            vm.getLinkageCondition();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }


        function deleteLinkageConditions() {
            var isCheck = $(".chk_list").is(':checked');
            if(!isCheck) {
                SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
                return;
            }
            SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var arrChk = $("input[name='chk_list']:checked");
                    var linkageConditions = new Array();
                    $(arrChk).each(function() {
                        linkageConditions.push(this.value);
                    });
                    LinkageConditionService.deleteLinkageContidition(linkageConditions).then(function (response) {
                        document.getElementById("chk_all").checked = false;
                        var items = document.getElementsByName("chk_list");
                        for(var j = 0; j < items.length; j++){
                            items[j].checked = false;
                        }
                        if (response.success) {
                            vm.getLinkageCondition();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        function pageChanged() {
            angular.element("#chk_all").checked = false;
            vm.getLinkageCondition(vm.page);
        }

        function checkLinkageCondition() {
            var arrChk = $("input[name='chk_list']:checked");
            if(arrChk.length < vm.pageSize) {
                document.getElementById("chk_all").checked = false;
            } else if(arrChk.length === vm.pageSize) {
                document.getElementById("chk_all").checked = true;
            }
        }

        function checkAllLinkageCondition() {
            var chk_all = $("#chk_all").is(':checked');
            var items = document.getElementsByName("chk_list");
            if(chk_all) {
                for(var i = 0; i < items.length; i++){
                    items[i].checked = true;
                }
            } else {
                for(var j = 0; j < items.length; j++){
                    items[j].checked = false;
                }
            }
        }
    }
})();


/**
 * Created by zyl on 2017/8/7.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('IntelligentLinkageSettingController', IntelligentLinkageSettingController);

  IntelligentLinkageSettingController.$inject = ['IntelligentLinkageService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService','$state'];

  function IntelligentLinkageSettingController(IntelligentLinkageService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService,$state) {
    var vm = this;
    vm.linkageSetting = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkLinkageSetting = checkLinkageSetting;
    vm.checkAllLinkageSettings = checkAllLinkageSettings;
    vm.pageChanged = pageChanged;
    vm.search = search;
    //vm.resetLinkage = resetLinkage;
    vm.deleteLinkageSetting = deleteLinkageSetting;
    vm.deleteLinkageSettings = deleteLinkageSettings;
    vm.getLinkageSettings = getLinkageSettings;
    vm.initWeidget = initWeidget;

    vm.initWeidget();
    vm.search();

    //get link
    function getLinkageSettings() {
      return IntelligentLinkageService.getLinkSettings(vm.linkageSetting, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.linkageSettings = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search link
    function search() {
      vm.getLinkageSettings();
    }

    ////reset link
    //function resetLinkage() {
    //  vm.linkageSetting.seasonScope = "";
    //  vm.linkageSetting.linkJson = "";
    //}

    //delete link
    function deleteLinkageSetting(linkage) {
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var links = new Array();
          var entity = new Object();
          entity.linkSettingId = linkage.linkSettingId;
          links.push(entity);
          IntelligentLinkageService.deleteLinkSettings(links).then(function (response) {
            if (response.success) {
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
              return $state.go('linkageSetting', {linkId:vm.linkageSetting.linkId}, {reload: true});
            }
          })
        }
      });
    }

    function initWeidget() {
      // timezones and gender
      MessageTemplateService.getByCode().query({code:'IOT.SCM_INTELLIGENT_LINKAGE_TYPE'},function (data) {
        vm.lankageType = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'IOT.SCM_INTELLIGENT_LINKAGE_SEASON'},function (data) {
        vm.lankageSeason = data.rows;
      },function (error) {
      });
    }

    //delete link
    function deleteLinkageSettings() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var links = new Array();
          $(arrChk).each(function() {
            var link = new Object();
            link.linkSettingId = this.value;
            links.push(link);
          });
          IntelligentLinkageService.deleteLinkSettings(links).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
              return $state.go('linkageSetting', {linkId:vm.linkageSetting.linkId}, {reload: true});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getLinkage();
    }

    //check or unCheck check link
    function checkLinkageSetting() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check link
    function checkAllLinkageSettings() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('linkage', {
        parent: 'app',
        url: "/linkage",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/scm/html/intelligentLinkage.html",
            controller: 'IntelligentLinkageController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
            };
          }
        }
      })
      .state('linkage.add', {
        parent: 'linkage',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/scm/html/addIntelligentLinkage.html',
            controller: 'AddIntelligentLinkageController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                }
              }
            }
          }).result.then(function () {
            $state.go('linkage', null, {reload: true});
          }, function () {
            $state.go('linkage');
          });
        }]
      })
      .state('linkage.edit', {
        parent: 'linkage',
        url: "/edit/:linkId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/scm/html/addIntelligentLinkage.html',
            controller: 'AddIntelligentLinkageController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  linkId: $stateParams.linkId
                }
              }
            }
          }).result.then(function () {
            $state.go('linkage', null, {reload: true});
          }, function () {
            $state.go('linkage');
          });
        }]
      })
      .state('linkageSetting', {
        parent: 'app',
        url: "/linkageSetting/{linkId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/scm/html/intelligentLinkageSettings.html",
            controller: 'IntelligentLinkageSettingController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',function ($stateParams) {
            return {
              linkId: $stateParams.linkId
            };
          }]
        }
      })
      .state('linkageSetting.add', {
        parent: 'app',
        url: "/addLinkSetting/{linkId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/scm/html/addIntelligentLinkageSettings.html',
            controller: 'AddIntelligentLinkageSettingController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  linkId: $stateParams.linkId
                }
              }
            }
          }).result.then(function () {
            $state.go('linkageSetting', {linkId: $stateParams.linkId}, {reload: true});
          }, function () {
            $state.go('linkageSetting',{linkId: $stateParams.linkId});
          });
        }]
      })
      .state('linkageSetting.edit', {
        parent: 'app',
        url: "/editLinkSetting/{linkId}/{linkSettingId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/scm/html/addIntelligentLinkageSettings.html',
            controller: 'AddIntelligentLinkageSettingController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  linkId: $stateParams.linkId,
                  linkSettingId:$stateParams.linkSettingId
                }
              }
            }
          }).result.then(function () {
            $state.go('linkageSetting', {linkId: $stateParams.linkId}, {reload: true});
          }, function () {
            $state.go('linkageSetting',{linkId: $stateParams.linkId});
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('IntelligentLinkageService', IntelligentLinkageService);

  IntelligentLinkageService.$inject = ['$http'];

  function IntelligentLinkageService($http) {
    return {
      getLinkage: getLinkage,
      deleteLinks: deleteLinks,
      addLink: addLink,
      updateLink:updateLink,
      getLinkInfo: getLinkInfo,
      getLinkSettings:getLinkSettings,
      addLinkSetting:addLinkSetting,
      deleteLinkSettings:deleteLinkSettings,
      updateLinkSetting:updateLinkSetting
    };

    //get link
    function getLinkage(entity, page) {
      var resourceUrl = '/api/ctm/partyLink/queryLink?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //get link
    function getLinkSettings(entity, page) {
      var resourceUrl = '/api/ctm/partyLinkSetting/queryLinkSetting?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete links
    function deleteLinks(entity) {
      var resourceUrl = '/api/ctm/partyLink/deleteLink';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //delete links
    function deleteLinkSettings(entity) {
      var resourceUrl = '/api/ctm/partyLinkSetting/deleteLinkSetting';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //add link
    function addLink(entity) {
      var resourceUrl = '/api/ctm/partyLink/insertLink';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //add link
    function addLinkSetting(entity) {
      var resourceUrl = '/api/ctm/partyLinkSetting/insertLinkSetting';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //update link
    function updateLink(entity) {
      var resourceUrl = '/api/ctm/partyLink/updateLink';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //update link
    function updateLinkSetting(entity) {
      var resourceUrl = '/api/ctm/partyLinkSetting/updateLinkSetting';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //get link locale info
    function getLinkInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('IntelligentLinkageController', IntelligentLinkageController);

  IntelligentLinkageController.$inject = ['IntelligentLinkageService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

  function IntelligentLinkageController(IntelligentLinkageService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
    var vm = this;
    vm.linkage = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkLinkage = checkLinkage;
    vm.checkAllLinkage = checkAllLinkage;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.deleteLinkage = deleteLinkage;
    vm.deleteLinkages = deleteLinkages;
    vm.getLinkage = getLinkage;
    vm.initWeidget = initWeidget;

    vm.initWeidget();
    vm.search();

    //get link
    function getLinkage() {
      return IntelligentLinkageService.getLinkage(vm.linkage, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.linkages = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search link
    function search() {
      vm.getLinkage();
    }

    //delete link
    function deleteLinkage(linkage) {
      SweetAlert.confirm(linkage.linkName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var links = new Array();
          var entity = new Object();
          entity.linkId = linkage.linkId;
          links.push(entity);
          IntelligentLinkageService.deleteLinks(links).then(function (response) {
            if (response.success) {
              vm.getLinkage();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    function initWeidget() {
      // timezones and gender
      MessageTemplateService.getByCode().query({code:'IOT.SCM_INTELLIGENT_LINKAGE_TYPE'},function (data) {
        vm.lankageType = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'IOT.SCM_INTELLIGENT_LINKAGE_SEASON'},function (data) {
        vm.lankageSeason = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'IOT.SCM_LINK_IDENTITY'},function (data) {
        vm.linkIdentitys = data.rows;
      },function (error) {
      });
    }

    //delete link
    function deleteLinkages() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var links = new Array();
          $(arrChk).each(function() {
            var link = new Object();
            link.linkId = this.value;
            links.push(link);
          });
          IntelligentLinkageService.deleteLinks(links).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getLinkage();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getLinkage();
    }

    //check or unCheck check link
    function checkLinkage() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check link
    function checkAllLinkage() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('CusromizeOneTouchSceneDialogController', Controller);

  Controller.$inject = ['$sessionStorage', 'CusromizeOneTouchSceneService', 'paginationConstants', 'SweetAlert', '$filter', '$state', 'CommandMaintenanceService', '$uibModalInstance', 'PromptService', 'toastr', 'entity', '$localStorage','Upload','BaseConfig','MessageTemplateService','toastrConfig'];

  function Controller($sessionStorage, CusromizeOneTouchSceneService, paginationConstants, SweetAlert, $filter, $state, CommandMaintenanceService, $uibModalInstance, PromptService, toastr, entity, $localStorage, Upload, BaseConfig, MessageTemplateService,toastrConfig) {
    var vm = this;
    vm.unifiedStructureProduct = entity;

    vm.submit = submit;
    vm.init = init;
    vm.selectCmdSet = selectCmdSet;
    vm.showDescription = showDescription;
    vm.localeSureDescription = localeSureDescription;
    vm.clear = clear;
    vm.initLangs = initLangs;
    vm.typeChange = typeChange;


    vm.init();
    vm.selectCmdSet();
    vm.initLangs();

    /**
     * 图片上传
     */
    vm.uploadImg = '';
    vm.varMay = true;
    vm.imgShow = true;
    vm.oldFile = "assets/images/logo-header.png";
    vm.file = "";
    vm.submitFile = submitFile;
    vm.changeFile = changeFile;
    vm.setFile = setFile;

    function submitFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
      if (vm.file == "assets/images/logo-header.png") {
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"));
        return;
      }
      upload(vm.file);
    }

    function changeFile() {
      if (vm.file) {
        vm.varMay = true;
        vm.oldFile = vm.file
      }
    }

    function setFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
    }

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data) {
        //upload success
        vm.unifiedStructureProduct.attribute4 = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
        } else {
          vm.varMay = true;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
        toastr.error($filter('T')("uploadImg.uploadFail"));
      });
    }

    function typeChange() {
      if (vm.unifiedStructureProduct.type === "CUSTOM_WAKE_UP"){
        vm.imgShow = false;
      }else{
        vm.imgShow = true;
      }
    }
    function selectCmdSet() {
      CommandMaintenanceService.getCommandSet({}, 1, -1).then(function (data) {
        vm.cmdSets = data.rows;
      })
    }

    function init() {
      MessageTemplateService.getByCode().query({code:'SYS.CUSROMIZE_ONE_TOUCH_SCENE'},function (data) {
        vm.types = data.rows;
      },function (error) {
      });
      if (vm.unifiedStructureProduct.id) {
        CusromizeOneTouchSceneService.query(vm.unifiedStructureProduct, 1, 1)
        .then(function (data) {
          vm.unifiedStructureProduct = data.rows[0];
          if (data.rows[0].attribute4 !== '' &&
            data.rows[0].attribute4 !== null &&
            data.rows[0].attribute4 !== undefined){
            vm.oldFile = vm.unifiedStructureProduct.attribute4;
          }
          CusromizeOneTouchSceneService.getUSProductLocaleInfo(vm.unifiedStructureProduct.id, 'com.iot.portal.admin.scm.dto.ScmUnifiedStructureProductDTO',  angular.element("#localeBtn_description").val())
          .then(function (res) {
            var __tls = {};
            var description = {};
            for (var i in res) {
              description[res[i].langCode] = res[i].value;
            }
            __tls[angular.element("#localeBtn_description").val()] = description;
            vm.unifiedStructureProduct.__tls = __tls;
            angular.element('#localBtn_decription').attr('disabled', false);
          })
        })
      }
    }

    function submit() {
      if (vm.unifiedStructureProduct.id) {
        update();
      } else {
        add();
      }
    }

    function update() {
      CusromizeOneTouchSceneService.update(vm.unifiedStructureProduct)
      .then(function (data) {
        if (data.success) {
          toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          $uibModalInstance.close();
          $state.go('unifiedStructureProduct', null, {reload: 'unifiedStructureProduct'});
        } else {
          SweetAlert.error($filter('T')("title.failed"), {title: $filter('T')("btnTypeName.prompt")})
          .then(function () {
              $uibModalInstance.close();
              $state.go('unifiedStructureProduct', null, {reload: 'unifiedStructureProduct'});
            }
          )
        }
      })
    }

    function add() {
      CusromizeOneTouchSceneService.add(vm.unifiedStructureProduct)
      .then(function (data) {
        if (data.success) {
          toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          $uibModalInstance.close();
          $state.go('cusromizeOneTouchScene', null, {reload: 'unifiedStructureProduct'});
        } else {
          toastr.err($filter('T')("title.failed"), $filter('T')("title.confirmTitle"));
          $uibModalInstance.close();
          $state.go('cusromizeOneTouchScene', null, {reload: 'unifiedStructureProduct'});
        }
      })
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        angular.element("#localeBtn_description").attr("disabled", false);
      });
    }

    function showDescription() {
      angular.element("#localeModal_description").modal("show");
      if (angular.element("#localeModalBody_description").html().trim() === "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = angular.element("<div class ='form-group'></div>");
            div.append("<lable class = 'control-label'>" + langs[i].description + "</lable>");
            div.append("<input type = 'text' class = 'form-control' name = '" + langs[i].langCode + "description' ng-model='vm.unifiedStructureProduct.__tls.description." + langs[i].langCode + "'/>");
            angular.element("#localeModalBody_description").append(div);
            if (vm.unifiedStructureProduct.id) {
              angular.element("input[name='" + langs[i].langCode + "description']").val(vm.unifiedStructureProduct.__tls[angular.element("#localeBtn_description").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function localeSureDescription() {
      var __tls = vm.unifiedStructureProduct.__tls || {};
      var description = {};

      for (var i in langs) {
        description[langs[i].langCode] = angular.element("input[name = '" + langs[i].langCode + "description']").val();
      }

      var btnValue = angular.element("#localeBtn_description").val();
      vm.unifiedStructureProduct[btnValue] = angular.element("input[name='" + (window.localStorage.lang || 'en_GB') + "description']").val();
      angular.element("#localeModal_description").modal("hide");
      __tls[btnValue] = description;
      vm.unifiedStructureProduct.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }

})();

(function () {
  'use strict';

  angular.module('hmapFront').config(config);

  function config($stateProvider) {
    $stateProvider.state('cusromizeOneTouchScene', {
      parent: 'app',
      url: '/cusromizeOneTouchScene',
      views: {
        'body': {
          templateUrl: 'app/iot/portal/admin/scm/html/cusromizeOneTouchScene.html',
          controller: 'CusromizeOneTouchSceneController',
          controllerAs: 'vm'
        }
      }
    })
    .state('cusromizeOneTouchScene.add', {
      parent: 'cusromizeOneTouchScene',
      url: '/add',
      onEnter: ['$uibModal', '$state', function ($uibModal, $state) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/scm/html/cusromizeOneTouchScene-dialog.html',
          controller: 'CusromizeOneTouchSceneDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {}
            }
          }
        }).result.then(function () {
          $state.go('cusromizeOneTouchScene', null, {reload: true})
        }, function () {
          $state.go('cusromizeOneTouchScene', null, {reload: true})
        })
      }]
    })
    .state('cusromizeOneTouchScene.edit', {
      parent: 'cusromizeOneTouchScene',
      url: '/edit/:id',
      onEnter: ['$uibModal', '$stateParams', '$state', function ($uibModal, $stateParams, $state) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/scm/html/cusromizeOneTouchScene-dialog.html',
          controller: 'CusromizeOneTouchSceneDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                id: $stateParams.id
              }
            }
          }
        }).result.then(function () {
          $state.go('cusromizeOneTouchScene', null, {reload: true})
        }, function () {
          $state.go('cusromizeOneTouchScene', null, {reload: true})
        })
      }]
    })
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').factory('CusromizeOneTouchSceneService', service);

  service.$inject = ['$http'];

  function service($http) {
    return {
      query: query,
      add: add,
      update: update,
      deleteAll: deleteAll,
      getUSProductLocaleInfo: getUSProductLocaleInfo,
      queryByType: queryByType
    };

    function query(body, page, pageSize) {
      var resourceUrl = '/api/scm/usp/query?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }

    function queryByType(body, page, pageSize) {
      var resourceUrl = '/api/scm/usp/queryByType?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }

    function add(body) {
      var resourceUrl = '/api/scm/usp/add';
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }

    function update(body) {
      var resourceUrl = '/api/scm/usp/update';
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }


    function deleteAll(body) {
      var resourceUrl = '/api/scm/usp/remove';
      return $http.post(resourceUrl, body, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }

    //get unifiedStructureProduct locale info
    function getUSProductLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('CusromizeOneTouchSceneController', CusromizeOneTouchSceneController);

  CusromizeOneTouchSceneController.$inject = ['$sessionStorage', 'CusromizeOneTouchSceneService', 'paginationConstants',
    'SweetAlert', '$filter', 'CommandMaintenanceService','MessageTemplateService'];

  function CusromizeOneTouchSceneController($sessionStorage, CusromizeOneTouchSceneService, paginationConstants,
                                             SweetAlert, $filter, CommandMaintenanceService,MessageTemplateService) {
    var vm = this;
    vm.unifiedStructureProduct = {};
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.cmdSets = [];
    vm.unifiedStructureProduct.type = "CUSTOM";


    vm.checkUnifiedStruectureProduct = checkUnifiedStruectureProduct;
    vm.checkAll = checkAll;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.deleteOne = deleteOne;
    vm.deleteSelects = deleteSelects;
    vm.reset = reset;
    vm.selectCmdSet = selectCmdSet;

    vm.search();
    vm.selectCmdSet();


    function reset() {
      vm.unifiedStructureProduct.type = "CUSTOM";
      vm.unifiedStructureProduct.objectId = undefined;
    }

    function search() {
      getTypee();
      /*if (vm.unifiedStructureProduct && (vm.unifiedStructureProduct.type || "") === "") {
        delete vm.unifiedStructureProduct.type;
      }*/
      if (vm.unifiedStructureProduct.type === null || vm.unifiedStructureProduct.type === ""){
        vm.unifiedStructureProduct.type = "CUSTOM"
      }
      if(vm.unifiedStructureProduct.objectId == ""){
        vm.unifiedStructureProduct.objectId = undefined;
      }
      if (vm.unifiedStructureProduct.type === "CUSTOM"){
        return CusromizeOneTouchSceneService.queryByType(vm.unifiedStructureProduct, vm.page, vm.itemsPerPage).then(function (data) {
          if (!data.rows) {
            return;
          }
          vm.unifiedStructureProducts = data.rows;
          vm.totalItems = data.total;
          vm.pageSize = data.rows.length;
        })
      }else{
        return CusromizeOneTouchSceneService.query(vm.unifiedStructureProduct, vm.page, vm.itemsPerPage).then(function (data) {
          if (!data.rows) {
            return;
          }
          vm.unifiedStructureProducts = data.rows;
          vm.totalItems = data.total;
          vm.pageSize = data.rows.length;
        })
      }
    }

    function deleteOne(unifiedStructureProduct) {
      SweetAlert.confirm(unifiedStructureProduct.type + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          var products = [];
          products.push(unifiedStructureProduct);
          CusromizeOneTouchSceneService.deleteAll(products).then(function (response) {
            if (response.success) {
              vm.search();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    function deleteSelects() {
      var isCheck = angular.element(".chk_list").is(':checked');
      if (!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          var arrChk = angular.element("input[name='chk_list']:checked");
          var usps = [];
          angular.element(arrChk).each(function (item, value) {
            var usp = {};
            usp.id = value.defaultValue;
            usps.push(usp);
          });
          UnifiedStructureProductService.deleteAll(usps).then(function (response) {
            angular.element("chk_all").checked = false;
            var items = angular.element("chk_list");
            for (var j = 0; j < items.length; j++) {
              items[j].checked = false;
            }
            if (response.success) {
              vm.search();
              debugger;
              angular.element(".chk_list").attr('checked', false);
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")}).then(vm.search);
            }
          })
        }
      });
    }

    function selectCmdSet() {
      CommandMaintenanceService.getCommandSet({}, 1, -1).then(function (data) {
        vm.cmdSets = data.rows;
      })
    }

    function pageChanged() {
      angular.element('#chk_all').checked = false;
      vm.search();
    }

    function checkUnifiedStruectureProduct() {
      var arrChk = angular.element("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        angular.element("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        angular.element("chk_all").checked = true;
      }
    }

    function checkAll() {
      var chk_all = angular.element("#chk_all").is(':checked');
      var items = angular.element(".chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    function getTypee() {
      MessageTemplateService.getByCode().query({code: 'SYS.CUSROMIZE_ONE_TOUCH_SCENE'}, function (data) {
        vm.types = data.rows;
      }, function (error) {
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddSmallPartsFunctionController', AddSmallPartsFunctionController);

  AddSmallPartsFunctionController.$inject = ['SmallPartsService', '$state', '$uibModalInstance', 'toastr',
    'entity', 'PromptService', '$filter', 'toastrConfig', '$localStorage', '$sessionStorage', 'Upload', 'BaseConfig'];

  function AddSmallPartsFunctionController(SmallPartsService, $state, $uibModalInstance,
                                           toastr, entity, PromptService, $filter, toastrConfig, $localStorage, $sessionStorage, Upload, BaseConfig) {
    var vm = this;
    vm.smallPartFunction = entity;
    vm.clear = clear;
    vm.saveFunction = saveFunction;
    vm.showFunctionName = showFunctionName;
    vm.localeSureFunctionName = localeSureFunctionName;
    vm.load = load;
    vm.edit = false;
    vm.judgeEditOrCreate = judgeEditOrCreate;
    vm.judgeEditOrCreate();
    vm.load();


    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    vm.oldFile = "assets/images/logo-header.png";
    vm.file = "";
    vm.imageRequired = true;
    vm.submitFile = submitFile;
    vm.changeFile = changeFile;
    vm.setFile = setFile;

    function judgeEditOrCreate() {
      if (entity.hasOwnProperty('widgetFunctionId')) {
        vm.edit = true;
      }
    }

    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn_functionName").attr("disabled", false);
      });
    }

    initLangs();

    function load() {


      if (vm.edit) {
        SmallPartsService.getSmallPartFunction(vm.smallPartFunction, 1).then(function (result) {
          vm.smallPartFunction = result.rows[0];
          if (vm.smallPartFunction.imageUrl != null) {
            vm.oldFile = vm.smallPartFunction.imageUrl;
          }
          if (vm.smallPartFunction.imageUrl != null) {
            vm.imageRequired = false;
            vm.varMay = false;
          }
          SmallPartsService.getSmallPartInfo(vm.smallPartFunction.widgetFunctionId, 'com.iot.portal.admin.sys.widget.dto.SysWidgetFunctionDTO', $("#localeBtn_functionName").val())
            .then(function (data) {
              var __tls = {};
              var name = {};
              for (var i in data) {
                name[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn_functionName").val()] = name;
              vm.smallPartFunction.__tls = __tls;
              $("#localeBtn_functionName").attr("disabled", false);
            })
        })
      }
    }

    function saveFunction() {
      /*if ('' !== vm.smallPartFunction.json && undefined !== vm.smallPartFunction.json) {
        if (!isJSON(vm.smallPartFunction.json)) {
          toastr.error($filter('T')("dvmProduct.checkJsonFormat"), $filter('T')("dvmProduct.invalidJson"));
          return;
        }
      }*/
      vm.uploadImg = vm.uploadImg ? vm.uploadImg : vm.smallPartFunction.imageUrl;

      if (vm.uploadImg && vm.uploadImg.rows) {
        vm.smallPartFunction.imageUrl = vm.uploadImg.rows[0].objectUrl;
      }
      if (!vm.edit) {
        return SmallPartsService.addSmallPartFunction(vm.smallPartFunction).then(function (data) {
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('smallPartFunction', null, {reload: true});
          }
        });
      } else {
        return SmallPartsService.updateSmallPartFunction(vm.smallPartFunction).then(function (data) {
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('smallPartFunction', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function submitFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
      if (vm.file == "assets/images/logo-header.png") {
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"));
        return;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    }

    function changeFile() {
      vm.size = vm.file.size / 1024 /1024;
     if (vm.size > 5){
       toastr.error($filter('T')("uploadImg.uploadMaxSize"));
     }
      if (vm.file) {
        vm.varMay = true;
        vm.oldFile = vm.file
      }
    }

    function setFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
    }

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //upload success
        vm.smallPartFunction.imageUrl = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
        } else {
          vm.varMay = true;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
      });
    }

    function showFunctionName() {
      $("#localeModal_functionName").modal("show");
      if ($.trim($("#localeModelBody_functionName").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "functionName' ng-model='vm.smallPartFunction.__tls." + $("#localeBtn_functionName").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_functionName").append(div);
            if (vm.smallPartFunction.widgetFunctionId) {
              $("input[name='" + langs[i].langCode + "functionName']").val(vm.smallPartFunction.__tls[$("#localeBtn_functionName").val()][langs[i].langCode]);
            }
          }
        }
      }
    }


    function localeSureFunctionName() {
      var __tls = vm.smallPartFunction.__tls || {};
      var functionName = {};
      for (var i in langs) {
        functionName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "functionName']").val();
      }
      var btnValue = $("#localeBtn_functionName").val();
      vm.smallPartFunction[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "functionName']").val();
      $("#localeModal_functionName").modal("hide");
      __tls[btnValue] = functionName;
      vm.smallPartFunction.__tls = __tls;

    }
   /* function isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
      console.log('It is not a string!')
    }*/

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
    .controller('AddSmallPartsController', AddSmallPartsController);

    AddSmallPartsController.$inject = ['SmallPartsService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', '$filter', 'toastrConfig', '$localStorage', '$sessionStorage', 'Upload', 'BaseConfig'];

    function AddSmallPartsController(SmallPartsService, $state, $uibModalInstance, toastr, entity, PromptService, $filter, toastrConfig, $localStorage, $sessionStorage, Upload, BaseConfig) {
        var vm = this;
        vm.smallPart = entity;
        vm.clear = clear;
        vm.save = save;
        vm.showSmallPartName = showSmallPartName;
        vm.localeSureSmallPartName = localeSureSmallPartName;
        vm.load = load;
        vm.edit = false;
        vm.judgeEditOrCreate = judgeEditOrCreate;
        vm.judgeEditOrCreate();
        vm.load();


        //图片上传
        /* vm.uploadImg = '';
         vm.varMay = true;
         vm.varMays = false;
         vm.imgShow = false;
         vm.oldFile="assets/images/logo-header.png";
         vm.file = "";
         vm.imageRequired = true;
         vm.submitFile = submitFile;
         vm.changeFile = changeFile;
         vm.setFile = setFile;*/

        function judgeEditOrCreate() {
            if (entity.hasOwnProperty('widgetId')) {
                vm.edit = true;
            }
        }

        var langs = [];

        function initLangs() {
            PromptService.selectLang().query(function (data) {
                langs = data.rows;
                $("#localeBtn_widgetName").attr("disabled", false);
            });
        }

        initLangs();

        function load() {
            SmallPartsService.getCommandSets(1, -1).then(function (data) {
                if (!data) {
                    return;
                }
                vm.cmdSetNames = data.rows;
            });
            if (vm.edit) {
                SmallPartsService.getSmallPart(vm.smallPart, 1).then(function (result) {
                    vm.smallPart = result.rows[0];
                    if (vm.smallPart.imageUrl != null) {
                        vm.oldFile = vm.smallPart.imageUrl;
                    }
                    if (vm.smallPart.imageUrl != null) {
                        vm.imageRequired = false;
                        vm.varMay = false;
                    }
                    SmallPartsService.getSmallPartInfo(vm.smallPart.widgetId, 'com.iot.portal.admin.dvm.dto.DvmWidgetDTO', $("#localeBtn_widgetName").val())
                    .then(function (data) {
                        var __tls = {};
                        var name = {};
                        for (var i in data) {
                            name[data[i].langCode] = data[i].value;
                        }
                        __tls[$("#localeBtn_widgetName").val()] = name;
                        vm.smallPart.__tls = __tls;
                        $("#localeBtn_widgetName").attr("disabled", false);
                    })
                })
            }
        }

        function save() {
            /* vm.uploadImg = vm.uploadImg ? vm.uploadImg : vm.smallPart.imageUrl;

             if(vm.uploadImg && vm.uploadImg.rows){
                 vm.smallPart.imageUrl = vm.uploadImg.rows[0].objectUrl;
             }*/


            if (!vm.edit) {
                return SmallPartsService.addSmallPart(vm.smallPart).then(function (data) {
                    if (data.code == 'repeat') {
                        toastr.warning($filter('T')('distribution.repeatNot'));
                        return;
                    }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('smallPart', null, {reload: true});
                    }
                });
            } else {
                return SmallPartsService.updateSmallPart(vm.smallPart).then(function (data) {
                    if (data.code == 'repeat') {
                        toastr.warning($filter('T')('distribution.repeatNot'));
                        return;
                    }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('smallPart', null, {reload: true});
                    }
                });
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        /* function submitFile() {
             if(vm.oldFile!="assets/images/logo-header.png"){
                 vm.file=vm.oldFile;
             }
             if(vm.file=="assets/images/logo-header.png"){
                 toastr.error($filter('T')("uploadImg.pleaseUploadImg"));
                 return;
             }
             upload(vm.file);
             if (vm.file != null && vm.file != undefined && vm.file != "") {
                 vm.imgShow = true;
             } else {
                 vm.imgShow = false;
             }
         }

         function changeFile() {
             if(vm.file){
                 vm.varMay = true;
                 vm.oldFile=vm.file
             }
         }

         function setFile(){
             if(vm.oldFile!="assets/images/logo-header.png"){
                 vm.file=vm.oldFile;
             }
         }

         function upload(file) {
             vm.fileInfo = file;
             var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
             Upload.upload({
                 url: BaseConfig.url + '/api/menu/imageUpload',
                 headers: {
                     'Authorization': 'Bearer ' + token.access_token,
                     'X-Requested-With':'XMLHttpRequest'
                 },
                 //upload file
                 data: {file: file}
             }).progress(function (evt) {
                 //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
             }).success(function (data, status, headers, config) {
                 //upload success
                 vm.smallPart.imageUrl = data.rows[0].objectUrl;
                 if (data.rows.length > 0) {
                     vm.varMay = false;
                 } else {
                     vm.varMay = true;
                 }
                 vm.uploadImg = data;
                 toastr.success($filter('T')("uploadImg.uploadSuccess"));
             }).error(function (data, status, headers, config) {
             });
         }*/

        function showSmallPartName() {
            $("#localeModal_widgetName").modal("show");
            if ($.trim($("#localeModelBody_widgetName").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode
                            + "widgetName' ng-model='vm.smallPart.__tls." + $("#localeBtn_widgetName").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_widgetName").append(div);
                        if (vm.smallPart.widgetId) {
                            $("input[name='" + langs[i].langCode + "widgetName']").val(vm.smallPart.__tls[$("#localeBtn_widgetName").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }


        function localeSureSmallPartName() {
            var __tls = vm.smallPart.__tls || {};
            var widgetName = {};
            for (var i in langs) {
                widgetName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "widgetName']").val();
            }
            var btnValue = $("#localeBtn_widgetName").val();
            vm.smallPart[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "widgetName']").val();
            $("#localeModal_widgetName").modal("hide");
            __tls[btnValue] = widgetName;
            vm.smallPart.__tls = __tls;
        }


        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 3,
            newestOnTop: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('AddSceneProductController', AddSceneProductController);

    AddSceneProductController.$inject = ['toastr','SceneProductService', '$state', '$uibModalInstance', 'SweetAlert',
        'entity', 'PromptService', '$filter','toastrConfig'];

    function AddSceneProductController(toastr,SceneProductService, $state, $uibModalInstance, SweetAlert,
                                       entity, PromptService, $filter,toastrConfig) {
        var vm = this;
        vm.sceneProduct = entity;
        vm.cmdSets ={};
        vm.edit = false;
        vm.saveSceneProduct = saveSceneProduct;
        vm.clear = clear;
        vm.load = load;
        vm.judgeEditOrCreate = judgeEditOrCreate;
        vm.judgeEditOrCreate();
        vm.load();

        function judgeEditOrCreate() {
            if (entity.hasOwnProperty('scenarioProductId')) {
                vm.edit = true;
            }
        }

        function load() {
            SceneProductService.getSceneName().then(function (data) {
                vm.menus = data.rows;
            });
            SceneProductService.getCmdSet(vm.cmdSets ,1,-1).then(function (data) {
              vm.cmdSets = data.rows;
            });
            if (vm.edit) {
                SceneProductService.getSceneProduct(vm.sceneProduct, 1).then(function (data) {
                    if (!data) {
                        toastr.error($filter('T')("alert.noData"));
                        window.history.go(-1);
                    }
                    vm.sceneProduct.menuId = data.rows[0].menuId;
                    vm.sceneProduct.cmdSetId =data.rows[0].cmdSetId;
                })
            }
        }

        function saveSceneProduct() {
                 SceneProductService.addSceneProduct(vm.sceneProduct).then(function (data) {
                    if (data.code == 'repeat') {
                        toastr.warning($filter('T')('distribution.repeatNot'));
                        return;
                    }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('sceneProduct', null, {reload: true});
                    }
                })
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

      angular.extend(toastrConfig, {
        autoDismiss: false,
        containerId: 'toast-container',
        maxOpened: 3,
        newestOnTop: true,
        positionClass: 'toast-top-right',
        preventDuplicates: false,
        preventOpenDuplicates: true,
        target: 'body'
      });

    }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('AddProductActionParamsController', AddProductActionParamsController);

    AddProductActionParamsController.$inject = ['LinkageProductService', '$state', '$uibModalInstance', 'SweetAlert',
        'entity', 'PromptService', '$filter', 'toastr', 'toastrConfig'];

    function AddProductActionParamsController(LinkageProductService, $state, $uibModalInstance, SweetAlert,
                                              entity, PromptService, $filter, toastr, toastrConfig) {
        var vm = this;
        vm.actionParam = entity;

        vm.saveactionParams = saveactionParams;
        vm.showParamName = showActionParamName;
        vm.showParamDesc = showActionParamDesc;
       /* vm.showParamValue = showActionParamValue;
        vm.showParamDefaultValue = showActionParamDefaultValue;*/
        vm.localeSureActionParamName = localeSureActionParamName;
        vm.localeSureActionParamDesc = localeSureActionParamDesc;
       /* vm.localeSureActionParamValue = localeSureActionParamValue;
        vm.localeSureDefaultValue = localeSureParamDefaultValue;*/
        vm.clear = clear;
        vm.load = load;
        vm.paramType = [{name:'枚举',value:'1'},{name:'数值范围',value:'0'}];
        vm.edit = false;
        vm.judgeCreateOrEdit = judgeCreateOrEdit;
        vm.judgeCreateOrEdit();
        vm.load();

        function judgeCreateOrEdit() {
            if (entity.hasOwnProperty('linkActionParamId')) {
                vm.edit = true;
            }
        }

        var langs = [];

        function initLangs() {
            PromptService.selectLang().query(function (data) {
                langs = data.rows;
                $("#localBtn_paramName").attr("disabled", false);
                $("#localBtn_paramDesc").attr("disabled", false);
            });
        }

        initLangs();

        function load() {
            if (vm.edit) {
              LinkageProductService.getProductActionParam(vm.actionParam, 1).then(function (data) {
                    if (!data) {
                        toastr.error($filter('T')("alert.noData"));
                        window.history.go(-1);
                        return
                    }
                    vm.actionParam = data.rows[0];
                LinkageProductService.getProductActionParamInfo(vm.actionParam.linkActionParamId, 'com.iot.portal.admin.scm.dto.LinkActionParamDTO', $("#localBtn_paramDesc").val())
                        .then(function (data) {
                            var __tls = {};
                            var description = {};
                            for (var i in data) {
                                description[data[i].langCode] = data[i].value;
                            }
                            __tls[$("#localBtn_paramDesc").val()] = description;
                          LinkageProductService.getProductActionParamInfo(vm.actionParam.linkActionParamId, 'com.iot.portal.admin.scm.dto.LinkActionParamDTO', $("#localBtn_paramName").val())
                                .then(function (data) {
                                    var actionParamName = {};
                                    for (var i in data) {
                                        actionParamName[data[i].langCode] = data[i].value;
                                    }
                                    __tls[$("#localBtn_paramName").val()] = actionParamName;
                                    vm.actionParam.__tls = __tls;
                                    $("#localBtn_paramDesc").attr("disabled", false);
                                    $("#localBtn_paramName").attr("disabled", false);
                                })

                        })

                })
            }
        }

        function saveactionParams() {
            if (vm.edit) {
                return LinkageProductService.updateProductActionParam(vm.actionParam).then(function (data) {
                  if (data.code == 'repeat') {
                    toastr.warning($filter('T')('distribution.repeatNot'));
                    return;
                  }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('actionParams', {linkActionId: vm.actionParam.linkActionId}, {reload: true});
                    }
                })
            }
            else {
                return LinkageProductService.addProductActionParam(vm.actionParam).then(function (data) {
                  if (data.code == 'repeat') {
                    toastr.warning($filter('T')('distribution.repeatNot'));
                    return;
                  }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('actionParams', {linkActionId: vm.actionParam.linkActionId}, {reload: true});
                    }
                })
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function showActionParamName() {
            $("#localeModal_actionParamName").modal("show");
            if ($.trim($("#localeModelBody_actionParamName").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode
                            + "paramName' ng-model='vm.actionParam.__tls." + $("#localBtn_paramName").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionParamName").append(div);
                        if (vm.actionParam.linkActionParamId) {
                            $("input[name='" + langs[i].langCode + "paramName']").val(vm.actionParam.__tls[$("#localBtn_paramName").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }

        function showActionParamDesc() {
            $("#localeModal_actionParamDesc").modal("show");
            if ($.trim($("#localeModelBody_actionParamDesc").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode
                            + "Description' ng-model='vm.actionParam.__tls." + $("#localBtn_paramDesc").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionParamDesc").append(div);
                        if (vm.actionParam.linkActionParamId) {
                            $("input[name='" + langs[i].langCode + "Description']").val(vm.actionParam.__tls[$("#localBtn_paramDesc").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }

        /*function showActionParamValue() {
            $("#localeModal_actionParamValue").modal("show");
            if($.trim($("#localeModelBody_actionParamValue").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode
                            + "ParamRange' ng-model='vm.actionParam.__tls." + $("#localBtn_paramValue").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionParamValue").append(div);
                        if(vm.actionParam.actionParamId) {
                            $("input[name='" + langs[i].langCode + "ParamRange']").val(vm.actionParam.__tls[$("#localBtn_paramValue").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }
*/

        /*function showActionParamDefaultValue() {
            $("#localeModal_actionParamDefaultValue").modal("show");
            if($.trim($("#localeModelBody_actionParamDefaultValue").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode
                            + "DefaultValue' ng-model='vm.actionParam.__tls." + $("#localBtn_paramDefaultValue").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionParamDefaultValue").append(div);
                        if(vm.actionParam.actionParamId) {
                            $("input[name='" + langs[i].langCode + "DefaultValue']").val(vm.actionParam.__tls[$("#localBtn_paramDefaultValue").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }*/

        function localeSureActionParamName() {
            var __tls = vm.actionParam.__tls || {};
            var paramName = {};
            for (var i in langs) {
                paramName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "paramName']").val();
            }
            var btnValue = $("#localBtn_paramName").val();
            vm.actionParam[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "paramName']").val();
            $("#localeModal_actionParamName").modal("hide");
            __tls[btnValue] = paramName;
            vm.actionParam.__tls = __tls;
        }

        function localeSureActionParamDesc() {
            var __tls = vm.actionParam.__tls || {};
            var description = {};
            for (var i in langs) {
                description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Description']").val();
            }
            var btnValue = $("#localBtn_paramDesc").val();
            vm.actionParam[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Description']").val();
            $("#localeModal_actionParamDesc").modal("hide");
            __tls[btnValue] = description;
            vm.actionParam.__tls = __tls;
        }

        /*function localeSureActionParamValue() {
            var __tls = vm.actionParam.__tls || {};
            var ParamRange = {};
            for (var i in langs) {
              ParamRange[langs[i].langCode] = $("input[name='" + langs[i].langCode + "ParamRange']").val();
            }
            var btnValue = $("#localBtn_paramValue").val();
            vm.actionParam[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "ParamRange']").val();
            $("#localeModal_actionParamValue").modal("hide");
            __tls[btnValue] = ParamRange;
            vm.actionParam.__tls = __tls;
        }*/

        /*function localeSureParamDefaultValue() {
            var __tls = vm.actionParam.__tls || {};
            var defaultValue = {};
            for (var i in langs) {
              defaultValue[langs[i].langCode] = $("input[name='" + langs[i].langCode + "DefaultValue']").val();
            }
            var btnValue = $("#localBtn_paramDefaultValue").val();
            vm.actionParam[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "DefaultValue']").val();
            $("#localeModal_actionParamDefaultValue").modal("hide");
            __tls[btnValue] = defaultValue;
            vm.actionParam.__tls = __tls;
        }*/

        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 3,
            newestOnTop: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    }
})();


(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('AddProductActionController', AddProductActionController);

    AddProductActionController.$inject = ['LinkageProductService', '$state', '$uibModalInstance', 'toastr',
        'entity', 'PromptService', '$filter', 'toastrConfig'];

    function AddProductActionController(LinkageProductService, $state, $uibModalInstance,
                                       toastr, entity, PromptService, $filter, toastrConfig) {
        var vm = this;
        vm.productAction = entity;

        vm.saveProductAction= saveProductAction;
        vm.showProductActionName = showProductActionName;
        vm.showProductActionDesc=showProductActionDesc;
        vm.localeSureProductActionName=localeSureProductActionName;
        vm.localeSureProductActionDesc=localeSureProductActionDesc;
        vm.clear = clear;
        vm.load = load;
        vm.edit = false;
        vm.judgeEditOrCreate = judgeEditOrCreate;
        vm.judgeEditOrCreate();
        vm.load();

        function judgeEditOrCreate() {
            if(entity.hasOwnProperty('linkActionId')){
                vm.edit = true;
            }
        }

        var langs = [];
        function initLangs() {
            PromptService.selectLang().query(function(data) {
                langs = data.rows;
                $("#localeBtn_productActionName").attr("disabled", false);
                $("#localeBtn_productActionDesc").attr("disabled", false);
            });
        }

        initLangs();

        function load() {
            if (vm.edit) {
              LinkageProductService.getProductAction(vm.productAction,1).then(function (data) {
                    if (!data) {
                        toastr.error($filter('T')("alert.noData"));
                        window.history.go(-1);
                        return
                    }
                    vm.productAction=data.rows[0];
                LinkageProductService.getProdcutActionInfo(vm.productAction.linkActionId, 'com.iot.portal.admin.scm.dto.LinkActionDTO', $("#localeBtn_productActionDesc").val()).then(
                        function (data) {
                            var __tls = {};
                            var description = {};
                            for (var i in data) {
                                description[data[i].langCode] = data[i].value;
                            }
                            __tls[$("#localeBtn_productActionDesc").val()] = description;
                          LinkageProductService.getProdcutActionInfo(vm.productAction.linkActionId, 'com.iot.portal.admin.scm.dto.LinkActionDTO', $("#localeBtn_productActionName").val())
                                .then(function (data) {
                                    var ProdcutActionName = {};
                                    for (var i in data) {
                                        ProdcutActionName[data[i].langCode] = data[i].value;
                                    }
                                    __tls[$("#localeBtn_productActionName").val()] = ProdcutActionName;
                                    vm.productAction.__tls = __tls;
                                    $("#localeBtn_productActionName").attr("disabled", false);
                                    $("#localeBtn_productActionDesc").attr("disabled", false);
                                })

                        }
                    )
                })
            }
        }


        function saveProductAction() {
            if(!vm.edit){
                return LinkageProductService.addProductAction(vm.productAction).then(function (data) {
                    if (data.code == 'repeat') {
                        toastr.warning($filter('T')('distribution.repeatNot'));
                        return;
                    }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('productAction', {linkProductId:vm.productAction.linkProductId}, {reload: true});
                    }
                });
            } else{
                return LinkageProductService.updateProductAction(vm.productAction).then(function (data) {
                  if (data.code == 'repeat') {
                    toastr.warning($filter('T')('distribution.repeatNot'));
                    return;
                  }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('productAction', {linkProductId:vm.productAction.linkProductId}, {reload: true});
                    }
                });
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function showProductActionName() {
            $("#localeModal_productActionName").modal("show");
            if($.trim($("#localeModelBody_productActionName").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode
                            + "actionName' ng-model='vm.productAction.__tls." + $("#localeBtn_productActionName").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_productActionName").append(div);
                        if(vm.productAction.linkActionId) {
                            $("input[name='" + langs[i].langCode + "actionName']").val(vm.productAction.__tls[$("#localeBtn_productActionName").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }

        function showProductActionDesc() {
            $("#localeModal_productActionDesc").modal("show");
            if($.trim($("#localeModelBody_productActionDesc").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode
                            + "actionDesc' ng-model='vm.productAction.__tls." + $("#localeBtn_productActionDesc").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_productActionDesc").append(div);
                        if(vm.productAction.linkActionId) {
                            $("input[name='" + langs[i].langCode + "actionDesc']").val(vm.productAction.__tls[$("#localeBtn_productActionDesc").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }

        function localeSureProductActionName() {
            var __tls = vm.productAction.__tls || {};
            var actionName = {};
            for (var i in langs) {
              actionName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "actionName']").val();
            }
            var btnValue = $("#localeBtn_productActionName").val();
            vm.productAction[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "actionName']").val();
            $("#localeModal_productActionName").modal("hide");
            __tls[btnValue] = actionName;
            vm.productAction.__tls = __tls;
        }

        function localeSureProductActionDesc() {
            var __tls = vm.productAction.__tls || {};
            var description = {};
            for (var i in langs) {
                description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "actionDesc']").val();
            }
            var btnValue = $("#localeBtn_productActionDesc").val();
            vm.productAction[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "actionDesc']").val();
            $("#localeModal_productActionDesc").modal("hide");
            __tls[btnValue] = description;
            vm.productAction.__tls = __tls;
        }

        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 3,
            newestOnTop: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('AddLinkageProductController', AddLinkageProductController);

  AddLinkageProductController.$inject = ['LinkageProductService', '$state', '$uibModalInstance', 'SweetAlert',
    'entity', 'PromptService', '$filter', 'toastr', 'toastrConfig', 'Upload', 'BaseConfig', '$sessionStorage', '$localStorage'];

  function AddLinkageProductController(LinkageProductService, $state, $uibModalInstance, SweetAlert,
                                       entity, PromptService, $filter, toastr, toastrConfig, Upload, BaseConfig, $sessionStorage, $localStorage) {
    var vm = this;
    vm.linkageProduct = entity;
    vm.cmdSets = {};
    vm.edit = false;
    vm.judgeEditOrCreate = judgeEditOrCreate;


    vm.saveLinkageProduct = saveLinkageProduct;
    vm.clear = clear;
    vm.load = load;
    vm.judgeEditOrCreate();
    vm.load();

    /**
     * 图片上传
     */
    vm.uploadImg = '';
    vm.varMay = true;
    vm.imgShow = false;
    vm.oldFile = "assets/images/logo-header.png";
    vm.file = "";
    vm.submitFile = submitFile;
    vm.changeFile = changeFile;
    vm.setFile = setFile;

    function judgeEditOrCreate() {
      if (entity.hasOwnProperty('linkProductId')) {
        vm.edit = true;
      }
    }

    function load() {
      if (vm.edit) {
        LinkageProductService.getLinkageProduct(vm.linkageProduct, 1).then(function (data) {
          if (!data) {
            toastr.error($filter('T')("alert.noData"));
            window.history.go(-1);
          }
          vm.linkageProduct = data.rows[0];
          vm.oldFile = vm.linkageProduct.linkIcon;
        })
      }
      LinkageProductService.getCmdSet(vm.cmdSets, 1, -1).then(function (data) {
        vm.cmdSets = data.rows;
      });
    }

    function saveLinkageProduct() {
      if (vm.edit) {
        return LinkageProductService.updateLinkageProduct(vm.linkageProduct).then(function (data) {
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('linkageProduct', null, {reload: true});
          }
        })
      }
      else {
        return LinkageProductService.addLinkageProduct(vm.linkageProduct).then(function (data) {
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('linkageProduct', null, {reload: true});
          }
        })
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });

    function submitFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
      if (vm.file == "assets/images/logo-header.png") {
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"));
        return;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    }

    function changeFile() {
      if (vm.file) {
        vm.varMay = true;
        vm.oldFile = vm.file
      }
    }

    function setFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
    }

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data) {
        //upload success
        vm.linkageProduct.linkIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
        } else {
          vm.varMay = true;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('AddLinkageConditionController', AddLinkageConditionController);

  AddLinkageConditionController.$inject = ['LinkageConditionService', '$state', '$uibModalInstance', 'toastr',
    'entity', 'PromptService', '$filter', 'toastrConfig', 'Upload', 'BaseConfig', '$sessionStorage', '$localStorage'];

  function AddLinkageConditionController(LinkageConditionService, $state, $uibModalInstance,
                                         toastr, entity, PromptService, $filter, toastrConfig, Upload, BaseConfig, $sessionStorage, $localStorage) {
    var vm = this;
    vm.linkageCondition = entity;
    vm.linkCodeReadOnly = false;
    vm.cmdSets = {};
    vm.clear = clear;
    vm.save = save;
    vm.showLinkageConditionDesc = showLinkageConditionDesc;
    vm.showLinkageConditionName = showLinkageConditionName;
    vm.localeSureLinkageConditionName = localeSureLinkageConditionName;
    vm.localeSureLinkageConditionDesc = localeSureLinkageConditionDesc;
    vm.load = load;
    vm.edit = false;
    vm.judgeEditOrCreate = judgeEditOrCreate;
    vm.judgeEditOrCreate();
    vm.load();

    /**
     * 图片上传
     */
    vm.uploadImg = '';
    vm.varMay = true;
    vm.imgShow = false;
    vm.oldFile = "assets/images/logo-header.png";
    vm.file = "";
    vm.submitFile = submitFile;
    vm.changeFile = changeFile;
    vm.setFile = setFile;

    function judgeEditOrCreate() {
      if (entity.hasOwnProperty('linkTriggerId')) {
        vm.edit = true;
      }
    }

    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn_conditionName").attr("disabled", false);
        $("#localeBtn_conditionDesc").attr("disabled", false);
      });
    }

    initLangs();

    function load() {
      LinkageConditionService.getCmdSet(vm.cmdSets, 1, -1).then(function (data) {
        if (!data) {
          return;
        }
        vm.cmdSets = data.rows;
      });
      if (vm.edit) {
        LinkageConditionService.getLinkageContidition(vm.linkageCondition, 1).then(function (result) {
          vm.linkageCondition = result.rows[0];

          if (vm.linkageCondition.linkIcon != null) {
            vm.oldFile = vm.linkageCondition.linkIcon;
            vm.varMay = false;
          }
          LinkageConditionService.getLinkageConditionInfo(vm.linkageCondition.linkTriggerId, 'com.iot.portal.admin.scm.dto.LinkTriggerDTO', $("#localeBtn_conditionDesc").val())
          .then(function (data) {
            var __tls = {};
            var description = {};
            for (var i in data) {
              description[data[i].langCode] = data[i].value;
            }
            __tls[$("#localeBtn_conditionDesc").val()] = description;
            LinkageConditionService.getLinkageConditionInfo(vm.linkageCondition.linkTriggerId, 'com.iot.portal.admin.scm.dto.LinkTriggerDTO', $("#localeBtn_conditionName").val())
            .then(function (data) {
              var linkageConditionName = {};
              for (var i in data) {
                linkageConditionName[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn_conditionName").val()] = linkageConditionName;
              vm.linkageCondition.__tls = __tls;
              $("#localeBtn_conditionName").attr("disabled", false);
              $("#localeBtn_conditionDesc").attr("disabled", false);
            })
          })
        })
      }
    }

    function save() {
      if (!vm.edit) {
        return LinkageConditionService.addLinkageContidition(vm.linkageCondition).then(function (data) {
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('linkageCondition', null, {reload: true});
          }
        });
      } else {
        return LinkageConditionService.updateLinkageContidition(vm.linkageCondition).then(function (data) {
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('linkageCondition', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showLinkageConditionName() {
      $("#localeModal_conditionName").modal("show");
      if ($.trim($("#localeModelBody_conditionName").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "conditionName' ng-model='vm.linkageCondition.__tls." + $("#localeBtn_conditionName").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_conditionName").append(div);
            if (vm.linkageCondition.linkTriggerId) {
              $("input[name='" + langs[i].langCode + "conditionName']").val(vm.linkageCondition.__tls[$("#localeBtn_conditionName").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showLinkageConditionDesc() {
      $("#localeModal_conditionDesc").modal("show");
      if ($.trim($("#localeModelBody_conditionDesc").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "conditionDesc' ng-model='vm.linkageCondition.__tls." + $("#localeBtn_conditionDesc").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_conditionDesc").append(div);
            if (vm.linkageCondition.linkTriggerId) {
              $("input[name='" + langs[i].langCode + "conditionDesc']").val(vm.linkageCondition.__tls[$("#localeBtn_conditionDesc").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function localeSureLinkageConditionName() {
      var __tls = vm.linkageCondition.__tls || {};
      var linkageConditionName = {};
      for (var i in langs) {
        linkageConditionName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "conditionName']").val();
      }
      var btnValue = $("#localeBtn_conditionName").val();
      vm.linkageCondition[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "conditionName']").val();
      $("#localeModal_conditionName").modal("hide");
      __tls[btnValue] = linkageConditionName;
      vm.linkageCondition.__tls = __tls;
    }

    function localeSureLinkageConditionDesc() {
      var __tls = vm.linkageCondition.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "conditionDesc']").val();
      }
      var btnValue = $("#localeBtn_conditionDesc").val();
      vm.linkageCondition[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "conditionDesc']").val();
      $("#localeModal_conditionDesc").modal("hide");
      __tls[btnValue] = description;
      vm.linkageCondition.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    function submitFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
      if (vm.file == "assets/images/logo-header.png") {
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"));
        return;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    }


    function changeFile() {
      if (vm.file) {
        vm.varMay = true;
        vm.oldFile = vm.file
      }
    }

    function setFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
    }

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data) {
        //upload success
        vm.linkageCondition.linkIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
        } else {
          vm.varMay = true;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
      });
    }
  }

})();

/**
 * Created by zyl on 2017/8/7.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddIntelligentLinkageSettingController', AddIntelligentLinkageSettingController);

  AddIntelligentLinkageSettingController.$inject = ['IntelligentLinkageService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', '$filter','$stateParams'];

  function AddIntelligentLinkageSettingController(IntelligentLinkageService, $state, $uibModalInstance, toastr, entity, PromptService, $filter,$stateParams) {
    var vm = this;
    vm.linkSetting = entity;
    vm.addLinkSetting = addLinkSetting;
    vm.load = load;
    vm.clear = clear;
    vm.load();

    function load() {
      if (vm.linkSetting.linkSettingId) {
        //vm.editOrCreate='Edit';
        IntelligentLinkageService.getLinkSettings(vm.linkSetting, 1).then(function (result) {
          vm.linkSetting = result.rows[0];
        })
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    //submit add link
    function addLinkSetting() {
      if(!vm.linkSetting.linkSettingId){
        return IntelligentLinkageService.addLinkSetting(vm.linkSetting).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('linkageSetting', {linkId: $stateParams.linkId}, {reload: true});
          }
        });
      } else{
        return IntelligentLinkageService.updateLinkSetting(vm.linkSetting).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('linkageSetting', {linkId: $stateParams.linkId}, {reload: true});
          }
        });
      }
    }
  }
})();

/**
 * Created by xiwang.liu on 2016/8/10.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddIntelligentLinkageController', AddIntelligentLinkageController);

  AddIntelligentLinkageController.$inject = ['IntelligentLinkageService', '$state', '$uibModalInstance', 'toastr',
    'entity', 'PromptService', '$filter', 'toastrConfig'];

  function AddIntelligentLinkageController(IntelligentLinkageService, $state, $uibModalInstance,
    toastr, entity, PromptService, $filter, toastrConfig) {
    var vm = this;
    vm.link = entity;
    vm.linkCodeReadOnly=false;
    vm.clear = clear;
    vm.addLink = addLink;
    vm.show = show;
    vm.showLinkName = showLinkName;
    vm.localeSure = localeSure;
    vm.localeSureLinkName = localeSureLinkName;
    vm.load = load;
    vm.load();

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
        $("#localeBtn_linkName").attr("disabled", false);
      });
    }
    initLangs();

    function load() {
      if (vm.link.linkId) {
        vm.linkCodeReadOnly=true;
        //vm.editOrCreate='Edit';
        IntelligentLinkageService.getLinkage(vm.link, 1).then(function (result) {
          vm.link = result.rows[0];
          IntelligentLinkageService.getLinkInfo(vm.link.linkId, 'com.iot.portal.admin.scm.dto.ScmLinkDTO', $("#localeBtn").val())
            .then(function (data) {
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn").val()] = description;
              IntelligentLinkageService.getLinkInfo(vm.link.linkId, 'com.iot.portal.admin.scm.dto.ScmLinkDTO', $("#localeBtn_linkName").val())
                .then(function (data) {
                  var linkName = {};
                  for (var i in data) {
                    linkName[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#localeBtn_linkName").val()] = linkName;
                  vm.link.__tls = __tls;
                  $("#localeBtn").attr("disabled", false);
                  $("#localeBtn_linkName").attr("disabled", false);
                })
            })
        })
      }
    }

    //submit add link
    function addLink() {
      if(!vm.link.linkId){
        return IntelligentLinkageService.addLink(vm.link).then(function (data) {
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('linkage', null, {reload: true});
          }
        });
      } else{
        return IntelligentLinkageService.updateLink(vm.link).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('linkage', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    //show model
    function show() {
      $("#localeModal").modal("show");
      if($.trim($("#localeModelBody").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "' ng-model='vm.link.__tls." + $("#localeBtn").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody").append(div);
            if(vm.link.linkId){
              $("input[name='" + langs[i].langCode + "']").val(vm.link.__tls[$("#localeBtn").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    //show link name model
    function showLinkName() {
      $("#localeModal_linkName").modal("show");
      if($.trim($("#localeModelBody_linkName").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Name' ng-model='vm.link.__tls." + $("#localeBtn_linkName").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_linkName").append(div);
            if(vm.link.linkId) {
              $("input[name='" + langs[i].langCode + "Name']").val(vm.link.__tls[$("#localeBtn_linkName").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    //save model
    function localeSure() {
      var __tls = vm.link.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "']").val();
      }
      var btnValue = $("#localeBtn").val();
      vm.link[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal").modal("hide");
      __tls[btnValue] = description;
      vm.link.__tls = __tls;
    }

    //save link name model
    function localeSureLinkName() {
      var __tls = vm.link.__tls || {};
      var linkName = {};
      for (var i in langs) {
        linkName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Name']").val();
      }
      var btnValue = $("#localeBtn_linkName").val();
      vm.link[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Name']").val();
      $("#localeModal_linkName").modal("hide");
      __tls[btnValue] = linkName;
      vm.link.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('AddActionParamsController', AddActionParamsController);

    AddActionParamsController.$inject = ['SceneProductService', '$state', '$uibModalInstance', 'SweetAlert',
        'entity', 'PromptService', '$filter','toastr','toastrConfig'];

    function AddActionParamsController(SceneProductService, $state,$uibModalInstance,SweetAlert,
                                           entity, PromptService, $filter,toastr,toastrConfig) {
        var vm = this;
        vm.actionParam = entity;

        vm.saveactionParams = saveactionParams;
        vm.showParamName=showActionParamName;
        vm.showParamDesc = showActionParamDesc;
       /* vm.showParamValue = showActionParamValue;
        vm.showParamDefaultValue = showActionParamDefaultValue;*/
        vm.localeSureActionParamName = localeSureActionParamName;
        vm.localeSureActionParamDesc = localeSureActionParamDesc;
        /*vm.localeSureActionParamValue = localeSureActionParamValue;
        vm.localeSureParamDefaultValue = localeSureParamDefaultValue;*/
        vm.clear = clear;
        vm.load = load;
        vm.edit=false;
        vm.judgeEditOrCreate = judgeEditOrCreate;
        vm.judgeEditOrCreate();
        vm.load();
        vm.paramType = [{name:'枚举',value:'1'},{name:'数值范围',value:'0'}];
        function judgeEditOrCreate() {
            if(entity.hasOwnProperty('actionParamId')){
                vm.edit = true;
            }
        }

        var langs = [];
        function initLangs() {
            PromptService.selectLang().query(function(data) {
                langs = data.rows;
                $("#localBtn_paramName").attr("disabled", false);
                $("#localBtn_paramDesc").attr("disabled", false);
                /*$("#localBtn_paramValue").attr("disabled", false);
                $("#localBtn_paramDefaultValue").attr("disabled", false);*/
            });
        }
        initLangs();

        function load() {
            if (vm.edit) {
              SceneProductService.getActionParam(vm.actionParam,1).then(function (data) {
                    if (!data) {
                        toastr.error($filter('T')("alert.noData"));
                        window.history.go(-1);
                        return
                    }
                    vm.actionParam=data.rows[0];
                SceneProductService.getActionParamInfo(vm.actionParam.actionParamId, 'com.iot.portal.admin.scm.dto.ScenarioActionParamDTO', $("#localBtn_paramDesc").val()).then(
                        function (data) {
                            var __tls = {};
                            var description = {};
                            for (var i in data) {
                                description[data[i].langCode] = data[i].value;
                            }
                            __tls[$("#localBtn_paramDesc").val()] = description;
                          SceneProductService.getActionParamInfo(vm.actionParam.actionParamId, 'com.iot.portal.admin.scm.dto.ScenarioActionParamDTO', $("#localBtn_paramName").val())
                                .then(function (data) {
                                    var actionParamName = {};
                                    for (var i in data) {
                                        actionParamName[data[i].langCode] = data[i].value;
                                    }
                                    __tls[$("#localBtn_paramName").val()] = actionParamName;
                                    vm.actionParam.__tls = __tls;
                                    $("#localBtn_paramName").attr("disabled", false);
                                    $("#localBtn_paramDesc").attr("disabled", false);
                                })

                        }
                    )
                })
            }
        }

        function saveactionParams() {
            if(vm.edit){
                return SceneProductService.updateActionParam(vm.actionParam).then(function (data) {
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('actionParams',{scenarioActionId:vm.actionParam.scenarioActionId},{reload:true});
                    }
                })
            }
            else{
                return SceneProductService.addActionParam(vm.actionParam).then(function (data) {
                    if (data.code == 'repeat') {
                        toastr.warning($filter('T')('distribution.repeatNot'));
                        return;
                    }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('actionParams', {scenarioActionId:vm.actionParam.scenarioActionId}, {reload: true});
                    }
                })
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function showActionParamName() {
            $("#localeModal_actionParamName").modal("show");
            if($.trim($("#localeModelBody_actionParamName").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode + "paramName' ng-model='vm.actionParam.__tls." + $("#localBtn_paramName").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionParamName").append(div);
                        if(vm.actionParam.actionParamId) {
                            $("input[name='" + langs[i].langCode + "paramName']").val(vm.actionParam.__tls[$("#localBtn_paramName").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }

        function showActionParamDesc() {
            $("#localeModal_actionParamDesc").modal("show");
            if($.trim($("#localeModelBody_actionParamDesc").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode + "desc' " +
                            "ng-model='vm.actionParam.__tls." + $("#localBtn_paramDesc").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionParamDesc").append(div);
                        if(vm.actionParam.actionParamId) {
                            $("input[name='" + langs[i].langCode + "desc']").val(vm.actionParam.__tls[$("#localBtn_paramDesc").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }

       /* function showActionParamValue() {
            $("#localeModal_actionParamValue").modal("show");
            if($.trim($("#localeModelBody_actionParamValue").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode + "paramRange' " +
                            "ng-model='vm.actionParam.__tls." + $("#localBtn_paramValue").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionParamValue").append(div);
                        if(vm.actionParam.actionParamId) {
                            $("input[name='" + langs[i].langCode + "paramRange']").val(vm.actionParam.__tls[$("#localBtn_paramValue").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }

        function showActionParamDefaultValue() {
            $("#localeModal_actionParamDefaultValue").modal("show");
            if($.trim($("#localeModelBody_actionParamDefaultValue").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode + "defaultValue' " +
                            "ng-model='vm.actionParam.__tls." + $("#localBtn_paramDefaultValue").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionParamDefaultValue").append(div);
                        if(vm.actionParam.actionParamId) {
                            $("input[name='" + langs[i].langCode + "defaultValue']").val(vm.actionParam.__tls[$("#localBtn_paramDefaultValue").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }*/

        function localeSureActionParamName() {
            var __tls = vm.actionParam.__tls || {};
            var Name = {};
            for (var i in langs) {
                Name[langs[i].langCode] = $("input[name='" + langs[i].langCode + "paramName']").val();
            }
            var btnValue = $("#localBtn_paramName").val();
            vm.actionParam[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "paramName']").val();
            $("#localeModal_actionParamName").modal("hide");
            __tls[btnValue] = Name;
            vm.actionParam.__tls = __tls;
        }

        function localeSureActionParamDesc() {
            var __tls = vm.actionParam.__tls || {};
            var description = {};
            for (var i in langs) {
                description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "desc']").val();
            }
            var btnValue = $("#localBtn_paramDesc").val();
            vm.actionParam[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "desc']").val();
            $("#localeModal_actionParamDesc").modal("hide");
            __tls[btnValue] = description;
            vm.actionParam.__tls = __tls;
        }

        /*function localeSureActionParamValue() {
            var __tls = vm.actionParam.__tls || {};
            var Name = {};
            for (var i in langs) {
                Name[langs[i].langCode] = $("input[name='" + langs[i].langCode + "paramRange']").val();
            }
            var btnValue = $("#localBtn_paramValue").val();
            vm.actionParam[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "paramRange']").val();
            $("#localeModal_actionParamValue").modal("hide");
            __tls[btnValue] = Name;
            vm.actionParam.__tls = __tls;
        }

        function localeSureParamDefaultValue() {
            var __tls = vm.actionParam.__tls || {};
            var description = {};
            for (var i in langs) {
                description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "defaultValue']").val();
            }
            var btnValue = $("#localBtn_paramDefaultValue").val();
            vm.actionParam[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "defaultValue']").val();
            $("#localeModal_actionParamDefaultValue").modal("hide");
            __tls[btnValue] = description;
            vm.actionParam.__tls = __tls;
        }*/

        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 3,
            newestOnTop: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    }
})();


(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('AddActionConfigController', AddActionConfigController);

    AddActionConfigController.$inject = ['IntelligentLinkageService','SceneProductService', '$state', '$uibModalInstance', 'toastr',
        'entity', 'PromptService', '$filter', 'toastrConfig'];

    function AddActionConfigController(IntelligentLinkageService,SceneProductService, $state, $uibModalInstance,
                                             toastr, entity, PromptService, $filter, toastrConfig) {
        var vm = this;
        vm.actionConfig = entity;

        vm.saveActionConfig = saveActionConfig;
        vm.showActionConfigName = showActionConfigName;
        vm.showActionConfigDesc=showActionConfigDesc;
        vm.localeSureActionConfigName=localeSureActionConfigName;
        vm.localeSureActionConfigDesc=localeSureActionConfigDesc;
        vm.clear = clear;
        vm.load = load;
        vm.judgeEditOrCreate = judgeEditOrCreate;
        vm.recommand = [{'name':'是','value':'1'},{'name':'否','value':'0'}];
        vm.edit = false;
        vm.judgeEditOrCreate();
        vm.load();

        function judgeEditOrCreate() {
            if(entity.hasOwnProperty('scenarioActionId')){
                vm.edit = true;
            }
        }

        var langs = [];
        function initLangs() {
            PromptService.selectLang().query(function(data) {
                langs = data.rows;
                $("#localeBtn_actionConfigName").attr("disabled", false);
                $("#localeBtn_actionConfigDesc").attr("disabled", false);
            });
        }

        initLangs();
        function load() {
            if (vm.edit) {
              SceneProductService.getActionConfig(vm.actionConfig,1).then(function (data) {
                    if (!data) {
                        toastr.error($filter('T')("alert.noData"));
                        window.history.go(-1);
                        return
                    }
                    vm.actionConfig=data.rows[0];
                SceneProductService.getActionConfigInfo(vm.actionConfig.scenarioActionId, 'com.iot.portal.admin.scm.dto.ScenarioActionDTO', $("#localeBtn_actionConfigDesc").val())
                        .then(function (data) {
                            var __tls = {};
                            var description = {};
                            for (var i in data) {
                                description[data[i].langCode] = data[i].value;
                            }
                            __tls[$("#localeBtn_actionConfigDesc").val()] = description;
                          SceneProductService.getActionConfigInfo(vm.actionConfig.scenarioActionId, 'com.iot.portal.admin.scm.dto.ScenarioActionDTO', $("#localeBtn_actionConfigName").val())
                                .then(function (data) {
                                    var actionConfigName = {};
                                    for (var i in data) {
                                        actionConfigName[data[i].langCode] = data[i].value;
                                    }
                                    __tls[$("#localeBtn_actionConfigName").val()] = actionConfigName;
                                    vm.actionConfig.__tls = __tls;
                                    $("#localeBtn_actionConfigName").attr("disabled", false);
                                    $("#localeBtn_actionConfigDesc").attr("disabled", false);
                                })

                        }
                    )
                })
            }
        }


        function saveActionConfig() {
            if(!vm.edit){
              SceneProductService.addActionConfig(vm.actionConfig).then(function (data) {
                    if (data.code == 'repeat') {
                        toastr.warning($filter('T')('distribution.repeatNot'));
                        return;
                    }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('actionConfig',{scenarioProductId:vm.actionConfig.scenarioProductId}, {reload: true});
                    }
                });
            } else{
              SceneProductService.updateActionConfig(vm.actionConfig).then(function (data) {
                  if (data.code == 'repeat') {
                    toastr.warning($filter('T')('distribution.repeatNot'));
                    return;
                  }
                    if (data.success) {
                        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
                        $uibModalInstance.close();
                        return $state.go('actionConfig', {scenarioProductId:vm.actionConfig.scenarioProductId}, {reload: true});
                    }
                });
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function showActionConfigName() {
            $("#localeModal_actionConfigName").modal("show");
            if($.trim($("#localeModelBody_actionConfigName").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode + "actionName' ng-model='vm.actionConfig.__tls." + $("#localeBtn_linkName").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionConfigName").append(div);
                        if(vm.actionConfig.scenarioActionId) {
                            $("input[name='" + langs[i].langCode + "actionName']").val(vm.actionConfig.__tls[$("#localeBtn_actionConfigName").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }

        function showActionConfigDesc() {
            $("#localeModal_actionConfigDesc").modal("show");
            if($.trim($("#localeModelBody_actionConfigDesc").html()) == "") {
                for (var i in langs) {
                    if (langs.hasOwnProperty(i)) {
                        var div = $("<div class='form-group'></div>");
                        div.append("<label class='control-label'>" + langs[i].description + "</label>");
                        div.append("<input type='text' class='form-control' name='" + langs[i].langCode + "desc' ng-model='vm.actionConfig.__tls." + $("#localeBtn_linkName").val() + '.' + langs[i].langCode + "'/>");
                        $("#localeModelBody_actionConfigDesc").append(div);
                        if(vm.actionConfig.scenarioActionId) {
                            $("input[name='" + langs[i].langCode + "desc']").val(vm.actionConfig.__tls[$("#localeBtn_actionConfigDesc").val()][langs[i].langCode]);
                        }
                    }
                }
            }
        }

        function localeSureActionConfigName() {
            var __tls = vm.actionConfig.__tls || {};
            var Name = {};
            for (var i in langs) {
                Name[langs[i].langCode] = $("input[name='" + langs[i].langCode + "actionName']").val();
            }
            var btnValue = $("#localeBtn_actionConfigName").val();
            vm.actionConfig[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "actionName']").val();
            $("#localeModal_actionConfigName").modal("hide");
            __tls[btnValue] = Name;
            vm.actionConfig.__tls = __tls;
        }

        function localeSureActionConfigDesc() {
            var __tls = vm.actionConfig.__tls || {};
            var description = {};
            for (var i in langs) {
                description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "desc']").val();
            }
            var btnValue = $("#localeBtn_actionConfigDesc").val();
            vm.actionConfig[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "desc']").val();
            $("#localeModal_actionConfigDesc").modal("hide");
            __tls[btnValue] = description;
            vm.actionConfig.__tls = __tls;
        }

        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 3,
            newestOnTop: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    }
})();

(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('ActionParamsController', ActionParamsController);

    ActionParamsController.$inject = ['$sessionStorage','SceneProductService', 'paginationConstants', 'SweetAlert', '$filter', 'MessageTemplateService','entity'];

    function ActionParamsController($sessionStorage,SceneProductService, paginationConstants, SweetAlert, $filter, MessageTemplateService,entity) {
        var vm = this;
        vm.actionParam = entity;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.checkactionParam = checkactionParam;
        vm.checkAllactionParam = checkAllactionParam;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.deleteActionParam = deleteActionParam;
        vm.deleteActionParams = deleteActionParams;
        vm.getActionParam = getActionParam;

        vm.search();

        function getActionParam() {
            return SceneProductService.getActionParam(vm.actionParam, vm.page).then(function (data) {
                if(!data.rows){
                    return;
                }
                vm.actionParams = data.rows;
                vm.totalItems = data.total;
                vm.pageSize = data.rows.length;
            })
        }

        function search() {
            vm.getActionParam();
            vm.actionParam.productTypeName=$sessionStorage.scm_js_sceneProduct_productTypeName;
            vm.actionParam.actionName=$sessionStorage.scm_js_actionConfig_actionName;
        }

        function deleteActionParam(actionParam) {
            SweetAlert.confirm(actionParam.paramName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var actionParams = new Array();
                    actionParams.push(actionParam.actionParamId);
                  SceneProductService.deleteActionParam(actionParams).then(function (response) {
                        if (response.success) {
                            vm.getActionParam();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }



        function deleteActionParams() {
            var isCheck = $(".chk_list").is(':checked');
            if(!isCheck) {
                SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
                return;
            }
            SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var arrChk = $("input[name='chk_list']:checked");
                    var actionParams = new Array();
                    $(arrChk).each(function() {
                        actionParams.push(this.value);
                    });
                  SceneProductService.deleteActionParam(actionParams).then(function (response) {
                        document.getElementById("chk_all").checked = false;
                        var items = document.getElementsByName("chk_list");
                        for(var j = 0; j < items.length; j++){
                            items[j].checked = false;
                        }
                        if (response.success) {
                            vm.getActionParam();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        //page changed
        function pageChanged() {
            angular.element("#chk_all").checked = false;
            vm.getActionParam(vm.page);
        }

        //check or unCheck check link
        function checkactionParam() {
            var arrChk = $("input[name='chk_list']:checked");
            if(arrChk.length < vm.pageSize) {
                document.getElementById("chk_all").checked = false;
            } else if(arrChk.length === vm.pageSize) {
                document.getElementById("chk_all").checked = true;
            }
        }

        //check or unCheck all check link
        function checkAllactionParam() {
            var chk_all = $("#chk_all").is(':checked');
            var items = document.getElementsByName("chk_list");
            if(chk_all) {
                for(var i = 0; i < items.length; i++){
                    items[i].checked = true;
                }
            } else {
                for(var j = 0; j < items.length; j++){
                    items[j].checked = false;
                }
            }
        }
    }
})();


(function () {
    'use strict';

    angular.module('hmapFront')
        .controller('ActionConfigControlle', ActionConfigControlle);

    ActionConfigControlle.$inject = ['$sessionStorage','SceneProductService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

    function ActionConfigControlle($sessionStorage,SceneProductService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
        var vm = this;
        vm.actionConfig = entity;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.checkActionConfig = checkActionConfig;
        vm.checkAllActionConfig = checkAllActionConfig;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.deleteActionConfig = deleteActionConfig;
        vm.deleteActionConfigs = deleteActionConfigs;
        vm.getActionConfig = getActionConfig;
        vm.getProductNameAndConfigName = getProductNameAndConfigName;
        vm.reset = reset;


        vm.recommand = [{'name':'是','value':'1'},{'name':'否','value':'0'}];
        vm.search();

        function reset() {
            vm.actionConfig.recommendFlag = undefined;
            vm.actionConfig.actionCode=undefined;
            vm.actionConfig.actionName = undefined;
        }

        function getProductNameAndConfigName(actionName) {
            $sessionStorage.scm_js_sceneProduct_productTypeName = vm.actionConfig.productTypeName;
            $sessionStorage.scm_js_actionConfig_actionName = actionName;
        }

        function getActionConfig() {
            return SceneProductService.getActionConfig(vm.actionConfig, vm.page).then(function (data) {
                if(!data.rows){
                    return;
                }
                vm.actionConfigs = data.rows;
                vm.totalItems = data.total;
                vm.pageSize = data.rows.length;
            })
        }

        function search() {
            vm.getActionConfig();
            vm.actionConfig.productTypeName= $sessionStorage.scm_js_sceneProduct_productTypeName;
            vm.actionConfig.sceneName=$sessionStorage.scm_js_sceneProduct_sceneName
        }

        function deleteActionConfig(actionConfig) {
            SweetAlert.confirm(actionConfig.actionName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var actionConfigs = new Array();
                    actionConfigs.push(actionConfig.scenarioActionId);
                  SceneProductService.deleteActionConfig(actionConfigs).then(function (response) {
                        if (response.success) {
                            vm.getActionConfig();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        function deleteActionConfigs() {
            var isCheck = $(".chk_list").is(':checked');
            if(!isCheck) {
                SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
                return;
            }
            SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
                if(p){
                    var arrChk = $("input[name='chk_list']:checked");
                    var actionConfigs = new Array();
                    $(arrChk).each(function() {
                        actionConfigs.push(this.value);
                    });
                  SceneProductService.deleteActionConfig(actionConfigs).then(function (response) {
                        document.getElementById("chk_all").checked = false;
                        var items = document.getElementsByName("chk_list");
                        for(var j = 0; j < items.length; j++){
                            items[j].checked = false;
                        }
                        if (response.success) {
                            vm.getActionConfig();
                            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
                        }
                    })
                }
            });
        }

        //page changed
        function pageChanged() {
            angular.element("#chk_all").checked = false;
            vm.getActionConfig(vm.page);
        }

        //check or unCheck check link
        function checkActionConfig() {
            var arrChk = $("input[name='chk_list']:checked");
            if(arrChk.length < vm.pageSize) {
                document.getElementById("chk_all").checked = false;
            } else if(arrChk.length === vm.pageSize) {
                document.getElementById("chk_all").checked = true;
            }
        }

        //check or unCheck all check link
        function checkAllActionConfig() {
            var chk_all = $("#chk_all").is(':checked');
            var items = document.getElementsByName("chk_list");
            if(chk_all) {
                for(var i = 0; i < items.length; i++){
                    items[i].checked = true;
                }
            } else {
                for(var j = 0; j < items.length; j++){
                    items[j].checked = false;
                }
            }
        }
    }
})();


/**
 * Created by shi on 2017/6/12.
 */

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .controller('ProductImageInfoController', ProductImageInfoController);

  ProductImageInfoController.$inject = ['$filter', 'toastr', 'ProductImageService', 'toastrConfig', '$stateParams', '$state', 'entity', 'SweetAlert'];

  /** @ngInject */
  function ProductImageInfoController($filter, toastr, ProductImageService, toastrConfig, $stateParams, $state, entity, SweetAlert) {
    var vm = this;
    vm.page = 1;
    vm.imageInfoDto = entity;
    vm.getAllProductImageInfo = getAllProductImageInfo;
    vm.pageChanged = pageChanged;
    vm.deleteProductImageInfo = deleteProductImageInfo;
    vm.search = search;
    vm.getAllProductImageInfo();

    function getAllProductImageInfo() {
      // console.log( $stateParams.imageCode);
      // vm.imageInfoDto.imageCode = $stateParams.imageCode;
      return ProductImageService.getAllProductImageInfo(vm.imageInfoDto, vm.page).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.imageInfoList = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    function search() {
      vm.imageInfoDto.productName = vm.productName;
      vm.getAllProductImageInfo();
    }

    function deleteProductImageInfo(productImageId) {
      var requestBody = {
        productImageId: productImageId,
        processingStatus: "delete"
      };
      SweetAlert.confirm($filter('T')('productImage.deleteTip'), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          ProductImageService.updateProductImageInfo(requestBody).then(function (data) {
            if (data.success) {
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
              return $state.go('productImageInfo', {imageCode: vm.imageInfoDto.imageCode}, {reload: 'productImageInfo'});
            }
          })
        }
      })
    }

    function pageChanged(page) {
      vm.page = page;
      vm.getAllProductImageInfo();
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Created by shi on 2017/6/12.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('productImageCode', {
        parent: 'app',
        url: "/productImageCode",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/product/html/productImageCode.html",
            controller: 'ProductImageCodeController',
            controllerAs: 'vm'
          },
        },
          resolve: {
            entity : function () {
              return {};
            }
          }
      })
      .state('productImageCode.add', {
        parent:'productImageCode',
        url:"/addProductImageCode",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/product/html/addProductImageCode.html',
            controller: 'AddProductImageCodeController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                }
              }
            }
          }).result.then(function () {
            $state.go('productImageCode', null, {reload: 'productImageCode'});
          }, function () {
            $state.go('productImageCode');
          });
        }]
      }).state('productImageCode.edit', {
        parent:'productImageCode',
        url:"/editProductImageCode/:imageCode",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/product/html/addProductImageCode.html',
            controller: 'AddProductImageCodeController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  imageCode : $stateParams.imageCode
                }
              }
            }
          }).result.then(function () {
            $state.go('productImageCode', null, {reload: 'productImageCode'});
          }, function () {
            $state.go('productImageCode');
          });
        }]
      }) .state('productImageInfo', {
        parent: 'app',
        url: "/productImageCode/productImageInfo/:imageCode",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/product/html/productImageInfo.html",
            controller: 'ProductImageInfoController',
            controllerAs: 'vm',
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              imageCode : $stateParams.imageCode
            };
          }
        }
      }
    ).state('productImageInfo.add', {
      parent:'productImageInfo',
      url:"/addProductImageInfo",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/product/html/addProductImageInfo.html',
          controller: 'AddProductImageInfoController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                imageCode : $stateParams.imageCode
              }
            }
          }
        }).result.then(function () {
          $state.go('productImageInfo', null, {reload: 'productImageInfo'});
        }, function () {
          $state.go('productImageInfo');
        });
      }]
    }).state('productImageInfo.edit', {
        parent:'productImageInfo',
        url:"/editProductImageInfo/:productImageId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/product/html/addProductImageInfo.html',
            controller: 'AddProductImageInfoController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  imageCode : $stateParams.imageCode,
                  productImageId : $stateParams.productImageId
                }
              }
            }
          }).result.then(function () {
            $state.go('productImageInfo', null, {reload: 'productImageInfo'});
          }, function () {
            $state.go('productImageInfo');
          });
        }]
      })
  }
})();

/**
 * Created by shi on 2017/6/12.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('ProductImageService', ProductImageService);

  ProductImageService.$inject = ['$http'];

  function ProductImageService($http) {
    return {
      getAllProductImageCode : getAllProductImageCode,
      creatProductImageCode : creatProductImageCode,
      editProductImageCode : editProductImageCode,
      getAllProductImageInfo : getAllProductImageInfo,
      updateProductImageInfo : updateProductImageInfo,
      selectOtherProduct : selectOtherProduct,
      insertProductImageInfo : insertProductImageInfo
    };
    //get all product image code
    function getAllProductImageCode(imageCode, pageIndex) {
      const resourceUrl = '/api/product/image/selectImageCode?pageIndex=' + pageIndex + '&imageCode=' + imageCode;
      return $http.post(resourceUrl, {headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
    //creat product image code
    function creatProductImageCode(entity) {
      const resourceUrl = '/api/product/image/insertImageCode';
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
    //edit product image code
    function editProductImageCode(entity) {
      const resourceUrl = '/api/product/image/updateImageCode';
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
    //query product image info
    function getAllProductImageInfo(entity,pageIndex) {
      const resourceUrl = '/api/product/image/selectImageInfo?pageIndex='+pageIndex;
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
    //update or delete product image info
    function updateProductImageInfo(entity) {
      const resourceUrl = '/api/product/image/updateImageInfo';
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
    //select other product
    function selectOtherProduct(entity) {
      const resourceUrl = '/api/product/image/selectOtherProduct';
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
    //insert product image info
    function insertProductImageInfo(entity) {
      const resourceUrl = '/api/product/image/insertProductImageInfo';
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
  }
})();

/**
 * Created by shi on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ProductImageCodeController', ProductImageCodeController);

  ProductImageCodeController.$inject = [  '$filter', 'ProductImageService','toastr','toastrConfig','$state','SweetAlert'];
  /** @ngInject */
  function ProductImageCodeController(   $filter, ProductImageService,toastr,toastrConfig,$state,SweetAlert) {
    var vm = this;
    vm.page = 1;
    vm.imageCode = '';
    vm.imageCodeList = new Array();
    vm.getAllProductImageCode = getAllProductImageCode;
    vm.delProductImageCode = delProductImageCode;
    vm.pageChanged = pageChanged;
    vm.search = search;

    vm.getAllProductImageCode();

    function getAllProductImageCode() {
      return ProductImageService.getAllProductImageCode(vm.imageCode, vm.page).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.imageCodeList = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      });
    }

    function delProductImageCode(imageCodeInfo) {
      var productImageDto = {};
      productImageDto.imageCode = imageCodeInfo.imageCode;
      productImageDto.processingStatus = 'delete';

      SweetAlert.confirm($filter('T')('productImage.deleteTip'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          ProductImageService.editProductImageCode(productImageDto).then(function (data){
            if(data.success){
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
              return $state.go('productImageCode', null, {reload: 'productImageCode'});
            }
          })
        }
      })
    }
    function pageChanged(page) {
      vm.page = page;
      vm.getAllProductImageCode();
    }
    
    function search() {
      vm.getAllProductImageCode();
    }
    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Created by shi on 2017/6/12.
 */

(function(){
  'use strict';
  angular
    .module('hmapFront')
    .controller('AddProductImageInfoController', AddProductImageInfoController);

  AddProductImageInfoController.$inject = ['$filter','toastr','$uibModalInstance', 'ProductImageService','toastrConfig','$stateParams','$state','entity','$localStorage','Upload','BaseConfig'];
  /** @ngInject */
  function AddProductImageInfoController( $filter,toastr,$uibModalInstance ,ProductImageService,toastrConfig,$stateParams,$state,entity,$localStorage,Upload,BaseConfig) {
    var vm = this;
    vm.isEdit = false;
    vm.productImageInfoDto = entity;
    vm.file = '';
    vm.oldFile="assets/images/logo-header.png";
    vm.imageChange = false;
    vm.otherProductList = [];

    vm.upload = upload;
    vm.addProductImageInfo = addProductImageInfo;
    vm.init = init;
    vm.clear = clear;
    vm.changeFile = changeFile;
    vm.selectOtherProduct = selectOtherProduct;

    vm.init();

    function addProductImageInfo() {
      if(vm.isEdit){
        return ProductImageService.updateProductImageInfo(vm.productImageInfoDto).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('productImageInfo',  {imageCode : vm.productImageInfoDto.imageCode}, {reload: 'productImageInfo'});
          }
        })
      } else {
        return ProductImageService.insertProductImageInfo(vm.productImageInfoDto).then(function (data) {
          if(data.success){
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          }else {
            toastr.error($filter('T')("title.saveFail"), $filter('T')("title.confirmTitle"));
          }
          $uibModalInstance.close();
          return $state.go('productImageInfo',  {imageCode : vm.productImageInfoDto.imageCode}, {reload: 'productImageInfo'});
        })
      }
    }

    function init() {
      if(vm.productImageInfoDto.productImageId){
        vm.isEdit = true;
        ProductImageService.getAllProductImageInfo(vm.productImageInfoDto,1).then(function (data) {
          vm.productImageInfoDto = data.rows[0];
          if(vm.productImageInfoDto.imageUrl){
            vm.oldFile = vm.productImageInfoDto.imageUrl;
          }
        })
      } else {
        vm.selectOtherProduct();
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function changeFile() {
      if(vm.file){
        vm.imageChange = true;
        vm.oldFile=vm.file;
        vm.upload(vm.file);
      }
    }

    function selectOtherProduct() {
      return ProductImageService.selectOtherProduct(vm.productImageInfoDto).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.otherProductList = data.rows;
      })
    }

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/product/image/productImageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //upload success
        vm.productImageInfoDto.imageUrl = data.rows[0];
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
      });
    }


  }
})();

/**
 * Created by shi on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AddProductImageCodeController', AddProductImageCodeController);

  AddProductImageCodeController.$inject = ['entity',  '$uibModalInstance','$filter','toastr', 'ProductImageService','toastrConfig','$state'];
  /** @ngInject */
  function AddProductImageCodeController( entity, $uibModalInstance, $filter, toastr, ProductImageService,toastrConfig,$state) {
    var vm = this;
    vm.productImageDto = entity;
    vm.isEdit = false;
    vm.creatProductImageCode = creatProductImageCode;
    vm.clear = clear;
    vm.load = load;
    vm.getProductImageCode = getProductImageCode;

    vm.load();

    function creatProductImageCode() {
      console.log(vm.productImageDto.imageCode);
      if (!vm.isEdit) {
        return ProductImageService.creatProductImageCode(vm.productImageDto).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('productImageCode', null, {reload: 'productImageCode'});
          }
        })
      } else {
        return ProductImageService.editProductImageCode(vm.productImageDto).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('productImageCode', null, {reload: 'productImageCode'});
          }
        })
      }
    }
    function load() {
      if(vm.productImageDto.imageCode){
        vm.isEdit = true;
        vm.getProductImageCode(vm.productImageDto.imageCode);
      } else {
        vm.isEdit = false;
      }
    }

    function getProductImageCode(imageCode) {
      return ProductImageService.getAllProductImageCode(imageCode,1).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.productImageDto.imageCode = data.rows[0].imageCode;
        vm.productImageDto.description = data.rows[0].description;
      });
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('rolePermission', {
        parent: 'app',
        url: "/rolePermission",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/permission/html/rolePermission.html",
            controller: 'RolePermController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {};
              }
            }
          }
        }
      })
      .state('rolePermission.view', {
        parent: 'rolePermission',
        url: "/view/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/permission/html/permission-dialog.html',
            controller: 'PermDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id,
                  viewFlag: true,
                  editFlag: true
                };
              }
            }
          }).result.then(function () {
            $state.go('rolePermission');
          }, function () {
            $state.go('rolePermission');
          });
        }]
      })
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('RolePermService', RolePermService);

  RolePermService.$inject = ['$http', '$rootScope'];

  function RolePermService($http, $rootScope) {
    return {
      queryRolePermission: queryRolePermission,
      updateRolePermission: updateRolePermission
    };

    function queryRolePermission(entity) {
      var resourceUrl = '/api/permission/role/query?page=1&pageSize=-1';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function updateRolePermission(entity) {
      var resourceUrl = '/api/permission/role/update';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('RolePermController', RolePermController);

  RolePermController.$inject = ['$filter', '$translate', '$state', 'entity', 'RolePermService', 'PermService', 'RoleService', 'MessageTemplateService', 'paginationConstants', 'toastr', 'toastrConfig', 'SweetAlert'];

  function RolePermController($filter, $translate, $state, entity, RolePermService, PermService, RoleService, MessageTemplateService, paginationConstants, toastr, toastrConfig, SweetAlert) {

    var vm = this;
    vm.condition = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.copyRoleTitle = $filter('T')('permission.copyRole');

    vm.serviceList = [{value: "admin", meaning: "admin"}];
    vm.levelList = [
      {value: 'owner', meaning: $filter('T')('permission.ownerLevel')},
      {value: 'contributor', meaning: $filter('T')('permission.contributorLevel')},
      {value: 'reader', meaning: $filter('T')('permission.readerLevel')}
    ];

    vm.load = load;
    vm.search = search;
    vm.pageChanged = pageChanged;
    vm.reset = reset;
    vm.save = save;
    vm.checkAllItems = checkAllItems;
    vm.checkItem = checkItem;
    vm.queryRolePermission = queryRolePermission;
    vm.queryRole = queryRole;
    vm.searchRole = searchRole;
    vm.copyRole = copyRole;
    vm.validateService = validateService;
    vm.validateRole = validateRole;
    vm.queryPermission = queryPermission;
    vm.updateRolePermission = updateRolePermission;
    vm.viewPermission = viewPermission;
    vm.initService = initService;

    vm.initService();
    vm.load();

    function initService() {
      MessageTemplateService.getByCode().query({code:'SYS.PERMISSION_SERVICE'},function (data) {
        vm.serviceList = data.rows;
      },function (error) {
      });
    }

    function queryRolePermission() {
      var requestBody = {
        roleId: vm.copyRoleId ? vm.copyRoleId : vm.roleId,
        service: vm.condition.service
      };
      RolePermService.queryRolePermission(requestBody).then(function (response) {
        if (response.success) {
          vm.rolePermissions = response.rows;
          vm.search();
        }
      });
    }

    function queryRole() {
      RoleService.findRoles(1, -1).query({page: 1, pagesize: -1}, function (response) {
        if (response.success) {
          vm.roles = response.rows;
          if (vm.roles && vm.roles.length > 0) {
            vm.roleId = vm.roles[0].roleId + "";
            vm.selectRoleId = vm.roleId;
            var roleType = vm.roles[0].attribute1;
            if (roleType === 'kohler') {
              vm.condition.service = 'admin';
            } else {
              vm.condition.service = roleType;
            }
            vm.queryRolePermission();
          }
        }
      })
    }

    function searchRole() {
      if (vm.selectRoleId) {
        vm.roleId = vm.selectRoleId;
        vm.copyRoleId = null;
        vm.copyRoleTitle = $filter('T')('permission.copyRole');
        for (var i=0; i<vm.roles.length; i++) {
          if (vm.roles[i].roleId == vm.roleId) {
            var roleType = vm.roles[i].attribute1;
            if (roleType === 'kohler') {
              vm.condition.service = 'admin';
            } else {
              vm.condition.service = roleType;
            }
            break;
          }
        }
        vm.queryRolePermission();
      }
    }

    function copyRole() {
      if (!vm.selectCopyRoleId) {
        toastr.error($filter('T')('permission.copyRoleRequired'));
        return;
      }
      if (vm.copyRoleId !== vm.selectCopyRoleId) {
        vm.copyRoleId = vm.selectCopyRoleId;
        vm.copyRoleTitle = $filter('T')('permission.copyRoleConfirm');
        if (vm.copyRoleId === 'sa') {
          for (var i = 0; i < vm.permissions.length; i++) {
            vm.permissions[i].assigned = true;
          }
          if (vm.permissions.length > 0) {
            vm.allAssigned = true;
          } else {
            vm.allAssigned = false;
          }
        } else if (vm.copyRoleId === 'engr') {
          var num = 0;
          for (var i = 0; i < vm.permissions.length; i++) {
            var level = vm.permissions[i].level;
            if (level === 'contributor' || level === 'reader') {
              vm.permissions[i].assigned = true;
              num++;
            } else {
              vm.permissions[i].assigned = false;
            }
          }
          if (num > 0 && num === vm.permissions.length) {
            vm.allAssigned = true;
          } else {
            vm.allAssigned = false;
          }
        } else if (vm.copyRoleId === 'tourist') {
          var num = 0;
          for (var i = 0; i < vm.permissions.length; i++) {
            if (vm.permissions[i].level === 'reader') {
              vm.permissions[i].assigned = true;
              num++;
            } else {
              vm.permissions[i].assigned = false;
            }
          }
          if (num > 0 && num === vm.permissions.length) {
            vm.allAssigned = true;
          } else {
            vm.allAssigned = false;
          }
        } else if (vm.copyRoleId === 'none') {
          for (var i = 0; i < vm.permissions.length; i++) {
            vm.permissions[i].assigned = false;
          }
          vm.allAssigned = false;
        } else {
          vm.queryRolePermission();
        }
        SweetAlert.success($filter('T')("permission.copyRoleSuccess"), {title: $filter('T')("btnTypeName.prompt")});
      } else {
        var copyRole = vm.copyRoleId;
        if (copyRole === 'sa' || copyRole ==='engr' || copyRole === 'tourist' || copyRole === 'none') {
          copyRole = vm.condition.service + '.' + copyRole;
        }
        var requestBody = {
          roleId: vm.roleId,
          copyRole: copyRole
        };
        RolePermService.updateRolePermission(requestBody).then(function (response) {
          if (response.success) {
            vm.copyRoleId = null;
            vm.copyRoleTitle = $filter('T')('permission.copyRole');
            toastr.success($filter('T')('title.saveSuccess'));
            vm.queryRolePermission();
          } else {
            toastr.error($filter('T')('title.saveFail'));
          }
        }, function () {
          toastr.error($filter('T')('title.saveFail'));
        });
      }
    }

    function validateRole(role) {
      if (vm.roleId == role.roleId) return false;
      var roleType = role.attribute1;
      if (roleType === 'kohler') {
        return 'admin' === vm.condition.service;
      } else {
        return roleType === vm.condition.service;
      }
    }

    function validateService(service) {
      return service.value === vm.condition.service;
    }

    function queryPermission() {
      vm.selectRoleId = vm.roleId;
      vm.selectCopyRoleId = vm.copyRoleId;
      PermService.queryPermission(vm.condition, vm.page).then(function (response) {
        if (response.success) {
          vm.permissions = response.rows;
          vm.totalItems = response.total;
          vm.pageSize = response.rows.length;
          if (vm.copyRoleId === 'sa') {
            for (var i = 0; i < vm.permissions.length; i++) {
              vm.permissions[i].assigned = true;
            }
            if (vm.permissions.length > 0) {
              vm.allAssigned = true;
            } else {
              vm.allAssigned = false;
            }
          } else if (vm.copyRoleId === 'engr') {
            var num = 0;
            for (var i = 0; i < vm.permissions.length; i++) {
              var level = vm.permissions[i].level;
              if (level === 'contributor' || level === 'reader') {
                vm.permissions[i].assigned = true;
                num++;
              } else {
                vm.permissions[i].assigned = false;
              }
            }
            if (num > 0 && num === vm.permissions.length) {
              vm.allAssigned = true;
            } else {
              vm.allAssigned = false;
            }
          } else if (vm.copyRoleId === 'tourist') {
            var num = 0;
            for (var i = 0; i < vm.permissions.length; i++) {
              if (vm.permissions[i].level === 'reader') {
                vm.permissions[i].assigned = true;
                num++;
              } else {
                vm.permissions[i].assigned = false;
              }
            }
            if (num > 0 && num === vm.permissions.length) {
              vm.allAssigned = true;
            } else {
              vm.allAssigned = false;
            }
          } else if (vm.copyRoleId === 'none') {
            for (var i = 0; i < vm.permissions.length; i++) {
              vm.permissions[i].assigned = false;
            }
            vm.allAssigned = false;
          } else {
            vm.allAssigned = false;
            if (vm.rolePermissions) {
              var num = 0;
              for (var i = 0; i < vm.permissions.length; i++) {
                for (var j = 0; j < vm.rolePermissions.length; j++) {
                  if (vm.permissions[i].id === vm.rolePermissions[j].permissionId) {
                    vm.permissions[i].assigned = true;
                    num++;
                    break;
                  }
                }
              }
              if (num > 0 && num === vm.permissions.length) {
                vm.allAssigned = true;
              }
            }
          }
        }
      });
    }

    function updateRolePermission() {
      var allItems = [];
      var checkItems = [];
      var arrChk = $("input[name='chk_list']");
      $(arrChk).each(function () {
        if ($(this).is(':checked')) {
          checkItems.push(this.value);
        }
        allItems.push(this.value);
      });
      var requestBody = {
        roleId: vm.roleId,
        permissionIds: checkItems,
        deletePermissionIds: allItems
      };
      RolePermService.updateRolePermission(requestBody).then(function (response) {
        if (response.success) {
          toastr.success($filter('T')('title.saveSuccess'));
          vm.queryRolePermission();
        } else {
          toastr.error($filter('T')('title.saveFail'));
        }
      }, function () {
        toastr.error($filter('T')('title.saveFail'));
      });
    }

    function viewPermission(entity) {
      if (entity.isDelete === 'Y') {
        SweetAlert.error($translate.instant("permission.deletedNotView"), {title: $filter('T')("btnTypeName.prompt")});
      } else {
        $state.go('rolePermission.view', {id: entity.id});
      }
    }

    function checkItem() {
      var arrChk = $("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    function checkAllItems() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    function load() {
      vm.queryRole();
    }

    function pageChanged() {
      vm.queryPermission();
    }

    function search() {
      vm.queryPermission();
    }

    function reset() {
      vm.condition = {service: vm.condition.service};
    }

    function save() {
      vm.updateRolePermission();
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('ResPermService', ResPermService);

  ResPermService.$inject = ['$http', '$rootScope'];

  function ResPermService($http, $rootScope) {
    return {
      queryResourcePermission: queryResourcePermission,
      updateResourcePermission: updateResourcePermission
    };

    function queryResourcePermission(entity) {
      var resourceUrl = '/api/permission/resource/query?page=1&pageSize=-1';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function updateResourcePermission(entity) {
      var resourceUrl = '/api/permission/resource/update';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ResPermDialogController', ResPermDialogController);

  ResPermDialogController.$inject = ['$filter', '$translate', '$state', 'entity', 'ResPermService', 'PermService', 'MessageTemplateService', 'paginationConstants', '$uibModalInstance', 'toastr', 'toastrConfig', 'SweetAlert'];

  function ResPermDialogController($filter, $translate, $state, entity, ResPermService, PermService, MessageTemplateService, paginationConstants, $uibModalInstance, toastr, toastrConfig, SweetAlert) {

    var vm = this;
    vm.condition = {};
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.resourceId = entity.resourceId;

    vm.serviceList = [{value: "admin", meaning: "admin"}];
    vm.levelList = [
      {value: 'owner', meaning: $filter('T')('permission.ownerLevel')},
      {value: 'contributor', meaning: $filter('T')('permission.contributorLevel')},
      {value: 'reader', meaning: $filter('T')('permission.readerLevel')}
    ];

    vm.load = load;
    vm.search = search;
    vm.pageChanged = pageChanged;
    vm.reset = reset;
    vm.save = save;
    vm.clear = clear;
    vm.checkAllItems = checkAllItems;
    vm.checkItem = checkItem;
    vm.queryPermission = queryPermission;
    vm.updateResourcePermission = updateResourcePermission;
    vm.initService = initService;

    vm.initService();
    vm.load();

    function initService() {
      MessageTemplateService.getByCode().query({code:'SYS.PERMISSION_SERVICE'},function (data) {
        vm.serviceList = data.rows;
      },function (error) {
      });
    }

    function queryPermission() {
      PermService.queryPermission(vm.condition, vm.page).then(function (response) {
        if (response.success) {
          vm.permissions = response.rows;
          vm.totalItems = response.total;
          vm.pageSize = response.rows.length;
        }
      });
    }

    function updateResourcePermission() {
      var checkItems = [];
      var isCheck = $(".chk_list").is(':checked');
      if (isCheck) {
        var arrChk = $("input[name='chk_list']:checked");
        $(arrChk).each(function () {
          checkItems.push(this.value);
        });
      }
      var requestBody = {
        resourceId: vm.resourceId,
        permissionIds: checkItems
      };
      ResPermService.updateResourcePermission(requestBody).then(function (response) {
        if (response.success) {
          toastr.success($filter('T')('title.saveSuccess'));
          $uibModalInstance.close();
        } else {
          toastr.error($filter('T')('title.saveFail'));
        }
      }, function () {
        toastr.error($filter('T')('title.saveFail'));
      });
    }

    function checkItem() {
      var arrChk = $("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    function checkAllItems() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    function load() {
      vm.queryPermission();
    }

    function pageChanged() {
      vm.queryPermission();
    }

    function search() {
      vm.queryPermission();
    }

    function reset() {
      vm.condition = {};
    }

    function save() {
      vm.updateResourcePermission();
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('permissionScope', {
        parent: 'app',
        url: "/permissionScope",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/permission/html/permissionScope.html",
            controller: 'PermScopeController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {};
              }
            }
          }
        }
      })
      .state('permissionScope.edit', {
        parent: 'permissionScope',
        url: "/edit/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/permission/html/permissionScope-dialog.html',
            controller: 'PermScopeDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id,
                  editFlag: true
                };
              }
            }
          }).result.then(function () {
            $state.go('permissionScope', null, {reload: 'permissionScope'});
          }, function () {
            $state.go('permissionScope', null, {reload: 'permissionScope'});
          });
        }]
      })
      .state('permissionScope.add', {
        parent: 'permissionScope',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/permission/html/permissionScope-dialog.html',
            controller: 'PermScopeDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  editFlag: false
                }
              }
            }
          }).result.then(function () {
            $state.go('permissionScope', null, {reload: 'permissionScope'});
          }, function () {
            $state.go('permissionScope', null, {reload: 'permissionScope'});
          });
        }]
      })
      .state('permissionScope.reload', {
        parent: 'permissionScope',
        url: "/reload",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/permission/html/permission-reload-dialog.html',
            controller: 'PermReloadDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            resolve: {
              entity: function () {
                return {}
              }
            }
          }).result.then(function () {
            $state.go('permissionScope');
          }, function (p) {
            $state.go('permissionScope');
          });
        }]
      })
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('PermScopeService', PermScopeService);

  PermScopeService.$inject = ['$http', '$rootScope'];

  function PermScopeService($http, $rootScope) {
    return {
      queryScope: queryScope,
      createScope: createScope,
      updateScope: updateScope,
      deleteScope: deleteScope,
      reloadPermission: reloadPermission,
      selectedScope: {},
    };

    function queryScope(entity, page) {
      var resourceUrl = '/api/permission/scope/query?page=' + page;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function createScope(entity) {
      var resourceUrl = '/api/permission/scope/create';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function updateScope(entity) {
      var resourceUrl = '/api/permission/scope/update';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function deleteScope(entity) {
      var resourceUrl = '/api/permission/scope/delete';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function reloadPermission(entity) {
      var resourceUrl = '/api/permission/reload';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('PermScopeController', PermScopeController);

  PermScopeController.$inject = ['$filter', '$translate', '$state', 'entity', 'PermScopeService', 'MessageTemplateService', 'paginationConstants', 'toastr', 'toastrConfig', 'SweetAlert'];

  function PermScopeController($filter, $translate, $state, entity, PermScopeService, MessageTemplateService, paginationConstants, toastr, toastrConfig, SweetAlert) {

    var vm = this;
    vm.condition = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.condition.service = "admin";
    vm.serviceList = [{value: "admin", meaning: "admin"}];
    vm.typeList = [
      {value: 'package', meaning: $filter('T')('permission.packagePath')},
      {value: 'class', meaning: $filter('T')('permission.classPath')},
      {value: 'method', meaning: $filter('T')('permission.methodPath')},
    ];

    vm.load = load;
    vm.search = search;
    vm.pageChanged = pageChanged;
    vm.reset = reset;
    vm.checkAllItems = checkAllItems;
    vm.checkItem = checkItem;
    vm.queryScope = queryScope;
    vm.addScope = addScope;
    vm.editScope = editScope;
    vm.deleteScope = deleteScope;
    vm.reloadPermission = reloadPermission;
    vm.initService = initService;

    vm.initService();
    vm.load();

    function initService() {
      MessageTemplateService.getByCode().query({code:'SYS.PERMISSION_SERVICE'},function (data) {
        vm.serviceList = data.rows;
      },function (error) {
      });
    }

    function queryScope() {
      PermScopeService.queryScope(vm.condition, vm.page).then(function (response) {
        if (response.success) {
          vm.scopes = response.rows;
          vm.totalItems = response.total;
          vm.pageSize = response.rows.length;
        }
      });
    }

    function addScope() {
      PermScopeService.selectedScope = {
        service: vm.condition.service
      };
      $state.go('permissionScope.add');
    }

    function editScope(entity) {
      PermScopeService.selectedScope = {
        service: vm.condition.service
      };
      $state.go('permissionScope.edit', {id: entity.id});
    }

    function deleteScope(entity) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          var requestBody = {id: entity.id};
          PermScopeService.deleteScope(requestBody).then(function (response) {
            if (response.success) {
              toastr.success($filter('T')('title.deleteSuccess'));
              search();
            } else {
              toastr.error($filter('T')('title.deleteFail'));
            }
          }, function () {
            toastr.error($filter('T')('title.deleteFail'));
          });
        }
      });
    }

    function reloadPermission() {
      var checkItems = [];
      var isCheck = $(".chk_list").is(':checked');
      if (isCheck) {
        var arrChk = $("input[name='chk_list']:checked");
        $(arrChk).each(function () {
          checkItems.push(this.value);
        });
      }
      PermScopeService.selectedScope = {
        service: vm.condition.service,
        scopeIds: checkItems
      };
      $state.go('permissionScope.reload');
    }

    function load() {
      vm.queryScope();
    }

    function pageChanged() {
      vm.queryScope();
    }

    function search() {
      vm.queryScope();
    }

    function reset() {
      vm.condition = {service: "admin"};
    }

    function checkItem() {
      var arrChk = $("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    function checkAllItems() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('PermScopeDialogController', PermScopeDialogController);

  PermScopeDialogController.$inject = ['$filter', '$translate', '$scope', 'entity', 'PermScopeService', '$uibModalInstance', 'toastr', 'toastrConfig', 'SweetAlert'];

  function PermScopeDialogController($filter, $translate, $scope, entity, PermScopeService, $uibModalInstance, toastr, toastrConfig, SweetAlert) {

    var vm = this;
    vm.scope = {
      id: entity.id,
      service: PermScopeService.selectedScope.service
    };
    vm.isSaving = false;
    vm.isEdit = entity.editFlag;
    vm.title = vm.isEdit ? $filter('T')('permission.updateScope') : $filter('T')('permission.createScope');

    vm.typeList = [
      {value: 'package', meaning: $filter('T')('permission.packagePath')},
      {value: 'class', meaning: $filter('T')('permission.classPath')},
      {value: 'method', meaning: $filter('T')('permission.methodPath')}
    ];

    vm.load = load;
    vm.save = save;
    vm.clear = clear;

    vm.load();

    function load() {
      if (vm.isEdit) {
        var requestBody = {id: vm.scope.id};
        PermScopeService.queryScope(requestBody, 1).then(function (response) {
          if (response.success && response.rows && response.rows.length > 0) {
            vm.scope = response.rows[0];
          } else {
            toastr.error($filter('T')('title.queryFailed'));
          }
        });
      }
    }

    function save() {
      vm.isSaving = true;
      if (vm.isEdit) {
        PermScopeService.updateScope(vm.scope).then(function (response) {
          vm.isSaving = false;
          if (response.success) {
            toastr.success($filter('T')('title.saveSuccess'));
            $uibModalInstance.close();
          } else {
            toastr.error($filter('T')('title.saveFail'));
          }
        }, function () {
          vm.isSaving = false;
          toastr.error($filter('T')('title.saveFail'));
        });
      } else {
        PermScopeService.createScope(vm.scope).then(function (response) {
          vm.isSaving = false;
          if (response.success) {
            toastr.success($filter('T')('title.saveSuccess'));
            $uibModalInstance.close();
          } else {
            toastr.error($filter('T')('title.saveFail'));
          }
        }, function () {
          vm.isSaving = false;
          toastr.error($filter('T')('title.saveFail'));
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('permission', {
        parent: 'app',
        url: "/permission",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/permission/html/permission.html",
            controller: 'PermController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {};
              }
            }
          }
        }
      })
      .state('permission.edit', {
        parent: 'permission',
        url: "/edit/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/permission/html/permission-dialog.html',
            controller: 'PermDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id,
                  editFlag: true,
                };
              }
            }
          }).result.then(function () {
            $state.go('permission', null, {reload: 'permission'});
          }, function () {
            $state.go('permission', null, {reload: 'permission'});
          });
        }]
      })
      .state('permission.add', {
        parent: 'permission',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/permission/html/permission-dialog.html',
            controller: 'PermDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  service: $stateParams.service,
                  editFlag: false
                }
              }
            }
          }).result.then(function () {
            $state.go('permission', null, {reload: 'permission'});
          }, function () {
            $state.go('permission', null, {reload: 'permission'});
          });
        }]
      })
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('PermService', PermService);

  PermService.$inject = ['$http', '$rootScope'];

  function PermService($http, $rootScope) {
    return {
      queryPermission: queryPermission,
      createPermission: createPermission,
      updatePermission: updatePermission,
      deletePermission: deletePermission,
      selectedPermission: {}
    };

    function queryPermission(entity, page) {
      var resourceUrl = '/api/permission/query?page=' + page;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function createPermission(entity) {
      var resourceUrl = '/api/permission/create';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function updatePermission(entity) {
      var resourceUrl = '/api/permission/update';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function deletePermission(entity) {
      var resourceUrl = '/api/permission/delete';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('PermController', PermController);

  PermController.$inject = ['$filter', '$translate', '$state', 'entity', 'PermService', 'MessageTemplateService', 'paginationConstants', 'toastr', 'toastrConfig', 'SweetAlert'];

  function PermController($filter, $translate, $state, entity, PermService, MessageTemplateService, paginationConstants, toastr, toastrConfig, SweetAlert) {

    var vm = this;
    vm.condition = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.condition.service = "admin";
    vm.serviceList = [{value: "admin", meaning: "admin"}];
    vm.levelList = [
      {value: 'owner', meaning: $filter('T')('permission.ownerLevel')},
      {value: 'contributor', meaning: $filter('T')('permission.contributorLevel')},
      {value: 'reader', meaning: $filter('T')('permission.readerLevel')},
    ];

    vm.load = load;
    vm.search = search;
    vm.pageChanged = pageChanged;
    vm.reset = reset;
    vm.queryPermission = queryPermission;
    vm.addPermission = addPermission;
    vm.editPermission = editPermission;
    vm.deletePermission = deletePermission;
    vm.goPermissoinScope = goPermissoinScope;
    vm.initService = initService;

    vm.initService();
    vm.load();

    function initService() {
      MessageTemplateService.getByCode().query({code:'SYS.PERMISSION_SERVICE'},function (data) {
        vm.serviceList = data.rows;
      },function (error) {
      });
    }

    function queryPermission() {
      PermService.queryPermission(vm.condition, vm.page).then(function (response) {
        if (response.success) {
          vm.permissions = response.rows;
          vm.totalItems = response.total;
          vm.pageSize = response.rows.length;
        }
      });
    }

    function addPermission() {
      PermService.selectedPermission = {
        service: vm.condition.service
      };
      $state.go('permission.add');
    }

    function editPermission(entity) {
      if (entity.isDelete === 'Y') {
        SweetAlert.error($translate.instant("permission.deletedNotUpdate"), {title: $filter('T')("btnTypeName.prompt")});
      } else {
        PermService.selectedPermission = {
          service: vm.condition.service,
          isCustom: entity.isCustom
        };
        $state.go('permission.edit', {id: entity.id});
      }
    }

    function deletePermission(entity) {
      if (entity.isCustom === 'Y' || entity.isDelete === 'Y') {
        SweetAlert.confirm($filter('T')("plugin.deleteConfirm"),
          {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
          if (p) {
            var requestBody = {id: entity.id};
            PermService.deletePermission(requestBody).then(function (response) {
              if (response.success) {
                toastr.success($filter('T')('title.deleteSuccess'));
                search();
              } else {
                toastr.error($filter('T')('title.deleteFail'));
              }
            }, function () {
              toastr.error($filter('T')('title.deleteFail'));
            });
          }
        });
      } else {
        SweetAlert.error($translate.instant("permission.canNotDelete"), {title: $filter('T')("btnTypeName.prompt")});
      }
    }

    function load() {
      vm.queryPermission();
    }

    function pageChanged() {
      vm.queryPermission();
    }

    function search() {
      vm.queryPermission();
    }

    function reset() {
      vm.condition = {service: "admin"};
    }

    function goPermissoinScope() {
      $state.go('permissionScope');
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('PermReloadDialogController', PermReloadDialogController);

  PermReloadDialogController.$inject = ['$filter', '$translate', '$scope', 'entity', 'PermScopeService', '$uibModalInstance', 'toastr', 'toastrConfig', 'SweetAlert'];

  function PermReloadDialogController($filter, $translate, $scope, entity, PermScopeService, $uibModalInstance, toastr, toastrConfig, SweetAlert) {

    var vm = this;
    vm.scope = {
      service: PermScopeService.selectedScope.service,
      scopeIds: PermScopeService.selectedScope.scopeIds,
      override: 'true'
    };
    vm.isSaving = false;
    vm.title = $filter('T')('permission.scanPermission');

    vm.flagList = [
      {value: 'true', meaning: $filter('T')('appEdition.yes')},
      {value: 'false', meaning: $filter('T')('appEdition.no')}
    ];

    // vm.load = load;
    vm.save = save;
    vm.clear = clear;

    function save() {
      vm.isSaving = true;
      PermScopeService.reloadPermission(vm.scope).then(function (response) {
        vm.isSaving = false;
        if (response.success) {
          SweetAlert.success($filter('T')('permission.scanPermissionSuccess'),
            {title: $filter('T')('btnTypeName.prompt')}).then(function () {
            $uibModalInstance.close();
          });
        } else {
          toastr.error($filter('T')('title.operationFailed'));
        }
      }, function () {
        vm.isSaving = false;
        toastr.error($filter('T')('title.operationFailed'));
      });
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by linyanhui.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('PermDialogController', PermDialogController);

  PermDialogController.$inject = ['$filter', '$translate', '$scope', 'entity', 'PermService', 'PromptService', 'RoleService', '$uibModalInstance', 'toastr', 'toastrConfig', 'SweetAlert'];

  function PermDialogController($filter, $translate, $scope, entity, PermService, PromptService, RoleService, $uibModalInstance, toastr, toastrConfig, SweetAlert) {

    var vm = this;
    vm.permission = {
      id: entity.id,
      service: PermService.selectedPermission.service,
      isCustom: PermService.selectedPermission.isCustom
    };
    vm.isSaving = false;
    vm.isEdit = entity.editFlag;
    vm.isView = entity.viewFlag;
    vm.title = $filter('T')('permission.createPermission');
    if (vm.isView) {
      vm.title = $filter('T')('permission.viewPermission')
    } else if (vm.isEdit) {
      vm.title = $filter('T')('permission.updatePermission')
    }
    vm.isCustom = vm.permission.isCustom === 'Y';
    if (!vm.isEdit) {
      vm.permission.enable = 'Y';
      vm.permission.userLogin = 'Y';
      vm.permission.clientLogin = 'Y';
      vm.permission.isPublic = 'N';
    }

    vm.levelList = [
      {value: 'owner', meaning: $filter('T')('permission.ownerLevel')},
      {value: 'contributor', meaning: $filter('T')('permission.contributorLevel')},
      {value: 'reader', meaning: $filter('T')('permission.readerLevel')}
    ];
    vm.flagList = [
      {value: 'Y', meaning: $filter('T')('appEdition.yes')},
      {value: 'N', meaning: $filter('T')('appEdition.no')}
    ];

    vm.load = load;
    vm.save = save;
    vm.clear = clear;
    vm.initLangs = initLangs;
    vm.loadMultiLang = loadMultiLang;
    vm.showLocale = showLocale;
    vm.localeSure = localeSure;

    vm.load();

    function load() {
      if (vm.isEdit) {
        var requestBody = {id: vm.permission.id};
        PermService.queryPermission(requestBody, 1).then(function (response) {
          if (response.success && response.rows && response.rows.length > 0) {
            vm.permission = response.rows[0];
            loadMultiLang(vm.permission.id);
          } else {
            toastr.error($filter('T')('title.queryFailed'));
          }
        });
      }
    }

    function save() {
      vm.isSaving = true;
      if (vm.isEdit) {
        PermService.updatePermission(vm.permission).then(function (response) {
          vm.isSaving = false;
          if (response.success) {
            toastr.success($filter('T')('title.saveSuccess'));
            $uibModalInstance.close();
          } else if (response.message === 'Invalid permission method') {
            toastr.error($filter('T')('permission.invalidMethod'));
          } else {
            toastr.error($filter('T')('title.saveFail'));
          }
        }, function () {
          vm.isSaving = false;
          toastr.error($filter('T')('title.saveFail'));
        });
      } else {
        PermService.createPermission(vm.permission).then(function (response) {
          vm.isSaving = false;
          if (response.success) {
            toastr.success($filter('T')('title.saveSuccess'));
            $uibModalInstance.close();
          } else if (response.message === 'Invalid permission method') {
            toastr.error($filter('T')('permission.invalidMethod'));
          } else {
            toastr.error($filter('T')('title.saveFail'));
          }
        }, function () {
          vm.isSaving = false;
          toastr.error($filter('T')('title.saveFail'));
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#descriptionBtn").attr("disabled", false);
      });
    }
    initLangs();

    function loadMultiLang(id) {
      var nameList = {};
      var __tls = {};
      RoleService.getRoleLocaleInfo(id, 'com.kohler.iot.integrator.hms.permission.entities.PermissionInfo', 'description')
        .then(function (data) {
          nameList = {};
          for (var i in data) {
            nameList[data[i].langCode] = data[i].value;
          }
          __tls['description'] = nameList;
          vm.permission.__tls = __tls;
          $("#descriptionBtn").attr("disabled", false);
        });
    }

    function showLocale(name) {
      $("#localeModal_" + name).modal("show");
      if ($.trim($("#localeModelBody_" + name).html()) == "") {
        for (var i in langs) {
          var inputName = name + "_" + langs[i].langCode;
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='" + inputName
            + "' ng-model='vm.permission.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_" + name).append(div);
          if (vm.isEdit) {
            $("input[name='" + inputName + "']")
              .val(vm.permission.__tls[name][langs[i].langCode])
              .attr('disabled', vm.isView);
          }
        }
      }
    }

    function localeSure(name) {
      var __tls = vm.permission.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + name + "_" + langs[i].langCode + "']").val();
      }
      vm.permission[name] = $("input[name='" + name + "_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_" + name).modal("hide");
      __tls[name] = description;
      vm.permission.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by xiawangliu on 2017/7/25.
 */
(function () {
  'use strict';

  angular.module('hmapFront').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('groupHeader', {
        parent: 'app',
        url: "/groupHeader",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ogm/html/group.html",
            controller: 'GroupController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {}
          }
        }
      })

      .state('groupHeader.add', {
        parent: 'groupHeader',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/iot/portal/admin/ogm/html/addGroup.html",
            controller: 'AddGroupController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  groupType: 'commercial'
                }
              }
            }
          }).result.then(function () {
            $state.go('groupHeader', null, {reload: 'groupHeader'});
          }, function () {
            $state.go('groupHeader');
          });
        }]
      })

      .state('groupHeader.edit', {
        parent: 'groupHeader',
        url: "/edit/{groupId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/iot/portal/admin/ogm/html/addGroup.html",
            controller: 'AddGroupController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  groupId: $stateParams.groupId
                }
              }
            }
          }).result.then(function () {
            $state.go('groupHeader', null, {reload: 'groupHeader'});
          }, function () {
            $state.go('groupHeader');
          });
        }]
      })
  }
})();

/**
 * Created by mclin on 2017-4-28.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('GroupService', GroupService);

  GroupService.$inject = ['$resource', '$http'];

  function GroupService($resource, $http) {
    var service = {
      queryGroups: queryGroups,
      queryGroupName:queryGroupName,
      saveGroup:saveGroup,
      updateGroup:updateGroup,
      deleteGroup:deleteGroup,
      getGroupLineLocaleInfo:getGroupLineLocaleInfo
    };
    return service;

    function queryGroups(data, schema) {
      var resourceUrl = '/api/group/query?page=' + data.page + "&pageSize=" + data.pageSize + '&schema=' + schema;
      return $http.post(resourceUrl, {groupName: data.groupName,referenceSource:"commercial",parentGroupId:-1}, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function queryGroupName(data, page, schema) {
      var resourceUrl = '/api/group/queryGroup?page=' + page + '&schema=' + schema;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function saveGroup(data, schema) {
      var resourceUrl = '/api/group/saveGroup?schema=' + schema;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function updateGroup(data, schema) {
      var resourceUrl = '/api/group/updateGroup?schema=' + schema;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function deleteGroup(data, schema) {
      var resourceUrl = '/api/group/deleteGroup?schema=' + schema;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    //get product locale info
    function getGroupLineLocaleInfo(code, dto, field,schema) {
      var resourceUrl = '/api/sys/multiLanguageSchema?id=' + code + "&dto=" + dto + "&field=" + field + "&schema=" + schema;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
  }

})();

/**
 * Created by xiawang.liu on 2017/7/31.
 */

(function () {
  'use strict';

  angular.module('hmapFront').controller('GroupController', GroupController);

  GroupController.$inject = ['GroupService', '$state', 'paginationConstants', 'entity', 'toastr', 'toastrConfig', 'SweetAlert', '$filter'];

  function GroupController(GroupService, $state, paginationConstants, entity, toastr, toastrConfig, SweetAlert, $filter) {
    var vm = this;
    vm.group = entity;

    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.schema = 'com';

    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.remove = remove;

    vm.search();

    function loadAll(group,page) {
      return GroupService.queryGroupName(group, page, vm.schema).then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
        })
    }

    function search() {
      if (vm.group.groupName === null || vm.group.groupName === "") {
        vm.group.groupName = "";
      }
      loadAll(vm.group, vm.page);
    }

    function pageChanged() {
      loadAll(vm.group, vm.page);
    }

    function remove(entity) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          GroupService.deleteGroup({groupId: entity.groupId}, vm.schema).then( function (response) {
            if (response.success) {
              toastr.success($filter('T')('title.deleteSuccess'));
              search();
            } else if (response.code === 'canNotDelete') {
              toastr.error($filter('T')('group.canNotDelete'));
            } else if (response.code === 'canNotDeleteForUser') {
              toastr.error($filter('T')('group.canNotDeleteForUser'));
            } else {
              toastr.error($filter('T')('title.deleteFail'));
            }
          }, function () {
            toastr.error($filter('T')('title.deleteFail'));
          });
        }
      });
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by mclin on 2017-4-28.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('GroupDialogController', GroupDialogController);

  GroupDialogController.$inject = ['GroupService', 'paginationConstants', 'entity', '$state', '$uibModalInstance', '$log', 'PartyService'];

  function GroupDialogController(GroupService, paginationConstants, entity, $state, $uibModalInstance, $log, PartyService) {
    var vm = this;

    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.schema = 'com';

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.save = save;
    vm.loadAll = loadAll;

    vm.groups = [];
    vm.selectedGroup = {};

    // query condition
    vm.searchGroupName = null;

    vm.clear = clear;

    vm.loadAll();
    function loadAll() {
      GroupService.queryGroups({
        groupName: (vm.searchGroupName == undefined) ? null : vm.searchGroupName,
        page: vm.page,
        pageSize: paginationConstants.itemsPerPage
      }, vm.schema).then(function(response){
        vm.groups = response.rows;
        vm.totalItems =  response.total;
      });
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function onError(error) {
    }

    function pageChanged() {
      loadAll();
    }

    function save() {
      PartyService.shareGroup(vm.selectedGroup);
      $uibModalInstance.close();
    }
  }
})();

/**
 * Created by zyl on 2017/7/31.
 */

(function () {
  'use strict';

  angular.module('hmapFront').controller('AddGroupController', AddGroupController);

  AddGroupController.$inject = ['PromptService', 'GroupService', '$state', '$uibModalInstance', 'paginationConstants', 'entity', 'SweetAlert', 'toastr', '$filter'];

  function AddGroupController(PromptService, GroupService, $state, $uibModalInstance, paginationConstants, entity, SweetAlert, toastr, $filter) {
    var vm = this;
    vm.group = entity;
    vm.schema = 'com';
    vm.saveGroup = saveGroup;
    vm.showDescription = showDescription;
    vm.showGroupName = showGroupName;
    vm.localeSure = localeSure;
    vm.localeSureGroupName = localeSureGroupName;
    vm.load = load;
    vm.clear = clear;
    vm.initLangs = initLangs;
    vm.initLangs();
    vm.load();

    // langs
    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn_description").attr("disabled", false);
        $("#localeBtn_groupName").attr("disabled", false);
      });
    }

    //init load
    function load() {
      if (vm.group.groupId) {
        GroupService.queryGroupName(vm.group, 1, vm.schema).then(function (result) {
          vm.group = result.rows[0];
          GroupService.getGroupLineLocaleInfo(vm.group.groupId, 'com.iot.portal.admin.ogm.dto.OgmGroupDTO', $("#localeBtn_groupName").val(),vm.schema)
          .then(function(data){
            var __tls = {};
            var groupName = {};
            for (var i in data) {
              groupName[data[i].langCode] = data[i].value;
            }
            __tls[$("#localeBtn_groupName").val()] = groupName;
            GroupService.getGroupLineLocaleInfo(vm.group.groupId, 'com.iot.portal.admin.ogm.dto.OgmGroupDTO', $("#localeBtn_description").val(),vm.schema)
              .then(function (data) {
                var description = {};
                for (var i in data) {
                  description[data[i].langCode] = data[i].value;
                }
                __tls[$("#localeBtn_description").val()] = description;
                vm.group.__tls = __tls;
                $("#localeBtn_groupName").attr("disabled", false);
                $("#localeBtn_description").attr("disabled", false);
              })
          })
        })
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function saveGroup() {
      if (!vm.group.groupId) {
        return GroupService.saveGroup(vm.group, vm.schema).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('groupHeader', null, {reload: 'groupHeader'});
          }
        })
      }
      else {
        return GroupService.updateGroup(vm.group, vm.schema).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('groupHeader', null, {reload: 'groupHeader'});
          }
        })
      }
    }

    function showDescription() {
      $("#localeModal").modal("show");
      if ($.trim($("#localeModelBody").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "description' ng-model='vm.group.__tls." + $("#localeBtn_description").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody").append(div);
            if (vm.group.groupId) {
              $("input[name='" + langs[i].langCode + "description']").val(vm.group.__tls[$("#localeBtn_description").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showGroupName() {
      $("#localeModalGroupName").modal("show");
      if ($.trim($("#localeModelBodyGroupName").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "groupName' ng-model='vm.group.__tls." + $("#localeBtn_groupName").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBodyGroupName").append(div);
            if (vm.group.groupId) {
              $("input[name='" + langs[i].langCode + "groupName']").val(vm.group.__tls[$("#localeBtn_groupName").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    //save desc model
    function localeSure() {
      var __tls = vm.group.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "description']").val();
      }
      var btnValue = $("#localeBtn_description").val();
      vm.group[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "description']").val();
      $("#localeModal").modal("hide");
      __tls[btnValue] = description;
      vm.group.__tls = __tls;
    }

    //save desc model
    function localeSureGroupName() {
      var __tls = vm.group.__tls || {};
      var groupName = {};
      for (var i in langs) {
        groupName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "groupName']").val();
      }
      var btnValue = $("#localeBtn_groupName").val();
      vm.group[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "groupName']").val();
      $("#localeModalGroupName").modal("hide");
      __tls[btnValue] = groupName;
      vm.group.__tls = __tls;
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/08/13.
 */

(function () {
  'use strict';

  angular.module('hmapFront').config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('mlattribute', {
        parent: 'app',
        url: "/mlattribute/{productId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ml/html/mlproductattribute.html",
            controller: 'MlProductAttributeController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams', function ($stateParams) {
            return {
              productId : $stateParams.productId
            };
          }]
        }
      })
      .state('mlattribute.add', {
        parent: 'mlattribute',
        url: "/add/{productId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ml/html/addmlattribute.html',
            controller: 'AddMlAttributeController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  productId: $stateParams.productId
                }
              }
            }
          }).result.then(function () {
            $state.go('mlattribute', null, {reload: true});
          }, function () {
            $state.go('mlattribute');
          });
        }]
      })
      .state('mlattribute.edit', {
        parent: 'mlattribute',
        url: "/edit/:propertyId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ml/html/addProductProperty.html',
            controller: 'AddProductPropertyController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  propertyId: $stateParams.propertyId
                }
              }
            }
          }).result.then(function () {
            $state.go('mlattribute');
          }, function () {
            $state.go('mlattribute');
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/08/13.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('MlProductAttributeController', MlProductAttributeController);

  MlProductAttributeController.$inject = ['MlProductService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', '$state', 'MessageTemplateService'];

  function MlProductAttributeController(MlProductService, paginationConstants, entity, SweetAlert, $filter, $state, MessageTemplateService) {
    var vm = this;
    vm.property = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkProperty = checkProperty;
    vm.checkAllProperty = checkAllProperty;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetProperty = resetProperty;
    vm.deleteProperty = deleteProperty;
    vm.deletePropertys = deletePropertys;
    vm.getProperty = getProperty;
    vm.initWeidget = initWeidget;

    vm.initWeidget();
    vm.getProperty();

    //get Property
    function getProperty() {
      return MlProductService.getProperty(vm.property, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.propertys = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search property
    function search() {
      vm.getProperty();
    }

    //reset Property
    function resetProperty() {
      vm.property.productPropertyCode = undefined;
      vm.property.productPropertyName = undefined;
    }

    //delete Property
    function deleteProperty(property) {
      SweetAlert.confirm(property.productPropertyCode + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var propertys = new Array();
          var entity = new Object();
          entity.attributeId = property.attributeId;
          propertys.push(entity);
          MlProductService.deletePropertys(propertys).then(function (response) {
            if (response.success) {
              vm.getProperty();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete Property
    function deletePropertys() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var propertys = new Array();
          $(arrChk).each(function() {
            var property = new Object();
            property.attributeId = this.value;
            propertys.push(property);
          });
          MlProductService.deletePropertys(propertys).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getProperty();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getProperty();
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'IOT.DVM_ATTRIBUTE_TYPE'},function (data) {
        vm.attributeType = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'IOT.DVM_ATTRIBUTE_RULE_TYPE'},function (data) {
        vm.ruleType = data.rows;
      },function (error) {
      });
    }

    //check or unCheck check Property
    function checkProperty() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Property
    function checkAllProperty() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/08/13.
 */

(function () {
  'use strict';

  angular.module('hmapFront').config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('mlproduct', {
        parent: 'app',
        url: "/mlproduct",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ml/html/mlproduct.html",
            controller: 'MlProductController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {};
          }
        }
      })
      .state('mlproduct.add', {
        parent: 'mlproduct',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ml/html/addmlproduct.html',
            controller: 'AddMlProductController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {}
              }
            }
          }).result.then(function () {
            $state.go('mlproduct', null, {reload: true});
          }, function () {
            $state.go('mlproduct');
          });
        }]
      })
      .state('mlproduct.edit', {
        parent: 'mlproduct',
        url: "/edit/:productId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ml/html/addProduct.html',
            controller: 'AddMlProductController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  productId: $stateParams.productId
                }
              }
            }
          }).result.then(function () {
            $state.go('mlproduct');
          }, function () {
            $state.go('mlproduct');
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/08/13.
 */


(function () {
  'use strict';

  angular.module('hmapFront').factory('MlProductService', MlProductService);

  MlProductService.$inject = ['$http'];

  function MlProductService($http) {
    return {
      getProduct: getProduct,
      getProductType: getProductType,
      getProperty: getProperty,
      getProductLocaleInfo: getProductLocaleInfo,
      getProductsNotInMl : selectProductsNotInMl,
      getAction : getAction,
      getAttributeNotInMl : getAttributeNotInMl,

      deleteProducts: deleteProducts,
      deletePropertys: deletePropertys,
      deleteAction : deleteAction,

      addAttribute: addAttribute,
      addProperty: addProperty,
      addAction: addAction,

      updateProduct:updateProduct,
      updateProperty: updateProperty,
      updateAction: updateAction

    };

    function getAttributeNotInMl(entity, page) {
      var resourceUrl = '/api/ml/queryProductProper?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })

    }

    function updateAction(entity) {
      var resourceUrl = '/api/ml/updateProductAction';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function addAction(entity) {
      var resourceUrl = '/api/ml/insertProductAction';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function deleteAction(entity) {
      var resourceUrl = '/api/ml/deleteProductAction';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function getAction(entity, page) {
      var resourceUrl = '/api/ml/queryProductAction?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function selectProductsNotInMl(page) {
      var resourceUrl = '/api/ml/selectProductsNotInMl?page=' + page + '&pageSize=' + 10;
      return $http.get(resourceUrl, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get product
    function getProduct(entity, page) {
      var resourceUrl = '/api/ml/selectMlProducts?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get property
    function getProperty(entity, page) {
      var resourceUrl = '/api/ml/queryProductAttribute?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete products
    function deleteProducts(entity) {
      var resourceUrl = '/api/ml/deleteMlProducts';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete products
    function deletePropertys(entity) {
      var resourceUrl = '/api/ml/deleteProductAttribute';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //add product
    function addAttribute(entity) {
      var resourceUrl = '/api/ml/insertProductAttribute';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //update product
    function updateProduct(entity) {
      var resourceUrl = '/api/ctm/updateProduct';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //add product
    function addProperty (entity) {
      var resourceUrl = '/api/ml/insertMlProducts';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //update product
    function updateProperty (entity) {
      var resourceUrl = '/api/ctm/updateProductProperty';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function getProductType(entity,page){
      var resourceUrl = '/api/dvm/queryProductType?page='+page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //get product locale info
    function getProductLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('MlProductController', MlProductController);

  MlProductController.$inject = ['$rootScope', 'MlProductService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];

  function MlProductController($rootScope, MlProductService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.product = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkProduct = checkProduct;
    vm.checkAllProduct = checkAllProduct;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetProduct = resetProduct;
    vm.deleteProduct = deleteProduct;
    vm.deleteProducts = deleteProducts;
    vm.getProduct = getProduct;

    vm.getProduct();

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
      if(toState.parent == 'app' && toState.name == 'mlproduct' && fromState.name == 'mlproduct.edit') {
        vm.getProduct();
      }
    });

    //get product
    function getProduct() {
      return MlProductService.getProduct(vm.product, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.products = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search product
    function search() {
      vm.getProduct();
    }

    //reset product
    function resetProduct() {
      vm.product.productName = undefined;
      vm.product.referenceSource = undefined;
    }

    //delete product
    function deleteProduct(product) {
      SweetAlert.confirm(product.productCode + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var products = new Array();
          var entity = new Object();
          entity.productId = product.productId;
          //entity.processingStatus = 'delete';
          products.push(entity);
          MlProductService.deleteProducts(products).then(function (response) {
            if (response.success) {
              vm.getProduct();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete product
    function deleteProducts() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var products = new Array();
          $(arrChk).each(function() {
            var product = new Object();
            product.productId = this.value;
            products.push(product);
          });
          MlProductService.deleteProducts(products).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getProduct();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getProduct();
    }

    //check or unCheck check product
    function checkProduct() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check product
    function checkAllProduct() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('mlaction', {
        parent: 'app',
        url: "/mlaction/{attributeId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ml/html/mlattributeaction.html",
            controller: 'AttributeActionController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams', function ($stateParams) {
            return {
              attributeId : $stateParams.attributeId
            };
          }]
        }
      })
      .state('mlaction.add', {
        parent: 'mlaction',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ml/html/addmlaction.html',
            controller: 'AddMlActionController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  attributeId: $stateParams.attributeId
                }
              }
            }
          }).result.then(function () {
            $state.go('mlaction', null, {reload: true});
          }, function () {
            $state.go('mlaction');
          });
        }]
      })
      .state('mlaction.edit', {
        parent: 'mlaction',
        url: "/edit/:actionId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ml/html/addmlaction.html',
            controller: 'AddMlActionController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  actionId: $stateParams.actionId
                }
              }
            }
          }).result.then(function () {
            $state.go('mlaction', null, {reload: true});
          }, function () {
            $state.go('mlaction');
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AttributeActionController', AttributeActionController);

  AttributeActionController.$inject = ['MlProductService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

  function AttributeActionController(MlProductService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
    var vm = this;
    vm.property = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkProperty = checkProperty;
    vm.checkAllProperty = checkAllProperty;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetProperty = resetProperty;
    vm.deleteProperty = deleteProperty;
    vm.deletePropertys = deletePropertys;
    vm.getProperty = getProperty;
    vm.initWeidget = initWeidget;

    vm.initWeidget();
    vm.getProperty();

    //get Property
    function getProperty() {
      return MlProductService.getAction(vm.property, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.propertys = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search property
    function search() {
      vm.getProperty();
    }

    //reset Property
    function resetProperty() {
      vm.property.commandCode = undefined;
    }

    //delete Property
    function deleteProperty(property) {
      SweetAlert.confirm(property.commandCode + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var propertys = new Array();
          var entity = new Object();
          entity.actionId = property.actionId;
          propertys.push(entity);
          MlProductService.deleteAction(propertys).then(function (response) {
            if (response.success) {
              vm.getProperty();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete Property
    function deletePropertys() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var propertys = new Array();
          $(arrChk).each(function() {
            var property = new Object();
            property.actionId = this.value;
            propertys.push(property);
          });
          MlProductService.deleteAction(propertys).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getProperty();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getProperty();
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'IOT.DVM_ATTRIBUTE_TYPE'},function (data) {
        vm.attributeType = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'IOT.DVM_ATTRIBUTE_RULE_TYPE'},function (data) {
        vm.ruleType = data.rows;
      },function (error) {
      });
    }

    //check or unCheck check Property
    function checkProperty() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Property
    function checkAllProperty() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/08/13.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AddMlProductController', AddMlProductController);

  AddMlProductController.$inject = ['MlProductService', 'paginationConstants', 'entity', '$uibModalInstance', '$state', 'toastr', '$filter'];

  function AddMlProductController(MlProductService, paginationConstants, entity, $uibModalInstance, $state, toastr, $filter) {
    var vm = this;
    vm.property = entity;

    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.searchProperty = searchProperty;
    vm.initLoad = initLoad;
    vm.pageChanged = pageChanged;
    vm.clear = clear;
    vm.saveProperty = saveProperty;
    vm.checkProperty = checkProperty;
    vm.checkAllProperty = checkAllProperty;

    vm.initLoad();

    //init load page
    function initLoad() {
      MlProductService.getProductsNotInMl(vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.totalItems = data.total;
        vm.properties = data.rows;
        vm.pageSize = data.rows.length;
      })
    }

    //search property
    function searchProperty(){
      vm.initLoad();
    }

    //save choose property
    function saveProperty() {
      var arrChk = $("input[name='chk_list_add']:checked");
      var properties = new Array();
      $(arrChk).each(function() {
        var property = new Object();
        property.productId = this.value;
        properties.push(property);
      });
      MlProductService.addProperty(properties).then(function (response) {
        if (response.success) {
          toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          $uibModalInstance.close();
          return $state.go('mlproduct', null, {reload: true});
        }
      })
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.initLoad();
    }

    //cancel choose property
    function clear() {
      $uibModalInstance.dismiss('cancel');
      $state.go("mlproduct");
    }

    //check or unCheck check Sku
    function checkProperty() {
      var arrChk = $("input[name='chk_list_add']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Sku
    function checkAllProperty() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list_add");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/08/13.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AddMlAttributeController', AddMlAttributeController);

  AddMlAttributeController.$inject = ['MlProductService', 'paginationConstants', 'entity', '$uibModalInstance', '$state', 'toastr', '$filter'];

  function AddMlAttributeController(MlProductService, paginationConstants, entity, $uibModalInstance, $state, toastr, $filter) {
    var vm = this;
    vm.property = entity;

    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.searchProperty = searchProperty;
    vm.initLoad = initLoad;
    vm.pageChanged = pageChanged;
    vm.clear = clear;
    vm.saveProperty = saveProperty;
    vm.checkProperty = checkProperty;
    vm.checkAllProperty = checkAllProperty;

    vm.initLoad();

    //init load page
    function initLoad() {
      MlProductService.getAttributeNotInMl(vm.property, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.totalItems = data.total;
        vm.properties = data.rows;
        vm.pageSize = data.rows.length;
      })
    }

    //search property
    function searchProperty(){
      vm.initLoad();
    }

    //save choose property
    function saveProperty() {
      var arrChk = $("input[name='chk_list_add']:checked");
      var properties = new Array();
      $(arrChk).each(function() {
        var property = new Object();
        property.productPropertyId = this.value;
        property.skuId = vm.property.skuId;
        properties.push(property);
      });
      MlProductService.addAttribute(properties).then(function (response) {
        if (response.success) {
          toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          $uibModalInstance.close();
          return $state.go('mlproduct', null, {reload: true});
        }
      })
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.initLoad();
    }

    //cancel choose property
    function clear() {
      $uibModalInstance.dismiss('cancel');
      $state.go("mlproduct");
    }

    //check or unCheck check Sku
    function checkProperty() {
      var arrChk = $("input[name='chk_list_add']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Sku
    function checkAllProperty() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list_add");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by xiwang.liu on 2017/8/13.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddMlActionController', AddMlActionController);

  AddMlActionController.$inject = ['MlProductService', '$state', '$uibModalInstance', 'toastr', 'entity', '$filter'];

  function AddMlActionController(MlProductService, $state, $uibModalInstance, toastr, entity, $filter) {
    var vm = this;
    vm.sku = entity;
    vm.skuCodeReadOnly = false;

    vm.clear = clear;
    vm.addSku = addSku;
    vm.load = load;

    load();

    //init load
    function load() {
      if (vm.sku.actionId) {
        MlProductService.getAction(vm.sku, 1).then(function (result) {
          vm.sku = result.rows[0];
        })
      }
    }

    //submit  add sku
    function addSku() {
      var skus = new Array();
      skus.push(vm.sku);
      if(!vm.sku.actionId){
        return MlProductService.addAction(skus).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('mlaction', null, {reload: true});
          }
        });
      } else {
        return MlProductService.updateAction(skus).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('mlaction', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/04/16.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('amain', {
        parent: 'app',
        url: "/amain",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/main/html/main.html",
            controller: 'AdminMainController',
            controllerAs: 'vm'
          }
        }
      });
  }

})();

/**
 * Created by xiawang.liu on 2017/04/10.
 */

(function () {
  'use strict';

  angular.module('hmapFront').factory('AdminMainService', AdminMainService);

  AdminMainService.$inject = ['$http'];

  function AdminMainService($http) {
    return {
      getIotVersion: getIotVersion,
      getBoxVersion: getBoxVersion,
      getAppVersion: getAppVersion,
      getUpgradeSuccessRate: getUpgradeSuccessRate,
      getCurrentOnlineRate: getCurrentOnlineRate
    };

    //get On-Line rate
    function getCurrentOnlineRate(referenceSource, schema) {
      var resourceUrl = '/api/sys/online/currentOnline?referenceSource=' + referenceSource +'&schema=' + schema;
      return $http.post(resourceUrl, {headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }

    //get iot wifi version
    function getIotVersion(type, schema) {
      var resourceUrl = '/api/version/iotVersion?firmwareCode=' + type + '&schema=' + schema;
      return $http.post(resourceUrl, {headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }

    //get box version
    function getBoxVersion(schema) {
      var resourceUrl = '/api/version/boxVersion?schema=' + schema;
      return $http.post(resourceUrl, {headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }

    //get box version
    function getAppVersion(appType) {
      var resourceUrl = '/api/version/appVersion?appType=' + appType;
      return $http.post(resourceUrl, {headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }

    //get upgrade success rate
    function getUpgradeSuccessRate(schema) {
      var resourceUrl = '/api/version/deviceUpgrade?' + 'schema=' +schema;
      return $http.post(resourceUrl, {headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/04/10.
 */

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('AdminMainController', AdminMainController);

  AdminMainController.$inject = ['TopnavbarService', '$filter', 'AdminMainService', '$translate', '$timeout'];

  function AdminMainController(TopnavbarService, $filter, AdminMainService, $translate, $timeout) {


    var eContainerTotal = document.getElementById('eContainerTotal');
    var eCharts1 = document.getElementById('pie1');
    var eCharts2 = document.getElementById('pie2');
    var eCharts3 = document.getElementById('pie3');
    var eCharts4 = document.getElementById('pie4');
    var eCharts5 = document.getElementById('pie5');
    var eCharts6 = document.getElementById('pie6');
    var eCharts7 = document.getElementById('pie7');
    var eCharts8 = document.getElementById('pie8');
    //chart auto height and width to window
    var resizeWorldMapContainer = function () {
      eCharts1.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts1.style.height = eContainerTotal.clientHeight + 'px';
      eCharts2.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts2.style.height = eContainerTotal.clientHeight + 'px';
      eCharts3.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts3.style.height = eContainerTotal.clientHeight + 'px';
      eCharts4.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts4.style.height = eContainerTotal.clientHeight + 'px';
      eCharts5.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts5.style.height = eContainerTotal.clientHeight + 'px';
      eCharts6.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts6.style.height = eContainerTotal.clientHeight + 'px';
      eCharts7.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts7.style.height = eContainerTotal.clientHeight + 'px';
      eCharts8.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts8.style.height = eContainerTotal.clientHeight + 'px';
    };
    resizeWorldMapContainer();
    $('#eContainerTotal').resize(function () {
      resizeWorldMapContainer();
      pie1.resize();
      pie2.resize();
      pie3.resize();
      pie4.resize();
      pie5.resize();
      pie6.resize();
      pie7.resize();
      pie8.resize();
    });

    var pie1 = echarts.init(eCharts1);
    var pie2 = echarts.init(eCharts2);
    var pie3 = echarts.init(eCharts3);
    var pie4 = echarts.init(eCharts4);
    var pie5 = echarts.init(eCharts5);
    var pie6 = echarts.init(eCharts6);
    var pie7 = echarts.init(eCharts7);
    var pie8 = echarts.init(eCharts8);

    var vm = this;
    vm.getIotVersion = getIotVersion;
    vm.getBoxVersion = getBoxVersion;
    vm.getAppVersion = getAppVersion;
    vm.getUpgradeSuccessRate = getUpgradeSuccessRate;
    vm.getCommercialOnlineRate = getCommercialOnlineRate;
    vm.getResidentialOnlineRate = getResidentialOnlineRate;
    vm.timeOutFunc = timeOutFunc;

    vm.initLang = initLang;
    initLang();

    function timeOutFunc() {
      vm.getIotVersion("WIFI", 'res');
      vm.getIotVersion("BLE", 'res');
      vm.getBoxVersion('res');
      vm.getAppVersion('IOS');
      vm.getAppVersion('ANDROID');
      vm.getUpgradeSuccessRate('res');
      vm.getCommercialOnlineRate('commercial', 'com');
      vm.getResidentialOnlineRate('residential', 'res');
    }

    //init Language for the content
    function initLang() {
      var lang = '';
      TopnavbarService.selectLang().then(function (data) {
        lang = data;
        $translate.use(lang);
        $timeout(vm.timeOutFunc(), 100);
      });
    }

    //get commercial On-Line rate
    function getCommercialOnlineRate(referenceSource, schema) {
      return AdminMainService.getCurrentOnlineRate(referenceSource, schema).then(function (data) {
        if (!data.rows) {
          return;
        }
        var title = $translate.instant("main.commercialRate");//$filter('T')("main.commercialRate");
        var option = {
          title: {
            text: title
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: [$filter('T')("main.deviceRate"), $filter('T')("main.boxRate")],
            top: '6%',
            left: '0%',
            orient: 'vertical'
          },
          grid: {
            right: '20%'
          },
          xAxis: {
            boundaryGap: false,
            data: data.rows[0]
          },
          yAxis: {},
          series: [
            {
              name: $filter('T')("main.deviceRate"),
              type: 'line',
              data: data.rows[2]
            },
            {
              name: $filter('T')("main.boxRate"),
              type: 'line',
              data: data.rows[1]
            }
          ]
        };

        if (data.rows[0].length == 0) {
          var noDataTitle = $filter('T')("main.commercialRate");
          var noData = $filter('T')("alert.noData");
          $("#pie7").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
          vm.pie7NotData = true;
        } else {
          if (vm.pie7NotData) {
            $("#pie7").empty();
            pie7 = echarts.init(document.getElementById("pie7"));
            vm.pie7NotData = false;
          }
          pie7.setOption(option);
          pie7.on("click", function (param) {
          });
        }

      })
    }

    //get residential On-Line rate
    function getResidentialOnlineRate(referenceSource, schema) {
      return AdminMainService.getCurrentOnlineRate(referenceSource, schema).then(function (data) {
        if (!data.rows) {
          return;
        }
        var title = $filter('T')("main.residentialRate");
        var option = {
          title: {
            text: title
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: [$filter('T')("main.deviceRate"), $filter('T')("main.boxRate")],
            top: '6%',
            left: '0%',
            orient: 'vertical'
          },
          grid: {
            right: '20%'
          },
          xAxis: {
            boundaryGap: false,
            data: data.rows[0]
          },
          yAxis: {},
          series: [
            {
              name: $filter('T')("main.deviceRate"),
              type: 'line',
              data: data.rows[2]
            },
            {
              name: $filter('T')("main.boxRate"),
              type: 'line',
              data: data.rows[1]
            }
          ]
        };

        if (data.rows[0].length == 0) {
          var noDataTitle = $filter('T')("main.residentialRate");
          var noData = $filter('T')("alert.noData");
          $("#pie8").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
          vm.pie8NotData = true;
        } else {
          if (vm.pie8NotData) {
            $("#pie8").empty();
            pie8 = echarts.init(document.getElementById("pie8"));
            vm.pie8NotData = false;
          }
          pie8.setOption(option);
          pie8.on("click", function (param) {
          });
        }

      })
    }

    //get iot version data
    function getIotVersion(type, schema) {
      //set param to iot version pie
      return AdminMainService.getIotVersion(type, schema).then(function (data) {
        if (!data.rows) {
          return;
        }
        var title = data.rows[0].dataSmall.concat(data.rows[1].dataBig);
        var text;
        switch (type) {
          case 'WIFI' :
            text = $filter('T')("main.iotwifi");
            break;
          case 'BLE' :
            text = $filter('T')("main.iotble");
            break;
        }
        var option = {
          title: {
            text: text,
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c}({d}%)"
          },
          legend: {
            data: title,
            top: '10%',
            left: '0%',
            type: 'scroll',
            orient: 'vertical'
          },
          grid: {
            top: '10%'
          },
          series: [
            {
              name: text,
              center: ['40%', '55%'],
              type: 'pie',
              radius: ['45%', '65%'],
              data: data.rows[0].dataSmall
            },
            {
              name: text,
              label: {
                normal: {
                  position: 'inner'
                }
              },
              center: ['40%', '55%'],
              type: 'pie',
              radius: ['0%', '35%'],
              data: data.rows[1].dataBig
            }
          ]
        };
        switch (type) {
          case 'WIFI' :

            if (data.rows[1].dataBig.length == 0) {
              var noDataTitle = $filter('T')("main.iotwifi");
              var noData = $filter('T')("alert.noData");
              $("#pie3").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
              vm.pie3NotData = true;
            } else {
              if (vm.pie3NotData) {
                $("#pie3").empty();
                pie3 = echarts.init(document.getElementById("pie3"));
                vm.pie3NotData = false;
              }
              pie3.setOption(option);
              pie3.on("click", function (param) {
              });
            }


            break;
          case 'BLE' :

            if (data.rows[1].dataBig.length == 0) {
              var noDataTitle = $filter('T')("main.iotble");
              var noData = $filter('T')("alert.noData");
              $("#pie4").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
              vm.pie4NotData = true;
            } else {
              if (vm.pie4NotData) {
                $("#pie4").empty();
                pie4 = echarts.init(document.getElementById("pie4"));
                vm.pie4NotData = false;
              }
              pie4.setOption(option);
              pie4.on("click", function (param) {
              });
            }

            break;
        }
      });
    }

    //get box version data
    function getBoxVersion(schema) {
      //set param to box version pie
      return AdminMainService.getBoxVersion(schema).then(function (data) {
        if (!data.rows) {
          return;
        }
        var title = data.rows[0].dataSmall.concat(data.rows[1].dataBig);
        var text = $filter('T')("main.box");
        var option = {
          title: {
            text: text,
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            data: title,
            top: '10%',
            left: '0%',
            orient: 'vertical',
            type: 'scroll'
          },
          grid: {
            top: '10%'
          },
          series: [{
            name: text,
            center: ['40%', '55%'],
            type: 'pie',
            radius: ['45%', '65%'],
            data: data.rows[0].dataSmall
          },
            {
              name: text,
              label: {
                normal: {
                  position: 'inner'
                }
              },
              center: ['40%', '55%'],
              type: 'pie',
              radius: ['0%', '35%'],
              data: data.rows[1].dataBig
            }]
        };

        if (data.rows[1].dataBig.length == 0) {
          var noDataTitle = $filter('T')("main.box");
          var noData = $filter('T')("alert.noData");
          $("#pie2").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
          vm.pie2NotData = true;
        } else {
          if (vm.pie2NotData) {
            $("#pie2").empty();
            pie2 = echarts.init(document.getElementById("pie2"));
            vm.pie2NotData = false;
          }
          pie2.setOption(option);
          pie2.on("click", function (param) {
          });
        }
      });
    }

    //get app version data
    function getAppVersion(type) {
      //set param to app version pie
      return AdminMainService.getAppVersion(type).then(function (data) {
        if (!data.rows) {
          return;
        }
        var title = data.rows[0].dataSmall.concat(data.rows[1].dataBig);
        var text;
        switch (type) {
          case 'IOS' :
            text = $filter('T')("main.ios");
            break;
          case 'ANDROID' :
            text = $filter('T')("main.android");
            break;
        }
        var option = {
          title: {
            text: text
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c}({d}%)"
          },
          legend: {
            data: title,
            top: '10%',
            left: '0%',
            orient: 'vertical'
          },
          grid: {
            top: '10%'
          },
          series: [
            {
              name: text,
              center: ['40%', '55%'],
              type: 'pie',
              radius: ['45%', '65%'],
              data: data.rows[0].dataSmall
            }, {
              name: text,
              label: {
                normal: {
                  position: 'inner'
                }
              },
              center: ['40%', '55%'],
              type: 'pie',
              radius: ['0%', '35%'],
              data: data.rows[1].dataBig
            }
          ]
        };
        switch (type) {
          case 'IOS' :

            if (data.rows[1].dataBig.length == 0) {
              var noDataTitle = $filter('T')("main.ios");
              var noData = $filter('T')("alert.noData");
              $("#pie5").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
              vm.pie5NotData = true;
            } else {
              if (vm.pie5NotData) {
                $("#pie5").empty();
                pie5 = echarts.init(document.getElementById("pie5"));
                vm.pie5NotData = false;
              }
              pie5.setOption(option);
              pie5.on("click", function (param) {
              });
            }

            break;
          case 'ANDROID' :

            if (data.rows[1].dataBig.length == 0) {
              var noDataTitle = $filter('T')("main.android");
              var noData = $filter('T')("alert.noData");
              $("#pie6").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
              vm.pie6NotData = true;
            } else {
              if (vm.pie6NotData) {
                $("#pie6").empty();
                pie6 = echarts.init(document.getElementById("pie6"));
                vm.pie6NotData = false;
              }
              pie6.setOption(option);
              pie6.on("click", function (param) {
              });
            }

            break;
        }
      });
    }

    //get upgrade success rate
    function getUpgradeSuccessRate(schema) {
      //set param to success rate bar
      return AdminMainService.getUpgradeSuccessRate(schema).then(function (data) {
        if (!data.rows) {
          return;
        }
        var seriesList = [];
        if (data.rows[2]) {
          for (var i = 0; i < data.rows[2].length; i++) {
            var series = {};
            series.name = data.rows[2][i].name;
            series.type = 'bar';
            series.barWidth = '45%';
            series.stack = 'FIRMWARE';
            series.data = data.rows[2][i].data;
            seriesList.push(series)
          }
        }
        var text = $filter('T')("main.upgrade");
        var option = {
          title: {
            text: text,
          },
          tooltip: {
            trigger: 'item',
            formatter: "{b} <br/>{a} : {c}"
          },
          legend: {
            data: data.rows[1],
            top: '10%',
            left: '0%',
            orient: 'vertical',
            type: 'scroll'
          },
          grid: {
            bottom: '23px',
            left: '20%',
            top: '10%',
            right: '10%'
          },
          xAxis: {
            data: data.rows[0]
          },
          yAxis: {
            type: 'value'
          },
          series: seriesList
        };

        if (!data.rows[2]) {
          var title = $filter('T')("main.upgrade");
          var noData = $filter('T')("alert.noData");
          $("#pie1").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + title + '</div><div style="margin-left: 30%; margin-top: 145px">' + noData + '</div></div>');
          vm.pie1NotData = true;
        } else {
          if (vm.pie1NotData) {
            $("#pie1").empty();
            pie1 = echarts.init(document.getElementById("pie1"));
            vm.pie1NotData = false;
          }
          pie1.setOption(option);
          pie1.on("click", function (param) {
          });
        }
      });
    }
  }
})();

//resize of div
(function ($, h, c) {
  var a = $([]),
    e = $.resize = $.extend($.resize, {}),
    i,
    k = "setTimeout",
    j = "resize",
    d = j + "-special-event",
    b = "delay",
    f = "throttleWindow";
  e[b] = 250;
  e[f] = true;
  $.event.special[j] = {
    setup: function () {
      if (!e[f] && this[k]) {
        return false;
      }
      var l = $(this);
      a = a.add(l);
      $.data(this, d, {
        w: l.width(),
        h: l.height()
      });
      if (a.length === 1) {
        g();
      }
    },
    teardown: function () {
      if (!e[f] && this[k]) {
        return false;
      }
      var l = $(this);
      a = a.not(l);
      l.removeData(d);
      if (!a.length) {
        clearTimeout(i);
      }
    },
    add: function (l) {
      if (!e[f] && this[k]) {
        return false;
      }
      var n;

      function m(s, o, p) {
        var q = $(this),
          r = $.data(this, d);
        r.w = o !== c ? o : q.width();
        r.h = p !== c ? p : q.height();
        n.apply(this, arguments);
      }

      if ($.isFunction(l)) {
        n = l;
        return m;
      } else {
        n = l.handler;
        l.handler = m;
      }
    }
  };

  function g() {
    i = h[k](function () {
        a.each(function () {
          var n = $(this),
            m = n.width(),
            l = n.height(),
            o = $.data(this, d);
          if (m !== o.w || l !== o.h) {
            n.trigger(j, [o.w = m, o.h = l]);
          }
        });
        g();
      },
      e[b]);
  }
})(jQuery, this);

/**
 * Created by mclin on 2017-4-14.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('MainPageService', MainPageService);

    MainPageService.$inject = ['$resource', '$http', '$state'];

  function MainPageService($resource, $http) {
    var service = {
      getVerifyCode: getVerifyCode
    };
    return service;

    function getVerifyCode(url) {
      return $http({
        type: "post",
        dataType: 'text',
        url: url
      }).then(function successCallback(response) {
        if (response.status == "200") {
          return response.data;
        }
      })
      /*.success(function(data,header,config,status,obj1,obj2,obj3){
        $("#imgObj").attr("src", "data:image/jpeg;base64," + data);
        console.log("==============")
        //响应成功
      })*/
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/04/10.
 */
(function () {
  'use strict';
  angular
  .module('hmapFront')
  .controller('MainPageController', MainPageController);
  MainPageController.$inject = ['RedirectUrlService', '$rootScope', '$location', '$state', '$timeout', 'Auth', 'BaseConfig', '$window', '$translate', 'PromptService', 'MainPageService', '$stateParams', '$http', '$localStorage', 'Principal', '$q', 'webLogonService'];

  /** @ngInject */
  function MainPageController(RedirectUrlService, $rootScope, $location, $state, $timeout, Auth, BaseConfig, $window, $translate, PromptService, MainPageService, $stateParams, $http, $localStorage, Principal, $q, webLogonService) {
    var vm = this;

    vm.initRedir = initRedir;
    vm.login = login;
    vm.describe = "";

    vm.initRedir();

    function initRedir() {
      var lang = window.localStorage.lang;
      if (!lang) {
        //window.localStorage.lang = 'en_GB';
        $translate.use('en_GB');
      }
      var error = $location.search().error;
      if (error) {
        if (error == "server_error")
          vm.authenticationError = true;
        else if (error == "invalid_request") {
          vm.invalidRequestError = true;
        } else if (error == "invalid_user") {
          vm.invalidUserError = true;
        }
      }
      //var session = $sessionStorage.oauth;
    }

    function login() {
      if (BaseConfig.localDebugger) {
        $state.go("login");
      } else {
        RedirectUrlService.getTenantIdAndClientId().then(function (data) {
          $localStorage.b2cConfig = data.rows[0].authUrl;
          var aadLoginUrl = data.rows[0].aadLoginUrl;
          if (navigator.userAgent.toLowerCase().indexOf("firefox") > 0) {
            window.location.assign(aadLoginUrl);
          } else {
            window.location = aadLoginUrl;
          }
        });
      }
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/04/10.
 */
(function() {
    'use strict';
    angular
        .module('hmapFront')
        .controller('Login3Controller', Login3Controller);
  Login3Controller.$inject = ['$rootScope', '$state', '$timeout', 'Auth','BaseConfig', '$window', '$translate', 'PromptService', 'LoginService','$stateParams','$http','$localStorage','Principal','$q','webLogonService'];
    /** @ngInject */
    function Login3Controller($rootScope, $state, $timeout,Auth,BaseConfig, $window, $translate, PromptService, LoginService,$stateParams,$http,$localStorage,Principal,$q,webLogonService) {
        var vm = this;
        vm.login = login;
        vm.username = window.localStorage.username ?　window.localStorage.username : "";
        vm.password = window.localStorage.password ?　window.localStorage.password : "";
        //vm.password = "";
        vm.verifiCode = "";
        vm.initLangs = initLangs;
        vm.isSelected = false;
        vm.selectType = null;

        vm.langType = 'en_GB';
        vm.languageType = [];
        vm.type = $stateParams.type;
        vm.toUrl = $stateParams.url;
        vm.ty;
        var currentLang;
        currentLang = navigator.language;
        if(!currentLang){
            currentLang = navigator.browserLanguage;
        }
        currentLang = currentLang.replace("-","_");

        function initLangs() {
            PromptService.selectLangNoToken().query(function(data) {
                var rows = data.rows;
                for (var i in rows) {
                    if (rows.hasOwnProperty(i)) {
                        var obj = {};
                        obj["type"] = rows[i].langCode;
                        obj["value"] = rows[i].description;
                        vm.languageType[i] = obj;
                        vm.ty = rows[i].langCode;
                        if(vm.ty == currentLang){
                            vm.selectType = currentLang;
                            window.localStorage.lang = vm.selectType;
                            $translate.use(vm.selectType);
                        }
                    }
                }
                if(vm.selectType==null){
                    vm.selectType = vm.langType;
                    $translate.use( vm.selectType);
                }
            });
        }

        vm.initLangs();
        vm.changeLanguage = changeLanguage;

        // Load captche image
        vm.rnd = Math.random();

        // console.log(vm.verifiCodeUrl);
        function login (event) {
            if($stateParams.type == 'thirdParty'){
                var data = 'client_id=api_client_trans&client_secret=api_secret_trans&grant_type=password'+'&username=' + encodeURIComponent(vm.username) +
                    '&password=' + encodeURIComponent(vm.password) + '&lang=' + vm.langType;

                $http.post('http://42.159.239.127:8080/api/oauth/token', data, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).success(function (response) {
                    var expiredAt = new Date();
                    expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                    response.expires_at = expiredAt.getTime();
                    //console.log($localStorage.authenticationToken);
                    $localStorage.oauth_response = response;
                    //console.log("authenticationToken:" + $localStorage.authenticationToken);
                    if(vm.isSelected){
                        window.localStorage.username = vm.username;
                        window.localStorage.password = vm.password;
                    }
                    vm.authenticationError = false;
                    $rootScope.$broadcast('authenticationSuccess');
                    var deferred = $q.defer();
                    Principal.identity(true).then(function(account) {
                        deferred.resolve(data);
                    });
                    webLogonService.jump($stateParams.url);
                    //var to = $stateParams.url;
                    //$state.go('webLogon',{url:to});
                });
            }else{
                if(vm.selectType){
                    vm.langType = vm.selectType;
                }

                //event.preventDefault();
                Auth.login({
                    username: vm.username,
                    password: vm.password,
                    languageType: vm.langType,
                    type : vm.type,
                    toUrl : vm.toUrl
                }).then(function () {
                    if(vm.isSelected){
                        //remember username or password
                        window.localStorage.username = vm.username;
                        window.localStorage.password = vm.password;
                    }
                    vm.authenticationError = false;
                    $state.go('amain');
                    $rootScope.$broadcast('authenticationSuccess');
                }).catch(function (err) {
                    var errInfo = err.data.error_description;
                    if (errInfo) {
                        if(errInfo.indexOf("captcha") >= 0) {
                            vm.authenticationUserDisableError = false;
                            vm.authenticationError = false;
                        } else /*if(errInfo.indexOf("credentials") >= 0)*/ {
                            vm.authenticationUserDisableError = false;
                            vm.authenticationError = true;
                        }
                    } else {
                        vm.authenticationUserDisableError = false;
                        vm.authenticationError = true;
                    }
                });
            }

        }
        function changeLanguage(){
            /*      window.localStorage.lang = vm.selectType.type;
             $translate.use(vm.selectType.type);*/
            window.localStorage.lang = vm.selectType;
            $translate.use(vm.selectType);
        }
    }
})();

/**
 * Created by xiawang.liu on 2017/04/10.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        params: {"url":null ,"type":null},
        views:{
          'content@':{
            templateUrl: 'app/iot/portal/admin/login/html/login.html',
            controller: 'LoginController',
            controllerAs: 'vm'
          }
        }
      })
     /* .state('mainPage', {
          url: '/mainPage',
          params: {"errorCode":''},
          views:{
              'content@':{
                  templateUrl: 'app/iot/portal/admin/login/html/mainPage.html',
                  controller: 'MainPageController',
                  controllerAs: 'vm'
              }
          }
      })*/
  }
})();

/**
 * Created by mclin on 2017-4-14.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('LoginService', LoginService);

  LoginService.$inject = ['$resource', '$http', '$state'];

  function LoginService($resource, $http) {
    var service = {
      getVerifyCode: getVerifyCode
    };
    return service;

    function getVerifyCode(url) {
      return $http({
        type: "post",
        dataType: 'text',
        url: url
      }).then(function successCallback(response) {
        if (response.status == "200") {
          return response.data;
        }
      })
      /*.success(function(data,header,config,status,obj1,obj2,obj3){
        $("#imgObj").attr("src", "data:image/jpeg;base64," + data);
        console.log("==============")
        //响应成功
      })*/
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/04/10.
 */
(function () {
  'use strict';
  angular
  .module('hmapFront')
  .controller('LoginController', LoginController);
  LoginController.$inject = ['RedirectUrlService', '$sessionStorage', '$rootScope', '$location', '$state', '$timeout', 'Auth', 'BaseConfig', '$window', '$translate', 'PromptService', 'LoginService', '$stateParams', '$http', '$localStorage', 'Principal', '$q', 'webLogonService'];

  /** @ngInject */
  function LoginController(RedirectUrlService, $sessionStorage, $rootScope, $location, $state, $timeout, Auth, BaseConfig, $window, $translate, PromptService, LoginService, $stateParams, $http, $localStorage, Principal, $q, webLogonService) {
    var vm = this;

    vm.initRedir = initRedir;
    vm.login = login;
    vm.describe = "";
    vm.returnMainPage;
    vm.loginFlag;

    vm.initRedir();

    function initRedir() {

      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      vm.authenticationError = true;
      if (token) {//&&token.expires_at < new Date().getTime()
        delete $localStorage.authenticationToken;
        delete $sessionStorage.authenticationToken;
      }

      vm.loginFlag = true;

    }

    function login() {
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      if (token) {
        window.location = BaseConfig.localUrl;
      } else {
        RedirectUrlService.getTenantIdAndClientId().then(function (data) {
          $localStorage.b2cConfig = data.rows[0].authUrl;
          var aadLoginUrl = data.rows[0].aadLoginUrl;
          if (navigator.userAgent.toLowerCase().indexOf("firefox") > 0) {
            window.location.assign(aadLoginUrl);
          } else {
            window.location = aadLoginUrl;
          }
        });
      }
    }
  }
})();

/**
 * Created by user on 2017/4/12.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('testCommand', {
        parent: 'app',
        url: "/testCommand",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/inm/html/testCommand.html",
            controller: 'TestCommandController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              //console.log("0000="+$stateParams.codeId);
              return {
              /*  codeId:$stateParams.codeId*/
              };
            }
          ]
        }

      });


  }
})();

/**
 * Created by user on 2017/4/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('TestCommandController', TestCommandController);

  TestCommandController.$inject = ['CommandMaintenanceService', '$scope', '$state','SweetAlert','$filter'];

  function TestCommandController(CommandMaintenanceService, $scope, $state,SweetAlert,$filter) {
    var vm = this;
    vm.leftClear = leftClear;
    vm.rightClear = rightClear;
    vm.to_device = to_device;
    vm.to_application = to_application;
    vm.selectDirection = selectDirection;
    vm.translated = translated;
    vm.direction = "toDevice";
    vm.leftTitle = $filter('T')('command.application');
    vm.rightTitle = $filter('T')('command.device');

    function selectDirection() {
      if(vm.direction == "toDevice"){
        vm.leftTitle = $filter('T')('command.application');
        vm.rightTitle = $filter('T')('command.device');
      } else if(vm.direction == "toApplication") {
        vm.leftTitle = $filter('T')('command.device');
        vm.rightTitle = $filter('T')('command.application');
      }
    }


  function translated(json) {
      if(vm.direction=="toDevice"){
        to_device(json);
      } else if(vm.direction=="toApplication"){
        to_application(json);
      }

  }

    function to_device(json) {
      return CommandMaintenanceService.toDevice(json)
        .then(function (data) {
          var d = data.rows[0];
          vm.right = JSON.stringify(d, null, "\t");
        },function(data){
          vm.right = "";
          SweetAlert.error($filter('T')('command.paramError'),{title:$filter('T')('title.confirmTitle')});
        });
    }
    function to_application(json) {
      return CommandMaintenanceService.toApplication(json)
        .then(function (data) {
          var d = data.rows[0];
          vm.right  = JSON.stringify(d, null, "\t");
        },function(data){
          vm.right = "";
          SweetAlert.error($filter('T')('command.paramError'),{title:$filter('T')('title.confirmTitle')});
        });
    }

    function leftClear(){
      vm.left = "";
    }

    function rightClear(){
      vm.right = "";
    }
  }


})();

/**
 * Created by user on 2017/4/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditCommandParameterController', EditCommandParameterController);

  EditCommandParameterController.$inject = ['CommandMaintenanceService', '$scope', '$state', '$uibModalInstance', 'entity','toastr','$filter'];

  function EditCommandParameterController(CommandMaintenanceService, $scope, $state, $uibModalInstance,entity,toastr,$filter) {
    var vm = this;
    vm.commandParam = entity;
    vm.clear = clear;
    vm.update = update;
    vm.sequence = [1,2,3,4,5,6,7,8,9,10];
    var commandParam = vm.commandParam;
    getCommandParam(commandParam);
    function getCommandParam(commandParam) {
      return CommandMaintenanceService.findCommandParam(commandParam,1,999)
        .then(function (data) {
          vm.commandParam = data.rows[0];
          //console.log("result codeValue" + angular.toJson(vm.codeValue));
        })
    }

    function update() {
      var paramDefinition = vm.commandParam.paramDefinition;
      var ij = isJson(paramDefinition);
      if(ij){
        return CommandMaintenanceService.updateCommandParam(vm.commandParam)
          .then(function (data) {
            if (data.success) {
              /*toastr.success('保存成功！','信息提示');*/
              toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
              $uibModalInstance.close();
              return null;
            }
          })
      }else {
        vm.errorMsg = $filter('T')('command.addFailMsg');
        vm.addError = true;
      }


    }

    function isJson(str){
      if (str.indexOf("{") > -1) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      }
      return false;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


  }


})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditCommandController', EditCommandController);

  EditCommandController.$inject = ['CommandMaintenanceService', '$scope', '$state', '$uibModalInstance', 'entity','toastr','$filter'];

  function EditCommandController(CommandMaintenanceService, $scope, $state, $uibModalInstance, entity,toastr,$filter) {
    var vm = this;
    vm.command = entity;
    vm.clear = clear;

    vm.update = update;
    vm.products= null;
    vm.hasParam = ["Y", "N"];
    findProduct();
    vm.changeProduct = changeProduct;
    vm.preProductId = null;
    vm.preCmdDefinition = null;
    function findProduct(){
      return CommandMaintenanceService.findProduct()
        .then(function (data) {

          vm.products = data.rows;
          // vm.totalItems = data.total;
        })
    }
    var command = vm.command;
    getCommandByCommandId(command);
    function getCommandByCommandId(command) {
      return CommandMaintenanceService.findCommands(command)
        .then(function (data) {
          vm.command = data.rows[0];
          vm.preProductId = vm.command.productId;
          vm.preCmdDefinition = vm.command.cmdDefinition;
        })
    }

    function changeProduct(){
      for (var i in  vm.products) {
        if (vm.products[i].productCode == vm.command.productCode) {
          vm.command["productId"] = vm.products[i].productId;
          break;
        }
      }
    }

    function update() {
      //console.log("command:" + angular.toJson(vm.command));
      return CommandMaintenanceService.updateCommand(vm.command, vm.preProductId, vm.preCmdDefinition)
        .then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            /*toastr.success('保存成功！','信息提示');*/
            toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
            $uibModalInstance.close();
            return $state.go('commandMaintenance', null, {reload: true});
          }

        },function(data){
        vm.errorMsg = $filter('T')('command.addFailMsg');
        vm.addError = true;
      });

    }


    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


  }


})();

/**
 * Created by user on 2018/4/11.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('commandSet', {
        parent: 'app',
        url: "/commandSet",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/inm/html/commandSet.html",
            controller: 'CommandSetController',
            controllerAs: 'vm'
          }
        }
      })
      .state('commandSet.add', {
        parent: 'commandSet',
        url: "/add/:cmdSetId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/inm/html/addCommandSet-dialog.html',
            controller: 'AddCommandSetController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'xs',
            resolve: {
              entity: function () {
                return {
                  cmdSetId : $stateParams.cmdSetId
                };
              }
            }
          }).result.then(function () {
            $state.go('commandSet', null, {reload: true});
          }, function () {
            $state.go('commandSet');
          });
        }]
      })
  }
})();






(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('CommandSetController', CommandSetController);

  CommandSetController.$inject = ['CommandMaintenanceService', '$state','SweetAlert','toastr','$filter','paginationConstants'];

  function CommandSetController(CommandMaintenanceService, $state, SweetAlert, toastr,$filter,paginationConstants) {
    var vm = this;
    vm.commandSet = {};
    vm.commandSetQuery = {};
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;


    vm.search = search;
    vm.pageChanged = pageChanged;
    vm.checkCmdSet = checkCmdSet;
    vm.checkAllCmdSet = checkAllCmdSet;
    vm.deleteCmdSet = deleteCmdSet;
    vm.deleteCmdSets = deleteCmdSets;
    // vm.reset = reset;

    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    loadAll(vm.commandSet, page, pagesize);

    function loadAll(commandSet,page,pagesize){
      return CommandMaintenanceService.getCommandSet(commandSet,page,pagesize)
        .then(function (data) {
          if (data.success === true){
            vm.commandSet = data.rows;
            vm.totalItems = data.total;
            vm.pageSize = data.rows.length;
          }
        });
    }

    function checkCmdSet() {
      var arrChk = $("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    function checkAllCmdSet() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    function deleteCmdSet(commandSet) {
      SweetAlert.confirm(commandSet.cmdSetName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var commandSets = new Array();
          var obj = {};
          obj.cmdSetId = commandSet.cmdSetId;
          commandSets.push(obj);
          CommandMaintenanceService.deleteCommandSet(commandSets).then(function (response) {
            if (response.success) {
              loadAll(commandSet, page, pagesize);
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }


    function deleteCmdSets() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var commandSets = new Array();
          $(arrChk).each(function () {
            var jsonObj = {};
            jsonObj["cmdSetId"] = this.value;
            commandSets.push(jsonObj);
          });
          CommandMaintenanceService.deleteCommandSet(commandSets).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.commandSet = {};
              loadAll(vm.commandSet, page, pagesize);
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    function search() {
      var page = vm.page = 1;
      var pagesize = paginationConstants.itemsPerPage;
      if (vm.commandSetQuery.cmdSetName === null || vm.commandSetQuery.cmdSetName === "") {
        vm.commandSetQuery.cmdSetName = undefined;
      }
      if (vm.commandSetQuery.deviceIdentity === null || vm.commandSetQuery.deviceIdentity === "") {
        vm.commandSetQuery.deviceIdentity = undefined;
      }
      loadAll(vm.commandSetQuery, page, pagesize);
    }




   /* function reset() {
      vm.commandParam.paramName = undefined;
      vm.commandParam.paramDefinition = undefined;
    };*/

    function pageChanged() {
      var commandSet;
      if (vm.commandSetQuery) {
        commandSet = vm.commandSetQuery;
      }else{
        commandSet ={};
      }
      angular.element("#chk_all").checked = false;
      loadAll(commandSet, vm.page, paginationConstants.itemsPerPage);
    }

  }


})();


/**
 * Created by user on 2017/4/17.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('commandParameter', {
        parent: 'app',
        url: "/commandParameter/{cmdId}/{paramId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/inm/html/commandParameter.html",
            controller: 'CommandParameterController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              //console.log("0000="+$stateParams.codeId);
              return {
                cmdId:$stateParams.cmdId,
                cmdCode:$stateParams.cmdCode
              };
            }
          ]
        }

      })
      .state('commandParameter.add', {
        parent: 'commandParameter',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {

          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/inm/html/addCommandParameter.html',
            controller: 'AddCommandParameterController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  cmdId:$stateParams.cmdId,
                 cmdCode:$stateParams.cmdCode
                };
              }
            }
          }).result.then(function () {
            $state.go('commandParameter', null, {reload: true});
          }, function () {
            $state.go('commandParameter');
          });
        }]
      })
      .state('commandParameter.edit', {
        parent: 'commandParameter',
        url: "/edit/:paramId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          ////console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/inm/html/editCommandParameter.html',
            controller: 'EditCommandParameterController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                //console.log("entity:"+angular.toJson($stateParams.codeId));
                return {
                  paramId:$stateParams.paramId
                };
              }
            }
          }).result.then(function () {
            //console.log("commandMaintenance go1");
            $state.go('commandParameter', null, {reload: true});
          }, function () {
            //console.log("commandMaintenance go2");
            $state.go('commandParameter');
          });
        }]
      })

  }
})();



(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('CommandParameterController', CommandParameterController);

  CommandParameterController.$inject = ['CommandMaintenanceService', 'entity', '$state','SweetAlert','toastr','$filter'];

  function CommandParameterController(CommandMaintenanceService, entity, $state, SweetAlert, toastr,$filter) {
    var vm = this;
    vm.command = entity;
    vm.commandParam = {};
    vm.page = 1;
    vm.itemsPerPage = 10;
    vm.delete = deleteCommandParam;
    vm.search = search;
    vm.reset = reset;


    loadAll(vm.command);
    getCommand(vm.command);


    function getCommand(command) {
      return CommandMaintenanceService.findCommands(command)
        .then(function (data) {
          vm.command = data.rows[0];
        })

    }

    function loadAll(command) {
      return CommandMaintenanceService.findCommandParam(command,vm.page,10)
        .then(function (data) {
          vm.result = data.rows;
          vm.paramTotalItems = data.total;
        })

    }

    function search() {
      if (vm.commandParam.paramName === "") {
        vm.commandParam.paramName = undefined;
      }
      if (vm.commandParam.paramDefinition  === "") {
        vm.commandParam.paramDefinition= undefined;
      }
      vm.commandParam.cmdId = vm.command.cmdId;
      var commandParam = vm.commandParam;

      loadAll(commandParam);

    };

    function reset() {
      vm.commandParam.paramName = undefined;
      vm.commandParam.paramDefinition = undefined;
    };

  function deleteCommandParam(commandParam) {
    SweetAlert.confirm($filter('T')('command.deleteWarning'),{title:$filter('T')('title.confirmTitle')}).then(function(p){
      if(p){
        return CommandMaintenanceService.deleteCommandParam(commandParam)
          .then(function (data) {
            if (data.success) {
/*              toastr.success('删除成功！','信息提示');
              $uibModalInstance.close();*/
              return $state.go('commandParameter', null, {reload: true});
            }
          });
      }
    })

  }

  }


})();

/**
 * Created by user on 2017/4/11.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('commandMaintenance', {
        parent: 'app',
        url: "/commandMaintenance",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/inm/html/commandMaintenance.html",
            controller: 'CommandMaintenanceController',
            controllerAs: 'vm'
          }
        }
      })
      .state('commandMaintenance.add', {
        parent: 'commandMaintenance',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/inm/html/addCommand.html',
            controller: 'AddCommandController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'xs',
            resolve: {
              entity: function () {
                return {

                };
              }
            }
          }).result.then(function () {
            $state.go('commandMaintenance', null, {reload: true});
          }, function () {
            $state.go('commandMaintenance');
          });
        }]
      })
      .state('commandMaintenance.test', {
      parent: 'commandMaintenance',
      url: "/test",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        //console.log($uibModal);
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/inm/html/testCommand.html',
          controller: 'TestCommandController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {

              };
            }
          }
        }).result.then(function () {
          $state.go('commandMaintenance', null, {reload: true});
        }, function () {
          $state.go('commandMaintenance');
        });
      }]
    })
      .state('commandMaintenance.edit', {
      parent: 'commandMaintenance',
      url: "/edit/:cmdId",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        ////console.log($uibModal);
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/inm/html/editCommand.html',
          controller: 'EditCommandController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              //console.log("entity:"+angular.toJson($stateParams.codeId));
              return {
                cmdId:$stateParams.cmdId
              };
            }
          }
        }).result.then(function () {
          //console.log("commandMaintenance go1");
          $state.go('commandMaintenance', null, {reload: true});
        }, function () {
          //console.log("commandMaintenance go2");
          $state.go('commandMaintenance');
        });
      }]
    })
/*      .state('commandMaintenance.remove', {
        parent: 'commandMaintenance',
        url: "/remove/:cmdId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          ////console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/inm/html/deleteCommand.html',
            controller: 'DeleteCommandController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'xs',
            resolve: {
              entity: function () {
                //console.log("entity:"+angular.toJson($stateParams.codeId));
                return {
                  cmdId:$stateParams.cmdId
                };
              }
            }
          }).result.then(function () {
            //console.log("commandMaintenance go1");
            $state.go('commandMaintenance', null, {reload: true});
          }, function () {
            //console.log("commandMaintenance go2");
            $state.go('commandMaintenance');
          });
        }]
      });*/


  }
})();

/* eslint-disable angular/log */
/**
 * Created by user on 2017/4/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('CommandMaintenanceService', CommandMaintenanceService);

  CommandMaintenanceService.$inject = ['$resource', '$http', '$state'];

  function CommandMaintenanceService($resource, $http) {
    var service = {
      findCommands: findCommands,
      updateCommand: updateCommand,
      addCommand: addCommand,
      deleteCommand: deleteCommand,
      findCommandParam: findCommandParam,
      addCommandParam: addCommandParam,
      updateCommandParam: updateCommandParam,
      deleteCommandParam: deleteCommandParam,
      findProduct: findProduct,
      toDevice: toDevice,
      toApplication: toApplication,

      //add method on 2018/7/32
      addCommandSet: addCommandSet,
      deleteCommandSet: deleteCommandSet,
      getCommandSet : getCommandSet,
      getCmdSetNameInfo : getCmdSetNameInfo,
      updateCommandSet : updateCommandSet
    };
    return service;

    function findCommands(command, page, pagesize) {
      if (page == undefined) {
        page = 1;
      }
      if (pagesize == undefined) {
        pagesize = 10;
      }

      var resourceUrl = '/api/inm/command/query?page=' + page + '&pageSize=' + pagesize;

      var data = command;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }


    function updateCommand(command, preProductId, preCmdDefinition) {

      var resourceUrl = '/api/inm/command/update';

      var data = command;
      data.preProductId = preProductId;
      data.preCmdDefinition = preCmdDefinition;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });

    };

    function addCommand(command) {
      var resourceUrl = "/api/inm/command/submit";

      return $http.post(resourceUrl, command, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;

      });
    };

    function deleteCommand(command) {
      var resourceUrl = "/api/inm/command/delete";
      return $http.post(resourceUrl, command, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function findCommandParam(commandParam, page, pageSize) {
      var resourceUrl = '/api/inm/commandParam/query?page=' + page + '&pageSize=' + pageSize;
      var data = commandParam;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function updateCommandParam(commandParam) {
      var resourceUrl = '/api/inm/commandParam/update';
      var data = commandParam;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function addCommandParam(commandParam) {
      var resourceUrl = "/api/inm/commandParam/insert";
      return $http.post(resourceUrl, commandParam, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;

      });
    }

    function deleteCommandParam(commandParam) {
      var resourceUrl = "/api/inm/commandParam/delete";
      return $http.post(resourceUrl, commandParam, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function findProduct() {
      var resourceUrl = "/api/inm/commandParam/findProduct";
      return $http.post(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function toDevice(json) {
      var resourceUrl = "/cmm/message/generateDeviceMessage";
      return $http.post(resourceUrl, json, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function toApplication(json) {
      var resourceUrl = "/cmm/message/parseDeviceMessage";
      return $http.post(resourceUrl, json, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function addCommandSet(commandSet) {
      var resourceUrl = "/api/inm/commandSet/insert";
      return $http.post(resourceUrl, commandSet, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function deleteCommandSet(entity) {
      var resourceUrl = '/api/inm/commandSet/delete';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
          return response.data;
        });
    }

    function getCommandSet(commandSet,page,pagesize) {
      var resourceUrl = "/api/inm/commandSet/query?page="+page+"&pageSize="+pagesize;
      return $http.post(resourceUrl, commandSet, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function getCmdSetNameInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }

    function updateCommandSet(commandSet) {
      var resourceUrl = "/api/inm/commandSet/update";
      return $http.post(resourceUrl, commandSet, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }
})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('CommandMaintenanceController', CommandMaintenanceController);

  CommandMaintenanceController.$inject = ['CommandMaintenanceService', '$state', 'paginationConstants','SweetAlert','$filter'];

  function CommandMaintenanceController(CommandMaintenanceService, $state, paginationConstants, SweetAlert,$filter) {
    var vm = this;

    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.delete = deleteCommand;

    vm.command = {};
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;


    loadAll(vm.command, page, pagesize);


    function loadAll(command, page, pagesize) {
      return CommandMaintenanceService.findCommands(command, page, pagesize)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;

        })
    }

    function search() {
      var page = vm.page = 1;
      var pagesize = paginationConstants.itemsPerPage;
      if (vm.command.command === null || vm.command.command === "") {
        vm.command.command = undefined;
      }
      if (vm.command.cmdDefinition === null || vm.command.cmdDefinition === "") {
        vm.command.cmdDefinition = undefined;
      }
      loadAll(vm.command, page, pagesize);
    };

    function reset() {
      vm.command.cmdCode = undefined;
      vm.command.cmdDefinition = undefined;
      vm.command.productCode = undefined;
    };

/*    function deleteCommand(command) {
      return CommandMaintenanceService.deleteCommand(command)
        .then(function (data) {
          var flag = data.success;
          //console.log("delete result:" + angular.toJson(flag));
          if (flag) {
            return $state.go('coding', null, {reload: true});
          }
        })
    };*/


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      loadAll(vm.command, vm.page, paginationConstants.itemsPerPage);
    };

    function deleteCommand(command) {
      SweetAlert.confirm($filter('T')('command.deleteWarning'),{title:$filter('T')('title.confirmTitle')}).then(function(p){
        if(p){
          return CommandMaintenanceService.deleteCommand(command)
            .then(function (data) {
              if (data.success) {
                return $state.go('commandMaintenance', null, {reload: true});
              }
            });
        }
      })
    }

  }


})();

/**
 * Created by user on 2018/8/23.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
  .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
    .state('commandDes', {
      parent: 'app',
      url: "/commandDes",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/inm/html/commandDescription.html",
          controller: 'CommandDesController',
          controllerAs: 'vm'
        }
      }
    })
    .state('commandDes.add', {
      parent: 'commandDes',
      url: "/add",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/inm/html/commandDescription-dialog.html',
          controller: 'CommandDesDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {};
            }
          }
        }).result.then(function () {
          $state.go('commandDes', null, {reload: true});
        }, function () {
          $state.go('commandDes');
        });
      }]
    })
    .state('commandDes.edit', {
      parent: 'commandDes',
      url: "/edit/:configurationId",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        ////console.log($uibModal);
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/inm/html/commandDescription-dialog.html',
          controller: 'CommandDesDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                configurationId:$stateParams.configurationId,
              };
            }
          }
        }).result.then(function () {
          $state.go('commandDes', null, {reload: true});
        }, function () {
          $state.go('commandDes');
        });
      }]
    })
  }
})();

/**
 * Created by user on 2018/8/23.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
  .factory('CommandDesService', CommandDesService);

  CommandDesService.$inject = ['$resource', '$http'];

  function CommandDesService($resource, $http) {
    var prefix = '/api/inm/CommandDescription';
    var service = {
      query: query,
      submit: submit,
      remove: remove,
      update: update
    };
    return service;

    function query(entity, page, pageSize) {
      var resourceUrl = prefix + '/query?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, entity,
        {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }

    function submit(entity) {
      var resourceUrl = prefix + '/insert';
      return $http.post(resourceUrl, entity,
        {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }

    function remove(entity) {
      var resourceUrl = prefix + '/delete';
      return $http.post(resourceUrl, entity,
        {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }

    function update(entity) {
      var resourceUrl = prefix + '/update';
      return $http.post(resourceUrl, entity,
        {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }

  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('CommandDesController', CommandDesController);

  CommandDesController.$inject = ['CommandDesService', '$state', 'SweetAlert', 'toastr', '$filter', 'paginationConstants','ProductService'];

  function CommandDesController(CommandDesService, $state, SweetAlert, toastr, $filter, paginationConstants,ProductService) {
    var vm = this;
    vm.commandDes = {};
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.loadAll = loadAll;
    vm.search = loadAll;
    vm.checkCommandDes = checkCommandDes;
    vm.checkAll = checkAll;
    vm.deleteCmdDes = deleteCmdDes;
    vm.deleteAll = deleteAll;
    vm.reset = reset;
    vm.pageChanged = pageChanged;

    vm.loadAll();

    function loadAll() {
      getProduct();
      if (vm.commandDes) {
        if ((vm.commandDes.versionMbd || "") === "") {
          delete vm.commandDes.versionMbd;
        }
        if ((vm.commandDes.connectModeType || "") === "") {
          delete vm.commandDes.connectModeType;
        }
        if ((vm.commandDes.connectModeHwpn || "") === "") {
          delete vm.commandDes.connectModeHwpn;
        }
        if ((vm.commandDes.connectModeVersion || "") === "") {
          delete vm.commandDes.connectModeVersion;
        }
        if ((vm.commandDes.versionConfiguration || "") === "") {
          delete vm.commandDes.versionConfiguration;
        }
      }
      CommandDesService.query(vm.commandDes, vm.page, vm.itemsPerPage)
        .then(function (data) {
          if (data.success) {
            vm.commandDess = data.rows;
            vm.totalItems = data.total;
          }
      });
    }

    function checkCommandDes() {
      var arrChk = angular.element("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        angular.element("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        angular.element("chk_all").checked = true;
      }
    }

    function checkAll() {
      var chk_all = angular.element("#chk_all").is(':checked');
      var items = angular.element(".chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    function deleteCmdDes(commandDes) {
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          var commandDess = [];
          commandDess.push(commandDes.configurationId);
          CommandDesService.remove(commandDess)
          .then(function (data) {
            if (data.success) {
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")})
              .then(function () {
                vm.loadAll();
              });
            }
          })
        }
      });
    }

    function deleteAll() {
      var isCheck = angular.element(".chk_list").is(':checked');
      if (!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          var arrChk = angular.element("input[name='chk_list']:checked");
          var cmdDess = [];
          angular.element(arrChk).each(function (item, value) {
            var cmdDes = {};
            cmdDes.id = value.defaultValue;
            cmdDess.push(cmdDes.id );
          });
          CommandDesService.remove(cmdDess)
          .then(function (data) {
            angular.element("chk_all").checked = false;
            var items = angular.element("chk_list");
            for (var j = 0; j < items.length; j++) {
              items[j].checked = false;
            }
            if (data.success) {
              angular.element(".chk_list").attr('checked', false);
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")})
              .then(function () {
                vm.loadAll();
              });
            }
          })
        }
      });
    }

    function reset() {
      vm.commandDes.productId = undefined;
      vm.commandDes.versionMbd = undefined;
      vm.commandDes.connectModeType = undefined;
      vm.commandDes.connectModeHwpn = undefined;
      vm.commandDes.connectModeVersion = undefined;
      vm.commandDes.versionConfiguration = undefined;
    }

    function getProduct() {
      ProductService.getProductByCopy()
      .then(function (data) {
        if (data.success) {
          vm.products = data.rows;
        }
      });
    }
    
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.loadAll();
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('CommandDesDialogController', CommandDesDialogController);

  CommandDesDialogController.$inject = ['CommandDesService', '$state', 'SweetAlert', 'toastr', '$filter', 'entity', '$uibModalInstance', 'ProductService','toastrConfig'];

  function CommandDesDialogController(CommandDesService, $state, SweetAlert, toastr, $filter, entity, $uibModalInstance, ProductService,toastrConfig) {
    var vm = this;
    vm.commandDes = entity;
    vm.edit = false;

    vm.load = load;
    vm.clear = clear;
    vm.save = save;
    vm.judgeEditOrCreate = judgeEditOrCreate;

    judgeEditOrCreate();
    vm.load();

    function judgeEditOrCreate() {
      if (entity.hasOwnProperty('configurationId')) {
        vm.edit = true;
      }
    }

    function load() {
      getProduct();
      vm.title = 'command.addCommandDes';
      if (vm.commandDes.configurationId) {
        vm.title = 'command.editCommandDes';
        CommandDesService.query(vm.commandDes, 1, -1)
        .then(function (data) {
          vm.commandDes = data.rows[0];
        });
      }
    }

    function isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
      console.log('It is not a string!')
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      if ('' !== vm.commandDes.configurationFile && undefined !== vm.commandDes.configurationFile
        && null !== vm.commandDes.configurationFile) {
        if (!isJSON(vm.commandDes.configurationFile)) {
          toastr.error($filter('T')("dvmProduct.checkJsonFormat"), $filter('T')("dvmProduct.invalidJson"));
          return;
        }
      }
      if (vm.edit) {
        CommandDesService.update(vm.commandDes)
        .then(function (data) {
          if (data.success) {
            if (data.success) {
              toastr.success($filter('T')('title.saveSuccess'), $filter('T')('title.confirmTitle'));
              $uibModalInstance.close();
              return $state.go('commandDes', null, {reload: true});
            }
          }
        });
      } else {
        CommandDesService.submit(vm.commandDes)
        .then(function (data) {
          if (data.success) {
            if (data.success) {
              toastr.success($filter('T')('title.saveSuccess'), $filter('T')('title.confirmTitle'));
              $uibModalInstance.close();
              return $state.go('commandDes', null, {reload: true});
            }
          }
        });
      }
    }

    function getProduct() {
      ProductService.getProductByCopy()
      .then(function (data) {
        if (data.success) {
          vm.products = data.rows;
        }
      });
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();



(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddCommandSetController', AddCommandSetController);

  AddCommandSetController.$inject = ['CommandMaintenanceService', '$state','SweetAlert','toastr','$filter','entity','$uibModalInstance','PromptService'];

  function AddCommandSetController(CommandMaintenanceService, $state, SweetAlert, toastr,$filter,entity,$uibModalInstance,PromptService) {
    var vm = this;
    vm.commandSet = entity;
    vm.edit = false;
    var langs = [];

    vm.localeSure = localeSure;
    vm.showLocale = showLocale;
    vm.add = add;
    vm.clear = clear;
    vm.load = load;

    judgeEditOrCreate();
    load();
    initLangs();

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#cmdSetNameBtn").attr("disabled", false);
      });
    }

    function judgeEditOrCreate() {
      if(entity.cmdSetId !== null && entity.cmdSetId !== '' && entity.cmdSetId !== undefined){
        vm.edit = true;
      }
    }

    function load() {
      if (vm.edit) {
        CommandMaintenanceService.getCommandSet(vm.commandSet, 1,1).then(function (result) {
          vm.commandSet = result.rows[0];
          CommandMaintenanceService.getCmdSetNameInfo(vm.commandSet.cmdSetId, 'com.iot.portal.admin.inm.dto.CommandSetDto',
            $("#cmdSetNameBtn").val())
            .then(function (data) {
              var __tls = {};
              var name = {};
              for (var i in data) {
                name[data[i].langCode] = data[i].value;
              }
              __tls[$("#cmdSetNameBtn").val()] = name;
              vm.commandSet.__tls = __tls;
              $("#cmdSetNameBtn").attr("disabled", false);
            })
        });
      }
    }

    function add() {
      if(!vm.edit){
        return CommandMaintenanceService.addCommandSet(vm.commandSet)
          .then(function (data) {
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('commandSet', null, {reload: true});
          }
        });
      } else{
        return CommandMaintenanceService.updateCommandSet(vm.commandSet)
          .then(function (data) {
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('commandSet', null, {reload: true});
          }
        });
      }
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $('#localeModal_' + name).modal("show");
      if ($.trim($('#localeModelBody_' + name).html()) == '') {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='" + name + "_" + langs[i].langCode
            + "' ng-model='vm.commandSet.__tls." + name + '.' + langs[i].langCode + "'/>");
          $('#localeModelBody_' + name).append(div);
          if(vm.edit){
            $("input[name='" +  name + "_" + langs[i].langCode).val(vm.commandSet.__tls[$("#cmdSetNameBtn").val()][langs[i].langCode]);
          }
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.commandSet.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + name + "_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.commandSet[name] = $("input[name='" + name + "_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_" + name).modal("hide");
      __tls[name] = description;
      vm.commandSet.__tls = __tls;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

  }
})();


/**
 * Created by user on 2017/4/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddCommandParameterController', AddCommandParameterController);

  AddCommandParameterController.$inject = ['CommandMaintenanceService', '$scope', '$state', '$uibModalInstance','entity','toastr','SweetAlert','$filter'];

  function AddCommandParameterController(CommandMaintenanceService, $scope, $state, $uibModalInstance,entity,toastr, SweetAlert,$filter) {
    var vm = this;
    vm.command = entity;
    vm.commandParam = {};
    vm.clear = clear;
    vm.sequence = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];
    vm.add = add;
    var command = vm.command;
    getCommandByCommandId(command);
    function getCommandByCommandId(command) {
      return CommandMaintenanceService.findCommands(command)
        .then(function (data) {
          vm.command = data.rows[0];
        })
    }
    function add() {
      vm.commandParam.cmdId = vm.command.cmdId;
      vm.commandParam.cmdCode = vm.command.cmdCode;
      var paramDefinition = vm.commandParam.paramDefinition;
      var ij = isJson(paramDefinition);
      if(ij){
        var cpn = {};
        var cpIndex = {};
        cpn["paramName"] = vm.commandParam.paramName;
        cpn["cmdId"] = vm.command.cmdId;
        cpIndex["cmdId"] = vm.command.cmdId;
        cpIndex["sequence"] = vm.commandParam.sequence;

        findeTotal(cpn);

      } else {
        vm.errorMsg = $filter('T')('command.addFailMsg');
        vm.addError = true;
      }


    }


    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function isJson(str){
      if (str.indexOf("{") > -1) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      }
      return false;
    }

    function findeTotal(cpn) {
      CommandMaintenanceService.findCommandParam(cpn,1,999)
        .then(function (data) {
          var v =  data.total;
          if(v>0){
            vm.errorMsg = $filter('T')('command.sameParam');
            vm.addError = true;
            //SweetAlert.error("已存在同名参数，新增失败！",{title:"提示"});
          }else{
                  return CommandMaintenanceService.addCommandParam(vm.commandParam)
                    .then(function (data) {
                      if (data.success) {
                        /*toastr.success('保存成功！','信息提示');*/
                        toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
                        $uibModalInstance.close();
                        return $state.go('commandParameter', null, {reload: true});
                      }
                    });
          }
        });
    }
  }


})();

/**
 * Created by user on 2017/4/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddCommandController', AddCommandController);

  AddCommandController.$inject = ['CommandMaintenanceService', '$scope', '$state', '$uibModalInstance','toastr','SweetAlert','$filter'];

  function AddCommandController(CommandMaintenanceService, $scope, $state, $uibModalInstance,toastr,SweetAlert,$filter) {
    var vm = this;
    vm.command = {};
    vm.clear = clear;
    vm.isSystem = false;
    vm.products= null;
    vm.hasParam = ["Y", "N"];
    vm.add = add;
    vm.changeProduct = changeProduct;
    findProduct();
    function findProduct(){
      return CommandMaintenanceService.findProduct()
        .then(function (data) {

          vm.products = data.rows;
         // vm.totalItems = data.total;
        })
    }
    function changeProduct(){
      for (var i in  vm.products) {
        if (vm.products[i].productCode == vm.command.productCode) {
          vm.command["productId"] = vm.products[i].productId;
            break;
        }
      }
    }


    function add() {
      var cpn = {};
      cpn["productCode"] = vm.command.productCode;
      cpn["cmdCode"] = vm.command.cmdCode;
      findTotal(cpn);
    };

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function findTotal(cpn) {
      CommandMaintenanceService.findCommands(cpn)
        .then(function (data) {
          var v =  data.total;
          if(v>0){
           vm.errorMsg = $filter('T')('command.sameCommand');
           vm.addError = true;
          }else{
            return CommandMaintenanceService.addCommand(vm.command)
              .then(function (data) {
                if (data.success) {
                  toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
                  $uibModalInstance.close();
                  return $state.go('commandMaintenance', null, {reload: true});
                }
              },function(data){
                vm.errorMsg = $filter('T')('command.addFailMsg');
                vm.addError = true;
              });
          }
        });
    }

  }


})();

/**
 * Created by xiawangliu on 2017/7/25.
 */
(function () {
  'use strict';

  angular.module('hmapFront').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('irule', {
        parent: 'app',
        url: "/irule",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/idk/html/irule.html",
            controller: 'IRuleController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {}
          }
        }
      })

      .state('irule.add', {
        parent: 'app',
        url: "/irule/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/iot/portal/admin/idk/html/addIRule.html",
            controller: 'AddIRuleController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                }
              }
            }
          }).result.then(function () {
            $state.go('irule', null, {reload: true});
          }, function () {
            $state.go('irule');
          });
        }]
      })

      .state('irule.edit', {
        parent: 'app',
        url: "/irule/edit/{ruleHeaderId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/iot/portal/admin/idk/html/addIRule.html",
            controller: 'AddIRuleController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  ruleHeaderId: $stateParams.ruleHeaderId
                }
              }
            }
          }).result.then(function () {
            $state.go('irule', null, {reload: true});
          }, function () {
            $state.go('irule');
          });
        }]
      })

      .state('irule.ruleLine', {
        parent: 'app',
        url: "/iruleLine/{ruleHeaderId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/idk/html/iruleLine.html",
            controller: 'IRuleLineController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              ruleHeaderId:$stateParams.ruleHeaderId
            }
          }
        }
      })

      .state('irule.ruleLine.add', {
        parent: 'app',
        url: "/iruleLine/add/{ruleHeaderId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/iot/portal/admin/idk/html/addIRuleLine.html",
            controller: 'AddIRuleLineController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  ruleHeaderId:$stateParams.ruleHeaderId
                }
              }
            }
          }).result.then(function () {
            $state.go('irule.ruleLine', {ruleHeaderId:$stateParams.ruleHeaderId}, {reload: true});
          }, function () {
            $state.go('irule.ruleLine', {ruleHeaderId: $stateParams.ruleHeaderId});
          })
        }]
      })
      .state('irule.ruleLine.edit', {
        parent: 'app',
        url: "/iruleLine/edit/{ruleHeaderId}/{ruleLineId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/iot/portal/admin/idk/html/addIRuleLine.html",
            controller: 'AddIRuleLineController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  ruleLineId: $stateParams.ruleLineId
                }
              }
            }
          }).result.then(function () {
            $state.go('irule.ruleLine', {ruleHeaderId: $stateParams.ruleHeaderId}, {reload: true});
          }, function () {
            $state.go('irule.ruleLine', {ruleHeaderId: $stateParams.ruleHeaderId});
          })
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/7/31.
 */

(function () {
  'use strict';

  angular.module('hmapFront').controller('IRuleLineController', IRuleLineController);

  IRuleLineController.$inject = ['IRuleService', '$state', 'paginationConstants', 'entity', 'SweetAlert', '$filter','MessageTemplateService'];

  function IRuleLineController(IRuleService, $state, paginationConstants, entity, SweetAlert, $filter,MessageTemplateService) {
    var vm = this;
    vm.iRuleLine = entity;

    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.deleteIRuleLine = deleteIRuleLine;
    vm.initWidget = initWidget;

    vm.search();
    vm.initWidget();

    function loadAll(ruleLine, page) {
      return IRuleService.queryIRuleLines(ruleLine, page).then(function (data) {
        vm.result = data.rows;
        vm.totalItems = data.total;
      })

    }

    function search() {
      if (vm.iRuleLine.ruleCode === null || vm.iRuleLine.ruleCode === "") {
        vm.iRuleLine.ruleCode = "";
      }
      if (vm.iRuleLine.description === null || vm.iRuleLine.description === "") {
        vm.iRuleLine.description = "";
      }
      if (vm.iRuleLine.ruleHeaderId == undefined || vm.iRuleLine.ruleHeaderId == "") {
      } else{
        loadAll(vm.iRuleLine, vm.page);
      }
    }
    function initWidget() {
      // timezones and gender
      MessageTemplateService.getByCode().query({code: 'SYS.ID_KEY_RULE_VALUE_RANGE'}, function (data) {
        vm.valueRange = data.rows;
      });
    }

    function deleteIRuleLine(iRuleLine) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm", {title: $filter('T')("title.confirmTitle")})).then(function (p) {
        if (p) {
          return IRuleService.deleteIRuleLine(iRuleLine).then(function (data) {
            if (data.success) {
              return $state.go('irule', null, {reload: true});
            }
          })
        }
      })
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      loadAll(vm.code, vm.page);
    }

  }
})();

/**
 * Created by zyl on 2017/7/31.
 */
(function () {
  'use strict';
  angular.module('hmapFront').factory('IRuleService', IRuleService);

  IRuleService.$inject = ['$resource', '$http', '$rootScope'];

  function IRuleService($resource, $http, $rootScope) {

    return {
      queryIRules: queryIRules,
      saveIRule: saveIRule,
      saveIRuleLine:saveIRuleLine,
      queryIRuleLines: queryIRuleLines,
      updateIRule: updateIRule,
      updateIRuleLine:updateIRuleLine,
      deleteIRule: deleteIRule,
      deleteIRuleLine: deleteIRuleLine,
      selectLang: selectLang,
      getRuleLineLocaleInfo:getRuleLineLocaleInfo
    };

    function queryIRules(data,page) {
      var resourceUrl = '/api/idkey/queryRuleHeader?page=' + page;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function saveIRule(data) {
      var resourceUrl = '/api/idkey/addRuleHeader';
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function saveIRuleLine(data) {
      var resourceUrl = '/api/idkey/addRuleLine';
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function queryIRuleLines(iRuleLine,page) {
      var resourceUrl = '/api/idkey/queryRuleLine?page='+page;
      return $http.post(resourceUrl, iRuleLine, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function updateIRule(iRule) {
      var resourceUrl = '/api/idkey/updateRuleHeader';
      return $http.post(resourceUrl, iRule, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function updateIRuleLine(iRuleLine) {
      var resourceUrl = '/api/idkey/updateRuleLine';
      return $http.post(resourceUrl, iRuleLine, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }
    function deleteIRule(iRule) {
      var resourceUrl = '/api/idkey/deleteRuleHeader';
      return $http.post(resourceUrl, iRule, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function deleteIRuleLine(iRuleLine) {
      var resourceUrl = '/api/idkey/deleteRuleLine';
      return $http.post(resourceUrl, {ruleLineId: iRuleLine.ruleLineId}, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    //get product locale info
    function getRuleLineLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }

    //query language value
    function selectLang(){
      var resourceUrl ='/api/prompt/queryLang';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

  }

})();

/**
 * Created by xiawang.liu on 2017/7/31.
 */

(function () {
  'use strict';

  angular.module('hmapFront').controller('IRuleController', IRuleController);

  IRuleController.$inject = ['IRuleService', '$state', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];

  function IRuleController(IRuleService, $state, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.irule = entity;

    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.deleteIrules = deleteIrules;

    vm.search();

    function loadAll(rule,page) {
      return IRuleService.queryIRules(rule, page).then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
        })
    }

    function search() {
      if (vm.irule.ruleType === null || vm.irule.ruleType === "") {
        vm.irule.ruleType = undefined;
      }
      loadAll(vm.irule, vm.page);
    }

    function deleteIrules(rule) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm", {title: $filter('T')("title.confirmTitle")})).then(function (p) {
        if(p){
          return IRuleService.deleteIRule(rule).then(function (data) {
              if (data.success) {
                return $state.go('irule', null, {reload: true});
              }
            })
        }
      })
    }


    function pageChanged() {
      loadAll(vm.irule, vm.page);
    }
  }
})();

/**
 * Created by xiawangliu on 2017/7/25.
 */
(function () {
  'use strict';

  angular.module('hmapFront').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('idkparty', {
        parent: 'app',
        url: "/idkparty",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/idk/html/idkey-party.html",
            controller: 'IdKeyPartyController',
            controllerAs: 'vm'
          }
        }
      }).state('idkparty.edit', {
      parent: 'app',
      url: "/idkparty/:partyId/edit",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/idk/html/idkey-party-edit.html",
          controller: 'IdKeyPartyEditController',
          controllerAs: 'vm',
          resolve: {
            entity: function ($stateParams) {
              return {
                partyId: $stateParams.partyId,
                partyStatus: 'Y'
              };
            }
          }
        }
      }
    }).state('idkparty.new', {
      parent: 'app',
      url: "/idkparty/new",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/idk/html/idkey-party-edit.html",
          controller: 'IdKeyPartyEditController',
          controllerAs: 'vm',
          resolve: {
            entity: function () {
              return {
                partyStatus: 'Y'
              };
            }
          }
        }
      }
    })
  }
})();

/**
 * Created by xiawangliu on 2017/7/25.
 */

(function () {
  'use strict';
  angular.module('hmapFront').factory('IdKeyPartyService', IdKeyPartyService);

  IdKeyPartyService.$inject = ['$resource', '$http', '$rootScope'];

  function IdKeyPartyService($resource, $http, $rootScope) {
    var selectedGroup = {};

    return {
      selectedGroup: selectedGroup,
      shareGroup: shareGroup,
      queryParties: queryParties,
      queryRoles: queryRoles,
      saveParty: saveParty,
      getParty: getParty,
      updateParty: updateParty,
      deleteParty: deleteParty,
      selectLang: selectLang
    };

    function queryParties(data) {
      var resourceUrl = '/api/party/queryKeyOrSkuParty?pageIndex=' + data.page + "&pageSize=" + data.pageSize;
      return $http.post(resourceUrl, {partyAccount: data.partyAccount}, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function saveParty(data) {
      var resourceUrl = '/api/party/addKeyOrSkuParty';
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function getParty(data) {
      var resourceUrl = '/api/party/queryKeyOrSkuParty?pageIndex=' + 1 + "&pageSize=" + -1;
      return $http.post(resourceUrl, {partyId: data.partyId}, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function updateParty(party) {
      var resourceUrl = '/api/party/updateKeyOrSkuParty';
      return $http.post(resourceUrl, party, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        }).then(function(response){
          return response.data;
        })
    }

    function deleteParty(party) {
      var resourceUrl = '/api/party/deleteKeyOrSkuParty';
      return $http.post(resourceUrl, {partyId: party.partyId, partyAccount: party.partyAccount}, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        }).then(function(response){
          return response.data;
        })
    }

    function queryRoles(data) {
      var resourceUrl = '/api/sysRole/queryRolesByCondition';
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function shareGroup(selectedGroup){
      this.selectedGroup = selectedGroup;
      $rootScope.$broadcast('handleSelectedGroup');
    }

    //query language value
    function selectLang(){
      var resourceUrl ='/api/prompt/queryLang';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

  }

})();

/**
 * Created by xiawangliu on 2017/7/25.
 */

(function() {
  'use strict';

  angular.module('hmapFront').controller('IdKeyPartyController', IdKeyPartyController);

  IdKeyPartyController.$inject = ['$filter', '$state', 'IdKeyPartyService','paginationConstants', 'toastr', 'SweetAlert', 'MessageTemplateService'];
  /** @ngInject */
  function IdKeyPartyController($filter, $state, IdKeyPartyService, paginationConstants, toastr, SweetAlert, MessageTemplateService) {
    var vm = this;

    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.pageChanged = pageChanged;
    vm.queryPartiesByCondition = queryPartiesByCondition;
    vm.deleteParty = deleteParty;
    vm.initWeidget = initWeidget;
    vm.loadAll = loadAll;

    vm.initWeidget();



    vm.loadAll(null);
    function loadAll(condition) {
      IdKeyPartyService.queryParties({
        partyAccount: condition,
        page: vm.page,
        pageSize: paginationConstants.itemsPerPage
      }).then(function(response) {
        vm.parties = response.rows;
        vm.totalItems = response.total;
      });
    }


    function deleteParty(party) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"), {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if(p){
          IdKeyPartyService.deleteParty(party).then(function(response){
            if (response.success) {
              toastr.success($filter('T')("plugin.deleteSucceed"), $filter('T')("plugin.deleteMessage"));
              loadAll();
            } else {
              toastr.error($filter('T')("plugin.deleteFailure"), $filter('T')("plugin.deleteMessage"));
            }
          }, function() {
            toastr.error($filter('T')("plugin.deleteFailure"), $filter('T')("plugin.deleteMessage"));
          })
        }
      });
    }

    function pageChanged() {
      loadAll(vm.searchPartyAccount == null || vm.searchPartyAccount == "" ? null : vm.searchPartyAccount);
    }

    function queryPartiesByCondition() {
      loadAll(vm.searchPartyAccount == null || vm.searchPartyAccount == "" ? null : vm.searchPartyAccount);
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'SYS.ID_KEY_PARTY'},function (data) {
        vm.referenceSources = data.rows;
      });

      MessageTemplateService.getByCode().query({code:'SYS.PROCESSING_STATUS'},function (data) {
        vm.states = data.rows;
      });

      IdKeyPartyService.queryRoles({condition1: 'idkey'}).then(function(response) {
        vm.roles = response.rows;
      })
    }
  }
})();

/**
 * Created by mclin on 2017-4-28.
 */
(function () {
  'use strict';

  angular.module('hmapFront').controller('IdKeyPartyEditController', IdKeyPartyEditController);

  IdKeyPartyEditController.$inject = ['$filter', '$state', 'entity', 'toastr', 'toastrConfig', 'SweetAlert', 'IdKeyPartyService', 'MessageTemplateService'];

  function IdKeyPartyEditController($filter, $state, entity, toastr, toastrConfig, SweetAlert, IdKeyPartyService, MessageTemplateService) {

    var vm = this;
    vm.party = entity;

    vm.clear = clear;
    vm.save = save;
    vm.initData = initData;
    vm.partyTypeChange = partyTypeChange;
    vm.initWeidget = initWeidget;
    vm.showOrHidePwd = showOrHidePwd;
    vm.validatePwd = validatePwd;
    vm.timezones = [];
    vm.locales = [];
    vm.roles = [];
    vm.genders = [];
    vm.states = [];
    vm.referenceSources = [];
    vm.showPwdEnabled = true;

    vm.initWeidget();
    vm.initData();

    var count = 0;
    function initData() {
      if (vm.party.partyId) {
        IdKeyPartyService.getParty(vm.party).then(function(response){
          if (response.rows.length > 0) {
            vm.party = response.rows[0];
            // clear password info
            vm.party.password = null;
            vm.party.passwordConfirm = null;
          }
        })
      }
    }

    function validatePwd() {
      var passwordEncrypted = $("#passwordInit").val();
      var passwordConfirm = $("#passwordConfirm").val();
      if(passwordEncrypted != passwordConfirm){
        SweetAlert.error($filter('T')("title.pwdNotSame"), {title: $filter('T')("btnTypeName.prompt")});
        $("#passwordConfirm").val("");
        vm.party.passwordConfirm = "";
      }
    }

    function clear() {
      $state.go('idkparty');
    }

    function save() {
      if (vm.party.partyId) {
        count++;
        if ((vm.party.password == null || $.trim(vm.party.password) == '') &&
          (vm.party.passwordConfirm == null || $.trim(vm.party.passwordConfirm) == '')) {
          vm.party.password = $.trim(vm.party.password);
          SweetAlert.confirm($filter('T')('title.pwdModifyTip'), {title: $filter('T')('title.confirmTitle')})
            .then(function (p) {
              if (p) {
                IdKeyPartyService.updateParty(vm.party).then(function (response) {
                  toastr.success($filter('T')('title.saveSuccess'));
                  $state.go("idkparty");
                });
              }
            })
        } else {
          if (vm.party.password == vm.party.passwordConfirm) {
            vm.party.password = $.trim(vm.party.password);
            IdKeyPartyService.updateParty(vm.party).then(function(response){
              toastr.success($filter('T')('title.saveSuccess'));
              $state.go("idkparty");
            });
          } else {
            toastr.error("[" + count + "] " + $filter('T')('title.pwdNotSame'));
          }
        }
      } else if (!vm.party.partyId) {
        count++;
        if ((vm.party.password == null || $.trim(vm.party.password) == '') &&
          (vm.party.passwordConfirm == null || $.trim(vm.party.passwordConfirm) == '')) {
          vm.party.password = $.trim(vm.party.password);
          IdKeyPartyService.saveParty(vm.party).then(function(response){

            if(response.code=='repeat'){
              toastr.warning($filter('T')('distribution.repeatNot'));
              return ;
            }

            toastr.success($filter('T')('title.saveSuccess'));
            $state.go("idkparty");
          });
        } else {
          if (vm.party.password == vm.party.passwordConfirm) {
            vm.party.password = $.trim(vm.party.password);
            IdKeyPartyService.saveParty(vm.party).then(function(response){
              if(response.code=='repeat'){
                toastr.warning($filter('T')('distribution.repeatNot'));
                return ;
              }

              toastr.success($filter('T')('title.saveSuccess'));
              $state.go("idkparty");
            });
          } else {
            toastr.error("[" + count + "] " + $filter('T')('title.pwdNotSame'));
          }
        }
      }
      count = 0;
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'SYS.TIME_ZONE'},function (data) {
        vm.timezones = data.rows;
      });

      MessageTemplateService.getByCode().query({code:'SYS.ID_KEY_PARTY'},function (data) {
        vm.referenceSources = data.rows;
      });

      MessageTemplateService.getByCode().query({code:'SYS.PROCESSING_STATUS'},function (data) {
        vm.states = data.rows;
      });

      IdKeyPartyService.queryRoles({condition1: 'idkey'}).then(function(response) {
        vm.roles = response.rows;
      })
    }

    function partyTypeChange() {
      vm.party.partyType = vm.party.referenceSource;
    }

    function showOrHidePwd() {
      var pwdInput = angular.element('#passwordInit');
      var pwdInputConfirm = angular.element('#passwordConfirm');
      if (vm.showPwdEnabled) {
        pwdInput.prop('type', 'text');
        pwdInputConfirm.prop('type', 'text');
        vm.showPwdEnabled = false;
      } else {
        pwdInput.prop('type', 'password');
        pwdInputConfirm.prop('type', 'password');
        vm.showPwdEnabled = true;
      }
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });

  }
})();

/**
 * Created by zyl on 2017/7/31.
 */

(function () {
  'use strict';

  angular.module('hmapFront').controller('AddIRuleLineController', AddIRuleLineController);

  AddIRuleLineController.$inject = ['PromptService', 'MessageTemplateService', 'IRuleService', '$state', '$uibModalInstance', 'paginationConstants', 'entity', 'SweetAlert', 'toastr', '$filter'];

  function AddIRuleLineController(PromptService, MessageTemplateService, IRuleService, $state, $uibModalInstance, paginationConstants, entity, SweetAlert, toastr, $filter) {
    var vm = this;
    vm.iRuleLine = entity;

    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.ruleValueDisabled = false;

    vm.addRuleLine = addRuleLine;
    vm.showDescription = showDescription;
    vm.localeSureDescription = localeSureDescription;
    vm.getLookUp = getLookUp;
    vm.clear = clear;
    vm.initLangs = initLangs;
    vm.loadAll = loadAll;
    vm.setRuleCodeEditalbe = setRuleCodeEditalbe;
    vm.initLangs();
    vm.loadAll();
    vm.getLookUp();
    vm.setRuleCodeEditalbe();
    // langs
    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn_description").attr("disabled", false);
      });
    }

    function setRuleCodeEditalbe(){
      if(vm.iRuleLine.ruleLineId){
        vm.CodeEditable = true;
      }
    }
    function loadAll() {
      if (vm.iRuleLine.ruleLineId) {
        IRuleService.queryIRuleLines(vm.iRuleLine, 1).then(function (result) {
          vm.iRuleLine = result.rows[0];
          IRuleService.getRuleLineLocaleInfo(vm.iRuleLine.ruleLineId, 'com.iot.common.sys.dto.IdmKeyRuleLineDTO', $("#localeBtn_description").val())
            .then(function (data) {
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn_description").val()] = description;
              vm.iRuleLine.__tls = __tls;
              $("#localeBtn_description").attr("disabled", false);
            })
        })
      }
    }

    function addRuleLine() {
      if (vm.iRuleLine.ruleLineId) {
        return IRuleService.updateIRuleLine(vm.iRuleLine).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('irule.ruleLine', null, {reload: true});
          }
        })
      }
      else {
        return IRuleService.saveIRuleLine(vm.iRuleLine).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('irule.ruleLine', null, {reload: true});
          }
        })
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showDescription() {
      $("#localeDescriptionModal").modal("show");
      if ($.trim($("#localeDescriptionModalBody").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "description' ng-model='vm.iRule.__tls." + $("#localeBtn_description").val() + '.' + langs[i].langCode + "'/>");
            $("#localeDescriptionModalBody").append(div);
            if (vm.iRuleLine.ruleLineId) {
              $("input[name='" + langs[i].langCode + "description']").val(vm.iRuleLine.__tls[$("#localeBtn_description").val()][langs[i].langCode]);
            }
          }
        }
      }
    }
    //save desc model
    function localeSureDescription() {
      var __tls = vm.iRuleLine.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "description']").val();
      }
      var btnValue = $("#localeBtn_description").val();
      vm.iRuleLine[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "description']").val();
      $("#localeDescriptionModal").modal("hide");
      __tls[btnValue] = description;
      vm.iRuleLine.__tls = __tls;
    }

    function getLookUp() {
      MessageTemplateService.getByCode().query({code: 'SYS.ID_KEY_RULE_VALUE_RANGE'}, function (data) {
        vm.valueRange = data.rows;
      });
    }
  }
})();

/**
 * Created by zyl on 2017/7/31.
 */

(function () {
  'use strict';

  angular.module('hmapFront').controller('AddIRuleController', AddIRuleController);

  AddIRuleController.$inject = ['PromptService', 'IRuleService', '$state','$uibModalInstance', 'paginationConstants', 'entity', 'SweetAlert','toastr', '$filter'];

  function AddIRuleController(PromptService, IRuleService, $state, $uibModalInstance, paginationConstants, entity, SweetAlert,toastr, $filter) {
    var vm = this;
    vm.irule = entity;
    vm.saveRule = saveRule;
    vm.showDescription = showDescription;
    vm.localeSure = localeSure;
    vm.load = load;
    vm.clear = clear;
    vm.initLangs = initLangs;
    vm.initLangs();
    vm.load();

    // langs
    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn_description").attr("disabled", false);
      });
    }

    //init load
    function load() {
      if (vm.irule.ruleHeaderId) {
        IRuleService.queryIRules(vm.irule, 1).then(function (result) {
          vm.irule = result.rows[0];
          IRuleService.getRuleLineLocaleInfo(vm.irule.ruleHeaderId, 'com.iot.common.sys.dto.IdmKeyRuleHeaderDTO', $("#localeBtn_description").val())
            .then(function (data) {
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn_description").val()] = description;
              vm.irule.__tls = __tls;
              $("#localeBtn_description").attr("disabled", false);
            })
        })
      }
    }
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function saveRule() {
      if(!vm.irule.ruleHeaderId){
        return IRuleService.saveIRule(vm.irule).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('irule', null, {reload: true});
          }
        })
      }
      else {
        return IRuleService.updateIRule(vm.irule).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('irule', null, {reload: true});
          }
        })
      }
    }

    function showDescription() {
      $("#localeModal").modal("show");
      if ($.trim($("#localeModelBody").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "description' ng-model='vm.irule.__tls." + $("#localeBtn_description").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody").append(div);
            if (vm.irule.ruleHeaderId) {
              $("input[name='" + langs[i].langCode + "description']").val(vm.irule.__tls[$("#localeBtn_description").val()][langs[i].langCode]);
            }
          }
        }
      }
    }
    //save desc model
    function localeSure() {
      var __tls = vm.irule.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "description']").val();
      }
      var btnValue = $("#localeBtn_description").val();
      vm.irule[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "description']").val();
      $("#localeModal").modal("hide");
      __tls[btnValue] = description;
      vm.irule.__tls = __tls;
    }

  }
})();

/**
 * Created by xiawang.liu on 2017/06/11.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('ViewDevicePropertyController', ViewDevicePropertyController);

  ViewDevicePropertyController.$inject = ['$scope', 'DeviceBaseService', 'paginationConstants', 'entity', '$uibModalInstance'];

  function ViewDevicePropertyController($scope, DeviceBaseService, paginationConstants, entity, $uibModalInstance) {
    var vm = this;
    vm.property = entity;
    vm.schema = {
      residential: 'res',
      commercial: 'com'
    };
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.getProperty = getProperty;
    vm.clear = clear;
    vm.getProperty();

    //get Property
    function getProperty() {
      return DeviceBaseService.getProperty(vm.property, vm.page, vm.schema[vm.property.referenceSource]).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.property = data.rows[0];
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    $scope.$watch('$viewContentLoaded', function(){
      $("select").attr("disabled", true);
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * Created by xiwang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('UpdateSkuPropertyController', UpdateSkuPropertyController);

  UpdateSkuPropertyController.$inject = ['SkuService', '$scope', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', 'SweetAlert', '$filter', 'ProductService'];

  function UpdateSkuPropertyController(SkuService, $scope, $state, $uibModalInstance, toastr, entity, PromptService, SweetAlert, $filter, ProductService) {
    var vm = this;
    vm.property = entity;

    vm.clear = clear;
    vm.addProperty = addProperty;
    vm.show = show;
    vm.showPropertyName = showPropertyName;
    vm.localeSure = localeSure;
    vm.localeSurePropertyName = localeSurePropertyName;
    vm.showParameterRange = showParameterRange;
    vm.showDefaultValue = showDefaultValue;
    vm.showCurrentValue = showCurrentValue;
    vm.localeSureParameterRange = localeSureParameterRange;
    vm.localeSureDefaultValue = localeSureDefaultValue;
    vm.localeSureCurrentValue = localeSureCurrentValue;
    vm.changeParameterRange = changeParameterRange;
    vm.load = load;
    vm.getUnit = getUnit;

    vm.load();
    vm.getUnit();

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
        /*$("#localeBtn_propertyName").attr("disabled", false);*/
        /*$("#localeBtn_parameterRange").attr("disabled", false);*/
        $("#localeBtn_defaultValue").attr("disabled", false);
        $("#localeBtn_currentValue").attr("disabled", false);
      });
    }
    initLangs();

    //init load
    function load() {
      if (vm.property.propertyId) {
        SkuService.getProperty(vm.property, 1).then(function (result) {
          vm.property = result.rows[0];
          SkuService.getProductLocaleInfo(vm.property.propertyId, 'com.iot.portal.admin.dvm.dto.DvmSkuPropertyDTO', $("#localeBtn").val())
            .then(function (data) {
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn").val()] = description;
              SkuService.getProductLocaleInfo(vm.property.propertyId, 'com.iot.portal.admin.dvm.dto.DvmSkuPropertyDTO', $("#localeBtn_propertyName").val())
                .then(function (data) {
                  var propertyName = {};
                  for (var i in data) {
                    propertyName[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#localeBtn_propertyName").val()] = propertyName;
                  vm.property.__tls = __tls;
                  SkuService.getProductLocaleInfo(vm.property.propertyId, 'com.iot.portal.admin.dvm.dto.DvmSkuPropertyDTO', $("#localeBtn_parameterRange").val())
                    .then(function (data) {
                      var parameterRange = {};
                      for (var i in data) {
                        parameterRange[data[i].langCode] = data[i].value;
                      }
                      __tls[$("#localeBtn_parameterRange").val()] = parameterRange;
                      vm.property.__tls = __tls;
                      SkuService.getProductLocaleInfo(vm.property.propertyId, 'com.iot.portal.admin.dvm.dto.DvmSkuPropertyDTO', $("#localeBtn_defaultValue").val())
                        .then(function (data) {
                          var defaultValue = {};
                          for (var i in data) {
                            defaultValue[data[i].langCode] = data[i].value;
                          }
                          __tls[$("#localeBtn_defaultValue").val()] = defaultValue;
                          vm.property.__tls = __tls;
                          SkuService.getProductLocaleInfo(vm.property.propertyId, 'com.iot.portal.admin.dvm.dto.DvmSkuPropertyDTO', $("#localeBtn_currentValue").val())
                            .then(function (data) {
                              var currentValue = {};
                              for (var i in data) {
                                currentValue[data[i].langCode] = data[i].value;
                              }
                              __tls[$("#localeBtn_currentValue").val()] = currentValue;
                              vm.property.__tls = __tls;
                              $("#localeBtn").attr("disabled", false);
                              /*$("#localeBtn_propertyName").attr("disabled", false);*/
                              if((vm.property.parameterType == 'ENUMERATE')){
                                $("#localeBtn_parameterRange").attr("disabled", false);
                              }
                              $("#localeBtn_defaultValue").attr("disabled", false);
                              $("#localeBtn_currentValue").attr("disabled", false);
                            })
                        })
                    })
                })
            })
        })
      }
    }

    function getUnit() {
      ProductService.getUnit().then(function (result) {
        if(!result.rows){
          return;
        }
        vm.units = result.rows;
      })
    }

    //invalid range
    function changeParameterRange() {
      if(vm.property.parameterRange){
        var parameterRange = vm.property.parameterRange;
        if(parameterRange.indexOf("/") == 0 || parameterRange.indexOf("/") + 1 == parameterRange.length){
          return false;
        }
        return true;
      }
    }

    //submit add product
    function addProperty() {
      if(!vm.changeParameterRange()){
        SweetAlert.error($filter('T')("property.ruleIllegal"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      var properties = new Array();
      properties.push(vm.property);
      return SkuService.updateProperty(properties).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('dvmPproperty', null, {reload: true});
          }
        });
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    //page init disable select
 /*   $scope.$watch('$viewContentLoaded', function(){
      $("select").attr("disabled", true);
    });*/

    function show() {
      $("#localeModal").modal("show");
      if($.trim($("#localeModelBody").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "' ng-model='vm.property.__tls." + $("#localeBtn").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "']").val(vm.property.__tls[$("#localeBtn").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showPropertyName() {
      $("#localeModal_propertyName").modal("show");
      if($.trim($("#localeModelBody_propertyName").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Name' ng-model='vm.property.__tls." + $("#localeBtn_propertyName").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_propertyName").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "Name']").val(vm.property.__tls[$("#localeBtn_propertyName").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showParameterRange() {
      $("#localeModal_parameterRange").modal("show");
      if($.trim($("#localeModelBody_parameterRange").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Range' ng-model='vm.property.__tls." + $("#localeBtn_parameterRange").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_parameterRange").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "Range']").val(vm.property.__tls[$("#localeBtn_parameterRange").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showDefaultValue() {
      $("#localeModal_defaultValue").modal("show");
      if($.trim($("#localeModelBody_defaultValue").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Default' ng-model='vm.property.__tls." + $("#localeBtn_defaultValue").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_defaultValue").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "Default']").val(vm.property.__tls[$("#localeBtn_defaultValue").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showCurrentValue() {
      $("#localeModal_currentValue").modal("show");
      if($.trim($("#localeModelBody_currentValue").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Current' ng-model='vm.property.__tls." + $("#localeBtn_currentValue").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_currentValue").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "Current']").val(vm.property.__tls[$("#localeBtn_currentValue").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function localeSure() {
      var __tls = vm.property.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "']").val();
      }
      var btnValue = $("#localeBtn").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal").modal("hide");
      __tls[btnValue] = description;
      vm.property.__tls = __tls;
    }

    function localeSurePropertyName() {
      var __tls = vm.property.__tls || {};
      var propertyName = {};
      for (var i in langs) {
        propertyName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Name']").val();
      }
      var btnValue = $("#localeBtn_propertyName").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Name']").val();
      $("#localeModal_propertyName").modal("hide");
      __tls[btnValue] = propertyName;
      vm.property.__tls = __tls;
    }

    function localeSureParameterRange() {
      var __tls = vm.property.__tls || {};
      var parameterRange = {};
      for (var i in langs) {
        parameterRange[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Range']").val();
      }
      var btnValue = $("#localeBtn_parameterRange").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Range']").val();
      $("#localeModal_parameterRange").modal("hide");
      __tls[btnValue] = parameterRange;
      vm.property.__tls = __tls;
    }

    function localeSureDefaultValue() {
      var __tls = vm.property.__tls || {};
      var defaultValue = {};
      for (var i in langs) {
        defaultValue[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Default']").val();
      }
      var btnValue = $("#localeBtn_defaultValue").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Default']").val();
      $("#localeModal_defaultValue").modal("hide");
      __tls[btnValue] = defaultValue;
      vm.property.__tls = __tls;
    }

    function localeSureCurrentValue() {
      var __tls = vm.property.__tls || {};
      var currentValue = {};
      for (var i in langs) {
        currentValue[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Current']").val();
      }
      var btnValue = $("#localeBtn_currentValue").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Current']").val();
      $("#localeModal_currentValue").modal("hide");
      __tls[btnValue] = currentValue;
      vm.property.__tls = __tls;
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('dvmSproperty', {
        parent: 'app',
        url: "/dvmSproperty/{skuId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/skuProperty.html",
            controller: 'SkuPropertyController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams', function ($stateParams) {
            return {
              skuId : $stateParams.skuId
            };
          }]
        }
      })
      .state('dvmSproperty.add', {
        parent: 'dvmSproperty',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addSkuProperty.html',
            controller: 'AddSkuPropertyController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  skuId : $stateParams.skuId
                }
              }
            }
          }).result.then(function () {
            $state.go('dvmSproperty', null, {reload: true});
          }, function () {
            $state.go('dvmSproperty');
          });
        }]
      })
      .state('dvmSproperty.edit', {
        parent: 'dvmSproperty',
        url: "/edit/:propertyId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/updateSkuProperty.html',
            controller: 'UpdateSkuPropertyController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  propertyId: $stateParams.propertyId
                }
              }
            }
          }).result.then(function () {
            $state.go('dvmSproperty', null, {reload: true});
          }, function () {
            $state.go('dvmSproperty');
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('SkuPropertyController', SkuPropertyController);

  SkuPropertyController.$inject = ['SkuService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', '$state', 'toastr', 'MessageTemplateService'];

  function SkuPropertyController(SkuService, paginationConstants, entity, SweetAlert, $filter, $state, toastr, MessageTemplateService) {
    var vm = this;
    vm.property = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkProperty = checkProperty;
    vm.checkAllProperty = checkAllProperty;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetProperty = resetProperty;
    vm.deleteProperty = deleteProperty;
    vm.deletePropertys = deletePropertys;
    vm.getProperty = getProperty;
    vm.initWeidget = initWeidget;

    vm.getProperty();
    vm.initWeidget();

    //get Property
    function getProperty() {
      return SkuService.getProperty(vm.property, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.propertys = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search property
    function search() {
      vm.getProperty();
    }

    //reset Property
    function resetProperty() {
      vm.property.propertyName = undefined;
      vm.property.propertyCode = undefined;
    }

    //delete Property
    function deleteProperty(property) {
      SweetAlert.confirm(property.propertyCode + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var propertys = new Array();
          var entity = new Object();
          entity.skuId = vm.property.skuId;
          entity.propertyId = property.propertyId;
          propertys.push(entity);
          SkuService.deletePropertys(propertys).then(function (response) {
            if (response.success) {
              vm.getProperty();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete Property
    function deletePropertys() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var propertys = new Array();
          $(arrChk).each(function() {
            var property = new Object();
            property.propertyId = this.value;
            property.skuId = vm.property.skuId;
            propertys.push(property);
          });
          SkuService.deletePropertys(propertys).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getProperty();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getProperty();
    }


    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'IOT.DVM_ATTRIBUTE_TYPE'},function (data) {
        vm.attributeType = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'IOT.DVM_ATTRIBUTE_RULE_TYPE'},function (data) {
        vm.ruleType = data.rows;
      },function (error) {
      });
    }

    //check or unCheck check Property
    function checkProperty() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Property
    function checkAllProperty() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('dvmsku', {
        parent: 'app',
        url: "/dvmsku",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/sku.html",
            controller: 'SkuController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
            };
          }
        }
      })
      .state('dvmsku.add', {
        parent: 'dvmsku',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addSku.html',
            controller: 'AddSkuController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  productId: $stateParams.productId
                }
              }
            }
          }).result.then(function () {
            $state.go('dvmsku', null, {reload: true});
          }, function () {
            $state.go('dvmsku');
          });
        }]
      })
      .state('dvmsku.edit', {
        parent: 'dvmsku',
        url: "/edit/:skuId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addSku.html',
            controller: 'AddSkuController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  skuId: $stateParams.skuId
                }
              }
            }
          }).result.then(function () {
            $state.go('dvmsku', null, {reload: true});
          }, function () {
            $state.go('dvmsku');
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront').factory('SkuService', SkuService);

  SkuService.$inject = ['$http'];

  function SkuService($http) {
    return {
      getSku: getSku,
      getProperty: getProperty,
      deleteSkus: deleteSkus,
      deletePropertys: deletePropertys,
      addSku: addSku,
      updateSku: updateSku,
      addProperty: addProperty,
      getProductLocaleInfo: getProductLocaleInfo,
      getProduct: getProduct,
      getPropertyInProduct: getPropertyInProduct,
      updateProperty: updateProperty
    };

    //add product
    function updateProperty (entity) {
      var resourceUrl = '/api/ctm/updateSkuProperty';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get property in product
    function getPropertyInProduct(propertyCode, skuId, page) {
      var resourceUrl = '/api/ctm/selectProductPropertyNeSkuProperty?page=' + page + '&skuId=' + skuId + '&propertyCode=' + propertyCode;
      return $http.post(resourceUrl, new Object(),{
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    //get product
    function getProduct(entity) {
      var resourceUrl = '/api/ctm/selectProduct?pageSize=-1';
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    //get sku
    function getSku(entity, page) {
      var resourceUrl = '/api/ctm/selectSku?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get property
    function getProperty(entity, page) {
      var resourceUrl = '/api/ctm/selectSkuProperty?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete products
    function deleteSkus(entity) {
      var resourceUrl = '/api/ctm/deleteSku';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete products
    function deletePropertys(entity) {
      var resourceUrl = '/api/ctm/deleteSkuProperty';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //add product
    function addSku(entity) {
      var resourceUrl = '/api/ctm/insertSku';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //update product
    function updateSku(entity) {
      var resourceUrl = '/api/ctm/updateSku';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //add product
    function addProperty (entity) {
      var resourceUrl = '/api/ctm/insertSkuProperty';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get product locale info
    function getProductLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('SkuController', SkuController);

  SkuController.$inject = ['SkuService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

  function SkuController(SkuService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
    var vm = this;
    vm.sku = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkSku = checkSku;
    vm.checkAllSku = checkAllSku;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetSku = resetSku;
    vm.deleteSku = deleteSku;
    vm.deleteSkus = deleteSkus;
    vm.getSku = getSku;
    vm.initWidget = initWidget;

    vm.getSku();
    vm.initWidget();

    //get Sku
    function getSku() {
      return SkuService.getSku(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.skus = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search sku
    function search() {
      vm.getSku();
    }

    //reset Sku
    function resetSku() {
      vm.sku.skuNumber = undefined;
      vm.sku.skuName = undefined;
    }

    //delete sku
    function deleteSku(sku) {
      SweetAlert.confirm(sku.skuNumber + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var skus = new Array();
          var entity = new Object();
          entity.skuId = sku.skuId;
          skus.push(entity);
          SkuService.deleteSkus(skus).then(function (response) {
            if (response.success) {
              vm.getSku();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete Sku
    function deleteSkus() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var skus = new Array();
          $(arrChk).each(function() {
            var sku = new Object();
            sku.skuId = this.value;
            skus.push(sku);
          });
          SkuService.deleteSkus(skus).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getSku();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getSku();
    }

    //check or unCheck check Sku
    function checkSku() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Sku
    function checkAllSku() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }

    function initWidget() {
      // timezones and gender
      MessageTemplateService.getByCode().query({code:'IOT.DVM_SKU_VEIL_FLAG'},function (data) {
        vm.veilFlag = data.rows;
      },function (error) {
      });
    }
  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('resDeviceMonitor', {
        parent: 'app',
        url: "/deviceMonitor",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/resDeviceMonitor.html",
            controller: 'DeviceMonitorController',
            controllerAs: 'vm'
          }
        },
        resolve:{
          entity:function(){
            return {};
          }
        }
      })
      .state('resDeviceInfo', {
        parent: 'app',
        url: "/resDeviceInfo/{deviceId}/{boxId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/resDeviceConnectedInfo.html",
            controller: 'resDeviceInfoController',
            controllerAs: 'vm'
          }
        },
        resolve:{
          entity:function($stateParams){
            return {
              deviceId:$stateParams.deviceId,
              boxId:$stateParams.boxId
            };
          }
        }
      })
      //.state('resDeviceMonitor.view', {
      //  parent: 'resDeviceMonitor',
      //  url: "/resDeviceLog/{deviceId}",
      //  onEnter:['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal){
      //    $uibModal.open({
      //      templateUrl: "app/iot/portal/admin/dvm/html/residentialDeviceLog.html",
      //      controller: 'resDevInfoController',
      //      controllerAs: 'vm',
      //      backdrop: 'static',
      //      size: 'lg',
      //      resolve:{
      //        entity:function($stateParams){
      //          return {
      //            deviceId:$stateParams.deviceId
      //          };
      //        }
      //      }
      //    })
      //  }]
      //})
  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('DeviceMonitorController', DeviceMonitorController);

  DeviceMonitorController.$inject = ['BaseConfig', '$localStorage', 'MessageTemplateService','DvmDeviceService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];
  /** @ngInject */
  function DeviceMonitorController(BaseConfig, $localStorage, MessageTemplateService, DvmDeviceService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.dvmDevice = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.dvmDevice.skuNumber = '';
    vm.dvmDevice.inException = '';
    vm.dvmDevice.deviceCode = '';
    vm.dvmDevice.deviceSerialNumber = '';
    vm.dvmDevice.iotDeviceId = '';
    vm.dvmDevice.referenceSource='residential';
    vm.dvmDevice.boundStatus = '';
    vm.dvmDevice.connectStatus = '';

    vm.searchResidential = searchResidential;
    vm.getResidentialDevice = getResidentialDevice;
    vm.getProduct = getProduct;
    vm.setValueToVm = setValueToVm;
    vm.residentialPageChanged = residentialPageChanged;
    vm.resetDvmDevice = resetDvmDevice;
    vm.initWidget = initWidget;
    vm.exportExcel = exportExcel;
    vm.inException = [];
    vm.connectStatus = [];

    vm.getResidentialDevice();
    vm.getProduct();
    vm.initWidget();

    //get tResidentialDevices
    function getResidentialDevice() {
      return DvmDeviceService.queryDvmDevice(vm.dvmDevice, vm.page, 'res').then(function (data) {
        console.log(data);
        if (!data.rows) {
          return;
        }
        vm.devices = data.rows;
        vm.totalDevice = data.total;
        vm.pageSize = data.rows.length;
      })
    }
    //get product
    function getProduct() {
      return DvmDeviceService.queryResidentialProductExcBox({}).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.products = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }
    //search dvmDevice
    function searchResidential() {
      vm.getResidentialDevice();
    }

    //set deviceId boxId to vm
    function setValueToVm($event, value) {
      if (value) {
        vm.dvmDevice = $($event.target).dvmDevice;
      }
    }

    //page changed
    function residentialPageChanged() {
      vm.getResidentialDevice();
    }

    //reset search condition
    function resetDvmDevice() {
      vm.dvmDevice.skuNumber = '';
      vm.dvmDevice.inException = '';
      vm.dvmDevice.deviceCode = '';
      vm.dvmDevice.deviceSerialNumber = '';
      vm.dvmDevice.iotDeviceId = '';
      vm.dvmDevice.boundStatus = '';
      vm.dvmDevice.connectStatus = '';
    }

    function initWidget() {
      // device exception status
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.DEVICE_EXCEPTION_STATUS'}, function (data) {
        vm.inException = data.rows;
      }, function (error) {
      });
      // online offline status
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.DEVICE_ONOFFLINE_STATUS'}, function (data) {
        vm.connectStatus = data.rows;
      }, function (error) {
      });

    }

    function exportExcel() {
      window.location = BaseConfig.url + '/api/public/dvm/excel/excelExportForResidentialMonitor?token='
        + $localStorage.authenticationToken.access_token
        + '&iotDeviceId=' + vm.dvmDevice.iotDeviceId + '&skuNumber=' + vm.dvmDevice.skuNumber
        + '&inException=' + vm.dvmDevice.inException + '&deviceCode=' + vm.dvmDevice.deviceCode
        + '&deviceSerialNumber=' + vm.dvmDevice.deviceSerialNumber
        + '&boundStatus=' + vm.dvmDevice.boundStatus + '&connectStatus=' + vm.dvmDevice.connectStatus;
    }
  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('resDeviceInfoController', resDeviceInfoController);

  resDeviceInfoController.$inject = ['DvmDeviceService', 'MessageTemplateService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];

  /** @ngInject */
  function resDeviceInfoController(DvmDeviceService, MessageTemplateService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.dvmDeviceInfo = entity;
    vm.page = 1;
    vm.boxPage = 1;
    vm.firmwarePage = 1;
    vm.exceptionsPage = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.dvmDeviceInfo.exceptionDescription = '';
    vm.dvmDeviceInfo.begigTime = '';
    vm.dvmDeviceInfo.endTime = '';

    vm.getExceptions = getExcepitons;
    vm.getParties = getParties;
    vm.getBoxes = getBoxes;
    vm.getFirmVersions = getFirmVersions;
    vm.residentialInfoPageChanged = residentialInfoPageChanged;
    vm.residentialInfoPartyPageChanged = residentialInfoPartyPageChanged;
    vm.residentialInfoBoxPageChanged = residentialInfoBoxPageChanged;
    vm.residentialExceptionPageChanged = residentialExceptionPageChanged;
    vm.initWidget = initWidget;
    vm.searchException = searchException;
    vm.exceptionType = [];

    vm.getParties();
    vm.getBoxes();
    vm.getFirmVersions();
    vm.getExceptions();
    vm.initWidget();

    function searchException() {
      vm.getExceptions();
    }

    function initWidget() {
      console.log(vm.dvmDeviceInfo)
      // device exception type
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.DEVICE_EXCEPTION_TYPE'}, function (data) {
        vm.exceptionType = data.rows;
      }, function (error) {
      });
    }

    //get residentialDeviceExceptions
    function getExcepitons() {
      return DvmDeviceService.queryDeviceException(vm.dvmDeviceInfo, vm.exceptionsPage, 'res').then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.exceptions = data.rows;
        vm.excepitonsTotalItems = data.total;
        vm.excepitonsPageSize = data.rows.length;
      })
    }

    //search party Connected dvmDeviceInfo
    function getParties() {
      return DvmDeviceService.queryPartyOfDevice(vm.dvmDeviceInfo, vm.page, 'res')
      .then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.parties = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search devices connected the same box
    function getBoxes() {
      return DvmDeviceService.queryBoxOfDevice(vm.dvmDeviceInfo, vm.boxPage, 'res')
      .then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.boxes = data.rows;
        vm.boxTotalItems = data.total;
        vm.boxPageSize = data.rows.length;
      })
    }

    //search dvmDeviceInfo firmware versions
    function getFirmVersions() {
      console.log(vm.dvmDeviceInfo)
      return DvmDeviceService.queryDeviceFirmwareVersion(vm.dvmDeviceInfo, vm.firmwarePage, 'res')
      .then(function (data) {
        if (!data.rows) {
          return;
        }
        console.log(data);
        vm.firmVersions = data.rows;
        vm.firmwareTotalItems = data.total;
        vm.firmwarePageSize = data.rows.length;
      })
    }

    function residentialInfoPageChanged() {
      vm.getFirmVersions();
    }

    function residentialInfoPartyPageChanged() {
      vm.getParties();
    }

    function residentialInfoBoxPageChanged() {
      vm.getBoxes();
    }

    function residentialExceptionPageChanged() {
      vm.getExceptions();
    }

    $('.form_date').datetimepicker({
      language: 'vm.lang',
      format: 'yyyy-mm-dd',
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0
    });

    function compareDate() {
      var start = $('#start').val();
      var end = $('#end').val();
      if (start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if (startTime > endTime) {
          var msg = $filter('T')("main.msg");
          vm.dvmDeviceInfo.endTime = "";
          SweetAlert.error(msg, {title: $filter('T')("btnTypeName.prompt")});
        }
      }
    }
  }
})();

/**
 * Created by zyl on 2017/6/29.
 */
(function(){
  'use strict';
  angular
    .module('hmapFront')
    .controller('resBoxLogController',resBoxLogController);

  resBoxLogController.$inject = ['BoxService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];
  /** @ngInject */
  function resBoxLogController(BoxService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.resBoxLog = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.getResBoxLog = getResBoxLog;
    vm.popupOpen = popupOpen;
    vm.search = search;
    vm.pageChanged = pageChanged;

    vm.lang = window.localStorage.lang;
    if(vm.lang == 'en_GB'){
      vm.lang = 'en';
    }

    vm.getResBoxLog();
    function getResBoxLog() {
      vm.resBoxLog.referenceSource = "residential";
      if (vm.resBoxLog.logTime) {
        vm.resBoxLog.logTime = vm.resBoxLog.logTime + ' 00:00:00';
      }
      return BoxService.queryBoxLog(vm.resBoxLog, vm.page, 'res')
        .then(function (data) {
          if (!data.rows) {
            return;
          }
          vm.resBoxLogs = data.rows;
          vm.totalItems = data.total;
        })
    }
    function search(){
      vm.getResBoxLog();
    }
    function pageChanged(){
      vm.getResBoxLog();
    }
    function popupOpen(){
      vm.isOpen = true;
    }

    //data plugin
    $('.form_date').datetimepicker({
      language: vm.lang,
      format: 'yyyy-mm-dd',
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0
    });

  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('resBoxInfoController', resBoxInfoController);

  resBoxInfoController.$inject = ['BoxService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];
  /** @ngInject */
  function resBoxInfoController(BoxService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.dvmResBox = entity;
    vm.page = 1;
    vm.devicePage = 1;
    vm.firmwarePage = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.getParties = getParties;
    vm.getDevices = getDevices;
    vm.getFirmVersions = getFirmVersions;
    vm.resBoxInfoFirmPageChanged = resBoxInfoFirmPageChanged;
    vm.resBoxInfoPartyPageChanged = resBoxInfoPartyPageChanged;
    vm.resBoxInfoDevPageChanged = resBoxInfoDevPageChanged;

    vm.getParties();
    vm.getDevices();
    vm.getFirmVersions();

    //search party Connected dvmResBox
    function getParties(){
      return BoxService.queryPartyOfBox(vm.dvmResBox,vm.page, 'res')
        .then(function(data){
          if(!data.rows){
            return;
          }
          vm.parties = data.rows;
          vm.totalItems = data.total;
          vm.pageSize = data.rows.length;
        })
    }
    //search devices connected the same box
    function getDevices(){
      return BoxService.queryDeviceInBox(vm.dvmResBox,vm.devicePage, 'res')
        .then(function(data){
          if(!data.rows){
            return;
          }
          vm.devices = data.rows;
          vm.deviceTotalItems = data.total;
          vm.devicePageSize = data.rows.length;
        })
    }
    //search dvmResBox firmware versions
    function getFirmVersions(){
      return BoxService.queryBoxFirmwareVersion(vm.dvmResBox,vm.firmwarePage, 'res')
        .then(function(data){
          if(!data.rows){
            return;
          }
          vm.firmVersions = data.rows;
          vm.firmwareTotalItems = data.total;
          vm.firmwarePageSize = data.rows.length;
        })
    }
    function resBoxInfoFirmPageChanged(){
      vm.getFirmVersions();
    }

    function resBoxInfoPartyPageChanged(){
      vm.getParties();
    }

    function resBoxInfoDevPageChanged(){
      vm.getDevices();
    }
  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('resBoxMonitor', {
        parent: 'app',
        url: "/resBoxMonitor",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/residentialBox.html",
            controller: 'resBoxController',
            controllerAs: 'vm'
          }
        },
        resolve:{
          entity:function(){
            return {};
          }
        }
      })
      .state('residentialBoxInfo', {
        parent: 'app',
        url: "/residentialBoxInfo/{boxId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/residentialBoxInfo.html",
            controller: 'resBoxInfoController',
            controllerAs: 'vm'
          }
        },
        resolve:{
          entity:function($stateParams){
            return {
              boxId:$stateParams.boxId
            };
          }
        }
      })
      .state('resBoxLog', {
          parent: 'app',
          url: "/resBoxLog/{boxId}",
          views: {
            'body': {
              templateUrl: 'app/iot/portal/admin/dvm/html/resBoxLog.html',
              controller: 'resBoxLogController',
              controllerAs: 'vm'
            }
          },
          resolve: {
            entity: function ($stateParams) {
              return {
                boxId: $stateParams.boxId
              };
            }
          }
        }
      )
  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('resBoxController', resBoxController);

  resBoxController.$inject = ['BaseConfig','$localStorage', 'MessageTemplateService', 'BoxService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];
  /** @ngInject */
  function resBoxController(BaseConfig,$localStorage, MessageTemplateService, BoxService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.dvmResiBox = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.dvmResiBox.skuNumber = '';
    vm.dvmResiBox.connectStatus = '';
    vm.dvmResiBox.boxSerialNumber = '';
    vm.dvmResiBox.boundStatus = '';

    vm.searchResidential = searchResidential;
    vm.getResidentialBox = getResidentialBox;
    vm.setValueToVm = setValueToVm;
    vm.residentialBoxPageChanged = residentialBoxPageChanged;
    vm.initWidget = initWidget;
    vm.exportExcel = exportExcel;
    vm.resBoxStatus = [];
    vm.getResidentialBox();
    vm.initWidget();

    //get tResidentialDevices
    function getResidentialBox() {
      return BoxService.queryBoxes(vm.dvmResiBox, vm.page, 'res').then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.boxes = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search dvmResiBox
    function searchResidential() {
      vm.getResidentialBox();
    }

    //set deviceId boxId to vm
    function setValueToVm($event, value) {
      if (value) {
        vm.dvmResiBox = $($event.target).dvmResiBox;
      }
    }

    //page changed
    function residentialBoxPageChanged() {
      vm.getResidentialBox();
    }


    function initWidget() {
      // timezones and gender
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.BOX_STATUS'}, function (data) {
        vm.resBoxStatus = data.rows;
      }, function (error) {
      });
    }

    function exportExcel() {
      window.location = BaseConfig.url + '/api/public/dvm/excel/excelExportForResidentialBoxes?token='
        + $localStorage.authenticationToken.access_token + '&skuNumber=' + vm.dvmResiBox.skuNumber
        + '&connectStatus=' + vm.dvmResiBox.connectStatus
        + '&boxSerialNumber=' + vm.dvmResiBox.boxSerialNumber
        + '&boundStatus=' + vm.dvmResiBox.boundStatus;
    }
  }
})();

/**
 * Created by zyl on 2017/8/5.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('ProductTypeController', ProductTypeController);
  ProductTypeController.$inject = ['ProductService','paginationConstants','entity','SweetAlert','$filter'];
  function ProductTypeController(ProductService,paginationConstants,entity,SweetAlert,$filter){
    var vm = this;
    vm.productType = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.getProductType = getProductType;
    vm.deleteProductType = deleteProductType;
    vm.deleteProductTypes = deleteProductTypes;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.checkProductType = checkProductType;
    vm.checkAllProductType = checkAllProductType;

    vm.search();

    function getProductType(){
      return ProductService.getProductType(vm.productType,vm.page).then(function(data){
        if(!data.rows){
          return;
        }
        vm.productTypes = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    function search(){
      vm.getProductType();
    }
    function deleteProductType(productType){
      SweetAlert.confirm($filter('T')('dvmProduct.deleteConfirm'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          var productTypes = new Array();
          var entity = new Object();
          entity.productTypeId = productType.productTypeId;
          productTypes.push(entity);
          ProductService.deleteProductType(productTypes).then(function(response){
            if(response.success){
              vm.getProductType();
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
            }
          })
        }
      })
    }

    function deleteProductTypes(){
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck){
        SweetAlert.error($filter('T')('dvmProduct.selectOne'),{title:$filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')('dvmProduct.deleteConfirm'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          var arrChk = $("input[name = 'chk_list']:checked");
          var productTypes = new Array();
          $(arrChk).each(function(){
            var entity = new Object();
            entity.productTypeId = this.value;
            productTypes.push(entity);
          });

          ProductService.deleteProductType(productTypes).then(function(response){
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0;j<items.length;j++){
              items[j].checked = false;
            }
            if(response.success){
              vm.getProductType();
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
            }
          })
        }
      })
    }

    function pageChanged(){
      angular.element("#chk_all").checked = false;
      vm.getProductType();
    }

    function checkProductType(){
      var arrChk = $("input[name = 'chk_list']:checked");
      if(arrChk.length<vm.pageSize){
        document.getElementById("chk_all").checked = false;
      }
      else if(arrChk.length === vm.pageSize){
        document.getElementById("chk_all").checked = true;
      }
    }

    function checkAllProductType(){
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all){
        for(var i = 0;i<items.length;i++){
          items[i].checked = true;
        }
      }else{
        for(var i = 0;i<items.length;i++){
          items[i].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('dvmPproperty', {
        parent: 'app',
        url: "/dvmPproperty/{productId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/productProperty.html",
            controller: 'ProductPropertyController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams', function ($stateParams) {
            return {
              productId : $stateParams.productId
            };
          }]
        }
      })
      .state('dvmPproperty.add', {
        parent: 'dvmPproperty',
        url: "/add/{productId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addProductProperty.html',
            controller: 'AddProductPropertyController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  productId: $stateParams.productId
                }
              }
            }
          }).result.then(function () {
            $state.go('dvmPproperty', null, {reload: true});
          }, function () {
            $state.go('dvmPproperty');
          });
        }]
      })
      .state('dvmPproperty.edit', {
        parent: 'dvmPproperty',
        url: "/edit/:propertyId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addProductProperty.html',
            controller: 'AddProductPropertyController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  propertyId: $stateParams.propertyId
                }
              }
            }
          }).result.then(function () {
            $state.go('dvmPproperty');
          }, function () {
            $state.go('dvmPproperty');
          });
        }]
      })
      .state('dvmPproperty.copy', {
        parent: 'dvmPproperty',
        url: "/copy/:productId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/copyProductProperty.html',
            controller: 'CopyProductPropertyController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  newProductId: $stateParams.productId
                }
              }
            }
          }).result.then(function () {
            $state.go('dvmPproperty', null, {reload: true});
          }, function () {
            $state.go('dvmPproperty');
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('ProductPropertyController', ProductPropertyController);

  ProductPropertyController.$inject = ['$rootScope', 'ProductService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', '$state', 'toastr', 'MessageTemplateService'];

  function ProductPropertyController($rootScope, ProductService, paginationConstants, entity, SweetAlert, $filter, $state, toastr, MessageTemplateService) {
    var vm = this;
    vm.property = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkProperty = checkProperty;
    vm.checkAllProperty = checkAllProperty;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetProperty = resetProperty;
    vm.deleteProperty = deleteProperty;
    vm.deletePropertys = deletePropertys;
    vm.getProperty = getProperty;
    vm.copyProductProperty = copyProductProperty;
    vm.initWeidget = initWeidget;

    vm.initWeidget();
    vm.getProperty();

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
      if(toState.parent == 'app' && toState.name == 'dvmPproperty' && fromState.name == 'dvmPproperty.edit') {
        vm.getProperty();
      }
    });

    //get Property
    function getProperty() {
      return ProductService.getProperty(vm.property, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.propertys = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }
    //copy product property
    function copyProductProperty() {
      $state.go("dvmPproperty.copy", '{productId:vm.property.productId}')
    }

    //search property
    function search() {
      vm.getProperty();
    }

    //reset Property
    function resetProperty() {
      vm.property.propertyName = undefined;
      vm.property.propertyCode = undefined;
    }

    //delete Property
    function deleteProperty(property) {
      SweetAlert.confirm(property.propertyCode + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var propertys = new Array();
          var entity = new Object();
          entity.propertyId = property.propertyId;
          propertys.push(entity);
          ProductService.deletePropertys(propertys).then(function (response) {
            if (response.success) {
              vm.getProperty();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete Property
    function deletePropertys() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var propertys = new Array();
          $(arrChk).each(function() {
            var property = new Object();
            property.propertyId = this.value;
            propertys.push(property);
          });
          ProductService.deletePropertys(propertys).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getProperty();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getProperty();
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'IOT.DVM_ATTRIBUTE_TYPE'},function (data) {
        vm.attributeType = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'IOT.DVM_ATTRIBUTE_RULE_TYPE'},function (data) {
        vm.ruleType = data.rows;
      },function (error) {
      });
    }

    //check or unCheck check Property
    function checkProperty() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Property
    function checkAllProperty() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('dvmproduct', {
        parent: 'app',
        url: "/dvmproduct",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/product.html",
            controller: 'ProductController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {};
          }
        }
      })
      .state('dvmproduct.add', {
        parent: 'dvmproduct',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addProduct.html',
            controller: 'AddProductController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {}
              }
            }
          }).result.then(function () {
            $state.go('dvmproduct', null, {reload: true});
          }, function () {
            $state.go('dvmproduct');
          });
        }]
      })
      .state('dvmproduct.edit', {
        parent: 'dvmproduct',
        url: "/edit/:productId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addProduct.html',
            controller: 'AddProductController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  productId: $stateParams.productId
                }
              }
            }
          }).result.then(function () {
            $state.go('dvmproduct');
          }, function () {
            $state.go('dvmproduct');
          });
        }]
      })
      .state('productType', {
        parent: 'app',
        url: "/productType",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/productType.html",
            controller: 'ProductTypeController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {};
          }
        }
      })
      .state('productType.add', {
        parent:'app',
        url:"/addProductType",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addProductType.html',
            controller: 'addProductTypeController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  productTypeId: $stateParams.productTypeId
                }
              }
            }
          }).result.then(function () {
            $state.go('productType', null, {reload: true});
          }, function () {
            $state.go('productType');
          });
        }]
      })
      .state('productType.edit', {
        parent:'app',
        url:"/editProductType/{productTypeId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addProductType.html',
            controller: 'addProductTypeController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  productTypeId: $stateParams.productTypeId
                }
              }
            }
          }).result.then(function () {
            $state.go('productType', null, {reload: true});
          }, function () {
            $state.go('productType');
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('ProductService', ProductService);

  ProductService.$inject = ['$http'];

  function ProductService($http) {
    return {
      getProduct: getProduct,
      getProductType: getProductType,
      getAllProductType: getAllProductType,
      getProperty: getProperty,
      deleteProducts: deleteProducts,
      deletePropertys: deletePropertys,
      addProduct: addProduct,
      updateProduct:updateProduct,
      addProperty: addProperty,
      updateProperty: updateProperty,
      getProductLocaleInfo: getProductLocaleInfo,
      copyProperty: copyProperty,
      getProductByCopy:getProductByCopy,
      getUnit: getUnit,
      //getProductType:getProductType,
      addProductType:addProductType,
      updateProductType:updateProductType,
      deleteProductType:deleteProductType,
      getProductById:getProductById,

      //add method on 2018/7/24
      getAllCmdSet : getAllCmdSet
    };

    //get product
    function getProductById(productId, page) {
      var resourceUrl = '/api/ctm/selectProduct?page=' + page + '&productId=' + productId;
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    //get unit
    function getUnit() {
      var resourceUrl = '/api/unit/query?pageSize=-1';
      return $http.post(resourceUrl, new Object(), {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //copy property
    function copyProperty(entity) {
      var resourceUrl = '/api/ctm/copyProductProperty';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get product
    function getProductByCopy() {
      var resourceUrl = '/api/ctm/selectProduct?pageSize=-1';
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    //get product
    function getProduct(entity, page) {
      var resourceUrl = '/api/ctm/selectProduct?page=' + page+'&productName='+entity.productName
        +'&productCode='+entity.productCode+'&referenceSource='+entity.referenceSource+'&productId='+entity.productId+'&productRegion='+entity.productRegion;
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    //get property
    function getProperty(entity, page) {
      var resourceUrl = '/api/ctm/selectProductProperty?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete products
    function deleteProducts(entity) {
      var resourceUrl = '/api/ctm/deleteProduct';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete products
    function deletePropertys(entity) {
      var resourceUrl = '/api/ctm/deleteProductProperty';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //add product
    function addProduct(entity) {
      var resourceUrl = '/api/ctm/insertProduct';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //update product
    function updateProduct(entity) {
      var resourceUrl = '/api/ctm/updateProduct';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //add product
    function addProperty (entity) {
      var resourceUrl = '/api/ctm/insertProductProperty';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //update product
    function updateProperty (entity) {
      var resourceUrl = '/api/ctm/updateProductProperty';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function getProductType(entity,page){
      var resourceUrl = '/api/dvm/queryProductType?page='+page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function addProductType(entity){
      var resourceUrl = '/api/dvm/insertProductType';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    function updateProductType(entity){
      var resourceUrl = '/api/dvm/updateProductType';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    function deleteProductType(entity){
      var resourceUrl = '/api/dvm/deleteProductType';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //get product locale info
    function getProductLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }

    //get productType
    function getAllProductType(entity, page,pageSize) {
      var resourceUrl = '/api/dvm/queryProductType?page='+page+'&pageSize='+pageSize;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }


    function getAllCmdSet(cmdSet,page,pagesize) {
      var resourceUrl = '/api/inm/commandSet/query?page='+page+'&pageSize='+pagesize;
      return $http.post(resourceUrl, cmdSet,{
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('ProductController', ProductController);

  ProductController.$inject = ['$rootScope', 'ProductService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

  function ProductController($rootScope, ProductService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
    var vm = this;
    vm.product = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkProduct = checkProduct;
    vm.checkAllProduct = checkAllProduct;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetProduct = resetProduct;
    vm.deleteProduct = deleteProduct;
    vm.deleteProducts = deleteProducts;
    vm.getProduct = getProduct;
    vm.initWeidget = initWeidget;

    vm.search();
    vm.initWeidget();

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      if (toState.parent == 'app' && toState.name == 'dvmproduct' && fromState.name == 'dvmproduct.edit') {
        vm.getProduct();
      }
    });

    //get product
    function getProduct() {
      return ProductService.getProduct(vm.product, vm.page).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.products = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search product
    function search() {
      if (vm.product.productName === null || vm.product.productName === undefined) {
        vm.product.productName = '';
      }
      if (vm.product.productCode === null || vm.product.productCode === undefined) {
        vm.product.productCode = '';
      }
      if (vm.product.referenceSource === null || vm.product.referenceSource === undefined) {
        vm.product.referenceSource = '';
      }
      if (vm.product.productId === null || vm.product.productId === undefined) {
        vm.product.productId = '';
      }
      if (vm.product.productRegion === null || vm.product.productRegion === undefined) {
        vm.product.productRegion = '';
      }
      vm.getProduct();
    }

    //reset product
    function resetProduct() {
      vm.product.productName = undefined;
      vm.product.productCode = undefined;
      vm.product.referenceSource = undefined;
      vm.product.productId = undefined;
      vm.product.productRegion = undefined;
    }

    //delete product
    function deleteProduct(product) {
      SweetAlert.confirm(product.productCode + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          var products = new Array();
          var entity = new Object();
          entity.productId = product.productId;
          //entity.processingStatus = 'delete';
          products.push(entity);
          ProductService.deleteProducts(products).then(function (response) {
            if (response.success) {
              vm.getProduct();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //delete product
    function deleteProducts() {
      var isCheck = $(".chk_list").is(':checked');
      if (!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          var arrChk = $("input[name='chk_list']:checked");
          var products = new Array();
          $(arrChk).each(function () {
            var product = new Object();
            product.productId = this.value;
            products.push(product);
          });
          ProductService.deleteProducts(products).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for (var j = 0; j < items.length; j++) {
              items[j].checked = false;
            }
            if (response.success) {
              vm.getProduct();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getProduct();
    }

    //check or unCheck check product
    function checkProduct() {
      var arrChk = $("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check product
    function checkAllProduct() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.COM_PRODUCT_TYPE'}, function (data) {
        vm.referenceSource = data.rows;
      }, function (error) {
      });

      MessageTemplateService.getByCode().query({code: 'IOT.DVM.PRODUCT_REGION'}, function (data) {
        vm.productRegion = data.rows;
      }, function (err) {
      })
    }

  }
})();

/**
 * Created by yangyang.zou on 2019/04/02.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('otherNameList', {
        parent: 'app',
        url: "/otherNameList",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/otherNameList.html",
            controller: 'OtherNameListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {};
          }
        }
      })
      .state('otherNameList.add', {
        parent:'app',
        url:"/addOtherNameList",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addOtherNameList.html',
            controller: 'AddOtherNameListController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  otherNameListId: $stateParams.otherNameListId
                }
              }
            }
          }).result.then(function () {
            $state.go('otherNameList', null, {reload: true});
          }, function () {
            $state.go('otherNameList');
          });
        }]
      })
      .state('otherNameList.edit', {
        parent: 'app',
        url: "/editOtherNameList/{otherNameListId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addOtherNameList.html',
            controller: 'AddOtherNameListController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  otherNameListId: $stateParams.otherNameListId
                }
              }
            }
          }).result.then(function () {
            $state.go('otherNameList', null, {reload: true});
          }, function () {
            $state.go('otherNameList');
          });
        }]
      })
  }
})();

/**
 * Created by yangyang.zou on 2019/04/02.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('OtherNameListService', OtherNameListService);

  OtherNameListService.$inject = ['$http'];

  function OtherNameListService($http) {
    return {
      getOtherNameList: getOtherNameList,
      addOtherNameList: addOtherNameList,
      updateOtherNameList: updateOtherNameList,
      getOtherNameListLocaleInfo: getOtherNameListLocaleInfo,
      deleteOtherNameList: deleteOtherNameList
    };

    //get otherNameList
    function getOtherNameList(entity, page) {
      var resourceUrl = '/api/dvm/selectOtherNameList?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function addOtherNameList(entity){
      var resourceUrl = '/api/dvm/insertOtherNameList';
      console.log(entity);
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function updateOtherNameList(entity){
      var resourceUrl = '/api/dvm/updateOtherNameList';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }


    function getOtherNameListLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }

    function deleteOtherNameList(entity){
      var resourceUrl = '/api/dvm/deleteOtherNameList';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
  }
})();

/**
 * Created by yangyang.zou on 2019/04/01.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('OtherNameListController', OtherNameListController);

  OtherNameListController.$inject = ['OtherNameListService', 'paginationConstants', 'entity','SweetAlert','$filter','MessageTemplateService'];

  function OtherNameListController(OtherNameListService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
    var vm = this;
    vm.otherNameList = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.getOtherNameList = getOtherNameList;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.checkOtherNameList = checkOtherNameList;
    vm.checkAllOtherNameList = checkAllOtherNameList;
    vm.deleteOtherNameList = deleteOtherNameList;
    vm.deleteOtherNameLists = deleteOtherNameLists;
    vm.initWeidget = initWeidget;

    vm.search();
    vm.initWeidget();

    //get otherNameList
    function getOtherNameList() {
      return OtherNameListService.getOtherNameList(vm.otherNameList, vm.page).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.otherNameLists = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    function search(){
      vm.getOtherNameList();
    }


    function pageChanged(){
      angular.element("#chk_all").checked = false;
      vm.getOtherNameList();
    }


    function deleteOtherNameList(otherNameList){
      SweetAlert.confirm($filter('T')('dvmProduct.deleteConfirm'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          var otherNameLists = new Array();
          var entity = new Object();
          entity.otherNameListId = otherNameList.otherNameListId;
          otherNameLists.push(entity);
          OtherNameListService.deleteOtherNameList(otherNameLists).then(function(response){
            if(response.success){
              vm.getOtherNameList();
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
            }
          })
        }
      })
    }

    function deleteOtherNameLists(){
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck){
        SweetAlert.error($filter('T')('dvmProduct.selectOne'),{title:$filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')('dvmProduct.deleteConfirm'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          var arrChk = $("input[name = 'chk_list']:checked");
          var otherNameLists = new Array();
          $(arrChk).each(function(){
            var entity = new Object();
            entity.otherNameListId = this.value;
            otherNameLists.push(entity);
          });

          OtherNameListService.deleteOtherNameList(otherNameLists).then(function(response){
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0;j<items.length;j++){
              items[j].checked = false;
            }
            if(response.success){
              vm.getOtherNameList();
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
            }
          })
        }
      })
    }


    function checkOtherNameList(){
      var arrChk = $("input[name = 'chk_list']:checked");
      if(arrChk.length<vm.pageSize){
        document.getElementById("chk_all").checked = false;
      }
      else if(arrChk.length === vm.pageSize){
        document.getElementById("chk_all").checked = true;
      }
    }

    function checkAllOtherNameList(){
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all){
        for(var i = 0;i<items.length;i++){
          items[i].checked = true;
        }
      }else{
        for(var i = 0;i<items.length;i++){
          items[i].checked = false;
        }
      }
    }


    function initWeidget() {
      MessageTemplateService.getByCode().query({code: 'SYS.OTHER_TYPE'}, function (data) {
        vm.otherType = data.rows;
      }, function (error) {
      });
    }


  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('on-line', {
        parent: 'app',
        url: "/on-line",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/onLineRate.html",
            controller: 'OnLineRateController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
            };
          }
        }
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('OnLineRateService', OnLineRateService);

  OnLineRateService.$inject = ['$http'];

  function OnLineRateService($http) {
    return {
      getHistoryOnlineRate: getHistoryOnlineRate
    };

    //get On-Line rate
    function getHistoryOnlineRate(referenceSource, startTime, endTime, schema) {
      var resourceUrl = '/api/sys/online/historyOnline?referenceSource=' + referenceSource + '&startTime=' + startTime + '&endTime=' + endTime + '&schema=' + schema;
      return $http.post(resourceUrl, {headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('OnLineRateController', OnLineRateController);

  OnLineRateController.$inject = ['OnLineRateService', 'entity', 'SweetAlert', '$filter'];

  function OnLineRateController(OnLineRateService, entity, SweetAlert, $filter) {
    var vm = this;
    vm.onLine =  entity;

    vm.lang = window.localStorage.lang;
    if(vm.lang == 'en_GB'){
      vm.lang = 'en';
    }

    var eContainerTotal = document.getElementById('eContainerTotal');
    var eCharts7 = document.getElementById('pie7');
    var eCharts8 = document.getElementById('pie8');
    //chart auto height and width to window
    var resizeWorldMapContainer = function () {
      eCharts7.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts7.style.height = eContainerTotal.clientHeight + 'px';
      eCharts8.style.width = eContainerTotal.clientWidth - 6 + 'px';
      eCharts8.style.height = eContainerTotal.clientHeight + 'px';
    };
    resizeWorldMapContainer();
    $('#eContainerTotal').resize(function () {
      resizeWorldMapContainer();
      pie7.resize();
      pie8.resize();
    });

    var pie7 = echarts.init(document.getElementById('pie7'));
    var pie8 = echarts.init(document.getElementById('pie8'));

    vm.getCommercialOnLineRate = getCommercialOnLineRate;
    vm.getResidentialOnLineRate = getResidentialOnLineRate;
    vm.search = search;
    vm.resetOnLine = resetOnLine;
    vm.compareDate = compareDate;

    vm.onLine.beginTime = '';
    vm.onLine.endTime = '';
    vm.getCommercialOnLineRate('commercial', 'com');
    vm.getResidentialOnLineRate('residential', 'res');

    //get box On-Line rate
    function getCommercialOnLineRate(referenceSource, schema) {
      return OnLineRateService.getHistoryOnlineRate(referenceSource, vm.onLine.beginTime, vm.onLine.endTime, schema).then(function (data) {
        if(!data.rows){
          return;
        }
        var title = $filter('T')("main.commercialRate");
        var option = {
          title: {
            text: title
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data:[$filter('T')("main.deviceRate"), $filter('T')("main.boxRate")],
            top:'6%',
            left:'42%'
          },
          grid:{
            right:'4%',
            left: '5%'
          },
          xAxis: {
            boundaryGap: false,
            data: data.rows[0]
          },
          yAxis: {},
          series: [
            {
              name:$filter('T')("main.deviceRate"),
              type:'line',
              data:data.rows[2]
            },
            {
              name:$filter('T')("main.boxRate"),
              type:'line',
              data:data.rows[1]
            }
          ]
        };

        if(data.rows[0].length == 0) {
          var noDataTitle = $filter('T')("main.commercialRate");
          var noData = $filter('T')("alert.noData");
          $("#pie7").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 46%; margin-top: 145px">' + noData + '</div></div>');
          vm.pie7NotData = true;
        } else {
          if(vm.pie7NotData){
            $("#pie7").empty();
            pie7 = echarts.init(document.getElementById("pie7"));
            vm.pie7NotData = false;
          }
          pie7.setOption(option);
          pie7.on("click", function (param) {
          });
        }

      })
    }

    //get device On-Line rate
    function getResidentialOnLineRate(referenceSource, schema) {
      return OnLineRateService.getHistoryOnlineRate(referenceSource, vm.onLine.beginTime, vm.onLine.endTime, schema).then(function (data) {
        if(!data.rows){
          return;
        }
        var title = $filter('T')("main.residentialRate");
        var option = {
          title: {
            text: title
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data:[$filter('T')("main.deviceRate"), $filter('T')("main.boxRate")],
            top:'6%',
            left:'42%'
          },
          grid:{
            right:'4%',
            left: '5%'
          },
          xAxis: {
            boundaryGap: false,
            data: data.rows[0]
          },
          yAxis: {},
          series: [
            {
              name:$filter('T')("main.deviceRate"),
              type:'line',
              data:data.rows[2]
            },
            {
              name:$filter('T')("main.boxRate"),
              type:'line',
              data:data.rows[1]
            }
          ]
        };

        if(data.rows[0].length == 0) {
          var noDataTitle = $filter('T')("main.residentialRate");
          var noData = $filter('T')("alert.noData");
          $("#pie8").html('<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' + noDataTitle + '</div><div style="margin-left: 46%; margin-top: 145px">' + noData + '</div></div>');
          vm.pie8NotData = true;
        } else {
          if(vm.pie8NotData){
            $("#pie8").empty();
            pie8 = echarts.init(document.getElementById("pie8"));
            vm.pie8NotData = false;
          }
          pie8.setOption(option);
          pie8.on("click", function (param) {
          });
        }

      })
    }

    //search product
    function search() {
      vm.onLine.beginTime = document.getElementById("start").value;
      vm.onLine.endTime = document.getElementById("end").value;
      vm.getCommercialOnLineRate('commercial', 'com');
      vm.getResidentialOnLineRate('residential', 'res');
    }

    //reset product
    function resetOnLine() {
      vm.onLine.beginTime = undefined;
      vm.onLine.endTime = undefined;
    }

    //data plugin
    $('.form_date').datetimepicker({
      language: vm.lang,
      format: 'yyyy-mm-dd',
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0
    });

    //compare date
    function compareDate() {
      var start = $("#start").val();
      var end = $("#end").val();
      if(start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if(startTime > endTime) {
          var msg = $filter('T')("main.msg");
          vm.onLine.endTime = "";
          SweetAlert.error(msg, {title: $filter('T')("btnTypeName.prompt")});
        }
      }
    }
  }
})();
//resize of div
(function($, h, c) {
  var a = $([]),
    e = $.resize = $.extend($.resize, {}),
    i,
    k = "setTimeout",
    j = "resize",
    d = j + "-special-event",
    b = "delay",
    f = "throttleWindow";
  e[b] = 250;
  e[f] = true;
  $.event.special[j] = {
    setup: function() {
      if (!e[f] && this[k]) {
        return false;
      }
      var l = $(this);
      a = a.add(l);
      $.data(this, d, {
        w: l.width(),
        h: l.height()
      });
      if (a.length === 1) {
        g();
      }
    },
    teardown: function() {
      if (!e[f] && this[k]) {
        return false;
      }
      var l = $(this);
      a = a.not(l);
      l.removeData(d);
      if (!a.length) {
        clearTimeout(i);
      }
    },
    add: function(l) {
      if (!e[f] && this[k]) {
        return false;
      }
      var n;
      function m(s, o, p) {
        var q = $(this),
          r = $.data(this, d);
        r.w = o !== c ? o: q.width();
        r.h = p !== c ? p: q.height();
        n.apply(this, arguments);
      }
      if ($.isFunction(l)) {
        n = l;
        return m;
      } else {
        n = l.handler;
        l.handler = m;
      }
    }
  };
  function g() {
    i = h[k](function() {
        a.each(function() {
          var n = $(this),
            m = n.width(),
            l = n.height(),
            o = $.data(this, d);
          if (m !== o.w || l !== o.h) {
            n.trigger(j, [o.w = m, o.h = l]);
          }
        });
        g();
      },
      e[b]);
  }
})(jQuery, this);

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('DvmDeviceService', DeviceService);

  DeviceService.$inject = ['$http'];

  function DeviceService($http) {

    var service = {
      queryDvmDevice:queryDvmDevice,
      queryCommercialProduct:getCommercialProducts,
      queryDeviceException:getDeviceException,
      queryPartyOfDevice:queryPartyOfDevice,
      queryBoxOfDevice:queryBoxOfDevice,
      queryDeviceFirmwareVersion:queryDeviceFirmwareVersion,




      queryResidentialProductExcBox:getResidentialProductExcBox
      // queryResidentialDevicesExceptions:queryResidentialDevicesExceptions,
      // queryParties:queryParties,
      // queryBoxes:queryBoxes,
      // queryFirmwareVersion:queryFirmwareVersion
    };

    return service;

    function queryDvmDevice(entity,page,schema) {
      var resourceUrl = '/api/dvm/getDevice?page=' + page + '&schema=' + schema;
      return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
        .then(function(response){
          return response.data;
        })
    }

    function getCommercialProducts(referenceSource) {
      var resourceUrl ='/api/ctm/selectProduct?referenceSource='+referenceSource;
      return $http.get(resourceUrl)
        .then(function (response) {
          return response.data;
        })
    }

    function getDeviceException(entity,page, schema) {
      var resourceUrl = '/api/dvm/getDeviceMonitor?page=' + page + '&schema=' + schema;
      return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
      .then(function(response){
        return response.data;
      })
    }

    function queryPartyOfDevice(entity,page, schema){
      // var resourceUrl = '/api/dvm/getPartyConnDevice?page=' + page + '&schema=' + schema;
      var resourceUrl = '/api/dvm/queryPartiesByDeviceId?deviceId=' + entity.deviceId + '&schema=' + schema;
      return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
      .then(function(response){
        return response.data;
      })
    }

    function queryBoxOfDevice(entity,page, schema){
      // var resourceUrl = '/api/dvm/getBoxConnDevice?page=' + page + '&schema=' + schema;
      var resourceUrl = '/api/dvm/queryBoxInfo?deviceId=' + entity.deviceId + '&schema=' + schema;
      return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
      .then(function(response){
        return response.data;
      })
    }

    // function queryBoxes(entity,page){
    //   var resourceUrl = '/api/dvm/boxComConnDevice?page=' + page;
    //   return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
    //   .then(function(response){
    //     return response.data;
    //   })
    // }
    // function queryFirmwareVersion(entity,page){
    //   var resourceUrl = '/api/dvm/deviceComFirmwareVersion?page=' + page;
    //   return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
    //   .then(function(response){
    //     return response.data;
    //   })
    // }

    //
    //
    // function queryResidentialDevices(entity,page) {
    //   var resourceUrl = '/api/device/queryResDevice?pageIndex=' + page;
    //   return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
    //   .then(function(response){
    //     return response.data;
    //   })
    // }

    //get product
    function getResidentialProductExcBox(entity) {
      var resourceUrl = '/api/ctm/selectResProduct?pageSize='+'-1';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    // function queryResidentialDevicesExceptions(entity,page) {
    //   var resourceUrl='/api/dvm/resDeviceMonitor?page='+page;
    //   return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
    //   .then(function (response) {
    //     return response.data;
    //   })
    // }

    // function queryParties(entity,page){
    //   var resourceUrl = '/api/dvm/partyConnectedDevice?page=' + page;
    //   return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
    //   .then(function(response){
    //     return response.data;
    //   })
    // }
    function queryDeviceFirmwareVersion(entity,page, schema){
      var resourceUrl = '/api/dvm/getDeviceFirmVersion?deviceId=' + entity.deviceId + '&schema=' + schema;
      return $http.post(resourceUrl,entity,{headers:{'Content-Type':'application/json;charset=utf-8'}})
      .then(function(response){
        return response.data;
      })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('dvmDproperty', {
        parent: 'app',
        url: "/dvmDproperty/{deviceId}/{referenceSource}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/deviceProperty.html",
            controller: 'DevicePropertyController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams', function ($stateParams) {
            return {
              deviceId : $stateParams.deviceId,
              referenceSource:$stateParams.referenceSource,
            };
          }]
        }
      })
      .state('dvmDproperty.view', {
        parent: 'app',
        url: "/viewDeviceProperty/{deviceId}/{propertyId}/{referenceSource}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/viewDeviceProperty.html',
            controller: 'ViewDevicePropertyController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  deviceId : $stateParams.deviceId,
                  propertyId : $stateParams.propertyId,
                  referenceSource:$stateParams.referenceSource
                }
              }
            }
          }).result.then(function () {
            $state.go('dvmDproperty',{deviceId:$stateParams.deviceId,referenceSource:$stateParams.referenceSource});
          }, function () {
            $state.go('dvmDproperty',{deviceId:$stateParams.deviceId,referenceSource:$stateParams.referenceSource});
          });
        }]
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/06/11.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('DevicePropertyController', DevicePropertyController);

  DevicePropertyController.$inject = ['DeviceBaseService', 'paginationConstants', 'entity'];

  function DevicePropertyController(DeviceBaseService, paginationConstants, entity, MessageTemplateService) {
    var vm = this;
    vm.property = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.referenceSources = [];

    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetProperty = resetProperty;
    vm.getProperty = getProperty;

    vm.getProperty();

    //get Property
    function getProperty() {
      var schema = "";
      if ('residential'===vm.property.referenceSource) {
        schema = 'res'
      } else if ('commercial' === vm.property.referenceSource) {
        schema = 'com';
      } else {
        return;
      }
      return DeviceBaseService.getProperty(vm.property, vm.page, schema).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.propertys = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search property
    function search() {
      vm.getProperty();
    }

    //reset Property
    function resetProperty() {
      vm.property.propertyName = undefined;
      vm.property.propertyCode = undefined;
    }

    //page changed
    function pageChanged() {
      vm.getProperty();
    }
  }
})();

/**
 * Created by yangyang.zou on 2019/04/01.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('deviceNameList', {
        parent: 'app',
        url: "/deviceNameList",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/deviceNameList.html",
            controller: 'DeviceNameListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {};
          }
        }
      })
      .state('deviceNameList.add', {
        parent:'app',
        url:"/addDeviceNameList",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addDeviceNameList.html',
            controller: 'AddDeviceNameListController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  deviceNameListId: $stateParams.deviceNameListId
                }
              }
            }
          }).result.then(function () {
            $state.go('deviceNameList', null, {reload: true});
          }, function () {
            $state.go('deviceNameList');
          });
        }]
      })
      .state('deviceNameList.edit', {
        parent: 'app',
        url: "/editDeviceNameList/{deviceNameListId}",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/dvm/html/addDeviceNameList.html',
            controller: 'AddDeviceNameListController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  deviceNameListId: $stateParams.deviceNameListId
                }
              }
            }
          }).result.then(function () {
            $state.go('deviceNameList', null, {reload: true});
          }, function () {
            $state.go('deviceNameList');
          });
        }]
      })
  }
})();

/**
 * Created by yangyang.zou on 2019/04/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('DeviceNameListService', DeviceNameListService);

  DeviceNameListService.$inject = ['$http'];

  function DeviceNameListService($http) {
    return {
      getDeviceNameList: getDeviceNameList,
      addDeviceNameList: addDeviceNameList,
      updateDeviceNameList: updateDeviceNameList,
      getDeviceNameListLocaleInfo: getDeviceNameListLocaleInfo,
      deleteDeviceNameList: deleteDeviceNameList,
      getProduct: getProduct
    };

    //get deviceNameList
    function getDeviceNameList(entity, page) {
      var resourceUrl = '/api/dvm/selectDeviceNameList?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function addDeviceNameList(entity){
      var resourceUrl = '/api/dvm/insertDeviceNameList';
      console.log(entity);
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function updateDeviceNameList(entity){
      var resourceUrl = '/api/dvm/updateDeviceNameList';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }


    function getDeviceNameListLocaleInfo(code, dto, field) {
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }

    function deleteDeviceNameList(entity){
      var resourceUrl = '/api/dvm/deleteDeviceNameList';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function getProduct(entity) {
      var resourceUrl = '/api/ctm/selectProduct?pageSize=-1';
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

  }
})();

/**
 * Created by yangyang.zou on 2019/04/01.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('DeviceNameListController', DeviceNameListController);

  DeviceNameListController.$inject = ['DeviceNameListService', 'paginationConstants', 'entity','SweetAlert','$filter'];

  function DeviceNameListController(DeviceNameListService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.deviceNameList = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.getDeviceNameList = getDeviceNameList;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.checkDeviceNameList = checkDeviceNameList;
    vm.checkAllDeviceNameList = checkAllDeviceNameList;
    vm.deleteDeviceNameList = deleteDeviceNameList;
    vm.deleteDeviceNameLists = deleteDeviceNameLists;

    search();

    //get deviceNameList
    function getDeviceNameList() {
      return DeviceNameListService.getDeviceNameList(vm.deviceNameList, vm.page).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.deviceNameLists = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    function search(){
      vm.getDeviceNameList();
    }


    function pageChanged(){
      angular.element("#chk_all").checked = false;
      vm.getDeviceNameList();
    }


    function deleteDeviceNameList(deviceNameList){
      SweetAlert.confirm($filter('T')('dvmProduct.deleteConfirm'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          var deviceNameLists = new Array();
          var entity = new Object();
          entity.deviceNameListId = deviceNameList.deviceNameListId;
          deviceNameLists.push(entity);
          DeviceNameListService.deleteDeviceNameList(deviceNameLists).then(function(response){
            if(response.success){
              vm.getDeviceNameList();
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
            }
          })
        }
      })
    }

    function deleteDeviceNameLists(){
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck){
        SweetAlert.error($filter('T')('dvmProduct.selectOne'),{title:$filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')('dvmProduct.deleteConfirm'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          var arrChk = $("input[name = 'chk_list']:checked");
          var deviceNameLists = new Array();
          $(arrChk).each(function(){
            var entity = new Object();
            entity.deviceNameListId = this.value;
            deviceNameLists.push(entity);
          });

          DeviceNameListService.deleteDeviceNameList(deviceNameLists).then(function(response){
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0;j<items.length;j++){
              items[j].checked = false;
            }
            if(response.success){
              vm.getDeviceNameList();
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
            }
          })
        }
      })
    }


    function checkDeviceNameList(){
      var arrChk = $("input[name = 'chk_list']:checked");
      if(arrChk.length<vm.pageSize){
        document.getElementById("chk_all").checked = false;
      }
      else if(arrChk.length === vm.pageSize){
        document.getElementById("chk_all").checked = true;
      }
    }

    function checkAllDeviceNameList(){
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all){
        for(var i = 0;i<items.length;i++){
          items[i].checked = true;
        }
      }else{
        for(var i = 0;i<items.length;i++){
          items[i].checked = false;
        }
      }
    }


  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('dvmdevice', {
        parent: 'app',
        url: "/dvmdevice",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/device.html",
            controller: 'DeviceBaseController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
            };
          }
        }
      })
  }
})();

/**
 * Created by xiawang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('DeviceBaseService', DeviceBaseService);

  DeviceBaseService.$inject = ['$http'];

  function DeviceBaseService($http) {
    return {
      getDevice: getDevice,
      getProperty: getProperty
    };

    //get product
    function getDevice(entity, page, schema) {
      var resourceUrl = '/api/device/queryDevice?pageIndex=' + page + '&schema=' + schema;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get property
    function getProperty(entity, page, schema) {
      var resourceUrl = '/api/device/queryDeviceProperty?pageIndex=' + page + '&schema=' + schema;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/05/25.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('DeviceBaseController', DeviceBaseController);

  DeviceBaseController.$inject = ['DeviceBaseService', 'paginationConstants', 'entity', 'MessageTemplateService'];

  function DeviceBaseController(DeviceBaseService, paginationConstants, entity, MessageTemplateService) {
    var vm = this;
    vm.device = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    //set default device reference source.
    vm.device.referenceSource = 'residential';

    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetDevice = resetDevice;
    vm.getDevice = getDevice;
    vm.initWidget = initWidget;

    vm.getDevice();
    vm.initWidget();

    //get Device
    function getDevice() {
      var schema = "";
      if ('residential'=== vm.device.referenceSource) {
        schema = 'res'
      } else if ('commercial' === vm.device.referenceSource) {
        schema = 'com';
      }
      return DeviceBaseService.getDevice(vm.device, vm.page, schema).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.devices = data.rows;
        vm.totalItems = data.total;
      })
    }

    //search device
    function search() {
      vm.getDevice();
    }

    //reset Device
    function resetDevice() {
      vm.device.productName = undefined;
      vm.device.deviceSerialNumber = undefined;
      vm.device.skuNumber = undefined;
      vm.device.referenceSource = 'residential';
    }

    //page changed
    function pageChanged() {
      vm.getDevice();
    }

    function initWidget() {
      MessageTemplateService.getByCode().query({code:'IOT.DVM.COM_PRODUCT_TYPE'},function (data) {
        vm.referenceSources = data.rows;
      });
    }
  }
})();

/**
 * Created by xiwang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('CopyProductPropertyController', CopyProductPropertyController);

  CopyProductPropertyController.$inject = ['ProductService', '$state', '$uibModalInstance', 'toastr', 'entity','$filter'];

  function CopyProductPropertyController(ProductService, $state, $uibModalInstance, toastr, entity,$filter) {
    var vm = this;
    vm.property = entity;

    vm.cancel = cancel;
    vm.getProduct = getProduct;
    vm.copyPropertySubmit = copyPropertySubmit;

    vm.getProduct();

    function getProduct() {
      ProductService.getProductByCopy().then(function (data) {
        if(!data.rows){
          return;
        }
        for (var i = 0; i < data.rows.length; i++) {
          if (vm.property.newProductId == data.rows[i].productId) {
            data.rows.splice(i, 1);
          }
        }
        vm.products = data.rows;
      })
    }

    //submit copy
    function copyPropertySubmit() {
      ProductService.copyProperty(vm.property).then(function (response) {
        if (response.success) {
          toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          $uibModalInstance.close();
          return $state.go('dvmPproperty', null, {reload: true});
        }
      })
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('deviceMonitor', {
      parent: 'app',
      url: "/commDeviceMonitor",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/dvm/html/commDeviceMonitor.html",
          controller: 'commDeviceMonitorController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {};
        }
      }
    })
    .state('commDeviceInfo', {
      parent: 'app',
      url: "/commDeviceInfo/{deviceId}/{boxId}",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/dvm/html/comDevConnInfo.html",
          controller: 'commDevInfoController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            deviceId: $stateParams.deviceId,
            boxId: $stateParams.boxId
          };
        }
      }
    })

  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('commDeviceMonitorController', commDeviceMonitorController);

  commDeviceMonitorController.$inject = ['BaseConfig', '$localStorage', 'MessageTemplateService','DvmDeviceService', 'paginationConstants', 'entity'];
  /** @ngInject */
  function commDeviceMonitorController(BaseConfig, $localStorage, MessageTemplateService,DvmDeviceService, paginationConstants, entity) {
    var vm = this;
    vm.CommDevice = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.CommDevice.orgName = '';
    vm.CommDevice.skuNumber = '';
    vm.CommDevice.inException = '';
    vm.CommDevice.iotDeviceId = '';
    vm.CommDevice.deviceCode = '';
    vm.CommDevice.deviceSerialNumber = '';
    vm.CommDevice.boundStatus = '';
    vm.CommDevice.connectStatus = '';

    vm.searchCommercial = searchCommercial;
    vm.getCommercialDevice = getCommercialDevice;
    vm.setValueToVm = setValueToVm;
    vm.commercialPageChanged = commercialPageChanged;
    vm.resetCommDevice = resetCommDevice;
    vm.initWidget = initWidget;
    vm.exportExcel = exportExcel;

    vm.inException = [];
    vm.connectStatus = [];

    vm.getCommercialDevice();
    vm.initWidget();
    //get Commercial CommDevice
    function getCommercialDevice(){
      return DvmDeviceService.queryDvmDevice(vm.CommDevice, vm.page, 'com')
        .then(function(data){
          if(!data.rows){
            return;
          }
          vm.devices = data.rows;
          vm.totalItems = data.total;
          vm.pageSize = data.rows.length;
        })
    }

    //search commercialDevice
    function searchCommercial(){
      vm.getCommercialDevice();
    }
    //set deviceId boxId to vm
    function setValueToVm($event,value){
      if(value){
        vm.CommDevice = $($event.target).CommDevice;
      }
    }
    //page changed
    function commercialPageChanged() {
      vm.getCommercialDevice();
    }
    //reset search condition
    function resetCommDevice(){
      vm.CommDevice.orgName = '';
      vm.CommDevice.skuNumber = '';
      vm.CommDevice.inException = '';
      vm.CommDevice.iotDeviceId = '';
      vm.CommDevice.deviceCode = '';
      vm.CommDevice.deviceSerialNumber = '';
      vm.CommDevice.boundStatus = '';
      vm.CommDevice.connectStatus = '';
    }

    function initWidget() {

      // device exception status
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.DEVICE_EXCEPTION_STATUS'}, function (data) {
        vm.inException = data.rows;
      }, function (error) {
      });
      // device exception status
      MessageTemplateService.getByCode().query({code: 'IOT.DVM_EXCEPTION_PROCESS_STATUS'}, function (data) {
        vm.processStatus = data.rows;
      }, function (error) {
      });
      // online offline status
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.DEVICE_ONOFFLINE_STATUS'}, function (data) {
        vm.connectStatus = data.rows;
      }, function (error) {
      });
      // device exception type
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.DEVICE_EXCEPTION_TYPE'}, function (data) {
        vm.exceptionType = data.rows;
      }, function (error) {
      });

      //get commercial products
      DvmDeviceService.queryCommercialProduct("commercial").then(function (data) {
        if(!data.rows){
          return;
        }
        vm.commercialProducts = data.rows;
      })
    }

    function exportExcel() {
      window.location = BaseConfig.url + '/api/public/dvm/excel/excelExportForCommercialMonitor?token='
        + $localStorage.authenticationToken.access_token
        + '&orgName=' + vm.CommDevice.orgName + '&iotDeviceId=' + vm.CommDevice.iotDeviceId
        + '&skuNumber=' + vm.CommDevice.skuNumber
        + '&inException=' + vm.CommDevice.inException + '&deviceCode=' + vm.CommDevice.deviceCode
        + '&deviceSerialNumber=' + vm.CommDevice.deviceSerialNumber
        + '&boundStatus=' + vm.CommDevice.boundStatus + '&connectStatus=' + vm.CommDevice.connectStatus;
    }
  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('commDevInfoController', commDevInfoController);

  commDevInfoController.$inject = ['MessageTemplateService', 'DvmDeviceService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];

  /** @ngInject */
  function commDevInfoController(MessageTemplateService, DvmDeviceService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.dvmCommDevice = entity;
    vm.page = 1;
    vm.boxPage = 1;
    vm.firmwarePage = 1;
    vm.exceptionPage = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.dvmCommDevice.endTime = '';
    vm.dvmCommDevice.beginTime = '';
    vm.dvmCommDevice.exceptionDescription = '';
    vm.searchException = searchException;
    vm.getParties = getParties;
    vm.getBoxes = getBoxes;
    vm.getFirmVersions = getFirmVersions;
    vm.getCommercialExceptions = getCommercialExceptions;
    vm.commercialInfoPageChanged = commercialInfoPageChanged;
    vm.commercialInfoPartyPageChanged = commercialInfoPartyPageChanged;
    vm.commercialInfoBoxPageChanged = commercialInfoBoxPageChanged;
    vm.commercialExceptionPageChanged = commercialExceptionPageChanged;
    vm.compareDate = compareDate;
    vm.initWidget = initWidget;
    vm.exceptionType = [];
    vm.processStatus = [];

    vm.getCommercialExceptions();
    vm.getParties();
    vm.getBoxes();
    vm.getFirmVersions();
    vm.initWidget();

    //get Commercial Exceptions
    function getCommercialExceptions() {
      return DvmDeviceService.queryDeviceException(vm.dvmCommDevice, vm.exceptionPage, 'com')
      .then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.exceptions = data.rows;
        vm.exceptionsTotalItems = data.total;
        vm.exceptionPageSize = data.rows.length;
      })
    }

    function initWidget() {
      // device exception status
      MessageTemplateService.getByCode().query({code: 'IOT.SYS_PROCESSING_STATUS'}, function (data) {
        vm.processStatus = data.rows;
      }, function (error) {
      });
      // device exception type
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.DEVICE_EXCEPTION_TYPE'}, function (data) {
        vm.exceptionType = data.rows;
      }, function (error) {
      });
    }

    //search party Connected dvmCommDevice
    function getParties() {
      return DvmDeviceService.queryPartyOfDevice(vm.dvmCommDevice, vm.page, 'com')
      .then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.parties = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search devices connected the same box
    function getBoxes() {
      return DvmDeviceService.queryBoxOfDevice(vm.dvmCommDevice, vm.boxPage, 'com')
      .then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.boxes = data.rows;
        vm.boxTotalItems = data.total;
        vm.boxPageSize = data.rows.length;
      })
    }

    //search dvmCommDevice firmware versions
    function getFirmVersions() {
      return DvmDeviceService.queryDeviceFirmwareVersion(vm.dvmCommDevice, vm.firmwarePage, 'com')
      .then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.firmVersions = data.rows;
        vm.firmwareTotalItems = data.total;
        vm.firmwarePageSize = data.rows.length;
      })
    }

    function commercialInfoPageChanged() {
      vm.getFirmVersions();
    }

    function commercialInfoPartyPageChanged() {
      vm.getParties();
    }

    function commercialInfoBoxPageChanged() {
      vm.getBoxes();
    }

    function commercialExceptionPageChanged() {
      vm.getCommercialExceptions();
    }

    function searchException() {
      vm.getCommercialExceptions()
    }

    $('.form_date').datetimepicker({
      language: vm.lang,
      format: 'yyyy-mm-dd',
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0
    });

    function compareDate() {
      var start = $('#start').val();
      var end = $('#end').val();
      if (start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if (startTime > endTime) {
          var msg = $filter('T')("main.msg");
          vm.dvmCommDevice.endTime = "";
          SweetAlert.error(msg, {title: $filter('T')("btnTypeName.prompt")});
        }
      }
    }
  }
})();

/**
 * Created by zyl on 2017/6/29.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('CommercialBoxLogController',commBoxLogController);

  commBoxLogController.$inject = ['BoxService', 'paginationConstants', 'entity'];
  function commBoxLogController(BoxService, paginationConstants, entity){
    var vm = this;
    vm.commBoxLogger = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.getCommBoxLog = getCommBoxLog;
    vm.popupOpen = popupOpen;
    vm.pageChanged = pageChanged;

    vm.lang = window.localStorage.lang;
    if(vm.lang == 'en_GB'){
      vm.lang = 'en';
    }

    vm.getCommBoxLog();

    function getCommBoxLog(){
      vm.commBoxLogger.referenceSource = "commercial";
      return BoxService.queryBoxLog(vm.commBoxLogger, vm.page, 'com')
        .then(function(data){
          if(!data){
            return;
          }
          vm.commBoxLog = data.rows;
          vm.totalItems = data.total;
        })
    }

    function popupOpen() {
      vm.isOpen = true;
    }

    function pageChanged(){
      vm.getResBoxLog();
    }

    //data plugin
    $('.form_date').datetimepicker({
      language: vm.lang,
      format: 'yyyy-mm-dd',
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0
    });

  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('CommercialBoxInfoController', CommercialBoxInfoController);

  CommercialBoxInfoController.$inject = ['BoxService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];
  /** @ngInject */
  function CommercialBoxInfoController(BoxService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.dvmCommBox = entity;
    vm.page = 1;
    vm.devicePage = 1;
    vm.firmwarePage = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.getParties = getParties;
    vm.getDevices = getDevices;
    vm.getFirmVersions = getFirmVersions;
    vm.commercialBoxInfoFirmPageChanged = commercialBoxInfoFirmPageChanged;
    vm.commercialBoxInfoPartyPageChanged = commercialBoxInfoPartyPageChanged;
    vm.commercialBoxInfoDevPageChanged = commercialBoxInfoDevPageChanged;

    vm.getParties();
    vm.getDevices();
    vm.getFirmVersions();

    //search party Connected dvmCommBox
    function getParties(){
      return BoxService.queryPartyOfBox(vm.dvmCommBox,vm.page,'com')
        .then(function(data){
          if(!data.rows){
            return;
          }
          vm.parties = data.rows;
          vm.totalItems = data.total;
          vm.pageSize = data.rows.length;
        })
    }
    //search devices connected the same box
    function getDevices(){
      return BoxService.queryDeviceInBox(vm.dvmCommBox,vm.devicePage,'com')
        .then(function(data){
          if(!data.rows){
            return;
          }
          vm.devices = data.rows;
          vm.deviceTotalItems = data.total;
          vm.devicePageSize = data.rows.length;
        })
    }
    //search dvmCommBox firmware versions
    function getFirmVersions(){
      return BoxService.queryBoxFirmwareVersion(vm.dvmCommBox,vm.firmwarePage,'com')
        .then(function(data){
          if(!data.rows){
            return;
          }
          vm.firmVersions = data.rows;
          vm.firmwareTotalItems = data.total;
          vm.firmwarePageSize = data.rows.length;
        })
    }

    function commercialBoxInfoPartyPageChanged(){
      vm.getParties();
    }

    function commercialBoxInfoFirmPageChanged(){
      vm.getFirmVersions();
    }

    function commercialBoxInfoDevPageChanged(){
      vm.getDevices();
    }
  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('commBoxMonitor', {
        parent: 'app',
        url: "/commBoxMonitor",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/commercialBox.html",
            controller: 'CommercialBoxController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {};
          }
        }
      })
      .state('commBoxInfo', {
        parent: 'app',
        url: "/commBoxInfo/{boxId}",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/dvm/html/commercialBoxInfo.html",
            controller: 'CommercialBoxInfoController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              boxId: $stateParams.boxId
            };
          }
        }
      })
      .state('commBoxLog', {
          parent: 'app',
          url: "/commBoxLog/{boxId}",
          views: {
            'body': {
              templateUrl: 'app/iot/portal/admin/dvm/html/commBoxLog.html',
              controller: 'CommercialBoxLogController',
              controllerAs: 'vm'
            }
          },
          resolve: {
            entity: function ($stateParams) {
              return {
                boxId: $stateParams.boxId
              };
            }
          }
        }
      )
  }
})();

/**
 * Created by youliang.zhu on 2017/6/12.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('CommercialBoxController', CommercialBoxController);

  CommercialBoxController.$inject = ['BaseConfig','$localStorage','MessageTemplateService', 'BoxService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];
  /** @ngInject */
  function CommercialBoxController(BaseConfig,$localStorage,MessageTemplateService, BoxService, paginationConstants, entity, SweetAlert, $filter) {
    var vm = this;
    vm.CommBox = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.searchCommercialBox = searchCommercialBox;
    vm.getCommercialBoxes = getCommercialBoxes;
    vm.setValueToVm = setValueToVm;
    vm.commercialBoxPageChanged = commercialBoxPageChanged;
    vm.initWidget = initWidget;
    vm.exportExcel = exportExcel;

    vm.CommBox.orgName = '';
    vm.CommBox.skuNumber = '';
    vm.CommBox.connectStatus = '';
    vm.CommBox.boxSerialNumber = '';
    vm.CommBox.boundStatus = '';

    vm.boxStatus = [];
    vm.getCommercialBoxes();
    vm.initWidget();
    //get Commercial CommBox
    function getCommercialBoxes() {
      return BoxService.queryBoxes(vm.CommBox, vm.page, 'com')
        .then(function (data) {
          if (!data.rows) {
            return;
          }
          vm.boxes = data.rows;
          vm.totalItems = data.total;
          vm.pageSize = data.rows.length;
        })
    }

    //search commercialDevice
    function searchCommercialBox() {
      vm.getCommercialBoxes();
    }

    //set deviceId boxId to vm
    function setValueToVm($event, value) {
      if (value) {
        vm.CommBox = $($event.target).CommBox;
      }
    }

    //page changed
    function commercialBoxPageChanged() {
      vm.getCommercialBoxes();
    }

    function initWidget() {
      //
      MessageTemplateService.getByCode().query({code: 'IOT.DVM.BOX_STATUS'}, function (data) {
        vm.boxStatus = data.rows;
      }, function (error) {
      });
    }


    function exportExcel() {
      window.location = BaseConfig.url + '/api/public/dvm/excel/excelExportForCommercialBoxes?token='
        + $localStorage.authenticationToken.access_token
        + '&orgName=' + vm.CommBox.orgName + '&skuNumber=' + vm.CommBox.skuNumber
        + '&connectStatus=' + vm.CommBox.connectStatus
        + '&boxSerialNumber=' + vm.CommBox.boxSerialNumber
        + '&boundStatus=' + vm.CommBox.boundStatus;
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').factory('BoxService', BoxService);

  BoxService.$inject = ['$http'];

  function BoxService($http) {
    return {
      queryBoxes: queryBoxes,
      queryPartyOfBox: queryPartyOfBox,
      queryDeviceInBox: queryDeviceInBox,
      queryBoxFirmwareVersion: queryBoxFirmwareVersion,
      queryBoxLog: queryBoxLog
    };

    function queryBoxes(entity, page, referenceSource) {
      var resourceUrl = '/api/dvm/getDvmBoxes?page=' + page + '&schema=' + referenceSource;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }

    function queryPartyOfBox(entity, page, referenceSource) {
      var resourceUrl = '/api/dvm/getPartiesConnBox?page=' + page + '&schema=' + referenceSource;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }


    function queryDeviceInBox(entity, page, referenceSource) {
      var resourceUrl = '/api/dvm/getDeviceInBox?page=' + page + '&schema=' + referenceSource;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }

    function queryBoxFirmwareVersion(entity, page, referenceSource) {
      var resourceUrl = '/api/dvm/getBoxFirmVersion?page=' + page + '&schema=' + referenceSource;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }

    function queryBoxLog(entity, page, referenceSource) {
      var resourceUrl = '/api/dvm/box/log?page=' + page + '&schema=' + referenceSource;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}})
      .then(function (response) {
        return response.data;
      })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/06/03 0031.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AddSkuPropertyController', AddSkuPropertyController);

  AddSkuPropertyController.$inject = ['SkuService', 'paginationConstants', 'entity', '$uibModalInstance', '$state', 'toastr', '$filter', 'MessageTemplateService'];

  function AddSkuPropertyController(SkuService, paginationConstants, entity, $uibModalInstance, $state, toastr, $filter, MessageTemplateService) {
    var vm = this;
    vm.property = entity;

    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.searchProperty = searchProperty;
    vm.initLoad = initLoad;
    vm.pageChanged = pageChanged;
    vm.clear = clear;
    vm.saveProperty = saveProperty;
    vm.checkProperty = checkProperty;
    vm.checkAllProperty = checkAllProperty;
    vm.initWeidget = initWeidget;

    vm.initLoad();
    vm.initWeidget();

    //init load page
    function initLoad() {
      if (!vm.property.propertyCode) {
        vm.property.propertyCode = '';
      }
      SkuService.getPropertyInProduct(vm.property.propertyCode, vm.property.skuId, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.totalItems = data.total;
        vm.properties = data.rows;
        vm.pageSize = data.rows.length;
      })
    }

    //search property
    function searchProperty(){
      vm.initLoad();
    }

    //save choose property
    function saveProperty() {
      var arrChk = $("input[name='chk_list_add']:checked");
      var properties = new Array();
      $(arrChk).each(function() {
        var property = new Object();
        property.productPropertyId = this.value;
        property.skuId = vm.property.skuId;
        properties.push(property);
      });
      SkuService.addProperty(properties).then(function (response) {
        if (response.success) {
          toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          $uibModalInstance.close();
          return $state.go('dvmSproperty', null, {reload: true});
        }
      })
    }

    //page changed
    function pageChanged() {
      vm.initLoad();
    }

    //cancel choose property
    function clear() {
      $uibModalInstance.dismiss('cancel');
      $state.go("dvmSproperty");
    }

    //check or unCheck check Sku
    function checkProperty() {
      var arrChk = $("input[name='chk_list_add']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Sku
    function checkAllProperty() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list_add");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'IOT.DVM_ATTRIBUTE_RULE_TYPE'},function (data) {
        vm.ruleType = data.rows;
      },function (error) {
      });
    }
  }
})();

/**
 * Created by xiwang.liu on 2016/8/10.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddSkuController', AddSkuController);

  AddSkuController.$inject = ['SkuService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', '$filter'];

  function AddSkuController(SkuService, $state, $uibModalInstance, toastr, entity, PromptService, $filter) {
    var vm = this;
    vm.sku = entity;
    vm.skuCodeReadOnly = false;

    vm.clear = clear;
    vm.addSku = addSku;
    vm.show = show;
    vm.showSkuName = showSkuName;
    vm.localeSure = localeSure;
    vm.localeSureSkuName = localeSureSkuName;
    vm.getProduct = getProduct;
    vm.load = load;

    vm.getProduct();

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
        $("#localeBtn_skuName").attr("disabled", false);
      });
    }
    initLangs();

    setSkuReadOnly();
    function setSkuReadOnly(){
      if(vm.sku.skuId!=null){
        vm.skuCodeReadOnly = true;
      }
    }
    //get product
    function getProduct() {
      SkuService.getProduct(vm.sku).then(function (result) {
        if(!result.rows){
          return;
        }
        vm.products = result.rows;
        vm.load();
      })
    }

    //init load
    function load() {
      if (vm.sku.skuId) {
        SkuService.getSku(vm.sku, 1).then(function (result) {
          vm.sku = result.rows[0];
          SkuService.getProductLocaleInfo(vm.sku.skuId, 'com.iot.portal.admin.dvm.dto.DvmSkuDTO', $("#localeBtn").val())
            .then(function (data) {
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn").val()] = description;
              SkuService.getProductLocaleInfo(vm.sku.skuId, 'com.iot.portal.admin.dvm.dto.DvmSkuDTO', $("#localeBtn_skuName").val())
                .then(function (data) {
                  var skuName = {};
                  for (var i in data) {
                    skuName[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#localeBtn_skuName").val()] = skuName;
                  vm.sku.__tls = __tls;
                  $("#localeBtn").attr("disabled", false);
                  $("#localeBtn_skuName").attr("disabled", false);
                })
            })
        })
      }
    }

    //submit  add sku
    function addSku() {
      var skus = new Array();
      skus.push(vm.sku);
      if(!vm.sku.skuId){
        return SkuService.addSku(skus).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('dvmsku', null, {reload: true});
          }
        });
      } else {
        return SkuService.updateSku(skus).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('dvmsku', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    //show model
    function show() {
      $("#localeModal").modal("show");
      if($.trim($("#localeModelBody").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "' ng-model='vm.sku.__tls." + $("#localeBtn").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody").append(div);
            if(vm.sku.skuId){
              $("input[name='" + langs[i].langCode + "']").val(vm.sku.__tls[$("#localeBtn").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    //show sku name model
    function showSkuName() {
      $("#localeModal_skuName").modal("show");
      if($.trim($("#localeModelBody_skuName").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Name' ng-model='vm.sku.__tls." + $("#localeBtn_skuName").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_skuName").append(div);
            if(vm.sku.skuId) {
              $("input[name='" + langs[i].langCode + "Name']").val(vm.sku.__tls[$("#localeBtn_skuName").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    //save desc model
    function localeSure() {
      var __tls = vm.sku.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "']").val();
      }
      var btnValue = $("#localeBtn").val();
      vm.sku[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal").modal("hide");
      __tls[btnValue] = description;
      vm.sku.__tls = __tls;
    }

    //save sku name model
    function localeSureSkuName() {
      var __tls = vm.sku.__tls || {};
      var skuName = {};
      for (var i in langs) {
        skuName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Name']").val();
      }
      var btnValue = $("#localeBtn_skuName").val();
      vm.sku[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Name']").val();
      $("#localeModal_skuName").modal("hide");
      __tls[btnValue] = skuName;
      vm.sku.__tls = __tls;
    }
  }
})();

/**
 * Created by zyl on 2017/8/5.
 */
(function () {
  'use strict';
  angular.module('hmapFront')
  .controller('addProductTypeController', addProductTypeController);
  addProductTypeController.$inject = ['ProductService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService',
    '$filter', '$localStorage', 'Upload', 'BaseConfig', '$sessionStorage', 'toastrConfig'];

  function addProductTypeController(ProductService, $state, $uibModalInstance, toastr, entity, PromptService,
                                    $filter, $localStorage, Upload, BaseConfig, $sessionStorage, toastrConfig) {

    var vm = this;
    vm.productType = entity;

    vm.showDescription = showDescription;
    vm.showProductType = showProductType;
    vm.localeSureDescription = localeSureDescription;
    vm.localeSureProductType = localeSureProductType;
    vm.clear = clear;
    vm.load = load;
    vm.changeFile = changeFile;
    vm.submitFile = submitFile;
    vm.initLangs = initLangs;
    vm.addProductType = addProductType;
    vm.setFile = setFile;
    vm.setReadOnlyCode = setReadOnlyCode;
    vm.oldFile = "assets/images/logo-header.png";
    vm.file = "";
    vm.imageRequired = true;
    vm.readOnlyCode = false;
    var langs = [];
    vm.load();
    vm.initLangs();
    vm.setFile();
    vm.setReadOnlyCode();

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn_productType").attr("disabled", false);
        $("#localeBtn_description").attr("disabled", false);
      })
    }

    function setFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
    }

    function setReadOnlyCode() {
      if (vm.productType.productTypeId) {
        vm.readOnlyCode = true;
      }
    }

    function load() {
      if (vm.productType.productTypeId) {
        //vm.editOrCreate='Edit';
        ProductService.getProductType(vm.productType, 1).then(function (result) {
          vm.productType = result.rows[0];

          if (vm.productType.productTypeImage) {
            vm.oldFile = vm.productType.productTypeImage;
            vm.imageRequired = false;
          } else {
            vm.oldFile = "assets/images/logo-header.png";
          }
          ProductService.getProductLocaleInfo(vm.productType.productTypeId, 'com.iot.portal.admin.dvm.dto.DvmProductTypeDTO', $("#localeBtn_description").val())
          .then(function (data) {
            var __tls = {};
            var description = {};
            for (var i in data) {
              description[data[i].langCode] = data[i].value;
            }
            __tls[$("#localeBtn_description").val()] = description;
            ProductService.getProductLocaleInfo(vm.productType.productTypeId, 'com.iot.portal.admin.dvm.dto.DvmProductTypeDTO', $("#localeBtn_productType").val())
            .then(function (data) {
              var productTypeName = {};
              for (var i in data) {
                productTypeName[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn_productType").val()] = productTypeName;
              vm.productType.__tls = __tls;
              $("#localeBtn_description").attr("disabled", false);
              $("#localeBtn_productType").attr("disabled", false);
            })
          })
        })
      }
    }

    function addProductType() {
      var productTypes = [];
      productTypes.push(vm.productType);
      if (!vm.productType.productTypeId) {
        return ProductService.addProductType(productTypes).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('productType', null, {reload: true});
          }
        });
      } else {
        return ProductService.updateProductType(productTypes).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('productType', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showProductType() {
      $("#localeModal_productType").modal("show");
      if ($.trim($("#localeModalBody_productType").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class ='form-group'></div>");
            div.append("<lable class = 'control-label'>" + langs[i].description + "</lable>");
            div.append("<input type = 'text' class = 'form-control' name = '" + langs[i].langCode
              + "productTypeName' ng-model='vm.productType.__tls." + $("#localeBtn_productType").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModalBody_productType").append(div);
            if (vm.productType.productTypeId) {
              $("input[name='" + langs[i].langCode + "productTypeName']").val(vm.productType.__tls[$("#localeBtn_productType").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showDescription() {
      $("#localeModal_description").modal("show");
      if ($.trim($("#localeModalBody_description").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class ='form-group'></div>");
            div.append("<lable class = 'control-label'>" + langs[i].description + "</lable>");
            div.append("<input type = 'text' class = 'form-control' name = '" + langs[i].langCode
              + "description' ng-model='vm.productType.__tls." + $("#localeBtn_description").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModalBody_description").append(div);
            if (vm.productType.productTypeId) {
              $("input[name='" + langs[i].langCode + "description']").val(vm.productType.__tls[$("#localeBtn_description").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function localeSureProductType() {
      var __tls = vm.productType.__tls || {};
      var productTypeName = {};
      for (var i in langs) {
        productTypeName[langs[i].langCode] = $("input[name = '" + langs[i].langCode + "productTypeName']").val();
      }
      var btnValue = $("#localeBtn_productType").val();
      vm.productType[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "productTypeName']").val();
      $("#localeModal_productType").modal("hide");
      __tls[btnValue] = productTypeName;
      vm.productType.__tls = __tls;
    }

    function localeSureDescription() {
      var __tls = vm.productType.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name = '" + langs[i].langCode + "description']").val();
      }
      var btnValue = $("#localeBtn_description").val();
      vm.productType[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "description']").val();
      $("#localeModal_description").modal("hide");
      __tls[btnValue] = description;
      vm.productType.__tls = __tls;
    }

    function changeFile() {
      if (vm.file) {
        vm.oldFile = vm.file;
      }
    }

    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;

    function submitFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
      if (vm.file == "assets/images/logo-header.png") {
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"));
        return;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    }

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //upload success
        vm.productType.productTypeImage = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
      });
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

  }
})();

/**
 * Created by xiwang.liu on 2017/06/01.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddProductPropertyController', AddProductPropertyController);

  AddProductPropertyController.$inject = ['$stateParams', 'ProductService','MessageTemplateService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', 'SweetAlert', '$filter','Upload','$localStorage','$sessionStorage','BaseConfig'];

  function AddProductPropertyController($stateParams, ProductService,MessageTemplateService, $state, $uibModalInstance, toastr, entity, PromptService, SweetAlert, $filter,Upload,$localStorage,$sessionStorage,BaseConfig) {
    var vm = this;
    vm.property = entity;

    vm.clear = clear;
    vm.addProperty = addProperty;
    vm.show = show;
    vm.showPropertyName = showPropertyName;
    vm.localeSure = localeSure;
    vm.localeSurePropertyName = localeSurePropertyName;
    vm.showParameterRange = showParameterRange;
    vm.showDefaultValue = showDefaultValue;
    vm.showCurrentValue = showCurrentValue;
    vm.localeSureParameterRange = localeSureParameterRange;
    vm.localeSureDefaultValue = localeSureDefaultValue;
    vm.localeSureCurrentValue = localeSureCurrentValue;
    vm.changeParameterRange = changeParameterRange;
    vm.load = load;
    vm.getUnit = getUnit;
    vm.getModifySetable = getModifySetable;
    vm.getProduct = getProduct;
    vm.upload = upload;

    vm.file = "";

    vm.uploadMusic = uploadMusic;

    vm.getUnit();
    vm.load();
    vm.getModifySetable();

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
        $("#localeBtn_propertyName").attr("disabled", false);
        $("#localeBtn_parameterRange").attr("disabled", false);
        $("#localeBtn_defaultValue").attr("disabled", false);
        $("#localeBtn_currentValue").attr("disabled", false);
      });
    }
    initLangs();
    vm.getProduct();
    // vm.getModifySetable();
    //get unit
    function getUnit() {
      ProductService.getUnit().then(function (result) {
        if(!result.rows){
          return;
        }
        vm.units = result.rows;
      })
    }

    function getProduct(){
      ProductService.getProductById($stateParams.productId, 1).then(function(data){
        if(!data.rows){
          return;
        }
        vm.product = data.rows[0];
        if(vm.product.referenceSource=='residential'){
          vm.property.modifyFlag = 'N';
        }
      })
    }
    //init load
    function load() {
      if (vm.property.propertyId) {
        ProductService.getProperty(vm.property, 1).then(function (result) {
          vm.property = result.rows[0];
          ProductService.getProductLocaleInfo(vm.property.propertyId, 'com.iot.portal.admin.dvm.dto.DvmProductPropertyDTO', $("#localeBtn").val())
            .then(function (data) {
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn").val()] = description;
              ProductService.getProductLocaleInfo(vm.property.propertyId, 'com.iot.portal.admin.dvm.dto.DvmProductPropertyDTO', $("#localeBtn_propertyName").val())
                .then(function (data) {
                  var propertyName = {};
                  for (var i in data) {
                    propertyName[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#localeBtn_propertyName").val()] = propertyName;
                  vm.property.__tls = __tls;
                  ProductService.getProductLocaleInfo(vm.property.propertyId, 'com.iot.portal.admin.dvm.dto.DvmProductPropertyDTO', $("#localeBtn_parameterRange").val())
                    .then(function (data) {
                      var parameterRange = {};
                      for (var i in data) {
                        parameterRange[data[i].langCode] = data[i].value;
                      }
                      __tls[$("#localeBtn_parameterRange").val()] = parameterRange;
                      vm.property.__tls = __tls;
                      ProductService.getProductLocaleInfo(vm.property.propertyId, 'com.iot.portal.admin.dvm.dto.DvmProductPropertyDTO', $("#localeBtn_defaultValue").val())
                        .then(function (data) {
                          var defaultValue = {};
                          for (var i in data) {
                            defaultValue[data[i].langCode] = data[i].value;
                          }
                          __tls[$("#localeBtn_defaultValue").val()] = defaultValue;
                          vm.property.__tls = __tls;
                          $("#localeBtn").attr("disabled", false);
                          $("#localeBtn_propertyName").attr("disabled", false);
                          $("#localeBtn_parameterRange").attr("disabled", false);
                          $("#localeBtn_defaultValue").attr("disabled", false);
                        })
                    })
                })
            })
        })
      }
    }

    //invalid range
    function changeParameterRange() {
      if(vm.property.parameterType == 'ANY_VALUE'){
        return true;
      } else if(vm.property.parameterRange){
        var parameterRange = vm.property.parameterRange;
        if(parameterRange.indexOf("/") == 0 || parameterRange.indexOf("/") + 1 == parameterRange.length){
          return false;
        }
        return true;
      } else {
        return false;
      }
    }

    //submit add product
    function addProperty() {
      if(!vm.changeParameterRange()){
        SweetAlert.error($filter('T')("property.ruleIllegal"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      var properties = new Array();
      properties.push(vm.property);
      if(vm.property.propertyId){
        return ProductService.updateProperty(properties).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('dvmPproperty');
          }
        });
      } else {
        return ProductService.addProperty(properties).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('dvmPproperty');
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function show() {
      $("#localeModal").modal("show");
      if($.trim($("#localeModelBody").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "' ng-model='vm.property.__tls." + $("#localeBtn").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "']").val(vm.property.__tls[$("#localeBtn").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showPropertyName() {
      $("#localeModal_propertyName").modal("show");
      if($.trim($("#localeModelBody_propertyName").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Name' ng-model='vm.property.__tls." + $("#localeBtn_propertyName").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_propertyName").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "Name']").val(vm.property.__tls[$("#localeBtn_propertyName").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showParameterRange() {
      $("#localeModal_parameterRange").modal("show");
      if($.trim($("#localeModelBody_parameterRange").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Range' ng-model='vm.property.__tls." + $("#localeBtn_parameterRange").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_parameterRange").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "Range']").val(vm.property.__tls[$("#localeBtn_parameterRange").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showDefaultValue() {
      $("#localeModal_defaultValue").modal("show");
      if($.trim($("#localeModelBody_defaultValue").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Default' ng-model='vm.property.__tls." + $("#localeBtn_defaultValue").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_defaultValue").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "Default']").val(vm.property.__tls[$("#localeBtn_defaultValue").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showCurrentValue() {
      $("#localeModal_currentValue").modal("show");
      if($.trim($("#localeModelBody_currentValue").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Current' ng-model='vm.property.__tls." + $("#localeBtn_currentValue").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_currentValue").append(div);
            if(vm.property.propertyId){
              $("input[name='" + langs[i].langCode + "Current']").val(vm.property.__tls[$("#localeBtn_currentValue").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function localeSure() {
      var __tls = vm.property.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "']").val();
      }
      var btnValue = $("#localeBtn").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal").modal("hide");
      __tls[btnValue] = description;
      vm.property.__tls = __tls;
    }

    function localeSurePropertyName() {
      var __tls = vm.property.__tls || {};
      var propertyName = {};
      for (var i in langs) {
        propertyName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Name']").val();
      }
      var btnValue = $("#localeBtn_propertyName").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Name']").val();
      $("#localeModal_propertyName").modal("hide");
      __tls[btnValue] = propertyName;
      vm.property.__tls = __tls;
    }

    function localeSureParameterRange() {
      var __tls = vm.property.__tls || {};
      var parameterRange = {};
      for (var i in langs) {
        parameterRange[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Range']").val();
      }
      var btnValue = $("#localeBtn_parameterRange").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Range']").val();
      $("#localeModal_parameterRange").modal("hide");
      __tls[btnValue] = parameterRange;
      vm.property.__tls = __tls;
    }

    function localeSureDefaultValue() {
      var __tls = vm.property.__tls || {};
      var defaultValue = {};
      for (var i in langs) {
        defaultValue[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Default']").val();
      }
      var btnValue = $("#localeBtn_defaultValue").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Default']").val();
      $("#localeModal_defaultValue").modal("hide");
      __tls[btnValue] = defaultValue;
      vm.property.__tls = __tls;
    }

    function localeSureCurrentValue() {
      var __tls = vm.property.__tls || {};
      var currentValue = {};
      for (var i in langs) {
        currentValue[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Current']").val();
      }
      var btnValue = $("#localeBtn_currentValue").val();
      vm.property[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Current']").val();
      $("#localeModal_currentValue").modal("hide");
      __tls[btnValue] = currentValue;
      vm.property.__tls = __tls;
    }

    function getModifySetable(){
      MessageTemplateService.getByCode().query({code: 'SYS.YES_NO'}, function (data) {
        vm.modifyFlag = data.rows;
      }, function (error) {
      });
    }

    function upload(file) {
      var file=document.getElementById("music").files[0];
      if (file == null || file== undefined || file == '') {
        return false;
      }
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/ctm/uploadMusic',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data) {
        //upload success
        vm.property.attribute1 = data.rows[0].musicUrl;
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
      });
    }
    function uploadMusic() {
      vm.upload(vm.file);
    }
  }
})();

/**
 * Created by xiwang.liu on 2016/8/10.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddProductController', AddProductController);

  AddProductController.$inject = ['ProductService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService',
    '$filter', '$localStorage', '$sessionStorage', 'Upload', 'BaseConfig', 'toastrConfig'];

  function AddProductController(ProductService, $state, $uibModalInstance, toastr, entity, PromptService, $filter,
                                $localStorage, $sessionStorage, Upload, BaseConfig, toastrConfig) {
    var vm = this;
    vm.product = entity;
    vm.productType = entity;
    vm.cmdSet = {};
    vm.CodeEditable = false;
    vm.clear = clear;
    vm.addProduct = addProduct;
    vm.getProductType = getProductType;
    vm.getCmdSet = getCmdSet;
    vm.show = show;
    vm.showProductName = showProductName;
    vm.showGuidanceNotes = showGuidanceNotes;
    vm.localeSureGuidanceNotes = localeSureGuidanceNotes;
    vm.localeSure = localeSure;
    vm.localeSureProductName = localeSureProductName;
    // vm.setProductCmdSetId = setProductCmdSetId;
    vm.flagProductTypeSelected = flagProductTypeSelected;
    vm.load = load;
    vm.load();

    vm.productTypes = [];
    vm.cmdSets = [];

    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    vm.oldFile="assets/images/logo-header.png";
    vm.file = "";
    vm.imageRequired = true;
    vm.submitFile = submitFile;
    vm.changeFile = changeFile;
    vm.setFile = setFile;

    //图片上传
    vm.uploadGuidanceImg = '';
    vm.varGuidanceMay = true;
    vm.varGuidanceMays = false;
    vm.guidanceImgShow = false;
    vm.oldGuidanceFile="assets/images/logo-header.png";
    vm.guidanceFile = "";
    vm.imageGuidanceRequired = true;
    vm.submitGuidanceFile = submitGuidanceFile;
    vm.changeGuidanceFile = changeGuidanceFile;
    vm.setGuidanceFile = setGuidanceFile;

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
        $("#localeBtn_productName").attr("disabled", false);
        $("#localeBtn_guidanceNotes").attr("disabled", false);
      });
    }
    initLangs();

    setEdit();
    function setEdit(){
      if (vm.product.productId!=null){
        vm.CodeEditable = true;
      }
    }

    function flagProductTypeSelected(productTypeName) {
        // noinspection JSAnnotator
        if(productTypeName===vm.product.productType){
          return true;
        }
        else
          return false;

    }
    function load() {
      if(vm.product.productName===null||vm.product.productName===undefined){
        vm.product.productName='';
      }
      if(vm.product.productCode===null||vm.product.productCode===undefined){
        vm.product.productCode='';
      }
      if(vm.product.referenceSource===null||vm.product.referenceSource===undefined){
        vm.product.referenceSource='';
      }
      if(vm.product.productRegion===null||vm.product.productRegion===undefined){
        vm.product.productRegion='';
      }
      if (vm.product.productId) {
        //vm.editOrCreate='Edit';
        ProductService.getProduct(vm.product, 1).then(function (result) {
          vm.product = result.rows[0];
          vm.getProductType();
          vm.getCmdSet();
          if(vm.product.productImage!=null){
            vm.oldFile = vm.product.productImage;
            vm.imageRequired = false;
            vm.varMay = false;
          }

          if(vm.product.operationImage!=null){
            vm.oldGuidanceFile = vm.product.operationImage;
            vm.imageGuidanceRequired = false;
            vm.varGuidanceMay = false;
          }

          ProductService.getProductLocaleInfo(vm.product.productId, 'com.iot.portal.admin.dvm.dto.DvmProductDTO', $("#localeBtn").val())
            .then(function (data) {
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn").val()] = description;
              ProductService.getProductLocaleInfo(vm.product.productId, 'com.iot.portal.admin.dvm.dto.DvmProductDTO', $("#localeBtn_productName").val())
                .then(function (data) {
                  var productName = {};
                  for (var i in data) {
                    productName[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#localeBtn_productName").val()] = productName;
                  ProductService.getProductLocaleInfo(vm.product.productId, 'com.iot.portal.admin.dvm.dto.DvmProductDTO', $("#localeBtn_guidanceNotes").val())
                    .then(function (data) {
                      var guidanceNotes = {};
                      for (var i in data) {
                        guidanceNotes[data[i].langCode] = data[i].value;
                      }
                      __tls[$("#localeBtn_guidanceNotes").val()] = guidanceNotes;
                      vm.product.__tls = __tls;
                      $("#localeBtn").attr("disabled", false);
                      $("#localeBtn_productName").attr("disabled", false);
                      $("#localeBtn_guidanceNotes").attr("disabled", false);
                    })
                })
            })
        })
      }
      else{
          ProductService.getAllProductType(vm.productType, 1, 50).then(function (data) {
            if(!data.rows){
              return;
            }
            vm.productTypes = data.rows;
          });
        ProductService.getAllCmdSet(vm.cmdSet, 1, 50).then(function (data) {
          if(!data.rows){
            return;
          }
          vm.cmdSets = data.rows;
        });
      }
    }

    //get productType
    function getProductType() {
      ProductService.getAllProductType(vm.productType, 1, 50).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.productTypes = data.rows;
        for(var i = 0;i<vm.productTypes.length;i++){
          if(vm.productTypes[i].productTypeName == vm.product.productType){
            vm.product.productType = vm.productTypes[i].productTypeCode;
          }
        }
      })
    }

    function getCmdSet() {
      ProductService.getAllCmdSet(vm.cmdSet, 1, 50).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.cmdSets = data.rows;
        for(var i = 0;i<vm.cmdSets.length;i++){
          if(vm.cmdSets[i].cmdSetId == vm.product.cmdSetId){
            vm.product.cmdSetId = vm.cmdSets[i].cmdSetId;
          }
        }
      });
    }

    // function setProductCmdSetId(){
    //   if(vm.product.productId){
    //     for(var i = 0;i<vm.productTypes.length;i++){
    //       if(vm.product.productType == vm.productTypes[i].productTypeName){
    //         vm.product.cmdSetId = vm.productTypes[i].cmdSetId;
    //         vm.product.deviceIdentity = vm.productTypes[i].deviceIdentity;
    //       }
    //     }
    //   }
    //   else {
    //     for(var i = 0;i<vm.productTypes.length;i++){
    //       if(vm.product.productType == vm.productTypes[i].productTypeCode){
    //         vm.product.cmdSetId = vm.productTypes[i].cmdSetId;
    //         vm.product.deviceIdentity = vm.productTypes[i].deviceIdentity;
    //       }
    //     }
    //   }
    // }
    //submit add product
    function addProduct() {
      vm.uploadImg = vm.uploadImg ? vm.uploadImg : vm.product.productImage;
      vm.uploadGuidanceImg = vm.uploadGuidanceImg ? vm.uploadGuidanceImg : vm.product.operationImage;

      if(vm.uploadImg && vm.uploadImg.rows){
        vm.product.productImage = vm.uploadImg.rows[0].objectUrl;
      }

      if(vm.uploadGuidanceImg && vm.uploadGuidanceImg.rows){
        vm.product.operationImage = vm.uploadGuidanceImg.rows[0].objectUrl;
      }
      if ('' !== vm.product.voiceCommand && undefined !== vm.product.voiceCommand
        && null !==vm.product.voiceCommand) {
        if (!isJSON(vm.product.voiceCommand)) {
          toastr.error($filter('T')("dvmProduct.checkJsonFormat"), $filter('T')("dvmProduct.invalidJson"));
          return;
        }
      }
      if ('' !== vm.product.contrastCommand && undefined !== vm.product.contrastCommand
        && null !==vm.product.contrastCommand) {
        if (!isJSON(vm.product.contrastCommand)) {
          toastr.error($filter('T')("dvmProduct.checkJsonFormat"), $filter('T')("dvmProduct.invalidJson"));
          return;
        }
      }
      var products = new Array();
      products.push(vm.product);
      if(!vm.product.productId){
        return ProductService.addProduct(products).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('dvmproduct', null, {reload: true});
          }
        });
      } else{
        return ProductService.updateProduct(products).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('dvmproduct');
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    //show model
    function show() {
      $("#localeModal").modal("show");
      if($.trim($("#localeModelBody").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "' ng-model='vm.product.__tls." + $("#localeBtn").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody").append(div);
            if(vm.product.productId){
              $("input[name='" + langs[i].langCode + "']").val(vm.product.__tls[$("#localeBtn").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    //show product name model
    function showProductName() {
      $("#localeModal_productName").modal("show");
      if($.trim($("#localeModelBody_productName").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "Name' ng-model='vm.product.__tls." + $("#localeBtn_productName").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_productName").append(div);
            if(vm.product.productId) {
              $("input[name='" + langs[i].langCode + "Name']").val(vm.product.__tls[$("#localeBtn_productName").val()][langs[i].langCode]);
            }
          }
        }
      }
    }
    //show product name model
    function showGuidanceNotes() {
      $("#localeModal_guidanceNotes").modal("show");
      if($.trim($("#localeModelBody_guidanceNotes").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + langs[i].langCode
              + "guidanceNotes' ng-model='vm.product.__tls." + $("#localeBtn_guidanceNotes").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModelBody_guidanceNotes").append(div);
            if(vm.product.productId) {
              $("input[name='" + langs[i].langCode + "guidanceNotes']").val(vm.product.__tls[$("#localeBtn_guidanceNotes").val()][langs[i].langCode]);
            }
          }
        }
      }
    }
    //save model
    function localeSure() {
      var __tls = vm.product.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "']").val();
      }
      var btnValue = $("#localeBtn").val();
      vm.product[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal").modal("hide");
      __tls[btnValue] = description;
      vm.product.__tls = __tls;
    }

    //save product name model
    function localeSureProductName() {
      var __tls = vm.product.__tls || {};
      var productName = {};
      for (var i in langs) {
        productName[langs[i].langCode] = $("input[name='" + langs[i].langCode + "Name']").val();
      }
      var btnValue = $("#localeBtn_productName").val();
      vm.product[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "Name']").val();
      $("#localeModal_productName").modal("hide");
      __tls[btnValue] = productName;
      vm.product.__tls = __tls;
    }

    //save product name model
    function localeSureGuidanceNotes() {
      var __tls = vm.product.__tls || {};
      var guidanceNotes = {};
      for (var i in langs) {
        guidanceNotes[langs[i].langCode] = $("input[name='" + langs[i].langCode + "guidanceNotes']").val();
      }
      var btnValue = $("#localeBtn_guidanceNotes").val();
      vm.product[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "guidanceNotes']").val();
      $("#localeModal_guidanceNotes").modal("hide");
      __tls[btnValue] = guidanceNotes;
      vm.product.__tls = __tls;
    }

    function setFile(){
      if(vm.oldFile!="assets/images/logo-header.png"){
        vm.file=vm.oldFile;
      }
    }

    function setGuidanceFile(){
      if(vm.oldGuidanceFile!="assets/images/logo-header.png"){
        vm.guidanceFile=vm.oldGuidanceFile;
      }
    }

    function changeFile() {
      if(vm.file){
        vm.varMay = true;
        vm.oldFile=vm.file
      }
    }

    function changeGuidanceFile() {
      if(vm.guidanceFile){
        vm.varGuidanceMay = true;
        vm.oldGuidanceFile=vm.guidanceFile
      }
    }

    function submitFile() {
      if(vm.oldFile!="assets/images/logo-header.png"){
        vm.file=vm.oldFile;
      }
      if(vm.file=="assets/images/logo-header.png"){
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"));
        return;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    }

    function submitGuidanceFile() {
      if(vm.oldGuidanceFile!="assets/images/logo-header.png"){
        vm.guidanceFile=vm.oldGuidanceFile;
      }
      if(vm.guidanceFile=="assets/images/logo-header.png"){
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"));
        return;
      }
      uploadGuidance(vm.guidanceFile);
      if (vm.guidanceFile != null && vm.guidanceFile != undefined && vm.guidanceFile != "") {
        vm.guidanceImgShow = true;
      } else {
        vm.guidanceImgShow = false;
      }
    }

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data) {
        //upload success
        vm.productType.productTypeImage = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
      });
    }

    function uploadGuidance(file) {
      vm.guidanceFileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data) {
        //upload success
        vm.productType.operationImage = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varGuidanceMay = false;
          vm.varGuidanceMays = true;
        } else {
          vm.varGuidanceMay = true;
          vm.varGuidanceMays = false;
        }
        vm.uploadGuidanceImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
      });
    }

    function isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
      console.log('It is not a string!')
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by yangyang.zou on 2019/04/02.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddOtherNameListController', AddOtherNameListController);

  AddOtherNameListController.$inject = ['OtherNameListService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService',
    '$filter', 'toastrConfig','MessageTemplateService','$localStorage','Upload', 'BaseConfig', '$sessionStorage'];

  function AddOtherNameListController(OtherNameListService, $state, $uibModalInstance, toastr, entity, PromptService, $filter,
                                      toastrConfig, MessageTemplateService, $localStorage, Upload, BaseConfig, $sessionStorage) {
    var vm = this;
    vm.otherNameList = entity;

    vm.clear = clear;
    vm.addOtherNameList = addOtherNameList;
    vm.showOtherNameList = showOtherNameList;
    vm.showDescription = showDescription;
    vm.localeSureOtherNameList = localeSureOtherNameList;
    vm.localeSureDescription = localeSureDescription;
    vm.initLangs = initLangs;
    vm.setReadOnlyCode = setReadOnlyCode;
    vm.load = load;
    vm.initWeidget = initWeidget;
    vm.setFile = setFile;
    vm.changeFile = changeFile;
    vm.submitFile = submitFile;
    vm.changeType = changeType;
    vm.oldFile = "assets/images/logo-header.png";
    vm.file = "";
    var langs = [];
    vm.readOnlyCode = false;
    vm.imgShow = true;
    vm.nameShow = true;

    vm.initWeidget();
    vm.initLangs();
    vm.load();
    vm.setFile();
    vm.setReadOnlyCode();


    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn_otherNameList").attr("disabled", false);
        $("#localeBtn_description").attr("disabled", false);
      })
    }

    function setReadOnlyCode() {
      if (vm.otherNameList.otherNameListId) {
        vm.readOnlyCode = true;
      }
    }

    function load() {
      if (vm.otherNameList.otherNameListId) {
        //vm.editOrCreate='Edit';
        OtherNameListService.getOtherNameList(vm.otherNameList, 1).then(function (result) {
          vm.otherNameList = result.rows[0];

          if (vm.otherNameList.otherType.indexOf("_ICON") != -1 && vm.otherNameList.otherName) {
            vm.oldFile = vm.otherNameList.otherName;
            vm.imgShow = true;
            vm.nameShow = false;
          } else {
            vm.oldFile = "assets/images/logo-header.png";
            vm.imgShow = false;
            vm.nameShow = true;
          }
          OtherNameListService.getOtherNameListLocaleInfo(vm.otherNameList.otherNameListId, 'com.iot.portal.admin.dvm.dto.DvmOtherNameListDTO', $("#localeBtn_description").val())
            .then(function (data) {
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn_description").val()] = description;
              OtherNameListService.getOtherNameListLocaleInfo(vm.otherNameList.otherNameListId, 'com.iot.portal.admin.dvm.dto.DvmOtherNameListDTO', $("#localeBtn_otherNameList").val())
                .then(function (data) {
                  var otherName = {};
                  for (var i in data) {
                    otherName[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#localeBtn_otherNameList").val()] = otherName;
                  vm.otherNameList.__tls = __tls;
                  $("#localeBtn_otherNameList").attr("disabled", false);
                  $("#localeBtn_description").attr("disabled", false);
                })
            })
        })
      }
    }

    //submit  add otherNameList
    function addOtherNameList() {
      var otherNameLists = new Array();
      otherNameLists.push(vm.otherNameList);
      if(!vm.otherNameList.otherNameListId){
        return OtherNameListService.addOtherNameList(otherNameLists).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('otherNameList', null, {reload: 'otherNameList'});
          }
        });
      } else {
        return OtherNameListService.updateOtherNameList(otherNameLists).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('otherNameList', null, {reload: 'otherNameList'});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


    function showOtherNameList() {
      $("#localeModal_otherNameList").modal("show");
      if ($.trim($("#localeModalBody_otherNameList").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class ='form-group'></div>");
            div.append("<lable class = 'control-label'>" + langs[i].description + "</lable>");
            div.append("<input type = 'text' class = 'form-control' name = '" + langs[i].langCode
              + "otherName' ng-model='vm.otherNameList.__tls." + $("#localeBtn_otherNameList").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModalBody_otherNameList").append(div);
            if (vm.otherNameList.otherNameListId) {
              $("input[name='" + langs[i].langCode + "otherName']").val(vm.otherNameList.__tls[$("#localeBtn_otherNameList").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showDescription() {
      $("#localeModal_description").modal("show");
      if ($.trim($("#localeModalBody_description").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class ='form-group'></div>");
            div.append("<lable class = 'control-label'>" + langs[i].description + "</lable>");
            div.append("<input type = 'text' class = 'form-control' name = '" + langs[i].langCode
              + "description' ng-model='vm.otherNameList.__tls." + $("#localeBtn_description").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModalBody_description").append(div);
            if (vm.otherNameList.otherNameListId) {
              $("input[name='" + langs[i].langCode + "description']").val(vm.otherNameList.__tls[$("#localeBtn_description").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function localeSureOtherNameList() {
      var __tls = vm.otherNameList.__tls || {};
      var otherName = {};
      for (var i in langs) {
        otherName[langs[i].langCode] = $("input[name = '" + langs[i].langCode + "otherName']").val();
      }
      var btnValue = $("#localeBtn_otherNameList").val();
      vm.otherNameList[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "otherName']").val();
      $("#localeModal_otherNameList").modal("hide");
      __tls[btnValue] = otherName;
      vm.otherNameList.__tls = __tls;
    }

    function localeSureDescription() {
      var __tls = vm.otherNameList.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name = '" + langs[i].langCode + "description']").val();
      }
      var btnValue = $("#localeBtn_description").val();
      vm.otherNameList[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "description']").val();
      $("#localeModal_description").modal("hide");
      __tls[btnValue] = description;
      vm.otherNameList.__tls = __tls;
    }


    function initWeidget() {
      MessageTemplateService.getByCode().query({code: 'SYS.OTHER_TYPE'}, function (data) {
        vm.otherTypeSource = data.rows;
      }, function (error) {
      });
    }

    function setFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
    }

    function changeFile() {
      if (vm.file) {
        vm.oldFile = vm.file;
      }
      vm.submitFile();
    }


    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;

    function submitFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
      if (vm.file == "assets/images/logo-header.png") {
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"));
        return;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    }

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //upload file
        data: {file: file}
      }).progress(function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //upload success
        vm.otherNameList.otherName = data.rows[0].objectUrl;

        var __tls = vm.otherNameList.__tls || {};
        var otherName = {};
        for (var i in langs) {
          otherName[langs[i].langCode] = data.rows[0].objectUrl;
        }
        __tls["otherName"] = otherName;
        vm.otherNameList.__tls = __tls;

        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"));
      }).error(function (data, status, headers, config) {
      });
    }

    function changeType(otherType) {
      if (otherType){
        if (otherType.indexOf("_ICON") != -1){
          vm.imgShow = true;
          vm.nameShow = false;
        }else{
          vm.imgShow = false;
          vm.nameShow = true;
        }
      }
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

  }
})();

/**
 * Created by yangyang.zou on 2019/04/01.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddDeviceNameListController', AddDeviceNameListController);

  AddDeviceNameListController.$inject = ['DeviceNameListService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', '$filter','toastrConfig'];

  function AddDeviceNameListController(DeviceNameListService, $state, $uibModalInstance, toastr, entity, PromptService, $filter,toastrConfig) {
    var vm = this;
    vm.deviceNameList = entity;

    vm.clear = clear;
    vm.addDeviceNameList = addDeviceNameList;
    vm.showDeviceNameList = showDeviceNameList;
    vm.showDescription = showDescription;
    vm.localeSureDeviceNameList = localeSureDeviceNameList;
    vm.localeSureDescription = localeSureDescription;
    vm.initLangs = initLangs;
    vm.setReadOnlyCode = setReadOnlyCode;
    vm.getProduct = getProduct;
    vm.load = load;
    var langs = [];
    vm.readOnlyCode = false;


    vm.initLangs();
    vm.setReadOnlyCode();
    vm.getProduct();

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn_deviceNameList").attr("disabled", false);
        $("#localeBtn_description").attr("disabled", false);
      })
    }

    function setReadOnlyCode() {
      if (vm.deviceNameList.deviceNameListId) {
        vm.readOnlyCode = true;
      }
    }

    function getProduct() {
      DeviceNameListService.getProduct(vm.deviceNameList).then(function (result) {
        if(!result.rows){
          return;
        }
        vm.products = result.rows;
        vm.load();
      })
    }

    function load() {
      if (vm.deviceNameList.deviceNameListId) {
        //vm.editOrCreate='Edit';
        DeviceNameListService.getDeviceNameList(vm.deviceNameList, 1).then(function (result) {
          vm.deviceNameList = result.rows[0];
          DeviceNameListService.getDeviceNameListLocaleInfo(vm.deviceNameList.deviceNameListId, 'com.iot.portal.admin.dvm.dto.DvmDeviceNameListDTO', $("#localeBtn_description").val())
            .then(function (data) {
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn_description").val()] = description;
              DeviceNameListService.getDeviceNameListLocaleInfo(vm.deviceNameList.deviceNameListId, 'com.iot.portal.admin.dvm.dto.DvmDeviceNameListDTO', $("#localeBtn_deviceNameList").val())
                .then(function (data) {
                  var deviceName = {};
                  for (var i in data) {
                    deviceName[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#localeBtn_deviceNameList").val()] = deviceName;
                  vm.deviceNameList.__tls = __tls;
                  $("#localeBtn_deviceNameList").attr("disabled", false);
                  $("#localeBtn_description").attr("disabled", false);
                })
            })
        })
      }
    }

    //submit  add deviceNameList
    function addDeviceNameList() {
      var deviceNameLists = new Array();
      deviceNameLists.push(vm.deviceNameList);
      if(!vm.deviceNameList.deviceNameListId){
        return DeviceNameListService.addDeviceNameList(deviceNameLists).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('deviceNameList', null, {reload: true});
          }
        });
      } else {
        return DeviceNameListService.updateDeviceNameList(deviceNameLists).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('deviceNameList', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


    function showDeviceNameList() {
      $("#localeModal_deviceNameList").modal("show");
      if ($.trim($("#localeModalBody_deviceNameList").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class ='form-group'></div>");
            div.append("<lable class = 'control-label'>" + langs[i].description + "</lable>");
            div.append("<input type = 'text' class = 'form-control' name = '" + langs[i].langCode
              + "deviceName' ng-model='vm.deviceNameList.__tls." + $("#localeBtn_deviceNameList").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModalBody_deviceNameList").append(div);
            if (vm.deviceNameList.deviceNameListId) {
              $("input[name='" + langs[i].langCode + "deviceName']").val(vm.deviceNameList.__tls[$("#localeBtn_deviceNameList").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function showDescription() {
      $("#localeModal_description").modal("show");
      if ($.trim($("#localeModalBody_description").html()) == "") {
        for (var i in langs) {
          if (langs.hasOwnProperty(i)) {
            var div = $("<div class ='form-group'></div>");
            div.append("<lable class = 'control-label'>" + langs[i].description + "</lable>");
            div.append("<input type = 'text' class = 'form-control' name = '" + langs[i].langCode
              + "description' ng-model='vm.deviceNameList.__tls." + $("#localeBtn_description").val() + '.' + langs[i].langCode + "'/>");
            $("#localeModalBody_description").append(div);
            if (vm.deviceNameList.deviceNameListId) {
              $("input[name='" + langs[i].langCode + "description']").val(vm.deviceNameList.__tls[$("#localeBtn_description").val()][langs[i].langCode]);
            }
          }
        }
      }
    }

    function localeSureDeviceNameList() {
       var __tls = vm.deviceNameList.__tls || {};
      var deviceName = {};
      for (var i in langs) {
        deviceName[langs[i].langCode] = $("input[name = '" + langs[i].langCode + "deviceName']").val();
      }
      var btnValue = $("#localeBtn_deviceNameList").val();
      vm.deviceNameList[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "deviceName']").val();
      $("#localeModal_deviceNameList").modal("hide");
      __tls[btnValue] = deviceName;
      vm.deviceNameList.__tls = __tls;
    }

    function localeSureDescription() {
      var __tls = vm.deviceNameList.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name = '" + langs[i].langCode + "description']").val();
      }
      var btnValue = $("#localeBtn_description").val();
      vm.deviceNameList[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "description']").val();
      $("#localeModal_description").modal("hide");
      __tls[btnValue] = description;
      vm.deviceNameList.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .constant('tableHeaderConstant', {
      T_DVM_PRODUCT_B: {
        shows:['productCode','productName','propertyCode','propertyType','propertyName','status'],
        mainId:'productId',
        connectedId:'propertyId'
      },
      T_INM_COMMAND:{
        shows:['productName','productCode','cmdCode','paramName','status'],
        mainId:'cmdId',
        connectedId:'paramId'
      },
      T_SYS_MESSAGE_TEMPLATE_B:{
        mainId:'templateId',
        shows:['productCode','templateType','templateCode','templateName','status']
      },
      SYS_CODE_B:{
        shows:['code','meaning','description1','description2','status'],
        mainId:'codeId',
        connectedId:'codeValueId'
      }
    });
})();

(function () {
  'use strict';
  var app = angular.module('hmapFront');

  app.filter('DataUpdateStatus', dataUpdateStatus);

  dataUpdateStatus.$inject = ['$translate'];

  function dataUpdateStatus($translate) {
    return function (items) {
      var filtered = [];
      angular.forEach(items,function(item){
        var temp = {};
        angular.extend(temp,item);
        temp.rawStatus = temp.status;
        if('doNothing' === item.status){
          temp.status = $translate.instant('dataDistribution.no');
        } else if (item.status.indexOf('add')>0) {
          temp.status = $translate.instant('dataDistribution.add');
        } else if (item.status.indexOf('update')>0) {
          temp.status = $translate.instant('dataDistribution.update')
        }
        filtered.push(temp);
      });

      return filtered;
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('dataHistoryDetailController', dataHistoryDetailController);

  dataHistoryDetailController.$inject = ['$sessionStorage','$uibModalInstance','entity','DataDistributionService', 'paginationConstants', 'SweetAlert', '$filter','$state','$translate','tableHeaderConstant','BaseConfig'];

  function dataHistoryDetailController($sessionStorage, $uibModalInstance,entity,DataDistributionService, paginationConstants, SweetAlert, $filter, $state,$translate,tableHeaderConstant,BaseConfig) {
    var vm = this;
    vm.data = entity;
    vm.page = 1;
    vm.data.dataFrom = BaseConfig.env;
    vm.tableHeaderConstant = tableHeaderConstant;

    vm.pageChanged = pageChanged;
    vm.queryDataDistribution = queryDataDistribution;
    // vm.distributionData = distributionData;
    // vm.compareDate = compareDate;
    vm.clear = clear;
    vm.getTableCode = getTableCode;

    vm.getTableCode();
    vm.queryDataDistribution();

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


    function pageChanged() {
      vm.queryDataDistribution(vm.page);
    }

    function queryDataDistribution() {
      vm.tableHeader = vm.tableHeaderConstant[vm.data.tableCode];
      vm.data.operationType = "query";
      if(vm.data.successFlag){
        DataDistributionService.getDataDistributionHistorySuccess(vm.data).then(function (data) {
          vm.dataGet = data.rows;
          vm.totalItems = data.rows.length;
        })
      } else {
        DataDistributionService.getDataDistributionHistoryFailed(vm.data).then(function (data) {
          vm.dataGet = data.rows;
          vm.totalItems = data.rows.length;
        })
      }


    }

    function getTableCode() {
      vm.data.tableCode =  $sessionStorage.DataDelivery_History_TableCode;
    }

    //
    // function distributionData() {
    //   if (vm.data.beginTime==null||vm.data.beginTime==''){
    //     SweetAlert.error($filter('T')("distribution.notBeginTime"), {title: $filter('T')("btnTypeName.prompt")});
    //     return;
    //   }
    //   if (vm.data.endTime==null||vm.data.endTime==''){
    //     SweetAlert.error($filter('T')("distribution.notEndTime"), {title: $filter('T')("btnTypeName.prompt")});
    //     return;
    //   }
    //   if(vm.data.tableCode==null||vm.data.tableCode==''){
    //     SweetAlert.error($filter('T')("distribution.notDataType"), {title: $filter('T')("btnTypeName.prompt")});
    //     return;
    //   }
    //   if(vm.data.dataTo==null||vm.data.dataTo==''){
    //     SweetAlert.error($filter('T')("distribution.notDataTo"), {title: $filter('T')("btnTypeName.prompt")});
    //     return;
    //   }
    //   if (vm.data.dataFrom != "staging" && vm.data.dataTo == "prod") {
    //     SweetAlert.error($filter('T')("title.errorDistribution"), {title: $filter('T')("btnTypeName.prompt")});
    //     return;
    //   }
    //   vm.data.operationType = "query";
    //   DataDistributionService.distributingData(vm.data).then(function (data) {
    //     if(data.rows.length==0){
    //       SweetAlert.success($filter('T')("title.distributionSuccess"), {title: $filter('T')("btnTypeName.prompt")}).then(
    //         $state.go('dataDistribution',null,{reload:true})
    //       )
    //     }
    //     else {
    //       vm.distributionFailIdList = data.rows;
    //     }
    //   })
    // }
    //
    //
    // $('.form_date').datetimepicker({
    //   language: 'vm.lang',
    //   format: 'yyyy-mm-dd HH:ii:ss',
    //   weekStart: 1,
    //   todayBtn: 1,
    //   autoclose: 1,
    //   todayHighlight: 1,
    //   startView: 2,
    //   minView: 0,
    //   maxView:'decade',
    //   forceParse: 0,
    //   minuteStep: 1
    // });
    //
    // function compareDate() {
    //   var start = $('#start').val();
    //   var end = $('#end').val();
    //   if (start && end) {
    //     var startTime = new Date(start).getTime();
    //     var endTime = new Date(end).getTime();
    //     if (startTime > endTime) {
    //       var msg = $filter('T')("main.msg");
    //       vm.data.endTime = "";
    //       SweetAlert.error(msg, {title: $filter('T')("btnTypeName.prompt")});
    //     }
    //
    //     var max = new Date(endTime - startTime).getMonth();
    //     if(parseInt(max)>=2){
    //       // var msgTimeInterval = $filter('T')("main.msg");
    //       vm.data.endTime = "";
    //       SweetAlert.error($translate.instant('dataDistribution.timeInterval'), {title: $filter('T')("btnTypeName.prompt")});
    //     }
    //   }
    // }

  }
})();


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('dataHistoryController', dataHistoryController);

  dataHistoryController.$inject = ['BaseConfig','DataDistributionService', 'paginationConstants', 'SweetAlert', '$filter','$state','$sessionStorage','MessageTemplateService'];

  function dataHistoryController(BaseConfig,DataDistributionService, paginationConstants, SweetAlert, $filter,$state,$sessionStorage,MessageTemplateService) {
    var vm = this;
    vm.data = {};
    vm.data.beginTime = '';
    vm.data.endTime = '';
    vm.datas = {};
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.data.dataFrom = BaseConfig.env;
    vm.data.dataTo = BaseConfig.distEnv;


   /* vm.personName = '';
    vm.failData = '';
    vm.needDealData ='';
    vm.aimDatabase ='';
    vm.type='';*/

    vm.MIGRATORY_PERSON_NAME ='';
    vm.MIGRATORY_TIME ='';
    vm.MIGRATORY_TYPE='';
    vm.MIGRATORY_AIM_DATABASE='';

    vm.pageChanged = pageChanged;
    vm.queryDataDistributionHistory = queryDataDistributionHistory;
    vm.distributionDataHistory = distributionDataHistory;
    vm.compareDate = compareDate;
    vm.getTableCode = getTableCode;
    vm.reset = reset;
    vm.initWeidget = initWeidget;
    vm.initWeidget();

    function reset() {
      vm.data.beginTime = undefined;
      vm.data.endTime = undefined;
      vm.data.tableCode = undefined;
    }

   function getTableCode() {
     $sessionStorage.DataDelivery_History_TableCode = vm.data.tableCode;
   }



    function pageChanged() {
      vm.queryDataDistributionHistory(vm.page);
    }

    function queryDataDistributionHistory() {
      if (vm.data.beginTime==null||vm.data.beginTime==''){
        SweetAlert.error($filter('T')("distribution.notBeginTime"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.endTime==null||vm.data.endTime==''){
        SweetAlert.error($filter('T')("distribution.notEndTime"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if(vm.data.tableCode==null||vm.data.tableCode==''){
        SweetAlert.error($filter('T')("distribution.notDataType"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if(vm.data.dataTo==null||vm.data.dataTo==''){
        SweetAlert.error($filter('T')("distribution.notDataTo"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      vm.data.operationType = "query";
      DataDistributionService.getDataDistributionHistory(vm.data,vm.page).then(function (data) {
        vm.datas = data.rows;
      })


    }

    function distributionDataHistory() {
      if (vm.data.beginTime==null||vm.data.beginTime==''){
        SweetAlert.error($filter('T')("distribution.notBeginTime"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.endTime==null||vm.data.endTime==''){
        SweetAlert.error($filter('T')("distribution.notEndTime"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if(vm.data.tableCode==null||vm.data.tableCode==''){
        SweetAlert.error($filter('T')("distribution.notDataType"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if(vm.data.dataTo==null||vm.data.dataTo==''){
        SweetAlert.error($filter('T')("distribution.notDataTo"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.dataFrom != "staging" && vm.data.dataTo == "prod") {
        SweetAlert.error($filter('T')("title.errorDistribution"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      vm.data.operationType = "query";
      DataDistributionService.distributingData(vm.data).then(function (data) {
        if(data.rows.length==0){
          SweetAlert.success($filter('T')("title.distributionSuccess"), {title: $filter('T')("btnTypeName.prompt")}).then(
            $state.go('dataDistribution',null,{reload:true})
          )
        }
        else {
          $("#tbody").empty();
          vm.distributionFailIdList = data.rows;
        }
      })
    }


    $('.form_date').datetimepicker({
      language: 'vm.lang',
      format: 'yyyy-mm-dd HH:ii:ss',
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 0,
      maxView:'decade',
      forceParse: 0,
      minuteStep: 1
    });

    function compareDate() {
      var start = $('#start').val();
      var end = $('#end').val();
      if (start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if (startTime > endTime) {
          var msg = $filter('T')("main.msg");
          vm.data.endTime = "";
          SweetAlert.error(msg, {title: $filter('T')("btnTypeName.prompt")});
        }

        var max = new Date(endTime - startTime).getMonth();
        if(parseInt(max)>=2){
          var msg = $filter('T')("main.msg");
          vm.data.endTime = "";
          SweetAlert.error($translate.instant('dataDistribution.timeInterval'), {title: $filter('T')("btnTypeName.prompt")});
        }
      }
    }


    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'MASTER.DATA_MOVE_CODE'},function (data) {
        vm.tableType = data.rows;
      },function (error) {
      });
    }

  }
})();


(function () {
    'use strict';

    angular.module('hmapFront')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        $stateProvider
            .state('dataDistribution', {
                parent: 'app',
                url: "/dataDistribution",
                views: {
                    'body': {
                        templateUrl: "app/iot/portal/admin/dataDelivery/html/dataDistribution.html",
                        controller: 'DataDistributionController',
                        controllerAs: 'vm'
                    }
                }
            })
          .state('dataHistory', {
            parent: 'app',
            url: "/dataHistory",
            views: {
              'body': {
                templateUrl: "app/iot/portal/admin/dataDelivery/html/dataDistrbutionHistory.html",
                controller: 'dataHistoryController',
                controllerAs: 'vm'
              }
            }
          })
          .state('dataHistory.successDetail', {
            parent: 'dataHistory',
            url: '/successDetail/:id',
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'app/iot/portal/admin/dataDelivery/html/dataHistoryDetail.html',
                controller: 'dataHistoryDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                  entity: function () {
                    return {
                      id:$stateParams.id,
                      successFlag:true
                    }
                  }
                }
              }).result.then(function () {
                $state.go('dataHistory', null, {reload: true});
              }, function () {
                $state.go('dataHistory')
              })
            }]
          })
        .state('dataHistory.failDetail', {
          parent: 'dataHistory',
          url: '/failedDetail/:id',
          onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/iot/portal/admin/dataDelivery/html/dataHistoryDetail.html',
              controller: 'dataHistoryDetailController',
              controllerAs: 'vm',
              backdrop: 'static',
              size: 'lg',
              resolve: {
                entity: function () {
                  return {
                    id:$stateParams.id,
                    successFlag:false
                  }
                }
              }
            }).result.then(function () {
              $state.go('dataHistory', null, {reload: true});
            }, function () {
              $state.go('dataHistory')
            })
          }]
        })
    }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .factory('DataDistributionService', DataDistributionService);

  DataDistributionService.$inject = ['$http'];

  function DataDistributionService($http) {
    return {
      getDataDistribution: getDataDistribution,
      distributingData: distributingAllData,
      distributeSelectedData : distributingSelectedData,
      getDataDistributionHistory: getDataDistributionHistory,
      getDataDistributionHistorySuccess:getDataDistributionHistorySuccess,
      getDataDistributionHistoryFailed:getDataDistributionHistoryFailed
    };

    function getDataDistribution(entity, page) {
      var resourceUrl = '/api/datasource/queryDataByTableName?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }


    function distributingAllData(entity) {
      var resourceUrl = '/api/datasource/dataDistribute';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }


    function distributingSelectedData(entity) {
      var resourceUrl = '/api/datasource/dataDistributeSelective';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //dataDistributionHistory
    function getDataDistributionHistory(entity, page) {
      var resourceUrl = '/api/datasource/queryDataDistributionHistory?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function getDataDistributionHistorySuccess(entity) {
      var resourceUrl = '/api/datasource/queryDataDistributionHistory/successData?dataFrom='+entity.dataFrom+'&migratoryId='+entity.id;
      return $http.post(resourceUrl,entity,{headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    function getDataDistributionHistoryFailed(entity) {
      var resourceUrl = '/api/datasource/queryDataDistributionHistory/failData?dataFrom='+entity.dataFrom+'&migratoryId='+entity.id;
      return $http.post(resourceUrl,entity,{headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('DataDistributionController', DataDistributionController);

  DataDistributionController.$inject = ['uibPaginationConfig','DataDistributionService', 'paginationConstants', 'SweetAlert', '$filter', '$state', '$translate', 'tableHeaderConstant', 'BaseConfig'];

  function DataDistributionController(uibPaginationConfig,DataDistributionService, paginationConstants, SweetAlert, $filter, $state, $translate, tableHeaderConstant, BaseConfig) {
    var vm = this;
    vm.data = {};
    vm.data.beginTime = '';
    vm.data.endTime = '';

    vm.distParam = {};
    vm.distParam.dataFrom = BaseConfig.env;
    vm.distParam.dataTo = BaseConfig.distEnv;

    vm.datas = {};
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.data.dataFrom = BaseConfig.env;
    vm.data.dataTo = BaseConfig.distEnv;
    vm.tableHeaderConstant = tableHeaderConstant;
    vm.resetCondition = resetCondition;

    vm.pageChanged = pageChanged;
    vm.queryDataDistribution = queryDataDistribution;
    vm.distributionData = distributionData;
    vm.compareDate = compareDate;
    vm.checkData = checkData;
    vm.checkAllData = checkAllData;
    vm.distributeAllData = distributeAllData;
    vm.distributeSelectedData = distributeSelectedData;
    vm.beforeDistributeData = beforeDistributeData;
    vm.initDateShow = initDateShow;
    vm.initDateShow();

    function initDateShow() {
      vm.data.endTime = $filter('date')( new Date() ,'yyyy-MM-dd');
      vm.data.beginTime =$filter('date')( new Date(new Date().getTime()-30*24*3600*1000),'yyyy-MM-dd');
    }

    function beforeDistributeData() {
      SweetAlert.confirm($filter('T')("distribution.distributionInfo"), {title: $filter('T')("btnTypeName.prompt")}).then(function(p){
        vm.distributionData()
      });
    }

    function pageChanged() {
      //vm.queryDataDistribution(vm.page);
    }

    function resetCondition() {
      vm.data.beginTime = '';
      vm.data.endTime = '';
      vm.data.tableCode = '';
      vm.data.dataCode = '';
    }

    function queryDataDistribution() {
      vm.dataGet = [];
      vm.totalItems = 0;
      if (vm.data.beginTime == null || vm.data.beginTime == '') {
        SweetAlert.error($filter('T')("distribution.notBeginTime"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.endTime == null || vm.data.endTime == '') {
        SweetAlert.error($filter('T')("distribution.notEndTime"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.tableCode == null || vm.data.tableCode == '') {
        SweetAlert.error($filter('T')("distribution.notDataType"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.dataTo == null || vm.data.dataTo == '') {
        SweetAlert.error($filter('T')("distribution.notDataTo"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      vm.tableHeader = vm.tableHeaderConstant[vm.data.tableCode];
      vm.data.operationType = "query";
      DataDistributionService.getDataDistribution(vm.data, vm.page).then(function (data) {
        vm.dataGet = $filter('DataUpdateStatus')(data.rows);
        vm.totalItems = data.rows.length;
      })

    }

    function distributionData() {
      if (vm.data.beginTime == null || vm.data.beginTime == '') {
        SweetAlert.error($filter('T')("distribution.notBeginTime"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.endTime == null || vm.data.endTime == '') {
        SweetAlert.error($filter('T')("distribution.notEndTime"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.tableCode == null || vm.data.tableCode == '') {
        SweetAlert.error($filter('T')("distribution.notDataType"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.dataTo == null || vm.data.dataTo == '') {
        SweetAlert.error($filter('T')("distribution.notDataTo"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      if (vm.data.dataFrom != "staging" && vm.data.dataTo == "prod") {
        SweetAlert.error($filter('T')("title.errorDistribution"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      vm.data.operationType = "query";
      vm.distParam.tableName = vm.data.tableCode;
      vm.distParam.tableCode = vm.data.tableCode;
      vm.distParam.beginTime = vm.data.beginTime;
      vm.distParam.endTime = vm.data.endTime;
      var arrChk = angular.element("input[name='chk_list']:checked");//get checked data
      if (arrChk.length === 0) {
        vm.distParam.type = "all";
        vm.distributeAllData(vm.distParam);
      }
      else {
        vm.distParam.type = "checked";
        vm.distributionDataArr = [];
        angular.forEach(arrChk, function (item) {
          var dataTemp = angular.fromJson(item.value);
          if ('doNothing' !== dataTemp.rawStatus) {
            var data = {};
            data.mainId = dataTemp[vm.tableHeader.mainId];//vm.rawData[][vm.tableHeader[vm.tableHeader[0]]];
            data.connectedId = dataTemp[vm.tableHeader.connectedId];
            if(!data.connectedId){
              data.connectedId = '';
            }
            data.status = dataTemp.rawStatus;//[vm.rawData][item.value].status;
            vm.distributionDataArr.push(data);
          }
        });
        if (vm.distributionDataArr.length > 0) {
          vm.distParam.dataDtos = vm.distributionDataArr;
          vm.distributeSelectedData(vm.distParam);
        } else {
          SweetAlert.info($translate.instant('dataDistribution.newest'), {title:'info'});
        }
      }
    }


    $('.form_date').datetimepicker({
      language: 'vm.lang',
      format: 'yyyy-mm-dd',
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      maxView: 'decade',
      forceParse: 0,
      minuteStep: 1
    });

    function compareDate() {
      var start = $('#start').val();
      var end = $('#end').val();
      if (start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if (startTime > endTime) {
          var msg = $filter('T')("main.msg");
          vm.data.endTime = "";
          SweetAlert.error(msg, {title: $filter('T')("btnTypeName.prompt")});
        }

        var max = new Date(endTime - startTime).getMonth();
        if (parseInt(max) >= 2) {
          // var msgTimeInterval = $filter('T')("main.msg");
          vm.data.endTime = "";
          SweetAlert.error($translate.instant('dataDistribution.timeInterval'), {title: $filter('T')("btnTypeName.prompt")});
        }
      }
    }


    //check or unCheck check product
    function checkData() {
      var arrChk = angular.element("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        angular.element("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        angular.element("chk_all").checked = true;
      }
    }

    //check or unCheck all check product
    function checkAllData() {
      var chk_all = angular.element("#chk_all").is(':checked');
      var items = angular.element("input[name='chk_list']");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }


    function distributeAllData(data) {
      DataDistributionService.distributingData(data).then(function (data) {
        if (data.rows.length == 0) {
          SweetAlert.success($filter('T')("title.distributionSuccess"), {title: $filter('T')("btnTypeName.prompt")}).then(
            $state.go('dataDistribution', null, {reload: true})
          )
        }
        else {
          vm.distributionFailIdList = data.rows;
        }
      })
    }


    function distributeSelectedData(data) {
      DataDistributionService.distributeSelectedData(data).then(function (data) {
        if (data.rows.length == 0) {
          SweetAlert.success($filter('T')("title.distributionSuccess"), {title: $filter('T')("btnTypeName.prompt")}).then(
            $state.go('dataDistribution', null, {reload: true})
          )
        }
        else {
          vm.distributionFailIdList = data.rows;
        }
      })
    }

  }
})();


(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('rPartyRelationshipController', rPartyRelationshipController);

  rPartyRelationshipController.$inject = ['SweetAlert', 'rPartyService', 'paginationConstants', 'entity', 'toastr', '$filter', '$state'];

  function rPartyRelationshipController(SweetAlert, rPartyService, paginationConstants, entity, toastr, $filter, $state) {
    var vm = this;
    vm.box = entity;
    vm.device = entity;
    vm.product = entity;
    vm.suber = entity;
    vm.page_box = 1;
    vm.page_device = 1;
    vm.page_suber = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.partyBox = {};

    vm.returnParty = returnParty;
    vm.pageChanged_box = pageChanged_box;
    vm.pageChanged_device = pageChanged_device;
    vm.getBoxByPartyId = getBoxByPartyId;
    vm.getDeviceByPartyId = getDeviceByPartyId;
    vm.getProduct = getProduct;
    vm.getResidentialProduct = getResidentialProduct;
    vm.getSubUserByPartyId = getSubUserByPartyId;
    vm.unbindBox = unbindBox;
    vm.getProduct();
    vm.getBoxByPartyId();
    vm.getDeviceByPartyId();
    vm.getResidentialProduct();
    vm.getSubUserByPartyId();


    function unbindBox(boxId) {
      SweetAlert.confirm($filter('T')("userManage.unbindBoxTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if (p) {
          vm.partyBox.boxId = boxId;
          vm.partyBox.partyId = vm.box.partyId;
          vm.partyBox.badFlag = 'Y';
          rPartyService.unbindBoxById(vm.partyBox).then(function (data) {
            SweetAlert.success($filter('T')("userManage.unbindBoxSuccess")).then(
              function (isConfirm) {
                $state.go('rparty.relationship', {partyId: vm.partyBox.partyId}, {reload: 'rparty.relationship'});
              }
            );
          }).catch(function (error) {
            toastr.warning($filter('T')("userManage.unbindBoxFailed"));
          })
        }
      })
    }

    function getBoxByPartyId() {
      rPartyService.getBoxByPartyId(vm.box, vm.page_box).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.boxes = data.rows;
        vm.totalItems_box = data.total;
      })
    }

    function getDeviceByPartyId() {
      rPartyService.getDeviceByPartyId(vm.device, vm.page_device).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.devices = data.rows;
        vm.totalItems_device = data.total;
      })
    }

    function getProduct() {
      rPartyService.getProduct(vm.product, -1).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.products = data.rows;
        vm.totalItems_product = data.total;
      })
    }

    function getResidentialProduct() {
      rPartyService.getResidentialProduct(vm.product, 1, 50).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.rProducts = data.rows;
        vm.totalItems_product = data.total;
      })
    }


    // 这个是新接口，不支持分页了
    function getSubUserByPartyId(){
      rPartyService.getSubUserByPartyId(vm.device, vm.page_device).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.subers = data.rows;
        vm.totalItems_suber = data.total;
      })
    }


    function pageChanged_box() {
      vm.getBoxByPartyId();
    }

    function pageChanged_device() {
      vm.getDeviceByPartyId();
    }

    function returnParty() {
      window.history.go(-1);
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/06/15 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('rparty', {
        parent: 'app',
        url: "/rparty",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ctm/html/rParty.html",
            controller: 'rPartyController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                };
              }
            }
          }
        }
      })
      .state('rparty.relationship', {
        parent: 'app',
        url: "/rparty/relationship/:partyId",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ctm/html/rPartyRelationship.html",
            controller: 'rPartyRelationshipController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  partyId: $stateParams.partyId
                };
              }
            }
          }
        }
      }
    )
  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('rPartyService', rPartyService);

  rPartyService.$inject = ['$http'];

  function rPartyService($http) {
    return {
      queryParties: queryParties,
      getBoxByPartyId: getBoxByPartyId,
      getDeviceByPartyId: getDeviceByPartyId,
      getProduct: getProduct,
      getResidentialProduct: getResidentialProduct,
      unbindBoxById: unbindBoxById,
      deleteParties: deleteParties,
      getSubUserByPartyId:getSubUserByPartyId
    };

    function getDeviceByPartyId(entity, page) {
      var resourceUrl = '/api/device/queryDeviceByResidential?page=' + page;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function getSubUserByPartyId(entity){
      var resourceUrl = '/api/party/residentialQuerySuber?ownerPartyId=' + entity.partyId;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function unbindBoxById(entity) {
        var resourceUrl='/api/box/updateBoxStatus?schema=res';
        return $http.post(resourceUrl,entity,{
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }
        }).then(function (response) {
            return response.data;
        })
    }

    function getBoxByPartyId(entity, page) {
      var resourceUrl = '/api/box/queryBoxByResidential?page=' + page;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function queryParties(entity, page) {
      var resourceUrl = '/api/party/residentialQuery?page=' + page ;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function getProduct(entity, page) {
      var resourceUrl = '/api/ctm/selectProduct?pageSize=-1';
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    function getResidentialProduct(entity, page,pageSize) {
      var resourceUrl = '/api/ctm/selectResProduct?page=' + page+'&pageSize='+pageSize;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function deleteParties(entity) {
      var resourceUrl = '/api/party/residentialDelete';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('rPartyController', rPartyController);

  rPartyController.$inject = ['$localStorage', 'BaseConfig', 'entity', 'rPartyService','paginationConstants', 'toastr', '$filter', 'toastrConfig', 'SweetAlert'];

  function rPartyController($localStorage, BaseConfig, entity, rPartyService, paginationConstants, toastr, $filter, toastrConfig, SweetAlert) {
    var vm = this;
    vm.party = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.party.partyAccount = '';

    vm.exportExcel = exportExcel;
    vm.pageChanged = pageChanged;
    vm.getResidentialParty = getResidentialParty;
    vm.deleteResidentialParty = deleteResidentialParty;

    vm.getResidentialParty();

    function getResidentialParty() {
      rPartyService.queryParties(vm.party, vm.page).then(function(response){
        vm.parties = response.rows;
        for(var i = 0;i<vm.parties.length; i++){
          if (vm.parties[i].birthDate) {
            vm.parties[i].birthDate = new Date(vm.parties[i].birthDate);
          }
        }
        vm.totalItems =  response.total;
      });
    }

    function deleteResidentialParty(party) {
      SweetAlert.confirm($filter('T')('userManage.inputPartyNumberToDeleteParty'),
        {title: $filter('T')("plugin.deletePrompt"), type: 'input', closeOnConfirm: false}).then(function (p) {
        if (p && p === party.partyNumber) {
          var deleteParty = [{partyId: party.partyId, partyAccount: party.partyAccount}];
          rPartyService.deleteParties(deleteParty).then(function (response) {
            if (response.success) {
              toastr.success($filter('T')('title.deleteSuccess'));
            } else {
              toastr.error($filter('T')('title.deleteFail'));
            }
            getResidentialParty();
            swal.close();
          }, function (response) {
            toastr.error($filter('T')('title.deleteFail'));
            swal.close();
          });
          return true;
        } else if (p !== false) {
          toastr.error($filter('T')('userManage.mismatchPartyNumber'));
        }
      });
    }

    function pageChanged() {
      vm.getResidentialParty();
    }

    function exportExcel() {
      window.location = BaseConfig.url + '/api/public/party/excel/excelExportForResidentialUser?token='
        + $localStorage.authenticationToken.access_token
        + '&partyAccount=' + vm.party.partyAccount;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('PartyRelationshipController', PartyRelationshipController);

  PartyRelationshipController.$inject = ['SweetAlert','toastr','PartyService','paginationConstants', 'entity','DvmDeviceService', '$filter', '$state'];

  function PartyRelationshipController(SweetAlert,toastr,PartyService, paginationConstants, entity, DvmDeviceService, $filter, $state) {
    var vm = this;
    vm.box = entity;
    vm.device = entity;
    vm.page_box = 1;
    vm.page_device = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.partyBox = {};

    vm.returnParty = returnParty;
    vm.pageChanged_box = pageChanged_box;
    vm.pageChanged_device = pageChanged_device;
    vm.getBoxByPartyId = getBoxByPartyId;
    vm.getDeviceByPartyId = getDeviceByPartyId;
    vm.unbindBox = unbindBox;
    vm.getBoxByPartyId();
    vm.getDeviceByPartyId();

    function unbindBox(boxId) {
      SweetAlert.confirm($filter('T')("userManage.unbindBoxTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if (p) {
          vm.partyBox.boxId = boxId;
          vm.partyBox.partyId = vm.box.partyId;
          vm.partyBox.badFlag = 'Y';
          PartyService.unbindBoxById(vm.partyBox).then(function (data) {
            SweetAlert.success($filter('T')("userManage.unbindBoxSuccess")).then(
              function (isConfirm) {
                $state.go('party.relationship', {partyId: vm.partyBox.partyId}, {reload: 'party.relationship'});
              }
            );
          }).catch(function (error) {
            toastr.warning($filter('T')("userManage.unbindBoxFailed"));
          })
        }
      })
    }

    function getBoxByPartyId() {
      PartyService.getBoxByPartyId(vm.box, vm.page_box).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.boxes = data.rows;
        vm.totalItems_box = data.total;
      })
    }

    function getDeviceByPartyId() {
      PartyService.getDeviceByPartyId(vm.device, vm.page_device, 'com').then(function (data) {
        if(!data.rows){
          return;
        }
        vm.devices = data.rows;
        vm.totalItems_device = data.total;
      });

      //get commercial products
      DvmDeviceService.queryCommercialProduct("commercial").then(function (data) {
        if(!data.rows){
          return;
        }
        vm.commercialProducts = data.rows;
      })

    }

    function pageChanged_box() {
      vm.getBoxByPartyId();
    }

    function pageChanged_device() {
      vm.getDeviceByPartyId();
    }

    function returnParty() {
      window.history.go(-1);
    }
  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('party', {
        parent: 'app',
        url: "/party",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ctm/html/party.html",
            controller: 'PartyController',
            controllerAs: 'vm'
          }
        }
      }).state('party.edit', {
      parent: 'app',
      url: "/party/:partyId/edit",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/ctm/html/party-edit.html",
          controller: 'PartyEditController',
          controllerAs: 'vm',
          resolve: {
            entity: function ($stateParams) {
              return {
                partyId: $stateParams.partyId,
                partyType: 'commercial',
                partyAccount: null,
                password: null,
                headPortrait: null,
                partyName: null,
                sex: '1',
                phoneNumber: null,
                emailAddress: null,
                locationAddress: null,
                roleId: null,
                timeZone: 'GMT+0800',
                partyStatus: 'Y',
                groupId: null,
                referenceSource: 'commercial'
              };
            }
          }
        }
      }
    }).state('party.new', {
      parent: 'app',
      url: "/party/new",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/ctm/html/party-new.html",
          controller: 'PartyNewController',
          controllerAs: 'vm',
          resolve: {
            entity: function () {
              return {
                partyId: null,
                partyType: 'commercial',
                partyAccount: null,
                password: null,
                headPortrait: null,
                partyName: null,
                sex: '1',
                phoneNumber: null,
                emailAddress: null,
                locationAddress: null,
                roleId: null,
                timeZone: 'GMT+0800',
                partyStatus: 'Y',
                groupId: null,
                referenceSource: 'commercial'
              };
            }
          }
        }
      }
    }).state('party.relationship', {
      parent: 'app',
      url: "/party/relationship/:partyId",
      views: {
        'body': {
          templateUrl: "app/iot/portal/admin/ctm/html/partyRelationship.html",
          controller: 'PartyRelationshipController',
          controllerAs: 'vm',
          resolve: {
            entity: function ($stateParams) {
              return {
                partyId: $stateParams.partyId
              };
            }
          }
        }
      }
    }).state('party.group', {
      parent: 'party.new',
      url: "/group",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/ogm/html/group-dialog.html',
          controller: 'GroupDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                groupId: $stateParams.groupId
              };
            }
          }
        }).result.then(function () {
          $state.go('party.new');
        }, function () {
          $state.go('party.new');
        });
      }]
    }).state('party.editGroup', {
        parent: 'party.edit',
        url: "/editGroup",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ogm/html/group-dialog.html',
            controller: 'GroupDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  groupId: $stateParams.groupId
                };
              }
            }
          }).result.then(function () {
            $state.go('party.edit');
          }, function () {
            $state.go('party.edit');
          });
        }]
      })
  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('PartyService', PartyService);

  PartyService.$inject = ['$resource', '$http', '$rootScope'];

  function PartyService($resource, $http, $rootScope) {
    var selectedGroup = {};
    var adminPwd = '';

    var service = {
      adminPwd: adminPwd,
      selectedGroup: selectedGroup,
      shareGroup: shareGroup,
      queryParties: queryParties,
      getLookUp: getLookUp,
      queryRoles: queryRoles,
      queryGroup: queryGroup,
      saveParty: saveParty,
      getParty: getParty,
      updateParty: updateParty,
      operateParty: operateParty,
      deleteParty: deleteParty,
      selectLang: selectLang,
      getBoxByPartyId: getBoxByPartyId,
      getDeviceByPartyId: getDeviceByPartyId,
      querySysConfig:querySysConfig,
      unbindBoxById:unbindBoxById
    };
    return service;

    function querySysConfig() {
        return $resource('/api/sysConfig/query', {}, {
            'query': {method: 'GET'}
        });
    }
    function unbindBoxById(entity) {
      var resourceUrl='/api/box/updateBoxStatus?schema=com';
      return $http.post(resourceUrl,entity,{
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }
    function getDeviceByPartyId(entity, page, schema) {
      var resourceUrl = '/api/device/queryDeviceByPartyId?page=' + page + '&schema=' + schema;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function getBoxByPartyId(entity, page) {
      var resourceUrl = '/api/box/queryBoxByPartyId?page=' + page;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function queryParties(data) {
      var resourceUrl = '/api/party/query?page=' + data.page + "&pageSize=" + data.pageSize;
      return $http.post(resourceUrl, {partyName: data.partyName}, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function saveParty(data) {
      var resourceUrl = '/api/party/save';
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function getParty(partyId) {
      var resourceUrl = '/api/party/get';
      return $http.post(resourceUrl, {partyId: partyId}, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function updateParty(party) {
      var resourceUrl = '/api/party/update';
      return $http.post(resourceUrl, party, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        }).then(function(response){
          return response.data;
        })
    }

    function operateParty(party) {
      var resourceUrl = '/api/party/operate';
      return $http.post(resourceUrl, party, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function deleteParty(party) {
      var resourceUrl = '/api/party/delete';
      return $http.post(resourceUrl, party, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        }).then(function(response){
          return response.data;
        })
    }

    function getLookUp(codes){
      var resourceUrl ='/common/code?';
      for (var i in codes) {
        if (codes.hasOwnProperty(i)) {
          switch (i) {
            case "0":
              resourceUrl = resourceUrl + 'var' + i + "=" + codes[i];
              break;
            default:
              resourceUrl = resourceUrl + '&var' + i + '=' + codes[i];
              break;
          }
        }
      }

      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        transformResponse: function(data) {
          // 直接返回原始数据，不做任何转换
          return data;
      }
      }).then(function (response) {
        var result = [];
        if (response.status == "200") {
          var datas = response.data.split(";");
          for (var i in datas) {
            if (datas.hasOwnProperty(i)) {
              var data = $.trim(datas[i]);
              if (data != "") {
                //result[i] = eval('(' + datas[i].split("=")[1] + ')');
                result[i] = JSON.parse(datas[i].split("=")[1]);
              }
            }
          }
        }
        return result;
      });
    }

    function queryRoles(data) {
      var resourceUrl = '/api/sysRole/queryRolesByCondition';
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function queryGroup(data) {
      var resourceUrl = '/api/group/query?schema=' + data.schema;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function shareGroup(selectedGroup){
      this.selectedGroup = selectedGroup;
      $rootScope.$broadcast('handleSelectedGroup');
    }

    //query language value
    function selectLang(){
      var resourceUrl ='/api/prompt/queryLang';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

  }

})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('PartyController', PartyController);

  PartyController.$inject = ['$localStorage', 'BaseConfig', '$filter', '$state', '$scope', 'PartyService', 'paginationConstants', 'toastr', 'toastrConfig', 'PromptService', 'SweetAlert', 'MessageTemplateService'];

  /** @ngInject */
  function PartyController($localStorage, BaseConfig, $filter, $state, $scope, PartyService, paginationConstants, toastr, toastrConfig, PromptService, SweetAlert, MessageTemplateService) {
    var vm = this;
    vm.adminPwd = '';

    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.searchPartyName = '';

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.queryPartiesByCondition = queryPartiesByCondition;
    vm.deleteParty = deleteParty;
    vm.saveAdminPwd = saveAdminPwd;
    vm.initWeidget = initWeidget;
    vm.exportExcel = exportExcel;
    vm.loadAll = loadAll;

    // query condition
    vm.searchPartyName = null;

    vm.parties = {};
    vm.roles = [];
    vm.states = [];
    vm.genders = [];
    vm.referenceSources = [];

    vm.initWeidget();
    vm.loadAll();

    function loadAll(condition) {
      PartyService.queryParties({
        partyName: (condition == undefined) ? null : condition,
        page: vm.page,
        pageSize: paginationConstants.itemsPerPage
      }).then(function (response) {
        vm.parties = response.rows;
        vm.totalItems = response.total;
      }, function () {
        toastr.error($filter('T')("title.loadFailMsg"));
      });
    }

    function deleteParty(party) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"),
        {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if (p) {
          var deleteParty = {partyId: party.partyId, partyAccount: party.partyAccount, adminPwd: vm.adminPwd};
          PartyService.deleteParty(deleteParty).then(function (response) {
            var code = response.code;
            if (!code || code === 'succ') {
              toastr.success($filter('T')('title.deleteSuccess'));
            } else if (response.message === 'permission_denied') {
              toastr.error($filter('T')('prompt.permissionDenied'));
            } else if (response.message === 'password_error') {
              toastr.error($filter('T')('login.invalidPwd'));
            } else if (code === 'canNotDelete') {
              toastr.warning($filter('T')("login.canNotDelete"));
            } else {
              toastr.error($filter('T')('title.deleteFail'));
            }
            loadAll();
          }, function (response) {
            tostarErrorMessage(response.data);
          })
        }
      });
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      loadAll();
    }

    function queryPartiesByCondition() {
      loadAll(vm.searchPartyName == null || vm.searchPartyName == "" ? null : vm.searchPartyName);
    }

    function initWeidget() {
      // timezones and gender
      PartyService.getLookUp(['SYS.TIME_ZONE', 'SYS.GENDER', 'SYS.PROCESSING_STATUS', 'SYS.REFERENCE_SOURCE'])
      .then(function (data) {
        vm.timezones = data[0];
        vm.genders = data[1];
        vm.referenceSources = data[3];
      });

      MessageTemplateService.getByCode().query({code: 'SYS.PROCESSING_STATUS'}, function (data) {
        vm.states = data.rows;
      }, function (error) {
      });

      // locales
      PromptService.selectLangNoToken().query(function (result) {
        vm.locales = result.rows;
      });

      // roles
      PartyService.queryRoles({condition1: 'commercial'})
      .then(function (response) {
        vm.roles = response.rows;
      })
    }

    function exportExcel() {
      window.location = BaseConfig.url + '/api/public/party/excel/excelExportForCommercialUser?token=' + $localStorage.authenticationToken.access_token
        + '&partyAccount=' + vm.searchPartyName;
    }

    function saveAdminPwd() {
      PartyService.adminPwd = vm.adminPwd;
      angular.element('#adminPwd').attr('style', 'border-color: #e7eaec');
    }

    (function (ele, vm) {
      if (angular.isDefined(PartyService.adminPwd) && PartyService.adminPwd !== '') {
        vm.adminPwd = PartyService.adminPwd;
        angular.element('#adminPwd').attr('style', 'border-color: #e7eaec');
      }
      ele.bind('blur', vm.saveAdminPwd);
    })(angular.element('#adminPwd'), vm);

    function tostarErrorMessage(res) {
      if (res.message === 'permission_denied') {
        toastr.error($filter('T')('prompt.permissionDenied'));
      } else if (res.message === 'password_error') {
        toastr.error($filter('T')('login.invalidPwd'));
      } else if (res.message === 'canNotDelete') {
        toastr.warning($filter('T')("login.canNotDelete"));
      } else {
        toastr.error($filter('T')('title.deleteFail'));
      }
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by mclin on 2017-4-28.
 */
(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('PartyNewController', PartyNewController);

  PartyNewController.$inject = ['SweetAlert', '$filter', '$scope', '$state', 'entity', 'toastr', 'PartyService', 'PromptService', 'toastrConfig', 'MessageTemplateService'];

  function PartyNewController(SweetAlert, $filter, $scope, $state, entity, toastr, PartyService, PromptService, toastrConfig, MessageTemplateService) {

    var vm = this;

    vm.party = entity;

    vm.clear = clear;
    vm.save = save;
    vm.partyTypeChange = partyTypeChange;
    vm.showGroupNameModel = showGroupNameModel;
    vm.groupNameSure = groupNameSure;
    vm.initLanguages = initLanguages;
    vm.getSuffix = getSuffix;
    vm.showOrHidePwd = showOrHidePwd;

    // select
    vm.initWeidget = initWeidget;
    vm.timezones = [];
    vm.locales = [];
    vm.roles = [];
    vm.genders = [];
    vm.states = [];
    vm.referenceSources = [];
    vm.suffix = '';
    vm.showPwdEnabled = true;
    vm.validatePwd = validatePwd;

    vm.initWeidget();
    vm.initLanguages();
    vm.getSuffix();

    function validatePwd() {
      var passwordEncrypted = $("#passwordInit").val();
      var passwordConfirm = $("#passwordConfirm").val();
      if (passwordEncrypted != passwordConfirm) {
        SweetAlert.error($filter('T')("title.pwdNotSame"), {title: $filter('T')("btnTypeName.prompt")});
        $("#passwordConfirm").val("");
        vm.party.passwordConfirm = "";
      }
    }

    function getSuffix() {
      PartyService.querySysConfig().query({configKey: 'aad.commercial.username.suffix'}, onSuccess, onError);

      function onSuccess(data) {
        vm.suffix = '@' + data.rows[0].configValue;
      }

      function onError() {

      }
    }

    function clear() {
      $state.go('party');
    }

    //get languages
    function initLanguages() {
      PartyService.selectLang().query(function (data) {
        vm.langs = data.rows;
        $("#groupNameBtn").attr("disabled", false);
      });
    }

    function save() {
      if ((vm.party.phoneNumber || '').trim() && (!(/^[0-9]+$/.test(vm.party.phoneNumber)))) {
        toastr.warning($filter('T')('userManage.validPhone'));
        vm.party.partyAccount = undefined;
        return;
      }

      var mailNickName = vm.party.mailNickname;
      if (mailNickName.indexOf("@") >= 0) {
        toastr.warning($filter('T')('userManage.mailNicknameValid'));
        vm.party.partyAccount = undefined;
        return;
      }
      if ((vm.party.password || '').trim() && vm.party.password === vm.party.passwordConfirm) {
        vm.party.password = $.trim(vm.party.password);
        vm.party.partyAccount = vm.party.partyAccount + vm.suffix;
        vm.party.adminPwd = PartyService.adminPwd;
        PartyService.saveParty(vm.party).then(function (response) {
          saveUserResponse(response, 'party');
          vm.party.partyAccount = undefined;
        }, function () {
          toastr.error($filter('T')('title.saveFail'));
          vm.party.partyAccount = undefined;
        });
      } else {
        toastr.error($filter('T')('title.pwdNotSame'));
      }
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code: 'SYS.PROCESSING_STATUS'}, function (data) {
        vm.states = data.rows;
      }, function (error) {
      });
      // timezones and gender
      PartyService.getLookUp(['SYS.TIME_ZONE', 'SYS.GENDER', 'SYS.REFERENCE_SOURCE'])
      .then(function (data) {
        vm.timezones = data[0];
        vm.genders = data[1];
        vm.referenceSources = data[3];
      });
      // locales
      PromptService.selectLangNoToken().query(function (result) {
        vm.locales = result.rows;
      });
      // roles
      PartyService.queryRoles({condition1: 'commercial'})
      .then(function (response) {
        vm.roles = response.rows;
      });
      PartyService.queryGroup({parentGroupId: -1, referenceSource: 'commercial', schema: 'com'})
      .then(function (response) {
        vm.groups = response.rows;
      })
    }

    function partyTypeChange() {
      vm.party.partyType = vm.party.referenceSource;
    }

    $scope.$on('handleSelectedGroup', function () {
      vm.party.groupId = PartyService.selectedGroup.groupId
      vm.party.groupName = PartyService.selectedGroup.groupName
    });

    //show model
    function showGroupNameModel() {
      $("#groupNameModal").modal("show");
      var groupNameModalBody = $("#groupNameModalBody");
      if ($.trim(groupNameModalBody.html()) == "") {
        for (var i in vm.langs) {
          if (vm.langs.hasOwnProperty(i)) {
            var div = $("<div class='form-group'></div>");
            div.append("<label class='control-label'>" + vm.langs[i].description + "</label>");
            div.append("<input type='text' class='form-control' name='" + vm.langs[i].langCode
              + "' ng-model='vm.party.__tls.groupName.'" + vm.langs[i].langCode + "'/>");
            groupNameModalBody.append(div);
          }
        }
      }
    }

    //submit groupName
    function groupNameSure() {
      var __tls = vm.party.__tls || {};
      var groupName = {};
      for (var i in vm.langs) {
        groupName[vm.langs[i].langCode] = $("input[name='" + vm.langs[i].langCode + "']").val();
      }
      var btnValue = 'groupName';
      vm.party[btnValue] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#groupNameModal").modal("hide");
      __tls[btnValue] = groupName;
      vm.party.__tls = __tls;
    }

    function saveUserResponse(response, toState) {
      var code = response.code;
      if (!code || code === 'succ') {
        toastr.success($filter('T')('title.saveSuccess'));
        $state.go(toState);
      } else if (code === 'userNameFormateError') {
        toastr.warning($filter('T')('userManage.validLoginName'));
      } else if (code === 'regexFail') {
        toastr.warning($filter('T')('userManage.passwordRegEx'));
      } else if (code === 'repeat') {
        toastr.warning($filter('T')('userManage.sameUsername'));
      } else {
        if (response.message === 'permission_denied') {
          toastr.error($filter('T')('prompt.permissionDenied'));
        } else if (response.message === 'password_error') {
          toastr.error($filter('T')('userManage.invalidAdminPwd'));
        } else {
          toastr.error($filter('T')('title.saveFail'));
        }
      }
    }

    function showOrHidePwd() {
      var pwdInput = angular.element('#passwordInit');
      var pwdInputConfirm = angular.element('#passwordConfirm');
      if (vm.showPwdEnabled) {
        pwdInput.prop('type', 'text');
        pwdInputConfirm.prop('type', 'text');
        vm.showPwdEnabled = false;
      } else {
        pwdInput.prop('type', 'password');
        pwdInputConfirm.prop('type', 'password');
        vm.showPwdEnabled = true;
      }
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Created by mclin on 2017-4-28.
 */
(function () {
  'use strict';

  angular.module('hmapFront').controller('PartyEditController', PartyEditController);

  PartyEditController.$inject = ['$filter', '$scope', '$state', 'entity', 'toastr', 'toastrConfig', 'SweetAlert', 'PartyService', 'PromptService', 'MessageTemplateService'];

  function PartyEditController($filter, $scope, $state, entity, toastr, toastrConfig, SweetAlert, PartyService, PromptService, MessageTemplateService) {

    var vm = this;

    vm.party = entity;

    vm.clear = clear;
    vm.save = save;
    vm.initData = initData;
    vm.partyTypeChange = partyTypeChange;
    vm.showOrHidePwd = showOrHidePwd;
    vm.operate = operate;

    // select
    vm.initWeidget = initWeidget;
    vm.timezones = [];
    vm.locales = [];
    vm.roles = [];
    vm.genders = [];
    vm.states = [];
    vm.referenceSources = [];
    vm.showPwdEnabled = true;

    vm.operationList = [
      {value: 'assign_user_admin', meaning: $filter('T')('userManage.assignUserAdmin')},
      {value: 'unassign_user_admin', meaning: $filter('T')('userManage.unassignUserAdmin')},
      {value: 'assign_pwd_admin', meaning: $filter('T')('userManage.assignPwdAdmin')},
      {value: 'unassign_pwd_admin', meaning: $filter('T')('userManage.unassignPwdAdmin')}
    ];

    vm.initWeidget();
    vm.initData();

    vm.validatePwd = validatePwd;

    function validatePwd() {
      var passwordEncrypted = $("#passwordInit").val();
      var passwordConfirm = $("#passwordConfirm").val();
      if (passwordEncrypted !== passwordConfirm) {
        SweetAlert.error($filter('T')("title.pwdNotSame"), {title: $filter('T')("btnTypeName.prompt")});
        $("#passwordConfirm").val("");
        vm.party.passwordConfirm = "";
      }
    }

    function initData() {
      PartyService.getParty(vm.party.partyId).then(function (response) {
        if (response.rows.length > 0) {
          vm.party = response.rows[0];
          // clear password info
          vm.party.password = null;
          vm.party.passwordConfirm = null;
        }
      }, function () {
        toastr.error($filter('T')('title.loadFailMsg'));
      })
    }

    function clear() {
      $state.go('party');
    }

    function save() {
      if ((vm.party.phoneNumber || '').trim() && (!(/^1[3|4|5|8][0-9]\d{4,8}$/.test(vm.party.phoneNumber)))) {
        toastr.warning($filter('T')('userManage.validPhone'));
        return;
      }
      if ((vm.party.password == null || $.trim(vm.party.password) === '') &&
        (vm.party.passwordConfirm == null || $.trim(vm.party.passwordConfirm) === '')) {
        vm.party.password = $.trim(vm.party.password);
        SweetAlert.confirm($filter('T')('title.pwdModifyTip'), {title: $filter('T')('title.confirmTitle')})
        .then(function (p) {
          if (p) {
            vm.party.adminPwd = PartyService.adminPwd;
            PartyService.updateParty(vm.party).then(function (response) {
              saveUserResponse(response, 'party');
            });
          }
        })
      } else {
        if (vm.party.password === vm.party.passwordConfirm) {
          vm.party.password = $.trim(vm.party.password);
          vm.party.adminPwd = PartyService.adminPwd;
          PartyService.updateParty(vm.party).then(function (response) {
            saveUserResponse(response, 'party');
          });
        } else {
          toastr.error($filter('T')('title.pwdNotSame'));
        }
      }
    }

    function initWeidget() {

      MessageTemplateService.getByCode().query({code: 'SYS.PROCESSING_STATUS'}, function (data) {
        vm.states = data.rows;
      }, function (error) {
      });
      // timezones and gender
      PartyService.getLookUp(['SYS.TIME_ZONE', 'SYS.GENDER','SYS.REFERENCE_SOURCE'])
      .then(function (data) {
        vm.timezones = data[0];
        vm.genders = data[1];
        vm.referenceSources = data[3];
      });
      // locales
      PromptService.selectLangNoToken().query(function (result) {
        vm.locales = result.rows;
      });
      // roles
      PartyService.queryRoles({condition1: 'commercial'})
      .then(function (response) {
        vm.roles = response.rows;
      })

    }

    function saveUserResponse(response, toState) {
      var code = response.code;
      if (!code || code === 'succ') {
        toastr.success($filter('T')('title.saveSuccess'));
        $state.go(toState);
      } else if (code === 'userNameFormateError') {
        toastr.warning($filter('T')('userManage.validLoginName'));
      } else if (code === 'regexFail') {
        toastr.warning($filter('T')('userManage.passwordRegEx'));
      } else if (code === 'repeat') {
        toastr.warning($filter('T')('userManage.sameUsername'));
      } else {
        if (response.message === 'permission_denied') {
          toastr.error($filter('T')('prompt.permissionDenied'));
        } else if (response.message === 'password_error') {
          toastr.error($filter('T')('userManage.invalidAdminPwd'));
        } else {
          toastr.error($filter('T')('title.saveFail'));
        }
      }
    }

    function partyTypeChange() {
      vm.party.partyType = vm.party.referenceSource;
    }

    $scope.$on('handleSelectedGroup', function () {
      vm.party.groupId = PartyService.selectedGroup.groupId
      vm.party.groupName = PartyService.selectedGroup.groupName
    });

    function showOrHidePwd() {
      var pwdInput = angular.element('#passwordInit');
      var pwdInputConfirm = angular.element('#passwordConfirm');
      if (vm.showPwdEnabled) {
        pwdInput.prop('type', 'text');
        pwdInputConfirm.prop('type', 'text');
        vm.showPwdEnabled = false;
      } else {
        pwdInput.prop('type', 'password');
        pwdInputConfirm.prop('type', 'password');
        vm.showPwdEnabled = true;
      }
    }

    function operate() {
      var requestBody = {
        partyId: vm.party.partyId,
        operation: vm.party.operation,
        adminPwd: PartyService.adminPwd
      };
      PartyService.operateParty(requestBody).then(function (response) {
        var code = response.code;
        if (!code || code === 'succ') {
          toastr.success($filter('T')('title.operationSuccess'));
        } else {
          if (response.message === 'permission_denied') {
            toastr.error($filter('T')('prompt.permissionDenied'));
          } else if (response.message === 'password_error') {
            toastr.error($filter('T')('userManage.invalidAdminPwd'));
          } else if (response.message === 'directory_role_assigned') {
            toastr.success($filter('T')('userManage.roleAssigned'));
          } else if (response.message === 'directory_role_unassigned') {
            toastr.success($filter('T')('userManage.roleUnassigned'));
          } else {
            toastr.error($filter('T')('title.operationFailed'));
          }
        }
      }, function () {
        toastr.error($filter('T')('title.operationFailed'));
      })
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });

  }
})();

/**
 * Created by xiawang.liu on 2017/06/15 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('gparty', {
        parent: 'app',
        url: "/gparty",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ctm/html/gParty.html",
            controller: 'gPartyController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                };
              }
            }
          }
        }
      })
   
    
  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('gPartyService', gPartyService);

  gPartyService.$inject = ['$http'];

  function gPartyService($http) {
    return {
      queryParties: queryParties,
      getBoxByPartyId: getBoxByPartyId,
      getDeviceByPartyId: getDeviceByPartyId,
      getProduct: getProduct,
      getResidentialProduct: getResidentialProduct,
      unbindBoxById: unbindBoxById,
      deleteParties: deleteParties,
      queryProductCodeList: queryProductCodeList,
      renewal:renewal,
      cancel:cancel,
      selectCode:selectCode,
      selsectByCode:selsectByCode,
      tijiao:tijiao,
      queryStatus:queryStatus
    };

    function getDeviceByPartyId(entity, page) {
      var resourceUrl = '/api/device/queryDeviceByResidential?page=' + page;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function unbindBoxById(entity) {
        var resourceUrl='/api/box/updateBoxStatus?schema=res';
        return $http.post(resourceUrl,entity,{
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }
        }).then(function (response) {
            return response.data;
        })
    }

    function getBoxByPartyId(entity, page) {
      var resourceUrl = '/api/box/queryBoxByResidential?page=' + page;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function queryParties(entity, page) {
      var resourceUrl = '/api/project/queryProjectUserList?page=' + page ;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }
    
    function selectCode(supplierCode,supplierName) {
      var resourceUrl = '/api/project/selectCode?supplierCode=' + supplierCode +"&supplierName="+supplierName;
      return $http.post(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function tijiao(supplierCode,supplierName,supplierNumber) {
      var resourceUrl = '/api/project/projectRegister?supplierCode='+supplierCode
      +"&supplierName="+supplierName+"&supplierNumber="+supplierNumber;
      return $http.post(resourceUrl, supplierCode,supplierName,supplierNumber, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function renewal(entity) {
      var resourceUrl = '/api/project/updateProjectEntity?' ;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }


    function cancel(entity) {
      var resourceUrl = '/api/project/delete?' ;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }


    function selsectByCode(entity) {
      var resourceUrl = '/api/project/selsectByCode?supplierCode='+entity;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

    function queryProductCodeList() {
      var url = '/api/project/selectAll';
      return $http.post(url, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data
      })
    }

    
    function queryStatus(supplierNumber) {
      var url = '/api/project/queryStatus?supplierNumber='+supplierNumber;
      return $http.post(url, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data
      })
    }
    

    function getProduct(entity, page) {
      var resourceUrl = '/api/ctm/selectProduct?pageSize=-1';
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    function getResidentialProduct(entity, page,pageSize) {
      var resourceUrl = '/api/ctm/selectResProduct?page=' + page+'&pageSize='+pageSize;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function deleteParties(entity) {
      var resourceUrl = '/api/party/residentialDelete';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

  

  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('gPartyController', gPartyController);

  gPartyController.$inject = ['$localStorage', 'BaseConfig', 'entity', 'gPartyService','paginationConstants', 'toastr', '$filter', 'toastrConfig', 'SweetAlert'];

  function gPartyController($localStorage, BaseConfig, entity, gPartyService, paginationConstants, toastr, $filter, toastrConfig, SweetAlert) {
    var vm = this;
    vm.party = {
      "partyAccount":'',
      "attribute1":'',
      "supplier":{
        "supplierCode":''
      }

    };
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.party.partyAccount = '';
    vm.exportExcel2 = exportExcel2;
    vm.pageChanged = pageChanged;
    vm.getResidentialParty = getResidentialParty;
    vm.deleteResidentialParty = deleteResidentialParty;
    vm.tijiao=tijiao;
    vm.update=update;
    vm.loading= false;
    vm.appear3=false;
    vm.appear4=true;
    vm.appear5=false;
    vm.appear6=false;
    vm.renewal=renewal;
    vm.cancel =cancel ;
    vm.selectCode=selectCode;
    vm.aa=aa;
    vm.Code='';
    vm.Code1=null;
    vm.selsectByCode=selsectByCode;
    vm.educe=educe;
    vm.bb=bb;
    vm.queryProductCodeList=queryProductCodeList;
    vm.queryStatus=queryStatus;
    vm.cc=cc;



    vm.getResidentialParty();
    vm.datas={
      "objectId":'',
      "partyAccount":'',
      "password":null,
      "status":''
    };
    vm.trigger=false;
    vm.appear=false;
    vm.appear1=false;
    vm.appear2=false;
    vm.productCodeList=[];
    vm.dto={
      "supplierCode":'',
      "supplierName":'',
      "supplierNumber":1
    };
     vm.yz=0;
    function getResidentialParty() {

      vm.loading =true;
      vm.datas={
        "objectId":'',
        "partyAccount":'',
        "password":null,
        "status":''
      };
      vm.party.attribute1=vm.Code1;

      gPartyService.queryParties(vm.party, vm.page).then(function(response){
        vm.parties = response.rows;
        if(vm.parties!=null){
        for(var i = 0;i<vm.parties.length; i++){
          if (vm.parties[i].birthDate) {
            vm.parties[i].birthDate = new Date(vm.parties[i].birthDate);
          }
        }
      }
      if(vm.parties==null ||   vm.parties==''){
        vm.appear3=true;
      }


        vm.totalItems =  response.total;
        vm.loading =false;
      });

    }

    function deleteResidentialParty(party) {
      SweetAlert.confirm($filter('T')('userManage.inputPartyNumberToDeleteParty'),
        {title: $filter('T')("plugin.deletePrompt"), type: 'input', closeOnConfirm: false}).then(function (p) {
        if (p && p === party.partyNumber) {
          var deleteParty = [{partyId: party.partyId, partyAccount: party.partyAccount}];
          gPartyService.deleteParties(deleteParty).then(function (response) {
            if (response.success) {
              toastr.success($filter('T')('title.deleteSuccess'));
            } else {
              toastr.error($filter('T')('title.deleteFail'));
            }
            getResidentialParty();
            swal.close();
          }, function (response) {
            toastr.error($filter('T')('title.deleteFail'));
            swal.close();
          });
          return true;
        } else if (p !== false) {
          toastr.error($filter('T')('userManage.mismatchPartyNumber'));
        }
      });
    }

    function pageChanged() {

      vm.getResidentialParty();

    }

    function exportExcel2() {
      window.location = BaseConfig.url + '/api/public/party/excel/excelExportForProjectUser?token='
        + $localStorage.authenticationToken.access_token
        + '&partyAccount=' + vm.party.partyAccount;
    }

    function selectCode(){
      vm.yz=1;
        var rex=/^[0-9a-zA-Z_]*$/;
        var txt= /([\*\"\'<>\/])+/
    gPartyService.selectCode( vm.dto.supplierCode,vm.dto.supplierName).then(function (data) {
        if(!rex.test(vm.dto.supplierCode)){
          vm.appear1=true;
         }else if(txt.test(vm.dto.supplierName)){
          vm.appear1=true;
         }else if(vm.dto.supplierNumber<=0 || vm.dto.supplierNumber>2000){
          vm.appear1=true;
         }else if("203"==data.code){
            vm.trigger=true;
         } else{ vm.tijiao();}
    });
  }


    function aa() {
      vm.trigger=false;
      vm.appear=false;
      vm.appear1=false;
      vm.appear3=false;
      vm.appear2=false;
    }

    function bb() {
    vm.dto={
      "supplierCode":'',
      "supplierName":'',
      "supplierNumber":1
    };
  }

  function cc() {

    vm.appear6=false;
  }

    function tijiao() {
      if(vm.dto.supplierCode!=null && vm.dto.supplierCode!='' && vm.yz==1){
      vm.trigger=false;
      gPartyService.tijiao(vm.dto.supplierCode, vm.dto.supplierName,vm.dto.supplierNumber).then(function(response){

    });
    vm.appear4=false;
    vm.appear5=true;
    vm.appear6=true;
    vm.yz=0;
  }
  }





    function educe() {
      window.location = BaseConfig.url + '/r/api/register/selsectparticulars?token='
      + $localStorage.authenticationToken.access_token;
    }


    function renewal() {
      var password = vm.datas.password;
      var regex = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{14,25}$/;
      var regex2 = /^[0-9a-zA-Z]{14,25}$/;

      if (!regex.test(password)) {
        return toastr.error('密码最少14位,必须包含大小写字母和数字');
      }else if (!regex2.test(password)) {
        return toastr.error('密码不能包含特殊字符');
      }
      document.getElementById('lights').style.display='none';
      document.getElementById('fade').style.display = 'none';
      gPartyService.renewal(vm.datas).then(function(response){


      });

        vm.getResidentialParty();



    }

    function cancel() {
      gPartyService.cancel(vm.datas).then(function(response){
        if("204"==response.code){
          vm.appear=true;
     }

      });

        vm.getResidentialParty();

    }


    function queryStatus() {
      gPartyService.queryStatus(vm.dto.supplierNumber).then(function(response){
       if(false==response.success){
        vm.appear2=true;
       }else{

        window.location = BaseConfig.url + '/r/api/register/exportAccount?token='
        + $localStorage.authenticationToken.access_token;
        vm.appear5=false;
       vm.appear4=true;
        vm.dto={
          "supplierCode":'',
          "supplierName":'',
          "supplierNumber":1
        };
        vm.getResidentialParty();
        vm.queryProductCodeList();

       }
      });
    }



    function update(party) {
       vm.datas.objectId=party.objectId;
       vm.datas.partyAccount=party.partyAccount;
       vm.datas.status=party.attribute2;



    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });

   function queryProductCodeList(){
    gPartyService.queryProductCodeList().then(function (data) {
      vm.party.attribute1=null;
      vm.productCodeList = data.rows;

    });
  }

  gPartyService.queryProductCodeList().then(function (data) {
    vm.party.attribute1=null;
    vm.productCodeList = data.rows;

  });


    function selsectByCode() {
    if(vm.Code==null || vm.Code==''){
        vm.getResidentialParty();
    }else{
      gPartyService.selsectByCode(vm.Code).then(function(response){

        vm.party.attribute1=response.rows[0].supplierId;

        vm.loading =true;
        vm.datas={
          "objectId":'',
          "partyAccount":'',
          "password":null,
          "status":''
        };

        gPartyService.queryParties(vm.party, vm.page).then(function(response){
          vm.parties = response.rows;
          for(var i = 0;i<vm.parties.length; i++){
            if (vm.parties[i].birthDate) {
              vm.parties[i].birthDate = new Date(vm.parties[i].birthDate);
            }
          }
          vm.totalItems =  response.total;
          vm.loading =false;
        });



      });

    }
  }

  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').config(tenantConfig);

  function tenantConfig($stateProvider) {
    $stateProvider.state('tenant', {
      parent: 'app',
      url: '/tenant',
      views: {
        'body': {
          templateUrl: 'app/iot/portal/admin/b2c/html/tenant.html',
          controller: 'TenantController',
          controllerAs: 'vm'
        }
      }
    })
    .state('tenant.add', {
      parent: 'tenant',
      url: '/add',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/b2c/html/tenant-dialog.html',
          controller: 'TenantDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve:{
            entity: function($stateParams) {
              return {
              }
            }
          }
        }).result.then(function () {
          $state.go('tenant', null, {reload: 'tenant'});
        }, function () {
          $state.go('tenant', null, {reload: 'tenant'});
        })
      }]
    })
    .state('tenant.edit', {
      parent: 'tenant',
      url: '/edit/:tenantId',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/b2c/html/tenant-dialog.html',
          controller: 'TenantDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve:{
            entity: function() {
              return {
                tenantId: $stateParams.tenantId
              }
            }
          }
        }).result.then(function () {
          $state.go('tenant', null, {reload: 'tenant'});
        }, function () {
          $state.go('tenant', null, {reload: 'tenant'});
        })
      }]
    })
  }

})();

(function () {
  'use strict';
  angular.module('hmapFront')
  .factory('TenantService', TenantService);

  TenantService.$inject = ['$http'];

  function TenantService($http) {
    var prefix = '/api/admin/ctm/tenant';
    return {
      query: query,
      submit: submit,
      remove: remove
    };

    function query(app, page, pageSize) {
      var resourceUrl = prefix + '/query?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function submit(app) {
      var resourceUrl = prefix + '/submit';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function remove(app) {
      var resourceUrl = prefix + '/remove';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }
  }
})();

(function () {
  'use strict';
  angular.module('hmapFront')
  .controller('TenantController', TenantController);

  TenantController.$inject = ['$filter', '$rootScope', 'TenantService', '$state', 'paginationConstants', 'SweetAlert','KeyService'];

  function TenantController($filter, $rootScope, TenantService, $state, paginationConstants, SweetAlert,KeyService) {
    var vm = this;
    vm.tenants = {};
    vm.page = 1;
    vm.totalItems = null;

    vm.itemsPerPage = paginationConstants.itemsPerPage;
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    vm.load = load;
    vm.deleteTenant = deleteTenant;
    //vm.deleteAllTenant = deleteAllTenant;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;

    load(vm.tenants,page,pagesize);

    function load(tenant,page,pagesize) {
      // getKeys();
      getTenant();
      return TenantService.query(tenant,page,pagesize)
        .then(function (data) {
          if (data.success){
            vm.tenants = data.rows;
            vm.totalItems = data.total;
          }
        })
    }

    function deleteTenant(tenant) {
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          var tenants = [];
          tenants.push(tenant);
          return TenantService.remove(tenants)
            .then(function (data) {
              var flag = data.success;
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
                vm.search();
              }
            })
        }
      });

    }

    function getTenant() {
      TenantService.query({}, 1, -1).then(function (data) {
        vm.results = data.rows;
      })
    }

   /* function getKeys() {
      KeyService.query({},-1,0)
        .then(function (data) {
          vm.keys = data.rows;
        })
    }*/

    function search() {
      load(vm.tenant,page,pagesize);
    }

    function reset() {
      vm.tenant.tenantId = undefined;
      vm.tenant.version = undefined;
    }

    function pageChanged() {
      load(vm.tenant, vm.page, paginationConstants.itemsPerPage);
    }

  }
})();

(function () {
  'use strict';
  angular.module('hmapFront').controller('TenantDialogController', TenantDialogController);

  TenantDialogController.$inject = ['entity', 'SweetAlert', '$filter', '$state', 'KeyService', '$uibModalInstance',
    'TenantService', 'toastr'];

  function TenantDialogController(entity, SweetAlert, $filter, $state, KeyService, $uibModalInstance, TenantService, toastr) {
    var vm = this;

    vm.tenant = entity;

    vm.edit = false;

    vm.clear = clear;
    vm.save = save;
    vm.judgeEdit = judgeEdit;
    vm.load = load;
    vm.getKeys = getKeys;


    judgeEdit();

    vm.load();

    function load() {
      vm.title = 'tenant.addTenant';
      if (vm.edit) {
        vm.title = 'tenant.editTenant';
        getKeys();
        return TenantService.query(vm.tenant,-1,0)
          .then(function (data) {
            if (data.success) {
              vm.tenant = data.rows[0];
            }
          });
      }else{
        vm.keyShow = true;
      }
    }

    function judgeEdit() {
      if (entity.hasOwnProperty('tenantId')) {
        vm.edit = true;
      }
    }

    function save() {
      if (vm.tenant.keySize && (!(/^[1-9]\d*$/.test(vm.tenant.keySize)))) {
        toastr.warning($filter('T')('key.validKeySize'));
        return;
      }
      var tenants = [];
      tenants.push(vm.tenant);
      return TenantService.submit(tenants)
        .then(function (data) {
          if (data.success) {
            SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
              .then(function () {
                $uibModalInstance.close();
                $state.go('tenant');
              })
          }else {
            SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
          }
        })
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function getKeys() {
      KeyService.query(vm.tenant, 1, -1)
        .then(function (data) {
          if (data.success){
            vm.keys = data.rows;
          }
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').config(tenantConfig);

  function tenantConfig($stateProvider) {
    $stateProvider.state('partyGroup', {
      parent: 'app',
      url: '/partyGroup',
      views: {
        'body': {
          templateUrl: 'app/iot/portal/admin/b2c/html/partyGroup.html',
          controller: 'PartyGroupController',
          controllerAs: 'vm'
        }
      }
    })
    .state('partyGroup.add', {
      parent: 'partyGroup',
      url: '/add',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/b2c/html/partyGroup-dialog.html',
          controller: 'PartyGroupDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve:{
            entity: function($stateParams) {
              return {
              }
            }
          }
        }).result.then(function () {
          $state.go('partyGroup', null, {reload: 'partyGroup'});
        }, function () {
          $state.go('partyGroup', null, {reload: 'partyGroup'});
        })
      }]
    })
    .state('partyGroup.edit', {
      parent: 'partyGroup',
      url: '/edit/:groupId',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/b2c/html/partyGroup-dialog.html',
          controller: 'PartyGroupDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve:{
            entity: function() {
              return {
                groupId: $stateParams.groupId
              }
            }
          }
        }).result.then(function () {
          $state.go('partyGroup', null, {reload: 'partyGroup'});
        }, function () {
          $state.go('partyGroup', null, {reload: 'partyGroup'});
        })
      }]
    })
  }
})();

(function () {
  'use strict';
  angular.module('hmapFront')
  .factory('PartyGroupService', PartyGroupService);

  PartyGroupService.$inject = ['$http'];

  function PartyGroupService($http) {
    var prefix = '/api/admin/ctm/party/group';
    return {
      query: query,
      submit: submit,
      remove: remove
    };

    function query(app, page, pageSize) {
      var resourceUrl = prefix + '/query?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function submit(app) {
      var resourceUrl = prefix + '/submit';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function remove(app) {
      var resourceUrl = prefix + '/remove';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }
  }
})();

(function () {
  'use strict';
  angular.module('hmapFront')
  .controller('PartyGroupController', PartyGroupController);

  PartyGroupController.$inject = ['$filter', '$rootScope', 'PartyGroupService', '$state', 'paginationConstants', 'SweetAlert','TenantService'];

  function PartyGroupController($filter, $rootScope, PartyGroupService, $state, paginationConstants, SweetAlert,TenantService) {
    var vm = this;
    vm.groups = {};
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    vm.load = load;
    vm.deleteGroup = deleteGroup;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;

    load(vm.groups,page,pagesize);

    function load(group,page,pagesize) {
      // getKeys();
      getTenant();
      return PartyGroupService.query(group,page,pagesize)
        .then(function (data) {
          if (data.success){
            vm.groups = data.rows;
            vm.totalItems = data.total;
          }
        })
    }

    function deleteGroup(group) {
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          var groups = [];
          groups.push(group);
          return PartyGroupService.remove(groups)
            .then(function (data) {
              var flag = data.success;
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
                vm.search();
              }
            })
        }
      });

    }

    function getTenant() {
      TenantService.query({}, 1, -1).then(function (data) {
        vm.results = data.rows;
      })
    }

    function search() {
      load(vm.group,page,pagesize);
    }

    function reset() {
      vm.group.groupName = undefined;
      vm.group.tenantId = undefined;
    }

    function pageChanged() {
      load(vm.group, vm.page, paginationConstants.itemsPerPage);
    }
  }
})();

(function () {
  'use strict';
  angular.module('hmapFront').controller('PartyGroupDialogController', PartyGroupDialogController);

  PartyGroupDialogController.$inject = ['entity', 'SweetAlert', '$filter', '$state', 'KeyService', '$uibModalInstance', 'TenantService', 'PartyGroupService' ];

  function PartyGroupDialogController(entity, SweetAlert, $filter, $state, KeyService, $uibModalInstance, TenantService, PartyGroupService ) {
    var vm = this;
    vm.group = entity;
    vm.edit = false;

    vm.clear = clear;
    vm.save = save;
    vm.judgeEdit = judgeEdit;
    vm.load = load;

    judgeEdit();
    vm.load();

    function load() {
      getTenant();
      vm.title = 'partyGroup.addGroup';
      if (vm.edit) {
        vm.title = 'partyGroup.editGroup';
        return PartyGroupService.query(vm.group, -1, 0)
          .then(function (data) {
            if (data.success) {
              vm.group = data.rows[0];
            }
          });
      }
    }

    function judgeEdit() {
      if (entity.hasOwnProperty('groupId')) {
        vm.edit = true;
      }
    }

    function save() {
      var groups = [];
      groups.push(vm.group);
      return PartyGroupService.submit(groups)
        .then(function (data) {
          if (data.success) {
            SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
              .then(function () {
                $uibModalInstance.close();
                $state.go('partyGroup');
              })
          }else {
            SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
          }
        })
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function getTenant() {
      TenantService.query({}, 1, -1).then(function (data) {
        vm.results = data.rows;
      })
    }
  }
})();

/**
 * Created by xiawang.liu on 2017/06/15 0023.
 */
(function () {
  'use strict';

  angular
  .module('hmapFront')
  .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('b2cResParty', {
      parent: 'app',
      url: '/b2cResParty',
      views: {
        'body': {
          templateUrl: 'app/iot/portal/admin/b2c/html/party.html',
          controller: 'ResPartyController',
          controllerAs: 'vm'
        }
      }
    })
    .state('b2cResParty.edit', {
        parent: 'b2cResParty',
        url: '/edit/:partyId',
        onEnter: ['$stateParams', '$state','$uibModal', function ($stateParams, $state,$uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/b2c/html/party-dialog.html',
            controller: 'ResPartyDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  partyId: $stateParams.partyId
                }
              }
            }
          }).result.then(function () {
            $state.go('b2cResParty', null, {reload: 'b2cResParty'});
          }, function () {
            $state.go('b2cResParty', null, {reload: 'b2cResParty'});
          })
        }]
      }
    );
  }
})();

(function () {
  'use strict';
  angular
  .module('hmapFront')
  .factory('ResPartyService', ResPartyService);

  ResPartyService.$inject = ['$http'];

  function ResPartyService($http) {
    return {
      queryParties: queryParties,
      updateParties: updateParties,
      deleteParties: deleteParties
    };

    function queryParties(entity, page, pageSize) {
      var resourceUrl = '/api/admin/party/residentialQuery?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function updateParties(entity) {
      var resourceUrl = '/api/admin/party/residentialUpdate';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function deleteParties(entity) {
      var resourceUrl = '/api/admin/party/residentialDelete';
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ResPartyController', ResPartyController);

  ResPartyController.$inject = ['$localStorage', 'BaseConfig',  'ResPartyService', 'paginationConstants', 'TenantService', 'toastr', '$filter', 'toastrConfig', 'SweetAlert'];

  function ResPartyController($localStorage, BaseConfig, ResPartyService, paginationConstants, TenantService, toastr, $filter, toastrConfig, SweetAlert) {
    var vm = this;
    vm.party = {};
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.party.partyAccount = '';

    vm.exportExcel = exportExcel;
    vm.pageChanged = pageChanged;
    vm.getResidentialParty = getResidentialParty;
    vm.deleteResidentialParty = deleteResidentialParty;

    vm.getResidentialParty();


    function getResidentialParty() {
      getTenant();
      if (vm.party && (vm.party.partyAccount || "") === "") {
        delete vm.party.partyAccount;
      }
      ResPartyService.queryParties(vm.party, vm.page, vm.itemsPerPage).then(function(response){
        vm.parties = response.rows;
        for(var i = 0;i < vm.parties.length; i++){
          if (vm.parties[i].birthDate) {
            vm.parties[i].birthDate = new Date(vm.parties[i].birthDate);
          }
        }
        vm.totalItems =  response.total;
      });
    }

    function deleteResidentialParty(party) {
      SweetAlert.confirm($filter('T')('userManage.inputPhoneNumberToDeleteParty'),
        {title: $filter('T')("plugin.deletePrompt"), type: 'input', closeOnConfirm: false}).then(function (p) {
        if (p && (p === party.partyAccount || p === party.phoneNumber || p === party.emailAddress)) {
          var deleteParty = [{partyId: party.partyId, partyAccount: party.partyAccount}];
          ResPartyService.deleteParties(deleteParty).then(function (response) {
            if (response.success) {
              toastr.success($filter('T')('title.deleteSuccess'));
            } else {
              toastr.error($filter('T')('title.deleteFail'));
            }
            getResidentialParty();
            swal.close();
          }, function (response) {
            toastr.error($filter('T')('title.deleteFail'));
            swal.close();
          });
          return true;
        } else if (p !== false) {
          toastr.error($filter('T')('userManage.mismatchPhoneNumber'));
        }
      });
    }

    function getTenant() {
      console.log("Jayson ....test getTenant");
      TenantService.query({}, 1, -1).then(function (data) {
        vm.results = data.rows;
      })
    }

    function pageChanged() {
      vm.getResidentialParty();
    }

    function exportExcel() {
     if (undefined === vm.party.partyAccount) {
       vm.party.partyAccount = '';
     }
      window.location = $localStorage.b2cConfig + '/api/public/party/excel/excelExportForResidentialUser?token=' + $localStorage.authenticationToken.access_token
        + '&partyAccount=' + vm.party.partyAccount;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('ResPartyDialogController', ResPartyDialogController);

  ResPartyDialogController.$inject = ['$localStorage', 'BaseConfig', 'ResPartyService', '$uibModalInstance',
    'PartyGroupService', 'entity', 'SweetAlert', '$filter', '$state', 'TenantService' ];

  function ResPartyDialogController($localStorage, BaseConfig, ResPartyService, $uibModalInstance,
                                    PartyGroupService, entity, SweetAlert, $filter, $state, TenantService ) {
    var vm = this;
    vm.party = entity;

    vm.load = load;
    vm.save = save;
    vm.clear = clear;
    vm.changeTenant = changeTenant;

    vm.load();

    function load() {
      getGroups();
      getTenant();
      //console.log(vm.party.userGroupId);
      ResPartyService.queryParties(vm.party, 1, 1)
      .then(function (data) {
        if (data.success) {
          vm.party = data.rows[0];
          vm.party.edit = true;
          vm.party.userGroupId = (vm.party.userGroupId || '-1').toString();
          if (vm.party.userGroupId === '-1') {
            vm.party.edit = false;
          }
        }
      });
    }

    function save() {
      var partys = [];
      vm.party.userGroupId = parseInt(vm.party.userGroupId);
      partys.push(vm.party);
      ResPartyService.updateParties(partys)
      .then(function (data) {
        if (data.success) {
          SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
          .then(function () {
            $uibModalInstance.close();
            $state.go('b2cResParty')
          });
        } else {
          SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
        }
      });
    }

    function getGroups() {
      PartyGroupService.query({}, 1, -1)
      .then(function (data) {
        if (data.success) {
          vm.groups = data.rows;
        }
      });
    }

    function getTenant() {
      TenantService.query({}, 1, -1).then(function (data) {
        vm.results = data.rows;
      })
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


    function changeTenant() {
      var groupId = parseInt(vm.party.userGroupId);
      for (var i = 0; i < vm.groups.length; i++) {
        // console.log("test: "+vm.groups[0].groupId.toString());
        if (groupId === vm.groups[i].groupId) {
          vm.party.edit = true;
          vm.party.tenantId = vm.groups[i].tenantId;
          return;
        } else if (groupId === -1) {
          vm.party.edit = false;
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').config(keyConfig);

  function keyConfig($stateProvider) {
    $stateProvider.state('key', {
      parent: 'app',
      url: '/key',
      views: {
        'body': {
          templateUrl: 'app/iot/portal/admin/b2c/html/key.html',
          controller: 'KeyController',
          controllerAs: 'vm'
        }
      }
    })
    .state('key.add', {
      parent: 'key',
      url: '/add',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/b2c/html/key-dialog.html',
          controller: 'KeyDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function() {
              return {
              }
            }
          }
        }).result.then(function () {
          $state.go('key', null, {reload: 'key'});
        }, function () {
          $state.go('key', null, {reload: 'key'});
        })
      }]
    })
    .state('key.edit', {
      parent: 'key',
      url: '/edit/:id',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/b2c/html/key-dialog.html',
          controller: 'KeyDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve:{
            entity: function() {
              return {
                id: $stateParams.id
              }
            }
          }
        }).result.then(function () {
          $state.go('key', null, {reload: 'key'});
        }, function () {
          $state.go('key', null, {reload: 'key'});
        })
      }]
    })
    .state('key.resetAES', {
      parent: 'key',
      url: '/resetAES',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/b2c/html/key-resetAES-dialog.html',
          controller: 'KeyRestAESController',
          controllerAs: 'vm',
          backdrop: 'static',
          resolve:{
            entity: function() {
              return {
              }
            }
          }
        }).result.then(function () {
          $state.go('key');
        }, function () {
          $state.go('key');
        })
      }]
    })
  }

})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .factory('KeyService', KeyService);

  KeyService.$inject = ['$http'];

  function KeyService($http) {
    var prefix = '/api/admin/ctm/key';
    return {
      query: query,
      submit: submit,
      remove: remove,
      setMainKey: setMainKey,
      refreshKey: refreshKey,
      getCurrentRSA: getCurrentRSA,
      refreshRSA: refreshRSA
    };

    function query(key, page, pageSize) {
      var resourceUrl = prefix + '/query?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, key).then(function (response) {
        return response.data;
      })
    }

    function submit(key) {
      var resourceUrl = prefix + '/submit';
      return $http.post(resourceUrl, key).then(function (response) {
        return response.data;
      })
    }

    function remove(key) {
      var resourceUrl = prefix + '/remove';
      return $http.post(resourceUrl, key).then(function (response) {
        return response.data;
      })
    }

    function setMainKey(key) {
      var resourceUrl = prefix + '/setMainKey';
      return $http.post(resourceUrl, key).then(function (response) {
        return response.data;
      })
    }

    function refreshKey(key) {
      var resourceUrl = prefix + '/refreshKey';
      return $http.post(resourceUrl, key).then(function (response) {
        return response.data;
      })
    }

    function getCurrentRSA() {
      var resourceUrl = '/api/admin/security/dataProtection/currentRSA';
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    function refreshRSA(keyName) {
      var resourceUrl = '/api/admin/security/dataProtection/refreshRSA?keyName='+keyName;
      return $http.post(resourceUrl).then(function (response) {
        return response.data;
      })
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').controller('KeyController', KeyController);
  KeyController.$inject = ['$filter','KeyService', '$rootScope', '$state', 'paginationConstants', 'SweetAlert','MessageTemplateService','TenantService','$translate'];
  function KeyController($filter,KeyService, $rootScope, $state, paginationConstants, SweetAlert,MessageTemplateService,TenantService,$translate) {
    var vm = this;
    vm.keys = {};
    vm.page = 1;
    vm.totalItems = null;
    vm.isMain = [{
      value: 'Y',
      name: $translate.instant("appEdition.yes")
    },{
      value: 'N',
      name: $translate.instant("appEdition.no")
    }];


    vm.itemsPerPage = paginationConstants.itemsPerPage;
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    vm.deleteKey = deleteKey;
    vm.load = load;
    vm.search = search;
    vm.pageChanged = pageChanged;

    vm.setMainKey = setMainKey;
    vm.refreshKey = refreshKey;
    vm.getIsMains = getIsMain;
    vm.reset = reset;

    vm.getIsMains();

    function getIsMain(){
      MessageTemplateService.getByCode().query({code:'SYS.YES_NO'},function (data) {
        vm.isMains = data.rows;
      },function (error) {
      });
    }


    load();
    function load() {
      getTenant();
      return KeyService.query(vm.key, page ,pagesize)
        .then(function (data) {
          if (data.success){
            vm.keys =  data.rows;
            vm.totalItems = data.total;
          }
        })
    }

    function search() {
      load();
    }

    function reset() {
      vm.key.tenantId = undefined;
      vm.key.keyName = undefined;
    }
    function deleteKey(key) {
      if (key.isMain === 'Y'){
        SweetAlert.error($translate.instant("key.noDel"),{title: $filter('T')("btnTypeName.prompt")});
        return false;
      }
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          var keys = [];
          keys.push(key);
          return KeyService.remove(keys)
            .then(function (data) {
              var flag = data.success;
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
                vm.search();
              }
            })
        }
      });
    }

    function pageChanged() {
      getTenant();
      KeyService.query(vm.key, vm.page, paginationConstants.itemsPerPage)
        .then(function (data) {
          if (data.success){
            vm.keys =  data.rows;
            vm.totalItems = data.total;
          }
        });
    }

    function setMainKey(key) {
      if (key.isMain === 'Y'){
        SweetAlert.alert($filter('T')("key.isMaind"), {title: $filter('T')("title.confirmTitle")});
        return;
      }
      SweetAlert.confirm($filter('T')("key.setMainTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          KeyService.setMainKey(key)
          .then(function (data) {
            if (data.success){
              SweetAlert.success($filter('T')('title.setSuccess'), {title: $filter('T')('btnTypeName.prompt')})
              vm.search();
            }
          })
        }
      });
    }

    function refreshKey(key) {
      KeyService.refreshKey(key)
        .then(function (data) {
          if (data.success){
            SweetAlert.success($filter('T')('title.refreshSuccess'), {title: $filter('T')('btnTypeName.prompt')})
            vm.search();
          }
        })
    }

    function getTenant() {
      TenantService.query({}, 1, -1).then(function (data) {
        vm.tenants = data.rows;
      })
    }

  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').controller('KeyRestAESController', KeyRestAESController);

  KeyRestAESController.$inject = ['KeyService', 'SweetAlert', '$filter', '$state',  '$uibModalInstance', '$translate'];

  function KeyRestAESController( KeyService, SweetAlert, $filter, $state,  $uibModalInstance, $translate) {
    var vm = this;

    vm.keyName = '';

    vm.clear = clear;
    vm.save = save;
    vm.load = load;

    vm.load();

    function load() {
      KeyService.getCurrentRSA()
      .then(function (data) {
        vm.keyName = data;
      })
    }


    function save() {
      KeyService.refreshRSA(vm.keyName)
        .then(function (data) {
          if (data.success === true) {
            SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
              .then(function (){
                  $uibModalInstance.close();
                  $state.go('key')
              });
          }else {
            SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
          }
        })
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').controller('KeyDialogController', KeyDialogController);

  KeyDialogController.$inject = ['entity', 'KeyService', 'SweetAlert', '$filter', '$state', 'TenantService',
    '$uibModalInstance', '$translate', 'toastr'];

  function KeyDialogController(entity, KeyService, SweetAlert, $filter, $state, TenantService, $uibModalInstance,
                               $translate, toastr) {
    var vm = this;

    vm.key = entity;

    vm.clear = clear;
    vm.save = save;
    vm.load = load;
    vm.getTenant = getTenant;

    vm.edit = false;
    vm.isMain = [{
      value: 'Y',
      name: $translate.instant("appEdition.yes")
    },{
      value: 'N',
      name: $translate.instant("appEdition.no")
    }];

    vm.judgeEditOrCreate = judgeEditOrCreate;
    judgeEditOrCreate();

    vm.load();

    function load() {
      vm.title = 'key.addKey';
      vm.key.isMain = 'N';
      getTenant();
      if (vm.edit){
        vm.title = 'key.editKey';
        vm.key.isMain = undefined;
        return KeyService.query(vm.key,-1,0)
          .then(function (data) {
            if (data.success){
              vm.key = data.rows[0];
            }
          });
      }
    }

    function judgeEditOrCreate() {
      if(entity.hasOwnProperty('id')){
        vm.edit = true;
      }
    }

    function save() {
      if (vm.key.keySize && (!(/^[1-9]\d*$/.test(vm.key.keySize)))) {
        toastr.warning($filter('T')('key.validKeySize'));
        return;
      }
      var keys = [];
      keys.push(vm.key);
      KeyService.submit(keys)
        .then(function (data) {
          if (data.success) {
            SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
              .then(function (){
                  $uibModalInstance.close();
                  $state.go('key')
              });
          }else {
            SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
          }
        })
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
    function getTenant() {
      TenantService.query({}, 1, -1).then(function (data) {
        vm.tenants = data.rows;
      })
    }

  }
})();

/**
 * Created by user on 2018/7/6.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('b2cClientDetails', {
        parent: 'app',
        url: "/b2cClientDetails",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/b2c/html/clientDetails.html",
            controller: 'ClientDetailController',
            controllerAs: 'vm'
          }
        }
      })
      .state('b2cClientDetails.edit', {
        parent: 'b2cClientDetails',
        url: "/edit/:clientId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/b2c/html/clientDetails-dialog.html',
            controller: 'ClientDetailDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  clientId: $stateParams.clientId,
                  editFlag: true
                };
              }
            }
          }).result.then(function () {
            $state.go('b2cClientDetails', null, {reload: 'b2cClientDetails'});
          }, function () {
            $state.go('b2cClientDetails', null, {reload: 'b2cClientDetails'});
          });
        }]
      })
      .state('b2cClientDetails.add', {
        parent: 'b2cClientDetails',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/b2c/html/clientDetails-dialog.html',
            controller: 'ClientDetailDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  editFlag: false
                }
              }
            }
          }).result.then(function () {
            $state.go('b2cClientDetails', null, {reload: 'b2cClientDetails'});
          }, function () {
            $state.go('b2cClientDetails', null, {reload: 'b2cClientDetails'});
          });
        }]
      })
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .factory('ClientDetailService', ClientDetailService);

  ClientDetailService.$inject = ['$http'];

  function ClientDetailService($http) {
    var prefix = '/api/admin/oauth/client';
    return {
      query: query,
      submit: submit,
      create: create,
      remove: remove,
      generateUUID: generateUUID
    };

    function query(app, page, pageSize) {
      var resourceUrl = prefix + '/query?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function submit(app) {
      var resourceUrl = prefix + '/submit';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function create(app) {
      var resourceUrl = prefix + '/create';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function remove(app) {
      var resourceUrl = prefix + '/remove';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function generateUUID() { //生成新的UUID
      var date = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    };
  }
})();

/**
 * Created by user on 2018/7/4.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('ClientDetailController', ClientDetailsController);

  ClientDetailsController.$inject = ['$filter', '$rootScope', 'ClientDetailService', '$state', 'paginationConstants', 'SweetAlert'];

  function ClientDetailsController($filter, $rootScope, ClientDetailService, $state, paginationConstants, SweetAlert) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.clientDetail = {};

    vm.deleteClient = deleteClient;
    vm.search = search;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.reset = reset;
    vm.isDel = isDel;

    vm.itemsPerPage = paginationConstants.itemsPerPage;
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    loadAll(vm.clientDetail, page, pagesize);

    function loadAll(clientDetail, page, pagesize) {
      return ClientDetailService.query(clientDetail,page, pagesize)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
         // console.log("result00000" + angular.toJson(vm.result));
        }, onSuccess, onError)
    }

    function deleteClient(clientDetail) {
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          var clientDetails = [];
          clientDetails.push(clientDetail);
          return ClientDetailService.remove(clientDetails)
            .then(function (data) {
              var flag = data.success;
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
               vm.search();
              }
            })
        }
      });
    }

    function isDel(value){
      var reg= /^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$/;
      if (!reg.test(value.clientId)) {
        return false;
      }
      return true;
    }

    function reset() {
      vm.clientDetail = {};
    }

    function search() {
      var page = vm.page = 1;
      var pagesize = paginationConstants.itemsPerPage;
      // if (vm.clientDetail.clientId === null || vm.clientDetail.clientId === "") {
      //   vm.clientDetail.clientId = undefined;
      // }
      // if (vm.clientDetail.webServerRedirectUri === null || vm.clientDetail.webServerRedirectUri === "") {
      //   vm.clientDetail.webServerRedirectUri = undefined;
      // }
      loadAll(vm.clientDetail, page, pagesize);
    };

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.clientDetail = data.rows;
      vm.totalItems = data.total;
    }

    function onError(error) {
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll(vm.clientDetail, vm.page, paginationConstants.itemsPerPage);
    }
  }
})();

/**
 * Created by zhouzy on 2016/7/31 0031.
 */
(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('ClientDetailDialogController', ClientDetailsDialogController);

  ClientDetailsDialogController.$inject = ['$filter', 'PromptService', 'RoleService', '$timeout', '$scope',
    '$stateParams', '$uibModalInstance', 'entity', 'ClientDetailService', 'toastr', 'uibDateParser', 'SweetAlert',
    'TenantService', '$translate', 'toastrConfig','$state'];

  function ClientDetailsDialogController($filter, PromptService, RoleService, $timeout, $scope, $stateParams,
                                         $uibModalInstance, entity, ClientDetailService, toastr, uibDateParser, SweetAlert,
                                         TenantService, $translate, toastrConfig,$state) {
    var vm = this;
    vm.lang = window.localStorage.lang;
    if (vm.lang == 'en_GB') {
      vm.lang = 'en';
    }

    vm.clientDetail = {clientId: entity.clientId};
    vm.clientDetail.authorities = '';
    vm.clientDetail.authorizedGrantTypes = '';
    vm.authorizedGrantTypesArr = [];
    vm.authoritiesArr = [];
    vm.tenantIdArr = [];
    vm.choseFlag = false;
    vm.shows = true;
    vm.isEdit = entity.editFlag;

    vm.typeValues = [
      {name: $filter('T')('clientDetail.passwordMode'), value: 'password'},
      {name: $filter('T')('clientDetail.refreshTokenMode'), value: 'refresh_token'},
      {name: $filter('T')('clientDetail.clientMode'), value: 'client_credentials'},
      {name: $filter('T')('clientDetail.codeMode'), value: 'authorization_code'},
      {name: $filter('T')('clientDetail.implicitMode'), value: 'implicit'}
      ];

    vm.roleValues = [
      {name: $filter('T')('clientDetail.roleAdmin'), value: 'ROLE_ADMIN'},
      {name: $filter('T')('clientDetail.roleAdmin')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_ADMIN_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleComm'), value: 'ROLE_COMM'},
      {name: $filter('T')('clientDetail.roleComm')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_COMM_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleCommApp'), value: 'ROLE_COMM_APP'},
      {name: $filter('T')('clientDetail.roleCommApp')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_COMM_APP_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleCommApi'), value: 'ROLE_COMM_API'},
      {name: $filter('T')('clientDetail.roleCommApi')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_COMM_API_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleDps'), value: 'ROLE_DPS'},
      {name: $filter('T')('clientDetail.roleDps')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_DPS_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleResi'), value: 'ROLE_RESI'},
      {name: $filter('T')('clientDetail.roleResi')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_RESI_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleResiApi'), value: 'ROLE_RESI_API'},
      {name: $filter('T')('clientDetail.roleResiApi')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_RESI_API_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleSmr'), value: 'ROLE_SMR'},
      {name: $filter('T')('clientDetail.roleSmr')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_SMR_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleSmrApp'), value: 'ROLE_SMR_APP'},
      {name: $filter('T')('clientDetail.roleSmrApp')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_SMR_APP_TRANSMIT'}
      ];

    vm.autoapprove = [{
      value: 'true',
      name: $translate.instant("appEdition.yes")
    }, {
      value: 'false',
      name: $translate.instant("appEdition.no")
    }];
    vm.allTenantId =  $translate.instant("clientDetail.all");

    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.popupOpen = popupOpen;
    vm.load = load;
    vm.initLangs = initLangs;
    vm.selectTypeChange = selectTypeChange;
    vm.selectChange = selectChange;
    vm.selectTenantId = selectTenantId;
    vm.changeSecret = changeSecret;
    //vm.getScope = getScope;

    vm.load();

    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#appDescBtn").attr("disabled", false);
        $("#appNameBtn").attr("disabled", false);
      });
    }

    function changeSecret() {
      if ($("#clientSecret").attr("type") === 'password') {
        $("#clientSecret").attr('type', 'text');
      } else {
        $("#clientSecret").attr('type', 'password');
      }

    }

    initLangs();

    $scope.$watch('$viewContentLoaded', function () {
      //data plugin
      $('.form_date').datetimepicker({
        language: vm.lang,
        format: 'yyyy-mm-dd 00:00:00',
        weekStart: 1,
        todayBtn: 1,
        autoclose: 1,
        todayHighlight: 1,
        startView: 2,
        minView: 2,
        forceParse: 0
      });
    });

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
      console.log('It is not a string!')
    }

    function isNumber(value) {
      var re = /^(\+|-)?\d+($|\.\d+$)/;
      //console.log("1->" + re.test(value));
      if (!re.test(value)) {
        return false;
      }
      return true;
    }

    function save() {
      //vm.isSaving = true;
      if ('' !== vm.clientDetail.additionalInformation && undefined !== vm.clientDetail.additionalInformation
        && null !== vm.clientDetail.additionalInformation) {
        if (!isJSON(vm.clientDetail.additionalInformation)) {
          toastr.error($filter('T')("dvmProduct.checkJsonFormat"), $filter('T')("dvmProduct.invalidJson"));
          return;
        }
      }

      if ('' !== vm.clientDetail.accessTokenValidity && undefined !== vm.clientDetail.accessTokenValidity
        && null !== vm.clientDetail.accessTokenValidity) {
        console.log(isNumber(vm.clientDetail.accessTokenValidity));
        if (!isNumber(vm.clientDetail.accessTokenValidity)) {
          toastr.error($filter('T')("clientDetail.inputNumber"), $filter('T')("btnTypeName.prompt"));
          vm.clientDetail.accessTokenValidity = undefined;
          return;
        }
      }

      if ('' !== vm.clientDetail.refreshTokenValidity && undefined !== vm.clientDetail.refreshTokenValidity
        && null !== vm.clientDetail.refreshTokenValidity) {
        if (!isNumber(vm.clientDetail.refreshTokenValidity)) {
          toastr.error($filter('T')("clientDetail.inputNumber"), $filter('T')("btnTypeName.prompt"));
          vm.clientDetail.refreshTokenValidity = undefined;
          return;
        }
      }

      if (vm.autoapproveFlag === 'Y') {
        vm.clientDetail.autoapprove = true;
      } else if (vm.autoapproveFlag === 'N') {
        vm.clientDetail.autoapprove = false;
      }

      var clientDetails = [];
      clientDetails.push(vm.clientDetail);
      if (vm.isEdit){
        ClientDetailService.submit(clientDetails)
        .then(function (data) {
          if (data.success) {
            SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
            .then(function () {
              $uibModalInstance.close();
              $state.go('b2cClientDetails');
            })
          } else {
            SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
          }
        })
      } else{
        ClientDetailService.create(clientDetails)
        .then(function (data) {
          if (data.success) {
            SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
            .then(function () {
              $uibModalInstance.close();
              $state.go('b2cClientDetails');
            })
          } else {
            SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
          }
        })
      }

    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        format: 'yyyy-MM-dd hh:mm:ss',
        maxDate: new Date(2099, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function popupOpen() {
      vm.isOpen = true;
    }

    function load() {
      getTenant();
      vm.clientDetail.autoapprove = 'true';
      if (vm.isEdit) {
        vm.title = 'clientDetail.editTitle';
        vm.clientDetail.resourceIds = undefined;
        vm.clientDetail.scope = undefined;
        vm.clientDetail.clientSecret = undefined;
        vm.clientDetail.authorities = undefined;
        vm.clientDetail.authorizedGrantTypes = undefined;
        ClientDetailService.query(vm.clientDetail, 1, 10)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
          vm.clientDetail = vm.result[0];
          if (vm.clientDetail.authorizedGrantTypes === 'client_credentials') {
            vm.shows = false;
          }else{
            vm.shows = true;
          }
        })
      } else {
        vm.clientDetail.tenantId = '';
        vm.clientDetail.clientId = ClientDetailService.generateUUID();
        vm.clientDetail.clientSecret = ClientDetailService.generateUUID();
        vm.clientDetail.resourceIds = 'api-resource,iapi-resource';
        vm.clientDetail.scope = 'read,write';
        vm.title = 'clientDetail.createTitle';
      }
    }

    function selectTypeChange() {
      var value = vm.grantType;
      if (undefined === vm.clientDetail.authorizedGrantTypes || null === vm.clientDetail.authorizedGrantTypes) {
        vm.clientDetail.authorizedGrantTypes = '';
      }
      vm.authorizedGrantTypesArr = vm.clientDetail.authorizedGrantTypes.split(',');
      if ('' !== value && vm.authorizedGrantTypesArr.indexOf(value) === -1) {
        vm.authorizedGrantTypesArr.push(value);
        var tenantId =  vm.clientDetail.tenantId;
        if (vm.clientDetail.authorizedGrantTypes === '') {
          vm.clientDetail.tenantId = '';
          vm.clientDetail.authorizedGrantTypes += value;
          if (vm.clientDetail.authorizedGrantTypes === 'client_credentials') {
            vm.choseFlag = true;
            vm.shows = false;
            if ('*' === tenantId) {
              vm.clientDetail.tenantId = '';
            }
            return;
          } else {
            vm.choseFlag = false;
            vm.shows = true;
          }
        } else {
          if (vm.clientDetail.authorizedGrantTypes === 'client_credentials') {
            vm.choseFlag = true;
            vm.shows = false;
            return;
          } else if (value !== 'client_credentials') {
            vm.choseFlag = false;
            vm.shows = true;
            vm.clientDetail.authorizedGrantTypes = vm.clientDetail.authorizedGrantTypes + ',' + value;
          }
        }
      }
    }

    function selectChange() {
      var value = vm.auth;
      if (undefined === vm.clientDetail.authorities || null === vm.clientDetail.authorities) {
        vm.clientDetail.authorities = '';
      }
      vm.authoritiesArr = vm.clientDetail.authorities.split(',');
      if ('' !== value && vm.authoritiesArr.indexOf(value) === -1) {
        vm.authoritiesArr.push(value);
        if (vm.clientDetail.authorities === '') {
          vm.clientDetail.authorities += value;
        } else {
          vm.clientDetail.authorities = vm.clientDetail.authorities + ',' + value;
        }
      }
    }

    function selectTenantId() {
      var value = vm.tenantId;
      if (!(undefined === vm.clientDetail.tenantId || null === vm.clientDetail.tenantId)) {
        vm.tenantIdArr = vm.clientDetail.tenantId.toString().split(',');
      }
      if ('' !== value && vm.tenantIdArr.indexOf(value) === -1) {
        vm.tenantIdArr.push(value);
        if (vm.choseFlag || vm.clientDetail.authorizedGrantTypes === 'client_credentials') {
          vm.clientDetail.tenantId = value;
          vm.shows = false;
        } else {
          vm.shows = true;
          if (vm.clientDetail.tenantId === '') {
            vm.clientDetail.tenantId += value;
          } else {
            if (value === "*" || vm.clientDetail.tenantId === "*"){
              vm.clientDetail.tenantId = value;
            } else{
              vm.clientDetail.tenantId = vm.clientDetail.tenantId + ',' + value;
            }
          }
        }
      }
    }
    function getTenant() {
      TenantService.query({}, 1, -1).then(function (data) {
        vm.tenants = data.rows;
      })
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').config(applicationConfig);

  function applicationConfig($stateProvider) {
    $stateProvider.state('b2cApplication', {
      parent: 'app',
      url: '/b2cApplication',
      views: {
        'body': {
          templateUrl: 'app/iot/portal/admin/b2c/html/application.html',
          controller: 'b2cApplicationController',
          controllerAs: 'vm'
        }
      }
    })
    .state('b2cApplication.edit', {
      parent: 'b2cApplication',
      url: '/edit/:appId',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/b2c/html/application-dialog.html',
          controller: 'b2cApplicationDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function() {
              return {
                'appId': $stateParams.appId
              }
            }
          }
        }).result.then(function () {
          $state.go('b2cApplication', null, {reload: 'b2cApplication'});
        }, function () {
          $state.go('b2cApplication', null, {reload: 'b2cApplication'});
        })
      }]
    })
    .state('b2cApplication.add', {
      parent: 'b2cApplication',
      url: '/add',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/iot/portal/admin/b2c/html/application-dialog.html',
          controller: 'b2cApplicationDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function() {
              return {}
            }
          }
        }).result.then(function () {
          $state.go('b2cApplication', null, {reload: 'b2cApplication'});
        }, function () {
          $state.go('b2cApplication', null, {reload: 'b2cApplication'});
        })
      }]
    })

  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .factory('b2cApplicationService', b2cApplicationService);

  b2cApplicationService.$inject = ['$http'];

  function b2cApplicationService($http) {
    var prefix = '/api/admin/ctm/app';
    return {
      query: query,
      submit: submit,
      remove: remove
    };

    function query(app, page, pageSize) {
      var resourceUrl = prefix + '/query?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }
    function submit(app) {
      var resourceUrl = prefix + '/submit';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }
    function remove(app) {
      var resourceUrl = prefix + '/remove';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }
  }
})();

(function () {
  'use strict';
  angular.module('hmapFront')
  .controller('b2cApplicationController', b2cApplicationController);

  b2cApplicationController.$inject = ['b2cApplicationService', 'paginationConstants', 'TenantService', 'SweetAlert', '$filter','$state'];

  function b2cApplicationController(b2cApplicationService, paginationConstants, TenantService, SweetAlert, $filter,$state) {

    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.projects = [
      "admin",
      "commercial",
      "commercialApi",
      "commercialApp",
      "residential",
      "residentialApi",
      "devicePreProvisioning",
      "smartmirror",
      "smartmirrorApp"
    ];

    vm.search = search;
    vm.getTenant = getTenant;
    vm.getApplication = getApplication;
    vm.delete = deleteApplication;
    //vm.deleteApplications = deleteApplications;
    vm.pageChanged = pageChanged;
    vm.reset = reset;

    vm.getApplication();
    getTenant();

    function search() {
      getApplication();
    }

    function getApplication() {
      getTenant();
      b2cApplicationService.query(vm.application, vm.page, vm.itemsPerPage).then(function(data) {
        vm.applications = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    function getTenant() {
      TenantService.query({}, 1, -1).then(function (data) {
        vm.tenants = data.rows;
      })
    }

    function reset() {
      vm.application.tenantId = undefined;
      vm.application.project = undefined;
    }

    function deleteApplication(application) {
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          var applications = [];
          applications.push(application);
          return b2cApplicationService.remove(applications).then(function (data) {
              var flag = data.success;
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
                vm.search();
              }
            })
        }
      });
    }

/*

    function deleteApplications() {
      var isChecked = angular.element('.chk_list').is(':checked');

      if(!isChecked) {
        SweetAlert.info($filter('T')(''), $filter('T')(''));
      } else {
        SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
          if(p){
            var applications = [];
            var arrChk = angular.element("input[name='chk_list']:checked");
            angular.forEach(arrChk, function(item) {
              applications.push(item.value);
            });
            b2cApplicationService.remove(applications).then(function (response) {
              angular.element("chk_all").checked = false;
              var items = angular.element("chk_list");
              for(var j = 0; j < items.length; j++){
                items[j].checked = false;
              }
              if (response.success) {
                vm.getActionConfig();
                SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
              }
            })
          }
        });
      }
    }
*/

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      getApplication();
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('b2cApplicationDialogController', b2cApplicationDialogController);

  b2cApplicationDialogController.$inject = ['entity', 'b2cApplicationService', 'SweetAlert', '$filter', '$state', 'TenantService', '$uibModalInstance', 'toastr'];

  function b2cApplicationDialogController(entity, b2cApplicationService, SweetAlert, $filter, $state, TenantService, $uibModalInstance, toastr) {
    var vm = this;
    vm.application = entity;
    vm.edit = false;
    vm.projects = [
      "admin",
      "commercial",
      "commercialApi",
      "commercialApp",
      "residential",
      "residentialApi",
      "devicePreProvisioning",
      "smartmirror",
      "smartmirrorApp"
    ];

    vm.save = saveApplication;
    vm.getTenant = getTenant;
    //vm.getApplication = getApplication;
    vm.judgeEditOrCreate = judgeEditOrCreate;
    vm.load = load;
    vm.clear = clear;

    judgeEditOrCreate();
    vm.load();

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    /* function getApplication() {
       return b2cApplicationService.query(vm.application)
         .then(function (data) {
           vm.applications = data.rows;
         });
     }*/

    function judgeEditOrCreate() {
      if (entity.hasOwnProperty('appId')) {
        vm.edit = true;
      }
    }

    function load() {
      vm.title = 'application.addApp';
      getTenant();
      if (vm.edit) {
        vm.title = 'application.editApp';
        b2cApplicationService.query(vm.application, 1, -1)
        .then(function (data) {
          if (data.success) {
            vm.application = data.rows[0];
          }
        });
      }
    }

    function saveApplication() {
      var applications = [];
      applications.push(vm.application);
      b2cApplicationService.submit(applications)
      .then(function (data) {
        if (data.success) {
          SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
          .then(function () {
            $uibModalInstance.close();
            $state.go('b2cApplication');
          })
        }
        else {
          SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
        }
      })
    }

    function getTenant() {
      TenantService.query({}, 1, -1)
      .then(function (data) {
        vm.tenants = data.rows;
      })
    }
  }

})();

/**
 * Created by gumei.wang 2019/10/25.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('dimension', {
        parent: 'app',
        url: "/dimension",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ai/html/dimension.html",
            controller: 'DimensionController',
            controllerAs: 'vm'
          },
        },
        resolve: {
          entity : function () {
            return {};
          }
        }
      })
      .state('dimension.add', {
        parent:'dimension',
        url:"/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ai/html/dimension-dialog.html',
            controller: 'DimensionDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                }
              }
            }
          }).result.then(function () {
            $state.go('dimension', null, {reload: 'dimension'});
          }, function () {
            $state.go('dimension');
          });
        }]
      })
      .state('dimension.edit', {
        parent:'dimension',
        url:"/edit/:dimensionNodeId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ai/html/dimension-dialog.html',
            controller: 'DimensionDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  dimensionNodeId : $stateParams.dimensionNodeId
                }
              }
            }
          }).result.then(function () {
            $state.go('dimension', null, {reload: 'dimension'});
          }, function () {
            $state.go('dimension');
          });
        }]
      })
  }
})();

/**
 * Created by gumei.wang 2019/10/25.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('DimensionController', DimensionController);

  DimensionController.$inject = ['$filter', 'AiAcquisitionService','toastr','toastrConfig','$state','SweetAlert','paginationConstants'];
  /** @ngInject */
  function DimensionController($filter, AiAcquisitionService,toastr,toastrConfig,$state,SweetAlert,paginationConstants) {
    var vm = this;
    vm.page = 1;
    vm.pageSize = 10;
    vm.dimension = {};
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.getAllDimension = getAllDimension;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.deleteDimension = deleteDimension;
    vm.deleteDimensions = deleteDimensions;
    vm.checkAllDimension = checkAllDimension;
    vm.checkDimension = checkDimension;
    vm.showContent = showContent;

    vm.getAllDimension();

    function reset() {
      vm.page = 1;
      vm.pageSize = 10;
      vm.dimension = {};
    }

    function getAllDimension() {
      vm.pageSize = paginationConstants.itemsPerPage;
      return AiAcquisitionService.getAllDimension(vm.dimension, vm.page, vm.pageSize).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.dimensions = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      });
    }

    function deleteDimension(dimension) {
      SweetAlert.confirm($filter('T')('productImage.deleteTip'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          var dimensions = [];
          dimensions.push(dimension);
          AiAcquisitionService.deleteDimension(dimensions).then(function (data){
            if(data.success){
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
              return $state.go('dimension', null, {reload: 'dimension'});
            }
          })
        }
      })
    }

    function deleteDimensions() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var dimensions = new Array();
          $(arrChk).each(function() {
            dimensions.push(this.value);
          });
          AiAcquisitionService.deleteDimension(dimensions).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getAllDimension();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //check or unCheck all check link
    function checkAllDimension() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }

    //check or unCheck check link
    function checkDimension() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    function pageChanged() {
      vm.getAllDimension();
    }

    function search() {
      vm.getAllDimension();
    }

    function showContent(dimension) {
      $("#contentModal").modal("show");
      vm.currentContent = dimension.description;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('DimensionDialogController', DimensionDialogController);

  DimensionDialogController.$inject = ['entity', 'b2cApplicationService', 'SweetAlert', '$filter', '$state', 'AiAcquisitionService', '$uibModalInstance', 'toastr'];

  function DimensionDialogController(entity, b2cApplicationService, SweetAlert, $filter, $state, AiAcquisitionService, $uibModalInstance, toastr) {
    var vm = this;
    vm.dimension = entity;
    vm.edit = false;
    vm.projects = [
      "admin",
      "commercial",
      "commercialApi",
      "commercialApp",
      "residential",
      "residentialApi",
      "devicePreProvisioning",
      "smartmirror",
      "smartmirrorApp"
    ];
    vm.title = $filter('T')('apConfig.addDimension');

    vm.save = creatDimension;
    //vm.getApplication = getApplication;
    vm.judgeEditOrCreate = judgeEditOrCreate;
    vm.load = load;
    vm.clear = clear;

    judgeEditOrCreate();
    vm.load();

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    /* function getApplication() {
       return b2cApplicationService.query(vm.application)
         .then(function (data) {
           vm.applications = data.rows;
         });
     }*/

    function judgeEditOrCreate() {
      if (entity.hasOwnProperty('dimensionNodeId')) {
        vm.edit = true;
        vm.title = $filter('T')('aiConfig.editDimension');
      } else {
        vm.title = $filter('T')('aiConfig.addDimension');
      }
    }

    function load() {
      vm.title = 'aiConfig.addDimension';
      if (vm.edit) {
        vm.title = 'aiConfig.editDimension';
        AiAcquisitionService.getAllDimension(vm.dimension, 1, -1)
        .then(function (data) {
          if (data.success) {
            vm.dimension = data.rows[0];
          }
        });
      }
    }

    function creatDimension() {
      AiAcquisitionService.creatDimension(vm.dimension)
      .then(function (data) {
        if (data.success) {
          SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
          .then(function () {
            $uibModalInstance.close();
            $state.go('dimension', null, {reload: true});
          })
        }
        else {
          SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
        }
      })
    }

  }

})();

/**
 * Created by gumei.wang 2019/10/25.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('aiAcquisition', {
        parent: 'app',
        url: "/aiAcquisition",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/ai/html/aiAcquisition.html",
            controller: 'AiAcquisitionController',
            controllerAs: 'vm'
          },
        },
        resolve: {
          entity : function () {
            return {};
          }
        }
      })
      .state('aiAcquisition.add', {
        parent:'aiAcquisition',
        url:"/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ai/html/aiAcquisition-dialog.html',
            controller: 'AiAcquisitionDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                }
              }
            }
          }).result.then(function () {
            $state.go('aiAcquisition', null, {reload: 'aiAcquisition'});
          }, function () {
            $state.go('aiAcquisition');
          });
        }]
      })
      .state('aiAcquisition.edit', {
        parent:'aiAcquisition',
        url:"/edit/:collectionId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ai/html/aiAcquisition-dialog.html',
            controller: 'AiAcquisitionDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  collectionId : $stateParams.collectionId
                }
              }
            }
          }).result.then(function () {
            $state.go('aiAcquisition', null, {reload: 'aiAcquisition'});
          }, function () {
            $state.go('aiAcquisition');
          });
        }]
      })
      .state('acquisitionNode', {
          parent: 'app',
          url: "/acquisitionNode",
          views: {
            'body': {
              templateUrl: "app/iot/portal/admin/ai/html/acquisitionNode.html",
              controller: 'AcquisitionNodeController',
              controllerAs: 'vm',
            }
          },
          resolve: {
            entity: function ($stateParams) {
              return {
                imageCode : $stateParams.imageCode
              };
            }
          }
        })
      .state('acquisitionNode.add', {
        parent:'acquisitionNode',
        url:"/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ai/html/acquisitionNode-dialog.html',
            controller: 'AcquisitionNodeDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  imageCode : $stateParams.imageCode
                }
              }
            }
          }).result.then(function () {
            $state.go('acquisitionNode', null, {reload: 'acquisitionNode'});
          }, function () {
            $state.go('acquisitionNode');
          });
        }]
      })
      .state('acquisitionNode.edit', {
        parent:'acquisitionNode',
        url:"/edit/:collectionNodeId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/ai/html/acquisitionNode-dialog.html',
            controller: 'AcquisitionNodeDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  collectionNodeId : $stateParams.collectionNodeId,
                }
              }
            }
          }).result.then(function () {
            $state.go('acquisitionNode', null, {reload: 'acquisitionNode'});
          }, function () {
            $state.go('acquisitionNode');
          });
        }]
      })
  }
})();

/**
 * Created by gumei.wang 2019/10/25.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('AiAcquisitionService', AiAcquisitionService);

  AiAcquisitionService.$inject = ['$http'];

  function AiAcquisitionService($http) {
    return {
      getAllDimension : getAllDimension,
      deleteDimension : deleteDimension,
      creatDimension : creatDimension,

      getAcquisitionNode : getAcquisitionNode,
      creatAcquisitionNode : creatAcquisitionNode,
      deleteAcquisitionNode : deleteAcquisitionNode,

      getAcquisition : getAcquisition,
      creatAcquisition : creatAcquisition,
      deleteAcquisition : deleteAcquisition,

      getValidProduct : getValidProduct,

    };
    //get all influence dimension
    function getAllDimension(entity, page, pageSize) {
      var resourceUrl = '/api/ml/selectDimensionNode?pageIndex='+page+'&pageSize='+pageSize;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
     /* console.log('getAllDimension -> entity', entity);
      var data = {rows: [
          {dimensionId: 1, dimensionName: '维度一', dimensionCode: '0001'
            ,dimensionContent: '啦啦啦啦啦;sdfsdfegwef;个人serge被;啦啦啦啦啦;sdfsdfegwef;个人serge被;' +
              'dgertgererhw;我5以为5因为5也5;染个色染色体黄色图;吖v问题问题veteran'},
          {dimensionId: 2,dimensionName: '维度二', dimensionCode: '0002',
            dimensionContent: '啦啦啦啦啦;sdfsdfegwef;个人serge被;'},
          {dimensionId: 3,dimensionName: '维度三', dimensionCode: '0003',
            dimensionContent: '啦啦啦啦啦;sdfsdfegwef;个人serge被;'},
          {dimensionId: 4,dimensionName: '维度五', dimensionCode: '0004',
            dimensionContent: '啦啦啦啦啦;sdfsdfegwef;个人serge被;'},
          {dimensionId: 5,dimensionName: '维度六', dimensionCode: '0005'},
          {dimensionId: 6,dimensionName: '维度八', dimensionCode: '0006'},
          {dimensionId: 7,dimensionName: '维度九', dimensionCode: '0007'},
          {dimensionId: 8,dimensionName: '维度十', dimensionCode: '0008'},
          {dimensionId: 9,dimensionName: '维度十一', dimensionCode: '0904'},
          {dimensionId: 10,dimensionName: '维度十二', dimensionCode: '5004'},
        ],
        total: 23
      };
      return new Promise(function (resolve, reject) {
        setTimeout(function () { resolve(data) },0);
      })*/
    }

    // delete dimension
    function deleteDimension(entity) {
      console.log('deleteDimension -> entity', entity);
      // return new Promise(function (resolve, reject) {
      //   setTimeout(function () {
      //     resolve({success: true})
      //   },0)
      // })
      var resourceUrl = '/api/ml/deleteDimensionNode';
      return $http.post(resourceUrl,entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }
    //creat product image code
    function creatDimension(entity) {
      console.log('creatDimension -> entity', entity);
      // return new Promise(function (resolve, reject) {
      //   setTimeout(function () {
      //     resolve({success: true})
      //   },0)
      // })
      const resourceUrl = '/api/ml/insertOrUpdateDimensionNode';
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }


    //get acquisition node
    function getAcquisitionNode(entity, page, pageSize) {
      console.log('getAcquisitionNode -> entity', entity);
      const resourceUrl = '/api/ml/selectCollectionNodeList?pageIndex='+page+'&pageSize='+pageSize;
      return $http.post(resourceUrl, entity, {headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
     /*
      var data = {rows: [
          {nodeId: 1, product: '维度一', cmd: '0001',param: 'sdfsdn',preState: 'serwer',arriveState: 'dfwsefwe',productProperty:'ferwe'},
          {nodeId: 2,product: '维度二', cmd: '0002', param: 'edwedw',preState: 'dsf',arriveState: 'dfwsefwe',productProperty:'ferwe'},
          {nodeId: 3,product: '维度三', cmd: '0003', param: 'feg',preState: 'sdf',arriveState: 'dfwsefwe',productProperty:'ferwe'},
          {nodeId: 4,product: '维度五', cmd: '0004', param: 'dsf',preState: 'serwer',arriveState: 'dfwsefwe',productProperty:'ferwe'},
          {nodeId: 5,product: '维度六', cmd: '0005', param: 'df',preState: 'serwer',arriveState: 'dfwsefwe',productProperty:'ferwe'},
          {nodeId: 6,product: '维度八', cmd: '0006', param: 'xfsdf',preState: 'serwer',arriveState: 'dfwsefwe',productProperty:'ferwe'},
          {nodeId: 7,product: '维度九', cmd: '0007', param: 'arf',preState: 'serwer',arriveState: 'dfwsefwe',productProperty:'ferwe'},
          {nodeId: 8,product: '维度十', cmd: '0008', param: 'sdf',preState: 'serwer',arriveState: 'dfwsefwe',productProperty:'ferwe'},
          {nodeId: 9,product: '维度十一', cmd: '0904', param: 'sd',preState: 'serwer',arriveState: 'dfwsefwe',productProperty:'ferwe'},
          {nodeId: 10,product: '维度十二', cmd: '5004', param: 'erw',preState: 'serwer',arriveState: 'dfwsefwe',productProperty:'ferwe'},
        ],
        total: 23
      };
      return new Promise(function (resolve, reject) {
        setTimeout(function () { resolve(data) },0);
      })*/
    }

    //query product image info
    function getValidProduct() {
      const resourceUrl = '/api/ml/selectProduct';
      return $http.get(resourceUrl,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        });
      /*var data = {rows: [
          {productId: 1, productDes: '维度一'},
          {productId: 2,productDes: '维度二'},
          {productId: 3,productDes: '维度三'},
          {productId: 4,productDes: '维度五'},
          {productId: 5,productDes: '维度六'},
          {productId: 6,productDes: '维度八'},
          {productId: 7,productDes: '维度九'},
          {productId: 8,productDes: '维度十'},
          {productId: 9,productDes: '维度十一'},
          {productId: 10,productDes: '维度十二'},
        ],
        total: 23
      };
      return new Promise(function (resolve, reject) {
        setTimeout(function () { resolve(data) },0);
      })*/
    }
    function creatAcquisitionNode(entity) {
      console.log('creatAcquisitionNode -> entity', entity);
      // return new Promise(function (resolve, reject) {
      //   setTimeout(function () {
      //     resolve({success: true})
      //   },0)
      // })
      const resourceUrl = '/api/ml/insertCollectionNode';
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }
    //select other product
    function deleteAcquisitionNode(entity) {
      console.log('deleteAcquisitionNode -> entity', entity);
      // return new Promise(function (resolve, reject) {
      //   setTimeout(function () {
      //     resolve({success: true})
      //   },0)
      // })
      var resourceUrl = '/api/ml/deleteCollectionNode';
      return $http.post(resourceUrl,entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }


    //insert product image info
    function getAcquisition(entity, page, pageSize) {
      console.log('getAcquisition -> entity', entity);
      const resourceUrl = '/api/ml/selectIntelligenceList?pageIndex='+page+'&pageSize='+pageSize;
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
     /* console.log('getAcquisition -> entity', entity);
      var data = {rows: [
          {aiAcquisitionId: 1,productName: '维度一', dimension: '0001',cmdCode: 'sdfsdn',paramCode: 'serwer',acquisitionNode: 'dfwsefwe'},
          {aiAcquisitionId: 2,productName: '维度二', dimension: '0002', cmdCode: 'edwedw',paramCode: 'dsf',acquisitionNode: 'dfwsefwe'},
          {aiAcquisitionId: 3,productName: '维度三', dimension: '0003', cmdCode: 'feg',paramCode: 'sdf',acquisitionNode: 'dfwsefwe'},
          {aiAcquisitionId: 4,productName: '维度五', dimension: '0004', cmdCode: 'dsf',paramCode: 'serwer',acquisitionNode: 'dfwsefwe'},
          {aiAcquisitionId: 5,productName: '维度六', dimension: '0005', cmdCode: 'df',paramCode: 'serwer',acquisitionNode: 'dfwsefwe'},
          {aiAcquisitionId: 6,productName: '维度八', dimension: '0006', cmdCode: 'xfsdf',paramCode: 'serwer',acquisitionNode: 'dfwsefwe'},
          {aiAcquisitionId: 7,productName: '维度九', dimension: '0007', cmdCode: 'arf',paramCode: 'serwer',acquisitionNode: 'dfwsefwe'},
          {aiAcquisitionId: 8,productName: '维度十', dimension: '0008', cmdCode: 'sdf',paramCode: 'serwer',acquisitionNode: 'dfwsefwe'},
          {aiAcquisitionId: 9,productName: '维度十一', dimension: '0904', cmdCode: 'sd',paramCode: 'serwer',acquisitionNode: 'dfwsefwe'},
          {aiAcquisitionId: 10,productName: '维度十二', dimension: '5004', cmdCode: 'erw',paramCode: 'serwer',acquisitionNode: 'dfwsefwe'},
        ],
        total: 23
      };
      return new Promise(function (resolve, reject) {
        setTimeout(function () { resolve(data) },0);
      })*/
    }

    function creatAcquisition(entity) {
      const resourceUrl = '/api/ml/updateOrInsertIntelligence';
      return $http.post(resourceUrl,entity,{headers : {'Content-Type': 'application/json;charset=utf-8'}})
        .then(function (response) {
          return response.data;
        })
    }

    function deleteAcquisition(entity) {
      console.log('deleteAcquisition -> entity', entity);
      var resourceUrl = '/api/ml/deleteIntelligence';
      return $http.post(resourceUrl,entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (res) {
        return res.data;
      })
    }

  }
})();

/**
 * Created by gumei.wang 2019/10/25.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AiAcquisitionController', AiAcquisitionController);

  AiAcquisitionController.$inject = ['$filter', 'AiAcquisitionService','toastr','toastrConfig','$state','SweetAlert','paginationConstants'];
  /** @ngInject */
  function AiAcquisitionController($filter, AiAcquisitionService,toastr,toastrConfig,$state,SweetAlert,paginationConstants) {
    var vm = this;
    vm.page = 1;
    vm.pageSize = 10;
    vm.acquisition = {};
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.getAcquisition = getAcquisition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.deleteAcquisition = deleteAcquisition;
    vm.deleteAcquisitions = deleteAcquisitions;
    vm.checkAllAcquisition = checkAllAcquisition;
    vm.checkAcquisition = checkAcquisition;

    vm.getAcquisition();

    function reset() {
      vm.page = 1;
      vm.pageSize = 10;
      vm.acquisition = {};
    }

    function getAcquisition() {
      vm.pageSize = paginationConstants.itemsPerPage;
      return AiAcquisitionService.getAcquisition(vm.acquisition, vm.page, vm.pageSize).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.acquisitions = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      });
    }

    function deleteAcquisition(acquisition) {
      SweetAlert.confirm($filter('T')('productImage.deleteTip'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          var acquisitions = [];
          acquisitions.push(acquisition);
          AiAcquisitionService.deleteAcquisition(acquisitions).then(function (data){
            if(data.success){
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
              return $state.go('aiAcquisition', null, {reload: 'aiAcquisition'});
            }
          })
        }
      })
    }

    function deleteAcquisitions() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var acquisitions = new Array();
          $(arrChk).each(function() {
            acquisitions.push(this.value);
          });
          AiAcquisitionService.deleteAcquisition(acquisitions).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getAcquisition();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //check or unCheck all check link
    function checkAllAcquisition() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }

    //check or unCheck check link
    function checkAcquisition() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    function pageChanged() {
      vm.getAcquisition();
    }

    function search() {
      vm.getAcquisition();
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('AiAcquisitionDialogController', AiAcquisitionDialogController);

  AiAcquisitionDialogController.$inject = ['entity', 'b2cApplicationService', 'SweetAlert', '$filter', '$state', 'AiAcquisitionService', '$uibModalInstance', 'toastr'];

  function AiAcquisitionDialogController(entity, b2cApplicationService, SweetAlert, $filter, $state, AiAcquisitionService, $uibModalInstance, toastr) {
    var vm = this;
    vm.acquisition = entity;
    vm.edit = false;
    vm.projects = [
      "admin",
      "commercial",
      "commercialApi",
      "commercialApp",
      "residential",
      "residentialApi",
      "devicePreProvisioning",
      "smartmirror",
      "smartmirrorApp"
    ];
    vm.title = $filter('T')('apConfig.addIntelligentAcquisition');

    vm.save = creatAcquisition;
    vm.judgeEditOrCreate = judgeEditOrCreate;
    vm.load = load;
    vm.clear = clear;
    vm.getAllDimension = getAllDimension;
    vm.changeAcquisitionNode = changeAcquisitionNode;
    vm.getAcquisitionNode = getAcquisitionNode;

    judgeEditOrCreate();
    vm.load();

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function judgeEditOrCreate() {
      if (entity.hasOwnProperty('collectionId')) {
        vm.edit = true;
        vm.title = $filter('T')('aiConfig.editIntelligentAcquisition');
      } else {
        vm.title = $filter('T')('aiConfig.addIntelligentAcquisition');
      }
    }

    function load() {
      getAcquisitionNode();
      getAllDimension();
      vm.title = 'aiConfig.addIntelligentAcquisition';
      if (vm.edit) {
        vm.title = 'aiConfig.editIntelligentAcquisition';
        AiAcquisitionService.getAcquisition(vm.acquisition, 1, -1)
        .then(function (data) {
          if (data.success) {
            vm.acquisition = data.rows[0];
          }
        });
      }
    }


    function creatAcquisition() {
      AiAcquisitionService.creatAcquisition(vm.acquisition)
      .then(function (data) {
        if (data.success) {
          SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
          .then(function () {
            $uibModalInstance.close();
            $state.go('aiAcquisition', null, {reload: true});
          })
        }
        else {
          SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
        }
      })
    }

    function getAllDimension() {
      return AiAcquisitionService.getAllDimension({}, 1, -1).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.dimensions = data.rows;
      });
    }

    function changeAcquisitionNode(acquisitionNodeTmp) {
      var acquisitionNode = JSON.parse(acquisitionNodeTmp);
      vm.acquisition.productId = acquisitionNode.productId;
      console.log('changeDimension -> productName', acquisitionNode.productName);
      return AiAcquisitionService.getAcquisitionNode({productName: acquisitionNode.productName}, 1, -1).then(function (data) {
        if (data.rows) {
          vm.acquisition.collectionNodeId = data.rows[0].collectionNodeId;
          vm.acquisition.collectionNodeCode = data.rows[0].collectionNodeCode;
        }

        console.log('vm.acquisition', vm.acquisition);
      });
    }

    function getAcquisitionNode() {
      return AiAcquisitionService.getAcquisitionNode({}, 1, -1).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.acquisitionNodes = data.rows;
      })
    }

  }
})();

/**
 * Created by gumei.wang 2019/10/25.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AcquisitionNodeController', AcquisitionNodeController);

  AcquisitionNodeController.$inject = ['$filter', 'AiAcquisitionService','toastr','toastrConfig','$state','SweetAlert','paginationConstants'];
  /** @ngInject */
  function AcquisitionNodeController($filter, AiAcquisitionService,toastr,toastrConfig,$state,SweetAlert,paginationConstants) {
    var vm = this;
    vm.page = 1;
    vm.pageSize = 10;
    vm.acquisitionNode = {};
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.getAcquisitionNode = getAcquisitionNode;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.deleteAcquisitionNode = deleteAcquisitionNode;
    vm.deleteAcquisitionNodes = deleteAcquisitionNodes;
    vm.checkAllAcquisitionNode = checkAllAcquisitionNode;
    vm.checkAcquisitionNode = checkAcquisitionNode;

    vm.getAcquisitionNode();

    function reset() {
      vm.page = 1;
      vm.pageSize = 10;
      vm.acquisitionNode = {};
    }

    function getAcquisitionNode() {
      vm.pageSize = paginationConstants.itemsPerPage;
      return AiAcquisitionService.getAcquisitionNode(vm.acquisitionNode, vm.page, vm.pageSize).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.acquisitionNodes = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      });
    }

    function deleteAcquisitionNode(node) {
      SweetAlert.confirm($filter('T')('productImage.deleteTip'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          var nodes = [];
          nodes.push(node);
          AiAcquisitionService.deleteAcquisitionNode(nodes).then(function (data){
            if(data.success){
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
              return $state.go('acquisitionNode', null, {reload: 'acquisitionNode'});
            }
          })
        }
      })
    }

    function deleteAcquisitionNodes() {
      var isCheck = $(".chk_list").is(':checked');
      if(!isCheck) {
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return;
      }
      SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var arrChk = $("input[name='chk_list']:checked");
          var nodes = new Array();
          $(arrChk).each(function() {
            nodes.push(this.value);
          });
          AiAcquisitionService.deleteAcquisitionNode(nodes).then(function (response) {
            document.getElementById("chk_all").checked = false;
            var items = document.getElementsByName("chk_list");
            for(var j = 0; j < items.length; j++){
              items[j].checked = false;
            }
            if (response.success) {
              vm.getAcquisitionNode();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //check or unCheck all check link
    function checkAllAcquisitionNode() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }

    //check or unCheck check link
    function checkAcquisitionNode() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    function pageChanged() {
      vm.getAcquisitionNode();
    }

    function search() {
      vm.getAcquisitionNode();
    }



    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('AcquisitionNodeDialogController', AcquisitionNodeDialogController);

  AcquisitionNodeDialogController.$inject = ['entity', 'b2cApplicationService', 'SweetAlert', '$filter', '$state', 'AiAcquisitionService', '$uibModalInstance', 'toastr'];

  function AcquisitionNodeDialogController(entity, b2cApplicationService, SweetAlert, $filter, $state, AiAcquisitionService, $uibModalInstance, toastr) {
    var vm = this;
    vm.acquisitionNode = entity;
    vm.edit = false;
    vm.projects = [
      "admin",
      "commercial",
      "commercialApi",
      "commercialApp",
      "residential",
      "residentialApi",
      "devicePreProvisioning",
      "smartmirror",
      "smartmirrorApp"
    ];
    vm.title = $filter('T')('apConfig.addAcquisitionNode');

    vm.save = creatAcquisitionNode;
    //vm.getApplication = getApplication;
    vm.judgeEditOrCreate = judgeEditOrCreate;
    vm.load = load;
    vm.clear = clear;
    vm.getValidProduct = getValidProduct;

    judgeEditOrCreate();
    vm.load();

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function judgeEditOrCreate() {
      if (entity.hasOwnProperty('collectionNodeId')) {
        vm.edit = true;
        vm.title = $filter('T')('aiConfig.editAcquisitionNode');
      } else {
        vm.title = $filter('T')('aiConfig.addAcquisitionNode');
      }
    }

    function load() {
      getValidProduct();
      vm.title = 'aiConfig.addAcquisitionNode';
      if (vm.edit) {
        vm.title = 'aiConfig.editAcquisitionNode';
        AiAcquisitionService.getAcquisitionNode(vm.acquisitionNode, 1, -1)
        .then(function (data) {
          if (data.success) {
            vm.acquisitionNode = data.rows[0];
          }
        });
      }
    }

    function creatAcquisitionNode() {
      AiAcquisitionService.creatAcquisitionNode(vm.acquisitionNode)
      .then(function (data) {
        if (data.success) {
          SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
          .then(function () {
            $uibModalInstance.close();
            $state.go('acquisitionNode', null, {reload: true});
          })
        }
        else {
          SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
        }
      })
    }

    function getValidProduct() {
      return AiAcquisitionService.getValidProduct().then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.products = data.rows;
      });
    }

  }

})();

/**
 * Created by JaysonJia on 2023/12/12.
 */
(function () {
  "use strict";
  angular.module("hmapFront").config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider.state("userRegion", {
      parent: "app",
      url: "/userRegion",
      views: {
        body: {
          templateUrl: "app/iot/portal/admin/analysis/html/userRegion.html",
          controller: "UserRegionController",
          controllerAs: "vm",
        },
      },
      resolve: {
        entity: function () {
          return {};
        },
      },
    });
  }
})();

/**
 * Created by JaysonJia on 2023/12/12.
 */
(function () {
  "use strict";
  angular
    .module("hmapFront")
    .controller("UserRegionController", UserRegionController);
  UserRegionController.$inject = [
    "BaseConfig",
    "$localStorage",
    "AnalysisService",
    "$translate",
    "entity",
    "$filter",
  ];
  function UserRegionController(
    BaseConfig,
    $localStorage,
    AnalysisService,
    $translate,
    entity,
    $filter
  ) {
    var vm = this;

    var eContainerTotal = document.getElementById("eContainerTotal");
    var eCharts1 = document.getElementById("pie1");
    var eCharts2 = document.getElementById("pie2");
    var eCharts3 = document.getElementById("pie3");
    //chart auto height and width to window
    var resizeWorldMapContainer = function () {
      eCharts1.style.width = eContainerTotal.clientWidth - 6 + "px";
      eCharts1.style.height = eContainerTotal.clientHeight + "px";
      eCharts2.style.width = eContainerTotal.clientWidth - 6 + "px";
      eCharts2.style.height = eContainerTotal.clientHeight + "px";
      eCharts3.style.width = eContainerTotal.clientWidth - 6 + "px";
      eCharts3.style.height = eContainerTotal.clientHeight + "px";
    };
    resizeWorldMapContainer();
    $("#eContainerTotal").resize(function () {
      resizeWorldMapContainer();
      pie1.resize();
      pie2.resize();
      pie3.resize();
    });

    var pie1 = echarts.init(eCharts1);
    var pie2 = echarts.init(eCharts2);
    var pie3 = echarts.init(eCharts3);

    vm.getUserStatistics = getUserStatistics;
    vm.getUserStatistics();

    function getUserStatistics() {
      // 先用一个其它接口替代一下，由于 getUserStatistics 没有部署到dev上
      AnalysisService.getUserStatistics().then(function (data) {
        console.log(data);

        // if(!data.rows){
        //   return;
        // }

        // 性别分布
        var title = data.rows[0].gender;
        var text = $translate.instant("dataAnalysis.userGenderDis");
        var option = {
          title: {
            text: text,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c}({d}%)",
          },
          legend: {
            data: title,
            top: "10%",
            left: "0%",
            orient: "vertical",
          },
          grid: {
            top: "10%",
          },
          series: [
            {
              name: text,
              type: "pie",
              radius: "60%",
              data: data.rows[0].gender,
            },
          ],
        };
        if (data.rows[0].gender.length == 0) {
          var noDataTitle = $filter("T")("main.ios");
          var noData = $filter("T")("alert.noData");
          $("#pie1").html(
            '<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' +
              noDataTitle +
              '</div><div style="margin-left: 30%; margin-top: 145px">' +
              noData +
              "</div></div>"
          );
          vm.pie1NotData = true;
        } else {
          if (vm.pie1NotData) {
            $("#pie1").empty();
            pie1 = echarts.init(document.getElementById("pie1"));
            vm.pie1NotData = false;
          }
          pie1.setOption(option);
          pie1.on("click", function (param) {});
        }

        // 年龄分布
        var title = data.rows[0].age;
        var text = $translate.instant("dataAnalysis.userAgeDis");
        var option = {
          title: {
            text: text,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c}({d}%)",
          },
          legend: {
            data: title,
            top: "10%",
            left: "0%",
            orient: "vertical",
          },
          grid: {
            top: "10%",
          },
          series: {
            name: text,
            type: "pie",
            radius: "60%",
            data: data.rows[0].age,
          },
        };
        if (data.rows[0].gender.length == 0) {
          var noDataTitle = $filter("T")("main.ios");
          var noData = $filter("T")("alert.noData");
          $("#pie2").html(
            '<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' +
              noDataTitle +
              '</div><div style="margin-left: 30%; margin-top: 145px">' +
              noData +
              "</div></div>"
          );
          vm.pie2NotData = true;
        } else {
          if (vm.pie2NotData) {
            $("#pie2").empty();
            pie2 = echarts.init(document.getElementById("pie2"));
            vm.pie2NotData = false;
          }
          pie2.setOption(option);
          pie2.on("click", function (param) {});
        }

        //区域分布
        var title = data.rows[0].region;
        var text = $translate.instant("dataAnalysis.userAreaDis");
        var option = {
          title: {
            text: text,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c}({d}%)",
          },
          legend: {
            data: title,
            top: "10%",
            left: "0%",
            orient: "vertical",
            type: "scroll",
          },
          grid: {
            top: "10%",
          },
          series: {
            name: text,
            type: "pie",
            radius: "60%",
            data: data.rows[0].region,
          },
        };
        if (data.rows[0].gender.length == 0) {
          var noDataTitle = $filter("T")("main.ios");
          var noData = $filter("T")("alert.noData");
          $("#pie3").html(
            '<div style="height: 357px"><div style="color: #3c3c3c; font-weight:bolder; font-size: 18px; margin-left: 5px; padding-top: 2px">' +
              noDataTitle +
              '</div><div style="margin-left: 30%; margin-top: 145px">' +
              noData +
              "</div></div>"
          );
          vm.pie3NotData = true;
        } else {
          if (vm.pie3NotData) {
            $("#pie3").empty();
            pie3 = echarts.init(document.getElementById("pie3"));
            vm.pie3NotData = false;
          }
          pie3.setOption(option);
          pie3.on("click", function (param) {});
        }
      });
    }
  }
})();

/**
 * Created by JaysonJia on 2023/12/12.
 */
(function () {
  "use strict";
  angular.module("hmapFront").config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider.state("userActivity", {
      parent: "app",
      url: "/userActivity",
      views: {
        body: {
          templateUrl: "app/iot/portal/admin/analysis/html/userActivity.html",
          controller: "UserActivityController",
          controllerAs: "vm",
        },
      },
      resolve: {
        entity: function () {
          return {};
        },
      },
    });
  }
})();

/**
 * Created by JaysonJia on 2023/12/12.
 */
(function () {
  "use strict";
  angular
    .module("hmapFront")
    .controller("UserActivityController", UserActivityController);
  UserActivityController.$inject = [
    "BaseConfig",
    "$localStorage",
    "AnalysisService",
    "CodingValueService",
    "entity",
    "SweetAlert",
    "$filter",
  ];
  function UserActivityController(
    BaseConfig,
    $localStorage,
    AnalysisService,
    CodingValueService,
    entity,
    SweetAlert,
    $filter
  ) {
    var vm = this;
    vm.deviceActivity = entity;
    vm.page = 1;
    vm.totalDevices = 0;
    vm.sevenDaysDevices = 0;
    vm.thirtyDaysDevices = 0;

    var eContainerTotal = document.getElementById("eContainerTotal");
    var eCharts7 = document.getElementById("pie7");
    var eCharts8 = document.getElementById("pie8");

    //chart auto height and width to window
    var resizeWorldMapContainer = function () {
      eCharts7.style.width = eContainerTotal.clientWidth - 6 + "px";
      eCharts7.style.height = eContainerTotal.clientHeight + "px";
      eCharts8.style.width = eContainerTotal.clientWidth - 6 + "px";
      eCharts8.style.height = eContainerTotal.clientHeight + "px";
    };
    resizeWorldMapContainer();
    $("#eContainerTotal").resize(function () {
      resizeWorldMapContainer();
      pie7.resize();
      pie8.resize();
    });

    var pie7 = echarts.init(document.getElementById("pie7"));
    var pie8 = echarts.init(document.getElementById("pie8"));

    vm.deviceActivity.region = "";
    vm.deviceActivity.moduleType = "";
    vm.deviceActivity.productCode = "";
    vm.deviceActivity.productType = "";
    vm.deviceActivity.startDateTime = "";
    vm.deviceActivity.endDateTime = "";
    vm.deviceActivity.cmdCode = "";
    vm.deviceActivity.cmdSource = "residential";
    vm.typeList = ["day", "month"];
    vm.deviceActivity.queryType = vm.typeList[0];

    vm.getActiveUsers = getActiveUsers;
    vm.getActiveUsesByCode = getActiveUsesByCode;
    vm.getActiveVoiceUsers = getActiveVoiceUsers;

    vm.getProduct = getProduct;
    vm.getProvinceList = getProvinceList;
    vm.searchDeviceActivity = searchDeviceActivity;
    vm.resetDeviceActivity = resetDeviceActivity;
    vm.initWidget = initWidget;
    vm.compareDate = compareDate;

    vm.getActiveUsers();
    vm.getActiveVoiceUsers();

    vm.getProduct();
    vm.getProvinceList();
    vm.initWidget();

    // 获取用户活跃数
    function getActiveUsers() {
      AnalysisService.getActiveUsers(vm.deviceActivity).then(function (data) {
        if (!data.rows) {
          return;
        }

        var xArrayData = [];
        var yArrayData = [];
        for (var i in data.rows) {
          xArrayData[i] = data.rows[i].date;
          yArrayData[i] = data.rows[i].count;
        }
        var title = $filter("T")("dataAnalysis.userActivity");
        var option = {
          title: {
            text: title,
            left: "auto",
            top: "auto",
            textStyle: {
              color: "#333",
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: [$filter("T")("dataAnalysis.userActiveNumber")],
            top: "6%",
            left: "42%",
          },
          grid: {
            right: "4%",
            left: "5%",
          },
          xAxis: {
            boundaryGap: false,
            data: xArrayData,
          },
          yAxis: {},
          series: [
            {
              name: $filter("T")("dataAnalysis.userActiveNumber"),
              type: "line",
              data: yArrayData,
            },
          ],
        };

        var emptyOption = {
          title: {
            show: true,
            textStyle: {
              color: "#bcbcbc",
            },
            text: "暂无数据",
            left: "center",
            top: "center",
          },
          series: [
            {
              data: [],
            },
          ],
        };

        if (data.rows.length == 0) {
          pie7.setOption(emptyOption);
        } else {
          pie7.setOption(option);
          pie7.on("click", function (param) {});
        }
      });
    }

    // 根据sendCommand 获取用户活跃数，查询某个发送某个命令, 发送了多少次
    function getActiveUsesByCode() {
      AnalysisService.getActiveUsersByCode(vm.deviceActivity).then(function (
        data
      ) {
        if (!data.rows) {
          return;
        }

        var xArrayData = [];
        var yArrayData = [];
        for (var i in data.rows) {
          xArrayData[i] = data.rows[i].date;
          yArrayData[i] = data.rows[i].count;
        }
        var title = $filter("T")("dataAnalysis.userActivity");
        var option = {
          title: {
            text: title,
            left: "auto",
            top: "auto",
            textStyle: {
              color: "#333",
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: [$filter("T")("dataAnalysis.userActiveNumber")],
            top: "6%",
            left: "42%",
          },
          grid: {
            right: "4%",
            left: "5%",
          },
          xAxis: {
            boundaryGap: false,
            data: xArrayData,
          },
          yAxis: {},
          series: [
            {
              name: $filter("T")("dataAnalysis.userActiveNumber"),
              type: "line",
              data: yArrayData,
            },
          ],
        };

        var emptyOption = {
          title: {
            show: true,
            textStyle: {
              color: "#bcbcbc",
            },
            text: "暂无数据",
            left: "center",
            top: "center",
          },
          series: [
            {
              data: [],
            },
          ],
        };

        if (data.rows.length == 0) {
          pie7.setOption(emptyOption);
        } else {
          pie7.setOption(option);
          pie7.on("click", function (param) {});
        }
      });
    }

    function getActiveVoiceUsers() {
      AnalysisService.getActiveVoiceUser(vm.deviceActivity).then(function (
        data
      ) {
        if (!data.rows) {
          return;
        }

        var xArrayData = [];
        var yArrayData = [];
        for (var i in data.rows) {
          xArrayData[i] = data.rows[i].date;
          yArrayData[i] = data.rows[i].count;
        }
        var title = $filter("T")("dataAnalysis.voiceUserActivity");
        var option = {
          title: {
            text: title,
            left: "auto",
            top: "auto",
            textStyle: {
              color: "#333",
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: [$filter("T")("dataAnalysis.userActiveNumber")],
            top: "6%",
            left: "42%",
          },
          grid: {
            right: "4%",
            left: "5%",
          },
          xAxis: {
            boundaryGap: false,
            data: xArrayData,
          },
          yAxis: {},
          series: [
            {
              name: $filter("T")("dataAnalysis.userActiveNumber"),
              type: "line",
              data: yArrayData,
            },
          ],
        };

        var emptyOption = {
          title: {
            show: true,
            textStyle: {
              color: "#bcbcbc",
            },
            text: "语音活跃用户 - 暂无数据",
            left: "center",
            top: "center",
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: [$filter("T")("dataAnalysis.userActiveNumber")],
            top: "6%",
            left: "42%",
          },
          grid: {
            right: "4%",
            left: "5%",
          },
          xAxis: {
            boundaryGap: false,
            data: [],
          },
          yAxis: {},
          series: [
            {
              name: $filter("T")("dataAnalysis.userActiveNumber"),
              type: "line",
              data: [],
            },
          ],
        };
        if (data.rows.length == 0) {
          pie8.setOption(emptyOption);
        } else {
          pie8.setOption(option);
          pie8.on("click", function (param) {});
        }
      });
    }

    // 获取产品列表
    function getProduct() {
      return AnalysisService.queryResidentialProductExcBox({}).then(function (
        data
      ) {
        if (!data.rows) {
          return;
        }
        vm.products = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      });
    }

    // 获取省份列表
    function getProvinceList() {
      return AnalysisService.getProvinceCode("zh_CN").then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.provinceList = data.rows;
      });
    }

    // 搜索活跃设备
    function searchDeviceActivity() {
      if (vm.deviceActivity.cmdCode != "") {
        vm.getActiveUsesByCode();
      } else {
        vm.getActiveUsers();
      }
      vm.getActiveVoiceUsers();
    }

    // 首先定义一个getPreviousDate函数，方便调用
    function getPreviousDate(numOfDays) {
      var date = new Date();
      date.setDate(date.getDate() - numOfDays);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var day = date.getDate();
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    }

    function getCurrentDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var day = date.getDate();
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    }

    //reset search condition
    function resetDeviceActivity() {
      vm.deviceActivity.region = "";
      vm.deviceActivity.moduleType = "";
      vm.deviceActivity.productCode = "";
      vm.deviceActivity.productType = "";
      vm.deviceActivity.queryType = vm.typeList[0];
      vm.deviceActivity.startDateTime = "";
      vm.deviceActivity.endDateTime = "";
      vm.deviceActivity.cmdCode = "";
    }

    function initWidget() {
      // get iot protocol type
      CodingValueService.findCodeValuesByCodeValue({ codeId: 12019 }).then(
        function (tagDatas) {
          if (tagDatas) {
            vm.moduleList = tagDatas.rows;
          }
        }
      );
      // get all product type
      AnalysisService.getAllProductType({}, 1, 50).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.productTypes = data.rows;
      });
    }

    //data plugin
    $(".form_date").datetimepicker({
      language: vm.lang,
      format: "yyyy-mm-dd",
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0,
    });

    //compare date
    function compareDate() {
      var start = $("#start").val();
      var end = $("#end").val();
      if (start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if (startTime > endTime) {
          var msg = $filter("T")("main.msg");
          vm.onLine.endTime = "";
          SweetAlert.error(msg, { title: $filter("T")("btnTypeName.prompt") });
        }
      }
    }
  }
})();

/**
 * Created by JaysonJia on 2023/11/09.
 */
(function () {
  "use strict";
  angular.module("hmapFront").config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider.state("top10Commands", {
      parent: "app",
      url: "/top10Commands",
      views: {
        body: {
          templateUrl: "app/iot/portal/admin/analysis/html/top10commands.html",
          controller: "Top10CommandsController",
          controllerAs: "vm",
        },
      },
      resolve: {
        entity: function () {
          return {};
        },
      },
    });
  }
})();

/**
 * Created by JaysonJia on 2023/11/09.
 */
(function () {
  "use strict";
  angular
    .module("hmapFront")
    .controller("Top10CommandsController", Top10CommandsController);
  Top10CommandsController.$inject = [
    "BaseConfig",
    "$localStorage",
    "AnalysisService",
    "CodingValueService",
    "entity",
    "SweetAlert",
    "$filter",
  ];
  function Top10CommandsController(
    BaseConfig,
    $localStorage,
    AnalysisService,
    CodingValueService,
    entity,
    SweetAlert,
    $filter
  ) {
    var vm = this;
    vm.top10Commands = entity;
    vm.page = 1;
    // vm.top10Commands.cmdSource='residentialApi';

    vm.top10Commands.region = "";
    vm.top10Commands.moduleType = "";
    vm.top10Commands.productCode = "";
    vm.top10Commands.productType = "";
    vm.top10Commands.startDateTime = "";
    vm.top10Commands.endDateTime = "";

    vm.getResidentialTop10Commands = getResidentialTop10Commands;
    vm.getProduct = getProduct;
    vm.getProvinceList = getProvinceList;
    vm.searchTop10Commands = searchTop10Commands;
    vm.resetTop10Commands = resetTop10Commands;
    vm.initWidget = initWidget;
    vm.compareDate = compareDate;

    // vm.getResidentialDevice();
    vm.getResidentialTop10Commands();
    vm.getProduct();
    vm.getProvinceList();
    vm.initWidget();

    // get top10 commands
    function getResidentialTop10Commands() {
      return AnalysisService.queryTop10Commands(vm.top10Commands).then(
        function (data) {
          if (!data.rows) {
            return;
          }
          vm.devices = data.rows;
        }
      );
    }

    //get product
    function getProduct() {
      return AnalysisService.queryResidentialProductExcBox({}).then(function (
        data
      ) {
        if (!data.rows) {
          return;
        }
        vm.products = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      });
    }
    //search dvmDevice
    function searchTop10Commands() {
      vm.getResidentialTop10Commands();
    }

    //reset search condition
    function resetTop10Commands() {
      vm.top10Commands.region = "";
      vm.top10Commands.moduleType = "";
      vm.top10Commands.productCode = "";
      vm.top10Commands.productType = "";
      vm.top10Commands.startDateTime = "";
      vm.top10Commands.endDateTime = "";
    }

    function initWidget() {
      // get iot protocol type
      CodingValueService.findCodeValuesByCodeValue({ codeId: 12019 }).then(
        function (tagDatas) {
          if (tagDatas) {
            vm.moduleList = tagDatas.rows;
          }
        }
      );
      // get all product type
      AnalysisService.getAllProductType({}, 1, 50).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.productTypes = data.rows;
      });
    }

    //data plugin
    $(".form_date").datetimepicker({
      language: vm.lang,
      format: "yyyy-mm-dd",
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0,
    });

    //compare date
    function compareDate() {
      var start = $("#start").val();
      var end = $("#end").val();
      if (start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if (startTime > endTime) {
          var msg = $filter("T")("main.msg");
          vm.onLine.endTime = "";
          SweetAlert.error(msg, { title: $filter("T")("btnTypeName.prompt") });
        }
      }
    }

    // 获取省份列表
    function getProvinceList() {
      return AnalysisService.getProvinceCode("zh_CN").then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.provinceList = data.rows;
      });
    }
  }
})();

/**
 * Created by JaysonJia on 2023/11/09.
 */
(function () {
  "use strict";
  angular.module("hmapFront").config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider.state("productStatus", {
      parent: "app",
      url: "/productStatus",
      views: {
        body: {
          templateUrl: "app/iot/portal/admin/analysis/html/productStatus.html",
          controller: "ProductStatusController",
          controllerAs: "vm",
        },
      },
      resolve: {
        entity: function () {
          return {};
        },
      },
    });
  }
})();

/**
 * Created by JaysonJia on 2023/11/09.
 */
(function () {
  "use strict";
  angular
    .module("hmapFront")
    .controller("ProductStatusController", ProductStatusController);
  ProductStatusController.$inject = [
    "BaseConfig",
    "$localStorage",
    "AnalysisService",
    "CodingValueService",
    "entity",
    "SweetAlert",
    "$filter",
  ];
  function ProductStatusController(
    BaseConfig,
    $localStorage,
    AnalysisService,
    CodingValueService,
    entity,
    SweetAlert,
    $filter
  ) {
    var vm = this;
    vm.lang = $localStorage.lang || BaseConfig.lang;
    vm.productStatus = entity;

    var eContainerTotal = document.getElementById("eContainerTotal");
    var eCharts7 = document.getElementById("pie7");
    var eCharts8 = document.getElementById("pie8");

    //chart auto height and width to window
    var resizeWorldMapContainer = function () {
      // 柱状图区域
      eCharts7.style.width = eContainerTotal.clientWidth - 6 + "px";
      eCharts7.style.height = eContainerTotal.clientHeight + "px";

      // 饼图区域（父容器）
      eCharts8.style.width = eContainerTotal.clientWidth - 6 + "px";
      eCharts8.style.height = eContainerTotal.clientHeight + "px";

      // 子饼图自适应宽高
      ["pie8_morning", "pie8_afternoon", "pie8_evening"].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) {
          el.style.width = eCharts8.clientWidth / 3 - 10 + "px"; // 平均分三块
          el.style.height = eCharts8.clientHeight + "px";
        }
      });
    };
    resizeWorldMapContainer();

    $("#eContainerTotal").resize(function () {
      resizeWorldMapContainer();
      if (pie7) pie7.resize();

      // 三个饼图分别resize
      ["pie8_morning", "pie8_afternoon", "pie8_evening"].forEach(function (id) {
        var chart = echarts.getInstanceByDom(document.getElementById(id));
        if (chart) chart.resize();
      });
    });

    // 初始化柱状图
    var pie7 = echarts.init(document.getElementById("pie7"));

    vm.deviceCount = 0;

    vm.statusDataForList = [];

    vm.productStatus.productCode = "";
    vm.productStatus.startDateTime = "";
    vm.productStatus.endDateTime = "";
    vm.productStatus.cmdCode = "";

    vm.getProductStatusCode = getProductStatusCode;
    vm.getProductStatusByCode = getProductStatusByCode;

    vm.getProduct = getProduct;
    vm.searchProductStatusCode = searchProductStatusCode;
    vm.resetProductStatusCode = resetProductStatusCode;
    vm.compareDate = compareDate;

    vm.getProduct();

    // 获取产品状态码统计数据
    function getProductStatusCode() {
      vm.statusDataForList = [];

      return AnalysisService.getProductStatusCode({
        productCode: vm.productStatus.productCode,
        startDateTime: vm.productStatus.startDateTime,
        endDateTime: vm.productStatus.endDateTime,
      }).then(function (data) {
        // Handle empty data case
        if (!data || !data.rows || !data.rows.length) {
          // Clear and show "No Data" for bar chart
          pie7.clear();
          pie7.setOption({
            title: {
              text: "各时段状态总量\n(No Data)",
              left: "center",
            },
          });

          // Clear and show "No Data" for all pie charts
          ["pie8_morning", "pie8_afternoon", "pie8_evening"].forEach(function (
            id
          ) {
            var chart = echarts.getInstanceByDom(document.getElementById(id));
            if (chart) {
              chart.clear();
              chart.setOption({
                title: {
                  text:
                    id.split("_")[1].charAt(0).toUpperCase() +
                    id.split("_")[1].slice(1) +
                    "\n(No Data)",
                  left: "center",
                },
              });
            }
          });
          return;
        }

        vm.statusCodes = data.rows[0];
        vm.deviceCount = vm.statusCodes.deviceCount;
        renderBarChart(vm.statusCodes.cmdStatistics);
        renderPieChart(vm.statusCodes.cmdStatistics);
      });
    }
    // 根据cmdCode 获取活跃设备数，查询某个设备上报的status 使用了多少次
    function getProductStatusByCode() {
      return AnalysisService.getProductStatusByCode({
        productCode: vm.productStatus.productCode,
        startDateTime: vm.productStatus.startDateTime,
        endDateTime: vm.productStatus.endDateTime,
        cmdCode: vm.productStatus.cmdCode,
      }).then(function (data) {
        if (!data) {
          return;
        }
        vm.statusDataForList = processStatistics(data);
      });
    }

    /**
     * 将 API 返回的嵌套数据转换为卡片/列表视图结构
     * @param {object} apiResponse - 包含 rows 数组的 API 响应
     * @returns {Array} 转换后的列表数据
     */
    function processStatistics(apiResponse) {
      var processedData = [];

      if (apiResponse.rows && apiResponse.rows.length > 0) {
        apiResponse.rows.forEach(function (row) {
          var card = {
            productCode: row.productCode,
            cmdCode: row.cmdCode,
            deviceCount: row.deviceCount,
            timeStats: {}, // 存储 morning, afternoon, evening
          };

          var paramStats = row.paramStatistics;

          // 遍历 morning, afternoon, evening
          for (var time in paramStats) {
            if (paramStats.hasOwnProperty(time)) {
              card.timeStats[time] = []; // 准备存储展平后的参数列表

              var timeData = paramStats[time];
              // 遍历 SS, HOUR, MINUTE 等参数类别 (paramKey)
              for (var paramKey in timeData) {
                if (timeData.hasOwnProperty(paramKey)) {
                  var paramDetails = timeData[paramKey];

                  // 遍历 off, ring, 0 等具体参数值 (paramValue)
                  for (var paramValue in paramDetails) {
                    if (paramDetails.hasOwnProperty(paramValue)) {
                      // 将键值对展平为列表项
                      card.timeStats[time].push({
                        paramKey: paramKey,
                        paramValue: paramValue,
                        count: paramDetails[paramValue],
                      });
                    }
                  }
                }
              }
            }
          }
          processedData.push(card);
        });
      }
      return processedData;
    }

    function renderBarChart(cmdStatistics) {
      var timeKeys = Object.keys(cmdStatistics);
      var totalData = timeKeys.map(function (key) {
        var sum = 0;
        var status = cmdStatistics[key];
        for (var s in status) {
          sum += status[s];
        }
        return sum;
      });

      var option = {
        title: { text: "各时段状态总量", left: "center" },
        tooltip: {},
        xAxis: {
          type: "category",
          data: timeKeys.map(function (k) {
            return k;
          }),
        },
        yAxis: { type: "value" },
        series: [
          {
            name: "总量",
            type: "bar",
            data: totalData,
            itemStyle: { color: "#4B9EF5" },
          },
        ],
      };

      pie7.setOption(option);
    }

    function renderPieChart(cmdStatistics) {
      if (!cmdStatistics) return;

      // 各时段 key
      var periods = [
        { key: "morning(00:00-11:59)", title: "Morning", el: "pie8_morning" },
        {
          key: "afternoon(12:00-17:59)",
          title: "Afternoon",
          el: "pie8_afternoon",
        },
        { key: "evening(18:00-23:59)", title: "Evening", el: "pie8_evening" },
      ];

      periods.forEach(function (p) {
        var chartDom = document.getElementById(p.el);
        if (!chartDom) return;

        var myChart = echarts.init(chartDom);
        var data = cmdStatistics[p.key];
        if (!data) {
          myChart.clear();
          myChart.setOption({
            title: {
              text: p.title + "\n(No Data)",
              left: "center",
              top: "middle",
              textStyle: { fontSize: 14, color: "#999" },
            },
          });
          return;
        }

        var pieData = Object.keys(data).map(function (k) {
          return {
            name: k, // 去掉 STATUSXX 或 STATUSXX_ 前缀 .replace(/^STATUS\d*_?/, "")
            value: data[k],
          };
        });

        var option = {
          title: {
            text: p.title,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b}<br/>数量：{c} ({d}%)",
          },
          // legend: {
          //   type: "scroll", // 开启滚动分页
          //   orient: "vertical", // 垂直排列
          //   left: "0%", // 放在左侧
          //   top: "10%", // 从上方偏移一点
          //   bottom: "10%", // 到底部留空间
          //   pageIconColor: "#5470C6", // 翻页箭头颜色（可选）
          //   pageIconSize: 12, // 翻页箭头大小（可选）
          //   data: pieData.map(function (item) {
          //     return item.name;
          //   }),
          // },
          series: [
            {
              name: p.title,
              type: "pie",
              radius: "60%",
              center: ["50%", "55%"],
              data: pieData,
              label: {
                show: true,
                formatter: "{b}: {d}%",
                fontSize: 10,
              },
            },
          ],
        };

        myChart.setOption(option);
      });
    }

    //reset search condition
    function resetProductStatusCode() {
      vm.productStatus.productCode = "";
      vm.productStatus.startDateTime = "";
      vm.productStatus.endDateTime = "";
      vm.productStatus.cmdCode = "";
      vm.deviceCount = 0;
      // Clear bar chart completely
      pie7.clear();
      vm.statusDataForList = [];

      // Clear all pie charts completely
      ["pie8_morning", "pie8_afternoon", "pie8_evening"].forEach(function (id) {
        var chart = echarts.getInstanceByDom(document.getElementById(id));
        if (chart) {
          chart.clear();
        }
      });
    }

    //search
    function searchProductStatusCode() {
      if (!vm.productStatus.productCode) {
        var msg = $filter("T")("dataAnalysis.selectProduct");
        SweetAlert.error(msg, { title: $filter("T")("btnTypeName.prompt") });
        return;
      }

      if (!vm.productStatus.startDateTime || !vm.productStatus.endDateTime) {
        var msg = $filter("T")("dataAnalysis.selectPeriod");
        SweetAlert.error(msg, { title: $filter("T")("btnTypeName.prompt") });
        return;
      }
      compareDate();
      if (vm.productStatus.cmdCode != "") {
        vm.getProductStatusCode();
        vm.getProductStatusByCode();
      } else {
        vm.getProductStatusCode();
      }
    }

    // 获取产品列表
    function getProduct() {
      return AnalysisService.queryResidentialProductExcBox({}).then(function (
        data
      ) {
        if (!data.rows) {
          return;
        }
        vm.products = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      });
    }

    //data plugin
    $(".form_date").datetimepicker({
      language: vm.lang,
      format: "yyyy-mm-dd",
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0,
    });

    //compare date
    function compareDate() {
      var start = $("#start").val();
      var end = $("#end").val();
      if (start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if (startTime > endTime) {
          var msg = $filter("T")("main.msg");
          // vm.onLine.endTime = "";
          SweetAlert.error(msg, { title: $filter("T")("btnTypeName.prompt") });
        }
      }
    }
  }
})();

/**
 * Created by JaysonJia on 2023/11/09.
 */
(function () {
  "use strict";
  angular.module("hmapFront").config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider.state("deviceActivity", {
      parent: "app",
      url: "/deviceActivity",
      views: {
        body: {
          templateUrl: "app/iot/portal/admin/analysis/html/deviceActivity.html",
          controller: "DeviceActivityController",
          controllerAs: "vm",
        },
      },
      resolve: {
        entity: function () {
          return {};
        },
      },
    });
  }
})();

/**
 * Created by JaysonJia on 2023/11/09.
 */
(function () {
  "use strict";
  angular
    .module("hmapFront")
    .controller("DeviceActivityController", DeviceActivityController);
  DeviceActivityController.$inject = [
    "BaseConfig",
    "$localStorage",
    "AnalysisService",
    "CodingValueService",
    "entity",
    "SweetAlert",
    "$filter",
  ];
  function DeviceActivityController(
    BaseConfig,
    $localStorage,
    AnalysisService,
    CodingValueService,
    entity,
    SweetAlert,
    $filter
  ) {
    var vm = this;
    vm.deviceActivity = entity;
    vm.page = 1;
    vm.totalDevices = 0;
    vm.sevenDaysDevices = 0;
    vm.thirtyDaysDevices = 0;

    var eContainerTotal = document.getElementById("eContainerTotal");
    var eCharts7 = document.getElementById("pie7");

    //chart auto height and width to window
    var resizeWorldMapContainer = function () {
      eCharts7.style.width = eContainerTotal.clientWidth - 6 + "px";
      eCharts7.style.height = eContainerTotal.clientHeight + "px";
    };
    resizeWorldMapContainer();
    $("#eContainerTotal").resize(function () {
      resizeWorldMapContainer();
      pie7.resize();
    });

    var pie7 = echarts.init(document.getElementById("pie7"));

    vm.deviceActivity.region = "";
    vm.deviceActivity.moduleType = "";
    vm.deviceActivity.productCode = "";
    vm.deviceActivity.productType = "";
    vm.deviceActivity.startDateTime = "";
    vm.deviceActivity.endDateTime = "";
    vm.deviceActivity.cmdCode = "";

    vm.getActiveDevices = getActiveDevices;
    vm.getActiveDevicesByCode = getActiveDevicesByCode;
    vm.get7DaysActiveDevices = get7DaysActiveDevices;
    vm.get30DaysActiveDevices = get30DaysActiveDevices;
    vm.getTotalDevices = getTotalDevices;

    vm.getProduct = getProduct;
    vm.getProvinceList = getProvinceList;
    vm.searchDeviceActivity = searchDeviceActivity;
    vm.resetDeviceActivity = resetDeviceActivity;
    vm.initWidget = initWidget;
    vm.compareDate = compareDate;
    vm.typeList = ["day", "month"];
    vm.deviceActivity.queryType = vm.typeList[0];

    vm.getActiveDevices();

    vm.get7DaysActiveDevices();
    vm.get30DaysActiveDevices();
    vm.getTotalDevices();

    vm.getProduct();
    vm.getProvinceList();
    vm.initWidget();

    // 获取活跃设备数
    function getActiveDevices() {
      AnalysisService.getActiveDevices(vm.deviceActivity).then(function (data) {
        if (!data.rows) {
          return;
        }

        var xArrayData = [];
        var yArrayData = [];
        for (var i in data.rows) {
          xArrayData[i] = data.rows[i].date;
          yArrayData[i] = data.rows[i].count;
        }
        var title = $filter("T")("dataAnalysis.deviceActivity");
        var option = {
          title: {
            text: title,
            left: "auto",
            top: "auto",
            textStyle: {
              color: "#333",
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: [$filter("T")("dataAnalysis.deviceActiveNumber")],
            top: "6%",
            left: "42%",
          },
          grid: {
            right: "4%",
            left: "5%",
          },
          xAxis: {
            show: true,
            boundaryGap: false,
            data: xArrayData,
          },
          yAxis: {},
          series: [
            {
              name: $filter("T")("dataAnalysis.deviceActiveNumber"),
              type: "line",
              data: yArrayData,
            },
          ],
        };

        var emptyOption = {
          title: {
            show: true,
            textStyle: {
              color: "#bcbcbc",
            },
            text: "暂无数据",
            left: "center",
            top: "center",
          },
          series: [
            {
              data: [],
            },
          ],
        };

        if (data.rows.length == 0) {
          pie7.setOption(emptyOption);
        } else {
          pie7.setOption(option);
          pie7.on("click", function (param) {});
        }
      });
    }

    // 根据cmdCode 获取活跃设备数，查询某个设备上报的status 使用了多少次
    function getActiveDevicesByCode() {
      AnalysisService.getActiveDevicesByCode(vm.deviceActivity).then(function (
        data
      ) {
        if (!data.rows) {
          return;
        }

        var xArrayData = [];
        var yArrayData = [];
        for (var i in data.rows) {
          xArrayData[i] = data.rows[i].date;
          yArrayData[i] = data.rows[i].count;
        }
        var title = $filter("T")("dataAnalysis.deviceActivity");
        var option = {
          title: {
            text: title,
            left: "auto",
            top: "auto",
            textStyle: {
              color: "#333",
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: [$filter("T")("dataAnalysis.deviceActiveNumber")],
            top: "6%",
            left: "42%",
          },
          grid: {
            right: "4%",
            left: "5%",
          },
          xAxis: {
            show: true,
            boundaryGap: false,
            data: xArrayData,
          },
          yAxis: {},
          series: [
            {
              name: $filter("T")("dataAnalysis.deviceActiveNumber"),
              type: "line",
              data: yArrayData,
            },
          ],
        };

        var emptyOption = {
          title: {
            show: true,
            textStyle: {
              color: "#bcbcbc",
            },
            text: "暂无数据",
            left: "center",
            top: "center",
          },
          series: [
            {
              data: [],
            },
          ],
        };

        if (data.rows.length == 0) {
          pie7.setOption(emptyOption);
        } else {
          pie7.setOption(option);
          pie7.on("click", function (param) {});
        }
      });
    }

    // 获取7天活跃设备数
    function get7DaysActiveDevices() {
      var requestBody = {
        startDateTime: getPreviousDate(7),
        endDateTime: getCurrentDate(),
        queryType: "day",
      };
      AnalysisService.getDeviceOperationNumberById(requestBody).then(function (
        data
      ) {
        if (!data) {
          return;
        }
        vm.sevenDaysDevices = data.total;
      });
    }

    // 获取30天活跃设备数
    function get30DaysActiveDevices() {
      var requestBody = {
        startDateTime: getPreviousDate(30),
        endDateTime: getCurrentDate(),
        queryType: "day",
      };
      AnalysisService.getDeviceOperationNumberById(requestBody).then(function (
        data
      ) {
        if (!data) {
          return;
        }
        vm.thirtyDaysDevices = data.total;
      });
    }

    // 获取累计设备总数
    function getTotalDevices() {
      AnalysisService.queryTotalDevices().then(function (data) {
        if (!data) {
          return;
        }
        vm.totalDevices = data.total;
      });
    }

    // 获取产品列表
    function getProduct() {
      return AnalysisService.queryResidentialProductExcBox({}).then(function (
        data
      ) {
        if (!data.rows) {
          return;
        }
        vm.products = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      });
    }

    // 获取省份列表
    function getProvinceList() {
      return AnalysisService.getProvinceCode("zh_CN").then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.provinceList = data.rows;
      });
    }

    // 搜索活跃设备
    function searchDeviceActivity() {
      if (vm.deviceActivity.cmdCode != "") {
        vm.getActiveDevicesByCode();
      } else {
        vm.getActiveDevices();
      }
    }

    // 首先定义一个getPreviousDate函数，方便调用
    function getPreviousDate(numOfDays) {
      var date = new Date();
      date.setDate(date.getDate() - numOfDays);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var day = date.getDate();
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    }

    function getCurrentDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var day = date.getDate();
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    }

    //reset search condition
    function resetDeviceActivity() {
      vm.deviceActivity.region = "";
      vm.deviceActivity.moduleType = "";
      vm.deviceActivity.productCode = "";
      vm.deviceActivity.productType = "";
      vm.deviceActivity.queryType = vm.typeList[0];
      vm.deviceActivity.startDateTime = "";
      vm.deviceActivity.endDateTime = "";
      vm.deviceActivity.cmdCode = "";
    }

    function initWidget() {
      // get iot protocol type
      CodingValueService.findCodeValuesByCodeValue({ codeId: 12019 }).then(
        function (tagDatas) {
          if (tagDatas) {
            vm.moduleList = tagDatas.rows;
          }
        }
      );
      // get all product type
      AnalysisService.getAllProductType({}, 1, 50).then(function (data) {
        if (!data.rows) {
          return;
        }
        vm.productTypes = data.rows;
      });
    }

    //data plugin
    $(".form_date").datetimepicker({
      language: vm.lang,
      format: "yyyy-mm-dd",
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0,
    });

    //compare date
    function compareDate() {
      var start = $("#start").val();
      var end = $("#end").val();
      if (start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if (startTime > endTime) {
          var msg = $filter("T")("main.msg");
          vm.onLine.endTime = "";
          SweetAlert.error(msg, { title: $filter("T")("btnTypeName.prompt") });
        }
      }
    }
  }
})();

/**
 * Created by Jayson.Jia on 2023/11/9.
 */

(function () {
  "use strict";
  angular.module("hmapFront").factory("AnalysisService", AnalysisService);

  AnalysisService.$inject = ["$http"];

  function AnalysisService($http) {
    var service = {
      queryTop10Commands: queryTop10Commands,
      queryResidentialProductExcBox: getResidentialProductExcBox,
      getAllProductType: getAllProductType,
      getDeviceOperationNumberById: getDeviceOperationNumberById,
      queryTotalDevices: queryTotalDevices,
      getActiveDevices: getActiveDevices,
      getActiveDevicesByCode: getActiveDevicesByCode,
      getActiveUsers: getActiveUsers,
      getActiveUsersByCode: getActiveUsersByCode,
      getProvinceCode: getProvinceCode,
      getUserStatistics: getUserStatistics,
      getActiveVoiceUser: getActiveVoiceUser,
      getProductStatusCode: getProductStatusCode,
      getProductStatusByCode: getProductStatusByCode,
    };

    return service;

    function queryTop10Commands(entity) {
      var resourceUrl = "/api/datamining/command/queryTop10Commands";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    //get product
    function getResidentialProductExcBox(entity) {
      var resourceUrl = "/api/ctm/selectResProduct?pageSize=" + "-1";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    //get productType
    function getAllProductType(entity, page, pageSize) {
      var resourceUrl =
        "/api/dvm/queryProductType?page=" + page + "&pageSize=" + pageSize;
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getProvinceCode(lang) {
      var resourceUrl = "/api/sys/queryProviceCode/" + lang;
      return $http
        .get(resourceUrl, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getDeviceOperationNumberById(entity) {
      var resourceUrl = "/api/datamining/command/queryOperateNumberByDeviceId";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function queryTotalDevices() {
      var resourceUrl = "/api/device/queryTotalNumberOfDevice";
      return $http
        .get(resourceUrl, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getActiveDevices(entity) {
      var resourceUrl = "/api/datamining/status/queryActiveDevice";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getActiveDevicesByCode(entity) {
      var resourceUrl = "/api/datamining/status/queryByFunction";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getActiveUsers(entity) {
      var resourceUrl = "/api/datamining/command/queryOperateNumberByDate";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getActiveUsersByCode(entity) {
      var resourceUrl = "/api/datamining/command/queryByFunction";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getUserStatistics() {
      var resourceUrl = "/api/datamining/user/query/zh_CN";
      return $http
        .get(resourceUrl, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getActiveVoiceUser(entity) {
      var resourceUrl = "/api/datamining/query";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getProductStatusCode(entity) {
      var resourceUrl = "/api/datamining/status/dataStatistics";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }

    function getProductStatusByCode(entity) {
      var resourceUrl = "/api/datamining/status/dataStatisticsByCmdCode";
      return $http
        .post(resourceUrl, entity, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        })
        .then(function (response) {
          return response.data;
        });
    }
  }
})();

/**
 *  * @description directive for sweet alert
 * @author Tushar Borole
 * @createDate 18/04/2015
 * @version 1.0.3
 * @lastmodifiedDate 06/18/2015
 */



(function() {
  'use strict';


  // Check we have sweet alert js included
  if (angular.isUndefined(window.swal)) {
    throw "Please inlcude sweet alert js and css from http://t4t5.github.io/sweetalert/";
  }

  angular
    .module('hmapFront')
    .directive('sweetalert', sweetalert)
    .factory('SweetAlert', sweetalert_service);

  sweetalert.$inject = ['$parse'];

  /* @ngInject */
  function sweetalert($parse) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      link: link
    };
    return directive;

    function link(scope, element, attrs, controller) {
      var sweetElement = angular.element(element);
      sweetElement.click(function() {
        var sweetOptions = scope.$eval(attrs.sweetOptions);
        var sweetConfirmOption = scope.$eval(attrs.sweetConfirmOption);
        var sweetCancelOption = scope.$eval(attrs.sweetCancelOption);


        swal(sweetOptions,
          function(isConfirm) {
            if (isConfirm) {
              if (sweetConfirmOption) swal(sweetConfirmOption);
              if (attrs.sweetOnConfirm) scope.$evalAsync(attrs.sweetOnConfirm);

            } else {
              if (sweetCancelOption) swal(sweetCancelOption);
              if (attrs.sweetOnCancel) scope.$evalAsync(attrs.sweetOnCancel);
            }
          });

      })

    }
  }

  // Use SweetAlert as service
  //
  // swal() gets two arguments;
  // first argument is parameters Objects (with default values).
  // second argument is Callback function when clicking on "OK"/"Cancel", which is a promise.
  // register to the promise (using 'then') and handle the resolve / reject according to your business logic.
  //
  // Add 'SweetAlert' to your directive / controller / ect)
  // Use SweetAlert.confirm(msg, options) / SweetAlert.alert(msg, options) / SweetAlert.info(msg, options) / SweetAlert.success(msg, options)
  // pass arguments:
  // msg; String - The message to be displayed in the alert / confirm box (mandatory).
  // options; Object (optinal):
  //   title: String - the title of the box.
  //   type: String - "warning" / "info" / "error" / "success" / "" (empty string will not display a graphic icon).
  //   showCancelButton: Boolean - shows the "cancel" button (true will behave like confirm dialog, false will behave like alert dialog).
  // Use returned promise;
  //
  // SweetAlert.confirm("Are you sure?", {title : "Careful now!"})
  //           .then(function(p) { do something on success },
  //                 function(p) { do something on fail }
  //           );
  //
  // SweetAlert.success("You have successfully completed our poll!", {title: "Good job!"});

  sweetalert_service.$inject = ['$q','$filter'];

  function sweetalert_service($q,$filter) {
    function swal_alert(message, options) {
      return swal_confirm(message, angular.extend({
        title: "Alert",
        text: message,
        type: "warning",
        showCancelButton: false
      }, options));
    }

    function swal_info(message, options) {
      return swal_alert(message, angular.extend({
        type: "info"
      }, options));
    }

    function swal_success(message, options) {
      return swal_alert(message, angular.extend({
        type: "success"
      }, options));
    }

    function swal_error(message, options) {
      return swal_alert(message, angular.extend({
        type: "error"
      }, options));
    }

    function swal_confirm(message, options) {
      var defered = $q.defer();
      var options = angular.extend({
        title: "Alert",
        text: message,
        type: "warning",
        showCancelButton: true,
        confirmButtonText:$filter('T')("btnTypeName.okay"),
        cancelButtonText:$filter('T')("btnTypeName.cancel")
      }, options);
      swal(options, function(r) {
        defered.resolve(r);
      }, function(e) {
        defered.reject(e);
      });
      return defered.promise;
    }
    return {
      alert: swal_alert,
      confirm: swal_confirm,
      info: swal_info,
      success: swal_success,
      error: swal_error
    };
  }

})();


var filterModule = angular.module('hmapFront');

filterModule.filter("T", ['$translate', function($translate) {
    return function(key) {
        if(key){
            return $translate.instant(key);
        }
    };
}]);

/**
 * Created by user on 2017/4/11.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('webLogon', {
        parent: 'app',
        url: '/webLogon',
        params: {'url':null},
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/cmt/webLogon.html",
            controller: 'webLogonController',
            controllerAs: 'vm'
          }
        }
      });


  }
})();

/* eslint-disable angular/log */
/**
 * Created by user on 2017/4/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('webLogonService', webLogonService );

  webLogonService.$inject = ['$resource', '$http', '$state','$localStorage','$location'];

  function webLogonService($resource, $http, $state,$localStorage,$location) {

    var service = {
      logon: logon,
      outLogon: outLogon,
      tokenLogon : tokenLogon,
      jump:jump
    };
    return service;

    function logon(url) {

/*      console.log("-webLogonService--weblogon---" );
      console.log(window.to);*/
      var to = $localStorage.oauth_response;
      var toUrl = window.to;
      window.to=null;
      var resourceUrl = 'http://42.159.239.127:8080/api/oauth/authorize?' +
        'redirect_uri=' +toUrl+
        '&client_id=api_client' +
        '&response_type=code' +
        '&access_token='+to.access_token;
      location.href=resourceUrl;

    }

    function jump (url) {
      window.to=url;
     $state.go('webLogon',{url:url});
    }
    function outLogon() {
      $state.go('app');
    }

    function tokenLogon(url) {
     // console.log("-webLogonService--tokenLogon---" );
      var token = $localStorage.oauth_response;
     if(token==undefined||token==""||token==null){
       var tourl = url;
       $state.go('login',{url:tourl,type:'thirdParty'});
      }else{
       jump (url);
      }

    }



  }

})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('webLogonController', webLogonController);

  webLogonController.$inject = ['webLogonService', '$state','AuthServerProvider','$stateParams'];

  function webLogonController(webLogonService, $state ,$stateParams) {
    var vm = this;
    vm.logon = logon;
    vm.outLogon = outLogon;
    vm.tokenLogon = tokenLogon;
/*    console.log("---077770--"+window.to);
    console.log("---0000--"+$stateParams.url);*/
    function logon() {
     // console.log("---weblogon--"+$stateParams.toUrl);
      return webLogonService.logon($stateParams.toUrl);
    }

    function outLogon() {

     // console.log("---outLogon---" );
      return webLogonService.outLogon();
    }
    function tokenLogon(url) {
      //console.log("---tokenLogon---" );
      return webLogonService.tokenLogon(url);
    }
  }


})();

/**
 * Created by user on 2017/4/11.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('tokenLogon', {
        parent: 'app',
        url: "/tokenLogon",
        views: {
          'body': {
            templateUrl: "app/iot/portal/admin/cmt/tokenLogon.html",
            controller: 'webLogonController',
            controllerAs: 'vm'
          }
        }
      });


  }
})();

/**
 * Created by user on 2016/8/3.
 */
(function (){
  'use strict';

  angular.module('hmapFront')
    .controller('WfTempController',WfTempController);
    /** @ngInject */
    function WfTempController(WfSourceService,WfTempService,WfConditionTypeService,$state,$scope,paginationConstants,entity){
      var vm = this;
      vm.wfTemp = entity;
      vm.wfConditionType = {}
      vm.page = 1;
      vm.conditionPage = 1;
      vm.totalItems = null;
      vm.transition = transition;
      vm.pageChanged=pageChanged;
      vm.conditionPageChanged=conditionPageChanged;
      vm.itemsPerPage = paginationConstants.itemsPerPage;
      vm.wfTemp.page = vm.page;
      vm.wfConditionType.page =  vm.conditionPage;

      vm.wfTemp.pagesize = paginationConstants.itemsPerPage;
      vm.wfConditionType.pagesize =  paginationConstants.itemsPerPage;

      getWfSource(vm.wfTemp.sourceId);

    function getWfSource(id){
      WfSourceService.get().get({
        id:id
      }, function(data){
        //alert(11111)
        vm.wfTemp.apiHeaderId = data.rows[0].apiHeaderId;
        vm.wfTemp.apiHeaderName = data.rows[0].apiHeaderName;
        vm.wfTemp.getWfListApiName = data.rows[0].getWfListApiName;
        getWfTemps(vm.wfTemp);
        vm.wfConditionType.apiHeaderId = data.rows[0].apiHeaderId;
        getWfConditionTypes(vm.wfConditionType);
      }, function(){
        console.log('error');
      });
    }
      //获取模板
    function getWfTemps(wfTemp){
      WfTempService.getWfTemps().get({
        apiHeaderId:wfTemp.apiHeaderId,
        templateCode:wfTemp.templateCode,
        workflowName:wfTemp.workflowName,
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, function (data, headers) {
        vm.wfTempAll = data.rows;
        vm.totalItems =  data.total;
      }, function (error) {
        console.log('error');
      });
    }

  //获取查询条件
      function getWfConditionTypes(wfConditionType){
        WfConditionTypeService.getWfConditionTypes().get({
          apiHeaderId:wfConditionType.apiHeaderId,
          conditionTypeCode:wfConditionType.conditionTypeCode,
          conditionTypeName:wfConditionType.conditionTypeName,
          page: vm.conditionPage,
          pagesize: paginationConstants.itemsPerPage
        }, function (data, headers) {
          vm.wfConditionTypeAll = data.rows;
          vm.totalConditionItems =  data.total;
        }, function (error) {
          console.log('error');
        });
      }

      vm.search = function(){
        //每次搜索的时候把page设为 1
        vm.wfTemp.page = vm.page = 1;
        vm.wfTemp.pagesize = paginationConstants.itemsPerPage;

        getWfTemps(vm.wfTemp);
      }
      vm.searchConditionType = function(){
        //每次搜索的时候把page设为 1
        vm.wfConditionType.page = vm.conditionPage = 1;
        vm.wfConditionType.pagesize = paginationConstants.itemsPerPage;

        getWfConditionTypes(vm.wfConditionType);
      }

      vm.delete = function(id){
        WfTempService.delete().delete({id:id},
          function(data){
            getWfTemps(vm.wfTemp);
        },
        function(error){
          console.log('error');
        })
      }
      vm.editConditionType = function (id){
        $state.go('wfTemp.wfConditionTypeEdit',{id:id,sourceId:vm.wfTemp.sourceId});
      }
      vm.deleteConditionType = function(id){
        WfConditionTypeService.delete().delete({id:id},
          function(data){
            getWfConditionTypes(vm.wfConditionType);
          },
          function(error){
            console.log('error');
          })
      }

      function transition () {
        $state.transitionTo($state.$current, {
          page: vm.page
        });
      }

      function pageChanged() {
        console.log('Page changed to: ' +vm.page);
        vm.wfTemp.page = vm.page;
        vm.wfTemp.pagesize = paginationConstants.itemsPerPage;
        getWfTemps(vm.wfTemp);
      };

      function conditionPageChanged() {
        vm.wfConditionType.page = vm.conditionPage;
        vm.wfConditionType.pagesize = paginationConstants.itemsPerPage;
        getWfConditionTypes(vm.wfConditionType);
      };

      $scope.addHeader = function(){
        $state.go("addHeader");
      }
    };



})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('wfTemp', {
        parent: 'app',
        url: "/wfSource/:sourceId/wfTemp",
        views: {
          'body': {
            templateUrl: "app/workflowApv/wfTemp/wfTempList.html",
            controller: 'WfTempController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                page:null,
                pagesize:null,
                sourceId:$stateParams.sourceId
              };
            }
          ]
        }

      })
      .state('wfTemp.edit', {
        parent: 'app',
        url: "/wfSource/:sourceId/wfTemp/:id",
        views: {
          'body': {
            templateUrl: "app/workflowApv/wfTemp/editWfTemp.html",
            controller: 'EditWfTempController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                id:$stateParams.id,
                sourceId:$stateParams.sourceId
              };
            }
          ]
        }

      })
      .state('wfTemp.new', {
        parent: 'app',
        url: "/new/wfTemp",
        views: {
          'body': {
            templateUrl: "app/workflowApv/wfTemp/editWfTemp.html",
            controller: 'EditWfTempController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
              id: null
            };
          }
        }
      })
      .state('wfTemp.wfConditionTypeEdit', {
        parent: 'app',
        url: "/wfSource/:sourceId/wfTemp/wfConditionType/:id",
        views: {
          'body': {
            templateUrl: "app/workflowApv/wfConditionType/editWfConditionType.html",
            controller: 'EditWfConditionTypeController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                id:$stateParams.id,
                sourceId:$stateParams.sourceId
              };
            }
          ]
        }

      })
      .state('wfTemp.wfConditionTypeNew', {
        parent: 'app',
        url: "/new/wfConditionType",
        views: {
          'body': {
            templateUrl: "app/workflowApv/wfConditionType/editWfConditionType.html",
            controller: 'EditWfConditionTypeController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
              id: null
            };
          }
        }
      })
  }
})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('WfTempService',['$resource', function($resource){
      var service = {
        getWfTemps: getWfTemps,
        get:getWfTemp,
        create:create,
        edit:edit,
        delete:deleteWfTemp
      };
      return service;

      function getWfTemps() {
        var resourceUrl ='/api/wecorpwftemplate/query';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }
      function getWfTemp() {
        var resourceUrl ='/api/wecorpwftemplate/selectedById';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }
      function create(wfTemp){
        var resourceUrl ='/api/wecorpwftemplate/insert';
        return $resource(resourceUrl, {}, {
          'save': {method: 'POST'}
        });
      }
      function edit(wfTemp){
        var resourceUrl ='/api/wecorpwftemplate/update';
        return $resource(resourceUrl, {}, {
          'save': {method: 'POST'}
        });
      }
      function deleteWfTemp(wfTemp){
        var resourceUrl ='/api/wecorpwftemplate/delete';
        return $resource(resourceUrl, {}, {
          'delete': {method: 'POST'}
        });
      }
    }]);


})();

/**
 * Created by xinming on 2016/9/2.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('EditWfTempController', EditWfTempController);

  EditWfTempController.$inject = ['$scope', '$state', '$stateParams', '$uibModal', '$log', 'WfTempService','WfSourceService', 'entity', 'paginationConstants'];

  function EditWfTempController($scope, $state, $stateParams, $uibModal, $log, WfTempService, WfSourceService,entity, paginationConstants) {
    var vm = this;
    vm.wfTemp = entity;
    //来源系统ID和名称

    vm.sourceId = vm.wfTemp.sourceId;

    vm.editOrCreate='create';
    vm.modalInstance = {};
    vm.isAllSelected = false;
    vm.confirmDelete = false;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;

    vm.saveOrUpdate = saveOrUpdate;
    vm.load = load;
    vm.isNotDelete = isNotDelete;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.load();
    //vm.sourceName = null;
    vm.goSelectLine = goSelectLine;
    vm.cancel = cancel;
    //HeaderService.get(function (result) {
    //  vm.sourceName = result.rows;
    //});
    function load() {
      if (vm.wfTemp.id != undefined && vm.wfTemp.id != null && vm.wfTemp.id != '') {
        vm.editOrCreate='edit';
        WfTempService.get().get(vm.wfTemp, function (result) {
          vm.wfTemp = result.rows[0];
        });
      }else{
        getWfSource(vm.sourceId);
      }
    }

    function getWfSource(id){
      WfSourceService.get().get({
        id:id
      }, function(data){
        vm.wfTemp.apiHeaderId = data.rows[0].apiHeaderId;
        vm.wfTemp.apiHeaderName = data.rows[0].apiHeaderName;
        vm.wfTemp.getWfListApiName = data.rows[0].getWfListApiName;
      }, function(){
        console.log('error');
      });
    }

    function isNotDelete(resource) {
      return resource.__status != "delete";
    }

    function saveOrUpdate() {
      if (vm.editOrCreate=='create'){
        vm.wfTemp.id = null;
        WfTempService.create().save(vm.wfTemp, onSuccess, onError);
      }
      else if (vm.editOrCreate=='edit'){
        WfTempService.edit().save(vm.wfTemp, onSuccess, onError);
      }
    }
    function cancel(){
      //alert(vm.sourceId)
      $state.go('wfTemp',{sourceId:vm.sourceId});
    }
    function onSuccess(data, headers) {
      $state.go('wfTemp',{sourceId:vm.sourceId});
    }

    function onError(error) {
      console.log('error');
    }


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      console.log('Page changed to: ' + vm.page);
    };
    //跳转到接口行选择页面
    function goSelectLine(interfaceType){
      $uibModal.open({
        templateUrl: 'app/workflowApv/selectInfModal.html',
        controller: 'SelectInfModalController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              apiHeaderId:vm.wfTemp.apiHeaderId
            };
          }
        }
      }).result.then(function (result) {
          switch(interfaceType){
            case 'list':
              vm.wfTemp.getWfListApiName = result.lineName;
              vm.wfTemp.getWfListApiLineId = result.lineId;
              break;
            case 'detail':
              vm.wfTemp.getWfDetailApiName = result.lineName;
              vm.wfTemp.getWfDetailApiLineId = result.lineId;
              break;
            case 'setStatus':
              vm.wfTemp.setWfStatusApiName = result.lineName;
              vm.wfTemp.setWfStatusApiLineId = result.lineId;
              break;
            case 'userList':
              vm.wfTemp.getUserListApiName = result.lineName;
              vm.wfTemp.getUserListApiLineId = result.lineId;
              break;
          }
        }, function (reason) {
          console.log(reason)
        });
    }

  }
})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('wfSource', {
        parent: 'app',
        url: "/wfSource",
        views: {
          'body': {
            templateUrl: "app/workflowApv/wfSource/wfSourceList.html",
            controller: 'WfSourceController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                page:null,
                pagesize:null
              };
            }
          ]
        }

      })
      .state('wfSource.edit', {
        parent: 'app',
        url: "/wfSource/:id",
        views: {
          'body': {
            templateUrl: "app/workflowApv/wfSource/editWfSource.html",
            controller: 'EditWfSourceController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                id:$stateParams.id
              };
            }
          ]
        }

      })
      .state('wfSource.new', {
        parent: 'app',
        url: "/new/wfSource",
        views: {
          'body': {
            templateUrl: "app/workflowApv/wfSource/editwfSource.html.html",
            controller: 'EditWfSourceController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
              id: null
            };
          }
        }
      })


  }
})();

/**
 * Created by hxm on 2016/9/21
 */
(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('WfSourceService',['$resource', function($resource){
      var service = {
        getWfSources: getWfSources,
        get:getWfSource,
        create:create,
        edit:edit,
        delete:deleteWfSource

      };
      return service;
      function getWfSources() {
        var resourceUrl ='/api/wecorpwfsource/query';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }
      function getWfSource() {
        var resourceUrl ='/api/wecorpwfsource/selectedById';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }
      function create(wfTemp){
        var resourceUrl ='/api/wecorpwfsource/insert';
        return $resource(resourceUrl, {}, {
          'save': {method: 'POST'}
        });
      }
      function edit(wfTemp){
        var resourceUrl ='/api/wecorpwfsource/update';
        return $resource(resourceUrl, {}, {
          'save': {method: 'POST'}
        });
      }
      function deleteWfSource(wfTemp){
        var resourceUrl ='/api/wecorpwfsource/delete';
        return $resource(resourceUrl, {}, {
          'delete': {method: 'POST'}
        });
      }
    }]);


})();

/**
 * Created by user on 2016/8/3.
 */
(function (){
  'use strict';

  angular.module('hmapFront')
    .controller('WfSourceController',['WfSourceService','$state','$scope','paginationConstants','entity',
    function(WfSourceService,$state,$scope,paginationConstants,entity){
      var vm = this;
      vm.wfSource = entity;

      vm.page = 1;
      vm.totalItems = null;
      vm.transition = transition;
      vm.pageChanged=pageChanged;
      vm.itemsPerPage = paginationConstants.itemsPerPage;

      //var page = vm.page;
      //var pageSize = paginationConstants.itemsPerPage;
      vm.wfSource.page = vm.page;
      vm.wfSource.pagesize = paginationConstants.itemsPerPage;


      getWfSources(vm.wfSource);

    function getWfSources(wfSource){
      WfSourceService.getWfSources().get({
        apiHeaderName:wfSource.apiHeaderName,
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    } function onSuccess(data, headers) {
        vm.wfSourceAll = data.rows;
        vm.totalItems =  data.total;
      }
      function onError(error) {
        console.log('error');
      }

      vm.search = function(){
        //每次搜索的时候把page设为 1
        vm.wfSource.page = vm.page = 1;
        vm.wfSource.pagesize = paginationConstants.itemsPerPage;

        getWfSources(vm.wfSource);
      }
      vm.delete = function(id){
        WfSourceService.delete().delete({id:id},
          function(data){
            getWfSources(vm.wfSource);
          },
          function(error){
           console.log(error);
          })
      }

      function transition () {
        $state.transitionTo($state.$current, {
          page: vm.page
        });
      }

      function pageChanged() {
        console.log('Page changed to: ' +vm.page);
        vm.wfSource.page = vm.page;
        vm.wfSource.pagesize = paginationConstants.itemsPerPage;
        getWfSources(vm.wfSource);
      };

      $scope.addHeader = function(){
        $state.go("addHeader");
      }
    }]);


})();

/**
 * Created by xinming on 2016/9/2.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('EditWfSourceController', EditWfSourceController);

  EditWfSourceController.$inject = ['$scope', '$state', '$stateParams', '$uibModal', '$log', 'WfSourceService','HeaderService', 'entity', 'paginationConstants'];

  function EditWfSourceController($scope, $state, $stateParams, $uibModal, $log, WfSourceService, HeaderService,entity, paginationConstants) {
    var vm = this;
    vm.wfSource = entity;
    vm.editOrCreate='create';
    vm.modalInstance = {};
    vm.isAllSelected = false;
    vm.confirmDelete = false;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;

    vm.saveOrUpdate = saveOrUpdate;
    vm.load = load;
    vm.isNotDelete = isNotDelete;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.load();
    //vm.sourceName = null;
    vm.goSelectHeader = goSelectHeader;
    vm.goSelectLine = goSelectLine;
    vm.cancel = cancel;
    //HeaderService.get(function (result) {
    //  vm.sourceName = result.rows;
    //});
    function load() {
      if (vm.wfSource.id != undefined && vm.wfSource.id != null && vm.wfSource.id != '') {
        vm.editOrCreate='edit';
        WfSourceService.get().get(vm.wfSource, function (result) {
          vm.wfSource = result.rows[0];
        });
      }
    }


    function isNotDelete(resource) {
      return resource.__status != "delete";
    }

    function saveOrUpdate() {
      if (vm.editOrCreate=='create'){
        vm.wfSource.id = null;
        WfSourceService.create().save(vm.wfSource, onSuccess, onError);
      }
      else if (vm.editOrCreate=='edit'){
        WfSourceService.edit().save(vm.wfSource, onSuccess, onError);
      }
    }
    function cancel(){
      $state.go('wfSource');
    }
    function onSuccess(data, headers) {
      $state.go('wfSource');
    }

    function onError(error) {
      console.log('error');
    }


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      console.log('Page changed to: ' + vm.page);
    };

    function goSelectHeader(){
      $uibModal.open({
        templateUrl: 'app/workflowApv/selectInfHeaderModal.html',
        controller: 'SelectInfHeaderModalController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: {
            apiHeaderId:null
          }
        }
      }).result.then(function (result) {
          if (vm.wfSource.apiHeaderId != result.headerId){
            vm.wfSource.getWfListApiName = "";
            vm.wfSource.getWfListApiId = "";
          }
          vm.wfSource.apiHeaderId = result.headerId
          vm.wfSource.apiHeaderName = result.name

        }, function (reason) {
          console.log(reason)
        });
    }
    //跳转到接口行选择页面
    function goSelectLine(){
      $uibModal.open({
        templateUrl: 'app/workflowApv/selectInfModal.html',
        controller: 'SelectInfModalController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: {
            apiHeaderId:vm.wfSource.apiHeaderId
          }
        }
      }).result.then(function (result) {
          vm.wfSource.getWfListApiName = result.lineName;
          vm.wfSource.getWfListApiLineId = result.lineId;
        }, function (reason) {
          console.log(reason)
        });
    }

  }
})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('wfInt', {
        parent: 'app',
        url: "/wfInt",
        views: {
          'body': {
            templateUrl: "app/workflowApv/wfInt/wfInt.html",
            controller: 'WfIntController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity:
            function () {
              return {
                page:null,
                pagesize:null
              };
            }
        }

      })



  }
})();

/**
 * Created by hxm on 2016/9/21
 */
(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('WfIntService',WfIntService);

  WfIntService.$inject = ['$resource'];

    function WfIntService($resource){

      var service = {
        getWfInts: getWfInts
      }
      return service;

      function getWfInts() {
        var resourceUrl ='/api/wecorpwfinstanceinterface/query';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }


    };


})();

/**
 * Created by user on 2016/8/3.
 */
(function (){
  'use strict';

  angular.module('hmapFront')
    .controller('WfIntController',WfIntController);

  WfIntController.$inject = ['WfIntService','paginationConstants','entity','DTOptionsBuilder','DTColumnBuilder','$q'];

    function WfIntController(WfIntService,paginationConstants,entity,DTOptionsBuilder,DTColumnBuilder,$q){
      var vm = this;
      vm.wfInt = entity;
      vm.page = 1;
      vm.totalItems = null;
      vm.itemsPerPage = paginationConstants.itemsPerPage;
      vm.wfInt.page = vm.page;
      vm.wfInt.pagesize = paginationConstants.itemsPerPage;

      vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withOption('searching',false)
        .withFnServerData(serverData)
        .withDataProp('data') //Tried 'data' as well
        .withPaginationType('full_numbers')
        .withBootstrap();

      function serverData(sSource, aoData, fnCallback, oSettings) {
        //All the parameters you need is in the aoData variable
        var draw = aoData[0].value;
        var order = aoData[2].value;
        var start = aoData[3].value;
        var length = aoData[4].value;

        switch(order[0].column)
        {
          case 0:
            order[0].column = "workflowInterfaceId"
            break;
          case 1:
            order[0].column = "workflowId"
            break;
          case 3:
            order[0].column = "workflowErrorCode"
            break;
          case 5:
            order[0].column = "creationDate"
            break;
        }
        var params = {  page:start/length +1,
                        pagesize:length,
                        order:order};

        getWfInts(params).then(
          function(result){
          if (fnCallback){
            var records = {
              'draw': draw,
              'recordsTotal': result.total,
              'recordsFiltered': result.total,
              'data': result.rows
            };
            fnCallback(records);
          }
        }, function (error) {
        });
      };

      vm.dtColumns = [
        DTColumnBuilder.newColumn('workflowInterfaceId').withTitle('接口ID'),
        DTColumnBuilder.newColumn('workflowId').withTitle('工作流ID'),
        DTColumnBuilder.newColumn('workflowJson').withTitle('推送内容'),
        DTColumnBuilder.newColumn('workflowErrorCode').withTitle('推送状态编码'),
        DTColumnBuilder.newColumn('workflowErrorMessage').withTitle('推送状态'),
        DTColumnBuilder.newColumn('creationDate').withTitle('创建时间'),
        DTColumnBuilder.newColumn('lastUpdateDate').withTitle('上次更新时间'),
      ];


    function getWfInts(params){
      var deferred = $q.defer();
       WfIntService.getWfInts().get({
        page: params.page,
        pagesize: params.pagesize,
        order:params.order
      },function(result){
         console.log(result);
           deferred.resolve(result);

       },
         function (error) {
           console.log('error');
           deferred.reject(error);
         });
       return deferred.promise;
    }

      vm.search = function(){
        //每次搜索的时候把page设为 1
        vm.wfInt.page = vm.page = 1;
        vm.wfInt.pagesize = paginationConstants.itemsPerPage;

        getWfInts(vm.wfInt).then(
          function(result){
          }, function (error) {
          });;
      }



    };


})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('WfConditionTypeService',WfConditionTypeService);

  /** @ngInject */

  function WfConditionTypeService($resource){

      var service = {
        getWfConditionTypes: getWfConditionTypes,
        get:get,
        create:create,
        edit:edit,
        delete:deleteWfConditionType,
      };
      return service;
      function getWfConditionTypes() {
        var resourceUrl ='/api/wecorpwfcondition/query';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }
      function get() {
        var resourceUrl ='/api/wecorpwfcondition/selectedById';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }
      function create(wfConditionType){
        var resourceUrl ='/api/wecorpwfcondition/insert';
        return $resource(resourceUrl, {}, {
          'save': {method: 'POST'}
        });
      }
      function edit(wfConditionType){
        var resourceUrl ='/api/wecorpwfcondition/update';
        return $resource(resourceUrl, {}, {
          'save': {method: 'POST'}
        });
      }
      function deleteWfConditionType(wfConditionType){
        var resourceUrl ='/api/wecorpwfcondition/delete';
        return $resource(resourceUrl, {}, {
          'delete': {method: 'POST'}
        });
      }
    }


})();

/**
 * Created by xinming on 2016/9/2.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('EditWfConditionTypeController', EditWfConditionTypeController);

  EditWfConditionTypeController.$inject = [ '$state', '$uibModal', '$log','WfSourceService', 'entity', 'paginationConstants','WfConditionTypeService'];

  function EditWfConditionTypeController( $state, $uibModal, $log, WfSourceService,entity, paginationConstants,WfConditionTypeService) {
    var vm = this;
    vm.wfConditionType = entity;
    //来源系统ID和名称

    vm.sourceId = vm.wfConditionType.sourceId;

    vm.editOrCreate='create';
    vm.modalInstance = {};
    vm.isAllSelected = false;
    vm.confirmDelete = false;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;

    vm.saveOrUpdate = saveOrUpdate;
    vm.load = load;
    vm.isNotDelete = isNotDelete;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.load();
    //vm.sourceName = null;
    vm.goSelectLine = goSelectLine;
    vm.cancel = cancel;
    //HeaderService.get(function (result) {
    //  vm.sourceName = result.rows;
    //});
    function load() {
      if (vm.wfConditionType.id != undefined && vm.wfConditionType.id != null && vm.wfConditionType.id != '') {
        vm.editOrCreate='edit';
        WfConditionTypeService.get().get(vm.wfConditionType, function (result) {
          vm.wfConditionType = result.rows[0];
        });
      }else{
        getWfSource(vm.sourceId);
      }
    }

    function getWfSource(id){
      WfSourceService.get().get({
        id:id
      }, function(data){
        vm.wfConditionType.apiHeaderId = data.rows[0].apiHeaderId;
        vm.wfConditionType.apiHeaderName = data.rows[0].apiHeaderName;
        vm.wfConditionType.getWfListApiName = data.rows[0].getWfListApiName;
      }, function(){
        console.log('error');
      });
    }

    function isNotDelete(resource) {
      return resource.__status != "delete";
    }

    function saveOrUpdate() {
      if (vm.editOrCreate=='create'){
        vm.wfConditionType.id = null;
        WfConditionTypeService.create().save(vm.wfConditionType, onSuccess, onError);
      }
      else if (vm.editOrCreate=='edit'){
        WfConditionTypeService.edit().save(vm.wfConditionType, onSuccess, onError);
      }
    }
    function cancel(){
      //alert(vm.sourceId)
      $state.go('wfTemp',{sourceId:vm.sourceId});
    }
    function onSuccess(data, headers) {
      $state.go('wfTemp',{sourceId:vm.sourceId});
    }

    function onError(error) {
      console.log('error');
    }


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      console.log('Page changed to: ' + vm.page);
    };
    //跳转到接口行选择页面
    function goSelectLine(){
      $uibModal.open({
        templateUrl: 'app/workflowApv/selectInfModal.html',
        controller: 'SelectInfModalController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              apiHeaderId:vm.wfConditionType.apiHeaderId
            };
          }
        }
      }).result.then(function (result) {
          vm.wfConditionType.getWfConditionApiName = result.lineName;
          vm.wfConditionType.getWfConditionApiLineId = result.lineId;
        }, function (reason) {
          console.log(reason)
        });
    }
  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('taskDetail', {
        parent: 'app',
        url: "/taskDetail",
        views: {
          'body': {
            templateUrl: "app/task/taskDetail/taskDetail.html",
            controller: 'TaskDetailController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                  jobName: null,
                  jobStatus:null,
                  jobGroup: null,
                  jobClassName: null,
                  description: null,
                  previousFireTime: null,
                  scheduledFireTime: null,
                  nextFireTime: null,
                  fireTime: null
                };
              }
            }
          }
        }
      })
      .state('taskDetail.scheduler', {
        parent: 'app',
        url: "/scheduler",
        views: {
          'body': {
            templateUrl: "app/task/taskDetail/scheduler.html",
            controller: 'SchedulerController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                  runningSince:null,
                  numberOfJobsExecuted: null,
                  schedulerName: null,
                  schedulerInstanceId: null,
                  threadPoolSize: null,
                  version: null,
                  inStandbyMode: null,
                  jobStoreClustered: null,
                  jobStoreClass: null,
                  jobStoreSupportsPersistence: null,
                  started: null,
                  shutdown: null,
                  schedulerRemote: null
                };
              }
            }
          }
        }
      })
      .state('taskDetail.new', {
        parent: 'taskDetail',
        url: "/new",
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: "app/task/taskDetail/taskDetail-new.html",
            controller: 'TaskDetailNewController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  jobName: null,
                  jobGroup: null,
                  jobClassName: null,
                  description: null,
                  previousFireTime: null,
                  scheduledFireTime: null,
                  nextFireTime: null,
                  fireTime: null
                };
              }
            }
          }).result.then(function() {
              //console.log("taskDetail go1");
              $state.go('taskDetail', null, { reload: true });
            }, function() {
              //console.log("taskDetail go2");
              $state.go('taskDetail');
            });
        }]
      })
      .state('taskDetail.newCrom', {
        parent: 'taskDetail',
        url: "/newCrom",
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: "app/task/taskDetail/taskDetail-new-crom.html",
            controller: 'TaskDetailNewCromController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  jobName: null,
                  jobGroup: null,
                  jobClassName: null,
                  description: null,
                  previousFireTime: null,
                  scheduledFireTime: null,
                  nextFireTime: null,
                  fireTime: null
                };
              }
            }
          }).result.then(function() {
              //console.log("taskDetail go1");
              $state.go('taskDetail', null, { reload: true });
            }, function() {
              //console.log("taskDetail go2");
              $state.go('taskDetail');
            });
        }]
      })
      .state('taskDetail.newRest', {
        parent: 'taskDetail',
        url: "/newRest",
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: "app/task/taskDetail/taskDetail-new-rest.html",
            controller: 'TaskDetailNewRestController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  jobName: null,
                  jobGroup: null,
                  jobClassName: null,
                  description: null,
                  previousFireTime: null,
                  scheduledFireTime: null,
                  nextFireTime: null,
                  fireTime: null
                };
              }
            }
          }).result.then(function() {
              //console.log("taskDetail go1");
              $state.go('taskDetail', null, { reload: true });
            }, function() {
              //console.log("taskDetail go2");
              $state.go('taskDetail');
            });
        }]
      })
      .state('taskDetail.show', {
        parent: 'taskDetail',
        url: "/:jobName/show",
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: "app/task/taskDetail/taskDetail-show.html",
            controller: 'TaskDetailShowController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  jobName: $stateParams.jobName
                };
                //return {
                //  jobName: null,
                //  jobGroup: null,
                //  description: null,
                //  jobClassName: null,
                //  start: null,
                //  end: null,
                //  previousFireTime: null,
                //  fireTime: null,
                //  scheduledFireTime: null,
                //  nextFireTime: null,
                //  cronExpression: null
                //};
              }
            }
          }).result.then(function() {
              //console.log("taskDetail go1");
              $state.go('taskDetail', null, { reload: true });
            }, function() {
              //console.log("taskDetail go2");
              $state.go('taskDetail');
            });
        }]
      })
  }

})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('TaskDetail', TaskDetail);

  TaskDetail.$inject = ['$resource'];

  function TaskDetail ($resource) {
    var service = {
      TaskDetailCreate: TaskDetailCreate,
      TaskDetailDelete: TaskDetailDelete,
      TaskDetailPause: TaskDetailPause,
      TaskDetailFound: TaskDetailFound,
      TaskDetailResume: TaskDetailResume,
      SchedulerPauseall: SchedulerPauseall,
      SchedulerQuery: SchedulerQuery,
      SchedulerResumeall: SchedulerResumeall,
      SchedulerStandby: SchedulerStandby,
      SchedulerStart: SchedulerStart,
      SchedulerInfo: SchedulerInfo,
      AccessTokenGet:AccessTokenGet
    };
    return service;

    function AccessTokenGet(){
      return $resource("/job/api/job/getAccessToken", {}, {
        'get': {method: 'POST'}
      });
    }
    function TaskDetailCreate () {
      return $resource("/job/api/customJob/createJob", {}, {
        'save': {method: 'POST'}
      });
    }
    function TaskDetailDelete () {
      return $resource("/job/api/customJob/deletejob", {}, {
        'update': {method: 'POST'}
      });
    }
    function TaskDetailPause () {
      return $resource("/job/api/customJob/pausejob", {}, {
        'update': {method: 'POST'}
      });
    }
    function TaskDetailFound () {
      return $resource("/job/api/customJob/foundJob", {}, {
        'query': {method: 'POST', isArray: false}
      });
    }
    function TaskDetailResume () {
      return $resource("/job/api/customJob/resumejob", {}, {
        'update': {method: 'POST'}
      });
    }
    function SchedulerPauseall () {
      return $resource("/job/api/scheduler/pauseall", {}, {
        'pauseall': {method: 'POST'}
      });
    }
    function SchedulerQuery () {
      return $resource("/job/api/scheduler/query", {}, {
        'query': {method: 'POST'}
      });
    }
    function SchedulerResumeall () {
      return $resource("/job/api/scheduler/pauseall", {}, {
        'resumeall': {method: 'POST'}
      });
    }
    function SchedulerStandby () {
      return $resource("/job/api/scheduler/standby", {}, {
        'standby': {method: 'POST'}
      });
    }
    function SchedulerStart () {
      return $resource("/job/api/scheduler/start", {}, {
        'start': {method: 'POST'}
      });
    }
    function SchedulerInfo () {
      return $resource("/job/api/scheduler/info", {}, {
        'info': {method: 'POST'}
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('TaskDetailController', TaskDetailController);
  TaskDetailController.$inject = ['$state','TaskDetail','entity','paginationConstants','SysConfig'];
  /** @ngInject */
  function TaskDetailController( $state, TaskDetail,entity, paginationConstants,SysConfig) {
    var vm = this;
    vm.page = 1;
    vm.pagesize = 10;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.dto ={};
    vm.loadJobs=loadJobs;
    vm.pauseJobs=pauseJobs;
    vm.delJobs=delJobs;
    vm.setColor=setColor;
    vm.resumeJobs=resumeJobs;
    vm.updateSelectionAll=updateSelectionAll;
    vm.updateSelection=updateSelection;
    vm.updateSelectedAll=updateSelectedAll;
    vm.updateSelected=updateSelected;
    vm.isSelected=isSelected;
    vm.loadAll();
    vm.selected = [];
    vm.selectedTags = [];
    vm.jobs=[];
    function loadAll() {
      TaskDetail.TaskDetailFound().query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
      vm.initWidget();
    }
    function resumeJobs(){
      TaskDetail.TaskDetailResume().update(
        vm.selectedTags,delSuccess, onError );
    }
    function delJobs(){
      TaskDetail.TaskDetailDelete().update(
        vm.selectedTags ,delSuccess, onError);
    }
    function delSuccess() {
      vm.loadAll();
    }
    function pauseJobs(){
      TaskDetail.TaskDetailPause().update(
        vm.selectedTags ,delSuccess, onError);
    }
    function loadJobs(){
      //console.log(vm.dto.jobName);
      vm.dto.page=vm.page;
      vm.dto.pagesize=vm.itemsPerPage;
      TaskDetail.TaskDetailFound().query(
        vm.dto, onSuccess, onError
      );
    }
    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.jobs = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');
    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }
    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll();
    }
    function updateSelected(action,id,data){
      if(action == 'add' && vm.selected.indexOf(id) == -1){
        vm.selected.push(id);
        vm.selectedTags.push(data);
      }
      if(action == 'remove' && vm.selected.indexOf(id)!=-1){
        var idx = vm.selected.indexOf(id);
        vm.selected.splice(idx,1);
        vm.selectedTags.splice(idx,1);
      }
    };
    function updateSelection($event, id){
      var checkbox = $event.target;
      var action = (checkbox.checked?'add':'remove');
      updateSelected(action,id,{jobName:id,jobGroup:checkbox.name});
      //console.log("selected:"+vm.selected);
      angular.forEach(vm.selectedTags, function(obj,index,array) {
        //console.log("selectedTags:" +index+"---:"+obj.jobName+","+obj.jobGroup);
      })
    };
    function isSelected(id){
      return vm.selected.indexOf(id)>=0;
    };

    function updateSelectedAll(action){
      if(action == 'add'){
        vm.selected=[];
        vm.selectedTags=[];
        angular.forEach(vm.jobs, function(obj,index,array){
          vm.selected.push(obj.jobName);
          vm.selectedTags.push({jobName:obj.jobName,jobGroup:obj.jobGroup});
        });
      }
      if(action == 'remove'){
        vm.selected=[];
        vm.selectedTags=[];
      }
    };
    function updateSelectionAll($event){
      var checkbox = $event.target;
      var action = (checkbox.checked?'add':'remove');
      updateSelectedAll(action);
      //console.log("selected:"+vm.selected);
      angular.forEach(vm.selectedTags, function(obj,index,array) {
        //console.log("selectedTags:" +index+"---:"+obj.jobName+","+obj.jobGroup);
      })
    }
    function setColor (status) {
      var p = "";
      if ("Finish" == status) {
        p = '#00FF00';
      } else if ("Failed" == status) {
        p = '#F75D59';
      } else if ("Vetoed" == status) {
        p = '#FDD017';
      }
      return {"color": p};
    }
  }
})();

/**
 * Created by chenlei on 2016/8/5.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('TaskDetailShowController', TaskDetailShowController);

  TaskDetailShowController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity','TaskDetail'];

  function TaskDetailShowController($timeout,$scope,$stateParams, $uibModalInstance, entity,TaskDetail) {
    var vm = this;

    vm.show = entity;
    vm.clear = clear;
    vm.load=load;
    vm.job=""

    vm.clientId={};
    vm.requestUrl={};
    vm.param={};
    vm.accessTokenUri={};
    vm.clientSecret={};

    vm.load(vm.show);

    function load(job) {
      TaskDetail.TaskDetailFound().query(job, onSuccess, onError);
    }
    function onSuccess(data) {
      //console.log('onSuccess');
      //console.log(data);
      vm.job = data.rows[0];

      angular.forEach(vm.job.jobDatas, function (data) {
        if(data.name==="clientId"){
          vm.clientId.value=data.value;
        }
        if(data.name==="clientSecret"){
          vm.clientSecret.value=data.value;
        }
        if(data.name==="accessTokenUri"){
          vm.accessTokenUri.value=data.value;
        }
        if(data.name==="param"){
          vm.param.value=data.value;
        }
        if(data.name==="requestUrl"){
          vm.requestUrl.value=data.value;
        }
      });
    }
    function onError(error) {
      //console.log('error');
    }

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * Created by chenlei on 2016/8/5.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('TaskDetailNewController', TaskDetailNewController);

  TaskDetailNewController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity','TaskDetail','toastr','$filter'];

  function TaskDetailNewController($timeout, $scope, $stateParams, $uibModalInstance, entity, TaskDetail,toastr,$filter) {
    var vm = this;

    vm.taskDetail = entity;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.startOpen = startOpen;
    vm.endOpen = endOpen;
    vm.taskDetail.jobGroup='DEFAULT';
    vm.addRow=addRow;
    vm.delRow=delRow;
    vm.taskDetail.jobData=[];
    vm.selected=[];

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.taskDetail.triggerType='SIMPLE';
      if(vm.taskDetail.startTime!=null){
        vm.taskDetail.startTime=vm.taskDetail.startTime.valueOf();
      }
      if(vm.taskDetail.endTime!=null){
        vm.taskDetail.endTime=vm.taskDetail.endTime.valueOf();
      }
      vm.isSaving = true;
      TaskDetail.TaskDetailCreate().save(vm.taskDetail, onSaveSuccess, onSaveError);
    }

    function onSaveSuccess(result) {
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $scope.$emit('hmapFront:taskDetailUpdate', result);
      $uibModalInstance.close(result);
      vm.isSaving = true;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function startOpen() {
      vm.isStartOpen = true;
    }
    function endOpen() {
      vm.isEndOpen = true;
    }

    function addRow(){
      vm.taskDetail.jobData.push({name:"",value:""})
    }
    function delRow(){
      for(var i=vm.selected.length-1;i>=0;i--){
        vm.taskDetail.jobData.splice(vm.selected[i],1);
      }
      vm.selected=[];
    }
    var updateSelected = function(action,id){
      if(action == 'add' && vm.selected.indexOf(id) == -1){
        vm.selected.push(id);
      }
      if(action == 'remove' && vm.selected.indexOf(id)!=-1){
        var idx = vm.selected.indexOf(id);
        vm.selected.splice(idx,1);
      }
    };
    vm.updateSelection = function($event, id){
      var checkbox = $event.target;
      var action = (checkbox.checked?'add':'remove');
      updateSelected(action,id);
      //console.log("selected:"+$scope.selected);
    };
    vm.isSelected = function(id){
      return vm.selected.indexOf(id)>=0;
    };

    var updateSelectedAll = function(action){
      if(action == 'add'){
        vm.selected=[];
        angular.forEach(vm.taskDetail.jobData, function(data,index,array){
          vm.selected.push(index);
        });
      }
      if(action == 'remove'){
        vm.selected=[];
      }
    };
    vm.updateSelectionAll = function($event){
      var checkbox = $event.target;
      var action = (checkbox.checked?'add':'remove');
      updateSelectedAll(action);
      //console.log("selected:"+$scope.selected);
    }
  }
})();

/**
 * Created by Administrator on 2016/11/29.
 */
/**
 * Created by chenlei on 2016/8/5.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('TaskDetailNewRestController', TaskDetailNewRestController);

  TaskDetailNewRestController.$inject = ['PromptService','$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity','TaskDetail'];

  function TaskDetailNewRestController(PromptService,$timeout, $scope, $stateParams, $uibModalInstance, entity, TaskDetail) {
    var vm = this;

    vm.showFlag = false;
    vm.taskDetail = entity;
    vm.back = back;
    vm.show = show;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.startOpen = startOpen;
    vm.endOpen = endOpen;
    vm.taskDetail.jobGroup='DEFAULT';
    vm.taskDetail.jobClassName='hmap.core.job.common.CommonJob';
    vm.taskDetail.jobDatas=[];
    var langs = [];
    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.localeSure = localeSure;

    vm.getToken = getToken;
    vm.token = {
      token_url : '',
      client_id : '',
      client_secret : '',
      grant_type : 'client_credentials'
    };

    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#templateContentBtn").attr("disabled", false);
        $("#descriptionBtn").attr("disabled", false);
        $("#templateNameBtn").attr("disabled", false);
        $("#linkAddressBtn").attr("disabled", false);
      });
    }
    initLangs();

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.taskDetail.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.taskDetail.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.taskDetail[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.taskDetail.__tls = __tls;
    }

    vm.requestUrl = {
      name:'requestUrl',
      value:''
    };
    vm.param = {
      name:'param',
      value:''
    };
    vm.accessTokenUri = {
      name:'accessTokenUri',
      value:''
    };
    vm.clientId = {
      name:'clientId',
      value:''
    };
    vm.clientSecret = {
      name:'clientSecret',
      value:''
    };
    //console.log(vm.taskDetail.jobData);
    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function back(){
      vm.showFlag = false;
    }

    function show(){
      vm.showFlag = true;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function getToken() {

      TaskDetail.AccessTokenGet().get(vm.token, onSaveSuccess2, onSaveError2);

    }

    function save() {



      vm.taskDetail.jobDatas.push(vm.requestUrl,vm.accessTokenUri,vm.clientId,vm.clientSecret,vm.param);
      vm.taskDetail.triggerType='SIMPLE';
      if(vm.taskDetail.startTime!=null){
        vm.taskDetail.startTime=vm.taskDetail.startTime.valueOf();
      }
      if(vm.taskDetail.endTime!=null){
        vm.taskDetail.endTime=vm.taskDetail.endTime.valueOf();
      }
      vm.isSaving = false;
      TaskDetail.TaskDetailCreate().save(vm.taskDetail, onSaveSuccess, onSaveError);
    }

    function onSaveSuccess(result) {
      $scope.$emit('hmapFront:taskDetailUpdate', result);
      $uibModalInstance.close(result);
      vm.isSaving = true;
    }
    function onSaveSuccess2(result) {

      vm.data2.value = result.rows[0];
      vm.showFlag = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }
    function onSaveError2() {

    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function startOpen() {
      vm.isStartOpen = true;
    }
    function endOpen() {
      vm.isEndOpen = true;
    }
  }
})();

/**
 * Created by chenlei on 2016/8/5.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('TaskDetailNewCromController', TaskDetailNewCromController);

  TaskDetailNewCromController.$inject = ['$filter','PromptService','$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity','TaskDetail','toastr'];

  function TaskDetailNewCromController($filter,PromptService,$timeout, $scope, $stateParams, $uibModalInstance, entity, TaskDetail,toastr) {
    var vm = this;

    vm.taskDetail = entity;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.startOpen = startOpen;
    vm.endOpen = endOpen;
    vm.taskDetail.jobGroup='DEFAULT';
    vm.taskDetail.cronExpression='0 * * * * ?';
    vm.taskDetail.jobClassName='hmap.core.job.common.CommonJob';
    vm.addRow=addRow;
    vm.delRow=delRow;
    vm.taskDetail.jobDatas=[];
    vm.selected=[];
    var langs = [];
    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.localeSure = localeSure;

    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#templateContentBtn").attr("disabled", false);
        $("#descriptionBtn").attr("disabled", false);
        $("#templateNameBtn").attr("disabled", false);
        $("#linkAddressBtn").attr("disabled", false);
      });
    }
    initLangs();

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.taskDetail.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.taskDetail.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.taskDetail[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.taskDetail.__tls = __tls;
    }


    vm.requestUrl = {
      name:'requestUrl',
      value:''
    };
    vm.param = {
      name:'param',
      value:''
    };
    vm.accessTokenUri = {
      name:'accessTokenUri',
      value:''
    };
    vm.clientId = {
      name:'clientId',
      value:''
    };
    vm.clientSecret = {
      name:'clientSecret',
      value:''
    };

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.taskDetail.jobDatas.push(vm.requestUrl,vm.accessTokenUri,vm.clientId,vm.clientSecret,vm.param);
      vm.taskDetail.triggerType='CRON';
      if(vm.taskDetail.startTime!=null){
        vm.taskDetail.startTime=vm.taskDetail.startTime.valueOf();
      }
      if(vm.taskDetail.endTime!=null){
        vm.taskDetail.endTime=vm.taskDetail.endTime.valueOf();
      }
      vm.isSaving = true;
      TaskDetail.TaskDetailCreate().save(vm.taskDetail, onSaveSuccess, onSaveError);
    }

    function onSaveSuccess(result) {
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $scope.$emit('hmapFront:taskDetailUpdate', result);
      $uibModalInstance.close(result);
      vm.isSaving = true;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function startOpen() {
      vm.isStartOpen = true;
    }
    function endOpen() {
      vm.isEndOpen = true;
    }
    function addRow(){
      vm.taskDetail.jobDatas.push({name:"",value:""})
    }
    function delRow(){
      for(var i=vm.selected.length-1;i>=0;i--){
        vm.taskDetail.jobDatas.splice(vm.selected[i],1);
      }
      vm.selected=[];
    }
    var updateSelected = function(action,id){
      if(action == 'add' && vm.selected.indexOf(id) == -1){
        vm.selected.push(id);
      }
      if(action == 'remove' && vm.selected.indexOf(id)!=-1){
        var idx = vm.selected.indexOf(id);
        vm.selected.splice(idx,1);
      }
    };
    vm.updateSelection = function($event, id){
      var checkbox = $event.target;
      var action = (checkbox.checked?'add':'remove');
      updateSelected(action,id);
      //console.log("selected:"+vm.selected);
    };
    vm.isSelected = function(id){
      return vm.selected.indexOf(id)>=0;
    };

    var updateSelectedAll = function(action){
      if(action == 'add'){
        vm.selected=[];
        angular.forEach(vm.taskDetail.jobDatas, function(data,index,array){
          vm.selected.push(index);
        });
      }
      if(action == 'remove'){
        vm.selected=[];
      }
    };
    vm.updateSelectionAll = function($event){
      var checkbox = $event.target;
      var action = (checkbox.checked?'add':'remove');
      updateSelectedAll(action);
      //console.log("selected:"+vm.selected);
    }
  }
})();

/**
 * Created by chenlei on 2016/8/5.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('SchedulerController', SchedulerController);

  SchedulerController.$inject = ['$timeout', 'TaskDetail','$state', '$stateParams','User','entity','uibDateParser'];

  function SchedulerController(paginationConstants, TaskDetail, $state, $stateParams, User, entity, uibDateParser) {
    var vm = this;
    vm.loadAll = loadAll;
    vm.getScheduler = getScheduler;
    vm.schedulers = [];
    vm.clear = clear;
    vm.start = start;
    vm.standby = standby;
    vm.jobs=[];
    vm.load=load;
    vm.pauseall=pauseall;
    vm.resumeall=resumeall;
    vm.load();
    vm.loadAll();

    function clear() {
      $state.go('scheduler');
    }

    function start() {
      TaskDetail.SchedulerStart().start({},loadSuccess, loadError);
    }
    function standby() {
      TaskDetail.SchedulerStandby().standby({},loadSuccess, loadError);
    }
    function pauseall() {
      TaskDetail.SchedulerPauseall().pauseall({},loadSuccess, loadError);
    }
    function resumeall() {
      TaskDetail.SchedulerResumeall().resumeall({},loadSuccess, loadError);
    }
    function load(){
      TaskDetail.SchedulerInfo().info({},loadSuccess, loadError)
    }
    function loadSuccess(data, headers) {
      //console.log('loadSuccess');
      //console.log(data);
      vm.schedulers = data.rows;
    }
    function loadError(error) {
      //console.log('error');
    }
    function loadAll() {
      TaskDetail.SchedulerQuery().query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.jobs = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');
    }

    function getScheduler(id) {
      if (id) {
        User.get({id: id}, function (result) {
          vm.user = result.rows[0];
          vm.user.startActiveDate=uibDateParser.parse(vm.user.startActiveDate,"yyyy-MM-dd");
          vm.user.endActiveDate=uibDateParser.parse(vm.user.endActiveDate,"yyyy-MM-dd");
        });
      }
    }

  }
})();

(function () {
  'use strict';
  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider){
    $stateProvider
      .state('ltsJob', {
        parent:'app',
        url: '/ltsJob',
        params: {"url":null ,"type":null},
        views:{
          'body':{
            templateUrl: 'app/task/taskDetail/ltsJob.html',
            controller: 'LtsJobController',
            controllerAs: 'vm'
          }
        }
      })
  }
})();

(function () {
  'use strict';
  angular.module('hmapFront')
    .controller('LtsJobController',LtsJobController);

  LtsJobController.$inject = ['SysConfig', '$localStorage', '$sessionStorage', '$log', '$window'];

  function LtsJobController(SysConfig, $localStorage, $sessionStorage, $log, $window) {
    var vm = this;
    vm.getLtsJobUrl = getLtsJobUrl;
    vm.getLtsJobUrl();
    vm.tempwindow = undefined;
    function getLtsJobUrl() {
      SysConfig.query().query({configKey:'SYS.LTS_JOB_URL'},function (data) {
        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;

        vm.ltsJobUrl = data.rows[0].configValue+'?refresh_token='+token.refresh_token;

        if(!vm.tempwindow && undefined !== vm.tempwindow){
          vm.tempwindow = $window.open('_blank');
          vm.tempwindow.location = vm.ltsJobUrl;
        }

      },function (error) {
        $log.log(error);
      });
    }
  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
     .state('executionLog', {
        parent: 'app',
        url: "/executionLog",
        views: {
          'body': {
            templateUrl: "app/task/executionLog/executionLog.html",
            controller: 'ExecutionLogController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                  jobRunningInfoId: null,
                  jobName: null,
                  jobGroup: null,
                  jobStatus: null,
                  executionSummary: null,
                  previousFireTime: null,
                  scheduledFireTime: null,
                  nextFireTime: null,
                  fireTime: null,
                };
              }
            }
          }
        }
      })
  }

})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('ExecutionLog', ExecutionLog);

  ExecutionLog.$inject = ['$resource'];

  function ExecutionLog ($resource) {
    var service = {
      loadAll: loadAll
    };
    return service;

    function loadAll(page, pageSize) {
      return $resource("/job/api/ExecutionLog?page=" + page + "&pageSize=" + pageSize, {}, {
        'query': {method: 'POST', isArray: false}
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ExecutionLogController', ExecutionLogController);
  ExecutionLogController.$inject = ['$state','ExecutionLog','entity','paginationConstants'];
  /** @ngInject */
  function ExecutionLogController($state, ExecutionLog,entity, paginationConstants) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.job = entity;
    vm.loadJobs=loadJobs;
    vm.loadAll();

    function loadAll() {
      var page=vm.page;
      var pagesize=paginationConstants.itemsPerPage;
      ExecutionLog.loadAll(page,pagesize).query({}, onSuccess, onError);
    }
    function loadJobs() {
      var page = vm.page;
      var pagesize = paginationConstants.itemsPerPage;
      ExecutionLog.loadAll(page, pagesize).query(vm.job, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.jobs = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');

    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll();
    }
  }
})();

/**
 * Created by Administrator on 2016/9/2.
 */
(function(){
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('profileValue', {
        parent: 'app',
        url: "/profileValue/{id}",
        views: {
          'body': {
            templateUrl: "app/profile/profileValue/profileValue.html",
            controller: 'ProfileValueController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              //console.log("0000="+$stateParams.id);
              return {
                id:$stateParams.id
              };
            }
          ]
        }

      })
      .state('profileValue.new', {
        parent: 'profileValue',
        url: "/newProfileValue/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          //console.log($stateParams);
          $uibModal.open({
            templateUrl: 'app/profile/profileValue/profileValue-dialog.html',
            controller: 'ProfileValueDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id:null,
                  profileId:$stateParams.id,
                  valueId:null,
                  levelValue:null
                };
              }
            }
          }).result.then(function () {
              //console.log("profileValue go1");
              $state.go('profileValue', null, {reload: true});
            }, function () {
              //console.log("profileValue go2");
              $state.go('profileValue');
            });
        }]
      }).state('profileValue.edit', {
        parent: 'profileValue',
        url: "/:profileId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          //console.log( angular.toJson($stateParams));
          //console.log($state);
          $uibModal.open({
            templateUrl: 'app/profile/profileValue/profileValue-dialog.html',
            controller: 'ProfileValueDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.profileId
                };
              }
            }
          }).result.then(function () {
              //console.log("profileValue go1");
              $state.go('profileValue', null, {reload: true});
            }, function () {
              //console.log("profileValue go2");
              $state.go('profileValue');
            });
        }]
      });

  }
})();

/**
 * Created by Administrator on 2016/9/2.
 */
(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('ProfileValue', ProfileValue);

  ProfileValue.$inject = ['$resource'];

  function ProfileValue ($resource) {
    var resourceUrl = '/api/profileValue';

    return $resource(resourceUrl, {}, {
      'query': { method: 'GET',isArray:false},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();

/**
 * Created by Administrator on 2016/9/2.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ProfileValueController', ProfileValueController);

  ProfileValueController.$inject = ['$state','ProfileValue',  'entity','paginationConstants'];

  function ProfileValueController($state, ProfileValue, entity, paginationConstants) {
    var vm = this;

    vm.page = 1;
    vm.profileValues = entity;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.pageChanged=pageChanged;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadAll();


    function loadAll() {
      //console.log(vm.profileValues.id);
      ProfileValue.query({
        profileId: vm.profileValues.id
      }, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.profileValues = data.rows[0][0];
      vm.profiles = data.rows[0][2][0];
      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');
    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }
    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll();
    };
  }



})();

/**
 * Created by Administrator on 2016/9/5.
 */

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ProfileValueDialogController', ProfileValueDialogController);

  ProfileValueDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProfileValue'];

  function ProfileValueDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ProfileValue) {
    var vm = this;

    vm.profileValue = entity;
    vm.clear = clear;
    vm.save = save;
    vm.loadValue = loadValue;
    vm.dateOptions = dateOptions;
    vm.popupOpen = popupOpen;
    vm.load=load;
    vm.profileValue.levelId = $scope;

    //console.log(vm.profileValue.profileId);

    vm.load(vm.profileValue.id);

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.isSaving = true;
      if (vm.profileValue.id !== null) {
        ProfileValue.update(vm.profileValue, onSaveSuccess, onSaveError);
      } else {
        ProfileValue.save(vm.profileValue, onSaveSuccess, onSaveError);
      }
    }

    function onSaveSuccess(result) {
      $scope.$emit('hmapFront:profileUpdate', result);
      $uibModalInstance.close(result);
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function loadValue() {
      ProfileValue.query({
        levelId:vm.profileValue.levelId
      }, function (result) {
        vm.levels = result.rows[0][1]
          //console.log(vm.levels);
        //console.log(result);
      });
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function popupOpen() {
      vm.isOpen = true;
    }



    function load(id) {
      if (id) {
        //console.log(id);
        ProfileValue.query({
          profileValueId:id
        }, function (result) {
          vm.profileValue = result.rows[0][0][0],
          //console.log(vm.profileValue.levelId);
          ProfileValue.query({
            levelId:vm.profileValue.levelId
          }, function (result) {
            vm.levels = result.rows[0][1]
            //console.log(vm.levels);
            //console.log(result);
            //console.log(vm.profileValue.levelName);
          });

        });
      }

    }

  }
})();

/**
 * Created by user on 2016/8/16.
 */

(function(){
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('profile', {
        parent: 'app',
        url: "/profile",
        views: {
          'body': {
            templateUrl: "app/profile/profile/profile.html",
            controller: 'ProfileController',
            controllerAs: 'vm'
          }
        }

      })
      .state('profile.new', {
        parent: 'profile',
        url: "/new",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/profile/profile/profile-dialog.html',
            controller: 'ProfileDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: null,
                  profileName: null,
                  profileDesc: null
                };
              }
            }
          }).result.then(function () {
              //console.log("profile go1");
              $state.go('profile', null, {reload: true});
            }, function () {
              //console.log("profile go2");
              $state.go('profile');
            });
        }]
      }).state('profile.edit', {
        parent: 'profile',
        url: "/:id/edit",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/profile/profile/profile-dialog.html',
            controller: 'ProfileDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              //console.log("profile go1");
              $state.go('profile', null, {reload: true});
            }, function () {
              //console.log("profile go2");
              $state.go('profile');
            });
        }]
      });
  }
})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('Profile', Profile);

  Profile.$inject = ['$resource'];

  function Profile ($resource) {
    var resourceUrl = '/api/profile/:id';

    return $resource(resourceUrl, {}, {
      'query': { method: 'GET',isArray:false},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ProfileController', ProfileController);

  ProfileController.$inject = ['$state','Profile','paginationConstants'];

  function ProfileController($state, Profile, paginationConstants) {
    var vm = this;

    vm.page = 1;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.pageChanged=pageChanged;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadAll();


    function loadAll() {
      Profile.query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.profiles = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');
    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }
    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll();
    };
  }



})();

/**
 * Created by Administrator on 2016/9/2.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ProfileDialogController', ProfileDialogController);

  ProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Profile'];

  function ProfileDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Profile) {
    var vm = this;

    vm.profile = entity;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.popupOpen = popupOpen;
    vm.load=load;

    vm.load(vm.profile.id);

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.isSaving = true;
      //console.log(vm.profile);
      if (vm.profile.id !== null) {
        Profile.update(vm.profile, onSaveSuccess, onSaveError);
      } else {
        Profile.save(vm.profile, onSaveSuccess, onSaveError);
      }
    }

    function onSaveSuccess(result) {
      $scope.$emit('hmapFront:profileUpdate', result);
      $uibModalInstance.close(result);
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function popupOpen() {
      vm.isOpen = true;
    }



    function load(id) {
      if (id) {
        //console.log('loadone');
        Profile.query({
          page: 1,
          pagesize: 10
        }, function (result) {
          vm.profile = result.rows[0]});
      }

    }

  }
})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('PluginShowVersionController', PluginShowVersionController);

  PluginShowVersionController.$inject = ['PluginService', '$scope', '$state', '$uibModalInstance', 'entity'];

  function PluginShowVersionController(PluginService, $scope, $state, $uibModalInstance, entity) {
    var vm = this;
    vm.version = entity;

    vm.clear = clear;
    vm.loadOneVersion=loadOneVersion;
    vm.getPermission=getPermission;

    vm.permissionData=[];
    vm.permissions=[];

    vm.loadOneVersion(entity.id);

    function clear() {
      $uibModalInstance.close(vm.version.menuId);
    }

    function loadOneVersion(id) {
      if(id){
        PluginService.getOneVersion().query({id: id}, function (result) {
          vm.version = result.rows[0];
          if(vm.version.showConer=='Y'){
            vm.version.showConer=true;
          }else{
            vm.version.showConer=false;
          }
          if(vm.version.isSilenceUpdate=='Y'){
            vm.version.isSilenceUpdate=true;
          }else{
            vm.version.isSilenceUpdate=false;
          }
          if(vm.version.isForceUpdate=='Y'){
            vm.version.isForceUpdate=true;
          }else{
            vm.version.isForceUpdate=false;
          }
          getPermission();
        });
      }
    }

    function getPermission(){
      PluginService.getPermissionData().query({id: vm.version.id}, function (data){
        vm.result = data.rows;
        for(var i=0;i<vm.result.length;i++){
          vm.permissionData.push({id:vm.result[i].id,dataIcon:vm.result[i].valueIcon,dataType:vm.result[i].dataType,
            dataValue:vm.result[i].dataValue,dataId:vm.result[i].dataKey})
        }
      });
    }
  }
})();

/**
 * Created by liuxiawang on 2017/04/06.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
  .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
    .state('plugin', {
      parent: 'app',
      url: "/plugin",
      params: {
        appId: ''
      },
      views: {
        'body': {
          templateUrl: "app/plugin/html/plugin.html",
          controller: 'PluginController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            appId: $stateParams.appId
          };
        }
      }
    })
    .state('plugin.detail', {
      parent: 'app',
      url: "/plugin/:id",
      params: {
        id: ''
      },
      views: {
        'body': {
          templateUrl: "app/plugin/html/plugin-detail.html",
          controller: 'PluginDetailController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            id: $stateParams.id
          };
        }
      }
    }).state('plugin.newPlugin', {
      parent: 'app',
      url: "/newPlugin/:appId",
      views: {
        'body': {
          templateUrl: "app/plugin/html/plugin-new.html",
          controller: 'PluginNewController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            appId: $stateParams.appId
          };
        }
      }
    }).state('plugin.addVersion', {
      parent: 'app',
      url: "/addVersion/:id",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/plugin/html/addVersion.html',
          controller: 'PluginAddVersionController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                id: $stateParams.id
              };
            }
          }
        }).result.then(function (res) {
          // console.log("i m res: ",res);
          $state.go('plugin.detail', {id: res});
        }, function (err) {
          // console.log("i m error: ",err);
          $state.go('plugin');
        });
      }]
    }).state('plugin.showPluginVersion', {
      parent: 'app',
      url: "/showPluginVersion/:id",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/plugin/html/showVersion.html',
          controller: 'PluginShowVersionController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                id: $stateParams.id
              };
            }
          }
        }).result.then(function (res) {
          $state.go('plugin.detail', {id: res});
        }, function (err) {
          $state.go('plugin');
        });
      }]
    });
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('PluginService', PluginService);

  PluginService.$inject = ['$resource', '$http'];

  function PluginService($resource,$http) {
    var service = {
      findPlugin: findPlugin,
      deletePlugin:deletePlugin,
      getPlugin:getPlugin,
      getPermissionData:getPermissionData,
      generateUUID:generateUUID,
      savePermissionData:savePermissionData,
      insertOrUpdate:insertOrUpdate,
      insertVersion:insertVersion,
      getVersion:getVersion,
      getOneVersion:getOneVersion,
      deleteVersion:deleteVersion,
      getCategoryList:getCategoryList,
      loadPluginTypeList:loadPluginTypeList,
      getAppAuthList:getAppAuthList,
      search:search,
      redisInit:redisInit,
      selectProductCanChoose:selectProductCanChoose,
      resetKey: resetKey,
      updateNewVersion: updateNewVersion
    };
    return service;

    function redisInit() {
      var resourceUrl = '/api/redis/redisInitLoad';
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function resetKey() {
      var resourceUrl = '/api/security/jwtToken/refreshKey';
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function getCategoryList(appId) {
      var resourceUrl = '/api/menuCategory/getList?appId='+"a765ff3f-8d33-49b4-a9c9-48e991544242";
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function selectProductCanChoose() {
      var resourceUrl = '/api/menu/selectProductCanChoose';
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function search() {
      var resourceUrl = '/api/queryAllHeader';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST', isArray: false},
        'get': {
          method: 'GET',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
            }
            return data;
          }
        }
      });
    }


    function loadPluginTypeList() {
      var resourceUrl = '/api/menuCategory/getPluginType';
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function findPlugin(plugin) {
      var resourceUrl = '/api/menu/query';
      var data=plugin;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function getPlugin() {
      var resourceUrl = '/api/menu/getMenu/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }


    function deletePlugin() {
      var resourceUrl =  '/api/menu/delete';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function getPermissionData() {
      var resourceUrl = '/api/applicationPermission/query/:id';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST', isArray: false}
      });
    }

    function generateUUID() { //生成新的UUID
      var date = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    }

    function savePermissionData(dataId) {
      var resourceUrl = '/api/applicationPermission/save?dataId='+dataId;
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function insertOrUpdate() {
      var resourceUrl = '/api/menu/insertOrUpdate';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function insertVersion() {
      var resourceUrl = '/api/menuVersion/insertVersion';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function getVersion() {
      var resourceUrl = '/api/menuVersion/getVersion/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function getOneVersion() {
      var resourceUrl = '/api/menuVersion/getOneVersion/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function getAppAuthList() {
      var resourceUrl = '/api/appauth/getList';
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function deleteVersion() {
      var resourceUrl = '/api/menuVersion/deleteVersion/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function updateNewVersion() {
      var resourceUrl = '/api/menuVersion/updateNewVersion/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('PluginController', PluginController);

  PluginController.$inject = ['MessageTemplateService','PluginService','$scope','toastr', '$state', 'paginationConstants','entity','SweetAlert','$filter'];

  function PluginController(MessageTemplateService,PluginService,$scope,toastr, $state, paginationConstants,entity,SweetAlert,$filter) {

    var vm = this;
    vm.loadAppAuthList = loadAppAuthList;
    vm.loadAll = loadAll;
    vm.search = search;
    vm.deletePlugin = deletePlugin;
    vm.reset = reset;
    vm.plugin = {
      appId:''
    };
    vm.uploadPic="assets/images/upload.png";
    vm.appList=[];
    // var plugin = vm.plugin;

    vm.result=[];

    loadAppAuthList();
    // loadAll(plugin);

    vm.initWeidget = initWeidget;
    initWeidget();

    function initWeidget() {
      /*PartyService.getLookUp(['SYS.TEMPLE_TYPE'])
       .then(function (data) {
       vm.templateTypeList = data[0];
       })*/
      MessageTemplateService.getByCode().query({code:'IOT.PGM.PLUGIN_TYPE'},function (data) {
        vm.pluginTypeList=data.rows;
      },function (error) {
      });
    }

    function loadAll(plugin) {
      return PluginService.findPlugin(plugin)
        .then(function (data) {
          vm.result = data.rows;
        })
    }

    function reset() {
      vm.plugin.pluginType = '';
      vm.plugin.menuName = '';
    }

    function deletePlugin(id) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"), {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if(p){
          if(id){
            PluginService.deletePlugin().query({id: id}, function (result) {
              toastr.success($filter('T')("plugin.deleteSucceed"), $filter('T')("plugin.deleteMessage"));
              // $state.go('menu.detail/'+entity.id);
              loadAll(vm.plugin);
            });
          }
        }
      });
    }

    function search() {
      loadAll(vm.plugin);
    };

    function loadAppAuthList() {
      return PluginService.getAppAuthList()
        .then(function (data) {
          vm.appList = data.rows;
          // console.log('appList--'+angular.toJson(vm.appList));
          for(var i=0;i<vm.appList.length;i++){
            sessionStorage.setItem(vm.appList[i].id,vm.appList[i].appId);
          }
          if(entity.appId){
            vm.plugin.appId=entity.appId;
            loadAll(vm.plugin)
          }else{
            if(vm.appList.length>0){
              vm.plugin.appId=vm.appList[0].appId;
              loadAll(vm.plugin)
            }else{
              // console.log('暂无应用');
            }
          }
        })
    }
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('PluginNewController', PluginNewController);

  PluginNewController.$inject = ['$filter','PluginService','MessageTemplateService','PromptService', 'toastrConfig','$scope', '$state', '$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','toastr','entity','$translate'];

  function PluginNewController($filter,PluginService,MessageTemplateService,PromptService,toastrConfig, $scope, $state, $localStorage, $sessionStorage, $timeout, Upload, BaseConfig,toastr,entity, $translate) {
    var vm = this;
     vm.plugin = entity;
    // console.log('entity='+angular.toJson(entity))
    vm.save = save;
    vm.submitFile = submitFile;

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    vm.upload = upload;
    vm.oldFile="assets/images/logo-header.png";
    vm.changeFile=changeFile;
    vm.clear=clear;
    vm.permissionData=[];
    // vm.savePermission=savePermission;
    vm.file = "";
    vm.categoryList=[];
    vm.loadList=loadList;

    vm.localeSure = localeSure;
    vm.showLocale = showLocale;
    vm.initLangs = initLangs;
    vm.initWeidget = initWeidget;
    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#menuNameBtn").attr("disabled", false);
        $("#menuDescBtn").attr("disabled", false);
        $("#functionDescBtn").attr("disabled", false);

       /* $("#menuDescBtn").attr("disabled", false);
        $("#templateNameBtn").attr("disabled", false);*/
      });
    }

    initLangs();

    vm.plugin = entity;
    vm.pluginTypeList = [];
    loadList(entity.appId);
    //loadPluginTypeList();
    initWeidget();
    vm.selectProductCanChoose = selectProductCanChoose;


    function loadList(appId) {
      return PluginService.getCategoryList(appId)
        .then(function (data) {
          vm.categoryList = data.rows;

          // console.log('liebiao_'+angular.toJson(vm.categoryList))
        })
    }
    vm.selectProductCanChoose();

    function selectProductCanChoose(){
      return PluginService.selectProductCanChoose()
        .then(function (data) {
          vm.pluginCodeList = data.rows;
        })

    }

    function initWeidget() {

      MessageTemplateService.getByCode().query({code:'IOT.PGM.PLUGIN_TYPE'},function (data) {
        vm.pluginTypeList=data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'IOT.PGM.PLUGIN_CATEGORY_TYPE'},function (data) {
        vm.menuTypeList=data.rows;
      },function (error) {
      });
      // state
    }

    /*function loadPluginTypeList() {
      return PluginService.loadPluginTypeList()
        .then(function (data) {
          vm.pluginTypeList = data.rows;
          // console.log('liebiao_'+angular.toJson(vm.categoryList))
        })
    }*/



    function changeFile() {
      if(vm.file){
        vm.oldFile=vm.file
      }
    }
    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitFile() {
      if(vm.oldFile!="assets/images/logo-header.png"){
        vm.file=vm.oldFile;
      }
      if(vm.file=="assets/images/logo-header.png"){
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"), $filter('T')("title.ErrorInfo"));
        return;
      }
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
        toastr.info('请先点击按钮上方图片框选择对应图片!!');
        return;
      }
      upload(vm.file);
    };

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With':'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        ////console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        console.log("data from backend ：", data.rows[0].objectUrl);
        vm.plugin.menuIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($translate.instant('uploadImg.uploadSuccess'), $translate.instant('title.infoTitle'));
      }).error(function (data, status, headers, config) {
        //上传失败
        ////console.log('错误状态: ' + status);
      });
    }

    function save() {
      /*if(vm.plugin.menuIcon==""||vm.plugin.menuIcon==undefined||vm.plugin.menuIcon==null){
        toastr.error('请先上传图片!!', '错误信息');
        return;
      }*/
      if(vm.plugin.isMandatory==true){
        vm.plugin.isMandatory='Y';
      }else{
        vm.plugin.isMandatory='N';
      }

      if(vm.plugin.isCoverNavBar==true){
        vm.plugin.isCoverNavBar='Y';
      }else{
        vm.plugin.isCoverNavBar='N';
      }

      if(vm.plugin.isDefault==true){
        vm.plugin.isDefault='Y';
      }else{
        vm.plugin.isDefault='N';
      }


      vm.plugin.categoryId=vm.categoryList[0].id;
      vm.plugin.menuType = "LOCAL";
      vm.permissions=[];//拿选取的权限数据
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=PluginService.generateUUID();
        }
        vm.permissions.push({id:permissionId,valueIcon:vm.permissionData[i].dataIcon,dataId:'',
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,dataKey:vm.permissionData[i].dataId,
          visibilityType:'WEBAPP'})
      }
      vm.plugin.appId=entity.appId;
      vm.plugin.applicationPermissions = vm.permissions;
       console.log('data to be save：'+angular.toJson(vm.plugin));
      PluginService.insertOrUpdate().save(vm.plugin, onSuccess, onError);
      // console.log(angular.toJson(vm.plugin));
    };
    function onSuccess(data, headers) {
      if(data.code=="repeat"){
        toastr.warning($filter('T')('distribution.repeatNot'), $filter('T')("plugin.warnMessage"));
        return;
      }
      //vm.plugin = data.rows[0];
      toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.infoTitle"));
      $state.go('plugin');
    }
    function onError(error) {

    }
    function clear() {
      $state.go('plugin',{appId:entity.appId});
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.plugin.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.plugin.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.plugin[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.plugin.__tls = __tls;
    }

    /*function savePermission() {
      vm.permissions=[];
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=MenuService.generateUUID();
        }
        vm.permissions.push({id:permissionId,dataIcon:vm.permissionData[i].dataIcon,dataId:vm.menu.id,
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,valueId:vm.permissionData[i].dataId,
          visibilityType:'WEBAPP'})
      }
      MenuService.savePermissionData(vm.menu.id).save(vm.permissions);
    }*/
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('PluginDetailController', PluginDetailController);

  PluginDetailController.$inject = ['$filter', 'MessageTemplateService', 'PluginService', 'RoleService', 'PromptService', 'toastrConfig', '$scope', '$state', '$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig', 'toastr', 'entity', 'SweetAlert'];

  function PluginDetailController($filter, MessageTemplateService, PluginService, RoleService, PromptService, toastrConfig, $scope, $state, $localStorage, $sessionStorage, $timeout, Upload, BaseConfig, toastr, entity, SweetAlert) {
    var vm = this;
    vm.menu = entity;

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    vm.save = save;
    vm.submitFile = submitFile;
    vm.upload = upload;
    vm.changeFile = changeFile;

    vm.load = load;
    vm.loadVersion = loadVersion;
    vm.deleteVersion = deleteVersion;
    vm.oldFile = "assets/images/logo-header.png";

    vm.clear = clear;
    vm.ischecked = "";
    vm.mouseIn = "";
    vm.permissions = [];
    vm.check = check;
    vm.nocheck = nocheck;
    vm.pluginTypeList = [];
    vm.selectProductCanChoose = selectProductCanChoose;

    vm.savePermission = savePermission;
    vm.getPermission = getPermission;
    vm.permissionData = [];
    vm.menuVersions = [];
    vm.categoryList = [];
    vm.loadList = loadList;

    vm.showLocale = showLocale;
    vm.localeSure = localeSure;
    vm.cancerChooseCode = cancerChooseCode;
    vm.setNewVersion = setNewVersion;

    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
      });
    }

    initLangs();


    vm.load(entity.id);
    vm.loadVersion(entity.id);

    //loadPluginTypeList();

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_" + name).modal("show");
      if ($.trim($("#localeModelBody_" + name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='" + name + "_" + langs[i].langCode
            + "' ng-model='vm.menu.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_" + name).append(div);
          $("input[name='" + name + "_" + langs[i].langCode + "']").val(vm.menu.__tls[name][langs[i].langCode]);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.menu.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + name + "_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.menu[name] = $("input[name='" + name + "_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_" + name).modal("hide");
      __tls[name] = description;
      vm.menu.__tls = __tls;
    }

    function cancerChooseCode() {
      vm.menu.pluginCode = pluginCodeOld;
      vm.ischecked = "";
      $event.stopPropagation();
    }

    function loadList(appId) {
      return PluginService.getCategoryList(appId)
      .then(function (data) {
        vm.categoryList = data.rows;
        // console.log('liebiao_'+angular.toJson(vm.categoryList))
      })
    }

    vm.file = "";

    function changeFile() {
      if (vm.file) {
        vm.oldFile = vm.file
      }
    }

    var pluginCodeOld = "";

    function load(id) {
      if (id) {
        PluginService.getPlugin().query({id: id}, function (result) {
          vm.menu = result.rows[0];
          vm.loadList(vm.menu.appId);
          if (vm.menu.pluginCode) {
            pluginCodeOld = vm.menu.pluginCode;
          }
          // console.log('后台传来的是：'+angular.toJson(vm.menu));
          if (vm.menu.isCoverNavBar == 'Y') {
            vm.menu.isCoverNavBar = true;
          } else {
            vm.menu.isCoverNavBar = false;
          }
          if (vm.menu.status == 'Y') {
            vm.menu.status = true;
          } else {
            vm.menu.status = false;
          }
          if (vm.menu.isDefault == 'Y') {
            vm.menu.isDefault = true;
          } else {
            vm.menu.isDefault = false;
          }
          //getPermission();
          vm.oldFile = vm.menu.menuIcon;
          vm.menu.oldMenuName = vm.menu.menuName;
          var __tls = {};
          RoleService.getRoleLocaleInfo(id, 'com.iot.portal.admin.hms.menu.domain.HmsMenuInfo', 'menuName')
          .then(function (data) {
            //deal with the multilanguage field value
            var menuNameList = {};
            for (var i in data) {
              menuNameList[data[i].langCode] = data[i].value;
            }
            __tls['menuName'] = menuNameList;

            RoleService.getRoleLocaleInfo(id, 'com.iot.portal.admin.hms.menu.domain.HmsMenuInfo', 'functionDesc')
            .then(function (data) {
              //deal with the multilanguage field value
              var menuDescList = {};
              for (var i in data) {
                menuDescList[data[i].langCode] = data[i].value;
              }
              __tls['functionDesc'] = menuDescList;

              RoleService.getRoleLocaleInfo(id, 'com.iot.portal.admin.hms.menu.domain.HmsMenuInfo', 'menuDesc')
              .then(function (data) {
                //deal with the multilanguage field value
                var menuDescList = {};
                for (var i in data) {
                  menuDescList[data[i].langCode] = data[i].value;
                }
                __tls['menuDesc'] = menuDescList;

                vm.menu.__tls = __tls;
                $("#menuNameBtn").attr("disabled", false);
                $("#menuDescBtn").attr("disabled", false);
                $("#functionDescBtn").attr("disabled", false);
                /*$("#templateNameBtn").attr("disabled", false);*/
              });
            });


          });


        });
      }
    }

    function loadVersion(id) {
      if (id) {
        PluginService.getVersion().query({id: id}, function (result) {
          vm.menuVersions = result.rows;
          console.log(vm.menuVersions);
        });
      }
    }

    /*function loadPluginTypeList() {
      return PluginService.loadPluginTypeList()
        .then(function (data) {
          vm.pluginTypeList = data.rows;
          // console.log('liebiao_'+angular.toJson(vm.categoryList))
        })
    }*/
    initWeidget();

    function initWeidget() {
      MessageTemplateService.getByCode().query({code: 'IOT.PGM.PLUGIN_TYPE'}, function (data) {
        vm.pluginTypeList = data.rows;
      }, function (error) {
      });

      MessageTemplateService.getByCode().query({code: 'IOT.PGM.PLUGIN_CATEGORY_TYPE'}, function (data) {
        vm.menuTypeList = data.rows;
      }, function (error) {
      });
      // state
    }

    vm.selectProductCanChoose();

    function selectProductCanChoose() {
      return PluginService.selectProductCanChoose()
      .then(function (data) {
        vm.pluginCodeList = data.rows;
      })

    }

    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;

    //提交
    function submitFile() {
      if (vm.oldFile != "assets/images/logo-header.png") {
        vm.file = vm.oldFile;
      }
      if (!vm.file) {
        toastr.warning($filter('T')("plugin.pluginImgRequired"), $filter('T')('plugin.warnMessage'));
        return;
      }
      upload(vm.file);
      /*if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }*/
    }

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        ////console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.menu.menuIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')('uploadImg.uploadSuccess'), $filter('T')('title.confirmTitle'));
        vm.save();
      }).error(function (data, status, headers, config) {
        //上传失败
        ////console.log('错误状态: ' + status);
      });
    };

//$filter('T')("plugin.deleteConfirm")
    function deleteVersion(id) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"), {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if (p) {
          if (id) {
            PluginService.deleteVersion().query({id: id}, function (result) {
              toastr.success($filter('T')("plugin.deleteSucceed"), $filter('T')("plugin.deleteMessage"));
              // $state.go('menu.detail/'+entity.id);
              vm.loadVersion(entity.id);
            });
          }
        }
      });
    }

    function trim(str) { //删除左右两端的空格
      return str.replace(/(^\s*)|(\s*$)/g, "");
    }


    function save() {
      if (vm.menu.menuName == "" || vm.menu.menuName == undefined || vm.menu.menuName == null || trim(vm.menu.menuName) == "") {
        toastr.warning($filter('T')("plugin.pluginNameNotNull"), $filter('T')("plugin.warnMessage"), $filter('T')("plugin.pluginNameNotNull"));
        return;
      }
      ;

      if (vm.menu.menuDesc == "" || vm.menu.menuDesc == undefined || vm.menu.menuDesc == null || trim(vm.menu.menuDesc) == "") {
        toastr.warning($filter('T')("plugin.DescriptionNotNull"), $filter('T')("plugin.warnMessage"));
        return;
      }

      if (vm.menu.isMandatory == true) {
        vm.menu.isMandatory = 'Y';
      } else {
        vm.menu.isMandatory = 'N';
      }
      if (vm.menu.status == true) {
        vm.menu.status = 'Y';
      } else {
        vm.menu.status = 'N';
      }

      if (vm.menu.isCoverNavBar == true) {
        vm.menu.isCoverNavBar = 'Y';
      } else {
        vm.menu.isCoverNavBar = 'N';
      }

      if (vm.menu.isDefault == true) {
        vm.menu.isDefault = 'Y';
      } else {
        vm.menu.isDefault = 'N';
      }

      vm.permissions = [];//拿选取的权限数据
      for (var i = 0; i < vm.permissionData.length; i++) {
        var permissionId = "";
        if (vm.permissionData[i].id) {
          permissionId = vm.permissionData[i].id;
        } else {
          permissionId = PluginService.generateUUID();
        }
        vm.permissions.push({
          id: permissionId,
          valueIcon: vm.permissionData[i].dataIcon,
          dataId: '',
          dataType: vm.permissionData[i].dataType,
          dataValue: vm.permissionData[i].dataValue,
          dataKey: vm.permissionData[i].dataId,
          visibilityType: 'WEBAPP'
        })
      }
      vm.menu.applicationPermissions = vm.permissions;
      vm.menu.editOrAdd = 'edit';
      PluginService.insertOrUpdate().save(vm.menu, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      if (data.code == 'repeat') {
        toastr.warning($filter('T')('distribution.repeatNot'), $filter('T')("plugin.warnMessage"));
        return;
      }
      //vm.menu=data.rows[0];
      vm.menu.oldMenuName = vm.menu.menuName;
      if (vm.menu.isMandatory === 'Y') {
        vm.menu.isMandatory = true;
      } else {
        vm.menu.isMandatory = false;
      }
      if (vm.menu.status == 'Y') {
        vm.menu.status = true;
      } else {
        vm.menu.status = false;
      }

      if (vm.menu.isDefault == 'Y') {
        vm.menu.isDefault = true;
      } else {
        vm.menu.isDefault = false;
      }

      if (vm.menu.isCoverNavBar == 'Y') {
        vm.menu.isCoverNavBar = true;
      } else {
        vm.menu.isCoverNavBar = false;
      }
      toastr.success(vm.menu.menuName + $filter('T')('title.saveSuccess'), $filter('T')('title.confirmTitle'));
      //toastr.success('保存成功!', '提示信息');
      vm.ischecked = "";
      vm.mouseIn = "";
      pluginCodeOld = vm.menu.pluginCode;
      // $state.go('menu.detail',{id:entity.id});
    }

    function onError(error) {
    }

    function clear() {
      // $state.go('menu');
    }

    function check(name) {
      vm.ischecked = name;
    }

    function nocheck($event) {
      if (vm.ischecked = 'pluginCode') {
        vm.menu.pluginCode = pluginCodeOld;
      }
      vm.ischecked = "";
      $event.stopPropagation();
    }


    function savePermission() {
      vm.permissions = [];
      for (var i = 0; i < vm.permissionData.length; i++) {
        var permissionId = "";
        if (vm.permissionData[i].id) {
          permissionId = vm.permissionData[i].id;
        } else {
          permissionId = PluginService.generateUUID();
        }
        // console.log('permissionData-->'+angular.toJson(vm.permissionData[i]));
        vm.permissions.push({
          id: permissionId,
          valueIcon: vm.permissionData[i].dataIcon,
          dataId: vm.menu.id,
          dataType: vm.permissionData[i].dataType,
          dataValue: vm.permissionData[i].dataValue,
          dataKey: vm.permissionData[i].dataId,
          visibilityType: 'WEBAPP'
        })
      }
      PluginService.savePermissionData(vm.menu.id).save(vm.permissions, onSuccess1, onError1);
    }

    function onSuccess1(data, headers) {
      toastr.success($filter('T')('title.saveSuccess'), $filter('T')('title.confirmTitle'));
      vm.ischecked = "";
      vm.mouseIn = "";
    }

    function onError1(error) {
    }

    function getPermission() {
      PluginService.getPermissionData().query({id: vm.menu.id}, function (data) {
        vm.result = data.rows;
        // console.log('vm.result'+angular.toJson(vm.result));
        for (var i = 0; i < vm.result.length; i++) {
          vm.permissionData.push({
            id: vm.result[i].id, dataIcon: vm.result[i].valueIcon, dataType: vm.result[i].dataType,
            dataValue: vm.result[i].dataValue, dataId: vm.result[i].dataKey
          })
        }
        // console.log('vm.permissionData'+angular.toJson(vm.permissionData));
      });
    }

    function setNewVersion(menuV) {
      console.log(menuV);
      if (menuV) {
        PluginService.updateNewVersion().query({id: menuV.id}, function (result) {
          //toastr.success($filter('T')("version.updateSucceed"), $filter('T')("version.updateMessage"));
          console.log("success");
          vm.loadVersion(entity.id);
        });
      }
    }
  }
})();

/**
 * Created by 罗平 on 2016/9/29.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('PluginAddVersionController', PluginAddVersionController);

  PluginAddVersionController.$inject = [ 'PluginService','PromptService','$filter', '$scope', 'toastrConfig','$state', '$uibModalInstance','entity','toastr','Upload','BaseConfig','$localStorage','$sessionStorage','$translate'];

  function PluginAddVersionController(PluginService,PromptService,$filter, $scope,toastrConfig, $state, $uibModalInstance,entity,toastr,Upload,BaseConfig,$localStorage,$sessionStorage,$translate) {
    var vm = this;
    vm.savePermission=savePermission;
    vm.permissionData=[];
  /*  vm.changConer = changConer;*/
    vm.isGrayscalPlugin = [{
      value: 'Y',
      name: $translate.instant("appEdition.yes")
    },{
      value: 'N',
      name: $translate.instant("appEdition.no")
    }];

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
    vm.typeFlag = true;
    vm.showButton = true;
    vm.noEdit = false;
    // vm.noButton = false;
    vm.menuVersion = {
      menuId:'',
      menuVersionVisible:''
    };
    vm.menuVersion.menuId = entity.id;
    // console.log('id'+angular.toJson(entity))
    vm.clear = clear;
    vm.add = add;
    vm.loadPlugin = loadPlugin;
    vm.upFile=upFile;
    vm.localUpLoad=localUpLoad;

    vm.localeSure = localeSure;
    vm.showLocale = showLocale;
    vm.initLangs = initLangs;
    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#menuDescBtn").attr("disabled", false);
        /* $("#menuDescBtn").attr("disabled", false);
         $("#templateNameBtn").attr("disabled", false);*/
      });
    }

    initLangs();


    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.menuVersion.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.menuVersion.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.menuVersion[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.menuVersion.__tls = __tls;
    }

    vm.loadPlugin(entity.id);
    function loadPlugin(id) {
      if(id){
        PluginService.getPlugin().query({id: id}, function (result) {
          vm.menu = result.rows[0];
          if(vm.menu.menuType=='LOCAL'){
            vm.typeFlag = true;
            vm.showButton = true;
          }else{
            vm.typeFlag = false;
            vm.showButton = false;
          }
        });
      }
    }

    function add() {
      var menuVersionVisible = '';
      for(var i=0;i<vm.permissionData.length;i++){
        menuVersionVisible = menuVersionVisible+vm.permissionData[i].dataValue+';';
      }
      vm.menuVersion.menuVersionVisible=menuVersionVisible;
      if(vm.menuVersion.showConer==true){
        vm.menuVersion.showConer='Y';
      }else{
        vm.menuVersion.showConer='N';
      }
      if(vm.menuVersion.isSilenceUpdate==true){
        vm.menuVersion.isSilenceUpdate='Y';
      }else{
        vm.menuVersion.isSilenceUpdate='N';
      }
      if(vm.menuVersion.isForceUpdate==true){
        vm.menuVersion.isForceUpdate='Y';
      }else{
        vm.menuVersion.isForceUpdate='N';
      }
      vm.permissions=[];//保存的权限数据
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=PluginService.generateUUID();
        }
        vm.permissions.push({id:permissionId,valueIcon:vm.permissionData[i].dataIcon,dataId:'',
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,dataKey:vm.permissionData[i].dataId,
          visibilityType:'WEBVERSION'})
      }
      vm.menuVersion.applicationPermissions=vm.permissions;
      PluginService.insertVersion().save(vm.menuVersion, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      if(data.code=='versionRepeat'){
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.error($filter('T')("plugin.versionRepeat"), $filter('T')("title.infoTitle"));
        $("#menuVersion").removeAttr("readonly");
        return;
      }
      //vm.menuVersion = data.rows[0];
      toastr.success('保存成功!', '提示信息');
      $uibModalInstance.close(entity.id);
    }
    function onError(error) {
    }

    function clear() {
      $uibModalInstance.close(entity.id);
      //$uibModalInstance.dismiss('cancel');
    }

    function savePermission() {
      vm.permissions=[];
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=PluginService.generateUUID();
        }
        vm.permissions.push({id:permissionId,dataIcon:vm.permissionData[i].dataIcon,dataId:vm.menuVersion.id,
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,valueId:vm.permissionData[i].dataId,
          visibilityType:'WEBVERSION'})
      }
      // console.log('vm.menu.id--'+vm.menuVersion.id);
      PluginService.savePermissionData(vm.menuVersion.id).save(vm.permissions);
    }

    function localUpLoad(target){
      if(vm.menu.menuType=='LOCAL'){
        document.getElementById(target).click();
      }
    }



    function upFile(){
      if(!vm.menuVersion.menuVersion) {
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.warning($filter('T')("plugin.versionFirst"), $filter('T')("plugin.warnMessage"));
        return false;
      }
      var file=document.getElementById("zip").files[0];
      if (file == null || file== undefined || file == '') {
        return false;
      }
      $("#menuVersion").attr("readonly",true);
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/menuVersion/uploadZip',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        data: {file: file,menuVersion:vm.menuVersion.menuVersion,pluginCode:vm.menu.pluginCode}
      }).progress(function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        // vm.picurl=data.rows[0].pictureUrl;
        // $state.go('legwork', null, {reload: true});
        console.log('上传后拿到的内容是：'+angular.toJson(data));
        console.log("成功上传：");
        if(data.success==false){
          toastr.error($filter('T')("plugin.packageUploadFail"), $filter('T')("title.ErrorInfo"));
          return ;
        }
        if(data.code=='versionRepeat'){
          var file = $("#zip");
          file.after(file.clone().val(""));
          file.remove();
          toastr.error($filter('T')("plugin.versionRepeat"), $filter('T')("title.infoTitle"));
          $("#menuVersion").removeAttr("readonly");
          return;
        }else if(data.code=='errorType'){
          var file = $("#zip");
          file.after(file.clone().val(""));
          file.remove();
          toastr.error($filter('T')("plugin.mustCorrectFormet"), $filter('T')("plugin.warnMessage"));
          $("#menuVersion").removeAttr("readonly");
          return;
        }
        if(data.success==true){
          toastr.success('资源包上传成功!', '提示信息');
        }
        vm.menuVersion.cloudUrl = data.rows[0].zipUrl;
        vm.menuVersion.menuResource = data.rows[0].zipUrl;
        vm.menuVersion.contentMd5 = data.rows[0].contentMd5;
        vm.menuVersion.picId = data.rows[0].picId;
        /*vm.menuVersion.menuVersion = data.rows[0].menuVersion;
        vm.menuVersion.menuDesc = data.rows[0].menuDesc;
        vm.menuVersion.menuResource = data.rows[0].menuResource;
        vm.menuVersion.menuLocalPath = data.rows[0].menuLocalPath;
        vm.menuVersion.showConer = data.rows[0].showConer;
        vm.menuVersion.isSilenceUpdate = data.rows[0].isSilenceUpdate;
        vm.menuVersion.isForceUpdate = data.rows[0].isForceUpdate;
        if(vm.menuVersion.showConer=='Y'){
          vm.menuVersion.showConer=true;
        }else{
          vm.menuVersion.showConer=false;
        }
        if(vm.menuVersion.isSilenceUpdate=='Y'){
          vm.menuVersion.isSilenceUpdate=true;
        }else{
          vm.menuVersion.isSilenceUpdate=false;
        }
        if(vm.menuVersion.isForceUpdate=='Y'){
          vm.menuVersion.isForceUpdate=true;
        }else{
          vm.menuVersion.isForceUpdate=false;
        }*/
        vm.noEdit = true;
      }).error(function (data, status, headers, config) {

      });
    }

  }
})();

/**
 * Created by user on 2016/8/10.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditCodingValueController', EditCodingValueController);

  EditCodingValueController.$inject = ['$filter','CodingValueService', '$state', '$uibModalInstance', 'entity','toastr', 'CodingService', 'PromptService'];

  function EditCodingValueController($filter,CodingValueService, $state, $uibModalInstance, entity,toastr, CodingService, PromptService) {
    var vm = this;
    vm.codeValue = entity;
    vm.clear = clear;
    vm.update = update;

    //console.log("codeValue:" + angular.toJson(vm.codeValue));

    var codeValue = vm.codeValue;
    vm.showMeaningLocale = showMeaningLocale;
    vm.meaningLocaleSure = meaningLocaleSure;
    vm.showDecLocale = showDecLocale;
    vm.decLocaleSure = decLocaleSure;

    // langs[{'name': '简体中文', 'value': 'zh_CN'}, {'name': 'English', 'value': 'en_GB'}]
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
      });
    }
    initLangs();

    getCodeValue(codeValue);
    function getCodeValue(codeValue) {
      CodingValueService.findCodeValuesByCodeValue(codeValue)
        .then(function (data) {
          vm.codeValue = data.rows[0];
          CodingService.getCodeLocaleInfo(codeValue.codeValueId, 'com.kohler.iot.base.general.entities.CodeValue', $("#meaningLocaleBtn").val())
            .then(function (data) {
              //deal with the multilanguage field value
              var __tls = {};
              var meanings = {};
              for (var i in data) {
                meanings[data[i].langCode] = data[i].value;
              }
              __tls[$("#meaningLocaleBtn").val()] = meanings;
              CodingService.getCodeLocaleInfo(codeValue.codeValueId, 'com.kohler.iot.base.general.entities.CodeValue', $("#decLocaleBtn").val())
                .then(function (data) {
                  //deal with the multilanguage field value
                  var decs = {};
                  for (var i in data) {
                    decs[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#decLocaleBtn").val()] = decs;
                  vm.codeValue.__tls = __tls;
                  $("#meaningLocaleBtn").attr('disabled', false);
                  $("#decLocaleBtn").attr('disabled', false);
                })
            })
        })
    }

    function update() {
      //console.log("code:" + angular.toJson(vm.codeValue));
      return CodingValueService.updateCodeValue(vm.codeValue)
        .then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
            $uibModalInstance.close();
            return null;
            //return $state.go('codingValue', null, {reload: 'codingValue'});
          }

        })

    }


    //$scope.addLine = function (header) {
    //  $state.go("addLine", {headerId: header.headerId});
    //};
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showMeaningLocale() {
      // According to langs to make inputs.
      $("#meaningLocaleModal").modal("show");
      if($.trim($("#meaningLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='m_" + langs[i].langCode
            + "' ng-model='vm.codeValue.__tls." + $("#meaningLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#meaningLocaleModelBody").append(div);
          // init field value
          $("input[name='m_" + langs[i].langCode + "']").val(vm.codeValue.__tls[$("#meaningLocaleBtn").val()][langs[i].langCode]);
        }
      }

    }

    function meaningLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.codeValue.__tls || {};
      var description = {};

      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='m_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.codeValue[$("#meaningLocaleBtn").val()] = $("input[name='m_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#meaningLocaleModal").modal("hide");
      __tls[$("#meaningLocaleBtn").val()] = description;
      vm.codeValue.__tls = __tls;
    }

    function showDecLocale() {
      // According to langs to make inputs.
      $("#decLocaleModal").modal("show");
      if($.trim($("#decLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='d_" + langs[i].langCode
            + "' ng-model='vm.codeValue.__tls." + $("#decLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#decLocaleModelBody").append(div);
          // init field value
          $("input[name='d_" + langs[i].langCode + "']").val(vm.codeValue.__tls[$("#decLocaleBtn").val()][langs[i].langCode]);
        }
      }

    }

    function decLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.codeValue.__tls || {};
      var description = {};

      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='d_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.codeValue[$("#decLocaleBtn").val()] = $("input[name='d_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#decLocaleModal").modal("hide");
      __tls[$("#decLocaleBtn").val()] = description;
      vm.codeValue.__tls = __tls;
    }
  }


})();

/**
 * Created by user on 2016/8/10.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('codingValue', {
        parent: 'app',
        url: "/codingValue/{codeId}",
        views: {
          'body': {
            templateUrl: "app/lookup/codingValue/codingValue.html",
            controller: 'CodingValueController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              //console.log("0000="+$stateParams.codeId);
              return {
                codeId:$stateParams.codeId
              };
            }
          ]
        }

      }).state('codingValue.edit', {
        parent: 'codingValue',
        url: "/edit/:codeValueId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          ////console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/lookup/codingValue/editCodingValue.html',
            controller: 'EditCodingValueController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                //console.log("entity:"+angular.toJson($stateParams.codeValueId));
                return {
                  codeValueId:$stateParams.codeValueId
                };
              }
            }
          }).result.then(function () {
              //console.log("codingValue go1");
              $state.go('codingValue', null, {reload: 'codingValue'});
            }, function () {
              //console.log("codingValue go2");
              $state.go('codingValue');
            });
        }]
      }) .state('codingValue.add', {
        parent: 'codingValue',
        url: "/add/:codeId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/lookup/codingValue/addCodingValue.html',
            controller: 'AddCodingValueController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                //console.log("entity:"+angular.toJson($stateParams.codeId));
                return {
                  codeId:$stateParams.codeId,
                  value: null,
                  meaning: null
                };
              }
            }
          }).result.then(function () {
              //console.log("codingValue go1");
              $state.go('codingValue', null, {reload: 'codingValue'});
            }, function () {
              //console.log("codingValue go2");
              $state.go('codingValue');
            });
        }]
      });


  }
})();

/**
 * Created by user on 2016/8/10.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('CodingValueService', CodingValueService);

  CodingValueService.$inject = ['$resource', '$http', '$state'];

  function CodingValueService($resource, $http) {
    var service = {
      //findCodeValues: findCodeValues,
      findCodeValuesByCodeValue:findCodeValuesByCodeValue,
      updateCodeValue: updateCodeValue,
      addCodingValue: addCodingValue,
      deleteCodeValue:deleteCodeValue
    };
    return service;

  /*  function findCodeValues(code) {
      //console.log("service  code+++:" + angular.toJson(code));
      var resourceUrl = '/api/codeValue/getValuesByCode';
      var data = code;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response.data));
        return response.data;
      })
    }*/

    function findCodeValuesByCodeValue(codeValue) {
      //console.log("service  code----:" + angular.toJson(codeValue));
      var resourceUrl = '/api/codeValue/getValues';
      var data = codeValue;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response.data));
        return response.data;
      })
    }


    function updateCodeValue(codeValue) {

      var resourceUrl = '/api/codeValue/update';
      var data = codeValue;
      //console.log("service  codeValue:" + angular.toJson(data));
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });

    };

    function addCodingValue(codeValue) {
      var resourceUrl = "/api/codeValue/insert";
      //console.log("insert codeValue:" + angular.toJson(codeValue));

      return $http.post(resourceUrl, codeValue, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function deleteCodeValue(codeValue){
      var resourceUrl = "/api/codeValue/delete";
      //console.log("delete codeValue:"+angular.toJson(codeValue));
      return $http.post(resourceUrl,codeValue,{
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function(response){
        return response.data;
      })
    }


  }

})();

/**
 * Created by user on 2016/8/10.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('CodingValueController', CodingValueController);

  CodingValueController.$inject = ['$filter','CodingValueService', 'CodingService', 'entity', '$state','SweetAlert','toastr'];

  function CodingValueController($filter,CodingValueService, CodingService, entity, $state,SweetAlert,toastr) {
    var vm = this;
    vm.code = entity;

    vm.search = search;
    vm.reset = reset;
    vm.delete = deleteCodeValue;
    vm.reBack = reBack;

    loadAll(vm.code);
    getCodes(vm.code);


    function getCodes(code) {
      return CodingService.findCodes(code)
        .then(function (data) {
          vm.code = data.rows[0];
          //console.log("result code" + angular.toJson(vm.code));
        })

    }

    function loadAll(code) {
      return CodingValueService.findCodeValuesByCodeValue(code)
        .then(function (data) {
          vm.codeValues = data.rows;
          //console.log("result values" + angular.toJson(vm.codeValues));
        })

    };

    function search() {
      if (vm.codeValue.value === "") {
        vm.codeValue.value = undefined;
      }
      if (vm.codeValue.meaning === "") {
        vm.codeValue.meaning = undefined;
      }
      vm.codeValue.codeId = vm.code.codeId;
      var codeValue = vm.codeValue;

      loadAll(codeValue);

    };

    function reset() {
      vm.codeValue.value = undefined;
      vm.codeValue.meaning = undefined;
    };

    function deleteCodeValue(codeValue) {

      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"),
        {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
          if(p){
            return CodingValueService.deleteCodeValue(codeValue)
              .then(function (data) {
                var flag = data.success;
                //console.log("delete result" + angular.toJson(flag));
                toastr.success($filter('T')("plugin.deleteSucceed"), $filter('T')("plugin.deleteMessage"));
                if (flag) {
                  return $state.go('codingValue', null, {reload: 'codingValue'});
                }
              })
          }
        });

      //console.log("result codeValue" + angular.toJson(codeValue));


    };

    function reBack() {
      $state.go("coding");
    }

  }


})();

/**
 * Created by user on 2016/8/10.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddCodingValueController', AddCodingValueController);

  AddCodingValueController.$inject = ['CodingValueService', '$uibModalInstance', 'entity','toastr', '$filter', 'PromptService', 'toastrConfig'];

  function AddCodingValueController(CodingValueService, $uibModalInstance, entity,toastr, $filter, PromptService, toastrConfig) {
    var vm = this;
    vm.codeValue = entity;
    vm.clear = clear;
    vm.add = add;
    vm.showMeaningLocale = showMeaningLocale;
    vm.meaningLocaleSure = meaningLocaleSure;
    vm.showDecLocale = showDecLocale;
    vm.decLocaleSure = decLocaleSure;

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#meaningLocaleBtn").attr('disabled', false);
        $("#decLocaleBtn").attr('disabled', false);
      });
    }
    initLangs();

    function add() {
      //console.log("codeValue:" + angular.toJson(vm.codeValue));
      // console.log(vm.codeValue);
      return CodingValueService.addCodingValue(vm.codeValue).then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.code == 'repeat') {
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
            $uibModalInstance.close();
            return null;
          }
        })
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showMeaningLocale() {
      // According to langs to make inputs.
      $("#meaningLocaleModal").modal("show");
      if($.trim($("#meaningLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='m_" + langs[i].langCode + "' ng-model='vm.codeValue.__tls."
            + $("#meaningLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#meaningLocaleModelBody").append(div);
        }
      }

    }

    function meaningLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.codeValue.__tls || {};
      var description = {};

      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='m_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.codeValue[$("#meaningLocaleBtn").val()] = $("input[name='m_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#meaningLocaleModal").modal("hide");
      __tls[$("#meaningLocaleBtn").val()] = description;
      vm.codeValue.__tls = __tls;
    }

    function showDecLocale() {
      // According to langs to make inputs.
      $("#decLocaleModal").modal("show");
      if($.trim($("#decLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='d_" + langs[i].langCode + "' ng-model='vm.codeValue.__tls."
            + $("#decLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#decLocaleModelBody").append(div);
        }
      }

    }

    function decLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.codeValue.__tls || {};
      var description = {};

      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='d_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.codeValue[$("#decLocaleBtn").val()] = $("input[name='d_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#decLocaleModal").modal("hide");
      __tls[$("#decLocaleBtn").val()] = description;
      vm.codeValue.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditCodingController', EditCodingController);

  EditCodingController.$inject = ['CodingService', '$scope', '$state', '$uibModalInstance', 'entity','toastr', 'PromptService','$filter'];

  function EditCodingController(CodingService, $scope, $state, $uibModalInstance, entity,toastr, PromptService, $filter) {
    var vm = this;
    vm.code = entity;
    vm.clear = clear;

    vm.update = update;
    //console.log("code:" + angular.toJson(vm.code));
    vm.show = show;
    vm.localeSure = localeSure;

    // langs[{'name': '简体中文', 'value': 'zh_CN'}, {'name': 'English', 'value': 'en_GB'}]
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
      });
    }
    initLangs();

    var code = vm.code;
    getCodeByCodeId(code);
    function getCodeByCodeId(code) {
      return CodingService.findCodes(code)
        .then(function (data) {
          vm.code = data.rows[0];
          return CodingService.getCodeLocaleInfo(code.codeId, 'com.kohler.iot.base.general.entities.Code', $("#localeBtn").val())
            .then(function (data) {
              //deal with the multilanguage field value
              var __tls = {};
              var description = {};
              for (var i in data) {
                description[data[i].langCode] = data[i].value;
              }
              __tls[$("#localeBtn").val()] = description;
              vm.code.__tls = __tls;
              $("#localeBtn").attr('disabled', false);
            })
          //console.log("result00000" + angular.toJson(vm.code));
        })
    }

    function update() {
      //console.log("code:" + angular.toJson(vm.code));
      return CodingService.updateCodes(vm.code)
        .then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
            $uibModalInstance.close();
            return $state.go('coding', null, {reload: 'coding'});
          }

        })

    }


    //$scope.addLine = function (header) {
    //  $state.go("addLine", {headerId: header.headerId});
    //};
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function show() {
      // According to langs to make inputs.
      $("#localeModal").modal("show");
      if($.trim($("#localeModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='" + langs[i].langCode
            + "' ng-model='vm.code.__tls." + $("#localeBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody").append(div);
          // init field value
          $("input[name='" + langs[i].langCode + "']").val(vm.code.__tls[$("#localeBtn").val()][langs[i].langCode]);
        }
      }

    }

    function localeSure() {
      // console.log(window.localStorage.lang);
      var __tls = {};
      var description = {};

      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.code[$("#localeBtn").val()] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal").modal("hide");
      __tls[$("#localeBtn").val()] = description;
      vm.code.__tls = __tls;
    }

  }


})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('coding', {
        parent: 'app',
        url: "/coding",
        views: {
          'body': {
            templateUrl: "app/lookup/coding/coding.html",
            controller: 'CodingController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            //console.log("entity:"+angular.toJson($stateParams.codeId));
            return {
                code: null,
                description: null
            };
          }
        }

      }).state('coding.edit', {
        parent: 'coding',
        url: "/edit/:codeId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          ////console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/lookup/coding/editCoding.html',
            controller: 'EditCodingController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                //console.log("entity:"+angular.toJson($stateParams.codeId));
                return {
                  codeId:$stateParams.codeId
                };
              }
            }
          }).result.then(function () {
              //console.log("coding go1");
              $state.go('coding', null, {reload: 'coding'});
            }, function () {
              //console.log("coding go2");
              $state.go('coding');
            });
        }]
      }).state('coding.add', {
        parent: 'coding',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/lookup/coding/addCoding.html',
            controller: 'AddCodingController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function($stateParams) {
                return {
                  code: null,
                  description: null
              }
              }
            }
          }).result.then(function () {
              //console.log("coding go1");
              $state.go('coding', null, {reload: 'coding'});
            }, function () {
              //console.log("coding go2");
              $state.go('coding');
            });
        }]
      })

  }
})();

/**
 * Created by user on 2016/8/9.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('CodingService', CodingService);

  CodingService.$inject = ['$resource', '$http', '$state'];

  function CodingService($resource, $http) {
    var service = {
      findCodes: findCodes,
      updateCodes: updateCodes,
      addCoding: addCoding,
      deleteCode:deleteCode,
      getLangs: getLangs,
      getCodeLocaleInfo: getCodeLocaleInfo
    };
    return service;

    function findCodes(code,page,pagesize) {
      if(page==undefined){
        page = 1;
      }
      if(pagesize == undefined){
        pagesize = 10;
      }
      //console.log("service  code:" + angular.toJson(code));
      var resourceUrl = '/api/code/query?page='+page+'&pagesize='+pagesize;

      var data = code;
      //console.log("data params:"+angular.toJson(data));
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response.data));
        return response.data;
      })
    }


    function updateCodes(code) {

      var resourceUrl = '/api/code/update';
      var data = code;
      //console.log("service  code:" + angular.toJson(data));
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });

    }

    function addCoding(code) {
      var resourceUrl = "/api/code/insert";
      //console.log("insert code:" + angular.toJson(code));

      return $http.post(resourceUrl, code, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;

      });
    };

    function deleteCode(code) {
      var resourceUrl = "/api/code/delete";
      //console.log("delete code:"+angular.toJson(code));
      return $http.post(resourceUrl, code, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function getLangs() {
      var resourceUrl = '/sys/language/query';
      var data = {};
      data["page"] = 1;
      data["pageSize"] = 999;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response));
        if (response.status == "200" && response.data.success) {
          return response.data.rows;
        } else {
          return [];
        }
      })
    }

    function getCodeLocaleInfo(code, dto, field) {
      //console.log("service  code:" + angular.toJson(code));
      var data = {};
      // lookup code use com.kohler.iot.base.general.entities.Code, looup value use com.kohler.iot.base.general.entities.CodeValue
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      //console.log("data params:"+angular.toJson(data));
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response));
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }

  }

})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('CodingController', CodingController);

  CodingController.$inject = ['$filter','$rootScope', 'CodingService', '$state', 'paginationConstants', 'entity','SweetAlert'];

  function CodingController($filter,$rootScope, CodingService, $state, paginationConstants, entity,SweetAlert) {
    var vm = this;

    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.delete = deleteCode;

    vm.code = entity;
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;


    loadAll(vm.code, page, pagesize);

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
      if(toState.parent == 'app' && toState.name == 'coding' && fromState.name == 'coding.edit') {
        loadAll(vm.code, vm.page, paginationConstants.itemsPerPage);
      }
    });


    function loadAll(code, page, pagesize) {
      return CodingService.findCodes(code, page, pagesize)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
          //console.log("result00000" + angular.toJson(vm.result));
        })

    }

    function search() {
      var page = vm.page = 1;
      var pagesize = paginationConstants.itemsPerPage;
      if (vm.code.code === null || vm.code.code === "") {
        vm.code.code = undefined;
      }
      if (vm.code.description === null || vm.code.description === "") {
        vm.code.description = undefined;
      }
      loadAll(vm.code, page, pagesize);
    };

    function reset() {
      vm.code.code = undefined;
      vm.code.description = undefined;
    };

    function deleteCode(code) {
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          return CodingService.deleteCode(code)
            .then(function (data) {
              var flag = data.success;
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
                return $state.go('coding', null, {reload: 'coding'});
              }
            })
        }
      });

    };


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);

      loadAll(vm.code, vm.page, paginationConstants.itemsPerPage);
    };

  }


})();

/**
 * Created by user on 2016/8/10.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddCodingController', AddCodingController);

  AddCodingController.$inject = ['CodingService', '$scope', '$state', '$uibModalInstance','toastr', 'entity', 'PromptService', '$filter', 'toastrConfig'];

  function AddCodingController(CodingService, $scope, $state, $uibModalInstance,toastr, entity, PromptService, $filter, toastrConfig) {
    var vm = this;
    vm.code = entity;
    vm.clear = clear;

    vm.add = add;
    vm.show = show;
    vm.localeSure = localeSure;

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
      });
    }
    initLangs();

    function add() {
      //console.log("code:" + angular.toJson(vm.code));
      return CodingService.addCoding(vm.code)
        .then(function (data) {
          if(data.code=='repeat'){
            toastr.warning($filter('T')('distribution.repeatNot'));
            return ;
          }
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            toastr.success($filter('T')('title.saveSuccess'));
            $uibModalInstance.close();
            return $state.go('coding', null, {reload: 'coding'});
          }

        });

    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    $scope.locale = function () {
      console.log($("#field_appCode").html());
    };

    function show() {
      // According to langs to make inputs.
      $("#localeModal").modal("show");
      if($.trim($("#localeModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='" + langs[i].langCode
            + "' ng-model='vm.code.__tls." + $("#localeBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody").append(div);
        }
      }
    }

    function localeSure() {
      // console.log(window.localStorage.lang);
      var __tls = {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.code[$("#localeBtn").val()] = $("input[name='" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal").modal("hide");
      __tls[$("#localeBtn").val()] = description;
      vm.code.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('TopnavbarService', TopnavbarService);

  TopnavbarService.$inject = ['$http', '$resource'];

  function TopnavbarService($http) {
    var service = {
      selectLang: selectLang,
      updateLanguage: updateLanguage
    };
    return service;

    function selectLang() {
      var resourceUrl = '/api/hmsUser/selectLocal';
      return $http.post(resourceUrl, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function updateLanguage(entity) {
      var resourceUrl = '/api/hmsUser/updateLocal';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
  }

})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('TopnavbarController', TopnavbarController);

  TopnavbarController.$inject = ['$filter', 'SweetAlert', 'TopnavbarService', 'PromptService', '$translate', '$state', 'Auth', '$localStorage', '$sessionStorage', 'Hmapfe', '$http'];

  function TopnavbarController($filter, SweetAlert, TopnavbarService, PromptService, $translate, $state, Auth, $localStorage, $sessionStorage, Hmapfe, $http) {

    var vm = this;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.initLangs = initLangs;

    /*vm.ty='';*/
    vm.languageType = [];
    vm.initLangs();
    vm.selectType = null;

    function changeLanguage() {
      TopnavbarService.updateLanguage({lang: vm.selectType}).then(function (data) {
        if (data.success) {
          window.localStorage.lang = vm.selectType;
          $translate.use(vm.selectType);
          window.location.reload();
        } else {
          SweetAlert.error($filter('T')('prompt.info'), {title: $filter('T')('prompt.setLangFailed')});
        }
      });
    }

    function initLangs() {
      TopnavbarService.selectLang().then(function (data) {
        vm.selectType = data;
        window.localStorage.lang = vm.selectType;
        $translate.use(vm.selectType);
      });
      PromptService.selectLangNoToken().query(function (data) {
        var rows = data.rows;
        for (var i in rows) {
          if (rows.hasOwnProperty(i)) {
            var obj = {};
            obj["lang"] = rows[i].langCode;
            obj["value"] = rows[i].description;
            vm.languageType[i] = obj;
          }
        }
      });
    }

    function logoutToken(logout) {
      $http.post('/api/logout').then(logout);
    }


    function logout() {
      logoutToken(deleteToken);
    }

    function deleteToken() {
      $localStorage.allTags = undefined;
      $localStorage.deptData = undefined;
      $sessionStorage.user = undefined;
      $sessionStorage.role = undefined;
      Auth.logout();
      // window.location = "http://localhost:3000/#/mainPage?error=exit";
      $state.go('mainPage');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('LeftnavbarController', LeftnavbarController);

  LeftnavbarController.$inject = ['$localStorage','$timeout', '$sessionStorage', '$log', 'Authority','BaseConfig'];

  function LeftnavbarController($localStorage,$timeout, $sessionStorage, $log, Authority,BaseConfig) {
    var vm = this;
    vm.loadUser = loadUser;
    vm.loadRole = loadRole;
    vm.user = {};
    vm.role = {};
    vm.menu = [];
    vm.loadUser();
    vm.loadRole();

    function loadUser() {
      var token = $localStorage.authenticationToken||$sessionStorage.authenticationToken;
      if(!$sessionStorage.user&&!token){
          window.location = BaseConfig.localUrl;
          return ;
      }

      vm.user.partyAccount = $sessionStorage.user.partyAccount;
    }
    function loadRole() {
      Authority.queryUserRoles().get({userId : $sessionStorage.user.partyId }, function (data) {
          $sessionStorage.role = data.rows;
          vm.role.roleName = $sessionStorage.role[0].roleName;
        }
        ,function (error) {
        });
    }


    function onSuccess(data, headers) {
      vm.menu = data.rows;
    }

    function onError(error) {
      //console.log('error');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider
      .state('error', {
        url: '/error',
        parent: 'app',
        data: {
          authorities: [],
          pageTitle: 'error.title'
        },
        views: {
          'body': {
            templateUrl: 'app/layouts/error/error.html'
          }
        }
        //views: {
        //    'content@': {
        //        templateUrl: 'app/layouts/error/error.html'
        //    }
        //}
      })
      .state('accessdenied', {
        parent: 'app',
        url: '/accessdenied',
        views: {
          'body': {
            templateUrl: 'app/layouts/error/accessdenied.html'
          }
        }

        //views: {
        //    'content@': {
        //
        //    }
        //}
      });
  }
})();

/**
 * Created by user on 2016/8/23.
 */
(function(){
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('test', {
        parent: 'app',
        url: "/test/{lineId}",
        views: {
          'body': {
            templateUrl: "app/interfaceTest/test/test.html",
            controller: 'TestController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                lineId:$stateParams.lineId

              };
            }
          ]
        }

      });
  }
})();

/**
 * Created by user on 2016/8/23.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('TestService', TestService);

  TestService.$inject = ['$resource', '$http', '$state'];

  function TestService($resource, $http) {
    var service = {
      findHeaderAndLineByLine: findHeaderAndLineByLine,
      getParamsExample:getParamsExample,
      updateParamsExample:updateParamsExample

    };
    return service;

    function findHeaderAndLineByLine(line) {

      var resourceUrl = '/api/getHeaderAndLineByLineId';
      return $http.post(resourceUrl, line, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("find header,line" + angular.toJson(response.data));
        return response.data;
      })
    };

    function getParamsExample(example){
      var resourceUrl = '/api/getExample'
      return $http.post(resourceUrl,example, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("find example:" + angular.toJson(response.data));
        return response.data;
      })

    };

    function updateParamsExample(example){
      var resourceUrl = '/api/updateExample'
      return $http.post(resourceUrl,example, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("update example:" + angular.toJson(response.data));
        return response.data;
      })

    };


  }

})();

/**
 * Created by user on 2016/8/23.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('TestController', TestController);

  TestController.$inject = ['TestService', '$state', 'entity'];

  function TestController(TestService, $state, entity) {
    var vm = this;
    vm.line = entity;
    vm.example = entity;
    findHeaderAndLine(vm.line);
    getExampleByLine(vm.line);

    function findHeaderAndLine(line) {
      return TestService.findHeaderAndLineByLine(line)
        .then(function (data) {
          vm.header = data.rows[0];
          //console.log("result headerAndLine:" + angular.toJson(data));

        });

    };

    function getExampleByLine(line) {
      return TestService.getParamsExample(line)
        .then(function (data) {
          vm.example = data.rows[0];
        })
    };

    vm.save = function () {
      vm.example.lineId = vm.header.lineId;
      vm.example.inputExample = vm.inputParams;
      vm.example.outputExample = vm.outputParams;
      return TestService.updateParamsExample(vm.example)
        .then(function (data) {
          vm.result = data.success;
          //console.log("save example:" + vm.result);
        })

    }


    vm.copyInputExample = function () {
      //console.log("inputExample:" + vm.example.inputExample);
      vm.inputParams = vm.example.inputExample;
    }


  }


})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('line', {
        parent: 'app',
        url: "/line/{headerId}",
        views: {
          'body': {
            templateUrl: "app/interfaceManage/line/line.html",
            controller: 'LineController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                headerId: $stateParams.headerId,
                page: null,
                pagesize: null
              };
            }
          ]
        }
      })
      .state('line.edit', {
        parent: 'app',
        url: "/line/edit/{lineId}",
        views: {
          'body': {
            templateUrl: "app/interfaceManage/line/line-detail.html",
            controller: 'LineDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                lineId: $stateParams.lineId
              };
            }
          ]
        }
      })
      .state('line.new', {
        parent: 'app',
        url: "/line/new/{headerId}",
        views: {
          'body': {
            templateUrl: "app/interfaceManage/line/line-detail.html",
            controller: 'LineDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                headerId: $stateParams.headerId
              };
            }
          ]
        }

      });
  };

})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('LineService', LineService);

  LineService.$inject = ['$resource', '$http', '$state'];

  function LineService($resource, $http) {
    var service = {
      getLines: getLines,
      getLine: getLine,
      insertLine:insertLine,
      updateLine:updateLine
    };
    return service;

    function getLine() {
      var resourceUrl = '/api/queryLine';
      return $resource(resourceUrl, {}, {
        'get': {method: 'POST'}
      });

    }

    function getLines(line) {
      //console.log("line params:" + angular.toJson(line));

      var resourceUrl = '/api/getLinesByHeaderId';

      return $http.post(resourceUrl, line, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("获取Lines接口", angular.toJson(response));
        return response.data;
      });


    }

    function updateLine() {
      var resourceUrl = '/api/updateLine';
      return $resource(resourceUrl, {}, {
        'update': {method: 'POST'}
      });
    }
    function insertLine(){
      var resourceUrl = '/api/insertLine';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST', isArray: false}
      });
    }

  }

})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('LineController', LineController);

  LineController.$inject = ['LineService', 'HeaderService','$scope', '$state', 'entity', 'paginationConstants'];

  function LineController(LineService, HeaderService,$scope, $state, entity, paginationConstants) {
    var vm = this;

    vm.page = 1;
    vm.totalItems = null;

    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.line = entity;
    vm.line.page = vm.page;
    vm.line.pagesize = paginationConstants.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.reback = reback;
    vm.header = {};

    getHeader(vm.line);
    getLinesByHeaderId(vm.line);

    function getHeader(header) {
      HeaderService.query().query(vm.line, onQuerySuccess, onError);
    };

    function onError(error) {
      //console.log('error');
    }

    function onQuerySuccess(data) {
      vm.header = data.rows[0];
    }

    function getLinesByHeaderId(line) {
      return LineService.getLines(line)
        .then(function (data) {
          vm.lines = data.rows;
          vm.totalItems = data.total;
          //console.log("lines:"+angular.toJson(data));
        });

    };

    function search() {
      //每次搜索的时候把page设为 1
      vm.line.page = vm.page = 1;
      vm.line.pagesize = paginationConstants.itemsPerPage;

      if (vm.line.lineCode != null && vm.line.lineCode === "") {
        vm.line.lineCode = undefined;
      }
      if (vm.line.lineName != null && vm.line.name === "") {
        vm.line.lineName = undefined;
      }
      getLinesByHeaderId(vm.line);
    };

    function reset() {
      vm.line.lineCode = undefined;
      vm.line.lineName = undefined;
    };

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      vm.line.page = vm.page;
      vm.line.pagesize = paginationConstants.itemsPerPage;
      getLinesByHeaderId(vm.line);
    };


    $scope.addLine = function (header) {
      $state.go("addLine", {headerId: header.headerId});
    };

    function reback() {
      $state.go("header", null, {reload: "header"});
    }


  }


})();

/**
 * Created by user on 2016/8/8.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('LineDetailController', LineDetailController);

  LineDetailController.$inject = ['PromptService','RoleService','$filter','LineService', '$state', 'entity','toastr','toastrConfig','MessageTemplateService'];

  function LineDetailController(PromptService,RoleService,$filter,LineService, $state, entity,toastr,toastrConfig,MessageTemplateService) {
    var vm = this;
    vm.line = entity;
    vm.update = update;
    vm.clear = clear;
    vm.getLine=getLine;
    vm.initWeidget = initWeidget;

    vm.initWeidget();
    vm.getLine(vm.line.lineId);

    vm.flags = [];


    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.localeSure = localeSure;


    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#lineNameBtn").attr("disabled", false);
      });
    }
    initLangs();

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.line.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
          if(vm.line.__tls)
            $("input[name='"+name+"_" + langs[i].langCode + "']").val(vm.line.__tls[name][langs[i].langCode]);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.line.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.line[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.line.__tls = __tls;
    }

    //根据lineId获取line
    function getLine(lineId) {
      if(lineId){
        LineService.getLine().get({lineId: lineId}, onSuccess, onError);
      }
    }

    function onSuccess(data, headers) {
      vm.line = data.rows[0];
      var nameList = {};
      var __tls = {};
      RoleService.getRoleLocaleInfo(vm.line.lineId, 'com.kohler.iot.integrator.hms.api.entities.HmsInterfaceLine', 'lineName')
        .then(function (data) {
          //deal with the multilanguage field value;
          nameList = {};
          for (var i in data) {
            nameList[data[i].langCode] = data[i].value;
          }
          __tls['lineName'] = nameList;
          vm.line.__tls = __tls;
          $("#lineNameBtn").attr("disabled", false);
        });
    }
    function onError(error) {
      //console.log('get line error');
    }

    //修改
    function update() {
      if(vm.line.lineId){
        LineService.updateLine().update(vm.line, updateSuccess, updateError);
      }
      else{
        LineService.insertLine().save(vm.line, updateSuccess, updateError);
      }
    }
    function updateSuccess(data, headers) {
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return ;
      }
      vm.result = data;
      if (data.success) {
        toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.confirmTitle"));
        return $state.go("line", {headerId: vm.line.headerId});
      }
    }
    function updateError(error) {
      //console.log('update line error');
    }


    function clear() {
      $state.go("line", {headerId: vm.line.headerId});
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'SYS.YES_NO'},function (data) {
        vm.flags = data.rows;
      },function (error) {
      });
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });

  }


})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('header', {
        parent: 'app',
        url: "/header",
        views: {
          'body': {
            templateUrl: "app/interfaceManage/header/header.html",
            controller: 'HeaderController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                page: null,
                pagesize: null
              };
            }
          ]
        }
      })
      .state('header.edit', {
        parent: 'app',
        params: {
          header: ""
        },
        url: "/header/{headerId}",
        views: {
          'body': {
            templateUrl: "app/interfaceManage/header/header-detail.html",
            controller: 'HeaderDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                headerId: $stateParams.headerId
              };
            }
          ]
        }
      })
      .state('header.new', {
        parent: 'app',
        params: {
          header: ""
        },
        url: "/new/header",
        views: {
          'body': {
            templateUrl: "app/interfaceManage/header/header-detail.html",
            controller: 'HeaderDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                headerId: null
              };
            }
          ]
        }
      });
  }
})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('HeaderService', HeaderService);

  HeaderService.$inject = ['$http', '$resource'];

  function HeaderService($http, $resource) {

    var service = {
      queryAll: queryAll,
      update: update,
      add:add,
      query:query,
      syncMock:syncMock
    };
    return service;

    function queryAll() {
    var resourceUrl = '/api/queryAllHeader';
    return $resource(resourceUrl, {}, {
      'query': {method: 'POST', isArray: false},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }
    });
    }
    function update() {
      var resourceUrl = '/api/updateHeader';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST', isArray: false}
      });
    }

    function add() {
      var resourceUrl = '/api/addHeader';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST', isArray: false}
      });
    }

    function query(){
      var resourceUrl = '/api/getHeaderByHeaderId';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST', isArray: false}
      });
    }
    function syncMock(){
      var resourceUrl = '/api/syncMockConfig';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST', isArray: false}
      });
    }
  }


})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('HeaderController', HeaderController);

  HeaderController.$inject = ['HeaderService', '$state', 'paginationConstants', 'entity'];

  function HeaderController(HeaderService, $state, paginationConstants, entity) {
    var vm = this;
    vm.header = entity;

    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.header.page = vm.page;
    vm.header.pagesize = vm.itemsPerPage;
    vm.authTypes = [
      {value: "BASIC_AUTH", description: "BasicAuth验证"},
      {value: "OAUTH2", description: "OAuth2.0验证"},
      {value: "NO_AUTH", description: "无验证"}
    ];

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.loadAll=loadAll;

    vm.loadAll();


    function loadAll() {
      //console.log("00000:" + angular.toJson(vm.header));
      //selectSystemType();
      HeaderService.queryAll().query(vm.header, onSuccess, onError)
    }

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(angular.toJson(data));
      vm.headerAll = data.rows;
      vm.totalItems = data.total;
    }

    function onError(error) {
      //console.log('error');
    }

    function search() {
      //每次搜索的时候把page设为 1
      vm.header.page = vm.page = 1;
      vm.header.pagesize = vm.itemsPerPage;

      if (vm.header.interfaceCode != null && vm.header.interfaceCode === "") {
        vm.header.interfaceCode = undefined;
      }
      if (vm.header.name != null && vm.header.name === "") {
        vm.header.name = undefined;
      }
      loadAll();
    };

    function reset() {
      vm.header.name = undefined;
      vm.header.interfaceCode = undefined;
    }


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      vm.header.page = vm.page;
      vm.header.pagesize = vm.itemsPerPage;
      loadAll();
    };
  }


})();

/**
 * Created by user on 2016/8/4.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('HeaderDetailController', HeaderDetailController);

  HeaderDetailController.$inject = ['PromptService','RoleService','$filter','Thirdparty', 'HeaderService', '$state', 'entity', 'MessageTemplateService','Hmapfe','toastr','toastrConfig'];

  function HeaderDetailController(PromptService,RoleService,$filter,Thirdparty, HeaderService, $state, entity, MessageTemplateService, Hmapfe, toastr, toastrConfig) {
    var vm = this;
    vm.update = update;
    vm.cancel = cancel;
    vm.header = entity;

    vm.header.authType = 'NO_AUTH';
    vm.syncMsg=$filter('T')("btnTypeName.syncToLine");
    vm.syncLoading = false;
    vm.getHeader = getHeader;
    vm.change = change;
    vm.loadAllThirdparty = loadAllThirdParty;
    vm.syncLines = syncLines;
    vm.initWeidget = initWeidget;
    vm.getHeader();
    vm.initWeidget();
    vm.loadAllThirdparty();

    vm.flags = [];
    vm.systemTypes = [];
    vm.requestMethods = [];
    vm.interfaceTypes = [];
    vm.requestFormats = [];
    vm.authTypes = [];
    vm.authGrantTypes = [];

    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.clear = clear;
    vm.localeSure = localeSure;
    vm.changeSystem = changeSystem;
    vm.show = false;

    function changeSystem(){
      if(vm.header.systemType=="IN"){
        vm.show = false;
      }else if(vm.header.systemType=="OUT"){
        vm.show = true;
      }
    }


    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#nameBtn").attr("disabled", false);
      });
    }
    initLangs();

    function clear() {
      $state.go('header');
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.header.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
          if(vm.header.__tls)
            $("input[name='"+name+"_" + langs[i].langCode + "']").val(vm.header.__tls[name][langs[i].langCode]);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.header.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.header[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.header.__tls = __tls;
    }

    function getHeader() {
      Hmapfe.log("vm.header:"+vm.header.headerId);

      if(vm.header.headerId != null) {
        HeaderService.query().query(vm.header, onQuerySuccess, onError);
      }

    }

    function update() {
      if (vm.header.headerId) {
        HeaderService.update().save(vm.header, onSuccess, onError)
      }
      else {
        HeaderService.add().save(vm.header, onSuccess, onError)
      }
    }

    function onQuerySuccess(data) {
      Hmapfe.log("header data:"+angular.toJson(data));
      vm.header = data.rows[0];

      if (vm.header.authType == 'BASIC_AUTH') {
        vm.header.isBasic = true;
        vm.header.isAuth = false;
      }
      if (vm.header.authType == 'OAUTH2') {
        vm.header.isAuth = true;
        vm.header.isBasic = false;
      }
      if (vm.header.authType == 'NO_AUTH') {
        vm.header.isBasic = false;
        vm.header.isAuth = false;
        Hmapfe.log('NO_AUTH');

      }
      if(vm.header.systemType=="OUT"){
        vm.show = true;
      }
      var nameList = {};
      var __tls = {};
      RoleService.getRoleLocaleInfo(vm.header.headerId, 'hmap.core.hms.api.domain.HmsInterfaceHeader', 'name')
        .then(function (data) {
          //deal with the multilanguage field value
          nameList = {};
          for (var i in data) {
            nameList[data[i].langCode] = data[i].value;
          }
          __tls['name'] = nameList;
          vm.header.__tls = __tls;
          $("#nameBtn").attr("disabled", false);
        });
    }

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(angular.toJson(data));
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return ;
      }
      vm.result = data;
      //console.log("update result"+angular.toJson(data));
      if (data.success) {
        toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.confirmTitle"));
        return $state.go("header");
      }
    }

    function onError(error) {
      //console.log('error');

    }

    function onMockSuccess(data, headers) {
      console.log(data);
      if(data.success){
        vm.syncMsg=$filter('T')("title.syncSuccess");
      } else{
        vm.syncMsg=$filter('T')("title.syncFail");
      }
      vm.syncLoading = false;
    }

    function syncLines() {
      vm.syncLoading = true;
      console.log('syncLines');
      HeaderService.syncMock().save(vm.header, onMockSuccess, onError);
    }

    function cancel() {
      $state.go("header");
    }

    function change() {
      if (vm.header.authType == 'BASIC_AUTH') {
        vm.header.isBasic = true;
        vm.header.isAuth = false;
      }
      if (vm.header.authType == 'OAUTH2') {
        vm.header.isAuth = true;
        vm.header.isBasic = false;
      }
      if (vm.header.authType == 'NO_AUTH') {
        vm.header.isBasic = false;
        vm.header.isAuth = false;
        Hmapfe.log('NO_AUTH');

      }
    }

    function loadAllThirdParty() {
      Thirdparty.query({
        page: 1,
        pagesize: 100
      }, onThirdPartySuccess, onError);
    }

    function onThirdPartySuccess(data, headers) {
      vm.thirdpartys = data.rows;
    }

    function initWeidget() {

      MessageTemplateService.getByCode().query({code:'SYS.YES_NO'},function (data) {
        vm.flags = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'HMS.SYSTEM_TYPE'},function (data) {
        vm.systemTypes = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'HMS.REQUEST_METHOD'},function (data) {
        vm.requestMethods = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'HMS.INTERFACE_TYPE'},function (data) {
        vm.interfaceTypes = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'HMS.REQUEST_FORMAT'},function (data) {
        vm.requestFormats = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'HMS.AUTH_TYPE'},function (data) {
        vm.authTypes = data.rows;
      },function (error) {
      });

      MessageTemplateService.getByCode().query({code:'HMS.AUTH_GRANT_TYPE'},function (data) {
        vm.authGrantTypes = data.rows;
      },function (error) {
      });
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by user on 2016/8/8.
 */
(function () {
    'use strict';

    angular.module('hmapFront')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        $stateProvider
            .state('editLine', {
                parent: 'app',
                url: "/editLine/{lineId}",
                views: {
                    'body': {
                        templateUrl: "app/interfaceManage/editLine/editLine.html",
                        controller: 'EditLineController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams',
                        function ($stateParams) {
                            //console.log("0000="+$stateParams.lineId)
                            return {
                                lineId:$stateParams.lineId
                                //headerId:$stateParams.headerId
                            };
                        }
                    ]
                }

            });
    }

})();

/**
 * Created by user on 2016/8/8.
 */

(function () {
    'use strict';
    angular.module('hmapFront')
        .factory('EditLineService', EditLineService);

    EditLineService.$inject = ['$resource'];

    function EditLineService($resource) {

        var service = {
            updateLine: updateLine,
            getLine: getLine
        };
        return service;

        function getLine() {
            var resourceUrl = '/api/queryLine';
          return $resource(resourceUrl, {}, {
            'get': {method: 'POST'}
          });

        }

        function updateLine() {
            var resourceUrl = '/api/updateLine';
          return $resource(resourceUrl, {}, {
            'update': {method: 'POST'}
          });

        }


    }


})();

/**
 * Created by user on 2016/8/8.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditLineController', EditLineController);

  EditLineController.$inject = ['EditLineService', '$state', 'entity'];

  function EditLineController(EditLineService, $state, entity) {
    var vm = this;
    vm.line = entity;
    vm.update = update;
    vm.clear = clear;

    var lineId = vm.line.lineId;
    getLine(lineId);

    vm.flag = [
      {code: "Y", name: "是"},
      {code: "N", name: "否"}
    ];

    //根据lineId获取line
    function getLine(lineId) {
      EditLineService.getLine().get({lineId: lineId}, onSuccess, onError);
    };

    function onSuccess(data, headers) {
      vm.line = data.rows[0];
    };
    function onError(error) {
      //console.log('get line error');
    };

    //修改
    function update() {
      EditLineService.updateLine().update(vm.line, updateSuccess, updateError);
    };
    function updateSuccess(data, headers) {
      vm.result = data;
      if (data.success) {
        return $state.go("line", {headerId: vm.line.headerId});
      }
    };
    function updateError(error) {
      //console.log('update line error');
    };


    function clear() {
      $state.go("line", {headerId: vm.line.headerId});
    };


  }


})();

/**
 * Created by user on 2016/8/4.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('editHeader', {
        parent: 'app',
        params: {
          header: ""
        },
        url: "/editHeader/{headerId}",
        views: {
          'body': {
            templateUrl: "app/interfaceManage/editHeader/editHeader.html",
            controller: 'EditHeaderController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                headerId:$stateParams.headerId

              };
            }
          ]
        }

      });
  }
})();

/**
 * Created by user on 2016/8/4.
 */

(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('EditHeaderService', EditHeaderService);

  EditHeaderService.$inject = ['$resource', '$http'];

  function EditHeaderService($resource, $http) {
    var service = {
      query: query,
      querySystemType: querySystemType
    };
    return service;

    function query() {
      var resourceUrl = '/api/updateHeader';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST', isArray: false}
      });
    }

    function querySystemType(){
      var resourceUrl = '/api/queryAllHeader';
      return $resource(resourceUrl, {}, {
        'get': {
          method: 'GET',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
            }
            return data;
          }
        }
      });
    }


    /* var service = {
     updateHeader : updateHeader
     };
     return service;

     function updateHeader(newHeader){
     var resourceUrl = '/api/updateHeader';
     var data = newHeader;
     //console.log("update header param:"+angular.toJson(data));

     return  $http.post(resourceUrl,data , {
     headers: {
     'Content-Type': 'application/json;charset=utf-8'
     }
     }).then(function (response) {
     //console.log("edit header接口", angular.toJson(response));
     return response.data;
     });

     }*/


  }


})();

/**
 * Created by user on 2016/8/4.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditHeaderController', EditHeaderController);

  EditHeaderController.$inject = ['LineService','EditHeaderService', '$state' ,'entity'];

  function EditHeaderController(LineService,EditHeaderService,  $state, entity) {
    var vm = this;
    vm.update = update;
    vm.cancel = cancel;

    vm.header = entity;
    getHeader(vm.header);

    vm.interfaceType = ["REST", "SOAP","PLSQL"];
    vm.requestMethod = ["GET", "POST"];
    vm.requestFormat = ["raw"];
    vm.flag = [
      {code : "Y", name : "是"},
      {code : "N", name : "否"}
    ];

    vm.selectSystemType = selectSystemType;
    vm.selectSystemType();
    function selectSystemType(){
      //console.log("111111111");
      EditHeaderService.querySystemType().get(function(result) {
        //console.log("result:::::::::"+angular.toJson(result));
        vm.systemTypes = result.rows;
      });
    }

    function getHeader(header){
      return LineService.getHeaderByHeaderId(header)
        .then(function(data){
          vm.header = data.rows[0];
        })
    };


    function update(){
      EditHeaderService.query().query(vm.header, onSuccess, onError)
    }

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(angular.toJson(data));
      vm.result = data;
      //console.log("update result"+angular.toJson(data));
      if (data.success) {
        return $state.go("header");
      }
    }

    function onError(error) {
      //console.log('error');

    }


    /*function update() {
      return EditHeaderService.updateHeader(vm.header)
        .then(function (data) {
          vm.result = data;
          //console.log("result00000"+angular.toJson(data));
          if (data.success) {
            return $state.go("header");
          }

        });

    }*/

    function cancel() {
      $state.go("header");
    }

  }


})();

/**
 * Created by user on 2016/8/8.
 */
(function () {
    'use strict';

    angular.module('hmapFront')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        $stateProvider
            .state('addLine', {
                parent: 'app',
                url: "/addLine/{headerId}",
                views: {
                    'body': {
                        templateUrl: "app/interfaceManage/addLine/addLine.html",
                        controller: 'AddLineController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams',
                        function ($stateParams) {
                            //console.log("0000="+$stateParams.headerId)
                            return {
                                headerId:$stateParams.headerId
                            };
                        }
                    ]
                }

            });
    }

})();

/**
 * Created by user on 2016/8/8.
 */


(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('AddLineService', AddLineService);

  AddLineService.$inject = ['$http', '$resource'];

  function AddLineService($http, $resource) {

    var resourceUrl = '/api/insertLine';
    return $resource(resourceUrl, {}, {
      'query': {method: 'POST', isArray: false}
    });


  }


})();

/**
 * Created by user on 2016/8/8.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddLineController', AddLineController);

  AddLineController.$inject = ['AddLineService', '$state', 'entity'];

  function AddLineController(AddLineService, $state, entity) {
    var vm = this;
    vm.line = entity;
    vm.add = add;
    vm.clear = clear;

    vm.flag = [
      {code: "Y", name: "是"},
      {code: "N", name: "否"}
    ];

    function add() {
      AddLineService.query(vm.line, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(angular.toJson(data));
      vm.result = data;
      if (data.success) {
        return $state.go("line", {headerId: entity.headerId});
      }
    }

    function onError(error) {
      //console.log('error');

    }

    function clear() {
      $state.go("line", {headerId: entity.headerId});
    }


  }


})();

/**
 * Created by user on 2016/8/8.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('addHeader', {
        parent: 'app',
        params: {
          header: ""
        },
        url: "/addHeader",
        views: {
          'body': {
            templateUrl: "app/interfaceManage/addHeader/addHeader.html",
            controller: 'AddHeaderController',
            controllerAs: 'vm'
          }
        }

      });
  }
})();

/**
 * Created by user on 2016/8/8.
 */

(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('AddHeaderService', AddHeaderService);

  AddHeaderService.$inject = ['$resource', '$http'];

  function AddHeaderService($resource, $http) {
    var service = {
      query : query,
      querySystemType : querySystemType
    };
    return service;

    function query() {
      var resourceUrl = '/api/addHeader';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST', isArray: false}
      });
    }

    function querySystemType(){
      var resourceUrl = '/api/queryAllHeader';
      return $resource(resourceUrl, {}, {
        'get': {
          method: 'GET',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
            }
            return data;
          }
        }
      });
    }

  }


})();

/**
 * Created by user on 2016/8/8.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddHeaderController', AddHeaderController);

  AddHeaderController.$inject = ['AddHeaderService', '$state'];

  function AddHeaderController(AddHeaderService, $state) {
    var vm = this;
    vm.add = add;
    vm.cancel = cancel;

    vm.header = null;

    vm.interfaceType = ["REST", "SOAP","PLSQL"];
    //vm.header.interfaceType = "REST";
    vm.requestMethod = ["GET", "POST"];
    vm.requestFormat = ["raw"];
    vm.flag = [
      {code : "Y", name : "是"},
      {code : "N", name : "否"}
    ];
    vm.selectSystemType = selectSystemType;
    vm.selectSystemType();

    function selectSystemType(){
      //console.log("111111111");
      AddHeaderService.querySystemType().get(function(result) {
        //console.log("result:::::::::"+angular.toJson(result));
        vm.systemTypes = result.rows;
      });
    }

    function add () {
      AddHeaderService.query().query(vm.header, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      vm.result = data;
      //console.log("insert result "+angular.toJson(data));
      if (data.success) {
        return $state.go("header");
      }
    }
    function onError(error) {
      //console.log('error');

    }

    function cancel() {
      $state.go("header");
    }

  }


})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('wxSetMenu', {
        parent: 'app',
        url: "/wxSetMenu",
        views: {
          'body': {
            templateUrl: "app/wxSetMenu/wxSetMenu.html",
            controller: 'WxSetMenuController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {};
            }
          ]
        }
      })
      .state('wxSetMenu.new', {
        parent: 'app',
        url: "/wxSetMenu/new",
        views: {
          'body': {
            templateUrl: "app/wxSetMenu/wxSetMenu-new.html",
            controller: 'WxSetMenuNewController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                  id: null,
                  menuType: null,
                  menuName: null,
                  parentId: null,
                  content: null
                }
              }
            }
          }
        }
      })
      .state('wxSetMenu.edit', {
        parent: 'app',
        url: "/wxSetMenu/:id/edit",
        views: {
          'body': {
            templateUrl: "app/wxSetMenu/wxSetMenu-edit.html",
            controller: 'WxSetMenuEditController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  id: $stateParams.id
                };
              }
            }
          }
        }
      })
  }
})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('WxSetMenu', WxSetMenu);

  WxSetMenu.$inject = ['$resource','BaseConfig','$sessionStorage'];

  function WxSetMenu ($resource,BaseConfig,$sessionStorage) {
    var service = {
      wxMenuLoadSearch: wxMenuLoadSearch,
      wxMenuUpdate: wxMenuUpdate,
      wxMenuSave: wxMenuSave,
      wxSetMenu:wxSetMenu,
      wxMenuLoadMenu:wxMenuLoadMenu
    };
    return service;

    function wxMenuLoadSearch(page,pageSize) {
      return $resource("/api/wxMenuFound?page="+page+"&pageSize="+pageSize, {}, {
        'query': {method: 'POST', isArray: false}
      });
    }
    function wxMenuUpdate() {
      return $resource("/api/wxMenuUpdate", {}, {
        'update': {method: 'POST'}
      });
    }
    function wxMenuSave() {
      return $resource("/api/wxMenuSave", {}, {
        'save': {method: 'POST'}
      });
    }
    function wxSetMenu() {
      return $resource("/api/wxSetMenu", {}, {
        'update': {method: 'POST'}
      });
    }
    function wxMenuLoadMenu() {
      return $resource("/api/wxSelectAllMenu", {}, {
        'query': {method: 'POST'}
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('WxSetMenuController', WxSetMenuController);
  WxSetMenuController.$inject = ['$state','WxSetMenu','entity','paginationConstants','$localStorage','$sessionStorage','Upload','BaseConfig'];
  /** @ngInject */
  function WxSetMenuController($state, WxSetMenu,entity, paginationConstants,$localStorage,$sessionStorage,Upload,BaseConfig) {
    var vm = this;
    vm.menu=entity;
    vm.menus=[];
    vm.page = 1;
    vm.file="";
    vm.totalItems = null;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadSearch=loadSearch;
    vm.update=update;
    vm.setMenu=setMenu;
    vm.loadSearch();

    function loadSearch(){
      var page=vm.page;
      var pageSize=paginationConstants.itemsPerPage;
      WxSetMenu.wxMenuLoadSearch(page,pageSize).query(vm.menu, onSuccess, onError);
    }
    function setMenu(){
      WxSetMenu.wxSetMenu().update(setSuccess, setError);
    }
    function onSuccess(data, headers) {
      console.log('onSuccess');
      console.log(data);
      vm.menus = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      console.log('error');
    }
    function setSuccess(data, headers) {
      console.log('setSuccess');
      console.log(data);
    }
    function setError(error) {
      console.log('error');
    }
    function update(){
      WxSetMenu.wxMenuLoadSearch().update(vm.menu, onSuccess, onError);
    }
    function pageChanged() {
      console.log('Page changed to: ' +vm.page);
      loadSearch();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('WxSetMenuNewController', WxSetMenuNewController);

  WxSetMenuNewController.$inject = ['$timeout','$scope','$state', '$stateParams','WxSetMenu','entity','uibDateParser'];

  function WxSetMenuNewController($timeout,$scope, $state, $stateParams, WxSetMenu, entity, uibDateParser) {
    var vm = this;
    vm.menu = entity;
    vm.menus=[];
    vm.allMenu=allMenu;
    vm.clear = clear;
    vm.save = save;

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });
    function allMenu() {
      WxSetMenu.wxMenuLoadMenu().query(getSuccess, onError);
    }
    function getSuccess(data, headers) {
      console.log('getSuccess');
      console.log(data);
      vm.menus = data.rows;
    }
    function onError(error) {
      console.log('error');
    }
    function clear() {
      $state.go('wxSetMenu');
    }
    function save() {
      WxSetMenu.wxMenuSave.save(vm.menu, onSaveSuccess, onSaveError);
    }
    function onSaveSuccess(result) {
      $scope.$emit('hmapFront:wxSetMenuUpdate', result);
      vm.isSaving = true;
      $state.go('wxSetMenu');
    }
    function onSaveError() {
      vm.isSaving = false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('WxSetMenuEditController', WxSetMenuEditController);

  WxSetMenuEditController.$inject = ['$timeout','$scope','$state', '$stateParams','WxSetMenu','entity','uibDateParser'];

  function WxSetMenuEditController($timeout,$scope, $state, $stateParams, WxSetMenu, entity, uibDateParser) {
    var vm = this;
    vm.menu = entity;
    vm.clear = clear;
    vm.save = save;
    vm.load=load;
    vm.menus=[];
    vm.allMenu=allMenu;
    vm.load(vm.menu.id);
    vm.allMenu();


    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function allMenu() {
      WxSetMenu.wxMenuLoadMenu().query(getSuccess, onError);
    }
    function clear() {
      $state.go('wxSetMenu');
    }

    function save() {
      vm.isSaving = true;
      WxSetMenu.wxMenuUpdate().update(vm.menu, onSaveSuccess, onSaveError);
    }

    function onSaveSuccess(result) {
      $scope.$emit('hmapFront:wxSetMenuUpdate', result);
      vm.isSaving = true;
      $state.go('wxSetMenu');
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function load(id) {
      vm.menu.id=id;
      WxSetMenu.wxMenuLoadSearch(1,1).query(vm.menu, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      console.log('onSuccess');
      console.log(data);
      vm.menu = data.rows[0];
    }
    function getSuccess(data, headers) {
      console.log('getSuccess');
      console.log(data);
      vm.menus = data.rows;
    }
    function onError(error) {
      console.log('error');
    }
  }
})();

/**
 * Created by xinming on 2016/9/6.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .controller('SelectInfModalController', SelectInfModalController);

  SelectInfModalController.$inject = [ '$uibModalInstance', 'entity', 'LineService','paginationConstants'];
  function SelectInfModalController($uibModalInstance,entity,LineService,paginationConstants){
    var vm = this;
    vm.page = 1;
    vm.line = entity;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.selectedLines = {};
    vm.clear = clear;
    vm.save = save;

    vm.loadAll();

    function loadAll() {
      if (vm.line.apiHeaderId) {
        LineService.getLines({
          headerId: vm.line.apiHeaderId,
          page: vm.page,
          pagesize: paginationConstants.itemsPerPage
        }).then(
          function (data) {
            vm.lines = data.rows;
            vm.totalItems =  data.total;
          }
      );
      }

    }
    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadAll();
    };
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      $uibModalInstance.close(vm.selectedLines);
    }
  }
})();

/**
 * Created by xinming on 2016/9/6.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .controller('SelectInfHeaderModalController', SelectInfHeaderModalController);

  SelectInfHeaderModalController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HeaderService','paginationConstants','WfSourceService'];
  function SelectInfHeaderModalController($timeout,$scope,$stateParams,$uibModalInstance,entity,HeaderService,paginationConstants,WfSourceService){
    var vm = this;
    vm.page = 1;
    vm.header = entity;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.loadHeader = loadHeader;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.selectedHeaders = {};
    vm.clear = clear;
    vm.save = save;

    vm.loadAll();
    vm.loadHeader();

    function loadAll() {
        HeaderService.queryAll().query({
          apiHeaderId: vm.header.apiHeaderId,
          page: vm.page,
          pagesize: paginationConstants.itemsPerPage
        }, onSuccess, onError);

    }

    function loadHeader() {
      if (vm.header.apiHeaderId) {//!= undefined && vm.function.functionId != null && vm.function.functionId != ''
        HeaderService.get(vm.header, function (result) {
          vm.header = result.rows[0];
        });
      }
    }

    function onSuccess(data) {
      vm.headers = data.rows;
      vm.totalItems = data.total;
    }

    function onSaveEntrySuccess(data) {
      $log.info(data);
      $uibModalInstance.close(data);
    }

    function onError(error) {
      $log.info('error');

    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadAll();
    };
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      $uibModalInstance.close(vm.selectedHeaders);
    }
  }
})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('wecorpAgentList', {
        parent: 'app',
        url: "/wecorpAgentList",
        views: {
          'body': {
            templateUrl: "app/wecorpAgent/wecorpAgentList.html",
            controller: 'WecorpAgentListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                page:null,
                pagesize:null
              };
            }
          ]
        }

      })

  }
})();

/**
 * Created by hxm on 2016/9/21
 */
(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('WecorpAgentListService',['$resource','$rootScope', function($resource,$rootScope){
      var selectedHeader = {};
      var selectedLine = {};
      var service = {
        getAgentList: getAgentList
      };
      return service;
      function getAgentList() {
        var resourceUrl ='/api/wecorpagent/query';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }
    }]);


})();

/**
 * Created by user on 2016/8/3.
 */
(function (){
  'use strict';

  angular.module('hmapFront')
    .controller('WecorpAgentListController',['WecorpAgentListService','$state','$scope','paginationConstants','entity',
    function(WecorpAgentListService,$state,$scope,paginationConstants,entity){
      var vm = this;
      vm.wecorpAgentList = entity;
      getAgentList(vm.wecorpAgentList);
      function getAgentList(wecorpAgentList){
        WecorpAgentListService.getAgentList().get({
          apiHeaderName:wecorpAgentList.apiHeaderName
        }, onSuccess, onError);
      } function onSuccess(data, headers) {
        vm.agentList = data.rows;
      }
      function onError(error) {
        console.log('error');
      }
    }]);
})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('wecorpAgentCustomMenu', {
        parent: 'app',
        url: "/wecorpAgentList/:agentid/wecorpAgentCustomMenu",
        views: {
          'body': {
            templateUrl: "app/wecorpAgent/wecorpAgentCustomMenu.html",
            controller: 'WecorpAgentCustomMenuController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                page:null,
                pagesize:null,
                agentid:$stateParams.agentid
              };
            }
          ]
        }

      });
  }
})();

/**
 * Created by hxm on 2016/9/21
 */
(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('WecorpAgentCustomMenuService',['$resource','$rootScope', function($resource,$rootScope){
      var selectedHeader = {};
      var selectedLine = {};
      var service = {
        create:create,
        getMenuList:getMenuList,
        deleteMenuRecord:deleteMenuRecord,
        deleteReleaseMenu:deleteReleaseMenu
      };
      return service;

      function create(menu){
        var resourceUrl ='/api/wecorpcustommenu/save';
        return $resource(resourceUrl, {}, {
          'saveMenu': {method: 'POST'}
        });
      }
      function getMenuList() {
        var resourceUrl ='/api/wecorpcustommenu/getMenuList';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }

      function deleteMenuRecord(wfTemp){
        var resourceUrl ='/api/wecorpcustommenu/deleteMenuRecord';
        return $resource(resourceUrl, {}, {
          'delete': {method: 'POST'}
        });
      }

      function deleteReleaseMenu() {
        var resourceUrl ='/api/wecorpcustommenu/deleteMenu';
        return $resource(resourceUrl, {}, {
          'delete': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }
    }]);


})();

/**
 * Created by user on 2016/8/3.
 */
(function (){
  'use strict';

  angular
    .module('hmapFront')
    .controller('WecorpAgentCustomMenuController',['$filter','WecorpAgentCustomMenuService','$anchorScroll','$state','$scope','$location','$localStorage','$sessionStorage','paginationConstants','entity','Upload','BaseConfig','SweetAlert',
    function($filter,WecorpAgentCustomMenuService,$anchorScroll,$state,$scope,$location,$localStorage,$sessionStorage,paginationConstants,entity,Upload,BaseConfig,SweetAlert){
      var vm = this;
      var i;
      vm.agent = entity;
      vm.editId=null;
      vm.menus ={};

      vm.page = 1;
      vm.totalItems = null;
      vm.pageChanged=pageChanged;
      vm.itemsPerPage = paginationConstants.itemsPerPage;
      vm.agent.page = vm.page;
      vm.agent.pagesize = paginationConstants.itemsPerPage;

      vm.showSubMenu =2;
      vm.mouseIndex = -1;
      vm.addMenuInputShowFlag=false;
      vm.saveMenuButtonCanClick = true;
      vm.releaseMenuButtonCanClick = true;
      vm.deletereleaseMenuButtonCanClick = true;
      vm.addMenuName=''
      vm.addSubMenuName = ''
      vm.menuSelectedId = -1 ;
      vm.menuType = [
        {code :"click", name : "菜单key"},
        {code :"view", name : "跳转到网页"},
        {code :"scancode_push", name : "扫码推事件"},
        {code :"scancode_waitmsg", name : "扫码推事件(弹框)"},
        {code :"pic_sysphoto", name : "系统拍照"},
        {code :"pic_photo_or_album", name : "拍照或者相册"},
        {code :"pic_weixin", name : "微信发图器"},
        {code :"location_select", name : "地理位置选择器"}
      ];
      vm.sortableOptions = {
        allowDuplicates: true,
        dragStart:function(){

        },
        accept: function (sourceItemHandleScope, destSortableScope) {return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;},
        orderChanged:function(event){
          if(vm.showSubMenu==event.dest.index){
            vm.showSubMenu = event.source.index;
          }
          else if(vm.showSubMenu==event.source.index){
            vm.showSubMenu = event.dest.index;
          }
          //var tmp = vm.buttonLeft.slice(0);
          //console.log(vm.buttonLeft);
          //for(var i =0 ; i < vm.buttonLeft.length ; i++){
          //    if(i==event.source.index){
          //      vm.buttonLeft[i] = tmp[event.dest.index]
          //    }else if(i==event.dest.index){
          //    vm.buttonLeft[i] = tmp[event.source.index]
          //    }else{
          //      vm.buttonLeft[i] = tmp[i]
          //    }
          //}
        }
      };

      vm.sortableOptions1 = {
        accept: function (sourceItemHandleScope, destSortableScope) {return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;}
      };
      vm.clickMenu = clickMenu;
      vm.isShowMenu =isShowMenu;
      vm.deleteMenu = deleteMenu;
      vm.addMenu = addMenu;
      vm.addMenuOperation = addMenuOperation;
      vm.addSubMenuOperation = addSubMenuOperation;
      vm.saveMenu = saveMenu;
      vm.search = search;
      vm.editRecord = editRecord;
      vm.deleteRecord = deleteRecord;
      vm.newMenu = newMenu;
      vm.releaseMenu = releaseMenu;
      vm.deleteReleaseMenu = deleteReleaseMenu;
      getMenuList(vm.agent.agentid);


      function clickMenu(index){
        if(vm.showSubMenu == index){
          vm.showSubMenu = -1;
        }else{
          vm.showSubMenu = index;
        }

      }
      function isShowMenu(index,showSubMenu,subMenu){
        if(subMenu==undefined){
          return false;
        }
        if(subMenu.length==0){
          return false
        }
          return index == showSubMenu;
      }
      function deleteMenu(x,y){
        if(y==-1){
          vm.menus.button.splice(x,1);
        }else{
          vm.menus.button[x].sub_button.splice(y,1);
        }
      }
      function addMenu(){
        vm.addMenuInputShowFlag = true;
      }
      function addMenuOperation(){
        if(vm.addMenuName!=""){
          if(vm.menus.button!=null){
          vm.menus.button[vm.menus.button.length]={
            "name": vm.addMenuName,
            "type": "",
            "key":""
          };
          }else{
            vm.menus={"button":[{
              "name": vm.addMenuName,
              "type": "",
              "key":""
            }]};
          }
          vm.addMenuName="";
        }
      }
      function addSubMenuOperation(index){
        if(vm.addSubMenuName!=""){
          if(vm.menus.button[index].sub_button==null){
            vm.menus.button[index].sub_button=[{
              "name": vm.addSubMenuName,
              "type": "",
              "key":""
            }];
            vm.addSubMenuName="";
          }else{
            vm.menus.button[index].sub_button[vm.menus.button[index].sub_button.length]={
              "name": vm.addSubMenuName,
              "type": "",
              "key":""
            };
            vm.addSubMenuName="";
          }

        }
      }

      function saveMenu(){
        vm.saveMenuButtonCanClick = false;
        var sendBody ={
          //"id":vm.editId, 使用历史记录，而不是菜单保存机制
          "agentid":vm.agent.agentid,
          "menuName":vm.menuName,
          "menuBody":JSON.stringify(vm.menus),
          "enableFlag":"N"
        }
        WecorpAgentCustomMenuService.create().saveMenu(sendBody,
          function(data, headers) {
            SweetAlert.success($filter('T')("title.saveSuccess"), {title:$filter('T')("title.infoTitle")});
            getMenuList(vm.agent.agentid);
            vm.saveMenuButtonCanClick = true;
          }, function(error) {
            vm.saveMenuButtonCanClick = true;
            console.log('error');
          });

      }

      function getMenuList(agentid){
        WecorpAgentCustomMenuService.getMenuList().get({
          agentid:agentid,
          page: vm.page,
          pagesize: paginationConstants.itemsPerPage,
          menuName:vm.agent.menuName
        }, onSuccess, onError);
      } function onSuccess(data, headers) {
        vm.menuList = data.rows;
        vm.totalItems =  data.total;
        if(vm.menuList.length!=0){
        vm.menus = JSON.parse(vm.menuList[0].menuBody);
        vm.menuName = vm.menuList[0].menuName;
        vm.menuSelectedId = vm.menuList[0].id;
        vm.editId=vm.menuList[0].id;
        }else{
          vm.menus = {};
          vm.menuName ='';
        }
      }
      function onError(error) {
        console.log('error');
      }

      function pageChanged() {
        console.log('Page changed to: ' +vm.page);
        vm.agent.page = vm.page;
        vm.agent.pagesize = paginationConstants.itemsPerPage;
        getMenuList(vm.agent.agentid);
      };

      function search(){
        //每次搜索的时候把page设为 1
        vm.agent.page = vm.page = 1;
        vm.agent.pagesize = paginationConstants.itemsPerPage;

        getMenuList(vm.agent.agentid);
      }

      function editRecord(menu,id){
        vm.menus = JSON.parse(menu.menuBody);
        vm.editId = menu.id;
        vm.menuSelectedId = id;
        vm.menuName = menu.menuName;
        $anchorScroll('menuBody');
      }

      function deleteRecord(id){
        SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")})
          .then(function(p) {
            if(p){
            WecorpAgentCustomMenuService.deleteMenuRecord().delete({id:id},
            function(data){
              getMenuList(vm.agent.agentid);
            },
            function(error){
              console.log(error);
            })
            };
          },
          function(p) {}
        );
      }

      function newMenu(){
        SweetAlert.confirm($filter('T')("title.cancelConfirm"), {title: $filter('T')("title.confirmTitle")})
          .then(function(p) {
            if(p){
            vm.menus={};
            vm.editId=null;
            vm.menuSelectedId = -1;
            vm.menuName='';
            }
          },
          function(p) {}
        );

      }
      function releaseMenu(){
        vm.releaseMenuButtonCanClick = false;
        SweetAlert.confirm($filter('T')("title.releaseConfirm"), {title: $filter('T')("title.confirmTitle")})
          .then(function(p) {
            if(p){
              var sendBody ={
                "id":vm.editId,
                "agentid":vm.agent.agentid,
                "menuName":vm.menuName,
                "menuBody":JSON.stringify(vm.menus),
                "enableFlag":"Y"
              }
              WecorpAgentCustomMenuService.create().saveMenu(sendBody,
                function(data, headers) {
                  SweetAlert.success($filter('T')("title.createSuccess"), {title:$filter('T')("title.infoTitle")});
                  getMenuList(vm.agent.agentid);
                  vm.releaseMenuButtonCanClick = true;
                }, function(error) {
                  console.log('error');
                  vm.releaseMenuButtonCanClick = true;
                });
            }else{
              vm.releaseMenuButtonCanClick = true;
            }
          },
          function(p) {}
        );
      }
      function deleteReleaseMenu(){
        vm.deletereleaseMenuButtonCanClick = false;
        console.log(vm.agent.agentid)
        SweetAlert.confirm($filter('T')("title.cleanConfirm"), {title: $filter('T')("title.confirmTitle")})
          .then(function(p) {
            if(p){
              WecorpAgentCustomMenuService.deleteReleaseMenu().delete({agentid:vm.agent.agentid},
                function(data, headers) {
                  SweetAlert.success($filter('T')("title.deleteFail"), {title:$filter('T')("title.infoTitle")});
                  getMenuList(vm.agent.agentid);
                  vm.deletereleaseMenuButtonCanClick = true;
                }, function(error) {
                  console.log('error');
                  vm.deletereleaseMenuButtonCanClick = true;
                });
            }else{
              vm.deletereleaseMenuButtonCanClick = true;
            }
          },
          function(p) {}
        );
      }
    }])
    .directive('focusMe', function($timeout) {
      return {
        scope: { trigger: '@focusMe' },
        link: function(scope, element) {
          scope.$watch('trigger', function(value) {
            if(value === "true") {
              $timeout(function() {
                element[0].focus();
              });
            }
          });
        }
      };
    });
})();

/**
 * Created by user on 2016/8/3.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('wecorpAgent', {
        parent: 'app',
        url: "/wecorpAgentList/:agentid/wecorpAgent",
        views: {
          'body': {
            templateUrl: "app/wecorpAgent/wecorpAgent.html",
            controller: 'WecorpAgentController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                page:null,
                pagesize:null,
                agentid:$stateParams.agentid
              };
            }
          ]
        }

      });
  }
})();

/**
 * Created by hxm on 2016/9/21
 */
(function () {
  'use strict';
  angular.module('hmapFront')
    .factory('WecorpAgentService',['$resource','$rootScope', function($resource,$rootScope){
      var selectedHeader = {};
      var selectedLine = {};
      var service = {
        getAgent: getAgent,
        create:create
      };
      return service;
      function getAgent() {
        var resourceUrl ='/api/wecorpagent/getByAgentid';
        return $resource(resourceUrl, {}, {
          'get': {
            method: 'GET',
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            }
          }
        });
      }

      function create(agent){
        var resourceUrl ='/api/wecorpagent/save';
        return $resource(resourceUrl, {}, {
          'save': {method: 'POST'}
        });
      }

    }]);


})();

/**
 * Created by user on 2016/8/3.
 */
(function (){
  'use strict';

  angular.module('hmapFront')
    .controller('WecorpAgentController',['$filter','WecorpAgentService','$state','$scope','$location','$localStorage','$sessionStorage','paginationConstants','entity','Upload','BaseConfig','SweetAlert',
    function($filter,WecorpAgentService,$state,$scope,$location,$localStorage,$sessionStorage,paginationConstants,entity,Upload,BaseConfig,SweetAlert){
      var vm = this;
      vm.agentType = [
        {code :1, name : "消息型应用"},
        {code :2, name : "主页型应用"}
      ];
      vm.file = null;
      vm.isfile = false;
      vm.reportuserFlag = [
        {code :0, name : "不接受"},
        {code :1, name : "接受"}
      ];
      vm.reportenterFlag = [
        {code :0, name : "不上报"},
        {code :1, name : "上报"}
      ];
      vm.reportLocationFlag=[
        {code :0, name : "不上报"},
        {code :1, name : "进入会话上报"},
        {code :2, name : "持续上报"}
      ];
      vm.showSubmintButtonFlag=false;
      vm.wecorpAgent = entity;


      vm.save = save;
      vm.cancel = cancel;
      vm.cancelChooseImage = cancelChooseImage;
      vm.chooseImage = chooseImage;
      vm.setCustomMenu = setCustomMenu;

      getAgent(vm.wecorpAgent);
      function getAgent(wecorpAgent){
        WecorpAgentService.getAgent().get({
          apiHeaderName:wecorpAgent.apiHeaderName,
          agentid:wecorpAgent.agentid
        }, function(data, headers) {
          vm.agent = data.rows;
          vm.showSubmintButtonFlag = true;
        }, function(error) {
          console.log('error');
        });
      }



      function save(){
        if(vm.isfile){
        upload(vm.file);
        }else{
          WecorpAgentService.create().save(vm.agent[0],
            function(data, headers) {
              SweetAlert.success($filter('T')("title.saveSuccess"), {title:$filter('T')("title.infoTitle")});
              getAgent(vm.wecorpAgent);
            }, function(error) {
              console.log('error');
            });
        }
      }
      function cancel(){
        $state.go('wecorpAgentList');
      }
      function cancelChooseImage(){
        vm.isfile = false;
        vm.file=null;
      }
      function chooseImage(){
        vm.isfile = true;
      }

      function upload(file) {
        vm.fileInfo = file;
        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        Upload.upload({
          //服务端接收
          url: BaseConfig.url + '/api/wecorpagent/uploadLogo',
          headers: {
            'Authorization': 'Bearer ' + token.access_token
          },
          //上传的文件
          data: {file: file}
        }).progress(function (evt) {
          //进度条
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        }).success(function (data, status, headers, config) {
          //上传成功
          vm.agent[0].logo_mediaid = data.message;
          WecorpAgentService.create().save(vm.agent[0],
            function(data, headers) {
              SweetAlert.success($filter('T')("title.saveSuccess"), {title:$filter('T')("title.infoTitle")});
              getAgent(vm.wecorpAgent);
            }, function(error) {
              console.log('error');
            });
        }).error(function (data, status, headers, config) {
          //上传失败
          console.log('错误状态: ' + status);
        });
      };

      function setCustomMenu(wecorpAgent){
        $location.path("app/wecorpAgentList/"+wecorpAgent.agentid+"/wecorpAgentCustomMenu");
      }

    }]);
})();

/**
 * Created by zhusifeng on 2016/8/31.
 */
(function () {
  'use strict';
   angular.module('hmapFront')
     .directive('repeatFinish',['$timeout',function($timeout){
       return {
         link: function(scope,element,attr){
           //console.log("+++++++: "+scope.$index);
           if(scope.$last == true){
             $timeout(function(){
               scope.$apply(attr.repeatfinish);
               //console.log('ng-repeat执行完毕'+attr.repeatfinish);
             },250);
           }
         }
       }
     }])

    .controller('umEditorController', umEditorController);

  umEditorController.$inject = ['$filter','umEditorService','$state','$scope','$uibModal','$timeout','Upload','toastr','SweetAlert','$sce'];
  function umEditorController($filter,umEditorService,$state,$scope,$uibModal,$timeout,Upload,toastr,SweetAlert,$sce) {
    var vm = this;
    vm.articleCount=0;
    vm.articleArr=[];
    vm.curShowCount=0; //当前显示的图文的articleCount值
    vm.show = 0;
    vm.coverRemark="";

    vm.articles=new Array(500);
    vm.article={};
    vm.templates={};
    vm.perviews="";
    //vm.editArticle={};

    vm.addImageText=addImageText; //添加图文
    vm.imageTextSelected=imageTextSelected;
    vm.onMouseOverImageText=onMouseOverImageText;
    vm.onMouseOutImageText=onMouseOutImageText;
    vm.imageTextDown=imageTextDown;
    vm.imageTextUp=imageTextUp;
    vm.imageTextDel=imageTextDel;
    vm.titleInput=titleInput;
    vm.send=send;
    vm.insertImage = insertImage;
    vm.insertRedio = insertRedio;
    vm.insertMusic = insertMusic;
    vm.insertVote = insertVote;
    vm.perview=perview;
    vm.localUpLoad = localUpLoad;
    vm.submitEdit = submitEdit;
    vm.selectAllTemplate =selectAllTemplate;

    init();
    function init(){
      addImageText();
      selectAllTemplate();
      vm.curShowCount=vm.articleCount;
      //$timeout( function() {imageTextSelected(vm.curShowCount)},500);
    }
    //新增图文
    function addImageText(){
      vm.articleCount=vm.articleCount+1;
      vm.articleArr.push(vm.articleCount);
      vm.curShowCount=vm.articleCount;
      vm.article={};
      saveData();
      //vm.curShowCount=vm.articleCount;
      //$timeout( function() {imageTextSelected(vm.curShowCount)},500);
    }

    /*选定右侧图文，并显示对应的表单*/
    function imageTextSelected(articleCount){
      //TODO 不规范
      //$("#imageTextList").find("div[id^='imageText']").removeClass("select_image_text");  //移除
      //$("#imageText"+articleCount).addClass("select_image_text");
      if(articleCount==vm.articleArr[0]){ //首图文
        vm.coverRemark="封面 小图片建议尺寸：900像素 * 500像素";
      }else{
        vm.coverRemark="封面 小图片建议尺寸：200像素 * 200像素";
      }
      saveData();
      vm.curShowCount=articleCount;
      showData();
    }

    function showData(){
       ///显示选定图文的数据
      if(vm.articles[vm.curShowCount]==undefined){
        vm.article={};
      }else{
        vm.article=vm.articles[vm.curShowCount];
      }
      //封面
      //if(vm.article.coverImg==undefined || vm.article.coverImg==''){
      //  $("#form").find("img[name='coverImg']").removeAttr("src");
      //}else{
      //  $("#form").find("img[name='coverImg']").attr("src",vm.article.coverImg);
      //}
    }

    function saveData(){

      vm.articles[vm.curShowCount]=vm.article;  //保存当前图文的数据
      //console.log(+vm.curShowCount+"==save===: "+angular.toJson(vm.articles[vm.curShowCount]));
    }

    function titleInput(){
      //TODO 不规范
      //$("#imageText"+vm.curShowCount).find("p[name='title']").text(vm.article.title==''?'标题':vm.article.title);

      saveData();
    }

    /*鼠标移入图文*/
    function onMouseOverImageText(articleCount){
      vm.show=articleCount;
    }
    /*鼠标移出图文*/
    function onMouseOutImageText(){
      vm.show=0
    }
    /*图文下移*/
    function imageTextDown(index){
      for(var i=0;i<vm.articleArr.length;i++){
        if(i==index){
          var v=vm.articleArr[i];
          vm.articleArr[i]=vm.articleArr[i+1];
          vm.articleArr[i+1]=v;
          break;
        }
      }
    }
    /*图文上移*/
    function imageTextUp(index){
      for(var i=0;i<vm.articleArr.length;i++){
        if(i==index){
          var v=vm.articleArr[i];
          vm.articleArr[i]=vm.articleArr[i-1];
          vm.articleArr[i-1]=v;
          break;
        }
      }
    }
    /*图文删除*/
    function imageTextDel(index){
      vm.articles[vm.articleArr[index]]=undefined;
      vm.articleArr.splice(index,1);
      imageTextSelected(vm.articleArr[vm.articleArr.length-1]);//选中最后一个
    }

    //打开图片上传模态框
    function insertImage(type){
      var modalInstance = $uibModal.open({
        templateUrl: 'app/umEditor/imgModal.html',
        controller: 'ImageModalController',
        controllerAs: '$ctrl',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              type: type
            };
          }
        }
      }).result.then(function (selectedImage) {
          //console.log("selectedImage: "+angular.toJson(selectedImage));
          if(type=='content'){  //正文
            insertContent(selectedImage);
          }else if(type=='cover'){ //封面
            selectCover(selectedImage);
          }
        }, function () {
          //console.log('Modal dismissed at: ' + new Date());
        });
    }
    function insertContent(selectedImage){
      var html = '';
      for(var i=0;i<selectedImage.length;i++){
        html += '<p><img src="' + selectedImage[i].attachmentUrl + '" id="' + selectedImage[i].attachmentId + '" style="max-width:100%"/></p>'
      }
      $timeout(function() {
        UE.getEditor('myUeditor').execCommand('insertHtml', html); //插入内容
      });
    }

    function selectCover(selectedImage){
        if(selectedImage.length>0){
          vm.article.contentCover=selectedImage[0].attachmentUrl;
          //$("#form").find("img[name='coverImg']").attr("src",vm.article.coverImg);
        }
    }

    /*弹出input file加载文件框*/
    function localUpLoad(target){
      document.getElementById(target).click();
    }

    //保存
    function submitEdit(){
      imageTextSelected(vm.curShowCount);
      for(var i=0;i<vm.articleArr.length;i++){
        var article=vm.articles[vm.articleArr[i]];
        var message=umEditorService.checkData(article);
        if(message!=''){
          imageTextSelected(vm.articleArr[i]);
          SweetAlert.error(message,{title:$filter('T')("title.infoTitle")});
          return false;
        }
      }
      var articles=[];
      for(var i=0;i<vm.articleArr.length;i++){
        articles.push(vm.articles[vm.articleArr[i]]);
      }
      var data={articles:articles,flag:'add'};
      console.log("submitEdit data: "+angular.toJson(data));
      vm.article.status = "未发布";
      umEditorService.submitInfo().insert(vm.article)
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
    }


    //弹出视频模态框
    function insertRedio(_this){
      $(_this).attr("data-toggle","modal");
    }

    //选择视频
    function selectRadio(target){
      console.log("选择视频");
      document.getElementById(target).click();
    }

    //弹出音乐模态框
    function insertMusic(_this){
      $(_this).attr("data-toggle","modal");
    }

    //选择音乐
    function selectMusic(target){
      console.log("选择音乐");
      document.getElementById(target).click();
    }

    //弹出投票模态框
    function insertVote(_this){
      $(_this).attr("data-toggle","modal");
    }

    //发起投票
    function selectVote(target){
      console.log("选择投票");
      document.getElementById(target).click();
    }


    //预览
    function perview(){
      imageTextSelected(vm.curShowCount);
      for(var i=0;i<vm.articleArr.length;i++){
        var article=vm.articles[vm.articleArr[i]];
        var message=umEditorService.checkData(article);
        if(message!=''){
          imageTextSelected(vm.articleArr[i]);
          SweetAlert.error(message,{title:$filter('T')("title.infoTitle")});
          return false;
        }
      }
      umEditorService.perview().perview(vm.article,onPerviewSuccess,onError);
    }

    //发布
    function send(data)
    {
      console.log(data);
      imageTextSelected(vm.curShowCount);
      for(var i=0;i<vm.articleArr.length;i++){
        var article=vm.articles[vm.articleArr[i]];
        var message=umEditorService.checkData(article);
        if(message!=''){
          imageTextSelected(vm.articleArr[i]);
          SweetAlert.error(message,{title:$filter('T')("title.infoTitle")});
          return false;
        }
      }

      var modalInstance = $uibModal.open({
        templateUrl: 'app/umEditor/selectSendPerson.html',
        controller: 'SendPersonController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              articleArr: vm.articleArr,
              articles:data
            };
          }
        }
      }).result.then(function (data) {

        }, function () {
          //console.log('Modal dismissed at: ' + new Date());
        });
    }
    function selectAllTemplate(){
      umEditorService.queryAllTemplate().query(onSuccess,onError);
    }

    function onSuccess(data){
      vm.templates=data.rows;
    }

    function onError(error) {
      //console.log('error');
    }

    function onPerviewSuccess(data){
      vm.perviews = data.rows;
      //$state.go('perview',{perviews:vm.perviews})
      var modalInstance = $uibModal.open({
        templateUrl: 'app/umEditor/perview.html',
        controller: 'PerviewController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              perviews:vm.perviews
            };
          }
        }
      }).result.then(function (data) {
        }, function () {
          //console.log('Modal dismissed at: ' + new Date());
        });
    }

  }


})();


/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('umEditor', {
        parent: 'app',
        url: "/umEditor",
        views: {
          'body': {
            templateUrl: "app/umEditor/umeditor.html",
            controller: 'umEditorController',
            controllerAs: 'vm'
          }
        }
      })
      .state('perview', {
        params:{'perviews':null},
        parent: 'app',
        url: "/umEditor",
        views: {
          'body': {
            templateUrl: "app/umEditor/perview.html",
            controller: 'PerviewController',
            controllerAs: 'vm'
          }
        }
      })
  }
})();

/**
 * Created by zhusifeng on 2016/9/8.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('umEditorService', umEditorService);

  umEditorService.$inject = ['$resource', '$http','$q','$log'];

  function umEditorService($resource, $http,$q, $log) {
    var service = {
      addAttachmentGroup:addAttachmentGroup,
      queryAttachmentGroup:queryAttachmentGroup,
      queryAttachment:queryAttachment,
      checkData:checkData,
    /*  uploadMyImg: uploadMyImg,
      readAsDataUrl: readAsDataURL,
      onLoad: onLoad,
      getReader: getReader,
      onError: onError,*/
      submitInfo:submitInfo,
      queryAllTemplate:queryAllTemplate,
      savePublish:savePublish,
      perview:perview,

    };
    return service;
    function addAttachmentGroup(data){
      var resourceUrl = '/api/attachmentGroup/add';
      return $http.post(resourceUrl,data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("response: " + angular.toJson(response.data));
        return response.data;
      });
    }

    function queryAttachmentGroup(){
      var resourceUrl = '/api/attachmentGroup/query';
      return $http.get(resourceUrl).then(function (response) {
        //console.log("response: " + angular.toJson(response.data));
        return response.data;
      });
    }

    function queryAttachment(data){
      var resourceUrl = '/api/attachment/query';
      return $http.post(resourceUrl,data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("response: " + angular.toJson(response.data));
        return response.data;
      });
    }

    function checkData(article){
      var message='';
      if(isNUll(article.contentTitle)){
        message='标题不能为空';
      }else if(isNUll(article.contentBody)){
        message='正文不能为空';
      }else if(isNUll(article.contentCover)){
        message='封面不能为空';
      }else if(isNUll(article.templateId)){
        message='模版不能为空';
      }
      return message;
    }
    function isNUll(_target){
      if(_target==undefined || _target==null || _target==''){
        return true;
      }
      return false;
    }

    function submitInfo(data){
      var resourceUrl = '/api/content/save';
      return $resource(resourceUrl,{},{
        'insert':{method:'POST'}
      })
    }

    function queryAllTemplate(){
      var resourceUrl = '/api/template/query';
      return $resource(resourceUrl,{},{
        'query':{method:'GET'}
      })
    }

    function savePublish(){
      var resourceUrl = '/api/content/savePublish';
      return $resource(resourceUrl,{},{
        'save':{method:'POST'}
      })
    }

    function perview(){
      var resourceUrl = '/api/content/perview';
      return $resource(resourceUrl,{},{
        'perview':{method:'POST'}
      })
    }

   /* function onLoad(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    }
    function onError(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    }
    function getReader(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      return reader;
    }
    function readAsDataURL(file, scope) {
      var deferred = $q.defer();
      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);
      return deferred.promise;
    }
    function uploadMyImg(file){
      var resourceUrl = '/api/objectUploadNoThumbnail';
      return $http.post(resourceUrl,file, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        console.log("000000" + angular.toJson(response.data));
        return response.data;
      })
    }*/
  }

})();

/**
 * Created by hand on 2016/12/8.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('SendPersonController', SendPersonController);

  SendPersonController.$inject = ['$filter','$stateParams', '$uibModalInstance','entity','umEditorService','$state', 'Contacts', 'paginationConstants', '$log','$scope','$uibModal','Hmapfe','toastr','$localStorage'];

  function SendPersonController ($filter,$stateParams, $uibModalInstance,entity,umEditorService,$state, Contacts, paginationConstants, $log,$scope,$uibModal,Hmapfe,toastr,$localStorage) {

    var vm = this;
    $scope.selectedstaff =[];
    vm.articleArr=entity.articleArr;
    vm.articles=entity.articles;
    vm.page = 1;
    vm.isStaffShow=false;
    vm.isSpinnerShow=false;
    vm.isOrgShow=true;
    vm.isTagShow=false;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.jsTreeData = [];
    vm.deptData = [];
    vm.dept = {};
    vm.treeConfig = {};
    vm.treeInstance = {};
    vm.currentDept={};
    vm.checkedNodes = [];
    vm.allDepts = [];
    vm.allTags=[];
    vm.staffs = [];
    vm.treeEventsObj = {};
    vm.loadAll = loadAll;
    vm.initData = initData;
    vm.getSelectedNode = getSelectedNode;
    vm.generateTreeData = generateTreeData;
    vm.selectOrg=selectOrg;
    vm.selectTag=selectTag;
    vm.getAllTags=getAllTags;
    vm.openTagModal=openTagModal;
    vm.updateTag=updateTag;
    vm.lockTag=lockTag;
    vm.deleteTag=deleteTag;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.tagDetail=tagDetail;
    vm.save=save;
    vm.clear=clear;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.value = '';
    vm.loadAll();
    vm.getAllTags();
    vm.treeEventsObj = {
      activate_node: select
    };

    vm.ok = function () {
      $uibModalInstance.close();
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    function select(e, i) {
      vm.currentDept.deptNumber=i.node.id;
      vm.currentDept.deptName=i.node.text;
      loadDeptStaff();
    }


    function save(){
      console.log("save:"+$scope.selectedstaff)
      vm.articles.userName =$scope.selectedstaff;
      umEditorService.savePublish().save(vm.articles,onSaveSuccess,onError);
    }
    function onSaveSuccess(result) {
      //console.log(result);
      toastr.success($('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $uibModalInstance.close(result);
    }



    function loadDeptStaff(){
      vm.isStaffShow=false;
      vm.isSpinnerShow=true;
      vm.dept.deptNumber = vm.currentDept.deptNumber;
      vm.dept.page = vm.page;
      vm.dept.pagesize = vm.itemsPerPage;

      Contacts.findDeptStaff().get(vm.dept, onStaffSuccess, onError);
    }
    function loadAll() {
      console.log(vm.articles);
      Contacts.findAllDepts().query({}, onSuccess, onError);
    }

    function initData() {
      vm.treeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'dnd']
      };
    }

    function getSelectedNode() {
      vm.checkedNodes = vm.treeInstance.jstree(true).get_selected();
    }

    function generateTreeData() {
      vm.deptData = [];
      var root = {};
      //$log.info(menu);
      //root.id = 0;
      //root.parent = "#";
      //root.text = "企业组织架构";
      //root.state = {opened: true,selected:false};
      //vm.deptData.push(root);

      angular.forEach(vm.allDepts, function (dept) {
        if(dept.id==1){
          var root = {};
          root.id =dept.id;
          root.parent = "#";
          root.text = dept.name;
          root.state = {opened: true,selected:false};
          vm.deptData.push(root);
        }
        else{
          var treeNode = {};
          //$log.info(menu);
          treeNode.id = dept.id;
          treeNode.parent = dept.parentId;
          treeNode.text = dept.name;
          treeNode.state = {opened: false,selected:false};
          vm.deptData.push(treeNode);
        }
      });
      //初始化
      vm.currentDept.deptNumber=vm.deptData[0].id;
      vm.currentDept.deptName=vm.deptData[0].text;
      $localStorage.deptData=vm.deptData;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function onSuccess(data, headers) {
      vm.allDepts = data.rows;
      vm.generateTreeData();
      vm.jsTreeData = [];
      vm.initData();
      angular.copy(vm.deptData, vm.jsTreeData);
      vm.treeConfig.version++;

    }

    function onStaffSuccess(data, headers) {
      vm.staffs = data.rows;
      vm.totalItems = data.total;
      vm.isStaffShow=true;
      vm.isSpinnerShow=false;
    }

    function onError(error) {
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadDeptStaff();
    };

    function selectTag(){
      vm.isOrgShow=false;
      vm.isTagShow=true;
    }
    function selectOrg(){
      vm.isOrgShow=true;
      vm.isTagShow=false;
      //getAllTags
    }
    $scope.$on('handleAddNewTag', function() {
      console.log(Contacts.newTag);
      vm.allTags.push(Contacts.newTag);
    });

    function getAllTags(){
      Contacts.getAllTags().get({}, onTagsSuccess, onError);
    }

    function onTagsSuccess(data, headers){
      vm.allTags = data.rows;
      $localStorage.allTags=vm.allTags;
    }
    function openTagModal(){
      var modalInstance = $uibModal.open({
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/contacts/tag-dialog.html',
        controller: 'TagDialogController',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              tagName: null
            };
          }
        }
      });
    };
    function updateTag(id){
      Hmapfe.log('updateTag');
    }
    function lockTag(id){
      Hmapfe.log('lockTag');
    }
    function deleteTag(id){
      //Contacts.deleteTag().save({}, onTagsSuccess, onError);
      Hmapfe.log('lockTag:'+id);
    }
    function tagDetail(){
      Hmapfe.log('tagDetail');
    }




    vm.isChecked = function(id){
      return $scope.selected.indexOf(id) >= 0 ;
    } ;

    vm.updateSelection = function($event,id){
      var checkbox = $event.target ;
      var checked = checkbox.checked ;
      if(checked){
        console.log("111  :"+checked);
        $scope.selectedstaff.push(id) ;
      }else{
        console.log("222  :"+checked);
        var idx = $scope.selectedstaff.indexOf(id) ;
        $scope.selectedstaff.splice(idx,1) ;
      }
    } ;



  }


})();

/**
 * Created by hand on 2016/12/20.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('PerviewController', PerviewController);

  PerviewController.$inject = ['$sce','$uibModalInstance','entity'];

  function PerviewController($sce,$uibModalInstance,entity) {
    var vm = this;
    vm.perview = "";


    init();
    function init() {
       vm.perview = $sce.trustAsHtml(entity.perviews[0]);
    }

    vm.ok = function () {
      $uibModalInstance.close();
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }
})();

/**
 * Created by zhouzy on 2016/9/18 0018.
 */
/**
 * Created by zhouzy on 2016/8/4 0004.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ImageModalController', ImageModalController);

  ImageModalController.$inject = ['$filter','$stateParams', '$uibModalInstance','$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','SweetAlert','entity','umEditorService'];

  function ImageModalController ($filter,$stateParams, $uibModalInstance,$localStorage,$sessionStorage,$timeout,Upload,BaseConfig,SweetAlert,entity,umEditorService) {
    var $ctrl = this;
    $ctrl.operate=entity.type;
    $ctrl.type='IMAGE';
    $ctrl.pageSize=10;
    $ctrl.sumPage=0;
    $ctrl.curPage=1;
    $ctrl.targetPage='';
    $ctrl.currentGroup="unGroup";  //未分组
    $ctrl.groupData = [];
    $ctrl.imageData = [];
    $ctrl.isOpen=false;

    $ctrl.prevPage=prevPage;
    $ctrl.nextPage=nextPage;
    $ctrl.skipPage=skipPage;
    $ctrl.selectedGroup=selectedGroup;
    $ctrl.selectPicture=selectPicture;
    $ctrl.upLoadImage=upLoadImage;
    $ctrl.addTag = addTag;
    $ctrl.closeAddTag = closeAddTag;
    $ctrl.localUpLoad=localUpLoad;

    $ctrl.preIndex=null;

    $ctrl.dynamicPopover = {
      templateUrl: 'popover.html'
    };

    init();
    function init(){
      queryGroup()
    }

    function queryGroup(){
      umEditorService.queryAttachmentGroup().then(function(data){
        $ctrl.groupData= data.rows;
        queryImage();
      },function(error){
        //console.log(error);
        SweetAlert.error($filter('T')("title.queryFailed"), {title:$filter('T')("title.infoTitle")});
      });
    }
    function queryImage(){
      var data={groupId:$ctrl.currentGroup,type:$ctrl.type,pageCount:$ctrl.curPage,pageSize:$ctrl.pageSize};
      umEditorService.queryAttachment(data).then(function(resp){
        $ctrl.imageData= resp.rows;
        if(resp.total%$ctrl.pageSize==0){
          $ctrl.sumPage=resp.total/$ctrl.pageSize;
        }else{
          $ctrl.sumPage=parseInt(resp.total/$ctrl.pageSize)+1
        }
      },function(error){
        //console.log(error);
        SweetAlert.error($filter('T')("title.queryFailed"), {title:$filter('T')("title.infoTitle")});
      });
    }
    function prevPage(){
      $ctrl.curPage=$ctrl.curPage-1;
      queryImage();
    }
    function nextPage(){
      $ctrl.curPage=$ctrl.curPage+1;
      queryImage();
    }
    function skipPage(){
      var regx=/^[1-9]+[0-9]*$/;
      if(!regx.test($ctrl.targetPage) || $ctrl.targetPage>$ctrl.sumPage){
        $ctrl.targetPage='';
        SweetAlert.error($filter('T')("title.inputNormalPage"),{title:$filter('T')("title.infoTitle")});
        return false;
      }
      $ctrl.curPage=$ctrl.targetPage;
      queryImage();
    }
    //标注选定的组
    function selectedGroup(groupId){
      $ctrl.currentGroup=groupId;
      queryImage();
    }
    //选择图片
    function selectPicture(index){
      if($ctrl.imageData[index].selectFlag){
        $ctrl.imageData[index].selectFlag=false;
      }else{
        if($ctrl.operate=='cover'){  //选择封面
            if($ctrl.preIndex!=null){
              $ctrl.imageData[$ctrl.preIndex].selectFlag=false;  //取消前一个的选定
            }
          $ctrl.imageData[index].selectFlag=true;
          $ctrl.preIndex=index;
        }else{    //选择正文图片
          $ctrl.imageData[index].selectFlag=true;
        }
      }
    }
    /*弹出input file加载文件框*/
    function localUpLoad(target){
      document.getElementById(target).click();
    }
    function upLoadImage(){
      var file=document.getElementById("picture").files[0];
      if (file == null || file== undefined || file == '') {
        return false;
      }
        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        Upload.upload({
          //服务端接收
          url: BaseConfig.url + '/api/attachment/uploadFile',
          headers: {
            'Authorization': 'Bearer ' + token.access_token
          },
          //上传的文件
          data: {file: file,type:$ctrl.type,groupId:$ctrl.currentGroup}
        }).progress(function (evt) {
          //进度条
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        }).success(function (data, status, headers, config) {
          //上传成功
          //console.log("服务器返回的数据：", angular.toJson(data));
          queryGroup();
        }).error(function (data, status, headers, config) {
          //上传失败
          //console.log('上传失败,服务器返回的数据: ' + angular.toJson(data));
          SweetAlert.error(data.message,{title:$filter('T')("title.infoTitle")});
        });
    }
    //确认新建
    function addTag(){
      if($ctrl.groupName==undefined || $ctrl.groupName==''){
        SweetAlert.error($filter('T')("title.inputNotNull"),{title:$filter('T')("title.infoTitle")});
        return false;
      }
      var data={groupName:$ctrl.groupName};
      umEditorService.addAttachmentGroup(data).then(function(resp){
        closeAddTag();
        queryGroup();
      });
    }

    function closeAddTag(){
      $ctrl.isOpen=false;
    }

    $ctrl.ok = function () {
      var data=[];
      for(var index=0;index<$ctrl.imageData.length;index++){
        if($ctrl.imageData[index].selectFlag){
          data.push($ctrl.imageData[index]);
        }
      }
      //console.log("data=====: "+angular.toJson(data));
      closeAddTag();
      $uibModalInstance.close(data);
    };

    $ctrl.cancel = function () {
      closeAddTag();
      $uibModalInstance.dismiss('cancel');
    };
  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('thirdparty', {
        parent: 'app',
        url: "/thirdparty",
        views: {
          'body': {
            templateUrl: "app/thirdparty/thirdparty.html",
            controller: 'ThirdpartyController',
            controllerAs: 'vm'
          }
        }
      })
      .state('thirdparty-detail', {
        parent: 'app',
        url: "/thirdparty/:id",
        views: {
          'body': {
            templateUrl: "app/thirdparty/thirdparty-detail.html",
            controller: 'ThirdpartyDetailController',
            controllerAs: 'vm'
          }
        }
      })
      .state('thirdparty.new', {
        parent: 'thirdparty',
        url: "/new",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/thirdparty/thirdparty-dialog.html',
            controller: 'ThirdpartyDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: null,
                  appName: null,
                  appDesc: null,
                  appCode: null,
                  appIcon: null,
                  appKey: null,
                  appSecret: null,
                  freeFlag: null,
                  expiredDate: null,
                  enableFlag: null,
                  appHomepage: null
                };
              }
            }
          }).result.then(function () {
              //console.log("thirdparty go1");
              $state.go('thirdparty', null, {reload: true});
            }, function () {
              //console.log("thirdparty go2");
              $state.go('thirdparty');
            });
        }]
      }).state('thirdparty.edit', {
        parent: 'thirdparty',
        url: "/:id/edit",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/thirdparty/thirdparty-dialog.html',
            controller: 'ThirdpartyDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              //console.log("thirdparty go1");
              $state.go('thirdparty', null, {reload: true});
            }, function () {
              //console.log("thirdparty go2");
              $state.go('thirdparty');
            });
        }]
      });
  }

})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('Thirdparty', Thirdparty);

  Thirdparty.$inject = ['$resource'];

  function Thirdparty ($resource) {
    var resourceUrl ='/api/thirdpartyApp/:id';

    return $resource(resourceUrl, {}, {
      'query': { method: 'GET',isArray:false},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }


})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ThirdpartyController', ThirdpartyController);

  ThirdpartyController.$inject = ['$filter','toastr','SweetAlert','PluginService','$state','Thirdparty','paginationConstants'];

  function ThirdpartyController($filter,toastr,SweetAlert,PluginService,$state,Thirdparty,paginationConstants) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.redisInit = redisInit;
    vm.keyReset = keyReset;
    vm.loadAll();

    function loadAll () {
      Thirdparty.query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }

    function redisInit() {
      SweetAlert.confirm($filter('T')("appEdition.refreshConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          return PluginService.redisInit()
            .then(function (data) {
              toastr.success($filter('T')("title.refreshSuccess"),$filter('T')("title.infoTitle"));
            })
        }
      });
    }

    function keyReset() {
      SweetAlert.confirm($filter('T')("appEdition.resetKey"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          return PluginService.resetKey()
          .then(function (data) {
            toastr.success($filter('T')("title.resetSuccess"),$filter('T')("title.infoTitle"));
          })
        }
      });
    }

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.thirdpartys = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');
    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll();
    }
  }



})();

/**
 * Created by zhouzy on 2016/7/31 0031.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ThirdpartyDialogController', ThirdpartyDialogController);

  ThirdpartyDialogController.$inject = ['$filter','PromptService','RoleService','$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Thirdparty','toastr','uibDateParser'];

  function ThirdpartyDialogController($filter,PromptService,RoleService,$timeout, $scope, $stateParams, $uibModalInstance, entity, Thirdparty,toastr,uibDateParser) {
    var vm = this;
    vm.lang = window.localStorage.lang;
    if(vm.lang == 'en_GB'){
      vm.lang = 'en';
    }

    vm.thirdparty = entity;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.popupOpen = popupOpen;
    vm.load=load;

    vm.load(vm.thirdparty.id);

    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.localeSure = localeSure;


    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#appDescBtn").attr("disabled", false);
        $("#appNameBtn").attr("disabled", false);
      });
    }
    initLangs();

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.thirdparty.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
          if(vm.thirdparty.__tls){
            if(vm.thirdparty.__tls[name]){
              $("input[name='"+name+"_" + langs[i].langCode + "']").val(vm.thirdparty.__tls[name][langs[i].langCode]);
            }
          }
        }
      }
    }

    $scope.$watch('$viewContentLoaded', function(){
      //data plugin
      $('.form_date').datetimepicker({
        language: vm.lang,
        format: 'yyyy-mm-dd 00:00:00',
        weekStart: 1,
        todayBtn: 1,
        autoclose: 1,
        todayHighlight: 1,
        startView: 2,
        minView: 2,
        forceParse: 0
      });
    });

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.thirdparty.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.thirdparty[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.thirdparty.__tls = __tls;
    }

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.isSaving = true;
      if(vm.thirdparty.expiredDate!=null){
        vm.thirdparty.expiredDate=$("#field_expiredDate").val();
      }
      if(!vm.thirdparty.enableFlag)
        vm.thirdparty.enableFlag = 'N';
      if (vm.thirdparty.id !== null) {
        Thirdparty.update(vm.thirdparty, onSaveSuccess, onSaveError);
      } else {
        Thirdparty.save(vm.thirdparty, onSaveSuccess, onSaveError);
      }
    }

    function onSaveSuccess(result) {
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      $scope.$emit('hmapFront:thirdpartyUpdate', result);
      $uibModalInstance.close(result);
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        format:'yyyy-MM-dd hh:mm:ss',
        maxDate: new Date(2099, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function popupOpen() {
      vm.isOpen = true;
    }


    function GMTToStr(Dtime){
      var date = new Date(Dtime);
      var str=date.getFullYear() + '-' +
        (date.getMonth() + 1) + '-' +
        date.getDate() + ' ' +
        date.getHours() + ':' +
        date.getMinutes() + ':' +
        date.getSeconds();
      return str
    }
    function load(id) {
      if (id) {
        //console.log('loadone');
        Thirdparty.get({id: id}, function (result) {
          vm.thirdparty = result.rows[0];
          //vm.thirdparty.expiredDate = GMTToStr(vm.thirdparty.expiredDate);
          var appDecList = {};
          var appNameList = {};
          var __tls = {};
          //
          RoleService.getRoleLocaleInfo(id, 'com.kohler.iot.integrator.hms.general.entities.HmsThirdpartyApp', 'appDesc')
            .then(function (data) {
              //deal with the multilanguage field value
              appDecList = {};
              for (var i in data) {
                appDecList[data[i].langCode] = data[i].value;
              }
              __tls['appDesc'] = appDecList;

              RoleService.getRoleLocaleInfo(id, 'com.kohler.iot.integrator.hms.general.entities.HmsThirdpartyApp', 'appName')
                .then(function (data) {
                  //deal with the multilanguage field value
                  appNameList = {};
                  for (var i in data) {
                    appNameList[data[i].langCode] = data[i].value;
                  }
                  __tls['appName'] = appNameList;
                });
              vm.thirdparty.__tls = __tls;
              $("#appDecBtn").attr("disabled", false);
              $("#appNameBtn").attr("disabled", false);
              //vm.thirdparty.expiredDate=uibDateParser.parse(vm.thirdparty.expiredDate,"yyyy-MM-dd hh:mm:ss");
            });
        });
      }

    }

  }
})();

/**
 * Created by zhouzy on 2016/8/4 0004.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ThirdpartyDetailController', ThirdpartyDetailController);

  ThirdpartyDetailController.$inject = ['$stateParams', 'Thirdparty'];

  function ThirdpartyDetailController ($stateParams, Thirdparty) {
    var vm = this;

    vm.load = load;
    vm.thirdparty = {};

    vm.load($stateParams.id);

    function load (id) {
      Thirdparty.get({id: id}, function(result) {

        vm.thirdparty = result.rows[0];
        //console.log(vm.thirdparty);
        //console.log(vm.thirdparty.appName);
      });
    }
  }
})();

/**
 * Created by zhouzy on 2016/8/18 0018.
 */
/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('sysConfig', {
        parent: 'app',
        url: "/sysConfig",
        views: {
          'body': {
            templateUrl: "app/sysConfig/sysConfig.html",
            controller: 'SysConfigController',
            controllerAs: 'vm'
          }
        }
      })
      .state('sysConfig.new', {
        parent: 'sysConfig',
        url: "/new",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/sysConfig/sysConfig-dialog.html',
            controller: 'SysConfigDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: null,
                  configKey: null,
                  configValue: null,
                  configLevel: null,
                  enable: 'Y',
                  configDesc: null
                };
              }
            }
          }).result.then(function () {
              $state.go('sysConfig', null, {reload: 'sysConfig'});
            }, function () {
              $state.go('sysConfig', null, {reload: 'sysConfig'});
            });
        }]
      }).state('sysConfig.edit', {
        parent: 'sysConfig',
        url: "/edit/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/sysConfig/sysConfig-dialog.html',
            controller: 'SysConfigDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              $state.go('sysConfig', null, {reload: 'sysConfig'});
            }, function () {
              $state.go('sysConfig', null, {reload: 'sysConfig'});
            });
        }]
      });
  }
})();

/**
 * Created by zhouzy on 2016/8/18 0018.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('SysConfig', SysConfig);

  SysConfig.$inject = ['$resource'];

  function SysConfig($resource) {
    var service = {
      query: query,
      saveOrUpdate: saveOrUpdate,
      remove: remove
    };
    return service;

    function query() {
      var resourceUrl = '/api/sysConfig/query';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function saveOrUpdate() {
      var resourceUrl = '/api/sysConfig/saveOrUpdate';
      return $resource(resourceUrl, {}, {
        'saveOrUpdate': {method: 'POST'}
      });
    }

    function remove() {
      var resourceUrl = '/api/sysConfig/delete';
      return $resource(resourceUrl, {}, {
        'remove': {method: 'POST'}
      });
    }

  }
})();

/**
 * Created by zhouzy on 2016/8/18 0018.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('SysConfigController', SysConfigController);

  SysConfigController.$inject = ['$filter', '$state', 'SysConfig', 'paginationConstants', 'toastr', 'toastrConfig', 'SweetAlert'];

  function SysConfigController($filter, $state, SysConfig, paginationConstants, toastr, toastrConfig, SweetAlert) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.searchConfig = {};
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.clear = clear;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.search = search;
    vm.remove = remove;
    vm.value = '';
    vm.loadAll();

    function loadAll() {
      SysConfig.query().query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }

    function search() {
      vm.searchConfig.page = vm.page;
      vm.searchConfig.pagesize = paginationConstants.itemsPerPage;
      SysConfig.query().query(vm.searchConfig, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.sysConfigs = data.rows;
      vm.totalItems = data.total;
    }

    function onError(error) {
      //console.log('error');

    }

    function clear() {
      vm.searchConfig.configKey = "";
      vm.searchConfig.configDesc = "";
    }
    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      search();
    }

    function remove(entity) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          SysConfig.remove().remove({id: entity.id}, function (response) {
            if (response.success) {
              toastr.success($filter('T')('title.deleteSuccess'));
              search();
            } else {
              toastr.error($filter('T')('title.deleteFail'));
            }
          }, function () {
            toastr.error($filter('T')('title.deleteFail'));
          });
        }
      });
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }


})();

/**
 * Created by zhouzy on 2016/9/23 0023.
 */
/**
 * Created by zhouzy on 2016/7/31 0031.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('SysConfigDialogController', SysConfigDialogController);

  SysConfigDialogController.$inject = ['PromptService','RoleService','$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SysConfig','toastr','$filter'];

  function SysConfigDialogController(PromptService,RoleService,$timeout, $scope, $stateParams, $uibModalInstance, entity, SysConfig,toastr,$filter) {
    var vm = this;
    vm.sysConfig = entity;
    vm.isSystem = false;
    vm.configLevelType = ["SYSTEM", "USER"];
    vm.clear = clear;
    vm.save = save;
    vm.load = load;
    vm.load(vm.sysConfig.id);

    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.localeSure = localeSure;


    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#configDescBtn").attr("disabled", false);
      });
    }
    initLangs();

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.sysConfig.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
          if(vm.sysConfig.__tls)
            $("input[name='"+name+"_" + langs[i].langCode + "']").val(vm.sysConfig.__tls[name][langs[i].langCode]);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.sysConfig.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.sysConfig[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.sysConfig.__tls = __tls;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.isSaving = true;
      //console.log(vm.sysConfig);
      SysConfig.saveOrUpdate().saveOrUpdate(vm.sysConfig, onSaveSuccess, onSaveError);
    }

    function onSaveSuccess(result) {
      if (result.success) {
        //console.log(result);
        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.infoTitle"));
        $scope.$emit('hmapFront:sysConfigUpdate', result);
        $uibModalInstance.close(result);
      } else {
        toastr.error($filter('T')("title.saveFail"), $filter('T')("title.infoTitle"));
      }
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function load(id) {
      if (id) {
        SysConfig.query().query(vm.sysConfig, function (result) {
          vm.sysConfig = result.rows[0];
          if (vm.sysConfig.configLevel === 'SYSTEM') {
            vm.isSystem = true;
          }
          else {
            vm.isSystem = false;
          }

          var nameList = {};
          var __tls = {};
          RoleService.getRoleLocaleInfo(id, 'com.kohler.iot.integrator.hms.general.entities.HmsSystemConfig', 'configDesc')
            .then(function (data) {
              //deal with the multilanguage field value
              nameList = {};
              for (var i in data) {
                nameList[data[i].langCode] = data[i].value;
              }
              __tls['configDesc'] = nameList;
              vm.sysConfig.__tls = __tls;
              $("#configDescBtn").attr("disabled", false);
            });
        });
      }


    }

  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('schedule', {
        parent: 'app',
        url: "/schedule",
        views: {
          'body': {
            templateUrl: "app/schedule/schedule.html",
            controller: 'ScheduleController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {};
            }
          ]
        }
      })
      .state('schedule.new', {
        parent: 'app',
        url: "/schedule/new",
        views: {
          'body': {
            templateUrl: "app/schedule/schedule-new.html",
            controller: 'ScheduleNewController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                  id: null,
                  info: null,
                  state: null,
                  url: null,
                  paperId: null,
                  perName: null,
                  perName2: null,
                  perTitle: null,
                  perTitle2: null,
                  perPhoto: null,
                  place: null,
                  orderNum: null,
                  time: null,
                  profile: null
                }
              }
            }
          }
        }
      })
      .state('schedule.edit', {
        parent: 'app',
        url: "/schedule/:id/edit",
        views: {
          'body': {
            templateUrl: "app/schedule/schedule-new.html",
            controller: 'ScheduleEditController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  id: $stateParams.id
                };
              }
            }
          }
        }
      })
  }
})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('Schedule', Schedule);

  Schedule.$inject = ['$http','$resource','Upload','BaseConfig','$localStorage','$sessionStorage'];

  function Schedule ($http,$resource,Upload,BaseConfig,$localStorage,$sessionStorage) {
    var service = {
      scheduleLoadSearch: scheduleLoadSearch,
      scheduleUpdate: scheduleUpdate
    };
    return service;

    function scheduleLoadSearch(page,pageSize) {
      return $resource("/api/scheduleFound?page="+page+"&pageSize="+pageSize, {}, {
        'query': {method: 'POST', isArray: false}
      });
    }
    function scheduleUpdate() {
      return $resource("/api/scheduleUpdate", {}, {
        'update': {method: 'POST'}
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ScheduleController', ScheduleController);
  ScheduleController.$inject = ['$state','Schedule','entity','paginationConstants','$localStorage','$sessionStorage','Upload','BaseConfig'];
  /** @ngInject */
  function ScheduleController($state, Schedule,entity, paginationConstants,$localStorage,$sessionStorage,Upload,BaseConfig) {
    var vm = this;
    vm.schedule=entity;
    vm.schedules=[];
    vm.page = 1;
    vm.file="";
    vm.importExcel=importExcel;
    vm.totalItems = null;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadSearch=loadSearch;
    vm.fishUpload=fishUpload;
    vm.exportExcel=exportExcel;
    vm.update=update;
    vm.sign=sign;
    vm.pass=pass;
    vm.loadSearch();

    function loadSearch(){
      var page=vm.page;
      var pageSize=paginationConstants.itemsPerPage;
      Schedule.scheduleLoadSearch(page,pageSize).query(vm.schedule, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      console.log('onSuccess');
      console.log(data);
      vm.schedules = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      console.log('error');
    }
    function update(){
      Schedule.scheduleLoadSearch().update(vm.schedule, onSuccess, onError);
    }
    function sign(schedule){
      Schedule.sign="Y";
      Schedule.scheduleUpdate().update(schedule);
      loadSearch();
    }
    function pass(schedule){
      Schedule.passState="Y";
      Schedule.scheduleUpdate().update(schedule);
    }
    function pageChanged() {
      console.log('Page changed to: ' +vm.page);
      loadSearch();
    }
    function importExcel(obj) {
      document.getElementById(obj).click();
    }
    function fishUpload() {
      Schedule.scheduleImport(vm.file);
    }
    function exportExcel() {
      Schedule.scheduleExport(vm.schedule);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ScheduleNewController', ScheduleNewController);

  ScheduleNewController.$inject = ['$timeout','$scope','$state', '$stateParams','Schedule','entity','uibDateParser'];

  function ScheduleNewController($timeout,$scope, $state, $stateParams, Schedule, entity, uibDateParser) {
    var vm = this;
    vm.schedule = entity;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.sendTime = sendTime;

    vm.target = [
      {id:'all',name:'all'},
      {id:'hand',name:'hand'},
      {id:'join',name:'join'},
      {id:'pic',name:'pic'},
      {id:'park',name:'park'}
    ];
    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });
    function clear() {
      $state.go('schedule');
    }
    function save() {
      vm.isSaving = true;
      if (vm.schedule.id !== null) {
        Schedule.update(vm.schedule, onSaveSuccess, onSaveError);
      } else {
        Schedule.save(vm.schedule, onSaveSuccess, onSaveError);
      }
    }
    function onSaveSuccess(result) {
      $scope.$emit('hmapFront:scheduleUpdate', result);
      vm.isSaving = true;
      $state.go('schedule');
    }
    function onSaveError() {
      vm.isSaving = false;
    }
    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }
    function sendTime() {
      vm.isSendTime = true;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ScheduleEditController', ScheduleEditController);

  ScheduleEditController.$inject = ['$timeout','$scope','$state', '$stateParams','Schedule','entity','uibDateParser'];

  function ScheduleEditController($timeout,$scope, $state, $stateParams, Schedule, entity, uibDateParser) {
    var vm = this;

    vm.schedule = entity;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.sendTime = sendTime;
    vm.load=load;

    vm.load(vm.schedule.id);

    vm.target = [
      {id:'all',name:'all'},
      {id:'hand',name:'hand'},
      {id:'join',name:'join'},
      {id:'pic',name:'pic'},
      {id:'park',name:'park'}
    ];

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $state.go('schedule');
    }

    function save() {
      vm.isSaving = true;
      if (vm.schedule.id !== null) {
        Schedule.update(vm.schedule, onSaveSuccess, onSaveError);
      } else {
        Schedule.save(vm.schedule, onSaveSuccess, onSaveError);
      }
    }

    function onSaveSuccess(result) {
      $scope.$emit('hmapFront:scheduleUpdate', result);
      vm.isSaving = true;
      $state.go('schedule');
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function sendTime() {
      vm.isSendTime = true;
    }

    function load(id) {
      vm.schedule.id=id;
      Schedule.scheduleLoadSearch(1,1).query(vm.schedule, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      console.log('onSuccess');
      console.log(data);
      vm.schedule = data.rows[0];
      vm.schedule.sendTime=uibDateParser.parse(vm.schedule.sendTime,"yyyy-MM-dd");
    }
    function onError(error) {
      console.log('error');
    }
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('RoleManagerController', RoleManagerController);

  RoleManagerController.$inject = ['toastr','$filter','RoleService', 'Authority', 'paginationConstants','cfpLoadingBar', '$state', '$log', 'MessageTemplateService', 'SweetAlert'];

  function RoleManagerController(toastr,$filter, RoleService, Authority, paginationConstants, cfpLoadingBar, $state, $log, MessageTemplateService, SweetAlert) {
    var vm = this;
    vm.addError = false;
    vm.errorMsg = "";
    vm.page = 1;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.initWeidget = initWeidget;
    vm.ignoreChanges = true;
    vm.role = {};
    vm.jsTreeData = [];
    vm.menuData = [];
    vm.treeConfig = {};
    vm.treeInstance = {};
    vm.checkedNodes = [];
    vm.menuItems = [];
    vm.currentRole = {};
    vm.roles = [];
    vm.roleFunctions=[];
    vm.roleTypes = [];
    vm.getSelectedNode = getSelectedNode;
    vm.generateTreeData = generateTreeData;
    vm.initData = initData;
    vm.loadAllAuthority = loadAllAuthority;
    vm.selectRole = selectRole;
    vm.loadAllRole = loadAllRole;
    vm.queryRole = queryRole;
    vm.saveAuthority=saveAuthority;
    vm.applyModelChanges=applyModelChanges;
    vm.deleteRole = deleteRole;
    vm.initData();
    // vm.loadAllAuthority();
    vm.loadAllRole();
    vm.initWeidget();

    function initWeidget() {
      // state
      MessageTemplateService.getByCode().query({code:'SYS.ROLE_TYPE'},function (data) {
        vm.roleTypes = data.rows;
      },function (error) {
      });
    }

    function loadAllRole() {
      RoleService.findRoles(vm.page,paginationConstants.itemsPerPage).query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onRoleSuccess, onError);
    }

    function onRoleSuccess(data, headers) {
      vm.roles = data.rows;
      vm.totalItems =  data.total;
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      ////console.log('Page changed to: ' + vm.page);
      loadAllRole();
    };

    function queryRole() {
      clearTree();
      if (vm.role.roleCode != null && $.trim(vm.role.roleCode) == '') {
        vm.role.roleCode = null;
      }
      if (vm.role.roleName != null && $.trim(vm.role.roleName) == '') {
        vm.role.roleName = null;
      }
      if (vm.role.roleDescription != null && $.trim(vm.role.roleDescription) == '') {
        vm.role.roleDescription = null;
      }
      RoleService.findRoles().query(vm.role, onRoleSuccess, onError);
    }


    function getSelectedNode() {
      vm.checkedNodes = vm.treeInstance.jstree(true).get_selected();
      //$log.info(vm.checkedNodes);
    }

    function generateTreeData() {
      vm.menuData = [];
      angular.forEach(vm.menuItems, function (menu) {
        var treeNode = {};
        //$log.info(menu);
        treeNode.id = menu.id;
        treeNode.parent = "#";
        treeNode.text = menu.text;
        var ischecked=false;

        if(menu.ischecked){
          ischecked=true;
        }
        treeNode.state = {opened: true, selected: ischecked};
        vm.menuData.push(treeNode);
        if (menu.children != undefined && menu.children != null && menu.children.length > 0) {
          angular.forEach(menu.children, function (m) {
            expandTree(m, menu);
          });
        }
      });
    }

    function expandTree(menuNode, parentNode) {
      var treeNode = {};
      treeNode.id = menuNode.id;
      treeNode.parent = parentNode.id;
      treeNode.text = menuNode.text;
      var ischecked=false;
      if(menuNode.ischecked){
        ischecked=true;
      }
      treeNode.state = {opened: true, selected: ischecked};
      vm.menuData.push(treeNode);
      if (menuNode.children != undefined && menuNode.children != null && menuNode.children.length > 0) {
        angular.forEach(menuNode.children, function (menu) {
          expandTree(menu, menuNode);
        });
      }
    }

    function initData() {
      vm.treeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'checkbox']
      };
    }

    function loadAllAuthority(role) {
      Authority.queryRoleFunc().query({
        roleId: role.roleId,
        moduleCode: role.attribute1
      }, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      vm.addError = false;
      complete();
      vm.menuItems = data.rows;
      vm.generateTreeData();
      vm.jsTreeData=[];
      angular.copy(vm.menuData, vm.jsTreeData);
      vm.treeConfig.version++;
      /*$log.info('vm.jsTreeData');
      $log.info(vm.jsTreeData);
      $log.info('vm.jsTreeDataend');
      vm.totalItems = data.total;*/
    }
    function onRoleFunctionSuccess(data){
      // $log.info(data);
    }

    function onError(error) {
      // console.log(error);
      if (error.data && false == error.data.success) {
        clearTree();
        vm.errorMsg = error.data.message;
        vm.addError = true;
      }
    }

    function start() {
      cfpLoadingBar.start();
    };

    function complete() {
      cfpLoadingBar.complete();
    }

    function selectRole(role) {
      start();
      vm.currentRole = role.roleId;
      loadAllAuthority(role);
    }

    function saveAuthority(){
      vm.roleFunctions=[];

      var selected_nodes = vm.treeInstance.jstree(true).get_selected();
      // $log.info(selected_nodes);
      angular.forEach(selected_nodes, function (node) {
        var roleFunction={
          roleId: vm.currentRole,
          functionId:node
        };
        vm.roleFunctions.push(roleFunction);
      });
      // $log.info(vm.roleFunctions);
      Authority.save().save(vm.roleFunctions,onRoleFunctionSuccess,onError);
    }
    function applyModelChanges(){
      // $log.info("applyModelChanges");
      return vm.ignoreChanges;
    }
    function deleteRole(role){
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          return RoleService.deleteRole(role)
            .then(function (data) {
              var flag = data.success;
              if(data.code=='userNotEmpty'){
                toastr.warning($filter('T')("title.userNotEmpty"));
                return;
              }
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
                return $state.go('role', null, {reload: true});
              }
            })
        }
      });
    }

    function clearTree(){
      vm.jsTreeData=[];
      vm.totalItems = 0;
      vm.treeConfig.version++;
    }
  }


})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('role', {
        parent: 'app',
        url: "/role",
        views: {
          'body': {
            templateUrl: "app/roleManager/roleManage.html",
            controller: 'RoleManagerController',
            controllerAs: 'vm'
          }
        }
      })
      .state('role.add', {
        parent: 'role',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/roleManager/addRole.html',
            controller: 'AddRoleController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg'
          }).result.then(function () {
              //console.log("role go1");
              $state.go('role', null, {reload: true});
            }, function () {
              //console.log("role go2");
              $state.go('role');
            });
        }]
      })
      .state('role.edit', {
        parent: 'role',
        url: "/edit/:roleId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          ////console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/roleManager/editRole.html',
            controller: 'EditRoleController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                //console.log("entity:"+angular.toJson($stateParams.roleId));
                return {
                  roleId:$stateParams.roleId
                };
              }
            }
          }).result.then(function () {
              //console.log("role go1");
              $state.go('role', null, {reload: true});
            }, function (p) {
              //console.log("role go2");
              if (p === 'cancel') {
                $state.go('role');
              } else {
                $state.go('role', null, {reload: true});
              }
            });
        }]
      })
  };
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('RoleService', RoleService);

  RoleService.$inject = ['$resource','$http'];

  function RoleService($resource,$http) {
    var service = {
      findRoles: findRoles,
      findRole:findRole,
      updateRoles: updateRoles,
      addRole: addRole,
      addOrUpdate:addOrUpdate,
      getRoleLocaleInfo: getRoleLocaleInfo,
      deleteRole: deleteRole
    };
    return service;

    function findRoles(page,pagesize) {
      if(page==undefined){
        page = 1;
      }
      if(pagesize == undefined){
        pagesize = 10;
      }
      var resourceUrl = '/api/role/queryAll?page='+page+"&pagesize="+pagesize;
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function addOrUpdate(roleId) {
      var resourceUrl = '/api/ordinaryRole/addOrDel?roleId='+roleId;
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function findRole(roleId) {
      var resourceUrl = '/api/role/getRole?roleId='+roleId;
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function updateRoles() {
      var resourceUrl = '/api/role/updateRole';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function addRole() {
      var resourceUrl = '/api/role/insertSelective';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function getUserRole(){

    }

    //code :B 主表主键id  dto：com.kohler.iot.base.general.entities.CodeValue，field  字段命名
    function getRoleLocaleInfo(code, dto, field) {
      //console.log("service  code:" + angular.toJson(code));
      var data = {};
      // lookup code use com.kohler.iot.base.general.entities.Code, looup value use com.kohler.iot.base.general.entities.CodeValue
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      //console.log("data params:"+angular.toJson(data));
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response));
        if (response.status == "200") {

          return response.data.multiLanguages;
        }
      })
    }

    function deleteRole(role) {
      var resourceUrl = "/api/role/deleteRole";
      //console.log("delete code:"+angular.toJson(code));
      return $http.post(resourceUrl, role, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }
  }

})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditRoleController', EditRoleController);

  EditRoleController.$inject = ['$filter','RoleService', 'MessageTemplateService', '$uibModalInstance', 'entity','toastr','Hmapfe', 'PromptService'];

  function EditRoleController($filter,RoleService, MessageTemplateService, $uibModalInstance, entity,toastr,Hmapfe, PromptService) {
    var vm = this;
    vm.role = entity;
    vm.ordinaryRole='';
    vm.clear = clear;
    vm.update = update;
    vm.loadRole=loadRole;
    vm.changRole=changRole;
    vm.initWeidget = initWeidget;
    vm.roleNameLocaleSure = roleNameLocaleSure;
    vm.showRoleNameLocale = showRoleNameLocale;
    vm.roleDecLocaleSure = roleDecLocaleSure;
    vm.showRoleDecLocale = showRoleDecLocale;

    vm.loadRole(entity.roleId);
    vm.roleTypes = [];

    vm.initWeidget();

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
      });
    }
    initLangs();

    function loadRole(roleId) {
      Hmapfe.log('edit role');
      Hmapfe.log(vm.role);
      RoleService.findRole(roleId)
        .then(function (data) {
          vm.role = data.rows[0];
          vm.ordinaryRole = data.rows[1];

          RoleService.getRoleLocaleInfo(roleId, 'com.iot.portal.admin.ctm.entities.SysRoleDto', $("#roleNameLocaleBtn").val())
            .then(function (data) {
              //deal with the multilanguage field value
              var __tls = {};
              var roleName = {};
              for (var i in data) {
                roleName[data[i].langCode] = data[i].value;
              }
              __tls[$("#roleNameLocaleBtn").val()] = roleName;
              RoleService.getRoleLocaleInfo(roleId, 'com.iot.portal.admin.ctm.entities.SysRoleDto', $("#roleDecLocaleBtn").val())
                .then(function (data) {
                  //deal with the multilanguage field value
                   var roleDec = {};
                   for (var i in data) {
                     roleDec[data[i].langCode] = data[i].value;
                   }
                   __tls[$("#roleDecLocaleBtn").val()] = roleDec;
                   vm.role.__tls = __tls;
                   $("#roleNameLocaleBtn").attr("disabled", false);
                   $("#roleDecLocaleBtn").attr("disabled", false);
                })
            })
        })
    }

    function changRole(roleId) {
      // console.log('999999')
      // console.log(vm.ordinaryRole);
        RoleService.addOrUpdate(roleId)
          .then(function (data) {
            if(vm.ordinaryRole==true){
              swal('您已修改为普通角色');
            }else{
              swal('您已修改为非普通角色');
            }
          })
    }

    function update() {
      RoleService.updateRoles().save(vm.role,onSuccess,onError);
    };
    function onSuccess(data, headers) {
      if(data.code=='repeat'){
        toastr.warning($filter('T')("roleManage.roleCodeRepeat"), $filter('T')("plugin.warnMessage"));
        return;
      }
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $uibModalInstance.close(data);
    }
    function onError(error) {
      //console.log('error');
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function initWeidget() {
      // state
      MessageTemplateService.getByCode().query({code:'SYS.ROLE_TYPE'},function (data) {
        vm.roleTypes = data.rows;
      },function (error) {
      });
    }

    function showRoleNameLocale() {
      // According to langs to make inputs.
      $("#roleNameLocaleModal").modal("show");
      if($.trim($("#roleNameLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='rn_" + langs[i].langCode
            + "' ng-model='vm.role.__tls." + $("#roleNameLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#roleNameLocaleModelBody").append(div);
          // init field value
          $("input[name='rn_" + langs[i].langCode + "']").val(vm.role.__tls[$("#roleNameLocaleBtn").val()][langs[i].langCode]);
        }
      }

    }

    function roleNameLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.role.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='rn_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.role[$("#roleNameLocaleBtn").val()] = $("input[name='rn_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#roleNameLocaleModal").modal("hide");
      __tls[$("#roleNameLocaleBtn").val()] = description;
      vm.role.__tls = __tls;
    }

    function showRoleDecLocale() {
      // According to langs to make inputs.
      $("#roleDecLocaleModal").modal("show");
      if($.trim($("#roleDecLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='rd_" + langs[i].langCode
            + "' ng-model='vm.role.__tls." + $("#roleDecLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#roleDecLocaleModelBody").append(div);
          // init field value
          $("input[name='rd_" + langs[i].langCode + "']").val(vm.role.__tls[$("#roleDecLocaleBtn").val()][langs[i].langCode]);
        }
      }

    }

    function roleDecLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.role.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='rd_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.role[$("#roleDecLocaleBtn").val()] = $("input[name='rd_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#roleDecLocaleModal").modal("hide");
      __tls[$("#roleDecLocaleBtn").val()] = description;
      vm.role.__tls = __tls;
    }
  }


})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddRoleController', AddRoleController);

  AddRoleController.$inject = ['$filter','RoleService', '$uibModalInstance', 'toastr', 'PromptService', 'toastrConfig', 'MessageTemplateService'];

  function AddRoleController($filter,RoleService, $uibModalInstance, toastr, PromptService, toastrConfig, MessageTemplateService) {
    var vm = this;
    vm.role = {};
    vm.clear = clear;
    vm.add = add;
    vm.initWeidget = initWeidget;
    vm.roleNameLocaleSure = roleNameLocaleSure;
    vm.showRoleNameLocale = showRoleNameLocale;
    vm.roleDecLocaleSure = roleDecLocaleSure;
    vm.showRoleDecLocale = showRoleDecLocale;

    vm.roleTypes = [];

    vm.initWeidget();

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#roleNameLocaleBtn").attr("disabled", false);
        $("#roleDecLocaleBtn").attr("disabled", false);
      });
    }
    initLangs();

    function add() {
      RoleService.addRole().save(vm.role,onSuccess,onError);
    };

    function initWeidget() {
      // state
      MessageTemplateService.getByCode().query({code:'SYS.ROLE_TYPE'},function (data) {
        vm.roleTypes = data.rows;
      },function (error) {
      });
    }

    function onSuccess(data, headers) {
      if(data.code=='repeat'){
        toastr.warning($filter('T')("roleManage.roleCodeRepeat"), $filter('T')("plugin.warnMessage"));
        return;
      }
      toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
      $uibModalInstance.close(data);
    }
    function onError(error) {
      //console.log('error');
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showRoleNameLocale() {
      // According to langs to make inputs.
      $("#roleNameLocaleModal").modal("show");
      if($.trim($("#roleNameLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='rn_" + langs[i].langCode
            + "' ng-model='vm.role.__tls." + $("#roleNameLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#roleNameLocaleModelBody").append(div);
        }
      }

    }

    function roleNameLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.role.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='rn_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.role[$("#roleNameLocaleBtn").val()] = $("input[name='rn_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#roleNameLocaleModal").modal("hide");
      __tls[$("#roleNameLocaleBtn").val()] = description;
      vm.role.__tls = __tls;
    }

    function showRoleDecLocale() {
      // According to langs to make inputs.
      $("#roleDecLocaleModal").modal("show");
      if($.trim($("#roleDecLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='rd_" + langs[i].langCode
            + "' ng-model='vm.role.__tls." + $("#roleDecLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#roleDecLocaleModelBody").append(div);
        }
      }

    }

    function roleDecLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.role.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='rd_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.role[$("#roleDecLocaleBtn").val()] = $("input[name='rd_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#roleDecLocaleModal").modal("hide");
      __tls[$("#roleDecLocaleBtn").val()] = description;
      vm.role.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }


})();

/**
 * Created by shi.yin on 2017/6/12.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('RoleGrantManagerController', RoleGrantManagerController);

  RoleGrantManagerController.$inject = ['FirmwareUpdateService','$filter','RoleClientService','entity', 'Authority', 'paginationConstants','cfpLoadingBar', '$state', '$log', 'PartyService', 'SweetAlert'];

  function RoleGrantManagerController(FirmwareUpdateService,$filter, RoleClientService, entity,Authority, paginationConstants, cfpLoadingBar, $state, $log, PartyService, SweetAlert) {
    var vm = this;
    vm.role = entity;
    vm.applicationClientList = entity;
    vm.addError = false;
    vm.errorMsg = "";
    vm.page = 1;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.initWeidget = initWeidget;
    vm.loadAllClient = loadAllClient;
    vm.deleteClientById = deleteClientById;
    vm.loadAllClient();
    vm.initWeidget();

    function initWeidget() {
      // state
      /*PartyService.getLookUp(['SYS.ROLE_TYPE'])
        .then(function (data) {
          vm.roleTypes = data[0];
        })*/

      FirmwareUpdateService.getByCode().query({code:'SYS.APPLICATION_CLIENT_TYPE'},function (data) {
        vm.appAuzModeList=data.rows;
      },function (error) {
      });
    }

    vm.applicationClientList = [
      {'name':$filter('T')("appAuth.authorizationCode"), 'value':'authorization_code'},
      {'name':$filter('T')("appAuth.implicit"), 'value':'implicit'},
      {'name':$filter('T')("appAuth.clientCredentials"), 'value':'client_credentials'},
      {'name':$filter('T')("appAuth.password"), 'value':'password'}
    ];

    function loadAllClient() {
      RoleClientService.loadAllClient2().query({roleId: vm.role.roleId,appName:vm.role.appName,appAuzMode:vm.role.appAuzMode}, function (data) {
      /*RoleClientService.loadAllClient(vm.role.roleId) .then(function (data) {
        vm.role.clientList = data.rows;
      });*/
      vm.role.clientList = data.rows;
      });
    }

    function onRoleSuccess(data, headers) {
      vm.roles = data.rows;
      vm.totalItems =  data.total;
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      ////console.log('Page changed to: ' + vm.page);
      loadAllRole();
    };




    function onError(error) {
      // console.log(error);
      if (error.data && false == error.data.success) {
        clearTree();
        vm.errorMsg = error.data.message;
        vm.addError = true;
      }
    }

    function deleteClientById(grantAuthClientId){
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          var temp = {};
          temp.id = grantAuthClientId;
          return RoleClientService.deleteClientById(temp)
            .then(function (data) {
              var flag = data.success;
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
                return $state.go('roleGrantClient', null, {reload: true});
              }
            })
        }
      });
    }


  }


})();

/**
 * Created by shi.yin on 2017/6/12.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('RoleClientManagerController', RoleClientManagerController);

  RoleClientManagerController.$inject = ['$filter','RoleClientService', 'Authority', 'paginationConstants','cfpLoadingBar', '$state', '$log', 'PartyService', 'SweetAlert'];

  function RoleClientManagerController($filter, RoleClientService, Authority, paginationConstants, cfpLoadingBar, $state, $log, PartyService, SweetAlert) {
    var vm = this;
    vm.addError = false;
    vm.errorMsg = "";
    vm.page = 1;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.initWeidget = initWeidget;
    vm.ignoreChanges = true;
    vm.role = {};
    vm.jsTreeData = [];
    vm.menuData = [];
    vm.treeConfig = {};
    vm.treeInstance = {};
    vm.checkedNodes = [];
    vm.menuItems = [];
    vm.currentRole = {};
    vm.roles = [];
    vm.roleFunctions=[];
    vm.roleTypes = [];
    vm.selectRole = selectRole;
    vm.loadAllRole = loadAllRole;
    vm.queryRole = queryRole;
    vm.saveAuthority=saveAuthority;
    vm.applyModelChanges=applyModelChanges;
    vm.deleteRole = deleteRole;
    // vm.loadAllAuthority();
    vm.loadAllRole();
    vm.initWeidget();

    function initWeidget() {
      // state
      PartyService.getLookUp(['SYS.ROLE_TYPE'])
        .then(function (data) {
          vm.roleTypes = data[0];
        })


    }

    function loadAllRole() {
      RoleClientService.findRoles(vm.page,paginationConstants.itemsPerPage).query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onRoleSuccess, onError);
    }

    function onRoleSuccess(data, headers) {
      vm.roles = data.rows;
      vm.totalItems =  data.total;
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      ////console.log('Page changed to: ' + vm.page);
      loadAllRole();
    };

    function queryRole() {
      if (vm.role.roleCode != null && $.trim(vm.role.roleCode) == '') {
        vm.role.roleCode = null;
      }
      if (vm.role.roleName != null && $.trim(vm.role.roleName) == '') {
        vm.role.roleName = null;
      }
      if (vm.role.roleDescription != null && $.trim(vm.role.roleDescription) == '') {
        vm.role.roleDescription = null;
      }
      RoleClientService.findRoles().query(vm.role, onRoleSuccess, onError);
    }


    function onSuccess(data, headers) {
      vm.addError = false;
      complete();
      vm.menuItems = data.rows;
      vm.generateTreeData();
      vm.jsTreeData=[];
      angular.copy(vm.menuData, vm.jsTreeData);
      vm.treeConfig.version++;
      /*$log.info('vm.jsTreeData');
      $log.info(vm.jsTreeData);
      $log.info('vm.jsTreeDataend');*/
      vm.totalItems = data.total;
    }
    function onRoleFunctionSuccess(data){
      // $log.info(data);
    }

    function onError(error) {
      // console.log(error);
      if (error.data && false == error.data.success) {
        vm.errorMsg = error.data.message;
        vm.addError = true;
      }
    }



    function complete() {
      cfpLoadingBar.complete();
    }

    function selectRole(role) {
      start();
      vm.currentRole = role.roleId;
      loadAllAuthority(role);
    }

    function saveAuthority(){
      vm.roleFunctions=[];

      var selected_nodes = vm.treeInstance.jstree(true).get_selected();
      // $log.info(selected_nodes);
      angular.forEach(selected_nodes, function (node) {
        var roleFunction={
          roleId: vm.currentRole,
          functionId:node
        };
        vm.roleFunctions.push(roleFunction);
      });
      // $log.info(vm.roleFunctions);
      Authority.save().save(vm.roleFunctions,onRoleFunctionSuccess,onError);
    }
    function applyModelChanges(){
      // $log.info("applyModelChanges");
      return vm.ignoreChanges;
    }
    function deleteRole(role){
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          return RoleClientService.deleteRole(role)
            .then(function (data) {
              var flag = data.success;
              var code = data.code;
              if(code=='notDeleteClientEnough'){
                SweetAlert.info($filter('T')("title.notBindMust"),{title: $filter('T')("title.infoTitle")});
                return ;
              }else if(code=='notDeleteInterfaceEnough'){
                SweetAlert.info($filter('T')("title.notBindInterfaceMust"),{title: $filter('T')("title.infoTitle")});
                return ;
              }
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
                return $state.go('roleClient', null, {reload: true});
              }
            })
        }
      });
    }


  }


})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('roleClient', {
        parent: 'app',
        url: "/roleClient",
        views: {
          'body': {
            templateUrl: "app/roleClientManager/roleClientManage.html",
            controller: 'RoleClientManagerController',
            controllerAs: 'vm'
          }
        }
      })
      .state('roleClient.add', {
        parent: 'roleClient',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/roleClientManager/addRoleClient.html',
            controller: 'AddRoleClientController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg'
          }).result.then(function () {
              //console.log("role go1");
              $state.go('roleClient', null, {reload: true});
            }, function () {
              //console.log("role go2");
              $state.go('roleClient');
            });
        }]
      })
    .state('roleClient.edit', {
        parent: 'roleClient',
        url: "/edit/:roleId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          ////console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/roleClientManager/editRoleClient.html',
            controller: 'EditRoleClientController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                //console.log("entity:"+angular.toJson($stateParams.roleId));
                return {
                  roleId:$stateParams.roleId
                };
              }
            }
          }).result.then(function () {
              //console.log("role go1");
              $state.go('roleClient', null, {reload: true});
            }, function () {
              //console.log("role go2");
              $state.go('roleClient', null, {reload: true});
              // $state.go('role');
            });
        }]
      })
      .state('roleGrantClient', {
        parent: 'app',
        url: "/roleGrantClient/:roleId",
        views: {
          'body': {
            templateUrl: "app/roleClientManager/roleGrantManage.html",
            controller: 'RoleGrantManagerController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              //console.log("0000="+$stateParams.codeId);
              return {
                roleId:$stateParams.roleId
              };
            }
          ]
        }
      })
      .state('roleGrantClient.addClient', {
        parent: 'roleGrantClient',
        url: "/addClient",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/roleClientManager/addClient-dialog.html',
            controller: 'AddClientDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  roleId: $stateParams.roleId
                };
              }
            }
          }).result.then(function () {
            $state.go('roleGrantClient', null, {reload: true});
          }, function () {
            //console.log("function.detail go2");
          });
        }]
      })
  };
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('RoleClientService', RoleClientService);

  RoleClientService.$inject = ['$resource','$http'];

  function RoleClientService($resource,$http) {
    var service = {
      findRoles: findRoles,
      findRole:findRole,
      updateRoles: updateRoles,
      addRole: addRole,
      getRoleLocaleInfo: getRoleLocaleInfo,
      deleteRole: deleteRole,
      loadAllClient:loadAllClient,
      loadAllClient2:loadAllClient2,
      selectAllCanChooseClient:selectAllCanChooseClient,
      createClient:createClient,
      deleteClientById:deleteClientById
    };
    return service;

    function selectAllCanChooseClient(){
      var resourceUrl ='/api/clientRole/selectAllCanChooseClient';
      return $resource(resourceUrl, {}, {
        'query': { method: 'GET',isArray:false},
        'get': {
          method: 'GET',
          transformResponse: function (data) {
            /*if (data) {
              data = angular.fromJson(data);
            }*/
            return data;
          }
        }
      });
    }

    function findRoles(page,pagesize) {
      if(page==undefined){
        page = 1;
      }
      if(pagesize == undefined){
        pagesize = 10;
      }
      var resourceUrl = '/api/clientRole/queryAll?page='+page+"&pagesize="+pagesize;
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function createClient(){
      var resourceUrl ='/api/clientRole/createClient';
      return $resource(resourceUrl, {}, {
        'saveOrUpdate': {method: 'POST'}
      });
    }




    function loadAllClient(roleId) {
      var resourceUrl = '/api/clientRole/selectAllClientByRoleId?roleId='+roleId;
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function loadAllClient2() {
      var resourceUrl = '/api/clientRole/selectAllClientByRoleId';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }



    function findRole(roleId) {
      var resourceUrl = '/api/clientRole/getRole?roleId='+roleId;
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function updateRoles() {
      var resourceUrl = '/api/clientRole/editRole';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function addRole() {
      var resourceUrl = '/api/clientRole/insertSelective';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function getUserRole(){

    }

    //code :B 主表主键id  dto：com.kohler.iot.base.general.entities.CodeValue，field  字段命名
    function getRoleLocaleInfo(code, dto, field) {
      //console.log("service  code:" + angular.toJson(code));
      var data = {};
      // lookup code use com.kohler.iot.base.general.entities.Code, looup value use com.kohler.iot.base.general.entities.CodeValue
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      //console.log("data params:"+angular.toJson(data));
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response));
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }

    function deleteRole(role) {
      var resourceUrl = "/api/clientRole/deleteRole";
      //console.log("delete code:"+angular.toJson(code));
      return $http.post(resourceUrl, role, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

    function deleteClientById(role) {
      var resourceUrl = "/api/clientRole/deleteClientById";
      //console.log("delete code:"+angular.toJson(code));
      return $http.post(resourceUrl, role, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }
  }

})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditRoleClientController', EditRoleClientController);

  EditRoleClientController.$inject = ['toastrConfig','$filter','RoleClientService', '$scope', '$state', '$uibModalInstance', 'entity','toastr','Hmapfe', 'MessageTemplateService', 'PromptService'];

  function EditRoleClientController(toastrConfig,$filter,RoleClientService, $scope, $state, $uibModalInstance, entity,toastr,Hmapfe, MessageTemplateService, PromptService) {
    var vm = this;
    vm.role = entity;
    vm.ordinaryRole='';
    vm.clear = clear;
    vm.update = update;
    vm.loadRole=loadRole;
    vm.changRole=changRole;
    vm.initWeidget = initWeidget;
    vm.roleNameLocaleSure = roleNameLocaleSure;
    vm.showRoleNameLocale = showRoleNameLocale;
    vm.roleDecLocaleSure = roleDecLocaleSure;
    vm.showRoleDecLocale = showRoleDecLocale;

    vm.loadRole(entity.roleId);
    vm.roleTypes = [];

    vm.initWeidget();

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
      });
    }
    initLangs();

    function loadRole(roleId) {
      Hmapfe.log('edit role');
      Hmapfe.log(vm.role);
      RoleClientService.findRole(roleId)
        .then(function (data) {
          vm.role = data.rows[0];
          vm.ordinaryRole = data.rows[1];

          RoleClientService.getRoleLocaleInfo(roleId, 'com.iot.portal.admin.hms.appcenter.entities.ClientRole', $("#roleNameLocaleBtn").val())
            .then(function (data) {
              //deal with the multilanguage field value
              var __tls = {};
              var roleName = {};
              for (var i in data) {
                roleName[data[i].langCode] = data[i].value;
              }
              __tls[$("#roleNameLocaleBtn").val()] = roleName;
              RoleClientService.getRoleLocaleInfo(roleId, 'com.iot.portal.admin.hms.appcenter.entities.ClientRole', $("#roleDecLocaleBtn").val())
                .then(function (data) {
                  //deal with the multilanguage field value
                   var roleDec = {};
                   for (var i in data) {
                     roleDec[data[i].langCode] = data[i].value;
                   }
                   __tls[$("#roleDecLocaleBtn").val()] = roleDec;
                   vm.role.__tls = __tls;
                   $("#roleNameLocaleBtn").attr("disabled", false);
                   $("#roleDecLocaleBtn").attr("disabled", false);
                })
            })
        })
    }

    function changRole(roleId) {
      // console.log('999999')
      // console.log(vm.ordinaryRole);
      RoleClientService.addOrUpdate(roleId)
          .then(function (data) {
            if(vm.ordinaryRole==true){
              swal('您已修改为普通角色');
            }else{
              swal('您已修改为非普通角色');
            }
          })
    }

    function update() {
      RoleClientService.updateRoles().save(vm.role,onSuccess,onError);
    };
    function onSuccess(data, headers) {
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
      $uibModalInstance.close(data);
    }
    function onError(error) {
      //console.log('error');
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function initWeidget() {
      // state
      MessageTemplateService.getByCode().query({code:'SYS.ROLE_CLIENT_TYPE'},function (data) {
        vm.roleTypes = data.rows;
      },function (error) {
      });
    }

    function showRoleNameLocale() {
      // According to langs to make inputs.
      $("#roleNameLocaleModal").modal("show");
      if($.trim($("#roleNameLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='rn_" + langs[i].langCode
            + "' ng-model='vm.role.__tls." + $("#roleNameLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#roleNameLocaleModelBody").append(div);
          // init field value
          $("input[name='rn_" + langs[i].langCode + "']").val(vm.role.__tls[$("#roleNameLocaleBtn").val()][langs[i].langCode]);
        }
      }

    }

    function roleNameLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.role.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='rn_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.role[$("#roleNameLocaleBtn").val()] = $("input[name='rn_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#roleNameLocaleModal").modal("hide");
      __tls[$("#roleNameLocaleBtn").val()] = description;
      vm.role.__tls = __tls;
    }

    function showRoleDecLocale() {
      // According to langs to make inputs.
      $("#roleDecLocaleModal").modal("show");
      if($.trim($("#roleDecLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='rd_" + langs[i].langCode
            + "' ng-model='vm.role.__tls." + $("#roleDecLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#roleDecLocaleModelBody").append(div);
          // init field value
          $("input[name='rd_" + langs[i].langCode + "']").val(vm.role.__tls[$("#roleDecLocaleBtn").val()][langs[i].langCode]);
        }
      }

    }

    function roleDecLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.role.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='rd_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.role[$("#roleDecLocaleBtn").val()] = $("input[name='rd_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#roleDecLocaleModal").modal("hide");
      __tls[$("#roleDecLocaleBtn").val()] = description;
      vm.role.__tls = __tls;
    }
  }


})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddRoleClientController', AddRoleClientController);

  AddRoleClientController.$inject = ['toastrConfig','$filter','RoleClientService', '$scope', '$state', '$uibModalInstance','toastr', 'MessageTemplateService', 'PromptService'];

  function AddRoleClientController(toastrConfig,$filter,RoleClientService, $scope, $state, $uibModalInstance,toastr, MessageTemplateService, PromptService) {
    var vm = this;
    vm.role = {};
    vm.clear = clear;
    vm.add = add;
    vm.initWeidget = initWeidget;
    vm.roleNameLocaleSure = roleNameLocaleSure;
    vm.showRoleNameLocale = showRoleNameLocale;
    vm.roleDecLocaleSure = roleDecLocaleSure;
    vm.showRoleDecLocale = showRoleDecLocale;

    vm.roleTypes = [];

    vm.initWeidget();
    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#roleNameLocaleBtn").attr("disabled", false);
        $("#roleDecLocaleBtn").attr("disabled", false);
      });
    }
    initLangs();

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    function add() {
      RoleClientService.addRole().save(vm.role,onSuccess,onError);
    };

    function initWeidget() {
      // state
      MessageTemplateService.getByCode().query({code:'SYS.ROLE_CLIENT_TYPE'},function (data) {
        vm.roleTypes = data.rows;
      },function (error) {
      });
    }

    function onSuccess(data, headers) {
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
      $uibModalInstance.close(data);
    }
    function onError(error) {
      //console.log('error');
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showRoleNameLocale() {
      // According to langs to make inputs.
      $("#roleNameLocaleModal").modal("show");
      if($.trim($("#roleNameLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='rn_" + langs[i].langCode
            + "' ng-model='vm.role.__tls." + $("#roleNameLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#roleNameLocaleModelBody").append(div);
        }
      }

    }

    function showRoleDecLocale() {
      // According to langs to make inputs.
      $("#roleDecLocaleModal").modal("show");
      if($.trim($("#roleDecLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='rd_" + langs[i].langCode
            + "' ng-model='vm.role.__tls." + $("#roleDecLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#roleDecLocaleModelBody").append(div);
        }
      }
    }

    function roleNameLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.role.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='rn_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.role[$("#roleNameLocaleBtn").val()] = $("input[name='rn_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#roleNameLocaleModal").modal("hide");
      __tls[$("#roleNameLocaleBtn").val()] = description;
      vm.role.__tls = __tls;
    }


    function roleDecLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.role.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='rd_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.role[$("#roleDecLocaleBtn").val()] = $("input[name='rd_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#roleDecLocaleModal").modal("hide");
      __tls[$("#roleDecLocaleBtn").val()] = description;
      vm.role.__tls = __tls;
    }
  }


})();

/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AddClientDialogController', AddClientDialogController);

  AddClientDialogController.$inject = ['$filter','SweetAlert','RoleClientService', 'paginationConstants', 'entity', '$uibModalInstance','$state','toastr','MessageTemplateService'];

  function AddClientDialogController($filter,SweetAlert,RoleClientService, paginationConstants, entity, $uibModalInstance,$state,toastr,MessageTemplateService) {
    var vm = this;
    vm.function = entity;
    vm.function.resources=[];
    vm.condition = {};
    vm.page = 1;
    vm.search=search;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;
    vm.isAllSelected = false;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.toggleAll = toggleAll;
    vm.clear = clear;
    vm.save = save;
    vm.initWeidget = initWeidget;

    vm.enabled = false;

    vm.loadAll();

    function loadAll() {
      RoleClientService.selectAllCanChooseClient().query({
        roleId: vm.function.roleId,
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
      initWeidget();
    }

    function search(){
      RoleClientService.selectAllCanChooseClient().query({
        roleId: vm.function.roleId,
        page: vm.page,
        appName:vm.function.appName,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.resources = data.rows;
      vm.totalItems = data.total;
    }
    function onAddResourceSuccess(data) {
      toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
      $uibModalInstance.close(data);
    }

    function onError(error) {
      //console.log('error');

    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadAll();
    };
    function clear() {
      $uibModalInstance.dismiss('cancel');
      $state.go("roleGrantClient");
    }

    function save() {
      vm.function.resources = [];
      angular.forEach(vm.resources, function (res) {
        if (res.addFlag === 'Y') {
          res.__status = 'add';
          vm.function.resources.push(res);
        }
      });
      if(vm.function.resources.length==0){
        SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
        return ;
      }
      vm.enabled = true;
      RoleClientService.createClient().saveOrUpdate(vm.function, onAddResourceSuccess, onError);

    }

    function toggleAll() {

      var toggleStatus = !vm.isAllSelected;
      var resourceStatus = 'N';
      if (toggleStatus) {
        resourceStatus = 'N';
      }
      else {
        resourceStatus = 'Y';
      }
      angular.forEach(vm.resources, function (res) {
        res.addFlag = resourceStatus;
      });
    }

    function initWeidget() {
      MessageTemplateService.getByCode().query({code:'SYS.APPLICATION_CLIENT_TYPE'},function (data) {
        vm.appAddAuzModeList=data.rows;
      },function (error) {
      });
    }
  }
})();

/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('resource', {
        parent: 'app',
        url: "/resource",
        views: {
          'body': {
            templateUrl: "app/resource/resource.html",
            controller: 'ResourceController',
            controllerAs: 'vm'
          }
        }
      })
      .state('resource.detail', {
        parent: 'app',
        url: "/resource/:id",
        views: {
          'body': {
            templateUrl: "app/resource/resource-detail.html",
            controller: 'ResourceDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              resourceId: $stateParams.id
            };
          }
        }
      }).state('resource.new', {
        parent: 'app',
        url: "/new/resource",
        views: {
          'body': {
            templateUrl: "app/resource/resource-detail.html",
            controller: 'ResourceDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              resourceId: null,
              name:null,
              url:null,
              type:null,
              description:null
            };
          }
        }
      })
      .state('resource.addPermission', {
        parent: 'resource.detail',
        url: "/addPermission",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/permission/html/resourcePermission-dialog.html',
            controller: 'ResPermDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  resourceId: $stateParams.id
                };
              }
            }
          }).result.then(function () {
            $state.go('resource.detail', null, {reload: 'resource.detail'});
          }, function () {
            $state.go('resource.detail', null, {reload: 'resource.detail'});
          });
        }]
      })
      .state('resource.viewPermission', {
        parent: 'resource.detail',
        url: "/viewPermission/:permissionId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/iot/portal/admin/permission/html/permission-dialog.html',
            controller: 'PermDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  resourceId: $stateParams.id,
                  id: $stateParams.permissionId,
                  viewFlag: true,
                  editFlag: true
                };
              }
            }
          }).result.then(function () {
            $state.go('resource.detail');
          }, function () {
            $state.go('resource.detail');
          });
        }]
      })
  }

})();

/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('Resource', Resource);

  Resource.$inject = ['$resource', '$http'];

  function Resource ($resource, $http) {
    var service={
      query:query,
      save:save,
      remove:remove,
      getResourceLocaleInfo: getResourceLocaleInfo
    };
    return service;

    function query(){
      var resourceUrl ='/api/resource/query';
      return $resource(resourceUrl, {}, {
        'query': { method: 'GET',isArray:false},
        'get': {
          method: 'GET'
        },
        'update': {method: 'PUT'}
      });
    }

    function save(){
      var resourceUrl ='/api/resource/save';
      return $resource(resourceUrl, {}, {
        'saveOrUpdate': {method: 'POST'}
      });
    }

    function remove(){
      var resourceUrl ='/api/resource/remove';
      return $resource(resourceUrl, {}, {
        'remove': {method: 'POST'}
      });
    }

    function getResourceLocaleInfo(code, dto, field) {
      var data = {};
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }

  }
})();

/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ResourceController', ResourceController);

  ResourceController.$inject = ['Resource','paginationConstants','$timeout', '$localStorage'];

  function ResourceController(Resource,paginationConstants,$timeout, $localStorage) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = 0;
    vm.loadAll = loadAll;
    vm.loadByName=loadByName;
    vm.transition = transition;
    vm.condition={};
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.loadAll();


    function loadAll () {
      vm.condition.page = vm.page;
      vm.condition.pagesize = paginationConstants.itemsPerPage;
      Resource.query().query(vm.condition, onSuccess, onError);
    }

    function loadByName(){
      loadAll();
    }

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.resources = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');

    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll();
    }
  }
})();

/**
 * Created by zhouzy on 2016/8/29 0029.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ResourceDetailController', ResourceDetailController);

  ResourceDetailController.$inject = ['$state', '$stateParams', 'Resource', 'PermService', 'ResPermService', 'entity', 'paginationConstants', '$q', '$timeout', '$scope', 'toastr', 'toastrConfig', 'PromptService', '$filter', 'SweetAlert'];

  function ResourceDetailController($state, $stateParams, Resource, PermService, ResPermService, entity, paginationConstants, $q, $timeout, $scope, toastr, toastrConfig, PromptService, $filter, SweetAlert) {
    var vm = this;
    vm.saveOrUpdate = saveOrUpdate;
    vm.remove = remove;
    vm.showNameLocale = showNameLocale;
    vm.nameLocaleSure = nameLocaleSure;
    vm.showDecLocale = showDecLocale;
    vm.decLocaleSure = decLocaleSure;
    vm.reBack = reBack;
    vm.loadPermission = loadPermission;
    vm.isNotDelete = isNotDelete;
    vm.viewPermission = viewPermission;
    vm.savePermission = savePermission;
    vm.deletePermission = deletePermission;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.toggleAll = toggleAll;
    vm.load = load;
    vm.resource = entity;
    vm.isAllSelected = false;
    vm.confirmDelete = false;
    vm.editOrCreate='create';
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = 0;

    vm.levelList = [
      {value: 'owner', meaning: $filter('T')('permission.ownerLevel')},
      {value: 'contributor', meaning: $filter('T')('permission.contributorLevel')},
      {value: 'reader', meaning: $filter('T')('permission.readerLevel')}
    ];

    vm.load();

    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        if (!vm.resource.resourceId) {
          $("#nameLocaleBtn").attr("disabled", false);
          $("#decLocaleBtn").attr("disabled", false);
        }
      });
    }
    initLangs();

    function load() {
      if (vm.resource.resourceId) {
        vm.editOrCreate='Edit';
        Resource.query().get(vm.resource,
          function (result) {
            vm.resource = result.rows[0];
            vm.loadPermission();
            Resource.getResourceLocaleInfo(vm.resource.resourceId, 'com.kohler.iot.base.function.entities.Resource', $("#nameLocaleBtn").val())
              .then(function (data) {
                //deal with the multilanguage field value
                var __tls = {};
                var name = {};
                for (var i in data) {
                  name[data[i].langCode] = data[i].value;
                }
                __tls[$("#nameLocaleBtn").val()] = name;
                Resource.getResourceLocaleInfo(vm.resource.resourceId, 'com.kohler.iot.base.function.entities.Resource', $("#decLocaleBtn").val())
                  .then(function (data) {
                    //deal with the multilanguage field value
                    var dec = {};
                    for (var i in data) {
                      dec[data[i].langCode] = data[i].value;
                    }
                    __tls[$("#decLocaleBtn").val()] = dec;
                    vm.resource.__tls = __tls;
                    $("#nameLocaleBtn").attr("disabled", false);
                    $("#decLocaleBtn").attr("disabled", false);
                  })
              })
          },
          function (error) {
          }
        );
      }
    }

    function loadPermission() {
      var requestBody = {resourceId: vm.resource.resourceId};
      PermService.queryPermission(requestBody, vm.page).then(function (response) {
        if (response.success) {
          vm.permissions = response.rows;
          vm.totalItems = response.total;
          vm.pageSize = response.rows.length;
        }
      })
    }

    function isNotDelete(permission) {
      return permission.__status !== "delete";
    }

    function viewPermission(entity) {
      if (entity.isDelete === 'Y') {
        SweetAlert.error($translate.instant("permission.deletedNotView"), {title: $filter('T')("btnTypeName.prompt")});
      } else {
        $state.go('resource.viewPermission', {permissionId: entity.id, id: vm.resource.resourceId});
      }
    }

    function saveOrUpdate() {
      // console.log(vm.resource);
      Resource.save().saveOrUpdate(vm.resource, onSuccess, onError);
    }

    function remove() {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          // console.log(vm.resource);
          Resource.remove().remove([{resourceId:vm.resource.resourceId}], function () {
            toastr.success($filter('T')("title.deleteSuccess"), $filter('T')("title.infoTitle"));
            $state.go('resource');
          }, function () {
            toastr.error($filter('T')('title.deleteFail'));
          });
        }
      });
    }

    function onSuccess(data, headers) {
      if (data.success) {
        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.infoTitle"));
        $state.go('resource');
      } else {
        onError();
      }
    }

    function onError(error) {
      toastr.error($filter('T')('title.saveFail'));
    }

    function savePermission() {
      var deletePermissionIds = [];
      angular.forEach(vm.permissions, function (item) {
        if (item.__status === 'delete') {
          deletePermissionIds.push(item.id);
        }
      });
      var requestBody = {
        resourceId: vm.resource.resourceId,
        deletePermissionIds: deletePermissionIds
      };
      ResPermService.updateResourcePermission(requestBody).then(function (data) {
        if (data.success) {
          toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.infoTitle"));
          loadPermission();
        } else {
          onError();
        }
      }, onError);
    }

    function deletePermission() {
      angular.forEach(vm.permissions, function (item) {
        if (item.deleteFlag === "Y") {
          item.__status = "delete";
        }
      });
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      vm.loadPermission();
    }

    function toggleAll() {
      var toggleStatus = !vm.isAllSelected;
      var resourceStatus = 'N';
      if (toggleStatus) {
        resourceStatus = 'N';
      }
      else {
        resourceStatus = 'Y';
      }
      angular.forEach(vm.permissions, function (res) {
        res.deleteFlag = resourceStatus;
      });
    }

    function reBack() {
      $state.go("resource");
    }

    function showNameLocale() {
      // According to langs to make inputs.
      $("#nameLocaleModal").modal("show");
      if ($.trim($("#nameLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='n_" + langs[i].langCode
            + "' ng-model='vm.resource.__tls." + $("#nameLocaleModal").val() + '.' + langs[i].langCode + "'/>");
          $("#nameLocaleModelBody").append(div);
          if (vm.resource.resourceId) {
            $("input[name='n_" + langs[i].langCode + "']").val(vm.resource.__tls[$("#nameLocaleBtn").val()][langs[i].langCode]);
          }
        }
      }

    }

    function nameLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.resource.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='n_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.resource[$("#nameLocaleBtn").val()] = $("input[name='n_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#nameLocaleModal").modal("hide");
      __tls[$("#nameLocaleBtn").val()] = description;
      vm.resource.__tls = __tls;
    }

    function showDecLocale() {
      // According to langs to make inputs.
      $("#decLocaleModal").modal("show");
      if ($.trim($("#decLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='d_" + langs[i].langCode
            + "' ng-model='vm.resource.__tls." + $("#decLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#decLocaleModelBody").append(div);
          if (vm.resource.resourceId) {
            $("input[name='d_" + langs[i].langCode + "']").val(vm.resource.__tls[$("#decLocaleBtn").val()][langs[i].langCode]);
          }
        }
      }

    }

    function decLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.resource.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='d_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.resource[$("#decLocaleBtn").val()] = $("input[name='d_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#decLocaleModal").modal("hide");
      __tls[$("#decLocaleBtn").val()] = description;
      vm.resource.__tls = __tls;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('remind', {
        parent: 'app',
        url: "/remind",
        views: {
          'body': {
            templateUrl: "app/remind/remind.html",
            controller: 'RemindController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {};
            }
          ]
        }
      })
      .state('remind.new', {
        parent: 'app',
        url: "/remind/new",
        views: {
          'body': {
            templateUrl: "app/remind/remind-new.html",
            controller: 'RemindNewController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                  id: null,
                  target: null,
                  sendTime: null,
                  megId: null,
                  info: null,
                  state: null
                }
              }
            }
          }
        }
      })
      .state('remind.edit', {
        parent: 'app',
        url: "/remind/:id/edit",
        views: {
          'body': {
            templateUrl: "app/remind/remind-new.html",
            controller: 'RemindEditController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  id: $stateParams.id
                };
              }
            }
          }
        }
      })
  }
})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('Remind', Remind);

  Remind.$inject = ['$http','$resource','Upload','BaseConfig','$localStorage','$sessionStorage'];

  function Remind ($http,$resource,Upload,BaseConfig,$localStorage,$sessionStorage) {
    var service = {
      remindLoadSearch: remindLoadSearch,
      remindUpdate: remindUpdate,
    };
    return service;

    function remindLoadSearch(page,pageSize) {
      return $resource("/api/remindFound?page="+page+"&pageSize="+pageSize, {}, {
        'query': {method: 'POST', isArray: false}
      });
    }
    function remindUpdate() {
      return $resource("/api/remindUpdate", {}, {
        'update': {method: 'POST'}
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('RemindController', RemindController);
  RemindController.$inject = ['$state','Remind','entity','paginationConstants','$localStorage','$sessionStorage','Upload','BaseConfig'];
  /** @ngInject */
  function RemindController($state, Remind,entity, paginationConstants,$localStorage,$sessionStorage,Upload,BaseConfig) {
    var vm = this;
    vm.remind=entity;
    vm.reminds=[];
    vm.page = 1;
    vm.file="";
    vm.totalItems = null;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadSearch=loadSearch;
    vm.update=update;
    vm.loadSearch();

    function loadSearch(){
      var page=vm.page;
      var pageSize=paginationConstants.itemsPerPage;
      Remind.remindLoadSearch(page,pageSize).query(vm.remind, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      console.log('onSuccess');
      console.log(data);
      vm.reminds = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      console.log('error');
    }
    function update(){
      Remind.remindLoadSearch().update(vm.remind, onSuccess, onError);
    }
    function pageChanged() {
      console.log('Page changed to: ' +vm.page);
      loadSearch();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('RemindNewController', RemindNewController);

  RemindNewController.$inject = ['$timeout','$scope','$state', '$stateParams','Remind','entity','uibDateParser'];

  function RemindNewController($timeout,$scope, $state, $stateParams, Remind, entity, uibDateParser) {
    var vm = this;
    vm.remind = entity;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.sendTime = sendTime;

    vm.target = [
      {id:'all',name:'all'},
      {id:'hand',name:'hand'},
      {id:'join',name:'join'},
      {id:'pic',name:'pic'},
      {id:'park',name:'park'}
    ];
    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });
    function clear() {
      $state.go('remind');
    }
    function save() {
      vm.isSaving = true;
      if (vm.remind.id !== null) {
        Remind.update(vm.remind, onSaveSuccess, onSaveError);
      } else {
        Remind.save(vm.remind, onSaveSuccess, onSaveError);
      }
    }
    function onSaveSuccess(result) {
      $scope.$emit('hmapFront:remindUpdate', result);
      vm.isSaving = true;
      $state.go('remind');
    }
    function onSaveError() {
      vm.isSaving = false;
    }
    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }
    function sendTime() {
      vm.isSendTime = true;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('RemindEditController', RemindEditController);

  RemindEditController.$inject = ['$timeout','$scope','$state', '$stateParams','Remind','entity','uibDateParser'];

  function RemindEditController($timeout,$scope, $state, $stateParams, Remind, entity, uibDateParser) {
    var vm = this;

    vm.remind = entity;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.sendTime = sendTime;
    vm.load=load;

    vm.load(vm.remind.id);

    vm.target = [
      {id:'all',name:'all'},
      {id:'hand',name:'hand'},
      {id:'join',name:'join'},
      {id:'pic',name:'pic'},
      {id:'park',name:'park'}
    ];

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $state.go('remind');
    }

    function save() {
      vm.isSaving = true;
      if (vm.remind.id !== null) {
        Remind.update(vm.remind, onSaveSuccess, onSaveError);
      } else {
        Remind.save(vm.remind, onSaveSuccess, onSaveError);
      }
    }

    function onSaveSuccess(result) {
      $scope.$emit('hmapFront:remindUpdate', result);
      vm.isSaving = true;
      $state.go('remind');
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function sendTime() {
      vm.isSendTime = true;
    }

    function load(id) {
      vm.remind.id=id;
      Remind.remindLoadSearch(1,1).query(vm.remind, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      console.log('onSuccess');
      console.log(data);
      vm.remind = data.rows[0];
      vm.remind.sendTime=uibDateParser.parse(vm.remind.sendTime,"yyyy-MM-dd");
    }
    function onError(error) {
      console.log('error');
    }
  }
})();

/**
 * Created by Koma.Tshu on 2016/8/9.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('promptIndex', {
        parent: 'app',
        url: "/promptIndex",
        views: {
          'body': {
            templateUrl: "app/prompt/promptIndex.html",
            controller: 'PromptIndexController',
            controllerAs: 'vm'
          }
        },
      resolve: {
      entity: ['$stateParams',
        function ($stateParams) {
          return {
            code:null,
            lang:null,
            dec:null
          };
        }
      ]
    }
      })
      .state('promptIndex.add', {
        parent: 'promptIndex',
        url: '/add',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log("$uibModal:" + $uibModal);
          $uibModal.open({
            templateUrl: 'app/prompt/prompt-dialog.html',
            controller: 'PromptDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                //console.log("state entity:"+angular.toJson($stateParams.promptId));
                return {
                  promptId: null,
                  promptCode: null,
                  lang: null,
                  description: null
                };
              }
            }
          }).result.then(function () {
              //console.log("promptIndex go1");
              $state.go('promptIndex', null, {reload: 'promptIndex'});
            }, function () {
              //console.log("promptIndex go2");
              $state.go('promptIndex');
            });
        }]
      })
      .state('promptIndex.edit', {
        parent: 'promptIndex',
        url: "/edit/:promptId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          //console.log("$stateParams.promptId:" + $stateParams.promptId);
          $uibModal.open({
            templateUrl: 'app/prompt/prompt-dialog.html',
            controller: 'PromptDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                //console.log("state entity:"+angular.toJson($stateParams.promptId));
                return {
                  promptId: $stateParams.promptId
                };
              }
            }
          }).result.then(function () {
              //console.log("promptIndex go1");
              $state.go('promptIndex', null, {reload: 'promptIndex'});
            }, function () {
              //console.log("promptIndex go2");
              $state.go('promptIndex');
            });
        }]
      });
  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('PromptService', PromptService);

  PromptService.$inject = ['$resource','$http'];

  function PromptService ($resource,$http) {
    //console.log("have come in servcie...");
    var service = {
      queryPrompts : queryPrompts,
      savePrompt : savePrompt,
      updatePrompt : updatePrompt,
      findByPromptId : findByPromptId,
      selectLang : selectLang,
      selectLangNoToken: selectLangNoToken,
      deletePrompt:deletePrompt
    };
    return service;

    //查询所有描述
    function queryPrompts(page,pageSize){
      //console.log("service page:" + page);
      //console.log("service pageSize:" + pageSize);
      var resourceUrl ='/api/prompt/selectPrompts?page='+page+'&pageSize='+pageSize;
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    //新增描述
    function savePrompt(prompt){
      var resourceUrl ='/api/prompt/savePrompt';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

    //编辑描述
    function updatePrompt(prompt){
      var resourceUrl ='/api/prompt/updatePrompt';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

    //根据promptId查询对象
    function findByPromptId(){
      var resourceUrl ='/api/prompt/findByPromptId';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

    //查询语言value
    function selectLang(){
      var resourceUrl ='/api/prompt/queryLang';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

    //查询语言value,不需要token
    function selectLangNoToken(){
      var resourceUrl ='/sys/language/query';
      return $resource(resourceUrl,{page: 1, pageSize: 999}, {
        'query': {method: 'POST'}
      })
    }

    //删除描述
    function deletePrompt(prompt) {
      var resourceUrl = "/api/prompt/deletePrompt";
      return $http.post(resourceUrl, prompt, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

  }
})();

/**
 * Created by Koma.Tshu on 2016/8/9.
 */
(function () {
  'use strict';

  angular.module("hmapFront").controller("PromptIndexController", PromptIndexController);

  PromptIndexController.$inject = ['$filter','$state', 'PromptService','entity', 'paginationConstants', 'SweetAlert'];

  function PromptIndexController($filter,$state, PromptService,entity, paginationConstants, SweetAlert) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.deletePrompt = deletePrompt;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.searchPrompt = entity;

    vm.loadAll(vm.searchPrompt,vm.page,vm.itemsPerPage);

    function selectLang(){
      return PromptService.selectLang().query(onLangSuccess,onError);
    }

    function onLangSuccess(data){
      vm.langValue = data.rows;
    }

    function loadAll(searchPrompt,page,pageSize) {
      selectLang();
      //console.log("savePage:" + vm.page);
      return PromptService.queryPrompts(page,pageSize).query(searchPrompt,onSearchSuccess, onError);
    }
    function onSearchSuccess(data) {
      //console.log('onSuccess');
      //console.log(data);
      vm.prompts = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadAll(vm.searchPrompt,vm.page,vm.itemsPerPage);
    }

    vm.search = function(){
      vm.page = 1;
      vm.itemsPerPage = paginationConstants.itemsPerPage;
      //console.log("searchPrompt:" + vm.searchPrompt.promptCode);
      loadAll(vm.searchPrompt,vm.page,vm.itemsPerPage);
    };

    vm.clear = function () {
      vm.searchPrompt.promptCode = null;
      vm.searchPrompt.lang = null;
      vm.searchPrompt.description = null;
    }

    function deletePrompt(prompt) {
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          PromptService.deletePrompt(prompt)
            .then(function (data) {
              var flag = data.success;
              if (flag) {
                $state.go('promptIndex', null, {reload: 'promptIndex'});
              }
            })
        }
      });

    };
  }
})();


/**
 * Created by Koma.Tshu on 2016/8/12.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .controller('PromptDialogController', PromptDialogController);

  PromptDialogController.$inject = ['$timeout', '$uibModalInstance', 'entity', 'PromptService', 'toastr', '$filter', 'toastrConfig'];
  function PromptDialogController($timeout, $uibModalInstance, entity, PromptService, toastr, $filter, toastrConfig){
    var vm = this;

    vm.prompt = entity;
    vm.clear = clear;
    vm.save = save;
    vm.load=load;
    vm.selectLang=selectLang;

    vm.selectLang();
    vm.load(vm.prompt);

    function selectLang(){
      return PromptService.selectLang().query(onLangSuccess,onError);
    }

    function onLangSuccess(data){
      vm.langValue = data.rows;
    }

    $timeout(function () {
      angular.element('.form-group:eq(0)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.isSaving = true;
      //console.log("vm.prompt.promptId:" + vm.prompt.promptId);
      if (vm.prompt.promptId != null && vm.prompt.promptId != undefined) {
        PromptService.updatePrompt().query(vm.prompt,onSaveSuccess,onError);
      } else {
        //console.log("vm.prompt:" + vm.prompt.promptCode);
        PromptService.savePrompt().query(vm.prompt,onSaveSuccess,onError);
      }
    }

    function onSaveSuccess(data){
      //console.log("resultData:" + angular.toJson(data));
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        vm.isSaving = false;
        return ;
      }
      if (data.success) {
        toastr.success($filter('T')('title.saveSuccess'));
        $uibModalInstance.close();
        vm.isSaving = false;
      }
    }

    function load(promptId) {
      if (promptId != null) {
        //console.log('loadone');
        PromptService.findByPromptId().query(promptId,onLoadSuccess,onError);
      }
    }

    function onLoadSuccess(data){
      vm.prompt = data.rows[0];
    }

    function onError(error) {
      vm.isSaving = false;
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Created by mclin on 2017-4-16.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('preferences', {
        parent: 'app',
        url: "/preferences",
        views: {
          'body': {
            templateUrl: "app/preferences/preferences.html",
            controller: 'PreferencesController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function($stateParams) {
            return [{
              preferencesId: null,
              preferences: null,
              preferencesValue: null,
              objectVersionNumber: null,
              userId: null
            },{
              preferencesId: null,
              preferences: null,
              preferencesValue: null,
              objectVersionNumber: null,
              userId: null
            }]
          }
        }
      })
  }

})();

/**
 * Created by mclin on 2017-4-16.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('PreferencesService', PreferencesService);

  PreferencesService.$inject = ['$resource', '$http', '$state'];

  function PreferencesService($resource, $http, $state) {
    var service={
      getInitData: getInitData,
      queryPreferences: queryPreferences,
      savePreferences: savePreferences,
      getCode: getCode
    };
    return service;

    function getInitData(){
      var resourceTimeZoneUrl ='/common/code?Timezones=SYS.TIME_ZONE';
      return $http.get(resourceTimeZoneUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response.data));
        if (response.status == "200") {
          //var timezones = eval('(' + response.data.match(/=(\S*);/)[1] + ')');
          var timezones = JSON.parse(response.data.match(/=(\S*);/)[1]);
          return timezones;
        }
      });
    }

    function queryPreferences(){
      var resourceUrl ='/api/preferences/queryPreferences';
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response.data));
        if (response.status == "200" && response.data.success) {
          return response.data.rows;
        }
      });
    }

    function savePreferences(data) {
      var resourceUrl = '/api/preferences/savePreferences';

      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });

    }

    function getCode(){
      var resourceUrl ='/api/code/test';
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response.data));
        if (response.status == "200" && response.data.success) {
          console.log(response.data.rows);
        }
      });
    }

  }
})();

/**
 * Created by mclin on 2017-4-16.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('PreferencesController', PreferencesController);

  PreferencesController.$inject = ['PreferencesService','paginationConstants', 'toastr', '$timeout', '$localStorage', 'entity', '$state', 'PromptService','$filter'];

  function PreferencesController(PreferencesService,paginationConstants, toastr,$timeout, $localStorage, entity, $state, PromptService,$filter) {
    var vm = this;

    vm.timeZone = entity[0];
    vm.locale = entity[1];
    vm.saveData = saveData;
    vm.getCode = getCode;

    // langs
    function initData() {
      PreferencesService.getInitData()
        .then(function (data) {
          vm.timezones = data;
          var locales = [];
          PromptService.selectLangNoToken().query(function(result) {
            var rows = result.rows;
            for (var i in rows) {
              var obj = {};
              obj["value"] = rows[i].langCode;
              obj["meaning"] = rows[i].description;
              locales[i] = obj;
            }
            vm.locales = locales;
          });

          // init page data
          PreferencesService.queryPreferences()
            .then(function (data) {
              var optionsDivs = $(".options_div");
              var size = optionsDivs.size();
              for (var i = 0; i < size; i++) {
                for (var j in data) {
                  var optionsDivVal = optionsDivs.eq(i).attr("value");
                  var dataItem = data[j];
                  if (optionsDivVal == dataItem.preferences) {
                    vm[optionsDivVal]["preferencesId"] = dataItem.preferencesId;
                    vm[optionsDivVal]["preferences"] = dataItem.preferences;
                    vm[optionsDivVal]["preferencesValue"] = dataItem.preferencesValue;
                    vm[optionsDivVal]["objectVersionNumber"] = dataItem.objectVersionNumber;
                    vm[optionsDivVal]["userId"] = data[j].userId;
                  }
                }
              }
            })
        })
    }
    initData();

    function saveData() {
      // make data
      var data = [];
      var optionsDivs = $(".options_div");
      var size = optionsDivs.size();
      for (var i = 0; i < size; i++) {
        var optionsDivVal = optionsDivs.eq(i).attr("value");
        var obj = {};
        obj["preferencesId"] = vm[optionsDivVal]["preferencesId"]
        obj["preferences"] = optionsDivVal;
        obj["preferencesValue"] = vm[optionsDivVal]["preferencesValue"];
        obj["objectVersionNumber"] = vm[optionsDivVal]["objectVersionNumber"];
        obj["userId"] = vm[optionsDivVal]["userId"];
        data[i] = obj;
      }
      // console.log(data);
      return PreferencesService.savePreferences(data)
        .then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
          } else {
            toastr.error($filter('T')("title.saveFail") + data.message$+$filter('T')("title.infoTitle"));
          }

        })
    }

    function getCode() {
      PreferencesService.getCode();
    }

  }
})();

/**
 * Created by linghui.xie on 2022/02/22.
 */

 (function () {
  'use strict';

  angular.module('hmapFront')
    .controller('ModuleFirmwareListController', ModuleFirmwareListController);

  ModuleFirmwareListController.$inject = ['moduleFirmwareService', 'paginationConstants', 'entity', 'toastr', 'toastrConfig', 'SweetAlert', '$filter'];

  function ModuleFirmwareListController(moduleFirmwareService, paginationConstants, entity, toastr, toastrConfig, SweetAlert, $filter) {
    
    var vm = this;
    vm.sku = entity;
    console.log(vm.sku)
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetSku = resetSku;
    vm.deleteSku = deleteSku;
    vm.getSku = getSku;
    vm.changePublic=changePublic;

    vm.getSku();

    // 获取列表
    function getSku() {
      return moduleFirmwareService.getModuleFirmwareList(vm.sku.groupId, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        
        vm.firmwareList = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    // 搜索
    function search() {
      if ((vm.sku.componentNumber === '' || vm.sku.componentNumber == null || vm.sku.componentNumber == undefined) && (vm.sku.partNumber === '' || vm.sku.partNumber == null || vm.sku.partNumber == undefined)) {
        // 当搜索项为空的时候，获取列表数据
        vm.getSku();
        return false;
      }
      vm.page = 1; // 默认为1
      return moduleFirmwareService.queryLatestFirmwareByNumber(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        
        vm.firmwareList = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    // 重置
    function resetSku() {
      vm.sku.componentNumber = undefined;
      vm.sku.partNumber = undefined;
    }

    // 删除固件
    function deleteSku(oat_device) {
      console.log(oat_device)
      if (oat_device.isPublic=='Y') {
        toastr.error('当前固件被作为公共通知使用，暂时无法删除');
        return false;
      }
      SweetAlert.confirm(oat_device.componentName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          moduleFirmwareService.deleteFirmware(oat_device.firmwareId).then(function (response) {
            if (response.success) {
              vm.getSku();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    // 公共通知
    function changePublic(template) {
      SweetAlert.confirm($filter('T')("firmware.isChangePublic"), {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if(p){
          moduleFirmwareService.changePublicNotice(template.firmwareId).then(function (data) {
            if (data.success === true){
              $('#notifyPublicBtn'+template.firmwareId).attr('disabled',true);
              vm.getSku()
            }
          });
        }
      });
    }

    function pageChanged() {
      vm.getSku();
    }

    angular.extend(toastrConfig, {
      preventDuplicates: false
    });

  }
})();

/**
 * Created by linghui.xie on 2022/02/16.
 */

 (function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('moduleFirmware', {
        parent: 'app',
        url: "/moduleFirmware",
        views: {
          'body': {
            templateUrl: "app/moduleFirmware/moduleFirmware.html",
            controller: 'ModuleFirmwareController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
            };
          }
        }
      })
      .state('moduleFirmware.add', {
        parent: 'moduleFirmware',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/moduleFirmware/addGroups.html',
            controller: 'AddGroupsController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {}
              }
            }
          }).result.then(function () {
            $state.go('moduleFirmware', null, {reload: true});
          }, function () {
            $state.go('moduleFirmware');
          });
        }]
      })
      .state('moduleFirmware.edit', {
        parent: 'moduleFirmware',
        url: "/edit/:groupId&:hwpn&:hwpnName&:note",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/moduleFirmware/addGroups.html',
            controller: 'AddGroupsController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  groupId: $stateParams.groupId,
                  hwpn: $stateParams.hwpn,
                  hwpnName: $stateParams.hwpnName,
                  note: $stateParams.note
                }
              }
            }
          }).result.then(function () {
            $state.go('moduleFirmware', null, {reload: true});
          }, function () {
            $state.go('moduleFirmware');
          });
        }]
      })
      .state('moduleFirmware.info', {
        parent: 'app',
        params: {
          header: ""
        },
        url: "/moduleFirmwareList/:groupId&:hwpnName",
        views: {
          'body': {
            templateUrl: "app/moduleFirmware/moduleFirmwareList.html",
            controller: 'ModuleFirmwareListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                groupId: $stateParams.groupId,
                hwpnName: $stateParams.hwpnName
              };
            }
          ]
        }
      })
      .state('moduleFirmware.editFirmware', {
        parent: 'moduleFirmware.info',
        url: "/editFirmware/:id&:groupId&:configurationFile&:hwpnName",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/moduleFirmware/addModuleFirmware.html',
            controller: 'AddModuleFirmwareController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  groupId: $stateParams.groupId,
                  configurationFile: $stateParams.configurationFile,
                  hwpnName: $stateParams.hwpnName,
                  id: $stateParams.id
                }
              }
            }
          }).result.then(function () {
            $state.go('moduleFirmware.info', null, {reload: true});
          }, function () {
            $state.go('moduleFirmware.info');
          });
        }]
      })
      .state('moduleFirmware.addFirmware', {
        parent: 'moduleFirmware.info',
        url: "/addFirmware/:groupId&:hwpnName",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/moduleFirmware/addModuleFirmware.html',
            controller: 'AddModuleFirmwareController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  groupId: $stateParams.groupId,
                  hwpnName: $stateParams.hwpnName
                }
              }
            }
          }).result.then(function () {
            $state.go('moduleFirmware.info', null, {reload: true});
          }, function () {
            $state.go('moduleFirmware.info');
          });
        }]
      })
      .state('moduleFirmware.lookFirmwareList', {
        parent: 'app',
        params: {
          header: ""
        },
        url: "/moduleFirmware/lookModuleFirmwareList/:id&:hwpnName&:componentNumber&:partNumber",
        views: {
          'body': {
            templateUrl: "app/moduleFirmware/lookModuleFirmwareList.html",
            controller: 'LookModuleFirmwareListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                id: $stateParams.id,
                componentNumber: $stateParams.componentNumber,
                partNumber: $stateParams.partNumber,
                hwpnName: $stateParams.hwpnName
              };
            }
          ]
        }
      })
  }
})();

/**
 * Created by linghui.xie on 2022/02/16.
 */


 (function () {
  'use strict';

  angular.module('hmapFront').factory('moduleFirmwareService', moduleFirmwareService);

  moduleFirmwareService.$inject = ['$http', '$rootScope', '$resource'];

  function moduleFirmwareService($http, $rootScope, $resource) {
    return {
      getAllGroups: getAllGroups,
      addGroup: addGroup,
      deleteGroup: deleteGroup,
      updateGroup: updateGroup,
      getModuleFirmwareList: getModuleFirmwareList,
      deleteFirmware: deleteFirmware,
      changePublicNotice: changePublicNotice,
      queryLatestFirmwareByNumber: queryLatestFirmwareByNumber,
      queryAllFirmwareVersion: queryAllFirmwareVersion,
      queryFirmwareByNumber: queryFirmwareByNumber,
      addGroupModuleFirmware: addGroupModuleFirmware,
      editGroupModuleFirmware: editGroupModuleFirmware,
      getSearchGroupByHwpn: getSearchGroupByHwpn
    };

    //get product
    function getAllGroups(page) {
      var resourceUrl = '/api/module/ota/group/queryAllGroups';
      return $http({
        method:"POST",
        url:resourceUrl,
        params:{page:page}, 
        headers: {'Content-Type': 'application/json;charset=utf-8'}
      }).then(function (response) {
        return response.data;
      })
    }
    
    //get product
    function updateGroup(entity) {
      var resourceUrl = '/api/module/ota/group/update';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get addGroup
    function addGroup(entity) {
      var resourceUrl = '/api/module/ota/group/insert';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    // deleteGroup
    function deleteGroup(entity) {
      var resourceUrl = '/api/module/ota/group/delete/'+entity;
      return $http.post(resourceUrl, {}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //add addGroupModuleFirmware
    function addGroupModuleFirmware(entity) {
      var resourceUrl = '/api/module/ota/firmware/insert';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //edit editGroupModuleFirmware
    function editGroupModuleFirmware(entity) {
      var resourceUrl = '/api/module/ota/firmware/update?groupId='+entity.groupId+'&firmwareId='+entity.firmwareId+'&componentNumber='+entity.componentNumber+'&partNumber='+entity.partNumber+'&referenceSource='+entity.referenceSource;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //get queryLatestFirmwareByNumber
    function queryLatestFirmwareByNumber(entity, page) {
      var resourceUrl = '/api/module/ota/firmware/queryLatestFirmwareByNumber/' + entity.groupId + '?page=' + page;
      var data = {};
      if (entity.componentNumber) {
        data.componentNumber = entity.componentNumber;
      }
      if (entity.partNumber) {
        data.partNumber = entity.partNumber;
      }
      return $http.post(resourceUrl, data, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //delete deleteFirmware
    function deleteFirmware(entity) {
      var resourceUrl = '/api/module/ota/firmware/delete/' + entity;
      return $http.post(resourceUrl, {}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //queryAllFirmwareVersion
    function queryAllFirmwareVersion(entity, page) {
      var resourceUrl = '/api/module/ota/firmware/queryAllFirmwareVersion/' + entity.id +'?page=' + page;
      return $http.post(resourceUrl, {componentNumber: entity.componentNumber, partNumber: entity.partNumber}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function queryFirmwareByNumber(entity, page) {
      var resourceUrl = '/api/module/ota/firmware/queryFirmwareByNumber/' + entity.id +'?page=' + page;
      return $http.post(resourceUrl, {partNumber: entity.partNumber, componentNumber: entity.componentNumber}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //get getModuleFirmwareList
    function getModuleFirmwareList(entity, page) {
      var resourceUrl = '/api/module/ota/firmware/queryLatestFirmwareVersion/'+entity+'?page='+page;
      return $http.post(resourceUrl, {}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get getSearchGroupByHwpn
    function getSearchGroupByHwpn(entity, page) {
      var data = {}
      if (entity.hwpn) {
        data.hwpn = entity.hwpn;
      }
      if (entity.hwpnName) {
        data.hwpnName = entity.hwpnName;
      }
      var resourceUrl = '/api/module/ota/group/queryGroupByHwpn?page=' + page;
      return $http.post(resourceUrl, data, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //changePublicNotice
    function changePublicNotice(entity) {
      var resourceUrl = '/api/module/public/'+entity;
      return $http.post(resourceUrl, {}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

  }
})();

/**
 * Created by linghui.xie on 2022/02/16.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('ModuleFirmwareController', ModuleFirmwareController);

  ModuleFirmwareController.$inject = ['moduleFirmwareService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

  function ModuleFirmwareController(moduleFirmwareService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
    var vm = this;
    vm.sku = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetSku = resetSku;
    vm.deleteSku = deleteSku;
    vm.getSku = getSku;
    vm.hwpn = {}

    vm.getSku();

    //get Sku
    function getSku() {
      return moduleFirmwareService.getAllGroups(vm.page).then(function (data) {
        if (!data.rows) {
          return;
        }

        vm.skus = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search
    function search() {
      vm.page = 1; // 默认为1
      return moduleFirmwareService.getSearchGroupByHwpn(vm.hwpn, vm.page).then(function (data) {
        if (!data.rows) {
          return;
        }

        vm.skus = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //reset hwpn
    function resetSku() {
      vm.hwpn.hwpn = undefined;
      vm.hwpn.hwpnName = undefined;
    }

    //delete sku
    function deleteSku(group) {
      // ' 是否确认被删除，若分组下有资源将一并删除'
      // $filter('T')("dvmProduct.deleteConfirm")
      SweetAlert.confirm(group.hwpnNumber + ' 是否确认被删除，若分组下有资源将一并删除', { title: $filter('T')("btnTypeName.prompt") }).then(function (p) {
        if (p) {
          console.log('删除分组')
          moduleFirmwareService.deleteGroup(group.groupId).then(function (response) {
            if (response.success) {
              vm.getSku();
              SweetAlert.success($filter('T')("title.successfulOperation"), { title: $filter('T')("btnTypeName.prompt") });
            } else {
              SweetAlert.error($filter('T')("title.operationFailed"), { title: $filter('T')("btnTypeName.prompt") });
            }
          })
        }
      });
    }


    //page changed
    function pageChanged() {
      vm.getSku();
    }

  }
})();

/**
 * Created by linghui.xie on 2022/02/24.
 */

 (function () {
  'use strict';

  angular.module('hmapFront')
    .controller('LookModuleFirmwareListController', LookModuleFirmwareListController);

  LookModuleFirmwareListController.$inject = ['moduleFirmwareService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];

  function LookModuleFirmwareListController(moduleFirmwareService, paginationConstants, entity, SweetAlert, $filter) {
    
    var vm = this;
    vm.sku = entity;
    console.log(vm.sku)
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetSku = resetSku;
    vm.getSku = getSku;
    vm.changePublic=changePublic;

    vm.getSku();

    function getSku() {
      // /api/module/ota/firmware/queryAllFirmwareVersion/{groupId}
      return moduleFirmwareService.queryFirmwareByNumber(vm.sku, vm.page).then(function (data) {
      // return moduleFirmwareService.queryAllFirmwareVersion(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        
        vm.firmwareList = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    // 搜索
    function search() {
      if ((vm.sku.componentNumber === '' || vm.sku.componentNumber == null || vm.sku.componentNumber == undefined) && (vm.sku.partNumber === '' || vm.sku.partNumber == null || vm.sku.partNumber == undefined)) {
        // 当搜索项为空的时候，获取列表数据
        vm.getSku();
        return false;
      }
      vm.page = 1; // 默认为1
      return moduleFirmwareService.queryFirmwareByNumber(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        
        vm.firmwareList = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    // 重置
    function resetSku() {
      vm.sku.componentNumber = undefined;
      vm.sku.partNumber = undefined;
    }

    // 公共通知
    function changePublic(template) {
      SweetAlert.confirm($filter('T')("firmware.isChangePublic"), {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if(p){
          moduleFirmwareService.changePublicNotice(template.firmwareId).then(function (data) {
            if (data.success === true){
              $('#moduleNotifyPublicBtn'+template.firmwareId).attr('disabled',true);
              vm.getSku()
            }
          });
        }
      });
    }

    function pageChanged() {
      vm.getSku();
    }

  }
})();

/**
 * Created by linghui.xie on 2022/02/23.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddModuleFirmwareController', AddModuleFirmwareController);

  AddModuleFirmwareController.$inject = ['moduleFirmwareService', '$state', '$uibModalInstance', 'toastr', 'toastrConfig', 'entity', 'PromptService', '$filter', '$scope', '$localStorage', '$sessionStorage', 'Upload', 'BaseConfig'];

  function AddModuleFirmwareController(moduleFirmwareService, $state, $uibModalInstance, toastr, toastrConfig, entity, PromptService, $filter, $scope, $localStorage, $sessionStorage, Upload, BaseConfig) {
    var vm = this;
    vm.sku = entity;
    console.log(vm.sku)
    vm.skuCodeReadOnly = false;
    vm.readonly = true;
    vm.config = {};
    vm.firmware = {
      groupId: vm.sku.groupId, // 分组id
      referenceSource: "residential", // 前端写死
      file: {}, // 读取json文件
      urls: [] // 上传资源包返回的数据
    };
    vm.btnStatus = false; // 用于判断固件资源包是否导入成功
    vm.resourceSub = {
      groupId: vm.sku.groupId // 分组id
    };

    vm.clear = clear;
    vm.addFirmware = addFirmware;
    vm.upConfigModuleFiles = upConfigModuleFiles;
    vm.upModuleResourceFile = upModuleResourceFile;
    vm.verifyData = verifyData;


    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
        $("#localeBtn_skuName").attr("disabled", false);
      });
    }
    initLangs();

    setSkuReadOnly();
    function setSkuReadOnly() {
      if (vm.sku.id != null) {
        vm.firmware.file = JSON.parse(vm.sku.configurationFile);
        vm.firmware.firmwareId = vm.sku.id; // 编辑固件的id
        var json = vm.firmware.file;
        vm.firmware.componentNumber = json.loading.componentNumber; // 组件id
        vm.firmware.partNumber = json.loading.partNumber; // partID
        if (json && JSON.stringify(json) != "{}") {
          vm.config.firmwareVersion = json.firmwareVersion; // 固件版本
          vm.config.firmwareName = json.firmwareName; // 固件名称
          if (json.setting && JSON.stringify(json.setting) != "{}") {
            vm.config.forceUpdate = json.setting.forceUpdate; // 是否强制更新
            vm.config.subPackageSize = json.setting.subPackageSize; // 下载分包大小
          }
          if (json.loading && JSON.stringify(json.loading) != "{}") {
            vm.config.downloadLocation = json.loading.downloadLocation; // 下载到那里
            vm.config.downloadUrlType = json.loading.downloadUrlType; // 下载最大长度
            vm.config.isSilentDownload = json.loading.isSilentDownload; // 是否为静默下载
            vm.config.priority = json.loading.priority; // 升级包优先级
            vm.config.part = json.loading.partNumber + '-' + json.loading.partName;// part号+part名称
            vm.config.component = json.loading.componentNumber + '-' + json.loading.componentName; // 组件号+组件名称
          }
        }
      }
    }

    //submit 通过id判断是否是新增固件还是编辑
    function addFirmware() {
      console.log(vm.firmware);
      // 提交新增固件
      // addGroupFirmware
      if (vm.sku.id !== '' && vm.sku.id != undefined && vm.sku.id != null) {
        console.log('编辑')
        if (vm.firmware.file && JSON.stringify(vm.firmware.file) != "{}" && vm.firmware.urls.length > 0) {
          moduleFirmwareService.editGroupModuleFirmware(vm.firmware).then(function (data) {
            console.log(data);
            if (data.success) {
              toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
              $uibModalInstance.close();
              return $state.go('deviceFirmware.firmwareList', null, { reload: true });
            }
          });
        } else {
          // toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          toastr.error('内容未进行任何修改，将不作保存');
          return false;
          // 娟娟核实过了，每次编辑的时候，导入资源包的文件都必须重新上传
          // console.log('提示上传文件')
        }
      } else {



        if (vm.firmware.file && JSON.stringify(vm.firmware.file) != "{}" && vm.firmware.urls.length > 0) {
          console.log('提交新增')
          // /api/module/ota/firmware/insert
          moduleFirmwareService.addGroupModuleFirmware(vm.firmware).then(function (data) {
            if (data.success) {
              toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
              $uibModalInstance.close();
              return $state.go('deviceFirmware.firmwareList', null, { reload: true });
            }
          });

        } else {
          // toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
          toastr.error('配置文件和资源包缺失或者有误，请您重新导入正确的配置文件和资源包');
          return false;
          // 娟娟核实过了，每次编辑的时候，导入资源包的文件都必须重新上传
          // console.log('提示上传文件')
        }
      }
    }

    // 读取本地json文件
    function upConfigModuleFiles() {
      var selectedFile = document.getElementById("configModuleFiles").files[0]; // 获取读取的File对象
      var reader = new FileReader(); // 这里是核心！！！读取操作就是由它完成的。
      reader.readAsText(selectedFile, "UTF-8"); // UTF-8
      reader.onload = function () {
        console.log("读取结果：", this.result); // 当读取完成之后会回调这个函数，然后此时文件的内容存储到了result中。直接操作即可。
        var json = JSON.parse(this.result);

        if (json && JSON.stringify(json) != "{}") {
          vm.config.firmwareVersion = json.firmwareVersion; // 固件版本
          vm.config.firmwareName = json.firmwareName; // 固件名称
          if (json.setting && JSON.stringify(json.setting) != "{}") {
            vm.config.forceUpdate = json.setting.forceUpdate; // 是否强制更新
            vm.config.subPackageSize = json.setting.subPackageSize; // 下载分包大小
          }
          if (json.loading && JSON.stringify(json.loading) != "{}") {
            vm.config.downloadLocation = json.loading.downloadLocation; // 下载到那里
            vm.config.downloadUrlType = json.loading.downloadUrlType; // 下载最大长度
            vm.config.isSilentDownload = json.loading.isSilentDownload; // 是否为静默下载
            vm.config.priority = json.loading.priority; // 升级包优先级
            vm.config.part = json.loading.partNumber + '-' + json.loading.partName; // part号+part名称
            vm.config.component = json.loading.componentNumber + '-' + json.loading.componentName; // 组件号+组件名称
          }
        }
        vm.firmware.file = json;
        $scope.$digest();
        var file = $("#configModuleFiles");
        file.after(file.clone().val(""));
        file.remove();
        // 版本号不能为空
        if (vm.firmware.file.firmwareVersion === '' || vm.firmware.file.firmwareVersion == null || vm.firmware.file.firmwareVersion == undefined) {
          toastr.error('JSON文件版本号缺失或者有误，请您重新导入正确的固件版本号');
          return false;
        }
        // 判断loading是否为空对象
        if (vm.firmware.file.setting && JSON.stringify(vm.firmware.file.setting) != "{}") {
          if (vm.firmware.file.setting.subPackageSize === '' || vm.firmware.file.setting.subPackageSize == null || vm.firmware.file.setting.subPackageSize == undefined) {
            toastr.error('JSON文件分包大小缺失或者有误，请您重新导入正确的分包大小');
            return false;
          }
        } else {
          toastr.error('setting字段不能为空');
          return false;
        }
        // 判断loading是否为空对象
        if (vm.firmware.file.loading && JSON.stringify(vm.firmware.file.loading) != "{}") {
          if (vm.firmware.file.loading.componentNumber === '' || vm.firmware.file.loading.componentNumber == null || vm.firmware.file.loading.componentNumber == undefined) {
            toastr.error('JSON文件组件号缺失或者有误，请您重新导入正确的组件号');
            return false;
          }
          if (vm.firmware.file.loading.partNumber === '' || vm.firmware.file.loading.partNumber == null || vm.firmware.file.loading.partNumber == undefined) {
            toastr.error('JSON文件part号缺失或者有误，请您重新导入正确的part号');
            return false;
          }
        } else {
          toastr.error('loading字段不能为空');
          return false;
        }
      }
    }

    function verifyData() {
      // subVersionSize
      // componentNumber
      // partNumber
      // version
      if (vm.firmware.file && JSON.stringify(vm.firmware.file) != "{}") {
        // 版本号不能为空
        if (vm.firmware.file.firmwareVersion === '' || vm.firmware.file.firmwareVersion == null || vm.firmware.file.firmwareVersion == undefined) {
          toastr.error('JSON文件版本号缺失或者有误，请您重新导入正确的固件版本号');
          return false;
        }
        // 判断loading是否为空对象
        if (vm.firmware.file.setting && JSON.stringify(vm.firmware.file.setting) != "{}") {
          if (vm.firmware.file.setting.subPackageSize === '' || vm.firmware.file.setting.subPackageSize == null || vm.firmware.file.setting.subPackageSize == undefined) {
            toastr.error('JSON文件分包大小缺失或者有误，请您重新导入正确的分包大小');
            return false;
          }
        } else {
          toastr.error('setting字段不能为空');
          return false;
        }
        // 判断loading是否为空对象
        if (vm.firmware.file.loading && JSON.stringify(vm.firmware.file.loading) != "{}") {
          if (vm.firmware.file.loading.componentNumber === '' || vm.firmware.file.loading.componentNumber == null || vm.firmware.file.loading.componentNumber == undefined) {
            toastr.error('JSON文件组件号缺失或者有误，请您重新导入正确的组件号');
            return false;
          }
          if (vm.firmware.file.loading.partNumber === '' || vm.firmware.file.loading.partNumber == null || vm.firmware.file.loading.partNumber == undefined) {
            toastr.error('JSON文件part号缺失或者有误，请您重新导入正确的part号');
            return false;
          }
        } else {
          toastr.error('loading字段不能为空');
          return false;
        }

        vm.resourceSub.subVersionSize = vm.firmware.file.setting.subPackageSize; // 分包大小
        vm.resourceSub.version = vm.firmware.file.firmwareVersion; // 固件版本
        vm.resourceSub.componentNumber = vm.firmware.file.loading.componentNumber; // 组件号
        vm.resourceSub.partNumber = vm.firmware.file.loading.partNumber; // part号
        console.log(vm.resourceSub);

        // 触发文件上传
        angular.element("#moduleResourceFile").click();
        // return $("#resourceFile").click();
      } else {
        toastr.error('JSON文件数据不能为空');
        // console.log('提示数据为空')
      }
    }

    // 上传资源文件 
    function upModuleResourceFile() {
      var resourceFile = document.getElementById("moduleResourceFile").files[0];//获取读取的File对象
      vm.resourceSub.file = resourceFile;
      console.log(vm.resourceSub)
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        // 上传固件包
        url: BaseConfig.url + '/api/module/ota/firmware/upload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        data: vm.resourceSub
      }).success(function (data, status, headers, config) {
        // vm.picurl=data.rows[0].pictureUrl;
        // $state.go('legwork', null, {reload: true});
        // console.log(data);
        if (data.success) {
          vm.firmware.urls = data.rows;
          vm.btnStatus = true;
          toastr.success('资源文件导入成功');
        } else {
          // 上传失败设置为空
          vm.firmware.urls = [];
          toastr.error('资源文件导入失败');
        }

        // console.log('上传后拿到的内容是：'+angular.toJson(data));
        // console.log("成功上传：");
      })
      $scope.$digest();
      var file = $("#moduleResourceFile");
      file.after(file.clone().val(""));
      file.remove();
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
    angular.extend(toastrConfig, {
      preventDuplicates: false,
    });

  }
})();

/**
 * Created by linghui.xie on 2022/02/16.
 */


 (function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddGroupsController', AddGroupsController);

  AddGroupsController.$inject = ['moduleFirmwareService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', '$filter'];

  function AddGroupsController(moduleFirmwareService, $state, $uibModalInstance, toastr, entity, PromptService, $filter) {
    var vm = this;
    vm.group = {};
    vm.data = {};
    if (entity.hwpnName) {
      vm.data.hwpnName = entity.hwpnName;
    }
    if (entity.hwpn) {
      vm.data.hwpn = entity.hwpn;
    }
    if (entity.note) {
      vm.data.note = entity.note;
    }
    vm.group = entity;
    // console.log(vm.sku)
    vm.skuCodeReadOnly = false;

    vm.clear = clear;
    vm.addGroup = addGroup;

    //submit 新增产品分组
    function addGroup() {
      if (vm.group.groupId) {
        vm.subData = JSON.parse(JSON.stringify(vm.group))
        if (vm.subData.hwpnName && vm.subData.hwpnName == vm.data.hwpnName) {
          // 表示hwpnName有值的同时，并且没有发生改变
          delete vm.subData.hwpnName;
        }
        if (vm.subData.hwpn && vm.subData.hwpn == vm.data.hwpn) {
          // 表示hwpn有值的同时，并且没有发生改变
          delete vm.subData.hwpn;
        }
        if (vm.subData.note && vm.subData.note == vm.data.note) {
          // 表示note有值的同时，并且没有发生改变
          delete vm.subData.note;
        }
        // 编辑逻辑
        moduleFirmwareService.updateGroup(vm.subData).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('moduleFirmware', null, {reload: true});
          }
        });
      } else {
        // 新增 addGroup
        moduleFirmwareService.addGroup(vm.group).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('moduleFirmware', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('modifyPwd', {
      parent: 'app',
      url: "/modifyPwd",
      views: {
        'body': {
          templateUrl: "app/modifyPwd/modifyPwd.html",
          controller: 'modifyPwdController',
          controllerAs: 'vm'
        }
      }
    })
  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('modifyPwdService', modifyPwdService);

  modifyPwdService.$inject = ['$resource','$http'];

  function modifyPwdService($resource,$http) {
    var service = {
      modifyPwd:modifyPwd
    };
    return service;

    function modifyPwd(){
      var resourceUrl ='/api/hmsUser/modifyPwd';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }
  }
})();

/**
 * Created by zhusifeng on 2016/8/31.
 */
(function () {
  'use strict';
  angular.module('hmapFront')
  .controller('modifyPwdController', modifyPwdController);

  modifyPwdController.$inject = ['$state', '$scope', 'SweetAlert', 'modifyPwdService', '$localStorage', '$sessionStorage', '$filter', 'CryptoJS'];

  function modifyPwdController($state, $scope, SweetAlert, modifyPwdService, $localStorage, $sessionStorage, $filter, CryptoJS) {
    var vm = this;
    vm.modifyPwd = modifyPwd;
    vm.showOrHidePwd = showOrHidePwd;
    vm.showPwdEnabled = true;

    function modifyPwd() {
      if (vm.newPwd !== vm.reNewPwd) {
        vm.reNewPwd = '';
        SweetAlert.error($filter('T')('prompt.passwordConfirm'), {title: $filter('T')('prompt.info')});
        return false;
      }
      var key = CryptoJS.toBase64('0102030405060708');
      var iv = CryptoJS.toBase64('0102030405060708');
      var newPwd = CryptoJS.aesEncryptCBC(vm.newPwd, key, iv);
      var renewPwd = CryptoJS.aesEncryptCBC(vm.reNewPwd, key, iv);
      var data = {newPassword: '' + newPwd, newCheckPassword: '' + renewPwd};
      return modifyPwdService.modifyPwd().query(data, onSuccess, onError);
    }

    function onSuccess(response) {
      if (response.code && response.code === 'err') {
        if (response.message === 'permission_denied') {
          SweetAlert.error($filter('T')('prompt.permissionDenied'), {title: $filter('T')('prompt.info')});
        } else {
          SweetAlert.error($filter('T')('prompt.modifyFailed'), {title: $filter('T')('prompt.info')});
        }
      } else {
        SweetAlert.success($filter('T')('prompt.modifyPwdReLogin'), {title: $filter('T')('prompt.info')}).then(function () {
          $localStorage.authenticationToken = undefined;
          $sessionStorage.authenticationToken = undefined;
          $state.go('login');
        });
      }
    }

    function onError() {
      SweetAlert.error($filter('T')('prompt.modifyFailed'), {title: $filter('T')('prompt.info')});
      reset();
    }

    function reset() {
      vm.oldPwd = '';
      vm.newPwd = '';
      vm.reNewPwd = '';
    }

    function showOrHidePwd() {
      var pwdInput = angular.element('#pwdInput');
      var pwdInputConfirm = angular.element('#pwdInputConfirm');
      if (vm.showPwdEnabled) {
        pwdInput.prop('type', 'text');
        pwdInputConfirm.prop('type', 'text');
        vm.showPwdEnabled = false;
      } else {
        pwdInput.prop('type', 'password');
        pwdInputConfirm.prop('type', 'password');
        vm.showPwdEnabled = true;
      }
    }
  }
})();


(function() {
  'use strict';
  angular.module('hmapFront').factory('CryptoJS', Crypto);

  function Crypto() {

    var crypto = core();
    base64(crypto);
    sha256(crypto);
    hmac(crypto);
    aes(crypto);

    return {
      toBase64 : toBase64,
      aesEncryptCBC : aesCBCEncrypt
    };

    function toBase64(msg) {
      return crypto.enc.Utf8.parse(msg);
    }

    function aesCBCEncrypt(password, key, iv) {
      return crypto.AES.encrypt(password, key, { iv: iv, mode:crypto.mode.CBC, padding: crypto.pad.Pkcs7});
    }


    function base64(CryptoJS) {
      (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;

        /**
         * Base64 encoding strategy.
         */
        var Base64 = C_enc.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var map = this._map;

            // Clamp excess bits
            wordArray.clamp();

            // Convert
            var base64Chars = [];
            for (var i = 0; i < sigBytes; i += 3) {
              var byte1 = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
              var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

              var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

              for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
                base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
              }
            }

            // Add padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              while (base64Chars.length % 4) {
                base64Chars.push(paddingChar);
              }
            }

            return base64Chars.join('');
          },

          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(base64Str) {
            // Shortcuts
            var base64StrLength = base64Str.length;
            var map = this._map;

            // Ignore padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              var paddingIndex = base64Str.indexOf(paddingChar);
              if (paddingIndex != -1) {
                base64StrLength = paddingIndex;
              }
            }

            // Convert
            var words = [];
            var nBytes = 0;
            for (var i = 0; i < base64StrLength; i++) {
              if (i % 4) {
                var bits1 = map.indexOf(base64Str.charAt(i - 1)) << ((i % 4) * 2);
                var bits2 = map.indexOf(base64Str.charAt(i)) >>> (6 - (i % 4) * 2);
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= (bitsCombined) << (24 - (nBytes % 4) * 8);
                nBytes++;
              }
            }

            return WordArray.create(words, nBytes);
          },

          _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
      }());
      return CryptoJS.enc.Base64;
    }

    function core(CryptoJS) {
      /**
       * CryptoJS core components.
       */
      var CryptoJS = CryptoJS || (function(Math, undefined) {
        /**
         * CryptoJS namespace.
         */
        var C = {};

        /**
         * Library namespace.
         */
        var C_lib = C.lib = {};

        /**
         * Base object for prototypal inheritance.
         */
        var Base = C_lib.Base = (function() {
          function F() {
          }

          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(overrides) {
              // Spawn
              F.prototype = this;
              var subtype = new F();

              // Augment
              if (overrides) {
                subtype.mixIn(overrides);
              }

              // Create default initializer
              if (!subtype.hasOwnProperty('init')) {
                subtype.init = function() {
                  subtype.$super.init.apply(this, arguments);
                };
              }

              // Initializer's prototype is the subtype object
              subtype.init.prototype = subtype;

              // Reference supertype
              subtype.$super = this;

              return subtype;
            },

            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var instance = this.extend();
              instance.init.apply(instance, arguments);

              return instance;
            },

            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },

            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(properties) {
              for (var propertyName in properties) {
                if (properties.hasOwnProperty(propertyName)) {
                  this[propertyName] = properties[propertyName];
                }
              }

              // IE won't copy toString using the loop above
              if (properties.hasOwnProperty('toString')) {
                this.toString = properties.toString;
              }
            },

            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }());

        /**
         * An array of 32-bit words.
         *
         * @property {Array} words The array of 32-bit words.
         * @property {number} sigBytes The number of significant bytes in this word array.
         */
        var WordArray = C_lib.WordArray = Base.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(words, sigBytes) {
            words = this.words = words || [];

            if (sigBytes != undefined) {
              this.sigBytes = sigBytes;
            }
            else {
              this.sigBytes = words.length * 4;
            }
          },

          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(encoder) {
            return (encoder || Hex).stringify(this);
          },

          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(wordArray) {
            // Shortcuts
            var thisWords = this.words;
            var thatWords = wordArray.words;
            var thisSigBytes = this.sigBytes;
            var thatSigBytes = wordArray.sigBytes;

            // Clamp excess bits
            this.clamp();

            // Concat
            if (thisSigBytes % 4) {
              // Copy one byte at a time
              for (var i = 0; i < thatSigBytes; i++) {
                var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
              }
            }
            else {
              // Copy one word at a time
              for (var i = 0; i < thatSigBytes; i += 4) {
                thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
              }
            }
            this.sigBytes += thatSigBytes;

            // Chainable
            return this;
          },

          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            // Shortcuts
            var words = this.words;
            var sigBytes = this.sigBytes;

            // Clamp
            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
            words.length = Math.ceil(sigBytes / 4);
          },

          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var clone = Base.clone.call(this);
            clone.words = this.words.slice(0);

            return clone;
          },

          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(nBytes) {
            var words = [];

            var r = (function(m_w) {
              var m_w = m_w;
              var m_z = 0x3ade68b1;
              var mask = 0xffffffff;

              return function() {
                m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
                m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
                var result = ((m_z << 0x10) + m_w) & mask;
                result /= 0x100000000;
                result += 0.5;
                return result * (Math.random() > .5 ? 1 : -1);
              }
            });

            for (var i = 0, rcache; i < nBytes; i += 4) {
              var _r = r((rcache || Math.random()) * 0x100000000);

              rcache = _r() * 0x3ade67b7;
              words.push((_r() * 0x100000000) | 0);
            }

            return new WordArray.init(words, nBytes);
          }
        });

        /**
         * Encoder namespace.
         */
        var C_enc = C.enc = {};

        /**
         * Hex encoding strategy.
         */
        var Hex = C_enc.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var hexChars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              hexChars.push((bite >>> 4).toString(16));
              hexChars.push((bite & 0x0f).toString(16));
            }

            return hexChars.join('');
          },

          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(hexStr) {
            // Shortcut
            var hexStrLength = hexStr.length;

            // Convert
            var words = [];
            for (var i = 0; i < hexStrLength; i += 2) {
              words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
            }

            return new WordArray.init(words, hexStrLength / 2);
          }
        };

        /**
         * Latin1 encoding strategy.
         */
        var Latin1 = C_enc.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var latin1Chars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              latin1Chars.push(String.fromCharCode(bite));
            }

            return latin1Chars.join('');
          },

          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(latin1Str) {
            // Shortcut
            var latin1StrLength = latin1Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < latin1StrLength; i++) {
              words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
            }

            return new WordArray.init(words, latin1StrLength);
          }
        };

        /**
         * UTF-8 encoding strategy.
         */
        var Utf8 = C_enc.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(wordArray) {
            try {
              return decodeURIComponent(escape(Latin1.stringify(wordArray)));
            }
            catch (e) {
              throw new Error('Malformed UTF-8 data');
            }
          },

          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(utf8Str) {
            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
          }
        };

        /**
         * Abstract buffered block algorithm template.
         *
         * The property blockSize must be implemented in a concrete subtype.
         *
         * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
         */
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            // Initial values
            this._data = new WordArray.init();
            this._nDataBytes = 0;
          },

          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(data) {
            // Convert string to WordArray, else assume WordArray already
            if (typeof data == 'string') {
              data = Utf8.parse(data);
            }

            // Append
            this._data.concat(data);
            this._nDataBytes += data.sigBytes;
          },

          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(doFlush) {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;
            var dataSigBytes = data.sigBytes;
            var blockSize = this.blockSize;
            var blockSizeBytes = blockSize * 4;

            // Count blocks ready
            var nBlocksReady = dataSigBytes / blockSizeBytes;
            if (doFlush) {
              // Round up to include partial blocks
              nBlocksReady = Math.ceil(nBlocksReady);
            }
            else {
              // Round down to include only full blocks,
              // less the number of blocks that must remain in the buffer
              nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
            }

            // Count words ready
            var nWordsReady = nBlocksReady * blockSize;

            // Count bytes ready
            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

            // Process blocks
            if (nWordsReady) {
              for (var offset = 0; offset < nWordsReady; offset += blockSize) {
                // Perform concrete-algorithm logic
                this._doProcessBlock(dataWords, offset);
              }

              // Remove processed words
              var processedWords = dataWords.splice(0, nWordsReady);
              data.sigBytes -= nBytesReady;
            }

            // Return processed words
            return new WordArray.init(processedWords, nBytesReady);
          },

          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var clone = Base.clone.call(this);
            clone._data = this._data.clone();

            return clone;
          },

          _minBufferSize: 0
        });

        /**
         * Abstract hasher template.
         *
         * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
         */
        var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
          /**
           * Configuration options.
           */
          cfg: Base.extend(),

          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(cfg) {
            // Apply config defaults
            this.cfg = this.cfg.extend(cfg);

            // Set initial values
            this.reset();
          },

          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            // Reset data buffer
            BufferedBlockAlgorithm.reset.call(this);

            // Perform concrete-hasher logic
            this._doReset();
          },

          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(messageUpdate) {
            // Append
            this._append(messageUpdate);

            // Update the hash
            this._process();

            // Chainable
            return this;
          },

          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(messageUpdate) {
            // Final message update
            if (messageUpdate) {
              this._append(messageUpdate);
            }

            // Perform concrete-hasher logic
            var hash = this._doFinalize();

            return hash;
          },

          blockSize: 512 / 32,

          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(hasher) {
            return function(message, cfg) {
              return new hasher.init(cfg).finalize(message);
            };
          },

          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(hasher) {
            return function(message, key) {
              return new C_algo.HMAC.init(hasher, key).finalize(message);
            };
          }
        });

        /**
         * Algorithm namespace.
         */
        var C_algo = C.algo = {};

        return C;
      }(Math));
      return CryptoJS;
    }

    function sha256(CryptoJS) {

      (function(Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Initialization and round constants tables
        var H = [];
        var K = [];

        // Compute constants
        (function() {
          function isPrime(n) {
            var sqrtN = Math.sqrt(n);
            for (var factor = 2; factor <= sqrtN; factor++) {
              if (!(n % factor)) {
                return false;
              }
            }

            return true;
          }

          function getFractionalBits(n) {
            return ((n - (n | 0)) * 0x100000000) | 0;
          }

          var n = 2;
          var nPrime = 0;
          while (nPrime < 64) {
            if (isPrime(n)) {
              if (nPrime < 8) {
                H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
              }
              K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

              nPrime++;
            }

            n++;
          }
        }());

        // Reusable object
        var W = [];

        /**
         * SHA-256 hash algorithm.
         */
        var SHA256 = C_algo.SHA256 = Hasher.extend({
          _doReset: function() {
            this._hash = new WordArray.init(H.slice(0));
          },

          _doProcessBlock: function(M, offset) {
            // Shortcut
            var H = this._hash.words;

            // Working variables
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];
            var f = H[5];
            var g = H[6];
            var h = H[7];

            // Computation
            for (var i = 0; i < 64; i++) {
              if (i < 16) {
                W[i] = M[offset + i] | 0;
              }
              else {
                var gamma0x = W[i - 15];
                var gamma0 = ((gamma0x << 25) | (gamma0x >>> 7)) ^
                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
                  (gamma0x >>> 3);

                var gamma1x = W[i - 2];
                var gamma1 = ((gamma1x << 15) | (gamma1x >>> 17)) ^
                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
                  (gamma1x >>> 10);

                W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
              }

              var ch = (e & f) ^ (~e & g);
              var maj = (a & b) ^ (a & c) ^ (b & c);

              var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
              var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7) | (e >>> 25));

              var t1 = h + sigma1 + ch + K[i] + W[i];
              var t2 = sigma0 + maj;

              h = g;
              g = f;
              f = e;
              e = (d + t1) | 0;
              d = c;
              c = b;
              b = a;
              a = (t1 + t2) | 0;
            }

            // Intermediate hash value
            H[0] = (H[0] + a) | 0;
            H[1] = (H[1] + b) | 0;
            H[2] = (H[2] + c) | 0;
            H[3] = (H[3] + d) | 0;
            H[4] = (H[4] + e) | 0;
            H[5] = (H[5] + f) | 0;
            H[6] = (H[6] + g) | 0;
            H[7] = (H[7] + h) | 0;
          },

          _doFinalize: function() {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Return final computed hash
            return this._hash;
          },

          clone: function() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });

        C.SHA256 = Hasher._createHelper(SHA256);

        C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
      }(Math));


      return CryptoJS.SHA256;

    }

    function hmac(CryptoJS) {

      (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;

        /**
         * HMAC algorithm.
         */
        var HMAC = C_algo.HMAC = Base.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(hasher, key) {
            // Init hasher
            hasher = this._hasher = new hasher.init();

            // Convert string to WordArray, else assume WordArray already
            if (typeof key == 'string') {
              key = Utf8.parse(key);
            }

            // Shortcuts
            var hasherBlockSize = hasher.blockSize;
            var hasherBlockSizeBytes = hasherBlockSize * 4;

            // Allow arbitrary length keys
            if (key.sigBytes > hasherBlockSizeBytes) {
              key = hasher.finalize(key);
            }

            // Clamp excess bits
            key.clamp();

            // Clone key for inner and outer pads
            var oKey = this._oKey = key.clone();
            var iKey = this._iKey = key.clone();

            // Shortcuts
            var oKeyWords = oKey.words;
            var iKeyWords = iKey.words;

            // XOR keys with pad constants
            for (var i = 0; i < hasherBlockSize; i++) {
              oKeyWords[i] ^= 0x5c5c5c5c;
              iKeyWords[i] ^= 0x36363636;
            }
            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

            // Set initial values
            this.reset();
          },

          reset: function() {
            // Shortcut
            var hasher = this._hasher;

            // Reset
            hasher.reset();
            hasher.update(this._iKey);
          },

          update: function(messageUpdate) {
            this._hasher.update(messageUpdate);

            // Chainable
            return this;
          },

          finalize: function(messageUpdate) {
            // Shortcut
            var hasher = this._hasher;

            // Compute HMAC
            var innerHash = hasher.finalize(messageUpdate);
            hasher.reset();
            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

            return hmac;
          }
        });
      }());


    }

    function aes(CryptoJS) {

      /**
       * CryptoJS core components.
       */
      var CryptoJS = CryptoJS || (function (Math, undefined) {
        /*
	     * Local polyfil of Object.create
	     */
        var create = Object.create || (function () {
          function F() {};

          return function (obj) {
            var subtype;

            F.prototype = obj;

            subtype = new F();

            F.prototype = null;

            return subtype;
          };
        }());

        /**
         * CryptoJS namespace.
         */
        var C = {};

        /**
         * Library namespace.
         */
        var C_lib = C.lib = {};

        /**
         * Base object for prototypal inheritance.
         */
        var Base = C_lib.Base = (function () {


          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function (overrides) {
              // Spawn
              var subtype = create(this);

              // Augment
              if (overrides) {
                subtype.mixIn(overrides);
              }

              // Create default initializer
              if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
                subtype.init = function () {
                  subtype.$super.init.apply(this, arguments);
                };
              }

              // Initializer's prototype is the subtype object
              subtype.init.prototype = subtype;

              // Reference supertype
              subtype.$super = this;

              return subtype;
            },

            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function () {
              var instance = this.extend();
              instance.init.apply(instance, arguments);

              return instance;
            },

            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function () {
            },

            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function (properties) {
              for (var propertyName in properties) {
                if (properties.hasOwnProperty(propertyName)) {
                  this[propertyName] = properties[propertyName];
                }
              }

              // IE won't copy toString using the loop above
              if (properties.hasOwnProperty('toString')) {
                this.toString = properties.toString;
              }
            },

            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function () {
              return this.init.prototype.extend(this);
            }
          };
        }());

        /**
         * An array of 32-bit words.
         *
         * @property {Array} words The array of 32-bit words.
         * @property {number} sigBytes The number of significant bytes in this word array.
         */
        var WordArray = C_lib.WordArray = Base.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function (words, sigBytes) {
            words = this.words = words || [];

            if (sigBytes != undefined) {
              this.sigBytes = sigBytes;
            } else {
              this.sigBytes = words.length * 4;
            }
          },

          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function (encoder) {
            return (encoder || Hex).stringify(this);
          },

          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function (wordArray) {
            // Shortcuts
            var thisWords = this.words;
            var thatWords = wordArray.words;
            var thisSigBytes = this.sigBytes;
            var thatSigBytes = wordArray.sigBytes;

            // Clamp excess bits
            this.clamp();

            // Concat
            if (thisSigBytes % 4) {
              // Copy one byte at a time
              for (var i = 0; i < thatSigBytes; i++) {
                var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
              }
            } else {
              // Copy one word at a time
              for (var i = 0; i < thatSigBytes; i += 4) {
                thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
              }
            }
            this.sigBytes += thatSigBytes;

            // Chainable
            return this;
          },

          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function () {
            // Shortcuts
            var words = this.words;
            var sigBytes = this.sigBytes;

            // Clamp
            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
            words.length = Math.ceil(sigBytes / 4);
          },

          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function () {
            var clone = Base.clone.call(this);
            clone.words = this.words.slice(0);

            return clone;
          },

          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function (nBytes) {
            var words = [];

            var r = (function (m_w) {
              var m_w = m_w;
              var m_z = 0x3ade68b1;
              var mask = 0xffffffff;

              return function () {
                m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
                m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
                var result = ((m_z << 0x10) + m_w) & mask;
                result /= 0x100000000;
                result += 0.5;
                return result * (Math.random() > .5 ? 1 : -1);
              }
            });

            for (var i = 0, rcache; i < nBytes; i += 4) {
              var _r = r((rcache || Math.random()) * 0x100000000);

              rcache = _r() * 0x3ade67b7;
              words.push((_r() * 0x100000000) | 0);
            }

            return new WordArray.init(words, nBytes);
          }
        });

        /**
         * Encoder namespace.
         */
        var C_enc = C.enc = {};

        /**
         * Hex encoding strategy.
         */
        var Hex = C_enc.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var hexChars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              hexChars.push((bite >>> 4).toString(16));
              hexChars.push((bite & 0x0f).toString(16));
            }

            return hexChars.join('');
          },

          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function (hexStr) {
            // Shortcut
            var hexStrLength = hexStr.length;

            // Convert
            var words = [];
            for (var i = 0; i < hexStrLength; i += 2) {
              words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
            }

            return new WordArray.init(words, hexStrLength / 2);
          }
        };

        /**
         * Latin1 encoding strategy.
         */
        var Latin1 = C_enc.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var latin1Chars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              latin1Chars.push(String.fromCharCode(bite));
            }

            return latin1Chars.join('');
          },

          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function (latin1Str) {
            // Shortcut
            var latin1StrLength = latin1Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < latin1StrLength; i++) {
              words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
            }

            return new WordArray.init(words, latin1StrLength);
          }
        };

        /**
         * UTF-8 encoding strategy.
         */
        var Utf8 = C_enc.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function (wordArray) {
            try {
              return decodeURIComponent(escape(Latin1.stringify(wordArray)));
            } catch (e) {
              throw new Error('Malformed UTF-8 data');
            }
          },

          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function (utf8Str) {
            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
          }
        };

        /**
         * Abstract buffered block algorithm template.
         *
         * The property blockSize must be implemented in a concrete subtype.
         *
         * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
         */
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function () {
            // Initial values
            this._data = new WordArray.init();
            this._nDataBytes = 0;
          },

          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function (data) {
            // Convert string to WordArray, else assume WordArray already
            if (typeof data == 'string') {
              data = Utf8.parse(data);
            }

            // Append
            this._data.concat(data);
            this._nDataBytes += data.sigBytes;
          },

          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function (doFlush) {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;
            var dataSigBytes = data.sigBytes;
            var blockSize = this.blockSize;
            var blockSizeBytes = blockSize * 4;

            // Count blocks ready
            var nBlocksReady = dataSigBytes / blockSizeBytes;
            if (doFlush) {
              // Round up to include partial blocks
              nBlocksReady = Math.ceil(nBlocksReady);
            } else {
              // Round down to include only full blocks,
              // less the number of blocks that must remain in the buffer
              nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
            }

            // Count words ready
            var nWordsReady = nBlocksReady * blockSize;

            // Count bytes ready
            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

            // Process blocks
            if (nWordsReady) {
              for (var offset = 0; offset < nWordsReady; offset += blockSize) {
                // Perform concrete-algorithm logic
                this._doProcessBlock(dataWords, offset);
              }

              // Remove processed words
              var processedWords = dataWords.splice(0, nWordsReady);
              data.sigBytes -= nBytesReady;
            }

            // Return processed words
            return new WordArray.init(processedWords, nBytesReady);
          },

          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function () {
            var clone = Base.clone.call(this);
            clone._data = this._data.clone();

            return clone;
          },

          _minBufferSize: 0
        });

        /**
         * Abstract hasher template.
         *
         * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
         */
        var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
          /**
           * Configuration options.
           */
          cfg: Base.extend(),

          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function (cfg) {
            // Apply config defaults
            this.cfg = this.cfg.extend(cfg);

            // Set initial values
            this.reset();
          },

          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function () {
            // Reset data buffer
            BufferedBlockAlgorithm.reset.call(this);

            // Perform concrete-hasher logic
            this._doReset();
          },

          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function (messageUpdate) {
            // Append
            this._append(messageUpdate);

            // Update the hash
            this._process();

            // Chainable
            return this;
          },

          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function (messageUpdate) {
            // Final message update
            if (messageUpdate) {
              this._append(messageUpdate);
            }

            // Perform concrete-hasher logic
            var hash = this._doFinalize();

            return hash;
          },

          blockSize: 512/32,

          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function (hasher) {
            return function (message, cfg) {
              return new hasher.init(cfg).finalize(message);
            };
          },

          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function (hasher) {
            return function (message, key) {
              return new C_algo.HMAC.init(hasher, key).finalize(message);
            };
          }
        });

        /**
         * Algorithm namespace.
         */
        var C_algo = C.algo = {};

        return C;
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;

        /**
         * Base64 encoding strategy.
         */
        var Base64 = C_enc.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var map = this._map;

            // Clamp excess bits
            wordArray.clamp();

            // Convert
            var base64Chars = [];
            for (var i = 0; i < sigBytes; i += 3) {
              var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
              var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
              var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

              var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

              for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
                base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
              }
            }

            // Add padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              while (base64Chars.length % 4) {
                base64Chars.push(paddingChar);
              }
            }

            return base64Chars.join('');
          },

          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function (base64Str) {
            // Shortcuts
            var base64StrLength = base64Str.length;
            var map = this._map;
            var reverseMap = this._reverseMap;

            if (!reverseMap) {
              reverseMap = this._reverseMap = [];
              for (var j = 0; j < map.length; j++) {
                reverseMap[map.charCodeAt(j)] = j;
              }
            }

            // Ignore padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              var paddingIndex = base64Str.indexOf(paddingChar);
              if (paddingIndex !== -1) {
                base64StrLength = paddingIndex;
              }
            }

            // Convert
            return parseLoop(base64Str, base64StrLength, reverseMap);

          },

          _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };

        function parseLoop(base64Str, base64StrLength, reverseMap) {
          var words = [];
          var nBytes = 0;
          for (var i = 0; i < base64StrLength; i++) {
            if (i % 4) {
              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
              nBytes++;
            }
          }
          return WordArray.create(words, nBytes);
        }
      }());


      (function (Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Constants table
        var T = [];

        // Compute constants
        (function () {
          for (var i = 0; i < 64; i++) {
            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
          }
        }());

        /**
         * MD5 hash algorithm.
         */
        var MD5 = C_algo.MD5 = Hasher.extend({
          _doReset: function () {
            this._hash = new WordArray.init([
              0x67452301, 0xefcdab89,
              0x98badcfe, 0x10325476
            ]);
          },

          _doProcessBlock: function (M, offset) {
            // Swap endian
            for (var i = 0; i < 16; i++) {
              // Shortcuts
              var offset_i = offset + i;
              var M_offset_i = M[offset_i];

              M[offset_i] = (
                (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
                (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
              );
            }

            // Shortcuts
            var H = this._hash.words;

            var M_offset_0  = M[offset + 0];
            var M_offset_1  = M[offset + 1];
            var M_offset_2  = M[offset + 2];
            var M_offset_3  = M[offset + 3];
            var M_offset_4  = M[offset + 4];
            var M_offset_5  = M[offset + 5];
            var M_offset_6  = M[offset + 6];
            var M_offset_7  = M[offset + 7];
            var M_offset_8  = M[offset + 8];
            var M_offset_9  = M[offset + 9];
            var M_offset_10 = M[offset + 10];
            var M_offset_11 = M[offset + 11];
            var M_offset_12 = M[offset + 12];
            var M_offset_13 = M[offset + 13];
            var M_offset_14 = M[offset + 14];
            var M_offset_15 = M[offset + 15];

            // Working varialbes
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];

            // Computation
            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
            d = II(d, a, b, c, M_offset_7,  10, T[49]);
            c = II(c, d, a, b, M_offset_14, 15, T[50]);
            b = II(b, c, d, a, M_offset_5,  21, T[51]);
            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
            d = II(d, a, b, c, M_offset_3,  10, T[53]);
            c = II(c, d, a, b, M_offset_10, 15, T[54]);
            b = II(b, c, d, a, M_offset_1,  21, T[55]);
            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
            d = II(d, a, b, c, M_offset_15, 10, T[57]);
            c = II(c, d, a, b, M_offset_6,  15, T[58]);
            b = II(b, c, d, a, M_offset_13, 21, T[59]);
            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
            d = II(d, a, b, c, M_offset_11, 10, T[61]);
            c = II(c, d, a, b, M_offset_2,  15, T[62]);
            b = II(b, c, d, a, M_offset_9,  21, T[63]);

            // Intermediate hash value
            H[0] = (H[0] + a) | 0;
            H[1] = (H[1] + b) | 0;
            H[2] = (H[2] + c) | 0;
            H[3] = (H[3] + d) | 0;
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
            var nBitsTotalL = nBitsTotal;
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
              (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
              (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
            );
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
              (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
              (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
            );

            data.sigBytes = (dataWords.length + 1) * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var hash = this._hash;
            var H = hash.words;

            // Swap endian
            for (var i = 0; i < 4; i++) {
              // Shortcut
              var H_i = H[i];

              H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
                (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
            }

            // Return final computed hash
            return hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });

        function FF(a, b, c, d, x, s, t) {
          var n = a + ((b & c) | (~b & d)) + x + t;
          return ((n << s) | (n >>> (32 - s))) + b;
        }

        function GG(a, b, c, d, x, s, t) {
          var n = a + ((b & d) | (c & ~d)) + x + t;
          return ((n << s) | (n >>> (32 - s))) + b;
        }

        function HH(a, b, c, d, x, s, t) {
          var n = a + (b ^ c ^ d) + x + t;
          return ((n << s) | (n >>> (32 - s))) + b;
        }

        function II(a, b, c, d, x, s, t) {
          var n = a + (c ^ (b | ~d)) + x + t;
          return ((n << s) | (n >>> (32 - s))) + b;
        }

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.MD5('message');
         *     var hash = CryptoJS.MD5(wordArray);
         */
        C.MD5 = Hasher._createHelper(MD5);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacMD5(message, key);
         */
        C.HmacMD5 = Hasher._createHmacHelper(MD5);
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Reusable object
        var W = [];

        /**
         * SHA-1 hash algorithm.
         */
        var SHA1 = C_algo.SHA1 = Hasher.extend({
          _doReset: function () {
            this._hash = new WordArray.init([
              0x67452301, 0xefcdab89,
              0x98badcfe, 0x10325476,
              0xc3d2e1f0
            ]);
          },

          _doProcessBlock: function (M, offset) {
            // Shortcut
            var H = this._hash.words;

            // Working variables
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];

            // Computation
            for (var i = 0; i < 80; i++) {
              if (i < 16) {
                W[i] = M[offset + i] | 0;
              } else {
                var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                W[i] = (n << 1) | (n >>> 31);
              }

              var t = ((a << 5) | (a >>> 27)) + e + W[i];
              if (i < 20) {
                t += ((b & c) | (~b & d)) + 0x5a827999;
              } else if (i < 40) {
                t += (b ^ c ^ d) + 0x6ed9eba1;
              } else if (i < 60) {
                t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
              } else /* if (i < 80) */ {
                t += (b ^ c ^ d) - 0x359d3e2a;
              }

              e = d;
              d = c;
              c = (b << 30) | (b >>> 2);
              b = a;
              a = t;
            }

            // Intermediate hash value
            H[0] = (H[0] + a) | 0;
            H[1] = (H[1] + b) | 0;
            H[2] = (H[2] + c) | 0;
            H[3] = (H[3] + d) | 0;
            H[4] = (H[4] + e) | 0;
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Return final computed hash
            return this._hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA1('message');
         *     var hash = CryptoJS.SHA1(wordArray);
         */
        C.SHA1 = Hasher._createHelper(SHA1);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA1(message, key);
         */
        C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
      }());


      (function (Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Initialization and round constants tables
        var H = [];
        var K = [];

        // Compute constants
        (function () {
          function isPrime(n) {
            var sqrtN = Math.sqrt(n);
            for (var factor = 2; factor <= sqrtN; factor++) {
              if (!(n % factor)) {
                return false;
              }
            }

            return true;
          }

          function getFractionalBits(n) {
            return ((n - (n | 0)) * 0x100000000) | 0;
          }

          var n = 2;
          var nPrime = 0;
          while (nPrime < 64) {
            if (isPrime(n)) {
              if (nPrime < 8) {
                H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
              }
              K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

              nPrime++;
            }

            n++;
          }
        }());

        // Reusable object
        var W = [];

        /**
         * SHA-256 hash algorithm.
         */
        var SHA256 = C_algo.SHA256 = Hasher.extend({
          _doReset: function () {
            this._hash = new WordArray.init(H.slice(0));
          },

          _doProcessBlock: function (M, offset) {
            // Shortcut
            var H = this._hash.words;

            // Working variables
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];
            var f = H[5];
            var g = H[6];
            var h = H[7];

            // Computation
            for (var i = 0; i < 64; i++) {
              if (i < 16) {
                W[i] = M[offset + i] | 0;
              } else {
                var gamma0x = W[i - 15];
                var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
                  (gamma0x >>> 3);

                var gamma1x = W[i - 2];
                var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
                  (gamma1x >>> 10);

                W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
              }

              var ch  = (e & f) ^ (~e & g);
              var maj = (a & b) ^ (a & c) ^ (b & c);

              var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
              var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

              var t1 = h + sigma1 + ch + K[i] + W[i];
              var t2 = sigma0 + maj;

              h = g;
              g = f;
              f = e;
              e = (d + t1) | 0;
              d = c;
              c = b;
              b = a;
              a = (t1 + t2) | 0;
            }

            // Intermediate hash value
            H[0] = (H[0] + a) | 0;
            H[1] = (H[1] + b) | 0;
            H[2] = (H[2] + c) | 0;
            H[3] = (H[3] + d) | 0;
            H[4] = (H[4] + e) | 0;
            H[5] = (H[5] + f) | 0;
            H[6] = (H[6] + g) | 0;
            H[7] = (H[7] + h) | 0;
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Return final computed hash
            return this._hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA256('message');
         *     var hash = CryptoJS.SHA256(wordArray);
         */
        C.SHA256 = Hasher._createHelper(SHA256);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA256(message, key);
         */
        C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;

        /**
         * UTF-16 BE encoding strategy.
         */
        var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var utf16Chars = [];
            for (var i = 0; i < sigBytes; i += 2) {
              var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
              utf16Chars.push(String.fromCharCode(codePoint));
            }

            return utf16Chars.join('');
          },

          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function (utf16Str) {
            // Shortcut
            var utf16StrLength = utf16Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < utf16StrLength; i++) {
              words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
            }

            return WordArray.create(words, utf16StrLength * 2);
          }
        };

        /**
         * UTF-16 LE encoding strategy.
         */
        C_enc.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var utf16Chars = [];
            for (var i = 0; i < sigBytes; i += 2) {
              var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
              utf16Chars.push(String.fromCharCode(codePoint));
            }

            return utf16Chars.join('');
          },

          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function (utf16Str) {
            // Shortcut
            var utf16StrLength = utf16Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < utf16StrLength; i++) {
              words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
            }

            return WordArray.create(words, utf16StrLength * 2);
          }
        };

        function swapEndian(word) {
          return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
        }
      }());


      (function () {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') {
          return;
        }

        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;

        // Reference original init
        var superInit = WordArray.init;

        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function (typedArray) {
          // Convert buffers to uint8
          if (typedArray instanceof ArrayBuffer) {
            typedArray = new Uint8Array(typedArray);
          }

          // Convert other array views to uint8
          if (
            typedArray instanceof Int8Array ||
            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
            typedArray instanceof Int16Array ||
            typedArray instanceof Uint16Array ||
            typedArray instanceof Int32Array ||
            typedArray instanceof Uint32Array ||
            typedArray instanceof Float32Array ||
            typedArray instanceof Float64Array
          ) {
            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
          }

          // Handle Uint8Array
          if (typedArray instanceof Uint8Array) {
            // Shortcut
            var typedArrayByteLength = typedArray.byteLength;

            // Extract bytes
            var words = [];
            for (var i = 0; i < typedArrayByteLength; i++) {
              words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
            }

            // Initialize this word array
            superInit.call(this, words, typedArrayByteLength);
          } else {
            // Else call normal init
            superInit.apply(this, arguments);
          }
        };

        subInit.prototype = WordArray;
      }());


      /** @preserve
       (c) 2012 by Cédric Mesnil. All rights reserved.

       Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

       - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
       - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

       THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
       */

      (function (Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Constants table
        var _zl = WordArray.create([
          0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
          7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
          3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
          1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
          4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
        var _zr = WordArray.create([
          5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
          6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
          15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
          8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
          12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
        var _sl = WordArray.create([
          11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
          7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
          11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
          9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
        var _sr = WordArray.create([
          8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
          9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
          9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
          15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
          8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

        var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
        var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

        /**
         * RIPEMD160 hash algorithm.
         */
        var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
          _doReset: function () {
            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
          },

          _doProcessBlock: function (M, offset) {

            // Swap endian
            for (var i = 0; i < 16; i++) {
              // Shortcuts
              var offset_i = offset + i;
              var M_offset_i = M[offset_i];

              // Swap
              M[offset_i] = (
                (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
                (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
              );
            }
            // Shortcut
            var H  = this._hash.words;
            var hl = _hl.words;
            var hr = _hr.words;
            var zl = _zl.words;
            var zr = _zr.words;
            var sl = _sl.words;
            var sr = _sr.words;

            // Working variables
            var al, bl, cl, dl, el;
            var ar, br, cr, dr, er;

            ar = al = H[0];
            br = bl = H[1];
            cr = cl = H[2];
            dr = dl = H[3];
            er = el = H[4];
            // Computation
            var t;
            for (var i = 0; i < 80; i += 1) {
              t = (al +  M[offset+zl[i]])|0;
              if (i<16){
                t +=  f1(bl,cl,dl) + hl[0];
              } else if (i<32) {
                t +=  f2(bl,cl,dl) + hl[1];
              } else if (i<48) {
                t +=  f3(bl,cl,dl) + hl[2];
              } else if (i<64) {
                t +=  f4(bl,cl,dl) + hl[3];
              } else {// if (i<80) {
                t +=  f5(bl,cl,dl) + hl[4];
              }
              t = t|0;
              t =  rotl(t,sl[i]);
              t = (t+el)|0;
              al = el;
              el = dl;
              dl = rotl(cl, 10);
              cl = bl;
              bl = t;

              t = (ar + M[offset+zr[i]])|0;
              if (i<16){
                t +=  f5(br,cr,dr) + hr[0];
              } else if (i<32) {
                t +=  f4(br,cr,dr) + hr[1];
              } else if (i<48) {
                t +=  f3(br,cr,dr) + hr[2];
              } else if (i<64) {
                t +=  f2(br,cr,dr) + hr[3];
              } else {// if (i<80) {
                t +=  f1(br,cr,dr) + hr[4];
              }
              t = t|0;
              t =  rotl(t,sr[i]) ;
              t = (t+er)|0;
              ar = er;
              er = dr;
              dr = rotl(cr, 10);
              cr = br;
              br = t;
            }
            // Intermediate hash value
            t    = (H[1] + cl + dr)|0;
            H[1] = (H[2] + dl + er)|0;
            H[2] = (H[3] + el + ar)|0;
            H[3] = (H[4] + al + br)|0;
            H[4] = (H[0] + bl + cr)|0;
            H[0] =  t;
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
              (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
              (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
            );
            data.sigBytes = (dataWords.length + 1) * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var hash = this._hash;
            var H = hash.words;

            // Swap endian
            for (var i = 0; i < 5; i++) {
              // Shortcut
              var H_i = H[i];

              // Swap
              H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
                (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
            }

            // Return final computed hash
            return hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });


        function f1(x, y, z) {
          return ((x) ^ (y) ^ (z));

        }

        function f2(x, y, z) {
          return (((x)&(y)) | ((~x)&(z)));
        }

        function f3(x, y, z) {
          return (((x) | (~(y))) ^ (z));
        }

        function f4(x, y, z) {
          return (((x) & (z)) | ((y)&(~(z))));
        }

        function f5(x, y, z) {
          return ((x) ^ ((y) |(~(z))));

        }

        function rotl(x,n) {
          return (x<<n) | (x>>>(32-n));
        }


        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.RIPEMD160('message');
         *     var hash = CryptoJS.RIPEMD160(wordArray);
         */
        C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
         */
        C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;

        /**
         * HMAC algorithm.
         */
        var HMAC = C_algo.HMAC = Base.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function (hasher, key) {
            // Init hasher
            hasher = this._hasher = new hasher.init();

            // Convert string to WordArray, else assume WordArray already
            if (typeof key == 'string') {
              key = Utf8.parse(key);
            }

            // Shortcuts
            var hasherBlockSize = hasher.blockSize;
            var hasherBlockSizeBytes = hasherBlockSize * 4;

            // Allow arbitrary length keys
            if (key.sigBytes > hasherBlockSizeBytes) {
              key = hasher.finalize(key);
            }

            // Clamp excess bits
            key.clamp();

            // Clone key for inner and outer pads
            var oKey = this._oKey = key.clone();
            var iKey = this._iKey = key.clone();

            // Shortcuts
            var oKeyWords = oKey.words;
            var iKeyWords = iKey.words;

            // XOR keys with pad constants
            for (var i = 0; i < hasherBlockSize; i++) {
              oKeyWords[i] ^= 0x5c5c5c5c;
              iKeyWords[i] ^= 0x36363636;
            }
            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

            // Set initial values
            this.reset();
          },

          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function () {
            // Shortcut
            var hasher = this._hasher;

            // Reset
            hasher.reset();
            hasher.update(this._iKey);
          },

          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function (messageUpdate) {
            this._hasher.update(messageUpdate);

            // Chainable
            return this;
          },

          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function (messageUpdate) {
            // Shortcut
            var hasher = this._hasher;

            // Compute HMAC
            var innerHash = hasher.finalize(messageUpdate);
            hasher.reset();
            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

            return hmac;
          }
        });
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA1 = C_algo.SHA1;
        var HMAC = C_algo.HMAC;

        /**
         * Password-Based Key Derivation Function 2 algorithm.
         */
        var PBKDF2 = C_algo.PBKDF2 = Base.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA1
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: Base.extend({
            keySize: 128/32,
            hasher: SHA1,
            iterations: 1
          }),

          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function (cfg) {
            this.cfg = this.cfg.extend(cfg);
          },

          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function (password, salt) {
            // Shortcut
            var cfg = this.cfg;

            // Init HMAC
            var hmac = HMAC.create(cfg.hasher, password);

            // Initial values
            var derivedKey = WordArray.create();
            var blockIndex = WordArray.create([0x00000001]);

            // Shortcuts
            var derivedKeyWords = derivedKey.words;
            var blockIndexWords = blockIndex.words;
            var keySize = cfg.keySize;
            var iterations = cfg.iterations;

            // Generate key
            while (derivedKeyWords.length < keySize) {
              var block = hmac.update(salt).finalize(blockIndex);
              hmac.reset();

              // Shortcuts
              var blockWords = block.words;
              var blockWordsLength = blockWords.length;

              // Iterations
              var intermediate = block;
              for (var i = 1; i < iterations; i++) {
                intermediate = hmac.finalize(intermediate);
                hmac.reset();

                // Shortcut
                var intermediateWords = intermediate.words;

                // XOR intermediate with block
                for (var j = 0; j < blockWordsLength; j++) {
                  blockWords[j] ^= intermediateWords[j];
                }
              }

              derivedKey.concat(block);
              blockIndexWords[0]++;
            }
            derivedKey.sigBytes = keySize * 4;

            return derivedKey;
          }
        });

        /**
         * Computes the Password-Based Key Derivation Function 2.
         *
         * @param {WordArray|string} password The password.
         * @param {WordArray|string} salt A salt.
         * @param {Object} cfg (Optional) The configuration options to use for this computation.
         *
         * @return {WordArray} The derived key.
         *
         * @static
         *
         * @example
         *
         *     var key = CryptoJS.PBKDF2(password, salt);
         *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
         *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
         */
        C.PBKDF2 = function (password, salt, cfg) {
          return PBKDF2.create(cfg).compute(password, salt);
        };
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;

        /**
         * This key derivation function is meant to conform with EVP_BytesToKey.
         * www.openssl.org/docs/crypto/EVP_BytesToKey.html
         */
        var EvpKDF = C_algo.EvpKDF = Base.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: Base.extend({
            keySize: 128/32,
            hasher: MD5,
            iterations: 1
          }),

          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function (cfg) {
            this.cfg = this.cfg.extend(cfg);
          },

          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function (password, salt) {
            // Shortcut
            var cfg = this.cfg;

            // Init hasher
            var hasher = cfg.hasher.create();

            // Initial values
            var derivedKey = WordArray.create();

            // Shortcuts
            var derivedKeyWords = derivedKey.words;
            var keySize = cfg.keySize;
            var iterations = cfg.iterations;

            // Generate key
            while (derivedKeyWords.length < keySize) {
              if (block) {
                hasher.update(block);
              }
              var block = hasher.update(password).finalize(salt);
              hasher.reset();

              // Iterations
              for (var i = 1; i < iterations; i++) {
                block = hasher.finalize(block);
                hasher.reset();
              }

              derivedKey.concat(block);
            }
            derivedKey.sigBytes = keySize * 4;

            return derivedKey;
          }
        });

        /**
         * Derives a key from a password.
         *
         * @param {WordArray|string} password The password.
         * @param {WordArray|string} salt A salt.
         * @param {Object} cfg (Optional) The configuration options to use for this computation.
         *
         * @return {WordArray} The derived key.
         *
         * @static
         *
         * @example
         *
         *     var key = CryptoJS.EvpKDF(password, salt);
         *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
         *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
         */
        C.EvpKDF = function (password, salt, cfg) {
          return EvpKDF.create(cfg).compute(password, salt);
        };
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;

        /**
         * SHA-224 hash algorithm.
         */
        var SHA224 = C_algo.SHA224 = SHA256.extend({
          _doReset: function () {
            this._hash = new WordArray.init([
              0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
              0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
            ]);
          },

          _doFinalize: function () {
            var hash = SHA256._doFinalize.call(this);

            hash.sigBytes -= 4;

            return hash;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA224('message');
         *     var hash = CryptoJS.SHA224(wordArray);
         */
        C.SHA224 = SHA256._createHelper(SHA224);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA224(message, key);
         */
        C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
      }());


      (function (undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;

        /**
         * x64 namespace.
         */
        var C_x64 = C.x64 = {};

        /**
         * A 64-bit word.
         */
        var X64Word = C_x64.Word = Base.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function (high, low) {
            this.high = high;
            this.low = low;
          }

          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;

          // return X64Word.create(high, low);
          // },

          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;

          // return X64Word.create(high, low);
          // },

          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;

          // return X64Word.create(high, low);
          // },

          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;

          // return X64Word.create(high, low);
          // },

          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }

          // return X64Word.create(high, low);
          // },

          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }

          // return X64Word.create(high, low);
          // },

          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },

          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },

          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;

          // return X64Word.create(high, low);
          // }
        });

        /**
         * An array of 64-bit words.
         *
         * @property {Array} words The array of CryptoJS.x64.Word objects.
         * @property {number} sigBytes The number of significant bytes in this word array.
         */
        var X64WordArray = C_x64.WordArray = Base.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function (words, sigBytes) {
            words = this.words = words || [];

            if (sigBytes != undefined) {
              this.sigBytes = sigBytes;
            } else {
              this.sigBytes = words.length * 8;
            }
          },

          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function () {
            // Shortcuts
            var x64Words = this.words;
            var x64WordsLength = x64Words.length;

            // Convert
            var x32Words = [];
            for (var i = 0; i < x64WordsLength; i++) {
              var x64Word = x64Words[i];
              x32Words.push(x64Word.high);
              x32Words.push(x64Word.low);
            }

            return X32WordArray.create(x32Words, this.sigBytes);
          },

          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function () {
            var clone = Base.clone.call(this);

            // Clone "words" array
            var words = clone.words = this.words.slice(0);

            // Clone each X64Word object
            var wordsLength = words.length;
            for (var i = 0; i < wordsLength; i++) {
              words[i] = words[i].clone();
            }

            return clone;
          }
        });
      }());


      (function (Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;

        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES  = [];
        var ROUND_CONSTANTS = [];

        // Compute Constants
        (function () {
          // Compute rho offset constants
          var x = 1, y = 0;
          for (var t = 0; t < 24; t++) {
            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

            var newX = y % 5;
            var newY = (2 * x + 3 * y) % 5;
            x = newX;
            y = newY;
          }

          // Compute pi index constants
          for (var x = 0; x < 5; x++) {
            for (var y = 0; y < 5; y++) {
              PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
            }
          }

          // Compute round constants
          var LFSR = 0x01;
          for (var i = 0; i < 24; i++) {
            var roundConstantMsw = 0;
            var roundConstantLsw = 0;

            for (var j = 0; j < 7; j++) {
              if (LFSR & 0x01) {
                var bitPosition = (1 << j) - 1;
                if (bitPosition < 32) {
                  roundConstantLsw ^= 1 << bitPosition;
                } else /* if (bitPosition >= 32) */ {
                  roundConstantMsw ^= 1 << (bitPosition - 32);
                }
              }

              // Compute next LFSR
              if (LFSR & 0x80) {
                // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                LFSR = (LFSR << 1) ^ 0x71;
              } else {
                LFSR <<= 1;
              }
            }

            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
          }
        }());

        // Reusable objects for temporary values
        var T = [];
        (function () {
          for (var i = 0; i < 25; i++) {
            T[i] = X64Word.create();
          }
        }());

        /**
         * SHA-3 hash algorithm.
         */
        var SHA3 = C_algo.SHA3 = Hasher.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: Hasher.cfg.extend({
            outputLength: 512
          }),

          _doReset: function () {
            var state = this._state = []
            for (var i = 0; i < 25; i++) {
              state[i] = new X64Word.init();
            }

            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },

          _doProcessBlock: function (M, offset) {
            // Shortcuts
            var state = this._state;
            var nBlockSizeLanes = this.blockSize / 2;

            // Absorb
            for (var i = 0; i < nBlockSizeLanes; i++) {
              // Shortcuts
              var M2i  = M[offset + 2 * i];
              var M2i1 = M[offset + 2 * i + 1];

              // Swap endian
              M2i = (
                (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
                (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
              );
              M2i1 = (
                (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
                (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
              );

              // Absorb message into state
              var lane = state[i];
              lane.high ^= M2i1;
              lane.low  ^= M2i;
            }

            // Rounds
            for (var round = 0; round < 24; round++) {
              // Theta
              for (var x = 0; x < 5; x++) {
                // Mix column lanes
                var tMsw = 0, tLsw = 0;
                for (var y = 0; y < 5; y++) {
                  var lane = state[x + 5 * y];
                  tMsw ^= lane.high;
                  tLsw ^= lane.low;
                }

                // Temporary values
                var Tx = T[x];
                Tx.high = tMsw;
                Tx.low  = tLsw;
              }
              for (var x = 0; x < 5; x++) {
                // Shortcuts
                var Tx4 = T[(x + 4) % 5];
                var Tx1 = T[(x + 1) % 5];
                var Tx1Msw = Tx1.high;
                var Tx1Lsw = Tx1.low;

                // Mix surrounding columns
                var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
                var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
                for (var y = 0; y < 5; y++) {
                  var lane = state[x + 5 * y];
                  lane.high ^= tMsw;
                  lane.low  ^= tLsw;
                }
              }

              // Rho Pi
              for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
                // Shortcuts
                var lane = state[laneIndex];
                var laneMsw = lane.high;
                var laneLsw = lane.low;
                var rhoOffset = RHO_OFFSETS[laneIndex];

                // Rotate lanes
                if (rhoOffset < 32) {
                  var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
                  var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
                } else /* if (rhoOffset >= 32) */ {
                  var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
                  var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
                }

                // Transpose lanes
                var TPiLane = T[PI_INDEXES[laneIndex]];
                TPiLane.high = tMsw;
                TPiLane.low  = tLsw;
              }

              // Rho pi at x = y = 0
              var T0 = T[0];
              var state0 = state[0];
              T0.high = state0.high;
              T0.low  = state0.low;

              // Chi
              for (var x = 0; x < 5; x++) {
                for (var y = 0; y < 5; y++) {
                  // Shortcuts
                  var laneIndex = x + 5 * y;
                  var lane = state[laneIndex];
                  var TLane = T[laneIndex];
                  var Tx1Lane = T[((x + 1) % 5) + 5 * y];
                  var Tx2Lane = T[((x + 2) % 5) + 5 * y];

                  // Mix rows
                  lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
                  lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
                }
              }

              // Iota
              var lane = state[0];
              var roundConstant = ROUND_CONSTANTS[round];
              lane.high ^= roundConstant.high;
              lane.low  ^= roundConstant.low;;
            }
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;
            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;
            var blockSizeBits = this.blockSize * 32;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var state = this._state;
            var outputLengthBytes = this.cfg.outputLength / 8;
            var outputLengthLanes = outputLengthBytes / 8;

            // Squeeze
            var hashWords = [];
            for (var i = 0; i < outputLengthLanes; i++) {
              // Shortcuts
              var lane = state[i];
              var laneMsw = lane.high;
              var laneLsw = lane.low;

              // Swap endian
              laneMsw = (
                (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
                (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
              );
              laneLsw = (
                (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
                (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
              );

              // Squeeze state to retrieve hash
              hashWords.push(laneLsw);
              hashWords.push(laneMsw);
            }

            // Return final computed hash
            return new WordArray.init(hashWords, outputLengthBytes);
          },

          clone: function () {
            var clone = Hasher.clone.call(this);

            var state = clone._state = this._state.slice(0);
            for (var i = 0; i < 25; i++) {
              state[i] = state[i].clone();
            }

            return clone;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA3('message');
         *     var hash = CryptoJS.SHA3(wordArray);
         */
        C.SHA3 = Hasher._createHelper(SHA3);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA3(message, key);
         */
        C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;

        function X64Word_create() {
          return X64Word.create.apply(X64Word, arguments);
        }

        // Constants
        var K = [
          X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
          X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
          X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
          X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
          X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
          X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
          X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
          X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
          X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
          X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
          X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
          X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
          X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
          X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
          X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
          X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
          X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
          X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
          X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
          X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
          X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
          X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
          X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
          X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
          X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
          X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
          X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
          X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
          X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
          X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
          X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
          X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
          X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
          X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
          X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
          X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
          X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
          X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
          X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
          X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
        ];

        // Reusable objects
        var W = [];
        (function () {
          for (var i = 0; i < 80; i++) {
            W[i] = X64Word_create();
          }
        }());

        /**
         * SHA-512 hash algorithm.
         */
        var SHA512 = C_algo.SHA512 = Hasher.extend({
          _doReset: function () {
            this._hash = new X64WordArray.init([
              new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
              new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
              new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
              new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
            ]);
          },

          _doProcessBlock: function (M, offset) {
            // Shortcuts
            var H = this._hash.words;

            var H0 = H[0];
            var H1 = H[1];
            var H2 = H[2];
            var H3 = H[3];
            var H4 = H[4];
            var H5 = H[5];
            var H6 = H[6];
            var H7 = H[7];

            var H0h = H0.high;
            var H0l = H0.low;
            var H1h = H1.high;
            var H1l = H1.low;
            var H2h = H2.high;
            var H2l = H2.low;
            var H3h = H3.high;
            var H3l = H3.low;
            var H4h = H4.high;
            var H4l = H4.low;
            var H5h = H5.high;
            var H5l = H5.low;
            var H6h = H6.high;
            var H6l = H6.low;
            var H7h = H7.high;
            var H7l = H7.low;

            // Working variables
            var ah = H0h;
            var al = H0l;
            var bh = H1h;
            var bl = H1l;
            var ch = H2h;
            var cl = H2l;
            var dh = H3h;
            var dl = H3l;
            var eh = H4h;
            var el = H4l;
            var fh = H5h;
            var fl = H5l;
            var gh = H6h;
            var gl = H6l;
            var hh = H7h;
            var hl = H7l;

            // Rounds
            for (var i = 0; i < 80; i++) {
              // Shortcut
              var Wi = W[i];

              // Extend message
              if (i < 16) {
                var Wih = Wi.high = M[offset + i * 2]     | 0;
                var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
              } else {
                // Gamma0
                var gamma0x  = W[i - 15];
                var gamma0xh = gamma0x.high;
                var gamma0xl = gamma0x.low;
                var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
                var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

                // Gamma1
                var gamma1x  = W[i - 2];
                var gamma1xh = gamma1x.high;
                var gamma1xl = gamma1x.low;
                var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
                var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

                // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                var Wi7  = W[i - 7];
                var Wi7h = Wi7.high;
                var Wi7l = Wi7.low;

                var Wi16  = W[i - 16];
                var Wi16h = Wi16.high;
                var Wi16l = Wi16.low;

                var Wil = gamma0l + Wi7l;
                var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
                var Wil = Wil + gamma1l;
                var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
                var Wil = Wil + Wi16l;
                var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

                Wi.high = Wih;
                Wi.low  = Wil;
              }

              var chh  = (eh & fh) ^ (~eh & gh);
              var chl  = (el & fl) ^ (~el & gl);
              var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
              var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

              var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
              var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
              var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
              var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

              // t1 = h + sigma1 + ch + K[i] + W[i]
              var Ki  = K[i];
              var Kih = Ki.high;
              var Kil = Ki.low;

              var t1l = hl + sigma1l;
              var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
              var t1l = t1l + chl;
              var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
              var t1l = t1l + Kil;
              var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
              var t1l = t1l + Wil;
              var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

              // t2 = sigma0 + maj
              var t2l = sigma0l + majl;
              var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

              // Update working variables
              hh = gh;
              hl = gl;
              gh = fh;
              gl = fl;
              fh = eh;
              fl = el;
              el = (dl + t1l) | 0;
              eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
              dh = ch;
              dl = cl;
              ch = bh;
              cl = bl;
              bh = ah;
              bl = al;
              al = (t1l + t2l) | 0;
              ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
            }

            // Intermediate hash value
            H0l = H0.low  = (H0l + al);
            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
            H1l = H1.low  = (H1l + bl);
            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
            H2l = H2.low  = (H2l + cl);
            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
            H3l = H3.low  = (H3l + dl);
            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
            H4l = H4.low  = (H4l + el);
            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
            H5l = H5.low  = (H5l + fl);
            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
            H6l = H6.low  = (H6l + gl);
            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
            H7l = H7.low  = (H7l + hl);
            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Convert hash to 32-bit word array before returning
            var hash = this._hash.toX32();

            // Return final computed hash
            return hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          },

          blockSize: 1024/32
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA512('message');
         *     var hash = CryptoJS.SHA512(wordArray);
         */
        C.SHA512 = Hasher._createHelper(SHA512);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA512(message, key);
         */
        C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;

        /**
         * SHA-384 hash algorithm.
         */
        var SHA384 = C_algo.SHA384 = SHA512.extend({
          _doReset: function () {
            this._hash = new X64WordArray.init([
              new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
              new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
              new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
              new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
            ]);
          },

          _doFinalize: function () {
            var hash = SHA512._doFinalize.call(this);

            hash.sigBytes -= 16;

            return hash;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA384('message');
         *     var hash = CryptoJS.SHA384(wordArray);
         */
        C.SHA384 = SHA512._createHelper(SHA384);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA384(message, key);
         */
        C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
      }());


      /**
       * Cipher core components.
       */
      CryptoJS.lib.Cipher || (function (undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;

        /**
         * Abstract base cipher template.
         *
         * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
         * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
         * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
         * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
         */
        var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: Base.extend(),

          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function (key, cfg) {
            return this.create(this._ENC_XFORM_MODE, key, cfg);
          },

          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function (key, cfg) {
            return this.create(this._DEC_XFORM_MODE, key, cfg);
          },

          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function (xformMode, key, cfg) {
            // Apply config defaults
            this.cfg = this.cfg.extend(cfg);

            // Store transform mode and key
            this._xformMode = xformMode;
            this._key = key;

            // Set initial values
            this.reset();
          },

          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function () {
            // Reset data buffer
            BufferedBlockAlgorithm.reset.call(this);

            // Perform concrete-cipher logic
            this._doReset();
          },

          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function (dataUpdate) {
            // Append
            this._append(dataUpdate);

            // Process available blocks
            return this._process();
          },

          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function (dataUpdate) {
            // Final data update
            if (dataUpdate) {
              this._append(dataUpdate);
            }

            // Perform concrete-cipher logic
            var finalProcessedData = this._doFinalize();

            return finalProcessedData;
          },

          keySize: 128/32,

          ivSize: 128/32,

          _ENC_XFORM_MODE: 1,

          _DEC_XFORM_MODE: 2,

          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: (function () {
            function selectCipherStrategy(key) {
              if (typeof key == 'string') {
                return PasswordBasedCipher;
              } else {
                return SerializableCipher;
              }
            }

            return function (cipher) {
              return {
                encrypt: function (message, key, cfg) {
                  return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                },

                decrypt: function (ciphertext, key, cfg) {
                  return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                }
              };
            };
          }())
        });

        /**
         * Abstract base stream cipher template.
         *
         * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
         */
        var StreamCipher = C_lib.StreamCipher = Cipher.extend({
          _doFinalize: function () {
            // Process partial blocks
            var finalProcessedBlocks = this._process(!!'flush');

            return finalProcessedBlocks;
          },

          blockSize: 1
        });

        /**
         * Mode namespace.
         */
        var C_mode = C.mode = {};

        /**
         * Abstract base block cipher mode template.
         */
        var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function (cipher, iv) {
            return this.Encryptor.create(cipher, iv);
          },

          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function (cipher, iv) {
            return this.Decryptor.create(cipher, iv);
          },

          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function (cipher, iv) {
            this._cipher = cipher;
            this._iv = iv;
          }
        });

        /**
         * Cipher Block Chaining mode.
         */
        var CBC = C_mode.CBC = (function () {
          /**
           * Abstract base CBC mode.
           */
          var CBC = BlockCipherMode.extend();

          /**
           * CBC encryptor.
           */
          CBC.Encryptor = CBC.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function (words, offset) {
              // Shortcuts
              var cipher = this._cipher;
              var blockSize = cipher.blockSize;

              // XOR and encrypt
              xorBlock.call(this, words, offset, blockSize);
              cipher.encryptBlock(words, offset);

              // Remember this block to use with next block
              this._prevBlock = words.slice(offset, offset + blockSize);
            }
          });

          /**
           * CBC decryptor.
           */
          CBC.Decryptor = CBC.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function (words, offset) {
              // Shortcuts
              var cipher = this._cipher;
              var blockSize = cipher.blockSize;

              // Remember this block to use with next block
              var thisBlock = words.slice(offset, offset + blockSize);

              // Decrypt and XOR
              cipher.decryptBlock(words, offset);
              xorBlock.call(this, words, offset, blockSize);

              // This block becomes the previous block
              this._prevBlock = thisBlock;
            }
          });

          function xorBlock(words, offset, blockSize) {
            // Shortcut
            var iv = this._iv;

            // Choose mixing block
            if (iv) {
              var block = iv;

              // Remove IV for subsequent blocks
              this._iv = undefined;
            } else {
              var block = this._prevBlock;
            }

            // XOR blocks
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= block[i];
            }
          }

          return CBC;
        }());

        /**
         * Padding namespace.
         */
        var C_pad = C.pad = {};

        /**
         * PKCS #5/7 padding strategy.
         */
        var Pkcs7 = C_pad.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function (data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;

            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

            // Create padding word
            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

            // Create padding
            var paddingWords = [];
            for (var i = 0; i < nPaddingBytes; i += 4) {
              paddingWords.push(paddingWord);
            }
            var padding = WordArray.create(paddingWords, nPaddingBytes);

            // Add padding
            data.concat(padding);
          },

          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function (data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

            // Remove padding
            data.sigBytes -= nPaddingBytes;
          }
        };

        /**
         * Abstract base block cipher template.
         *
         * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
         */
        var BlockCipher = C_lib.BlockCipher = Cipher.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: Cipher.cfg.extend({
            mode: CBC,
            padding: Pkcs7
          }),

          reset: function () {
            // Reset cipher
            Cipher.reset.call(this);

            // Shortcuts
            var cfg = this.cfg;
            var iv = cfg.iv;
            var mode = cfg.mode;

            // Reset block mode
            if (this._xformMode == this._ENC_XFORM_MODE) {
              var modeCreator = mode.createEncryptor;
            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
              var modeCreator = mode.createDecryptor;
              // Keep at least one block in the buffer for unpadding
              this._minBufferSize = 1;
            }

            if (this._mode && this._mode.__creator == modeCreator) {
              this._mode.init(this, iv && iv.words);
            } else {
              this._mode = modeCreator.call(mode, this, iv && iv.words);
              this._mode.__creator = modeCreator;
            }
          },

          _doProcessBlock: function (words, offset) {
            this._mode.processBlock(words, offset);
          },

          _doFinalize: function () {
            // Shortcut
            var padding = this.cfg.padding;

            // Finalize
            if (this._xformMode == this._ENC_XFORM_MODE) {
              // Pad data
              padding.pad(this._data, this.blockSize);

              // Process final blocks
              var finalProcessedBlocks = this._process(!!'flush');
            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
              // Process final blocks
              var finalProcessedBlocks = this._process(!!'flush');

              // Unpad data
              padding.unpad(finalProcessedBlocks);
            }

            return finalProcessedBlocks;
          },

          blockSize: 128/32
        });

        /**
         * A collection of cipher parameters.
         *
         * @property {WordArray} ciphertext The raw ciphertext.
         * @property {WordArray} key The key to this ciphertext.
         * @property {WordArray} iv The IV used in the ciphering operation.
         * @property {WordArray} salt The salt used with a key derivation function.
         * @property {Cipher} algorithm The cipher algorithm.
         * @property {Mode} mode The block mode used in the ciphering operation.
         * @property {Padding} padding The padding scheme used in the ciphering operation.
         * @property {number} blockSize The block size of the cipher.
         * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
         */
        var CipherParams = C_lib.CipherParams = Base.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function (cipherParams) {
            this.mixIn(cipherParams);
          },

          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function (formatter) {
            return (formatter || this.formatter).stringify(this);
          }
        });

        /**
         * Format namespace.
         */
        var C_format = C.format = {};

        /**
         * OpenSSL formatting strategy.
         */
        var OpenSSLFormatter = C_format.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function (cipherParams) {
            // Shortcuts
            var ciphertext = cipherParams.ciphertext;
            var salt = cipherParams.salt;

            // Format
            if (salt) {
              var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
            } else {
              var wordArray = ciphertext;
            }

            return wordArray.toString(Base64);
          },

          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function (openSSLStr) {
            // Parse base64
            var ciphertext = Base64.parse(openSSLStr);

            // Shortcut
            var ciphertextWords = ciphertext.words;

            // Test for salt
            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
              // Extract salt
              var salt = WordArray.create(ciphertextWords.slice(2, 4));

              // Remove salt from ciphertext
              ciphertextWords.splice(0, 4);
              ciphertext.sigBytes -= 16;
            }

            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
          }
        };

        /**
         * A cipher wrapper that returns ciphertext as a serializable cipher params object.
         */
        var SerializableCipher = C_lib.SerializableCipher = Base.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: Base.extend({
            format: OpenSSLFormatter
          }),

          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function (cipher, message, key, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Encrypt
            var encryptor = cipher.createEncryptor(key, cfg);
            var ciphertext = encryptor.finalize(message);

            // Shortcut
            var cipherCfg = encryptor.cfg;

            // Create and return serializable cipher params
            return CipherParams.create({
              ciphertext: ciphertext,
              key: key,
              iv: cipherCfg.iv,
              algorithm: cipher,
              mode: cipherCfg.mode,
              padding: cipherCfg.padding,
              blockSize: cipher.blockSize,
              formatter: cfg.format
            });
          },

          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function (cipher, ciphertext, key, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Convert string to CipherParams
            ciphertext = this._parse(ciphertext, cfg.format);

            // Decrypt
            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

            return plaintext;
          },

          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function (ciphertext, format) {
            if (typeof ciphertext == 'string') {
              return format.parse(ciphertext, this);
            } else {
              return ciphertext;
            }
          }
        });

        /**
         * Key derivation function namespace.
         */
        var C_kdf = C.kdf = {};

        /**
         * OpenSSL key derivation function.
         */
        var OpenSSLKdf = C_kdf.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function (password, keySize, ivSize, salt) {
            // Generate random salt
            if (!salt) {
              salt = WordArray.random(64/8);
            }

            // Derive key and IV
            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

            // Separate key and IV
            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
            key.sigBytes = keySize * 4;

            // Return params
            return CipherParams.create({ key: key, iv: iv, salt: salt });
          }
        };

        /**
         * A serializable cipher wrapper that derives the key from a password,
         * and returns ciphertext as a serializable cipher params object.
         */
        var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: SerializableCipher.cfg.extend({
            kdf: OpenSSLKdf
          }),

          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function (cipher, message, password, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Derive key and other params
            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

            // Add IV to config
            cfg.iv = derivedParams.iv;

            // Encrypt
            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

            // Mix in derived params
            ciphertext.mixIn(derivedParams);

            return ciphertext;
          },

          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function (cipher, ciphertext, password, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Convert string to CipherParams
            ciphertext = this._parse(ciphertext, cfg.format);

            // Derive key and other params
            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

            // Add IV to config
            cfg.iv = derivedParams.iv;

            // Decrypt
            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

            return plaintext;
          }
        });
      }());


      /**
       * Cipher Feedback block mode.
       */
      CryptoJS.mode.CFB = (function () {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();

        CFB.Encryptor = CFB.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;

            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

            // Remember this block to use with next block
            this._prevBlock = words.slice(offset, offset + blockSize);
          }
        });

        CFB.Decryptor = CFB.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;

            // Remember this block to use with next block
            var thisBlock = words.slice(offset, offset + blockSize);

            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

            // This block becomes the previous block
            this._prevBlock = thisBlock;
          }
        });

        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
          // Shortcut
          var iv = this._iv;

          // Generate keystream
          if (iv) {
            var keystream = iv.slice(0);

            // Remove IV for subsequent blocks
            this._iv = undefined;
          } else {
            var keystream = this._prevBlock;
          }
          cipher.encryptBlock(keystream, 0);

          // Encrypt
          for (var i = 0; i < blockSize; i++) {
            words[offset + i] ^= keystream[i];
          }
        }

        return CFB;
      }());


      /**
       * Electronic Codebook block mode.
       */
      CryptoJS.mode.ECB = (function () {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();

        ECB.Encryptor = ECB.extend({
          processBlock: function (words, offset) {
            this._cipher.encryptBlock(words, offset);
          }
        });

        ECB.Decryptor = ECB.extend({
          processBlock: function (words, offset) {
            this._cipher.decryptBlock(words, offset);
          }
        });

        return ECB;
      }());


      /**
       * ANSI X.923 padding strategy.
       */
      CryptoJS.pad.AnsiX923 = {
        pad: function (data, blockSize) {
          // Shortcuts
          var dataSigBytes = data.sigBytes;
          var blockSizeBytes = blockSize * 4;

          // Count padding bytes
          var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

          // Compute last byte position
          var lastBytePos = dataSigBytes + nPaddingBytes - 1;

          // Pad
          data.clamp();
          data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
          data.sigBytes += nPaddingBytes;
        },

        unpad: function (data) {
          // Get number of padding bytes from last byte
          var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

          // Remove padding
          data.sigBytes -= nPaddingBytes;
        }
      };


      /**
       * ISO 10126 padding strategy.
       */
      CryptoJS.pad.Iso10126 = {
        pad: function (data, blockSize) {
          // Shortcut
          var blockSizeBytes = blockSize * 4;

          // Count padding bytes
          var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

          // Pad
          data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
          concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
        },

        unpad: function (data) {
          // Get number of padding bytes from last byte
          var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

          // Remove padding
          data.sigBytes -= nPaddingBytes;
        }
      };


      /**
       * ISO/IEC 9797-1 Padding Method 2.
       */
      CryptoJS.pad.Iso97971 = {
        pad: function (data, blockSize) {
          // Add 0x80 byte
          data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

          // Zero pad the rest
          CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },

        unpad: function (data) {
          // Remove zero padding
          CryptoJS.pad.ZeroPadding.unpad(data);

          // Remove one more byte -- the 0x80 byte
          data.sigBytes--;
        }
      };


      /**
       * Output Feedback block mode.
       */
      CryptoJS.mode.OFB = (function () {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();

        var Encryptor = OFB.Encryptor = OFB.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var keystream = this._keystream;

            // Generate keystream
            if (iv) {
              keystream = this._keystream = iv.slice(0);

              // Remove IV for subsequent blocks
              this._iv = undefined;
            }
            cipher.encryptBlock(keystream, 0);

            // Encrypt
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= keystream[i];
            }
          }
        });

        OFB.Decryptor = Encryptor;

        return OFB;
      }());


      /**
       * A noop padding strategy.
       */
      CryptoJS.pad.NoPadding = {
        pad: function () {
        },

        unpad: function () {
        }
      };


      (function (undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;

        var HexFormatter = C_format.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function (cipherParams) {
            return cipherParams.ciphertext.toString(Hex);
          },

          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function (input) {
            var ciphertext = Hex.parse(input);
            return CipherParams.create({ ciphertext: ciphertext });
          }
        };
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;

        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];

        // Compute lookup tables
        (function () {
          // Compute double table
          var d = [];
          for (var i = 0; i < 256; i++) {
            if (i < 128) {
              d[i] = i << 1;
            } else {
              d[i] = (i << 1) ^ 0x11b;
            }
          }

          // Walk GF(2^8)
          var x = 0;
          var xi = 0;
          for (var i = 0; i < 256; i++) {
            // Compute sbox
            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
            SBOX[x] = sx;
            INV_SBOX[sx] = x;

            // Compute multiplication
            var x2 = d[x];
            var x4 = d[x2];
            var x8 = d[x4];

            // Compute sub bytes, mix columns tables
            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
            SUB_MIX_3[x] = t;

            // Compute inv sub bytes, inv mix columns tables
            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
            INV_SUB_MIX_3[sx] = t;

            // Compute next counter
            if (!x) {
              x = xi = 1;
            } else {
              x = x2 ^ d[d[d[x8 ^ x2]]];
              xi ^= d[d[xi]];
            }
          }
        }());

        // Precomputed Rcon lookup
        var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

        /**
         * AES block cipher algorithm.
         */
        var AES = C_algo.AES = BlockCipher.extend({
          _doReset: function () {
            // Skip reset of nRounds has been set before and key did not change
            if (this._nRounds && this._keyPriorReset === this._key) {
              return;
            }

            // Shortcuts
            var key = this._keyPriorReset = this._key;
            var keyWords = key.words;
            var keySize = key.sigBytes / 4;

            // Compute number of rounds
            var nRounds = this._nRounds = keySize + 6;

            // Compute number of key schedule rows
            var ksRows = (nRounds + 1) * 4;

            // Compute key schedule
            var keySchedule = this._keySchedule = [];
            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
              if (ksRow < keySize) {
                keySchedule[ksRow] = keyWords[ksRow];
              } else {
                var t = keySchedule[ksRow - 1];

                if (!(ksRow % keySize)) {
                  // Rot word
                  t = (t << 8) | (t >>> 24);

                  // Sub word
                  t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

                  // Mix Rcon
                  t ^= RCON[(ksRow / keySize) | 0] << 24;
                } else if (keySize > 6 && ksRow % keySize == 4) {
                  // Sub word
                  t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
                }

                keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
              }
            }

            // Compute inv key schedule
            var invKeySchedule = this._invKeySchedule = [];
            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
              var ksRow = ksRows - invKsRow;

              if (invKsRow % 4) {
                var t = keySchedule[ksRow];
              } else {
                var t = keySchedule[ksRow - 4];
              }

              if (invKsRow < 4 || ksRow <= 4) {
                invKeySchedule[invKsRow] = t;
              } else {
                invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
                  INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
              }
            }
          },

          encryptBlock: function (M, offset) {
            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
          },

          decryptBlock: function (M, offset) {
            // Swap 2nd and 4th rows
            var t = M[offset + 1];
            M[offset + 1] = M[offset + 3];
            M[offset + 3] = t;

            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

            // Inv swap 2nd and 4th rows
            var t = M[offset + 1];
            M[offset + 1] = M[offset + 3];
            M[offset + 3] = t;
          },

          _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
            // Shortcut
            var nRounds = this._nRounds;

            // Get input, add round key
            var s0 = M[offset]     ^ keySchedule[0];
            var s1 = M[offset + 1] ^ keySchedule[1];
            var s2 = M[offset + 2] ^ keySchedule[2];
            var s3 = M[offset + 3] ^ keySchedule[3];

            // Key schedule row counter
            var ksRow = 4;

            // Rounds
            for (var round = 1; round < nRounds; round++) {
              // Shift rows, sub bytes, mix columns, add round key
              var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
              var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
              var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
              var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

              // Update state
              s0 = t0;
              s1 = t1;
              s2 = t2;
              s3 = t3;
            }

            // Shift rows, sub bytes, add round key
            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

            // Set output
            M[offset]     = t0;
            M[offset + 1] = t1;
            M[offset + 2] = t2;
            M[offset + 3] = t3;
          },

          keySize: 256/32
        });

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
         */
        C.AES = BlockCipher._createHelper(AES);
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;

        // Permuted Choice 1 constants
        var PC1 = [
          57, 49, 41, 33, 25, 17, 9,  1,
          58, 50, 42, 34, 26, 18, 10, 2,
          59, 51, 43, 35, 27, 19, 11, 3,
          60, 52, 44, 36, 63, 55, 47, 39,
          31, 23, 15, 7,  62, 54, 46, 38,
          30, 22, 14, 6,  61, 53, 45, 37,
          29, 21, 13, 5,  28, 20, 12, 4
        ];

        // Permuted Choice 2 constants
        var PC2 = [
          14, 17, 11, 24, 1,  5,
          3,  28, 15, 6,  21, 10,
          23, 19, 12, 4,  26, 8,
          16, 7,  27, 20, 13, 2,
          41, 52, 31, 37, 47, 55,
          30, 40, 51, 45, 33, 48,
          44, 49, 39, 56, 34, 53,
          46, 42, 50, 36, 29, 32
        ];

        // Cumulative bit shift constants
        var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

        // SBOXes and round permutation constants
        var SBOX_P = [
          {
            0x0: 0x808200,
            0x10000000: 0x8000,
            0x20000000: 0x808002,
            0x30000000: 0x2,
            0x40000000: 0x200,
            0x50000000: 0x808202,
            0x60000000: 0x800202,
            0x70000000: 0x800000,
            0x80000000: 0x202,
            0x90000000: 0x800200,
            0xa0000000: 0x8200,
            0xb0000000: 0x808000,
            0xc0000000: 0x8002,
            0xd0000000: 0x800002,
            0xe0000000: 0x0,
            0xf0000000: 0x8202,
            0x8000000: 0x0,
            0x18000000: 0x808202,
            0x28000000: 0x8202,
            0x38000000: 0x8000,
            0x48000000: 0x808200,
            0x58000000: 0x200,
            0x68000000: 0x808002,
            0x78000000: 0x2,
            0x88000000: 0x800200,
            0x98000000: 0x8200,
            0xa8000000: 0x808000,
            0xb8000000: 0x800202,
            0xc8000000: 0x800002,
            0xd8000000: 0x8002,
            0xe8000000: 0x202,
            0xf8000000: 0x800000,
            0x1: 0x8000,
            0x10000001: 0x2,
            0x20000001: 0x808200,
            0x30000001: 0x800000,
            0x40000001: 0x808002,
            0x50000001: 0x8200,
            0x60000001: 0x200,
            0x70000001: 0x800202,
            0x80000001: 0x808202,
            0x90000001: 0x808000,
            0xa0000001: 0x800002,
            0xb0000001: 0x8202,
            0xc0000001: 0x202,
            0xd0000001: 0x800200,
            0xe0000001: 0x8002,
            0xf0000001: 0x0,
            0x8000001: 0x808202,
            0x18000001: 0x808000,
            0x28000001: 0x800000,
            0x38000001: 0x200,
            0x48000001: 0x8000,
            0x58000001: 0x800002,
            0x68000001: 0x2,
            0x78000001: 0x8202,
            0x88000001: 0x8002,
            0x98000001: 0x800202,
            0xa8000001: 0x202,
            0xb8000001: 0x808200,
            0xc8000001: 0x800200,
            0xd8000001: 0x0,
            0xe8000001: 0x8200,
            0xf8000001: 0x808002
          },
          {
            0x0: 0x40084010,
            0x1000000: 0x4000,
            0x2000000: 0x80000,
            0x3000000: 0x40080010,
            0x4000000: 0x40000010,
            0x5000000: 0x40084000,
            0x6000000: 0x40004000,
            0x7000000: 0x10,
            0x8000000: 0x84000,
            0x9000000: 0x40004010,
            0xa000000: 0x40000000,
            0xb000000: 0x84010,
            0xc000000: 0x80010,
            0xd000000: 0x0,
            0xe000000: 0x4010,
            0xf000000: 0x40080000,
            0x800000: 0x40004000,
            0x1800000: 0x84010,
            0x2800000: 0x10,
            0x3800000: 0x40004010,
            0x4800000: 0x40084010,
            0x5800000: 0x40000000,
            0x6800000: 0x80000,
            0x7800000: 0x40080010,
            0x8800000: 0x80010,
            0x9800000: 0x0,
            0xa800000: 0x4000,
            0xb800000: 0x40080000,
            0xc800000: 0x40000010,
            0xd800000: 0x84000,
            0xe800000: 0x40084000,
            0xf800000: 0x4010,
            0x10000000: 0x0,
            0x11000000: 0x40080010,
            0x12000000: 0x40004010,
            0x13000000: 0x40084000,
            0x14000000: 0x40080000,
            0x15000000: 0x10,
            0x16000000: 0x84010,
            0x17000000: 0x4000,
            0x18000000: 0x4010,
            0x19000000: 0x80000,
            0x1a000000: 0x80010,
            0x1b000000: 0x40000010,
            0x1c000000: 0x84000,
            0x1d000000: 0x40004000,
            0x1e000000: 0x40000000,
            0x1f000000: 0x40084010,
            0x10800000: 0x84010,
            0x11800000: 0x80000,
            0x12800000: 0x40080000,
            0x13800000: 0x4000,
            0x14800000: 0x40004000,
            0x15800000: 0x40084010,
            0x16800000: 0x10,
            0x17800000: 0x40000000,
            0x18800000: 0x40084000,
            0x19800000: 0x40000010,
            0x1a800000: 0x40004010,
            0x1b800000: 0x80010,
            0x1c800000: 0x0,
            0x1d800000: 0x4010,
            0x1e800000: 0x40080010,
            0x1f800000: 0x84000
          },
          {
            0x0: 0x104,
            0x100000: 0x0,
            0x200000: 0x4000100,
            0x300000: 0x10104,
            0x400000: 0x10004,
            0x500000: 0x4000004,
            0x600000: 0x4010104,
            0x700000: 0x4010000,
            0x800000: 0x4000000,
            0x900000: 0x4010100,
            0xa00000: 0x10100,
            0xb00000: 0x4010004,
            0xc00000: 0x4000104,
            0xd00000: 0x10000,
            0xe00000: 0x4,
            0xf00000: 0x100,
            0x80000: 0x4010100,
            0x180000: 0x4010004,
            0x280000: 0x0,
            0x380000: 0x4000100,
            0x480000: 0x4000004,
            0x580000: 0x10000,
            0x680000: 0x10004,
            0x780000: 0x104,
            0x880000: 0x4,
            0x980000: 0x100,
            0xa80000: 0x4010000,
            0xb80000: 0x10104,
            0xc80000: 0x10100,
            0xd80000: 0x4000104,
            0xe80000: 0x4010104,
            0xf80000: 0x4000000,
            0x1000000: 0x4010100,
            0x1100000: 0x10004,
            0x1200000: 0x10000,
            0x1300000: 0x4000100,
            0x1400000: 0x100,
            0x1500000: 0x4010104,
            0x1600000: 0x4000004,
            0x1700000: 0x0,
            0x1800000: 0x4000104,
            0x1900000: 0x4000000,
            0x1a00000: 0x4,
            0x1b00000: 0x10100,
            0x1c00000: 0x4010000,
            0x1d00000: 0x104,
            0x1e00000: 0x10104,
            0x1f00000: 0x4010004,
            0x1080000: 0x4000000,
            0x1180000: 0x104,
            0x1280000: 0x4010100,
            0x1380000: 0x0,
            0x1480000: 0x10004,
            0x1580000: 0x4000100,
            0x1680000: 0x100,
            0x1780000: 0x4010004,
            0x1880000: 0x10000,
            0x1980000: 0x4010104,
            0x1a80000: 0x10104,
            0x1b80000: 0x4000004,
            0x1c80000: 0x4000104,
            0x1d80000: 0x4010000,
            0x1e80000: 0x4,
            0x1f80000: 0x10100
          },
          {
            0x0: 0x80401000,
            0x10000: 0x80001040,
            0x20000: 0x401040,
            0x30000: 0x80400000,
            0x40000: 0x0,
            0x50000: 0x401000,
            0x60000: 0x80000040,
            0x70000: 0x400040,
            0x80000: 0x80000000,
            0x90000: 0x400000,
            0xa0000: 0x40,
            0xb0000: 0x80001000,
            0xc0000: 0x80400040,
            0xd0000: 0x1040,
            0xe0000: 0x1000,
            0xf0000: 0x80401040,
            0x8000: 0x80001040,
            0x18000: 0x40,
            0x28000: 0x80400040,
            0x38000: 0x80001000,
            0x48000: 0x401000,
            0x58000: 0x80401040,
            0x68000: 0x0,
            0x78000: 0x80400000,
            0x88000: 0x1000,
            0x98000: 0x80401000,
            0xa8000: 0x400000,
            0xb8000: 0x1040,
            0xc8000: 0x80000000,
            0xd8000: 0x400040,
            0xe8000: 0x401040,
            0xf8000: 0x80000040,
            0x100000: 0x400040,
            0x110000: 0x401000,
            0x120000: 0x80000040,
            0x130000: 0x0,
            0x140000: 0x1040,
            0x150000: 0x80400040,
            0x160000: 0x80401000,
            0x170000: 0x80001040,
            0x180000: 0x80401040,
            0x190000: 0x80000000,
            0x1a0000: 0x80400000,
            0x1b0000: 0x401040,
            0x1c0000: 0x80001000,
            0x1d0000: 0x400000,
            0x1e0000: 0x40,
            0x1f0000: 0x1000,
            0x108000: 0x80400000,
            0x118000: 0x80401040,
            0x128000: 0x0,
            0x138000: 0x401000,
            0x148000: 0x400040,
            0x158000: 0x80000000,
            0x168000: 0x80001040,
            0x178000: 0x40,
            0x188000: 0x80000040,
            0x198000: 0x1000,
            0x1a8000: 0x80001000,
            0x1b8000: 0x80400040,
            0x1c8000: 0x1040,
            0x1d8000: 0x80401000,
            0x1e8000: 0x400000,
            0x1f8000: 0x401040
          },
          {
            0x0: 0x80,
            0x1000: 0x1040000,
            0x2000: 0x40000,
            0x3000: 0x20000000,
            0x4000: 0x20040080,
            0x5000: 0x1000080,
            0x6000: 0x21000080,
            0x7000: 0x40080,
            0x8000: 0x1000000,
            0x9000: 0x20040000,
            0xa000: 0x20000080,
            0xb000: 0x21040080,
            0xc000: 0x21040000,
            0xd000: 0x0,
            0xe000: 0x1040080,
            0xf000: 0x21000000,
            0x800: 0x1040080,
            0x1800: 0x21000080,
            0x2800: 0x80,
            0x3800: 0x1040000,
            0x4800: 0x40000,
            0x5800: 0x20040080,
            0x6800: 0x21040000,
            0x7800: 0x20000000,
            0x8800: 0x20040000,
            0x9800: 0x0,
            0xa800: 0x21040080,
            0xb800: 0x1000080,
            0xc800: 0x20000080,
            0xd800: 0x21000000,
            0xe800: 0x1000000,
            0xf800: 0x40080,
            0x10000: 0x40000,
            0x11000: 0x80,
            0x12000: 0x20000000,
            0x13000: 0x21000080,
            0x14000: 0x1000080,
            0x15000: 0x21040000,
            0x16000: 0x20040080,
            0x17000: 0x1000000,
            0x18000: 0x21040080,
            0x19000: 0x21000000,
            0x1a000: 0x1040000,
            0x1b000: 0x20040000,
            0x1c000: 0x40080,
            0x1d000: 0x20000080,
            0x1e000: 0x0,
            0x1f000: 0x1040080,
            0x10800: 0x21000080,
            0x11800: 0x1000000,
            0x12800: 0x1040000,
            0x13800: 0x20040080,
            0x14800: 0x20000000,
            0x15800: 0x1040080,
            0x16800: 0x80,
            0x17800: 0x21040000,
            0x18800: 0x40080,
            0x19800: 0x21040080,
            0x1a800: 0x0,
            0x1b800: 0x21000000,
            0x1c800: 0x1000080,
            0x1d800: 0x40000,
            0x1e800: 0x20040000,
            0x1f800: 0x20000080
          },
          {
            0x0: 0x10000008,
            0x100: 0x2000,
            0x200: 0x10200000,
            0x300: 0x10202008,
            0x400: 0x10002000,
            0x500: 0x200000,
            0x600: 0x200008,
            0x700: 0x10000000,
            0x800: 0x0,
            0x900: 0x10002008,
            0xa00: 0x202000,
            0xb00: 0x8,
            0xc00: 0x10200008,
            0xd00: 0x202008,
            0xe00: 0x2008,
            0xf00: 0x10202000,
            0x80: 0x10200000,
            0x180: 0x10202008,
            0x280: 0x8,
            0x380: 0x200000,
            0x480: 0x202008,
            0x580: 0x10000008,
            0x680: 0x10002000,
            0x780: 0x2008,
            0x880: 0x200008,
            0x980: 0x2000,
            0xa80: 0x10002008,
            0xb80: 0x10200008,
            0xc80: 0x0,
            0xd80: 0x10202000,
            0xe80: 0x202000,
            0xf80: 0x10000000,
            0x1000: 0x10002000,
            0x1100: 0x10200008,
            0x1200: 0x10202008,
            0x1300: 0x2008,
            0x1400: 0x200000,
            0x1500: 0x10000000,
            0x1600: 0x10000008,
            0x1700: 0x202000,
            0x1800: 0x202008,
            0x1900: 0x0,
            0x1a00: 0x8,
            0x1b00: 0x10200000,
            0x1c00: 0x2000,
            0x1d00: 0x10002008,
            0x1e00: 0x10202000,
            0x1f00: 0x200008,
            0x1080: 0x8,
            0x1180: 0x202000,
            0x1280: 0x200000,
            0x1380: 0x10000008,
            0x1480: 0x10002000,
            0x1580: 0x2008,
            0x1680: 0x10202008,
            0x1780: 0x10200000,
            0x1880: 0x10202000,
            0x1980: 0x10200008,
            0x1a80: 0x2000,
            0x1b80: 0x202008,
            0x1c80: 0x200008,
            0x1d80: 0x0,
            0x1e80: 0x10000000,
            0x1f80: 0x10002008
          },
          {
            0x0: 0x100000,
            0x10: 0x2000401,
            0x20: 0x400,
            0x30: 0x100401,
            0x40: 0x2100401,
            0x50: 0x0,
            0x60: 0x1,
            0x70: 0x2100001,
            0x80: 0x2000400,
            0x90: 0x100001,
            0xa0: 0x2000001,
            0xb0: 0x2100400,
            0xc0: 0x2100000,
            0xd0: 0x401,
            0xe0: 0x100400,
            0xf0: 0x2000000,
            0x8: 0x2100001,
            0x18: 0x0,
            0x28: 0x2000401,
            0x38: 0x2100400,
            0x48: 0x100000,
            0x58: 0x2000001,
            0x68: 0x2000000,
            0x78: 0x401,
            0x88: 0x100401,
            0x98: 0x2000400,
            0xa8: 0x2100000,
            0xb8: 0x100001,
            0xc8: 0x400,
            0xd8: 0x2100401,
            0xe8: 0x1,
            0xf8: 0x100400,
            0x100: 0x2000000,
            0x110: 0x100000,
            0x120: 0x2000401,
            0x130: 0x2100001,
            0x140: 0x100001,
            0x150: 0x2000400,
            0x160: 0x2100400,
            0x170: 0x100401,
            0x180: 0x401,
            0x190: 0x2100401,
            0x1a0: 0x100400,
            0x1b0: 0x1,
            0x1c0: 0x0,
            0x1d0: 0x2100000,
            0x1e0: 0x2000001,
            0x1f0: 0x400,
            0x108: 0x100400,
            0x118: 0x2000401,
            0x128: 0x2100001,
            0x138: 0x1,
            0x148: 0x2000000,
            0x158: 0x100000,
            0x168: 0x401,
            0x178: 0x2100400,
            0x188: 0x2000001,
            0x198: 0x2100000,
            0x1a8: 0x0,
            0x1b8: 0x2100401,
            0x1c8: 0x100401,
            0x1d8: 0x400,
            0x1e8: 0x2000400,
            0x1f8: 0x100001
          },
          {
            0x0: 0x8000820,
            0x1: 0x20000,
            0x2: 0x8000000,
            0x3: 0x20,
            0x4: 0x20020,
            0x5: 0x8020820,
            0x6: 0x8020800,
            0x7: 0x800,
            0x8: 0x8020000,
            0x9: 0x8000800,
            0xa: 0x20800,
            0xb: 0x8020020,
            0xc: 0x820,
            0xd: 0x0,
            0xe: 0x8000020,
            0xf: 0x20820,
            0x80000000: 0x800,
            0x80000001: 0x8020820,
            0x80000002: 0x8000820,
            0x80000003: 0x8000000,
            0x80000004: 0x8020000,
            0x80000005: 0x20800,
            0x80000006: 0x20820,
            0x80000007: 0x20,
            0x80000008: 0x8000020,
            0x80000009: 0x820,
            0x8000000a: 0x20020,
            0x8000000b: 0x8020800,
            0x8000000c: 0x0,
            0x8000000d: 0x8020020,
            0x8000000e: 0x8000800,
            0x8000000f: 0x20000,
            0x10: 0x20820,
            0x11: 0x8020800,
            0x12: 0x20,
            0x13: 0x800,
            0x14: 0x8000800,
            0x15: 0x8000020,
            0x16: 0x8020020,
            0x17: 0x20000,
            0x18: 0x0,
            0x19: 0x20020,
            0x1a: 0x8020000,
            0x1b: 0x8000820,
            0x1c: 0x8020820,
            0x1d: 0x20800,
            0x1e: 0x820,
            0x1f: 0x8000000,
            0x80000010: 0x20000,
            0x80000011: 0x800,
            0x80000012: 0x8020020,
            0x80000013: 0x20820,
            0x80000014: 0x20,
            0x80000015: 0x8020000,
            0x80000016: 0x8000000,
            0x80000017: 0x8000820,
            0x80000018: 0x8020820,
            0x80000019: 0x8000020,
            0x8000001a: 0x8000800,
            0x8000001b: 0x0,
            0x8000001c: 0x20800,
            0x8000001d: 0x820,
            0x8000001e: 0x20020,
            0x8000001f: 0x8020800
          }
        ];

        // Masks that select the SBOX input
        var SBOX_MASK = [
          0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
          0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
        ];

        /**
         * DES block cipher algorithm.
         */
        var DES = C_algo.DES = BlockCipher.extend({
          _doReset: function () {
            // Shortcuts
            var key = this._key;
            var keyWords = key.words;

            // Select 56 bits according to PC1
            var keyBits = [];
            for (var i = 0; i < 56; i++) {
              var keyBitPos = PC1[i] - 1;
              keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
            }

            // Assemble 16 subkeys
            var subKeys = this._subKeys = [];
            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
              // Create subkey
              var subKey = subKeys[nSubKey] = [];

              // Shortcut
              var bitShift = BIT_SHIFTS[nSubKey];

              // Select 48 bits according to PC2
              for (var i = 0; i < 24; i++) {
                // Select from the left 28 key bits
                subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

                // Select from the right 28 key bits
                subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
              }

              // Since each subkey is applied to an expanded 32-bit input,
              // the subkey can be broken into 8 values scaled to 32-bits,
              // which allows the key to be used without expansion
              subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
              for (var i = 1; i < 7; i++) {
                subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
              }
              subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
            }

            // Compute inverse subkeys
            var invSubKeys = this._invSubKeys = [];
            for (var i = 0; i < 16; i++) {
              invSubKeys[i] = subKeys[15 - i];
            }
          },

          encryptBlock: function (M, offset) {
            this._doCryptBlock(M, offset, this._subKeys);
          },

          decryptBlock: function (M, offset) {
            this._doCryptBlock(M, offset, this._invSubKeys);
          },

          _doCryptBlock: function (M, offset, subKeys) {
            // Get input
            this._lBlock = M[offset];
            this._rBlock = M[offset + 1];

            // Initial permutation
            exchangeLR.call(this, 4,  0x0f0f0f0f);
            exchangeLR.call(this, 16, 0x0000ffff);
            exchangeRL.call(this, 2,  0x33333333);
            exchangeRL.call(this, 8,  0x00ff00ff);
            exchangeLR.call(this, 1,  0x55555555);

            // Rounds
            for (var round = 0; round < 16; round++) {
              // Shortcuts
              var subKey = subKeys[round];
              var lBlock = this._lBlock;
              var rBlock = this._rBlock;

              // Feistel function
              var f = 0;
              for (var i = 0; i < 8; i++) {
                f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
              }
              this._lBlock = rBlock;
              this._rBlock = lBlock ^ f;
            }

            // Undo swap from last round
            var t = this._lBlock;
            this._lBlock = this._rBlock;
            this._rBlock = t;

            // Final permutation
            exchangeLR.call(this, 1,  0x55555555);
            exchangeRL.call(this, 8,  0x00ff00ff);
            exchangeRL.call(this, 2,  0x33333333);
            exchangeLR.call(this, 16, 0x0000ffff);
            exchangeLR.call(this, 4,  0x0f0f0f0f);

            // Set output
            M[offset] = this._lBlock;
            M[offset + 1] = this._rBlock;
          },

          keySize: 64/32,

          ivSize: 64/32,

          blockSize: 64/32
        });

        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
          var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
          this._rBlock ^= t;
          this._lBlock ^= t << offset;
        }

        function exchangeRL(offset, mask) {
          var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
          this._lBlock ^= t;
          this._rBlock ^= t << offset;
        }

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
         */
        C.DES = BlockCipher._createHelper(DES);

        /**
         * Triple-DES block cipher algorithm.
         */
        var TripleDES = C_algo.TripleDES = BlockCipher.extend({
          _doReset: function () {
            // Shortcuts
            var key = this._key;
            var keyWords = key.words;

            // Create DES instances
            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
          },

          encryptBlock: function (M, offset) {
            this._des1.encryptBlock(M, offset);
            this._des2.decryptBlock(M, offset);
            this._des3.encryptBlock(M, offset);
          },

          decryptBlock: function (M, offset) {
            this._des3.decryptBlock(M, offset);
            this._des2.encryptBlock(M, offset);
            this._des1.decryptBlock(M, offset);
          },

          keySize: 192/32,

          ivSize: 64/32,

          blockSize: 64/32
        });

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
         */
        C.TripleDES = BlockCipher._createHelper(TripleDES);
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;

        /**
         * RC4 stream cipher algorithm.
         */
        var RC4 = C_algo.RC4 = StreamCipher.extend({
          _doReset: function () {
            // Shortcuts
            var key = this._key;
            var keyWords = key.words;
            var keySigBytes = key.sigBytes;

            // Init sbox
            var S = this._S = [];
            for (var i = 0; i < 256; i++) {
              S[i] = i;
            }

            // Key setup
            for (var i = 0, j = 0; i < 256; i++) {
              var keyByteIndex = i % keySigBytes;
              var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

              j = (j + S[i] + keyByte) % 256;

              // Swap
              var t = S[i];
              S[i] = S[j];
              S[j] = t;
            }

            // Counters
            this._i = this._j = 0;
          },

          _doProcessBlock: function (M, offset) {
            M[offset] ^= generateKeystreamWord.call(this);
          },

          keySize: 256/32,

          ivSize: 0
        });

        function generateKeystreamWord() {
          // Shortcuts
          var S = this._S;
          var i = this._i;
          var j = this._j;

          // Generate keystream word
          var keystreamWord = 0;
          for (var n = 0; n < 4; n++) {
            i = (i + 1) % 256;
            j = (j + S[i]) % 256;

            // Swap
            var t = S[i];
            S[i] = S[j];
            S[j] = t;

            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
          }

          // Update counters
          this._i = i;
          this._j = j;

          return keystreamWord;
        }

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
         */
        C.RC4 = StreamCipher._createHelper(RC4);

        /**
         * Modified RC4 stream cipher algorithm.
         */
        var RC4Drop = C_algo.RC4Drop = RC4.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: RC4.cfg.extend({
            drop: 192
          }),

          _doReset: function () {
            RC4._doReset.call(this);

            // Drop
            for (var i = this.cfg.drop; i > 0; i--) {
              generateKeystreamWord.call(this);
            }
          }
        });

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
         */
        C.RC4Drop = StreamCipher._createHelper(RC4Drop);
      }());


      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      CryptoJS.mode.CTRGladman = (function () {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

        function incWord(word)
        {
          if (((word >> 24) & 0xff) === 0xff) { //overflow
            var b1 = (word >> 16)&0xff;
            var b2 = (word >> 8)&0xff;
            var b3 = word & 0xff;

            if (b1 === 0xff) // overflow b1
            {
              b1 = 0;
              if (b2 === 0xff)
              {
                b2 = 0;
                if (b3 === 0xff)
                {
                  b3 = 0;
                }
                else
                {
                  ++b3;
                }
              }
              else
              {
                ++b2;
              }
            }
            else
            {
              ++b1;
            }

            word = 0;
            word += (b1 << 16);
            word += (b2 << 8);
            word += b3;
          }
          else
          {
            word += (0x01 << 24);
          }
          return word;
        }

        function incCounter(counter)
        {
          if ((counter[0] = incWord(counter[0])) === 0)
          {
            // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
          }
          return counter;
        }

        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var counter = this._counter;

            // Generate keystream
            if (iv) {
              counter = this._counter = iv.slice(0);

              // Remove IV for subsequent blocks
              this._iv = undefined;
            }

            incCounter(counter);

            var keystream = counter.slice(0);
            cipher.encryptBlock(keystream, 0);

            // Encrypt
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= keystream[i];
            }
          }
        });

        CTRGladman.Decryptor = Encryptor;

        return CTRGladman;
      }());




      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;

        // Reusable objects
        var S  = [];
        var C_ = [];
        var G  = [];

        /**
         * Rabbit stream cipher algorithm
         */
        var Rabbit = C_algo.Rabbit = StreamCipher.extend({
          _doReset: function () {
            // Shortcuts
            var K = this._key.words;
            var iv = this.cfg.iv;

            // Swap endian
            for (var i = 0; i < 4; i++) {
              K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
                (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
            }

            // Generate initial state values
            var X = this._X = [
              K[0], (K[3] << 16) | (K[2] >>> 16),
              K[1], (K[0] << 16) | (K[3] >>> 16),
              K[2], (K[1] << 16) | (K[0] >>> 16),
              K[3], (K[2] << 16) | (K[1] >>> 16)
            ];

            // Generate initial counter values
            var C = this._C = [
              (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
              (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
              (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
              (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
            ];

            // Carry bit
            this._b = 0;

            // Iterate the system four times
            for (var i = 0; i < 4; i++) {
              nextState.call(this);
            }

            // Modify the counters
            for (var i = 0; i < 8; i++) {
              C[i] ^= X[(i + 4) & 7];
            }

            // IV setup
            if (iv) {
              // Shortcuts
              var IV = iv.words;
              var IV_0 = IV[0];
              var IV_1 = IV[1];

              // Generate four subvectors
              var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
              var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
              var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
              var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

              // Modify counter values
              C[0] ^= i0;
              C[1] ^= i1;
              C[2] ^= i2;
              C[3] ^= i3;
              C[4] ^= i0;
              C[5] ^= i1;
              C[6] ^= i2;
              C[7] ^= i3;

              // Iterate the system four times
              for (var i = 0; i < 4; i++) {
                nextState.call(this);
              }
            }
          },

          _doProcessBlock: function (M, offset) {
            // Shortcut
            var X = this._X;

            // Iterate the system
            nextState.call(this);

            // Generate four keystream words
            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

            for (var i = 0; i < 4; i++) {
              // Swap endian
              S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
                (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

              // Encrypt
              M[offset + i] ^= S[i];
            }
          },

          blockSize: 128/32,

          ivSize: 64/32
        });

        function nextState() {
          // Shortcuts
          var X = this._X;
          var C = this._C;

          // Save old counter values
          for (var i = 0; i < 8; i++) {
            C_[i] = C[i];
          }

          // Calculate new counter values
          C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
          C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
          C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
          C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
          C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
          C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
          C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
          C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
          this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

          // Calculate the g-values
          for (var i = 0; i < 8; i++) {
            var gx = X[i] + C[i];

            // Construct high and low argument for squaring
            var ga = gx & 0xffff;
            var gb = gx >>> 16;

            // Calculate high and low result of squaring
            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

            // High XOR low
            G[i] = gh ^ gl;
          }

          // Calculate new state values
          X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
          X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
          X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
          X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
          X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
          X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
          X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
          X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
        }

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
         */
        C.Rabbit = StreamCipher._createHelper(Rabbit);
      }());


      /**
       * Counter block mode.
       */
      CryptoJS.mode.CTR = (function () {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();

        var Encryptor = CTR.Encryptor = CTR.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var counter = this._counter;

            // Generate keystream
            if (iv) {
              counter = this._counter = iv.slice(0);

              // Remove IV for subsequent blocks
              this._iv = undefined;
            }
            var keystream = counter.slice(0);
            cipher.encryptBlock(keystream, 0);

            // Increment counter
            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

            // Encrypt
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= keystream[i];
            }
          }
        });

        CTR.Decryptor = Encryptor;

        return CTR;
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;

        // Reusable objects
        var S  = [];
        var C_ = [];
        var G  = [];

        /**
         * Rabbit stream cipher algorithm.
         *
         * This is a legacy version that neglected to convert the key to little-endian.
         * This error doesn't affect the cipher's security,
         * but it does affect its compatibility with other implementations.
         */
        var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
          _doReset: function () {
            // Shortcuts
            var K = this._key.words;
            var iv = this.cfg.iv;

            // Generate initial state values
            var X = this._X = [
              K[0], (K[3] << 16) | (K[2] >>> 16),
              K[1], (K[0] << 16) | (K[3] >>> 16),
              K[2], (K[1] << 16) | (K[0] >>> 16),
              K[3], (K[2] << 16) | (K[1] >>> 16)
            ];

            // Generate initial counter values
            var C = this._C = [
              (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
              (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
              (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
              (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
            ];

            // Carry bit
            this._b = 0;

            // Iterate the system four times
            for (var i = 0; i < 4; i++) {
              nextState.call(this);
            }

            // Modify the counters
            for (var i = 0; i < 8; i++) {
              C[i] ^= X[(i + 4) & 7];
            }

            // IV setup
            if (iv) {
              // Shortcuts
              var IV = iv.words;
              var IV_0 = IV[0];
              var IV_1 = IV[1];

              // Generate four subvectors
              var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
              var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
              var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
              var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

              // Modify counter values
              C[0] ^= i0;
              C[1] ^= i1;
              C[2] ^= i2;
              C[3] ^= i3;
              C[4] ^= i0;
              C[5] ^= i1;
              C[6] ^= i2;
              C[7] ^= i3;

              // Iterate the system four times
              for (var i = 0; i < 4; i++) {
                nextState.call(this);
              }
            }
          },

          _doProcessBlock: function (M, offset) {
            // Shortcut
            var X = this._X;

            // Iterate the system
            nextState.call(this);

            // Generate four keystream words
            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

            for (var i = 0; i < 4; i++) {
              // Swap endian
              S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
                (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

              // Encrypt
              M[offset + i] ^= S[i];
            }
          },

          blockSize: 128/32,

          ivSize: 64/32
        });

        function nextState() {
          // Shortcuts
          var X = this._X;
          var C = this._C;

          // Save old counter values
          for (var i = 0; i < 8; i++) {
            C_[i] = C[i];
          }

          // Calculate new counter values
          C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
          C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
          C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
          C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
          C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
          C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
          C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
          C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
          this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

          // Calculate the g-values
          for (var i = 0; i < 8; i++) {
            var gx = X[i] + C[i];

            // Construct high and low argument for squaring
            var ga = gx & 0xffff;
            var gb = gx >>> 16;

            // Calculate high and low result of squaring
            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

            // High XOR low
            G[i] = gh ^ gl;
          }

          // Calculate new state values
          X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
          X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
          X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
          X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
          X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
          X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
          X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
          X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
        }

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
         */
        C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
      }());


      /**
       * Zero padding strategy.
       */
      CryptoJS.pad.ZeroPadding = {
        pad: function (data, blockSize) {
          // Shortcut
          var blockSizeBytes = blockSize * 4;

          // Pad
          data.clamp();
          data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
        },

        unpad: function (data) {
          // Shortcut
          var dataWords = data.words;

          // Unpad
          var i = data.sigBytes - 1;
          while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
            i--;
          }
          data.sigBytes = i + 1;
        }
      };


      return CryptoJS;

    }
  }



})();
(function() {
    'use strict';

    angular
        .module('hmapFront')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('metrics', {
            parent: 'app',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'body': {
                    templateUrl: 'app/metrics/metrics.html',
                    controller: 'MetricsMonitoringModalController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('hmapFront')
        .factory('MetricsService', MetricsService);

  MetricsService.$inject = ['$rootScope', '$http','BaseConfig'];

    function MetricsService ($rootScope, $http,BaseConfig) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('/metrics/metrics').then(function (response) {
                //console.log(response);
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('/metrics/threads').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('hmapFront')
        .controller('MetricsMonitoringModalController', MetricsMonitoringModalController);

  MetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function MetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('hmapFront')
        .controller('MetricsMonitoringModalController', MetricsMonitoringModalController);

  MetricsMonitoringModalController.$inject = ['$scope','MetricsService', '$uibModal'];

    function MetricsMonitoringModalController ($scope, MetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
          MetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
          MetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('messageTemplate', {
        parent: 'app',
        url: "/messageTemplate",
        views: {
          'body': {
            templateUrl: "app/messageTemplate/messageTemplate.html",
            controller: 'MessageTemplateController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {};
          }
        }
      })
      .state('messageTemplateNew', {
        parent: 'messageTemplate',
        url: "/addMessageTemplate",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/messageTemplate/addMessageTemplate.html",
            controller: 'AddMessageTemplateController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg'
          }).result.then(function () {
            $state.go('messageTemplate', null, {reload: 'messageTemplate'});
          }, function () {
            $state.go('messageTemplate', null, {reload: 'messageTemplate'});
          });
        }]
      }).state('messageTemplateEdit', {
        parent: 'messageTemplate',
        url: "/editMessageTemplate/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/messageTemplate/editMessageTemplate.html",
            controller: 'EditMessageTemplateController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id
                };
              }
            }
          }).result.then(function () {
            $state.go('messageTemplate', null, {reload: 'messageTemplate'});
          }, function () {
            $state.go('messageTemplate', null, {reload: 'messageTemplate'});
          });
        }]
      })
      .state('messageTemplate.chooseSku', {
        parent: 'messageTemplateNew',
        url: "/chooseSku",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/messageTemplate/chooseSku-dialog.html',
            controller: 'ChooseSkuDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  type: $stateParams.type
                };
              }
            }
          }).result.then(function () {
            $state.go('messageTemplateNew');
          }, function () {
            $state.go('messageTemplateNew');
          });
        }]
      })
      .state('messageTemplate.editChooseSku', {
        parent: 'messageTemplateEdit',
        url: "/editChooseSku",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/messageTemplate/editChooseSku-dialog.html',
            controller: 'ChooseSkuDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg'
          }).result.then(function () {
            $state.go('messageTemplateEdit');
          }, function () {
            $state.go('messageTemplateEdit');
          });
        }]
      });
  }
})();


(function(){
  'use strict';
  angular.module('hmapFront')
    .factory('MessageTemplateService', MessageTemplateService);
  MessageTemplateService.$inject = ['$resource','$http','$rootScope'];

  function MessageTemplateService ($resource,$http,$rootScope) {
    var selectedParent = {};
    var selectedEditParent = {};
    var service = {
      queryAll:queryAll,
      selectById:selectById,
      submitInfo:submitInfo,
      deleteTemp:deleteTemp,
      edit:edit,
      getByCode:getByCode,
      selectAllSku:selectAllSku,
      selectAllProduce:selectAllProduce,
      shareParent:shareParent,
      shareEidtParent:shareEidtParent,
      selectedParent: selectedParent,
      selectedEditParent:selectedEditParent
    };
    return service;

    function shareParent(selectedParent){
      this.selectedParent = selectedParent;
      $rootScope.$broadcast('handleSelectedParent');
    }

    function shareEidtParent(selectedEditParent){
      this.selectedEditParent = selectedEditParent;
      $rootScope.$broadcast('handleSelectedEditParent');
    }

    function queryAll(){
      var resourceUrl = '/api/messageTemp/selectAll';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function selectAllSku(){
      var resourceUrl ='/api/ctm/selectAllSku';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function selectAllProduce(){
      var resourceUrl ='/api/ctm/selectProduct';
      return $resource(resourceUrl,{},{
        'query': {method: 'GET'}
      });
    }



    function getByCode(){
      var resourceUrl = '/api/messageTemp/getByCode';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function deleteTemp(){
      var resourceUrl = '/api/messageTemp/delete';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function selectById(){
      var resourceUrl = '/api/messageTemp/select';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function submitInfo(){
      var resourceUrl = '/api/messageTemp/insertSelective';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function edit(){
      var resourceUrl = '/api/messageTemp/edit';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module("hmapFront").controller("MessageTemplateController", MessageTemplateController);

  MessageTemplateController.$inject = ['$rootScope', '$filter', '$state', 'paginationConstants', 'MessageTemplateService', 'SweetAlert'];

  function MessageTemplateController($rootScope, $filter, $state, paginationConstants, MessageTemplateService, SweetAlert) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.template = {};
    vm.template.page = vm.page;
    vm.template.pagesize = vm.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.loadAll = loadAll;
    vm.deleteTemp = deleteTemp;

    vm.loadAll();

    vm.initWeidget = initWeidget;
    initWeidget();

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      if (toState.parent == 'app' && toState.name == 'messageTemplate' && fromState.name == 'messageTemplateEdit') {
        vm.pageChanged();
      }
    });

    function initWeidget() {
      /*PartyService.getLookUp(['SYS.TEMPLE_TYPE'])
       .then(function (data) {
       vm.templateTypeList = data[0];
       })*/
      MessageTemplateService.getByCode().query({ code: 'SYS.MALFUNCTION_LEVE' }, function (data) {
        vm.malfunctionLeveList = data.rows;
      }, function (error) {
      });
      MessageTemplateService.getByCode().query({ code: 'SYS.TEMPLE_TYPE' }, function (data) {
        vm.templateTypeList = data.rows;
      }, function (error) {
      });
    }


    function loadAll() {
      MessageTemplateService.queryAll().query(vm.template, onSuccess, onError)
    }

    function onSuccess(data, headers) {
      vm.templates = data.rows;
      vm.totalItems = data.total;
    }

    function onError(error) {
    }

    function search() {
      //每次搜索的时候把page设为 1
      vm.template.page = vm.page = 1;
      vm.template.pagesize = vm.itemsPerPage;
      loadAll();
    };

    function deleteTemp(id) {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"), { title: $filter('T')("plugin.deletePrompt") }).then(function (p) {
        if (p) {
          if (id) {
            MessageTemplateService.deleteTemp().query({ templateId: id }, onSuccessForDelete, onErrorForDelete)
          }
        }
      });
    }

    function onSuccessForDelete(data, headers) {
      if (data.code == 'succ') {
        loadAll();
      }
    }

    function onErrorForDelete(data, headers) {
      if (data.code != 'succ') {
        SweetAlert.error('error');
      }
    }

    function reset() {
      vm.template.templateName = '';
      vm.template.templateCode = '';
      vm.template.templateType = '';
      vm.template.productName = '';
      vm.template.malfunctionLeve = '';
    }


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      vm.template.page = vm.page;
      vm.template.pagesize = vm.itemsPerPage;
      loadAll();
    }
  }
})();

(function () {
  'use strict';

  angular.module("hmapFront").controller("EditMessageTemplateController", EditMessageTemplateController);

  EditMessageTemplateController.$inject = ['$state', 'SweetAlert', '$scope', 'entity', 'MessageTemplateService', '$filter', 'PromptService', '$uibModalInstance', 'PartyService', 'RoleService', 'toastrConfig', 'toastr'];

  function EditMessageTemplateController($state, SweetAlert, $scope, entity, MessageTemplateService, $filter, PromptService, $uibModalInstance, PartyService, RoleService, toastrConfig, toastr) {
    var vm = this;
    vm.isSending = false;
    vm.template = {};
    vm.edit = edit;

    vm.initWeidget = initWeidget;
    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.clear = clear;
    vm.localeSure = localeSure;

    vm.submitInfo = submitInfo;

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    initWeidget();

    $scope.$on('handleSelectedEditParent', function () {
      vm.template.productId = MessageTemplateService.selectedEditParent.productId;
      vm.template.productName = MessageTemplateService.selectedEditParent.productName;
    });

    function initWeidget() {
      /*MessageTemplateService.getByCode()
        .then(function (data) {
          vm.templateTypeList = data[0].rows;
        })*/
      MessageTemplateService.getByCode().query({ code: 'SYS.MALFUNCTION_LEVE' }, function (data) {
        vm.malfunctionLeveList = data.rows;
      }, function (error) {
      });
      MessageTemplateService.getByCode().query({ code: 'SYS.TEMPLE_TYPE' }, function (data) {
        vm.templateTypeList = data.rows;
      }, function (error) {
      });
    }

    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
      });
    }
    initLangs();

    loadAll();
    vm.template.templateId = entity.id;
    function loadAll() {
      MessageTemplateService.selectById().query({ templateId: entity.id }, function (result) {
        vm.template = result.rows[0];


        var templateNameList = {};
        var templateContentList = {};
        var descriptionList = {};
        var linkAddressList = {};
        var __tls = {};
        RoleService.getRoleLocaleInfo(entity.id, 'com.iot.portal.admin.sys.messagetemplate.dto.MessageTemplateManager', 'templateName')
          .then(function (data) {
            //deal with the multilanguage field value
            templateNameList = {};
            for (var i in data) {
              templateNameList[data[i].langCode] = data[i].value;
            }
            __tls['templateName'] = templateNameList;

            RoleService.getRoleLocaleInfo(entity.id, 'com.iot.portal.admin.sys.messagetemplate.dto.MessageTemplateManager', 'description')
              .then(function (data) {
                //deal with the multilanguage field value
                descriptionList = {};
                for (var i in data) {
                  descriptionList[data[i].langCode] = data[i].value;
                }
                __tls['description'] = descriptionList;
              });

            RoleService.getRoleLocaleInfo(entity.id, 'com.iot.portal.admin.sys.messagetemplate.dto.MessageTemplateManager', 'linkAddress')
              .then(function (data) {
                //deal with the multilanguage field value
                linkAddressList = {};
                for (var i in data) {
                  linkAddressList[data[i].langCode] = data[i].value;
                }
                __tls['linkAddress'] = linkAddressList;
              });

            RoleService.getRoleLocaleInfo(entity.id, 'com.iot.portal.admin.sys.messagetemplate.dto.MessageTemplateManager', 'templateContent')
              .then(function (data) {
                //deal with the multilanguage field value
                templateContentList = {};
                for (var i in data) {
                  templateContentList[data[i].langCode] = data[i].value;
                }
                __tls['templateContent'] = templateContentList;
                vm.template.__tls = __tls;

                $("#templateContentBtn").attr("disabled", false);
                $("#descriptionBtn").attr("disabled", false);
                $("#templateNameBtn").attr("disabled", false);
                $("#linkAddressBtn").attr("disabled", false);
              });
          });




      }, function (error) {

      });
    }

    function submitInfo() {
      if (vm.template.type == undefined || vm.template.type == '') {
        /*  SweetAlert.error("模板类型不能为空",{title:"提示"});*/
        SweetAlert.error($filter('T')('distribution.error_msg'), { title: $filter('T')('title.prompt') });
        return false;
      }
      MessageTemplateService.submitInfo().save(vm.template, onSuccess, onError);
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function edit() {
      MessageTemplateService.edit().save(vm.template, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      if (data.code == 'repeat') {
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      $uibModalInstance.close();
    }

    function onError(error) {
      vm.isSending = true;
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_" + name).modal("show");
      if ($.trim($("#localeModelBody_" + name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='" + name + "_" + langs[i].langCode
            + "' ng-model='vm.template.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_" + name).append(div);
          $("input[name='" + name + "_" + langs[i].langCode + "']").val(vm.template.__tls[name][langs[i].langCode]);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.template.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + name + "_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.template[name] = $("input[name='" + name + "_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_" + name).modal("hide");
      __tls[name] = description;
      vm.template.__tls = __tls;
    }

  }
})();

/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller("ChooseSkuDialogController", ChooseSkuDialogController);

  ChooseSkuDialogController.$inject = ['MessageTemplateService', 'paginationConstants', '$uibModalInstance','$state','toastr','$filter'];

  function ChooseSkuDialogController(MessageTemplateService,paginationConstants, $uibModalInstance,$state,toastr,$filter) {
    var vm = this;
    vm.sku = {};
    vm.product = {};
    vm.sku.resources=[];
    vm.page = 1;
    vm.search=search;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;
    vm.isAllSelected = false;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.clear = clear;
    vm.saveEditParent =saveEditParent;
    vm.saveParent = saveParent;
    vm.selectParent = {};
    vm.selectedEditParent = {};

    vm.loadAll();

    function loadAll() {
      MessageTemplateService.selectAllProduce().query(vm.product, onSuccess, onError)
    }

    function search(){
      vm.product.page = vm.page ;
      vm.product.pagesize = vm.itemsPerPage ;
      if(vm.sku.productName===undefined){
        vm.product.productName = '';
      }
      else{
        vm.product.productName = vm.sku.productName;
      }
      MessageTemplateService.selectAllProduce().query(vm.product, onSuccess, onError)
    }
    function onSuccess(data, headers) {
      vm.sku.resources = data.rows;
      vm.totalItems = data.total;
    }
    function onAddResourceSuccess(data) {
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $uibModalInstance.close(data);
    }

    function onError(error) {
      //console.log('error');

    }

    //save parent
    function saveParent() {
      MessageTemplateService.shareParent(vm.selectParent);
      $uibModalInstance.dismiss('cancel');
    }

    function saveEditParent() {
      MessageTemplateService.shareEidtParent(vm.selectedEditParent);
      $uibModalInstance.dismiss('cancel');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      search();
    };
    function clear() {
      $uibModalInstance.dismiss('cancel');
      // $state.go("roleGrantClient");
    }

    /*function save() {
      vm.sku.resources = [];
      angular.forEach(vm.resources, function (res) {
        if (res.addFlag === 'Y') {
          res.__status = 'add';
          vm.sku.resources.push(res);
        }
      });
      MessageTemplateService.createClient().saveOrUpdate(vm.function, onAddResourceSuccess, onError);

    }*/

    function toggleAll() {

      var toggleStatus = !vm.isAllSelected;
      var resourceStatus = 'N';
      if (toggleStatus) {
        resourceStatus = 'N';
      }
      else {
        resourceStatus = 'Y';
      }
      angular.forEach(vm.resources, function (res) {
        res.addFlag = resourceStatus;
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module("hmapFront").controller("AddMessageTemplateController", AddMessageTemplateController);

  AddMessageTemplateController.$inject = ['$state', 'SweetAlert', '$uibModalInstance', 'MessageTemplateService', '$filter', '$scope', 'PromptService', 'toastrConfig', 'toastr'];

  function AddMessageTemplateController($state, SweetAlert, $uibModalInstance, MessageTemplateService, $filter, $scope, PromptService, toastrConfig, toastr) {
    var vm = this;
    vm.isSending = false;
    vm.template = {};
    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.clear = clear;
    vm.localeSure = localeSure;
    vm.add = add;

    vm.initWeidget = initWeidget;
    initWeidget();
    // langs
    var langs = [];
    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#templateContentBtn").attr("disabled", false);
        $("#descriptionBtn").attr("disabled", false);
        $("#templateNameBtn").attr("disabled", false);
        $("#linkAddressBtn").attr("disabled", false);
      });
    }
    initLangs();

    $scope.$on('handleSelectedParent', function () {
      vm.template.productId = MessageTemplateService.selectedParent.productId;
      vm.template.productName = MessageTemplateService.selectedParent.productName;
    });

    function add() {
      MessageTemplateService.submitInfo().save(vm.template, onSuccess, onError);
      // RoleService.addRole().save(vm.role,onSuccess,onError);
    };

    function onSuccess(data, headers) {
      if (data.code == 'repeat') {
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      $uibModalInstance.close();
    }

    function onError(error) {
      vm.isSending = true;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_" + name).modal("show");
      if ($.trim($("#localeModelBody_" + name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='" + name + "_" + langs[i].langCode
            + "' ng-model='vm.template.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_" + name).append(div);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.template.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + name + "_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.template[name] = $("input[name='" + name + "_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_" + name).modal("hide");
      __tls[name] = description;
      vm.template.__tls = __tls;
    }

    function initWeidget() {
      /*PartyService.getLookUp(['SYS.TEMPLE_TYPE'])
        .then(function (data) {
          vm.templateTypeList = data[0];
        })*/
      MessageTemplateService.getByCode().query({ code: 'SYS.MALFUNCTION_LEVE' }, function (data) {
        vm.malfunctionLeveList = data.rows;
      }, function (error) {
      });
      MessageTemplateService.getByCode().query({ code: 'SYS.TEMPLE_TYPE' }, function (data) {
        vm.templateTypeList = data.rows;
      }, function (error) {
      });
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('messageCenter', {
        parent: 'app',
        url: "/messageCenter",
        views: {
          'body': {
            templateUrl: "app/messageCenter/messageCenter.html",
            controller: 'MessageCenterController',
            controllerAs: 'vm'
          }
        }
      });
  }
})();

/**
 * Created by Koma.Tshu on 2016/8/25.
 */
(function(){
  'use strict';
  angular.module('hmapFront')
    .factory('MessageCenterService', MessageCenterService);
  MessageCenterService.$inject = ['$resource','$http'];

  function MessageCenterService ($resource,$http) {
    var service = {
      sendMessage:sendMessage,
      queryMessageTemplate:queryMessageTemplate
    };
    return service;

    function sendMessage(){
      var resourceUrl ='/api/messageCenter/sendMessage';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

    function queryMessageTemplate(){
      var resourceUrl ='/api/messageTemplate/queryAll';
      return $resource(resourceUrl,{}, {
        'query': {method: 'GET'}
      })
    }
  }
})();

(function () {
  'use strict';

  angular.module("hmapFront")
    .controller("MessageCenterController", MessageCenterController);

  MessageCenterController.$inject = ['$state','MessageCenterService','$filter'];

  function MessageCenterController($state,MessageCenterService,$filter){
    var vm = this;
    vm.isSending=false;
    vm.pushMethod='jPush';
    vm.jpushType='registration';
    vm.contentVar={};
    vm.tag_placeholde = $filter('T')('distribution.tag_placeholde');
    vm.alias_placeholde = $filter('T')('distribution.alias_placeholde');
    vm.registration_placeholde =$filter('T')('distribution.registration_placeholde');
    vm.sms_placeholde = $filter('T')('distribution.sms_placeholder');
    vm.email_placeholder = $filter('T')('distribution.email_placeholder');

    vm.sendMessage=sendMessage;
    vm.selectTemplate=selectTemplate;

    loadAll();
    function loadAll(){
      MessageCenterService.queryMessageTemplate().query({},function (data) {
        vm.templates=data.rows[0];
      },function (error) {
      });
    }

    function sendMessage(){
        var data={
          pushMethod:vm.pushMethod,
          jpushType:vm.jpushType,
          sendObject:vm.sendObject,
          templateId:vm.templates[vm.pushMethod][vm.messageTemplateIndex].id,
          contentVar:angular.toJson(vm.contentVar)
        };
      MessageCenterService.sendMessage().query(data,onSuccess,onError)
    }

    function selectTemplate(){
      vm.messageTemplateId=vm.templates[vm.pushMethod][vm.messageTemplateIndex].id;
      vm.requestMsg=vm.templates[vm.pushMethod][vm.messageTemplateIndex].content;
    }

    function onSuccess(data) {
      vm.isSending=false;
      vm.retMsg="发送成功";
    }
    function onError(error) {
      vm.isSending=false;
      vm.retMsg="发送失败";
    }
  }
})();


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('ShowChartsController', ShowChartsController);

  ShowChartsController.$inject = ['MenuUsageService','$scope', '$state', 'paginationConstants','entity'];

  function ShowChartsController(MenuUsageService,$scope, $state, paginationConstants,entity) {

    var vm = this;
    vm.labels=[];//X轴数据
    vm.series=['菜单使用次数'];
    vm.data = [[]];//y轴数据
    vm.load=load;
    vm.charts = [];
    vm.menuId = entity.id;
    vm.countUser=0;
    vm.dateOptions = dateOptions;
    vm.startOpen1 = startOpen1;
    vm.startOpen2 = startOpen2;

    vm.queryDate={
      startDate:new Date(),
      endDate:new Date()
    }

    vm.load(entity.id,7);

    function load(id,total) {
      // console.log(angular.toJson(vm.queryDate));
      if(total==7){
        vm.queryDate.startDate = new Date((vm.queryDate.endDate/1000-86400*6)*1000);
        // console.log(angular.toJson(vm.queryDate));
      }else if(total==14){
        vm.queryDate.startDate = new Date((vm.queryDate.endDate/1000-86400*13)*1000);
      }else if(total==30){
        vm.queryDate.startDate = new Date((vm.queryDate.endDate/1000-86400*29)*1000);
      }
      if(vm.queryDate.startDate>vm.queryDate.endDate){
        swal('结束时间必须大于开始时间');
        return;
      }

      if(id){
        console.log(vm.queryDate.startDate.toLocaleDateString()+' '+vm.queryDate.endDate.toLocaleDateString());
        vm.labels=[];
        vm.data = [[]];
        return MenuUsageService.queryData(id,vm.queryDate.startDate.toLocaleDateString(),vm.queryDate.endDate.toLocaleDateString()).then(
          function (data) {
            // console.log(angular.toJson(data));
            vm.countUser=data.total;
            // vm.countUser=0;
            vm.charts = data.rows;
              for(var i=0;i<vm.charts.length-1;i++){
                vm.labels.push(vm.charts[i].accessDate);
                vm.data[0].push(vm.charts[i].count);
                // vm.countUser = vm.countUser+parseInt(vm.charts[i].count);
              }
          }
        )
      }
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2050, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function startOpen1() {
      vm.isStartOpen1 = true;
    }

    function startOpen2() {
      vm.isStartOpen2 = true;
    }

    vm.onClick=function (points,evt) {
    }
    vm.datasetOverride = [{ yAxisID: 'y-axis-1' }];
    vm.options = {
      scales: {
        yAxes: [
          {
            id: 'y-axis-1',
            type: 'linear',
            display: true,
            position: 'left'
          }
        ]
      }
    };

  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('menuUsage', {
        parent: 'app',
        url: "/menuUsage",
        views: {
          'body': {
            templateUrl: "app/menuUsage/menuUsage.html",
            controller: 'MenuUsageController',
            controllerAs: 'vm'
          }
        }
      }).state('menuUsage.showChart', {
      parent: 'app',
      url: "/menuUsage/:id",
      params:{
        id:''
      },
      views: {
        'body': {
          templateUrl: "app/menuUsage/showCharts.html",
          controller: 'ShowChartsController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            id: $stateParams.id
          };
        }
      }
    });
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('MenuUsageService', MenuUsageService);

  MenuUsageService.$inject = ['$resource', '$http'];

  function MenuUsageService($resource,$http) {
    var service = {
      geiAllMenu: geiAllMenu,
      queryData:queryData
    };
    return service;

    function geiAllMenu() {
      var resourceUrl = '/api/menuUsage/queryAll';
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function queryData(id,from,to) {
      // var resourceUrl = '/api/menuUsage/queryChartData?id='+id+'&totalDay='+totalDay;
      // return $resource(resourceUrl, {}, {
      //   'query': {method: 'GET'}
      // });

      var resourceUrl = '/api/menuUsage/queryChartData?id='+id+'&from='+from+'&to='+to;
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      });
    }
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('MenuUsageController', MenuUsageController);

  MenuUsageController.$inject = ['MenuUsageService','$scope', '$state', 'paginationConstants'];

  function MenuUsageController(MenuUsageService,$scope, $state, paginationConstants) {

    var vm = this;

    vm.result=[];

    loadAll();

    function loadAll() {
      return MenuUsageService.geiAllMenu()
        .then(function (data) {
          vm.result = data.rows;
        })
    }
  }
})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('ShowVersionController', ShowVersionController);

  ShowVersionController.$inject = ['MenuService', '$scope', '$state', '$uibModalInstance', 'entity'];

  function ShowVersionController(MenuService, $scope, $state, $uibModalInstance, entity) {
    var vm = this;
    vm.version = entity;

    vm.clear = clear;
    vm.loadOneVersion=loadOneVersion;
    vm.getPermission=getPermission;

    vm.permissionData=[];
    vm.permissions=[];

    vm.loadOneVersion(entity.id);

    function clear() {
      $uibModalInstance.close(vm.version.menuId);
    }

    function loadOneVersion(id) {
      if(id){
        MenuService.getOneVersion().query({id: id}, function (result) {
          vm.version = result.rows[0];
          if(vm.version.showConer=='Y'){
            vm.version.showConer=true;
          }else{
            vm.version.showConer=false;
          }
          if(vm.version.isSilenceUpdate=='Y'){
            vm.version.isSilenceUpdate=true;
          }else{
            vm.version.isSilenceUpdate=false;
          }
          if(vm.version.isForceUpdate=='Y'){
            vm.version.isForceUpdate=true;
          }else{
            vm.version.isForceUpdate=false;
          }


          getPermission();
        });
      }
    }

    function getPermission(){
      MenuService.getPermissionData().query({id: vm.version.id}, function (data){
        vm.result = data.rows;
        for(var i=0;i<vm.result.length;i++){
          vm.permissionData.push({id:vm.result[i].id,dataIcon:vm.result[i].valueIcon,dataType:vm.result[i].dataType,
            dataValue:vm.result[i].dataValue,dataId:vm.result[i].dataKey})
        }
      });
    }

  }


})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('menu', {
        parent: 'app',
        url: "/menu",
        params:{
          appId:''
        },
        views: {
          'body': {
            templateUrl: "app/menu/menu.html",
            controller: 'MenuController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              appId: $stateParams.appId
            };
          }
        }
      }).state('menu.detail', {
      parent: 'app',
      url: "/menu/:id",
      params:{
        id:''
      },
      views: {
        'body': {
          templateUrl: "app/menu/menu-detail.html",
          controller: 'MenuDetailController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            id: $stateParams.id
          };
        }
      }
    }).state('menu.newMenu', {
      parent: 'app',
      url: "/newMenu/:appId",
      views: {
        'body': {
          templateUrl: "app/menu/menu-new.html",
          controller: 'MenuNewController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            appId: $stateParams.appId
          };
        }
      }
    }).state('menu.addVersion', {
      parent: 'app',
      url: "/addVersion/:id",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/menu/addVersion.html',
          controller: 'AddVersionController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                id:$stateParams.id
              };
            }
          }
        }).result.then(function (res) {
          $state.go('menu.detail',{id:res});
        }, function (err) {
          $state.go('menu.detail',{id:res});
        });
      }]
    }).state('menu.showVersion', {
      parent: 'app',
      url: "/showVersion/:id",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/menu/showVersion.html',
          controller: 'ShowVersionController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                id:$stateParams.id
              };
            }
          }
        }).result.then(function (res) {
          $state.go('menu.detail',{id:res});
        }, function (err) {
          $state.go('menu');
        });
      }]
    });
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('MenuService', MenuService);

  MenuService.$inject = ['$resource', '$http'];

  function MenuService($resource,$http) {
    var service = {
      findMenu: findMenu,
      getMenu:getMenu,
      getPermissionData:getPermissionData,
      generateUUID:generateUUID,
      savePermissionData:savePermissionData,
      insertOrUpdate:insertOrUpdate,
      insertVersion:insertVersion,
      getVersion:getVersion,
      getOneVersion:getOneVersion,
      deleteVersion:deleteVersion,
      getCategoryList:getCategoryList,
      getAppAuthList:getAppAuthList
    };
    return service;

    function getCategoryList(appId) {
      var resourceUrl = '/api/menuCategory/getList?appId='+appId;
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function findMenu(menu) {

      var resourceUrl = '/api/menu/query';
      var data=menu;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
      // return $http.get(resourceUrl).then(function(response){
      //   return response.data;
      // })
    }

    function getMenu() {
      var resourceUrl = '/api/menu/getMenu/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function getPermissionData() {
      var resourceUrl = '/api/applicationPermission/query/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET', isArray: false}
      });
    }

    function generateUUID() { //生成新的UUID
      var date = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    };

    function savePermissionData(dataId) {
      var resourceUrl = '/api/applicationPermission/save?dataId='+dataId;
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function insertOrUpdate() {
      var resourceUrl = '/api/menu/insertOrUpdate';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    };

    function insertVersion() {
      var resourceUrl = '/api/menuVersion/insertVersion';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    };

    function getVersion() {
      var resourceUrl = '/api/menuVersion/getVersion/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function getOneVersion() {
      var resourceUrl = '/api/menuVersion/getOneVersion/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function getAppAuthList() {
      var resourceUrl = '/api/appauth/getList';
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function deleteVersion() {
      var resourceUrl = '/api/menuVersion/deleteVersion/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('MenuController', MenuController);

  MenuController.$inject = ['MenuService','$scope', '$state', 'paginationConstants','entity'];

  function MenuController(MenuService,$scope, $state, paginationConstants,entity) {

    var vm = this;
    vm.loadAppAuthList = loadAppAuthList;
    vm.loadAll = loadAll;
    console.log('entuty:'+angular.toJson(entity))
    vm.menu = {
      appId:''
    };
    // if(entity){
    //   vm.menu.appId=entity.appId;
    // }
    vm.uploadPic="assets/images/upload.png";
    vm.appList=[];
    // var menu = vm.menu;

    vm.result=[];

    loadAppAuthList();
    // loadAll(menu);

    function loadAll(menu) {
      return MenuService.findMenu(menu)
        .then(function (data) {
          vm.result = data.rows;
        })
    }

    function loadAppAuthList() {
      return MenuService.getAppAuthList()
        .then(function (data) {
          vm.appList = data.rows;
          // console.log('appList--'+angular.toJson(vm.appList));
          for(var i=0;i<vm.appList.length;i++){
            sessionStorage.setItem(vm.appList[i].id,vm.appList[i].appId);
          }
          if(vm.appList.length>0){
            if(entity.appId!=''){
              vm.menu.appId=entity.appId;
            }else{
              vm.menu.appId=vm.appList[0].appId;
            }
            loadAll(vm.menu)
          }else{
            // console.log('暂无应用');
          }
        })
    }
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('MenuNewController', MenuNewController);

  MenuNewController.$inject = ['$filter','MenuService', '$scope', '$state', '$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','toastr','entity'];

  function MenuNewController($filter,MenuService, $scope, $state, $localStorage, $sessionStorage, $timeout, Upload, BaseConfig,toastr,entity) {
    var vm = this;
    // vm.menu = entity;
    // console.log('entity='+angular.toJson(entity))
    vm.save = save;
    vm.submitFile = submitFile;
    vm.upload = upload;
    vm.oldFile="assets/images/logo-header.png";
    vm.changeFile=changeFile;
    vm.clear=clear;
    vm.permissionData=[];
    // vm.savePermission=savePermission;
    vm.file = "";
    vm.categoryList=[];
    vm.loadList=loadList;

    loadList(entity.appId);

    function loadList(appId) {
      return MenuService.getCategoryList(appId)
        .then(function (data) {
          vm.categoryList = data.rows;
          // console.log('liebiao_'+angular.toJson(vm.categoryList))
        })
    }

    function changeFile() {
      if(vm.file){
        vm.oldFile=vm.file
      }
    }
    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitFile() {
      if(vm.oldFile!="assets/images/logo-header.png"){
        vm.file=vm.oldFile;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    };

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        ////console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.menu.menuIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"), $filter('T')("title.confirmTitle"));
      }).error(function (data, status, headers, config) {
        //上传失败
        ////console.log('错误状态: ' + status);
      });
    };

    function save() {
      if(vm.menu.isMandatory==true){
        vm.menu.isMandatory='Y';
      }else{
        vm.menu.isMandatory='N';
      }

      vm.permissions=[];//拿选取的权限数据
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=MenuService.generateUUID();
        }
        vm.permissions.push({id:permissionId,valueIcon:vm.permissionData[i].dataIcon,dataId:'',
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,dataKey:vm.permissionData[i].dataId,
          visibilityType:'WEBAPP'})
      }
      vm.menu.appId=entity.appId;
      vm.menu.applicationPermissions = vm.permissions;
      // console.log('保存的是：'+angular.toJson(vm.menu));
      MenuService.insertOrUpdate().save(vm.menu, onSuccess, onError);
      // console.log(angular.toJson(vm.menu));
    };
    function onSuccess(data, headers) {
      vm.menu = data.rows[0];
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      $state.go('menu');
    }
    function onError(error) {
    }
    function clear() {
      $state.go('menu',{appId:entity.appId});
      // $state.go('menu');
    }

    /*function savePermission() {
      vm.permissions=[];
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=MenuService.generateUUID();
        }
        vm.permissions.push({id:permissionId,dataIcon:vm.permissionData[i].dataIcon,dataId:vm.menu.id,
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,valueId:vm.permissionData[i].dataId,
          visibilityType:'WEBAPP'})
      }
      MenuService.savePermissionData(vm.menu.id).save(vm.permissions);
    }*/
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('MenuDetailController', MenuDetailController);

  MenuDetailController.$inject = ['$filter','MenuService', '$scope', '$state', '$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','toastr','entity'];

  function MenuDetailController($filter,MenuService, $scope, $state, $localStorage, $sessionStorage, $timeout, Upload, BaseConfig,toastr,entity) {
    var vm = this;
    vm.menu = entity;

    vm.save = save;
    vm.submitFile = submitFile;
    vm.upload = upload;

    vm.load=load;
    vm.loadVersion=loadVersion;
    vm.deleteVersion = deleteVersion;
    vm.oldFile="assets/images/logo-header.png";

    vm.clear = clear;
    vm.ischecked="";
    vm.mouseIn="";
    vm.permissions=[];
    vm.check=check;
    vm.nocheck=nocheck;
    vm.changeFile=changeFile;

    vm.savePermission=savePermission;
    vm.getPermission=getPermission;
    vm.permissionData=[];
    vm.menuVersions=[];
    vm.categoryList=[];
    vm.loadList=loadList;

    vm.load(entity.id);
    vm.loadVersion(entity.id);

    vm.file = "";

    function loadList(appId) {
      return MenuService.getCategoryList(appId)
        .then(function (data) {
          vm.categoryList = data.rows;
          // console.log('liebiao_'+angular.toJson(vm.categoryList))
        })
    }

    function changeFile() {
      if(vm.file){
        vm.oldFile=vm.file
      }
    }

    function load(id) {
      if(id){
        MenuService.getMenu().query({id: id}, function (result) {
          vm.menu = result.rows[0];
          vm.loadList(vm.menu.appId);
          // console.log('后台传来的是：'+angular.toJson(vm.menu));
          if(vm.menu.isMandatory=='Y'){
            vm.menu.isMandatory=true;
          }else{
            vm.menu.isMandatory=false;
          }
          if(vm.menu.status=='Y'){
            vm.menu.status=true;
          }else{
            vm.menu.status=false;
          }
          getPermission();
          vm.oldFile=vm.menu.menuIcon;
        });
      }
    }

    function loadVersion(id) {
      if(id){
        MenuService.getVersion().query({id: id}, function (result) {
          vm.menuVersions = result.rows;
        });
      }
    }

    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitFile() {
      if(vm.oldFile!="assets/images/logo-header.png"){
        vm.file=vm.oldFile;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    };

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With':'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        ////console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.menu.menuIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        // toastr.success('图片上传成功!', '提示信息');
        vm.save();
      }).error(function (data, status, headers, config) {
        //上传失败
        ////console.log('错误状态: ' + status);
      });
    };

    function deleteVersion(id) {
      if(id){
        MenuService.deleteVersion().query({id: id}, function (result) {
          toastr.success($filter('T')('title.deleteSuccess'),$filter('T')('title.confirmTitle'));
          // $state.go('menu.detail/'+entity.id);
          vm.loadVersion(entity.id);
        });
      }
    }

    function save() {
      if(vm.menu.isMandatory==true){
        vm.menu.isMandatory='Y';
      }else{
        vm.menu.isMandatory='N';
      }
      if(vm.menu.status==true){
        vm.menu.status='Y';
      }else{
        vm.menu.status='N';
      }

      vm.permissions=[];//拿选取的权限数据
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=MenuService.generateUUID();
        }
        vm.permissions.push({id:permissionId,valueIcon:vm.permissionData[i].dataIcon,dataId:'',
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,dataKey:vm.permissionData[i].dataId,
          visibilityType:'WEBAPP'})
      }
      vm.menu.applicationPermissions = vm.permissions;
      MenuService.insertOrUpdate().save(vm.menu, onSuccess, onError);
    };
    function onSuccess(data, headers) {
      vm.menu=data.rows[0];
      if(vm.menu.isMandatory==='Y'){
        vm.menu.isMandatory=true;
      }else{
        vm.menu.isMandatory=false;
      }
      if(vm.menu.status=='Y'){
        vm.menu.status=true;
      }else{
        vm.menu.status=false;
      }

      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      vm.ischecked="";
      vm.mouseIn="";
      // $state.go('menu.detail',{id:entity.id});
    }
    function onError(error) {
    }
    function clear() {
      $state.go('menu',{appId:vm.menu.appId});
      // $state.go('menu');
    }
    function check(name) {
      vm.ischecked=name;
    }
    function nocheck($event) {
      vm.ischecked="";
      $event.stopPropagation();
    }

    function savePermission() {
      vm.permissions=[];
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=MenuService.generateUUID();
        }
        // console.log('permissionData-->'+angular.toJson(vm.permissionData[i]));
        vm.permissions.push({id:permissionId,valueIcon:vm.permissionData[i].dataIcon,dataId:vm.menu.id,
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,dataKey:vm.permissionData[i].dataId,
          visibilityType:'WEBAPP'})
      }
      MenuService.savePermissionData(vm.menu.id).save(vm.permissions, onSuccess1, onError1);
    }
    function onSuccess1(data, headers) {
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      vm.ischecked="";
      vm.mouseIn="";
    }
    function onError1(error) {
    }

    function getPermission(){
      MenuService.getPermissionData().query({id: vm.menu.id}, function (data){
        vm.result = data.rows;
        // console.log('vm.result'+angular.toJson(vm.result));
        for(var i=0;i<vm.result.length;i++){
          vm.permissionData.push({id:vm.result[i].id,dataIcon:vm.result[i].valueIcon,dataType:vm.result[i].dataType,
            dataValue:vm.result[i].dataValue,dataId:vm.result[i].dataKey})
        }
        // console.log('vm.permissionData'+angular.toJson(vm.permissionData));
      });
    }
  }
})();

/**
 * Created by 罗平 on 2016/9/29.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddVersionController', AddVersionController);

  AddVersionController.$inject = ['$filter','MenuService', '$scope', '$state', '$uibModalInstance','entity','toastr','Upload','BaseConfig','$localStorage','$sessionStorage'];

  function AddVersionController($filter,MenuService, $scope, $state, $uibModalInstance,entity,toastr,Upload,BaseConfig,$localStorage,$sessionStorage) {
    var vm = this;
    vm.savePermission=savePermission;
    vm.permissionData=[];
  /*  vm.changConer = changConer;*/
    vm.typeFlag = true;
    vm.showButton = true;
    vm.noEdit = false;
    // vm.noButton = false;
    vm.menuVersion = {
      menuId:'',
      menuVersionVisible:''
    };
    vm.menuVersion.menuId = entity.id;
    // console.log('id'+angular.toJson(entity))
    vm.clear = clear;
    vm.add = add;
    vm.loadMenu = loadMenu;
    vm.upFile=upFile;
    vm.localUpLoad=localUpLoad;

    vm.loadMenu(entity.id);
    function loadMenu(id) {
      if(id){
        MenuService.getMenu().query({id: id}, function (result) {
          vm.menu = result.rows[0];
          if(vm.menu.menuType=='LOCAL'){
            vm.typeFlag = true;
            vm.showButton = true;
          }else{
            vm.typeFlag = false;
            vm.showButton = false;
          }
        });
      }
    }

    function add() {
      var menuVersionVisible = '';
      for(var i=0;i<vm.permissionData.length;i++){
        menuVersionVisible = menuVersionVisible+vm.permissionData[i].dataValue+';';
      }
      vm.menuVersion.menuVersionVisible=menuVersionVisible;
      if(vm.menuVersion.showConer==true){
        vm.menuVersion.showConer='Y';
      }else{
        vm.menuVersion.showConer='N';
      }
      if(vm.menuVersion.isSilenceUpdate==true){
        vm.menuVersion.isSilenceUpdate='Y';
      }else{
        vm.menuVersion.isSilenceUpdate='N';
      }
      if(vm.menuVersion.isForceUpdate==true){
        vm.menuVersion.isForceUpdate='Y';
      }else{
        vm.menuVersion.isForceUpdate='N';
      }
      vm.permissions=[];//保存的权限数据
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=MenuService.generateUUID();
        }
        vm.permissions.push({id:permissionId,valueIcon:vm.permissionData[i].dataIcon,dataId:'',
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,dataKey:vm.permissionData[i].dataId,
          visibilityType:'WEBVERSION'})
      }
      vm.menuVersion.applicationPermissions=vm.permissions;
      MenuService.insertVersion().save(vm.menuVersion, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      vm.menuVersion = data.rows[0];
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $uibModalInstance.close(entity.id);
    }
    function onError(error) {
    }

    function clear() {
      $uibModalInstance.close(entity.id);
    }

    function savePermission() {
      vm.permissions=[];
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=MenuService.generateUUID();
        }
        vm.permissions.push({id:permissionId,dataIcon:vm.permissionData[i].dataIcon,dataId:vm.menuVersion.id,
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,valueId:vm.permissionData[i].dataId,
          visibilityType:'WEBVERSION'})
      }
      // console.log('vm.menu.id--'+vm.menuVersion.id);
      MenuService.savePermissionData(vm.menuVersion.id).save(vm.permissions);
    }

    function localUpLoad(target){
      if(vm.menu.menuType=='LOCAL'){
        document.getElementById(target).click();
      }
    }

    function upFile(){
      var file=document.getElementById("zip").files[0];
      if (file == null || file== undefined || file == '') {
        return false;
      }
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/menuVersion/uploadZip',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'requestFrom': 'admin'
        },
        data: {file: file}
      }).progress(function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        // vm.picurl=data.rows[0].pictureUrl;
        // $state.go('legwork', null, {reload: true});
        console.log('上传后拿到的内容是：'+angular.toJson(data));
        console.log("成功上传：");
        if(data.success==false){
          toastr.error($filter('T')("plugin.packageUploadFail"), $filter('T')("title.ErrorInfo"));
          return ;
        }
        vm.menuVersion.cloudUrl = data.rows[0].zipUrl;
        /*vm.menuVersion.menuVersion = data.rows[0].menuVersion;
        vm.menuVersion.menuDesc = data.rows[0].menuDesc;
        vm.menuVersion.menuResource = data.rows[0].menuResource;
        vm.menuVersion.menuLocalPath = data.rows[0].menuLocalPath;
        vm.menuVersion.showConer = data.rows[0].showConer;
        vm.menuVersion.isSilenceUpdate = data.rows[0].isSilenceUpdate;
        vm.menuVersion.isForceUpdate = data.rows[0].isForceUpdate;
        if(vm.menuVersion.showConer=='Y'){
          vm.menuVersion.showConer=true;
        }else{
          vm.menuVersion.showConer=false;
        }
        if(vm.menuVersion.isSilenceUpdate=='Y'){
          vm.menuVersion.isSilenceUpdate=true;
        }else{
          vm.menuVersion.isSilenceUpdate=false;
        }
        if(vm.menuVersion.isForceUpdate=='Y'){
          vm.menuVersion.isForceUpdate=true;
        }else{
          vm.menuVersion.isForceUpdate=false;
        }
        vm.noEdit = true;*/
      }).error(function (data, status, headers, config) {

      });
    }

  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('localMaterial', {
      parent: 'app',
      url: "/localMaterial",
      views: {
        'body': {
          templateUrl: "app/localMaterial/localMaterial.html",
          controller: 'localMaterialController',
          controllerAs: 'vm'
        }
      }
    })
  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('localMaterialService', localMaterialService);

  localMaterialService.$inject = ['$resource','$http'];

  function localMaterialService($resource,$http) {
    var service = {
      moveGroup:moveGroup,
      deleteAttachment:deleteAttachment,
      modifyName:modifyName
    };
    return service;

    function moveGroup(data) {
      var resourceUrl = '/api/attachment/moveGroup';
      return $http.post(resourceUrl,data).then(function(response){
        //console.log("response: "+angular.toJson(response.data));
        return response.data;
      });
    }

    function deleteAttachment(data){
      var resourceUrl = '/api/attachment/deleteAttachment';
      return $http.post(resourceUrl,data).then(function(response){
        //console.log("response: "+angular.toJson(response.data));
        return response.data;
      });
    }

    function modifyName(data){
      var resourceUrl = '/api/attachment/modifyName';
      return $http.post(resourceUrl,data).then(function(response){
        //console.log("response: "+angular.toJson(response.data));
        return response.data;
      });
    }

  }
})();

/**
 * Created by zhusifeng on 2016/8/31.
 */
(function () {
  'use strict';
  angular.module('hmapFront')
         .controller('localMaterialController', localMaterialController);

  localMaterialController.$inject = ['$filter','$state','$scope','$uibModal','$stateParams','$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','paginationConstants','SweetAlert','localMaterialService','umEditorService'];
  function localMaterialController($filter,$state,$scope,$uibModal,$stateParams,$localStorage,$sessionStorage,$timeout,Upload,BaseConfig,paginationConstants,SweetAlert,localMaterialService,umEditorService) {
    var vm = this;
    vm.page = 1;
    vm.pageSize = 8;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.groupData=[];
    vm.pictures=[];
    vm.currentGroup="unGroup";  //未分组
    vm.type="IMAGE";
    vm.seletAllFlag=false;
    vm.selectPictureCount=0;
    vm.popover = {
      editNameUrl: 'editName.html',
      moveGroupUrl: 'moveGroup.html',
      createGroupUrl:'createGroup.html'
    };

    vm.editName=editName;
    vm.editNameClose=editNameClose;
    vm.confirmEditName=confirmEditName;
    vm.moveGroup=moveGroup;
    vm.confrimMoveGroup=confrimMoveGroup;
    vm.batchMoveGroup=batchMoveGroup;
    vm.moveGroupClose=moveGroupClose;
    vm.deleteAttachement=deleteAttachement;
    vm.batchDeleteAttachement=batchDeleteAttachement;
    vm.selectPicture=selectPicture;
    vm.selectedGroup=selectedGroup;
    vm.selectAll=selectAll;
    vm.localUpLoad=localUpLoad;
    vm.upLoadImage=upLoadImage;
    vm.addGroup=addGroup;
    vm.closeAddGroup=closeAddGroup;


    vm.loadAll();
    function loadAll() {
      queryGroup();
    }

    function queryGroup(){
      umEditorService.queryAttachmentGroup().then(function(data){
        vm.groupData= data.rows;
        queryPicture();
      },function(error){
        //console.log(error);
        SweetAlert.error($filter('T')("title.queryFailed"), {title:$filter('T')("title.infoTitle")});
      });
      queryPicture()
    }
    function queryPicture(){
      var data={groupId:vm.currentGroup,type:vm.type,pageCount:vm.page,pageSize:vm.pageSize};
      umEditorService.queryAttachment(data).then(function(resp){
        vm.pictures= resp.rows;
        vm.totalItems = resp.total;
        vm.seletAllFlag=false;
        vm.selectPictureCount=0;
      },function(error){
        //console.log(error);
        SweetAlert.error($filter('T')("title.queryFailed"), {title:$filter('T')("title.infoTitle")});
      });
    }

    function selectAll(){
        for (var i=0;i<vm.pictures.length;i++){
          vm.pictures[i].selectFlag=vm.seletAllFlag;
        }
        if(vm.seletAllFlag){
          vm.selectPictureCount=vm.pictures.length;
        }else{
          vm.selectPictureCount=0;
        }

    }
    function selectPicture(index){
      if(vm.pictures[index].selectFlag!=undefined&&vm.pictures[index].selectFlag){
        vm.pictures[index].selectFlag=false;
        vm.selectPictureCount--;
      }else{
        vm.pictures[index].selectFlag=true;
        vm.selectPictureCount++;
      }
    }
    //标注选定的组
    function selectedGroup(groupId){
      vm.currentGroup=groupId;
      queryPicture();
    }

    function batchDeleteAttachement(){
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          var ids=[];
          for (var i=0;i<vm.pictures.length;i++){
            if(vm.pictures[i].selectFlag!=undefined && vm.pictures[i].selectFlag){
              ids.push(vm.pictures[i].attachmentId);
            }
          }
          localMaterialService.deleteAttachment({"ids":ids}).then(function (data) {
            SweetAlert.success($filter('T')("title.deleteSuccess"), {title:$filter('T')("title.infoTitle")});
            queryGroup();
          },function (error) {
            //console.log(error);
            SweetAlert.error($filter('T')("title.deleteFail"), {title:$filter('T')("title.infoTitle")});
          })
        }
      },function (p) {
      })
    }
    function deleteAttachement(id){
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          var ids=[];
          ids.push(id);
          localMaterialService.deleteAttachment({"ids":ids}).then(function (data) {
            SweetAlert.success($filter('T')("title.deleteSuccess"), {title:$filter('T')("title.infoTitle")});
            queryGroup();
          },function (error) {
            //console.log(error);
            SweetAlert.error($filter('T')("title.deleteFail"), {title:$filter('T')("title.infoTitle")});
          });
        }
      },function (p) {
      })
    }

    function editName(index){  //弹框
      if(vm.editIndex!=undefined){
        editNameClose();
      }
      vm.newPictureName=vm.pictures[index].attachmentName;
      vm.pictureId=vm.pictures[index].attachmentId;
      vm.editIndex=index;
    }
    function confirmEditName(){
      localMaterialService.modifyName({id:vm.pictureId,newName:vm.newPictureName}).then(function (data) {
        SweetAlert.success($filter('T')("title.operationSuccess"), {title:$filter('T')("title.infoTitle")});
        editNameClose();
        queryPicture();
      },function (error) {
        //console.log(error);
        SweetAlert.error($filter('T')("title.operationFailed"), {title:$filter('T')("title.infoTitle")});
      });
    }
    function editNameClose(){
      vm.pictures[vm.editIndex].isEditName=false;
    }


    function moveGroup(index){  //弹框
      if(vm.moveIndex!=undefined){
        moveGroupClose();
      }
      vm.selectRadio=undefined;
      vm.moveIndex=index;
    }
    function batchMoveGroup(){
      var ids=[];
      for (var i=0;i<vm.pictures.length;i++){
        if(vm.pictures[i].selectFlag!=undefined && vm.pictures[i].selectFlag){
          ids.push(vm.pictures[i].attachmentId);
        }
      }
      localMaterialService.moveGroup({ids:ids,groupId:vm.selectRadio}).then(function (data) {
        SweetAlert.success($filter('T')("title.groupingSuccess"), {title:$filter('T')("title.infoTitle")});
        queryGroup();
      },function (error) {
        //console.log(error);
        SweetAlert.error($filter('T')("title.groupingFail"), {title:$filter('T')("title.infoTitle")});
      })
    }
    function confrimMoveGroup(){
      var ids=[];
      ids.push(vm.pictures[vm.moveIndex].attachmentId);
      localMaterialService.moveGroup({ids:ids,groupId:vm.selectRadio}).then(function (data) {
        SweetAlert.success($filter('T')("title.groupingSuccess"), {title:$filter('T')("title.infoTitle")});
        moveGroupClose();
        queryGroup();
      },function (error) {
        //console.log(error);
        SweetAlert.error($filter('T')("title.groupingFail"), {title:$filter('T')("title.infoTitle")});
      })
    }
    function moveGroupClose(){
      if(vm.moveIndex=='batch'){ //批量分组
        vm.isBatchMoveGroup=false;
      }else{
        vm.pictures[vm.moveIndex].isMoveGroup=false;
      }
    }

    /*弹出input file加载文件框*/
    function localUpLoad(){
      document.getElementById("picture").click();
    }
    function upLoadImage(){
      var file=document.getElementById("picture").files[0];
      if (file == null || file== undefined || file == '') {
        //console.log('文件为空: ' + file)
        return false;
      }
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/attachment/uploadFile',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file,type:vm.type,groupId:vm.currentGroup}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        //console.log("服务器返回的数据：", angular.toJson(data));
        queryGroup();
      }).error(function (data, status, headers, config) {
        //上传失败
        //console.log('上传失败,服务器返回的数据: ' + angular.toJson(data));
        SweetAlert.error(data.message,{title:$filter('T')("title.infoTitle")});
      });
    }

    //确认新建
    function addGroup(){
      var data={groupName:vm.groupName};
      umEditorService.addAttachmentGroup(data).then(function(resp){
        closeAddGroup();
        queryGroup();
      });
    }

    function closeAddGroup(){
      vm.isCreateGroup=false;
      vm.groupName='';
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      queryPicture();
    }

  }
})();


/**
 * Created by mclin on 2017-4-14.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('lang', {
        parent: 'app',
        url: "/lang",
        views: {
          'body': {
            templateUrl: "app/lang/lang.html",
            controller: 'LangController',
            controllerAs: 'vm'
          }
        }

      }).state('lang.edit', {
      parent: 'lang',
      url: "/edit/:langCode",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        ////console.log($uibModal);
        $uibModal.open({
          templateUrl: 'app/lang/editLang.html',
          controller: 'EditLangController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              //console.log("entity:"+angular.toJson($stateParams.codeId));
              return {
                langCode:$stateParams.langCode,
                baseLang: null,
                description: null
              };
            }
          }
        }).result.then(function () {
          //console.log("coding go1");
          $state.go('lang', null, {reload: 'lang'});
        }, function () {
          //console.log("coding go2");
          $state.go('lang');
        });
      }]
    }).state('lang.add', {
      parent: 'lang',
      url: "/add",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/lang/addLang.html',
          controller: 'AddLangController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function($stateParams) {
              return {
                langCode: null,
                baseLang: null,
                description: null
              }
            }
          }
        }).result.then(function () {
          //console.log("coding go1");
          $state.go('lang', null, {reload: 'lang'});
        }, function () {
          //console.log("coding go2");
          $state.go('lang');
        });
      }]
    })

  }
})();

/**
 * Created by mclin on 2017-4-14.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('LangService', LangService);

  LangService.$inject = ['$resource', '$http', '$state'];

  function LangService($resource, $http) {
    var service = {
      findLangs: findLangs,
      updateLangs: updateLangs,
      addLang: addLang,
      deleteLang:deleteLang
    };
    return service;

    function findLangs(lang,page,pagesize) {
      if(page==undefined){
        page = 1;
      }
      if(pagesize == undefined){
        pagesize = 10;
      }
      //console.log("service  code:" + angular.toJson(code));
      var resourceUrl = '/api/lang/query?page='+page+'&pagesize='+pagesize;

      //console.log("data params:"+angular.toJson(data));
      return $http.post(resourceUrl, lang, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response.data));
        return response.data;
      });
    }


    function updateLangs(lang) {

      var resourceUrl = '/sys/language/submit';
      var data = [];
      lang['__status'] = 'update';
      data[0] = lang;
      //console.log("service  code:" + angular.toJson(data));
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });

    };

    function addLang(lang) {
      var resourceUrl = "/sys/language/submit";
      var data = [];
      lang['__status'] = 'add';
      data[0] = lang;
      //console.log("insert code:" + angular.toJson(code));

      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;

      });
    };

    function deleteLang(lang) {
      var resourceUrl = "/sys/language/delete";
      var data = [];
      lang['__status'] = 'delete';
      data[0] = lang;
      //console.log("delete code:"+angular.toJson(code));
      return $http.post(resourceUrl, data).then(function (response) {
        return response.data;
      })
    }

  }

})();

/**
 * Created by mclin on 2017-4-14.
 */
/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('LangController', LangController);

  LangController.$inject = ['$filter','LangService', '$state', 'paginationConstants','SweetAlert','toastr'];

  function LangController($filter,LangService, $state, paginationConstants,SweetAlert,toastr) {
    var vm = this;

    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.delete = deleteLang;

    vm.lang = {};
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;


    loadAll(vm.lang, page, pagesize);


    function loadAll(lang, page, pagesize) {
      return LangService.findLangs(lang, page, pagesize)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
          //console.log("result00000" + angular.toJson(vm.result));
        })

    }

    function search() {
      var page = vm.page = 1;
      var pagesize = paginationConstants.itemsPerPage;
      if (vm.lang.langCode === null || vm.lang.langCode === "") {
        vm.lang.langCode = undefined;
      }
      if (vm.lang.description === null || vm.lang.description === "") {
        vm.lang.description = undefined;
      }
      loadAll(vm.lang, page, pagesize);
    };

    function reset() {
      vm.lang.langCode = undefined;
      vm.lang.description = undefined;
    };


    function deleteLang(lang) {

      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"),
        {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if(p){
          var langObj = {};
          langObj['langCode'] = lang;
          langObj['__status'] = 'delete';
          return LangService.deleteLang(langObj)
            .then(function (data) {
              var flag = data.success;
              toastr.success($filter('T')("plugin.deleteSucceed"), $filter('T')("plugin.deleteMessage"));
              //console.log("delete result:" + angular.toJson(flag));
              if (flag) {
                return $state.go('lang', null, {reload: 'lang'});
              }
            })
        }
      });
    }


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);

      loadAll(vm.lang, vm.page, paginationConstants.itemsPerPage);
    };


  }


})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditLangController', EditLangController);

  EditLangController.$inject = ['$filter','LangService', '$scope', '$state', '$uibModalInstance', 'entity','toastr'];

  function EditLangController($filter,LangService, $scope, $state, $uibModalInstance, entity,toastr) {
    var vm = this;
    vm.lang = entity;
    vm.clear = clear;

    vm.update = update;
    //console.log("code:" + angular.toJson(vm.code));

    getLangByLangCode(vm.lang);
    function getLangByLangCode(lang) {
      return LangService.findLangs(lang)
        .then(function (data) {
          vm.lang = data.rows[0];
          //console.log("result00000" + angular.toJson(vm.code));
        })
    }

    function update() {
      //console.log("code:" + angular.toJson(vm.code));
      return LangService.updateLangs(vm.lang)
        .then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
            $uibModalInstance.close();
            return $state.go('lang', null, {reload: 'lang'});
          }

        })

    }


    //$scope.addLine = function (header) {
    //  $state.go("addLine", {headerId: header.headerId});
    //};
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


  }


})();

/**
 * Created by mclin on 2016/8/10.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddLangController', AddLangController);

  AddLangController.$inject = ['LangService', '$state', '$uibModalInstance', 'toastr', 'entity', '$filter', 'toastrConfig'];

  function AddLangController(LangService, $state, $uibModalInstance, toastr, entity, $filter, toastrConfig) {
    var vm = this;
    vm.code = entity;
    vm.clear = clear;

    vm.add = add;

    function add() {
      //console.log("code:" + angular.toJson(vm.code));
      return LangService.addLang(vm.lang)
        .then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if(data.code=='repeat'){
            toastr.warning($filter('T')('distribution.repeatNot'));
            return ;
          }
          if (data.success) {
            toastr.success($filter('T')('title.saveSuccess'));
            $uibModalInstance.close();
            return $state.go('lang', null, {reload: 'lang'});
          }
        });
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Created by user on 2016/8/16.
 */

(function(){
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('interfaceList', {
        parent: 'app',
        url: "/interfaceList",
        views: {
          'body': {
            templateUrl: "app/interfaceTest/interfaceList.html",
            controller: 'InterfaceListController',
            controllerAs: 'vm'
          }
        }

      });
  }
})();

/**
 * Created by user on 2016/8/16.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('InterfaceListService', InterfaceListService);

  InterfaceListService.$inject = ['$resource', '$http', '$state'];

  function InterfaceListService($resource, $http) {
    var service = {
      findHeaderAndLine: findHeaderAndLine,

    };
    return service;

    function findHeaderAndLine(page,pagesize) {

      var resourceUrl = '/api/getAllHeaderAndLine';
      return $http.post(resourceUrl, {"page":page,"pagesize":pagesize}, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        //console.log("000000" + angular.toJson(response.data));
        return response.data;
      })
    }


  }

})();

/**
 * Created by user on 2016/8/16.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('InterfaceListController', InterfaceListController);

  InterfaceListController.$inject = ['InterfaceListService', '$state','paginationConstants'];

  function InterfaceListController(InterfaceListService, $state,paginationConstants) {
    var vm = this;

    vm.page = 1;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    var page = vm.page;
    var pageSize = paginationConstants.itemsPerPage;
    findHeaderAndLine(page,pageSize);


    function findHeaderAndLine(page,pageSize) {
      return InterfaceListService.findHeaderAndLine(page,pageSize)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems =  data.total;
          //console.log("result00000"+angular.toJson(data));

        });

    }

    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      findHeaderAndLine(vm.page,pageSize);
    };


  }


})();

/**
 * Created by Koma.Tshu on 2016/8/25.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('interfaceAuth', {
        parent: 'app',
        url: "/interfaceAuth/:headerId/:lineId/:clientType/:authType",
        views: {
          'body': {
            templateUrl: "app/interfaceAuth/interfaceAuth.html",
            controller: 'InterfaceAuthController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                interfaceHeaderId:$stateParams.headerId,
                interfaceLineId:$stateParams.lineId,
                clientType: $stateParams.clientType,
                authType: $stateParams.authType
              };
            }
          ]
        }
      })
      .state('interfaceAuth.add', {
        parent: 'interfaceAuth',
        url: '/add',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log("$uibModal:" + $uibModal);
          $uibModal.open({
            templateUrl: 'app/interfaceAuth/interfaceAuth-dialog.html',
            controller: 'InterfaceAuthDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  interfaceAuthId: null,
                  clientType: $stateParams.clientType,
                  authType: $stateParams.authType,
                  interfaceHeaderId: $stateParams.headerId,
                  interfaceLineId: $stateParams.lineId,
                  authId: null
                };
              }
            }
          }).result.then(function () {
              //console.log("interfaceAuthIndex go1");
              $state.go('interfaceAuth', null, {reload: true});
            }, function () {
              //console.log("interfaceAuthIndex go2");
              $state.go('interfaceAuth');
            });
        }]
      })
  }
})();

/**
 * Created by Koma.Tshu on 2016/8/25.
 */
(function(){
  'use strict';
  angular.module('hmapFront')
    .factory('InterfaceAuthService', InterfaceAuthService);
  InterfaceAuthService.$inject = ['$resource','$http'];

  function InterfaceAuthService ($resource,$http) {
    var service = {
      selectAuthByHeaderId : selectAuthByHeaderId,
      selectAuthByLineId : selectAuthByLineId,
      selectAppName : selectAppName,
      saveInterfaceAuth : saveInterfaceAuth,
      deleteInterfaceAuth : deleteInterfaceAuth
    };
    return service;

    //根据headerId获取授权信息
    function selectAuthByHeaderId(InterfaceAuth){
      var resourceUrl ='/api/interfaceAuth/selectAuthByHeaderId';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

    //根据lineId获取授权信息
    function selectAuthByLineId(){
      var resourceUrl ='/api/interfaceAuth/selectAuthByLineId';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

    //查询所有应用名称
    function selectAppName(){
      var resourceUrl ='/api/interfaceAuth/selectbyLineIdOrHeadIdandClientType';
      //return $http.post(resourceUrl, {
      //
      //}).then(function (response) {
      //  return response.data;
      //})
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

    //新增描述
    function saveInterfaceAuth(){
      var resourceUrl ='/api/interfaceAuth/saveInterfaceAuth';
      //var data = InterfaceAuth;
      //return $http.post(resourceUrl,data, {
      //
      //}).then(function (response) {
      //  return response.data;
      //})
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }

    //删除描述
    function deleteInterfaceAuth(){
      var resourceUrl ='/api/interfaceAuth/deleteInterfaceAuth';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST'}
      })
    }
  }
})();

/**
 * Created by Koma.Tshu on 2016/8/25.
 */
(function () {
  'use strict';

  angular.module("hmapFront").controller("InterfaceAuthController", InterfaceAuthController);

  InterfaceAuthController.$inject = ['$filter','SweetAlert','$state','entity','InterfaceAuthService'];

  function InterfaceAuthController($filter,SweetAlert,$state,entity,InterfaceAuthService){
    var vm = this;
    vm.interfaceAuth = entity;
    vm.selectAuthByHeaderId = selectAuthByHeaderId;
    vm.selectAuthByLineId = selectAuthByLineId;
    if( vm.interfaceAuth.interfaceLineId == null || vm.interfaceAuth.interfaceLineId == undefined || vm.interfaceAuth.interfaceLineId == ""){
      //console.log("11111111headerId");
      vm.interfaceAuth.authType='head';
      vm.selectAuthByHeaderId(vm.interfaceAuth);
    }else{
      //console.log("22222222lineId");
      vm.interfaceAuth.authType='line';
      vm.selectAuthByLineId(vm.interfaceAuth);
    }

    //根据HeaderId查询授权
    function selectAuthByHeaderId(interfaceAuth){
      return InterfaceAuthService.selectAuthByHeaderId().query(interfaceAuth,onHeaderAndLineSuccess,onError);
    }

    //根据LineId查询授权
    function selectAuthByLineId(interfaceAuth){
      return InterfaceAuthService.selectAuthByLineId().query(interfaceAuth,onHeaderAndLineSuccess,onError);
    }

    function onHeaderAndLineSuccess(data){
        vm.interfaceAuthes = data.rows;
        //console.log("vm.interfaceAuthes header:" + angular.toJson(vm.interfaceAuthes));
    }

    //删除授权
    vm.delete = function (interfaceAuth){
      var p;
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          InterfaceAuthService.deleteInterfaceAuth().query(interfaceAuth,onDeleteSuccess,onError);
        }
      });
    };

    function onDeleteSuccess(data){
        var flag = data.success;
        //console.log("delete result:" + angular.toJson(flag));
        if (flag) {
          return $state.go('interfaceAuth', null, {reload: true});
        }
    }

    function onError(error) {
      //console.log('error');
    }
  }
})();

/**
 * Created by Koma.Tshu on 2016/8/25.
 */
(function () {
  'use strict';

  angular.module("hmapFront").controller("InterfaceAuthDialogController", InterfaceAuthDialogController);

  InterfaceAuthDialogController.$inject = ['$uibModalInstance', 'entity', 'InterfaceAuthService','toastr','$filter'];

  function InterfaceAuthDialogController($uibModalInstance, entity, InterfaceAuthService,toastr,$filter) {
    var vm = this;
    vm.interfaceAuth = entity;



    vm.clear = clear;
    vm.selectAppName = selectAppName;
    vm.save = save;
    vm.hmsAuth ={};

    if(vm.interfaceAuth.clientType=="外部"||vm.interfaceAuth.clientType=="OUT")
      vm.hmsAuth.clientType = "out";
    else if(vm.interfaceAuth.clientType=="内部"||vm.interfaceAuth.clientType=="IN"){
      vm.hmsAuth.clientType = "in";
    }
    vm.hmsAuth.interfaceHeaderId = vm.interfaceAuth.interfaceHeaderId;
    vm.hmsAuth.interfaceLineId = vm.interfaceAuth.interfaceLineId;
    vm.selectAppName(vm.hmsAuth);

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    //查询所有app信息
    function selectAppName(hmsAuth) {
      return InterfaceAuthService.selectAppName().query(hmsAuth,onAppNameSuccess, onError);
    }

    function onAppNameSuccess(data) {
      vm.appNames = data.rows;
    }

    //保存授权
    function save() {
      vm.isSaving = true;
      //console.log(vm.interfaceAuth);
      //console.log("vm.interfaceAuth:" + vm.interfaceAuth.authId);
      InterfaceAuthService.saveInterfaceAuth().query(vm.interfaceAuth, onSaveSuccess, onError);

    }

    function onSaveSuccess(data) {
      if (data.success) {
        toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
        $uibModalInstance.close();
        vm.isSaving = false;
      }
    }

    function onError(error) {
      //console.log('error');
    }
  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('guest', {
        parent: 'app',
        url: "/guest",
        views: {
          'body': {
            templateUrl: "app/guest/guest.html",
            controller: 'GuestController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {};
            }
          ]
        }
      });
      //.state('guest.new', {
      //  parent: 'app',
      //  url: "/guest/new",
      //  views: {
      //    'body': {
      //      templateUrl: "app/guest/guest-new.html",
      //      controller: 'GuestNewController',
      //      controllerAs: 'vm',
      //      resolve: {
      //        entity: function () {
      //          return {
      //            id: null,
      //            statusCode: null,
      //            gender: null,
      //            fullName: null,
      //            cellPhone: null,
      //            wxopenId: null,
      //            email: null,
      //            sign: null,
      //            parkNum: null,
      //            joinAct: null,
      //            isStaff: null,
      //            state: null,
      //            approveName: null,
      //            approveDate: null,
      //            equipment: null,
      //            source: null,
      //            sn: null,
      //            companyName: null,
      //            title: null,
      //            inviter: null,
      //            inviterId: null
      //          }
      //        }
      //      }
      //    }
      //  }
      //})
      //.state('guest.edit', {
      //  parent: 'app',
      //  url: "/guest/:id/edit",
      //  views: {
      //    'body': {
      //      templateUrl: "app/guest/guest-new.html",
      //      controller: 'guestNewController',
      //      controllerAs: 'vm',
      //      resolve: {
      //        entity: function ($stateParams) {
      //          return {
      //            id: $stateParams.id
      //          };
      //        }
      //      }
      //    }
      //  }
      //})
  }
})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('Guest', Guest);

  Guest.$inject = ['$http','$resource','Upload','BaseConfig','$localStorage','$sessionStorage'];

  function Guest ($http,$resource,Upload,BaseConfig,$localStorage,$sessionStorage) {
    var service = {
      guestLoadSearch: guestLoadSearch,
      guestUpdate: guestUpdate,
      guestImport: guestImport,
      guestExport:guestExport
    };
    return service;

    function guestLoadSearch(page,pageSize) {
      return $resource("/api/guestFound?page="+page+"&pageSize="+pageSize, {}, {
        'query': {method: 'POST', isArray: false}
      });
    }
    function guestUpdate() {
      return $resource("/api/guestUpdate", {}, {
        'update': {method: 'POST'}
      });
    }
    function guestImport(data) {
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        url: BaseConfig.url + '/api/guestImport',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        data: {file: data}
      })
    }
    function guestExport(data) {
      //return $resource("/api/guestExport", {}, {
      //  'export': {method: 'POST'}
      //});
      //console.log("000000" + angular.toJson(data));
      //return $http.post('/api/guestExport',data,{responseType: 'arraybuffer'}).then(function (response) {
      //  var blob = new Blob([response], {type: "application/vnd.ms-excel"});
      //  var objectUrl = URL.createObjectURL(blob);
      //  var aForExcel = $("<a><span class='forExcel'>下载excel</span></a>").attr("href",objectUrl);
      //  $("body").append(aForExcel);
      //  $(".forExcel").click();
      //  aForExcel.remove();
        //var data = new Blob([response.data], { type: response.headers('Content-Type') });
        //var filename = response.headers('Content-Disposition').split(';')[1].trim().substr('filename='.length);
        //FileSaver.saveAs(data, filename);
      //});
      //$http.post('/api/guestExport', data
      //).success(function(data, status, headers, config) {
      //
      //  }).error(function(data, status, headers, config) {
      //
      //  });
      $http({
        url: '/api/guestExport',
        method: "POST",
        data: data,
        headers: {
          'Content-type': 'application/json'
        },
        responseType: 'arraybuffer'
      }).success(function (data, status, headers, config) {
        var blob = new Blob([data], {type: "application/vnd.ms-excel"});
        var objectUrl = URL.createObjectURL(blob);
        var aForExcel = $("<a><span class='forExcel'>下载excel</span></a>").attr("href",objectUrl);
        $("body").append(aForExcel);
        $(".forExcel").click();
        aForExcel.remove();
      }).error(function (data, status, headers, config) {
        //upload failed
      });

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('GuestController', GuestController);
  GuestController.$inject = ['$state','Guest','entity','paginationConstants','$localStorage','$sessionStorage','Upload','BaseConfig'];
  /** @ngInject */
  function GuestController($state, Guest,entity, paginationConstants,$localStorage,$sessionStorage,Upload,BaseConfig) {
    var vm = this;
    vm.guest=entity;
    vm.guests=[];
    vm.page = 1;
    vm.file="";
    vm.importExcel=importExcel;
    vm.totalItems = null;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadSearch=loadSearch;
    vm.fishUpload=fishUpload;
    vm.exportExcel=exportExcel;
    vm.update=update;
    vm.sign=sign;
    vm.pass=pass;
    vm.loadSearch();

    function loadSearch(){
      var page=vm.page;
      var pageSize=paginationConstants.itemsPerPage;
      Guest.guestLoadSearch(page,pageSize).query(vm.guest, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      console.log('onSuccess');
      console.log(data);
      vm.guests = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      console.log('error');
    }
    function update(){
      Guest.guestLoadSearch().update(vm.guest, onSuccess, onError);
    }
    function sign(guest){
      guest.sign="Y";
      Guest.guestUpdate().update(guest);
      loadSearch();
    }
    function pass(guest){
      guest.passState="Y";
      Guest.guestUpdate().update(guest);
    }
    function pageChanged() {
      console.log('Page changed to: ' +vm.page);
      loadSearch();
    }
    function importExcel(obj) {
      document.getElementById(obj).click();
    }
    function fishUpload() {
      Guest.guestImport(vm.file);
    }
    function exportExcel() {
      Guest.guestExport(vm.guest);
    }
  }
})();

/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ResourceDialogController', ResourceDialogController);

  ResourceDialogController.$inject = ['Function', 'paginationConstants', 'entity', '$uibModalInstance','$state','toastr','$filter'];

  function ResourceDialogController(Function, paginationConstants, entity, $uibModalInstance,$state,toastr,$filter) {
    var vm = this;

    vm.function = entity;
    vm.function.resources=[];
    vm.condition = {};
    vm.page = 1;
    vm.search=search;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = 0;
    vm.isAllSelected = false;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.toggleAll = toggleAll;
    vm.clear = clear;
    vm.save = save;

    vm.loadAll();

    function loadAll() {
      Function.fetchNotResource().query({
        functionId: vm.function.functionId,
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }

    function search(){
      vm.condition.page = vm.page;
      vm.condition.pagesize = paginationConstants.itemsPerPage;
      Function.queryResource().query(vm.condition,onSuccess,onError);
    }
    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.resources = data.rows;
      vm.totalItems = data.total;
    }
    function onAddResourceSuccess(data) {
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $uibModalInstance.close(data);
    }

    function onError(error) {
      //console.log('error');
    }
    function onAddResourceError() {
      toastr.error($filter('T')('title.saveFail'));
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      vm.search();
    }
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      angular.forEach(vm.resources, function (res) {
        if (res.addFlag === 'Y') {
          res.__status = 'add';
          vm.function.resources.push(res);
        }
      });
      Function.updateFunctionResource().saveOrUpdate(vm.function, onAddResourceSuccess, onAddResourceError);

    }

    function toggleAll() {

      var toggleStatus = !vm.isAllSelected;
      var resourceStatus = 'N';
      if (toggleStatus) {
        resourceStatus = 'N';
      }
      else {
        resourceStatus = 'Y';
      }
      angular.forEach(vm.resources, function (res) {
        res.addFlag = resourceStatus;
      });
    }
  }
})();

/**
 * Created by zhouzy on 2016/9/1 0001.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ParentFunctionController', ParentFunctionController);

  ParentFunctionController.$inject = ['Function', 'paginationConstants', 'entity', '$state', '$uibModalInstance', 'toastr'];

  function ParentFunctionController(Function, paginationConstants, entity, $state, $uibModalInstance, toastr) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = 0;
    vm.functions = [];
    vm.function = entity;
    vm.queryFunction = {};
    vm.selectedFunction = {};
    vm.clear = clear;
    vm.save = save;
    vm.search = search;
    vm.loadAll = loadAll;
    vm.loadFunction = loadFunction;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadAll();
    vm.loadFunction();

    function loadAll() {
      Function.query().query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }

    function search() {
      vm.queryFunction.page=vm.page;
      vm.queryFunction.pagesize= paginationConstants.itemsPerPage;
      Function.query().query(vm.queryFunction, onSuccess, onError);
    }

    function loadFunction() {
      if (vm.function.functionId) {//!= undefined && vm.function.functionId != null && vm.function.functionId != ''
        Function.query().get(vm.function, function (result) {
          vm.function = result.rows[0];
        });
      }
    }

    function onSuccess(data, headers) {
      vm.functions = data.rows;
      vm.totalItems = data.total;
    }

    function onSaveParentSuccess(data) {
      $uibModalInstance.close(data);
    }

    function onError(error) {
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      vm.search();
    }

    function save() {
      console.log("select: ==== :"+angular.toJson(vm.selectedFunction));
      Function.shareFunction(vm.selectedFunction);
      $uibModalInstance.dismiss('cancel');
      //vm.function.parentFunctionId = vm.selectedFunction
      //Function.save().saveOrUpdate(vm.function, onSaveParentSuccess, onError);
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * Created by zhouzy on 2016/8/30 0030.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('function', {
        parent: 'app',
        url: "/function",
        views: {
          'body': {
            templateUrl: "app/function/function.html",
            controller: 'FunctionController',
            controllerAs: 'vm'
          }
        }
      })
      .state('function.detail', {
        parent: 'app',
        url: "/function/:id",
        views: {
          'body': {
            templateUrl: "app/function/function-detail.html",
            controller: 'FunctionDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              functionId: $stateParams.id
            };
          }
        }
      })
      .state('function.new', {
        parent: 'app',
        url: "/new/function",
        views: {
          'body': {
            templateUrl: "app/function/function-detail.html",
            controller: 'FunctionDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
              functionId: null,
              moduleCode: 'all'
            };
          }
        }
      })
      .state('function.addResource', {
        parent: 'function.detail',
        url: "/addResource",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/function/resource-dialog.html',
            controller: 'ResourceDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  functionId: $stateParams.id,
                  moduleCode: 'all'
                };
              }
            }
          }).result.then(function () {
              $state.go('function.detail', null, {reload: 'function.detail'});
            }, function () {
              $state.go('function.detail', null, {reload: 'function.detail'});
            });
        }]
      })
      .state('function.entry', {
        parent: 'function.detail',
        url: "/entry",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/function/entry-dialog.html',
            controller: 'EntryDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  functionId: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              $state.go('function.detail', null, {reload: 'function.detail'});
            }, function () {
              $state.go('function.detail');
              //console.log("function.detail");
            });
        }]
      })
      .state('function.parent', {
        parent: 'function.detail',
        url: "/parent",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/function/parent-dialog.html',
            controller: 'ParentFunctionController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  functionId: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              $state.go('function.detail', null, {reload: 'function.detail'});
            }, function () {
              $state.go('function.detail');
              //console.log("function.detail");
            });
        }]
      });
  }

})();

/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('Function', Function);

  Function.$inject = ['$resource','$rootScope','$http'];

  function Function ($resource,$rootScope,$http) {
    var selectedFunction = {};
    var selectedEntry = {};
    var service ={
      query:query,
      save:saveOrUpdate,
      remove:remove,
      fetchResource:fetchResource,
      fetchNotResource:fetchNotResource,
      updateFunctionResource:updateFunctionResource,
      menu:menu,

      selectedFunction:selectedFunction,
      shareFunction:shareFunction,
      selectedEntry:selectedEntry,
      shareEntry:shareEntry,
      queryResource:queryResource,
      getFunctionLocaleInfo: getFunctionLocaleInfo
    }
    return service;

   function shareFunction(selectedParent){
       this.selectedFunction = selectedParent;
       $rootScope.$broadcast('handleSelectedFunction');
    }
    function shareEntry(selectedEntry){
      this.selectedEntry = selectedEntry;
      $rootScope.$broadcast('handleSelectedEntry');
    }

    function query(){
      var resourceUrl ='/api/function/query';
      return $resource(resourceUrl, {}, {
        'query': { method: 'GET',isArray:false},
        'get': {
          method: 'GET',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
            }
            return data;
          }
        }
      });
    }

    function fetchResource(){
      var resourceUrl ='/api/function/fetchResource';
      return $resource(resourceUrl, {}, {
        'query': { method: 'GET',isArray:false},
        'get': {
          method: 'GET',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
            }
            return data;
          }
        }
      });
    }
    function fetchNotResource(){
      var resourceUrl ='/api/function/fetchNotResource';
      return $resource(resourceUrl, {}, {
        'query': { method: 'GET',isArray:false},
        'get': {
          method: 'GET',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
            }
            return data;
          }
        }
      });
    }
    function updateFunctionResource(){
      var resourceUrl ='/api/function/updateFunctionResource';
      return $resource(resourceUrl, {}, {
        'saveOrUpdate': {method: 'POST'}
      });
    }
    function saveOrUpdate(){
      var resourceUrl ='/api/function/save';
      return $resource(resourceUrl, {}, {
        'saveOrUpdate': {method: 'POST'}
      });
    }
    function remove(){
      var resourceUrl ='/api/function/remove';
      return $resource(resourceUrl, {}, {
        'remove': {method: 'POST'}
      });
    }
    function menu(){
      var resourceUrl ='/api/function/menus';
      return $resource(resourceUrl, {}, {
        'get': {method: 'GET'}
      });
    }
    function parentSelect(){

    }

    function queryResource(){
      var resourceUrl = '/api/resource/query';
      return $resource(resourceUrl,{},{
        'query':{ method: 'GET',isArray:false}
      })
    }

    function getFunctionLocaleInfo(code, dto, field) {
      var data = {};
      var resourceUrl = '/sys/multiLanguage?id=' + code + "&dto=" + dto + "&field=" + field;
      return $http.get(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        if (response.status == "200") {
          return response.data.multiLanguages;
        }
      })
    }
  }
})();

/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('FunctionController', FunctionController);

  FunctionController.$inject = ['Function','paginationConstants','$timeout', '$localStorage','$state','PartyService'];

  function FunctionController(Function,paginationConstants,$timeout, $localStorage,$state,PartyService) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = 0;
    vm.functions=[];
    vm.moduleTypes = [];
    vm.loadAll = loadAll;
    vm.condition={};
    vm.transition = transition;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadByName = loadByName;
    vm.initWeidget = initWeidget;
    vm.initWeidget();
    vm.loadAll();

    function loadAll () {
      vm.condition.page = vm.page;
      vm.condition.pagesize = paginationConstants.itemsPerPage;
      Function.query().query(vm.condition, onSuccess, onError);
    }

    function loadByName(){
      loadAll();
    }
    function onSuccess(data, headers) {
      vm.functions = data.rows;
      vm.totalItems =  data.total;
      //console.log(vm.functions);
    }
    function onError(error) {
      //console.log('error');
    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll();
    }
    function initWeidget() {
      // timezones and gender
      PartyService.getLookUp(['SYS.MODULE_TYPE'])
        .then(function (data) {
          vm.moduleTypes = data[0];
        })
    }
  }
})();

/**
 * Created by zhouzy on 2016/8/29 0029.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('FunctionDetailController', FunctionDetailController);

  FunctionDetailController.$inject = ['$scope','$filter' ,'$state', '$stateParams', '$uibModal', '$log', 'Function', 'entity', 'paginationConstants','toastr', 'toastrConfig', 'SweetAlert', 'PromptService', 'PartyService'];

  function FunctionDetailController($scope, $filter, $state, $stateParams, $uibModal, $log, Function, entity, paginationConstants, toastr, toastrConfig, SweetAlert, PromptService, PartyService) {
    var vm = this;
    vm.function = entity;
    vm.editOrCreate='create';
    vm.function.resources = [];
    vm.modalInstance = {};
    vm.isAllSelected = false;
    vm.confirmDelete = false;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = 0;
    vm.moduleTypes = [];
    vm.saveFunctionResource = saveFunctionResource;
    vm.deleteFunctionResource = deleteFunctionResource;
    vm.saveOrUpdate = saveOrUpdate;
    vm.remove = remove;
    vm.load = load;
    vm.loadResource = loadResource;
    vm.toggleAll = toggleAll;
    vm.isNotDelete = isNotDelete;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.reBack = reBack;
    vm.showFuncNameLocale = showFuncNameLocale;
    vm.showFuncDecLocale = showFuncDecLocale;
    vm.funcNameLocaleSure = funcNameLocaleSure;
    vm.funcDecLocaleSure = funcDecLocaleSure;
    vm.initWeidget = initWeidget;
    vm.initWeidget();
    vm.load();

    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        if(!vm.function.functionId) {
          $("#funcNameLocaleBtn").attr("disabled", false);
          $("#funcDecLocaleBtn").attr("disabled", false);
        }
      });
    }
    initLangs();

    function load() {
      if (vm.function.functionId) {
        vm.editOrCreate='Edit';
        Function.query().get(vm.function, function (result) {
          vm.function = result.rows[0];
          vm.loadResource();
          Function.getFunctionLocaleInfo(vm.function.functionId, 'com.kohler.iot.base.function.entities.Function', $("#funcNameLocaleBtn").val())
            .then(function (data) {
              //deal with the multilanguage field value
              var __tls = {};
              var name = {};
              for (var i in data) {
                name[data[i].langCode] = data[i].value;
              }
              __tls[$("#funcNameLocaleBtn").val()] = name;
              Function.getFunctionLocaleInfo(vm.function.functionId, 'com.kohler.iot.base.function.entities.Function', $("#funcDecLocaleBtn").val())
                .then(function (data) {
                  //deal with the multilanguage field value
                  var dec = {};
                  for (var i in data) {
                    dec[data[i].langCode] = data[i].value;
                  }
                  __tls[$("#funcDecLocaleBtn").val()] = dec;
                  vm.function.__tls = __tls;
                  $("#funcNameLocaleBtn").attr("disabled", false);
                  $("#funcDecLocaleBtn").attr("disabled", false);
                })
            })
        });
      }
    }

    function loadResource() {
      if (vm.function.functionId) {
        Function.fetchResource().get({
          functionId: vm.function.functionId, page: vm.page,
          pagesize: paginationConstants.itemsPerPage
        }, function (response) {
          if (response.success) {
            vm.function.resources = response.rows;
            vm.totalItems = response.total;
            vm.pageSize = response.rows.length;
          }
        });
      }
    }

    function isNotDelete(resource) {
      return resource.__status !== "delete";
    }

    function saveOrUpdate() {
      if (angular.isUndefined(vm.function.functionSequence)) {
        vm.function.functionSequence = 1;
      }
      Function.save().saveOrUpdate(vm.function, onSuccess, onError);
    }

    function remove() {
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"),
        {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if (p) {
          // console.log(vm.resource);
          Function.remove().remove([{functionId:vm.function.functionId}], function () {
            toastr.success($filter('T')("title.deleteSuccess"), $filter('T')("title.infoTitle"));
            $state.go('function');
          }, function () {
            toastr.error($filter('T')('title.deleteFail'));
          });
        }
      });
    }

    function onSuccess(data, headers) {
      if (data.success) {
        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.infoTitle"));
        $state.go('function');
      } else {
        onError();
      }
    }

    function onError(error) {
      toastr.error($filter('T')('title.saveFail'));
    }

    function saveFunctionResource() {
      Function.updateFunctionResource().saveOrUpdate(vm.function, function(data) {
        if (data.success) {
          toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
          loadResource();
        } else {
          onError();
        }
      }, onError);
    }

    //将选中的数据状态标记为删除
    function deleteFunctionResource() {
      // deleteConfirm();
      angular.forEach(vm.function.resources, function (res) {
        if (res.deleteFlag === "Y") {
          res.__status = "delete";
        }
      });
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadResource();
    }

    function toggleAll() {
      var toggleStatus = !vm.isAllSelected;
      var resourceStatus = 'N';
      if (toggleStatus) {
        resourceStatus = 'N';
      }
      else {
        resourceStatus = 'Y';
      }
      angular.forEach(vm.function.resources, function (res) {
        res.deleteFlag = resourceStatus;
      });
    }

    function reBack() {
      $state.go('function');
    }

    function showFuncNameLocale() {
      // According to langs to make inputs.s
      $("#funcNameLocaleModal").modal("show");
      if($.trim($("#funcNameLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='fn_" + langs[i].langCode
            + "' ng-model='vm.function.__tls." + $("#funcNameLocaleModal").val() + '.' + langs[i].langCode + "'/>");
          $("#funcNameLocaleModelBody").append(div);
          if(vm.function.functionId!=undefined&& vm.function.functionId!=null&& vm.function.functionId!=''){
            $("input[name='fn_" + langs[i].langCode + "']").val(vm.function.__tls[$("#funcNameLocaleBtn").val()][langs[i].langCode]);
          }
        }
      }

    }

    function funcNameLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.function.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='fn_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.function[$("#funcNameLocaleBtn").val()] = $("input[name='fn_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#funcNameLocaleModal").modal("hide");
      __tls[$("#funcNameLocaleBtn").val()] = description;
      vm.function.__tls = __tls;
    }

    function showFuncDecLocale() {
      // According to langs to make inputs.
      $("#funcDecLocaleModal").modal("show");
      if($.trim($("#funcDecLocaleModelBody").html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='fd_" + langs[i].langCode
            + "' ng-model='vm.function.__tls." + $("#funcDecLocaleBtn").val() + '.' + langs[i].langCode + "'/>");
          $("#funcDecLocaleModelBody").append(div);
          if(vm.function.functionId!=undefined&& vm.function.functionId!=null&& vm.function.functionId!=''){
            $("input[name='fd_" + langs[i].langCode + "']").val(vm.function.__tls[$("#funcDecLocaleBtn").val()][langs[i].langCode]);
          }
        }
      }

    }

    function funcDecLocaleSure() {
      // console.log(window.localStorage.lang);
      var __tls = vm.function.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='fd_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.function[$("#funcDecLocaleBtn").val()] = $("input[name='fd_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#funcDecLocaleModal").modal("hide");
      __tls[$("#funcDecLocaleBtn").val()] = description;
      vm.function.__tls = __tls;
    }

    $scope.$on('handleSelectedFunction', function() {
      //console.log(Function.selectedFunction.functionName);
      vm.function.parentFunctionId = Function.selectedFunction.functionId
      vm.function.parentFunctionName = Function.selectedFunction.functionName
    });

    $scope.$on('handleSelectedEntry', function() {
      //console.log(Function.selectedEntry.resourceName);
      vm.function.resourceId = Function.selectedEntry.resourceId
      vm.function.resourceName = Function.selectedEntry.name
    });

    function initWeidget() {
      // timezones and gender
      PartyService.getLookUp(['SYS.MODULE_TYPE'])
        .then(function (data) {
          vm.moduleTypes = data[0];
        })
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('EntryDialogController', EntryDialogController);

  EntryDialogController.$inject = ['Function', 'paginationConstants', 'entity', '$uibModalInstance', '$state', 'toastr'];

  function EntryDialogController(Function, paginationConstants, entity, $uibModalInstance, $state, toastr) {
    var vm = this;
    vm.page = 1;
    vm.function = entity;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = 0;
    vm.loadAll = loadAll;
    vm.loadFunction = loadFunction;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.selectedResource = {};
    vm.clear = clear;
    vm.save = save;

    vm.loadAll();
    vm.loadFunction();

    function loadAll() {
      if (vm.function.functionId) {
        Function.fetchResource().query({
          functionId: vm.function.functionId,
          page: vm.page,
          pagesize: paginationConstants.itemsPerPage
        }, onSuccess, onError);
      }

    }

    function loadFunction() {
      if (vm.function.functionId) {//!= undefined && vm.function.functionId != null && vm.function.functionId != ''
        Function.query().get(vm.function, function (result) {
          vm.function = result.rows[0];
        });
      }
    }

    function onSuccess(data, headers) {
      vm.resources = data.rows;
      vm.totalItems = data.total;
    }

    function onSaveEntrySuccess(data) {
      // $log.info(data);
      $uibModalInstance.close(data);
    }

    function onError(error) {
      // $log.info('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadAll();
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      Function.shareEntry(vm.selectedResource);
      $uibModalInstance.dismiss('ok');
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('whitelistDialogController', whitelistDialogController);

  whitelistDialogController.$inject = ['$rootScope', '$filter', '$state', 'FirmwareUpdateService', 'SweetAlert', 'paginationConstants'];

  function whitelistDialogController($rootScope, $filter, $state, FirmwareUpdateService, SweetAlert, paginationConstants) {
    var vm = this;
    vm.whitelists = {};
    vm.whitelist = {};
    vm.whitelist.userName = '';
    vm.whitelist.location = '';
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.getWhitelistBy = getWhitelistBy;
    vm.checkWhitelist = checkWhitelist;
    vm.checkAllWhitelist = checkAllWhitelist;
    vm.deleteWhitelist = deleteWhitelist;
    vm.search = search;
    vm.clear = clear;
    vm.pageChanged = pageChanged;

    load();

    function load() {
      getWhitelistBy();
    }

    function search() {
      getWhitelistBy();
    }

    function pageChanged() {
      vm.getWhitelistBy(vm.whitelist, vm.page);
    }

    function getWhitelistBy() {
      FirmwareUpdateService.getWhitelistBy(vm.whitelist, vm.page)
      .then(function (data) {
        vm.whitelists = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    function checkWhitelist() {
      var arrChk = angular.element("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        angular.element("#chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        angular.element("#chk_all").checked = true;
      }
    }

    function checkAllWhitelist() {
      var chk_all = angular.element("#chk_all").is(':checked');
      var items = angular.element(".chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    function deleteWhitelist() {
      var isCheck = angular.element(".chk_list").is(':checked');
      if (!isCheck) {
        SweetAlert.warning($filter('T')("btnTypeName.noData"), {title: $filter('T')("btnTypeName.info")});
      } else {
        SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
          if (p) {
            var arrChk = angular.element("input[name='chk_list']:checked");
            var whitelists = [];
            angular.element(arrChk).each(function (index, item) {
              var jsonObj = {};
              jsonObj["whiteListId"] = item.defaultValue;
              whitelists.push(jsonObj);
            });
            FirmwareUpdateService.deleteWhitelist(whitelists).then(function (response) {
              angular.element("#chk_all").attr("checked", false);
              var items = angular.element(".chk_list");
              for (var j = 0; j < items.length; j++) {
                items[j].checked = false;
              }
              if (response.success) {
                vm.getWhitelistBy(vm.whitelist, vm.page);
                SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
              }
            })
          }
        });
      }
    }

    function clear() {
      $state.go('firmwareUpdate', {}, {reload: true});
    }
  }
})();

(function () {
  'use strict';
  angular
  .module('hmapFront')
  .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
    .state('firmwareUpdate', {
      parent: 'app',
      url: '/firmwareUpdate',
      views: {
        'body': {
          templateUrl: 'app/firmwareUpdate/firmwareUpdate.html',
          controller: 'FirmwareUpdateController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {};
        }
      }
    })
    .state('whitelist', {
      parent: 'app',
      url: '/whitelist',
      views: {
        'body': {
          templateUrl: 'app/firmwareUpdate/whitelist-dialog.html',
          controller: 'whitelistDialogController',
          controllerAs: 'vm'
        }
      }
    })
    .state('firmwareUpdateNew', {
      parent: 'firmwareUpdate',
      url: '/addFirmwareUpdate',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/firmwareUpdate/addFirmwareUpdate.html',
          controller: 'AddFirmwareUpdateController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg'
        }).result.then(function () {
          $state.go('firmwareUpdate', null, {reload: true});
        }, function () {
          $state.go('firmwareUpdate', null, {reload: true});
        });
      }]
    })
    .state('firmwareUpdateEdit', {
      parent: 'firmwareUpdate',
      url: '/editFirmwareUpdate/:id',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/firmwareUpdate/editFirmwareUpdate.html',
          controller: 'EditFirmwareUpdateController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              //console.log("entity:"+angular.toJson($stateParams.roleId));
              return {
                id: $stateParams.id
              };
            }
          }
        }).result.then(function () {
          $state.go('firmwareUpdate', null, {reload: true});
        }, function () {
          $state.go('firmwareUpdate', null, {reload: true});
        });
      }]
      /*views: {
         'body': {
           templateUrl: "app/messageTemplate/editMessageTemplate.html",
           controller: 'EditMessageTemplateController',
           controllerAs: 'vm',
           resolve: {
             entity: function ($stateParams) {
               return {id:$stateParams.id};
             }
           }
         }
       }*/
    })
    .state('firmwareUpdate.chooseSku', {
      parent: 'firmwareUpdateNew',
      url: '/chooseSku',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/firmwareUpdate/chooseSkuForFirmware-dialog.html',
          controller: 'ChooseSkuForFirmwareDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              //console.log("entity:"+angular.toJson($stateParams.roleId));
              return {
                type: $stateParams.type
              };
            }
          }
        }).result.then(function () {
          $state.go('firmwareUpdateNew');
        }, function () {
          $state.go('firmwareUpdateNew');
        });
      }]
    })
    .state('firmwareUpdate.editChooseSku', {
      parent: 'firmwareUpdateEdit',
      url: '/editChooseSku',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/firmwareUpdate/editChooseSkuForFirmware-dialog.html',
          controller: 'ChooseSkuForFirmwareDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg'
        }).result.then(function () {
          $state.go('firmwareUpdateEdit');
        }, function () {
          $state.go('firmwareUpdateEdit');
        });
      }]
    })
    .state('firmwareUpdate.addVersion', {
      parent: 'firmwareUpdate',
      url: '/addVersion/:id',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/firmwareUpdate/addFirmwareVersion.html',
          controller: 'AddFirmwareVersionController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                id: $stateParams.id
              };
            }
          }
        }).result.then(function (res) {
          // console.log("i m res: ",res);
          $state.go('firmwareUpdate');
        }, function (err) {
          // console.log("i m error: ",err);
          $state.go('firmwareUpdate');
        });
      }]
    })
    .state('firmwareUpdate.addBatchVersion', {
      parent: 'firmwareUpdate',
      url: '/addBatchVersion',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/firmwareUpdate/addFirmwareBatchVersion.html',
          controller: 'AddFirmwareBatchVersionController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {};
            }
          }
        }).result.then(function (res) {
          // console.log("i m res: ",res);
          $state.go('firmwareUpdate', null, {reload: true});
        }, function (err) {
          // console.log("i m error: ",err);
          $state.go('firmwareUpdate', null, {reload: true});
        });
      }]
    })
    .state('firmwareUpdate.addNewFirmware', {
      parent: 'firmwareUpdate',
      url: '/addNewFirmware/:id',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/firmwareUpdate/addNewFirmware-dialog.html',
          controller: 'AddNewFirmwareDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                id: $stateParams.id
              };
            }
          }
        }).result.then(function (res) {
          // console.log("i m res: ",res);
          $state.go('firmwareUpdate', null, {reload: true});
        }, function (err) {
          // console.log("i m error: ",err);
          $state.go('firmwareUpdate', null, {reload: true});
        });
      }]
    })
    .state('whitelist.addWhitelist', {
      parent: 'whitelist',
      url: '/addWhitelist',
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/firmwareUpdate/addWhitelist-dialog.html',
          controller: 'addWhitelistDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {};
            }
          }
        }).result.then(function (res) {
          // console.log("i m res: ",res);
          $state.go('whitelist', null, {reload: true});
        }, function (err) {
          // console.log("i m error: ",err);
          $state.go('whitelist', null, {reload: true});
        });
      }]
    });
  }
})();

(function () {
  'use strict';
  angular.module('hmapFront')
  .factory('FirmwareUpdateService', FirmwareUpdateService);
  FirmwareUpdateService.$inject = ['$resource', '$http', '$rootScope'];

  function FirmwareUpdateService($resource, $http, $rootScope) {
    var selectedParent = {};
    var selectedEditParent = {};
    var service = {
      selectAllByInfo: selectAllByInfo,
      submitInfo: submitInfo,
      loadAllVersionById: loadAllVersionById,
      updateCurrentVersion: updateCurrentVersion,
      insertVersion: insertVersion,
      insertVersionBatch: insertVersionBatch,
      deleteTemp: deleteTemp,
      getByCode: getByCode,
      edit: edit,


      selectById: selectById,
      selectAllSku: selectAllSku,
      shareParent: shareParent,
      shareEidtParent: shareEidtParent,
      selectedParent: selectedParent,
      selectedEditParent: selectedEditParent,

      //2018/7/16
      addNewfirmVersion: addNewfirmVersion,
      judgeIsPublic: judgeIsPublic,
      changePrivate: changePrivate,
      deleteWhitelist: deleteWhitelist,
      deleteAllWhitelist: deleteAllWhitelist,
      getPartyBy: getPartyBy,
      addWhitelist: addWhitelist,
      addAllWhitelist: addAllWhitelist,
      getWhitelistBy: getWhitelistBy,
      judgeCnOrEn: judgeCnOrEn
    };
    return service;

    function shareParent(selectedParent) {
      this.selectedParent = selectedParent;
      $rootScope.$broadcast('handleSelectedParent');
    }

    function shareEidtParent(selectedEditParent) {
      this.selectedEditParent = selectedEditParent;
      $rootScope.$broadcast('handleSelectedEditParent');
    }

    function selectAllByInfo() {
      var resourceUrl = '/api/skuFirmware/selectAllByInfo';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function loadAllVersionById() {
      var resourceUrl = '/api/skuFirmware/getVersionByFirmwareId';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }


    function selectAllSku() {
      var resourceUrl = '/api/ctm/selectAllSku';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function getByCode() {
      var resourceUrl = '/api/messageTemp/getByCode';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function deleteTemp() {
      var resourceUrl = '/api/skuFirmware/delete';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function selectById() {
      var resourceUrl = '/api/skuFirmware/select';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function submitInfo() {
      var resourceUrl = '/api/skuFirmware/insertSelective';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function edit() {
      var resourceUrl = '/api/skuFirmware/update';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }


    function updateCurrentVersion() {
      var resourceUrl = '/api/skuFirmware/updateCurrentVersion';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function insertVersion() {
      var resourceUrl = '/api/skuFirmware/insertVersion';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    };

    function insertVersionBatch() {
      var resourceUrl = '/api/skuFirmware/insertVersionBatch';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    };

    //2018/7/16
    function pushAll(firmwareVersion) {
      var resourceUrl = '/api/auth/updateDetails';
      //console.log("service  code:" +"["+ angular.toJson(clientDetail)+"]");
      return $http.post(resourceUrl, "[" + angular.toJson(firmwareVersion) + "]", {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function getPartyBy(party, page) {
      var resourceUrl = '/api/skuFirmware/queryPartyByLocationAndUserName?page=' + page;
      //console.log("service  code:" +"["+ angular.toJson(clientDetail)+"]");
      return $http.post(resourceUrl, party, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function addNewfirmVersion(firmwareVerison) {
      var resourceUrl = '/api/skuFirmware/insertVersionUS';
      //console.log("service  code:" +"["+ angular.toJson(clientDetail)+"]");
      return $http.post(resourceUrl, firmwareVerison, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function judgeIsPublic(template) {
      var resourceUrl = '/api/skuFirmware/isPublic';
      //console.log("service  code:" +"["+ angular.toJson(clientDetail)+"]");
      return $http.post(resourceUrl, template, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function changePrivate() {
      var resourceUrl = '/api/skuFirmware/updateWhiteIsPublic';
      //console.log("service  code:" +"["+ angular.toJson(clientDetail)+"]");
      return $http.post(resourceUrl, {}, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function deleteWhitelist(whitelists) {
      var resourceUrl = '/api/skuFirmware/deleteWhite';
      return $http.post(resourceUrl, whitelists, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function addWhitelist(partys) {
      var resourceUrl = '/api/skuFirmware/addWhite';
      return $http.post(resourceUrl, partys, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function getWhitelistBy(whitelist, page) {
      var resourceUrl = '/api/skuFirmware/queryWhiteByLocationAndUserName?page=' + page;
      return $http.post(resourceUrl, whitelist, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function judgeCnOrEn(skuNum) {
      var resourceUrl = '/api/skuFirmware/judgeCountry?skuNum=' + skuNum;
      return $http.post(resourceUrl, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function deleteAllWhitelist(whiteList) {
      var resourceUrl = '/api/skuFirmware/deleteWhiteAll';
      return $http.post(resourceUrl, whiteList, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function addAllWhitelist(party) {
      var resourceUrl = '/api/skuFirmware/addWhiteAll?page=-1';
      return $http.post(resourceUrl, party, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("hmapFront")
    .controller("FirmwareUpdateController", FirmwareUpdateController);

  FirmwareUpdateController.$inject = [
    "$rootScope",
    "$filter",
    "$state",
    "paginationConstants",
    "FirmwareUpdateService",
    "SweetAlert",
    "toastr",
  ];

  function FirmwareUpdateController(
    $rootScope,
    $filter,
    $state,
    paginationConstants,
    FirmwareUpdateService,
    SweetAlert,
    toastr
  ) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;

    vm.pageVersion = 1;
    vm.totalItemsVersion = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.template = {};
    vm.templateVersion = {};
    vm.template.page = vm.page;
    vm.template.pagesize = vm.itemsPerPage;

    vm.templateVersion.page = vm.pageVersion;
    vm.templateVersion.pagesize = vm.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.loadAll = loadAll;
    vm.deleteTemp = deleteTemp;
    vm.clickPlan = clickPlan;
    vm.loadAllVersionById = loadAllVersionById;
    vm.pageChangedVersion = pageChangedVersion;
    // vm.saveParent = saveParent;
    vm.selectParent = -1;
    vm.dvmSkuFirmwareVersionList = [];
    vm.hardwareTypes = [];

    vm.loadAll();

    vm.initWeidget = initWeidget;
    initWeidget();

    var firmwareIdGlobal;
    vm.templateFirm = {};
    vm.firmwareIdGlobal = firmwareIdGlobal;

    //add funcation @Meathed changePublic() ,pushTo() by wgm on 2018/7/11
    vm.changePublic = changePublic;
    vm.changePrivate = changePrivate;
    //vm.pushTo = pushTo;
    vm.judgeRoule = judgeRoule;
    //vm.goPush = goPush;

    // function goPush(template) {
    //   return  $state.go("firmwareUpdate.pushFirmware", {template: JSON.stringify(template)});
    // }
    function initWeidget() {
      /*PartyService.getLookUp(['IOT.SYS_FIRMWARE_NAME', 'IOT.SYS_FIRMWARE_TYPE'])
        .then(function (data) {
          vm.templateTypeList = data[0];
          vm.firmwareTypeList = data[1];
        });*/
      FirmwareUpdateService.getByCode().query(
        { code: "IOT.SYS_FIRMWARE_NAME" },
        function (data) {
          vm.templateTypeList = data.rows;
        },
        function (error) {}
      );
      FirmwareUpdateService.getByCode().query(
        { code: "IOT.SYS_FIRMWARE_TYPE" },
        function (data) {
          vm.firmwareTypeList = data.rows;
        },
        function (error) {}
      );
      FirmwareUpdateService.getByCode().query(
        { code: "IOT.DVM_MODULE_PART_NUMBER" },
        function (data) {
          vm.hardwareTypes = data.rows;
        },
        function (error) {}
      );
    }
    function clickPlan($event, firmwareId, templateFirm) {
      for (
        var i = 0;
        i < $($event.target).parent().parent()[0].childElementCount;
        i++
      ) {
        $($event.target).parent().parent().children().eq(i).removeAttr("style");
      }
      $($event.target).parent().css("background-color", "#f4f4f4");
      vm.templateFirm = templateFirm;
      loadAllVersionById(firmwareId);
    }

    function loadAllVersionById(firmwareId) {
      firmwareIdGlobal = firmwareId;
      vm.firmwareIdGlobal = firmwareIdGlobal;
      /*var page = vm.page = 1;
      var pagesize = vm.itemsPerPage;*/
      vm.templateVersion.firmwareId = firmwareId;
      FirmwareUpdateService.loadAllVersionById().query(
        vm.templateVersion,
        onSuccessVersionQuery,
        onError
      );
    }

    function loadAll() {
      FirmwareUpdateService.selectAllByInfo().query(
        vm.template,
        onSuccess,
        onError
      );
    }

    $rootScope.$on(
      "$stateChangeSuccess",
      function (event, toState, toParams, fromState, fromParams) {
        if (
          toState.parent == "app" &&
          toState.name == "firmwareUpdate" &&
          fromState.name == "firmwareUpdate.addVersion"
        ) {
          FirmwareUpdateService.loadAllVersionById().query(
            vm.templateVersion,
            onSuccessVersionQuery,
            onError
          );
        }
      }
    );

    function onSuccess(data, headers) {
      vm.templates = data.rows;
      vm.totalItems = data.total;
      if (data.rows.length > 0) {
        loadAllVersionById(data.rows[0].firmwareId);
        vm.templateFirm = data.rows[0];
      }
    }

    function onSuccessVersionQuery(data, headers) {
      vm.selectParent = {};
      vm.dvmSkuFirmwareVersionList = [];
      vm.totalItemsVersion = data.total;
      vm.templateVersions = [];
      for (var i = 0; i < data.rows.length; i++) {
        var temp = data.rows[i];
        if (temp.lastFlag === "Y") {
          vm.selectParent = temp;
          vm.dvmSkuFirmwareVersionList.push(temp);
        }
        temp.isDisable = temp.isPublic === "Y";
        vm.templateVersions = data.rows;
      }
    }

    function onError(error) {
      vm.templateVersions = [];
    }

    function search() {
      //每次搜索的时候把page设为 1
      vm.template.page = vm.page = 1;
      vm.template.pagesize = vm.itemsPerPage;
      loadAll();
    }

    /*function saveParent() {
      if(vm.selectParent.lastFlag=='N')
        vm.dvmSkuFirmwareVersionList.push(vm.selectParent);
      console.info(vm.dvmSkuFirmwareVersionList);
      FirmwareUpdateService.updateCurrentVersion().save(vm.dvmSkuFirmwareVersionList, onSuccessUpdateCurrentVersion, onErrorForDelete);     /!*alert("---"+$("#lastFlag").val());
      alert("===="+vm.selectParent.versionId);
      alert("ssss"+vm.selectParent.lastFlag);*!/
     /!* FirmwareUpdateService.shareParent(vm.selectParent);
      $uibModalInstance.dismiss('cancel');*!/
    }*/

    function deleteTemp(id) {
      SweetAlert.confirm($filter("T")("plugin.deleteConfirm"), {
        title: $filter("T")("plugin.deletePrompt"),
      }).then(function (p) {
        if (p) {
          if (id) {
            FirmwareUpdateService.deleteTemp().query(
              { firmwareId: id },
              onSuccessForDelete,
              onErrorForDelete
            );
          }
        }
      });
    }

    function onSuccessForDelete(data, headers) {
      if (data.code == "succ") {
        loadAll();
      }
    }

    function onSuccessUpdateCurrentVersion(data, headers) {
      if (data.code == "succ") {
        loadAllVersionById(firmwareIdGlobal);
        SweetAlert.info("ok");
      }
    }

    function onErrorForDelete(data, headers) {
      if (data.code != "succ") {
        SweetAlert.error("error");
      }
    }

    function reset() {
      vm.template.firmwareName = "";
      vm.template.skuNumber = "";
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page,
      });
    }

    function pageChanged() {
      vm.template.page = vm.page;
      vm.template.pagesize = vm.itemsPerPage;
      loadAll();
    }

    function pageChangedVersion() {
      vm.templateVersion.page = vm.pageVersion;
      vm.templateVersion.pagesize = vm.itemsPerPage;
      loadAllVersionById(firmwareIdGlobal);
    }

    function changePublic(template) {
      SweetAlert.confirm($filter("T")("firmware.isChangePublic"), {
        title: $filter("T")("plugin.deletePrompt"),
      }).then(function (p) {
        if (p) {
          FirmwareUpdateService.judgeIsPublic(template).then(function (data) {
            //console.log('chang-public'+data);
            if (data.success === true) {
              $("#notifyPublicBtn" + template.versionId).attr("disabled", true);
              loadAll();
            }
          });
        }
      });
    }

    // function pushTo(firmwareVersion) {
    //
    //   return FirmwareUpdateService.pushAll(firmwareVersion)
    //     .then(function (data) {
    //       //console.log("resultData:" + angular.toJson(data));
    //       if (data.success) {
    //         toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.infoTitle"));
    //         $uibModalInstance.close();
    //         return $state.go('coding', null, {reload: true});
    //       }
    //     });
    // }

    function judgeRoule() {
      console.log(firmwareIdGlobal);
      console.log("judgeRoule");
      FirmwareUpdateService.judgeCnOrEn(vm.templateFirm.skuNumber).then(
        function (data) {
          if (data.message === "CN") {
            $state.go(
              "firmwareUpdate.addVersion",
              { id: vm.templateFirm.firmwareId },
              { reload: false }
            );
          } else {
            $state.go(
              "firmwareUpdate.addNewFirmware",
              { id: vm.templateFirm.firmwareId },
              { reload: true }
            );
          }
        }
      );
    }

    function changePrivate() {
      return FirmwareUpdateService.changePrivate().then(function (data) {
        //console.log(data);
        if (data.success === true) {
          toastr.success(
            $filter("T")("firmware.privateSuccess"),
            $filter("T")("title.confirmTitle")
          );
        } else if (data.success === false) {
          toastr.error(
            $filter("T")("firmware.privateFail"),
            $filter("T")("title.infoTitle")
          );
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module("hmapFront").controller("EditFirmwareUpdateController", EditFirmwareUpdateController);

  EditFirmwareUpdateController.$inject = ['$state','SweetAlert','$scope','entity','FirmwareUpdateService','$filter','PromptService','$uibModalInstance','PartyService','RoleService','toastrConfig','toastr'];

  function EditFirmwareUpdateController($state,SweetAlert,$scope,entity,FirmwareUpdateService,$filter,PromptService,$uibModalInstance,PartyService,RoleService,toastrConfig,toastr){
    var vm = this;
    vm.isSending=false;
    vm.template={};
    vm.edit =edit;

    vm.initWeidget = initWeidget;
    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.clear = clear;
    vm.localeSure = localeSure;

    vm.submitInfo=submitInfo;

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    initWeidget();

    $scope.$on('handleSelectedEditParent', function() {
      vm.template.skuId = FirmwareUpdateService.selectedEditParent.skuId;
      vm.template.skuName = FirmwareUpdateService.selectedEditParent.skuName;
    });

    function initWeidget() {
      /*FirmwareUpdateService.getByCode()
        .then(function (data) {
          vm.templateTypeList = data[0].rows;
        })*/
      FirmwareUpdateService.getByCode().query({code:'IOT.SYS_FIRMWARE_NAME'},function (data) {
        vm.fireWareNameList=data.rows;
      },function (error) {
      });

      FirmwareUpdateService.getByCode().query({code:'IOT.SYS_FIRMWARE_TYPE'},function (data) {
        vm.fireWareTypeList=data.rows;
      },function (error) {
      });
    }

    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
      });
    }
    initLangs();

    loadAll();
    vm.template.firmwareId = entity.id;
    function loadAll(){
      FirmwareUpdateService.selectById().query({firmwareId:entity.id},function (result) {
        vm.template=result.rows[0];


        var templateNameList = {};
        var templateContentList = {};
        var descriptionList = {};
        var __tls = {};
        RoleService.getRoleLocaleInfo(entity.id, 'com.iot.portal.admin.fwm.dto.DvmSkuFirmwareDTO', 'description')
          .then(function (data) {
            //deal with the multilanguage field value
            templateNameList = {};
            for (var i in data) {
              templateNameList[data[i].langCode] = data[i].value;
            }
            __tls['description'] = templateNameList;
            vm.template.__tls = __tls;
            $("#descriptionBtn").attr("disabled", false);
          });
      },function (error) {

      });
    }

    function submitInfo(){
      if(vm.template.type==undefined || vm.template.type==''){
      /*  SweetAlert.error("模板类型不能为空",{title:"提示"});*/
        SweetAlert.error($filter('T')('distribution.error_msg'),{title:$filter('T')('title.prompt')});
        return false;
      }
      FirmwareUpdateService.submitInfo().save(vm.template,onSuccess,onError);
    }

    function clear() {
      $state.go("messageTemplate",{},{reload: true});
      $uibModalInstance.dismiss('cancel');
    }

    function edit(){
      if(isNaN(vm.template.skuId)){
        toastr.warning('sku is not a number!');
        return;
      }
      FirmwareUpdateService.edit().save(vm.template,onSuccess,onError);
    }

    function onSuccess(data, headers) {
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      clear();
    }

    function onError(error) {
      vm.isSending=true;
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.template.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
          $("input[name='"+name+"_" + langs[i].langCode + "']").val(vm.template.__tls[name][langs[i].langCode]);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.template.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.template[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.template.__tls = __tls;
    }

  }
})();

/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller("ChooseSkuForFirmwareDialogController", ChooseSkuForFirmwareDialogController);

  ChooseSkuForFirmwareDialogController.$inject = ['FirmwareUpdateService', 'paginationConstants', '$uibModalInstance','$state','toastr'];

  function ChooseSkuForFirmwareDialogController(FirmwareUpdateService,paginationConstants, $uibModalInstance,$state,toastr) {
    var vm = this;
    vm.sku = {};
    vm.sku.resources=[];
    vm.page = 1;
    vm.search=search;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;
    vm.isAllSelected = false;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.clear = clear;
    vm.saveEditParent =saveEditParent;
    vm.saveParent = saveParent;
    vm.selectParent = {};
    vm.selectedEditParent = {};

    vm.loadAll();

    function loadAll() {
      vm.sku.page = vm.page ;
      vm.sku.pagesize = vm.itemsPerPage ;
      FirmwareUpdateService.selectAllSku().query(vm.sku, onSuccess, onError)
    }

    function search(){
      vm.sku.page = vm.page ;
      vm.sku.pagesize = vm.itemsPerPage ;
      FirmwareUpdateService.selectAllSku().query({skuNumber:vm.sku.skuNumber,skuName:vm.sku.skuName,page:vm.page,pagesize:vm.itemsPerPage}, onSuccess, onError)
    }
    function onSuccess(data, headers) {
      vm.sku.resources = data.rows;
      vm.totalItems = data.total;
    }
    function onAddResourceSuccess(data) {
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $uibModalInstance.close(data);
    }

    function onError(error) {
      //console.log('error');

    }

    //save parent
    function saveParent() {
      console.log(vm.selectParent)
      FirmwareUpdateService.shareParent(vm.selectParent);
      $uibModalInstance.dismiss('cancel');
    }

    function saveEditParent() {
      FirmwareUpdateService.shareEidtParent(vm.selectedEditParent);
      $uibModalInstance.dismiss('cancel');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      //loadAll();
      search();
    };
    function clear() {
      $uibModalInstance.dismiss('cancel');
      // $state.go("roleGrantClient");
    }

    /*function save() {
      vm.sku.resources = [];
      angular.forEach(vm.resources, function (res) {
        if (res.addFlag === 'Y') {
          res.__status = 'add';
          vm.sku.resources.push(res);
        }
      });
      MessageTemplateService.createClient().saveOrUpdate(vm.function, onAddResourceSuccess, onError);

    }*/

    function toggleAll() {

      var toggleStatus = !vm.isAllSelected;
      var resourceStatus = 'N';
      if (toggleStatus) {
        resourceStatus = 'N';
      }
      else {
        resourceStatus = 'Y';
      }
      angular.forEach(vm.resources, function (res) {
        res.addFlag = resourceStatus;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('addWhitelistDialogController', addWhitelistDialogController);

  addWhitelistDialogController.$inject = ['$rootScope', '$filter', '$state', 'FirmwareUpdateService', '$uibModalInstance', 'SweetAlert', 'paginationConstants'];

  function addWhitelistDialogController($rootScope, $filter, $state, FirmwareUpdateService, $uibModalInstance, SweetAlert, paginationConstants) {
    var vm = this;
    vm.partys = {};
    vm.party = {};
    vm.party.userName = '';
    vm.party.location = '';
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.clear = clear;
    vm.checkParty = checkParty;
    vm.checkAllParty = checkAllParty;
    vm.addParty = addParty;
    vm.getParty = getParty;
    // vm.getAllParty = getAllParty;
    vm.search = search;
    vm.pageChanged = pageChanged;
    vm.reset = reset;

    load();

    function load() {
      // getAllParty();
      getParty();
    }

    function getParty() {
      FirmwareUpdateService.getPartyBy(vm.party, vm.page)
        .then(function (data) {
          if (!data.rows) {
            return;
          }
          vm.partys = data.rows;
          vm.totalItems = data.total;
          vm.pageSize = data.rows.length;
        });
    }

    function pageChanged() {
      angular.element("#chk_all").checked = false;
      vm.getParty(vm.party,vm.page);
    }

    function search() {
      getParty();
    }

    // function getAllParty() {
    //   FirmwareUpdateService.getAllParty(vm.page)
    //     .then(function (data) {
    //       vm.partys = data.rows;
    //       vm.totalItems = data.total;
    //       vm.pageSize = data.rows.length;
    //     });
    // }

    function checkParty() {
      var arrChk = $("input[name='chk_list']:checked");
      if (arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if (arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    function checkAllParty() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if (chk_all) {
        for (var i = 0; i < items.length; i++) {
          items[i].checked = true;
        }
      } else {
        for (var j = 0; j < items.length; j++) {
          items[j].checked = false;
        }
      }
    }

    function addParty() {
      var isCheck = $(".chk_list").is(':checked');
      if (!isCheck) {
        SweetAlert.confirm($filter('T')("firmware.addAllConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
          if (p) {
            return FirmwareUpdateService.addAllWhitelist(vm.party)
              .then(function (data) {
                load();
                clear();
               });
          }
        });
      }else{
        var arrChk = $("input[name='chk_list']:checked");
        var partys = new Array();
        $(arrChk).each(function () {
          var jsonObj = {};
          jsonObj["partyId"] = this.value;
          partys.push(jsonObj);
        });
        FirmwareUpdateService.addWhitelist(partys).then(function (response) {
          document.getElementById("chk_all").checked = false;
          var items = document.getElementsByName("chk_list");
          for (var j = 0; j < items.length; j++) {
            items[j].checked = false;
          }
          if (response.success) {
            // vm.getAllParty();
            vm.getParty(vm.party,vm.page);
            SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            clear();
          }
        });
      }
      // SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        // if (p) {

        // }
      // });
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
      $state.go('whitelist', {}, {reload: true});
    }

    function reset() {
      vm.party.userName = '';
      vm.party.location = '';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AddNewFirmwareDialogController', AddNewFirmwareDialogController);

  AddNewFirmwareDialogController
    .$inject = ['$rootScope', '$filter', '$state', 'paginationConstants', 'FirmwareUpdateService', 'SweetAlert',
    '$uibModalInstance', 'PromptService', 'toastr', '$localStorage', '$sessionStorage', 'Upload', 'BaseConfig', '$scope',
    'entity','toastrConfig'];

  function AddNewFirmwareDialogController($rootScope, $filter, $state, paginationConstants, FirmwareUpdateService, SweetAlert,
                                          $uibModalInstance, PromptService, toastr, $localStorage, $sessionStorage, Upload, BaseConfig,
                                          $scope, entity,toastrConfig) {
    var vm = this;
    vm.firmwareVersion = {};
    vm.firmwareVersion.firmwareId = entity.id;
    vm.rsaFile = '';
    vm.certiFile = '';

    vm.clear = clear;
    vm.localeSure = localeSure;
    vm.showLocale = showLocale;
    vm.upFile = upFile;
    vm.changeRsaFile = changeRsaFile;
    vm.changeCertiFile = changeCertiFile;
    vm.save = save;

    var langs = [];

    initLangs();

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#descriptionBtn").attr("disabled", false);
        $("#versionNameBtn").attr("disabled", false);
      });
    }

    function changeRsaFile(ele) {
      console.log(ele.files);
      vm.rsaFile = ele.files[0];
    }

    function changeCertiFile(ele) {
      console.log(ele.files);
      vm.certiFile = ele.files[0];
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $('#localeModal_' + name).modal("show");
      if ($.trim($('#localeModelBody_' + name).html()) == '') {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='" + name + "_" + langs[i].langCode
            + "' ng-model='vm.firmwareVersion.__tls." + name + '.' + langs[i].langCode + "'/>");
          $('#localeModelBody_' + name).append(div);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.firmwareVersion.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='" + name + "_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.firmwareVersion[name] = $("input[name='" + name + "_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_" + name).modal("hide");
      __tls[name] = description;
      vm.firmwareVersion.__tls = __tls;
    }

    function upFile() {
      var flag = 0;
      if (!vm.firmwareVersion.versionNumber) {
        var file1 = $("#file1");
        file1.after(file1.clone().val(""));
        file1.remove();
        toastr.warning($filter('T')("plugin.versionFirst"), $filter('T')("plugin.warnMessage"));
        return false;
      }
      var file1 = document.getElementById("file1").files[0];
      var file2 = document.getElementById("file2").files[0];
      var file3 = document.getElementById("file3").files[0];
      var file;
      if (!(file1 == null || file1 == undefined || file1 == '')) {
        flag = 1;
        file = file1;
      } else if (!(file2 == null || file2 == undefined || file2 == '')) {
        flag = 2;
        file = file2;
      } else if (!(file3 == null || file3 == undefined || file3 == '')) {
        flag = 3;
        file = file3;
      }
      $("#versionNumber").attr("readonly", true);
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/skuFirmware/uploadPrivateZip',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'requestFrom': 'admin'
        },
        data: {file: file,versionNumber:vm.firmwareVersion.versionNumber,
          firmwareId:vm.firmwareVersion.firmwareId}
      })
        .progress(function (evt) {
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        }).success(function (data, status, headers, config) {
        // vm.picurl=data.rows[0].pictureUrl;
        // $state.go('legwork', null, {reload: true});
        cleanFile();
        //console.log('上传后拿到的内容是：'+angular.toJson(data));
        //console.log("成功上传：");
        if (data.success == false) {
          toastr.error($filter('T')("plugin.packageUploadFail"), $filter('T')("title.ErrorInfo"));
          return;
        }
        if (data.code == 'versionRepeat') {
          var file = $("#file");
          file.after(file.clone().val(""));
          file.remove();
          toastr.error($filter('T')("plugin.versionRepeat"), $filter('T')("title.infoTitle"));
          $("#versionNumber").removeAttr("readonly");
          return;
        }
        if (data.code == 'formatError') {
          var file = $("#file");
          file.after(file.clone().val(""));
          file.remove();
          toastr.error($filter('T')("plugin.mustCorrectFormet"), $filter('T')("plugin.warnMessage"));
          $("#versionNumber").removeAttr("readonly");
          return;
        }
        if (data.success == true) {
          toastr.success($filter('T')("plugin.packageUploadSuccess"), $filter('T')("title.confirmTitle"));
        }
        // vm.firmwareVersion.versionUrl = data.rows[0].zipUrl;
        // vm.firmwareVersion.versionSize = data.rows[0].versionSize;
        // vm.firmwareVersion.contentMd5 = data.rows[0].contentMd5;
        uploadSuccess(flag, data.rows[0]);
        vm.noEdit = true;
      }).error(function (data, status, headers, config) {
        cleanFile();
      });
    }

    function cleanFile() {
      var files = new Array();
      files[0] = $("#file1");
      files[1] = $("#file2");
      files[2] = $("#file3");
      for (var i = 0, temp; temp = files[i++];) {
        temp.after(temp.clone().val(""));
        temp.remove();
      }
    }

    function uploadSuccess(flag, firmwareVersion) {
      if (flag === 1) {
        vm.firmwareVersion.versionUrl = firmwareVersion.zipUrl;
      } else if (flag === 2) {
        vm.firmwareVersion.imageRsaSignature = firmwareVersion.zipUrl;
      } else if (flag === 3) {
        vm.firmwareVersion.certificate = firmwareVersion.zipUrl;
      }
    }

    function save() {
      FirmwareUpdateService.addNewfirmVersion(vm.firmwareVersion)
        .then(function (data) {
          //console.log(data.rows);
          if (data.success === true) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            clear();
          }else if (data.code === 'fail'){
            toastr.error($filter('T')("title.operationFailed"), $filter('T')("title.confirmTitle"));
          }
        });
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
      $state.go('firmwareUpdate', {}, {reload: true});
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

/**
 * Created by 罗平 on 2016/9/29.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddFirmwareVersionController', AddFirmwareVersionController);

  AddFirmwareVersionController.$inject = [ 'FirmwareUpdateService','PromptService','$filter', '$scope',
    'toastrConfig','$state', '$uibModalInstance','entity','toastr','Upload','BaseConfig','$localStorage',
    '$sessionStorage','CodingService','CodingValueService'];

  function AddFirmwareVersionController(FirmwareUpdateService,PromptService,$filter, $scope,toastrConfig, $state,
                                        $uibModalInstance,entity,toastr,Upload,BaseConfig,$localStorage,
                                        $sessionStorage,CodingService,CodingValueService) {
    var vm = this;
    vm.permissionData=[];
    /*  vm.changConer = changConer;*/

    vm.lang = 'en';
    if(!(vm.lang == 'zh_CN')){
      vm.lang = 'en';
    }

  /*  angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });*/
    vm.typeFlag = true;
    vm.showButton = true;
    vm.noEdit = false;
    vm.isCheckPoint = false;
    vm.checkPointTip = $filter('T')('firmware.checkPointTip');
    vm.isPublic = 'N';
    // vm.noButton = false;
    vm.menuVersion = {
      firmwareId:'',
      menuVersionVisible:''
    };
    vm.menuVersion.firmwareId = entity.id;
    // console.log('id'+angular.toJson(entity))
    vm.clear = clear;
    vm.add = add;
    // vm.loadPlugin = loadPlugin;
    vm.upFile=upFile;
    vm.localUpLoad=localUpLoad;

    vm.localeSure = localeSure;
    vm.showLocale = showLocale;
    vm.initLangs = initLangs;
    vm.dateOptions = dateOptions;
    vm.startOpen = startOpen;

    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#descriptionBtn").attr("disabled", false);
        $("#versionNameBtn").attr("disabled", false);
        /* $("#menuDescBtn").attr("disabled", false);
         $("#templateNameBtn").attr("disabled", false);*/
      });
    }

    function startOpen() {
      vm.isStartOpen = true;
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2080, 5, 22),
        minDate: new Date(),
        startingDay: 1

    };
      return options;
    }

    function getTags() {
      CodingService.findCodes({code: 'DVM.DEVICE_OTA.TAG'}, 1, -1)
        .then(function (data) {
          if (data && data.rows) {
            CodingValueService.findCodeValuesByCodeValue({codeId:data.rows[0].codeId})
              .then(function (tagDatas) {
                if (tagDatas) {
                  vm.tags = tagDatas.rows;
                  vm.selectedData = vm.tags;
                }
              })
          }
      });
    }

    $('.form_date').datetimepicker({
      language: vm.lang,
      format: 'yyyy-mm-dd',
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 2,
      forceParse: 0
    });

    initLangs();
    getTags();

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.menuVersion.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.menuVersion.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.menuVersion[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.menuVersion.__tls = __tls;
    }

   /* vm.loadPlugin(entity.id);
    function loadPlugin(id) {
      if(id){
        FirmwareUpdateService.getPlugin().query({id: id}, function (result) {
          vm.menu = result.rows[0];
          if(vm.menu.menuType=='LOCAL'){
            vm.typeFlag = true;
            vm.showButton = true;
          }else{
            vm.typeFlag = false;
            vm.showButton = false;
          }
        });
      }
    }*/

    function add() {
      /*if(vm.menuVersion.lastFlag==true){
        vm.menuVersion.lastFlag = "Y"
      }else if(vm.menuVersion.lastFlag==false){
        vm.menuVersion.lastFlag = "N"
      }else if(!vm.menuVersion.lastFlag){
        vm.menuVersion.lastFlag = "N"
      }*/

      var tagsArray = [];
      if (vm.selectedData) {
        vm.selectedData.forEach(function (item) {
          tagsArray.push(item.value);
        });
      }
      vm.menuVersion.tags = tagsArray.join(',');
      if(vm.menuVersion.updateDate){
        vm.menuVersion.updateDate=$("#start").val();
      }
      vm.menuVersion.releaseType = vm.isCheckPoint ? 'CHECKPOINT' : '';
      // console.log('menuVersion', vm.menuVersion);
      FirmwareUpdateService.insertVersion().save(vm.menuVersion, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      if(data.code=='versionRepeat'){
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.error($filter('T')("plugin.versionRepeat"), $filter('T')("title.infoTitle"));
        $("#menuVersion").removeAttr("readonly");
        return;
      }

      /*if(vm.menuVersion.lastFlag=="Y"){
        vm.menuVersion.lastFlag = true
      }else if(vm.menuVersion.lastFlag=="N"){
        vm.menuVersion.lastFlag = false
      }*/
      //vm.menuVersion = data.rows[0];
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      $uibModalInstance.close(entity.id);
      $state.go("firmwareUpdate");
    }

    function onError(error) {
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
      $state.go('firmwareUpdate',{},{reload: true});
    }

    function localUpLoad(target){
      if(vm.menu.menuType=='LOCAL'){
        document.getElementById(target).click();
      }
    }

    function upFile(){
      var flag = 0;
      if(!vm.menuVersion.versionNumber) {
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.warning($filter('T')("plugin.versionFirst"), $filter('T')("plugin.warnMessage"));
        return false;
      }
      var file=document.getElementById("zip").files[0];
      var file2 = document.getElementById("file2").files[0];
      var fileChoose;
      /*if (file == null || file== undefined || file == '') {
        return false;
      }*/
      if (!(file == null || file == undefined || file == '')) {
        flag = 1;
        fileChoose = file;
      } else if (!(file2 == null || file2 == undefined || file2 == '')) {
        flag = 2;
        fileChoose = file2;
      }
      $("#menuVersion").attr("readonly",true);
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/skuFirmware/uploadZip',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'requestFrom': 'admin'
        },
        data: {file: fileChoose,versionNumber:vm.menuVersion.versionNumber,
          firmwareId:vm.menuVersion.firmwareId}
      }).progress(function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        // vm.picurl=data.rows[0].pictureUrl;
        // $state.go('legwork', null, {reload: true});
        cleanFile();
        console.log('上传后拿到的内容是：'+angular.toJson(data));
        console.log("成功上传：");
        if(data.success==false){
          toastr.error($filter('T')("plugin.packageUploadFail"), $filter('T')("title.ErrorInfo"));
          return ;
        }
        if(data.code=='versionRepeat'){
          var file = $("#zip");
          file.after(file.clone().val(""));
          file.remove();
          toastr.error($filter('T')("plugin.versionRepeat"), $filter('T')("title.infoTitle"));
          $("#menuVersion").removeAttr("readonly");
          return;
        }
        if(data.code=='formatError'){
          var file = $("#zip");
          file.after(file.clone().val(""));
          file.remove();
          toastr.error($filter('T')("plugin.mustCorrectFormet"), $filter('T')("plugin.warnMessage"));
          $("#menuVersion").removeAttr("readonly");
          return;
        }


        if(data.success==true){
          toastr.success($filter('T')("plugin.packageUploadSuccess"), $filter('T')("title.confirmTitle"));
        }
        /*vm.menuVersion.versionUrl = data.rows[0].zipUrl;
        vm.menuVersion.versionSize = data.rows[0].versionSize;
        vm.menuVersion.contentMd5 = data.rows[0].contentMd5;*/
        uploadSuccess(flag, data.rows[0]);
        /*vm.menuVersion.menuVersion = data.rows[0].menuVersion;
         vm.menuVersion.menuDesc = data.rows[0].menuDesc;
         vm.menuVersion.menuResource = data.rows[0].menuResource;
         vm.menuVersion.menuLocalPath = data.rows[0].menuLocalPath;
         vm.menuVersion.showConer = data.rows[0].showConer;
         vm.menuVersion.isSilenceUpdate = data.rows[0].isSilenceUpdate;
         vm.menuVersion.isForceUpdate = data.rows[0].isForceUpdate;
         if(vm.menuVersion.showConer=='Y'){
         vm.menuVersion.showConer=true;
         }else{
         vm.menuVersion.showConer=false;
         }
         if(vm.menuVersion.isSilenceUpdate=='Y'){
         vm.menuVersion.isSilenceUpdate=true;
         }else{
         vm.menuVersion.isSilenceUpdate=false;
         }
         if(vm.menuVersion.isForceUpdate=='Y'){
         vm.menuVersion.isForceUpdate=true;
         }else{
         vm.menuVersion.isForceUpdate=false;
         }*/
        vm.noEdit = true;
      }).error(function (data, status, headers, config) {
        cleanFile()
      });
    }

    function cleanFile() {
      var files = new Array();
      files[0] = $("#zip");
      files[1] = $("#file2");
      for (var i = 0, temp; temp = files[i++];) {
        temp.after(temp.clone().val(""));
        temp.remove();
      }
    }

    function uploadSuccess(flag, firmwareVersion) {
      if (flag === 1) {
        vm.menuVersion.versionUrl = firmwareVersion.zipUrl;
        vm.menuVersion.versionSize = firmwareVersion.versionSize;
        vm.menuVersion.contentMd5 = firmwareVersion.contentMd5;
        vm.menuVersion.signature = firmwareVersion.signature;
      } else if (flag === 2) {
        vm.menuVersion.imageRsaSignature = firmwareVersion.zipUrl;
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module("hmapFront").controller("AddFirmwareUpdateController", AddFirmwareUpdateController);

  AddFirmwareUpdateController.$inject = ['$state','SweetAlert','$uibModalInstance','FirmwareUpdateService','$filter','$scope','PromptService','toastrConfig','toastr'];

  function AddFirmwareUpdateController($state,SweetAlert,$uibModalInstance,FirmwareUpdateService,$filter,$scope, PromptService,toastrConfig,toastr){
    var vm = this;
    vm.isSending=false;
    vm.template={};
    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.clear = clear;
    vm.localeSure = localeSure;
    vm.add = add;
    vm.isDisable = false;
    vm.isRequired= true;
    vm.judgeCountry = judgeCountry;

    function judgeCountry(){
      if (''!== vm.template.skuNum && null !== vm.template.skuNum
          && undefined !== vm.template.skuNum ) {
        FirmwareUpdateService.judgeCnOrEn(vm.template.skuNum)
          .then(function (data) {
            //console.log('judgeCountry'+data);
            if (data.message === 'CN') {
              vm.isDisable = false;
              vm.isRequired = true;
            }else {
              vm.isDisable = true;
              vm.isRequired = false;
            }
          });
      }
    }

    vm.lang = "en_GB";//window.localStorage.commerciallang;
    if(!(vm.lang == 'zh_CN')){
      vm.lang = 'en';
    }

    vm.initWeidget = initWeidget;
    initWeidget();
    // langs
    var langs = [];
    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });


    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#templateContentBtn").attr("disabled", false);
        $("#descriptionBtn").attr("disabled", false);
        $("#templateNameBtn").attr("disabled", false);
      });
    }
    initLangs();

    $scope.$on('handleSelectedParent', function() {
      vm.template.skuId = FirmwareUpdateService.selectedParent.skuId;
      vm.template.skuNum =  FirmwareUpdateService.selectedParent.skuNumber;
      vm.template.skuName = FirmwareUpdateService.selectedParent.skuName;
    });

   /* vm.submitInfo=submitInfo;

    function submitInfo(){
      if(vm.template.type==undefined || vm.template.type==''){
        SweetAlert.error($filter('T')('distribution.error_msg'),{title:$filter('T')('title.prompt')});
        return false;
      }
      var data={
        title:vm.template.title,
        content:vm.template.content,
        type:vm.template.type
      };
    FirmwareUpdateService.submitInfo().save(data,onSuccess,onError);
    }*/

    function add() {
      if(isNaN(vm.template.skuId)){
        toastr.warning('sku is not a number!');
        return;
      }
      console.log(vm.template);
      FirmwareUpdateService.submitInfo().save(vm.template,onSuccess,onError);
      // RoleService.addRole().save(vm.role,onSuccess,onError);
    }

    function onSuccess(data, headers) {
      if(data.code=='repeat'){
        //'can not add repeat data!'
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      clear();
    }

    function onError(error) {
      vm.isSending=true;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
      $state.go('firmwareUpdate',{},{reload: true});
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.template.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }

   /* function showLocale2(name) {
      // According to langs to make inputs.
      //$("#localeModal").modal("show");
      if($.trim($("#localeModal_"+name).html()) == "") {
        var div = "";
        div = div+'<div class="modal fade" id="localeModal__'+name+'" style="z-index: 2040; position: absolute;" data-keyboard="false">'+
          '<div class="modal-dialog">'+
          '<div class="modal-content">'+
          '<div class="modal-header">'+
          '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>'+
        '</div>'+
        '<div class="modal-body" id="localeModelBody_"'+name+'>';
        for (var i in langs) {
          div = div +　'<div class="form-group"></div>';
          div = div + '<label class="control-label">' + langs[i].description + '</label>';
          div = div +'<input type="text" class="form-control" name="rn_' + langs[i].langCode
            + '" ng-model="vm.template.__tls.' + name + '.' + langs[i].langCode + '"/>';

        }
        div = div+'</div>'+
          '</div>';
        $("#localeModal_"+name).html(div);
      }
      $("#localeModal__"+name).modal("show");


      vm.currentName = name;
    }*/

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.template.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.template[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.template.__tls = __tls;
    }

    function initWeidget() {
      /*PartyService.getLookUp(['SYS.TEMPLE_TYPE'])
        .then(function (data) {
          vm.templateTypeList = data[0];
        })*/
      FirmwareUpdateService.getByCode().query({code:'IOT.SYS_FIRMWARE_NAME'},function (data) {
        vm.fireWareNameList=data.rows;
      },function (error) {
      });

      FirmwareUpdateService.getByCode().query({code:'IOT.SYS_FIRMWARE_TYPE'},function (data) {
        vm.fireWareTypeList=data.rows;
      },function (error) {
      });
    }

  }
})();

/**
 * Created by ys on 2017/6/26.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddFirmwareBatchVersionController', AddFirmwareBatchVersionController);

  AddFirmwareBatchVersionController.$inject = [ 'FirmwareUpdateService','PromptService','$filter', '$scope',
    'toastrConfig','$state', '$uibModalInstance','entity','toastr','Upload','BaseConfig','$localStorage',
    '$sessionStorage', 'CodingService', 'CodingValueService'];

  function AddFirmwareBatchVersionController(FirmwareUpdateService,PromptService,$filter, $scope,toastrConfig,
                                             $state, $uibModalInstance,entity,toastr,Upload,BaseConfig,$localStorage,
                                             $sessionStorage, CodingService, CodingValueService) {
    var vm = this;
    vm.permissionData=[];
    vm.checkPointTip = $filter('T')('firmware.checkPointTip');
    vm.initWeidget = initWeidget;
    initWeidget();
    /*  vm.changConer = changConer;*/

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
    vm.typeFlag = true;
    vm.showButton = true;
    vm.noEdit = false;
    // vm.noButton = false;
    vm.menuVersion = {
      firmwareId:'',
      menuVersionVisible:''
    }
    vm.menuVersion.firmwareId = entity.id;
    // console.log('id'+angular.toJson(entity))
    vm.clear = clear;
    vm.add = add;
    // vm.loadPlugin = loadPlugin;
    vm.upFile=upFile;
    vm.localUpLoad=localUpLoad;

    vm.localeSure = localeSure;
    vm.showLocale = showLocale;
    vm.initLangs = initLangs;

    vm.dateOptions = dateOptions;
    vm.startOpen = startOpen;
    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#descriptionBtn").attr("disabled", false);
        $("#versionNameBtn").attr("disabled", false);
        /* $("#menuDescBtn").attr("disabled", false);
         $("#templateNameBtn").attr("disabled", false);*/
      });
    }

    initLangs();
    getTags();

    function startOpen() {
      vm.isStartOpen = true;
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }


    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.menuVersion.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.menuVersion.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.menuVersion[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.menuVersion.__tls = __tls;
    }

   /* vm.loadPlugin(entity.id);
    function loadPlugin(id) {
      if(id){
        FirmwareUpdateService.getPlugin().query({id: id}, function (result) {
          vm.menu = result.rows[0];
          if(vm.menu.menuType=='LOCAL'){
            vm.typeFlag = true;
            vm.showButton = true;
          }else{
            vm.typeFlag = false;
            vm.showButton = false;
          }
        });
      }
    }*/

    function add() {
      var tagsArray = [];
      if (vm.selectedData) {
        vm.selectedData.forEach(function (item) {
          tagsArray.push(item.value);
        });
      }
      vm.menuVersion.tags = tagsArray.join(',');

      if(vm.menuVersion.updateDate){
        vm.menuVersion.updateDate=$("#start").val();
      }
      vm.menuVersion.releaseType = vm.isCheckPoint ? 'CHECKPOINT' : '';
      // console.log('menuVersion', vm.menuVersion);
      FirmwareUpdateService.insertVersionBatch().save(vm.menuVersion, onSuccessAdd, onError);
    }

    function onSuccessAdd(data, headers) {
      if(data.code=='versionRepeat'){
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.error($filter('T')("plugin.versionRepeat"), $filter('T')("title.infoTitle"));
        $("#menuVersion").removeAttr("readonly");
        return;
      }else if(data.code=='formatError'){
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.error($filter('T')("plugin.mustCorrectFormet"), $filter('T')("title.infoTitle"));
        $("#menuVersion").removeAttr("readonly");
        return;
      }
      //vm.menuVersion = data.rows[0];
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      $state.go("firmwareUpdate");
      $uibModalInstance.close(entity.id);
    }


    function onSuccess(data, headers) {
      if(data.code=='versionRepeat'){
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.error($filter('T')("plugin.versionRepeat"), $filter('T')("title.infoTitle"));
        $("#menuVersion").removeAttr("readonly");
        return;
      }

      if(vm.menuVersion.lastFlag=="Y"){
        vm.menuVersion.lastFlag = true
      }else if(vm.menuVersion.lastFlag=="N"){
        vm.menuVersion.lastFlag = false
      }
      //vm.menuVersion = data.rows[0];
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      $uibModalInstance.close(entity.id);
    }


    function onError(error) {
    }

    function clear() {
      $uibModalInstance.close(entity.id);
      //$uibModalInstance.dismiss('cancel');
    }

    function localUpLoad(target){
      if(vm.menu.menuType=='LOCAL'){
        document.getElementById(target).click();
      }
    }



    function upFile(){
      if(!vm.menuVersion.firmwareType) {
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.warning($filter('T')("firmware.chooseFirmwareFirst"), $filter('T')("plugin.warnMessage"));
        return false;
      }

      if(!vm.menuVersion.versionNumber) {
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.warning($filter('T')("plugin.versionFirst"), $filter('T')("plugin.warnMessage"));
        return false;
      }
      var file=document.getElementById("zip").files[0];
      if (file == null || file== undefined || file == '') {
        return false;
      }
      $("#menuVersion").attr("readonly",true);
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/skuFirmware/uploadZip',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        data: {file: file,versionNumber:vm.menuVersion.versionNumber,
          firmwareId:vm.menuVersion.firmwareId,firmwareType:vm.menuVersion.firmwareType}
      }).progress(function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        // vm.picurl=data.rows[0].pictureUrl;
        // $state.go('legwork', null, {reload: true});
        console.log('上传后拿到的内容是：'+angular.toJson(data));
        console.log("成功上传：");
        if(data.success==false){
          toastr.error($filter('T')("plugin.packageUploadFail"), $filter('T')("title.ErrorInfo"));
          return ;
        }
        if(data.code=='versionRepeat'){
          var file = $("#zip");
          file.after(file.clone().val(""));
          file.remove();
          toastr.error($filter('T')("plugin.versionRepeat"), $filter('T')("title.infoTitle"));
          $("#menuVersion").removeAttr("readonly");
          return;
        }
        if(data.code=='formatError'){
          var file = $("#zip");
          file.after(file.clone().val(""));
          file.remove();
          toastr.error($filter('T')("plugin.mustCorrectFormet"), $filter('T')("plugin.warnMessage"));
          $("#menuVersion").removeAttr("readonly");
          return;
        }
        if(data.success==true){
          toastr.success($filter('T')("plugin.packageUploadSuccess"), $filter('T')("title.confirmTitle"));
        }
        $("#versionNumber").attr("readonly","readonly");
        vm.menuVersion.versionUrl = data.rows[0].zipUrl;
        vm.menuVersion.versionSize = data.rows[0].versionSize;
        vm.menuVersion.contentMd5 = data.rows[0].contentMd5;
        vm.menuVersion.signature = data.rows[0].signature;
        //$state.go("firmwareUpdate");
        /*vm.menuVersion.menuVersion = data.rows[0].menuVersion;
         vm.menuVersion.menuDesc = data.rows[0].menuDesc;
         vm.menuVersion.menuResource = data.rows[0].menuResource;
         vm.menuVersion.menuLocalPath = data.rows[0].menuLocalPath;
         vm.menuVersion.showConer = data.rows[0].showConer;
         vm.menuVersion.isSilenceUpdate = data.rows[0].isSilenceUpdate;
         vm.menuVersion.isForceUpdate = data.rows[0].isForceUpdate;
         if(vm.menuVersion.showConer=='Y'){
         vm.menuVersion.showConer=true;
         }else{
         vm.menuVersion.showConer=false;
         }
         if(vm.menuVersion.isSilenceUpdate=='Y'){
         vm.menuVersion.isSilenceUpdate=true;
         }else{
         vm.menuVersion.isSilenceUpdate=false;
         }
         if(vm.menuVersion.isForceUpdate=='Y'){
         vm.menuVersion.isForceUpdate=true;
         }else{
         vm.menuVersion.isForceUpdate=false;
         }*/
        vm.noEdit = true;
      }).error(function (data, status, headers, config) {

      });
    }

    function initWeidget() {
      /*PartyService.getLookUp(['SYS.TEMPLE_TYPE'])
       .then(function (data) {
       vm.templateTypeList = data[0];
       })*/
      FirmwareUpdateService.getByCode().query({code:'IOT.SYS_FIRMWARE_TYPE'},function (data) {
        vm.firmwareTypeList=data.rows;
      },function (error) {
      });
    }

    function getTags() {
      CodingService.findCodes({code: 'DVM.DEVICE_OTA.TAG'}, 1, -1)
        .then(function (data) {
          if (data && data.rows) {
            CodingValueService.findCodeValuesByCodeValue({codeId:data.rows[0].codeId})
              .then(function (tagDatas) {
                if (tagDatas) {
                  vm.tags = tagDatas.rows;
                  vm.selectedData = vm.tags;
                }
              })
          }
        });
    }

  }
})();

/**
 * Created by hand on 2016/11/3.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('feedback', {
        parent: 'app',
        url: "/feedback",
        views: {
          'body': {
            templateUrl: "app/feedback/feedback.html",
            controller: 'feedbackController',
            controllerAs: 'vm'
          }
        }
      })
  }

})();

/**
 * Created by hand on 2016/11/6.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('Feedback', Feedback);

  Feedback.$inject = ['$resource','$localStorage'];

  function Feedback($resource,$localStorage) {
    var service = {
      query: query,
      insert:insert,
      queryNotReply:queryNotReply,
      printFeedback:printFeedback,
      createFeedback:createFeedback
    };
    return service;

    function query() {
      var resourceUrl = '/api/feedquery';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function insert(){
      var resourceUrl = '/api/insertReply';
      return $resource(resourceUrl,{},{
        'insert':{method:'POST'}
      })
    }

    function queryNotReply(){
      var resourceUrl='/api/queryNotReply';
      return $resource(resourceUrl,{},{
        'query':{method:'GET'}
      })
    }

    function printFeedback(){
      var resourceUrl='/api/printFeedback';
      return $resource(resourceUrl,{},{
        'print':{method:'GET'}
      })
    }

    function createFeedback(){
      var resourceUrl='/api/createFeedback';
      return $resource(resourceUrl,{},{
        'insert':{method:'POST'}
      })
    }
  }
})();

/**
 * Created by hand on 2016/11/3.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('feedbackController', feedbackController);

  feedbackController.$inject = ['BaseConfig','$state', 'Feedback', 'paginationConstants','$localStorage','$scope','$uibModal','toastr'];

  function feedbackController(BaseConfig,$state,Feedback, paginationConstants,$localStorage,$scope,$uibModal,toastr) {

    var token = $localStorage.authenticationToken;
    var accessToken = token.access_token;

    var vm = this;
    this.picker3 = {
      date: new Date()
    };
    this.picker4 = {
      date: new Date()
    };
    vm.page=1;
    vm.totalItems = null;
    vm.isNotReply=false;
    vm.isSearch=false;
    vm.addReply={};
    vm.searchReply={};
    vm.searchFeedback ={};
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.transition = transition;
    vm.loadAll=loadAll;
    vm.loadAll();
    vm.search=search;
    vm.insert=insert;
    vm.queryNotReply=queryNotReply;
    vm.printFeedback=printFeedback;
    vm.openCalendar=openCalendar;
    vm.openCalendarL=openCalendarL;
    vm.createFeedback=createFeedback;
    vm.path = BaseConfig.url+'/common/printFeedback';
    function openCalendar (e, picker) {
      vm [picker].open = true;
    };
    function openCalendarL (e, picker) {
      vm [picker].open = true;
    };
    // watch min and max dates to calculate difference



    function createFeedback(){
      var modalInstance = $uibModal.open({
        templateUrl: 'app/feedback/feedback-dialog.html',
        controller: 'FeedbackDialogController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              feedbackData: null
            };
          }
        }
      }).result.then(function (feedbacks) {
          vm.feedbacks=feedbacks;
          vm.feedbacks.page= vm.page;
          vm.feedbacks.pageSize=paginationConstants.itemsPerPage;
          loadAll();
        }, function () {
          //console.log('Modal dismissed at: ' + new Date());

        });
    }


    function loadAll (){
      vm.isNotReply=false;
      vm.isSearch=false;
        Feedback.query().query({
          page: vm.page,
          accessToken: accessToken,
          pagesize: paginationConstants.itemsPerPage
        }, onSuccess, onError);
    }

    function insert(feedbackId,replyData){

      vm.isSaving = true;
      vm.isSearch=false;
      vm.addReply.feedbackId=feedbackId;
      vm.addReply.replyData=replyData;
      Feedback.insert().insert(vm.addReply, onSaveSuccess, onSaveError);
    }

    function queryNotReply(){
      vm.isNotReply=true;
      vm.isSearch=false;
      vm.searchReply.page = vm.page;
      vm.searchReply.pagesize = paginationConstants.itemsPerPage;
      vm.searchReply.accessToken=accessToken;
      Feedback.queryNotReply().query(vm.searchReply,onSuccess, onError);
    }


    function printFeedback(){
    //  console.log("=========: "+angular.toJson(vm.feedbacks[0]));
    //   Feedback.printFeedback().print(vm.feedbacks);
      console.log('9999999999999')
      return Feedback.printFeedback().print();
      // toastr.success('导出成功！','信息提示');
    }

    function search() {
      vm.isNotReply=false;
      vm.isSearch=true;
      vm.searchFeedback.page = vm.page;
      vm.searchFeedback.pageSize = paginationConstants.itemsPerPage;
      vm.searchFeedback.accessToken=accessToken;
      Feedback.query().query(vm.searchFeedback, onSuccess, onError);
    }



    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.feedbacks= data.rows;
      // console.log('feedbacks:'+angular.toJson(vm.feedbacks));
      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');

    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      if(vm.isNotReply){
        queryNotReply();
      }else if(vm.isSearch){
        search();
      }else{
        loadAll();
      }
    };

    function onSaveSuccess(result) {
      //console.log(result);
      loadAll();
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

  }
})();

/**
 * Created by hand on 2016/11/28.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('FeedbackDialogController', FeedbackDialogController);

  FeedbackDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Feedback','toastr','$filter'];

  function FeedbackDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Feedback,toastr,$filter) {
    var vm = this;
    vm.feedback = {};
    vm.feedbacks={};
    vm.isFeedback = false;
    vm.clear = clear;
    vm.save = save;
    vm.load = load;
    vm.load(vm.feedback.id);

    function clear(){
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.isSaving = true;
      //console.log(vm.sysConfig);
      Feedback.createFeedback().insert(vm.feedback, onSaveSuccess, onSaveError);
    }

    function onSaveSuccess(data, headers) {
      //console.log(result);
      vm.feedbacks=data.rows;
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $scope.$emit('hmapFront:feedbackUpdate',vm.feedbacks);
      $uibModalInstance.close(vm.feedbacks);
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

        function load(id) {
        if (id) {
          Feedback.query().query(vm.feedback, function (result) {
            vm.feedback = result.rows[0];
          });
        }

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('PushToB2cResPartyController', PushToB2cResPartyController);

  PushToB2cResPartyController.$inject = ['$localStorage','BaseConfig','paginationConstants','toastr','$filter','toastrConfig','$state','entity','SweetAlert','DowntimePushService'];

  function PushToB2cResPartyController($localStorage, BaseConfig, paginationConstants,toastr,$filter,toastrConfig,$state,entity,SweetAlert,DowntimePushService) {
    var vm = this;
    vm.party = {};
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.party.partyAccount = '';
    vm.templateId = entity.id;
    vm.pageChanged = pageChanged;
    vm.getResidentialParty = getResidentialParty;
    vm.checkParty = checkParty;
    vm.checkAllParty = checkAllParty;
    vm.back = back;
    vm.push = push;
    vm.check = check;
    vm.list = new Array();

    vm.getResidentialParty();

    function getResidentialParty() {
      if (vm.party && (vm.party.partyAccount || "") === "") {
        delete vm.party.partyAccount;
      }
      DowntimePushService.queryParties(vm.party, vm.page, vm.itemsPerPage).then(function(response){
      vm.parties = response.rows;
        for(var i = 0;i < vm.parties.length; i++){
          if (vm.parties[i].birthDate) {
            vm.parties[i].birthDate = new Date(vm.parties[i].birthDate);
          }
        }
        vm.totalItems =  response.total;
        vm.pageSize = response.rows.length;
      });
    }

    function pageChanged() {
      document.getElementById("chk_all").checked = false;

      vm.getResidentialParty();
      vm.checkParty();

      var flag = true;
      var arrAll = $("input[name = 'chk_list']");
      $(arrAll).each(function(){
        var checked = this.checked;
        var entity = new Object();
        entity.partyId = this.value;
        if (checked){
          for (var i=0; i<vm.list.length; i++){
            if (vm.list[i].partyId == entity.partyId){
              flag = false;
            }
          }
          if (flag){
            vm.list.push(entity);
          }
        }else{
          for (var i=0; i<vm.list.length; i++){
            if (vm.list[i].partyId == entity.partyId){
              vm.list.splice(i,1);
            }
          }
        }
        flag = true;
      });

      document.getElementById("chk_all").checked = false;

    }

    function checkParty(){
      var arrChk = $("input[name = 'chk_list']:checked");
      if(arrChk.length<vm.pageSize){
        document.getElementById("chk_all").checked = false;
      }
      else if(arrChk.length === vm.pageSize){
        document.getElementById("chk_all").checked = true;
      }
    }

    function checkAllParty(){
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all){
        for(var i = 0;i<items.length;i++){
          items[i].checked = true;
        }
      }else{
        for(var i = 0;i<items.length;i++){
          items[i].checked = false;
        }
      }
    }

    function check(partyId) {

      for (var i = 0; i < vm.list.length; i++){
        if (vm.list[i].partyId == partyId){
          return true;
        }
      }
      return false;
    }


    function back() {
      vm.list = [];
      $state.go("downtimePush",{},{reload: "downtimePush"});
    }

    function push() {
      var flag = true;
      var arrAll = $("input[name = 'chk_list']");
      $(arrAll).each(function(){
        var checked = this.checked;
        var entity = new Object();
        entity.partyId = this.value;
        if (checked){
          for (var i=0; i<vm.list.length; i++){
            if (vm.list[i].partyId == entity.partyId){
              flag = false;
            }
          }
          if (flag){
            vm.list.push(entity);
          }
        }else{
          for (var i=0; i<vm.list.length; i++){
            if (vm.list[i].partyId == entity.partyId){
              vm.list.splice(i,1);
            }
          }
        }
        flag = true;
      });

      document.getElementById("chk_all").checked = false;
      console.log(vm.list);

      SweetAlert.confirm($filter('T')('distribution.pushAllMessage'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          DowntimePushService.pushSelect(vm.list,vm.templateId ).then(function(response){
            if(response.success){
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
              vm.list = [];
            }
          })

        }
      })


    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }
})();

(function () {
  'use strict';

  angular.module("hmapFront").controller("EditDowntimePushController", EditDowntimePushController);

  EditDowntimePushController.$inject = ['$state','SweetAlert','$scope','entity','DowntimePushService','$filter','PromptService','$uibModalInstance','PartyService','RoleService','toastrConfig','toastr'];

  function EditDowntimePushController($state,SweetAlert,$scope,entity,DowntimePushService,$filter,PromptService,$uibModalInstance,PartyService,RoleService,toastrConfig,toastr){
    var vm = this;
    vm.isSending=false;
    vm.template={};
    vm.edit =edit;

    vm.intData = intData;
    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.clear = clear;
    vm.localeSure = localeSure;

    vm.submitInfo=submitInfo;

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    intData();

    $scope.$on('handleSelectedEditParent', function() {
      vm.template.productId = DowntimePushService.selectedEditParent.productId;
      vm.template.productName = DowntimePushService.selectedEditParent.productName;
    });

    function intData() {
      DowntimePushService.getByCode().query({code:'SYS.TEMPLE_TYPE'},function (data) {
        var list = new Array();
        if (data.rows){
          for (var i= 0; i < data.rows.length; i++) {
            if (data.rows[i].value.indexOf("ADMIN_DOWN_TIME_") != -1) {
              list.push(data.rows[i]);
            }
          }
        }
        vm.templateTypeList=list;
      },function (error) {
      });
    }

    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
      });
    }
    initLangs();

    loadAll();
    vm.template.templateId = entity.id;
    function loadAll(){
      DowntimePushService.selectById().query({templateId:entity.id},function (result) {
        vm.template=result.rows[0];


        var templateNameList = {};
        var templateContentList = {};
        var descriptionList = {};
        var linkAddressList = {};
        var __tls = {};
        RoleService.getRoleLocaleInfo(entity.id, 'com.iot.portal.admin.sys.messagetemplate.dto.MessageTemplateManager', 'templateName')
          .then(function (data) {
            //deal with the multilanguage field value
            templateNameList = {};
            for (var i in data) {
              templateNameList[data[i].langCode] = data[i].value;
            }
            __tls['templateName'] = templateNameList;

            RoleService.getRoleLocaleInfo(entity.id, 'com.iot.portal.admin.sys.messagetemplate.dto.MessageTemplateManager', 'description')
              .then(function (data) {
                //deal with the multilanguage field value
                descriptionList = {};
                for (var i in data) {
                  descriptionList[data[i].langCode] = data[i].value;
                }
                __tls['description'] = descriptionList;
              });

            RoleService.getRoleLocaleInfo(entity.id, 'com.iot.portal.admin.sys.messagetemplate.dto.MessageTemplateManager', 'linkAddress')
              .then(function (data) {
                //deal with the multilanguage field value
                linkAddressList = {};
                for (var i in data) {
                  linkAddressList[data[i].langCode] = data[i].value;
                }
                __tls['linkAddress'] = linkAddressList;
              });

            RoleService.getRoleLocaleInfo(entity.id, 'com.iot.portal.admin.sys.messagetemplate.dto.MessageTemplateManager', 'templateContent')
              .then(function (data) {
                //deal with the multilanguage field value
                templateContentList = {};
                for (var i in data) {
                  templateContentList[data[i].langCode] = data[i].value;
                }
                __tls['templateContent'] = templateContentList;
                vm.template.__tls = __tls;

                $("#templateContentBtn").attr("disabled", false);
                $("#descriptionBtn").attr("disabled", false);
                $("#templateNameBtn").attr("disabled", false);
                $("#linkAddressBtn").attr("disabled", false);
              });
          });
      },function (error) {

      });
    }

    function submitInfo(){
      if(vm.template.type==undefined || vm.template.type==''){
        /*  SweetAlert.error("模板类型不能为空",{title:"提示"});*/
        SweetAlert.error($filter('T')('distribution.error_msg'),{title:$filter('T')('title.prompt')});
        return false;
      }
      DowntimePushService.submitInfo().save(vm.template,onSuccess,onError);
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function edit(){
      DowntimePushService.edit().save(vm.template,onSuccess,onError);
    }

    function onSuccess(data, headers) {
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      $uibModalInstance.close();
    }

    function onError(error) {
      vm.isSending=true;
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.template.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
          $("input[name='"+name+"_" + langs[i].langCode + "']").val(vm.template.__tls[name][langs[i].langCode]);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.template.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.template[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.template.__tls = __tls;
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider.state('downtimePush', {
      parent: 'app',
      url: "/downtimePush",
      views: {
        'body': {
          templateUrl: "app/downtimePush/downtimePush.html",
          controller: 'DowntimePushController',
          controllerAs: 'vm'
        }
      }
    })
      .state('downtimePush.add', {
        parent: 'downtimePush',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/downtimePush/addDowntimePush.html",
            controller: 'AddDowntimePushController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function ($stateParams) {
                return {}
              }
            }
          }).result.then(function () {
            $state.go('downtimePush', null, {reload: 'downtimePush'});
          }, function () {
            $state.go('downtimePush', null, {reload: 'downtimePush'});
          });
        }]
      })
      .state('downtimePush.edit', {
        parent: 'downtimePush',
        url: "/edit/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/downtimePush/editDowntimePush.html",
            controller: 'EditDowntimePushController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id
                };
              }
            }
          }).result.then(function () {
            $state.go('downtimePush', null, {reload: 'downtimePush'});
          }, function () {
            $state.go('downtimePush', null, {reload: 'downtimePush'});
          });
        }]
      })
      .state('pushToB2cResParty', {
        parent: 'app',
        url: "/pushToB2cResParty/:id",
        views: {
          'body': {
            templateUrl: "app/downtimePush/pushToB2cResParty.html",
            controller: 'PushToB2cResPartyController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams', function ($stateParams) {
            return {
              id: $stateParams.id
            };
          }]
        }
      })

  }
})();


(function(){
  'use strict';
  angular.module('hmapFront')
    .factory('DowntimePushService', DowntimePushService);
  DowntimePushService.$inject = ['$resource','$http','$rootScope'];

  function DowntimePushService ($resource,$http,$rootScope) {
    var selectedParent = {};
    var selectedEditParent = {};
    var service = {
      queryAll:queryAll,
      selectById:selectById,
      submitInfo:submitInfo,
      deleteTemp:deleteTemp,
      edit:edit,
      getByCode:getByCode,
      selectAllSku:selectAllSku,
      selectAllProduce:selectAllProduce,
      shareParent:shareParent,
      shareEidtParent:shareEidtParent,
      selectedParent: selectedParent,
      selectedEditParent:selectedEditParent,
      pushAll:pushAll,
      pushSelect:pushSelect,
      queryParties:queryParties
    };
    return service;

    function shareParent(selectedParent){
      this.selectedParent = selectedParent;
      $rootScope.$broadcast('handleSelectedParent');
    }

    function shareEidtParent(selectedEditParent){
      this.selectedEditParent = selectedEditParent;
      $rootScope.$broadcast('handleSelectedEditParent');
    }

    function queryAll(){
      var resourceUrl = '/api/messageTemp/selectAll';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function selectAllSku(){
      var resourceUrl ='/api/ctm/selectAllSku';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function selectAllProduce(){
      var resourceUrl ='/api/ctm/selectProduct';
      return $resource(resourceUrl,{},{
        'query': {method: 'GET'}
      });
    }



    function getByCode(){
      var resourceUrl = '/api/messageTemp/getByCode';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function deleteTemp(){
      var resourceUrl = '/api/messageTemp/delete';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function selectById(){
      var resourceUrl = '/api/messageTemp/select';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function submitInfo(){
      var resourceUrl = '/api/messageTemp/insertSelective';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function edit(){
      var resourceUrl = '/api/messageTemp/edit';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function pushAll(templateId) {
      var resourceUrl = '/api/downTime/pushAll?templateId='+ templateId;
      return $http.post(resourceUrl, {}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    function pushSelect(entity, templateId) {
      var resourceUrl = '/api/downTime/pushSelect?templateId='+ templateId;
      return $http.post(resourceUrl, entity , {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }


    function queryParties(entity, page, pageSize) {
      var resourceUrl = '/api/downTime/userSelect?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, entity, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }
  }
})();

(function () {
  'use strict';

  angular.module("hmapFront").controller("DowntimePushController", DowntimePushController);

  DowntimePushController.$inject = ['$rootScope','$filter','$state','paginationConstants','DowntimePushService','SweetAlert'];

  function DowntimePushController($rootScope,$filter,$state,paginationConstants,DowntimePushService,SweetAlert){
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.template={};
    vm.template.page = vm.page;
    vm.template.pagesize = vm.itemsPerPage;
    vm.template.templateType = '';
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.reset = reset;
    vm.loadAll=loadAll;
    vm.deleteTemp = deleteTemp;
    vm.pushAll = pushAll;

    vm.loadAll();

    vm.initWeidget = initWeidget;
    initWeidget();

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
      if(toState.parent == 'app' && toState.name == 'messageTemplate' && fromState.name == 'messageTemplateEdit') {
        vm.pageChanged();
      }
    });

    function initWeidget() {
      DowntimePushService.getByCode().query({code:'SYS.TEMPLE_TYPE'},function (data) {
        var list = new Array();
        if (data.rows){
          for (var i= 0; i < data.rows.length; i++) {
            if (data.rows[i].value.indexOf("ADMIN_DOWN_TIME_") != -1) {
              list.push(data.rows[i]);
            }
          }
        }
        vm.templateTypeList=list;
        vm.template.templateType = '';
      },function (error) {
      });
    }


    function loadAll() {
      if (vm.template.templateType == null || vm.template.templateType == ""){
        vm.template.templateType = "ADMIN_DOWN";
      }
      DowntimePushService.queryAll().query(vm.template, onSuccess, onError)
    }

    function onSuccess(data, headers) {
      vm.templates = data.rows;
      vm.totalItems = data.total;
    }

    function onError(error) {
    }

    function search() {
      //每次搜索的时候把page设为 1
      vm.template.page = vm.page = 1;
      vm.template.pagesize = vm.itemsPerPage;
      loadAll();
    };

    function deleteTemp(id){
      SweetAlert.confirm($filter('T')("plugin.deleteConfirm"), {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if(p){
          if(id){
            DowntimePushService.deleteTemp().query({templateId: id}, onSuccessForDelete, onErrorForDelete)
          }
        }
      });
    }

    function onSuccessForDelete(data, headers) {
      if(data.code=='succ'){
        loadAll();
      }
    }

    function onErrorForDelete(data, headers) {
      if(data.code!='succ'){
        SweetAlert.error('error');
      }
    }

    function pushAll(templateId) {
      SweetAlert.confirm($filter('T')('distribution.pushAllMessage'),{title:$filter('T')("btnTypeName.prompt")}).then(function(p){
        if(p){
          DowntimePushService.pushAll(templateId).then(function(response){
            if(response.success){
              SweetAlert.success($filter('T')("title.successfulOperation"),{title:$filter('T')("btnTypeName.prompt")});
            }
          })
        }
      })
    }

    function reset() {
      vm.template.templateName = '';
      vm.template.templateCode = '';
      vm.template.templateType = '';
      vm.template.productName = '';
    }


    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      vm.template.page = vm.page;
      vm.template.pagesize = vm.itemsPerPage;
      loadAll();
    };
  }
})();

(function () {
  'use strict';

  angular.module("hmapFront").controller("AddDowntimePushController", AddDowntimePushController);

  AddDowntimePushController.$inject = ['$state','SweetAlert','$uibModalInstance','DowntimePushService','$filter','$scope','PromptService','toastrConfig','toastr'];

  function AddDowntimePushController($state,SweetAlert,$uibModalInstance,DowntimePushService,$filter,$scope, PromptService,toastrConfig,toastr){
    var vm = this;
    vm.isSending=false;
    vm.template={};
    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.clear = clear;
    vm.localeSure = localeSure;
    vm.add = add;

    vm.intData = intData;
    intData();
    // langs
    var langs = [];
    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#templateContentBtn").attr("disabled", false);
        $("#descriptionBtn").attr("disabled", false);
        $("#templateNameBtn").attr("disabled", false);
        $("#linkAddressBtn").attr("disabled", false);
      });
    }
    initLangs();

    $scope.$on('handleSelectedParent', function() {
      vm.template.productId = DowntimePushService.selectedParent.productId;
      vm.template.productName = DowntimePushService.selectedParent.productName;
    });

    function add() {
      vm.template.templateCode = vm.template.templateType + new Date().getTime();
      DowntimePushService.submitInfo().save(vm.template,onSuccess,onError);
    };

    function onSuccess(data, headers) {
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }else{
        toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
      }
      $uibModalInstance.close();
    }

    function onError(error) {
      vm.isSending=true;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.template.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }


    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.template.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.template[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.template.__tls = __tls;
    }

    function intData() {
      DowntimePushService.getByCode().query({code:'SYS.TEMPLE_TYPE'},function (data) {
        var list = new Array();
        if (data.rows){
          for (var i= 0; i < data.rows.length; i++) {
            if (data.rows[i].value.indexOf("ADMIN_DOWN_TIME_") != -1) {
              list.push(data.rows[i]);
            }
          }
        }
        vm.templateTypeList=list;
      },function (error) {
      });
    }

  }
})();

/**
 * Created by Koma.Tshu on 2016/10/13.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .controller('ViewAppController', ViewAppController);

  ViewAppController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'DistributionService', 'paginationConstants','Hmapfe'];
  function ViewAppController($timeout, $scope, $stateParams, entity, DistributionService, paginationConstants,Hmapfe) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.appVerion = entity;
    vm.getApp = getApp;
    vm.getAppVersion = getAppVersion;
    vm.getApp(vm.appVerion);
    vm.getAppVersion(vm.page, vm.itemsPerPage);
    function getApp() {
      if (vm.appVerion != null) {
        Hmapfe.log("handApp:" + vm.appVerion.appId);
        DistributionService.getApp().query(vm.appVerion, onGetAppSuccess, onError);
      }
    }

    function getAppVersion(page, pageSize) {
      if (vm.appVerion != null) {
        Hmapfe.log("handApp:" + vm.appVerion.appId);
        DistributionService.getAppVersion(page, pageSize).query(vm.appVerion, onGetAppVersionSuccess, onError);
      }
    }

    function onGetAppSuccess(data) {
      Hmapfe.log("appData:"+ angular.toJson(data.rows));
      vm.app = data.rows[0];
    }

    function onGetAppVersionSuccess(data) {
      Hmapfe.log("appVersion data:"+ angular.toJson(data.rows));
      vm.appVersions = data.rows;
      vm.totalItems = data.total;
    }

    vm.downLoadApp = function(fileUrl,appVersion){
      window.location.href=fileUrl;
      Hmapfe.log("appVersion::"+appVersion.downloadNum);
      DistributionService.viewEditDownloadNum().query(appVersion,onDownloadNumSuccess,onError);
    };

    function onDownloadNumSuccess(data){
      if(data.success){
        Hmapfe.log("editDownloadNum success!");
      }
    }

    function onError(error) {
      Hmapfe.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      Hmapfe.log('Page changed to: ' + vm.page);
      vm.getAppVersion(vm.appVerion, vm.page, vm.itemsPerPage);
    }
  }
})();

/**
 * Created by Koma.Tshu on 2016/10/13.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .controller('DownloadAppController', DownloadAppController);

  DownloadAppController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'DistributionService', 'Hmapfe'];
  function DownloadAppController($timeout, $scope, $stateParams, entity, DistributionService, Hmapfe) {
    var vm = this;
    vm.downloadApp = entity;
    vm.downLoad = downLoad;
    vm.getAppByRandomName = getAppByRandomName;
    vm.getAppByRandomName(vm.downloadApp);

    function getAppByRandomName(appVersion) {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) {
        appVersion.appPlatform = 'Android';
      }
      else if (isIOS) {
        appVersion.appPlatform = 'iOS';
      }
      else {
        appVersion.appPlatform = 'Android';
      }
      if (appVersion != null) {
        Hmapfe.log("appVersion:" + appVersion.randomCode);
        Hmapfe.log("appPlatform:" + appVersion.appPlatform);
        DistributionService.getAppByRandomName().query(appVersion, onGetAppByVersionIdSuccess, onError);
      }
    }

    function onGetAppByVersionIdSuccess(data) {
      vm.downloadApp = data.rows[0];
      Hmapfe.log("downloadApp data:" + angular.toJson(vm.downloadApp));
    }

    function downLoad() {
      Hmapfe.log("download:" + vm.downloadApp.appFile);
      vm.downloadApp.id=vm.downloadApp.lastestVersionId;
      DistributionService.editDownloadNum().query(vm.downloadApp, onDownloadNumSuccess, onError);
      var installHref;
      if(vm.downloadApp.appPlatform=='iOS'){
        installHref= "itms-services://?action=download-manifest&url="+vm.downloadApp.plistUrl;
      }
      else{
        installHref = vm.downloadApp.downloadUrl;
      }
      window.location.href =installHref;
    };

    function onDownloadNumSuccess(data) {
      if (data.success) {
        Hmapfe.log("editDownloadNum success!");
      }
    }

    function onError(error) {
      Hmapfe.log('error');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('distribution', {
        parent: 'app',
        url: "/distribution",
        views: {
          'body': {
            templateUrl: "app/distribution/distribution.html",
            controller: 'DistributionController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {};
            }
          ]
        }
      })
      .state('distribution.upload', {
        parent: 'app',
        url: '/distribution/upload',
        views: {
          'body': {
            templateUrl: 'app/distribution/distribution-upload.html',
            controller: 'DistributionUploadController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              appId: null
            };
          }
        }
      })
      .state('distribution.add', {
        parent: 'app',
        url: '/distribution/add',
        views: {
          'body': {
            templateUrl: 'app/distribution/distribution-detail.html',
            controller: 'DistributionDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              appId: null
            };
          }
        }
      })
      .state('distribution.edit', {
        parent: 'app',
        url: '/distribution/:appId',
        views: {
          'body': {
            templateUrl: 'app/distribution/distribution-detail.html',
            controller: 'DistributionDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            return {
              appId: $stateParams.appId
            };
          }
        }
      })
      .state('downloadApp', {
        //parent: 'app',
        url: "/downloadApp/:randomCode",
        views: {
          'content@': {
            templateUrl: "app/distribution/downloadApp.html",
            controller: 'DownloadAppController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                randomCode:$stateParams.randomCode
              };
            }
          ]
        }
      })
      .state('viewApp', {
        parent: 'app',
        url: "/viewApp/{appId}",
        views: {
          'body': {
            templateUrl: "app/distribution/viewApp.html",
            controller: 'ViewAppController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                appId: $stateParams.appId
              };
            }
          ]
        }
      })
      .state('viewApp.addAppVersion', {
        parent: 'viewApp',
        url: '/addAppVersion',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          console.log("$uibModal:" + $uibModal);
          $uibModal.open({
            templateUrl: 'app/distribution/addAppVersion.html',
            controller: 'AddAppVersionController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  appId: $stateParams.appId
                };
              }
            }
          }).result.then(function () {
              console.log("viewApp go1");
              $state.go('viewApp', null, {reload: true});
            }, function () {
              console.log("viewApp go2");
              $state.go('viewApp');
            });
        }]
      })
  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('DistributionService', DistributionService);

  DistributionService.$inject = ['$resource', '$http'];

  function DistributionService ($resource,$http) {
    var uploadApp={};
    var service = {
      queryApps: queryApps,
      getApp:getApp,
      getAppVersion:getAppVersion,
      getAppByRandomName:getAppByRandomName,
      saveApp:saveApp,
      saveAppVersion:saveAppVersion,
      saveEditApp:saveEditApp,
      editDownloadNum:editDownloadNum,
      viewEditDownloadNum:viewEditDownloadNum
    };
    return service;

    //查询所有app信息
    function queryApps(page,pageSize){
      var resourceUrl ='/api/appDistribution/queryApps?page='+page+'&pageSize='+pageSize;
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    //根据appId查询头数据
    function getApp(){
      var resourceUrl ='/api/appDistribution/queryAppByAppId';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    //根据appId查询行数据
    function getAppVersion(page,pageSize){
      var resourceUrl ='/api/appDistribution/queryAppVersionByAppId?page='+page+'&pageSize='+pageSize;
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    //根据appVersionId查询下载数据
    function getAppByRandomName(){
      var resourceUrl ='/appDownload/queryAppByRandomName';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    //新增App保存
    function saveApp(){
      var resourceUrl ='/api/appDistribution/saveApp';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    //新增AppVersion保存
    function saveAppVersion(){
      var resourceUrl = '/api/appDistribution/saveAppVersion';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    //编辑App保存
    function saveEditApp(){
      var resourceUrl = '/api/appDistribution/updateApp';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    //下载页面增加下载次数
    function editDownloadNum(){
      var resourceUrl = '/appDownload/editDownloadNum';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    //查看页面增加下载次数
    function viewEditDownloadNum(){
      var resourceUrl = '/api/appDistribution/editDownloadNum';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }
  }
})();

(function () {
  'use strict';

  angular.module("hmapFront").controller("DistributionController", DistributionController);

  DistributionController.$inject = ['$state', 'DistributionService','entity', 'paginationConstants'];

  function DistributionController($state, DistributionService,entity, paginationConstants) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.searchApp = entity;

    vm.loadAll(vm.searchApp,vm.page,vm.itemsPerPage);

    vm.staff = [{"code":"Android","description":"Android"},{"code":"IOS","description":"IOS"}];

    function loadAll(searchApp,page,pageSize) {
      return DistributionService.queryApps(page,pageSize).query(searchApp,onSearchSuccess, onError);
    }

    function onSearchSuccess(data) {
      console.log('onSuccess');
      console.log(data);
      vm.apps = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      console.log('error');
    }

    vm.search = function(){
      vm.page = 1;
      vm.itemsPerPage = paginationConstants.itemsPerPage;
      console.log("appName:" + vm.searchApp.appName);
      loadAll(vm.searchApp,vm.page,vm.itemsPerPage);
    };

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      console.log('Page changed to: ' + vm.page);
      loadAll(vm.searchApp,vm.page,vm.itemsPerPage);
    }

    vm.clear = function () {
      vm.searchApp.appName = null;
      vm.searchApp.appTerrace = null;
    }
  }
})();

/**
 * Created by zhouzy on 2017/1/16 0016.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .controller('DistributionUploadController', DistributionUploadController);

  DistributionUploadController.$inject = ['$state','$timeout', '$scope', '$stateParams','$localStorage', 'entity', '$sessionStorage', 'Upload', 'BaseConfig','DistributionService','toastr','Hmapfe'];
  function DistributionUploadController($state,$timeout,$scope,$stateParams,$localStorage,entity, $sessionStorage, Upload, BaseConfig,DistributionService,toastr,Hmapfe) {
    var vm = this;
    vm.distributionApp = entity;
    vm.cancel = cancel;
    vm.saveAdd = saveAdd;
    vm.submitImgFile = submitImgFile;
    vm.doUpload=doUpload;
    vm.staff = [{"code":"Android","description":"Android"},{"code":"IOS","description":"IOS"}];
    vm.load = load;
    vm.load();
    function cancel() {
      $state.go("distribution");
    }

    //打开modal加载数据
    function load() {
      if (vm.distributionApp.appId) {
        DistributionService.getApp().query(vm.distributionApp,onLoadSuccess,onError);
      }
    }
  function doUpload(){
    Hmapfe.log("doUpload");
  }
    function onLoadSuccess(data){
      Hmapfe.log("edit data:"+angular.toJson(data));
      vm.distributionApp = data.rows[0];
    }

    //新增保存
    function saveAdd() {
      vm.isSaving = true;
      var url = window.location.href;
      console.log("url1:"+url);
      var index = url.indexOf("#");
      var result = url.substr(0,index);
      vm.distributionApp.downLoadUrl = result+"#/downloadApp/";
      //vm.distributionApp.downLoadUrl = "http://10.211.97.177:3000/#/downloadApp/";
      console.log("url2:"+vm.distributionApp.downLoadUrl);
      DistributionService.saveApp().query(vm.distributionApp,onSaveSuccess,onError);
    }

    function onSaveSuccess(data){
      console.log("resultData:" + angular.toJson(data));
      if (data.success) {
        toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
        $state.go("distribution");
        vm.isSaving = false;
      }
    }
    //图片上传
    vm.icoFile = "";
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitImgFile() {
      uploadImg(vm.icoFile);
      if (vm.icoFile != null && vm.icoFile != undefined && vm.icoFile != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    }

    //应用上传
    vm.varMayApp = true;
    vm.varMaysApp = false;
    vm.uploadReturn = '';
    vm.progressShow = false;
    vm.progressPercentage = 0;
    vm.uploadApp = function (file) {
      vm.fileInfo = file;
      //获取文件大小
      vm.distributionApp.appSize = (file.size/1024/1024).toFixed(1)+'MB';
      console.log("file.name:"+vm.distributionApp.appSize );
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/appUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        vm.progressShow = true;
        //进度条
        vm.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.distributionApp = data.rows[0];
        vm.distributionApp.appFile = data.rows[0].objectUrl;
        vm.distributionApp.appSize = (file.size/1024/1024).toFixed(1)+'MB';
        if (data.rows.length > 0) {
          vm.varMayApp = false;
          vm.varMaysApp = true;
        } else {
          vm.varMayApp = true;
          vm.varMaysApp = false;
        }
        vm.uploadReturn = data;
        vm.progressShow = false;
        toastr.success($filter('T')("appEdition.AppUploadSuccess"),$filter('T')("title.infoTitle"));
        //文件上传成功，进入到明细页面
        DistributionService.uploadApp=vm.distributionApp;
        $state.go('distribution.add');
      }).error(function (data, status, headers, config) {
        //上传失败
        console.log('错误状态: ' + status);
      });
    };

    function onError(error) {
      console.log('error');
    }
  }
})();

/**
 * Created by Koma.Tshu on 2016/10/12.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .controller('DistributionDetailController', DistributionDetailController);

  DistributionDetailController.$inject = ['$filter','$state', '$timeout', '$scope', '$stateParams', '$localStorage', 'entity', '$sessionStorage', 'Upload', 'BaseConfig', 'DistributionService', 'toastr', 'Hmapfe'];
  function DistributionDetailController($filter,$state, $timeout, $scope, $stateParams, $localStorage, entity, $sessionStorage, Upload, BaseConfig, DistributionService, toastr, Hmapfe) {
    Hmapfe.log("have came in AddAppController...");
    var vm = this;
    vm.distributionApp = entity;
    vm.cancel = cancel;
    vm.saveAdd = saveAdd;
    vm.submitImgFile = submitImgFile;
    vm.staff = [{"code": "Android", "description": "Android"}, {"code": "IOS", "description": "IOS"}];
    vm.load = load;
    vm.load();

    function cancel() {
      $state.go("distribution");
    }

    //打开modal加载数据
    function load() {
      if (vm.distributionApp.appId) {
        DistributionService.getApp().query(vm.distributionApp, onLoadSuccess, onError);
      } else {
        vm.distributionApp = DistributionService.uploadApp;
      }
    }

    function onLoadSuccess(data) {
      Hmapfe.log("edit data:" + angular.toJson(data));
      vm.distributionApp = data.rows[0];
    }

    //新增保存
    function saveAdd() {
      vm.isSaving = true;
      var url = window.location.href;
      console.log("url1:" + url);
      var index = url.indexOf("#");
      var result = url.substr(0, index);
      vm.distributionApp.downLoadUrl = result + "#/downloadApp/";
      //vm.distributionApp.downLoadUrl = "http://10.211.97.177:3000/#/downloadApp/";
      console.log("url2:" + vm.distributionApp.downLoadUrl);
      DistributionService.saveApp().query(vm.distributionApp, onSaveSuccess, onError);
    }

    function onSaveSuccess(data) {
      console.log("resultData:" + angular.toJson(data));
      if (data.success) {
        toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
        $state.go("distribution");
        vm.isSaving = false;
      }
    }

    //图片上传
    vm.icoFile = "";
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitImgFile() {
      uploadImg(vm.icoFile);
      if (vm.icoFile != null && vm.icoFile != undefined && vm.icoFile != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    }

    function onError(error) {
      console.log('error');
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hmapFront')
    .controller('AddAppVersionController', AddAppVersionController);

  AddAppVersionController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$localStorage', 'entity', '$sessionStorage', 'Upload', 'BaseConfig', 'DistributionService','toastr','$filter'];
  function AddAppVersionController($timeout, $scope, $stateParams, $uibModalInstance, $localStorage, entity, $sessionStorage, Upload, BaseConfig, DistributionService,toastr,$filter) {
    var vm = this;
    vm.addAppVersion = entity;
    vm.clear = clear;
    vm.saveAddVersion = saveAddVersion;

    //应用上传
    vm.varMayAppVersion = true;
    vm.varMaysAppVersion = false;
    vm.uploadReturn = '';
    vm.versionProgressShow = false;
    vm.progressPercentage = 0;
    vm.uploadApp = function (file) {
      vm.fileInfo = file;
      //获取文件大小
      vm.addAppVersion.appSize = (file.size/1024/1024).toFixed(1)+'MB';
      console.log("file.name:"+vm.fileSize);
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/appUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        vm.versionProgressShow = true;
        //进度条
        vm.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + vm.progressPercentage + '% ' + evt.config.data.file.name);
      }).success(function (data, status, headers, config) {
        //上传成功
        console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.addAppVersion.appFile = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMayAppVersion = false;
          vm.varMaysAppVersion = true;
        } else {
          vm.varMayAppVersion = true;
          vm.varMaysAppVersion = false;
        }
        vm.uploadReturn = data;
        vm.versionProgressShow = false;
        toastr.success($filter('T')("appEdition.AppUploadSuccess"), $filter('T')("title.infoTitle"));
      }).error(function (data, status, headers, config) {
        //上传失败
        console.log('错误状态: ' + status);
      });
    };

    function saveAddVersion(){
      vm.isSaving = true;
      var url = window.location.href;
      console.log("url1:"+url);
      var index = url.indexOf("#");
      var result = url.substr(0,index);
      vm.addAppVersion.downLoadUrl = result+"#/downloadApp/";
      //vm.addAppVersion.downLoadUrl = "http://10.211.97.177:3000/#/downloadApp/";
      console.log("vm.addAppVersion:"+ vm.addAppVersion.appFile);
      DistributionService.saveAppVersion().query(vm.addAppVersion,onSaveVersionSuccess,onError);
    }

    function onSaveVersionSuccess(data){
      console.log("resultData:" + angular.toJson(data));
      if (data.success) {
        toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
        $uibModalInstance.close();
        vm.isSaving = false;
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function onError(){
      console.log("error");
    }
  }
})();

/**
 * Created by linghui.xie on 2022/02/09.
 */

 (function () {
  'use strict';

  angular.module('hmapFront')
    .controller('OatDeviceListController', OatDeviceListController);

  OatDeviceListController.$inject = ['deviceFirmwareService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

  function OatDeviceListController(deviceFirmwareService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
    
    var vm = this;
    vm.sku = entity;
    console.log(vm.sku)
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkSku = checkSku;
    vm.checkAllSku = checkAllSku;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetSku = resetSku;
    vm.deleteSku = deleteSku;
    vm.getSku = getSku;
    vm.initWidget = initWidget;

    vm.getSku();
    vm.initWidget();
    //get Sku
    function getSku() {
      // vm.skuName
      // vm.skuNumber
      return deviceFirmwareService.getSkuInfo(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        
        vm.skus = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search sku
    function search() {
      return deviceFirmwareService.getSearchSkuInfo(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        
        vm.skus = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //reset Sku
    function resetSku() {
      vm.sku.skuNumber = undefined;
      vm.sku.skuName = undefined;
    }

    //delete sku
    function deleteSku(sku) {
      SweetAlert.confirm(sku.skuNumber + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          var data = {
            groupId: vm.sku.groupId,
            skuId: sku.skuId
          }
          deviceFirmwareService.deleteSkus(data).then(function (response) {
            if (response.success) {
              vm.getSku();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      if(vm.sku.skuName||vm.sku.skuNumber){
        vm.search();
        return;
      }
      vm.getSku();
    }

    //check or unCheck check Sku
    function checkSku() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Sku
    function checkAllSku() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }

    function initWidget() {
      // timezones and gender
      MessageTemplateService.getByCode().query({code:'IOT.DVM_SKU_VEIL_FLAG'},function (data) {
        vm.veilFlag = data.rows;
      },function (error) {
      });
    }
  }
})();

/**
 * Created by linghui.xie on 2022/02/15.
 */

 (function () {
  'use strict';

  angular.module('hmapFront')
    .controller('OatDeviceFirmwareListController', OatDeviceFirmwareListController);

  OatDeviceFirmwareListController.$inject = ['deviceFirmwareService', 'paginationConstants', 'entity', 'toastr', 'toastrConfig', 'SweetAlert', '$filter'];

  function OatDeviceFirmwareListController(deviceFirmwareService, paginationConstants, entity, toastr, toastrConfig, SweetAlert, $filter) {
    
    var vm = this;
    vm.sku = entity;
    console.log(vm.sku)
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetSku = resetSku;
    vm.deleteSku = deleteSku;
    vm.getSku = getSku;
    vm.changePublic=changePublic;

    vm.getSku();

    function getSku() {
      return deviceFirmwareService.getDeviceFirmwareList(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        // console.log(data);
        vm.firmwareList = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    // 搜索
    function search() {
      if ((vm.sku.componentNumber === '' || vm.sku.componentNumber == null || vm.sku.componentNumber == undefined) && (vm.sku.partNumber === '' || vm.sku.partNumber == null || vm.sku.partNumber == undefined)) {
        // 当搜索项为空的时候，获取列表数据
        vm.getSku();
        return false;
      }
      vm.page = 1; // 默认为1
      return deviceFirmwareService.queryLatestFirmwareByNumber(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        
        vm.firmwareList = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    // 重置
    function resetSku() {
      vm.sku.componentNumber = undefined;
      vm.sku.partNumber = undefined;
    }

    // 删除固件
    function deleteSku(oat_device) {
      console.log(oat_device)
      if (oat_device.isPublic=='Y') {
        toastr.error('当前固件被作为公共通知使用，暂时无法删除');
        return false;
      }
      SweetAlert.confirm(oat_device.componentName + $filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          // oat_device.firmwareId
          // /api/module/ota/firmware/delete/{firmwareId}
          console.log('删除')
          deviceFirmwareService.deleteFirmwareDvm(oat_device.firmwareId).then(function (response) {
            if (response.success) {
              vm.getSku();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    // 公共通知
    function changePublic(template) {
      console.log(123);
      SweetAlert.confirm($filter('T')("firmware.isChangePublic"), {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if(p){
          // /api/dvm/public/{firmwareId}
          deviceFirmwareService.changePublicNotice(template.firmwareId).then(function (data) {
            if (data.success === true){
              $('#notifyPublicBtn'+template.firmwareId).attr('disabled',true);
              vm.getSku()
            }
          });
        }
      });
    }

    function pageChanged() {
      vm.search();
    }

    angular.extend(toastrConfig, {
      preventDuplicates: false
    });

  }
})();

/**
 * Created by linghui.xie on 2022/02/15.
 */

 (function () {
  'use strict';

  angular.module('hmapFront')
    .controller('LookDeviceFirmwareListController', LookDeviceFirmwareListController);

  LookDeviceFirmwareListController.$inject = ['deviceFirmwareService', 'paginationConstants', 'entity', 'SweetAlert', '$filter'];

  function LookDeviceFirmwareListController(deviceFirmwareService, paginationConstants, entity, SweetAlert, $filter) {
    
    var vm = this;
    vm.sku = entity;
    console.log(vm.sku)
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetSku = resetSku;
    vm.getSku = getSku;
    vm.changePublic=changePublic;

    vm.getSku();

    function getSku() {
      return deviceFirmwareService.queryFirmwareByNumber(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        
        vm.firmwareList = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    // 搜索
    function search() {
      vm.getSku();
    }

    // 重置
    function resetSku() {
      vm.sku.componentNumber = undefined;
      vm.sku.partNumber = undefined;
    }

    // 公共通知
    function changePublic(template) {
      SweetAlert.confirm($filter('T')("firmware.isChangePublic"), {title: $filter('T')("plugin.deletePrompt")}).then(function (p) {
        if(p){
          // /api/dvm/public/{firmwareId}
          deviceFirmwareService.changePublicNotice(template.firmwareId).then(function (data) {
            if (data.success === true){
              $('#historyNotifyPublicBtn'+template.firmwareId).attr('disabled',true);
              vm.getSku()
            }
          });
        }
      });
    }

    function pageChanged() {
      vm.getSku();
    }

  }
})();

/**
 * Created by linghui.xie on 2022/02/07.
 */

 (function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('deviceFirmware', {
        parent: 'app',
        url: "/deviceFirmware",
        views: {
          'body': {
            templateUrl: "app/deviceFirmware/deviceFirmware.html",
            controller: 'DeviceFirmwareController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            return {
            };
          }
        }
      })
      .state('deviceFirmware.add', {
        parent: 'deviceFirmware',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/deviceFirmware/addDeviceFirmware.html',
            controller: 'AddDeviceFirmwareController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  productId: $stateParams.productId
                }
              }
            }
          }).result.then(function () {
            $state.go('deviceFirmware', null, {reload: true});
          }, function () {
            $state.go('deviceFirmware');
          });
        }]
      })
      .state('deviceFirmware.edit', {
        parent: 'deviceFirmware',
        url: "/edit/:groupId&:groupName&:note",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/deviceFirmware/addDeviceFirmware.html',
            controller: 'AddDeviceFirmwareController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  groupId: $stateParams.groupId,
                  groupName: $stateParams.groupName,
                  note: $stateParams.note
                }
              }
            }
          }).result.then(function () {
            $state.go('deviceFirmware', null, {reload: true});
          }, function () {
            $state.go('deviceFirmware');
          });
        }]
      })      
      .state('deviceFirmware.info', {
        parent: 'app',
        params: {
          header: ""
        },
        url: "/oatDeviceList/:groupId&:groupName",
        views: {
          'body': {
            templateUrl: "app/deviceFirmware/oatDeviceList.html",
            controller: 'OatDeviceListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                groupId: $stateParams.groupId,
                groupName: $stateParams.groupName
              };
            }
          ]
        }
      })
      .state('deviceFirmware.editSku', {
        parent: 'deviceFirmware.info',
        url: "/editSku/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/deviceFirmware/addOatDevice.html',
            controller: 'AddOatDeviceController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  groupId: $stateParams.groupId,
                  id: $stateParams.id
                }
              }
            }
          }).result.then(function () {
            $state.go('deviceFirmware.info', null, {reload: true});
          }, function () {
            $state.go('deviceFirmware.info');
          });
        }]
      })
      .state('deviceFirmware.addSku', {
        parent: 'deviceFirmware.info',
        url: "/addSku/:groupName&:groupId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/deviceFirmware/addOatDevice.html',
            controller: 'AddOatDeviceController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function() {
                return {
                  groupId: $stateParams.groupId,
                  groupName: $stateParams.groupName
                }
              }
            }
          }).result.then(function () {
            $state.go('deviceFirmware.info', null, {reload: true});
          }, function () {
            $state.go('deviceFirmware.info');
          });
        }]
      })
      .state('deviceFirmware.chooseSku', {
        parent: 'deviceFirmware.addSku',
        url: '/chooseSku',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/deviceFirmware/chooseSkuForDevice-dialog.html',
            controller: 'ChooseSkuForDeviceDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  type: $stateParams.type
                };
              }
            }
          }).result.then(function () {
            $state.go('deviceFirmware.addSku', null, {reload: true});
          }, function () {
            $state.go('deviceFirmware.addSku');
          });
        }]
      })
      .state('deviceFirmware.editChooseSku', {
        parent: 'deviceFirmware.editSku',
        url: '/editChooseSku',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/deviceFirmware/editChooseSkuForDevice-dialog.html',
            controller: 'ChooseSkuForDeviceDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  type: $stateParams.type
                };
              }
            }
          }).result.then(function () {
            $state.go('deviceFirmware.editSku', null, {reload: true});
          }, function () {
            $state.go('deviceFirmware.editSku');
          });
        }]
      })
      .state('deviceFirmware.firmwareList', {
        parent: 'app',
        params: {
          header: ""
        },
        url: "/oatDeviceFirmwareList/:groupId&:groupName",
        views: {
          'body': {
            templateUrl: "app/deviceFirmware/oatDeviceFirmwareList.html",
            controller: 'OatDeviceFirmwareListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                groupId: $stateParams.groupId,
                groupName: $stateParams.groupName
              };
            }
          ]
        }
      })
      .state('deviceFirmware.firmwareListAdd', {
        parent: 'deviceFirmware.firmwareList',
        url: '/add/:groupName&:groupId',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/deviceFirmware/addFirmware.html',
            controller: 'AddFirmwareController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  groupId: $stateParams.groupId,
                  groupName: $stateParams.groupName
                };
              }
            }
          }).result.then(function () {
            $state.go('deviceFirmware.firmwareList', null, {reload: true});
          }, function () {
            $state.go('deviceFirmware.firmwareList');
          });
        }]
      })
      .state('deviceFirmware.firmwareListEdit', {
        parent: 'deviceFirmware.firmwareList',
        url: '/edit/:id&:configurationFile&:groupId&:groupName',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/deviceFirmware/editFirmware.html',
            controller: 'AddFirmwareController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id,
                  groupId: $stateParams.groupId,
                  groupName: $stateParams.groupName,
                  configurationFile: $stateParams.configurationFile
                };
              }
            }
          }).result.then(function () {
            $state.go('deviceFirmware.firmwareList', null, {reload: true});
          }, function () {
            $state.go('deviceFirmware.firmwareList');
          });
        }]
      })
      .state('deviceFirmware.lookFirmwareList', {
        parent: 'app',
        params: {
          header: ""
        },
        url: "/oatDeviceFirmwareList/lookDeviceFirmwareList/:id&:groupName&:componentNumber&:partNumber",
        views: {
          'body': {
            templateUrl: "app/deviceFirmware/lookDeviceFirmwareList.html",
            controller: 'LookDeviceFirmwareListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
                id: $stateParams.id,
                componentNumber: $stateParams.componentNumber,
                partNumber: $stateParams.partNumber,
                groupName: $stateParams.groupName
              };
            }
          ]
        }
      })
  }
})();

/**
 * Created by linghui.xie on 2022/02/07.
 */


 (function () {
  'use strict';

  angular.module('hmapFront').factory('deviceFirmwareService', deviceFirmwareService);

  deviceFirmwareService.$inject = ['$http', '$rootScope', '$resource'];

  function deviceFirmwareService($http, $rootScope, $resource) {
    var selectedParent = {};
    return {
      getSku: getSku,
      deleteSkus: deleteSkus,
      addSku: addSku,
      searchSku: searchSku,
      addGroup: addGroup,
      deleteGroup: deleteGroup,
      deleteFirmware: deleteFirmware,
      deleteFirmwareDvm:deleteFirmwareDvm,
      updateSku: updateSku,
      updateGroup: updateGroup,
      addGroupFirmware: addGroupFirmware,
      editGroupFirmware: editGroupFirmware,
      getProduct: getProduct,
      getSkuInfo: getSkuInfo,
      getSearchSkuInfo: getSearchSkuInfo,
      selectAllSku: selectAllSku,
      queryFirmwareByNumber: queryFirmwareByNumber,
      queryLatestFirmwareByNumber: queryLatestFirmwareByNumber,
      getDeviceFirmwareList: getDeviceFirmwareList,
      changePublicNotice: changePublicNotice,
      shareParent: shareParent,
      shareEidtParent: shareEidtParent,
      selectedParent: selectedParent
    };

    function shareParent(selectedParent) {
      this.selectedParent = selectedParent;
      // console.log(this.selectedParent)
      $rootScope.$broadcast('handleSelectedParent');
    }

    function shareEidtParent(selectedEditParent) {
      this.selectedEditParent = selectedEditParent;
      $rootScope.$broadcast('handleSelectedEditParent');
    }

    function selectAllSku() {
      var resourceUrl = '/api/ctm/selectAllSku';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    //get product
    function getProduct(entity) {
      var resourceUrl = '/api/ctm/selectProduct?pageSize=-1';
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    //get sku
    function getSku(entity, page) {
      var resourceUrl = '/api/dvm/ota/group/queryAllGroups?page=' + page;
      return $http.get(resourceUrl).then(function (response) {
        return response.data;
      })
    }

    //get getSkuInfo
    function getSkuInfo(entity, page) {
      var resourceUrl = '/api/dvm/ota/group/querySku/' + entity.groupId;
      return $http({
        method:"POST",
        url:resourceUrl, 
        params:{skuName: entity.skuName, skuNumber: entity.skuNumber,page: page}, 
        headers: {'Content-Type': 'application/json;charset=utf-8'}
      }).then(function (response) {
        return response.data;
      })
    }

    //get getSkuInfo
    function queryFirmwareByNumber(entity, page) {
      var resourceUrl = '/api/dvm/ota/firmware/queryFirmwareByNumber/' + entity.id;
      return $http.post(resourceUrl, {componentNumber: entity.componentNumber, partNumber: entity.partNumber, page: page}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get searchSku
    function searchSku(entity, page) {
      page = 1
      var resourceUrl = '/api/dvm/ota/group/querySku?page=' + page;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //get getSkuInfo
    function getSearchSkuInfo(entity, page) {
      var resourceUrl = '/api/dvm/ota/group/searchSku/' + entity.groupId;
      return $http.post(resourceUrl, {skuName: entity.skuName, skuNumber: entity.skuNumber,page: page}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //get queryLatestFirmwareByNumber
    function queryLatestFirmwareByNumber(entity, page) {
      var data = {};
      if (entity.componentNumber) {
        data.componentNumber = entity.componentNumber;
      }
      if (entity.partNumber) {
        data.partNumber = entity.partNumber;
      }
      if (page) {
        data.page = page;
      } else {
        data.page = 1;
      }
      var resourceUrl = '/api/dvm/ota/firmware/queryLatestFirmwareByNumber/' + entity.groupId;
      return $http.post(resourceUrl, data, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    function getDeviceFirmwareList(entity, page) {
      var resourceUrl = '/api/dvm/ota/firmware/queryLatestFirmwareVersion/' + entity.groupId;
      return $http({
        method:"POST",
        url:resourceUrl,
        params:{ page:page },
        headers:{'Content-Type': 'application/json;charset=utf-8'}
      }).then(function (response) {
        return response.data;
      })
    }

    //delete deleteSkus
    function deleteSkus(entity) {
      var resourceUrl = '/api/dvm/ota/group/deleteSku';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //delete deleteGroup
    function deleteGroup(entity) {
      var resourceUrl = '/api/dvm/ota/group/delete/' + entity;
      return $http.post(resourceUrl, {}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //delete deleteFirmware
    function deleteFirmware(entity) {
      var resourceUrl = '/api/module/ota/firmware/delete/' + entity;
      return $http.post(resourceUrl, {}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

    //add addSku
    function addSku(entity) {
      var resourceUrl = '/api/dvm/ota/group/addSku';
      return $http.post(resourceUrl, {groupId: entity.groupId, skuId: entity.skuId}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //add addGroupFirmware
    function addGroupFirmware(entity) {
      var resourceUrl = '/api/dvm/ota/firmware/insert';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //changePublicNotice
    function changePublicNotice(entity) {
      var resourceUrl = '/api/dvm/public/'+entity;
      return $http.post(resourceUrl, {}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //edit editGroupFirmware
    function editGroupFirmware(entity) {
      var resourceUrl = '/api/dvm/ota/firmware/update?groupId='+entity.groupId+'&firmwareId='+entity.firmwareId+'&componentNumber='+entity.componentNumber+'&partNumber='+entity.partNumber+'&referenceSource='+entity.referenceSource;
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    
    //add addGroup
    function addGroup(entity) {
      var resourceUrl = '/api/dvm/ota/group/insert';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //delete firmware
    function deleteFirmwareDvm(entity) {
      var resourceUrl = '/api/dvm/ota/firmware/delete/' + entity;
      return $http.post(resourceUrl, {}, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }
    //update product
    function updateSku(entity) {
      // 娟娟之前确认没有更新sku
    }
    
    //update updateGroup
    function updateGroup(entity) {
      var resourceUrl = '/api/dvm/ota/group/update';
      return $http.post(resourceUrl, entity, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(function (response) {
        return response.data;
      })
    }

  }
})();

/**
 * Created by linghui.xie on 2022/02/07.
 */

 (function () {
  'use strict';

  angular.module('hmapFront')
    .controller('DeviceFirmwareController', DeviceFirmwareController);

  DeviceFirmwareController.$inject = ['deviceFirmwareService', 'paginationConstants', 'entity', 'SweetAlert', '$filter', 'MessageTemplateService'];

  function DeviceFirmwareController(deviceFirmwareService, paginationConstants, entity, SweetAlert, $filter, MessageTemplateService) {
    var vm = this;
    vm.sku = entity;
    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.checkSku = checkSku;
    vm.checkAllSku = checkAllSku;
    vm.pageChanged = pageChanged;
    vm.search = search;
    vm.resetSku = resetSku;
    vm.deleteSku = deleteSku;
    // vm.deleteSkus = deleteSkus;
    vm.getSku = getSku;
    vm.initWidget = initWidget;

    vm.getSku();
    vm.initWidget();

    //get Sku
    function getSku() {
      return deviceFirmwareService.getSku(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.skus = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //search sku
    function search() {      
      return deviceFirmwareService.searchSku(vm.sku, vm.page).then(function (data) {
        if(!data.rows){
          return;
        }
        vm.skus = data.rows;
        vm.totalItems = data.total;
        vm.pageSize = data.rows.length;
      })
    }

    //reset Sku
    function resetSku() {
      vm.sku.skuNumber = undefined;
      vm.sku.skuName = undefined;
    }

    //delete sku
    function deleteSku(group) {
      //$filter('T')("dvmProduct.deleteConfirm")
      SweetAlert.confirm(group.groupName + ' 是否确认被删除，若分组下有资源将一并删除', {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
        if(p){
          // group.groupId
          console.log('删除分组')
          deviceFirmwareService.deleteGroup(group.groupId).then(function (response) {
            if (response.success) {
              vm.getSku();
              SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
            } else {
              SweetAlert.error($filter('T')("title.operationFailed"), {title: $filter('T')("btnTypeName.prompt")});
            }
          })
        }
      });
    }

    //批量删除
    // function deleteSkus() {
    //   var isCheck = $(".chk_list").is(':checked');
    //   if(!isCheck) {
    //     SweetAlert.error($filter('T')("dvmProduct.selectOne"), {title: $filter('T')("btnTypeName.prompt")});
    //     return;
    //   }
    //   SweetAlert.confirm($filter('T')("dvmProduct.deleteConfirm"), {title: $filter('T')("btnTypeName.prompt")}).then(function (p) {
    //     if(p){
    //       var arrChk = $("input[name='chk_list']:checked");
    //       var skus = new Array();
    //       $(arrChk).each(function() {
    //         var sku = new Object();
    //         sku.skuId = this.value;
    //         skus.push(sku);
    //       });
    //       deviceFirmwareService.deleteSkus(skus).then(function (response) {
    //         document.getElementById("chk_all").checked = false;
    //         var items = document.getElementsByName("chk_list");
    //         for(var j = 0; j < items.length; j++){
    //           items[j].checked = false;
    //         }
    //         if (response.success) {
    //           vm.getSku();
    //           SweetAlert.success($filter('T')("title.successfulOperation"), {title: $filter('T')("btnTypeName.prompt")});
    //         }
    //       })
    //     }
    //   });
    // }

    //page changed
    function pageChanged() {
      angular.element("#chk_all").checked = false;
      if(vm.sku.skuNumber||vm.sku.skuName){
        vm.search();
        return;
      }
      vm.getSku();
    }

    //check or unCheck check Sku
    function checkSku() {
      var arrChk = $("input[name='chk_list']:checked");
      if(arrChk.length < vm.pageSize) {
        document.getElementById("chk_all").checked = false;
      } else if(arrChk.length === vm.pageSize) {
        document.getElementById("chk_all").checked = true;
      }
    }

    //check or unCheck all check Sku
    function checkAllSku() {
      var chk_all = $("#chk_all").is(':checked');
      var items = document.getElementsByName("chk_list");
      if(chk_all) {
        for(var i = 0; i < items.length; i++){
          items[i].checked = true;
        }
      } else {
        for(var j = 0; j < items.length; j++){
          items[j].checked = false;
        }
      }
    }

    function initWidget() {
      // timezones and gender
      MessageTemplateService.getByCode().query({code:'IOT.DVM_SKU_VEIL_FLAG'},function (data) {
        vm.veilFlag = data.rows;
      },function (error) {
      });
    }
  }
})();

/**
 * Created by linghui.xie on 2022/02/14.
 */
 (function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller("ChooseSkuForDeviceDialogController", ChooseSkuForDeviceDialogController);

  ChooseSkuForDeviceDialogController.$inject = ['deviceFirmwareService', 'paginationConstants', '$uibModalInstance','$state','toastr'];

  function ChooseSkuForDeviceDialogController(deviceFirmwareService,paginationConstants, $uibModalInstance,$state,toastr) {
    var vm = this;
    vm.sku = {};
    vm.sku.resources=[];
    vm.page = 1;
    vm.search=search;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;
    vm.isAllSelected = false;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.clear = clear;
    vm.saveEditParent =saveEditParent;
    vm.saveParent = saveParent;
    vm.selectParent = {};
    vm.selectedEditParent = {};

    vm.loadAll();

    function loadAll() {
      vm.sku.page = vm.page ;
      vm.sku.pagesize = vm.itemsPerPage ;
      deviceFirmwareService.selectAllSku().query(vm.sku, onSuccess, onError)
    }

    function search(){
      vm.sku.page = vm.page ;
      vm.sku.pagesize = vm.itemsPerPage ;
      deviceFirmwareService.selectAllSku().query({skuNumber:vm.sku.skuNumber,skuName:vm.sku.skuName,page:vm.page,pagesize:vm.itemsPerPage}, onSuccess, onError)
    }
    function onSuccess(data, headers) {
      vm.sku.resources = data.rows;
      vm.totalItems = data.total;
    }
    function onAddResourceSuccess(data) {
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $uibModalInstance.close(data);
    }

    function onError(error) {
      //console.log('error');

    }

    //save parent
    function saveParent() {
      deviceFirmwareService.shareParent(vm.selectParent);
      $uibModalInstance.dismiss('cancel');
    }

    function saveEditParent() {
      deviceFirmwareService.shareEidtParent(vm.selectedEditParent);
      $uibModalInstance.dismiss('cancel');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      //loadAll();
      search();
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
      // $state.go("roleGrantClient");
    }

    /*function save() {
      vm.sku.resources = [];
      angular.forEach(vm.resources, function (res) {
        if (res.addFlag === 'Y') {
          res.__status = 'add';
          vm.sku.resources.push(res);
        }
      });
      MessageTemplateService.createClient().saveOrUpdate(vm.function, onAddResourceSuccess, onError);

    }*/
  }
})();

/**
 * Created by linghui.xie on 2022/02/07.
 */


 (function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddOatDeviceController', AddOatDeviceController);

  AddOatDeviceController.$inject = ['deviceFirmwareService', '$state', '$uibModalInstance', 'toastr', 'entity', 'PromptService', '$filter', '$scope'];

  function AddOatDeviceController(deviceFirmwareService, $state, $uibModalInstance, toastr, entity, PromptService, $filter, $scope) {
    var vm = this;
    vm.sku = entity;
    console.log(entity)
    vm.template={};
    vm.template.id = vm.sku.id;
    vm.template.groupId = vm.sku.groupId;
    vm.skuCodeReadOnly = false;

    vm.clear = clear;
    vm.addSku = addSku;
    vm.localeSure = localeSure;
    vm.getProduct = getProduct;
    vm.showLocale = showLocale;
    vm.load = load;

    vm.getProduct();
    
    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
        $("#localeBtn_skuName").attr("disabled", false);
      });
    }
    initLangs();

    $scope.$on('handleSelectedParent', function() {
      vm.template.skuId = deviceFirmwareService.selectedParent.skuId;
      vm.template.skuNum =  deviceFirmwareService.selectedParent.skuNumber;
      vm.template.skuName = deviceFirmwareService.selectedParent.skuName;
    });

    setSkuReadOnly();
    function setSkuReadOnly(){
      if(vm.sku.skuId!=null){
        vm.skuCodeReadOnly = true;
      }
    }
    //get product
    function getProduct() {
      deviceFirmwareService.getProduct(vm.sku).then(function (result) {
        if(!result.rows){
          return;
        }
        vm.products = result.rows;
        vm.load();
      })
    }
    
    //init load
    function load() {
      
    }

    //submit  add sku
    function addSku() {
      console.log(vm.template);
      // 判断是编辑还是新增
      if(!vm.sku.id){
        return deviceFirmwareService.addSku(vm.template).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('deviceFirmware.info', null, {reload: true});
          }
        });
      } else {
        return deviceFirmwareService.updateSku(vm.template).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('deviceFirmware.info', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.template.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }

    function localeSure(name) {
      var __tls = vm.template.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.template[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.template.__tls = __tls;
    }

  }
})();

/**
 * Created by linghui.xie on 2022/02/07.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddFirmwareController', AddFirmwareController);

  AddFirmwareController.$inject = ['deviceFirmwareService', '$state', '$uibModalInstance', 'toastr', 'toastrConfig', 'entity', 'PromptService', '$filter', '$scope', '$localStorage', '$sessionStorage', 'Upload', 'BaseConfig'];

  function AddFirmwareController(deviceFirmwareService, $state, $uibModalInstance, toastr, toastrConfig, entity, PromptService, $filter, $scope, $localStorage, $sessionStorage, Upload, BaseConfig) {
    var vm = this;
    vm.sku = entity;
    console.log(vm.sku)
    vm.skuCodeReadOnly = false;
    vm.readonly = true;
    vm.config = {};
    vm.firmware = {
      groupId: vm.sku.groupId, // 分组id
      referenceSource: "residential", // 前端写死
      file: {}, // 读取json文件
      urls: [] // 上传资源包返回的数据
    };
    vm.btnStatus = false;
    vm.resourceSub = {
      groupId: vm.sku.groupId // 分组id
    };

    vm.clear = clear;
    vm.addFirmware = addFirmware;
    vm.upConfigFiles = upConfigFiles;
    vm.upResourceFile = upResourceFile;
    vm.verifyData = verifyData;


    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
        $("#localeBtn_skuName").attr("disabled", false);
      });
    }
    initLangs();

    setSkuReadOnly();
    function setSkuReadOnly() {
      if (vm.sku.id != null) {
        vm.firmware.file = JSON.parse(vm.sku.configurationFile);
        vm.firmware.firmwareId = vm.sku.id; // 编辑固件的id
        var json = vm.firmware.file;
        vm.firmware.componentNumber = json.loading.componentNumber; // 组件id
        vm.firmware.partNumber = json.loading.partNumber; // partID
        if (json && JSON.stringify(json) != "{}") {
          vm.config.firmwareVersion = json.firmwareVersion; // 固件版本
          vm.config.firmwareName = json.firmwareName; // 固件名称
          if (json.setting && JSON.stringify(json.setting) != "{}") {
            vm.config.forceUpdate = json.setting.forceUpdate; // 是否强制更新
            vm.config.subPackageSize = json.setting.subPackageSize; // 下载分包大小
          }
          if (json.loading && JSON.stringify(json.loading) != "{}") {
            vm.config.downloadLocation = json.loading.downloadLocation; // 下载到那里
            vm.config.downloadUrlType = json.loading.downloadUrlType; // 下载最大长度
            vm.config.isSilentDownload = json.loading.isSilentDownload; // 是否为静默下载
            vm.config.priority = json.loading.priority; // 升级包优先级
            vm.config.part = json.loading.partNumber + '-' + json.loading.partName; // part号+part名称
            vm.config.component = json.loading.componentNumber + '-' + json.loading.componentName; // 组件号+组件名称
          }
        }
      }
    }

    //submit 通过id判断是否是新增固件还是编辑
    function addFirmware() {
      console.log(vm.firmware);
      if (vm.firmware.file && JSON.stringify(vm.firmware.file) != "{}" && vm.firmware.urls.length > 0) {
        // 提交新增固件
        // addGroupFirmware
        if (vm.sku.id !== '' && vm.sku.id != undefined && vm.sku.id != null) {
          console.log('编辑')
          deviceFirmwareService.editGroupFirmware(vm.firmware).then(function (data) {
            console.log(data);
            if (data.success) {
              toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
              $uibModalInstance.close();
              return $state.go('deviceFirmware.firmwareList', null, { reload: true });
            }
          });
        } else {
          console.log('提交新增')
          deviceFirmwareService.addGroupFirmware(vm.firmware).then(function (data) {
            if (data.success) {
              toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
              $uibModalInstance.close();
              return $state.go('deviceFirmware.firmwareList', null, { reload: true });
            }
          });
        }

      } else {
        toastr.error('配置文件和资源包缺失或者有误，请您重新导入正确的配置文件和资源包');
        return false;
        // 娟娟核实过了，每次编辑的时候，导入资源包的文件都必须重新上传
      }
    }

    // 读取本地json文件
    function upConfigFiles() {
      var selectedFile = document.getElementById("configFiles").files[0]; // 获取读取的File对象
      var reader = new FileReader(); // 这里是核心！！！读取操作就是由它完成的。
      reader.readAsText(selectedFile, "UTF-8"); // UTF-8
      reader.onload = function () {
        console.log("读取结果：", this.result); // 当读取完成之后会回调这个函数，然后此时文件的内容存储到了result中。直接操作即可。
        var json = JSON.parse(this.result);

        if (json && JSON.stringify(json) != "{}") {
          vm.config.firmwareVersion = json.firmwareVersion; // 固件版本
          vm.config.firmwareName = json.firmwareName; // 固件名称
          if (json.setting && JSON.stringify(json.setting) != "{}") {
            vm.config.forceUpdate = json.setting.forceUpdate; // 是否强制更新
            vm.config.subPackageSize = json.setting.subPackageSize; // 下载分包大小
          }
          if (json.loading && JSON.stringify(json.loading) != "{}") {
            vm.config.downloadLocation = json.loading.downloadLocation; // 下载到那里
            vm.config.downloadUrlType = json.loading.downloadUrlType; // 下载最大长度
            vm.config.isSilentDownload = json.loading.isSilentDownload; // 是否为静默下载
            vm.config.priority = json.loading.priority; // 升级包优先级
            vm.config.part = json.loading.partNumber + '-' + json.loading.partName; // part号+part名称
            vm.config.component = json.loading.componentNumber + '-' + json.loading.componentName; // 组件号+组件名称
          }
        }
        vm.firmware.file = json;
        $scope.$digest();
        var file = $("#configFiles");
        file.after(file.clone().val(""));
        file.remove();
        // 版本号不能为空
        if (vm.firmware.file.firmwareVersion === '' || vm.firmware.file.firmwareVersion == null || vm.firmware.file.firmwareVersion == undefined) {
          // 提示缺失版本号，提示用户重新读取json文件
          toastr.error('JSON文件版本号缺失或者有误，请您重新导入正确的固件版本号');
          return false;
        }
        // 判断loading是否为空对象
        if (vm.firmware.file.setting && JSON.stringify(vm.firmware.file.setting) != "{}") {
          if (vm.firmware.file.setting.subPackageSize === '' || vm.firmware.file.setting.subPackageSize == null || vm.firmware.file.setting.subPackageSize == undefined) {
            toastr.error('JSON文件分包大小缺失或者有误，请您重新导入正确的分包大小');
            return false;
          }
        } else {
          toastr.error('setting字段不能为空');
          return false;
        }
        // 判断loading是否为空对象
        if (vm.firmware.file.loading && JSON.stringify(vm.firmware.file.loading) != "{}") {
          if (vm.firmware.file.loading.componentNumber === '' || vm.firmware.file.loading.componentNumber == null || vm.firmware.file.loading.componentNumber == undefined) {
            toastr.error('JSON文件组件号缺失或者有误，请您重新导入正确的组件号');
            return false;
          }
          if (vm.firmware.file.loading.partNumber === '' || vm.firmware.file.loading.partNumber == null || vm.firmware.file.loading.partNumber == undefined) {
            toastr.error('JSON文件part号缺失或者有误，请您重新导入正确的part号');
            return false;
          }
        } else {
          toastr.error('loading字段不能为空');
          return false;
        }


      }
    }

    function verifyData() {
      // subVersionSize
      // componentNumber
      // partNumber
      // version
      if (vm.firmware.file && JSON.stringify(vm.firmware.file) != "{}") {
        // 版本号不能为空
        if (vm.firmware.file.firmwareVersion === '' || vm.firmware.file.firmwareVersion == null || vm.firmware.file.firmwareVersion == undefined) {
          // 提示缺失版本号，提示用户重新读取json文件
          toastr.error('JSON文件版本号缺失或者有误，请您重新导入正确的固件版本号');
          return false;
        }
        // 判断loading是否为空对象
        if (vm.firmware.file.setting && JSON.stringify(vm.firmware.file.setting) != "{}") {
          if (vm.firmware.file.setting.subPackageSize === '' || vm.firmware.file.setting.subPackageSize == null || vm.firmware.file.setting.subPackageSize == undefined) {
            toastr.error('JSON文件分包大小缺失或者有误，请您重新导入正确的分包大小');
            return false;
          }
        } else {
          toastr.error('setting字段不能为空');
          return false;
        }
        // 判断loading是否为空对象
        if (vm.firmware.file.loading && JSON.stringify(vm.firmware.file.loading) != "{}") {
          if (vm.firmware.file.loading.componentNumber === '' || vm.firmware.file.loading.componentNumber == null || vm.firmware.file.loading.componentNumber == undefined) {
            toastr.error('JSON文件组件号缺失或者有误，请您重新导入正确的组件号');
            return false;
          }
          if (vm.firmware.file.loading.partNumber === '' || vm.firmware.file.loading.partNumber == null || vm.firmware.file.loading.partNumber == undefined) {
            toastr.error('JSON文件part号缺失或者有误，请您重新导入正确的part号');
            return false;
          }
        } else {
          toastr.error('loading字段不能为空');
          return false;
        }

        vm.resourceSub.subVersionSize = vm.firmware.file.setting.subPackageSize; // 分包大小
        vm.resourceSub.version = vm.firmware.file.firmwareVersion; // 固件版本
        vm.resourceSub.componentNumber = vm.firmware.file.loading.componentNumber; // 组件号
        vm.resourceSub.partNumber = vm.firmware.file.loading.partNumber; // part号
        console.log(vm.resourceSub);

        // 触发文件上传
        angular.element("#resourceFile").click();
        // return $("#resourceFile").click();
      } else {
        toastr.error('JSON文件数据不能为空');
      }
    }

    // 上传资源文件 
    function upResourceFile() {
      var resourceFile = document.getElementById("resourceFile").files[0];//获取读取的File对象
      vm.resourceSub.file = resourceFile;
      console.log(vm.resourceSub)
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        // 上传固件包
        url: BaseConfig.url + '/api/dvm/ota/firmware/upload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        data: vm.resourceSub
      }).success(function (data, status, headers, config) {
        // vm.picurl=data.rows[0].pictureUrl;
        // $state.go('legwork', null, {reload: true});
        // console.log(data);
        if (data.success) {
          vm.firmware.urls = data.rows;
          vm.btnStatus = true;
          toastr.success('资源文件导入成功');
        } else {
          // 上传失败设置为空
          vm.firmware.urls = [];
          toastr.error('资源文件导入失败');
        }
        // console.log('上传后拿到的内容是：'+angular.toJson(data));
        // console.log("成功上传：");
      })
      $scope.$digest();
      var file = $("#resourceFile");
      file.after(file.clone().val(""));
      file.remove();
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
    angular.extend(toastrConfig, {
      preventDuplicates: false
    });
  }
})();

/**
 * Created by linghui.xie on 2022/02/07.
 */


 (function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddDeviceFirmwareController', AddDeviceFirmwareController);

  AddDeviceFirmwareController.$inject = ['deviceFirmwareService', '$state', '$uibModalInstance', 'toastr', 'toastrConfig','entity', 'PromptService', '$filter'];

  function AddDeviceFirmwareController(deviceFirmwareService, $state, $uibModalInstance, toastr,toastrConfig, entity, PromptService, $filter) {
    var vm = this;
    vm.group = {};
    vm.data = {};
    if (entity.groupName) {
      vm.data.groupName = entity.groupName;
    }
    if (entity.note) {
      vm.data.note = entity.note;
    }
    vm.group = entity;

    vm.clear = clear;
    vm.addSku = addSku;

    
    // langs
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#localeBtn").attr("disabled", false);
        $("#localeBtn_skuName").attr("disabled", false);
      });
    }
    initLangs();

    //submit 新增产品分组
    function addSku() {
      if (vm.group.groupId) {
        console.log('编辑逻辑')
        vm.subData = JSON.parse(JSON.stringify(vm.group))
        if (vm.subData.groupName && vm.subData.groupName == vm.data.groupName) {
          // 表示groupName有值的同时，并且没有发生改变
          delete vm.subData.groupName;
        }
        if (vm.subData.note && vm.subData.note == vm.data.note) {
          // 表示note有值的同时，并且没有发生改变
          delete vm.subData.note;
        }
        deviceFirmwareService.updateGroup(vm.subData).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('deviceFirmware', null, {reload: true});
          }
        });
      } else {
        // 新增 addGroup
        deviceFirmwareService.addGroup(vm.group).then(function (data) {
          if (data.success) {
            toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
            $uibModalInstance.close();
            return $state.go('deviceFirmware', null, {reload: true});
          }
        });
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
    angular.extend(toastrConfig, {
      preventDuplicates: false,
    });
  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('device', {
        parent: 'app',
        url: "/device",
        views: {
          'body': {
            templateUrl: "app/device/device.html",
            controller: 'DeviceController',
            controllerAs: 'vm'
          }
        }
      }).state('device.detail', {
        parent: 'app',
        url: "/device/:id",
        views: {
          'body': {
            templateUrl: "app/device/device-detail.html",
            controller: 'DeviceDetailController',
            controllerAs: 'vm'
          }
        }
      })
  }
})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('Device', Device);

  Device.$inject = ['$resource'];

  function Device ($resource) {
    var service = {
      selectByDeviceUser : selectByDeviceUser,
      updateByDeviceId : updateByDeviceId,
      getStatistic : getStatistic,
    };
    return service;

    function selectByDeviceUser(){
      var resourceUrl = '/api/device/query';
      return $resource(resourceUrl, {}, {
        'query': { method: 'GET',isArray: false},
        'get': {
          method: 'GET',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
            }
            return data;
          }
        },
        'update': { method:'PUT' }
      });
    };

    function updateByDeviceId(){
      var resourceUrl = '/api/device/update';
      return $resource(resourceUrl, {}, {
        'post': {
          method: 'POST',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
            }
            return data;
          }
        }
      });
    };

    function getStatistic(){
      var resourceUrl = '/api/device/statistic';
      return $resource(resourceUrl, {}, {
        'query': { method: 'GET',isArray: false}
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('DeviceController', DeviceController);
  DeviceController.$inject = ['$state','Device','paginationConstants'];
  /** @ngInject */
  function DeviceController($state, Device, paginationConstants) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.loadByName = loadByName;
    vm.transition = transition;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.foundByName="";
    vm.loadByName();
    vm.platform = [];
    vm.changeFlag = changeFlag;
    vm.labels = [];
    vm.series = ['android', 'ios'];
    vm.data =   [];
    vm.datasetOverride1 = [
        {
          borderWidth: 1,
          hoverBackgroundColor: '#23c6c8',
          hoverBorderColor: '#23c6c8',
          backgroundColor:'#1ab394',
          type: 'bar'
        },
        {

          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          type: 'bar'
        }
      ];
    vm.pielabels = [];
    vm.piedata = [];
    vm.pieoptions = { legend: { display: true } };
    vm.datasetOverride2 = {
      hoverBackgroundColor: ['#45b7cd', '#ff6384', '#ff8e72'],
      hoverBorderColor: ['#45b7cd', '#ff6384', '#ff8e72']
    };
    vm.colors= ['#1ab394', '#f8ac59'];
    vm.barOptions = {
      legend: {
        display: true,
        position:'top',
        fullWidth:true,
        labels: {
          fontColor: 'rgb(255, 99, 132)'
        }
      }
    };
    function changeFlag(deviceId){
      Device.updateByDeviceId().post({
        deviceId:deviceId
      }, updateSuccess, onError);
    };

    function loadByName(){
      Device.selectByDeviceUser().get({
        deviceUser:vm.foundByName
      }, onSuccess, onError);
      Device.getStatistic().query({},function(data,headers){
        vm.platform = data.rows[0].platform;
        var status = data.rows[0].status;
        var systems = data.rows[0].bars;
        vm.pielabels[0] = "正常";
        vm.piedata[0] = status.Y;
        vm.piedata[1] = status.N;
        vm.pielabels[1] = "禁用";
        var arr = [];
        for(var i=0;i<systems.length;i++){
          vm.labels[i]=systems[i].operationSystemVersion;
          arr[i]=[];
          for(var j=0;j<systems[i].barsList.length;j++){
            arr[i][j] = systems[i].barsList[j].value;
          }
        }
        vm.data = transform(arr);
      },onError);
    }

    //二维数组转置
    function transform(old){
      var arr = [];
      for (i=0;i<old[0].length;i++ ){
        arr[i]=[];
      }
      for(var i=0;i<old.length;i++){
        for(var j=0;j<old[i].length;j++){
          arr[j][i]=old[i][j];
        }
      }
      return arr;
    }
    function loadAll() {
      Device.selectByDeviceUser().query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      vm.devices = data.rows;
      vm.totalItems =  data.total;
    }
    function updateSuccess(data, headers) {
      console.log('updateSuccess');
      console.log(data);
      console.log(vm.devices)
      for(var i=0;i<vm.devices.length;i++){
        if(data.rows[0].deviceId == vm.devices[i].deviceId){
          vm.devices[i].deviceFlag = data.rows[0].deviceFlag;
          return;
        };
      }

    }
    function onError(error) {
      console.log('error');
    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      console.log('Page changed to: ' +vm.page);
      loadAll();
    };
  }
})();

/**
 * Created by zhouzy on 2016/11/28 0028.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('DeviceDetailController', DeviceDetailController);
  DeviceDetailController.$inject = ['$state','Device','paginationConstants'];
  /** @ngInject */
  function DeviceDetailController($state, Device, paginationConstants) {
    var vm = this;
  }
})();

/**
 * Created by Koma.Tshu on 2017/3/2.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('corpInfo', {
        parent: 'app',
        url: "/corpInfo",
        views: {
          'body': {
            templateUrl: "app/corpInfo/corpInfo.html",
            controller: 'CorpInfoController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {};
            }
          ]
        }
      })
  }
})();

/**
 * Created by zhouzy on 2016/11/10 0010.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('CorpInfoService', CorpInfo);

  CorpInfo.$inject = ['$resource'];

  function CorpInfo($resource) {
    var service = {
      queryCorpInfo : queryCorpInfo,
      saveCorpInfo : saveCorpInfo,
      updateCorpInfo : updateCorpInfo,
      generateCorp : generateCorp
    };
    return service;

    /**
     * 查询企业数据
     */
    function queryCorpInfo(){
      var resourceUrl ='/api/corpInfo/queryCorpInfo';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    /**
     * 保存企业数据
     */
    function saveCorpInfo(){
      var resourceUrl ='/api/corpInfo/saveCorpInfo';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    /**
     * 更新企业数据
     */
    function updateCorpInfo(){
      var resourceUrl ='/api/corpInfo/updateCorpInfo';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    /**
     *生成corpId,corpSecret
     */
    function generateCorp(){
      var resourceUrl ='/api/corpInfo/generateCorp';
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }
  }})();

/**
 * Created by Koma.Tshu on 2017/3/2.
 */
(function () {
  'use strict';

  angular.module("hmapFront").controller("CorpInfoController", CorpInfoController);

  CorpInfoController.$inject = ['$filter','CorpInfoService', '$localStorage', '$sessionStorage', 'Upload', 'BaseConfig', 'toastr', 'entity', '$log'];

  function CorpInfoController($filter,CorpInfoService, $localStorage, $sessionStorage, Upload, BaseConfig, toastr, entity, $log) {
    var vm = this;
    vm.addCorp = entity;
    vm.oldLogoFile = "assets/images/logo-header.png";
    vm.submitLogoFile = submitLogoFile;
    vm.changeLogoFile = changeLogoFile;
    vm.logoFile = "";
    vm.logoShow = true;
    vm.oldBootImgFile = "assets/images/logo-header.png";
    vm.submitBootImgFile = submitBootImgFile;
    vm.changeBootImgFile = changeBootImgFile;
    vm.bootImgFile = "";
    vm.bootImgShow = true;
    vm.saveCorpInfo = saveCorpInfo;
    vm.loadCorpInfo = loadCorpInfo;
    vm.generateCorp = generateCorp;

    //获取corpId部分显示与否
    vm.corpShow = false;
    //获取按钮显示与否
    vm.getCorpIdShow = false;
    //重置按钮显示与否
    vm.resetCorpIdShow = false;
    //企业名称是否只读
    vm.corpNameRO = false;

    /**
     * 初始化企业信息
     */
    vm.loadCorpInfo();
    function loadCorpInfo() {
      return CorpInfoService.queryCorpInfo().query(onQuerySuccess, onError);
    }

    /**
     * 企业logo上传
     */
    function changeLogoFile() {
      if (vm.oldLogoFile) {
        vm.oldLogoFile = vm.logoFile;
      }
    }

    function submitLogoFile() {
      if (vm.oldLogoFile != "assets/images/logo-header.png") {
        vm.logoFile = vm.oldLogoFile;
      }
      uploadLogoFile(vm.logoFile);
    }

    function uploadLogoFile(file) {
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data) {
        //上传成功
        $log.info("服务器返回的数据：", angular.toJson(data));
        vm.addCorp.corpLogoUrl = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.logoShow = false;
        } else {
          vm.logoShow = true;
        }
        toastr.success($filter('T')("uploadImg.uploadSuccess"),$filter('T')("title.infoTitle"));
      }).error(function (data, status, headers, config) {
        //上传失败
        $log.info('错误状态: ' + status);
      });
    }

    /**
     * 启动图上传
     */
    function changeBootImgFile() {
      if (vm.oldBootImgFile) {
        vm.oldBootImgFile = vm.bootImgFile;
      }
    }

    function submitBootImgFile() {
      if (vm.oldBootImgFile != "assets/images/logo-header.png") {
        vm.bootImgFile = vm.oldBootImgFile;
      }
      uploadBootImgFile(vm.bootImgFile);
    }

    function uploadBootImgFile(file) {
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data) {
        //上传成功
        $log.info("服务器返回的数据：", angular.toJson(data));
        vm.addCorp.bootImgUrl = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.bootImgShow = false;
        } else {
          vm.bootImgShow = true;
        }
        toastr.success($filter('T')("uploadImg.uploadSuccess"),$filter('T')("title.infoTitle"));
      }).error(function (data, status, headers, config) {
        //上传失败
        $log.info('错误状态: ' + status);
      });
    }

    /**
     * 保存企业数据
     */
    function saveCorpInfo() {
      vm.isSaving = true;
      if (vm.addCorp.id == null || vm.addCorp.id == "") {
        $log.info("save...");
        return CorpInfoService.saveCorpInfo().query(vm.addCorp, onSaveSuccess, onError);
      } else {
        return CorpInfoService.updateCorpInfo().query(vm.addCorp, onSaveSuccess, onError);
      }
    }

    /**
     * 查询成功方法
     */
    function onQuerySuccess(data) {
      $log.info('onQuerySuccess');
      $log.info(data.rows);
      if (data.rows.length > 0) {
        vm.addCorp = data.rows[0];
        vm.oldLogoFile = data.rows[0].corpLogoUrl;
        vm.oldBootImgFile = data.rows[0].bootImgUrl;
        vm.corpShow = true;
        vm.corpNameRO = true;
        if (data.rows[0].corpId == "0" && data.rows[0].corpSecret == 0) {
          vm.getCorpIdShow = true;
        } else {
          vm.resetCorpIdShow = true;
        }
      }
    }

    /**
     * 保存企业数据成功方法
     */
    function onSaveSuccess(data) {
      $log.info('onSaveSuccess');
      $log.info(data.rows);
      vm.addCorp = data.rows[0];
      vm.corpShow = true;
      vm.isSaving = false;
      vm.corpNameRO = true;
      vm.logoShow = true;
      vm.bootImgShow = true;
      if (data.rows[0].corpId == "0" && data.rows[0].corpSecret == 0) {
        vm.getCorpIdShow = true;
      } else {
        vm.resetCorpIdShow = true;
      }
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
    }

    /**
     * 获取/重置corpId,corpSecret
     */
    function generateCorp(num) {
      if (num == 1) {
        return CorpInfoService.generateCorp().query(vm.addCorp, onGenerateSuccess, onError);
      } else {
        swal({
            title: "是否确认重置?",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            closeOnConfirm: true,
            closeOnCancel: true
          },
          function (isConfirm) {
            if (isConfirm) {
              return CorpInfoService.generateCorp().query(vm.addCorp, onGenerateSuccess, onError);
            }
          });
      }
    }

    /**
     * 获取、重置corpId,corpSecret成功方法
     * @param data
     */
    function onGenerateSuccess(data) {
      $log.info("onGenerateSuccess");
      vm.addCorp = data.rows[0];
      vm.getCorpIdShow = false;
      vm.resetCorpIdShow = true;
    }

    /**
     * 失败方法
     */
    function onError(error) {
      $log.info('error');
    }
  }
})();

/**
 * Created by hand on 2016/12/22.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('contentList', {
        parent: 'app',
        url: "/contentList",
        views: {
          'body': {
            templateUrl: "app/contentList/contentList.html",
            controller: 'contentController',
            controllerAs: 'vm'
          }
        }
      })
  }

})();

/**
 * Created by hand on 2016/12/22.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('ContentService', ContentService);

  ContentService.$inject = ['$resource','$localStorage'];

  function ContentService($resource,$localStorage) {
    var service = {
      query: query,
    };
    return service;

    function query() {
      var resourceUrl = '/api/content/query';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }
  }
})();

/**
 * Created by hand on 2016/12/22.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('contentController', contentController);

  contentController.$inject = ['$state', 'paginationConstants','ContentService'];

  function contentController($state, paginationConstants,ContentService) {


    var vm = this;
    this.picker3 = {
      date: new Date()
    };
    this.picker4 = {
      date: new Date()
    };
    vm.page=1;
    vm.totalItems = null;

    vm.contents={};
    vm.isSearch=false;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.transition = transition;
    vm.loadAll=loadAll;
    vm.loadAll();
    vm.openCalendar=openCalendar;
    vm.openCalendarL=openCalendarL;

    function openCalendar (e, picker) {
      vm [picker].open = true;
    };
    function openCalendarL (e, picker) {
      vm [picker].open = true;
    };



    function loadAll (){
      ContentService.query().query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }


    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.contents= data.rows;
      console.log(vm.contents);
      console.log("12123:"+vm.contents[0].contentSubject);
      for(var i = 0;i<vm.contents.length;i++){
      //  if(vm.contents[i].contentSubject<0)
        if(vm.contents[0].contentSubject.len()>10){

        };
      }

      vm.totalItems =  data.total;
    }
    function onError(error) {
      //console.log('error');

    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll();
    };


  }
})();

/**
 * Created by zhouzy on 2016/11/11 0011.
 */
/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('TagDialogController', TagDialogController);

  TagDialogController.$inject = ['$filter','Contacts', 'paginationConstants', 'entity', '$uibModalInstance', '$state', '$scope', '$rootScope','$log','toastr'];

  function TagDialogController($filter,Contacts, paginationConstants, entity, $uibModalInstance, $state, $scope, $rootScope,$log,toastr) {
    var vm = this;
    vm.contactTag= entity;
    vm.saveTag=saveTag;
    vm.clear = clear;
    vm.getTag = getTag;
    vm.getTag();

    function saveTag(){
      Contacts.createOrUpdateTag().save(vm.contactTag, onSuccess,onError);
    }

    function getTag(){
      if(vm.contactTag.id != null){
        Contacts.getTagById().get(vm.contactTag,function(result){
          vm.contactTag = result.rows[0];
        });
      }

    }


    function onSuccess(data, headers) {

      vm.contactTag = data.rows[0];
      Contacts.newTag=vm.contactTag;
      $rootScope.$broadcast('handleAddNewTag');
      $uibModalInstance.dismiss('ok');
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
    }

    function onError(error) {
      $log.info('error');
    }
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('StaffImportController', StaffImportController);
  StaffImportController.$inject = ['$filter','Contacts', 'paginationConstants',  '$uibModalInstance', '$state', '$log', 'toastr', 'Hmapfe', 'BaseConfig', 'Upload', '$localStorage', '$sessionStorage'];
  function StaffImportController($filter,Contacts, paginationConstants,  $uibModalInstance, $state, $log, toastr, Hmapfe, BaseConfig, Upload, $localStorage, $sessionStorage) {
    var vm = this;
    vm.downloadPath = BaseConfig.url + '/common/staff/downloadStaff';
    vm.importStaff = importStaff;
    vm.clear = clear;

    function importStaff() {
      var excel = document.getElementById("excel").files[0];
      var fileName = excel.name;
      var port = fileName.lastIndexOf(".");
      var type = fileName.substring(port + 1);

      if (type == "xlsx") {
        upload(excel);
      } else {
        toastr.error($filter('T')("plugin.mustCorrectFormet"), $filter('T')("title.infoTitle"));
      }

    }


    function upload(file) {
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/staff/importStaff',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest'
        },
        //上传的文件
        data: {file: file}
      }).success(function (data, status, headers, config) {

        $uibModalInstance.close(data);
        toastr.success($filter('T')('title.importSuccess'),$filter('T')('title.confirmTitle'));
      }).error(function (data, status, headers, config) {
        toastr.error($filter('T')('title.importFail') + data.message,$filter('T')('title.confirmTitle'));
      });
    }


    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * Created by zhouzy on 2016/11/11 0011.
 */
/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/31 0031.
 */
/**
 * Created by zhouzy on 2016/8/28 0028.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('StaffDialogController', StaffDialogController);

  StaffDialogController.$inject = ['Contacts', 'paginationConstants', 'entity', '$uibModalInstance', '$state', '$scope', '$rootScope','$log','toastr','Hmapfe','$filter'];

  function StaffDialogController(Contacts, paginationConstants, entity, $uibModalInstance, $state, $scope, $rootScope,$log,toastr,Hmapfe,$filter) {
    var vm = this;
    vm.staff= entity;
    vm.loadStaffDetail=loadStaffDetail;
    vm.loadStaffDetail();
    vm.updateStaff = updateStaff;
    vm.deleteStaff = deleteStaff;
    vm.clear = clear;

    vm.empStatus = ["在职", "离职", "实习"];
    vm.genderId = [
      {code : "1", value : "男"},
      {code : "0", value : "女"}
    ]

    function loadStaffDetail(){
      if(vm.staff.accountNumber){
        var searObj={key:vm.staff.accountNumber};
        Contacts.getStaffDetail().query(searObj, function(result) {
          vm.staff = result.rows[0];
          console.log("====="+angular.toJson(vm.staff))
        });
      }
    }

    function updateStaff(){
      vm.isSaving = true;
      Contacts.updateStaffs().save([vm.staff], onUpdateSuccess, onError);
    }


    function deleteStaff(){
      var newStaff = [];
      newStaff.push(vm.staff);
      Contacts.deleteStaff().save(newStaff, onSuccess, onError);
    }

    function clear(){
      $uibModalInstance.dismiss('cancel');
    }

    function onSuccess(data, headers){
      toastr.success($filter('T')("title.deleteSuccess"),$filter('T')("title.infoTitle"));
      vm.isSaving = true;
      $uibModalInstance.close(data);
    }

    function onUpdateSuccess(data, headers){
      toastr.success($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      vm.isFlush = true;
      $uibModalInstance.close(data);
    }

    function onError(error) {
      toastr.error($filter('T')("title.saveSuccess"),$filter('T')("title.infoTitle"));
      $log.info('error');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('StaffAddController', StaffAddController);
  StaffAddController.$inject = ['$filter','Contacts', 'entity', '$state', '$scope', '$rootScope', '$log', 'toastr', '$uibModalInstance'];
  function StaffAddController($filter,Contacts, entity, $state, $scope, $rootScope, $log, toastr, $uibModalInstance) {
    var vm = this;
    vm.staff = entity;
    vm.saveStaff = saveStaff;
    vm.clear = clear;
    vm.empStatus = ["在职", "离职", "实习"];
    vm.genderId = [
      {code : "1", value : "男"},
      {code : "0", value : "女"}
    ]


    function saveStaff() {
      vm.isSaving = true;
      Contacts.createStaff().save([vm.staff], onSuccess, onError);
    }

    function onSuccess(data, headers) {
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      vm.isSaving = true;
      $uibModalInstance.close(data);
    }

    function onError(error) {
      toastr.error($filter('T')("title.saveFail") + data.message$+$filter('T')("title.infoTitle"));
      $log.info('error');
      vm.isSaving = false;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('DeptNewController', DeptNewController);

  DeptNewController.$inject = ['$filter','Contacts', 'paginationConstants', 'entity',  '$state', '$scope', '$rootScope','$log','toastr','Hmapfe'];

  function DeptNewController($filter,Contacts, paginationConstants, entity,  $state, $scope, $rootScope,$log,toastr,Hmapfe) {
    var vm = this;
    vm.dept= entity;
    vm.permissionData = [];
    vm.showData = {};
    vm.newDept = {};
    vm.flag = true;
    vm.getDeptManager = getDeptManager;
    vm.getDeptManager();

    vm.saveDept=saveDept;
    vm.clear = clear;



    function getDeptManager(){
      console.log("========"+angular.toJson(vm.dept.deptNumber)) ;
      if(vm.dept.deptNumber != null){
        Contacts.getDeptManager().get(vm.dept,function(result) {
          vm.dept = result.rows[0];
          vm.showData.dataValue = vm.dept.userName;
          vm.showData.dataId = vm.dept.accountNumber;
          vm.permissionData.push(vm.showData);
        });
      }else{
        vm.flag = false;
      }

    }


    function saveDept(){
      vm.newDept.deptName = vm.dept.name;
      vm.newDept.deptNumber = vm.dept.id;
      vm.newDept.parentDeptNumber = vm.dept.parentDeptNumber;
      if(vm.permissionData[0] != null){
        vm.newDept.manager = vm.permissionData[0].dataId;
      }

      console.log("======="+angular.toJson(vm.newDept));
      console.log("======="+angular.toJson(vm.dept));
      if(vm.newDept.deptNumber !=null){
        console.log("修改");
        Contacts.updateDepts().save(vm.newDept, onSuccess,onError);
      }else{
        console.log("新增");
        Contacts.createDepts().save(vm.newDept, onSuccess,onError);
      }
    }
    function onSuccess(data, headers) {
      //$rootScope.$broadcast('handleAddNewTag');
      toastr.success($filter('T')("title.successfulOperation"),$filter('T')("title.infoTitle"));
      $state.go("contacts");
    }

    function onError(error) {
      $log.info('error');
    }
    function clear() {
      $state.go("contacts");
    }

    function onManagerSuccess(data, headers) {
      console.log("vm.dept: ==="+angular.toJson(data.rows));
      //vm.dept = data.rows;
      console.log("vm.dept: ==="+angular.toJson(vm.dept));
      $log.info('success');
    }


  }
})();

/**
 * Created by zhouzy on 2016/11/10 0010.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('contacts', {
        parent: 'app',
        url: "/contacts",
        views: {
          'body': {
            templateUrl: "app/contacts/contacts.html",
            controller: 'ContactsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('contacts.tag', {
        parent: 'contacts',
        url: "/tag",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/contacts/tag-dialog.html',
            controller: 'TagDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  tagName: null
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
              //console.log("contacts.detail1");
            }, function () {
              $state.go('contacts');
              //console.log("contacts.detail2");
            });
        }]
      })

      .state('contacts.addDept', {
        parent: 'app',
        url: "/dept/add/:id",
        views: {
          'body': {
            templateUrl: "app/contacts/dept-new.html",
            controller: 'DeptNewController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  parentDeptNumber: $stateParams.id
                };
              }
            }
          }
        }
      })
      .state('contacts.editDept', {
        parent: 'app',
        url: "/dept/edit/:deptName&:deptNumber",
        views: {
          'body': {
            templateUrl: "app/contacts/dept-new.html",
            controller: 'DeptNewController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  deptName: $stateParams.deptName,
                  deptNumber: $stateParams.deptNumber
                };
              }
            }
          }
        }
      })
      .state('contacts.dialogStaff', {
        parent: 'contacts',
        url: "/contacts/staffEdit/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/contacts/staff-detail-dialog.html",
            controller: 'StaffDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  accountNumber: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
              //console.log("contacts.detail1");
            }, function () {
              $state.go('contacts');
              //console.log("contacts.detail2");
            });
        }]
      })
      .state('contacts.addStaff', {
        parent: 'contacts',
        url: "/contacts/staffAdd/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/contacts/staff-detail-add.html",
            controller: 'StaffAddController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  departmentId: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
              //console.log("contacts.detail1");
            }, function () {
              $state.go('contacts');
              //console.log("contacts.detail2");
            });
        }]
      })
      .state('contacts.new', {
        parent: 'contacts',
        url: "/new",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/sysConfig/sysConfig-dialog.html',
            controller: 'SysConfigDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: null,
                  configKey: null,
                  configValue: null,
                  configLevel: null,
                  enable: 'Y',
                  configDesc: null
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
            }, function () {
              $state.go('contacts');
            });
        }]
      })
      .state('contacts.importStaff', {
        parent: 'contacts',
        url: "/dept/import",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/contacts/staff-detail-import.html',
            controller: 'StaffImportController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  parentDeptNumber: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
              //console.log("contacts.detail1");
            }, function () {
              $state.go('contacts');
              //console.log("contacts.detail2");
            });
        }]
      });
  }
})();

/**
 * Created by zhouzy on 2016/11/10 0010.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('Contacts', Contacts);

  Contacts.$inject = ['$resource'];

  function Contacts($resource) {
    var newTag = {};
    var service = {
      findAllDepts: findAllDepts,
      createDepts:createDepts,
      updateDepts:updateDepts,
      createStaff:createStaff,
      getStaffDetail:getStaffDetail,
      findDeptStaff:findDeptStaff,
      createOrUpdateTag:createOrUpdate,
      contactListSearch:contactListSearch,
      contactStaffListSearch:contactStaffListSearch,
      contactStaffAndDeptListSearch:contactStaffAndDeptListSearch,
      getAllTags:getAllTags,
      lockTagOrNot:lockTagOrNot,
      deleteTag:deleteTag,
      getTagById:getTagById,
      findTagMemberByTagId:findTagMemberByTagId,
      insertTagMembers:insertTagMembers,
      deleteTagMember:deleteTagMember,
      deleteStaff:deleteStaff,
      getDeptManager:getDeptManager,
      updateStaffs:updateStaffs
    };
    return service;

    function findAllDepts() {
      var resourceUrl = '/api/dept/getAllDept';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }
    function createDepts() {
      var resourceUrl = '/api/dept/insertData';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }
    function updateDepts() {
      var resourceUrl = '/api/dept/updateData';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }
    function createStaff() {
      var resourceUrl = '/api/staff/insertData';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }
    function getStaffDetail() {
      var resourceUrl = '/api/staff/query';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }

    function findDeptStaff() {
      var resourceUrl = '/api/dept/getDeptStaff';
      return $resource(resourceUrl, {}, {
        'get': {method: 'POST'}
      });
    }
    //删除（改变enableFlag的转态值）
    function deleteStaff(){
      var resourceUrl = '/api/staff/updateEnableFlag';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function updateStaffs() {
      var resourceUrl = '/api/staff/updateData';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function createOrUpdate(){
      var resourceUrl = '/api/contactTag/createOrUpdate';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }
    function getAllTags(){
      var resourceUrl = '/api/contactTag/getAllTags';
      return $resource(resourceUrl, {}, {
        'get': {method: 'GET'}
      });
    }

    function lockTagOrNot(){
      var resourceUrl = '/api/contactTag/lockOrNot';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }
    function deleteTag(){
      var resourceUrl = '/api/contactTag/delete';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function getTagById(){
      var resourceUrl = '/api/contactTag/getTagById';
      return $resource(resourceUrl, {}, {
        'get': {method: 'POST'}
      });
    }

    function findTagMemberByTagId(){
      var resourceUrl = '/api/contactTagMember/findByTagId';
      return $resource(resourceUrl, {}, {
        'get': {method: 'POST'}
      });
    }

    function insertTagMembers(){
      var resourceUrl = '/api/contactTagMember/insert';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function deleteTagMember(){
      var resourceUrl = '/api/contactTagMember/deleteTagMember';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function contactListSearch(){
      var resourceUrl = '/api/contactList/search';
      return $resource(resourceUrl, {}, {
        'search': {method: 'POST'}
      });
    }

    function contactStaffListSearch(){
      var resourceUrl = '/api/contactList/searchStaff';
      return $resource(resourceUrl, {}, {
        'search': {method: 'POST'}
      });
    }

    function contactStaffAndDeptListSearch(){
      var resourceUrl = '/api/contactList/searchStaffAndDept';
      return $resource(resourceUrl, {}, {
        'search': {method: 'POST'}
      });
    }

    function getDeptManager(){
      var resourceUrl = '/api/dept/getDeptManager';
      return $resource(resourceUrl, {}, {
        'get': {method: 'POST'}
      });
    }



  }

})();

/**
 * Created by zhouzy on 2016/11/10 0010.
 */
/**
 * Created by zhouzy on 2016/8/18 0018.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ContactsController', ContactsController);

  ContactsController.$inject = ['$filter','$state', 'Contacts', 'paginationConstants', '$log', '$scope', '$uibModal', 'Hmapfe', 'toastr', '$localStorage', 'BaseConfig', '$sessionStorage'];

  function ContactsController($filter,$state, Contacts, paginationConstants, $log, $scope, $uibModal, Hmapfe, toastr, $localStorage, BaseConfig, $sessionStorage) {
    var vm = this;
    vm.currentUserName = $sessionStorage.user.partyAccount;
    vm.page = 1;
    vm.isStaffShow = false;
    vm.isSpinnerShow = false;
    vm.isOrgShow = true;
    vm.isTagShow = false;
    vm.isChoiceDept = false;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.jsTreeData = [];
    vm.deptData = [];
    vm.dept = {};
    vm.treeConfig = {};
    vm.treeInstance = {};
    vm.currentDept = {};
    vm.checkedNodes = [];
    vm.allDepts = [];
    vm.allTags = [];
    vm.currentTag = {};
    vm.tagMembers = [];
    vm.staffs = [];
    vm.treeEventsObj = {};
    vm.loadAll = loadAll;
    vm.initData = initData;
    vm.getSelectedNode = getSelectedNode;
    vm.generateTreeData = generateTreeData;
    vm.selectOrg = selectOrg;
    vm.selectTag = selectTag;
    vm.getAllTags = getAllTags;
    vm.openTagModal = openTagModal;
    vm.updateTag = updateTag;
    vm.lockTag = lockTag;
    vm.deleteTag = deleteTag;
    vm.deleteTagMembers = deleteTagMembers;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.tagDetail = tagDetail;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.value = '';
    vm.loadAll();
    vm.getAllTags();
    vm.treeEventsObj = {
      activate_node: select
    };
    vm.exportPath = BaseConfig.url + '/common/staff/exportAllStaff';
    vm.deleteStaff = deleteStaff;


    function select(e, i) {
      vm.currentDept.deptNumber = i.node.id;
      vm.currentDept.deptName = i.node.text;
      loadDeptStaff();
    }

    function loadDeptStaff() {
      vm.jsTreeData = [];
      vm.isStaffShow = false;
      vm.isSpinnerShow = true;
      vm.dept.deptNumber = vm.currentDept.deptNumber;
      vm.isChoiceDept = true;
      vm.dept.page = vm.page;
      vm.dept.pagesize = vm.itemsPerPage;

      Contacts.findDeptStaff().get(vm.dept, onStaffSuccess, onError);
    }

    function loadAll() {
      Contacts.findAllDepts().query({}, onSuccess, onError);
    }

    function initData() {
      vm.treeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'dnd']
      };
    }

    function getSelectedNode() {
      vm.checkedNodes = vm.treeInstance.jstree(true).get_selected();
    }

    function generateTreeData() {
      vm.deptData = [];
      var root = {};
      //$log.info(menu);
      //root.id = 0;
      //root.parent = "#";
      //root.text = "企业组织架构";
      //root.state = {opened: true,selected:false};
      //vm.deptData.push(root);

      angular.forEach(vm.allDepts, function (dept) {
        if (dept.id == 1) {
          var root = {};
          root.id = dept.id;
          root.parent = "#";
          root.text = dept.name;
          root.state = {opened: true, selected: false};
          vm.deptData.push(root);
        }
        else {
          var treeNode = {};
          //$log.info(menu);
          treeNode.id = dept.id;
          treeNode.parent = dept.parentId;
          treeNode.text = dept.name;
          treeNode.state = {opened: false, selected: false};
          vm.deptData.push(treeNode);
        }
      });
      //初始化
      vm.currentDept.deptNumber = vm.deptData[0].id;
      vm.currentDept.deptName = vm.deptData[0].text;
      $localStorage.deptData = vm.deptData;
    }

    function onSuccess(data, headers) {
      vm.allDepts = data.rows;
      vm.generateTreeData();
      vm.jsTreeData = [];
      vm.initData();
      angular.copy(vm.deptData, vm.jsTreeData);
      vm.treeConfig.version++;

    }

    function onStaffSuccess(data, headers) {
      vm.staffs = data.rows;
      angular.forEach(vm.staffs, function (staff) {
        staff.checked = false;
      });
      vm.totalItems = data.total;
      vm.isStaffShow = true;
      vm.isSpinnerShow = false;
    }

    function onError(error) {
      toastr.error($filter('T')("title.operationFailed"),$filter('T')("title.infoTitle"));
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadDeptStaff();
    };

    function selectTag(tag) {
      if (tag != undefined && tag != null) {
        vm.currentTag = tag;
        findTagMembers(vm.currentTag);
      }
      vm.isOrgShow = false;
      vm.isTagShow = true;
    }

    function findTagMembers(obj) {
      Contacts.findTagMemberByTagId().get({tagId: obj.id}, function (result) {

        vm.tagMembers = result.rows;
        angular.forEach(vm.tagMembers, function (tagMember) {
          tagMember.checked = false;
        });

      });
    }


    function selectOrg() {
      vm.isOrgShow = true;
      vm.isTagShow = false;
      //getAllTags
    }

    $scope.$on('handleAddNewTag', function () {
      if (existsInArray(Contacts.newTag, vm.allTags)) {
        vm.allTags.push(Contacts.newTag);
      } else {
        vm.allTags.splice(getPosInArray(Contacts.newTag, vm.allTags), 1);
        vm.allTags.push(Contacts.newTag);
      }

    });


    function existsInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].id === obj.id)
          return false;
      }
      return true;
    }

    function getPosInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].id === obj.id)
          return i;
      }
      return 0;
    }


    function getAllTags() {
      Contacts.getAllTags().get({}, onTagsSuccess, onError);
    }

    function onTagsSuccess(data, headers) {
      vm.allTags = data.rows;
      vm.currentTag = data.rows[0];

      findTagMembers(vm.currentTag);
      $localStorage.allTags = vm.allTags;
    }

    function openTagModal() {
      var modalInstance = $uibModal.open({
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/contacts/tag-dialog.html',
        controller: 'TagDialogController',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              tagName: null
            };
          }
        }
      });
    };
    function updateTag(id) {
      console.log("000000id; " + id);
      var modalInstance = $uibModal.open({
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/contacts/tag-dialog.html',
        controller: 'TagDialogController',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              id: id
            };
          }
        }
      });
    }

    function lockTag(obj, status) {
      var newTag = {};
      angular.copy(obj, newTag);
      newTag.tagStatus = status;
      newTag.tagOwner = vm.currentUserName;
      Contacts.lockTagOrNot().save(newTag, onlockTagsSuccess, onLockError);
    }

    function deleteTag(id) {
      Contacts.deleteTag().save({id: id}, onDelTagsSuccess, onError);
      Hmapfe.log('deleteTag:' + id);
    }

    //选择的标签内容添加到数据表中
    $scope.$on('selectDataToTag', function (event, data) {
      var tagMembers = [];
      for (var i = 0; i < data.length; i++) {
        var tagMember = {};
        tagMember.tagId = vm.currentTag.id;
        tagMember.memberId = data[i].dataId;
        tagMember.memberType = data[i].dataType;
        tagMembers.push(tagMember);
      }
      Contacts.insertTagMembers().save(tagMembers, onTagMemberSuccess, onTagMemberError);

    });

    function deleteTagMembers() {
      var selectedMembers = [];
      angular.forEach(vm.tagMembers, function (tagMember) {
        if (tagMember.checked == true) {
          selectedMembers.push(tagMember);
        }
      });

      Contacts.deleteTagMember().save(selectedMembers, onDelTagMemberSuccess, onDelTagMemberError);
    }


    function tagDetail() {
      Hmapfe.log('tagDetail');
    }

    function deleteStaff() {
      var newStaff = [];
      angular.forEach(vm.staffs, function (staff) {
        if (staff.checked == true) {
          newStaff.push(staff);
        }

      });
      Contacts.deleteStaff().save(newStaff, onDeleteStaffSuccess, onStaffError);
    }

    function onDeleteStaffSuccess(data, headers) {
      toastr.success($filter('T')("title.deleteFail"),$filter('T')("title.infoTitle"));
      loadDeptStaff();
    }

    function onStaffError(data, headers) {
      toastr.error($filter('T')("title.deleteFail"),$filter('T')("title.infoTitle"));
    }

    function onDelTagsSuccess(data, headers) {
      toastr.success($filter('T')("title.deleteFail"),$filter('T')("title.infoTitle"));
      vm.allTags.splice(getPosInArray(data.rows[0], vm.allTags), 1);
    }

    function onTagMemberSuccess(data, headers) {
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      findTagMembers(vm.currentTag);

    }

    function onTagMemberError(error) {
      toastr.error($filter('T')('title.operationFailed'),$filter('T')('title.confirmTitle'));

    }

    function onlockTagsSuccess(data, headers) {
      getAllTags();
      toastr.success($filter('T')("title.successfulOperation"),$filter('T')("title.infoTitle"));

    }

    function onLockError(error) {
      toastr.error($filter('T')('title.operationFailed'),$filter('T')('title.confirmTitle'));

    }

    function onDelTagMemberSuccess(data, headers) {
      getAllTags();
      toastr.success($filter('T')("title.deleteSuccess"),$filter('T')("title.infoTitle"));

    }

    function onDelTagMemberError(error) {
      toastr.error($filter('T')("title.deleteSuccess"),$filter('T')("title.infoTitle"));

    }


  }


})();

/**
 * Created by zhouzy on 2016/9/1 0001.
 */
(function () {
  "use strict";
  angular.module("hmapFront").factory("Authority", Authority);

  Authority.$inject = ["$resource"];

  function Authority($resource) {
    var service = {
      query: query,
      save: save,
      queryUserRoles: queryUserRoles,
      validateUrl: validateUrl,
      queryRoleFunc: queryRoleFunc,
    };
    return service;

    function query() {
      var resourceUrl = "/api/rolefunction/query";
      return $resource(
        resourceUrl,
        {},
        {
          query: { method: "GET", isArray: false },
          get: {
            method: "GET",
            transformResponse: function (data) {
              if (data) {
                data = angular.fromJson(data);
              }
              return data;
            },
          },
          update: { method: "PUT" },
        }
      );
    }

    function save() {
      var resourceUrl = "/api/rolefunction/save";
      return $resource(
        resourceUrl,
        {},
        {
          saveOrUpdate: { method: "POST" },
        }
      );
    }

    function queryUserRoles() {
      var resourceUrl = "/api/userRole";
      return $resource(
        resourceUrl,
        {},
        {
          get: { method: "GET" },
        }
      );
    }
    function validateUrl() {
      var resourceUrl = "/api/authority";
      return $resource(
        resourceUrl,
        {},
        {
          query: { method: "POST" },
        }
      );
    }
    function queryRoleFunc() {
      var resourceUrl = "/api/roleFunc/query";
      return $resource(
        resourceUrl,
        {},
        {
          query: { method: "GET", isArray: false },
        }
      );
    }
  }
})();

/**
 * Created by Koma.Tshu on 2017/3/11.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('auditLog', {
        parent: 'app',
        url: "/auditLog",
        views: {
          'body': {
            templateUrl: "app/auditLog/auditLog.html",
            controller: 'AuditLogController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {
              };
            }
          ]
        }
      })
  }
})();

/**
 * Created by Koma.Tshu on 2017/3/11.
 */
(function () {
  'use strict';
  angular
    .module('hmapFront')
    .factory('AuditLogService', AuditLogService);

  AuditLogService.$inject = ['$resource', '$http'];

  function AuditLogService($resource, $http) {
    //console.log("have come in servcie...");
    var service = {
      queryAuditLog : queryAuditLog,
      queryCodeValues : queryCodeValues
    };
    return service;

    function queryAuditLog(page,pageSize){
      console.log("have come in service...");
      var resourceUrl ='/api/auditLog/queryAuditLog?page='+page+'&pageSize='+pageSize;
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }

    function queryCodeValues(codeName){
      var resourceUrl ='/api/auditLog/queryCodeValues?codeName='+codeName;
      return $resource(resourceUrl,{}, {
        'query': {method: 'POST',isArray:false}
      })
    }
  }
})();

/**
 * Created by Koma.Tshu on 2017/3/11.
 */
(function () {
  'use strict';

  angular.module("hmapFront").controller("AuditLogController", AuditLogController);

  AuditLogController.$inject = ['$state', 'AuditLogService','entity', 'paginationConstants'];

  function AuditLogController($state, AuditLogService,entity, paginationConstants) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.searchAuditLog = entity;
    vm.openCalendarStart=openCalendarStart;
    vm.openCalendarTo=openCalendarTo;
    this.pickerStart = {
      date: new Date()
    };
    this.pickerTo = {
      date: new Date()
    };
    vm.loadAll(vm.searchAuditLog,vm.page,vm.itemsPerPage);

    /**
     * 加载全部方法
     * @param searchAuditLog
     * @param page
     * @param pageSize
     * @returns {*}
     */
    function loadAll(searchAuditLog,page,pageSize) {
      selectAuditSource();
      selectTransactionName();
      return AuditLogService.queryAuditLog(page,pageSize).query(searchAuditLog,onSearchSuccess, onError);
    }

    function onSearchSuccess(data) {
      //console.log('onSuccess');
      //console.log(data);
      vm.auditLogs = data.rows;
      vm.totalItems =  data.total;
    }

    /**
     * 搜索查询方法
     */
    vm.searchAudit = function(){
      vm.page = 1;
      vm.itemsPerPage = paginationConstants.itemsPerPage;
      //console.log("searchPrompt:" + vm.searchPrompt.promptCode);
      loadAll(vm.searchAuditLog,vm.page,vm.itemsPerPage);
    };

    /**
     * 清除搜索框方法
     */
    vm.clear = function () {
      vm.searchAuditLog.startDate = null;
      vm.searchAuditLog.endDate = null;
      vm.searchAuditLog.auditSource = null;
      vm.searchAuditLog.operator = null;
      vm.searchAuditLog.transactionName = null;
    };

    /**
     * 打开查询日历
     * @param e
     * @param picker
     */
    function openCalendarStart (e, picker) {
      vm [picker].open = true;
    }
    function openCalendarTo (e, picker) {
      vm [picker].open = true;
    }

    /**
     * 查询方式下拉框方法
     * @returns {*}
     */
    function selectAuditSource(){
      return AuditLogService.queryCodeValues("HMS_AUDIT_SOURCE").query(onAuditSourceSuccess,onError);
    }

    function onAuditSourceSuccess(data){
      vm.auditSources = data.rows;
    }

    /**
     * 查询功能下拉框方法
     * @returns {*}
     */
    function selectTransactionName(){
      return AuditLogService.queryCodeValues("HMS_TRANSACTION_NAME").query(onTransactionNameSuccess,onError);
    }

    function onTransactionNameSuccess(data){
      vm.transactionNames = data.rows;
    }

    function onError(error) {
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadAll(vm.searchAuditLog,vm.page,vm.itemsPerPage);
    }
  }
})();

/**
 * Created by user on 2018/7/6.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('clientDetails', {
        parent: 'app',
        url: "/clientDetails",
        views: {
          'body': {
            templateUrl: "app/application/clientDetails.html",
            controller: 'ClientDetailsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('clientDetails.edit', {
        parent: 'clientDetails',
        url: "/edit/:clientId",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/application/clientDetails-dialog.html',
            controller: 'ClientDetailsDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  clientId: $stateParams.clientId,
                  editFlag: true
                };
              }
            }
          }).result.then(function () {
            $state.go('clientDetails', null, {reload: 'clientDetails'});
          }, function () {
            $state.go('clientDetails', null, {reload: 'clientDetails'});
          });
        }]
      })
      .state('clientDetails.add', {
        parent: 'clientDetails',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/application/clientDetails-dialog.html',
            controller: 'ClientDetailsDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  editFlag: false
                }
              }
            }
          }).result.then(function () {
            $state.go('clientDetails', null, {reload: 'clientDetails'});
          }, function () {
            $state.go('clientDetails', null, {reload: 'clientDetails'});
          });
        }]
      })
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
  .factory('ClientDetailsService', ClientDetailsService);

  ClientDetailsService.$inject = ['$http'];

  function ClientDetailsService($http) {
    var prefix = '/api/oauth/client';
    return {
      query: query,
      submit: submit,
      remove: remove,
      create:create,
      generateUUID: generateUUID,
      queryProductCodeList: queryProductCodeList,
    };

    function query(app, page, pageSize) {
      var resourceUrl = prefix + '/query?page=' + page + '&pageSize=' + pageSize;
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function submit(app) {
      var resourceUrl = prefix + '/submit';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function create(app) {
      var resourceUrl = prefix + '/create';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function remove(app) {
      var resourceUrl = prefix + '/remove';
      return $http.post(resourceUrl, app).then(function (response) {
        return response.data;
      })
    }

    function generateUUID() { //生成新的UUID
      var date = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    };

    function queryProductCodeList() {
      const url = '/api/ctm/selectdvmproduct';
      return $http.post(url).then(function (response) {
        return response.data.map(function (item) {
          return {
            label: item.productName,
            value: item.productCode,
          };
        });
      });
    }
  }
})();

/**
 * Created by user on 2018/7/4.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
  .controller('ClientDetailsController', ClientDetailsController);

  ClientDetailsController.$inject = ['$filter', '$rootScope', 'ClientDetailsService', '$state', 'paginationConstants', 'SweetAlert'];

  function ClientDetailsController($filter, $rootScope, ClientDetailsService, $state, paginationConstants, SweetAlert) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.clientDetail = {};

    vm.deleteClient = deleteClient;
    vm.search = search;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.reset = reset;
    vm.isDel = isDel;
    vm.getProductList = getProductList;

    vm.getProductList();

    vm.itemsPerPage = paginationConstants.itemsPerPage;
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    loadAll(vm.clientDetail, page, pagesize);

    function getProductList() {
      ClientDetailsService.queryProductCodeList().then(function (data) {
        vm.productCodeList = data;
      });
    }

    function loadAll(clientDetail, page, pagesize) {
      return ClientDetailsService.query(clientDetail,page, pagesize)
      .then(function (data) {
        vm.result = data.rows;
        if (vm.result && vm.result.length > 0) {
          console.log('vm.productCodeList', vm.productCodeList);
          vm.result.forEach(function (item) {
            var productCode = item.productCode && item.productCode.split(',');
            var newProductCode = [];
            if (productCode && productCode.length > 0) {
              productCode.forEach(function(product) {
                if (vm.productCodeList && vm.productCodeList.length > 0) {
                  vm.productCodeList.forEach(function(code) {
                    if (product === code.value) {
                      newProductCode.push(code.label);
                    }
                  });
                }
              });
            }
            item.productCodeMeaning = newProductCode && newProductCode.join(',');
          });
        }
        vm.totalItems = data.total;
        // console.log("result00000" + angular.toJson(vm.result));
      }, onSuccess, onError)

    }

    function deleteClient(clientDetail) {
      SweetAlert.confirm($filter('T')("title.deleteTip"), {title: $filter('T')("title.confirmTitle")}).then(function (p) {
        if(p){
          var clientDetails = [];
          clientDetails.push(clientDetail);
          return ClientDetailsService.remove(clientDetails)
          .then(function (data) {
            var flag = data.success;
            //console.log("delete result:" + angular.toJson(flag));
            if (flag) {
              vm.search();
            }
          })
        }
      });
    }

    function reset() {
      vm.clientDetail = {};
    }

    function search() {
      var page = vm.page = 1;
      var pagesize = paginationConstants.itemsPerPage;
      loadAll(vm.clientDetail, page, pagesize);
    }

    function isDel(value){
      var reg= /^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$/;
      if (!reg.test(value.clientId)) {
        return false;
      }
      return true;
    }

    function onSuccess(data, headers) {
      //console.log('onSuccess');
      //console.log(data);
      vm.clientDetail = data.rows;
      vm.totalItems = data.total;
    }

    function onError(error) {
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' +vm.page);
      loadAll(vm.clientDetail, vm.page, paginationConstants.itemsPerPage);
    }
  }
})();

/**
 * Created by zhouzy on 2016/7/31 0031.
 */
(function () {
  'use strict';

  angular
  .module('hmapFront')
  .controller('ClientDetailsDialogController', ClientDetailsDialogController);

  ClientDetailsDialogController.$inject = ['$filter', 'PromptService', 'RoleService', '$timeout', '$scope',
    '$stateParams', '$uibModalInstance', 'entity', 'ClientDetailsService', 'toastr', 'uibDateParser', 'SweetAlert',
    'TenantService', '$translate', 'toastrConfig','$state'];

  function ClientDetailsDialogController($filter, PromptService, RoleService, $timeout, $scope, $stateParams,
                                         $uibModalInstance, entity, ClientDetailsService, toastr, uibDateParser, SweetAlert,
                                         TenantService, $translate, toastrConfig,$state) {
    var vm = this;
    vm.lang = window.localStorage.lang;
    if (vm.lang == 'en_GB') {
      vm.lang = 'en';
    }

    vm.clientDetail = {clientId: entity.clientId};
    vm.clientDetail.authorities = '';
    vm.clientDetail.authorizedGrantTypes = '';
    vm.authorizedGrantTypesArr = [];
    vm.authoritiesArr = [];
    vm.isEdit = entity.editFlag;

    vm.typeValues = [
      {name: $filter('T')('clientDetail.passwordMode'), value: 'password'},
      {name: $filter('T')('clientDetail.refreshTokenMode'), value: 'refresh_token'},
      {name: $filter('T')('clientDetail.clientMode'), value: 'client_credentials'},
      {name: $filter('T')('clientDetail.codeMode'), value: 'authorization_code'},
      {name: $filter('T')('clientDetail.implicitMode'), value: 'implicit'}
      ];

    vm.roleValues = [
      {name: $filter('T')('clientDetail.roleAdmin'), value: 'ROLE_ADMIN'},
      {name: $filter('T')('clientDetail.roleAdmin')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_ADMIN_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleComm'), value: 'ROLE_COMM'},
      {name: $filter('T')('clientDetail.roleComm')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_COMM_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleCommApp'), value: 'ROLE_COMM_APP'},
      {name: $filter('T')('clientDetail.roleCommApp')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_COMM_APP_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleCommApi'), value: 'ROLE_COMM_API'},
      {name: $filter('T')('clientDetail.roleCommApi')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_COMM_API_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleDps'), value: 'ROLE_DPS'},
      {name: $filter('T')('clientDetail.roleDps')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_DPS_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleResi'), value: 'ROLE_RESI'},
      {name: $filter('T')('clientDetail.roleResi')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_RESI_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleResiApi'), value: 'ROLE_RESI_API'},
      {name: $filter('T')('clientDetail.roleResiApi')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_RESI_API_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleSmr'), value: 'ROLE_SMR'},
      {name: $filter('T')('clientDetail.roleSmr')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_SMR_TRANSMIT'},
      {name: $filter('T')('clientDetail.roleSmrApp'), value: 'ROLE_SMR_APP'},
      {name: $filter('T')('clientDetail.roleSmrApp')+$filter('T')('clientDetail.roleClient'), value: 'ROLE_SMR_APP_TRANSMIT'}
    ];

    vm.autoapprove = [{
      value: 'true',
      name: $translate.instant("appEdition.yes")
    }, {
      value: 'false',
      name: $translate.instant("appEdition.no")
    }];

    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.popupOpen = popupOpen;
    vm.load = load;
    vm.initLangs = initLangs;
    vm.selectTypeChange = selectTypeChange;
    vm.selectChange = selectChange;
    vm.changeSecret = changeSecret;
    vm.getProductList = getProductList;
    //vm.getScope = getScope;
    //getProductList();

    vm.load();

    var langs = [];

    function initLangs() {
      PromptService.selectLang().query(function (data) {
        langs = data.rows;
        $("#appDescBtn").attr("disabled", false);
        $("#appNameBtn").attr("disabled", false);
      });
    }

    function changeSecret() {
      if ($("#clientSecret").attr("type") === 'password') {
        $("#clientSecret").attr('type', 'text');
      } else {
        $("#clientSecret").attr('type', 'password');
      }

    }

    initLangs();

    $scope.$watch('$viewContentLoaded', function () {
      //data plugin
      $('.form_date').datetimepicker({
        language: vm.lang,
        format: 'yyyy-mm-dd 00:00:00',
        weekStart: 1,
        todayBtn: 1,
        autoclose: 1,
        todayHighlight: 1,
        startView: 2,
        minView: 2,
        forceParse: 0
      });
    });

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
      console.log('It is not a string!')
    }

    function isNumber(value) {
      var re = /^(\+|-)?\d+($|\.\d+$)/;
      //console.log("1->" + re.test(value));
      if (!re.test(value)) {
        return false;
      }
      return true;
    }

    function save() {
      //vm.isSaving = true;
      if ('' !== vm.clientDetail.additionalInformation && undefined !== vm.clientDetail.additionalInformation
        && null !== vm.clientDetail.additionalInformation) {
        if (!isJSON(vm.clientDetail.additionalInformation)) {
          toastr.error($filter('T')("dvmProduct.checkJsonFormat"), $filter('T')("dvmProduct.invalidJson"));
          return;
        }
      }

      if ('' !== vm.clientDetail.accessTokenValidity && undefined !== vm.clientDetail.accessTokenValidity
        && null !== vm.clientDetail.accessTokenValidity) {
        console.log(isNumber(vm.clientDetail.accessTokenValidity));
        if (!isNumber(vm.clientDetail.accessTokenValidity)) {
          toastr.error($filter('T')("clientDetail.inputNumber"), $filter('T')("btnTypeName.prompt"));
          vm.clientDetail.accessTokenValidity = undefined;
          return;
        }
      }

      if ('' !== vm.clientDetail.refreshTokenValidity && undefined !== vm.clientDetail.refreshTokenValidity
        && null !== vm.clientDetail.refreshTokenValidity) {
        if (!isNumber(vm.clientDetail.refreshTokenValidity)) {
          toastr.error($filter('T')("clientDetail.inputNumber"), $filter('T')("btnTypeName.prompt"));
          vm.clientDetail.refreshTokenValidity = undefined;
          return;
        }
      }

      if (vm.autoapproveFlag === 'Y') {
        vm.clientDetail.autoapprove = true;
      } else if (vm.autoapproveFlag === 'N') {
        vm.clientDetail.autoapprove = false;
      }

      var clientDetails = [];
      clientDetails.push(vm.clientDetail);
      if (vm.isEdit){
        ClientDetailsService.submit(clientDetails)
        .then(function (data) {
          if (data.success) {
            SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
            .then(function () {
              $uibModalInstance.close();
              $state.go('clientDetails');
            })
          } else {
            SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
          }
        })
      } else{
        ClientDetailsService.create(clientDetails)
        .then(function (data) {
          if (data.success) {
            SweetAlert.success($filter('T')('title.saveSuccess'), {title: $filter('T')('btnTypeName.prompt')})
            .then(function () {
              $uibModalInstance.close();
              $state.go('clientDetails');
            })
          } else {
            SweetAlert.error(data.message, {title: $filter('T')('btnTypeName.prompt')});
          }
        })
      }
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        format: 'yyyy-MM-dd hh:mm:ss',
        maxDate: new Date(2099, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function popupOpen() {
      vm.isOpen = true;
    }

    function load() {

      vm.clientDetail.autoapprove = 'true';

      if (vm.isEdit) {
        vm.title = 'clientDetail.editTitle';
        vm.clientDetail.resourceIds = undefined;
        vm.clientDetail.scope = undefined;
        vm.clientDetail.clientSecret = undefined;
        vm.clientDetail.authorities = undefined;
        vm.clientDetail.authorizedGrantTypes = undefined;
        //避免接口因为返回数据时间差异导致数据不存在
        ClientDetailsService.queryProductCodeList().then(function (data1) {
          vm.productCodeList = data1;
          ClientDetailsService.query(vm.clientDetail, 1, 10)
          .then(function (data) {
            vm.result = data.rows;
            vm.totalItems = data.total;
            vm.clientDetail = vm.result[0];
            console.log('vm.productCodeList', vm.productCodeList);
            var productCode = vm.clientDetail.productCode.split(',');
            var newProductCode = [];
            if (productCode && productCode.length > 0) {
              productCode.forEach(function(item) {
                if (vm.productCodeList && vm.productCodeList.length > 0) {
                  vm.productCodeList.forEach(function(code) {
                    if (item === code.value) {
                      newProductCode.push(code);
                    }
                  });
                }
              });
            }
            vm.clientDetail.productCode = newProductCode;
            // console.log("result00000" + angular.toJson(vm.result));
          })
        });
      }else{
        vm.title = 'clientDetail.createTitle';
        vm.clientDetail.resourceIds = 'api-resource,iapi-resource';
        vm.clientDetail.scope = 'read,write';
        vm.clientDetail.clientSecret = ClientDetailsService.generateUUID();
        vm.clientDetail.clientId = ClientDetailsService.generateUUID();
      }
    }

    function selectTypeChange() {
      var value = vm.grantType;
      if (undefined === vm.clientDetail.authorizedGrantTypes || null === vm.clientDetail.authorizedGrantTypes) {
        vm.clientDetail.authorizedGrantTypes = '';
      }
      vm.authorizedGrantTypesArr = vm.clientDetail.authorizedGrantTypes.split(',');
      if ('' !== value && vm.authorizedGrantTypesArr.indexOf(value) === -1) {
        vm.authorizedGrantTypesArr.push(value);
        if (vm.clientDetail.authorizedGrantTypes === '') {
          vm.clientDetail.authorizedGrantTypes += value;
          if (vm.clientDetail.authorizedGrantTypes === 'client_credentials') {
            return;
          }
        } else {
          if (vm.clientDetail.authorizedGrantTypes === 'client_credentials') {
            return;
          } else if (value !== 'client_credentials') {
            vm.clientDetail.authorizedGrantTypes = vm.clientDetail.authorizedGrantTypes + ',' + value;
          }
        }
      }
    }

    function selectChange() {
      var value = vm.auth;
      if (undefined === vm.clientDetail.authorities || null === vm.clientDetail.authorities) {
        vm.clientDetail.authorities = '';
      }
      vm.authoritiesArr = vm.clientDetail.authorities.split(',');
      //console.log(vm.authoritiesArr.toString().indexOf(value) === -1);
      if ('' !== value && vm.authoritiesArr.indexOf(value) === -1) {
        vm.authoritiesArr.push(value);
        if (vm.clientDetail.authorities === '') {
          vm.clientDetail.authorities += value;
        } else {
          vm.clientDetail.authorities = vm.clientDetail.authorities + ',' + value;
        }
      }
    }

  /*  function getScope() {
      if ('SCOPE' === $("#autoapprove  option:selected").text()) {
        vm.clientDetail.autoapprove = vm.clientDetail.scope;
      }
      //console.log(vm.clientDetail.scope) ;
    }*/

    function getProductList() {
      ClientDetailsService.queryProductCodeList().then(function (data) {
        vm.productCodeList = data;
      });
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: true,
      target: 'body'
    });
  }

})();

/**
 * Created by Administrator on 2016/9/7.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('application', {
        parent: 'app',
        url: "/application",
        views: {
          'body': {
            templateUrl: "app/application/application.html",
            controller: 'ApplicationController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                };
              }
            }
          }
        }
      }).state('application.edit',{
        parent:'app',
        url:"application/edit/:id",
        views: {
          'body': {
            templateUrl: "app/application/application-edit.html",
            controller: 'ApplicationEditController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                };
              }
            }
          }
        }
      });
  }

})();

/**
 * Created by Administrator on 2016/9/7.
 */
(function () {
  "use strict";
  angular.module("hmapFront").factory("Application", Application);

  Application.$inject = ["$resource", "$http", "$q"];

  function Application($resource, $http, $q) {
    var service = {
      getToken1: getToken,
      getList: getList,
      getDetail: getDetail,
      saveAgent: saveAgent,
      getMediaId: getMediaId,
    };
    return service;

    function getToken() {
      console.log("000000" + "getToken");
      return $q.resolve(null);
    }
    function getList() {
      return $q.resolve([]);
    }
    function getDetail() {
      return $q.resolve(null);
    }
    function saveAgent() {
      return $q.resolve(null);
    }
    function getMediaId() {
      return $q.resolve(null);
    }
  }
})();

/**
 * Created by Administrator on 2016/9/7.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ApplicationController', ApplicationController);

  ApplicationController.$inject = ['$state','Application',  'entity','paginationConstants'];

  function ApplicationController($state, Application, entity, paginationConstants) {
    var vm = this;
    vm.token = null;

    Application.getToken1().then(function(data) {
      vm.token = data;
      ////console.log("000000" + vm.token);
      Application.getList(vm.token).then(function(data) {
        ////console.log("000000" + angular.toJson(data,true));
        ////console.log("000000" + typeof data);
        vm.application = data;
      })
    })



  }

})();

/**
 * Created by Administrator on 2016/9/12.
 */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('ApplicationEditController', ApplicationEditController);

  ApplicationEditController.$inject = ['$stateParams','$state','Application','$scope',  'entity','paginationConstants'];

  function ApplicationEditController($stateParams,$state, Application,$scope, entity, paginationConstants) {
    var vm = this;
    vm.token = null;
    vm.agent = null;
    vm.mediaId = "";
    vm.image = "";
    vm.load = load;
    vm.save = save;
    vm.uploadfile =uploadfile;
    vm.load($stateParams.id);

    function load(id) {
      Application.getToken1().then(function (data) {
        vm.token = data;
        ////console.log("000000" + vm.token);
        Application.getDetail(vm.token,id).then(function (data) {
          ////console.log("000000" + angular.toJson(data, true));
          vm.agent = data;
          if(vm.agent.type == 1) {
            vm.agent.type = "消息型应用";
          }else {
            vm.agent.type = "应用型应用";
          }
        })
      })
    }
    function save() {
      vm.agent.close = null;
      var filename = document.getElementById('field_img').files[0];
      var formdata = new FormData();
      formdata.append("media",filename);
      ////console.log("000000" + filename);
      Application.getToken1().then(function (data) {
        vm.token = data;
        ////console.log("000000" + vm.token);

      }).then(function() {

      })
      Application.getMediaId(vm.token,formdata).then(function (data) {
        ////console.log("000000" + angular.toJson(data, true));
        vm.mediaId = data.media_id;
        vm.agent.logo_mediaid = data.media_id;
        ////console.log("000000" + angular.toJson(vm.agent));
      })

      //Application.getToken1().then(function (data) {
      //  vm.token = data;
      //  ////console.log("000000" + vm.token);
      //  Application.saveAgent(vm.token,vm.agent).then(function (data) {
      //    ////console.log("000000" + angular.toJson(data, true));
      //  })
      //})
    }

    function uploadfile() {
      var filename = document.getElementById('field_img').files[0];
      var formdata = new FormData();
      formdata.append("media",filename);
      ////console.log("000000" + filename);
      Application.getToken1().then(function (data) {
        vm.token = data;
        ////console.log("000000" + vm.token);
        Application.getMediaId(vm.token,formdata).then(function (data) {
          ////console.log("000000" + angular.toJson(data, true));
          vm.mediaId = data.media_id;
        })
      })
    }

  }

})();

/**
 * Created by user on 2016/8/10.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('userChangeController', userChangeController);

  userChangeController.$inject = ['$filter','$scope', '$state','entity','$uibModalInstance','toastr','AnnualMeeting'];

  function userChangeController($filter,$scope, $state,entity, $uibModalInstance,toastr,AnnualMeeting) {
    var vm = this;
    vm.user=entity;
    vm.tables=[];
    vm.clear = clear;
    vm.save = save;
    vm.loadSearch=loadSearch;
    vm.loadSearch(entity.meetingId);
    vm.tableId="";
    vm.tableNum="";

    function loadSearch(id){
      AnnualMeeting.loadTables().query({id: id}, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      vm.tables = data.rows;
    }
    function onError(error) {
      toastr.error($filter('T')("title.loadError"),$filter('T')("title.infoTitle"));
    }
    function save() {
      vm.isSaving = true;
      AnnualMeeting.changeTable().save({empNo:entity.userId,tableId:vm.tableId},changeSuccess, changeError)
    }
    function changeSuccess(data, headers) {
      $uibModalInstance.dismiss('ok');
    }
    function changeError(error) {
      toastr.error($filter('T')("title.loadError"),$filter('T')("title.infoTitle"));
      vm.isSaving = false;
    }
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }
  }


})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('annualMeeting', {
        parent: 'app',
        url: "/annualMeeting",
        views: {
          'body': {
            templateUrl: "app/annualMeeting/annualMeeting.html",
            controller: 'AnnualMeetingController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              return {};
            }
          ]
        }
      })
      .state('annualMeeting.new', {
        parent: 'app',
        url: "/annualMeeting/new",
        views: {
          'body': {
            templateUrl: "app/annualMeeting/annualMeeting-new.html",
            controller: 'AnnualMeetingNewController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                  hmsAnnualMeeting: {
                    id: null,
                    statusCode: null,
                    gender: null,
                    fullName: null,
                    cellPhone: null,
                    wxopenId: null,
                    email: null,
                    sign: null,
                    parkNum: null,
                    joinAct: null,
                    isStaff: null,
                    state: null,
                    approveName: null,
                    approveDate: null,
                    equipment: null,
                    source: null,
                    sn: null,
                    companyName: null,
                    title: null,
                    inviter: null,
                    inviterId: null,
                    attribute1: null
                  },
                  splitList: []
                }
              }
            }
          }
        }
      })
      .state('annualMeeting.edit', {
        parent: 'app',
        url: "/annualMeeting/:id/edit",
        views: {
          'body': {
            templateUrl: "app/annualMeeting/annualMeeting-new.html",
            controller: 'AnnualMeetingNewController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  id: $stateParams.id
                };
              }
            }
          }
        }
      })
      .state('annualMeeting.show', {
        parent: 'app',
        url: "/annualMeeting/:id/show",
        views: {
          'body': {
            templateUrl: "app/annualMeeting/annualMeeting-show.html",
            controller: 'AnnualMeetingShowController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  id: $stateParams.id
                };
              }
            }
          }
        }
      })
      .state('annualMeeting.meetThousand', {
        parent: 'app',
        url: "/annualMeeting/meetThousand",
        views: {
          'body': {
            templateUrl: "app/annualMeeting/meet-thousand.html",
            controller: 'faceEcognitionMeetThousandCtrl',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {};
              }
            }
          }
        }
      })
      .state('annualMeeting.seat', {
        parent: 'app',
        url: "/annualMeeting/:id&:needSplit/seat",
        views: {
          'body': {
            templateUrl: "app/annualMeeting/annualMeeting-seat.html",
            controller: 'AnnualMeetingSeatController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  id: $stateParams.id,
                  needSplit: $stateParams.needSplit
                };
              }
            }
          }
        }
      })
      .state('meetingUsers', {
        parent: 'app',
        url: "/annualMeeting/:id/meetingUsers",
        views: {
          'body': {
            templateUrl: "app/annualMeeting/annualMeeting-user.html",
            controller: 'AnnualMeetingUserController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  id: $stateParams.id
                };
              }
            }
          }
        }
      })
      .state('meetingUsers.change', {
        parent: 'meetingUsers',
        url: "/:userId&:meetingId/userChange",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/annualMeeting/user-change.html',
            controller: 'userChangeController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  userId: $stateParams.userId,
                  meetingId: $stateParams.meetingId
                };
              }
            }
          }).result.then(function () {
              $state.go('meetingUsers', null, {reload: true});
            }, function () {
              $state.go('meetingUsers', null, {reload: true});
            });
        }]
      });
  }
})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('AnnualMeeting', AnnualMeeting);

  AnnualMeeting.$inject = ['$resource'];

  function AnnualMeeting ($resource) {
    var service = {
      meetingLoadSearch: meetingLoadSearch,
      staffLoadSearch: staffLoadSearch,
      meetingUpdate: meetingUpdate,
      getMeeting:getMeeting,
      getSeats:getSeats,
      buildTable:buildTable,
      buildTables:buildTables,
      saveTable:saveTable,
      generateUUID:generateUUID,
      loadTables:loadTables,
      changeTable:changeTable
    };
    return service;
    function loadTables() {
      return $resource("/api/tableFound/:id", {}, {
        'query': {method: 'GET'}
      });
    }
    function changeTable() {
      return $resource("/api/changeTable", {}, {
        'save': {method: 'POST'}
      });
    }
    function meetingLoadSearch(page,pageSize) {
      return $resource("/api/meetingFound?page="+page+"&pageSize="+pageSize, {}, {
        'query': {method: 'POST', isArray: false}
      });
    }
    function staffLoadSearch() {
      return $resource("/api/staffFound", {}, {
        'query': {method: 'POST', isArray: false}
      });
    }
    function meetingUpdate() {
      return $resource("/api/meetingUpdate", {}, {
        'save': {method: 'POST'}
      });
    }
    function buildTables() {
      return $resource("/api/buildTables", {}, {
        'save': {method: 'POST'}
      });
    }
    function buildTable() {
      var resourceUrl = '/api/buildTable';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }
    function getMeeting() {
      var resourceUrl = '/api/getMeeting/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }
    function getSeats() {
      var resourceUrl = '/api/getSeats/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET',isArray: false}
      });
    }
    function saveTable() {
      var resourceUrl = '/api/saveTable';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }
    function generateUUID() {
      var date = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AnnualMeetingController', AnnualMeetingController);
  AnnualMeetingController.$inject = ['$state','AnnualMeeting','entity','paginationConstants','$localStorage','$sessionStorage','Upload','BaseConfig'];
  /** @ngInject */
  function AnnualMeetingController($state, AnnualMeeting,entity, paginationConstants,$localStorage,$sessionStorage,Upload,BaseConfig) {
    var vm = this;
    vm.meeting=entity;
    vm.meetings=[];
    vm.page = 1;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadSearch=loadSearch;
    vm.update=update;
    vm.loadSearch();

    function loadSearch(){
      var page=vm.page;
      var pageSize=paginationConstants.itemsPerPage;
      AnnualMeeting.meetingLoadSearch(page,pageSize).query(vm.meeting, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      console.log('onSuccess');
      console.log(data);
      vm.meetings = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      console.log('error');
    }
    function update(){
      AnnualMeeting.meetingLoadSearch().update(vm.meeting, onSuccess, onError);
    }
    function pageChanged() {
      console.log('Page changed to: ' +vm.page);
      loadSearch();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AnnualMeetingUserController', AnnualMeetingUserController);
  AnnualMeetingUserController.$inject = ['$filter','AnnualMeeting','entity','paginationConstants','toastr'];
  /** @ngInject */
  function AnnualMeetingUserController($filter,AnnualMeeting,entity, paginationConstants,toastr) {
    var vm = this;
    vm.table=entity;
    vm.staffs=[];
    vm.page = 1;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.loadSearch=loadSearch;
    vm.loadSearch();

    function loadSearch(){
      AnnualMeeting.staffLoadSearch().query(vm.table, onSuccess, onError);
    }
    function onSuccess(data, headers) {
      vm.staffs = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      toastr.error($filter('T')("title.loadError"),$filter('T')("title.infoTitle"));
    }
    function pageChanged() {
      loadSearch();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AnnualMeetingShowController', AnnualMeetingShowController);
  AnnualMeetingShowController.$inject = ['$filter','$timeout','$state','AnnualMeeting','entity','toastr'];
  /** @ngInject */
  function AnnualMeetingShowController($filter,$timeout,$state, AnnualMeeting,entity,toastr) {
    var vm = this;
    vm.meeting=entity;
    vm.loadMeeting=loadMeeting;
    vm.isBuildTable=false;
    vm.loadMeeting(entity.id);
    vm.clear=clear;

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });
    function loadMeeting(id){
      if(id){
        AnnualMeeting.getMeeting().query({id: id}, onSuccess, onError);
      }
    }
    function onSuccess(data, headers) {
      vm.meeting = data.rows[0];
    }
    function onError(error) {
      toastr.error($filter('T')("title.loadError"),$filter('T')("title.infoTitle"));
    }
    function clear() {
      $state.go('annualMeeting');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AnnualMeetingSeatController', AnnualMeetingSeatController);
  AnnualMeetingSeatController.$inject = ['$state','AnnualMeeting','entity','toastr','$filter'];
  /** @ngInject */
  function AnnualMeetingSeatController($state, AnnualMeeting,entity,toastr,$filter) {
    var vm = this;
    vm.meeting=entity;
    vm.meetings=[];
    vm.loadSeats=loadSeats;
    vm.isBuildTable=false;
    vm.loadSeats(entity.id);
    vm.clear=clear;
    vm.creatTable=creatTable;
    vm.savetable=savetable;
    vm.splitName="";
    vm.hasSplit=false;
    vm.tableState=[
      {code: "Y", name: "可用"},
      {code: "N", name: "禁用"}
    ];
    function loadSeats(id){
      if(id){
        AnnualMeeting.getSeats().query({id: id}, onSuccess, onError);
      }
    }
    function onSuccess(data, headers) {
      vm.meetings = data.rows;
      if(vm.meeting.needSplit=='true'){
        vm.hasSplit=true;
      }
    }
    function onError(error) {
      toastr.error($filter('T')("title.loadError"),$filter('T')("title.infoTitle"));
    }
    function clear() {
      $state.go('annualMeeting');
    }
    function creatTable() {
      AnnualMeeting.buildTable().save({meetingId: vm.meeting.id,splitName:vm.splitName}, creatSuccess, creatError);
    }
    function creatSuccess(data, headers) {
          toastr.success($filter('T')("title.createSuccess"),$filter('T')("title.infoTitle"));
      vm.meetings.push(data.rows[0]);
    }
    function creatError(error) {
      toastr.error(error.data.message,$filter('T')("title.infoTitle"));
    }
    function savetable(table){
      AnnualMeeting.saveTable().save(table, creatSuccess, onError);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AnnualMeetingNewController', AnnualMeetingNewController);
  AnnualMeetingNewController.$inject = ['$filter','uibDateParser','$timeout','$state','AnnualMeeting','entity','toastr'];
  /** @ngInject */
  function AnnualMeetingNewController($filter,uibDateParser,$timeout,$state, AnnualMeeting,entity,toastr) {
    var vm = this;
    vm.meeting=entity;
    vm.loadMeeting=loadMeeting;
    vm.popupOpen = popupOpen;
    vm.dateOptions = dateOptions;
    vm.save=save;
    vm.creatTables=creatTables;
    vm.isBuildTable=false;
    vm.loadMeeting(entity.id);
    vm.clear=clear;
    vm.arrangementType = [
      {code: "1", name: "蛇形"},
      {code: "0", name: "流水"}
    ];
    vm.addSplit=addSplit;

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });
    function loadMeeting(id){
      if(id){
        AnnualMeeting.getMeeting().query({id: id}, onSuccess, onError);
      }else{
        vm.meeting.hmsAnnualMeeting.id=AnnualMeeting.generateUUID();
      }
    }
    function addSplit(){
      vm.meeting.splitList.push({id:AnnualMeeting.generateUUID(),meetingId:vm.meeting.hmsAnnualMeeting.id,splitName:"",startNum:"",endNum:""})
    }
    function popupOpen() {
      vm.isOpen = true;
    }
    function onSuccess(data, headers) {
      vm.meeting = data.rows[0];
      vm.meeting.hmsAnnualMeeting.meetingDate=uibDateParser.parse(vm.meeting.hmsAnnualMeeting.meetingDate,"yyyy-MM-dd");
      if(vm.meeting.hmsAnnualMeeting.needSplit=="true"){
        vm.meeting.hmsAnnualMeeting.needSplit=true;
      }
      if(vm.meeting.hmsAnnualMeeting.attribute1!="false"){
        vm.meeting.hmsAnnualMeeting.attribute1=true;
      }else{
        vm.meeting.hmsAnnualMeeting.attribute1=false;
      }
    }
    function onError(error) {
      toastr.error($filter('T')("title.loadError"),$filter('T')("title.infoTitle"));
    }
    function creatTables(){
      AnnualMeeting.buildTables().save(vm.meeting, buildSuccess, buildError);
    }
    function buildSuccess(result){
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      vm.isBuildTable=true;
    }
    function buildError(error) {
      toastr.error(error.data.message,$filter('T')("title.infoTitle"));
    }
    function save(){
      vm.isSaving = true;
      AnnualMeeting.meetingUpdate().save(vm.meeting, onSaveSuccess, onSaveError);
    }
    function onSaveSuccess(result) {
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      vm.isSaving = true;
    }

    function onSaveError() {
      toastr.error($filter('T')("title.saveFail"),$filter('T')("title.infoTitle"));
      vm.isSaving = false;
    }
    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }
    function clear(){
      $state.go('annualMeeting');
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('AppEditionLineService', AppEditionLineService);

  AppEditionLineService.$inject = ['$resource', '$http', '$state'];

  function AppEditionLineService ($resource, $http) {
    var service = {
      insertAppEditionLine: insertAppEditionLine,
      queryAppEditionLines:queryAppEditionLines,
      queryAppEditionLineById:queryAppEditionLineById,
      updateAppEditionLine:updateAppEditionLine,
      deleteAppEditionLine:deleteAppEditionLine,
      savePermissionData:savePermissionData,
      generateUUID:generateUUID,
      getPermissionData:getPermissionData,
      checkFile: checkFile
    };
    return service;

    function insertAppEditionLine(appEditionLine) {
      var resourceUrl = '/api/getAppEditionLine/insert';
      return $http.post(resourceUrl, appEditionLine, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function queryAppEditionLines(appEditionId,page,itemsPerPage){
      var resourceUrl = '/api/getAppEditionLine/queryByAppEditionId?appEditionId='+appEditionId+"&page="+page+"&pagesize="+itemsPerPage;
      return $http.get(resourceUrl, {}).then(function (response) {
        return response.data;
      });
    }
    function queryAppEditionLineById(id){
      var resourceUrl = '/api/getAppEditionLine/queryAppEditionLineById?id='+id;
      return $http.get(resourceUrl, {}).then(function (response) {
        return response.data;
      });
    }
    function updateAppEditionLine(appEditionLine){
      var resourceUrl = '/api/getAppEditionLine/update';
      return $http.post(resourceUrl, appEditionLine, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function deleteAppEditionLine(appEditionLine){
      var resourceUrl = '/api/getAppEditionLine/deleteAppEditionLineById';
      return $http.post(resourceUrl, appEditionLine, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    }

    function savePermissionData(dataId) {
      var resourceUrl = '/api/applicationPermission/save?dataId='+dataId;
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }

    function generateUUID() { //生成新的UUID
      var date = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    };

    function getPermissionData() {
      var resourceUrl = '/api/applicationPermission/query/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET', isArray: false}
      });
    }

    function checkFile(fileName, appEditionId, versionNumber, id) {
      var resourceUrl = '/api/getAppEditionLine/checkFile?fileName=' + fileName + '&appEditionId=' + appEditionId + '&versionNumber=' + versionNumber + '&id=' + id;
      return $http.post(resourceUrl, null).then(function (response) {
        return response.data;
      });
    }
  }
})();

/**
 * Created by chenlei on 2016/8/5.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AppEditionLineDialogController', AppEditionLineDialogController);

  AppEditionLineDialogController.$inject = ['$localStorage','BaseConfig','$sessionStorage','Upload', '$stateParams', '$uibModalInstance','toastr','AppEditionLineService','$filter', 'toastrConfig'];

  function AppEditionLineDialogController($localStorage,BaseConfig,$sessionStorage,Upload, $stateParams, $uibModalInstance,toastr,AppEditionLineService,$filter, toastrConfig) {
    var vm = this;

    vm.appeditionLine = {};
    vm.appeditionLine.id = $stateParams.appEditionLineId;
    vm.appeditionLine.appEditionId =  $stateParams.id;
    vm.savePermission=savePermission;
    vm.getPermission=getPermission;
    vm.permissionData=[];
    vm.clear = clear;
    vm.save = save;
    vm.load = load;
    vm.upFile=upFile;
    // vm.check=check;
    // vm.ischecked='';

    vm.appeditionLine.updateType = 'HotPatching';//默认值
    vm.appeditionLine.isMinimumEdition='N';
    vm.appeditionLine.isLatestEdition='N';
    vm.appeditionLine.enableFlag='N';
    vm.updateTypes = [
      {id:'HotPatching',name:$filter('T')('appEdition.hot_update')},
      {id:'ApplicationStore',name:$filter('T')('appEdition.app_store')}
    ];
    vm.state = [
      {id:'Y',name:$filter('T')('appEdition.yes')},
      {id:'N',name:$filter('T')('appEdition.no')}
    ];
    vm.load(vm.appeditionLine.id);

    function upFile(){
      if(!vm.appeditionLine.editionCode) {
        var file = $("#zip");
        file.after(file.clone().val(""));
        file.remove();
        toastr.warning($filter('T')("plugin.versionFirst"), $filter('T')("plugin.warnMessage"));
        return false;
      }
      var file=document.getElementById("zip").files[0];
      var fileName = file.name;
      if (file == null || file== undefined || file == '') {
        return false;
      }
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      var split = 50 * 1024 * 1024; // 50M 分片
      var chunks = Math.ceil(file.size / split);
      AppEditionLineService.checkFile(fileName, vm.appeditionLine.appEditionId, vm.appeditionLine.editionCode, vm.appeditionLine.id)
        .then(function (data) {
          if (!data.success) {
            return toastr.error(data.message);
          }
          var fileUUID = data.message;
          var successCount = 0;
          for (var i = 0; i < chunks; i++) {
            var chunkFile = file.slice(i * split, i * split + split);
            Upload.upload({
              //服务端接收
              url: BaseConfig.url + '/api/getAppEditionLine/fileSliceUpload',
              headers: {
                'Authorization': 'Bearer ' + token.access_token,
                'X-Requested-With': 'XMLHttpRequest',
                'requestFrom': 'admin'
              },
              //上传的文件
              data: {file: chunkFile, fileUUID: fileUUID, chunk: i}
            }).progress(function (evt) {
              //进度条
              var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (data, status, headers, config) {
              if (data.success) {
                if (++successCount == chunks) {
                  Upload.upload({
                    //服务端接收
                    url: BaseConfig.url + '/api/getAppEditionLine/mergeFileAndUpload',
                    headers: {
                      'Authorization': 'Bearer ' + token.access_token,
                      'X-Requested-With': 'XMLHttpRequest',
                      'requestFrom': 'admin'
                    },
                    data: {
                      fileUUID:fileUUID,
                      fileName:fileName,
                      chunks: chunks,
                      id: vm.appeditionLine.id,
                      versionNumber: vm.appeditionLine.editionCode,
                      appEditionId: vm.appeditionLine.appEditionId,
                      fileType: file.type
                    }
                  }).progress(function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                  }).success(function (data, status, headers, config) {
                    // vm.picurl=data.rows[0].pictureUrl;
                    // $state.go('legwork', null, {reload: true});
                    console.log('上传后拿到的内容是：' + angular.toJson(data));
                    console.log("成功上传：");
                    if (data.code == 'versionRepeat') {
                      var file = $("#zip");
                      file.after(file.clone().val(""));
                      file.remove();
                      toastr.error($filter('T')("plugin.versionRepeat"), $filter('T')("title.infoTitle"));
                      return;
                    } else if (data.code == 'errorType') {
                      var file = $("#zip");
                      file.after(file.clone().val(""));
                      file.remove();
                      toastr.error($filter('T')("plugin.mustCorrectFormet"), $filter('T')("plugin.warnMessage"));
                      $("#menuVersion").removeAttr("readonly");
                      return;
                    }
                    if (data.success == true) {
                      toastr.success($filter('T')("plugin.packageUploadSuccess"), $filter('T')("title.infoTitle"));
                    }
                    vm.appeditionLine.downloadUrl = data.rows[0].zipUrl;
                  }).error(function (data, status, headers, config) {

                  });
                }
              } else {
                //执行错误
              }
            }).error(function (data, status, headers, config) {
              //上传失败
              ////console.log('错误状态: ' + status);
            });
          }
        });

    }

/*    function check(name) {
      vm.ischecked=name;
    }*/

    function load(id){
      if (id) {
        vm.enabled = true;
        AppEditionLineService.queryAppEditionLineById(id).
          then(function (data) {
            //console.log("resultData:" + angular.toJson(data));
            if (data.success) {
              vm.appeditionLine = data.rows[0];
              getPermission();
            }

          });
        $("#buttonCancer").removeAttr("disabled");
      }else{
        vm.enabled = false;
        vm.appeditionLine.enableFlag = "Y";
        vm.appeditionLine.isLatestEdition = "Y";
        vm.appeditionLine.updateType = "ApplicationStore";
        $("#downloadUrl").attr("readonly","readonly");
      }
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {

      vm.permissions=[];
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=AppEditionLineService.generateUUID();
        }
        vm.permissions.push({id:permissionId,valueIcon:vm.permissionData[i].dataIcon,dataId:vm.appeditionLine.id,
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,dataKey:vm.permissionData[i].dataId,
          visibilityType:'CLIENTAPP'})
      }

      vm.appeditionLine.applicationPermissions=vm.permissions;

      vm.isSaving = true;
      if (vm.appeditionLine.id !== null&&vm.appeditionLine.id!=undefined) {
        AppEditionLineService.updateAppEditionLine(vm.appeditionLine).
          then(function (data) {
            if(data.code=="repeat"){
              toastr.warning($filter('T')('distribution.repeatNot'));
              return;
            }
            if (data.success) {
         /*     toastr.success('保存成功！','信息提示');*/
              toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
              $uibModalInstance.close();
              return null;
            }
          })

      } else {
        AppEditionLineService.insertAppEditionLine(vm.appeditionLine).
          then(function (data) {
          if(data.code=="repeat"){
            toastr.warning($filter('T')('distribution.repeatNot'));
            return;
          }
          if (data.success) {
            toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
            vm.appeditionLine=data.rows[0];
            $uibModalInstance.close();
            return null;
          }
        })
      }
    }

    function savePermission() {
      vm.permissions=[];
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=AppEditionLineService.generateUUID();
        }
        vm.permissions.push({id:permissionId,dataIcon:vm.permissionData[i].dataIcon,dataId:vm.appeditionLine.id,
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,valueId:vm.permissionData[i].dataId,
          visibilityType:'CLIENTAPP'})
      }
      // console.log('vm.appeditionLine.id--'+vm.appeditionLine.id);
      AppEditionLineService.savePermissionData(vm.appeditionLine.id).save(vm.permissions);
    }

    function getPermission(){
      AppEditionLineService.getPermissionData().query({id: vm.appeditionLine.id}, function (data){
        vm.result = data.rows;
        for(var i=0;i<vm.result.length;i++){
          // vm.permissionData.push({id:vm.result[i].id,dataIcon:vm.result[i].dataIcon,dataType:vm.result[i].dataType,
          //   dataValue:vm.result[i].dataValue,dataId:vm.result[i].valueId})
          vm.permissionData.push({id:vm.result[i].id,dataIcon:vm.result[i].valueIcon,dataType:vm.result[i].dataType,
            dataValue:vm.result[i].dataValue,dataId:vm.result[i].dataKey})
        }
      });
    }

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
     .state('appEdition', {
        parent: 'app',
        url: "/appEdition",
        views: {
          'body': {
            templateUrl: "app/appEdition/appEdition.html",
            controller: 'AppEditionController',
            controllerAs: 'vm'
          }
        }
      })
      .state('appEdition.new', {
        parent: 'appEdition',
        url: "/new",
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          ////console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/appEdition/appEdition-dialog.html',
            controller: 'AppEditionDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: null,
                  appDesc: null,
                  appCode: null,
                  appEquipment: null,
                  appSecret: null,
                  enableFlag: null
                };
              }
            }
          }).result.then(function() {
              ////console.log("appEdition go1");
              $state.go('appEdition', null, { reload: true });
            }, function() {
              ////console.log("appEdition go2");
              $state.go('appEdition');
            });
        }]
      })
      .state('appEdition.edit', {
        parent: 'appEdition',
        url: "/:id/edit",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          ////console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/appEdition/appEdition-dialog.html',
            controller: 'AppEditionDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              ////console.log("appEdition go1");
              $state.go('appEdition', null, {reload: true});
            }, function () {
              ////console.log("appEdition go2");
              $state.go('appEdition');
            });
        }]
      })
      .state('appEditionLine', {
        parent: 'app',
        url: "/appEdition/:id/:appId/detail",
        views: {
          'body': {
            templateUrl: "app/appEdition/appEdition-detail.html",
            controller: 'AppEditionDtetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: ['$stateParams',
            function ($stateParams) {
              //console.log("0000="+$stateParams.codeId);
              return {
                id:$stateParams.id,
                appId:$stateParams.appId
              };
            }
          ]
        }

      })
      .state('appEditionLine.new', {
        parent: 'appEditionLine',
        url: "/new",
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/appEdition/appEditionLine-dialog.html',
            controller: 'AppEditionLineDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function ($stateParams) {
                return {
                  appEditionId:$stateParams.id,
                  appEditionLineId:null
                };
              }
            }
          }).result.then(function() {
              ////console.log("appEdition go1");
              $state.go('appEditionLine', null, { reload: true });
            }, function() {
              ////console.log("appEdition go2");
              $state.go('appEditionLine');
            });
        }]
      })
      .state('appEditionLine.edit', {
        parent: 'appEditionLine',
        url: "/edit/:appEditionLineId/",
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/appEdition/appEditionLine-dialog.html',
            controller: 'AppEditionLineDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg'
          }).result.then(function() {
              ////console.log("appEdition go1");
              $state.go('appEditionLine', null, { reload: true });
            }, function() {
              ////console.log("appEdition go2");
              $state.go('appEditionLine');
            });
        }]
      })
  }

})();

(function() {
  'use strict';
  angular
    .module('hmapFront')
    .factory('AppEdition', AppEdition);

  AppEdition.$inject = ['$resource'];

  function AppEdition ($resource) {
    var resourceUrl = '/api/appEditionApp/:id';

    return $resource(resourceUrl, {}, {
      'query': { method: 'GET',isArray: false},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': { method:'PUT' }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AppEditionController', AppEditionController);
  AppEditionController.$inject = ['$state','AppEdition','paginationConstants'];
  /** @ngInject */
  function AppEditionController($state, AppEdition, paginationConstants) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.loadAll = loadAll;
    vm.transition = transition;
    vm.pageChanged=pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.loadAll();

    function loadAll() {
      AppEdition.query({
        page: vm.page,
        pagesize: paginationConstants.itemsPerPage
      }, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      ////console.log('onSuccess');
      ////console.log(data);
      vm.appEditions = data.rows;
      vm.totalItems =  data.total;
    }
    function onError(error) {
      ////console.log('error');

    }
    function transition () {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      ////console.log('Page changed to: ' +vm.page);
      loadAll();
    };
  }
})();

/**
 * Created by chenlei on 2016/8/5.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AppEditionDialogController', AppEditionDialogController);

  AppEditionDialogController.$inject = ['toastrConfig','AppAuthService','$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity','AppEdition','toastr','paginationConstants','$filter'];

  function AppEditionDialogController(toastrConfig,AppAuthService,$timeout, $scope, $stateParams, $uibModalInstance, entity, AppEdition,toastr,paginationConstants,$filter) {
    var vm = this;

    vm.appedition = entity;
    vm.clear = clear;
    vm.save = save;
    vm.dateOptions = dateOptions;
    vm.popupOpen = popupOpen;
    vm.load=load;

    vm.disabled = false;
    vm.searchApp={};
    vm.hmsAppAuth = null;
    var hmsAppAuth = vm.hmsAppAuth;
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    vm.load(vm.appedition.id);

    loadAllAppAuth(hmsAppAuth, page, pagesize);

    vm.Equipments = [
      {id:'IOS',name:'IOS'},
      {id:'ANDROID',name:'ANDROID'},
      {id:'WINDOWS PHONE',name:'WINDOWS PHONE'}
    ];
    vm.state = [
/*      {id:'Y',name:'是'},
      {id:'N',name:'否'}*/
      {id:'Y',name:$filter('T')('appEdition.yes')},
      {id:'N',name:$filter('T')('appEdition.no')}
    ];

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.isSaving = true;
      if (vm.appedition.id !== null) {
        AppEdition.update(vm.appedition, onSaveSuccess, onSaveError);
      } else {
        AppEdition.save(vm.appedition, onSaveSuccess, onSaveError);
      }
    }

    function onSaveSuccess(result) {
/*      toastr.success('保存成功！','信息提示');*/
      if(result.code=="repeat"){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      $scope.$emit('hmapFront:appeditionUpdate', result);
      $uibModalInstance.close(result);
      vm.isSaving = true;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function dateOptions() {
      var options = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      };
      return options;
    }

    function popupOpen() {
      vm.isOpen = true;
    }



    function load(id) {
      if (id) {
        ////console.log('loadone');
        vm.disabled = true;
        AppEdition.get({id: id}, function (result) {
          vm.appedition = result.rows[0];
          vm.appId = vm.appedition.appId;
        });
      }else{
        vm.appedition.enableFlag = 'Y';
      }
    }

    function loadAllAppAuth(hmsAppAuth, page, pagesize) {
      vm.searchApp.page = vm.page;
      vm.searchApp.pagesize = paginationConstants.itemsPerPage;
      vm.searchApp.isApp = "Y";
      AppAuthService.findAppAuth().query(vm.searchApp, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      vm.result = data.rows;
      vm.totalItems = data.total;
    }

    function onError(error) {
      console.log('error');
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AppEditionDtetailController', AppEditionDtetailController);
  AppEditionDtetailController.$inject = ['$state','AppEdition','AppEditionLineService','toastr','paginationConstants', 'entity','SweetAlert','$filter'];
  /** @ngInject */
  function AppEditionDtetailController($state, AppEdition,AppEditionLineService,toastr,paginationConstants,entity,SweetAlert,$filter) {
    var vm = this;
    vm.appEdition = entity;
    vm.appEditionLines =[];

    vm.page = 1;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.totalItems = null;
/*    vm.updateTypes = {HotPatching:'热更新',ApplicationStore:'应用商店'};*/

    vm.updateTypes = {HotPatching:$filter('T')('appEdition.hot_update'),ApplicationStore:$filter('T')('appEdition.app_store')};

   /* vm.state = {Y:'是',N:'否'};*/
    vm.state = {Y:$filter('T')('appEdition.yes'),N:$filter('T')('appEdition.no')};
    vm.deleteAppEditionLine = deleteAppEditionLine;
    vm.editionInfo = editionInfo;
    vm.showUpdateMessage = showUpdateMessage;
    vm.setLatestEdition = setLatestEdition;
    vm.setMinimumEdition =setMinimumEdition;
    vm.openAppEditionLine = openAppEditionLine;
    vm.closeAppEditionLine = closeAppEditionLine;

    loadAll(vm.appEdition.id);
    loadLineAll(vm.appEdition.id,vm.page,vm.itemsPerPage);

    function loadAll(id) {
      return  AppEdition.get({id: id}, function (result) {
        vm.appEdition = result.rows[0];
      });
    }

    function loadLineAll(appEditionId,page,itemsPerPage) {
      return  AppEditionLineService.queryAppEditionLines(appEditionId,page,itemsPerPage).
        then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            vm.appEditionLines = data.rows[0];
            vm.totalItems = data.total;
            return null;
          }

        })
    }
    function deleteAppEditionLine(appEditionLine){
      SweetAlert.confirm($filter('T')('appEdition.deleteConfirm'), {title: $filter('T')('btnTypeName.prompt')}).then(function (p) {
        if(p){
          AppEditionLineService.deleteAppEditionLine(appEditionLine).
          then(function (data) {
            //console.log("resultData:" + angular.toJson(data));
            if (data.success) {
              toastr.success($filter('T')('appEdition.deleteConfirm'),$filter('T')('appEdition.prompt'));
             /* toastr.success('删除成功！','信息提示');*/
              loadLineAll(vm.appEdition.id,vm.page,vm.itemsPerPage);
              return null;
            }
          })
        }
      });
    }
    function editionInfo(isMinimumEdition,isLatestEdition){
      if(isLatestEdition=='Y'&&isMinimumEdition=='Y'){
        return $filter('T')('appEdition.ml_version');
      }else if(isLatestEdition=='Y'){
        return $filter('T')('distribution.latest');
      }else if(isMinimumEdition=='Y'){
        return $filter('T')('appEdition.min_version');
      }else{
        return '';
      }
    }

    function showUpdateMessage(updateMessage){
      toastr.info(updateMessage,$filter('T')('appEdition.update_message'),{autoDismiss:false,closeButton:true,timeOut:5000});
    }

    function setLatestEdition(appEditionLine){
      appEditionLine.isLatestEdition ='Y'
      AppEditionLineService.updateAppEditionLine(appEditionLine).
        then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            loadLineAll(vm.appEdition.id,vm.page,vm.itemsPerPage);
          /*  toastr.success('设置最新版本成功！','信息提示');*/
            toastr.success($filter('T')('appEdition.update_message'),$filter('T')('btnTypeName.prompt'));
            return null;
          }
        })
    }
    function setMinimumEdition(appEditionLine){
      appEditionLine.isMinimumEdition ='Y'
      AppEditionLineService.updateAppEditionLine(appEditionLine).
        then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            loadLineAll(vm.appEdition.id,vm.page,vm.itemsPerPage);
            /*   toastr.success('设置最小版本成功！','信息提示');*/
            toastr.success($filter('T')('appEdition.min_ver_message'),$filter('T')('btnTypeName.prompt'));
            return null;
          }
        })
    }
    function openAppEditionLine(appEditionLine){
      appEditionLine.enableFlag ='Y'
      AppEditionLineService.updateAppEditionLine(appEditionLine).
        then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            loadLineAll(vm.appEdition.id,vm.page,vm.itemsPerPage);
           /* toastr.success('启用成功！','信息提示');*/
            toastr.success($filter('T')('appEdition.enabled_success'),$filter('T')('btnTypeName.prompt'));
            return null;
          }
        })
    }
    function closeAppEditionLine(appEditionLine){
      appEditionLine.enableFlag ='N'
      AppEditionLineService.updateAppEditionLine(appEditionLine).
        then(function (data) {
          //console.log("resultData:" + angular.toJson(data));
          if (data.success) {
            loadLineAll(vm.appEdition.id,vm.page,vm.itemsPerPage);
           /* toastr.success('禁用成功！','信息提示');*/
            toastr.success($filter('T')('appEdition.disable_success'),$filter('T')('btnTypeName.prompt'));
            return null;
          }
        })
    }
  }
})();

(function () {
  'use strict';
  angular.module('hmapFront').controller('PreNextGenTooltipController', PreNextGenTooltipController);
  PreNextGenTooltipController.$inject = ['$state'];

  function PreNextGenTooltipController($state) {
    var vm = this;
    vm.gotoNextGen = gotoNextGen;
    vm.gotoKohlerApp = gotoKohlerApp;

    function gotoNextGen() {
      $state.go('nextGenAppDownloadFix');
    }

    function gotoKohlerApp() {
      $state.go('appDownloadFix');
    }

  }
})();
/**
 * Created by zhouzy on 2016/7/23 0023.
 */
(function () {
  'use strict';

  angular
  .module('hmapFront')
  .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
    .state('appDownloadInternal', {
      parent: "app",
      url: "/internal/download",
      params: {"url": null, "type": null},
      views: {
        'body': {
          templateUrl: "app/appEdition/AppDownload.html",
          controller: 'AppDownloadController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {
            referenceSource: 'residential'
          };
        }
      }
    })
    .state('commercialAppDownloadInternal', {
      parent: "app",
      url: "/internal/commercialAppDownload",
      params: {"url": null, "type": null},
      views: {
        'body': {
          templateUrl: "app/appEdition/CommercialAppDownload.html",
          controller: 'AppDownloadController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {
            referenceSource: 'commercial'
          };
        }
      }
    })
    .state('NextGenAppDownloadInternal', {
      parent: "app",
      url: "/nextgen/download",
      params: {"url": null, "type": null},
      views: {
        'body': {
          templateUrl: "app/appEdition/NextGenAppDownload.html",
          controller: 'AppDownloadController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {
            referenceSource: 'nextgen'
          };
        }
      }
    })
  }
})();

(function () {
  'use strict';
  angular
  .module('hmapFront')
  .factory('AppDownloadService', AppDownloadService);

  AppDownloadService.$inject = ['$http'];

  function AppDownloadService($http) {
    return {
      LoadAppDownloadUrl: loadAppDownloadUrl,
      LoadAppBundleId: LoadAppBundleId
    };

    function loadAppDownloadUrl() {
      // var resourceUrl = "/api/appDownloadUrl?bundleId=" + bundleId;
      var resourceUrl = "/api/appDownloadUrl";
      return $http.get(resourceUrl, {}).then(function (response) {
        return response.data;
      });
    }

    function LoadAppBundleId() {
      var resourceUrl = "/api/appBundleId";
      return $http.get(resourceUrl, {}).then(function (response) {
        return response.data;
      });
    }
  }
})();

(function () {
  'use strict';
  angular.module('hmapFront')
  .controller('AppDownloadController', AppDownloadController);
  AppDownloadController.$inject = ['AppDownloadService', '$scope', '$translate', 'entity', '$window'];

  function AppDownloadController(AppDownloadService, $scope, $translate, entity, $window) {
    var vm = this;
    vm.load = load;
    vm.utf16to8 = utf16to8;
    // vm.loadBundleId = loadBundleId;
    vm.checkWechatAndAlipay = checkWechatAndAlipay;
    vm.hide = hide;
    //using angular-qr module,you have to define data for attribute 'text' first.
    vm.appDownloadUrl = {
      androidImg: '',
      iosImg: ''
    };
    vm.showTips = false;
    vm.checkWechatAndAlipay();

    // vm.loadBundleId();
    vm.load();

    // function loadBundleId() {
    //   AppDownloadService.LoadAppBundleId().then(function (data) {
    //     if (data) {
    //       vm.appBundle = data.rows;
    //       switch (entity.referenceSource) {
    //         // there are three bundle id could in different environment.
    //         case 'residential':
    //           vm.appBundle.forEach(function (appBundle) {
    //             // if bundle id is not next gen and commercial app, then it is residential app.
    //             if ('cn.com.kohlerkonnect' === appBundle.value || 'com.kohlerIOT.test' === appBundle.value) {
    //               vm.appBundleId = appBundle.value;
    //             }
    //           });
    //           break;
    //         default:
    //           // commercial and next gen app bundle id.
    //           vm.appBundle.forEach(function (appBundle) {
    //             if (-1 !== appBundle.value.indexOf(entity.referenceSource)) {
    //               vm.appBundleId = appBundle.value;
    //             }
    //           });
    //           break;
    //       }
    //       vm.load(vm.appBundleId);
    //     }
    //   })
    // }

    function load() {
      var currentLanguage;
      currentLanguage = navigator.language;
      if (!localStorage.lang) {
        if (!currentLanguage) {
          currentLanguage = navigator.browserLanguage;
        }
        currentLanguage = currentLanguage.replace("-", "_");
        $translate.use(currentLanguage);
      }
      AppDownloadService.LoadAppDownloadUrl().then(function (data) {
        // 遍历出来key，根据key值获取bundleId
        vm.appBundle = [];

        // 使用 for...in 遍历对象
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
              vm.appBundle.push(key);
            }
        }
        switch (entity.referenceSource) {
          // there are three bundle id could in different environment.
          case 'residential':
            vm.appBundle.forEach(function (appBundle) {
              // if bundle id is not next gen and commercial app, then it is residential app.
              if ('cn.com.kohlerkonnect' === appBundle || 'com.kohlerIOT.test' === appBundle) {
                vm.appBundleId = appBundle;
              }
            });
            break;
          default:
            // commercial and next gen app bundle id.
            vm.appBundle.forEach(function (appBundle) {
              if (-1 !== appBundle.indexOf(entity.referenceSource)) {
                vm.appBundleId = appBundle;
              }
            });
            break;
        }
        if (data[vm.appBundleId]) {
          vm.appDownloadUrl = {
            ios: data[vm.appBundleId].ios,
            android: data[vm.appBundleId].android
          };
          if (vm.appDownloadUrl.ios == '' || vm.appDownloadUrl.ios == undefined) {
            vm.hideIos = true;
          } else {
            vm.appDownloadUrl.iosImg = vm.utf16to8(vm.appDownloadUrl.ios);
          }
          if (vm.appDownloadUrl.android == '' || vm.appDownloadUrl.android == undefined) {
            vm.hideAndorid = true;
          } else {
            vm.appDownloadUrl.androidImg = vm.utf16to8(vm.appDownloadUrl.android);
          }
        }
      });
      // AppDownloadService.LoadAppDownloadUrl(bundleId).then(function (data) {
      //   if (data) {
      //     vm.appDownloadUrl = data;
      //     if (vm.appDownloadUrl.ios == '' || vm.appDownloadUrl.ios == undefined) {
      //       vm.hideIos = true;
      //     } else {
      //       vm.appDownloadUrl.iosImg = vm.utf16to8(vm.appDownloadUrl.ios);
      //     }
      //     if (vm.appDownloadUrl.android == '' || vm.appDownloadUrl.android == undefined) {
      //       vm.hideAndorid = true;
      //     } else {
      //       vm.appDownloadUrl.androidImg = vm.utf16to8(vm.appDownloadUrl.android);
      //     }
      //   }
      // });
    }

    function utf16to8(str) {
      var out, i, len, c;
      out = "";
      len = str.length;
      for (i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if ((c >= 0x0001) && (c <= 0x007F)) {
          out += str.charAt(i);
        } else if (c > 0x07FF) {
          out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
          out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
        } else {
          out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
        }
      }
      return out;
    }

    function checkWechatAndAlipay() {
      var nav = $window.navigator;
      vm.showTips = (/alipay/i.test(nav.userAgent.toLowerCase()) ||
        /micromessenger/i.test(nav.userAgent.toLowerCase())) && (!(/(iphone|ipad|ipod|ios)/i.test(nav.userAgent.toLowerCase())));
    }

    function hide() {
      vm.showTips = false;
    }
  }
})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditCategoryController', EditCategoryController);

  EditCategoryController.$inject = ['MenuCategoryService', '$scope', '$state', '$uibModalInstance', 'entity'];

  function EditCategoryController( MenuCategoryService,$scope, $state, $uibModalInstance, entity) {
    var vm = this;
    // console.log(angular.toJson(entity));
    vm.category={};
    vm.loadCategory=loadCategory;
    vm.update=update;
    vm.clear = clear;

    vm.loadCategory(entity.id)

    function loadCategory(id) {
      return MenuCategoryService.getCategory(id)
        .then(function (data) {
          vm.category=data.rows[0];
        })
    }

    function update(category) {
      return MenuCategoryService.updateCategory(category)
        .then(function (data) {
          $uibModalInstance.close();
          $state.go('appAuth.showCategory', {appId: vm.category.appId});
        })
    }

    function clear() {
      $uibModalInstance.close();
      $state.go('appAuth.showCategory', {appId: vm.category.appId});
    }


  }


})();

/**
 * Created by user on 2016/8/9.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('MenuCategoryService', MenuCategoryService);

  MenuCategoryService.$inject = ['$resource', '$http', '$state'];

  function MenuCategoryService($resource, $http) {
    var service = {
      getAllCategory: getAllCategory,
      addCategory:addCategory,
      getCategory:getCategory,
      updateCategory:updateCategory
    };
    return service;

    function getAllCategory(appId,page,pagesize) {
      var resourceUrl = '/api/menuCategory/queryAllCategory?appId='+appId+'&page='+page+'&pagesize='+pagesize;
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }

    function addCategory(category) {
      var resourceUrl = "/api/menuCategory/add";
      var data = category;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    };

    function updateCategory(category) {
      var resourceUrl = "/api/menuCategory/updateCategory";
      var data = category;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    };

    function getCategory(id) {
      var resourceUrl = '/api/menuCategory/getCategory?id='+id;
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      })
    }
  }
})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('MenuCategoryController', MenuCategoryController);

  MenuCategoryController.$inject = ['MenuCategoryService', '$state', 'paginationConstants','entity'];

  function MenuCategoryController(MenuCategoryService, $state, paginationConstants,entity) {
    var vm = this;
    vm.appId = entity.appId;
    // console.log('00'+angular.toJson(entity))
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;

    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    loadAll(vm.appId,page, pagesize);

    function loadAll(appId, page, pagesize) {
      return MenuCategoryService.getAllCategory(appId, page, pagesize)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
        })
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      loadAll(vm.appId, vm.page, paginationConstants.itemsPerPage);
    };

  }


})();

/**
 * Created by user on 2016/8/9.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddCategoryController', AddCategoryController);

  AddCategoryController.$inject = ['MenuCategoryService', '$scope', '$state', '$uibModalInstance', 'entity'];

  function AddCategoryController( MenuCategoryService,$scope, $state, $uibModalInstance, entity) {
    var vm = this;
    // console.log(angular.toJson(entity));
    vm.appId = entity.appId;
    vm.add=add;
    vm.category = {
      appId : vm.appId
    };
    vm.clear = clear;

    function add() {
      return MenuCategoryService.addCategory(vm.category)
        .then(function (data) {
          $uibModalInstance.close();
          $state.go('appAuth.showCategory', {appId: vm.appId});
        })
    }

    function clear() {
      $uibModalInstance.close();
      $state.go('appAuth.showCategory', {appId: vm.appId});
    }


  }


})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('EditAppConfigController', EditAppConfigController);

  EditAppConfigController.$inject = ['$filter','AppAuthService', '$stateParams', '$state', '$uibModalInstance', 'entity', 'paginationConstants', '$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','toastr'];

  function EditAppConfigController($filter,AppAuthService, $stateParams, $state, $uibModalInstance, entity, paginationConstants, $localStorage, $sessionStorage, $timeout, Upload, BaseConfig,toastr) {
    var vm = this;
    vm.hmsAppAuth = entity;
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.clear = clear;
    vm.update = update;
    vm.load = load;
    vm.creatUUID = creatUUID;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.submitFile = submitFile;
    vm.upload = upload;
    vm.changeType = changeType;

    vm.load($stateParams.id);
    vm.appType = [
      {code: "客户端应用", name: "客户端应用"},
      {code: "Web应用", name: "Web应用"}
    ];

    vm.appAuzMode = [
      {code: "password", name: "密码模式"},
      {code: "refresh_token", name: "客户端模式"}
    ];

    function changeType() {
      if (vm.hmsAppAuth.appType === "客户端应用") {
        vm.hmsAppAuth.appAuzMode = 'password';
        vm.appAuzMode = [
          {code: "password", name: "密码模式"},
          {code: "refresh_token", name: "客户端模式"}
        ];
      } else if (vm.hmsAppAuth.appType === "Web应用") {
        vm.hmsAppAuth.appAuzMode = 'authorization_code';
        vm.appAuzMode = [
          {code: "authorization_code", name: "授权码模式"},
        ];
      }
    };

    function loadHmsAppAuth() {
      AppAuthService.findRoles().query(vm.hmsAppAuth
        , onRoleSuccess, onError);
    }

    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitFile() {
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    };

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/objectUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        ////console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.hmsAppAuth.appIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"), $filter('T')("title.confirmTitle"));
      }).error(function (data, status, headers, config) {
        //上传失败
        ////console.log('错误状态: ' + status);
      });
    };

    function load(id) {
      AppAuthService.getAppAuth().query({id: id}, function (result) {
        vm.hmsAppAuth = result.rows[0];
        if (vm.hmsAppAuth.appType === "客户端应用") {
          vm.appType = [
            {code: "客户端应用", name: "客户端应用"},
            {code: "Web应用", name: "Web应用"}
          ];
        } else if (vm.hmsAppAuth.appType === "Web应用") {
          vm.appAuzMode = [
            {code: "authorization_code", name: "授权码模式"},
          ];
        }
      });
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      ////console.log('Page changed to: ' + vm.page);
      getAppAuthId(hmsAppAuth, vm.page, pagesize);
    };

    //刷新生成新的UUID
    function creatUUID() {
      vm.uuid = AppAuthService.generateUUID();
      ////console.log("新生成的UUID is ：", vm.uuid);
      vm.hmsAppAuth.appSecret = vm.uuid;
    }

    function update() {
      AppAuthService.insertOrUpdateAppAuth().save(vm.hmsAppAuth, onSuccess, onError);
    };

    function onRoleSuccess(data, headers) {
      vm.hmsAppAuth = data.rows[0];
    }

    function onSuccess(data, headers) {
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      $uibModalInstance.close(data);
    }

    function onError(error) {
      ////console.log('error');
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


  }


})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */

(function () {
  'use strict';

  angular.module('hmapFront')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('appAuth', {
        parent: 'app',
        url: "/appAuth",
        views: {
          'body': {
            templateUrl: "app/appConfigure/appAuth.html",
            controller: 'AppConfigController',
            controllerAs: 'vm'
          }
        }
      })
      .state('appAuth.new', {
        parent: 'app',
        url: "/appAuth/new",
        views: {
          'body': {
            templateUrl: "app/appConfigure/appAuth-detail-new.html",
            controller: 'AppAuthDetailNewController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            ////console.log("entity:"+angular.toJson($stateParams.id));
            return {
              id: null
            };
          }
        }
      })
      .state('appAuth.detail', {
        parent: 'app',
        url: "/appAuth/:id",
        views: {
          'body': {
            templateUrl: "app/appConfigure/appAuth-detail.html",
            controller: 'AppAuthDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function ($stateParams) {
            ////console.log("entity:"+angular.toJson($stateParams.id));
            return {
              id: $stateParams.id
            };
          }
        }
      })
      .state('appAuth.newWeb', {
        parent: 'app',
        url: "/appAuth/web/new",
        views: {
          'body': {
            templateUrl: "app/appConfigure/appAuth-web-new.html",
            controller: 'AppAuthWebNewController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          entity: function () {
            ////console.log("entity:"+angular.toJson($stateParams.id));
            return {
              id: null
            };
          }
        }
      })
      .state('appAuth.add', {
        parent: 'appAuth',
        url: "/add",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/appConfigure/addAppAuth.html',
            controller: 'AddAppConfigController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg'
          }).result.then(function () {
              ////console.log("appAuth go1");
              $state.go('appAuth', null, {reload: true});
            }, function () {
              ////console.log("appAuth go2");
              $state.go('appAuth');
            });
        }]
      })
      .state('appAuth.edit', {
        parent: 'appAuth',
        url: "/edit/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/appConfigure/editAppAuth.html',
            controller: 'EditAppConfigController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                ////console.log("entity:"+angular.toJson($stateParams.id));
                return {
                  id: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              ////console.log("hmsappauth go1");
              $state.go('appAuth', null, {reload: true});
            }, function () {
              ////console.log("hmsappauth go2");
              $state.go('appAuth');
            });
        }]
      }).state('appAuth.showCategory', {
      parent: 'app',
      url: "/showCategory/:appId",
      params:{
        appId:''
      },
      views: {
        'body': {
          templateUrl: "app/appConfigure/menuCategory.html",
          controller: 'MenuCategoryController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function ($stateParams) {
          return {
            appId:$stateParams.appId
          };
        }
      }
    }).state('appAuth.addCategory', {
      parent: 'app',
      url: "/addCategory/:appId",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/appConfigure/menuAddCategory.html',
          controller: 'AddCategoryController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                appId:$stateParams.appId
              };
            }
          }
        }).result.then(function () {
          // $state.go('notice', null, {reload: true});
        }, function () {
          // $state.go('notice');
        });
      }]
    }).state('appAuth.editCategory', {
      parent: 'app',
      url: "/editCategory/:id",
      onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'app/appConfigure/menuEditCategory.html',
          controller: 'EditCategoryController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            entity: function () {
              return {
                id:$stateParams.id
              };
            }
          }
        }).result.then(function () {
          // $state.go('notice', null, {reload: true});
        }, function () {
          // $state.go('notice');
        });
      }]
    })
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('AppAuthService', AppAuthService);

  AppAuthService.$inject = ['$resource', '$http'];

  function AppAuthService($resource,$http) {
    var service = {
      findAppAuth: findAppAuth,
      insertOrUpdateAppAuth: insertOrUpdateAppAuth,
      getAppAuth:getAppAuth,
      savePermissionData:savePermissionData,
      generateUUID:generateUUID,
      getPermissionData:getPermissionData,
      getOptionValue:getOptionValue,
      updateOptionValue:updateOptionValue
    };
    return service;

    function findAppAuth() {
      var resourceUrl = '/api/appauth/query';
      return $resource(resourceUrl, {}, {
        'query': {method: 'POST'}
      });
    }
    function savePermissionData(dataId) {
      var resourceUrl = '/api/applicationPermission/save?dataId='+dataId;
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    }
    function getPermissionData() {
      var resourceUrl = '/api/applicationPermission/query/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET', isArray: false}
      });
    }
    function getAppAuth() {
      var resourceUrl = '/api/appauth/:id';
      return $resource(resourceUrl, {}, {
        'query': {method: 'GET'}
      });
    }

    function insertOrUpdateAppAuth() {
      var resourceUrl = '/api/appauth/insertOrUpdate';
      return $resource(resourceUrl, {}, {
        'save': {method: 'POST'}
      });
    };

    function generateUUID() { //生成新的UUID
      var date = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    };

    function getOptionValue(option) {
      var resourceUrl = '/api/appOption/getOptionsValue';
      var data = option;
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    };

    function updateOptionValue(option) {
      var resourceUrl = "/api/appOption/updateOptionsValue";
      return $http.post(resourceUrl, option, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      });
    };

  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AppConfigController', AppConfigController);

  AppConfigController.$inject = ['AppAuthService','$scope', '$state', 'paginationConstants'];

  function AppConfigController(AppAuthService,$scope, $state, paginationConstants) {
    ////console.log("enter hmsAppAuth page....")
    var vm = this;
    vm.searchApp={};
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.hmsAppAuth = null;
    vm.uploadPic="assets/images/upload.png";
    var hmsAppAuth = vm.hmsAppAuth;
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.queryAppAuth = queryAppAuth;
    vm.query = query;

    loadAll(hmsAppAuth, page, pagesize);

    function loadAll(hmsAppAuth, page, pagesize) {
      vm.searchApp.page = vm.page;
      vm.searchApp.pagesize = paginationConstants.itemsPerPage;
      AppAuthService.findAppAuth().query(vm.searchApp, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      vm.result = data.rows;
      vm.totalItems = data.total;
    }

    function onError(error) {
      console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      ////console.log('Page changed to: ' + vm.page);
      loadAll(hmsAppAuth, vm.page, pagesize);
    };


    //搜索获取model值封装成对象
    vm.hmsAppAuth = {
      "appName": '',
      "appType":'',
      "userName": '',
      "appAuzMode":'',
    };



    function queryAppAuth() {
      var hmsAppAuth = vm.hmsAppAuth;
      loadAll(hmsAppAuth, page, pagesize);//因为公用一个查询方法所以在搜索的时候也需要传page,pagesize
      ////console.log("params is:", angular.toJson(vm.hmsAppAuth));
    }

    function query() {
      vm.searchApp.page = vm.page;
      vm.searchApp.pagesize = paginationConstants.itemsPerPage;
      AppAuthService.findAppAuth().query(vm.searchApp, onSuccess, onError);
    }

  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AppAuthWebNewController', AppAuthWebNewController);

  AppAuthWebNewController.$inject = ['$filter','AppAuthService', '$scope', '$state', '$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','toastr','entity'];

  function AppAuthWebNewController($filter,AppAuthService, $scope, $state, $localStorage, $sessionStorage, $timeout, Upload, BaseConfig,toastr,entity) {
    var vm = this;
    vm.hmsAppAuth = entity;
    vm.hmsAppAuth.appAuzMode = 'password';
    vm.save = save;
    vm.submitFile = submitFile;
    vm.upload = upload;
    vm.oldFile="assets/images/logo-header.png";
    vm.changeFile=changeFile;
    vm.clear=clear;

    vm.file = "";

    vm.appAuzMode = [
      {code: "authorization_code", name: "授权码模式"}
    ];

    function changeFile() {
      if(vm.file){
        vm.oldFile=vm.file
      }
    }
    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitFile() {
      if(vm.oldFile!="assets/images/logo-header.png"){
        vm.file=vm.oldFile;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    };

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        ////console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.hmsAppAuth.appIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"), $filter('T')("title.confirmTitle"));
      }).error(function (data, status, headers, config) {
        //上传失败
        ////console.log('错误状态: ' + status);
      });
    };

    function save() {
      AppAuthService.insertOrUpdateAppAuth().save(vm.hmsAppAuth, onSuccess, onError);
    };
    function onSuccess(data, headers) {
      //vm.hmsAppAuth=data.rows[0];
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
    }
    function onError(error) {
      ////console.log('error');
    }
    function clear() {
      $state.go('appAuth');
    }
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AppAuthDetailController', AppAuthDetailController);

  AppAuthDetailController.$inject = ['$filter','RoleService','PromptService','AppAuthService', '$scope', '$state', '$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','toastr','entity'];

  function AppAuthDetailController($filter,RoleService,PromptService,AppAuthService, $scope, $state, $localStorage, $sessionStorage, $timeout, Upload, BaseConfig,toastr,entity) {
    var vm = this;
    vm.hmsAppAuth = entity;
    vm.hmsAppAuth.appAuzMode = 'password';
    vm.save = save;
    vm.submitFile = submitFile;
    vm.upload = upload;
    vm.changeType = changeType;
    vm.load=load;
    vm.loadOption = loadOption;
    vm.oldFile="assets/images/logo-header.png";
    vm.changeFile=changeFile;
    vm.clear = clear;
    vm.ischecked="";
    vm.mouseIn="";
    vm.permissions=[];
    vm.option1={
      appId:'',
      optionName:''
    };
    vm.option2={
      appId:'',
      optionName:''
    };
    vm.check=check;
    vm.nocheck=nocheck;
    vm.refreshSecret=refreshSecret;
    vm.savePermission=savePermission;
    vm.getPermission=getPermission;
    vm.saveOptionValue = saveOptionValue;
    vm.permissionData=[];

    vm.load(entity.id);

    vm.initLangs = initLangs;
    vm.showLocale = showLocale;
    vm.localeSure = localeSure;
    vm.clearModel = clearModel;

    function clearModel(){
      $uibModalInstance.dismiss('cancel');
    }

    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
      });
    }
    initLangs();

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.hmsAppAuth.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
          $("input[name='"+name+"_" + langs[i].langCode + "']").val(vm.hmsAppAuth.__tls[name][langs[i].langCode]);
        }
      }
    }

    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.hmsAppAuth.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.hmsAppAuth[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.hmsAppAuth.__tls = __tls;
    }

    vm.file = "";
    vm.appType = [
      {code: "客户端应用", name: "客户端应用"},
      {code: "Web应用", name: "Web应用"}
    ];

    vm.appAuzMode = [
      {code: "password", name: "密码模式"},
      {code: "client_credentials", name: "客户端模式"}
    ];

    function saveOptionValue(option) {
      if(option.optionsValue==true){
        option.optionsValue='Y';
      }else{
        option.optionsValue='N';
      }
      // console.log('----'+angular.toJson(vm.option1));
      AppAuthService.updateOptionValue(option)
        .then(function (data) {
          toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
          vm.ischecked="";
          vm.mouseIn="";
          if(data.rows[0].optionName=='IS_MULTI_CATEGORY'){
            vm.option1 = data.rows[0];
            if(vm.option1.optionsValue=='Y'){
              vm.option1.optionsValue=true;
            }else{
              vm.option1.optionsValue=false;
            }
          }else if(data.rows[0].optionName=='IS_WATER_MARK'){
            vm.option2 = data.rows[0];
            if(vm.option2.optionsValue=='Y'){
              vm.option2.optionsValue=true;
            }else{
              vm.option2.optionsValue=false;
            }
          }
        });
    }

    function changeFile() {
      if(vm.file){
        vm.oldFile=vm.file
      }
    }
    function changeType(){
      if(vm.hmsAppAuth.appType === "客户端应用"){
        vm.hmsAppAuth.appAuzMode = 'password';
        vm.appAuzMode = [
          {code: "password", name: "密码模式"},
          {code: "client_credentials", name: "客户端模式"}
        ];
      }else if(vm.hmsAppAuth.appType === "Web应用"){
        vm.hmsAppAuth.appAuzMode = 'authorization_code';
        vm.appAuzMode = [
          {code: "authorization_code", name: "授权码模式"}
        ];
      }
    }

    function loadOption(option) {
      return AppAuthService.getOptionValue(option)
        .then(function (data) {
          if(data.rows[0].optionName=='IS_MULTI_CATEGORY'){
            vm.option1 = data.rows[0];
            if(vm.option1.optionsValue=='Y'){
              vm.option1.optionsValue=true;
            }else{
              vm.option1.optionsValue=false;
            }
          }else if(data.rows[0].optionName=='IS_WATER_MARK'){
            vm.option2 = data.rows[0];
            if(vm.option2.optionsValue=='Y'){
              vm.option2.optionsValue=true;
            }else{
              vm.option2.optionsValue=false;
            }
          }
        })
    }

    function load(id) {
      if(id){
        AppAuthService.getAppAuth().query({id: id}, function (result) {
          vm.hmsAppAuth = result.rows[0];


          if(vm.hmsAppAuth.isContainsPlugin=='Y')
            vm.hmsAppAuth.isContainsPlugin = true;
          else
            vm.hmsAppAuth.isContainsPlugin = false;

          if(vm.hmsAppAuth.isApp=='Y')
            vm.hmsAppAuth.isApp = true;
          else
            vm.hmsAppAuth.isApp = false;

          //jilu chushizhi fangbian quxiao caozuo
          vm.initIsContainsPlugin = vm.hmsAppAuth.isContainsPlugin;
          vm.initIsApp = vm.hmsAppAuth.isApp;

          vm.option1.appId=vm.hmsAppAuth.appId;
          vm.option1.optionName='IS_MULTI_CATEGORY';
          vm.option2.appId=vm.hmsAppAuth.appId;
          vm.option2.optionName='IS_WATER_MARK';
          vm.loadOption(vm.option1);
          vm.loadOption(vm.option2);
          vm.getPermission();
          vm.oldFile=vm.hmsAppAuth.appIcon;
          if (vm.hmsAppAuth.appType === "客户端应用") {
            vm.appType = [
              {code: "客户端应用", name: "客户端应用"},
              {code: "Web应用", name: "Web应用"}
            ];
          } else if (vm.hmsAppAuth.appType === "Web应用") {
            vm.appAuzMode = [
              {code: "authorization_code", name: "授权码模式"},
            ];
          }
          var appNameList = {};
          var __tls = {};
          RoleService.getRoleLocaleInfo(id, 'com.kohler.iot.integrator.hms.api.entities.HmsAppAuth', 'appName')
            .then(function (data) {
              //deal with the multilanguage field value
              appNameList = {};
              for (var i in data) {
                appNameList[data[i].langCode] = data[i].value;
              }
              __tls['appName'] = appNameList;
              vm.hmsAppAuth.__tls = __tls;
              $("#appNameBtn").attr("disabled", false);
            });
        });
      }
    }
    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitFile() {
      if(vm.oldFile!="assets/images/logo-header.png"){
        vm.file=vm.oldFile;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    };

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        ////console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.hmsAppAuth.appIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"), $filter('T')("title.confirmTitle"));
        vm.save();
      }).error(function (data, status, headers, config) {
        //上传失败
        ////console.log('错误状态: ' + status);
      });
    };

    function save() {
      if(vm.hmsAppAuth.isContainsPlugin==true){
        vm.initIsContainsPlugin = true;
        vm.hmsAppAuth.isContainsPlugin='Y';
      }else{
        vm.initIsContainsPlugin = false;
        vm.hmsAppAuth.isContainsPlugin='N';
      }

      if(vm.hmsAppAuth.isApp==true){
        vm.initIsApp = vm.hmsAppAuth.isApp;
        vm.hmsAppAuth.isApp='Y';

      }else{
        vm.initIsApp = false;
        vm.hmsAppAuth.isApp='N';
      }
      AppAuthService.insertOrUpdateAppAuth().save(vm.hmsAppAuth, onSuccess, onError);
    };
    function onSuccess(data, headers) {
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      if(vm.hmsAppAuth.isContainsPlugin=='Y'){
        vm.hmsAppAuth.isContainsPlugin=true;
      }else{
        vm.hmsAppAuth.isContainsPlugin=false;
      }

      if(vm.hmsAppAuth.isApp=='Y'){
        vm.hmsAppAuth.isApp=true;
      }else{
        vm.hmsAppAuth.isApp=false;
      }
      //vm.hmsAppAuth=data.rows[0];
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      // if(vm.hmsAppAuth.optionsValue=='Y'){
      //   vm.hmsAppAuth.optionsValue=true;
      // }else{
      //   vm.hmsAppAuth.optionsValue=false;
      // }
      vm.ischecked="";
      vm.mouseIn="";
    }
    function onError(error) {
      ////console.log('error');
    }
    function clear() {
      $state.go('appAuth');
    }
    function check(name) {
      vm.ischecked=name;
    }
    function nocheck($event) {
      vm.ischecked="";
      vm.hmsAppAuth.isContainsPlugin = vm.initIsContainsPlugin;
      vm.hmsAppAuth.isApp = vm.initIsApp;

      $event.stopPropagation();
    }
    function refreshSecret() {
      swal({
          title: "您确定吗?",
          text: "您将会刷新AppSecret的值!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "是的, 刷新它!",
          cancelButtonText: "不, 取消刷新!",
          closeOnConfirm: false,
          closeOnCancel: false
        },
        function(isConfirm){
          if (isConfirm) {
            vm.uuid = AppAuthService.generateUUID();
            vm.hmsAppAuth.appSecret = vm.uuid;
            vm.save();
            swal("已刷新!", "您的AppSecret值已经被刷新.", "success");
          } else {
            swal("未刷新", "您取消了刷新 :)", "error");
          }
        });
    }
    function savePermission() {
      vm.permissions=[];
      for(var i=0;i<vm.permissionData.length;i++){
        var permissionId="";
        if(vm.permissionData[i].id){
          permissionId=vm.permissionData[i].id;
        }else{
          permissionId=AppAuthService.generateUUID();
        }
        vm.permissions.push({id:permissionId,dataIcon:vm.permissionData[i].dataIcon,dataId:vm.hmsAppAuth.id,
          dataType:vm.permissionData[i].dataType,dataValue:vm.permissionData[i].dataValue,valueId:vm.permissionData[i].dataId,
          visibilityType:vm.hmsAppAuth.appName})
      }
      AppAuthService.savePermissionData(vm.hmsAppAuth.id).save(vm.permissions, onSuccess, onError);
    }
    function getPermission(){
      AppAuthService.getPermissionData().query({id: vm.hmsAppAuth.id}, function (data){
        vm.result = data.rows;
        for(var i=0;i<vm.result.length;i++){
          vm.permissionData.push({id:vm.result[i].id,dataIcon:vm.result[i].dataIcon,dataType:vm.result[i].dataType,
            dataValue:vm.result[i].dataValue,dataId:vm.result[i].valueId})
        }
      });
    }
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AppAuthDetailNewController', AppAuthDetailNewController);

  AppAuthDetailNewController.$inject = ['toastrConfig','$filter','AppAuthService','PromptService', '$scope', '$state', '$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','toastr','entity'];

  function AppAuthDetailNewController(toastrConfig,$filter,AppAuthService,PromptService, $scope, $state, $localStorage, $sessionStorage, $timeout, Upload, BaseConfig,toastr,entity) {
    var vm = this;
    vm.hmsAppAuth = entity;
    vm.hmsAppAuth.appAuzMode = 'password';
    vm.save = save;
    vm.submitFile = submitFile;
    vm.upload = upload;
    vm.changeType = changeType;
    vm.oldFile="assets/images/logo-header.png";
    vm.changeFile=changeFile;
    vm.clear = clear;

    vm.changeClient = changeClient;

    vm.file = "";

    vm.showLocale = showLocale;
    vm.clearModel = clearModel;
    vm.localeSure = localeSure;
    vm.initLangs = initLangs;
    vm.chooseThisApp = chooseThisApp;

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    vm.appAuzMode = [
      /*{code: "client_credentials", name: "客户端模式"},
      {code: "authorization_code", name: "授权码模式"},
      {code: "implicit", name: "简化模式"}*/
    ];

    vm.clientType = [
      {code: "out", name: $filter('T')("roleManage.out")},
      {code: "in", name: $filter('T')("roleManage.in")}
    ];

    function changeFile() {
      if(vm.file){
        vm.oldFile=vm.file
      }
    }

    function clearModel() {
      //$state.go("messageTemplate",{},{reload: true});
      $uibModalInstance.dismiss('cancel');
    }

    function chooseThisApp(){

      if(vm.hmsAppAuth.isApp == true){
        vm.hmsAppAuth.clientType = "in";
        vm.appAuzMode = [
          {code: "password", name: $filter('T')("appAuth.password")}
        ];
        vm.hmsAppAuth.appAuzMode = "password";
        $("#clientType").attr("disabled","disabled");
      }else{
        $("#clientType").removeAttr("disabled");
      }
    }

    function changeType(){
      if(vm.hmsAppAuth.appType === "客户端应用"){
        vm.hmsAppAuth.appAuzMode = 'password';
        vm.appAuzMode = [
          {code: "password", name: "密码模式"},
          {code: "client_credentials", name: "客户端模式"}
        ];
      }else if(vm.hmsAppAuth.appType === "Web应用"){
        vm.hmsAppAuth.appAuzMode = 'authorization_code';
        vm.appAuzMode = [
          {code: "authorization_code", name: "授权码模式"}
        ];
      }
    }

    function showLocale(name) {
      // According to langs to make inputs.
      $("#localeModal_"+name).modal("show");
      if($.trim($("#localeModelBody_"+name).html()) == "") {
        for (var i in langs) {
          var div = $("<div class='form-group'></div>");
          div.append("<label class='control-label'>" + langs[i].description + "</label>");
          div.append("<input type='text' class='form-control' name='"+name+"_" + langs[i].langCode
            + "' ng-model='vm.hmsAppAuth.__tls." + name + '.' + langs[i].langCode + "'/>");
          $("#localeModelBody_"+name).append(div);
        }
      }
    }
    var langs = [];
    function initLangs() {
      PromptService.selectLang().query(function(data) {
        langs = data.rows;
        $("#appNameBtn").attr("disabled", false);
      });
    }
    initLangs();


    function localeSure(name) {
      // console.log(window.localStorage.lang);
      var __tls = vm.hmsAppAuth.__tls || {};
      var description = {};
      for (var i in langs) {
        description[langs[i].langCode] = $("input[name='"+name+"_" + langs[i].langCode + "']").val();
      }
      // console.log(description);
      vm.hmsAppAuth[name] = $("input[name='"+name+"_" + (window.localStorage.lang || 'en_GB') + "']").val();
      $("#localeModal_"+name).modal("hide");
      __tls[name] = description;
      vm.hmsAppAuth.__tls = __tls;
    }

    function changeClient(){
      if(vm.hmsAppAuth.clientType=="out"){
        vm.appAuzMode = [
          {code: "client_credentials", name: $filter('T')("appAuth.clientCredentials")},
          {code: "authorization_code", name: $filter('T')("appAuth.authorizationCode")},
          {code: "implicit", name: $filter('T')("appAuth.implicit")},
          {code: "password", name: $filter('T')("appAuth.password")}
        ];
        vm.hmsAppAuth.isApp = "N";
      }
      if(vm.hmsAppAuth.clientType=="in"){
        vm.appAuzMode = [
          {code: "password", name: $filter('T')("appAuth.password")}
        ];
      }
    }

    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitFile() {
      if(vm.oldFile!="assets/images/logo-header.png"){
        vm.file=vm.oldFile;
      }
      if(vm.file=="assets/images/logo-header.png"){
        toastr.error($filter('T')("uploadImg.pleaseUploadImg"), $filter('T')("title.ErrorInfo"));
        return;
      }
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    };

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/menu/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        ////console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.hmsAppAuth.appIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"), $filter('T')("title.confirmTitle"));
      }).error(function (data, status, headers, config) {
        //上传失败
        ////console.log('错误状态: ' + status);
      });
    };

    function save() {
      if(vm.hmsAppAuth.appIcon==""||vm.hmsAppAuth.appIcon==undefined||vm.hmsAppAuth.appIcon==null){
        vm.hmsAppAuth.appIcon="assets/images/logo-header.png";
      }
      if(vm.hmsAppAuth.isContainsPlugin==true){
        vm.hmsAppAuth.isContainsPlugin = "Y";
      }else{
        vm.hmsAppAuth.isContainsPlugin = "N";
      }

      if(vm.hmsAppAuth.isApp==true){
        vm.hmsAppAuth.isApp = "Y";
      }else{
        vm.hmsAppAuth.isApp = "N";
      }
      AppAuthService.insertOrUpdateAppAuth().save(vm.hmsAppAuth, onSuccess, onError);
    };
    function onSuccess(data, headers) {
      //vm.hmsAppAuth=data.rows[0];
      if(data.code=='repeat'){
        toastr.warning($filter('T')('distribution.repeatNot'));
        return;
      }
      toastr.success($filter('T')('title.saveSuccess'),$filter('T')('title.confirmTitle'));
      $state.go('appAuth');

    }
    function onError(error) {
      ////console.log('error');
    }
    function clear() {
      $state.go('appAuth');
    }
  }
})();

/**
 * Created by xincai.zhang on 2016/8/12.
 */


(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AddAppConfigController', AddAppConfigController);

  AddAppConfigController.$inject = ['$filter','AppAuthService','toastrConfig', '$scope', '$state', '$uibModalInstance', '$localStorage', '$sessionStorage', '$timeout', 'Upload', 'BaseConfig','toastr'];

  function AddAppConfigController($filter,AppAuthService, $scope,toastrConfig, $state, $uibModalInstance, $localStorage, $sessionStorage, $timeout, Upload, BaseConfig,toastr) {
    var vm = this;
    vm.hmsAppAuth = {};
    vm.hmsAppAuth.appAuzMode = 'password';
    vm.hmsAppAuth.appType = '客户端应用';
    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    vm.clear = clear;
    vm.add = add;
    vm.submitFile = submitFile;
    vm.upload = upload;
    vm.changeType = changeType;


    vm.file = ""
    vm.appType = [
      {code: "客户端应用", name: "客户端应用"},
      {code: "Web应用", name: "Web应用"}
    ];

    vm.appAuzMode = [
      {code: "password", name: "密码模式"},
      {code: "client_credentials", name: "客户端模式"}
    ];

    function changeType(){
      if(vm.hmsAppAuth.appType === "客户端应用"){
        vm.hmsAppAuth.appAuzMode = 'password';
        vm.appAuzMode = [
          {code: "password", name: "密码模式"},
          {code: "client_credentials", name: "客户端模式"}
        ];
      }else if(vm.hmsAppAuth.appType === "Web应用"){
        vm.hmsAppAuth.appAuzMode = 'authorization_code';
        vm.appAuzMode = [
          {code: "authorization_code", name: "授权码模式"},
        ];
      }
    };

    //图片上传
    vm.uploadImg = '';
    vm.varMay = true;
    vm.varMays = false;
    vm.imgShow = false;
    //提交
    function submitFile() {
      upload(vm.file);
      if (vm.file != null && vm.file != undefined && vm.file != "") {
        vm.imgShow = true;
      } else {
        vm.imgShow = false;
      }
    };

    function upload(file) {
      vm.fileInfo = file;
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      Upload.upload({
        //服务端接收
        url: BaseConfig.url + '/api/imageUpload',
        headers: {
          'Authorization': 'Bearer ' + token.access_token,
          'X-Requested-With': 'XMLHttpRequest',
          'requestFrom': 'admin'
        },
        //上传的文件
        data: {file: file}
      }).progress(function (evt) {
        //进度条
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      }).success(function (data, status, headers, config) {
        //上传成功
        ////console.log("服务器返回的数据：", angular.toJson(data));
        //vm.hmsAppAuth.appIcon = data.rows[0].imgThumbnailUrl;
        vm.hmsAppAuth.appIcon = data.rows[0].objectUrl;
        if (data.rows.length > 0) {
          vm.varMay = false;
          vm.varMays = true;
        } else {
          vm.varMay = true;
          vm.varMays = false;
        }
        vm.uploadImg = data;
        toastr.success($filter('T')("uploadImg.uploadSuccess"), $filter('T')("title.confirmTitle"));
      }).error(function (data, status, headers, config) {
        //上传失败
        ////console.log('错误状态: ' + status);
      });
    };

    function add() {
      AppAuthService.insertOrUpdateAppAuth().save(vm.hmsAppAuth, onSuccess, onError);
    };
    function onSuccess(data, headers) {
      toastr.success($filter('T')("title.saveSuccess"), $filter('T')("title.confirmTitle"));
      $uibModalInstance.close(data);
    }

    function onError(error) {
      ////console.log('error');
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }


  }


})();

/**
 * Created by zhouzy on 2016/11/10 0010.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('accountRole', {
        parent: 'app',
        url: "/accountRole",
        views: {
          'body': {
            templateUrl: "app/accountRole/accountRole.html",
            controller: 'AccountRoleController',
            controllerAs: 'vm'
          }
        }
      })
/*      .state('contacts.tag', {
        parent: 'contacts',
        url: "/tag",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/contacts/tag-dialog.html',
            controller: 'TagDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  tagName: null
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
              //console.log("contacts.detail1");
            }, function () {
              $state.go('contacts');
              //console.log("contacts.detail2");
            });
        }]
      })

      .state('contacts.addDept', {
        parent: 'app',
        url: "/dept/add/:id",
        views: {
          'body': {
            templateUrl: "app/contacts/dept-new.html",
            controller: 'DeptNewController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  parentDeptNumber: $stateParams.id
                };
              }
            }
          }
        }
      })
      .state('contacts.editDept', {
        parent: 'app',
        url: "/dept/edit/:deptName&:deptNumber",
        views: {
          'body': {
            templateUrl: "app/contacts/dept-new.html",
            controller: 'DeptNewController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  deptName: $stateParams.deptName,
                  deptNumber: $stateParams.deptNumber
                };
              }
            }
          }
        }
      })
      .state('contacts.dialogStaff', {
        parent: 'contacts',
        url: "/contacts/staffEdit/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/contacts/staff-detail-dialog.html",
            controller: 'StaffDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  accountNumber: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
              //console.log("contacts.detail1");
            }, function () {
              $state.go('contacts');
              //console.log("contacts.detail2");
            });
        }]
      })
      .state('contacts.addStaff', {
        parent: 'contacts',
        url: "/contacts/staffAdd/:id",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: "app/contacts/staff-detail-add.html",
            controller: 'StaffAddController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  departmentId: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
              //console.log("contacts.detail1");
            }, function () {
              $state.go('contacts');
              //console.log("contacts.detail2");
            });
        }]
      })
      .state('contacts.new', {
        parent: 'contacts',
        url: "/new",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          //console.log($uibModal);
          $uibModal.open({
            templateUrl: 'app/sysConfig/sysConfig-dialog.html',
            controller: 'SysConfigDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  id: null,
                  configKey: null,
                  configValue: null,
                  configLevel: null,
                  enable: 'Y',
                  configDesc: null
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
            }, function () {
              $state.go('contacts');
            });
        }]
      })
      .state('contacts.importStaff', {
        parent: 'contacts',
        url: "/dept/import",
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'app/contacts/staff-detail-import.html',
            controller: 'StaffImportController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              entity: function () {
                return {
                  parentDeptNumber: $stateParams.id
                };
              }
            }
          }).result.then(function () {
              $state.go('contacts', null, {reload: true});
              //console.log("contacts.detail1");
            }, function () {
              $state.go('contacts');
              //console.log("contacts.detail2");
            });
        }]
      })*/
      ;
  }
})();

/**
 * Created by zhouzy on 2016/11/10 0010.
 */
(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('AccountRoleService', AccountRoleService);

  AccountRoleService.$inject = ['$resource','$http'];

  function AccountRoleService($resource,$http) {
   /* var newTag = {};*/
    var service = {
      findAllRole: findAllRole,
      findRoleMemberByRoleId:findRoleMemberByRoleId,
      saveAdmin:saveAdmin
    };
    return service;

    function findAllRole() {
      var resourceUrl = '/api/accountRole/getAllRole';
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      });
    }

    function findRoleMemberByRoleId(roleId,page,pagesize) {
      var resourceUrl = '/api/accountRole/getAllRoleMemberByRoleId?roleId='+roleId+'&page='+page+'&pagesize='+pagesize;
      return $http.get(resourceUrl).then(function(response){
        return response.data;
      });
    }

    function saveAdmin(data) {
      var resourceUrl = '/api/accountRole/save';
      return $http.post(resourceUrl, data, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(function (response) {
        return response.data;
      })
    }

  }

})();

/**
 * Created by zhouzy on 2016/11/10 0010.
 */
/**
 * Created by zhouzy on 2016/8/18 0018.
 */
(function () {
  'use strict';

  angular
    .module('hmapFront')
    .controller('AccountRoleController', AccountRoleController);

  AccountRoleController.$inject = ['$state', 'AccountRoleService','toastrConfig', 'paginationConstants', '$log', '$scope', '$uibModal', 'Hmapfe', 'toastr', '$localStorage', 'BaseConfig', '$sessionStorage'];

  function AccountRoleController($state, AccountRoleService,toastrConfig, paginationConstants, $log, $scope, $uibModal, Hmapfe, toastr, $localStorage, BaseConfig, $sessionStorage) {
    var vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.allAccountRole = [];
    vm.roleMembers = [];
    vm.currentRole = {};
    vm.permissionData=[];
    vm.saveAccountStaff={
      accountId:'',
      roleId:''
    };

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    vm.selectRole=selectRole;
    vm.getAllRole = getAllRole;
    vm.pageChanged = pageChanged;
    vm.transition = transition;
    vm.getAllRole();
    var page = vm.page;
    var pagesize = paginationConstants.itemsPerPage;

    function getAllRole() {
      AccountRoleService.findAllRole()
        .then(function (data) {
          // console.log('所有的角色信息：'+angular.toJson(data));
          vm.allAccountRole=data.rows;
          vm.currentRole = vm.allAccountRole[0];
          selectRole(vm.currentRole);
        })
    }

    function selectRole(role) {
      // console.log('vm.prome'+angular.toJson(vm.permissionData));
      if (role != undefined && role != null) {
        vm.currentRole = role;
        findRoleMembers(role.roleId,page,pagesize);
      }
    }

    function findRoleMembers(roleId,page,pagesize) {
      AccountRoleService.findRoleMemberByRoleId(roleId,page,pagesize)
        .then(function (data) {
          // console.log('此角色的成员有：'+angular.toJson(data));
          vm.roleMembers=data.rows;
          vm.totalItems = data.total;
        })
    }

    function pageChanged() {
      findRoleMembers(vm.currentRole.roleId,vm.page, paginationConstants.itemsPerPage);
    };

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    $scope.$watch('vm.permissionData',function (newValue, oldValue) {
      if(newValue.length>0&&vm.currentRole){
        vm.saveAccountStaff.accountId=newValue[0].dataId;
        vm.saveAccountStaff.roleId=vm.currentRole.roleId;
        if(vm.saveAccountStaff!={}){
          swal({
              title: "您确定吗?",
              text: "您将添加一个管理员到"+vm.currentRole.roleName+"!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "是的, 添加!",
              cancelButtonText: "不, 取消!",
              closeOnConfirm: false,
              closeOnCancel: false
            },
            function(isConfirm){
              if (isConfirm) {
                AccountRoleService.saveAdmin(vm.saveAccountStaff)
                  .then(function (data) {
                    // console.log('data-->'+angular.toJson(data));
                    if(data.success==true){
                      vm.saveAccountStaff={
                        accountId:'',
                        roleId:''
                      };
                      swal("已添加!", "您已经添加管理员.", "success");
                      $state.go('accountRole', null, {reload: true});
                    }else{
                      swal("添加失败", "您添加失败 :)", "error");
                    }
                  })
              } else {
                swal("未添加", "您取消添加 :)", "error");
              }
            });
        }
      }
    })



   /* vm.currentUserName = $sessionStorage.user.partyAccount;
    vm.page = 1;
    vm.isStaffShow = false;
    vm.isSpinnerShow = false;
    vm.isOrgShow = true;
    vm.isTagShow = false;
    vm.isChoiceDept = false;
    vm.totalItems = null;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.jsTreeData = [];
    vm.deptData = [];
    vm.dept = {};
    vm.treeConfig = {};
    vm.treeInstance = {};
    vm.currentDept = {};
    vm.checkedNodes = [];
    vm.allDepts = [];
    vm.allTags = [];
    vm.currentTag = {};
    vm.tagMembers = [];
    vm.staffs = [];
    vm.treeEventsObj = {};
    vm.loadAll = loadAll;
    vm.initData = initData;
    vm.getSelectedNode = getSelectedNode;
    vm.generateTreeData = generateTreeData;
    vm.selectOrg = selectOrg;
    vm.selectTag = selectTag;
    vm.getAllTags = getAllTags;
    vm.openTagModal = openTagModal;
    vm.updateTag = updateTag;
    vm.lockTag = lockTag;
    vm.deleteTag = deleteTag;
    vm.deleteTagMembers = deleteTagMembers;
    vm.transition = transition;
    vm.pageChanged = pageChanged;
    vm.tagDetail = tagDetail;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.value = '';
    vm.loadAll();
    vm.getAllTags();
    vm.treeEventsObj = {
      activate_node: select
    };
    vm.exportPath = BaseConfig.url + '/common/staff/exportAllStaff';
    vm.deleteStaff = deleteStaff;


    function select(e, i) {
      vm.currentDept.deptNumber = i.node.id;
      vm.currentDept.deptName = i.node.text;
      loadDeptStaff();
    }

    function loadDeptStaff() {
      vm.jsTreeData = [];
      vm.isStaffShow = false;
      vm.isSpinnerShow = true;
      vm.dept.deptNumber = vm.currentDept.deptNumber;
      vm.isChoiceDept = true;
      vm.dept.page = vm.page;
      vm.dept.pagesize = vm.itemsPerPage;

      Contacts.findDeptStaff().get(vm.dept, onStaffSuccess, onError);
    }

    function loadAll() {
      Contacts.findAllDepts().query({}, onSuccess, onError);
    }

    function initData() {
      vm.treeConfig = {
        core: {
          multiple: true,
          animation: true,
          error: function (error) {
            $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
          },
          check_callback: true,
          worker: true
        },
        'types': {
          'default': {
            'icon': 'fa fa-folder'
          }
        },
        version: 1,
        plugins: ['types', 'dnd']
      };
    }

    function getSelectedNode() {
      vm.checkedNodes = vm.treeInstance.jstree(true).get_selected();
    }

    function generateTreeData() {
      vm.deptData = [];
      var root = {};
      //$log.info(menu);
      //root.id = 0;
      //root.parent = "#";
      //root.text = "企业组织架构";
      //root.state = {opened: true,selected:false};
      //vm.deptData.push(root);

      angular.forEach(vm.allDepts, function (dept) {
        if (dept.id == 1) {
          var root = {};
          root.id = dept.id;
          root.parent = "#";
          root.text = dept.name;
          root.state = {opened: true, selected: false};
          vm.deptData.push(root);
        }
        else {
          var treeNode = {};
          //$log.info(menu);
          treeNode.id = dept.id;
          treeNode.parent = dept.parentId;
          treeNode.text = dept.name;
          treeNode.state = {opened: false, selected: false};
          vm.deptData.push(treeNode);
        }
      });
      //初始化
      vm.currentDept.deptNumber = vm.deptData[0].id;
      vm.currentDept.deptName = vm.deptData[0].text;
      $localStorage.deptData = vm.deptData;
    }

    function onSuccess(data, headers) {
      vm.allDepts = data.rows;
      vm.generateTreeData();
      vm.jsTreeData = [];
      vm.initData();
      angular.copy(vm.deptData, vm.jsTreeData);
      vm.treeConfig.version++;

    }

    function onStaffSuccess(data, headers) {
      vm.staffs = data.rows;
      angular.forEach(vm.staffs, function (staff) {
        staff.checked = false;
      });
      vm.totalItems = data.total;
      vm.isStaffShow = true;
      vm.isSpinnerShow = false;
    }

    function onError(error) {
      toastr.error('操作失败!', '提示信息');
      //console.log('error');
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page
      });
    }

    function pageChanged() {
      //console.log('Page changed to: ' + vm.page);
      loadDeptStaff();
    };

    function selectTag(tag) {
      if (tag != undefined && tag != null) {
        vm.currentTag = tag;
        findTagMembers(vm.currentTag);
      }
      vm.isOrgShow = false;
      vm.isTagShow = true;
    }

    function findTagMembers(obj) {
      Contacts.findTagMemberByTagId().get({tagId: obj.id}, function (result) {

        vm.tagMembers = result.rows;
        angular.forEach(vm.tagMembers, function (tagMember) {
          tagMember.checked = false;
        });

      });
    }


    function selectOrg() {
      vm.isOrgShow = true;
      vm.isTagShow = false;
      //getAllTags
    }

    $scope.$on('handleAddNewTag', function () {
      if (existsInArray(Contacts.newTag, vm.allTags)) {
        vm.allTags.push(Contacts.newTag);
      } else {
        vm.allTags.splice(getPosInArray(Contacts.newTag, vm.allTags), 1);
        vm.allTags.push(Contacts.newTag);
      }

    });


    function existsInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].id === obj.id)
          return false;
      }
      return true;
    }

    function getPosInArray(obj, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].id === obj.id)
          return i;
      }
      return 0;
    }


    function getAllTags() {
      Contacts.getAllTags().get({}, onTagsSuccess, onError);
    }

    function onTagsSuccess(data, headers) {
      vm.allTags = data.rows;
      vm.currentTag = data.rows[0];

      findTagMembers(vm.currentTag);
      $localStorage.allTags = vm.allTags;
    }

    function openTagModal() {
      var modalInstance = $uibModal.open({
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/contacts/tag-dialog.html',
        controller: 'TagDialogController',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              tagName: null
            };
          }
        }
      });
    };
    function updateTag(id) {
      console.log("000000id; " + id);
      var modalInstance = $uibModal.open({
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/contacts/tag-dialog.html',
        controller: 'TagDialogController',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          entity: function () {
            return {
              id: id
            };
          }
        }
      });
    }

    function lockTag(obj, status) {
      var newTag = {};
      angular.copy(obj, newTag);
      newTag.tagStatus = status;
      newTag.tagOwner = vm.currentUserName;
      Contacts.lockTagOrNot().save(newTag, onlockTagsSuccess, onLockError);
    }

    function deleteTag(id) {
      Contacts.deleteTag().save({id: id}, onDelTagsSuccess, onError);
      Hmapfe.log('deleteTag:' + id);
    }

    //选择的标签内容添加到数据表中
    $scope.$on('selectDataToTag', function (event, data) {
      var tagMembers = [];
      for (var i = 0; i < data.length; i++) {
        var tagMember = {};
        tagMember.tagId = vm.currentTag.id;
        tagMember.memberId = data[i].dataId;
        tagMember.memberType = data[i].dataType;
        tagMembers.push(tagMember);
      }
      Contacts.insertTagMembers().save(tagMembers, onTagMemberSuccess, onTagMemberError);

    });

    function deleteTagMembers() {
      var selectedMembers = [];
      angular.forEach(vm.tagMembers, function (tagMember) {
        if (tagMember.checked == true) {
          selectedMembers.push(tagMember);
        }
      });

      Contacts.deleteTagMember().save(selectedMembers, onDelTagMemberSuccess, onDelTagMemberError);
    }


    function tagDetail() {
      Hmapfe.log('tagDetail');
    }

    function deleteStaff() {
      var newStaff = [];
      angular.forEach(vm.staffs, function (staff) {
        if (staff.checked == true) {
          newStaff.push(staff);
        }

      });
      Contacts.deleteStaff().save(newStaff, onDeleteStaffSuccess, onStaffError);
    }

    function onDeleteStaffSuccess(data, headers) {
      toastr.success('删除成功!', '提示信息');
      loadDeptStaff();
    }

    function onStaffError(data, headers) {
      toastr.error('删除失败!', '提示信息');
    }

    function onDelTagsSuccess(data, headers) {
      toastr.success('删除成功!', '提示信息');
      vm.allTags.splice(getPosInArray(data.rows[0], vm.allTags), 1);
    }

    function onTagMemberSuccess(data, headers) {
      toastr.success('添加成功!', '提示信息');
      findTagMembers(vm.currentTag);

    }

    function onTagMemberError(error) {
      toastr.error('操作失败!', '提示信息');

    }

    function onlockTagsSuccess(data, headers) {
      getAllTags();
      toastr.success('操作成功!', '提示信息');

    }

    function onLockError(error) {
      toastr.error('操作失败!', '提示信息');

    }

    function onDelTagMemberSuccess(data, headers) {
      getAllTags();
      toastr.success('删除成功!', '提示信息');

    }

    function onDelTagMemberError(error) {
      toastr.error('删除失败!', '提示信息');

    }*/


  }


})();

(function() {
  'use strict';
  angular.module('hmapFront').factory('CryptoJS', Crypto);

  function Crypto() {

    var crypto = core();
    base64(crypto);
    sha256(crypto);
    hmac(crypto);
    aes(crypto);

    return {
      toBase64 : toBase64,
      aesEncryptCBC : aesCBCEncrypt,
      SHA256: crypto
    };

    function toBase64(msg) { 
      return crypto.enc.Utf8.parse(msg);
    }

    function aesCBCEncrypt(password, key, iv) {
      return crypto.AES.encrypt(password, key, { iv: iv, mode:crypto.mode.CBC, padding: crypto.pad.Pkcs7});
    }
    
    function base64(CryptoJS) {
      (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;

        /**
         * Base64 encoding strategy.
         */
        var Base64 = C_enc.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var map = this._map;

            // Clamp excess bits
            wordArray.clamp();

            // Convert
            var base64Chars = [];
            for (var i = 0; i < sigBytes; i += 3) {
              var byte1 = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
              var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

              var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

              for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
                base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
              }
            }

            // Add padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              while (base64Chars.length % 4) {
                base64Chars.push(paddingChar);
              }
            }

            return base64Chars.join('');
          },

          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(base64Str) {
            // Shortcuts
            var base64StrLength = base64Str.length;
            var map = this._map;

            // Ignore padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              var paddingIndex = base64Str.indexOf(paddingChar);
              if (paddingIndex != -1) {
                base64StrLength = paddingIndex;
              }
            }

            // Convert
            var words = [];
            var nBytes = 0;
            for (var i = 0; i < base64StrLength; i++) {
              if (i % 4) {
                var bits1 = map.indexOf(base64Str.charAt(i - 1)) << ((i % 4) * 2);
                var bits2 = map.indexOf(base64Str.charAt(i)) >>> (6 - (i % 4) * 2);
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= (bitsCombined) << (24 - (nBytes % 4) * 8);
                nBytes++;
              }
            }

            return WordArray.create(words, nBytes);
          },

          _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
      }());
      return CryptoJS.enc.Base64;
    }

    function core(CryptoJS) {
      /**
       * CryptoJS core components.
       */
      var CryptoJS = CryptoJS || (function(Math, undefined) {
        /**
         * CryptoJS namespace.
         */
        var C = {};

        /**
         * Library namespace.
         */
        var C_lib = C.lib = {};

        /**
         * Base object for prototypal inheritance.
         */
        var Base = C_lib.Base = (function() {
          function F() {
          }

          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(overrides) {
              // Spawn
              F.prototype = this;
              var subtype = new F();

              // Augment
              if (overrides) {
                subtype.mixIn(overrides);
              }

              // Create default initializer
              if (!subtype.hasOwnProperty('init')) {
                subtype.init = function() {
                  subtype.$super.init.apply(this, arguments);
                };
              }

              // Initializer's prototype is the subtype object
              subtype.init.prototype = subtype;

              // Reference supertype
              subtype.$super = this;

              return subtype;
            },

            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var instance = this.extend();
              instance.init.apply(instance, arguments);

              return instance;
            },

            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },

            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(properties) {
              for (var propertyName in properties) {
                if (properties.hasOwnProperty(propertyName)) {
                  this[propertyName] = properties[propertyName];
                }
              }

              // IE won't copy toString using the loop above
              if (properties.hasOwnProperty('toString')) {
                this.toString = properties.toString;
              }
            },

            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }());

        /**
         * An array of 32-bit words.
         *
         * @property {Array} words The array of 32-bit words.
         * @property {number} sigBytes The number of significant bytes in this word array.
         */
        var WordArray = C_lib.WordArray = Base.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(words, sigBytes) {
            words = this.words = words || [];

            if (sigBytes != undefined) {
              this.sigBytes = sigBytes;
            }
            else {
              this.sigBytes = words.length * 4;
            }
          },

          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(encoder) {
            return (encoder || Hex).stringify(this);
          },

          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(wordArray) {
            // Shortcuts
            var thisWords = this.words;
            var thatWords = wordArray.words;
            var thisSigBytes = this.sigBytes;
            var thatSigBytes = wordArray.sigBytes;

            // Clamp excess bits
            this.clamp();

            // Concat
            if (thisSigBytes % 4) {
              // Copy one byte at a time
              for (var i = 0; i < thatSigBytes; i++) {
                var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
              }
            }
            else {
              // Copy one word at a time
              for (var i = 0; i < thatSigBytes; i += 4) {
                thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
              }
            }
            this.sigBytes += thatSigBytes;

            // Chainable
            return this;
          },

          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            // Shortcuts
            var words = this.words;
            var sigBytes = this.sigBytes;

            // Clamp
            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
            words.length = Math.ceil(sigBytes / 4);
          },

          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var clone = Base.clone.call(this);
            clone.words = this.words.slice(0);

            return clone;
          },

          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(nBytes) {
            var words = [];

            var r = (function(m_w) {
              var m_w = m_w;
              var m_z = 0x3ade68b1;
              var mask = 0xffffffff;

              return function() {
                m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
                m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
                var result = ((m_z << 0x10) + m_w) & mask;
                result /= 0x100000000;
                result += 0.5;
                return result * (Math.random() > .5 ? 1 : -1);
              }
            });

            for (var i = 0, rcache; i < nBytes; i += 4) {
              var _r = r((rcache || Math.random()) * 0x100000000);

              rcache = _r() * 0x3ade67b7;
              words.push((_r() * 0x100000000) | 0);
            }

            return new WordArray.init(words, nBytes);
          }
        });

        /**
         * Encoder namespace.
         */
        var C_enc = C.enc = {};

        /**
         * Hex encoding strategy.
         */
        var Hex = C_enc.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var hexChars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              hexChars.push((bite >>> 4).toString(16));
              hexChars.push((bite & 0x0f).toString(16));
            }

            return hexChars.join('');
          },

          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(hexStr) {
            // Shortcut
            var hexStrLength = hexStr.length;

            // Convert
            var words = [];
            for (var i = 0; i < hexStrLength; i += 2) {
              words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
            }

            return new WordArray.init(words, hexStrLength / 2);
          }
        };

        /**
         * Latin1 encoding strategy.
         */
        var Latin1 = C_enc.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var latin1Chars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              latin1Chars.push(String.fromCharCode(bite));
            }

            return latin1Chars.join('');
          },

          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(latin1Str) {
            // Shortcut
            var latin1StrLength = latin1Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < latin1StrLength; i++) {
              words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
            }

            return new WordArray.init(words, latin1StrLength);
          }
        };

        /**
         * UTF-8 encoding strategy.
         */
        var Utf8 = C_enc.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(wordArray) {
            try {
              return decodeURIComponent(escape(Latin1.stringify(wordArray)));
            }
            catch (e) {
              throw new Error('Malformed UTF-8 data');
            }
          },

          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(utf8Str) {
            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
          }
        };

        /**
         * Abstract buffered block algorithm template.
         *
         * The property blockSize must be implemented in a concrete subtype.
         *
         * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
         */
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            // Initial values
            this._data = new WordArray.init();
            this._nDataBytes = 0;
          },

          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(data) {
            // Convert string to WordArray, else assume WordArray already
            if (typeof data == 'string') {
              data = Utf8.parse(data);
            }

            // Append
            this._data.concat(data);
            this._nDataBytes += data.sigBytes;
          },

          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(doFlush) {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;
            var dataSigBytes = data.sigBytes;
            var blockSize = this.blockSize;
            var blockSizeBytes = blockSize * 4;

            // Count blocks ready
            var nBlocksReady = dataSigBytes / blockSizeBytes;
            if (doFlush) {
              // Round up to include partial blocks
              nBlocksReady = Math.ceil(nBlocksReady);
            }
            else {
              // Round down to include only full blocks,
              // less the number of blocks that must remain in the buffer
              nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
            }

            // Count words ready
            var nWordsReady = nBlocksReady * blockSize;

            // Count bytes ready
            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

            // Process blocks
            if (nWordsReady) {
              for (var offset = 0; offset < nWordsReady; offset += blockSize) {
                // Perform concrete-algorithm logic
                this._doProcessBlock(dataWords, offset);
              }

              // Remove processed words
              var processedWords = dataWords.splice(0, nWordsReady);
              data.sigBytes -= nBytesReady;
            }

            // Return processed words
            return new WordArray.init(processedWords, nBytesReady);
          },

          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var clone = Base.clone.call(this);
            clone._data = this._data.clone();

            return clone;
          },

          _minBufferSize: 0
        });

        /**
         * Abstract hasher template.
         *
         * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
         */
        var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
          /**
           * Configuration options.
           */
          cfg: Base.extend(),

          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(cfg) {
            // Apply config defaults
            this.cfg = this.cfg.extend(cfg);

            // Set initial values
            this.reset();
          },

          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            // Reset data buffer
            BufferedBlockAlgorithm.reset.call(this);

            // Perform concrete-hasher logic
            this._doReset();
          },

          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(messageUpdate) {
            // Append
            this._append(messageUpdate);

            // Update the hash
            this._process();

            // Chainable
            return this;
          },

          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(messageUpdate) {
            // Final message update
            if (messageUpdate) {
              this._append(messageUpdate);
            }

            // Perform concrete-hasher logic
            var hash = this._doFinalize();

            return hash;
          },

          blockSize: 512 / 32,

          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(hasher) {
            return function(message, cfg) {
              return new hasher.init(cfg).finalize(message);
            };
          },

          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(hasher) {
            return function(message, key) {
              return new C_algo.HMAC.init(hasher, key).finalize(message);
            };
          }
        });

        /**
         * Algorithm namespace.
         */
        var C_algo = C.algo = {};

        return C;
      }(Math));
      return CryptoJS;
    }

    function sha256(CryptoJS) {

      (function(Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Initialization and round constants tables
        var H = [];
        var K = [];

        // Compute constants
        (function() {
          function isPrime(n) {
            var sqrtN = Math.sqrt(n);
            for (var factor = 2; factor <= sqrtN; factor++) {
              if (!(n % factor)) {
                return false;
              }
            }

            return true;
          }

          function getFractionalBits(n) {
            return ((n - (n | 0)) * 0x100000000) | 0;
          }

          var n = 2;
          var nPrime = 0;
          while (nPrime < 64) {
            if (isPrime(n)) {
              if (nPrime < 8) {
                H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
              }
              K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

              nPrime++;
            }

            n++;
          }
        }());

        // Reusable object
        var W = [];

        /**
         * SHA-256 hash algorithm.
         */
        var SHA256 = C_algo.SHA256 = Hasher.extend({
          _doReset: function() {
            this._hash = new WordArray.init(H.slice(0));
          },

          _doProcessBlock: function(M, offset) {
            // Shortcut
            var H = this._hash.words;

            // Working variables
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];
            var f = H[5];
            var g = H[6];
            var h = H[7];

            // Computation
            for (var i = 0; i < 64; i++) {
              if (i < 16) {
                W[i] = M[offset + i] | 0;
              }
              else {
                var gamma0x = W[i - 15];
                var gamma0 = ((gamma0x << 25) | (gamma0x >>> 7)) ^
                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
                  (gamma0x >>> 3);

                var gamma1x = W[i - 2];
                var gamma1 = ((gamma1x << 15) | (gamma1x >>> 17)) ^
                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
                  (gamma1x >>> 10);

                W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
              }

              var ch = (e & f) ^ (~e & g);
              var maj = (a & b) ^ (a & c) ^ (b & c);

              var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
              var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7) | (e >>> 25));

              var t1 = h + sigma1 + ch + K[i] + W[i];
              var t2 = sigma0 + maj;

              h = g;
              g = f;
              f = e;
              e = (d + t1) | 0;
              d = c;
              c = b;
              b = a;
              a = (t1 + t2) | 0;
            }

            // Intermediate hash value
            H[0] = (H[0] + a) | 0;
            H[1] = (H[1] + b) | 0;
            H[2] = (H[2] + c) | 0;
            H[3] = (H[3] + d) | 0;
            H[4] = (H[4] + e) | 0;
            H[5] = (H[5] + f) | 0;
            H[6] = (H[6] + g) | 0;
            H[7] = (H[7] + h) | 0;
          },

          _doFinalize: function() {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Return final computed hash
            return this._hash;
          },

          clone: function() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });

        C.SHA256 = Hasher._createHelper(SHA256);

        C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
      }(Math));


      return CryptoJS.SHA256;

    }

    function hmac(CryptoJS) {

      (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;

        /**
         * HMAC algorithm.
         */
        var HMAC = C_algo.HMAC = Base.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(hasher, key) {
            // Init hasher
            hasher = this._hasher = new hasher.init();

            // Convert string to WordArray, else assume WordArray already
            if (typeof key == 'string') {
              key = Utf8.parse(key);
            }

            // Shortcuts
            var hasherBlockSize = hasher.blockSize;
            var hasherBlockSizeBytes = hasherBlockSize * 4;

            // Allow arbitrary length keys
            if (key.sigBytes > hasherBlockSizeBytes) {
              key = hasher.finalize(key);
            }

            // Clamp excess bits
            key.clamp();

            // Clone key for inner and outer pads
            var oKey = this._oKey = key.clone();
            var iKey = this._iKey = key.clone();

            // Shortcuts
            var oKeyWords = oKey.words;
            var iKeyWords = iKey.words;

            // XOR keys with pad constants
            for (var i = 0; i < hasherBlockSize; i++) {
              oKeyWords[i] ^= 0x5c5c5c5c;
              iKeyWords[i] ^= 0x36363636;
            }
            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

            // Set initial values
            this.reset();
          },

          reset: function() {
            // Shortcut
            var hasher = this._hasher;

            // Reset
            hasher.reset();
            hasher.update(this._iKey);
          },

          update: function(messageUpdate) {
            this._hasher.update(messageUpdate);

            // Chainable
            return this;
          },

          finalize: function(messageUpdate) {
            // Shortcut
            var hasher = this._hasher;

            // Compute HMAC
            var innerHash = hasher.finalize(messageUpdate);
            hasher.reset();
            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

            return hmac;
          }
        });
      }());


    }

    function aes(CryptoJS) {

      /**
       * CryptoJS core components.
       */
      var CryptoJS = CryptoJS || (function (Math, undefined) {
        /*
	     * Local polyfil of Object.create
	     */
        var create = Object.create || (function () {
          function F() {};

          return function (obj) {
            var subtype;

            F.prototype = obj;

            subtype = new F();

            F.prototype = null;

            return subtype;
          };
        }());

        /**
         * CryptoJS namespace.
         */
        var C = {};

        /**
         * Library namespace.
         */
        var C_lib = C.lib = {};

        /**
         * Base object for prototypal inheritance.
         */
        var Base = C_lib.Base = (function () {


          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function (overrides) {
              // Spawn
              var subtype = create(this);

              // Augment
              if (overrides) {
                subtype.mixIn(overrides);
              }

              // Create default initializer
              if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
                subtype.init = function () {
                  subtype.$super.init.apply(this, arguments);
                };
              }

              // Initializer's prototype is the subtype object
              subtype.init.prototype = subtype;

              // Reference supertype
              subtype.$super = this;

              return subtype;
            },

            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function () {
              var instance = this.extend();
              instance.init.apply(instance, arguments);

              return instance;
            },

            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function () {
            },

            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function (properties) {
              for (var propertyName in properties) {
                if (properties.hasOwnProperty(propertyName)) {
                  this[propertyName] = properties[propertyName];
                }
              }

              // IE won't copy toString using the loop above
              if (properties.hasOwnProperty('toString')) {
                this.toString = properties.toString;
              }
            },

            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function () {
              return this.init.prototype.extend(this);
            }
          };
        }());

        /**
         * An array of 32-bit words.
         *
         * @property {Array} words The array of 32-bit words.
         * @property {number} sigBytes The number of significant bytes in this word array.
         */
        var WordArray = C_lib.WordArray = Base.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function (words, sigBytes) {
            words = this.words = words || [];

            if (sigBytes != undefined) {
              this.sigBytes = sigBytes;
            } else {
              this.sigBytes = words.length * 4;
            }
          },

          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function (encoder) {
            return (encoder || Hex).stringify(this);
          },

          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function (wordArray) {
            // Shortcuts
            var thisWords = this.words;
            var thatWords = wordArray.words;
            var thisSigBytes = this.sigBytes;
            var thatSigBytes = wordArray.sigBytes;

            // Clamp excess bits
            this.clamp();

            // Concat
            if (thisSigBytes % 4) {
              // Copy one byte at a time
              for (var i = 0; i < thatSigBytes; i++) {
                var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
              }
            } else {
              // Copy one word at a time
              for (var i = 0; i < thatSigBytes; i += 4) {
                thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
              }
            }
            this.sigBytes += thatSigBytes;

            // Chainable
            return this;
          },

          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function () {
            // Shortcuts
            var words = this.words;
            var sigBytes = this.sigBytes;

            // Clamp
            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
            words.length = Math.ceil(sigBytes / 4);
          },

          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function () {
            var clone = Base.clone.call(this);
            clone.words = this.words.slice(0);

            return clone;
          },

          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function (nBytes) {
            var words = [];

            var r = (function (m_w) {
              var m_w = m_w;
              var m_z = 0x3ade68b1;
              var mask = 0xffffffff;

              return function () {
                m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
                m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
                var result = ((m_z << 0x10) + m_w) & mask;
                result /= 0x100000000;
                result += 0.5;
                return result * (Math.random() > .5 ? 1 : -1);
              }
            });

            for (var i = 0, rcache; i < nBytes; i += 4) {
              var _r = r((rcache || Math.random()) * 0x100000000);

              rcache = _r() * 0x3ade67b7;
              words.push((_r() * 0x100000000) | 0);
            }

            return new WordArray.init(words, nBytes);
          }
        });

        /**
         * Encoder namespace.
         */
        var C_enc = C.enc = {};

        /**
         * Hex encoding strategy.
         */
        var Hex = C_enc.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var hexChars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              hexChars.push((bite >>> 4).toString(16));
              hexChars.push((bite & 0x0f).toString(16));
            }

            return hexChars.join('');
          },

          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function (hexStr) {
            // Shortcut
            var hexStrLength = hexStr.length;

            // Convert
            var words = [];
            for (var i = 0; i < hexStrLength; i += 2) {
              words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
            }

            return new WordArray.init(words, hexStrLength / 2);
          }
        };

        /**
         * Latin1 encoding strategy.
         */
        var Latin1 = C_enc.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var latin1Chars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
              latin1Chars.push(String.fromCharCode(bite));
            }

            return latin1Chars.join('');
          },

          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function (latin1Str) {
            // Shortcut
            var latin1StrLength = latin1Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < latin1StrLength; i++) {
              words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
            }

            return new WordArray.init(words, latin1StrLength);
          }
        };

        /**
         * UTF-8 encoding strategy.
         */
        var Utf8 = C_enc.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function (wordArray) {
            try {
              return decodeURIComponent(escape(Latin1.stringify(wordArray)));
            } catch (e) {
              throw new Error('Malformed UTF-8 data');
            }
          },

          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function (utf8Str) {
            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
          }
        };

        /**
         * Abstract buffered block algorithm template.
         *
         * The property blockSize must be implemented in a concrete subtype.
         *
         * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
         */
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function () {
            // Initial values
            this._data = new WordArray.init();
            this._nDataBytes = 0;
          },

          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function (data) {
            // Convert string to WordArray, else assume WordArray already
            if (typeof data == 'string') {
              data = Utf8.parse(data);
            }

            // Append
            this._data.concat(data);
            this._nDataBytes += data.sigBytes;
          },

          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function (doFlush) {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;
            var dataSigBytes = data.sigBytes;
            var blockSize = this.blockSize;
            var blockSizeBytes = blockSize * 4;

            // Count blocks ready
            var nBlocksReady = dataSigBytes / blockSizeBytes;
            if (doFlush) {
              // Round up to include partial blocks
              nBlocksReady = Math.ceil(nBlocksReady);
            } else {
              // Round down to include only full blocks,
              // less the number of blocks that must remain in the buffer
              nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
            }

            // Count words ready
            var nWordsReady = nBlocksReady * blockSize;

            // Count bytes ready
            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

            // Process blocks
            if (nWordsReady) {
              for (var offset = 0; offset < nWordsReady; offset += blockSize) {
                // Perform concrete-algorithm logic
                this._doProcessBlock(dataWords, offset);
              }

              // Remove processed words
              var processedWords = dataWords.splice(0, nWordsReady);
              data.sigBytes -= nBytesReady;
            }

            // Return processed words
            return new WordArray.init(processedWords, nBytesReady);
          },

          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function () {
            var clone = Base.clone.call(this);
            clone._data = this._data.clone();

            return clone;
          },

          _minBufferSize: 0
        });

        /**
         * Abstract hasher template.
         *
         * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
         */
        var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
          /**
           * Configuration options.
           */
          cfg: Base.extend(),

          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function (cfg) {
            // Apply config defaults
            this.cfg = this.cfg.extend(cfg);

            // Set initial values
            this.reset();
          },

          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function () {
            // Reset data buffer
            BufferedBlockAlgorithm.reset.call(this);

            // Perform concrete-hasher logic
            this._doReset();
          },

          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function (messageUpdate) {
            // Append
            this._append(messageUpdate);

            // Update the hash
            this._process();

            // Chainable
            return this;
          },

          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function (messageUpdate) {
            // Final message update
            if (messageUpdate) {
              this._append(messageUpdate);
            }

            // Perform concrete-hasher logic
            var hash = this._doFinalize();

            return hash;
          },

          blockSize: 512/32,

          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function (hasher) {
            return function (message, cfg) {
              return new hasher.init(cfg).finalize(message);
            };
          },

          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function (hasher) {
            return function (message, key) {
              return new C_algo.HMAC.init(hasher, key).finalize(message);
            };
          }
        });

        /**
         * Algorithm namespace.
         */
        var C_algo = C.algo = {};

        return C;
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;

        /**
         * Base64 encoding strategy.
         */
        var Base64 = C_enc.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var map = this._map;

            // Clamp excess bits
            wordArray.clamp();

            // Convert
            var base64Chars = [];
            for (var i = 0; i < sigBytes; i += 3) {
              var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
              var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
              var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

              var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

              for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
                base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
              }
            }

            // Add padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              while (base64Chars.length % 4) {
                base64Chars.push(paddingChar);
              }
            }

            return base64Chars.join('');
          },

          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function (base64Str) {
            // Shortcuts
            var base64StrLength = base64Str.length;
            var map = this._map;
            var reverseMap = this._reverseMap;

            if (!reverseMap) {
              reverseMap = this._reverseMap = [];
              for (var j = 0; j < map.length; j++) {
                reverseMap[map.charCodeAt(j)] = j;
              }
            }

            // Ignore padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              var paddingIndex = base64Str.indexOf(paddingChar);
              if (paddingIndex !== -1) {
                base64StrLength = paddingIndex;
              }
            }

            // Convert
            return parseLoop(base64Str, base64StrLength, reverseMap);

          },

          _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };

        function parseLoop(base64Str, base64StrLength, reverseMap) {
          var words = [];
          var nBytes = 0;
          for (var i = 0; i < base64StrLength; i++) {
            if (i % 4) {
              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
              nBytes++;
            }
          }
          return WordArray.create(words, nBytes);
        }
      }());


      (function (Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Constants table
        var T = [];

        // Compute constants
        (function () {
          for (var i = 0; i < 64; i++) {
            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
          }
        }());

        /**
         * MD5 hash algorithm.
         */
        var MD5 = C_algo.MD5 = Hasher.extend({
          _doReset: function () {
            this._hash = new WordArray.init([
              0x67452301, 0xefcdab89,
              0x98badcfe, 0x10325476
            ]);
          },

          _doProcessBlock: function (M, offset) {
            // Swap endian
            for (var i = 0; i < 16; i++) {
              // Shortcuts
              var offset_i = offset + i;
              var M_offset_i = M[offset_i];

              M[offset_i] = (
                (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
                (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
              );
            }

            // Shortcuts
            var H = this._hash.words;

            var M_offset_0  = M[offset + 0];
            var M_offset_1  = M[offset + 1];
            var M_offset_2  = M[offset + 2];
            var M_offset_3  = M[offset + 3];
            var M_offset_4  = M[offset + 4];
            var M_offset_5  = M[offset + 5];
            var M_offset_6  = M[offset + 6];
            var M_offset_7  = M[offset + 7];
            var M_offset_8  = M[offset + 8];
            var M_offset_9  = M[offset + 9];
            var M_offset_10 = M[offset + 10];
            var M_offset_11 = M[offset + 11];
            var M_offset_12 = M[offset + 12];
            var M_offset_13 = M[offset + 13];
            var M_offset_14 = M[offset + 14];
            var M_offset_15 = M[offset + 15];

            // Working varialbes
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];

            // Computation
            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
            d = II(d, a, b, c, M_offset_7,  10, T[49]);
            c = II(c, d, a, b, M_offset_14, 15, T[50]);
            b = II(b, c, d, a, M_offset_5,  21, T[51]);
            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
            d = II(d, a, b, c, M_offset_3,  10, T[53]);
            c = II(c, d, a, b, M_offset_10, 15, T[54]);
            b = II(b, c, d, a, M_offset_1,  21, T[55]);
            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
            d = II(d, a, b, c, M_offset_15, 10, T[57]);
            c = II(c, d, a, b, M_offset_6,  15, T[58]);
            b = II(b, c, d, a, M_offset_13, 21, T[59]);
            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
            d = II(d, a, b, c, M_offset_11, 10, T[61]);
            c = II(c, d, a, b, M_offset_2,  15, T[62]);
            b = II(b, c, d, a, M_offset_9,  21, T[63]);

            // Intermediate hash value
            H[0] = (H[0] + a) | 0;
            H[1] = (H[1] + b) | 0;
            H[2] = (H[2] + c) | 0;
            H[3] = (H[3] + d) | 0;
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
            var nBitsTotalL = nBitsTotal;
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
              (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
              (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
            );
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
              (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
              (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
            );

            data.sigBytes = (dataWords.length + 1) * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var hash = this._hash;
            var H = hash.words;

            // Swap endian
            for (var i = 0; i < 4; i++) {
              // Shortcut
              var H_i = H[i];

              H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
                (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
            }

            // Return final computed hash
            return hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });

        function FF(a, b, c, d, x, s, t) {
          var n = a + ((b & c) | (~b & d)) + x + t;
          return ((n << s) | (n >>> (32 - s))) + b;
        }

        function GG(a, b, c, d, x, s, t) {
          var n = a + ((b & d) | (c & ~d)) + x + t;
          return ((n << s) | (n >>> (32 - s))) + b;
        }

        function HH(a, b, c, d, x, s, t) {
          var n = a + (b ^ c ^ d) + x + t;
          return ((n << s) | (n >>> (32 - s))) + b;
        }

        function II(a, b, c, d, x, s, t) {
          var n = a + (c ^ (b | ~d)) + x + t;
          return ((n << s) | (n >>> (32 - s))) + b;
        }

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.MD5('message');
         *     var hash = CryptoJS.MD5(wordArray);
         */
        C.MD5 = Hasher._createHelper(MD5);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacMD5(message, key);
         */
        C.HmacMD5 = Hasher._createHmacHelper(MD5);
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Reusable object
        var W = [];

        /**
         * SHA-1 hash algorithm.
         */
        var SHA1 = C_algo.SHA1 = Hasher.extend({
          _doReset: function () {
            this._hash = new WordArray.init([
              0x67452301, 0xefcdab89,
              0x98badcfe, 0x10325476,
              0xc3d2e1f0
            ]);
          },

          _doProcessBlock: function (M, offset) {
            // Shortcut
            var H = this._hash.words;

            // Working variables
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];

            // Computation
            for (var i = 0; i < 80; i++) {
              if (i < 16) {
                W[i] = M[offset + i] | 0;
              } else {
                var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                W[i] = (n << 1) | (n >>> 31);
              }

              var t = ((a << 5) | (a >>> 27)) + e + W[i];
              if (i < 20) {
                t += ((b & c) | (~b & d)) + 0x5a827999;
              } else if (i < 40) {
                t += (b ^ c ^ d) + 0x6ed9eba1;
              } else if (i < 60) {
                t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
              } else /* if (i < 80) */ {
                t += (b ^ c ^ d) - 0x359d3e2a;
              }

              e = d;
              d = c;
              c = (b << 30) | (b >>> 2);
              b = a;
              a = t;
            }

            // Intermediate hash value
            H[0] = (H[0] + a) | 0;
            H[1] = (H[1] + b) | 0;
            H[2] = (H[2] + c) | 0;
            H[3] = (H[3] + d) | 0;
            H[4] = (H[4] + e) | 0;
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Return final computed hash
            return this._hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA1('message');
         *     var hash = CryptoJS.SHA1(wordArray);
         */
        C.SHA1 = Hasher._createHelper(SHA1);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA1(message, key);
         */
        C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
      }());


      (function (Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Initialization and round constants tables
        var H = [];
        var K = [];

        // Compute constants
        (function () {
          function isPrime(n) {
            var sqrtN = Math.sqrt(n);
            for (var factor = 2; factor <= sqrtN; factor++) {
              if (!(n % factor)) {
                return false;
              }
            }

            return true;
          }

          function getFractionalBits(n) {
            return ((n - (n | 0)) * 0x100000000) | 0;
          }

          var n = 2;
          var nPrime = 0;
          while (nPrime < 64) {
            if (isPrime(n)) {
              if (nPrime < 8) {
                H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
              }
              K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

              nPrime++;
            }

            n++;
          }
        }());

        // Reusable object
        var W = [];

        /**
         * SHA-256 hash algorithm.
         */
        var SHA256 = C_algo.SHA256 = Hasher.extend({
          _doReset: function () {
            this._hash = new WordArray.init(H.slice(0));
          },

          _doProcessBlock: function (M, offset) {
            // Shortcut
            var H = this._hash.words;

            // Working variables
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];
            var f = H[5];
            var g = H[6];
            var h = H[7];

            // Computation
            for (var i = 0; i < 64; i++) {
              if (i < 16) {
                W[i] = M[offset + i] | 0;
              } else {
                var gamma0x = W[i - 15];
                var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
                  (gamma0x >>> 3);

                var gamma1x = W[i - 2];
                var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
                  (gamma1x >>> 10);

                W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
              }

              var ch  = (e & f) ^ (~e & g);
              var maj = (a & b) ^ (a & c) ^ (b & c);

              var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
              var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

              var t1 = h + sigma1 + ch + K[i] + W[i];
              var t2 = sigma0 + maj;

              h = g;
              g = f;
              f = e;
              e = (d + t1) | 0;
              d = c;
              c = b;
              b = a;
              a = (t1 + t2) | 0;
            }

            // Intermediate hash value
            H[0] = (H[0] + a) | 0;
            H[1] = (H[1] + b) | 0;
            H[2] = (H[2] + c) | 0;
            H[3] = (H[3] + d) | 0;
            H[4] = (H[4] + e) | 0;
            H[5] = (H[5] + f) | 0;
            H[6] = (H[6] + g) | 0;
            H[7] = (H[7] + h) | 0;
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Return final computed hash
            return this._hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA256('message');
         *     var hash = CryptoJS.SHA256(wordArray);
         */
        C.SHA256 = Hasher._createHelper(SHA256);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA256(message, key);
         */
        C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;

        /**
         * UTF-16 BE encoding strategy.
         */
        var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var utf16Chars = [];
            for (var i = 0; i < sigBytes; i += 2) {
              var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
              utf16Chars.push(String.fromCharCode(codePoint));
            }

            return utf16Chars.join('');
          },

          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function (utf16Str) {
            // Shortcut
            var utf16StrLength = utf16Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < utf16StrLength; i++) {
              words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
            }

            return WordArray.create(words, utf16StrLength * 2);
          }
        };

        /**
         * UTF-16 LE encoding strategy.
         */
        C_enc.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var utf16Chars = [];
            for (var i = 0; i < sigBytes; i += 2) {
              var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
              utf16Chars.push(String.fromCharCode(codePoint));
            }

            return utf16Chars.join('');
          },

          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function (utf16Str) {
            // Shortcut
            var utf16StrLength = utf16Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < utf16StrLength; i++) {
              words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
            }

            return WordArray.create(words, utf16StrLength * 2);
          }
        };

        function swapEndian(word) {
          return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
        }
      }());


      (function () {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') {
          return;
        }

        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;

        // Reference original init
        var superInit = WordArray.init;

        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function (typedArray) {
          // Convert buffers to uint8
          if (typedArray instanceof ArrayBuffer) {
            typedArray = new Uint8Array(typedArray);
          }

          // Convert other array views to uint8
          if (
            typedArray instanceof Int8Array ||
            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
            typedArray instanceof Int16Array ||
            typedArray instanceof Uint16Array ||
            typedArray instanceof Int32Array ||
            typedArray instanceof Uint32Array ||
            typedArray instanceof Float32Array ||
            typedArray instanceof Float64Array
          ) {
            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
          }

          // Handle Uint8Array
          if (typedArray instanceof Uint8Array) {
            // Shortcut
            var typedArrayByteLength = typedArray.byteLength;

            // Extract bytes
            var words = [];
            for (var i = 0; i < typedArrayByteLength; i++) {
              words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
            }

            // Initialize this word array
            superInit.call(this, words, typedArrayByteLength);
          } else {
            // Else call normal init
            superInit.apply(this, arguments);
          }
        };

        subInit.prototype = WordArray;
      }());


      /** @preserve
       (c) 2012 by Cédric Mesnil. All rights reserved.

       Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

       - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
       - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

       THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
       */

      (function (Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;

        // Constants table
        var _zl = WordArray.create([
          0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
          7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
          3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
          1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
          4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
        var _zr = WordArray.create([
          5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
          6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
          15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
          8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
          12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
        var _sl = WordArray.create([
          11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
          7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
          11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
          9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
        var _sr = WordArray.create([
          8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
          9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
          9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
          15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
          8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

        var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
        var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

        /**
         * RIPEMD160 hash algorithm.
         */
        var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
          _doReset: function () {
            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
          },

          _doProcessBlock: function (M, offset) {

            // Swap endian
            for (var i = 0; i < 16; i++) {
              // Shortcuts
              var offset_i = offset + i;
              var M_offset_i = M[offset_i];

              // Swap
              M[offset_i] = (
                (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
                (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
              );
            }
            // Shortcut
            var H  = this._hash.words;
            var hl = _hl.words;
            var hr = _hr.words;
            var zl = _zl.words;
            var zr = _zr.words;
            var sl = _sl.words;
            var sr = _sr.words;

            // Working variables
            var al, bl, cl, dl, el;
            var ar, br, cr, dr, er;

            ar = al = H[0];
            br = bl = H[1];
            cr = cl = H[2];
            dr = dl = H[3];
            er = el = H[4];
            // Computation
            var t;
            for (var i = 0; i < 80; i += 1) {
              t = (al +  M[offset+zl[i]])|0;
              if (i<16){
                t +=  f1(bl,cl,dl) + hl[0];
              } else if (i<32) {
                t +=  f2(bl,cl,dl) + hl[1];
              } else if (i<48) {
                t +=  f3(bl,cl,dl) + hl[2];
              } else if (i<64) {
                t +=  f4(bl,cl,dl) + hl[3];
              } else {// if (i<80) {
                t +=  f5(bl,cl,dl) + hl[4];
              }
              t = t|0;
              t =  rotl(t,sl[i]);
              t = (t+el)|0;
              al = el;
              el = dl;
              dl = rotl(cl, 10);
              cl = bl;
              bl = t;

              t = (ar + M[offset+zr[i]])|0;
              if (i<16){
                t +=  f5(br,cr,dr) + hr[0];
              } else if (i<32) {
                t +=  f4(br,cr,dr) + hr[1];
              } else if (i<48) {
                t +=  f3(br,cr,dr) + hr[2];
              } else if (i<64) {
                t +=  f2(br,cr,dr) + hr[3];
              } else {// if (i<80) {
                t +=  f1(br,cr,dr) + hr[4];
              }
              t = t|0;
              t =  rotl(t,sr[i]) ;
              t = (t+er)|0;
              ar = er;
              er = dr;
              dr = rotl(cr, 10);
              cr = br;
              br = t;
            }
            // Intermediate hash value
            t    = (H[1] + cl + dr)|0;
            H[1] = (H[2] + dl + er)|0;
            H[2] = (H[3] + el + ar)|0;
            H[3] = (H[4] + al + br)|0;
            H[4] = (H[0] + bl + cr)|0;
            H[0] =  t;
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
              (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
              (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
            );
            data.sigBytes = (dataWords.length + 1) * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var hash = this._hash;
            var H = hash.words;

            // Swap endian
            for (var i = 0; i < 5; i++) {
              // Shortcut
              var H_i = H[i];

              // Swap
              H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
                (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
            }

            // Return final computed hash
            return hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          }
        });


        function f1(x, y, z) {
          return ((x) ^ (y) ^ (z));

        }

        function f2(x, y, z) {
          return (((x)&(y)) | ((~x)&(z)));
        }

        function f3(x, y, z) {
          return (((x) | (~(y))) ^ (z));
        }

        function f4(x, y, z) {
          return (((x) & (z)) | ((y)&(~(z))));
        }

        function f5(x, y, z) {
          return ((x) ^ ((y) |(~(z))));

        }

        function rotl(x,n) {
          return (x<<n) | (x>>>(32-n));
        }


        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.RIPEMD160('message');
         *     var hash = CryptoJS.RIPEMD160(wordArray);
         */
        C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
         */
        C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;

        /**
         * HMAC algorithm.
         */
        var HMAC = C_algo.HMAC = Base.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function (hasher, key) {
            // Init hasher
            hasher = this._hasher = new hasher.init();

            // Convert string to WordArray, else assume WordArray already
            if (typeof key == 'string') {
              key = Utf8.parse(key);
            }

            // Shortcuts
            var hasherBlockSize = hasher.blockSize;
            var hasherBlockSizeBytes = hasherBlockSize * 4;

            // Allow arbitrary length keys
            if (key.sigBytes > hasherBlockSizeBytes) {
              key = hasher.finalize(key);
            }

            // Clamp excess bits
            key.clamp();

            // Clone key for inner and outer pads
            var oKey = this._oKey = key.clone();
            var iKey = this._iKey = key.clone();

            // Shortcuts
            var oKeyWords = oKey.words;
            var iKeyWords = iKey.words;

            // XOR keys with pad constants
            for (var i = 0; i < hasherBlockSize; i++) {
              oKeyWords[i] ^= 0x5c5c5c5c;
              iKeyWords[i] ^= 0x36363636;
            }
            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

            // Set initial values
            this.reset();
          },

          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function () {
            // Shortcut
            var hasher = this._hasher;

            // Reset
            hasher.reset();
            hasher.update(this._iKey);
          },

          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function (messageUpdate) {
            this._hasher.update(messageUpdate);

            // Chainable
            return this;
          },

          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function (messageUpdate) {
            // Shortcut
            var hasher = this._hasher;

            // Compute HMAC
            var innerHash = hasher.finalize(messageUpdate);
            hasher.reset();
            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

            return hmac;
          }
        });
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA1 = C_algo.SHA1;
        var HMAC = C_algo.HMAC;

        /**
         * Password-Based Key Derivation Function 2 algorithm.
         */
        var PBKDF2 = C_algo.PBKDF2 = Base.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA1
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: Base.extend({
            keySize: 128/32,
            hasher: SHA1,
            iterations: 1
          }),

          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function (cfg) {
            this.cfg = this.cfg.extend(cfg);
          },

          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function (password, salt) {
            // Shortcut
            var cfg = this.cfg;

            // Init HMAC
            var hmac = HMAC.create(cfg.hasher, password);

            // Initial values
            var derivedKey = WordArray.create();
            var blockIndex = WordArray.create([0x00000001]);

            // Shortcuts
            var derivedKeyWords = derivedKey.words;
            var blockIndexWords = blockIndex.words;
            var keySize = cfg.keySize;
            var iterations = cfg.iterations;

            // Generate key
            while (derivedKeyWords.length < keySize) {
              var block = hmac.update(salt).finalize(blockIndex);
              hmac.reset();

              // Shortcuts
              var blockWords = block.words;
              var blockWordsLength = blockWords.length;

              // Iterations
              var intermediate = block;
              for (var i = 1; i < iterations; i++) {
                intermediate = hmac.finalize(intermediate);
                hmac.reset();

                // Shortcut
                var intermediateWords = intermediate.words;

                // XOR intermediate with block
                for (var j = 0; j < blockWordsLength; j++) {
                  blockWords[j] ^= intermediateWords[j];
                }
              }

              derivedKey.concat(block);
              blockIndexWords[0]++;
            }
            derivedKey.sigBytes = keySize * 4;

            return derivedKey;
          }
        });

        /**
         * Computes the Password-Based Key Derivation Function 2.
         *
         * @param {WordArray|string} password The password.
         * @param {WordArray|string} salt A salt.
         * @param {Object} cfg (Optional) The configuration options to use for this computation.
         *
         * @return {WordArray} The derived key.
         *
         * @static
         *
         * @example
         *
         *     var key = CryptoJS.PBKDF2(password, salt);
         *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
         *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
         */
        C.PBKDF2 = function (password, salt, cfg) {
          return PBKDF2.create(cfg).compute(password, salt);
        };
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;

        /**
         * This key derivation function is meant to conform with EVP_BytesToKey.
         * www.openssl.org/docs/crypto/EVP_BytesToKey.html
         */
        var EvpKDF = C_algo.EvpKDF = Base.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: Base.extend({
            keySize: 128/32,
            hasher: MD5,
            iterations: 1
          }),

          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function (cfg) {
            this.cfg = this.cfg.extend(cfg);
          },

          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function (password, salt) {
            // Shortcut
            var cfg = this.cfg;

            // Init hasher
            var hasher = cfg.hasher.create();

            // Initial values
            var derivedKey = WordArray.create();

            // Shortcuts
            var derivedKeyWords = derivedKey.words;
            var keySize = cfg.keySize;
            var iterations = cfg.iterations;

            // Generate key
            while (derivedKeyWords.length < keySize) {
              if (block) {
                hasher.update(block);
              }
              var block = hasher.update(password).finalize(salt);
              hasher.reset();

              // Iterations
              for (var i = 1; i < iterations; i++) {
                block = hasher.finalize(block);
                hasher.reset();
              }

              derivedKey.concat(block);
            }
            derivedKey.sigBytes = keySize * 4;

            return derivedKey;
          }
        });

        /**
         * Derives a key from a password.
         *
         * @param {WordArray|string} password The password.
         * @param {WordArray|string} salt A salt.
         * @param {Object} cfg (Optional) The configuration options to use for this computation.
         *
         * @return {WordArray} The derived key.
         *
         * @static
         *
         * @example
         *
         *     var key = CryptoJS.EvpKDF(password, salt);
         *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
         *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
         */
        C.EvpKDF = function (password, salt, cfg) {
          return EvpKDF.create(cfg).compute(password, salt);
        };
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;

        /**
         * SHA-224 hash algorithm.
         */
        var SHA224 = C_algo.SHA224 = SHA256.extend({
          _doReset: function () {
            this._hash = new WordArray.init([
              0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
              0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
            ]);
          },

          _doFinalize: function () {
            var hash = SHA256._doFinalize.call(this);

            hash.sigBytes -= 4;

            return hash;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA224('message');
         *     var hash = CryptoJS.SHA224(wordArray);
         */
        C.SHA224 = SHA256._createHelper(SHA224);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA224(message, key);
         */
        C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
      }());


      (function (undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;

        /**
         * x64 namespace.
         */
        var C_x64 = C.x64 = {};

        /**
         * A 64-bit word.
         */
        var X64Word = C_x64.Word = Base.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function (high, low) {
            this.high = high;
            this.low = low;
          }

          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;

          // return X64Word.create(high, low);
          // },

          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;

          // return X64Word.create(high, low);
          // },

          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;

          // return X64Word.create(high, low);
          // },

          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;

          // return X64Word.create(high, low);
          // },

          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }

          // return X64Word.create(high, low);
          // },

          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }

          // return X64Word.create(high, low);
          // },

          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },

          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },

          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;

          // return X64Word.create(high, low);
          // }
        });

        /**
         * An array of 64-bit words.
         *
         * @property {Array} words The array of CryptoJS.x64.Word objects.
         * @property {number} sigBytes The number of significant bytes in this word array.
         */
        var X64WordArray = C_x64.WordArray = Base.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function (words, sigBytes) {
            words = this.words = words || [];

            if (sigBytes != undefined) {
              this.sigBytes = sigBytes;
            } else {
              this.sigBytes = words.length * 8;
            }
          },

          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function () {
            // Shortcuts
            var x64Words = this.words;
            var x64WordsLength = x64Words.length;

            // Convert
            var x32Words = [];
            for (var i = 0; i < x64WordsLength; i++) {
              var x64Word = x64Words[i];
              x32Words.push(x64Word.high);
              x32Words.push(x64Word.low);
            }

            return X32WordArray.create(x32Words, this.sigBytes);
          },

          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function () {
            var clone = Base.clone.call(this);

            // Clone "words" array
            var words = clone.words = this.words.slice(0);

            // Clone each X64Word object
            var wordsLength = words.length;
            for (var i = 0; i < wordsLength; i++) {
              words[i] = words[i].clone();
            }

            return clone;
          }
        });
      }());


      (function (Math) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;

        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES  = [];
        var ROUND_CONSTANTS = [];

        // Compute Constants
        (function () {
          // Compute rho offset constants
          var x = 1, y = 0;
          for (var t = 0; t < 24; t++) {
            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

            var newX = y % 5;
            var newY = (2 * x + 3 * y) % 5;
            x = newX;
            y = newY;
          }

          // Compute pi index constants
          for (var x = 0; x < 5; x++) {
            for (var y = 0; y < 5; y++) {
              PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
            }
          }

          // Compute round constants
          var LFSR = 0x01;
          for (var i = 0; i < 24; i++) {
            var roundConstantMsw = 0;
            var roundConstantLsw = 0;

            for (var j = 0; j < 7; j++) {
              if (LFSR & 0x01) {
                var bitPosition = (1 << j) - 1;
                if (bitPosition < 32) {
                  roundConstantLsw ^= 1 << bitPosition;
                } else /* if (bitPosition >= 32) */ {
                  roundConstantMsw ^= 1 << (bitPosition - 32);
                }
              }

              // Compute next LFSR
              if (LFSR & 0x80) {
                // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                LFSR = (LFSR << 1) ^ 0x71;
              } else {
                LFSR <<= 1;
              }
            }

            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
          }
        }());

        // Reusable objects for temporary values
        var T = [];
        (function () {
          for (var i = 0; i < 25; i++) {
            T[i] = X64Word.create();
          }
        }());

        /**
         * SHA-3 hash algorithm.
         */
        var SHA3 = C_algo.SHA3 = Hasher.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: Hasher.cfg.extend({
            outputLength: 512
          }),

          _doReset: function () {
            var state = this._state = []
            for (var i = 0; i < 25; i++) {
              state[i] = new X64Word.init();
            }

            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },

          _doProcessBlock: function (M, offset) {
            // Shortcuts
            var state = this._state;
            var nBlockSizeLanes = this.blockSize / 2;

            // Absorb
            for (var i = 0; i < nBlockSizeLanes; i++) {
              // Shortcuts
              var M2i  = M[offset + 2 * i];
              var M2i1 = M[offset + 2 * i + 1];

              // Swap endian
              M2i = (
                (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
                (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
              );
              M2i1 = (
                (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
                (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
              );

              // Absorb message into state
              var lane = state[i];
              lane.high ^= M2i1;
              lane.low  ^= M2i;
            }

            // Rounds
            for (var round = 0; round < 24; round++) {
              // Theta
              for (var x = 0; x < 5; x++) {
                // Mix column lanes
                var tMsw = 0, tLsw = 0;
                for (var y = 0; y < 5; y++) {
                  var lane = state[x + 5 * y];
                  tMsw ^= lane.high;
                  tLsw ^= lane.low;
                }

                // Temporary values
                var Tx = T[x];
                Tx.high = tMsw;
                Tx.low  = tLsw;
              }
              for (var x = 0; x < 5; x++) {
                // Shortcuts
                var Tx4 = T[(x + 4) % 5];
                var Tx1 = T[(x + 1) % 5];
                var Tx1Msw = Tx1.high;
                var Tx1Lsw = Tx1.low;

                // Mix surrounding columns
                var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
                var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
                for (var y = 0; y < 5; y++) {
                  var lane = state[x + 5 * y];
                  lane.high ^= tMsw;
                  lane.low  ^= tLsw;
                }
              }

              // Rho Pi
              for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
                // Shortcuts
                var lane = state[laneIndex];
                var laneMsw = lane.high;
                var laneLsw = lane.low;
                var rhoOffset = RHO_OFFSETS[laneIndex];

                // Rotate lanes
                if (rhoOffset < 32) {
                  var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
                  var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
                } else /* if (rhoOffset >= 32) */ {
                  var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
                  var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
                }

                // Transpose lanes
                var TPiLane = T[PI_INDEXES[laneIndex]];
                TPiLane.high = tMsw;
                TPiLane.low  = tLsw;
              }

              // Rho pi at x = y = 0
              var T0 = T[0];
              var state0 = state[0];
              T0.high = state0.high;
              T0.low  = state0.low;

              // Chi
              for (var x = 0; x < 5; x++) {
                for (var y = 0; y < 5; y++) {
                  // Shortcuts
                  var laneIndex = x + 5 * y;
                  var lane = state[laneIndex];
                  var TLane = T[laneIndex];
                  var Tx1Lane = T[((x + 1) % 5) + 5 * y];
                  var Tx2Lane = T[((x + 2) % 5) + 5 * y];

                  // Mix rows
                  lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
                  lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
                }
              }

              // Iota
              var lane = state[0];
              var roundConstant = ROUND_CONSTANTS[round];
              lane.high ^= roundConstant.high;
              lane.low  ^= roundConstant.low;;
            }
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;
            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;
            var blockSizeBits = this.blockSize * 32;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var state = this._state;
            var outputLengthBytes = this.cfg.outputLength / 8;
            var outputLengthLanes = outputLengthBytes / 8;

            // Squeeze
            var hashWords = [];
            for (var i = 0; i < outputLengthLanes; i++) {
              // Shortcuts
              var lane = state[i];
              var laneMsw = lane.high;
              var laneLsw = lane.low;

              // Swap endian
              laneMsw = (
                (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
                (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
              );
              laneLsw = (
                (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
                (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
              );

              // Squeeze state to retrieve hash
              hashWords.push(laneLsw);
              hashWords.push(laneMsw);
            }

            // Return final computed hash
            return new WordArray.init(hashWords, outputLengthBytes);
          },

          clone: function () {
            var clone = Hasher.clone.call(this);

            var state = clone._state = this._state.slice(0);
            for (var i = 0; i < 25; i++) {
              state[i] = state[i].clone();
            }

            return clone;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA3('message');
         *     var hash = CryptoJS.SHA3(wordArray);
         */
        C.SHA3 = Hasher._createHelper(SHA3);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA3(message, key);
         */
        C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
      }(Math));


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;

        function X64Word_create() {
          return X64Word.create.apply(X64Word, arguments);
        }

        // Constants
        var K = [
          X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
          X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
          X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
          X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
          X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
          X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
          X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
          X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
          X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
          X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
          X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
          X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
          X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
          X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
          X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
          X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
          X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
          X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
          X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
          X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
          X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
          X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
          X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
          X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
          X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
          X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
          X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
          X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
          X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
          X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
          X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
          X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
          X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
          X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
          X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
          X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
          X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
          X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
          X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
          X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
        ];

        // Reusable objects
        var W = [];
        (function () {
          for (var i = 0; i < 80; i++) {
            W[i] = X64Word_create();
          }
        }());

        /**
         * SHA-512 hash algorithm.
         */
        var SHA512 = C_algo.SHA512 = Hasher.extend({
          _doReset: function () {
            this._hash = new X64WordArray.init([
              new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
              new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
              new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
              new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
            ]);
          },

          _doProcessBlock: function (M, offset) {
            // Shortcuts
            var H = this._hash.words;

            var H0 = H[0];
            var H1 = H[1];
            var H2 = H[2];
            var H3 = H[3];
            var H4 = H[4];
            var H5 = H[5];
            var H6 = H[6];
            var H7 = H[7];

            var H0h = H0.high;
            var H0l = H0.low;
            var H1h = H1.high;
            var H1l = H1.low;
            var H2h = H2.high;
            var H2l = H2.low;
            var H3h = H3.high;
            var H3l = H3.low;
            var H4h = H4.high;
            var H4l = H4.low;
            var H5h = H5.high;
            var H5l = H5.low;
            var H6h = H6.high;
            var H6l = H6.low;
            var H7h = H7.high;
            var H7l = H7.low;

            // Working variables
            var ah = H0h;
            var al = H0l;
            var bh = H1h;
            var bl = H1l;
            var ch = H2h;
            var cl = H2l;
            var dh = H3h;
            var dl = H3l;
            var eh = H4h;
            var el = H4l;
            var fh = H5h;
            var fl = H5l;
            var gh = H6h;
            var gl = H6l;
            var hh = H7h;
            var hl = H7l;

            // Rounds
            for (var i = 0; i < 80; i++) {
              // Shortcut
              var Wi = W[i];

              // Extend message
              if (i < 16) {
                var Wih = Wi.high = M[offset + i * 2]     | 0;
                var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
              } else {
                // Gamma0
                var gamma0x  = W[i - 15];
                var gamma0xh = gamma0x.high;
                var gamma0xl = gamma0x.low;
                var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
                var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

                // Gamma1
                var gamma1x  = W[i - 2];
                var gamma1xh = gamma1x.high;
                var gamma1xl = gamma1x.low;
                var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
                var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

                // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                var Wi7  = W[i - 7];
                var Wi7h = Wi7.high;
                var Wi7l = Wi7.low;

                var Wi16  = W[i - 16];
                var Wi16h = Wi16.high;
                var Wi16l = Wi16.low;

                var Wil = gamma0l + Wi7l;
                var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
                var Wil = Wil + gamma1l;
                var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
                var Wil = Wil + Wi16l;
                var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

                Wi.high = Wih;
                Wi.low  = Wil;
              }

              var chh  = (eh & fh) ^ (~eh & gh);
              var chl  = (el & fl) ^ (~el & gl);
              var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
              var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

              var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
              var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
              var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
              var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

              // t1 = h + sigma1 + ch + K[i] + W[i]
              var Ki  = K[i];
              var Kih = Ki.high;
              var Kil = Ki.low;

              var t1l = hl + sigma1l;
              var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
              var t1l = t1l + chl;
              var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
              var t1l = t1l + Kil;
              var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
              var t1l = t1l + Wil;
              var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

              // t2 = sigma0 + maj
              var t2l = sigma0l + majl;
              var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

              // Update working variables
              hh = gh;
              hl = gl;
              gh = fh;
              gl = fl;
              fh = eh;
              fl = el;
              el = (dl + t1l) | 0;
              eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
              dh = ch;
              dl = cl;
              ch = bh;
              cl = bl;
              bh = ah;
              bl = al;
              al = (t1l + t2l) | 0;
              ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
            }

            // Intermediate hash value
            H0l = H0.low  = (H0l + al);
            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
            H1l = H1.low  = (H1l + bl);
            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
            H2l = H2.low  = (H2l + cl);
            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
            H3l = H3.low  = (H3l + dl);
            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
            H4l = H4.low  = (H4l + el);
            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
            H5l = H5.low  = (H5l + fl);
            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
            H6l = H6.low  = (H6l + gl);
            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
            H7l = H7.low  = (H7l + hl);
            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
          },

          _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Convert hash to 32-bit word array before returning
            var hash = this._hash.toX32();

            // Return final computed hash
            return hash;
          },

          clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
          },

          blockSize: 1024/32
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA512('message');
         *     var hash = CryptoJS.SHA512(wordArray);
         */
        C.SHA512 = Hasher._createHelper(SHA512);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA512(message, key);
         */
        C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;

        /**
         * SHA-384 hash algorithm.
         */
        var SHA384 = C_algo.SHA384 = SHA512.extend({
          _doReset: function () {
            this._hash = new X64WordArray.init([
              new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
              new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
              new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
              new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
            ]);
          },

          _doFinalize: function () {
            var hash = SHA512._doFinalize.call(this);

            hash.sigBytes -= 16;

            return hash;
          }
        });

        /**
         * Shortcut function to the hasher's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         *
         * @return {WordArray} The hash.
         *
         * @static
         *
         * @example
         *
         *     var hash = CryptoJS.SHA384('message');
         *     var hash = CryptoJS.SHA384(wordArray);
         */
        C.SHA384 = SHA512._createHelper(SHA384);

        /**
         * Shortcut function to the HMAC's object interface.
         *
         * @param {WordArray|string} message The message to hash.
         * @param {WordArray|string} key The secret key.
         *
         * @return {WordArray} The HMAC.
         *
         * @static
         *
         * @example
         *
         *     var hmac = CryptoJS.HmacSHA384(message, key);
         */
        C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
      }());


      /**
       * Cipher core components.
       */
      CryptoJS.lib.Cipher || (function (undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;

        /**
         * Abstract base cipher template.
         *
         * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
         * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
         * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
         * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
         */
        var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: Base.extend(),

          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function (key, cfg) {
            return this.create(this._ENC_XFORM_MODE, key, cfg);
          },

          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function (key, cfg) {
            return this.create(this._DEC_XFORM_MODE, key, cfg);
          },

          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function (xformMode, key, cfg) {
            // Apply config defaults
            this.cfg = this.cfg.extend(cfg);

            // Store transform mode and key
            this._xformMode = xformMode;
            this._key = key;

            // Set initial values
            this.reset();
          },

          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function () {
            // Reset data buffer
            BufferedBlockAlgorithm.reset.call(this);

            // Perform concrete-cipher logic
            this._doReset();
          },

          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function (dataUpdate) {
            // Append
            this._append(dataUpdate);

            // Process available blocks
            return this._process();
          },

          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function (dataUpdate) {
            // Final data update
            if (dataUpdate) {
              this._append(dataUpdate);
            }

            // Perform concrete-cipher logic
            var finalProcessedData = this._doFinalize();

            return finalProcessedData;
          },

          keySize: 128/32,

          ivSize: 128/32,

          _ENC_XFORM_MODE: 1,

          _DEC_XFORM_MODE: 2,

          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: (function () {
            function selectCipherStrategy(key) {
              if (typeof key == 'string') {
                return PasswordBasedCipher;
              } else {
                return SerializableCipher;
              }
            }

            return function (cipher) {
              return {
                encrypt: function (message, key, cfg) {
                  return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                },

                decrypt: function (ciphertext, key, cfg) {
                  return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                }
              };
            };
          }())
        });

        /**
         * Abstract base stream cipher template.
         *
         * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
         */
        var StreamCipher = C_lib.StreamCipher = Cipher.extend({
          _doFinalize: function () {
            // Process partial blocks
            var finalProcessedBlocks = this._process(!!'flush');

            return finalProcessedBlocks;
          },

          blockSize: 1
        });

        /**
         * Mode namespace.
         */
        var C_mode = C.mode = {};

        /**
         * Abstract base block cipher mode template.
         */
        var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function (cipher, iv) {
            return this.Encryptor.create(cipher, iv);
          },

          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function (cipher, iv) {
            return this.Decryptor.create(cipher, iv);
          },

          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function (cipher, iv) {
            this._cipher = cipher;
            this._iv = iv;
          }
        });

        /**
         * Cipher Block Chaining mode.
         */
        var CBC = C_mode.CBC = (function () {
          /**
           * Abstract base CBC mode.
           */
          var CBC = BlockCipherMode.extend();

          /**
           * CBC encryptor.
           */
          CBC.Encryptor = CBC.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function (words, offset) {
              // Shortcuts
              var cipher = this._cipher;
              var blockSize = cipher.blockSize;

              // XOR and encrypt
              xorBlock.call(this, words, offset, blockSize);
              cipher.encryptBlock(words, offset);

              // Remember this block to use with next block
              this._prevBlock = words.slice(offset, offset + blockSize);
            }
          });

          /**
           * CBC decryptor.
           */
          CBC.Decryptor = CBC.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function (words, offset) {
              // Shortcuts
              var cipher = this._cipher;
              var blockSize = cipher.blockSize;

              // Remember this block to use with next block
              var thisBlock = words.slice(offset, offset + blockSize);

              // Decrypt and XOR
              cipher.decryptBlock(words, offset);
              xorBlock.call(this, words, offset, blockSize);

              // This block becomes the previous block
              this._prevBlock = thisBlock;
            }
          });

          function xorBlock(words, offset, blockSize) {
            // Shortcut
            var iv = this._iv;

            // Choose mixing block
            if (iv) {
              var block = iv;

              // Remove IV for subsequent blocks
              this._iv = undefined;
            } else {
              var block = this._prevBlock;
            }

            // XOR blocks
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= block[i];
            }
          }

          return CBC;
        }());

        /**
         * Padding namespace.
         */
        var C_pad = C.pad = {};

        /**
         * PKCS #5/7 padding strategy.
         */
        var Pkcs7 = C_pad.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function (data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;

            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

            // Create padding word
            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

            // Create padding
            var paddingWords = [];
            for (var i = 0; i < nPaddingBytes; i += 4) {
              paddingWords.push(paddingWord);
            }
            var padding = WordArray.create(paddingWords, nPaddingBytes);

            // Add padding
            data.concat(padding);
          },

          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function (data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

            // Remove padding
            data.sigBytes -= nPaddingBytes;
          }
        };

        /**
         * Abstract base block cipher template.
         *
         * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
         */
        var BlockCipher = C_lib.BlockCipher = Cipher.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: Cipher.cfg.extend({
            mode: CBC,
            padding: Pkcs7
          }),

          reset: function () {
            // Reset cipher
            Cipher.reset.call(this);

            // Shortcuts
            var cfg = this.cfg;
            var iv = cfg.iv;
            var mode = cfg.mode;

            // Reset block mode
            if (this._xformMode == this._ENC_XFORM_MODE) {
              var modeCreator = mode.createEncryptor;
            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
              var modeCreator = mode.createDecryptor;
              // Keep at least one block in the buffer for unpadding
              this._minBufferSize = 1;
            }

            if (this._mode && this._mode.__creator == modeCreator) {
              this._mode.init(this, iv && iv.words);
            } else {
              this._mode = modeCreator.call(mode, this, iv && iv.words);
              this._mode.__creator = modeCreator;
            }
          },

          _doProcessBlock: function (words, offset) {
            this._mode.processBlock(words, offset);
          },

          _doFinalize: function () {
            // Shortcut
            var padding = this.cfg.padding;

            // Finalize
            if (this._xformMode == this._ENC_XFORM_MODE) {
              // Pad data
              padding.pad(this._data, this.blockSize);

              // Process final blocks
              var finalProcessedBlocks = this._process(!!'flush');
            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
              // Process final blocks
              var finalProcessedBlocks = this._process(!!'flush');

              // Unpad data
              padding.unpad(finalProcessedBlocks);
            }

            return finalProcessedBlocks;
          },

          blockSize: 128/32
        });

        /**
         * A collection of cipher parameters.
         *
         * @property {WordArray} ciphertext The raw ciphertext.
         * @property {WordArray} key The key to this ciphertext.
         * @property {WordArray} iv The IV used in the ciphering operation.
         * @property {WordArray} salt The salt used with a key derivation function.
         * @property {Cipher} algorithm The cipher algorithm.
         * @property {Mode} mode The block mode used in the ciphering operation.
         * @property {Padding} padding The padding scheme used in the ciphering operation.
         * @property {number} blockSize The block size of the cipher.
         * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
         */
        var CipherParams = C_lib.CipherParams = Base.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function (cipherParams) {
            this.mixIn(cipherParams);
          },

          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function (formatter) {
            return (formatter || this.formatter).stringify(this);
          }
        });

        /**
         * Format namespace.
         */
        var C_format = C.format = {};

        /**
         * OpenSSL formatting strategy.
         */
        var OpenSSLFormatter = C_format.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function (cipherParams) {
            // Shortcuts
            var ciphertext = cipherParams.ciphertext;
            var salt = cipherParams.salt;

            // Format
            if (salt) {
              var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
            } else {
              var wordArray = ciphertext;
            }

            return wordArray.toString(Base64);
          },

          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function (openSSLStr) {
            // Parse base64
            var ciphertext = Base64.parse(openSSLStr);

            // Shortcut
            var ciphertextWords = ciphertext.words;

            // Test for salt
            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
              // Extract salt
              var salt = WordArray.create(ciphertextWords.slice(2, 4));

              // Remove salt from ciphertext
              ciphertextWords.splice(0, 4);
              ciphertext.sigBytes -= 16;
            }

            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
          }
        };

        /**
         * A cipher wrapper that returns ciphertext as a serializable cipher params object.
         */
        var SerializableCipher = C_lib.SerializableCipher = Base.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: Base.extend({
            format: OpenSSLFormatter
          }),

          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function (cipher, message, key, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Encrypt
            var encryptor = cipher.createEncryptor(key, cfg);
            var ciphertext = encryptor.finalize(message);

            // Shortcut
            var cipherCfg = encryptor.cfg;

            // Create and return serializable cipher params
            return CipherParams.create({
              ciphertext: ciphertext,
              key: key,
              iv: cipherCfg.iv,
              algorithm: cipher,
              mode: cipherCfg.mode,
              padding: cipherCfg.padding,
              blockSize: cipher.blockSize,
              formatter: cfg.format
            });
          },

          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function (cipher, ciphertext, key, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Convert string to CipherParams
            ciphertext = this._parse(ciphertext, cfg.format);

            // Decrypt
            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

            return plaintext;
          },

          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function (ciphertext, format) {
            if (typeof ciphertext == 'string') {
              return format.parse(ciphertext, this);
            } else {
              return ciphertext;
            }
          }
        });

        /**
         * Key derivation function namespace.
         */
        var C_kdf = C.kdf = {};

        /**
         * OpenSSL key derivation function.
         */
        var OpenSSLKdf = C_kdf.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function (password, keySize, ivSize, salt) {
            // Generate random salt
            if (!salt) {
              salt = WordArray.random(64/8);
            }

            // Derive key and IV
            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

            // Separate key and IV
            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
            key.sigBytes = keySize * 4;

            // Return params
            return CipherParams.create({ key: key, iv: iv, salt: salt });
          }
        };

        /**
         * A serializable cipher wrapper that derives the key from a password,
         * and returns ciphertext as a serializable cipher params object.
         */
        var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: SerializableCipher.cfg.extend({
            kdf: OpenSSLKdf
          }),

          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function (cipher, message, password, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Derive key and other params
            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

            // Add IV to config
            cfg.iv = derivedParams.iv;

            // Encrypt
            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

            // Mix in derived params
            ciphertext.mixIn(derivedParams);

            return ciphertext;
          },

          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function (cipher, ciphertext, password, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Convert string to CipherParams
            ciphertext = this._parse(ciphertext, cfg.format);

            // Derive key and other params
            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

            // Add IV to config
            cfg.iv = derivedParams.iv;

            // Decrypt
            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

            return plaintext;
          }
        });
      }());


      /**
       * Cipher Feedback block mode.
       */
      CryptoJS.mode.CFB = (function () {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();

        CFB.Encryptor = CFB.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;

            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

            // Remember this block to use with next block
            this._prevBlock = words.slice(offset, offset + blockSize);
          }
        });

        CFB.Decryptor = CFB.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;

            // Remember this block to use with next block
            var thisBlock = words.slice(offset, offset + blockSize);

            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

            // This block becomes the previous block
            this._prevBlock = thisBlock;
          }
        });

        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
          // Shortcut
          var iv = this._iv;

          // Generate keystream
          if (iv) {
            var keystream = iv.slice(0);

            // Remove IV for subsequent blocks
            this._iv = undefined;
          } else {
            var keystream = this._prevBlock;
          }
          cipher.encryptBlock(keystream, 0);

          // Encrypt
          for (var i = 0; i < blockSize; i++) {
            words[offset + i] ^= keystream[i];
          }
        }

        return CFB;
      }());


      /**
       * Electronic Codebook block mode.
       */
      CryptoJS.mode.ECB = (function () {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();

        ECB.Encryptor = ECB.extend({
          processBlock: function (words, offset) {
            this._cipher.encryptBlock(words, offset);
          }
        });

        ECB.Decryptor = ECB.extend({
          processBlock: function (words, offset) {
            this._cipher.decryptBlock(words, offset);
          }
        });

        return ECB;
      }());


      /**
       * ANSI X.923 padding strategy.
       */
      CryptoJS.pad.AnsiX923 = {
        pad: function (data, blockSize) {
          // Shortcuts
          var dataSigBytes = data.sigBytes;
          var blockSizeBytes = blockSize * 4;

          // Count padding bytes
          var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

          // Compute last byte position
          var lastBytePos = dataSigBytes + nPaddingBytes - 1;

          // Pad
          data.clamp();
          data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
          data.sigBytes += nPaddingBytes;
        },

        unpad: function (data) {
          // Get number of padding bytes from last byte
          var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

          // Remove padding
          data.sigBytes -= nPaddingBytes;
        }
      };


      /**
       * ISO 10126 padding strategy.
       */
      CryptoJS.pad.Iso10126 = {
        pad: function (data, blockSize) {
          // Shortcut
          var blockSizeBytes = blockSize * 4;

          // Count padding bytes
          var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

          // Pad
          data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
          concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
        },

        unpad: function (data) {
          // Get number of padding bytes from last byte
          var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

          // Remove padding
          data.sigBytes -= nPaddingBytes;
        }
      };


      /**
       * ISO/IEC 9797-1 Padding Method 2.
       */
      CryptoJS.pad.Iso97971 = {
        pad: function (data, blockSize) {
          // Add 0x80 byte
          data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

          // Zero pad the rest
          CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },

        unpad: function (data) {
          // Remove zero padding
          CryptoJS.pad.ZeroPadding.unpad(data);

          // Remove one more byte -- the 0x80 byte
          data.sigBytes--;
        }
      };


      /**
       * Output Feedback block mode.
       */
      CryptoJS.mode.OFB = (function () {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();

        var Encryptor = OFB.Encryptor = OFB.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var keystream = this._keystream;

            // Generate keystream
            if (iv) {
              keystream = this._keystream = iv.slice(0);

              // Remove IV for subsequent blocks
              this._iv = undefined;
            }
            cipher.encryptBlock(keystream, 0);

            // Encrypt
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= keystream[i];
            }
          }
        });

        OFB.Decryptor = Encryptor;

        return OFB;
      }());


      /**
       * A noop padding strategy.
       */
      CryptoJS.pad.NoPadding = {
        pad: function () {
        },

        unpad: function () {
        }
      };


      (function (undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;

        var HexFormatter = C_format.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function (cipherParams) {
            return cipherParams.ciphertext.toString(Hex);
          },

          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function (input) {
            var ciphertext = Hex.parse(input);
            return CipherParams.create({ ciphertext: ciphertext });
          }
        };
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;

        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];

        // Compute lookup tables
        (function () {
          // Compute double table
          var d = [];
          for (var i = 0; i < 256; i++) {
            if (i < 128) {
              d[i] = i << 1;
            } else {
              d[i] = (i << 1) ^ 0x11b;
            }
          }

          // Walk GF(2^8)
          var x = 0;
          var xi = 0;
          for (var i = 0; i < 256; i++) {
            // Compute sbox
            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
            SBOX[x] = sx;
            INV_SBOX[sx] = x;

            // Compute multiplication
            var x2 = d[x];
            var x4 = d[x2];
            var x8 = d[x4];

            // Compute sub bytes, mix columns tables
            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
            SUB_MIX_3[x] = t;

            // Compute inv sub bytes, inv mix columns tables
            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
            INV_SUB_MIX_3[sx] = t;

            // Compute next counter
            if (!x) {
              x = xi = 1;
            } else {
              x = x2 ^ d[d[d[x8 ^ x2]]];
              xi ^= d[d[xi]];
            }
          }
        }());

        // Precomputed Rcon lookup
        var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

        /**
         * AES block cipher algorithm.
         */
        var AES = C_algo.AES = BlockCipher.extend({
          _doReset: function () {
            // Skip reset of nRounds has been set before and key did not change
            if (this._nRounds && this._keyPriorReset === this._key) {
              return;
            }

            // Shortcuts
            var key = this._keyPriorReset = this._key;
            var keyWords = key.words;
            var keySize = key.sigBytes / 4;

            // Compute number of rounds
            var nRounds = this._nRounds = keySize + 6;

            // Compute number of key schedule rows
            var ksRows = (nRounds + 1) * 4;

            // Compute key schedule
            var keySchedule = this._keySchedule = [];
            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
              if (ksRow < keySize) {
                keySchedule[ksRow] = keyWords[ksRow];
              } else {
                var t = keySchedule[ksRow - 1];

                if (!(ksRow % keySize)) {
                  // Rot word
                  t = (t << 8) | (t >>> 24);

                  // Sub word
                  t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

                  // Mix Rcon
                  t ^= RCON[(ksRow / keySize) | 0] << 24;
                } else if (keySize > 6 && ksRow % keySize == 4) {
                  // Sub word
                  t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
                }

                keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
              }
            }

            // Compute inv key schedule
            var invKeySchedule = this._invKeySchedule = [];
            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
              var ksRow = ksRows - invKsRow;

              if (invKsRow % 4) {
                var t = keySchedule[ksRow];
              } else {
                var t = keySchedule[ksRow - 4];
              }

              if (invKsRow < 4 || ksRow <= 4) {
                invKeySchedule[invKsRow] = t;
              } else {
                invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
                  INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
              }
            }
          },

          encryptBlock: function (M, offset) {
            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
          },

          decryptBlock: function (M, offset) {
            // Swap 2nd and 4th rows
            var t = M[offset + 1];
            M[offset + 1] = M[offset + 3];
            M[offset + 3] = t;

            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

            // Inv swap 2nd and 4th rows
            var t = M[offset + 1];
            M[offset + 1] = M[offset + 3];
            M[offset + 3] = t;
          },

          _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
            // Shortcut
            var nRounds = this._nRounds;

            // Get input, add round key
            var s0 = M[offset]     ^ keySchedule[0];
            var s1 = M[offset + 1] ^ keySchedule[1];
            var s2 = M[offset + 2] ^ keySchedule[2];
            var s3 = M[offset + 3] ^ keySchedule[3];

            // Key schedule row counter
            var ksRow = 4;

            // Rounds
            for (var round = 1; round < nRounds; round++) {
              // Shift rows, sub bytes, mix columns, add round key
              var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
              var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
              var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
              var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

              // Update state
              s0 = t0;
              s1 = t1;
              s2 = t2;
              s3 = t3;
            }

            // Shift rows, sub bytes, add round key
            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

            // Set output
            M[offset]     = t0;
            M[offset + 1] = t1;
            M[offset + 2] = t2;
            M[offset + 3] = t3;
          },

          keySize: 256/32
        });

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
         */
        C.AES = BlockCipher._createHelper(AES);
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;

        // Permuted Choice 1 constants
        var PC1 = [
          57, 49, 41, 33, 25, 17, 9,  1,
          58, 50, 42, 34, 26, 18, 10, 2,
          59, 51, 43, 35, 27, 19, 11, 3,
          60, 52, 44, 36, 63, 55, 47, 39,
          31, 23, 15, 7,  62, 54, 46, 38,
          30, 22, 14, 6,  61, 53, 45, 37,
          29, 21, 13, 5,  28, 20, 12, 4
        ];

        // Permuted Choice 2 constants
        var PC2 = [
          14, 17, 11, 24, 1,  5,
          3,  28, 15, 6,  21, 10,
          23, 19, 12, 4,  26, 8,
          16, 7,  27, 20, 13, 2,
          41, 52, 31, 37, 47, 55,
          30, 40, 51, 45, 33, 48,
          44, 49, 39, 56, 34, 53,
          46, 42, 50, 36, 29, 32
        ];

        // Cumulative bit shift constants
        var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

        // SBOXes and round permutation constants
        var SBOX_P = [
          {
            0x0: 0x808200,
            0x10000000: 0x8000,
            0x20000000: 0x808002,
            0x30000000: 0x2,
            0x40000000: 0x200,
            0x50000000: 0x808202,
            0x60000000: 0x800202,
            0x70000000: 0x800000,
            0x80000000: 0x202,
            0x90000000: 0x800200,
            0xa0000000: 0x8200,
            0xb0000000: 0x808000,
            0xc0000000: 0x8002,
            0xd0000000: 0x800002,
            0xe0000000: 0x0,
            0xf0000000: 0x8202,
            0x8000000: 0x0,
            0x18000000: 0x808202,
            0x28000000: 0x8202,
            0x38000000: 0x8000,
            0x48000000: 0x808200,
            0x58000000: 0x200,
            0x68000000: 0x808002,
            0x78000000: 0x2,
            0x88000000: 0x800200,
            0x98000000: 0x8200,
            0xa8000000: 0x808000,
            0xb8000000: 0x800202,
            0xc8000000: 0x800002,
            0xd8000000: 0x8002,
            0xe8000000: 0x202,
            0xf8000000: 0x800000,
            0x1: 0x8000,
            0x10000001: 0x2,
            0x20000001: 0x808200,
            0x30000001: 0x800000,
            0x40000001: 0x808002,
            0x50000001: 0x8200,
            0x60000001: 0x200,
            0x70000001: 0x800202,
            0x80000001: 0x808202,
            0x90000001: 0x808000,
            0xa0000001: 0x800002,
            0xb0000001: 0x8202,
            0xc0000001: 0x202,
            0xd0000001: 0x800200,
            0xe0000001: 0x8002,
            0xf0000001: 0x0,
            0x8000001: 0x808202,
            0x18000001: 0x808000,
            0x28000001: 0x800000,
            0x38000001: 0x200,
            0x48000001: 0x8000,
            0x58000001: 0x800002,
            0x68000001: 0x2,
            0x78000001: 0x8202,
            0x88000001: 0x8002,
            0x98000001: 0x800202,
            0xa8000001: 0x202,
            0xb8000001: 0x808200,
            0xc8000001: 0x800200,
            0xd8000001: 0x0,
            0xe8000001: 0x8200,
            0xf8000001: 0x808002
          },
          {
            0x0: 0x40084010,
            0x1000000: 0x4000,
            0x2000000: 0x80000,
            0x3000000: 0x40080010,
            0x4000000: 0x40000010,
            0x5000000: 0x40084000,
            0x6000000: 0x40004000,
            0x7000000: 0x10,
            0x8000000: 0x84000,
            0x9000000: 0x40004010,
            0xa000000: 0x40000000,
            0xb000000: 0x84010,
            0xc000000: 0x80010,
            0xd000000: 0x0,
            0xe000000: 0x4010,
            0xf000000: 0x40080000,
            0x800000: 0x40004000,
            0x1800000: 0x84010,
            0x2800000: 0x10,
            0x3800000: 0x40004010,
            0x4800000: 0x40084010,
            0x5800000: 0x40000000,
            0x6800000: 0x80000,
            0x7800000: 0x40080010,
            0x8800000: 0x80010,
            0x9800000: 0x0,
            0xa800000: 0x4000,
            0xb800000: 0x40080000,
            0xc800000: 0x40000010,
            0xd800000: 0x84000,
            0xe800000: 0x40084000,
            0xf800000: 0x4010,
            0x10000000: 0x0,
            0x11000000: 0x40080010,
            0x12000000: 0x40004010,
            0x13000000: 0x40084000,
            0x14000000: 0x40080000,
            0x15000000: 0x10,
            0x16000000: 0x84010,
            0x17000000: 0x4000,
            0x18000000: 0x4010,
            0x19000000: 0x80000,
            0x1a000000: 0x80010,
            0x1b000000: 0x40000010,
            0x1c000000: 0x84000,
            0x1d000000: 0x40004000,
            0x1e000000: 0x40000000,
            0x1f000000: 0x40084010,
            0x10800000: 0x84010,
            0x11800000: 0x80000,
            0x12800000: 0x40080000,
            0x13800000: 0x4000,
            0x14800000: 0x40004000,
            0x15800000: 0x40084010,
            0x16800000: 0x10,
            0x17800000: 0x40000000,
            0x18800000: 0x40084000,
            0x19800000: 0x40000010,
            0x1a800000: 0x40004010,
            0x1b800000: 0x80010,
            0x1c800000: 0x0,
            0x1d800000: 0x4010,
            0x1e800000: 0x40080010,
            0x1f800000: 0x84000
          },
          {
            0x0: 0x104,
            0x100000: 0x0,
            0x200000: 0x4000100,
            0x300000: 0x10104,
            0x400000: 0x10004,
            0x500000: 0x4000004,
            0x600000: 0x4010104,
            0x700000: 0x4010000,
            0x800000: 0x4000000,
            0x900000: 0x4010100,
            0xa00000: 0x10100,
            0xb00000: 0x4010004,
            0xc00000: 0x4000104,
            0xd00000: 0x10000,
            0xe00000: 0x4,
            0xf00000: 0x100,
            0x80000: 0x4010100,
            0x180000: 0x4010004,
            0x280000: 0x0,
            0x380000: 0x4000100,
            0x480000: 0x4000004,
            0x580000: 0x10000,
            0x680000: 0x10004,
            0x780000: 0x104,
            0x880000: 0x4,
            0x980000: 0x100,
            0xa80000: 0x4010000,
            0xb80000: 0x10104,
            0xc80000: 0x10100,
            0xd80000: 0x4000104,
            0xe80000: 0x4010104,
            0xf80000: 0x4000000,
            0x1000000: 0x4010100,
            0x1100000: 0x10004,
            0x1200000: 0x10000,
            0x1300000: 0x4000100,
            0x1400000: 0x100,
            0x1500000: 0x4010104,
            0x1600000: 0x4000004,
            0x1700000: 0x0,
            0x1800000: 0x4000104,
            0x1900000: 0x4000000,
            0x1a00000: 0x4,
            0x1b00000: 0x10100,
            0x1c00000: 0x4010000,
            0x1d00000: 0x104,
            0x1e00000: 0x10104,
            0x1f00000: 0x4010004,
            0x1080000: 0x4000000,
            0x1180000: 0x104,
            0x1280000: 0x4010100,
            0x1380000: 0x0,
            0x1480000: 0x10004,
            0x1580000: 0x4000100,
            0x1680000: 0x100,
            0x1780000: 0x4010004,
            0x1880000: 0x10000,
            0x1980000: 0x4010104,
            0x1a80000: 0x10104,
            0x1b80000: 0x4000004,
            0x1c80000: 0x4000104,
            0x1d80000: 0x4010000,
            0x1e80000: 0x4,
            0x1f80000: 0x10100
          },
          {
            0x0: 0x80401000,
            0x10000: 0x80001040,
            0x20000: 0x401040,
            0x30000: 0x80400000,
            0x40000: 0x0,
            0x50000: 0x401000,
            0x60000: 0x80000040,
            0x70000: 0x400040,
            0x80000: 0x80000000,
            0x90000: 0x400000,
            0xa0000: 0x40,
            0xb0000: 0x80001000,
            0xc0000: 0x80400040,
            0xd0000: 0x1040,
            0xe0000: 0x1000,
            0xf0000: 0x80401040,
            0x8000: 0x80001040,
            0x18000: 0x40,
            0x28000: 0x80400040,
            0x38000: 0x80001000,
            0x48000: 0x401000,
            0x58000: 0x80401040,
            0x68000: 0x0,
            0x78000: 0x80400000,
            0x88000: 0x1000,
            0x98000: 0x80401000,
            0xa8000: 0x400000,
            0xb8000: 0x1040,
            0xc8000: 0x80000000,
            0xd8000: 0x400040,
            0xe8000: 0x401040,
            0xf8000: 0x80000040,
            0x100000: 0x400040,
            0x110000: 0x401000,
            0x120000: 0x80000040,
            0x130000: 0x0,
            0x140000: 0x1040,
            0x150000: 0x80400040,
            0x160000: 0x80401000,
            0x170000: 0x80001040,
            0x180000: 0x80401040,
            0x190000: 0x80000000,
            0x1a0000: 0x80400000,
            0x1b0000: 0x401040,
            0x1c0000: 0x80001000,
            0x1d0000: 0x400000,
            0x1e0000: 0x40,
            0x1f0000: 0x1000,
            0x108000: 0x80400000,
            0x118000: 0x80401040,
            0x128000: 0x0,
            0x138000: 0x401000,
            0x148000: 0x400040,
            0x158000: 0x80000000,
            0x168000: 0x80001040,
            0x178000: 0x40,
            0x188000: 0x80000040,
            0x198000: 0x1000,
            0x1a8000: 0x80001000,
            0x1b8000: 0x80400040,
            0x1c8000: 0x1040,
            0x1d8000: 0x80401000,
            0x1e8000: 0x400000,
            0x1f8000: 0x401040
          },
          {
            0x0: 0x80,
            0x1000: 0x1040000,
            0x2000: 0x40000,
            0x3000: 0x20000000,
            0x4000: 0x20040080,
            0x5000: 0x1000080,
            0x6000: 0x21000080,
            0x7000: 0x40080,
            0x8000: 0x1000000,
            0x9000: 0x20040000,
            0xa000: 0x20000080,
            0xb000: 0x21040080,
            0xc000: 0x21040000,
            0xd000: 0x0,
            0xe000: 0x1040080,
            0xf000: 0x21000000,
            0x800: 0x1040080,
            0x1800: 0x21000080,
            0x2800: 0x80,
            0x3800: 0x1040000,
            0x4800: 0x40000,
            0x5800: 0x20040080,
            0x6800: 0x21040000,
            0x7800: 0x20000000,
            0x8800: 0x20040000,
            0x9800: 0x0,
            0xa800: 0x21040080,
            0xb800: 0x1000080,
            0xc800: 0x20000080,
            0xd800: 0x21000000,
            0xe800: 0x1000000,
            0xf800: 0x40080,
            0x10000: 0x40000,
            0x11000: 0x80,
            0x12000: 0x20000000,
            0x13000: 0x21000080,
            0x14000: 0x1000080,
            0x15000: 0x21040000,
            0x16000: 0x20040080,
            0x17000: 0x1000000,
            0x18000: 0x21040080,
            0x19000: 0x21000000,
            0x1a000: 0x1040000,
            0x1b000: 0x20040000,
            0x1c000: 0x40080,
            0x1d000: 0x20000080,
            0x1e000: 0x0,
            0x1f000: 0x1040080,
            0x10800: 0x21000080,
            0x11800: 0x1000000,
            0x12800: 0x1040000,
            0x13800: 0x20040080,
            0x14800: 0x20000000,
            0x15800: 0x1040080,
            0x16800: 0x80,
            0x17800: 0x21040000,
            0x18800: 0x40080,
            0x19800: 0x21040080,
            0x1a800: 0x0,
            0x1b800: 0x21000000,
            0x1c800: 0x1000080,
            0x1d800: 0x40000,
            0x1e800: 0x20040000,
            0x1f800: 0x20000080
          },
          {
            0x0: 0x10000008,
            0x100: 0x2000,
            0x200: 0x10200000,
            0x300: 0x10202008,
            0x400: 0x10002000,
            0x500: 0x200000,
            0x600: 0x200008,
            0x700: 0x10000000,
            0x800: 0x0,
            0x900: 0x10002008,
            0xa00: 0x202000,
            0xb00: 0x8,
            0xc00: 0x10200008,
            0xd00: 0x202008,
            0xe00: 0x2008,
            0xf00: 0x10202000,
            0x80: 0x10200000,
            0x180: 0x10202008,
            0x280: 0x8,
            0x380: 0x200000,
            0x480: 0x202008,
            0x580: 0x10000008,
            0x680: 0x10002000,
            0x780: 0x2008,
            0x880: 0x200008,
            0x980: 0x2000,
            0xa80: 0x10002008,
            0xb80: 0x10200008,
            0xc80: 0x0,
            0xd80: 0x10202000,
            0xe80: 0x202000,
            0xf80: 0x10000000,
            0x1000: 0x10002000,
            0x1100: 0x10200008,
            0x1200: 0x10202008,
            0x1300: 0x2008,
            0x1400: 0x200000,
            0x1500: 0x10000000,
            0x1600: 0x10000008,
            0x1700: 0x202000,
            0x1800: 0x202008,
            0x1900: 0x0,
            0x1a00: 0x8,
            0x1b00: 0x10200000,
            0x1c00: 0x2000,
            0x1d00: 0x10002008,
            0x1e00: 0x10202000,
            0x1f00: 0x200008,
            0x1080: 0x8,
            0x1180: 0x202000,
            0x1280: 0x200000,
            0x1380: 0x10000008,
            0x1480: 0x10002000,
            0x1580: 0x2008,
            0x1680: 0x10202008,
            0x1780: 0x10200000,
            0x1880: 0x10202000,
            0x1980: 0x10200008,
            0x1a80: 0x2000,
            0x1b80: 0x202008,
            0x1c80: 0x200008,
            0x1d80: 0x0,
            0x1e80: 0x10000000,
            0x1f80: 0x10002008
          },
          {
            0x0: 0x100000,
            0x10: 0x2000401,
            0x20: 0x400,
            0x30: 0x100401,
            0x40: 0x2100401,
            0x50: 0x0,
            0x60: 0x1,
            0x70: 0x2100001,
            0x80: 0x2000400,
            0x90: 0x100001,
            0xa0: 0x2000001,
            0xb0: 0x2100400,
            0xc0: 0x2100000,
            0xd0: 0x401,
            0xe0: 0x100400,
            0xf0: 0x2000000,
            0x8: 0x2100001,
            0x18: 0x0,
            0x28: 0x2000401,
            0x38: 0x2100400,
            0x48: 0x100000,
            0x58: 0x2000001,
            0x68: 0x2000000,
            0x78: 0x401,
            0x88: 0x100401,
            0x98: 0x2000400,
            0xa8: 0x2100000,
            0xb8: 0x100001,
            0xc8: 0x400,
            0xd8: 0x2100401,
            0xe8: 0x1,
            0xf8: 0x100400,
            0x100: 0x2000000,
            0x110: 0x100000,
            0x120: 0x2000401,
            0x130: 0x2100001,
            0x140: 0x100001,
            0x150: 0x2000400,
            0x160: 0x2100400,
            0x170: 0x100401,
            0x180: 0x401,
            0x190: 0x2100401,
            0x1a0: 0x100400,
            0x1b0: 0x1,
            0x1c0: 0x0,
            0x1d0: 0x2100000,
            0x1e0: 0x2000001,
            0x1f0: 0x400,
            0x108: 0x100400,
            0x118: 0x2000401,
            0x128: 0x2100001,
            0x138: 0x1,
            0x148: 0x2000000,
            0x158: 0x100000,
            0x168: 0x401,
            0x178: 0x2100400,
            0x188: 0x2000001,
            0x198: 0x2100000,
            0x1a8: 0x0,
            0x1b8: 0x2100401,
            0x1c8: 0x100401,
            0x1d8: 0x400,
            0x1e8: 0x2000400,
            0x1f8: 0x100001
          },
          {
            0x0: 0x8000820,
            0x1: 0x20000,
            0x2: 0x8000000,
            0x3: 0x20,
            0x4: 0x20020,
            0x5: 0x8020820,
            0x6: 0x8020800,
            0x7: 0x800,
            0x8: 0x8020000,
            0x9: 0x8000800,
            0xa: 0x20800,
            0xb: 0x8020020,
            0xc: 0x820,
            0xd: 0x0,
            0xe: 0x8000020,
            0xf: 0x20820,
            0x80000000: 0x800,
            0x80000001: 0x8020820,
            0x80000002: 0x8000820,
            0x80000003: 0x8000000,
            0x80000004: 0x8020000,
            0x80000005: 0x20800,
            0x80000006: 0x20820,
            0x80000007: 0x20,
            0x80000008: 0x8000020,
            0x80000009: 0x820,
            0x8000000a: 0x20020,
            0x8000000b: 0x8020800,
            0x8000000c: 0x0,
            0x8000000d: 0x8020020,
            0x8000000e: 0x8000800,
            0x8000000f: 0x20000,
            0x10: 0x20820,
            0x11: 0x8020800,
            0x12: 0x20,
            0x13: 0x800,
            0x14: 0x8000800,
            0x15: 0x8000020,
            0x16: 0x8020020,
            0x17: 0x20000,
            0x18: 0x0,
            0x19: 0x20020,
            0x1a: 0x8020000,
            0x1b: 0x8000820,
            0x1c: 0x8020820,
            0x1d: 0x20800,
            0x1e: 0x820,
            0x1f: 0x8000000,
            0x80000010: 0x20000,
            0x80000011: 0x800,
            0x80000012: 0x8020020,
            0x80000013: 0x20820,
            0x80000014: 0x20,
            0x80000015: 0x8020000,
            0x80000016: 0x8000000,
            0x80000017: 0x8000820,
            0x80000018: 0x8020820,
            0x80000019: 0x8000020,
            0x8000001a: 0x8000800,
            0x8000001b: 0x0,
            0x8000001c: 0x20800,
            0x8000001d: 0x820,
            0x8000001e: 0x20020,
            0x8000001f: 0x8020800
          }
        ];

        // Masks that select the SBOX input
        var SBOX_MASK = [
          0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
          0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
        ];

        /**
         * DES block cipher algorithm.
         */
        var DES = C_algo.DES = BlockCipher.extend({
          _doReset: function () {
            // Shortcuts
            var key = this._key;
            var keyWords = key.words;

            // Select 56 bits according to PC1
            var keyBits = [];
            for (var i = 0; i < 56; i++) {
              var keyBitPos = PC1[i] - 1;
              keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
            }

            // Assemble 16 subkeys
            var subKeys = this._subKeys = [];
            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
              // Create subkey
              var subKey = subKeys[nSubKey] = [];

              // Shortcut
              var bitShift = BIT_SHIFTS[nSubKey];

              // Select 48 bits according to PC2
              for (var i = 0; i < 24; i++) {
                // Select from the left 28 key bits
                subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

                // Select from the right 28 key bits
                subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
              }

              // Since each subkey is applied to an expanded 32-bit input,
              // the subkey can be broken into 8 values scaled to 32-bits,
              // which allows the key to be used without expansion
              subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
              for (var i = 1; i < 7; i++) {
                subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
              }
              subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
            }

            // Compute inverse subkeys
            var invSubKeys = this._invSubKeys = [];
            for (var i = 0; i < 16; i++) {
              invSubKeys[i] = subKeys[15 - i];
            }
          },

          encryptBlock: function (M, offset) {
            this._doCryptBlock(M, offset, this._subKeys);
          },

          decryptBlock: function (M, offset) {
            this._doCryptBlock(M, offset, this._invSubKeys);
          },

          _doCryptBlock: function (M, offset, subKeys) {
            // Get input
            this._lBlock = M[offset];
            this._rBlock = M[offset + 1];

            // Initial permutation
            exchangeLR.call(this, 4,  0x0f0f0f0f);
            exchangeLR.call(this, 16, 0x0000ffff);
            exchangeRL.call(this, 2,  0x33333333);
            exchangeRL.call(this, 8,  0x00ff00ff);
            exchangeLR.call(this, 1,  0x55555555);

            // Rounds
            for (var round = 0; round < 16; round++) {
              // Shortcuts
              var subKey = subKeys[round];
              var lBlock = this._lBlock;
              var rBlock = this._rBlock;

              // Feistel function
              var f = 0;
              for (var i = 0; i < 8; i++) {
                f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
              }
              this._lBlock = rBlock;
              this._rBlock = lBlock ^ f;
            }

            // Undo swap from last round
            var t = this._lBlock;
            this._lBlock = this._rBlock;
            this._rBlock = t;

            // Final permutation
            exchangeLR.call(this, 1,  0x55555555);
            exchangeRL.call(this, 8,  0x00ff00ff);
            exchangeRL.call(this, 2,  0x33333333);
            exchangeLR.call(this, 16, 0x0000ffff);
            exchangeLR.call(this, 4,  0x0f0f0f0f);

            // Set output
            M[offset] = this._lBlock;
            M[offset + 1] = this._rBlock;
          },

          keySize: 64/32,

          ivSize: 64/32,

          blockSize: 64/32
        });

        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
          var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
          this._rBlock ^= t;
          this._lBlock ^= t << offset;
        }

        function exchangeRL(offset, mask) {
          var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
          this._lBlock ^= t;
          this._rBlock ^= t << offset;
        }

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
         */
        C.DES = BlockCipher._createHelper(DES);

        /**
         * Triple-DES block cipher algorithm.
         */
        var TripleDES = C_algo.TripleDES = BlockCipher.extend({
          _doReset: function () {
            // Shortcuts
            var key = this._key;
            var keyWords = key.words;

            // Create DES instances
            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
          },

          encryptBlock: function (M, offset) {
            this._des1.encryptBlock(M, offset);
            this._des2.decryptBlock(M, offset);
            this._des3.encryptBlock(M, offset);
          },

          decryptBlock: function (M, offset) {
            this._des3.decryptBlock(M, offset);
            this._des2.encryptBlock(M, offset);
            this._des1.decryptBlock(M, offset);
          },

          keySize: 192/32,

          ivSize: 64/32,

          blockSize: 64/32
        });

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
         */
        C.TripleDES = BlockCipher._createHelper(TripleDES);
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;

        /**
         * RC4 stream cipher algorithm.
         */
        var RC4 = C_algo.RC4 = StreamCipher.extend({
          _doReset: function () {
            // Shortcuts
            var key = this._key;
            var keyWords = key.words;
            var keySigBytes = key.sigBytes;

            // Init sbox
            var S = this._S = [];
            for (var i = 0; i < 256; i++) {
              S[i] = i;
            }

            // Key setup
            for (var i = 0, j = 0; i < 256; i++) {
              var keyByteIndex = i % keySigBytes;
              var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

              j = (j + S[i] + keyByte) % 256;

              // Swap
              var t = S[i];
              S[i] = S[j];
              S[j] = t;
            }

            // Counters
            this._i = this._j = 0;
          },

          _doProcessBlock: function (M, offset) {
            M[offset] ^= generateKeystreamWord.call(this);
          },

          keySize: 256/32,

          ivSize: 0
        });

        function generateKeystreamWord() {
          // Shortcuts
          var S = this._S;
          var i = this._i;
          var j = this._j;

          // Generate keystream word
          var keystreamWord = 0;
          for (var n = 0; n < 4; n++) {
            i = (i + 1) % 256;
            j = (j + S[i]) % 256;

            // Swap
            var t = S[i];
            S[i] = S[j];
            S[j] = t;

            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
          }

          // Update counters
          this._i = i;
          this._j = j;

          return keystreamWord;
        }

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
         */
        C.RC4 = StreamCipher._createHelper(RC4);

        /**
         * Modified RC4 stream cipher algorithm.
         */
        var RC4Drop = C_algo.RC4Drop = RC4.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: RC4.cfg.extend({
            drop: 192
          }),

          _doReset: function () {
            RC4._doReset.call(this);

            // Drop
            for (var i = this.cfg.drop; i > 0; i--) {
              generateKeystreamWord.call(this);
            }
          }
        });

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
         */
        C.RC4Drop = StreamCipher._createHelper(RC4Drop);
      }());


      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      CryptoJS.mode.CTRGladman = (function () {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

        function incWord(word)
        {
          if (((word >> 24) & 0xff) === 0xff) { //overflow
            var b1 = (word >> 16)&0xff;
            var b2 = (word >> 8)&0xff;
            var b3 = word & 0xff;

            if (b1 === 0xff) // overflow b1
            {
              b1 = 0;
              if (b2 === 0xff)
              {
                b2 = 0;
                if (b3 === 0xff)
                {
                  b3 = 0;
                }
                else
                {
                  ++b3;
                }
              }
              else
              {
                ++b2;
              }
            }
            else
            {
              ++b1;
            }

            word = 0;
            word += (b1 << 16);
            word += (b2 << 8);
            word += b3;
          }
          else
          {
            word += (0x01 << 24);
          }
          return word;
        }

        function incCounter(counter)
        {
          if ((counter[0] = incWord(counter[0])) === 0)
          {
            // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
          }
          return counter;
        }

        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var counter = this._counter;

            // Generate keystream
            if (iv) {
              counter = this._counter = iv.slice(0);

              // Remove IV for subsequent blocks
              this._iv = undefined;
            }

            incCounter(counter);

            var keystream = counter.slice(0);
            cipher.encryptBlock(keystream, 0);

            // Encrypt
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= keystream[i];
            }
          }
        });

        CTRGladman.Decryptor = Encryptor;

        return CTRGladman;
      }());




      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;

        // Reusable objects
        var S  = [];
        var C_ = [];
        var G  = [];

        /**
         * Rabbit stream cipher algorithm
         */
        var Rabbit = C_algo.Rabbit = StreamCipher.extend({
          _doReset: function () {
            // Shortcuts
            var K = this._key.words;
            var iv = this.cfg.iv;

            // Swap endian
            for (var i = 0; i < 4; i++) {
              K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
                (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
            }

            // Generate initial state values
            var X = this._X = [
              K[0], (K[3] << 16) | (K[2] >>> 16),
              K[1], (K[0] << 16) | (K[3] >>> 16),
              K[2], (K[1] << 16) | (K[0] >>> 16),
              K[3], (K[2] << 16) | (K[1] >>> 16)
            ];

            // Generate initial counter values
            var C = this._C = [
              (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
              (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
              (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
              (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
            ];

            // Carry bit
            this._b = 0;

            // Iterate the system four times
            for (var i = 0; i < 4; i++) {
              nextState.call(this);
            }

            // Modify the counters
            for (var i = 0; i < 8; i++) {
              C[i] ^= X[(i + 4) & 7];
            }

            // IV setup
            if (iv) {
              // Shortcuts
              var IV = iv.words;
              var IV_0 = IV[0];
              var IV_1 = IV[1];

              // Generate four subvectors
              var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
              var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
              var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
              var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

              // Modify counter values
              C[0] ^= i0;
              C[1] ^= i1;
              C[2] ^= i2;
              C[3] ^= i3;
              C[4] ^= i0;
              C[5] ^= i1;
              C[6] ^= i2;
              C[7] ^= i3;

              // Iterate the system four times
              for (var i = 0; i < 4; i++) {
                nextState.call(this);
              }
            }
          },

          _doProcessBlock: function (M, offset) {
            // Shortcut
            var X = this._X;

            // Iterate the system
            nextState.call(this);

            // Generate four keystream words
            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

            for (var i = 0; i < 4; i++) {
              // Swap endian
              S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
                (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

              // Encrypt
              M[offset + i] ^= S[i];
            }
          },

          blockSize: 128/32,

          ivSize: 64/32
        });

        function nextState() {
          // Shortcuts
          var X = this._X;
          var C = this._C;

          // Save old counter values
          for (var i = 0; i < 8; i++) {
            C_[i] = C[i];
          }

          // Calculate new counter values
          C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
          C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
          C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
          C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
          C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
          C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
          C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
          C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
          this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

          // Calculate the g-values
          for (var i = 0; i < 8; i++) {
            var gx = X[i] + C[i];

            // Construct high and low argument for squaring
            var ga = gx & 0xffff;
            var gb = gx >>> 16;

            // Calculate high and low result of squaring
            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

            // High XOR low
            G[i] = gh ^ gl;
          }

          // Calculate new state values
          X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
          X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
          X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
          X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
          X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
          X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
          X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
          X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
        }

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
         */
        C.Rabbit = StreamCipher._createHelper(Rabbit);
      }());


      /**
       * Counter block mode.
       */
      CryptoJS.mode.CTR = (function () {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();

        var Encryptor = CTR.Encryptor = CTR.extend({
          processBlock: function (words, offset) {
            // Shortcuts
            var cipher = this._cipher
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var counter = this._counter;

            // Generate keystream
            if (iv) {
              counter = this._counter = iv.slice(0);

              // Remove IV for subsequent blocks
              this._iv = undefined;
            }
            var keystream = counter.slice(0);
            cipher.encryptBlock(keystream, 0);

            // Increment counter
            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

            // Encrypt
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= keystream[i];
            }
          }
        });

        CTR.Decryptor = Encryptor;

        return CTR;
      }());


      (function () {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;

        // Reusable objects
        var S  = [];
        var C_ = [];
        var G  = [];

        /**
         * Rabbit stream cipher algorithm.
         *
         * This is a legacy version that neglected to convert the key to little-endian.
         * This error doesn't affect the cipher's security,
         * but it does affect its compatibility with other implementations.
         */
        var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
          _doReset: function () {
            // Shortcuts
            var K = this._key.words;
            var iv = this.cfg.iv;

            // Generate initial state values
            var X = this._X = [
              K[0], (K[3] << 16) | (K[2] >>> 16),
              K[1], (K[0] << 16) | (K[3] >>> 16),
              K[2], (K[1] << 16) | (K[0] >>> 16),
              K[3], (K[2] << 16) | (K[1] >>> 16)
            ];

            // Generate initial counter values
            var C = this._C = [
              (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
              (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
              (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
              (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
            ];

            // Carry bit
            this._b = 0;

            // Iterate the system four times
            for (var i = 0; i < 4; i++) {
              nextState.call(this);
            }

            // Modify the counters
            for (var i = 0; i < 8; i++) {
              C[i] ^= X[(i + 4) & 7];
            }

            // IV setup
            if (iv) {
              // Shortcuts
              var IV = iv.words;
              var IV_0 = IV[0];
              var IV_1 = IV[1];

              // Generate four subvectors
              var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
              var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
              var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
              var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

              // Modify counter values
              C[0] ^= i0;
              C[1] ^= i1;
              C[2] ^= i2;
              C[3] ^= i3;
              C[4] ^= i0;
              C[5] ^= i1;
              C[6] ^= i2;
              C[7] ^= i3;

              // Iterate the system four times
              for (var i = 0; i < 4; i++) {
                nextState.call(this);
              }
            }
          },

          _doProcessBlock: function (M, offset) {
            // Shortcut
            var X = this._X;

            // Iterate the system
            nextState.call(this);

            // Generate four keystream words
            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

            for (var i = 0; i < 4; i++) {
              // Swap endian
              S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
                (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

              // Encrypt
              M[offset + i] ^= S[i];
            }
          },

          blockSize: 128/32,

          ivSize: 64/32
        });

        function nextState() {
          // Shortcuts
          var X = this._X;
          var C = this._C;

          // Save old counter values
          for (var i = 0; i < 8; i++) {
            C_[i] = C[i];
          }

          // Calculate new counter values
          C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
          C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
          C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
          C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
          C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
          C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
          C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
          C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
          this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

          // Calculate the g-values
          for (var i = 0; i < 8; i++) {
            var gx = X[i] + C[i];

            // Construct high and low argument for squaring
            var ga = gx & 0xffff;
            var gb = gx >>> 16;

            // Calculate high and low result of squaring
            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

            // High XOR low
            G[i] = gh ^ gl;
          }

          // Calculate new state values
          X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
          X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
          X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
          X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
          X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
          X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
          X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
          X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
        }

        /**
         * Shortcut functions to the cipher's object interface.
         *
         * @example
         *
         *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
         *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
         */
        C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
      }());


      /**
       * Zero padding strategy.
       */
      CryptoJS.pad.ZeroPadding = {
        pad: function (data, blockSize) {
          // Shortcut
          var blockSizeBytes = blockSize * 4;

          // Pad
          data.clamp();
          data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
        },

        unpad: function (data) {
          // Shortcut
          var dataWords = data.words;

          // Unpad
          var i = data.sigBytes - 1;
          while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
            i--;
          }
          data.sigBytes = i + 1;
        }
      };


      return CryptoJS;

    }
  }



})();
(function () {
  'use strict';

  angular.module('hmapFront').config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('certificateManage', {
        parent: 'app',
        url: '/certificateManage',
        views: {
          body: {
            templateUrl: 'app/509Manage/certificateManage.html',
            controller: 'CertificateManageController',
            controllerAs: 'vm',
          },
        },
      });
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('CertificateManageService', CertificateManageService);

  CertificateManageService.$inject = ['$http','$filter'];

  function CertificateManageService($http,$filter) {
    const prefix = '/api/x509/certificate';
    return {
      query: query,
      downloadCert: downloadCert,
    };

    function query(app, page, pageSize) {
      const queryUrl = prefix + '/query?page=' + page + '&pageSize=' + pageSize;
      const searchUrl = prefix + '/query/' + app.deviceId + '?page=' + page + '&pageSize=' + pageSize;
      const isSearch = !!app.deviceId;
      
      const dataJson = {};
      if(app.deviceId){
        dataJson.deviceId = app.deviceId;
      }
      if(app.partyName || (app.startDate && app.endDate)){
      	const resourceUrl = prefix + '/queryByDate'+ '?page=' + page + '&pageSize=' + pageSize;
      	if(app.partyName){
      		dataJson.partyName = app.partyName;
      	}
      	if(app.startDate && app.endDate){  		 
      		dataJson.startDate = $filter('date')(app.startDate,'yyyy-MM-dd HH:mm:ss');
      		dataJson.endDate = $filter('date')(app.endDate,'yyyy-MM-dd HH:mm:ss');
      	}
        return $http.post(resourceUrl, dataJson).then(function (response) {
          return response.data;
        });
      }
      return (isSearch ? $http.get(searchUrl) : $http.post(queryUrl, {}))
        .then(function (response) {
          return response.data;
        });
    }

    function downloadCert(deviceId) {
      const url = prefix + '/txtExportForUser/' + deviceId;
      return $http.get(url);
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('CertificateManageController', CertificateManageController);

  CertificateManageController.$inject = [
    'CertificateManageService',
    'paginationConstants',
    '$filter',
    '$translate',
  ];

  function CertificateManageController(
    CertificateManageService,
    paginationConstants,
    $filter,
    $translate
  ) {
    const vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.searchData = {};

    vm.downloadCertificate = downloadCertificate;
    vm.search = search;
    vm.pageChanged = pageChanged;
    vm.compareDate = compareDate;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    const page = vm.page;
    const pageSize = paginationConstants.itemsPerPage;

    loadAll(vm.searchData, page, pageSize);

    function loadAll(searchData, page, pageSize) {
      //修改传输时间的格式
      searchData.startDate = $filter('date')(searchData.startDate,'yyyy-MM-dd HH:mm:ss');
      searchData.endDate = $filter('date')(searchData.endDate,'yyyy-MM-dd HH:mm:ss');
      return CertificateManageService.query(searchData, page, pageSize)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
        });
    }

    function downloadCertificate(deviceId) {
      return CertificateManageService.downloadCert(deviceId);
    }

    function search() {
      const page = vm.page = 1;
      const pageSize = paginationConstants.itemsPerPage;
      loadAll(vm.searchData, page, pageSize);
    }

    function pageChanged() {
      const page = vm.page;
      const pageSize = paginationConstants.itemsPerPage;
      loadAll(vm.searchData, page, pageSize);
    }
    
    $('.form_date').datetimepicker({
      language: 'vm.lang',
      format: 'yyyy-mm-dd hh:ii',
      weekStart: 1,
      todayBtn: 1,
      autoclose: 1,
      todayHighlight: 1,
      startView: 2,
      minView: 0,
      maxView:'decade',
      forceParse: 0,
      minuteStep: 1
    });

    function compareDate() {
      var start = $('#start').val();
      var end = $('#end').val();
      if (start && end) {
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        if (startTime > endTime) {
          var msg = $filter('T')("main.msg");
          vm.data.endTime = "";
          SweetAlert.error(msg, {title: $filter('T')("btnTypeName.prompt")});
        }

        var max = new Date(endTime - startTime).getMonth();
        if(parseInt(max)>=2){
          var msg = $filter('T')("main.msg");
          vm.data.endTime = "";
          SweetAlert.error($translate.instant('dataDistribution.timeInterval'), {title: $filter('T')("btnTypeName.prompt")});
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AccountManageOperationController', AccountManageOperationController);

  AccountManageOperationController.$inject = [
    '$filter',
    '$state',
    'SweetAlert',
    'toastr',
    'MessageTemplateService',
    'AccountManageService',
    'entity',
    'toastrConfig',
    'CryptoJS'
  ];

  function AccountManageOperationController(
    $filter,
    $state,
    SweetAlert,
    toastr,
    MessageTemplateService,
    AccountManageService,
    entity,
    toastrConfig,
    CryptoJS
  ) {
    const vm = this;
    const isEdit = !!entity.partyName;
    
    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
    vm.accountInfo = entity;
    vm.isEdit = isEdit;

    vm.showPwdEnabled = true;

    vm.initialWidget = initialWidget;
    vm.showOrHidePwd = showOrHidePwd;
    vm.clear = clear;
    vm.saveAccount = saveAccount;

    vm.initialWidget();

    function initialWidget() {
      MessageTemplateService.getByCode()
        .query({code: 'SYS.PROCESSING_STATUS'}, function (data) {
          vm.accountStatus = data.rows;
        }, function (error) {
        });

      if (!!entity.partyName) {
        AccountManageService.query(entity)
          .then(function (response) {
            vm.accountInfo = response.rows[0];
          });
      }
    }

    function showOrHidePwd() {
      const pwdInput = angular.element('#initialPassword');
      const pwdInputConfirm = angular.element('#confirmPassword');
      if (vm.showPwdEnabled) {
        pwdInput.prop('type', 'text');
        pwdInputConfirm.prop('type', 'text');
        vm.showPwdEnabled = false;
      } else {
        pwdInput.prop('type', 'password');
        pwdInputConfirm.prop('type', 'password');
        vm.showPwdEnabled = true;
      }
    }

    function clear() {
      $state.go('accountManage');
    }

    function saveAccount() {
      if (vm.accountInfo.password === vm.accountInfo.confirmPassword) {
        vm.accountInfo.macAddress = vm.accountInfo.macAddress.toUpperCase();
        //以下注释掉的代码存在问题,导致打包失败故屏蔽
        //let value = CryptoJS.SHA256(vm.accountInfo.password);
        vm.accountInfo.password=CryptoJS.SHA256.SHA256(vm.accountInfo.password).toString().toUpperCase();
        //console.log('sha256 hexStr->' + vm.accountInfo.password);
        (!isEdit ? AccountManageService.create(vm.accountInfo) : AccountManageService.update(vm.accountInfo))
          .then(function (response) {
            if (response.success) {
              toastr.success($filter('T')('title.saveSuccess'));
              vm.clear();
            } else {
              //失败则复原加密的密码
              vm.accountInfo.password = vm.accountInfo.confirmPassword;
              toastr.error(
                response.message,
                $filter('T')("btnTypeName.prompt")
              );
            }
          });
      } else {
        toastr.error(
          $filter('T')("title.pwdNotSame"),
          $filter('T')("btnTypeName.prompt")
        );
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront').config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('accountManage', {
        parent: 'app',
        url: '/accountManage',
        views: {
          body: {
            templateUrl: 'app/509Manage/accountManage.html',
            controller: 'AccountManageController',
            controllerAs: 'vm',
          },
        },
      })
      .state('accountManage.add', {
        parent: 'app',
        url: '/accountManage/add',
        views: {
          body: {
            templateUrl: 'app/509Manage/accountManageOperation.html',
            controller: 'AccountManageOperationController',
            controllerAs: 'vm',
            resolve: {
              entity: function () {
                return {
                  partyName: null,
                  vendorName: null,
                  clientId: null,
                  macAddress: null,
                  totalCount: null,
                  password: null,
                  partyStatus: null,
                };
              },
            },
          },
        },
      })
      .state('accountManage.edit', {
        parent: 'app',
        url: '/accountManage/edit/:partyName',
        views: {
          body: {
            templateUrl: 'app/509Manage/accountManageOperation.html',
            controller: 'AccountManageOperationController',
            controllerAs: 'vm',
            resolve: {
              entity: function ($stateParams) {
                return {
                  partyName: $stateParams.partyName,
                };
              },
            }
          },
        },
      });
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
    .factory('AccountManageService', AccountManageService);

  AccountManageService.$inject = ['$http'];

  function AccountManageService($http) {
    const prefix = '/api/x509/party';

    return {
      query: query,
      update: update,
      remove: remove,
      create: create,
    };

    function query(app, page, pageSize) {
      const queryUrl = prefix + '/query?page=' + page + '&pageSize=' + pageSize;
      const searchUrl = prefix + '/queryByName/' + app.partyName + '?page=' + page + '&pageSize=' + pageSize;
      const hasUsername = !!app.partyName;

      return (hasUsername ? $http.get(searchUrl) : $http.post(queryUrl, {}))
        .then(function (response) {
          return response.data;
        })
    }

    function update(app) {
      const url = prefix + '/update';
      const params = Object
        .keys(app)
        .filter(function (key) {
          return key !== 'partyName';
        })
        .reduce(function (acc, key) {
          acc[key] = app[key];
          return acc;
        }, {})
      return $http.post(url, params)
        .then(function (response) {
          return response.data;
        });
    }

    function remove(accountId) {
      const url = prefix + '/delete/' + accountId;
      return $http.post(url)
        .then(function (response) {
          return response.data;
        });
    }

    function create(app) {
      const url = prefix + '/insert';
      return $http.post(url, app)
        .then(function (response) {
          return response.data;
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('hmapFront')
    .controller('AccountManageController', AccountManageController);

  AccountManageController.$inject = [
    '$filter',
    '$state',
    'toastr',
    'AccountManageService',
    'paginationConstants',
    'SweetAlert',
    'MessageTemplateService',
    'toastrConfig'
  ];

  function AccountManageController(
    $filter,
    $state,
    toastr,
    AccountManageService,
    paginationConstants,
    SweetAlert,
    MessageTemplateService,
    toastrConfig
  ) {
    const vm = this;
    vm.page = 1;
    vm.totalItems = null;
    vm.searchData = {};

    vm.deleteAccount = deleteAccount;
    vm.search = search;
    vm.pageChanged = pageChanged;

    vm.itemsPerPage = paginationConstants.itemsPerPage;
    const page = vm.page;
    const pageSize = paginationConstants.itemsPerPage;

    loadAll(vm.searchData, page, pageSize);
    initWidget();

    function initWidget() {
      MessageTemplateService.getByCode()
        .query({code: 'SYS.PROCESSING_STATUS'}, function (data) {
          vm.accountStatus = data.rows;
        }, function (error) {
        });
    }
    initWidget();

    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });

    function initWidget() {
      MessageTemplateService.getByCode()
        .query({code: 'SYS.PROCESSING_STATUS'}, function (data) {
          vm.accountStatus = data.rows;
        }, function (error) {
        });
    }

    function loadAll(searchData, page, pageSize) {
      return AccountManageService.query(searchData, page, pageSize)
        .then(function (data) {
          vm.result = data.rows;
          vm.totalItems = data.total;
        });
    }

    function deleteAccount(searchData) {
      SweetAlert.confirm(
        $filter('T')("title.deleteTip"),
        {title: $filter('T')("title.confirmTitle")}
      ).then(function (p) {
        if (p) {
          AccountManageService.remove(searchData.partyId)
            .then(function (response) {
              if (response.success) {
                toastr.success($filter('T')('title.saveSuccess'));
                loadAll(vm.searchData, vm.page, paginationConstants.itemsPerPage);
              } else {
                toastr.error(response.message, $filter('T')("btnTypeName.prompt"));
              }
            });
        }
      });
    }

    function search() {
      const page = vm.page = 1;
      const pageSize = paginationConstants.itemsPerPage;
      loadAll(vm.searchData, page, pageSize);
    }

    function pageChanged() {
      const page = vm.page;
      const pageSize = paginationConstants.itemsPerPage;
      loadAll(vm.searchData, page, pageSize);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hmapFront')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';

  angular
  .module('hmapFront')
  .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $httpProvider, $translateProvider, $translateStaticFilesLoaderProvider) {
    var lang = window.localStorage.lang || 'en_GB';
    $translateProvider.preferredLanguage(lang);

    $translateProvider.useStaticFilesLoader({
      prefix: 'app/iot/portal/common/i18n/',
      suffix: '.json'
    });
    $stateProvider
    .state('appDownloadFix', {
      url: "/app/appDownload",
      params: {"url": null, "type": null},
      views: {
        'content@': {
          templateUrl: "app/appEdition/AppDownload.html",
          controller: 'AppDownloadController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {
            referenceSource: 'residential'
          };
        }
      }
    })
    .state('commercialAppDownload', {
      url: "/commercialAppDownload",
      params: {"url": null, "type": null},
      views: {
        'content@': {
          templateUrl: "app/appEdition/CommercialAppDownload.html",
          controller: 'AppDownloadController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {
            referenceSource: 'commercial'
          };
        }
      }
    })
    .state('nextGenAppDownload', {
      url: "/nextgen/appDownload",
      params: {"url": null, "type": null},
      views: {
        'content@': {
          templateUrl: "app/appEdition/PreNextGenAppDownload.html",
          controller: 'PreNextGenTooltipController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {
            referenceSource: 'nextgen'
          };
        }
      }
    })
    .state('nextGenAppDownloadFix', {
      url: "/nextgen/appDownloadFix",
      params: {"url": null, "type": null},
      views: {
        'content@': {
          templateUrl: "app/appEdition/NextGenAppDownload.html",
          controller: 'AppDownloadController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {
            referenceSource: 'nextgen'
          };
        }
      }
    })
    .state('appDownload', {
      url: "/appDownload",
      params: {"url": null, "type": null},
      views: {
        'content@': {
          templateUrl: "app/appEdition/AppDownload.html",
          controller: 'AppDownloadController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        entity: function () {
          return {
            referenceSource: 'residential'
          };
        }
      }
    })
    .state('app', {
      abstract: true,
      url: "/app",
      views: {
        'content@': {
          templateUrl: 'app/layouts/content.html'
        },
        'navigation@app': {
          templateUrl: 'app/layouts/leftnavbar/leftnavbar.html',
          controller: 'LeftnavbarController',
          controllerAs: 'vm'
        },
        'topnavbar@app': {
          templateUrl: 'app/layouts/topnavbar/topnavbar.html',
          controller: 'TopnavbarController',
          controllerAs: 'vm'
        },
        'footer@app': {
          templateUrl: 'app/layouts/footer.html'
        }
      },
      resolve: {
        authorize: ['Auth',
          function (Auth) {
            return Auth.authorize();
          }
        ]
      }
    })
    .state('mainPage', {
      url: "/mainPage",
      params: {"url": null, "type": null},
      views: {
        'content@': {
          templateUrl: 'app/iot/portal/admin/login/html/mainPage.html',
          controller: 'MainPageController',
          controllerAs: 'vm'
        }
      }
    });

    $urlRouterProvider.otherwise('/app/amain');
    //$httpProvider.defaults.withCredentials = true;
    $httpProvider.defaults.useXDomain = true;
  }
})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('hmapFront')
    .constant('VERSION', "0.0.1-SNAPSHOT")
    .constant('DEBUG_INFO_ENABLED', true)
  ;
})();

(function () {
  'use strict';

  angular
    .module('hmapFront')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $uibModalProvider, BaseConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    //forbidden close modal frame via esc key!
    $uibModalProvider.options = {
      keyboard: false
    };

    Offline.options = {
      checks: {
        xhr: {
          url: BaseConfig.url + '/api/public/keepAlive',
          type: 'GET',
          timeout: 2000
        }
      },
      checkOnLoad: false,
      interceptRequests: true,
      reconnect: {
        initialDelay: 3,
        delay: 3
      },
      requests: true,
      game: false
    };
  }

})();

angular.module("hmapFront").run(["$templateCache", function($templateCache) {$templateCache.put("app/509Manage/accountManage.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  table td{\n    max-width:200px;\n    word-wrap:break-word;\n    text-overflow:ellipsis;\n    white-space:nowrap;\n    overflow:hidden;\n  }\n  table td:hover{\n    white-space:normal;\n    overflow:auto;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=accountManage.title></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-12><label class=\"col-lg-1 control-label\"><span translate=accountManage.username></span></label><div class=col-lg-3><input type=text ng-model=vm.searchData.partyName class=form-control></div><button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-info\" type=button ui-sref=accountManage.add><span translate=btnTypeName.create></span></button></div></div></div></form><div style=margin-top:50px;width:100%;overflow:auto><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=accountManage.username></span></th><th><span translate=accountManage.clientId></span></th><th><span translate=accountManage.computerMACAddress></span></th><th><span translate=accountManage.supplier></span></th><th><span translate=accountManage.latestDeviceId></span></th><th><span translate=accountManage.generatedDeviceIdNum></span></th><th><span translate=accountManage.deviceIdTotalNum></span></th><th><span translate=accountManage.createTime></span></th><th><span translate=accountManage.notes></span></th><th><span translate=accountManage.status></span></th></tr></thead><tr ng-repeat=\"accountRecord in vm.result\"><td><a ui-sref=\"accountManage.edit({partyName: accountRecord.partyName})\"><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span> </i></a><a ng-click=vm.deleteAccount(accountRecord)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{accountRecord.partyName}}</td><td>{{accountRecord.clientId}}</td><td>{{accountRecord.macAddress}}</td><td>{{accountRecord.vendorName}}</td><td>{{accountRecord.currentDeviceId}}</td><td>{{accountRecord.generatedCount}}</td><td>{{accountRecord.totalCount}}</td><td>{{accountRecord.createTime}}</td><td>{{accountRecord.notes}}</td><td><select ng-model=accountRecord.partyStatus disabled><option ng-repeat=\"item in vm.accountStatus\" value={{item.value}}>{{item.meaning}}</option></select></td></tr></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/509Manage/accountManageOperation.html","<div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=accountManage.title></span></h5></div><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.saveAccount()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=accountManage.username></span></label><div class=col-lg-8><input ng-disabled=vm.isEdit type=text ng-model=vm.accountInfo.partyName class=form-control required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=accountManage.supplier></span></label><div class=col-lg-8><input type=text ng-model=vm.accountInfo.vendorName class=form-control required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=accountManage.latestDeviceId></span></label><div class=col-lg-8><input ng-disabled=vm.isEdit type=text outline=medium ng-model=vm.accountInfo.currentDeviceId class=form-control readonly></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=accountManage.clientId></span></label><div class=col-lg-8><input type=text ng-model=vm.accountInfo.clientId class=form-control required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=accountManage.computerMACAddress></span></label><div class=col-lg-8><input type=text ng-model=vm.accountInfo.macAddress class=form-control required placeholder=\"{{\'accountManage.macAddressTips\' | T}}\" ng-pattern=/^[A-Fa-f0-9]{12}$/ style=text-transform:uppercase></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=accountManage.status></span></label><div class=col-lg-8><select ng-model=vm.accountInfo.partyStatus class=form-control required><option ng-repeat=\"item in vm.accountStatus\" value={{item.value}}>{{item.meaning}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=accountManage.deviceIdTotalNum></span></label><div class=col-lg-8><input type=text ng-model=vm.accountInfo.totalCount class=form-control required placeholder=\"{{\'accountManage.deviceIdTotalNumTips\' | T}}\" ng-pattern=/^[1-9]\\d*$/ ></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=accountManage.initialPassword></span></label><div class=col-lg-8><input id=initialPassword type=password ng-model=vm.accountInfo.password class=form-control ng-blur=vm.validatePwd() placeholder=\"{{\'accountManage.passwordTips\' | T}}\" ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\" onkeyup=\"value=value.replace(/[^\\w]/g,\'\')\" required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=accountManage.confirmPassword></span></label><div class=col-lg-8><input id=confirmPassword type=password ng-model=vm.accountInfo.confirmPassword class=form-control ng-blur=vm.validatePwd() placeholder=\"{{\'accountManage.passwordConfirm\' | T}}\" ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\" onkeyup=\"value=value.replace(/[^\\w]/g,\'\')\" required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=accountManage.notes></span></label><div class=col-lg-8><textarea ng-model=vm.accountInfo.notes class=form-control maxlength=1024 rows=4></textarea></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button ng-click=vm.showOrHidePwd() class=\"btn btn-warning\"><span ng-if=vm.showPwdEnabled translate=btnTypeName.showPwd></span> <span ng-if=!vm.showPwdEnabled translate=btnTypeName.hidePwd></span></button> <button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span> <span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span> <span translate=btnTypeName.save></span></button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/509Manage/certificateManage.html","<style>table td{\n    max-width:300px;\n    word-wrap:break-word;\n    text-overflow:ellipsis;\n    white-space:nowrap;\n    overflow:hidden;\n  }\n  table td:hover{\n    white-space:normal;\n    overflow:auto;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=certificateManage.title></span></h5></div><div class=ibox-content><span style=color:red>*</span><span translate=certificateManage.prompt></span><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-8 style=\"margin-top: 10px\"><label class=\"col-lg-2 control-label\"><span translate=certificateManage.deviceId></span></label><div class=col-lg-4><input type=text ng-model=vm.searchData.deviceId class=form-control title=certificateManage.prompt></div><label class=\"col-lg-2 control-label\"><span translate=certificateManage.partyName></span></label><div class=col-lg-4><input type=text ng-model=vm.searchData.partyName class=form-control></div><label for=start class=\"col-lg-2 control-label\" style=\"margin-top: 10px\"><span translate=certificateManage.startDate></span></label><div class=col-lg-4 style=\"margin-top: 10px\"><p class=\"input-group date form_date\"><input type=text class=form-control id=start name=start ng-model=\"vm.searchData.startDate \" ng-change=vm.compareDate() disabled> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span></span> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div><label for=end class=\"col-lg-2 control-label\" style=\"margin-top: 10px\"><span translate=certificateManage.endDate></span></label><div class=col-lg-4 style=\"margin-top: 10px\"><p class=\"input-group date form_date\"><input type=text class=form-control id=end name=end ng-model=vm.searchData.endDate ng-change=vm.compareDate() disabled> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span></span> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-4><button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></form><div style=margin-top:50px;width:100%;overflow:auto><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=certificateManage.deviceId></span></th><th><span translate=certificateManage.partyName></span></th><th><span translate=certificateManage.createTime></span></th><th><span translate=certificateManage.expirationTime></span></th><th><span translate=certificateManage.certificate></span></th><th><span translate=btnTypeName.operation></span></th></tr></thead><tr ng-repeat=\"certificateRecord in vm.result\"><td>{{certificateRecord.commonName}}</td><td>{{certificateRecord.partyName}}</td><td>{{certificateRecord.createTime}}</td><td>{{certificateRecord.expirationTime}}</td><td>{{certificateRecord.certificate}}</td><td><a ng-show=\"{{certificateRecord.certificate ? true : false}}\" href=\"data:application/text;charset=utf-8,{{certificateRecord.certificate}}\" download={{certificateRecord.commonName}}.txt><i class=\"fa fa-edit text-navy\"><span translate=certificateManage.downloadCertificate></span></i></a></td></tr></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/accountRole/accountRole.html","<toaster-container></toaster-container><div class=\"wrapper wrapper-content\"><div class=contact-item><div class=row><div><h3>设置管理员</h3></div></div></div><div class=row><div class=\"col-lg-3 corp-tree\" style=\"height: 603px\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content mailbox-content\"><div class=file-manager><div class=row><uib-tabset active=activeForm><uib-tab index=1 heading=角色 select=vm.selectRole()><div class=\"form-group m-t\"><div class=table-responsive><table class=\"table table table-hover table-striped\"><tbody><tr ng-repeat=\"role in vm.allAccountRole\"><td width=100% ng-click=vm.selectRole(role)><a><i class=\"fa fa-user-md\"></i>{{role.roleName}}</a></td><!--                          <td width=\"25%\" align=\"right\" ng-if=\"tag.tagStatus==\'lock\' && tag.tagOwner != vm.currentUserName \">\n                            &lt;!&ndash;<i class=\"fa fa-lock\" ></i>&ndash;&gt;\n                          </td>--><!-- <td width=\"25%\" align=\"right\" ng-if=\"tag.tagStatus!=\'lock\' && tag.tagOwner!= vm.currentUserName\">\n                            <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\n                              <a href=\"\" id=\"simple-dropdown\" class=\"btn btn-xs btn-primary\" uib-dropdown-toggle>\n\n                                <i class=\"fa fa-pencil\"></i>\n                              </a>\n                              <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"simple-dropdown\">\n                                <li role=\"menuitem\"><a href=\"\" ng-click=\"vm.updateTag(tag.id)\">重命名</a></li>\n                                <li role=\"menuitem\"><a href=\"\" ng-click=\"vm.deleteTag(tag.id)\">删除</a></li>\n                                <li role=\"menuitem\"><a href=\"\" ng-click=\"vm.lockTag(tag,\'lock\')\">加锁</a></li>\n                              </ul>\n                            </div>\n                          </td>--><!-- 当前用户操作 --><!--<td width=\"25%\" align=\"right\" ng-if=\"tag.tagStatus==\'lock\' && tag.tagOwner == vm.currentUserName \">\n                            <i class=\"fa fa-lock\" ></i>\n                          </td>--><!--<td width=\"25%\" align=\"right\" ng-if=\"tag.tagOwner == vm.currentUserName \">\n                            <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\n                              <a href=\"\" id=\"simple-dropdown1\" class=\"btn btn-xs btn-primary\" uib-dropdown-toggle>\n                                <i class=\"fa fa-lock\" ng-if=\"tag.tagStatus==\'lock\'\"></i>\n                                <i class=\"fa fa-pencil\" ng-if=\"tag.tagStatus!=\'lock\'\"></i>\n                              </a>\n                              <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"simple-dropdown1\">\n                                <li role=\"menuitem\" ng-if=\"tag.tagStatus!=\'lock\'\"><a href=\"\" ng-click=\"vm.updateTag(tag.id)\">重命名</a></li>\n                                <li role=\"menuitem\" ng-if=\"tag.tagStatus!=\'lock\'\"><a href=\"\" ng-click=\"vm.deleteTag(tag.id)\">删除</a></li>\n                                <li role=\"menuitem\" ng-if=\"tag.tagStatus==\'lock\'\">\n                                  <a href=\"\" ng-click=\"vm.lockTag(tag,\'unlock\')\">\n                                  解锁\n                                </a></li>\n                                <li role=\"menuitem\" ng-if=\"tag.tagStatus!=\'lock\'\">\n                                  <a href=\"\" ng-click=\"vm.lockTag(tag,\'lock\')\">\n                                    加锁\n                                </a></li>\n                              </ul>\n                            </div>\n                          </td>--></tr></tbody></table></div></div></uib-tab></uib-tabset></div></div></div></div></div><div class=\"col-lg-9 animated fadeInRight corp-tree\" style=\"height: 603px\"><!--<div class=\"content\" ng-show=\"vm.isOrgShow\">\n        <div class=\"row\">\n          <div id=\"org-views\" ui-view=\"\" class=\"ng-scope\">\n            <fieldset class=\"ng-scope\">\n              <h2>{{vm.currentDept.deptName}}</h2>\n            </fieldset>\n            <fieldset class=\"m-t-md ng-scope\" ng-if=\"vm.isChoiceDept\">\n              <div class=\"row col-lg-5\">\n                <div class=\"input-group col-lg-offset-1 col-lg-11\">\n                  <a ui-sref=\"contacts.addStaff({id:vm.currentDept.deptNumber})\" class=\"btn btn-primary\">新建成员</a>\n                  <a ui-sref=\"contacts.importStaff()\" class=\"btn btn-primary\">批量导入</a>\n                  <a href=\"{{vm.exportPath}}\" class=\"btn btn-primary\">批量导出</a>\n                  <div class=\"input-group-btn\">\n                    <button data-toggle=\"dropdown\" class=\"btn btn-white dropdown-toggle\" type=\"button\"><span class=\"caret\"></span>\n                    </button>\n                    <ul class=\"dropdown-menu pull-right\">\n                      <li><a ui-sref=\"contacts.addDept({id:vm.currentDept.deptNumber})\">添加子部门</a></li>\n                      <li><a ui-sref=\"contacts.editDept({deptNumber:vm.currentDept.deptNumber,deptName:vm.currentDept.deptName})\">修改部门</a></li>\n                      <li><a ng-click=\"\">上移</a></li>\n                      <li><a ng-click=\"\">下移</a></li>\n                      <li><a ng-click=\"vm.deleteStaff()\">删除</a></li>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n            </fieldset>\n          </div>\n\n        </div>\n        <div class=\"row\">\n          <div class=\"table-responsive\">\n            <table id=\"staffTable\" class=\"table table-striped\">\n              <thead>\n              <tr>\n                <th width=\"10%\">操作</th>\n                <th width=\"20%\">姓名</th>\n                <th width=\"20%\">工号</th>\n                <th width=\"20%\">手机</th>\n                <th width=\"20%\">邮箱</th>\n                <th width=\"10%\">状态</th>\n              </tr>\n              </thead>\n              <tbody>\n\n              <tr ng-show=\"vm.isSpinnerShow\">\n                <td colspan=\"6\">\n                  <div class=\"spiner-example\">\n                    <div class=\"sk-spinner sk-spinner-pulse\"></div>\n                  </div>\n                </td>\n              </tr>\n\n              <tr ng-repeat=\"staff in vm.staffs track by staff.userId\" ng-show=\"vm.isStaffShow\"  >\n\n                <td >\n                  <input type=\"checkbox\" ng-model=\"staff.checked\"/>\n                  <a ui-sref=\"contacts.dialogStaff({id:staff.accountNumber})\" style=\"margin-left: 5px;\">编辑</a>\n                </td>\n                <td>{{staff.userName}}</td>\n                <td>{{staff.accountNumber}}</td>\n                <td>{{staff.mobile}}</td>\n                <td>{{staff.email}}</td>\n                <td>{{staff.empStatus}}</td>\n              </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"text-center\">\n            <item-count page=\"vm.page\" total=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\"></item-count>\n            <uib-pagination class=\"pagination-sm\"\n                            total-items=\"vm.totalItems\"\n                            ng-model=\"vm.page\"\n                            ng-change=\"vm.pageChanged()\"></uib-pagination>\n          </div>\n        </div>\n      </div>--><div class=content><div class=row><div id=tag-views class=ng-scope><fieldset class=ng-scope><h2>{{vm.currentRole.roleName}}</h2></fieldset><fieldset class=\"m-t-md ng-scope\"><staff-permission-selector permission-data=vm.permissionData ng-model=vm.permissionData></staff-permission-selector><!--<a href=\"\" class=\"btn btn-primary\" ng-click=\"vm.deleteTagMembers()\">批量删除</a>--></fieldset></div></div><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th width=10%>姓名</th><th width=20%>部门</th><th width=20%>手机号</th><th width=10%>工号</th></tr></thead><tbody><tr ng-repeat=\"roleMember in vm.roleMembers\"><td>{{roleMember.userName}}</td><td>{{roleMember.deptName}}</td><td>{{roleMember.mobile}}</td><td>{{roleMember.accountNumber}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/appConfigure/addAppAuth.html","<script>$(function () {\n    \'use strict\';\n    $(\"#uploadImg\").change(function () {\n      var imgPath = $(\"#uploadImg\").val();\n      var fileName = getFileName(imgPath);\n      $(\"#filePath\").val(fileName);\n    });\n    function getFileName(o) {\n      var pos = o.lastIndexOf(\"\\\\\");\n      return o.substring(pos + 1);\n    }\n  });</script><form name=addForm role=form ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=appAuth.addAppConfigTitle></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><input type=hidden class=form-control ng-model=vm.hmsAppAuth.Id><label class=control-label for=field_appName><span translate=appAuth.appName></span>应用名称</label><input type=text class=form-control style=\"width:300px;border: 1px solid grey\" name=appName id=field_appName ng-model=vm.hmsAppAuth.appName required></div></div><input type=hidden ng-model=vm.hmsAppAuth.appType><!--<div class=\"col-md-6\">\n        <div class=\"form-group\">\n\n          <label class=\"control-label\"><span translate=\"appAuth.updateAppConfig\"></span>应用类型</label>\n          <select class=\"form-control\" ng-model=\"vm.hmsAppAuth.appType\" ng-change=\"vm.changeType()\"\n                  style=\"width:300px;border: 1px solid grey;\" ng-init=\"vm.hmsAppAuth.appType=\'客户端应用\'\" required>\n            <option ng-repeat=\"x in vm.appType\" value=\"{{x.code}}\">{{x.name}}</option>\n          </select>\n        </div>\n      </div>--></div><div class=row><div class=col-md-6><div class=form-group><!--<div class=\"row\">--><!--<div class=\"col-lg-10\">--><label class=control-label for=filePath><span translate=appAuth.updateAppConfig></span>App图标</label><!--<input type=\"hidden\" class=\"form-control\" style=\"width: 300px;border: 1px solid grey;\" name=\"appIcon\"--><!--id=\"field_appIcon\"--><!--ng-model=\"vm.hmsAppAuth.appIcon\" required>--><!--<input type=\"file\" ng-model=\"vm.file\" ngf-select name=\"file\" accept=\"image/*\" required>--><div><div style=\"float: left\"><input type=text id=filePath readonly class=form-control style=\"height:33px;width:300px;border:1px solid #E5E6E7\"></div><a href=javascript:void(0); class=\"input btn-primary\">浏览 <input type=file id=uploadImg class=uploadFile ng-model=vm.file ngf-select name=file accept=image/* required></a></div><!--</div>--><!--<div class=\"col-lg-10\">--><div style=\"font-size: 40px\" ng-show=vm.imgShow><img height=50 width=50 ngf-src=vm.file></div><!--</div>--><!--</div>--><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div>开始上传</div><!--<div ng-show=\"vm.varMays\">上传成功</div>--></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=appAuth.updateAppConfig></span>授权模式</label><select class=form-control ng-model=vm.hmsAppAuth.appAuzMode style=\"width:300px;border: 1px solid grey\" required><option ng-repeat=\"x in vm.appAuzMode\" value={{x.code}}>{{x.name}}</option></select></div></div></div><div class=row><div class=col-md-6><permission-selector permission-data=vm.permissionData></permission-selector></div><div class=col-md-6></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></form>");
$templateCache.put("app/appConfigure/appAuth-detail-new.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=appAuth.addAppConfigTitle></span></h4></div><div class=modal-body><div class=row style=text-align:center><div style=text-align:center><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 60px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile></div><div><span translate=title.uploadPicTip></span></div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div><span translate=btnTypeName.upload></span></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><input type=hidden class=form-control ng-model=vm.hmsAppAuth.Id><label class=control-label for=field_appName><font color=red>*</font><span translate=thirdParty.appName></span></label><div class=input-group><input type=text class=form-control disabled style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=field_appName ng-model=vm.hmsAppAuth.appName required> <span class=input-group-btn><button id=appNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'appName\')\" value=appName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><input type=hidden class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appType ng-init=\"vm.hmsAppAuth.appType=\'客户端应用\'\" ng-model=vm.hmsAppAuth.appType required disabled><!--<div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n\n          <label class=\"control-label\"><font color=\"red\">*</font><span translate=\"appAuth.appType\"></span></label>\n          <input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appType\"\n                 ng-init=\"vm.hmsAppAuth.appType=\'客户端应用\'\" ng-model=\"vm.hmsAppAuth.appType\" required disabled>\n        </div>\n      </div>\n    </div>--><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><font color=red>*</font><span translate=appAuth.clientType></span></label><select class=form-control ng-model=vm.hmsAppAuth.clientType ng-change=vm.changeClient() style=\"width:100%;border: 1px solid #c8cacd\" id=clientType required><option ng-repeat=\"x in vm.clientType\" value={{x.code}}>{{x.name}}</option></select></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><font color=red>*</font><span translate=header.authorizationMode></span></label><select class=form-control ng-model=vm.hmsAppAuth.appAuzMode style=\"width:100%;border: 1px solid #c8cacd\" required><option ng-repeat=\"x in vm.appAuzMode\" value={{x.code}}>{{x.name}}</option></select></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><font color=red>*</font><span translate=appAuth.applicationType></span></label><select class=form-control ng-model=vm.hmsAppAuth.applicationType style=\"width:100%;border: 1px solid #c8cacd\" required><option value=residential>residential</option><option value=commercial>commercial</option><option value=admin>admin</option><option value=idkey>idkey</option><option value=skusn>skusn</option></select></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=header.whetherContainsPlugin></span></label><input type=checkbox ng-model=vm.hmsAppAuth.isContainsPlugin ngtruevalue=Y ngfalsevalue=N> &nbsp;&nbsp;&nbsp;&nbsp;<label class=control-label><span translate=header.whetherApp></span></label><input type=checkbox ng-click=vm.chooseThisApp() ng-model=vm.hmsAppAuth.isApp ngtruevalue=Y ngfalsevalue=N></div></div></div><!-- <div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><span translate=\"header.whetherApp\"></span></label>\n          <input type=\"checkbox\" ng-model=\"vm.hmsAppAuth.isApp\" ngTrueValue=\"Y\" ngFalseValue=\"N\">\n        </div>\n      </div>\n    </div>--></div><div class=modal-footer style=text-align:center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.return></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><div class=\"modal fade\" id=localeModal_appName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_appName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'appName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/appConfigure/appAuth-detail.html","<style>span {\n    font-size: 15px;\n  }\n\n  .menu-bcackground {\n    background-color: #f3f3f4;\n    width: 80%;\n    margin: 0 auto;\n  }\n\n  .menu-bcackground-selected {\n    background-color: #eaeaea;\n    width: 80%;\n    margin: 0 auto;\n  }\n  div{\n    outline:none;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }\n\n  .border {\n    border-bottom: 1px solid #c8cacd;\n    position: relative;\n    left: 25%;\n    width: 55%;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionspan><span translate=appAuth.updateAppConfig></span></h4></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'oldFile\' || vm.ischecked==\'oldFile\']\" ng-mouseenter=\"vm.mouseIn = \'oldFile\'\"><div class=row ng-click=\"vm.check(\'oldFile\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=appAuth.clientLogo></span></span></div><div class=col-md-8><div ng-if=\"vm.ischecked==\'oldFile\'\"><input ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=position:absolute;opacity:0;z-index:100;cursor:pointer;width:80px;height:80px type=file></div><div><img style=width:80px;height:80px ngf-src=vm.oldFile></div><div ng-if=\"vm.ischecked==\'oldFile\'\"><div><span translate=plugin.imageSize></span></div><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=button ng-click=vm.submitFile() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div><div class=col-md-1><a><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'appId\']\" ng-mouseenter=\"vm.mouseIn=\'appId\'\"><div class=row><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>AppID</span></div><div class=col-md-8><span class=control-span>{{vm.hmsAppAuth.appId}}</span></div></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'appSecret\' || vm.ischecked==\'appSecret\']\" ng-mouseenter=\"vm.mouseIn=\'appSecret\'\"><div class=row><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>AppSecret</span></div><div class=col-md-8><span class=control-span>{{vm.hmsAppAuth.appSecret}}</span></div></div><div class=col-md-1 ng-click=vm.refreshSecret()><a><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.flush></span></i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'userName\']\" ng-mouseenter=\"vm.mouseIn=\'userName\'\"><div class=row><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=appAuth.creater></span></span></div><div class=col-md-8><span class=control-span>{{vm.hmsAppAuth.userName}}</span></div></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'appName\' || vm.ischecked==\'appName\']\" ng-mouseenter=\"vm.mouseIn=\'appName\'\"><div class=row ng-click=\"vm.check(\'appName\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=appAuth.appName></span></span></div><div class=col-md-8><span ng-if=\"vm.ischecked!=\'appName\'\" class=control-span>{{vm.hmsAppAuth.appName}}</span><div ng-if=\"vm.ischecked==\'appName\'\"><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateName ng-model=vm.hmsAppAuth.appName readonly> <span class=input-group-btn><button id=appNameBtn class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'appName\')\" value=menuName><i class=\"fa fa-globe\"></i></button></span></div><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div><div class=col-md-1><a><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'clientType\']\" ng-mouseenter=\"vm.mouseIn=\'clientType\'\"><div class=row><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=appAuth.clientType></span></span></div><div class=col-md-8><span class=control-span ng-if=\"vm.hmsAppAuth.clientType==\'in\'\"><span translate=roleManage.in></span></span> <span class=control-span ng-if=\"vm.hmsAppAuth.clientType==\'out\'\"><span translate=roleManage.out></span></span></div></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'appAuzMode\']\" ng-mouseenter=\"vm.mouseIn=\'appAuzMode\'\"><div class=row><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=appAuth.grantType></span></span></div><div class=col-md-8><span ng-if=\"vm.hmsAppAuth.appAuzMode==\'password\'\" class=control-span><span translate=appAuth.password></span></span> <span ng-if=\"vm.hmsAppAuth.appAuzMode==\'client_credentials\'\" class=control-span><span translate=appAuth.clientCredentials></span></span> <span ng-if=\"vm.hmsAppAuth.appAuzMode==\'authorization_code\'\" class=control-span><span translate=appAuth.authorizationCode></span></span> <span ng-if=\"vm.hmsAppAuth.appAuzMode==\'implicit\'\" class=control-span><span translate=appAuth.implicit></span></span></div></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'applicationType\']\" ng-mouseenter=\"vm.mouseIn=\'applicationType\'\"><div class=row><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=appAuth.applicationType></span></span></div><div class=col-md-8><span>{{vm.hmsAppAuth.applicationType}}</span><!--<span ng-if=\"vm.hmsAppAuth.applicationType==\'password\'\" class=\"control-span\"><span translate=\"appAuth.password\"></span></span>\n          <span ng-if=\"vm.hmsAppAuth.applicationType==\'client_credentials\'\" class=\"control-span\"><span translate=\"appAuth.clientCredentials\"></span></span>\n          <span ng-if=\"vm.hmsAppAuth.applicationType==\'authorization_code\'\" class=\"control-span\"><span translate=\"appAuth.authorizationCode\"></span></span>\n          <span ng-if=\"vm.hmsAppAuth.applicationType==\'implicit\'\" class=\"control-span\"><span translate=\"appAuth.implicit\"></span></span>\n        --></div></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'isContainsPlugin\' || vm.ischecked==\'isContainsPlugin\']\" ng-mouseenter=\"vm.mouseIn = \'isContainsPlugin\'\"><div class=row ng-click=\"vm.check(\'isContainsPlugin\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span translate=header.whetherContainsPlugin></span></div><div class=col-md-6 ng-if=\"vm.ischecked!=\'isContainsPlugin\'\"><label><input type=checkbox ng-model=vm.hmsAppAuth.isContainsPlugin ngtruevalue=Y ngfalsevalue=N onclick=\"return false\"></label></div><div ng-if=\"vm.ischecked==\'isContainsPlugin\'\"><input type=checkbox ng-model=vm.hmsAppAuth.isContainsPlugin ngtruevalue=Y ngfalsevalue=N style=\"margin-left: 15px\">&nbsp;&nbsp;<br><br><div class=border style=\"left: 35%;width: 17%\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event) style=\"margin-left: 35%\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'isApp\' || vm.ischecked==\'isApp\']\" ng-mouseenter=\"vm.mouseIn = \'isApp\'\"><div class=row ng-click=\"vm.check(\'isApp\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span translate=header.whetherApp></span></div><div class=col-md-6 ng-if=\"vm.ischecked!=\'isApp\'\"><label><input type=checkbox ng-model=vm.hmsAppAuth.isApp ngtruevalue=Y ngfalsevalue=N onclick=\"return false\"></label></div><div ng-if=\"vm.ischecked==\'isApp\'\"><input type=checkbox ng-model=vm.hmsAppAuth.isApp ngtruevalue=Y ngfalsevalue=N style=\"margin-left: 15px\">&nbsp;&nbsp;<br><br><div class=border style=\"left: 35%;width: 17%\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event) style=\"margin-left: 35%\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></div></div></div><div class=border></div></form><div class=\"modal fade\" id=localeModal_appName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal ng-click=vm.clear() aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_appName></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear() data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'appName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/appConfigure/appAuth-web-new.html","<form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>新增应用配置</h4></div><div class=modal-body><div class=row style=text-align:center><div style=text-align:center><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/* required name=file size=1 style=\"left:calc(50% - 60px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile></div><div>建议上传图片尺寸为640x640，大小不超过5M。</div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div>开始上传</div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><input type=hidden class=form-control ng-model=vm.hmsAppAuth.Id><label class=control-label for=field_appName>应用名称</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=field_appName ng-model=vm.hmsAppAuth.appName required></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label>应用类型</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appType ng-init=\"vm.hmsAppAuth.appType=\'Web应用\'\" ng-model=vm.hmsAppAuth.appType required disabled></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label>授权模式</label><select class=form-control ng-model=vm.hmsAppAuth.appAuzMode ng-init=\"vm.hmsAppAuth.appAuzMode=\'authorization_code\'\" style=\"width:100%;border: 1px solid #c8cacd\" required disabled><option ng-repeat=\"x in vm.appAuzMode\" value={{x.code}}>{{x.name}}</option></select></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><permission-selector permission-data=vm.permissionData></permission-selector></div></div></div><div class=modal-footer style=text-align:center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></form>");
$templateCache.put("app/appConfigure/appAuth.html","<style>.item {\n    float: left;\n    margin-bottom: 10px;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 48px 6px 20px;\n    position: relative;\n    text-align: center;\n    width: 100px;\n  }\n  .item_add {\n    height: 80px;\n    left: 50%;\n    margin: -40px 0 0 -40px;\n    padding: 0;\n    position: absolute;\n    top: 50%;\n    width: 80px;\n  }\n  .new_app_btn {\n    color: #777;\n    margin: 86px auto 0;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=appAuth.appAuthTitle></span></h5></div><div class=ibox-content><div class=row style=\"margin-bottom: 20px\"><span class=col-md-12><span translate=appAuth.client></span></span></div><div><div class=row><div class=col-md-6><div class=col-lg-5><input type=text ng-model=vm.searchApp.appName translate-attr=\"{placeholder:\'thirdParty.appName\'}\" class=form-control></div><button id=searchBtn class=\"col-lg-1 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.query()></button> &nbsp; &nbsp; &nbsp; <a ui-sref=appAuth.new><span translate=btnTypeName.create class=\"btn btn-w-m btn-info ng-scope\"></span></a></div></div><div class=row style=margin-top:20px><div class=col-lg-2 ng-if=\"hmsAppAuth.appType==\'客户端应用\'\" style=\"height: 250px\" ng-repeat=\"hmsAppAuth in vm.result\"><a ui-sref=appAuth.detail({id:hmsAppAuth.id})><img style=width:150px;height:120px ng-src={{hmsAppAuth.appIcon}} class=img_logo></a><h3><span class=mod-apptype_icon-message translate-attr=\"{title:\'appAuth.msgApp\'}\"></span> {{hmsAppAuth.appName}}</h3></div><!--<div class=\"item col-lg-2\" style=\"\">\n              <a class=\"item_add\" ui-sref=\"appAuth.new\" translate-attr=\"{title:\'appAuth.createApp\'}\">\n                <img style=\"width:150px;height:120px;\" ng-src=\"{{vm.uploadPic}}\" class=\"img_logo\">\n              </a>\n              <div class=\"new_app_btn\"><h3><span translate=\"appAuth.createClient\"></span></h3></div>\n            </div>--></div></div><!--<div style=\"margin-top:50px;\">--><!--<table class=\"table table-striped table-hover\">--><!--<tbody>--><!--<tr ng-repeat=\"hmsAppAuth in vm.result\">--><!--<td>--><!--<a ui-sref=\"appAuth.detail({id:hmsAppAuth.id})\"><i class=\"fa fa-edit text-navy\">编辑</i></a>--><!--</td>--><!--<td>{{$index+1}}</td>--><!--<td><img height=\"30\" width=\"30\" ng-src=\"{{hmsAppAuth.appIcon}}\"/></td>--><!--<td>{{hmsAppAuth.appName}}</td>--><!--<td>{{hmsAppAuth.appType}}</td>--><!--<td>{{hmsAppAuth.userName}}</td>--><!--<td>{{hmsAppAuth.appId}}</td>--><!--&lt;!&ndash;<td>{{hmsAppAuth.appSecret}}</td>&ndash;&gt;--><!--<td>xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--></div></div></div></div>");
$templateCache.put("app/appConfigure/editAppAuth.html","<script>$(function () {\n    \'use strict\';\n    $(\"#uploadImg\").change(function () {\n      var imgPath = $(\"#uploadImg\").val();\n      var fileName = getFileName(imgPath);\n      $(\"#filePath\").val(fileName);\n    });\n    function getFileName(o){\n      var pos=o.lastIndexOf(\"\\\\\");\n      return o.substring(pos+1);\n    }\n  });</script><form name=editForm role=form ng-submit=vm.update()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>编辑应用配置</h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><input type=hidden class=form-control ng-model=vm.hmsAppAuth.Id><label class=control-label for=field_appName>应用名称</label><input type=text class=form-control style=\"width:300px;border: 1px solid grey\" name=appName id=field_appName ng-model=vm.hmsAppAuth.appName required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_appSecret>APPSECRET</label><div><div style=\"float: left\"><input type=text class=form-control style=\"width:300px;border: 1px solid grey\" readonly name=appSecret id=field_appSecret ng-model=vm.hmsAppAuth.appSecret></div><div style=\"float: none;margin-left: 5px\"><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.creatUUID()><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;刷新</button></div></div></div></div><div class=col-md-6 style=clear:both><div class=form-group><label class=control-label>应用类型</label><select class=form-control ng-model=vm.hmsAppAuth.appType ng-change=vm.changeType() style=\"width:300px;border: 1px solid grey\" required><option ng-repeat=\"x in vm.appType\" value={{x.code}}>{{x.name}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label>授权模式</label><select class=form-control ng-model=vm.hmsAppAuth.appAuzMode style=\"width:300px;border: 1px solid grey\" required><option ng-repeat=\"x in vm.appAuzMode\" value={{x.code}}>{{x.name}}</option></select></div></div><div class=col-md-6><div class=form-group><!--<div class=\"row\">--><!--<div class=\"col-lg-10\">--><label class=control-label>App图标</label><!--<input type=\"hidden\" class=\"form-control\" style=\"width: 300px;border: 1px solid grey;\" name=\"appIcon\"--><!--id=\"field_appIcon\"--><!--ng-model=\"vm.hmsAppAuth.appIcon\"--><!--/>--><!--<input type=\"file\" ng-model=\"vm.file\" ngf-select name=\"file\" accept=\"image/*\"/>--><div><div style=\"float: left\"><input type=text id=filePath readonly class=form-control style=\"height:33px;width:300px;border:1px solid #E5E6E7\"></div><a href=javascript:void(0); class=\"input btn-primary\">浏览 <input type=file id=uploadImg class=uploadFile ng-model=vm.file ngf-select name=file accept=image/* required></a></div><!--</div>--><!--<div class=\"col-lg-10\">--><div style=\"font-size: 40px\" ng-show=vm.imgShow><!--<img height=\"50\" width=\"50\" ng-src=\"{{vm.hmsAppAuth.appIcon}}\"/>--> <img id=imgs height=50 width=50 border=0 ngf-src=vm.file></div><!--</div>--><!--</div>--><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div>开始上传</div><!--<div ng-show=\"vm.varMays\">上传成功</div>--></div></div></div></div></div><div class=modal-footer><!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"\">--><!--<span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;Delete--><!--</button>--> <button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></form>");
$templateCache.put("app/appConfigure/menuAddCategory.html","<form name=editForm role=form novalidate ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>新增菜单类别</h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_appId>appId</label><input type=text class=form-control name=appId id=field_appId ng-model=vm.category.appId readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_categoryName>类名</label><input type=text class=form-control name=categoryName id=field_categoryName ng-model=vm.category.categoryName required></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></form>");
$templateCache.put("app/appConfigure/menuCategory.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>菜单类别</h5><!--<div class=\"ibox-tools\">\n            <a class=\"collapse-link\">\n              <i class=\"fa fa-chevron-up\"></i>\n            </a>\n            <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n              <i class=\"fa fa-wrench\"></i>\n            </a>\n            <ul class=\"dropdown-menu dropdown-user\">\n              <li><a href=\"#\">Config option 1</a>\n              </li>\n              <li><a href=\"#\">Config option 2</a>\n              </li>\n            </ul>\n            <a class=\"close-link\">\n              <i class=\"fa fa-times\"></i>\n            </a>\n          </div>--></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=appAuth.addCategory({appId:vm.appId})>新增</a></div></div><div class=col-lg-8></div></div></div></form><div class=hr-line-dashed></div><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><!--                <th style=\"width: 7%;\">ID</th>\n                <th style=\"width: 6%;\">用户ID</th>--><th style=\"width: 7%\">操作</th><th style=\"width: 7%\">类名</th></tr></thead><tbody><tr ng-repeat=\"category in vm.result\"><td><a ui-sref=appAuth.editCategory({id:category.id})><i class=\"fa fa-times text-navy\">编辑</i></a></td><td>{{category.categoryName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/appConfigure/menuEditCategory.html","<form name=editForm role=form novalidate ng-submit=vm.update(vm.category)><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>新增菜单类别</h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_appId>appId</label><input type=text class=form-control name=appId id=field_appId ng-model=vm.category.appId readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_categoryName>类名</label><input type=text class=form-control name=categoryName id=field_categoryName ng-model=vm.category.categoryName required></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></form>");
$templateCache.put("app/appEdition/AppDownload.html","<style>#appDownloadModal {\n    position: absolute;\n    background: rgba(0, 0, 0, 0.7);\n    z-index: 1000;\n    bottom: 0;\n    top: 0;\n    left: 0;\n    right: 0\n  }</style><div class=appDownload-bg><div id=appDownloadModal ng-show=vm.showTips ng-click=vm.hide()><img class=\"img-responsive center-block\" style=\"position: center; height: inherit\" src=./assets/img/leave_weixin.png alt=\"leave wechat.\"></div><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=appEdition.appDownload></h5></div><div class=ibox-content><br><div class=row style=\"text-align: center\"><div class=\"col-xs-6 col-md-6\"><label class=control-label><h3 translate=appEdition.android></h3></label><hr style=color:blue><div ng-hide=\"vm.appDownloadUrl.android==\'\'||vm.appDownloadUrl.android==undefined\"><p style=\"text-align: center;margin-top: 30px\" id=android><qr text=vm.appDownloadUrl.androidImg type-number=0 correction-level=H size=150 input-mode=\"\" image=true></qr></p><a id=androidUrl href={{vm.appDownloadUrl.android}}><button class=\"btn btn-primary\" translate=appEdition.appDownload></button></a><p style=\"font-size: 15px;margin-top: 30px\" translate=appEdition.downloadMessageAndroid></p><p style=\"font-size: 15px;margin-top: 30px\" translate=appEdition.downloadVersionsAndroid></p></div><div style=\"margin-top: 20%;font-size: large\" ng-hide=!vm.hideAndorid><span style=\"font-size: 15px\" translate=appEdition.appNotUpload></span></div></div><div class=\"col-xs-6 col-md-6\"><label class=control-label><h3 translate=appEdition.Ios></h3></label><hr style=color:blue><div ng-hide=\"vm.appDownloadUrl.ios==\'\'||vm.appDownloadUrl.ios==undefined\"><p style=\"text-align: center;margin-top: 30px\" id=ios><qr text=vm.appDownloadUrl.iosImg type-number=0 correction-level=H size=150 input-mode=\"\" image=true></qr></p><a href={{vm.appDownloadUrl.ios}}><button class=\"btn btn-primary\" translate=appEdition.appDownload></button></a><p style=\"font-size: 15px;margin-top: 30px\" translate=appEdition.downloadMessageIos></p><p style=\"font-size: 15px;margin-top: 30px\" translate=appEdition.downloadVersionsIos></p></div><div style=\"margin-top: 20%;font-size: large\" ng-hide=!vm.hideIos><span style=\"font-size: 15px\" translate=appEdition.appNotUpload></span></div></div></div></div></div></div></div>");
$templateCache.put("app/appEdition/CommercialAppDownload.html","<style>#appDownloadModal {\n        position: absolute;\n        background: rgba(0, 0, 0, 0.7);\n        z-index: 1000;\n        bottom: 0;\n        top: 0;\n        left: 0;\n        right: 0\n    }</style><div class=appDownload-bg><div id=appDownloadModal ng-show=vm.showTips ng-click=vm.hide()><img class=\"img-responsive center-block\" style=\"position: center; height: inherit\" src=./assets/img/leave_weixin.png alt=\"leave wechat.\"></div><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=appEdition.appDownload></h5></div><div class=ibox-content><br><div class=row style=\"text-align: center\"><label class=control-label><h3 translate=appEdition.android></h3></label><hr style=\"color: brown\"><div ng-hide=\"vm.appDownloadUrl.android==\'\'||vm.appDownloadUrl.android==undefined\"><p id=android style=\"text-align: center;margin-top: 30px\"><qr text=vm.appDownloadUrl.androidImg correction-level=H type-number=0 size=150 input-mode=\"\" image=0></qr></p><a href={{vm.appDownloadUrl.android}}><button class=\"btn btn-primary\" translate=appEdition.appDownload></button></a><p style=\"font-size: 15px;margin-top: 30px\" translate=appEdition.downloadMessageAndroid></p></div><div ng-hide=!vm.hideAndorid style=\"margin-top: 20%;font-size: large\"><span style=\"font-size: 15px\" translate=appEdition.appNotUpload></span></div></div></div></div></div></div>");
$templateCache.put("app/appEdition/NextGenAppDownload.html","<style>#appDownloadModal {\n    position: absolute;\n    background: rgba(0, 0, 0, 0.7);\n    z-index: 1000;\n    bottom: 0;\n    top: 0;\n    left: 0;\n    right: 0\n  }</style><div class=appDownload-bg><div id=appDownloadModal ng-show=vm.showTips ng-click=vm.hide()><img class=\"img-responsive center-block\" style=\"position: center; height: inherit\" src=./assets/img/leave_weixin.png alt=\"leave wechat.\"></div><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=appEdition.appDownload></h5></div><div class=ibox-content><br><div class=row style=\"text-align: center\"><div class=\"col-xs-6 col-md-6\"><label class=control-label><h3 translate=appEdition.android></h3></label><hr style=color:blue><div ng-hide=\"vm.appDownloadUrl.android==\'\'||vm.appDownloadUrl.android==undefined\"><p style=\"text-align: center;margin-top: 30px\" id=android><qr text=vm.appDownloadUrl.androidImg type-number=0 correction-level=H size=150 input-mode=\"\" image=true></qr></p><a id=androidUrl href={{vm.appDownloadUrl.android}}><button class=\"btn btn-primary\" translate=appEdition.appDownload></button></a><p style=\"font-size: 15px;margin-top: 30px\" translate=appEdition.downloadMessageAndroid></p></div><div style=\"margin-top: 20%;font-size: large\" ng-hide=!vm.hideAndorid><span style=\"font-size: 15px\" translate=appEdition.appNotUpload></span></div></div><div class=\"col-xs-6 col-md-6\"><label class=control-label><h3 translate=appEdition.Ios></h3></label><hr style=color:blue><div ng-hide=\"vm.appDownloadUrl.ios==\'\'||vm.appDownloadUrl.ios==undefined\"><p style=\"text-align: center;margin-top: 30px\" id=ios><qr text=vm.appDownloadUrl.iosImg type-number=0 correction-level=H size=150 input-mode=\"\" image=true></qr></p><a href={{vm.appDownloadUrl.ios}}><button class=\"btn btn-primary\" translate=appEdition.appDownload></button></a><p style=\"font-size: 15px;margin-top: 30px\" translate=appEdition.downloadMessageIos></p></div><div style=\"margin-top: 20%;font-size: large\" ng-hide=!vm.hideIos><span style=\"font-size: 15px\" translate=appEdition.appNotUpload></span></div></div></div></div></div></div></div>");
$templateCache.put("app/appEdition/PreNextGenAppDownload.html","<style>.kohler-box-app {\n        height: 20em;\n        width: 20em;\n    }</style><div class=appDownload-bg><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=btnTypeName.prompt></h5></div><div class=ibox-content><div class=row style=\"text-align: center\"><div class=row><img src=assets/images/icon_box@3x.png class=kohler-box-app></div><div class=row><p translate=appEdition.haveKohlerBox style=\"font-size: 2em\"></p></div><div class=row><button class=\"btn btn-success btn-w-m\" ng-click=vm.gotoKohlerApp() translate=appEdition.yes></button> <button class=\"btn btn-success btn-w-m\" ng-click=vm.gotoNextGen() translate=appEdition.no style=\"margin-left: 2em\"></button></div></div></div></div></div></div>");
$templateCache.put("app/appEdition/appEdition-detail.html","<!--<div>--><!--<h3>快速编码管理</h3>--><!--</div>--><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=appEdition.coded_values></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=header.applyName></label><div class=col-lg-8><input type=text ng-model=vm.appEdition.appName class=form-control readonly></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=appEdition.applicable_equipment></label><div class=col-lg-8><input type=text ng-model=vm.appEdition.appEquipment class=form-control readonly></div></div></div></div></form><div class=hr-line-dashed></div><form class=form-horizontal><input type=hidden ng-model=vm.code.codeId class=form-control><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=appEdition.home_page></label><div class=col-lg-8><input type=text ng-model=vm.appEdition.appHomepage class=form-control readonly></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=header.whetherEffective></label><div class=col-lg-8><input type=text ng-model=vm.appEdition.enableFlag class=form-control readonly></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=appEditionLine.new({appId:vm.appEdition.appId}) translate=btnTypeName.create></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset() translate=btnTypeName.reset></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search() translate=btnTypeName.search></button></div></div></div></div></form><div class=hr-line-dashed></div><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 20%;white-space: nowrap\" translate=btnTypeName.operation></th><th style=\"width: 5%;white-space: nowrap\" translate=header.sequence></th><th style=\"width: 10%;white-space: nowrap\" translate=appEdition.update_type></th><th style=\"width: 10%;white-space: nowrap\" translate=appEdition.version_number></th><th style=\"width: 10%;white-space: nowrap\" translate=appEdition.download_address></th><th style=\"width: 15%;white-space: nowrap\" translate=header.whetherEffective></th><th style=\"width: 15%;white-space: nowrap\" translate=appEdition.version_information></th></tr></thead><tbody><tr ng-repeat=\"appEditionLine in vm.appEditionLines\"><td><a ui-sref=appEditionLine.edit({appEditionLineId:appEditionLine.id})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.view></i></a><!--|<a ng-click=\"vm.deleteAppEditionLine({id:appEditionLine.id})\"><i class=\"fa fa-times text-navy\" translate=\"btnTypeName.del\"></i></a>--><!-- <a ng-show=\"appEditionLine.enableFlag==\'N\'\" ng-click=\"vm.openAppEditionLine(appEditionLine)\">|<i class=\"fa fa-check-circle text-navy\" translate=\"sysConfig.sysConfig\"></i></a>\n                <a ng-show=\"appEditionLine.enableFlag==\'Y\'\" ng-click=\"vm.closeAppEditionLine(appEditionLine)\">|<i class=\"fa fa-times text-navy\" translate=\"plugin.disable\"></i></a>\n                --> |<a ng-click=vm.showUpdateMessage(appEditionLine.updateMessage)><i class=\"fa fa-info-circle text-navy\" translate=appEdition.view_updates></i></a><br><a ng-click=vm.setLatestEdition(appEditionLine)><i class=\"fa fa-chevron-circle-up text-navy\" translate=appEdition.set_latest_version></i></a> |<a ng-click=vm.setMinimumEdition(appEditionLine)><i class=\"fa fa-chevron-circle-down text-navy\" translate=appEdition.set_minimum_version></i></a></td><td>{{appEditionLine.orderNum}}</td><td>{{vm.updateTypes[appEditionLine.updateType]}}</td><td>{{appEditionLine.editionCode}}</td><td style=width:100px;word-wrap:break-word;max-width:100px>{{appEditionLine.downloadUrl}}</td><td>{{vm.state[appEditionLine.enableFlag]}}</td><td>{{vm.editionInfo(appEditionLine.isMinimumEdition,appEditionLine.isLatestEdition)}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/appEdition/appEdition-dialog.html","<div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\" style=\"margin-bottom: 0\"><div class=ibox-title><h5 translate=appEdition.create_title></h5></div><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><input name=appId id=appId type=hidden><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: red\">*</span><span translate=appEdition.app_name></span></label><div class=col-lg-8><!--<input name=\"appCode\" class=\"form-control\" id=\"appCode\" type=\"text\"  ng-model=\"vm.appedition.appCode\">--><select required class=form-control id=authAppId name=authAppId ng-model=vm.appedition.appId ng-options=\"e.appId as e.appName for e in vm.result\" ng-disabled=vm.disabled><option value=\"\" translate=btnTypeName.select></option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=appEdition.home_page></label><div class=col-lg-8><input name=appHomepage class=form-control id=appHomepage type=text ng-model=vm.appedition.appHomepage></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: red\">*</span><span translate=appEdition.application_platform></span></label><div class=col-lg-8><!--<select name=\"appPlatform\" class=\"form-control\" id=\"appPlatform\" ng-model=\"vm.appedition.appEquipment\"><option value=\"iOS\">iOS</option><option value=\"Android\">Android</option><option value=\"Windows Phone\">Windows Phone</option></select>--><select required class=form-control id=appPlatform name=appPlatform ng-model=vm.appedition.appEquipment ng-options=\"e.id as e.name for e in vm.Equipments\"><option value=\"\" translate=btnTypeName.select></option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=appEdition.app_sharing_link></label><div class=col-lg-8><input name=downloadUrl class=form-control id=downloadUrl type=text ng-model=vm.appedition.downloadUrl></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: red\">*</span><span translate=header.whetherEffective></span></label><div class=col-lg-8><!--<select name=\"enableFlag\" class=\"form-control\" id=\"enableFlag\" ng-model=\"vm.appedition.enableFlag\"><option value=\"Y\" selected=\"\">是</option><option value=\"N\">否</option></select>--><select required class=form-control id=enableFlag name=enableFlag ng-model=vm.appedition.enableFlag ng-options=\"s.id as s.name for s in vm.state\"><!--<option value=\"\" translate=\"btnTypeName.select\"></option>--></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=appEdition.shopUrl></label><div class=col-lg-8><input name=downloadUrl class=form-control id=shopUrl type=text ng-model=vm.appedition.shopUrl></div></div></div></div><div class=from-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\" required><span style=color:red>*</span><span>BundleId</span></label><div class=col-lg-8><lookup-select lookup-type=HMS.APP_BUNDLE_ID lookup-value=vm.appedition.bundleId required></lookup-select><!-- <select  name=\"bundleId\" id=\"bundleId\" ng-model=\"vm.appedition.bundleId\" ng-options=\"s.value as s.name for s in vm.bundleId\"></select>--></div></div><div class=col-lg-6></div></div></div></form></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp; <span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=editForm.$invalid class=\"btn btn-primary\" ng-click=vm.save()><span class=\"glyphicon glyphicon-save\"></span>&nbsp; <span translate=btnTypeName.save></span></button></div></div></div>");
$templateCache.put("app/appEdition/appEdition.html","<style>.toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n  #toast-container {\n    z-index: 99999;\n  }</style><alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=appEdition.app_management></h5></div><div class=ibox-content><div><div class=container-fluid><div class=row><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=appEdition.new><span class=\"glyphicon glyphicon-plus\"></span> <span translate=appEdition.create_APP></span></button></div></div></div><br><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th translate=btnTypeName.operation></th><th translate=function.funcSeq></th><!--<th>应用代码</th>--><th translate=header.applyName></th><th translate=appEdition.applicable_equipment></th><th translate=appEdition.home_page></th><th translate=appEdition.download_address></th><th translate=appEdition.shopUrl></th><th translate=header.whetherEffective></th></tr></thead><tbody><tr ng-repeat=\"appEdition in vm.appEditions\"><td><a ui-sref=appEditionLine({id:appEdition.id,appId:appEdition.appId})><i class=\"fa fa-desktop text-navy\" translate=btnTypeName.view></i> </a><a ui-sref=appEdition.edit({id:appEdition.id})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a></td><td ng-bind=$index+1>1</td><!--<td ng-bind=\"appEdition.appCode\"></td>--><td ng-bind=appEdition.appName></td><td ng-bind=appEdition.appEquipment></td><td ng-bind=appEdition.appHomepage></td><td ng-bind=appEdition.downloadUrl></td><td ng-bind=appEdition.shopUrl></td><td ng-bind=appEdition.enableFlag></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/appEdition/appEditionLine-dialog.html","<style>#toast-container {\n    z-index: 1100;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n  #toast-container {\n    z-index: 99999;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=appEdition.create_version></h5></div><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><input name=appId id=appId type=hidden><fieldset ng-disabled=vm.enabled><div class=form-group><div class=row><!--<div class=\"col-lg-6\">\n                <label class=\"col-lg-3 control-label\" translate=\"appEdition.version_seq\"></label>\n                <div class=\"col-lg-8\">\n                  <input name=\"orderNum\"  translate-attr=\"{placeholder:\'appEdition.orderNum_placeholder\'}\"  class=\"form-control\" id=\"orderNum\" type=\"text\" ng-model=\"vm.appeditionLine.orderNum\" onkeyup=\"if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,\'\')}else{this.value=this.value.replace(/\\D/g,\'\')}\" onafterpaste=\"if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,\'\')}else{this.value=this.value.replace(/\\D/g,\'\')}\">\n                </div>\n              </div>--><div class=\"col-lg-6 form-group\"><label class=\"col-lg-3 control-label\" translate=plugin.versionNumber1></label><div class=col-lg-8><input name=editionCode translate-attr=\"{placeholder : \'appEdition.editionCode_placeholder\'}\" class=form-control id=editionCode type=text ng-model=vm.appeditionLine.editionCode></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=appEdition.is_min_version1></label><div class=col-lg-8><!--<select name=\"enableFlag\" class=\"form-control\" id=\"enableFlag\" ng-model=\"vm.appedition.enableFlag\"><option value=\"Y\" selected=\"\">是</option><option value=\"N\">否</option></select>--><select class=form-control id=isMinimumEdition name=isMinimumEdition ng-model=vm.appeditionLine.isMinimumEdition ng-options=\"s.id as s.name for s in vm.state\"></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=appEdition.update_type1></label><div class=col-lg-8><!--<select name=\"appPlatform\" class=\"form-control\" id=\"appPlatform\" ng-model=\"vm.appedition.appEquipment\"><option value=\"iOS\">iOS</option><option value=\"Android\">Android</option><option value=\"Windows Phone\">Windows Phone</option></select>--><select required class=form-control id=updateType name=updateType ng-model=vm.appeditionLine.updateType ng-options=\"e.id as e.name for e in vm.updateTypes\"></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=appEdition.download_address1></label><div class=col-lg-8><input required name=downloadUrl placeholder=\"\" class=form-control id=downloadUrl type=text ng-model=vm.appeditionLine.downloadUrl></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=header.whetherEffective1></label><div class=col-lg-8><!--<select name=\"enableFlag\" class=\"form-control\" id=\"enableFlag\" ng-model=\"vm.appedition.enableFlag\"><option value=\"Y\" selected=\"\">是</option><option value=\"N\">否</option></select>--><select required class=form-control id=enableFlag name=enableFlag ng-model=vm.appeditionLine.enableFlag ng-options=\"s.id as s.name for s in vm.state\"></select></div></div><div class=col-lg-6><div class=col-lg-8><div class=pull-left><input type=file name=zip id=zip ng-model=vm.zip onchange=angular.element(this).scope().vm.upFile() style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span translate=plugin.importPack></span></a></div></div></div><!--<div class=\"col-lg-6\">\n                <label class=\"col-lg-3 control-label\" translate=\"appEdition.is_new_version\"></label>\n                <div class=\"col-lg-8\">\n                  &lt;!&ndash;<select name=\"enableFlag\" class=\"form-control\" id=\"enableFlag\" ng-model=\"vm.appedition.enableFlag\"><option value=\"Y\" selected=\"\">是</option><option value=\"N\">否</option></select>&ndash;&gt;\n                  <select class=\"form-control\" id=\"isLatestEdition\" name=\"isLatestEdition\" ng-model=\"vm.appeditionLine.isLatestEdition\" ng-options=\"s.id as s.name for s in vm.state\" >\n                  </select>\n                </div>\n              </div>--></div></div><div class=form-group><div class=row><!-- <div class=\"col-lg-6\">\n\n                <style>\n                  .form-inline .multiple-select-box {\n                    height: 34px;\n                    width: 70%;\n                  }\n                </style>\n                <permission-selector permission-data=\"vm.permissionData\"></permission-selector>\n              </div>--></div></div><div class=form-group><div class=row><div class=col-lg-12><label class=\"col-lg-2 control-label\" style=\"width: 12.5%\" translate=appEdition.update_content></label><div class=col-lg-10><textarea name=updateMessage placeholder=\"\" class=form-control id=updateMessage style=height:200px ng-model=vm.appeditionLine.updateMessage>\n                  </textarea></div></div></div></div></fieldset><div class=modal-footer><button type=button id=buttonCancer class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear() style=\"margin-top: 6px\"><span class=\"glyphicon glyphicon-ban-circle\"></span> <span translate=btnTypeName.return></span></button> <span ng-if=!vm.enabled><button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp; <span translate=btnTypeName.save></span></button></span></div></form></div></div></div></div>");
$templateCache.put("app/annualMeeting/annualMeeting-new.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>年会信息编辑</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">年会名称</label><div class=\"col-lg-8 input-group\"><input type=text id=meetingTitle name=meetingTitle ng-model=vm.meeting.hmsAnnualMeeting.meetingTitle class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">主办城市</label><div class=\"col-lg-8 input-group\"><input type=text id=meetingCity name=meetingCity ng-model=vm.meeting.hmsAnnualMeeting.meetingCity class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">详细地址</label><div class=\"col-lg-8 input-group\"><input type=text id=meetingAddr name=meetingAddr ng-model=vm.meeting.hmsAnnualMeeting.meetingAddr class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">年会时间</label><div class=\"col-lg-8 input-group\"><p class=input-group><input type=text class=form-control uib-datepicker-popup name=meetingDate id=meetingDate ng-model=vm.meeting.hmsAnnualMeeting.meetingDate datepicker-options=vm.dateOptions is-open=vm.isOpen> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.popupOpen()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">地点经度</label><div class=\"col-lg-8 input-group\"><input type=text id=meetingAddrLong name=meetingAddrLong ng-model=vm.meeting.hmsAnnualMeeting.meetingAddrLong class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">地点维度</label><div class=\"col-lg-8 input-group\"><input type=text id=meetingAddrLati name=meetingAddrLati ng-model=vm.meeting.hmsAnnualMeeting.meetingAddrLati class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">总桌数</label><div class=\"col-lg-8 input-group\"><input type=number id=meetingTable name=meetingTable ng-model=vm.meeting.hmsAnnualMeeting.meetingTable class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">每桌人数</label><div class=\"col-lg-8 input-group\"><input type=number id=tableSeat name=tableSeat ng-model=vm.meeting.hmsAnnualMeeting.tableSeat class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">每排桌数</label><div class=\"col-lg-8 input-group\"><input type=number id=colTable name=colTable ng-model=vm.meeting.hmsAnnualMeeting.colTable class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">排列方式</label><div class=\"col-lg-8 input-group\"><div class=input-group style=width:100%><input readonly class=form-control ng-model=vm.meeting.hmsAnnualMeeting.arrangement type=text><div class=input-group-btn><button data-toggle=dropdown class=\"btn btn-white dropdown-toggle\" type=button>选择<span class=caret></span></button><ul class=\"dropdown-menu pull-right\"><li ng-repeat=\"x in vm.arrangementType\"><a ng-click=\"vm.meeting.hmsAnnualMeeting.arrangement=x.code\">{{x.name}}</a></li></ul></div></div></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">增长阈值</label><div class=\"col-lg-8 input-group\"><input type=text id=thresholdPercentage name=thresholdPercentage ng-model=vm.meeting.hmsAnnualMeeting.thresholdPercentage class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">增长比率</label><div class=\"col-lg-8 input-group\"><input type=text id=increasePercentage name=increasePercentage ng-model=vm.meeting.hmsAnnualMeeting.increasePercentage class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">logoURL</label><div class=\"col-lg-8 input-group\"><input type=text id=logo name=logo ng-model=vm.meeting.hmsAnnualMeeting.logo class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">需要自动增长</label><div class=\"col-lg-8 input-group\"><div class=row><div class=col-lg-6><div class=input-group><input type=checkbox id=needAdd name=needSplit ng-model=vm.meeting.hmsAnnualMeeting.attribute1 style=outline:none></div></div></div></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">需要划分区域</label><div class=\"col-lg-8 input-group\"><div class=row><div class=col-lg-6><div class=input-group><input type=checkbox id=needSplit name=needSplit ng-model=vm.meeting.hmsAnnualMeeting.needSplit style=outline:none></div></div><div class=col-lg-6><div class=input-group ng-if=vm.meeting.hmsAnnualMeeting.needSplit><button type=button class=\"btn btn-primary\" ng-click=vm.addSplit()>增加区域</button></div></div></div></div></div></div></div><div ng-if=vm.meeting.hmsAnnualMeeting.needSplit><div class=form-group ng-repeat=\"split in vm.meeting.splitList\"><div class=row><div class=col-lg-6><div class=col-lg-3><label class=control-label>区域</label></div><div class=\"col-lg-8 input-group\"><input type=text class=form-control ng-model=split.splitName> <span class=input-group-addon>区</span></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">桌位</label><div class=\"col-lg-8 form-group\"><div class=row><div class=col-lg-6><div class=input-group><span class=input-group-addon>从</span> <input type=number class=form-control ng-model=split.startNum> <span class=input-group-addon>桌</span></div></div><div class=col-lg-6><div class=input-group><span class=input-group-addon>到</span> <input type=number class=form-control ng-model=split.endNum> <span class=input-group-addon>桌</span></div></div></div></div></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button> <button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;返回</button> <button type=button ng-if=vm.isSaving class=\"btn btn-primary\" ng-click=vm.creatTables()><span class=\"glyphicon glyphicon-import\"></span>&nbsp;生成桌数据</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/annualMeeting/annualMeeting-seat.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>年会桌位信息</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><div class=form-group><div class=form-group><div class=row><div class=col-lg-4><div class=col-lg-8><button ng-click=vm.creatTable() class=\"btn btn-w-m btn-primary\">新增桌位</button></div></div><div class=col-lg-4 ng-if=vm.hasSplit><div class=input-group><label class=\"col-lg-3 control-label\">区域</label><div class=\"col-lg-8 input-group\"><input type=text id=splitName name=splitName ng-model=vm.splitName class=form-control></div></div></div></div></div><div class=row><div ng-repeat=\"meeting in vm.meetings\" class=\"row col-lg-2 col-sm-4\"><div class=input-group style=width:90%><div ui-sref=meetingUsers({id:meeting.id})><input readonly class=form-control style=\"text-align:center;background-color: #f9f9f9\" value={{meeting.tableNumber}}桌/{{meeting.availableSeat}} type=button></div><div class=input-group-btn><button data-toggle=dropdown class=\"btn btn-white dropdown-toggle\" type=button>{{meeting.status==\'Y\'?\'可用\':\'禁用\'}}<span class=caret></span></button><ul class=\"dropdown-menu pull-right\"><li ng-repeat=\"x in vm.tableState\"><a ng-click=\"meeting.status=x.code;vm.savetable(meeting)\">{{x.name}}</a></li></ul></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/annualMeeting/annualMeeting-show.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>年会信息查看</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">年会名称</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.meetingTitle}}</label></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">主办城市</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.meetingCity}}</label></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">详细地址</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.meetingAddr}}</label></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">年会时间</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.meetingDate}}</label></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">地点经度</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.meetingAddrLong}}</label></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">地点维度</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.meetingAddrLati}}</label></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">总桌数</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.meetingTable}}</label></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">每桌人数</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.tableSeat}}</label></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">每排桌数</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.colTable}}</label></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">排列方式</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.arrangement}}</label></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">增长阈值</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.thresholdPercentage}}</label></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">增长比率</label><div class=col-lg-8><label>{{vm.meeting.hmsAnnualMeeting.increasePercentage}}</label></div></div></div></div><div ng-if=vm.meeting.hmsAnnualMeeting.needSplit style=\"background-color: #e5e6e7\"><div class=form-group ng-repeat=\"split in vm.meeting.splitList\"><div class=row><div class=col-lg-6><div class=col-lg-3><label class=control-label>区域</label></div><div class=\"col-lg-8 input-group\"><label>{{split.splitName}}区</label></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">桌位</label><div class=\"col-lg-8 form-group\"><div class=row><div class=col-lg-6><div class=input-group><label>从{{split.startNum}}桌</label></div></div><div class=col-lg-6><div class=input-group><label>到{{split.endNum}}桌</label></div></div></div></div></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-primary\" ui-sref=annualMeeting.seat({id:vm.meeting.hmsAnnualMeeting.id,needSplit:vm.meeting.hmsAnnualMeeting.needSplit})><span class=\"glyphicon glyphicon-user\"></span>&nbsp;桌位信息</button> <button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/annualMeeting/annualMeeting-user.html","<div><div class=ibox-title><h2>人员信息</h2></div><div class=ibox-content><div class=table-responsive><table class=\"table table-striped\"><thead><th>姓名</th><th>工号</th><th>加入时间</th><th>操作</th></thead><tbody><tr ng-repeat=\"staff in vm.staffs track by staff.id\"><td ng-bind=staff.empName></td><td ng-bind=staff.empNo></td><td ng-bind=staff.creationDate></td><td><a ui-sref=meetingUsers.change({userId:staff.empNo,meetingId:staff.meetingId})><i class=\"fa fa-edit text-primary\">换桌</i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/annualMeeting/annualMeeting.html","<div><div class=ibox-title><h2>年会管理</h2></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">年会名称</label><div class=col-lg-8><input type=text id=searchFullName class=form-control ng-model=vm.meeting.meetingTitle></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">主办城市</label><div class=col-lg-8><input type=text id=searchCompanyName class=form-control ng-model=vm.meeting.meetingCity></div></div><div class=col-lg-4><div class=col-lg-8><button class=\"btn btn-w-m btn-primary\" type=button id=searchBtn ng-click=vm.loadSearch()>搜索</button></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=col-lg-8><button ui-sref=annualMeeting.new() class=\"btn btn-w-m btn-primary\" type=button id=newMeeting>添加年会</button></div></div><div class=col-lg-4><div class=col-lg-8><button ui-sref=annualMeeting.meetThousand() class=\"btn btn-w-m btn-primary\" type=button id=meetThousand>排行榜</button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><th>年会名称</th><th>主办城市</th><th>年会时间</th><th>详细地址</th><th>总桌数</th><th>操作</th></thead><tbody><tr ng-repeat=\"meeting in vm.meetings track by meeting.id\"><td ng-bind=meeting.meetingTitle></td><td ng-bind=meeting.meetingCity></td><td ng-bind=meeting.meetingDate></td><td ng-bind=meeting.meetingAddr></td><td ng-bind=meeting.meetingTable></td><td><a ui-sref=annualMeeting.edit({id:meeting.id})><i class=\"fa fa-edit text-primary\">编辑</i></a> <a ui-sref=annualMeeting.show({id:meeting.id})><i class=\"fa fa-eye text-primary\">查看</i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/annualMeeting/user-change.html","<form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title>更换桌位</h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label>桌位</label><div class=input-group style=width:90%><div><input readonly class=form-control style=\"text-align:center;background-color: #f9f9f9\" type=text ng-model=vm.tableNum></div><div class=input-group-btn><button data-toggle=dropdown class=\"btn btn-white dropdown-toggle\" type=button>选择<span class=caret></span></button><ul class=\"dropdown-menu pull-right\"><li ng-repeat=\"x in vm.tables\"><a ng-click=\"vm.tableId=x.id;vm.tableNum=x.tableNumber\">{{x.tableNumber}}号桌</a></li></ul></div></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>取消</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>保存</button></div></form>");
$templateCache.put("app/application/application-edit.html","<form name=addForm role=form novalidate ng-submit=vm.save() enctype=multipart/form-data><div class=row style=\"margin-top: 10px\"><div class=col-md-2><div class=form-group><label class=control-label>应用logo</label></div></div><div class=col-md-2><div class=form-group><img height=50 width=50 ng-src={{vm.agent.round_logo_url}}></div></div><div class=col-md-2><div class=form-group><input type=file class=form-control name=code id=field_img ng-model=vm.image></div></div></div><div class=row><div class=col-md-2><div class=form-group><label class=control-label for=field_agentName>应用名称</label></div></div><div class=col-md-4><div class=form-group><input type=text class=form-control name=code id=field_agentName ng-model=vm.agent.name required></div></div></div><div class=row><div class=col-md-2><div class=form-group><label class=control-label for=field_agentType>应用类型</label></div></div><div class=col-md-4><div class=form-group><input type=text class=form-control name=code id=field_agentType ng-model=vm.agent.type required disabled></div></div></div><div class=row><div class=col-md-2><div class=form-group><label class=control-label for=field_agentId>应用ID</label></div></div><div class=col-md-4><div class=form-group><input type=text class=form-control name=code id=field_agentId ng-model=vm.agent.agentid required disabled></div></div></div><div class=row><div class=col-md-2><div class=form-group><label class=control-label for=field_agentDesc>应用介绍</label></div></div><div class=col-md-4><div class=form-group><input type=text class=form-control name=code id=field_agentDesc ng-model=vm.agent.description required></div></div></div><div class=row><div class=col-md-2><div class=form-group><label class=control-label for=field_agentRedirect_domain>可信域名</label></div></div><div class=col-md-4><div class=form-group><input type=text class=form-control name=code id=field_agentRedirect_domain ng-model=vm.agent.redirect_domain required></div></div></div><div class=row><div class=col-md-2><div class=form-group><label class=control-label for=field_agentChat_extension_url>关联到会话</label></div></div><div class=col-md-4><div class=form-group><input type=text class=form-control name=code id=field_agentChat_extension_url ng-model=vm.agent.chat_extension_url required></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;Cancel</button> <button type=submit class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;Save</button></div></form>");
$templateCache.put("app/application/application.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>配置维护管理</h5><!-- <div class=\"ibox-tools\">\n            <a class=\"collapse-link\">\n              <i class=\"fa fa-chevron-up\"></i>\n            </a>\n            <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n              <i class=\"fa fa-wrench\"></i>\n            </a>\n            <ul class=\"dropdown-menu dropdown-user\">\n              <li><a href=\"#\">Config option 1</a>\n              </li>\n              <li><a href=\"#\">Config option 2</a>\n              </li>\n            </ul>\n            <a class=\"close-link\">\n              <i class=\"fa fa-times\"></i>\n            </a>\n          </div>--></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">维护名称</label><div class=col-lg-8><input type=text ng-model=vm.token class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">维护描述</label><div class=col-lg-8><input type=text ng-model=vm.code.description class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=profile.new>新增</a></div></div><div class=col-lg-4></div><div class=col-lg-4><!--<div class=\"col-lg-8 pull-right m-t-n-xs\">--><!--<button class=\"btn btn-white\" type=\"reset\" id=\"searchReset\">重置</button>--><!--<button class=\"btn btn-w-m btn-primary\" type=\"button\" ng-click=\"vm.search()\">搜索</button>--><!--</div>--></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 10%\">操作</th><th style=\"width: 10%\">名称</th></tr></thead><tbody><tr ng-repeat=\"x in vm.application\"><td style=width:10%><a ui-sref=application.edit({id:x.agentid})><i class=\"fa fa-edit text-navy\">查看</i></a></td><td><img height=50 width=50 ng-src={{x.round_logo_url}}> <span ng-bind=x.name></span></td></tr></tbody></table></div><!--<div class=\"text-center\">--><!--<item-count page=\"vm.page\" total=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\"></item-count>--><!--<uib-pagination class=\"pagination-sm\"--><!--total-items=\"vm.totalItems\"--><!--ng-model=\"vm.page\"--><!--ng-change=\"vm.pageChanged()\"></uib-pagination>--><!--</div>--></div></div></div></div></div>");
$templateCache.put("app/application/clientDetails-dialog.html","<style>#toast-container{\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate={{vm.title}}></span></h4></div><div class=modal-body><div class=form-group><label for=id><span translate=clientDetail.clientId></span></label><input type=text class=form-control id=id name=id ng-model=vm.clientDetail.clientId ng-disabled=vm.isEdit></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=clientSecret><font color=red>*</font><span translate=clientDetail.clientSecret></span></label><div class=input-group><input type=password name=clientSecret style=\"display: none\"> <input type=password class=form-control name=clientSecret id=clientSecret ng-model=vm.clientDetail.clientSecret required autocomplete=off> <span class=input-group-btn><a class=\"btn btn-default\" type=button value=templateName ng-click=vm.changeSecret()><i class=\"fa fa-eye text-navy\"></i></a></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=resourceIds><font color=red>*</font><span translate=clientDetail.resourceId></span></label><!--<div class=\"input-group\">--> <input type=text class=form-control name=resourceIds id=resourceIds ng-model=vm.clientDetail.resourceIds required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_scope><font color=red>*</font><span translate=clientDetail.scope></span></label><input type=text class=form-control name=scope id=field_scope ng-model=vm.clientDetail.scope required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_redirectUri><span translate=clientDetail.redirectUri></span></label><input type=text class=form-control name=webServerRedirectUri id=field_redirectUri ng-model=vm.clientDetail.webServerRedirectUri></div></div></div><div class=row><div class=col-md-6><div class=form-group><!--<div class=\"row\">--><label class=control-label><font color=red>*</font><span translate=clientDetail.authorizedGrantTypes></span></label><input ng-model=vm.clientDetail.authorizedGrantTypes class=form-control required style=\"margin-bottom: 5px\"><select id=authorizedGrantTypes ng-model=vm.grantType ng-change=vm.selectTypeChange() class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.typeValues\" value={{x.value}}>{{x.name}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=clientDetail.authorities></span></label><input ng-model=vm.clientDetail.authorities class=form-control required style=\"margin-bottom: 5px\"><select id=authoritie ng-model=vm.auth ng-change=vm.selectChange() class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.roleValues\" value={{x.value}}>{{x.name}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_accessTokenValidity><span translate=clientDetail.accessTokenValidity></span></label><!--<p class=\"input-group date form_date\">--> <input type=text class=form-control name=accessTokenValidity id=field_accessTokenValidity ng-model=vm.clientDetail.accessTokenValidity></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_refreshTokenValidity><span translate=clientDetail.refreshTokenValidity></span></label><!--<p class=\"input-group date form_date\">--> <input type=text class=form-control name=refreshTokenValidity id=field_refreshTokenValidity ng-model=vm.clientDetail.refreshTokenValidity></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=clientDetail.autoApprove></span></label><!--<select id=\"\" ng-model=\"vm.clientDetail.autoapprove\" class=\"form-control\" >\n            <option ng-repeat=\"x in vm.autoapprove\" value=\"{{x.value}}\">{{x.name}}</option>\n          </select>--><!--<lookup-select lookup-value=\"vm.autoapproveFlag\" lookup-type=\"SYS.YES_NO\" required=\"true\"></lookup-select>--><div><span style=\"position:absolute;overflow:hidden;width: 405px\"><select id=autoapprove ng-model=vm.clientDetail.autoapprove class=form-control><option ng-repeat=\"x in vm.autoapprove\" value={{x.value}}>{{x.name}}</option><option value={{vm.clientDetail.scope}}>SCOPE</option></select></span><span style=position:absolute;width:385px><input type=text ng-model=vm.clientDetail.autoapprove class=form-control></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=additionInfo><span translate=clientDetail.additionInfo></span></label><input type=text class=form-control name=additionalInformation id=additionInfo ng-model=vm.clientDetail.additionalInformation></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=clientDetail.callbackUrl></span></label><input type=text ng-model=vm.clientDetail.callbackUrl class=form-control></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=clientDetail.secret></span></label><input type=text ng-model=vm.clientDetail.secret class=form-control></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=clientDetail.authType></span></label><lookup-select lookup-value=vm.clientDetail.authType lookup-type=HMS.AUTH_TYPE ng-model=vm.clientDetail.authType></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=clientDetail.productCode></span></label><ui-select multiple sortable ng-model=vm.clientDetail.productCode theme=bootstrap class=\"form-control m-b\" reset-search-input=true remove-selected=false><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat=\"tag in vm.productCodeList\" refresh-delay=500>{{tag.label}}</ui-select-choices></ui-select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/application/clientDetails.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=clientDetail.title></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=clientDetail.clientId></span></label><div class=col-lg-6><input type=text ng-model=vm.clientDetail.clientId class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=clientDetail.redirectUri></span></label><div class=col-lg-6><input type=text ng-model=vm.clientDetail.webServerRedirectUri class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=clientDetail.authorities></span></label><div class=col-lg-6><input type=text ng-model=vm.clientDetail.authorities class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=clientDetail.authorizedGrantTypes></span></label><div class=col-lg-6><input type=text ng-model=vm.clientDetail.authorizedGrantTypes class=form-control></div></div></div><br></div><div class=form-group><div class=row><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" type=button ui-sref=clientDetails.add><span translate=btnTypeName.create></span></button></div></div><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:50px;width:100%;overflow:auto><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=clientDetail.clientId></span></th><th><span translate=clientDetail.resourceId></span></th><th><span translate=clientDetail.authorities></span></th><th><span translate=clientDetail.scope></span></th><th><span translate=clientDetail.authorizedGrantTypes></span></th><th><span translate=clientDetail.redirectUri></span></th><th><span translate=clientDetail.accessTokenValidity></span></th><th><span translate=clientDetail.refreshTokenValidity></span></th><th><span translate=clientDetail.autoApprove></span></th><th><span translate=clientDetail.callbackUrl></span></th><th><span translate=clientDetail.secret></span></th><th><span translate=clientDetail.authType></span></th><th><span translate=clientDetail.productCode></span></th></tr></thead><tbody><tr ng-repeat=\"clientDetail in vm.result\"><td><a ui-sref=clientDetails.edit({clientId:clientDetail.clientId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteClient(clientDetail)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{clientDetail.clientId}}</td><td style=\"word-wrap: break-word; word-break:break-all\">{{clientDetail.resourceIds}}</td><td>{{clientDetail.authorities}}</td><td>{{clientDetail.scope}}</td><td style=\"word-wrap: break-word; word-break:break-all\">{{clientDetail.authorizedGrantTypes}}</td><td style=\"word-wrap: break-word; word-break:break-all\">{{clientDetail.webServerRedirectUri}}</td><td>{{clientDetail.accessTokenValidity}}</td><td>{{clientDetail.refreshTokenValidity}}</td><td>{{clientDetail.autoapprove}}</td><td>{{clientDetail.callbackUrl}}</td><td>{{clientDetail.secret}}</td><td>{{clientDetail.authType}}</td><td>{{clientDetail.productCodeMeaning}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/auditLog/auditLog.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=row><div class=row><alert-error></alert-error></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>管理日志</h5></div><div class=ibox-content><div class=widget-body><div><form><div class=row><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px>时间</label><div class=\"col-md-9 input-group date\"><input type=text class=form-control datetime-picker=yyyy-MM-dd name=start id=start ng-model=vm.searchAuditLog.startDate is-open=vm.pickerStart.open> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openCalendarStart($event, \'pickerStart\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px>至</label><div class=\"col-md-9 input-group date\"><input type=text class=form-control datetime-picker=yyyy-MM-dd name=to id=to ng-model=vm.searchAuditLog.endDate is-open=vm.pickerTo.open> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openCalendarTo($event, \'pickerTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><br><div class=row><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px>方式</label><div class=\"col-md-9 input-group date\"><select class=form-control ng-model=vm.searchAuditLog.auditSource><option ng-repeat=\"x in vm.auditSources\" value={{x.value}}>{{x.description}}</option></select></div></div><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px>操作者</label><div class=\"col-md-9 input-group date\"><input type=text placeholder=模糊查询 ng-model=vm.searchAuditLog.operator class=form-control></div></div></div><br><div class=row><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px>功能</label><div class=\"col-md-9 input-group date\"><select class=form-control ng-model=vm.searchAuditLog.transactionName><option ng-repeat=\"x in vm.transactionNames\" value={{x.value}}>{{x.description}}</option></select></div></div><div class=col-md-5><div class=\"col-md-offset-3 col-md-9 input-group date\"><button class=\"btn btn-white\" type=button ng-click=vm.clear()>重置</button> <input type=submit class=\"btn btn-w-m btn-primary\" value=查询 ng-click=vm.searchAudit()></div></div></div></form><div class=table-responsive style=\"margin-top: 50px\"><table class=\"table table-striped\"><thead><tr><th>时间</th><th>方式</th><th>操作者</th><th>功能</th><th>备注</th></tr></thead><tbody><tr ng-repeat=\"auditLog in vm.auditLogs\"><td>{{auditLog.auditDate}}</td><td ng-if=\"auditLog.auditSource == \'MANAGE\'\">PC端</td><td ng-if=\"auditLog.auditSource == \'INTERFACE\'\">接口调用</td><td>{{auditLog.operator}}</td><td ng-if=\"auditLog.transactionName == \'LOGIN\'\">登陆</td><td ng-if=\"auditLog.transactionName == \'CREATE_MEMBER\'\">创建员工</td><td ng-if=\"auditLog.transactionName == \'EDIT_MEMBER\'\">修改员工</td><td ng-if=\"auditLog.transactionName == \'DEL_MEMBER\'\">删除员工</td><td ng-if=\"auditLog.transactionName == \'CREATE_DEPT\'\">创建部门</td><td ng-if=\"auditLog.transactionName == \'EDIT_DEPT\'\">修改部门</td><td ng-if=\"auditLog.transactionName == \'DEL_DEPT\'\">删除员工</td><td ng-if=\"auditLog.transactionName == \'CREATE_TAG\'\">创建标签</td><td ng-if=\"auditLog.transactionName == \'EDIT_TAG\'\">修改标签</td><td ng-if=\"auditLog.transactionName == \'DEL_TAG\'\">删除标签</td><td ng-if=\"auditLog.transactionName == \'CREATE_INTERFACE_HEAD\'\">创建接口头</td><td ng-if=\"auditLog.transactionName == \'EDIT_INTERFACE_HEAD\'\">修改接口头</td><td ng-if=\"auditLog.transactionName == \'CREATE_INTERFACE_LINE\'\">创建接口行</td><td ng-if=\"auditLog.transactionName == \'EDIT_INTERFACE_LINE\'\">修改接口行</td><td ng-if=\"auditLog.transactionName == \'EDIT_CORPINFO\'\">修改企业数据</td><td ng-if=\"auditLog.transactionName == \'CREATE_APPLICATION\'\">创建应用</td><td ng-if=\"auditLog.transactionName == \'EDIT_APPLICATION\'\">修改应用</td><td ng-if=\"auditLog.transactionName == \'DEL_APPLICATION\'\">删除应用</td><td ng-if=\"auditLog.transactionName == \'FORBIDDEN_APPLICATION\'\">禁用应用</td><td ng-if=\"auditLog.transactionName == \'CREATE_MATERIAL\'\">添加素材</td><td ng-if=\"auditLog.transactionName == \'LOGOUT\'\">退出</td><td ng-if=\"auditLog.transactionName == \'PUSH_MESSAGE\'\">推送消息</td><td ng-if=\"auditLog.transactionName == \'REGISTER_DEVICE\'\">注册设备</td><td ng-if=\"auditLog.transactionName == \'CREATE_MENU\'\">创建菜单</td><td>{{auditLog.auditContent}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div></div>");
$templateCache.put("app/contacts/contacts.html","<toaster-container></toaster-container><div class=\"wrapper wrapper-content\"><div class=contact-item><div class=row><div class=col-lg-3><div class=input-group><input class=form-control type=text> <span class=input-group-btn><button type=button class=\"btn btn-primary glyphicon glyphicon-search\"></button> </span></div></div><div class=\"col-lg-9 text-center\"><h3>企业通讯录</h3></div></div></div><div class=row><div class=\"col-lg-3 corp-tree\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content mailbox-content\"><div class=file-manager><div class=row><uib-tabset active=activeForm><uib-tab index=0 heading=组织架构 select=vm.selectOrg()><div js-tree=vm.treeConfig ng-model=vm.jsTreeData tree=vm.treeInstance tree-events-obj=vm.treeEventsObj></div></uib-tab><uib-tab index=1 heading=标签 select=vm.selectTag()><div class=\"form-group text-center m-t\"><button class=\"btn btn-success\" ng-click=vm.openTagModal()>新建标签</button></div><div class=\"form-group m-t\"><h3>我的标签</h3><div class=table-responsive><table class=\"table table table-hover table-striped\"><tbody><tr ng-repeat=\"tag in vm.allTags\"><td width=50% ng-click=vm.selectTag(tag)><a href=\"\" ng-click=vm.tagDetail()><i class=\"fa fa-flag\"></i>{{tag.tagName}}</a></td><td width=25% align=right ng-if=\"tag.tagStatus==\'lock\' && tag.tagOwner != vm.currentUserName \"><!--<i class=\"fa fa-lock\" ></i>--></td><td width=25% align=right ng-if=\"tag.tagStatus!=\'lock\' && tag.tagOwner!= vm.currentUserName\"><div class=btn-group uib-dropdown dropdown-append-to-body><a href=\"\" id=simple-dropdown class=\"btn btn-xs btn-primary\" uib-dropdown-toggle><i class=\"fa fa-pencil\"></i></a><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=simple-dropdown><li role=menuitem><a href=\"\" ng-click=vm.updateTag(tag.id)>重命名</a></li><li role=menuitem><a href=\"\" ng-click=vm.deleteTag(tag.id)>删除</a></li><li role=menuitem><a href=\"\" ng-click=\"vm.lockTag(tag,\'lock\')\">加锁</a></li></ul></div></td><!-- 当前用户操作 --><!--<td width=\"25%\" align=\"right\" ng-if=\"tag.tagStatus==\'lock\' && tag.tagOwner == vm.currentUserName \">\n                            <i class=\"fa fa-lock\" ></i>\n                          </td>--><td width=25% align=right ng-if=\"tag.tagOwner == vm.currentUserName \"><div class=btn-group uib-dropdown dropdown-append-to-body><a href=\"\" id=simple-dropdown1 class=\"btn btn-xs btn-primary\" uib-dropdown-toggle><i class=\"fa fa-lock\" ng-if=\"tag.tagStatus==\'lock\'\"></i> <i class=\"fa fa-pencil\" ng-if=\"tag.tagStatus!=\'lock\'\"></i></a><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=simple-dropdown1><li role=menuitem ng-if=\"tag.tagStatus!=\'lock\'\"><a href=\"\" ng-click=vm.updateTag(tag.id)>重命名</a></li><li role=menuitem ng-if=\"tag.tagStatus!=\'lock\'\"><a href=\"\" ng-click=vm.deleteTag(tag.id)>删除</a></li><li role=menuitem ng-if=\"tag.tagStatus==\'lock\'\"><a href=\"\" ng-click=\"vm.lockTag(tag,\'unlock\')\">解锁 </a></li><li role=menuitem ng-if=\"tag.tagStatus!=\'lock\'\"><a href=\"\" ng-click=\"vm.lockTag(tag,\'lock\')\">加锁 </a></li></ul></div></td></tr></tbody></table></div></div></uib-tab></uib-tabset></div></div></div></div></div><div class=\"col-lg-9 animated fadeInRight corp-tree\"><div class=content ng-show=vm.isOrgShow><div class=row><div id=org-views ui-view=\"\" class=ng-scope><fieldset class=ng-scope><h2>{{vm.currentDept.deptName}}</h2></fieldset><fieldset class=\"m-t-md ng-scope\" ng-if=vm.isChoiceDept><div class=\"row col-lg-5\"><div class=\"input-group col-lg-offset-1 col-lg-11\"><a ui-sref=contacts.addStaff({id:vm.currentDept.deptNumber}) class=\"btn btn-primary\">新建成员</a> <a ui-sref=contacts.importStaff() class=\"btn btn-primary\">批量导入</a> <a href={{vm.exportPath}} class=\"btn btn-primary\">批量导出</a><div class=input-group-btn><button data-toggle=dropdown class=\"btn btn-white dropdown-toggle\" type=button><span class=caret></span></button><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=contacts.addDept({id:vm.currentDept.deptNumber})>添加子部门</a></li><li><a ui-sref=contacts.editDept({deptNumber:vm.currentDept.deptNumber,deptName:vm.currentDept.deptName})>修改部门</a></li><li><a ng-click=\"\">上移</a></li><li><a ng-click=\"\">下移</a></li><li><a ng-click=vm.deleteStaff()>删除</a></li></ul></div></div></div></fieldset></div></div><div class=row><div class=table-responsive><table id=staffTable class=\"table table-striped\"><thead><tr><th width=10%>操作</th><th width=20%>姓名</th><th width=20%>工号</th><th width=20%>手机</th><th width=20%>邮箱</th><th width=10%>状态</th></tr></thead><tbody><tr ng-show=vm.isSpinnerShow><td colspan=6><div class=spiner-example><div class=\"sk-spinner sk-spinner-pulse\"></div></div></td></tr><tr ng-repeat=\"staff in vm.staffs track by staff.userId\" ng-show=vm.isStaffShow><td><input type=checkbox ng-model=staff.checked> <a ui-sref=contacts.dialogStaff({id:staff.accountNumber}) style=\"margin-left: 5px\">编辑</a></td><td>{{staff.userName}}</td><td>{{staff.accountNumber}}</td><td>{{staff.mobile}}</td><td>{{staff.email}}</td><td>{{staff.empStatus}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div><div class=content ng-show=vm.isTagShow><div class=row><div id=tag-views ui-view=\"\" class=ng-scope><fieldset class=ng-scope><h2>{{vm.currentTag.tagName}}</h2></fieldset><fieldset class=\"m-t-md ng-scope\"><tag-permission-selector permission-data=vm.permissionData></tag-permission-selector><a href=\"\" class=\"btn btn-primary\" ng-click=vm.deleteTagMembers()>批量删除</a></fieldset></div></div><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th width=10%>操作</th><th width=20%>名称</th><th width=20%>类别</th><th width=10%>状态</th></tr></thead><tbody><tr ng-show=vm.isSpinnerShow><td colspan=4><div class=spiner-example><div class=\"sk-spinner sk-spinner-pulse\"></div></div></td></tr><tr ng-repeat=\"tagMember in vm.tagMembers track by tagMember.tagMemberId\" ng-show=vm.isTagShow><td><input type=checkbox ng-model=tagMember.checked></td><td>{{tagMember.name}}</td><td ng-if=\"tagMember.type==\'dept\'\">部门</td><td ng-if=\"tagMember.type==\'staff\'\">员工</td><td></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/contacts/dept-new.html","<form name=editForm role=form novalidate><div class=ibox-content><div class=modal-header><h3 ng-if=!vm.flag>新增部门</h3><h3 ng-if=vm.flag>编辑部门</h3></div><div class=modal-body><div class=row><div class=col-md-3></div><div class=col-md-6><div class=form-group><label class=\"col-md-3 control-label\">部门名称</label><div class=col-md-7><input type=text class=form-control ng-model=vm.dept.name required></div><div class=col-md-2></div></div><div class=form-group><label class=\"col-md-3 control-label\">部门主管</label><div class=col-md-7><input type=text class=form-control ng-model=vm.permissionData[0].dataValue disabled> <input type=hidden class=form-control ng-model=vm.permissionData[0].dataId><staff-permission-selector permission-data=vm.permissionData></staff-permission-selector></div></div></div><div class=col-md-3></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-primary\" ng-disabled=editForm.$invalid ng-click=vm.saveDept()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 确定</span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span>关闭</span></button></div></div></div></form>");
$templateCache.put("app/contacts/staff-detail-add.html","<form name=editForm role=form novalidate ng-submit=vm.saveStaff()><div class=ibox-content><div class=modal-header>新增员工</div><div class=modal-body><div class=row><div class=col-md-3></div><div class=col-md-6><div class=form-group><label class=\"col-md-3 control-label\">姓名</label><div class=col-md-9><input type=text id=userName name=userName ng-model=vm.staff.userName class=form-control required> <span style=color:red ng-show=editForm.userName.$dirty><span ng-show=editForm.userName.$error.required>姓名不能为空。</span></span></div></div><div class=form-group><label class=\"col-md-3 control-label\">工号</label><div class=col-md-9><input type=text id=accountNumber name=accountNumber ng-model=vm.staff.accountNumber class=form-control required> <span style=color:red ng-show=editForm.accountNumber.$dirty><span ng-show=editForm.accountNumber.$error.required>工号不能为空。</span></span></div></div><div class=form-group><label class=\"col-md-3 control-label\">手机</label><div class=col-md-9><input type=tel id=mobile name=mobile ng-model=vm.staff.mobile class=form-control ng-minlength=11 ng-maxlength=11 ng-pattern=/^1[3|5][0-9]\\d{4,8}$/ ></div></div><div class=form-group><label class=\"col-md-3 control-label\">邮箱</label><div class=col-md-9><input type=email id=email name=email ng-model=vm.staff.email class=form-control> <span style=color:red ng-show=editForm.email.$invalid><span ng-show=editForm.email.$error.email>邮箱格式不正确。</span></span></div></div><div class=form-group><label class=\"col-md-3 control-label\">职位</label><div class=col-md-9><input type=text id=position name=position ng-model=vm.staff.position class=form-control></div></div><div class=form-group><label class=\"col-md-3 control-label\">性别</label><div class=col-md-9><!--<input type=\"number\" id=\"genderId\" name=\"genderId\"--><!--ng-model=\"vm.staff.genderId\" class=\"form-control\" required>--><select ng-init=\"vm.staff.genderId=vm.genderId[0].code\" ng-model=vm.staff.genderId class=form-control><option ng-repeat=\"x in vm.genderId\" value={{x.code}}>{{x.value}}</option></select></div></div><div class=form-group><label class=\"col-md-3 control-label\">员工状态</label><div class=col-md-9><select ng-init=\"vm.staff.empStatus=vm.empStatus[0]\" class=form-control ng-model=vm.staff.empStatus ng-options=\"x for x in vm.empStatus\"></select></div></div></div><div class=col-md-3></div></div></div><div class=modal-footer><div class=row><button type=submit class=\"btn btn-primary\" ng-disabled=\"editForm.$invalid || vm.isSaving\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 确定</span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span>关闭</span></button></div></div></div></form>");
$templateCache.put("app/contacts/staff-detail-dialog.html","<form name=editForm role=form novalidate ng-submit=vm.updateStaff()><div class=ibox-content><div class=modal-header>详细资料</div><div class=modal-body><div class=row><div class=col-md-3></div><div class=col-md-6><div class=form-group><label class=\"col-md-3 control-label\">姓名</label><div class=col-md-9><input type=text id=userName name=userName ng-model=vm.staff.userName class=form-control required> <span style=color:red ng-show=editForm.userName.$dirty><span ng-show=editForm.userName.$error.required>姓名不能为空。</span></span></div></div><div class=form-group><label class=\"col-md-3 control-label\">工号</label><div class=col-md-9><input type=text id=accountNumber name=accountNumber ng-model=vm.staff.accountNumber class=form-control disabled></div></div><div class=form-group><label class=\"col-md-3 control-label\">手机</label><div class=col-md-9><input type=text id=mobile name=mobile ng-model=vm.staff.mobile class=form-control ng-minlength=11 ng-maxlength=11 ng-pattern=/^1[3|5][0-9]\\d{4,8}$/ ></div></div><div class=form-group><label class=\"col-md-3 control-label\">邮箱</label><div class=col-md-9><input type=email id=email name=email ng-model=vm.staff.email class=form-control> <span style=color:red ng-show=editForm.email.$invalid><span ng-show=editForm.email.$error.email>邮箱格式不正确。</span></span></div></div><div class=form-group><label class=\"col-md-3 control-label\">职位</label><div class=col-md-9><input type=text id=position name=position ng-model=vm.staff.position class=form-control></div></div><div class=form-group><label class=\"col-md-3 control-label\">性别</label><div class=col-md-9><select class=form-control ng-model=vm.staff.genderId><option ng-repeat=\"x in vm.genderId\" value={{x.code}}>{{x.value}}</option></select></div></div><div class=form-group><label class=\"col-md-3 control-label\">员工状态</label><div class=col-md-9><select class=form-control ng-model=vm.staff.empStatus ng-options=\"x for x in vm.empStatus\"></select></div></div></div><div class=col-md-3></div></div></div><div class=modal-footer><div class=row><button type=submit class=\"btn btn-primary\" ng-disabled=\"editForm.$invalid || vm.isSaving\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 保存</span></button> <button type=button class=\"btn btn-danger\" ng-click=vm.deleteStaff()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 删除</span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span>关闭</span></button></div></div></div></form>");
$templateCache.put("app/contacts/staff-detail-import.html","<div class=ibox-content><div class=modal-header><b>员工信息批量导入</b></div><div class=modal-body><div class=row><div class=col-md-3></div><div class=col-md-6><div class=form-group><label class=\"col-md-3 control-label\">下载模板</label><div class=col-md-9><a href={{vm.downloadPath}}>员工信息模板</a></div></div><div class=form-group><div class=col-md-9></div></div><div class=form-group><label class=\"col-md-3 control-label\"></label><div class=col-md-9><!--<input type=\"file\" id=\"excel\" ng-model=\"vm.file\" name=\"file\">--> <a href=javascript:void(0); style=\"display: block;height: 100px;background-color: mintcream\">请选择要导入的excel <input type=file id=excel class=uploadFile ng-model=vm.file ngf-select name=file accept=multipart/form-data required></a></div></div></div><div class=col-md-3></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-primary\" ng-click=vm.importStaff()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 导入</span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span>关闭</span></button></div></div></div>");
$templateCache.put("app/contacts/tag-dialog.html","<div class=ibox-content><div class=modal-header>新建标签</div><div class=modal-body><div class=row><div class=col-md-3></div><div class=col-md-6><div class=form-group><label class=\"col-md-3 control-label\">标签名称</label><div class=col-md-9><input type=text class=form-control ng-model=vm.contactTag.tagName required></div></div></div><div class=col-md-3></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-primary\" ng-click=vm.saveTag()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 确定</span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span>关闭</span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div>");
$templateCache.put("app/contentList/contentList.html","<style>.item_default img{\n    height: 120px;\n    width: 180px;\n  }\n\n  .table-font-center{\n    text-align: center;\n  }\n   .contentFontType{\n     line-height: 120px;\n     height: 120px;\n     overflow: hidden;\n\n  }</style><div class=\"table-responsive table-font-center\"><table class=\"table table-striped\"><thead><tr><th class=\"col-md-1 table-font-center\">编辑</th><th class=\"col-md-2 table-font-center\">封面</th><th class=\"col-md-1 table-font-center\">标题</th><th class=\"col-md-1 table-font-center\">作者</th><th class=\"col-md-2 table-font-center\">创建时间</th><th class=\"col-md-1 table-font-center\">摘要</th><th class=\"col-md-1 table-font-center\">状态</th><th class=\"col-md-1 table-font-center\">删除</th></tr></thead><tbody><tr ng-repeat=\"content in vm.contents\"><td class=col-md-1><div class=\"btn-group flex-btn-group-container contentFontType\"><a ui-sref=sysConfig.edit({id:content.id})><i class=\"fa fa-edit text-navy\">编辑</i></a></div></td><td class=col-md-2><div name=imageTextCover class=item_default><img ng-src={{content.contentCover}} name=coverImg></div></td><td class=col-md-1><div class=contentFontType>{{content.contentTitle}}</div></td><td class=col-md-1><div class=contentFontType>{{content.contentAuthor}}</div></td><td class=col-md-2><div class=contentFontType>{{content.creationDate}}</div></td><td class=col-md-3><div class=contentFontType>{{content.contentSubject}}</div></td><td class=col-md-1><div class=contentFontType>{{content.contentAuthor}}</div></td><td class=col-md-1><div class=\"btn-group flex-btn-group-container contentFontType\"><a ui-sref=sysConfig.edit({id:content.id})><i class=\"fa fa-edit text-navy\">删除</i></a></div></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div>");
$templateCache.put("app/corpInfo/corpInfo.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=row><div class=row><alert-error></alert-error></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>企业数据</h5></div><div class=ibox-content><div class=widget-body><div><form name=addForm class=reg-page role=form novalidate ng-submit=vm.saveCorpInfo()><div class=rows style=\"width:90%;margin-left: 5%;margin-right: 5%\"><div class=form-group><label class=control-label for=corpName>企业名称 *</label><input type=text class=form-control name=corpName id=corpName ng-readonly=vm.corpNameRO ng-model=vm.addCorp.corpName required></div></div><div class=rows style=\"width:90%;margin-left: 5%;margin-right: 5%\"><div class=form-group><label class=control-label for=corpDesc>企业简介</label><textarea class=form-control rows=5 name=corpDesc id=corpDesc style=resize:none ng-model=vm.addCorp.corpDesc></textarea></div></div><div class=row style=\"width:90%;margin-left: 5%;margin-right: 5%\"><label class=control-label for=corpDesc>企业logo</label><div style=text-align:center><input id=uploadImg ng-model=vm.logoFile ng-change=vm.changeLogoFile() ngf-select accept=image/* name=file size=1 style=\"left:calc(50% - 60px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px\" type=file> <img style=width:120px;height:120px ngf-src=vm.oldLogoFile></div><div ng-show=vm.logoShow style=text-align:center>建议上传图片尺寸为640x640，大小不超过5M。</div><div style=\"text-align: center\"><div ng-show=vm.logoShow class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitLogoFile()><div>开始上传</div></div></div></div><div class=rows style=\"width:90%;margin-left: 5%;margin-right: 5%\"><div class=form-group><label class=control-label for=corpAddr>企业地址</label><input type=text class=form-control name=corpAddr id=corpAddr ng-model=vm.addCorp.corpAddr></div></div><div class=rows style=\"width:90%;margin-left: 5%;margin-right: 5%\"><div class=form-group><label class=control-label for=corpContact>企业联系人</label><input type=text class=form-control name=corpContact id=corpContact ng-model=vm.addCorp.corpContact></div></div><div class=row style=\"width:90%;margin-left: 5%;margin-right: 5%\"><label class=control-label for=corpDesc>启动图</label><div style=text-align:center><input id=bootImgUrl ng-model=vm.bootImgFile ng-change=vm.changeBootImgFile() ngf-select accept=image/* name=file size=1 style=\"left:calc(50% - 60px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px\" type=file> <img style=width:120px;height:120px ngf-src=vm.oldBootImgFile></div><div ng-show=vm.bootImgShow style=text-align:center>建议上传图片尺寸为640x640，大小不超过5M。</div><div style=\"text-align: center\"><div ng-show=vm.bootImgShow class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitBootImgFile()><div>开始上传</div></div></div></div><div class=rows style=\"width:90%;margin-left: 5%;margin-right: 5%\"><div class=form-group><label class=control-label for=bootImgRedirect>启动图跳转地址</label><input type=url class=form-control name=bootImgRedirect id=bootImgRedirect ng-model=vm.addCorp.bootImgRedirect></div></div><div class=row><div class=form-group><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel()>&nbsp;&nbsp;取消&nbsp;&nbsp;</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">&nbsp;&nbsp;保存&nbsp;&nbsp;</button></div></div></div><div ng-show=vm.corpShow style=\"margin-top:10px;margin-left: 5%\"><label class=control-label style=\"width:90%;margin-right: 5%\">以下是您接入企业应用需要的CorpID、CorpSecret，请妥善保管。</label><label class=control-label style=\"width:90%;margin-right: 5%\">CorpID和CorpSecret</label><button type=button class=\"btn btn-primary\" ng-show=vm.getCorpIdShow ng-click=vm.generateCorp(1)>&nbsp;&nbsp;获取&nbsp;&nbsp;</button> <button type=button class=\"btn btn-primary\" ng-show=vm.resetCorpIdShow ng-click=vm.generateCorp(2)>&nbsp;&nbsp;重置&nbsp;&nbsp;</button><div ng-show=vm.resetCorpIdShow>CorpID：{{vm.addCorp.corpId}}</div><div ng-show=vm.resetCorpIdShow>CorpSecret：{{vm.addCorp.corpSecret}}</div></div></form></div></div></div></div></div></div>");
$templateCache.put("app/device/device-detail.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=col-lg-10><h2>设备详情</h2></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=ibox><div class=ibox-title>基本信息</div><div class=ibox-content><div class=\"row m-t-lg\"><div class=col-md-6><div class=profile-image><i class=\"fa fa-apple fa-5x\"></i></div><div class=profile-info><div><div><h2 class=no-margins>张三</h2><h4>汉得信息>业务发展部</h4><small>总经理</small></div></div></div></div><div class=col-md-6><table class=\"table small m-b-xs\"><tbody><tr><td>系统</td><td>IOS10.1.1</td></tr><tr><td>手机号</td><td>13333333333</td></tr><tr><td>应用版本</td><td>v2.2.1</td></tr></tbody></table></div></div><div class=row><div class=col-md-4><button class=\"btn btn-default\">注销设备</button> <button class=\"btn btn-primary\">禁止设备</button> <button class=\"btn btn-warning\">擦除设备</button></div><div class=\"col-md-offset-2 col-md-6 text-right\">注册时间:2016-01-01,<i class=\"fa fa-map-marker\"></i>最近位置:上海市青浦区汇联路33号</div></div></div></div><div class=ibox><div class=ibox-title>登录信息</div><div class=ibox-content><div class=row><div class=\"col-md-offset-8 col-md-4 text-right\"><small><button class=\"btn btn-primary btn-circle\" type=button></button>在线 <button class=\"btn btn-warning btn-circle\" type=button></button>离线</small></div></div><p></p><p></p><div class=row><table class=table border=0><tr><td align=center><button class=\"btn btn-primary btn-circle\" type=button></button></td><td align=center><button class=\"btn btn-primary btn-circle\" type=button></button></td><td align=center><button class=\"btn btn-primary btn-circle\" type=button></button></td><td align=center><button class=\"btn btn-warning btn-circle\" type=button></button></td><td align=center><button class=\"btn btn-primary btn-circle\" type=button></button></td><td align=center><button class=\"btn btn-primary btn-circle\" type=button></button></td><td align=center><button class=\"btn btn-warning btn-circle\" type=button></button></td></tr><tr><td align=center>2016/11/28</td><td align=center>2016/11/29</td><td align=center>2016/11/30</td><td align=center>2016/12/01</td><td align=center>2016/12/02</td><td align=center>2016/12/03</td><td align=center>2016/12/04</td></tr></table></div></div></div></div>");
$templateCache.put("app/device/device.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><h2>设备管理</h2></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=row><div class=col-lg-3><div class=\"widget style1 navy-bg\"><div class=\"row text-center\">平台数</div><div class=row><div class=\"col-xs-4 text-center\"><i class=\"fa fa-android fa-3x\"></i> <span>{{vm.platform.android}}</span></div><div class=\"col-xs-offset-4 col-xs-4 text-center\"><i class=\"fa fa-apple fa-3x\"></i> <span>{{vm.platform.ios}}</span></div></div></div></div><div class=col-lg-1></div><div class=col-lg-4><div class=\"widget style1 lazur-bg\"><div class=\"row text-center\">用户数</div><div class=row><div class=\"col-xs-4 text-center\"><h2>5055</h2><span>总用户</span></div><div class=\"col-xs-3 text-center\"><h2>20</h2><span>已激活</span></div><div class=\"col-xs-5 text-center\"><h2>200000</h2><span>已授权</span></div></div></div></div><div class=col-lg-1></div><div class=col-lg-3><div class=\"widget style1 yellow-bg\"><div class=\"row text-center\">设备数</div><div class=row><div class=\"col-xs-4 text-center\"><h2>10</h2><span>在线</span></div><div class=\"col-xs-offset-4 col-xs-4 text-center\"><h2>200</h2><span>已激活</span></div></div></div></div></div><div class=row><div class=col-lg-6><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>版本分布图</h5></div><div class=ibox-content><div><canvas id=bar class=\"chart chart-bar\" chart-data=vm.data chart-labels=vm.labels chart-series=vm.series char-options=vm.barOptions chart-dataset-override=vm.datasetOverride1 height=140 responsive=true>chart-series=\"series\"</canvas></div></div></div></div><div class=col-lg-6><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>设备状态</h5></div><div class=ibox-content><canvas id=pie class=\"chart chart-pie\" chart-data=vm.piedata chart-labels=vm.pielabels char-options=vm.pieoptions chart-dataset-override=vm.datasetOverride2 height=140 responsive=true></canvas></div></div></div></div><div class=ibox><div class=ibox-title>设备列表</div><div class=ibox-content><div class=row><form class=form-horizontal><div class=form-group><div class=row><div class=\"col-sm-12 col-xs-12\"><label class=\"col-sm-2 col-xs-2 control-label\">用户名</label><div class=\"col-sm-7 col-xs-7\"><input type=text id=searchUserName class=form-control ng-model=vm.foundByName></div><button class=\"col-sm-2 col-xs-2 btn btn-w-m btn-primary\" type=button id=searchBtn ng-click=vm.loadByName()>搜索</button></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th style=\"width: 7%\">品牌</th><th style=\"width: 5%\">型号</th><th style=\"width: 6%\">操作系统</th><th style=\"width: 9%\">操作系统版本</th><th style=\"width: 8%\">客户端版本</th><th style=\"width: 20%\">用户名</th><th style=\"width: 9%\">创建时间</th><th style=\"width: 20%\">IME</th><th style=\"width: 6%\">状态</th><th style=\"width: 10%\">操作</th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices track by device.deviceId\"><td><i class=\"fa fa-android\"></i>{{device.deviceBrand}}</td><td ng-bind=device.deviceType></td><td ng-bind=device.operationSystem></td><td ng-bind=device.operationSystemVersion></td><td ng-bind=device.clientVersion></td><td ng-bind=device.deviceUser></td><td ng-bind=device.creationDate></td><td><a ui-sref=device.detail({id:device.deviceId})>{{device.ime}}</a></td><td><span ng-if=\"device.deviceFlag==\'N\'\">不可用</span> <span ng-if=\"device.deviceFlag!=\'N\'\">可用</span></td><td><a ng-if=\"device.deviceFlag==\'Y\'\" ng-href=javascript:void(0) ng-click=vm.changeFlag(device.deviceId)>注销</a> <a ng-if=\"device.deviceFlag==\'Y\'\" ng-href=javascript:void(0) ng-click=vm.changeFlag(device.deviceId)>禁用</a> <a ng-if=\"device.deviceFlag==\'Y\'\" ng-href=javascript:void(0) ng-click=vm.changeFlag(device.deviceId)>擦除</a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/deviceFirmware/addDeviceFirmware.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addSku()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span>{{ vm.group.groupId ? \'编辑产品分组\' : \'新增产品分组\' }}</span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>产品分组名称</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.group.groupName autocomplete=off required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span>说明</span></label><input type=text class=form-control name=code id=field_skuCode autocomplete=off ng-model=vm.group.note></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/deviceFirmware/addFirmware.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addFirmware()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span>{{ \'设备固件管理-\' + vm.sku.groupName + \'-新增固件\' }}</span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><!-- <label class=\"control-label\" for=\"field_skuCode\"><span style=\"color: red\">*</span><span >导入配置文件</span></label> --><div class=input-group><input type=file accept=application/json name=configFiles id=configFiles ng-model=vm.configFiles onchange=angular.element(this).scope().vm.upConfigFiles(this) autocomplete=off style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span>导入配置文件</span></a></div></div></div><div class=col-md-6><div class=form-group style=\"position: relative\"><!-- <label class=\"control-label\" for=\"field_skuCode\"><span style=\"color: red\">*</span><span >导入资源包</span></label> --><div><input type=file name=resourceFile id=resourceFile ng-model=vm.resourceFile onchange=angular.element(this).scope().vm.upResourceFile(this) autocomplete=off style=\"opacity: 0; position: absolute; z-index: -1; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\" ng-click=vm.verifyData()><span ng-if=!vm.btnStatus>导入资源包</span><span ng-if=vm.btnStatus>重新上传</span></a> <span ng-if=vm.btnStatus style=\"color:red;position: absolute;right: 10px;top: 50%;transform: translateY(-50%)\">:资源包已导入</span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级包版本号</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.firmwareVersion required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级包名称</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.firmwareName required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级组件名称(组件号+组件名称)</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.component required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>part号+part名称</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.part required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>分包大小(KB)</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.subPackageSize required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>下载地址最大长度</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.downloadUrlType required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>是否为必升版本</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.forceUpdate required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>是否静默下载</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.isSilentDownload required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级包优先级(数字越小优先级越高)</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.priority required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>包下载到那里</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.downloadLocation required ng-readonly=vm.readonly></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/deviceFirmware/addOatDevice.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addSku()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span>{{ vm.sku.id ? \'设备固件管理-\' + vm.sku.groupName + \'-编辑SKU\' : \'设备固件管理-\' + vm.sku.groupName + \'-新增SKU\' }}</span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>SKU编号</span></label><div class=input-group><input type=text class=form-control name=roleDescription readonly ng-model=vm.template.skuNum autocomplete=off required> <span ng-if=!vm.sku.id class=input-group-btn><a class=\"btn btn-default\" type=button ui-sref=deviceFirmware.chooseSku() value=templateName ng-blur=vm.judgeCountry()><i class=\"fa fa-edit text-navy\"></i></a> </span><span ng-if=vm.sku.id class=input-group-btn><a class=\"btn btn-default\" type=button ui-sref=deviceFirmware.editChooseSku() value=templateName><i class=\"fa fa-edit text-navy\"></i></a></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>SKU名称</span></label><input type=text class=form-control name=code id=field_skuCode readonly ng-model=vm.template.skuName autocomplete=off required disabled ng-readonly=vm.skuCodeReadOnly></div></div></div><!-- <div class=\"row\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\" for=\"field_skuCode\"><span style=\"color: red\">*</span><span>说明</span></label>\n          <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" name=\"roleDescription\" id=\"field_description\" required\n              ng-model=\"vm.template.description\" readonly />\n            <span class=\"input-group-btn\">\n              <button id=\"descriptionBtn\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.showLocale(\'description\')\"\n                value=\"description\"><i class=\"fa fa-globe\"></i></button>\n            </span>\n          </div>\n        </div>\n      </div>\n    </div> --></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close ng-click=vm.clear() data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/deviceFirmware/chooseSkuForDevice-dialog.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=distribution.chooseSku></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-5><label class=\"col-md-4 control-label\" style=padding-top:5px><span translate=distribution.SKU></span>：</label><div class=\"col-md-8 input-group date\"><input type=text ng-model=vm.sku.skuNumber class=form-control></div></div><div class=col-md-5><label class=\"col-md-4 control-label\" style=padding-top:5px><span translate=distribution.skuName></span>：</label><div class=\"col-md-8 input-group date\"><input type=text ng-model=vm.sku.skuName class=form-control></div></div><div class=col-md-2><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.search()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><!--<input type=\"checkbox\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.isAllSelected\">--></th><th><span translate=distribution.skuNumber></span></th><th><span translate=distribution.skuName></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.sku.resources track by resource.skuId\"><td><input type=radio ng-model=$parent.vm.selectParent name=parentOrganization ng-value=resource></td><td>{{resource.skuNumber}}</td><td>{{resource.skuName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveParent()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div>");
$templateCache.put("app/deviceFirmware/deviceFirmware.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=deviceFirmware.deviceFirmware></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span>SKU</span></label><div class=col-lg-8><input type=text ng-model=vm.sku.skuNumber class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span>SKU名称</span></label><div class=col-lg-8><input type=text ng-model=vm.sku.skuName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><!-- <div class=\"col-lg-4 pull-right m-t-n-xs\">\n                    <button class=\"btn btn-w-m btn-danger\" ng-click=\"vm.deleteSkus()\"><span translate=\"btnTypeName.del\"></span></button>\n                  </div> --><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=deviceFirmware.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetSku()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=table><thead><tr><!-- <th><input type=\"checkbox\" name=\"chk_all\" id=\"chk_all\" ng-click=\"vm.checkAllSku()\"/>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=\"btnTypeName.operation\"></span></th> --><th><span translate=btnTypeName.operation></span></th><th><span translate=deviceFirmware.product></span></th><th><span translate=deviceFirmware.code></span></th><th><span translate=deviceFirmware.name></span></th><th><span>说明</span></th></tr></thead><!--  --><!-- <tbody ng-repeat=\"sku in vm.skus track by $index\" ng-style=\"{ border-top: $index != 0 ? \'none\' : \'\' }\"> --><tbody ng-repeat=\"sku in vm.skus track by $index\" style=\"border-top: none\"><tr ng-if=\"sku.skus.length > 0\" ng-repeat=\"item in sku.skus\"><td ng-if=\"$index == 0\" rowspan=\"{{ $index == 0 ? sku.skus.length : \'\' }}\" ng-style=\"{ \'line-height\' : (sku.skus.length * 35) + \'px\' }\"><!-- <input type=\"checkbox\" name=\"chk_list\" class=\"chk_list\" value=\"{{sku.skuId}}\" ng-click=\"vm.checkSku()\"/>&nbsp;&nbsp; --> <a ng-if=\"$index == 0\" ui-sref=\"deviceFirmware.edit({groupId:sku.groupId, groupName: sku.groupName, note: sku.note})\"><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-if=\"$index == 0\" ui-sref=\"deviceFirmware.info({groupId:sku.groupId, groupName: sku.groupName})\"><i class=\"fa fa-eye text-navy\" translate=btnTypeName.view></i></a> <a ng-if=\"$index == 0\" ng-click=vm.deleteSku(sku)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-if=\"$index == 0\" rowspan=\"{{ $index == 0 ? sku.skus.length : \'\' }}\" ng-style=\"{ \'line-height\' : (sku.skus.length * 35) + \'px\' }\">{{$index == 0 ? sku.groupName : \'\'}}</td><td>{{item.skuNumber}}</td><td>{{item.skuName}}</td><td ng-if=\"$index == 0\" rowspan=\"{{ $index == 0 ? sku.skus.length : \'\' }}\" ng-style=\"{ \'line-height\' : (sku.skus.length * 35) + \'px\' }\">{{$index == 0 ? sku.note : \'\'}}</td></tr><tr ng-if=\"sku.skus.length <= 0\"><td><!-- <input type=\"checkbox\" name=\"chk_list\" class=\"chk_list\" value=\"{{sku.skuId}}\" ng-click=\"vm.checkSku()\"/>&nbsp;&nbsp; --> <a ui-sref=\"deviceFirmware.edit({groupId:sku.groupId, groupName: sku.groupName, note: sku.note})\"><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ui-sref=\"deviceFirmware.info({groupId:sku.groupId, groupName: sku.groupName})\"><i class=\"fa fa-eye text-navy\" translate=btnTypeName.view></i></a> <a ng-click=vm.deleteSku(sku)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{sku.groupName}}</td><td>{{item.skuNumber}}</td><td>{{item.skuName}}</td><td>{{sku.note}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/deviceFirmware/editChooseSkuForDevice-dialog.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=distribution.chooseSku></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-5><label class=\"col-md-4 control-label\" style=padding-top:5px><span translate=distribution.SKU></span>：</label><div class=\"col-md-8 input-group date\"><input type=text ng-model=vm.sku.skuNumber class=form-control></div></div><div class=col-md-5><label class=\"col-md-4 control-label\" style=padding-top:5px><span translate=distribution.skuName></span>：</label><div class=\"col-md-8 input-group date\"><input type=text ng-model=vm.sku.skuName class=form-control></div></div><div class=col-md-2><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.search()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><!--<input type=\"checkbox\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.isAllSelected\">--></th><th><span translate=distribution.skuNumber></span></th><th><span translate=distribution.skuName></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.sku.resources track by resource.skuId\"><td><input type=radio ng-model=$parent.vm.selectParent name=parentOrganization ng-value=resource></td><td>{{resource.skuNumber}}</td><td>{{resource.skuName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveParent()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div>");
$templateCache.put("app/deviceFirmware/editFirmware.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addFirmware()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span>{{ \'设备固件管理-\' + vm.sku.groupName + \'-编辑固件\' }}</span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><!-- <label class=\"control-label\" for=\"field_skuCode\"><span style=\"color: red\">*</span><span >导入配置文件</span></label> --><div class=input-group><input type=file accept=application/json name=configFiles id=configFiles ng-model=vm.configFiles onchange=angular.element(this).scope().vm.upConfigFiles(this) style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span>导入配置文件</span></a></div></div></div><div class=col-md-6><div class=form-group><!-- <label class=\"control-label\" for=\"field_skuCode\"><span style=\"color: red\">*</span><span >导入资源包</span></label> --><div class=input-group><input type=file name=resourceFile id=resourceFile ng-model=vm.resourceFile onchange=angular.element(this).scope().vm.upResourceFile(this) style=\"opacity: 0; position: absolute; z-index: -1; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\" ng-click=vm.verifyData()><span>导入资源包</span></a></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级包版本号</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.firmwareVersion required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级包名称</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.firmwareName required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级组件名称(组件号+组件名称)</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.component required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>part号+part名称</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.part required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>分包大小(KB)</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.subPackageSize required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>下载地址最大长度</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.downloadUrlType required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>是否为必升版本</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.forceUpdate required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>是否静默下载</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.isSilentDownload required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级包优先级(数字越小优先级越高)</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.priority required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>包下载到那里</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.downloadLocation required ng-readonly=vm.readonly></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/deviceFirmware/lookDeviceFirmwareList.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  table td {\n    max-width: 300px;\n    word-wrap: break-word;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  table td:hover {\n    white-space: normal;\n    overflow: auto;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span>{{ \'设备固件管理-\' + vm.sku.groupName + \'-历史固件列表\'}}</span></h5></div><div class=ibox-content><form class=form-horizontal><!-- <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-lg-4\">\n                  <label class=\"col-lg-4 control-label\"><span >组件号</span></label>\n                  <div class=\"col-lg-8\">\n                    <input type=\"text\" ng-model=\"vm.sku.componentNumber\" class=\"form-control\">\n                  </div>\n                </div>\n                <div class=\"col-lg-4\">\n                  <label class=\"col-lg-4 control-label\"><span >part号</span></label>\n                  <div class=\"col-lg-8\">\n                    <input type=\"text\" ng-model=\"vm.sku.partNumber\" class=\"form-control\">\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-lg-4\"></div>\n                <div class=\"col-lg-4\"></div>\n                <div class=\"col-lg-4\">\n                  <div class=\"col-lg-8 pull-right m-t-n-xs\">\n                    <button class=\"btn btn-white\" type=\"reset\" ng-click=\"vm.resetSku()\"><span translate=\"btnTypeName.reset\"></span></button>\n                    <button class=\"btn btn-w-m btn-primary\" type=\"button\" ng-click=\"vm.search()\"><span translate=\"btnTypeName.search\"></span></button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </form> --><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><!-- <th><span translate=\"btnTypeName.operation\"></span></th> --><th><span>升级组件号</span></th><th><span>升级组件名称</span></th><th><span>升级组件part号</span></th><th><span>升级组件part名称</span></th><th><span>版本</span></th><th><span>优先级</span></th><th><span>大小</span></th><th><span>更新日期</span></th><th><span>更新人(账号)</span></th><th><span>配置文件</span></th><th><span>动作</span></th></tr></thead><tbody style=\"border-top: none\"><tr ng-repeat=\"item in vm.firmwareList track by $index\"><!-- <td> --><!-- <a ui-sref=\"deviceFirmware.firmwareListEdit({id: 123})\"><i class=\"fa fa-edit text-navy\"><span translate=\"btnTypeName.edit\"></span></i></a>\n                    <a ui-sref=\"deviceFirmware.edit({groupId: vm.sku.groupId})\"><i class=\"fa fa-eye text-navy\">查看历史版本</i></a>\n                    <a ng-click=\"vm.deleteSku(sku)\"><i class=\"fa fa-times text-navy\"><span translate=\"btnTypeName.del\"></span></i></a> --><!-- </td> --><td>{{item.componentNumber}}</td><td>{{item.componentName}}</td><td>{{item.partNumber}}</td><td>{{item.partName}}</td><td>{{item.versionNumber}}</td><td>{{item.priority}}</td><td>{{item.versionSize}}</td><td>{{item.lastUpdateDate}}</td><td>{{item.partyName}}</td><td>{{item.configurationFile}}</td><td><div><button id=historyNotifyPublicBtn{{item.firmwareId}} class=\"btn bg-primary\" translate=firmware.notifyPublic ng-disabled=\"{{item.isPublic==\'Y\'}}\" ng-click=vm.changePublic(item)></button></div></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></form></div></div></div></div></div>");
$templateCache.put("app/deviceFirmware/oatDeviceFirmwareList.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  table td {\n    max-width: 200px;\n    word-wrap: break-word;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  table td:hover {\n    white-space: normal;\n    overflow: auto;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span>{{ \'设备固件管理-\' + vm.sku.groupName + \'-固件列表\'}}</span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span>组件号</span></label><div class=col-lg-8><input type=text ng-model=vm.sku.componentNumber class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span>part号</span></label><div class=col-lg-8><input type=text ng-model=vm.sku.partNumber class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=\"deviceFirmware.firmwareListAdd({groupId: vm.sku.groupId, groupName: vm.sku.groupName})\"><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetSku()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><p style=\"margin: 8px 0;color: red\">当前最新固件信息：</p><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span>升级组件号</span></th><th><span>升级组件名称</span></th><th><span>升级组件part号</span></th><th><span>升级组件part名称</span></th><th><span>版本</span></th><th><span>优先级</span></th><th><span>大小</span></th><th><span>更新日期</span></th><th><span>更新人(账号)</span></th><th><span>配置文件</span></th><th><span>动作</span></th></tr></thead><tbody style=\"border-top: none\"><tr ng-repeat=\"item in vm.firmwareList track by $index\"><td><a ui-sref=\"deviceFirmware.firmwareListEdit({id: item.firmwareId, configurationFile: item.configurationFile, groupId: vm.sku.groupId})\"><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ui-sref=\"deviceFirmware.lookFirmwareList({id: vm.sku.groupId, groupName: vm.sku.groupName, componentNumber: item.componentNumber, partNumber: item.partNumber})\"><i class=\"fa fa-eye text-navy\">查看历史版本</i></a> <a ng-click=vm.deleteSku(item)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{item.componentNumber}}</td><td>{{item.componentName}}</td><td>{{item.partNumber}}</td><td>{{item.partName}}</td><td>{{item.versionNumber}}</td><td>{{item.priority}}</td><td>{{item.versionSize}}</td><td>{{item.lastUpdateDate}}</td><td>{{item.partyName}}</td><td>{{item.configurationFile}}</td><td><div><button id=notifyPublicBtn{{item.firmwareId}} class=\"btn bg-primary\" translate=firmware.notifyPublic ng-disabled=\"item.isPublic==\'Y\'\" ng-click=vm.changePublic(item)></button></div></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/deviceFirmware/oatDeviceList.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span>{{ \'设备固件管理-\' + vm.sku.groupName + \'-SKU列表\' }}</span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=deviceFirmware.code></span></label><div class=col-lg-8><input type=text ng-model=vm.sku.skuNumber class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=deviceFirmware.name></span></label><div class=col-lg-8><input type=text ng-model=vm.sku.skuName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=\"deviceFirmware.firmwareList({groupId: vm.sku.groupId, groupName: vm.sku.groupName})\"><span>编辑固件</span></a></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=\"deviceFirmware.addSku({groupId: vm.sku.groupId, groupName: vm.sku.groupName})\"><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetSku()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=deviceFirmware.code></span></th><th><span translate=deviceFirmware.name></span></th><!-- <th><span translate=\"deviceFirmware.desc\"></span></th> --></tr></thead><tbody style=\"border-top: none\"><tr ng-repeat=\"sku in vm.skus track by $index\"><td><!-- <a ui-sref=\"deviceFirmware.editSku({groupId: vm.sku.groupId, id: sku.skuId})\"><i class=\"fa fa-edit text-navy\"><span translate=\"btnTypeName.edit\"></span></i></a> --> <a ng-click=vm.deleteSku(sku)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{sku.skuNumber}}</td><td>{{sku.skuName}}</td><!-- <td>{{sku.groupName}}</td> --></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/distribution/addAppVersion.html","<script>$(function(){\n    \'use strict\';\n    $(\"#uploadApp\").change(function () {\n      var appPath = $(\"#uploadApp\").val();\n      var fileName = getFileName(appPath);\n      $(\"#appFilePath\").val(fileName);\n    });\n  });\n  function getFileName(o){\n    var pos=o.lastIndexOf(\"\\\\\");\n    return o.substring(pos+1);\n  }</script><form name=addVersionForm role=form novalidate ng-submit=vm.saveAddVersion()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>新增版本</h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=versionMark>版本号</label><input type=text class=form-control name=versionMark id=versionMark ng-model=vm.addAppVersion.versionMark></div></div><div class=col-md-6><div class=form-group><label class=control-label for=appFilePath>应用上传</label><div><div style=\"float: left\"><input type=text id=appFilePath readonly class=form-control style=\"height:33px;width:300px;border:1px solid #E5E6E7\"></div><a href=javascript:void(0); class=\"input btn-primary\">浏览 <input type=file id=uploadApp class=uploadFile ng-model=vm.appFile ngf-select name=appFile></a></div><div ng-class=\"{progress: true, \'progress-striped\': vm.striped}\" ng-show=vm.versionProgressShow style=\"width: 300px\"><div ng-class=\"[\'progress-bar\', vm.style]\" ng-style=\"{width: vm.progressPercentage + \'%\'}\"><div>{{vm.progressPercentage}}%</div></div></div><div ng-show=vm.varMayAppVersion class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.uploadApp(vm.appFile)><div>开始上传</div></div><div ng-show=vm.varMaysAppVersion><img src=assets/images/check.png></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;Cancel</button> <button type=submit ng-disabled=\"addVersionForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;Save</button></div></form>");
$templateCache.put("app/distribution/distribution-detail.html","<script>$(function () {\n    \'use strict\';\n    $(\"#uploadImg\").change(function () {\n      var imgPath = $(\"#uploadImg\").val();\n      var fileName = getFileName(imgPath);\n      $(\"#filePath\").val(fileName);\n    });\n    $(\"#uploadApp\").change(function () {\n      var appPath = $(\"#uploadApp\").val();\n      var fileName = getFileName(appPath);\n      $(\"#appFilePath\").val(fileName);\n    });\n    function getFileName(o) {\n      var pos = o.lastIndexOf(\"\\\\\");\n      return o.substring(pos + 1);\n    }\n  })</script><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=row><div class=row><alert-error></alert-error></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>新增应用</h5></div><div class=ibox-content><form name=addForm class=reg-page role=form novalidate ng-submit=vm.saveAdd()><div class=rows><div class=col-md-5></div><img ng-src={{vm.distributionApp.appIcon}} alt=\"\" width=120px height=120px></div><div class=rows style=\"width:90%;margin-left: 5%;margin-right: 5%\"><div class=form-group><label class=control-label for=appName>应用名称 *</label><input type=text class=form-control name=appName id=appName ng-model=vm.distributionApp.appName required></div></div><div class=rows style=\"width:90%;margin-left: 5%;margin-right: 5%\"><div class=form-group><label class=control-label>平台</label><input type=text class=form-control name=appPlatform id=appPlatform ng-model=vm.distributionApp.appPlatform readonly></div></div><div class=rows style=\"width:90%;margin-left: 5%;margin-right: 5%\"><div class=form-group><label class=control-label for=lastestVersion>版本号</label><input type=text class=form-control name=lastestVersion id=lastestVersion ng-model=vm.distributionApp.lastestVersion readonly></div></div><div class=rows style=\"width:90%;margin-left: 5%;margin-right: 5%\"><div class=form-group><label class=control-label for=appIntroduce>简介</label><textarea class=form-control rows=5 name=appIntroduce id=appIntroduce style=resize:none ng-model=vm.distributionApp.appIntroduce></textarea></div></div><div class=row><div class=form-group><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel()>&nbsp;&nbsp;取消&nbsp;&nbsp;</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">&nbsp;&nbsp;保存&nbsp;&nbsp;</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/distribution/distribution-upload.html","<style>.tag-box {\n    margin: 20px 0;\n    text-align: center;\n    border: dashed 1px #ccc;\n    height:200px;\n  }\n  .uploader {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    font-family: Arial;\n    font-size: 118px;\n    margin: 0px;\n    padding: 0px;\n    cursor: pointer;\n    opacity: 0;\n  }</style><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"rows tag-box\"><div class=form-group><div class=row><input type=file id=uploadApp class=uploader ng-model=vm.appFile ngf-select name=appFile ng-change=vm.uploadApp(vm.appFile)></div><div class=row><div ng-show=vm.varMayApp class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.uploadApp(vm.appFile)><div translate=distribution.immediately_upload></div></div></div><div class=row><span translate=distribution.upload_prompt></span></div><uib-progressbar max=100 value=vm.progressPercentage><span style=\"color:white; white-space:nowrap\">{{vm.progressPercentage}}%</span></uib-progressbar><div ng-show=vm.varMaysApp><img src=assets/images/check.png></div></div></div></div>");
$templateCache.put("app/distribution/distribution.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=row><div class=row><alert-error></alert-error></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=distribution.management></h5></div><div class=ibox-content><div class=widget-body><form><div class=row><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px translate=function.funcName></label><div class=\"col-md-9 input-group date\"><input type=text translate-attr=\"{placeholder : \'sysConfig.fuzzyQuery\'}\" ng-model=vm.searchApp.appName class=form-control></div></div><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px translate=distribution.platform></label><div class=\"col-md-9 input-group date\"><select class=form-control ng-model=vm.searchApp.appTerrace><option ng-repeat=\"x in vm.staff\" value={{x.code}}>{{x.description}}</option></select></div></div></div><br><div class=row><div class=col-md-5></div><div class=col-md-5><div class=\"col-md-offset-3 col-md-9 input-group date\"><button class=\"btn btn-white\" type=button ng-click=vm.clear() translate=btnTypeName.reset>重置</button> <input type=submit class=\"btn btn-w-m btn-primary\" value=查询 translate-attr=\"{value:\'dataAnalysis.query\'}\" ng-click=vm.search()>&nbsp; <button class=\"btn btn-w-m btn-primary\" type=button ui-sref=distribution.upload translate=distribution.new></button></div></div></div></form><div class=table-responsive style=\"margin-top: 50px\"><table class=\"table table-striped\"><thead><tr><th translate=btnTypeName.operation></th><th translate=function.funcSeq></th><th translate=function.funcIcon></th><th translate=function.funcName></th><th translate=distribution.latest></th><th translate=distribution.platform></th><th translate=distribution.introduction></th><th translate=distribution.ut></th></tr></thead><tbody><tr ng-repeat=\"app in vm.apps\"><td><a><i class=\"fa fa-desktop text-navy\" ui-sref=viewApp({appId:app.appId}) translate=btnTypeName.check></i></a> <a><i class=\"fa fa-edit text-navy\" ui-sref=distribution.edit({appId:app.appId}) translate=btnTypeName.edit></i></a><!--<a><i class=\"fa fa-download text-warning\" ui-sref=\"downloadApp({appVersionId:app.appVersionId})\">下载</i></a>--></td><td>{{$index+1}}</td><td><img id=appImg height=30 width=30 ng-src={{app.appIcon}} style=border:0></td><td>{{app.appName}}</td><td>{{app.versionMark}}</td><td>{{app.appPlatform}}</td><td>{{app.appDescription}}</td><td>{{app.uploadingDate}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/distribution/downloadApp.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=row><div class=row><alert-error></alert-error></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>应用下载</h5></div><div class=ibox-content><div class=widget-body><div class=container style=margin-top:20px><ul class=\"pull-left breadcrumb\"><li><p style=\"font-size: 20px ;color: rgba(61, 82, 90, 0.75)\">{{vm.downloadApp.appName}}</p></li><li>版本:{{vm.downloadApp.lastestVersion}}</li><li>大小:{{vm.downloadApp.appSize}}</li><li>时间:{{vm.downloadApp.lastUpdateDate}}</li></ul></div><hr style=margin:0><div style=text-align:center;margin-top:30px><img ngf-src=vm.downloadApp.appIcon height=125px width=125px style=\"border-radius:30px;border:1px #CCCCCC solid\"></div><div style=\"text-align:center;margin:20px 0 10px\"><button type=button class=\"btn btn-lg\" style=\"background-color: #4096B2;border-color: #4096B2;color: #FFFFFF\" ng-click=vm.downLoad()><i class=\"glyphicon glyphicon-cloud-download\"></i>&nbsp下载安装</button></div><div style=text-align:center><span class=label style=\"background-color: #43C2EB;color:#FFFFFF\">适用于{{vm.downloadApp.appPlatform}}设备</span></div><div style=\"margin:0 20px\"><hr style=\"height:2px;border:none;border-top:2px dotted #CCCCCC; max-width:1200px\"></div><div style=text-align:center>或者用手机扫描下面的二维码安装<br><br><img ngf-src=vm.downloadApp.qrCode style=\"width:200px; height:200px\"></div></div></div></div></div></div>");
$templateCache.put("app/distribution/viewApp.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=row><div class=row><alert-error></alert-error></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>应用查看</h5></div><div class=ibox-content><div class=widget-body><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-12 pull-right m-t-n-xs\"><!--<g:link action=\"upAppv\" params=\"[appId:app.id]\">--> <button type=button class=\"btn btn-w-m btn-info\" ui-sref=distribution.upload><i class=\"glyphicon glyphicon-cloud-upload\"></i>上传新版本</button><!--</g:link>--></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"></div></div></div></div></form><div class=table-responsive><div class=col-md-12 style=\"height: 180px;background-color : #F5F5F5; margin:10px auto; border-top: solid 2px #56bc94\"><div class=col-md-8><div style=\"height: 70px\"><p style=\"font-size: 20px ;margin: 10px;font-weight: 500\">{{vm.app.appName}}</p><p style=\"font-size: 14px ;margin: 10px\">最新版本:{{vm.app.lastestVersion}}(build{{vm.app.buildNum}})</p></div><hr><div><p style=\"font-size: 18px ;margin: 10px\">APP ID :{{vm.app.appId}}</p></div></div><div class=col-md-2><div style=\"height: 160px;text-align:center;margin-top: 20px\"><a ui-sref=downloadApp({randomCode:vm.app.randomCode})><img ng-src={{vm.app.appIcon}} height=125px width=125px style=\"border-radius:24px;border:1px #CCCCCC solid\"></a><p style=\"text-align: center;margin-bottom: 0px\"><a style=color:#56bc94 ui-sref=downloadApp({randomCode:vm.app.randomCode})>查看应用</a></p></div></div><div class=col-md-2><div style=\"height: 160px;text-align:center;margin-top: 20px\"><img ng-src={{vm.app.qrCode}} height=125px width=125px style=\"border:1px #CCCCCC solid\"><p style=\"text-align: center;margin-bottom: 0px\">扫描二维码下载</p></div></div></div><div class=headline><h3>版本信息</h3></div><table class=\"table table-striped\"><thead><tr><th>操作</th><th>版本</th><th>Build</th><th>下载次数</th><th>大小</th><th>最新版本</th><th>更新时间</th></tr></thead><tbody><tr ng-repeat=\"appVersion in vm.appVersions\"><td><a><i class=\"fa fa-desktop text-navy\" ui-sref=downloadApp({randomCode:appVersion.versionKey})>查看</i></a><!--<a href=\"http://qiniu-app-cdn.pgyer.com/b574d9ff4555cbe5e1a11186daa08b6f.ipa?e=1476778815&amp;attname=%E5%B1%B1%E9%B9%B0%E7%BA%B8%E4%B8%9A.ipa&amp;token=6fYeQ7_TVB5L0QSzosNFfw2HU8eJhAirMF5VxV9G:L8Nm9pTKNeLqchPa08y0dsnctho=\"><i class=\"fa fa-download text-warning\">下载</i></a>--></td><td>{{appVersion.version}}</td><td>{{appVersion.buildNum}}</td><td>{{appVersion.downloadTimes}}</td><td>{{appVersion.appSize}}</td><td>{{appVersion.isCurrentVersion == \'Y\'?\'是\':\'否\'}}</td><td>{{appVersion.lastUpdateDate}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/downtimePush/addDowntimePush.html","<style>.toast-container {\n    z-index: 99999;\n  }\n\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n\n  #toast-container {\n    z-index: 99999;\n  }</style><form name=addForm role=form novalidate ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=btnTypeName.create></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.downtimePush_name></span></label><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateName ng-model=vm.template.templateName readonly> <span class=input-group-btn><button id=templateNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'templateName\')\" value=templateName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.downtimePush_type></span></label><select ng-model=vm.template.templateType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.templateTypeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><!--<div  class=\"row\" style=\"height: 300px;\"></div>--></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.downtimePush_content></span></label><!--<input type=\"text\" class=\"form-control\"\n                 ng-model=\"vm.template.templateContent\" required\n          />--><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateContent ng-model=vm.template.templateContent required readonly> <span class=input-group-btn><button id=templateContentBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'templateContent\')\" value=templateContent><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=distribution.description></span></label><!--<select ng-model=\"vm.template.description\" class=\"form-control\">\n            <option ng-repeat=\"x in vm.roleTypes\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>--><div class=input-group><input type=text class=form-control name=roleDescription id=field_description ng-model=vm.template.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_templateContent style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_templateContent></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'templateContent\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_templateName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_templateName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'templateName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/downtimePush/downtimePush.html","<div class=row><alert-error></alert-error></div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=distribution.downtimePush_maintenance></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=distribution.downtimePush_type></span></label><div class=col-lg-8><select ng-model=vm.template.templateType class=form-control required><!--<option value=\"{{x.value}}\"> </option>--><option selected value=\"\"></option><option ng-repeat=\"x in vm.templateTypeList\" value={{x.value}}>{{x.meaning}}</option></select><!--<input type=\"text\" ng-model=\"vm.template.templateType\" class=\"form-control\">--></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=distribution.template_name></span></label><div class=col-lg-8><input type=text ng-model=vm.template.templateName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=downtimePush.add translate=btnTypeName.create></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=hr-line-dashed></div><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th width=10% translate=btnTypeName.operation></th><th width=20% translate=distribution.downtimePush_name></th><th width=30% translate=distribution.downtimePush_content></th><th width=10% translate=distribution.downtimePush_type></th><th width=10% translate=distribution.description></th><th width=10% translate=btnTypeName.operation></th></tr></thead><tbody><tr ng-repeat=\"template in vm.templates \"><td><a ui-sref=downtimePush.edit({id:template.templateId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteTemp(template.templateId)><i class=\"fa fa-times text-warning\"><span translate=btnTypeName.del></span></i></a></td><td>{{template.templateName}}</td><td>{{template.templateContent}}</td><td>{{template.templateType}}</td><td>{{template.description}}</td><td><a ui-sref=pushToB2cResParty({id:template.templateId})><i class=\"fa fa-edit text-navy\"><span translate=distribution.pushOne></span></i></a> &nbsp;&nbsp; <a ng-click=vm.pushAll(template.templateId)><i class=\"fa fa-sign-in text-navy\"><span translate=distribution.pushAll></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/downtimePush/editDowntimePush.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.edit()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=btnTypeName.edit></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.downtimePush_name></span></label><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateName ng-model=vm.template.templateName readonly> <span class=input-group-btn><button id=templateNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'templateName\')\" value=templateName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.downtimePush_type></span></label><select ng-model=vm.template.templateType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.templateTypeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.downtimePush_content></span></label><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateContent ng-model=vm.template.templateContent readonly> <span class=input-group-btn><button id=templateContentBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'templateContent\')\" value=templateContent><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=distribution.description></span></label><div class=input-group><input type=text class=form-control name=roleDescription id=field_description ng-model=vm.template.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_templateContent style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_templateContent></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'templateContent\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_templateName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_templateName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'templateName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/downtimePush/pushToB2cResParty.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5><span translate=distribution.privateMessage></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=distribution.partyMessage></span></label><div class=col-lg-6><input type=text class=form-control ng-model=vm.party.partyAccount></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.back()><span translate=btnTypeName.cancel></span></button></div><div class=\"col-lg-5 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.push()><span translate=btnTypeName.push></span></button></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.getResidentialParty()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllParty()>&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=userManage.userName></span></th><th><span translate=userManage.telephone></span></th><th><span translate=userManage.email></span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><td><input type=checkbox name=chk_list ng-checked=vm.check(party.partyId) class=chk_list value={{party.partyId}} ng-click=vm.checkParty()>&nbsp;&nbsp;</td><td ng-bind=party.partyName></td><td ng-bind=party.phoneNumber></td><td ng-bind=party.emailAddress></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div>");
$templateCache.put("app/feedback/feedback-dialog.html","<div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>创建反馈</h4></div><div class=modal-body><form name=editForm role=form novalidate><!--<jhi-alert-error></jhi-alert-error>--><div class=row><div class=col-md-6><label class=\"col-md-6 control-label\" style=padding-top:4px>反馈类型：</label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.feedback.feedbackType class=form-control></div></div></div><div class=row><div class=col-md-12><div class=form-group><label class=control-label>反馈内容 ：</label><textarea class=form-control type=text ng-model=vm.feedback.feedbackData></textarea></div></div></div></form></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()>取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=vm.save()>提交</button></div>");
$templateCache.put("app/feedback/feedback.html","<style>.fb-ul{\n     list-style-type:none;\n     padding-left: 2%;\n     padding-right: 2%;\n     width: 100%;\n     border-bottom: 1px solid #18a689;\n     border-top:  1px solid #18a689;\n     border-right:  1px solid #18a689;\n     border-left:   8px solid #18a689;\n     margin-top: 2%;\n   }\n   .fb-ul-1{\n     padding: 0;\n   }\n  .fb-li-1{\n    padding-left: 2%;\n    padding-right: 2%;\n    list-style-type:none;\n    width: 100%;\n    height: 40px;\n    border:1px solid #dbdbdb;\n    background-color: #f9f9f9;\n  }\n\n   .demo_line_01{\n     padding: 0 20px 0;\n     margin: 10px 0;\n     line-height: 1px;\n     height:1px;\n     width:100%;\n     background: #dddddd;\n     overflow:hidden;\n   }\n\n  .fb-data{\n    height: 40px;\n    line-height: 40px;\n  }\n\n   .ul-class{\n     margin-bottom: 2%;\n   }</style><div class=row><div class=row><alert-error></alert-error></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>信息反馈</h5></div><div class=ibox-content><div class=widget-body><div><form><div class=row><div class=col-md-3><label class=\"col-md-6 control-label\" style=padding-top:4px>用户类型：</label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.searchFeedback.userType class=form-control></div></div><div class=col-md-3><label class=\"col-md-6 control-label\" style=padding-top:5px>反馈类型：</label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.searchFeedback.feedbackType class=form-control></div></div><div class=col-md-3><label class=\"col-md-6 control-label\" style=padding-top:5px>查询时间：</label><div class=col-md-6><p class=input-group><input type=text class=form-control datetime-picker=\"yyyy-MM-dd HH:mm:ss\" name=start id=start ng-model=vm.searchFeedback.startDate is-open=vm.picker3.open> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openCalendar($event, \'picker3\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=col-md-3><label class=\"col-md-6 control-label\" style=padding-top:5px>至：</label><div class=col-md-6><p class=input-group><input type=text class=form-control datetime-picker=\"yyyy-MM-dd HH:mm:ss\" name=end id=end ng-model=vm.searchFeedback.endDate is-open=vm.picker4.open> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openCalendarL($event, \'picker4\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><br><div class=row><div class=col-md-3><label class=\"col-md-6 control-label\" style=padding-top:5px>工号：</label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.searchFeedback.userId class=form-control></div></div><div class=col-md-3><label class=\"col-md-6 control-label\" style=padding-top:5px>关键词：</label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.searchFeedback.feedbackData class=form-control></div></div><div class=col-md-6><div class=\"col-md-offset-3 col-md-9 input-group date\"><input type=submit class=\"btn btn-w-m btn-primary\" value=查询 ng-click=vm.search()>&nbsp; <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.createFeedback()>创建</button>&nbsp;<!--<button class=\"btn btn-w-m btn-primary\" type=\"button\" ng-click=\"vm.printFeedback()\">导出</button>&nbsp; &nbsp; &nbsp; &nbsp;--> <button type=button class=\"btn btn-primary\"><a style=\"color: aliceblue\" href={{vm.path}}>导出Excel</a></button>&nbsp; &nbsp; &nbsp; &nbsp; <button ng-repeat=\"feedback in vm.feedbacks|limitTo:1\" class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.queryNotReply()>{{feedback.count}}个未回复</button></div></div></div></form><div><ul class=fb-ul ng-repeat=\"feedback in vm.feedbacks \"><li class=fb-li><div class=fb-data><span>{{feedback.userName}} 【{{feedback.userType}}】</span> {{feedback.feedbackDate}}</div><div class=demo_line_01>-</div><div class=fb-data>{{feedback.feedbackData}}</div><textarea class=form-control type=text ng-model=vm.feedbacks[$index].replyData></textarea><br><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.insert(feedback.feedbackId,vm.feedbacks[$index].replyData)>回复</button><br><br><div class=ul-class><ul class=fb-ul-1 ng-repeat=\"feedbackReply in feedback.hmsFeedbackReplyDTOs \"><li class=fb-li-1><div class=fb-data>{{feedbackReply.userName}} 回复 ：{{feedbackReply.replyData}} {{feedbackReply.replyDate}}</div></li></ul></div></li></ul></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/firmwareUpdate/addFirmwareBatchVersion.html","<style>.toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n  #toast-container {\n    z-index: 99999;\n  }\n  .check-input{\n    display: inline-block;\n    margin-right: 10px !important;\n  }</style><form name=addForm role=form ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=firmware.uploadBatchVersion></span></h4></div><div class=modal-body><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=distribution.hardwareType></span></label><!--<input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                 ng-model=\"vm.menuVersion.firmwareType\" required >--><lookup-select lookup-value=vm.menuVersion.hardwareType lookup-type=IOT.DVM_MODULE_PART_NUMBER required></lookup-select></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=firmware.firmwareType></span></label><!--<input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                 ng-model=\"vm.menuVersion.firmwareType\" required >--><select ng-model=vm.menuVersion.firmwareType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.firmwareTypeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=plugin.versionNumber></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=versionNumber ng-model=vm.menuVersion.versionNumber required></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=firmware.versionUrl></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=versionUrl ng-model=vm.menuVersion.versionUrl required readonly></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=firmware.versionName></span></label><div class=input-group><input type=text class=form-control name=versionName ng-model=vm.menuVersion.versionName required readonly> <span class=input-group-btn><button id=versionNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'versionName\')\" value=menuDesc><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><!--<div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><span translate=\"firmware.updateDate\"></span></label>\n          <div class=\"input-group date form_date\">\n            <input type=\"text\" readonly class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd HH:mm:ss\" name=\"start\" id=\"start\"\n                   ng-model=\"vm.menuVersion.updateDate\" datepicker-options=\"vm.dateOptions\" is-open=\"vm.isStartOpen\"/>\n            <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.startOpen()\">\n                      <i class=\"glyphicon glyphicon-calendar\"></i></button>\n                  </span>\n          </div>\n      </div>\n    </div>--><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=firmware.minimumVersion></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=minimumVersion ng-model=vm.menuVersion.minimumVersion required></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=distribution.description></span></label><div class=input-group><input type=text class=form-control name=description id=field_templateName ng-model=vm.menuVersion.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=menuDesc><i class=\"fa fa-globe\"></i></button></span></div><!--\n                    <input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                           ng-model=\"vm.menuVersion.menuDesc\" required >--></div></div></div><!--<div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><span translate=\"firmware.isCurrentVersion\"></span></label>  &nbsp;&nbsp; &nbsp;&nbsp;\n          <input type=\"checkbox\" ng-model=\"vm.menuVersion.lastFlag\" ngTrueValue=\"Y\" ngFalseValue=\"N\">\n          &nbsp;&nbsp;\n        </div>\n      </div>\n    </div>--><!--<div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\" style=\"width: 35%;\">\n        <permission-selector permission-data=\"vm.permissionData\"></permission-selector>\n      </div>\n    </div>--><div class=row><div class=\"col-md-offset-4 col-md-4\" style=\"margin-top: 18px\"><div class=form-group><div class=pull-left><input type=file name=zip id=zip ng-model=vm.zip onchange=angular.element(this).scope().vm.upFile() style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span translate=plugin.importPack></span></a></div></div><div style=\"color: red; margin-top: 34px\">(<span translate=plugin.versionFirst></span>)</div></div></div><!--checkPoint--><div class=row><div class=\"col-md-offset-4 col-md-4\" style=\"margin-top: 18px\"><div class=form-group><label class=control-label><input type=checkbox class=\"checkbox check-input\" ng-model=vm.isCheckPoint> <span translate=firmware.isCheckPoint></span> <a uib-tooltip={{vm.checkPointTip}} tooltip-placement=bottom class=font1 type=button><span class=\"glyphicon glyphicon-question-sign\"></span></a></label></div></div></div><!--tag--><div class=row><div class=\"col-md-offset-4 col-md-4\" style=\"margin-top: 18px\"><div class=form-group><label class=control-label><span translate=firmware.tag></span></label><ui-select multiple sortable limit=10 ng-model=vm.selectedData theme=bootstrap class=\"form-control m-b\" reset-search-input=true remove-selected=false><ui-select-match>{{$item.meaning}}</ui-select-match><ui-select-choices repeat=\"tag in vm.tags\" refresh-delay=500>{{tag.meaning}}</ui-select-choices></ui-select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=submit ng-disabled=\"(addForm.$invalid|| vm.isSaving)\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></form><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_versionName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_versionName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'versionName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/firmwareUpdate/addFirmwareUpdate.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  #toast-container {\n    z-index: 1100;\n  }</style><form name=addForm role=form novalidate ng-submit=vm.add() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=btnTypeName.create></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.SKU></span></label><!-- <input type=\"text\" class=\"form-control\" name=\"roldCode\" ng-click = \"\"\n                 ng-model=\"vm.template.skuId\" required readonly\n          />--><div class=input-group><input type=hidden class=form-control name=roleDescription readonly ng-model=vm.template.skuId required> <input type=text class=form-control name=roleDescription readonly ng-model=vm.template.skuName required> <span class=input-group-btn><a class=\"btn btn-default\" type=button ui-sref=firmwareUpdate.chooseSku() value=templateName ng-blur=vm.judgeCountry()><i class=\"fa fa-edit text-navy\"></i></a></span></div></div></div><div class=col-md-6><label class=control-label><span style=color:#f00>*</span><span translate=distribution.hardwareType></span></label><lookup-select id=testId lookup-value=vm.template.hardwareType lookup-type=IOT.DVM_MODULE_PART_NUMBER required disable=vm.isDisable></lookup-select></div></div><!--<div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><font color=\"red\">*</font><span translate=\"firmware.firmwareType\"></span></label>\n          <input type=\"text\" class=\"form-control\"\n                 ng-model=\"vm.template.firmwareType\" required\n          />\n        </div>\n      </div>--><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=firmware.firmwareType></span></label><select id=selectId ng-model=vm.template.firmwareType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.fireWareTypeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=firmware.firmwareName></span></label><input id=firmwareName type=text class=form-control name=roleDescription ng-model=vm.template.firmwareName><!--<select ng-model=\"vm.template.firmwareName\" class=\"form-control\" required>\n            <option ng-repeat=\"x in vm.fireWareNameList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>--></div></div><!-- <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><font color=\"red\">*</font><span translate=\"firmware.firwmareName\"></span></label>\n          &lt;!&ndash;<input type=\"text\" class=\"form-control\" name=\"roldCode\"\n                 ng-model=\"vm.template.templateName\" required\n          />&ndash;&gt;\n          &lt;!&ndash;<input type=\"text\" class=\"form-control\" name=\"roleDescription\" id=\"field_templateName\">&ndash;&gt;\n\n          <select ng-model=\"vm.template.firwmareName\" class=\"form-control\" required>\n            <option ng-repeat=\"x in vm.fireWareNameList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>\n          &lt;!&ndash;<div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" name=\"roleDescription\" id=\"field_templateName\"\n                  &lt;!&ndash; ng-model=\"vm.template.firmwareName\"&ndash;&gt;/>\n            <span class=\"input-group-btn\">\n              <button id=\"templateNameBtn\" disabled class=\"btn btn-default\" type=\"button\" ng-click=\"vm.showLocale(\'templateName\')\" value=\"templateName\"><i class=\"fa fa-globe\"></i></button>\n            </span>\n          </div>&ndash;&gt;\n        </div>\n      </div>--><!--<div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><font color=\"red\">*</font><span translate=\"appEdition.download_address\"></span></label>\n          <input type=\"text\" class=\"form-control\" name=\"roleDescription\"\n                 ng-model=\"vm.template.firmwareName\" readonly/>\n          &lt;!&ndash;<select ng-model=\"vm.template.templateType\" class=\"form-control\" required>\n            <option ng-repeat=\"x in vm.templateTypeList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>&ndash;&gt;\n        </div>\n      </div>--></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=distribution.description></span></label><!--<select ng-model=\"vm.template.description\" class=\"form-control\">\n            <option ng-repeat=\"x in vm.roleTypes\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>--><div class=input-group><input type=text class=form-control name=roleDescription id=field_description ng-model=vm.template.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close ng-click=vm.clear() data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!--<div class=\"modal fade\" id=\"localeModal__templateName2\"\n     style=\"z-index: 2040; position: absolute; display: none;\"\n     data-keyboard=\"false\"><div class=\"modal-dialog\">\n  <div class=\"modal-content\"><div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button>\n  </div>\n    <div class=\"modal-body\" id=\"localeModelBody_templateName\">\n    <div class=\"form-group\"></div>\n    <label class=\"control-label\">English</label><input type=\"text\" class=\"form-control\" name=\"rn_en_GB\" ng-model=\"vm.template.__tls.templateName.en_GB\">\n    <div class=\"form-group\"></div><label class=\"control-label\">泰文</label><input type=\"text\" class=\"form-control\" name=\"rn_th_TH\" ng-model=\"vm.template.__tls.templateName.th_TH\">\n    <div class=\"form-group\"></div><label class=\"control-label\">简体中文</label><input type=\"text\" class=\"form-control\" name=\"rn_zh_CN\" ng-model=\"vm.template.__tls.templateName.zh_CN\">\n    <div class=\"form-group\"></div><label class=\"control-label\">繁体中文</label><input type=\"text\" class=\"form-control\" name=\"rn_zh_HK\" ng-model=\"vm.template.__tls.templateName.zh_HK\">\n  </div>\n    <div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\"><span translate=\"btnTypeName.cancel\"></span></button><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.localeSure()\">\n    <span translate=\"btnTypeName.save\"></span></button>\n    </div>\n  </div>\n</div>\n</div>-->");
$templateCache.put("app/firmwareUpdate/addFirmwareVersion.html","<style>.toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n  #toast-container {\n    z-index: 99999;\n  }\n  .check-input{\n    display: inline-block;\n    margin-right: 10px !important;\n  }</style><div class=pre-scrollable style=\"max-height: 620px\"><form name=addForm role=form ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=firmware.uploadVersion></span></h4></div><div class=modal-body><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=plugin.versionNumber></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=menuVersion ng-model=vm.menuVersion.versionNumber required></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=firmware.versionUrl></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=versionUrl ng-model=vm.menuVersion.versionUrl required readonly></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=firmware.versionName></span></label><div class=input-group><input type=text class=form-control name=versionName ng-model=vm.menuVersion.versionName required readonly> <span class=input-group-btn><button id=versionNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'versionName\')\" value=menuDesc><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=firmware.minimumVersion></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=minimumVersion ng-model=vm.menuVersion.minimumVersion required></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=distribution.description></span></label><div class=input-group><input type=text class=form-control name=description id=field_templateName ng-model=vm.menuVersion.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=menuDesc><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-8\"><div class=form-group><label class=control-label for=file2><span translate=firmware.imageRsaSignature></span></label><div class=input-group><input type=file name=file2 id=file2 ng-model=vm.file2 onchange=angular.element(this).scope().vm.upFile(this) style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span translate=plugin.importPack></span></a></div></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\" style=\"margin-top: 18px\"><div class=form-group><label class=control-label><font color=red>*</font><span translate=firmware.imageFile></span></label><div class=input-group><input type=file name=zip id=zip ng-model=vm.zip onchange=angular.element(this).scope().vm.upFile() style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span translate=plugin.importPack></span></a></div></div><div style=\"color: red; margin-top: 5px\">(<span translate=plugin.versionFirst></span>)</div></div></div><!--checkPoint--><div class=row><div class=\"col-md-offset-4 col-md-4\" style=\"margin-top: 18px\"><div class=form-group><label class=control-label><input type=checkbox class=\"checkbox check-input\" ng-model=vm.isCheckPoint> <span translate=firmware.isCheckPoint></span> <a uib-tooltip={{vm.checkPointTip}} tooltip-placement=bottom class=font1 type=button><span class=\"glyphicon glyphicon-question-sign\"></span></a></label></div></div></div><div class=row><!--  todo 添加标签显示 在主页面中添加显示--><div class=\"col-md-offset-4 col-md-4\" style=\"margin-top: 18px\"><div class=form-group><label class=control-label><span translate=firmware.tag></span></label><ui-select multiple sortable limit=10 ng-model=vm.selectedData theme=bootstrap class=\"form-control m-b\" reset-search-input=true remove-selected=false><ui-select-match>{{$item.meaning}}</ui-select-match><ui-select-choices repeat=\"tag in vm.tags\" refresh-delay=500>{{tag.meaning}}</ui-select-choices></ui-select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=submit ng-disabled=\"(addForm.$invalid|| vm.isSaving)\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></form></div><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_versionName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_versionName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'versionName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/firmwareUpdate/addNewFirmware-dialog.html","<style>#toast-container{\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=firmware.versionAdd></span></h4></div><div class=modal-body><div class=row><div class=form-group><div class=\"col-md-offset-2 col-md-4\"><div class=pull-left><label class=control-label><font color=red>*</font><span translate=firmware.imageFile></span></label><div class=input-group><input type=file name=file1 id=file1 ng-model=vm.file1 onchange=angular.element(this).scope().vm.upFile(this) style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span translate=plugin.importPack></span></a></div></div></div><div class=col-md-4><div class=input-group><label class=control-label for=versionNumber><font color=red>*</font><span translate=firmware.versionNumber></span></label><input type=text class=form-control name=versionNumber id=versionNumber ng-model=vm.firmwareVersion.versionNumber required></div></div></div></div><hr><div class=row><div class=form-group><div class=\"col-md-offset-2 col-md-4\"><input type=hidden class=form-control ng-model=vm.firmwareVersion.versionName><label class=control-label for=field_versionName><font color=red>*</font><span translate=firmware.versionName></span></label><div class=input-group><input type=text class=form-control disabled style=\"width:100%;border: 1px solid #c8cacd\" name=versionName id=field_versionName ng-model=vm.firmwareVersion.versionName required> <span class=input-group-btn><button id=versionNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'versionName\')\" value=versionName><i class=\"fa fa-globe\"></i></button></span></div></div><div class=col-md-4><label class=control-label for=field_description><font color=red>*</font><span translate=dvmDevice.desc></span></label><div class=input-group><input type=text class=form-control disabled style=\"width:100%;border: 1px solid #c8cacd\" name=description id=field_description ng-model=vm.firmwareVersion.description required> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><hr><div class=row><div class=form-group><div class=\"col-md-offset-2 col-md-4\"><div class=pull-left><label class=control-label for=file2><font color=red>*</font><span translate=firmware.imageRsaSignature></span></label><div class=input-group><input type=file name=file2 id=file2 ng-model=vm.file2 onchange=angular.element(this).scope().vm.upFile(this) style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span translate=plugin.importPack></span></a></div></div></div><div class=col-md-4><label class=control-label for=field_releaseType><font color=red>*</font><span translate=firmware.releaseType></span></label><input type=text class=form-control name=releaseType id=field_releaseType ng-model=vm.firmwareVersion.releaseType required></div></div></div><hr><div class=row><div class=form-group><div class=\"col-md-offset-2 col-md-4\"><div class=pull-left><label class=control-label for=file3><font color=red>*</font><span translate=firmware.publicCertificate></span></label><div class=input-group><input type=file name=file3 id=file3 ng-model=vm.file3 onchange=angular.element(this).scope().vm.upFile(this) style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span translate=plugin.importPack></span></a></div></div></div><div class=col-md-4><div class=input-group><label class=control-label for=field_bootloaderVersion><font color=red>*</font><span translate=firmware.bootloaderVersion></span></label><input type=text class=form-control name=bootloaderVersion id=field_bootloaderVersion ng-model=vm.firmwareVersion.bootloaderVersion required></div></div></div></div><hr><div class=row><div class=form-group><div class=\"col-md-offset-2 col-md-4\"><div class=input-group><label class=control-label for=field_appVersion><font color=red>*</font><span translate=firmware.appVersion></span></label><input type=text class=form-control name=appVersion id=field_appVersion ng-model=vm.firmwareVersion.appVersion required></div></div><div class=col-md-4><div class=input-group><label class=control-label for=field_certificateVersion><font color=red>*</font><span translate=firmware.certificateVersion></span></label><input type=text class=form-control name=certificateVersion id=field_certificateVersion ng-model=vm.firmwareVersion.certificateVersion required></div></div></div></div><hr><div class=row><div class=form-group><div class=\"col-md-offset-2 col-md-4\"><div class=input-group><label class=control-label for=field_kernelVersion><font color=red>*</font><span translate=firmware.kernelVersion></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=kernelVersion id=field_kernelVersion ng-model=vm.firmwareVersion.kernelVersion required></div></div><div class=col-md-4><div class=form-group><label class=control-label><span translate=firmware.minimumVersion></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=minimumVersion id=minimumVersion ng-model=vm.firmwareVersion.minimumVersion required></div></div></div></div><hr></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><div class=\"modal fade\" id=localeModal_versionName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_versionName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'versionName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/firmwareUpdate/addWhitelist-dialog.html","<style>.modal-backdrop {\n    z-index: 1;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=firmware.addWhitelist></span></h4></div><div class=modal-body><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-3 control-label\"><span translate=userManage.partyNumber></span></label><div class=col-lg-9><input type=text ng-model=vm.party.userName class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-3 control-label\"><span translate=firmware.address></span></label><div class=col-lg-9><input type=text ng-model=vm.party.location class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4></div><div class=\"col-lg-offset-2 col-lg-5\"><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-primary\" type=button ng-click=vm.addParty()><span translate=firmware.add></span></button></div></div></div></div></form><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllParty()></th><th><span translate=firmware.account></span></th><th><span translate=userManage.partyNumber></span></th><th><span translate=firmware.address></span></th><!--<th><span translate=\"firmware.isPublic\"></span></th>--></tr></thead><tbody><tr ng-repeat=\"party in vm.partys\"><!----><td><input type=checkbox name=chk_list class=chk_list value={{party.partyId}} ng-click=vm.checkParty()></td><td>{{party.partyAccount}}</td><td>{{party.partyNumber}}</td><td>{{party.location}}</td><!--<td>{{party.resourceIds}}</td>--><!--<td>{{party.clientSecret}}</td>--></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div><div class=modal-footer><!-- <button type=\"button\" class=\"btn btn-info\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">\n       <span translate=\"appEdition.close\"></span>\n     </button>--></div></form>");
$templateCache.put("app/firmwareUpdate/chooseSkuForFirmware-dialog.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=distribution.chooseSku></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-5><label class=\"col-md-4 control-label\" style=padding-top:5px><span translate=distribution.SKU></span>：</label><div class=\"col-md-8 input-group date\"><input type=text ng-model=vm.sku.skuNumber class=form-control></div></div><div class=col-md-5><label class=\"col-md-4 control-label\" style=padding-top:5px><span translate=distribution.skuName></span>：</label><div class=\"col-md-8 input-group date\"><input type=text ng-model=vm.sku.skuName class=form-control></div></div><div class=col-md-2><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.search()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><!--<input type=\"checkbox\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.isAllSelected\">--></th><th><span translate=distribution.skuNumber></span></th><th><span translate=distribution.skuName></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.sku.resources track by resource.skuId\"><td><input type=radio ng-model=$parent.vm.selectParent name=parentOrganization ng-value=resource></td><td>{{resource.skuNumber}}</td><td>{{resource.skuName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveParent()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div>");
$templateCache.put("app/firmwareUpdate/editChooseSkuForFirmware-dialog.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=distribution.editChooseSku></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-6><label class=\"col-md-6 control-label\" style=padding-top:5px><span translate=distribution.skuName></span>：</label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.sku.skuName class=form-control></div></div><div class=col-md-6><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.search()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><!--<input type=\"checkbox\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.isAllSelected\">--></th><th><span translate=distribution.skuNumber></span></th><th><span translate=distribution.skuName></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.sku.resources track by resource.skuId\"><td><input type=radio ng-model=$parent.vm.selectedEditParent name=parentOrganization ng-value=resource></td><td>{{resource.skuNumber}}</td><td>{{resource.skuName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveEditParent()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button> <!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div>");
$templateCache.put("app/firmwareUpdate/editFirmwareUpdate.html","<style>.toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n  #toast-container {\n    z-index: 99999;\n  }</style><form name=addForm role=form novalidate ng-submit=vm.edit() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=btnTypeName.create></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.SKU></span></label><!--<input type=\"text\" class=\"form-control\" name=\"roldCode\"\n                 ng-model=\"vm.template.skuId\" required\n          />--><div class=input-group><input type=hidden class=form-control name=roleDescription readonly ng-model=vm.template.skuId required> <input type=text class=form-control name=roleDescription readonly ng-model=vm.template.skuName required> <span class=input-group-btn><a class=\"btn btn-default\" type=button ui-sref=firmwareUpdate.editChooseSku() value=templateName><i class=\"fa fa-edit text-navy\"></i></a></span></div></div></div><div class=col-md-6><label class=control-label><span style=color:#f00>*</span><span translate=distribution.hardwareType></span></label><lookup-select lookup-value=vm.template.hardwareType lookup-type=IOT.DVM_MODULE_PART_NUMBER required></lookup-select></div><!--<div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><font color=\"red\">*</font><span translate=\"distribution.SKU\"></span></label>\n          &lt;!&ndash; <input type=\"text\" class=\"form-control\" name=\"roldCode\" ng-click = \"\"\n                  ng-model=\"vm.template.skuId\" required readonly\n           />&ndash;&gt;\n          <div class=\"input-group\">\n            <input type=\"hidden\" class=\"form-control\" name=\"roleDescription\" readonly\n                   ng-model=\"vm.template.skuId\" required/>\n            <input type=\"text\" class=\"form-control\" name=\"roleDescription\" readonly\n                   ng-model=\"vm.template.skuName\" required/>\n            <span class=\"input-group-btn\">\n              <a class=\"btn btn-default\" type=\"button\" ui-sref=\"firmwareUpdate.chooseSku()\" value=\"templateName\"><i class=\"fa fa-edit text-navy\"></i></a>\n            </span>\n          </div>\n        </div>\n      </div>--><!--<div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><font color=\"red\">*</font><span translate=\"firmware.firmwareType\"></span></label>\n          <input type=\"text\" class=\"form-control\"\n                 ng-model=\"vm.template.firmwareType\" required\n          />\n        </div>\n      </div>--></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=firmware.firmwareType></span></label><select ng-model=vm.template.firmwareType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.fireWareTypeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=firmware.firmwareName></span></label><input type=text class=form-control name=roleDescription ng-model=vm.template.firmwareName><!--<select ng-model=\"vm.template.firmwareName\" class=\"form-control\" required>\n            <option ng-repeat=\"x in vm.fireWareNameList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>--></div></div><!-- <div class=\"col-md-6\">\n         <div class=\"form-group\">\n           <label class=\"control-label\"><font color=\"red\">*</font><span translate=\"firmware.firwmareName\"></span></label>\n           &lt;!&ndash;<input type=\"text\" class=\"form-control\" name=\"roldCode\"\n                  ng-model=\"vm.template.templateName\" required\n           />&ndash;&gt;\n           &lt;!&ndash;<input type=\"text\" class=\"form-control\" name=\"roleDescription\" id=\"field_templateName\">&ndash;&gt;\n\n           <select ng-model=\"vm.template.firwmareName\" class=\"form-control\" required>\n             <option ng-repeat=\"x in vm.fireWareNameList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n           </select>\n           &lt;!&ndash;<div class=\"input-group\">\n             <input type=\"text\" class=\"form-control\" name=\"roleDescription\" id=\"field_templateName\"\n                   &lt;!&ndash; ng-model=\"vm.template.firmwareName\"&ndash;&gt;/>\n             <span class=\"input-group-btn\">\n               <button id=\"templateNameBtn\" disabled class=\"btn btn-default\" type=\"button\" ng-click=\"vm.showLocale(\'templateName\')\" value=\"templateName\"><i class=\"fa fa-globe\"></i></button>\n             </span>\n           </div>&ndash;&gt;\n         </div>\n       </div>--><!--<div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><font color=\"red\">*</font><span translate=\"appEdition.download_address\"></span></label>\n          <input type=\"text\" class=\"form-control\" name=\"roleDescription\"\n                 ng-model=\"vm.template.firmwareName\" readonly/>\n          &lt;!&ndash;<select ng-model=\"vm.template.templateType\" class=\"form-control\" required>\n            <option ng-repeat=\"x in vm.templateTypeList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>&ndash;&gt;\n        </div>\n      </div>--></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=distribution.description></span></label><!--<select ng-model=\"vm.template.description\" class=\"form-control\">\n        <option ng-repeat=\"x in vm.roleTypes\" value=\"{{x.value}}\">{{x.meaning}}</option>\n      </select>--><div class=input-group><input type=text class=form-control name=roleDescription id=field_description ng-model=vm.template.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!--<div class=\"modal fade\" id=\"localeModal__templateName2\"\n     style=\"z-index: 2040; position: absolute; display: none;\"\n     data-keyboard=\"false\"><div class=\"modal-dialog\">\n  <div class=\"modal-content\"><div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button>\n  </div>\n    <div class=\"modal-body\" id=\"localeModelBody_templateName\">\n    <div class=\"form-group\"></div>\n    <label class=\"control-label\">English</label><input type=\"text\" class=\"form-control\" name=\"rn_en_GB\" ng-model=\"vm.template.__tls.templateName.en_GB\">\n    <div class=\"form-group\"></div><label class=\"control-label\">泰文</label><input type=\"text\" class=\"form-control\" name=\"rn_th_TH\" ng-model=\"vm.template.__tls.templateName.th_TH\">\n    <div class=\"form-group\"></div><label class=\"control-label\">简体中文</label><input type=\"text\" class=\"form-control\" name=\"rn_zh_CN\" ng-model=\"vm.template.__tls.templateName.zh_CN\">\n    <div class=\"form-group\"></div><label class=\"control-label\">繁体中文</label><input type=\"text\" class=\"form-control\" name=\"rn_zh_HK\" ng-model=\"vm.template.__tls.templateName.zh_HK\">\n  </div>\n    <div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\"><span translate=\"btnTypeName.cancel\"></span></button><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.localeSure()\">\n    <span translate=\"btnTypeName.save\"></span></button>\n    </div>\n  </div>\n</div>\n</div>-->");
$templateCache.put("app/firmwareUpdate/firmwareUpdate.html","<div class=row><alert-error></alert-error></div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=firmware.firmwareManager></h5></div><div class=ibox-content><!--<div class=\"form-group\">\n          <div class=\"row\">\n            <div class=\"col-lg-4\">\n              <label class=\"col-lg-4 control-label\">系统代码</label>\n              <div class=\"col-lg-8\">\n                <input type=\"text\" ng-model=\"vm.header.interfaceCode\" class=\"form-control\">\n              </div>\n            </div>\n            <div class=\"col-lg-4\">\n              <label class=\"col-lg-4 control-label\">系统名称</label>\n              <div class=\"col-lg-8\">\n                <input type=\"text\" ng-model=\"vm.header.name\" class=\"form-control\">\n              </div>\n            </div>\n          </div>\n        </div>--><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=distribution.skuNumber></span></label><div class=col-lg-8><input type=text ng-model=vm.template.skuNumber class=form-control><!--<select ng-model=\"vm.template.skuNumber\" class=\"form-control\" required>\n                    <option value=\"{{x.value}}\"> </option>\n                    <option ng-repeat=\"x in vm.templateTypeList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n                  </select>--><!--<input type=\"text\" ng-model=\"vm.template.templateType\" class=\"form-control\">--></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=firmware.firmwareType></span></label><div class=col-lg-8><select ng-model=vm.template.firmwareType class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.firmwareTypeList\" value={{x.value}}>{{x.meaning}}</option></select><!--<input type=\"text\" ng-model=\"vm.template.firmwareName\" class=\"form-control\">--></div></div><!--<div class=\"col-lg-4\">\n                <label class=\"col-lg-4 control-label\"><span translate=\"distribution.template_name\"></span></label>\n                <div class=\"col-lg-8\">\n                  <input type=\"text\" ng-model=\"vm.template.templateName\" class=\"form-control\">\n                </div>\n              </div>--></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=firmwareUpdateNew translate=btnTypeName.create></a> <a class=\"btn btn-w-m btn-info\" ui-sref=firmwareUpdate.addBatchVersion() translate=firmware.uploadBatchVersion></a></div></div><div class=col-lg-4><div class=\"col-lg-8 m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div><div class=col-lg-4><button class=\"btn bg-primary\" ng-click=vm.changePrivate() translate=firmware.notifyPrivate></button><!-- ui-sref=\"firmwareUpdate.pushFirmware({template:{{template.versionId}}})\"--> <button class=\"btn btn-info\" ui-sref=whitelist translate=firmware.whitelist></button></div></div></div></form><div class=hr-line-dashed></div><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th width=10% translate=btnTypeName.operation></th><th width=15% translate=distribution.SKU></th><th width=20% translate=distribution.skuName></th><th width=15% translate=distribution.hardwareType></th><th width=10% translate=firmware.firmwareType></th><th width=15% translate=firmware.firmwareName></th><th width=15% translate=distribution.description></th></tr></thead><tbody><tr ng-repeat=\"template in vm.templates \" ng-click=\"vm.clickPlan($event, template.firmwareId,template)\"><td><!--<a ui-sref=\"line({headerId:header.headerId})\"><i class=\"fa fa-desktop text-navy\">查看</i></a>--> <a ui-sref=firmwareUpdateEdit({id:template.firmwareId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteTemp(template.firmwareId)><i class=\"fa fa-times text-warning\"><span translate=btnTypeName.del></span></i></a><!--<a ui-sref=\"interfaceAuth({headerId:header.headerId})\" ><i class=\"fa fa-users text-navy\">授权</i></a>--></td><td>{{template.skuNumber}}</td><td>{{template.skuName}}</td><td><span ng-repeat=\"x in vm.hardwareTypes\" ng-if=\"template.hardwareType==x.value\">{{x.meaning}}</span></td><td><span ng-repeat=\"x in vm.firmwareTypeList\" ng-if=\"template.firmwareType==x.value\">{{x.meaning}}</span></td><td>{{template.firmwareName}}<!--<span ng-repeat=\"x in vm.templateTypeList\" ng-if=\"template.firmwareName==x.value\">{{x.meaning}}</span>--></td><td>{{template.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=firmware.version></h5></div><div class=ibox-content><div class=form-group><div class=row><!--<div class=\"col-lg-2\">\n              <div class=\"col-lg-8 pull-right m-t-n-xs\">\n                <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.saveParent()\" translate=\"appEdition.confirm\"></a>\n              </div>\n            </div>--><div class=col-lg-2><div class=\"col-lg-8 pull-right m-t-n-xs\"><!--ui-sref=\"firmwareUpdate.addVersion({id:vm.firmwareIdGlobal})\"--> <a class=\"btn btn-w-m btn-info\" ng-click=vm.judgeRoule(vm.template) translate=firmware.versionAdd></a></div></div></div></div><div class=hr-line-dashed></div><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th translate=firmware.isCurrentVersion></th><th translate=firmware.version></th><th translate=firmware.versionName></th><th translate=firmware.size></th><th translate=firmware.updateDate></th><th translate=firmware.versionDescript></th><th translate=firmware.minimumVersion></th><th translate=firmware.signatureFlag></th><th translate=firmware.isPublic></th><th translate=firmware.action></th></tr></thead><tbody><tr ng-repeat=\"template in vm.templateVersions  track by template.versionId\"><td><input type=radio ng-model=vm.selectParent id=lastFlag ng-value=template></td><!--<a ui-sref=\"interfaceAuth({headerId:header.headerId})\" ><i class=\"fa fa-users text-navy\">授权</i></a>--><td>{{template.versionNumber}}</td><td>{{template.versionName}}</td><td>{{template.versionSize}}MB</td><td>{{template.updateDate}}</td><td>{{template.description}}</td><td>{{template.minimumVersion}}</td><td>{{template.signatureFlag}}</td><td>{{template.isPublic}}</td><td><!--ng-click=\"vm.getProductType(smallPart)\"--><div class=row><button id=notifyPublicBtn{{template.versionId}} class=\"btn bg-primary\" translate=firmware.notifyPublic ng-disabled={{template.isDisable}} ng-click=vm.changePublic(template)></button></div></td></tr></tbody></table></div><div class=text-center><item-count page=vm.pageVersion total=vm.totalItemsVersion items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItemsVersion ng-model=vm.pageVersion ng-change=vm.pageChangedVersion()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/firmwareUpdate/whitelist-dialog.html","<div class=row><alert-error></alert-error></div><div class=row><div class=col-lg-12><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-3 control-label\"><span translate=firmware.account></span></label><div class=col-lg-9><input type=text ng-model=vm.whitelist.userName class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-3 control-label\"><span translate=firmware.address></span></label><div class=col-lg-9><input type=text ng-model=vm.whitelist.location class=form-control></div></div></div></div><div class=form-group><div class=row><div class=\"col-lg-4 col-lg-offset-1\"><a class=\"btn btn-info\" ui-sref=whitelist.addWhitelist><span translate=firmware.addWhitelist></span></a> <a class=\"btn btn-danger\" ng-click=vm.deleteWhitelist()><span translate=btnTypeName.del></span></a></div><div class=col-lg-4></div><div class=\"col-lg-offset-2 col-lg-5\"><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.clear()><span translate=btnTypeName.return></span></button> <button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form></div></div><div class=col-lg-12><div class=ibox-content><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllWhitelist()></th><th><span translate=firmware.account></span></th><th><span translate=firmware.address></span></th><!--<th><span translate=\"firmware.firmwareVersion\"></span></th>--><th><span translate=firmware.isPublic></span></th></tr></thead><tbody><tr ng-repeat=\"whitelist in vm.whitelists\"><!----><td><input type=checkbox name=chk_list class=chk_list value={{whitelist.whiteListId}} ng-click=vm.checkWhitelist()></td><td>{{whitelist.userName}}</td><td>{{whitelist.location}}</td><!--<td>{{whitelist.partyId}}</td>--><td>{{whitelist.isPublic}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div>");
$templateCache.put("app/function/entry-dialog.html","<div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=function.funcResrc></span></h4></div><div class=modal-body><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=btnTypeName.choose></span></th><th><span translate=resource.srcId></span></th><th><span translate=resource.srcName></span></th><th><span translate=resource.srcUrl></span></th><th><span translate=resource.srcType></span></th><th><span translate=resource.srcDec></span></th></tr></thead><tbody><tr><td><input type=radio ng-model=$parent.vm.selectedResource name=functionEnrty ng-value=\"\"></td><td colspan=5><span translate=btnTypeName.noChoose></span></td></tr><tr ng-repeat=\"resource in vm.resources\"><td><input type=radio ng-model=$parent.vm.selectedResource name=functionEnrty ng-value=resource></td><td>{{resource.resourceId}}</td><td>{{resource.name}}</td><td>{{resource.type}}</td><td>{{resource.url}}</td><td>{{resource.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.save()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button></div>");
$templateCache.put("app/function/function-detail.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  .field-required {\n    color: #f00;\n  }</style><div><alert-error></alert-error><h2><span><span translate=function.funcName></span>:{{vm.function.functionName}}</span></h2><div class=ibox-content><form class=form-inline name=functionForm role=form novalidate><div class=row><div class=col-md-6><div class=form-group><label class=\"col-md-4 control-label\"><span class=field-required>*</span><span translate=function.funcName></span></label><div class=col-md-8><div class=input-group><input type=text readonly ng-model=vm.function.functionName class=form-control required> <span class=input-group-btn><button id=funcNameLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showFuncNameLocale() value=functionName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=col-md-6><div class=form-group><label class=\"col-md-4 control-label\"><span class=field-required>*</span><span translate=function.funcCode></span></label><div class=col-md-8><input type=text ng-model=vm.function.functionCode class=form-control required></div></div></div></div><p></p><div class=row><div class=col-md-6><div class=form-group><label class=\"col-md-4 control-label\"><span translate=function.funcDec></span></label><div class=col-md-8><div class=input-group><input type=text readonly ng-model=vm.function.functionDescription class=form-control> <span class=input-group-btn><button id=funcDecLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showFuncDecLocale() value=functionDescription><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=col-md-6><div class=form-group><label class=\"col-md-4 control-label\"><span class=field-required>*</span><span translate=function.funcSeq></span></label><div class=col-md-8><input type=text ng-model=vm.function.functionSequence class=form-control required></div></div></div></div><p></p><div class=row><div class=col-md-6><div class=form-group><label class=\"col-md-4 control-label\"><span translate=function.funcIcon></span></label><div class=col-md-8><input type=text ng-model=vm.function.functionIcon class=form-control></div></div></div><div class=col-md-6 ng-if=\"vm.editOrCreate==\'Edit\'\"><div class=form-group><label class=\"col-md-4 control-label\"><span translate=function.parentFunc></span></label><div class=col-md-8><div class=input-group><input type=text ng-model=vm.function.parentFunctionName class=form-control readonly> <span class=input-group-btn><button type=button ui-sref=function.parent class=\"btn btn-primary glyphicon glyphicon-search\"></button></span></div></div></div></div></div><p></p><div class=row><div class=col-md-6><div class=form-group><label class=\"col-md-5 control-label\"><span class=field-required>*</span><span translate=function.moduleType></span></label><div class=col-md-7><select ng-model=vm.function.moduleCode required class=form-control><option ng-repeat=\"x in vm.moduleTypes\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=col-md-6><div class=form-group ng-if=\"vm.editOrCreate==\'Edit\'\"><label class=\"col-md-4 control-label\"><span translate=function.enterPage></span></label><div class=col-md-8><div class=input-group><input type=text ng-model=vm.function.resourceName class=form-control readonly> <span class=input-group-btn><button type=button ui-sref=function.entry class=\"btn btn-primary glyphicon glyphicon-search\"></button></span></div></div></div></div></div><br><button type=button class=\"btn btn-default\" ng-click=vm.reBack()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-disabled=functionForm.$invalid||vm.isSaving ng-click=vm.saveOrUpdate()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button> <button type=button class=\"btn btn-danger\" ng-disabled=vm.isSaving ng-show=\"vm.editOrCreate==\'Edit\'\" ng-click=vm.remove()><span class=\"glyphicon glyphicon-trash\"></span>&nbsp;<span translate=btnTypeName.del></span></button></form><br><br><div class=ibox-content ng-if=\"vm.editOrCreate==\'Edit\'\"><div class=row><h2><span><span translate=function.funcResrc></span></span></h2></div><br><div class=row><button type=button class=\"btn btn-primary\" ui-sref=function.addResource({id:vm.function.functionId})><span translate=btnTypeName.create></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveFunctionResource()><span translate=btnTypeName.save></span></button> <button type=button class=\"btn btn-danger\" ng-click=vm.deleteFunctionResource()><span translate=btnTypeName.del></span></button></div><br><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox ng-click=vm.toggleAll() ng-model=vm.isAllSelected></th><th><span translate=resource.srcId></span></th><th><span translate=resource.srcName></span></th><th><span translate=resource.srcUrl></span></th><th><span translate=resource.srcType></span></th><th><span translate=resource.srcDec></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.function.resources|filter:vm.isNotDelete\"><td><input type=checkbox ng-model=resource.deleteFlag ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td>{{resource.resourceId}}</td><td>{{resource.name}}</td><td>{{resource.url}}</td><td>{{resource.type}}</td><td>{{resource.description}}</td></tr></tbody></table></div></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=funcNameLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=funcNameLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.funcNameLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=funcDecLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=funcDecLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.funcDecLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/function/function.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div class=row><alert-error></alert-error></div><div class=ibox-title><h5><span translate=function.funcTitle></span></h5></div><div class=ibox-content><div><div class=container-fluid><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=function.funcName></span></label><div class=col-lg-6><input type=text id=name class=form-control ng-model=vm.condition.functionName></div><button class=\"col-lg-3 btn btn-w-m btn-primary\" type=button id=searchBtn ng-click=vm.loadByName()><span translate=btnTypeName.search></span></button></div><div class=col-lg-6><button class=\"btn btn-primary\" ui-sref=function.new><span class=\"glyphicon glyphicon-plus\"></span> <span translate=btnTypeName.create></span></button></div></div></div><br><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=function.funcName></span></th><th><span translate=function.moduleType></span></th><th><span translate=function.funcCode></span></th><th><span translate=function.funcIcon></span></th><th><span translate=function.funcSeq></span></th><th><span translate=function.funcDec></span></th><th><span translate=function.parentFunc></span></th><th><span translate=function.enterPage></span></th></tr></thead><tbody><tr ng-repeat=\"function in vm.functions track by function.functionId\"><td><a ui-sref=function.detail({id:function.functionId})>{{function.functionName}}</a></td><td><select ng-model=function.moduleCode disabled ng-options=\"x.value as x.meaning for x in vm.moduleTypes\"></select></td><td>{{function.functionCode}}</td><td>{{function.functionIcon}}</td><td>{{function.functionSequence}}</td><td>{{function.functionDescription}}</td><td>{{function.parentFunctionName}}</td><td>{{function.resourceName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/function/parent-dialog.html","<div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=title.chooseData></span></h4></div><div class=modal-body><form><div class=form-group><div class=row><div class=col-md-5><label class=\"col-md-3 control-label\"><span translate=function.funcName></span></label><div class=col-md-9><input type=text ng-model=vm.queryFunction.functionName class=form-control></div></div><div class=col-md-5><label class=\"col-md-3 control-label\"><span translate=function.funcCode></span></label><div class=col-md-9><input type=text ng-model=vm.queryFunction.functionCode class=form-control></div></div><div class=col-md-2><button type=button class=\"btn btn-primary\" ng-click=vm.search()><span class=\"glyphicon glyphicon-search\"></span>&nbsp;<span translate=btnTypeName.search></span></button></div></div></div></form><div class=table-responsive><table class=\"table table-striped\" width=70%><thead><tr><th><span translate=btnTypeName.choose></span></th><th><span translate=function.funcName></span></th><th><span translate=function.funcCode></span></th><th><span translate=function.funcDec></span></th></tr></thead><tbody><tr><td><input type=radio ng-model=$parent.vm.selectedFunction name=parentFunction ng-value=\"\"></td><td colspan=3><span translate=btnTypeName.noChoose></span></td></tr><tr ng-repeat=\"function in vm.functions track by function.functionId\"><td><input type=radio ng-model=$parent.vm.selectedFunction name=parentFunction ng-value=function></td><td>{{function.functionName}}</td><td>{{function.functionCode}}</td><td>{{function.functionDescription}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.save()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button></div>");
$templateCache.put("app/function/resource-dialog.html","<div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=function.chooseSrcTitle></span></h4></div><div class=modal-body><form><div class=form-group><div class=row><div class=col-md-6><label class=\"col-md-6 control-label\" style=padding-top:5px><span translate=resource.srcName></span>：</label><div class=\"col-md-6 input-group date\"><input type=text id=name ng-model=vm.condition.name class=form-control></div></div><div class=col-md-6><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.search()></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox ng-click=vm.toggleAll() ng-model=vm.isAllSelected></th><th><span translate=resource.srcName></span></th><th><span translate=resource.srcUrl></span></th><th><span translate=resource.srcType></span></th><th><span translate=resource.srcDec></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.resources track by resource.resourceId\"><td><input type=checkbox ng-model=resource.addFlag ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td>{{resource.name}}</td><td>{{resource.type}}</td><td>{{resource.url}}</td><td>{{resource.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.save()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button></div>");
$templateCache.put("app/guest/guest.html","<div><div class=ibox-title><h2>来宾管理</h2></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">姓名</label><div class=col-lg-8><input type=text id=searchFullName class=form-control ng-model=vm.guest.fullName></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">公司</label><div class=col-lg-8><input type=text id=searchCompanyName class=form-control ng-model=vm.guest.companyName></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">电话</label><div class=col-lg-8><input type=text id=searchCellPhone class=form-control ng-model=vm.guest.cellPhone></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">推荐人</label><div class=col-lg-8><input type=text id=searchInviter class=form-control ng-model=vm.guest.inviter></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">审批人</label><div class=col-lg-8><input type=text id=searchApproveName class=form-control ng-model=vm.guest.approveName></div></div><div class=col-lg-2><label class=\"col-lg-8 control-label\">通过审批</label><div class=col-lg-4><input type=checkbox ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" ng-checked=false id=searchState ng-model=vm.guest.passState></div></div><div class=col-lg-2><label class=\"col-lg-8 control-label\">签到</label><div class=col-lg-4><input type=checkbox ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" ng-checked=false id=searchSign ng-model=vm.guest.sign></div></div><!--<div class=\"col-lg-4\">--><!--<label class=\"col-lg-4 control-label\">汉得员工</label>--><!--<div class=\"col-lg-8\">--><!--<input type=\"checkbox\" value=\"\" id=\"searchIsStaff\" ng-model=\"vm.guest.isStaff\">--><!--</div>--><!--</div>--></div></div><div class=form-group><div class=row><!--<div class=\"col-lg-2\">--><!--<label class=\"col-lg-8 control-label\">注销</label>--><!--<div class=\"col-lg-4\">--><!--<input type=\"checkbox\" value=\"\" id=\"searchStatusCode\" ng-model=\"vm.guest.statusCode\">--><!--</div>--><!--</div>--><div class=col-lg-4><div class=col-lg-8><button class=\"btn btn-white\" type=reset id=searchReset>重置</button> <button class=\"btn btn-w-m btn-primary\" type=button id=searchBtn ng-click=vm.loadSearch()>搜索</button></div></div><div class=col-lg-4><div class=col-lg-8><input type=file ng-model=vm.file ng-change=vm.fishUpload() ngf-select name=imExcel id=imExcel style=\"display: none\"> <button type=button ng-click=\"vm.importExcel(\'imExcel\')\" class=\"btn btn-primary local_btn\">导入Excel</button> <button type=button ng-click=vm.exportExcel() class=\"btn btn-primary local_btn\">导出Excel</button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>操作</th><th>序号</th><!--<th>状态码</th>--><th>性别</th><th>姓名</th><th>电话</th><th>微信号</th><th>邮箱</th><th>签到</th><!--<th>停车位</th>--><th>活动</th><th>员工</th><th>状态</th><th>审批人</th><th>审批时间</th><th>环境</th><th>来源</th><th>流水号</th><th>公司</th><th>职位</th><th>邀请人</th><th>工号</th></tr></thead><tbody><tr ng-repeat=\"guest in vm.guests track by guest.id\"><td><a ng-if=\"guest.passState!=\'Y\'\" ng-click=vm.pass(guest)><i class=\"fa fa-edit text-primary\">审批</i></a> <a ng-if=\"guest.sign!=\'Y\'\" ng-click=vm.sign(guest)><i class=\"fa fa-sign-in text-info\">签到</i></a></td><td ng-bind=$index+1>1</td><!--<td ng-bind=\"guest.statusCode\"></td>--><td ng-bind=guest.gender></td><td ng-bind=guest.fullName></td><td ng-bind=guest.cellPhone></td><td ng-bind=guest.wxopenId></td><td ng-bind=guest.email></td><td ng-bind=guest.sign></td><!--<td ng-bind=\"guest.parkNum\"></td>--><td ng-bind=guest.joinAct></td><td ng-bind=guest.isStaff></td><td ng-bind=guest.passState></td><td ng-bind=guest.approveName></td><td ng-bind=guest.approveDate></td><td ng-bind=guest.equipment></td><td ng-bind=guest.source></td><td ng-bind=guest.sn></td><td ng-bind=guest.companyName></td><td ng-bind=guest.title></td><td ng-bind=guest.inviter></td><td ng-bind=guest.inviterId></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/interfaceAuth/interfaceAuth-dialog.html","<form name=editForm role=form novalidate ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>{{\'appAuth.createAuthorization\' | T}}</h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=authId>{{\'roleManage.roleClient\' | T}}</label><select class=form-control ng-model=vm.interfaceAuth.roleId name=authId id=authId required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.appNames\" value={{x.roleId}}>{{x.roleName}}</option></select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;{{\'btnTypeName.cancel\' | T}}</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;{{\'btnTypeName.save\' | T}}</button></div></form>");
$templateCache.put("app/interfaceAuth/interfaceAuth.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=row><div class=row><alert-error></alert-error></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>{{\'appAuth.authorizationInfo\' | T}}</h5></div><div class=ibox-content><div class=widget-body><button class=\"btn btn-w-m btn-primary\" type=button ui-sref=interfaceAuth.add>{{\'btnTypeName.create\' | T}}</button></div><br><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>{{\'appAuth.index\' | T}}</th><th>{{\'roleManage.roleClient\' | T}}</th><th>{{\'appAuth.authorizationDate\' | T}}</th><th>{{\'btnTypeName.operation\' | T}}</th></tr></thead><tbody><tr ng-repeat=\"interfaceAuth in vm.interfaceAuthes\"><td>{{$index+1}}</td><td>{{interfaceAuth.roleName}}</td><td>{{interfaceAuth.creationDate}}</td><td><a ng-click=vm.delete(interfaceAuth)>{{\'btnTypeName.del\' | T}}</a></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/interfaceTest/interfaceList.html","<div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>接口列表</h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">请求方法</label><div class=col-lg-8><input type=text ng-model=vm.header.requestMethod class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">接口类型</label><div class=col-lg-8><input type=text ng-model=vm.header.interfaceType class=form-control></div></div></div></div><div class=hr-line-dashed></div><div class=form-group><div class=row><div class=col-lg-8></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset id=searchReset>重置</button> <button class=\"btn btn-w-m btn-primary\" type=button>搜索</button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 5%\">序号</th><th style=\"width: 10%\">系统代码</th><th style=\"width: 10%\">接口代码</th><th style=width:10%>接口类型</th><th style=width:10%>请求方式</th><th style=width:10%>请求方法</th><th style=width:20%>系统地址</th><th style=width:15%>接口地址</th><th style=width:5%>测试</th></tr></thead><tbody><tr ng-repeat=\"result in vm.result\"><td>{{$index+1}}</td><td>{{result.interfaceCode}}</td><td>{{result.lineCode}}</td><td>{{result.interfaceType}}</td><td>{{result.requestFormat}}</td><td>{{result.requestMethod}}</td><td>{{result.domainUrl}}</td><td>{{result.iftUrl}}</td><td><a ui-sref=test({lineId:result.lineId})>测试</a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/lang/addLang.html","<style>#toast-container {\n    z-index: 1100;\n  }</style><form name=addForm role=form ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=language.addLangTitle></span></h4></div><div class=modal-body><div class=row><div class=col-md-7><div class=form-group><label class=control-label for=field_langCode><span translate=language.langCode></span></label><input type=text class=form-control name=langCode id=field_langCode ng-model=vm.lang.langCode required></div></div><div class=col-md-7><div class=form-group><label class=control-label for=field_baseLang><span translate=language.baseLang></span></label><input type=text class=form-control name=baseLang id=field_baseLang ng-model=vm.lang.baseLang required></div></div><div class=col-md-7><div class=form-group><label class=control-label for=field_description><span translate=language.langDec></span></label><input type=text class=form-control name=description id=field_description ng-model=vm.lang.description required></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/lang/editLang.html","<form name=editForm role=form novalidate ng-submit=vm.update()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=language.editLangTitle></span></h4></div><div class=modal-body><!--<div class=\"form-group\" ng-show=\"vm.code.codeId\">--><!--<label >ID</label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.code.codeId\" readonly/>--><!--</div>--><div class=row><div class=col-md-7><div class=form-group><label class=control-label for=field_langCode><span translate=language.langCode></span></label><input type=text class=form-control name=langCode id=field_langCode ng-model=vm.lang.langCode required readonly></div></div><div class=col-md-7><div class=form-group><label class=control-label for=field_baseLang><span translate=language.baseLang></span></label><input type=text class=form-control name=baseLang id=field_baseLang ng-model=vm.lang.baseLang required></div></div><div class=col-md-7><div class=form-group><label class=control-label for=field_description><span translate=language.langDec></span></label><input type=text class=form-control name=description id=field_description ng-model=vm.lang.description required></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/lang/lang.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=language.langTitle></span></h5><!--<div class=\"ibox-tools\">\n            <a class=\"collapse-link\">\n              <i class=\"fa fa-chevron-up\"></i>\n            </a>\n            <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n              <i class=\"fa fa-wrench\"></i>\n            </a>\n            <ul class=\"dropdown-menu dropdown-user\">\n              <li><a href=\"#\">Config option 1</a>\n              </li>\n              <li><a href=\"#\">Config option 2</a>\n              </li>\n            </ul>\n            <a class=\"close-link\">\n              <i class=\"fa fa-times\"></i>\n            </a>\n          </div>--></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=language.langCode></span></label><div class=col-lg-8><input type=text ng-model=vm.lang.langCode class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-4 control-label\"><span translate=language.langDec></span></label><div class=col-lg-8><input type=text ng-model=vm.lang.description class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=lang.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 20%\"><span translate=btnTypeName.operation></span></th><th style=\"width: 5%\"><span translate=lookup.number></span></th><th style=\"width: 25%\"><span translate=language.langCode></span></th><th style=\"width: 25%\"><span translate=language.baseLang></span></th><th style=\"width: 25%\"><span translate=language.langDec></span></th></tr></thead><tbody><tr ng-repeat=\"lang in vm.result\"><td><a ui-sref=lang.edit({langCode:lang.langCode})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.delete(lang.langCode)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{$index+1}}</td><td>{{lang.langCode}}</td><td>{{lang.baseLang}}</td><td>{{lang.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/layouts/content.html","<!-- Wrapper--><div id=wrapper><!-- Navigation --><!--<div ng-include=\"\'app/layouts/leftnavbar.html\'\"></div>--><div ui-view=navigation></div><!-- Page wraper --><!-- ng-class with current state name give you the ability to extended customization your view --><div id=page-wrapper class=white-bg><!-- Page wrapper --><!--<div ng-include=\"\'app/layouts/topnavbar.html\'\"></div>--><div ui-view=topnavbar></div><!-- Main view  --><div ui-view=body></div><!-- Footer --><!--<div ng-include=\"\'app/layouts/footer.html\'\"></div>--><div ui-view=footer></div></div><!-- End page wrapper--><!-- Right Sidebar --><div ng-include=\"\'app/layouts/right_sidebar.html\'\"></div></div><!-- End wrapper-->");
$templateCache.put("app/layouts/footer.html","<div class=footer><div><strong>Copyright</strong> KOHLER&copy; 2017</div></div>");
$templateCache.put("app/layouts/right_sidebar.html","<div id=right-sidebar ng-show=rightSidebar class=sidebar-open><div class=sidebar-container full-scroll><ul class=\"nav nav-tabs navs-3\"><li ng-class=\"{active: tab1}\"><a ng-click=\"tab1 = true; tab2 = false; tab3 = false\" ng-init=\"tab1 = true\">Notes </a></li><li ng-class=\"{active: tab2}\"><a ng-click=\"tab2 = true; tab1 = false; tab3 = false\">Projects </a></li><li ng-class=\"{active: tab3}\"><a ng-click=\"tab3 = true; tab1 = false; tab2 = false\"><i class=\"fa fa-gear\"></i> </a></li></ul><div class=tab-content><div class=tab-pane ng-class=\"{active: tab1}\"><div class=sidebar-title><h3><i class=\"fa fa-comments-o\"></i> Latest Notes</h3><small><i class=\"fa fa-tim\"></i> You have 10 new message.</small></div><div><div class=sidebar-message><a href=#><div class=\"pull-left text-center\"><img alt=image class=\"img-circle message-avatar\" src=assets/img/a1.jpg><div class=m-t-xs><i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i></div></div><div class=media-body>There are many variations of passages of Lorem Ipsum available.<br><small class=text-muted>Today 4:21 pm</small></div></a></div><div class=sidebar-message><a href=#><div class=\"pull-left text-center\"><img alt=image class=\"img-circle message-avatar\" src=assets/img/a2.jpg></div><div class=media-body>The point of using Lorem Ipsum is that it has a more-or-less normal.<br><small class=text-muted>Yesterday 2:45 pm</small></div></a></div><div class=sidebar-message><a href=#><div class=\"pull-left text-center\"><img alt=image class=\"img-circle message-avatar\" src=assets/img/a3.jpg><div class=m-t-xs><i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i></div></div><div class=media-body>Mevolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).<br><small class=text-muted>Yesterday 1:10 pm</small></div></a></div><div class=sidebar-message><a href=#><div class=\"pull-left text-center\"><img alt=image class=\"img-circle message-avatar\" src=assets/img/a4.jpg></div><div class=media-body>Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the<br><small class=text-muted>Monday 8:37 pm</small></div></a></div><div class=sidebar-message><a href=#><div class=\"pull-left text-center\"><img alt=image class=\"img-circle message-avatar\" src=assets/img/a8.jpg></div><div class=media-body>All the Lorem Ipsum generators on the Internet tend to repeat.<br><small class=text-muted>Today 4:21 pm</small></div></a></div><div class=sidebar-message><a href=#><div class=\"pull-left text-center\"><img alt=image class=\"img-circle message-avatar\" src=assets/img/a7.jpg></div><div class=media-body>Renaissance. The first line of Lorem Ipsum, \"Lorem ipsum dolor sit amet..\", comes from a line in section 1.10.32.<br><small class=text-muted>Yesterday 2:45 pm</small></div></a></div><div class=sidebar-message><a href=#><div class=\"pull-left text-center\"><img alt=image class=\"img-circle message-avatar\" src=assets/img/a3.jpg><div class=m-t-xs><i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i></div></div><div class=media-body>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below.<br><small class=text-muted>Yesterday 1:10 pm</small></div></a></div><div class=sidebar-message><a href=#><div class=\"pull-left text-center\"><img alt=image class=\"img-circle message-avatar\" src=assets/img/a4.jpg></div><div class=media-body>Uncover many web sites still in their infancy. Various versions have.<br><small class=text-muted>Monday 8:37 pm</small></div></a></div></div></div><div class=tab-pane ng-class=\"{active: tab2}\"><div class=sidebar-title><h3><i class=\"fa fa-cube\"></i> Latest projects</h3><small><i class=\"fa fa-tim\"></i> You have 14 projects. 10 not completed.</small></div><ul class=sidebar-list><li><a href=#><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Business valuation</h4>It is a long established fact that a reader will be distracted.<div class=small>Completion with: 22%</div><div class=\"progress progress-mini\"><div style=\"width: 22%\" class=\"progress-bar progress-bar-warning\"></div></div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li><li><a href=#><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Contract with Company</h4>Many desktop publishing packages and web page editors.<div class=small>Completion with: 48%</div><div class=\"progress progress-mini\"><div style=\"width: 48%\" class=progress-bar></div></div></a></li><li><a href=#><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Meeting</h4>By the readable content of a page when looking at its layout.<div class=small>Completion with: 14%</div><div class=\"progress progress-mini\"><div style=\"width: 14%\" class=\"progress-bar progress-bar-info\"></div></div></a></li><li><a href=#><span class=\"label label-primary pull-right\">NEW</span><h4>The generated</h4><!--<div class=\"small pull-right m-t-xs\">9 hours ago</div>--> There are many variations of passages of Lorem Ipsum available.<div class=small>Completion with: 22%</div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li><li><a href=#><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Business valuation</h4>It is a long established fact that a reader will be distracted.<div class=small>Completion with: 22%</div><div class=\"progress progress-mini\"><div style=\"width: 22%\" class=\"progress-bar progress-bar-warning\"></div></div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li><li><a href=#><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Contract with Company</h4>Many desktop publishing packages and web page editors.<div class=small>Completion with: 48%</div><div class=\"progress progress-mini\"><div style=\"width: 48%\" class=progress-bar></div></div></a></li><li><a href=#><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Meeting</h4>By the readable content of a page when looking at its layout.<div class=small>Completion with: 14%</div><div class=\"progress progress-mini\"><div style=\"width: 14%\" class=\"progress-bar progress-bar-info\"></div></div></a></li><li><a href=#><span class=\"label label-primary pull-right\">NEW</span><h4>The generated</h4><!--<div class=\"small pull-right m-t-xs\">9 hours ago</div>--> There are many variations of passages of Lorem Ipsum available.<div class=small>Completion with: 22%</div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li></ul></div><div class=tab-pane ng-class=\"{active: tab3}\"><div class=sidebar-title><h3><i class=\"fa fa-gears\"></i> Settings</h3><small><i class=\"fa fa-tim\"></i> You have 14 projects. 10 not completed.</small></div><div class=setings-item><span>Show notifications</span><div class=switch><div class=onoffswitch><input type=checkbox name=collapsemenu class=onoffswitch-checkbox id=example><label class=onoffswitch-label for=example><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div><div class=setings-item><span>Disable Chat</span><div class=switch><div class=onoffswitch><input type=checkbox name=collapsemenu checked class=onoffswitch-checkbox id=example2><label class=onoffswitch-label for=example2><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div><div class=setings-item><span>Enable history</span><div class=switch><div class=onoffswitch><input type=checkbox name=collapsemenu class=onoffswitch-checkbox id=example3><label class=onoffswitch-label for=example3><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div><div class=setings-item><span>Show charts</span><div class=switch><div class=onoffswitch><input type=checkbox name=collapsemenu class=onoffswitch-checkbox id=example4><label class=onoffswitch-label for=example4><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div><div class=setings-item><span>Offline users</span><div class=switch><div class=onoffswitch><input type=checkbox checked name=collapsemenu class=onoffswitch-checkbox id=example5><label class=onoffswitch-label for=example5><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div><div class=setings-item><span>Global search</span><div class=switch><div class=onoffswitch><input type=checkbox checked name=collapsemenu class=onoffswitch-checkbox id=example6><label class=onoffswitch-label for=example6><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div><div class=setings-item><span>Update everyday</span><div class=switch><div class=onoffswitch><input type=checkbox name=collapsemenu class=onoffswitch-checkbox id=example7><label class=onoffswitch-label for=example7><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div><div class=sidebar-content><h4>Settings</h4><div class=small>I belive that. Lorem Ipsum is simply dummy text of the printing and typesetting industry. And typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s. Over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</div></div></div></div></div></div>");
$templateCache.put("app/localMaterial/localMaterial.html","<style>.font1 {\n    line-height: 1.6;\n    font-family: \"Helvetica Neue\",\"Hiragino Sans GB\",\"Microsoft YaHei\",\"\\9ED1\\4F53\",Arial,sans-serif;\n    color: #222;\n    font-size: 15px;\n    font-weight: 400;\n  }\n  .ibox-content {\n    background-color: #ffffff;\n    color: inherit;\n    padding: 0 20px 20px 20px;\n    border-color: #e7eaec;\n    border-image: none;\n    border-style: solid solid none;\n    border-width: 1px 0;\n  }\n  .tab_btn {\n    border-radius: 8px;\n    font-size: 12px;\n    margin-right: 20px;\n  }\n  .li_item {\n    position: relative;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    float: left;\n    border: 1px solid #E1E1EC;\n    width: 171px;\n    box-shadow: 0 2px 5px #E1E1EC;\n  }\n\n  .item_name_style {\n    height: 20px;\n    text-align: center;\n    border-top: 1px solid #E1E1EC;\n    overflow: hidden;\n  }\n\n  .item_style {\n    width: 169px;\n    height: 150px;\n  }\n  .article_item_account_name {\n    float: left;\n    width: 100%;\n    min-height: 30px;\n    word-break: break-all;\n    background-color: #f4f5f9;\n    border-top: 1px solid #e7e7eb;\n  }\n  .selected_group{\n    background-color: #f4f5f9;\n  }</style><div class=row><alert-error></alert-error></div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>图片库</h5><!--<div class=\"ibox-tools\">\n            <a class=\"collapse-link\">\n              <i class=\"fa fa-chevron-up\"></i>\n            </a>\n            <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n              <i class=\"fa fa-wrench\"></i>\n            </a>\n            <ul class=\"dropdown-menu dropdown-user\">\n              <li><a href=\"#\">Config option 1</a>\n              </li>\n              <li><a href=\"#\">Config option 2</a>\n              </li>\n            </ul>\n            <a class=\"close-link\">\n              <i class=\"fa fa-times\"></i>\n            </a>\n          </div>--></div><div class=ibox-content style=\"overflow: scroll\"><div style=\"float: left;width: 750px\"><div class=row style=\"padding: 0 0 0 20px;border-bottom: 1px solid #DBDBE4;width: 770px\"><div class=\"checkbox i-checks\" style=\"float: left\"><label><input type=checkbox style=\"cursor: pointer\" ng-model=vm.seletAllFlag ng-click=vm.selectAll()><div style=\"padding-top: 2px\">全选</div></label></div><span style=\"float: left;padding-top: 5px;padding-left: 50px\"><button class=\"btn btn-defualt tab_btn\" ng-disabled=\"vm.selectPictureCount==0\" ng-click=\"vm.moveGroup(\'batch\')\" uib-popover-template=vm.popover.moveGroupUrl popover-placement=right popover-is-open=vm.isBatchMoveGroup>移动分组</button> <button class=\"btn btn-defualt tab_btn\" ng-disabled=\"vm.selectPictureCount==0\" ng-click=vm.batchDeleteAttachement()>删除</button> <button class=\"btn btn-primary tab_btn\" ng-click=vm.localUpLoad()>本地上传</button> <input type=file name=picture id=picture accept=image/* onchange=angular.element(this).scope().vm.upLoadImage() style=\"display: none\"></span></div><div class=row style=\"padding: 15px 0 15px 15px;min-height: 400px\"><div class=li_item style=\"cursor: pointer\" ng-repeat=\"picture in vm.pictures\"><img class=item_style ngf-src=picture.attachmentUrl alt={{picture.attachmentName}}><div class=item_name_style><div class=\"checkbox i-checks\" style=\"text-align: center;margin-top: 0\"><label><input type=checkbox style=\"margin-top: 2px;cursor: pointer\" ng-checked=vm.pictures[$index].selectFlag ng-click=vm.selectPicture($index)> {{picture.attachmentName}}</label></div></div><div class=article_item_account_name><ul style=\"padding-left: 0;list-style-type: none\"><li style=\"width: 33.33%;float: left;text-align: center\"><a ng-click=vm.editName($index) uib-popover-template=vm.popover.editNameUrl popover-placement=right popover-is-open=picture.isEditName><img ng-src=assets/images/localMaterial/edit.png></a></li><li style=\"width: 33.33%;float: left;text-align: center\"><a ng-click=vm.moveGroup($index) uib-popover-template=vm.popover.moveGroupUrl popover-placement=right popover-is-open=picture.isMoveGroup><img ng-src=assets/images/localMaterial/move.png></a></li><li style=\"width: 33.33%;float: left;text-align: center\"><a ng-click=vm.deleteAttachement(picture.attachmentId)><img ng-src=assets/images/localMaterial/delete.png></a></li></ul></div></div></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div><div style=\"width:190px;min-height: 600px;float: left;border-left: 1px solid #DBDBE4;border-right: 1px solid #DBDBE4\"><div ng-repeat=\"item in vm.groupData\"><div ng-class=\"{true:\'selected_group\',false:\'\'}[item.id==vm.currentGroup]\"><a class=font1 id={{item.id}} style=\"margin: 0 20px\" ng-click=vm.selectedGroup(item.id)>{{item.groupName}}({{item.attachmentCount}})</a></div></div><div style=\"padding: 5px 20px\"><a uib-popover-template=vm.popover.createGroupUrl popover-placement=bottom popover-is-open=vm.isCreateGroup class=font1 type=button>+新建分组</a></div></div></div><script type=text/ng-template id=createGroup.html><div>创建分组</div>\n        <div class=\"form-group\">\n          <input type=\"text\" ng-model=\"vm.groupName\" class=\"form-control\" maxlength=\"30\">\n        </div>\n        <div class=\"form-group\" style=\"text-align: center;\">\n          <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.groupName==undefined || vm.groupName==\'\'\" ng-click=\"vm.addGroup()\">确定</button>\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.closeAddGroup()\">取消</button>\n        </div></script><script type=text/ng-template id=editName.html><div style=\"width: 200px;height: 100px;\">\n          <div>编辑名称</div>\n          <div class=\"form-group\">\n            <input type=\"text\" ng-model=\"vm.newPictureName\" class=\"form-control\" maxlength=\"20\">\n          </div>\n          <div class=\"form-group\" style=\"text-align: center;\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.newPictureName==undefined || vm.newPictureName==\'\'\" ng-click=\"vm.confirmEditName()\">确定</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.editNameClose()\">取消</button>\n          </div>\n        </div></script><script type=text/ng-template id=moveGroup.html><div style=\"width: 150px;\" style=\"text-align: center;\">\n          <div class=\"radio\"  style=\"padding-left: 20px;\" ng-repeat=\"group in vm.groupData\">\n            <label>\n              <input type=\"radio\" ng-model=\"vm.selectRadio\" value=\"{{group.id}}\">\n              {{group.groupName}}\n            </label>\n          </div>\n\n          <div class=\"form-group\" style=\"text-align: center;\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-if=\"vm.isBatchMoveGroup\" ng-disabled=\"vm.selectRadio==undefined || vm.selectRadio==\'\'\" ng-click=\"vm.batchMoveGroup()\">确定</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.isBatchMoveGroup\" ng-click=\"vm.moveGroupClose()\">取消</button>\n\n            <button type=\"button\" class=\"btn btn-primary\" ng-if=\"vm.isBatchMoveGroup==undefined || vm.isBatchMoveGroup==false\" ng-disabled=\"vm.selectRadio==undefined || vm.selectRadio==\'\'\" ng-click=\"vm.confrimMoveGroup()\">确定</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.isBatchMoveGroup==undefined || vm.isBatchMoveGroup==false\" ng-click=\"vm.moveGroupClose()\">取消</button>\n          </div>\n        </div></script></div></div></div>");
$templateCache.put("app/menu/addVersion.html","<form name=addForm role=form ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>新增菜单版本</h4></div><div class=modal-body><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName>版本号</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=field_appName ng-model=vm.menuVersion.menuVersion required ng-disabled=vm.noEdit></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName>版本描述</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menuVersion.menuDesc required ng-disabled=vm.noEdit></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName>菜单资源</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menuVersion.menuResource required ng-disabled=vm.noEdit></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName>资源目录</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menuVersion.menuLocalPath ng-required=vm.typeFlag ng-disabled=vm.noEdit></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName>目标路径</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menuVersion.menuDestPath ng-required=vm.typeFlag></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\" style=\"width: 35%\"><permission-selector permission-data=vm.permissionData></permission-selector></div></div><div class=\"row col-md-offset-4\"><div class=col-md-3><label><input type=checkbox ng-model=vm.menuVersion.showConer ngtruevalue=Y ngfalsevalue=N ng-disabled=vm.noEdit>&nbsp;&nbsp;显示角标<br></label></div><div class=col-md-3 style=\"margin-left: -50px\"><label><input type=checkbox ng-model=vm.menuVersion.isSilenceUpdate ngtruevalue=Y ngfalsevalue=N ng-disabled=vm.noEdit>&nbsp;&nbsp;静默更新<br></label></div><div class=col-md-3 style=\"margin-left: -50px\"><label><input type=checkbox ng-model=vm.menuVersion.isForceUpdate ngtruevalue=Y ngfalsevalue=N ng-disabled=vm.noEdit>&nbsp;&nbsp;强制更新<br></label></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;关闭</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button><div class=pull-left ng-if=vm.showButton><input type=file name=zip id=zip ng-model=vm.zip accept=application/zip onchange=angular.element(this).scope().vm.upFile() style=\"display: none\"> <a ng-disabled=\"vm.menuVersion.menuVersion!=null || vm.menuVersion.menuDesc!=null || vm.menuVersion.menuResource!=null || vm.menuVersion.menuLocalPath!=null\" style=\"margin-left: 250%\" class=\"btn btn-w-m btn-info\" ng-click=\"vm.menuVersion.menuVersion!=null || vm.menuVersion.menuDesc!=null || vm.menuVersion.menuResource!=null || vm.menuVersion.menuLocalPath!=null || vm.localUpLoad(\'zip\')\">导入资源包</a></div></div></form>");
$templateCache.put("app/menu/menu-detail.html","<style>span {\n    font-size: 15px;\n  }\n\n  .menu-bcackground {\n    background-color: #f3f3f4;\n    width: 80%;\n    margin: 0 auto;\n  }\n\n  .menu-bcackground-selected {\n    background-color: #eaeaea;\n    width: 80%;\n    margin: 0 auto;\n  }\n  div{\n    outline:none;\n  }\n\n  .border {\n    border-bottom: 1px solid #c8cacd;\n    position: relative;\n    left: 26%;\n    width: 53%;\n  }</style><form name=addForm role=form><div class=modal-header><alert-error></alert-error><button type=button class=close aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionspan>菜单详细信息</h4></div><!--<div class=\"modal-body\"\n       ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'oldFile\' || vm.ischecked==\'oldFile\']\"\n       ng-mouseenter=\"vm.mouseIn = \'oldFile\'\">\n    <div class=\"row\" ng-click=\"vm.check(\'oldFile\')\">\n      <div class=\"col-md-offset-2 col-md-8\">\n        <div class=\"col-md-4\" style=\"margin-top: 4%;\">\n          <span class=\"control-span\">菜单Logo</span>\n        </div>\n        <div class=\"col-md-8\">\n          <div ng-if=\"vm.ischecked==\'oldFile\'\">\n            <input ng-model=\"vm.file\" ng-change=\"vm.changeFile()\" ngf-select accept=\"image/*\" name=\"file\" size=\"1\"\n                   style=\"position:absolute;opacity:0;z-index:100;cursor:pointer;width:80px;height:80px;\" type=\"file\">\n          </div>\n          <div>\n            <img style=\"width:80px;height:80px\" ngf-src=\"vm.menu.menuIcon\">\n          </div>\n          <div ng-if=\"vm.ischecked==\'oldFile\'\">\n            <div>\n              建议上传图片尺寸为640x640，大小不超过5M。\n            </div>\n            <br/>\n\n            <div class=\"border\" style=\"left: 0\"></div>\n            <br/>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.nocheck($event)\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消\n            </button>\n            <button type=\"button\" ng-click=\"vm.submitFile()\" class=\"btn btn-primary\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存\n            </button>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-1\">\n        <a><i class=\"fa fa-edit text-navy\">编辑</i></a>\n      </div>\n    </div>\n  </div>--><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'oldFile\' || vm.ischecked==\'oldFile\']\" ng-mouseenter=\"vm.mouseIn = \'oldFile\'\"><div class=row ng-click=\"vm.check(\'oldFile\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>菜单Logo</span></div><div class=col-md-8><div ng-if=\"vm.ischecked==\'oldFile\'\"><input ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/* name=file size=1 style=position:absolute;opacity:0;z-index:100;cursor:pointer;width:80px;height:80px type=file></div><div><img style=width:80px;height:80px ngf-src=vm.oldFile></div><div ng-if=\"vm.ischecked==\'oldFile\'\"><div>建议上传图片尺寸为640x640，大小不超过5M。</div><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button ng-click=vm.submitFile() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div><div class=col-md-1><a><i class=\"fa fa-edit text-navy\">编辑</i></a></div></div></div><div class=border></div><!--  <div class=\"modal-body\"\n       ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'appId\']\"\n       ng-mouseenter=\"vm.mouseIn=\'appId\'\">\n    <div class=\"row\">\n      <div class=\"col-md-offset-2 col-md-8\">\n        <div class=\"col-md-4\">\n          <span class=\"control-span\">菜单名称</span>\n        </div>\n        <div class=\"col-md-8\">\n          <span class=\"control-span\">{{vm.menu.menuName}}</span>\n        </div>\n      </div>\n    </div>\n  </div>--><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'menuName\']\" ng-mouseenter=\"vm.mouseIn=\'menuName\'\"><div class=row ng-click=\"vm.check(\'menuName\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>菜单名称</span></div><div class=col-md-6><span class=control-span ng-if=\"vm.ischecked!=\'menuName\'\">{{vm.menu.menuName}}</span><div ng-if=\"vm.ischecked==\'menuName\'\"><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menu.menuName required><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\">编辑</i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'appSecret\' || vm.ischecked==\'appSecret\']\" ng-mouseenter=\"vm.mouseIn=\'appSecret\'\"><div class=row ng-click=\"vm.check(\'menuType\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>菜单类型</span></div><div class=col-md-6><!--<span ng-if=\"vm.ischecked!=\'menuType\'\" class=\"control-span\">{{vm.menu.menuType}}</span>--><div><div><label class=radio-inline><input type=radio name=chickenEgg value=ONLINE ng-model=vm.menu.menuType required> 在线</label><label class=radio-inline><input type=radio name=chickenEgg value=LOCAL ng-model=vm.menu.menuType required> 本地</label><label class=radio-inline><input type=radio name=chickenEgg value=NATIVE ng-model=vm.menu.menuType required> 原生</label></div><br><div ng-if=\"vm.ischecked==\'menuType\'\"><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\">编辑</i></a></div><!--<div class=\"col-md-1\" ng-click=\"vm.refreshSecret()\">\n        <a><i class=\"fa fa-edit text-navy\">刷新</i></a>\n      </div>--></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'menuDesc\']\" ng-mouseenter=\"vm.mouseIn=\'menuDesc\'\"><div class=row ng-click=\"vm.check(\'menuDesc\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>功能介绍</span></div><div class=col-md-6><span class=control-span ng-if=\"vm.ischecked!=\'menuDesc\'\">{{vm.menu.menuDesc}}</span><div ng-if=\"vm.ischecked==\'menuDesc\'\"><textarea ng-model=vm.menu.menuDesc class=form-control rows=3 required></textarea><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\">编辑</i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'categoryId\']\" ng-mouseenter=\"vm.mouseIn=\'categoryId\'\"><div class=row ng-click=\"vm.check(\'categoryId\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>菜单类别</span></div><div class=col-md-6><span class=control-span><select ng-model=vm.menu.categoryId class=form-control><option ng-repeat=\"x in vm.categoryList\" value={{x.id}}>{{x.categoryName}}</option></select></span><div ng-if=\"vm.ischecked==\'categoryId\'\"><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\">编辑</i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'menuSeq\']\" ng-mouseenter=\"vm.mouseIn=\'menuSeq\'\"><div class=row ng-click=\"vm.check(\'menuSeq\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>菜单序号</span></div><div class=col-md-6><span class=control-span ng-if=\"vm.ischecked!=\'menuSeq\'\">{{vm.menu.menuSeq}}</span><div ng-if=\"vm.ischecked==\'menuSeq\'\"><input type=number class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menu.menuSeq required><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\">编辑</i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'permission\' || vm.ischecked==\'permission\']\" ng-mouseenter=\"vm.mouseIn=\'permission\'\"><div class=row ng-click=\"vm.check(\'permission\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>可见范围</span></div><div class=col-md-6><div ng-if=\"vm.ischecked!=\'permission\'\"><div class=\"multiple-select-box form-control ui-select-container ui-select-multiple ui-select-bootstrap m-b text-left\" readonly><span class=\"ui-select-match-item btn btn-default btn-xs\" draggable=true aria-disabled=false ng-repeat=\"data in vm.permissionData\"><i class={{data.dataIcon}}></i>{{data.dataValue}}</span></div></div><div ng-if=\"vm.ischecked==\'permission\'\"><permission-selector permission-data=vm.permissionData></permission-selector><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button ng-click=vm.savePermission() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\">编辑</i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'isMandatory\' || vm.ischecked==\'isMandatory\']\" ng-mouseenter=\"vm.mouseIn = \'isMandatory\'\"><div class=row ng-click=\"vm.check(\'isMandatory\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>是否必选</span></div><div class=col-md-6 ng-if=\"vm.ischecked!=\'isMandatory\'\"><label><input type=checkbox ng-model=vm.menu.isMandatory ngtruevalue=Y ngfalsevalue=N onclick=\"return false\"></label></div><div ng-if=\"vm.ischecked==\'isMandatory\'\"><input type=checkbox ng-model=vm.menu.isMandatory ngtruevalue=Y ngfalsevalue=N style=\"margin-left: 15px\">&nbsp;&nbsp;<br><br><div class=border style=\"left: 35%;width: 17%\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event) style=\"margin-left: 35%\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div><!--<div class=\"col-md-offset-4 col-md-4\">\n        <label><input type=\"checkbox\" ng-model=\"vm.menu.isMandatory\" ngTrueValue=\"Y\" ngFalseValue=\"N\">&nbsp;&nbsp;是否必选<br></label>\n      </div>--></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'status\' || vm.ischecked==\'status\']\" ng-mouseenter=\"vm.mouseIn = \'status\'\"><div class=row ng-click=\"vm.check(\'status\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span>禁用</span></div><div class=col-md-6 ng-if=\"vm.ischecked!=\'status\'\"><label><input type=checkbox ng-model=vm.menu.status ngtruevalue=Y ngfalsevalue=N onclick=\"return false\"></label></div><div ng-if=\"vm.ischecked==\'status\'\"><input type=checkbox ng-model=vm.menu.status ngtruevalue=Y ngfalsevalue=N style=\"margin-left: 15px\">&nbsp;&nbsp;<br><br><div class=border style=\"left: 35%;width: 17%\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event) style=\"margin-left: 35%\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div><!--<div class=\"col-md-offset-4 col-md-4\">\n        <label><input type=\"checkbox\" ng-model=\"vm.menu.isMandatory\" ngTrueValue=\"Y\" ngFalseValue=\"N\">&nbsp;&nbsp;是否必选<br></label>\n      </div>--></div></div><table border=1 style=\"width: 53%;margin-left: 26%\"><tr style=\"height: 40px\"><th>版本号</th><th>更新日期</th><th>操作</th></tr><tr style=\"height: 40px\" ng-repeat=\"menuV in vm.menuVersions\"><td>{{menuV.menuVersion}}</td><!--<td>{{menuV.serviceNumber}}</td>--><td>{{menuV.creationDate}}</td><td><a ui-sref=menu.showVersion({id:menuV.id})><i class=\"fa fa-edit text-navy\">查看</i></a> <a ng-click=vm.deleteVersion(menuV.id)><i class=\"fa fa-times text-navy\">删除</i></a></td></tr></table><a style=\"margin-left: 32%;margin-top: 1%\" class=\"btn btn-w-m btn-info\" ui-sref=menu.addVersion({id:vm.menu.id})>新增</a></form>");
$templateCache.put("app/menu/menu-new.html","<form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>新建菜单配置</h4></div><div class=modal-body><div class=row style=text-align:center><div style=text-align:center><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/* required name=file size=1 style=\"left:calc(50% - 60px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile></div><div>建议上传图片尺寸为640x640，大小不超过5M。</div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div>开始上传</div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><input type=hidden class=form-control ng-model=vm.menu.Id><label class=control-label for=field_appName>菜单名称</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=field_appName ng-model=vm.menu.menuName required></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label>功能介绍</label><!--<input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appType\"\n                  ng-model=\"vm.menu.menuDesc\" required>--><textarea ng-model=vm.menu.menuDesc class=form-control rows=3 required></textarea></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label>菜单类别</label><select ng-model=vm.menu.categoryId class=form-control><option ng-repeat=\"x in vm.categoryList\" value={{x.id}}>{{x.categoryName}}</option></select></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName>菜单序号</label><input type=number class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menu.menuSeq required></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label>菜单类型</label><div><label class=radio-inline><input type=radio name=chickenEgg value=ONLINE ng-model=vm.menu.menuType required> 在线</label><label class=radio-inline><input type=radio name=chickenEgg value=LOCAL ng-model=vm.menu.menuType required> 本地</label><label class=radio-inline><input type=radio name=chickenEgg value=NATIVE ng-model=vm.menu.menuType required> 原生</label></div></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\" style=\"width: 40%\"><permission-selector permission-data=vm.permissionData></permission-selector></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><label><input type=checkbox ng-model=vm.menu.isMandatory ngtruevalue=Y ngfalsevalue=N ng-readonly=true>&nbsp;&nbsp;是否必选<br></label><!--        <label class=\"checkbox-inline\">\n          <input type=\"checkbox\" ng-model=\"vm.menu.isMandatory\">\n          是否必选\n        </label>--></div></div></div><div class=modal-footer style=text-align:center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;提交</button></div></form>");
$templateCache.put("app/menu/menu.html","<style>.item {\n    float: left;\n    margin-bottom: 10px;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 48px 6px 20px;\n    position: relative;\n    text-align: center;\n    width: 100px;\n  }\n  .item_add {\n    height: 80px;\n    left: 50%;\n    margin: -40px 0 0 -40px;\n    padding: 0;\n    position: absolute;\n    top: 50%;\n    width: 80px;\n  }\n  .new_app_btn {\n    color: #777;\n    margin: 86px auto 0;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>菜单配置</h5></div><div class=ibox-content><div><select ng-change=vm.loadAll(vm.menu) ng-model=vm.menu.appId class=form-control style=\"width: 30%;float: right;background-color: azure\"><option ng-repeat=\"x in vm.appList\" value={{x.appId}}>{{x.appName}}</option></select><span style=\"float: right;font-size: large;margin-top: 4px;margin-right: 5px\">获取客户端菜单:</span></div><div><div class=row><span class=col-md-12 ng-if=\"vm.result.length>0\">在线菜单</span></div><div class=row><div ng-if=\"menu.menuType==\'ONLINE\' && menu.status==\'N\'\" class=item ng-repeat=\"menu in vm.result\"><a ui-sref=menu.detail({id:menu.id})><!--ui-sref=\"menu.detail({id:menu.id})\"--> <img style=width:80px;height:80px ng-src={{menu.menuIcon}} class=img_logo></a><h3 class=name><span class=mod-apptype_icon-message title=在线菜单></span> {{menu.menuName}}</h3></div></div></div><div><div class=row><span class=col-md-12 ng-if=\"vm.result.length>0\">本地菜单</span></div><div class=row><div ng-if=\"menu.menuType==\'LOCAL\' && menu.status==\'N\'\" class=item ng-repeat=\"menu in vm.result\"><a ui-sref=menu.detail({id:menu.id})><img style=width:80px;height:80px ng-src={{menu.menuIcon}} class=img_logo></a><h3 class=name><span class=mod-apptype_icon-message title=本地菜单></span> {{menu.menuName}}</h3></div></div></div><div><div class=row><span class=col-md-12 ng-if=\"vm.result.length>0\">原生菜单</span></div><div class=row><div ng-if=\"menu.menuType==\'NATIVE\' && menu.status==\'N\'\" class=item ng-repeat=\"menu in vm.result\"><a ui-sref=menu.detail({id:menu.id})><img style=width:80px;height:80px ng-src={{menu.menuIcon}} class=img_logo></a><h3 class=name><span class=mod-apptype_icon-message title=原生菜单></span> {{menu.menuName}}</h3></div></div></div><div><div class=row><span class=col-md-12 ng-if=\"vm.result.length>0\">已禁用菜单</span></div><div class=row><div ng-if=\"menu.status==\'Y\'\" class=item ng-repeat=\"menu in vm.result\"><a ui-sref=menu.detail({id:menu.id})><img style=width:80px;height:80px ng-src={{menu.menuIcon}} class=img_logo></a><h3 class=name><span class=mod-apptype_icon-message title=原生菜单></span> {{menu.menuName}}</h3></div></div></div><div class=row><div class=item style=\"left: 11px\"><a class=item_add ui-sref=menu.newMenu({appId:vm.menu.appId}) title=创建菜单><img style=width:80px;height:80px ng-src={{vm.uploadPic}} class=img_logo></a><div class=new_app_btn>新建菜单</div></div></div></div></div></div></div>");
$templateCache.put("app/menu/showVersion.html","<form name=editForm role=form novalidate ng-submit=vm.update()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>查看菜单版本</h4></div><div class=modal-body><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName>版本号</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=field_appName ng-model=vm.version.menuVersion readonly></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><input type=hidden class=form-control ng-model=vm.menu.Id><label class=control-label for=field_appName>版本描述</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.version.menuDesc readonly></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><input type=hidden class=form-control ng-model=vm.menu.Id><label class=control-label for=field_appName>菜单资源</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.version.menuResource readonly></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName>资源目录</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.version.menuLocalPath readonly></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName>目标路径</label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.version.menuDestPath readonly></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><!--<div class=\"col-md-2\">\n          <span class=\"control-span\">可见范围</span>\n        </div>--><label class=control-label for=field_appName>可见范围</label><!--<div class=\"col-md-9\">--><!--<div ng-if=\"vm.ischecked!=\'permission\'\">--><div class=\"multiple-select-box form-control ui-select-container ui-select-multiple ui-select-bootstrap m-b text-left\" readonly><span class=\"ui-select-match-item btn btn-default btn-xs\" draggable=true aria-disabled=false ng-repeat=\"data in vm.permissionData\"><i class={{data.dataIcon}}></i>{{data.dataValue}}</span></div><!--</div>--><!--<div ng-if=\"vm.ischecked==\'permission\'\">\n            <permission-selector permission-data=\"vm.permissionData\"></permission-selector>\n            <br/>\n\n            <div class=\"border\" style=\"left: 0\"></div>\n            <br/>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.nocheck($event)\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消\n            </button>\n            <button type=\"button\" ng-click=\"vm.savePermission()\" class=\"btn btn-primary\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存\n            </button>\n          </div>--><!--</div>--></div><!--      <div class=\"col-md-1\">\n              <a><i class=\"fa fa-edit text-navy\">编辑</i></a>\n            </div>--></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><label><input type=checkbox ng-model=vm.version.showConer ngtruevalue=Y ngfalsevalue=N onclick=\"return false\">&nbsp;&nbsp;显示角标<br></label></div><div class=col-md-3 style=\"margin-left: -200px\"><label><input type=checkbox ng-model=vm.version.isSilenceUpdate ngtruevalue=Y ngfalsevalue=N onclick=\"return false\">&nbsp;&nbsp;静默更新<br></label></div><div class=col-md-3 style=\"margin-left: -120px\"><label><input type=checkbox ng-model=vm.version.isForceUpdate ngtruevalue=Y ngfalsevalue=N onclick=\"return false\">&nbsp;&nbsp;强制更新<br></label></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button><!--<button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">\n      <span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存\n    </button>--></div></form>");
$templateCache.put("app/menuUsage/menuUsage.html","<style>.item {\n    float: left;\n    margin-bottom: 10px;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 48px 6px 20px;\n    position: relative;\n    text-align: center;\n    width: 100px;\n  }\n  .item_add {\n    height: 80px;\n    left: 50%;\n    margin: -40px 0 0 -40px;\n    padding: 0;\n    position: absolute;\n    top: 50%;\n    width: 80px;\n  }\n  .new_app_btn {\n    color: #777;\n    margin: 86px auto 0;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>菜单使用分析</h5></div><div class=ibox-content><div><div class=row><span class=col-md-12 ng-if=\"vm.result.length>0\">菜单列表</span></div><div class=row><div class=item ng-repeat=\"menu in vm.result\"><a ui-sref=menuUsage.showChart({id:menu.id})><img style=width:80px;height:80px ng-src={{menu.menuIcon}} class=img_logo></a><h3 class=name><span class=mod-apptype_icon-message></span> {{menu.menuName}}</h3></div></div></div></div></div></div></div>");
$templateCache.put("app/menuUsage/showCharts.html","<style>.item {\n    float: left;\n    margin-bottom: 10px;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 48px 6px 20px;\n    position: relative;\n    text-align: center;\n    width: 100px;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><div class=row><div class=item><a><img style=width:80px;height:80px ng-src={{vm.charts[vm.charts.length-1].menuIcon}} class=img_logo></a><h3 class=name><span class=mod-apptype_icon-message></span> {{vm.charts[vm.charts.length-1].menuName}}</h3></div></div><div class=ibox-tools>菜单统计<!--<a class=\"collapse-link\">\n            <i class=\"fa fa-chevron-up\"></i>\n          </a>\n          <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n            <i class=\"fa fa-wrench\"></i>\n          </a>\n          <ul class=\"dropdown-menu dropdown-user\">\n            <li><a href=\"#\">Config option 1</a>\n            </li>\n            <li><a href=\"#\">Config option 2</a>\n            </li>\n          </ul>\n          <a class=\"close-link\">\n            <i class=\"fa fa-times\"></i>\n          </a>--></div></div><div class=ibox-content><div style=\"width: 100%;height: 36px;font-size: large;background-color: aliceblue\">今日关键指标</div><div><div style=\"background-color: azure;width: 159px;height: 29px;font-size: initial;margin-top: 10px;margin-left: 90px;margin-bottom: 10px\">使用菜单总次数{{vm.countUser}}人</div><div class=col-md-5><div class=\"col-md-offset-2 col-md-10 input-group date\" style=\"display: -webkit-box\"><button class=\"btn btn-white\" type=button ng-click=vm.load(vm.menuId,7)>7天</button> <button class=\"btn btn-white\" type=button ng-click=vm.load(vm.menuId,14) style=\"margin-left: -3px\">14天</button> <button class=\"btn btn-white\" type=button ng-click=vm.load(vm.menuId,30) style=\"margin-left: -3px\">30天</button><p class=input-group style=\"width: 59%\"><input type=text class=form-control uib-datepicker-popup name=startDate ng-model=vm.queryDate.startDate required datepicker-options=vm.dateOptions is-open=vm.isStartOpen1 style=\"margin-left: 10px\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.startOpen1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><p style=\"margin-top: 2%;margin-left: 2%\">至</p><p class=input-group style=\"width: 59%\"><input type=text class=form-control uib-datepicker-popup name=endDate ng-model=vm.queryDate.endDate required datepicker-options=vm.dateOptions is-open=vm.isStartOpen2 style=\"margin-left: 10px\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.startOpen2()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><button class=btn type=button ng-click=vm.load(vm.menuId,100) style=\"margin-left: -3px\">查询</button></div></div><div style=\"width: 1289px;height: 644px\"><canvas id=line class=\"chart chart-line\" chart-data=vm.data chart-labels=vm.labels chart-series=vm.series chart-options=vm.options chart-dataset-override=vm.datasetOverride chart-click=vm.onClick></canvas></div></div></div></div></div></div>");
$templateCache.put("app/messageCenter/messageCenter.html","<style>.font {\n    line-height: 1.6;\n    font-family: \"Helvetica Neue\",\"Hiragino Sans GB\",\"Microsoft YaHei\",\"\\9ED1\\4F53\",Arial,sans-serif;\n    color: #222;\n    font-size: 14px;\n    font-weight: 400;\n  }</style><div class=row><alert-error></alert-error></div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=distribution.dp></h5><!--<div class=\"ibox-tools\">\n            <a class=\"collapse-link\">\n              <i class=\"fa fa-chevron-up\"></i>\n            </a>\n            <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n              <i class=\"fa fa-wrench\"></i>\n            </a>\n            <ul class=\"dropdown-menu dropdown-user\">\n              <li><a href=\"#\">Config option 1</a>\n              </li>\n              <li><a href=\"#\">Config option 2</a>\n              </li>\n            </ul>\n            <a class=\"close-link\">\n              <i class=\"fa fa-times\"></i>\n            </a>\n          </div>--></div><!--<div class=\"hr-line-dashed\"></div>--><div class=ibox-content style=\"font-size: 14px\"><form class=form-horizontal name=editForm role=form novalidate ng-submit=vm.sendMessage()><div class=form-group><div class=row><div class=col-lg-8><label class=\"col-lg-4 control-label\" translate=distribution.push_type></label><div class=col-lg-8><select class=form-control ng-model=vm.pushMethod required><option value=jPush>Jpush</option><option value=sms translate=distribution.message></option><option value=email translate=distribution.email></option></select><!--<lookup-select lookup-value=\"vm.pushMethod\" lookup-type=\"HMS.MESSAGE.TYPE\"></lookup-select>--></div></div><div class=col-lg-4></div></div></div><br><div class=form-group><div class=row><div class=col-lg-8><label class=\"col-lg-4 control-label\" translate=distribution.push_object></label><div class=col-lg-8 ng-if=\"vm.pushMethod==\'jPush\'\"><!-- <label class=\"radio-inline\">\n                      <input type=\"radio\" name=\"jpushType\" ng-model=\"vm.jpushType\" value=\"all\"> 所有人\n                    </label>--><label class=radio-inline><input type=radio name=jpushType ng-model=vm.jpushType value=tag> <span translate=distribution.device_tag></span></label><label class=radio-inline><input type=radio name=jpushType ng-model=vm.jpushType value=alias> <span translate=distribution.device_alias></span></label><label class=radio-inline><input type=radio name=jpushType ng-model=vm.jpushType value=registration> <span translate=distribution.registration_id></span></label></div><div class=col-lg-8 ng-if=\"vm.pushMethod!=\'jPush\'\"><!--                    <input type=\"text\" ng-model=\"vm.sendObject\" required\n                           ng-attr-placeholder=\"{{vm.pushMethod==\'sms\'?\'输入手机号码,以逗号分隔\':\n                           vm.pushMethod==\'email\'?\'输入邮箱,以逗号分隔\':\'\'}}\" class=\"form-control\">--> <input type=text ng-model=vm.sendObject required ng-attr-placeholder=\"{{vm.pushMethod==\'sms\'?vm.sms_placeholde:\n                          vm.pushMethod==\'email\'? vm.email_placeholder:\'\'}}\" class=form-control></div></div><div class=col-lg-4></div></div><div class=row ng-if=\"vm.pushMethod==\'jPush\'\"><div class=col-lg-8><label class=\"col-lg-4 control-label\"></label><div class=col-lg-8><div style=\"padding-top: 10px\" ng-if=\"vm.jpushType==\'all\'\" translate=distribution.jpushType_all></div><div ng-if=\"vm.jpushType!=\'all\'\"><!--                           <input type=\"text\" style=\"margin-top: 10px;\" ng-model=\"vm.sendObject\"  required\n                                  ng-attr-placeholder=\"{{vm.jpushType==\'tag\'?\'输入标签,以逗号分隔\':\n                                  vm.jpushType==\'alias\'?\'输入别名,以逗号分隔\':vm.jpushType==\'registration\'?\'输入Registration ID,以逗号分隔\':\'\'}}\" class=\"form-control\">--> <input type=text style=\"margin-top: 10px\" ng-model=vm.sendObject required ng-attr-placeholder=\"{{vm.jpushType==\'tag\'?vm.tag_placeholde:\n                                  vm.jpushType==\'alias\'?vm.alias_placeholde:vm.jpushType==\'registration\'?vm.registration_placeholde:\'\'}}\" class=form-control></div></div></div><div class=col-lg-4></div></div></div><br><div class=form-group><div class=row><div class=col-lg-8><label class=\"col-lg-4 control-label\" translate=distribution.message_template></label><div class=col-lg-8><select class=form-control ng-model=vm.messageTemplateIndex required><option value=\"\" ng-show=false></option><option ng-repeat=\"template in vm.templates[vm.pushMethod]\" value={{$index}}>{{template.title}}</option></select></div></div><div class=col-lg-4></div></div></div><br><div class=form-group><div class=row><div class=col-lg-8><label class=\"col-lg-4 control-label\" translate=distribution.request_content></label><template-content content={{vm.templates[vm.pushMethod][vm.messageTemplateIndex].content}} content-var=vm.contentVar></template-content></div><div class=col-lg-4></div></div></div><br><div class=form-group><div class=row><div class=col-lg-8><label class=\"col-lg-4 control-label\" translate=distribution.response_content></label><div class=col-lg-8><textarea ng-model=vm.retMsg rows=10 cols=20 class=form-control ng-disabled=true></textarea></div></div><div class=col-lg-4></div></div></div><br><div class=form-group><div class=row><div class=col-lg-8><div class=\"col-lg-8 pull-right m-t-n-xs\"><button type=submit ng-disabled=\"editForm.$invalid || vm.isSending\" class=\"btn btn-w-m btn-info\" translate=distribution.send></button></div></div><div class=col-lg-4></div></div></div></form></div></div></div></div>");
$templateCache.put("app/messageTemplate/addMessageTemplate.html","<style>.toast-container {\n    z-index: 99999;\n  }\n\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n\n  #toast-container {\n    z-index: 99999;\n  }</style><form name=addForm role=form novalidate ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=btnTypeName.create></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=dvmSku.productName></span></label><!-- <input type=\"text\" class=\"form-control\" name=\"roldCode\" ng-click = \"\"\n                 ng-model=\"vm.template.skuId\" required readonly\n          />--><div class=input-group><input type=hidden class=form-control name=roleDescription readonly ng-model=vm.template.productId> <input type=text class=form-control name=roleDescription readonly ng-model=vm.template.productName> <span class=input-group-btn><a class=\"btn btn-default\" type=button ui-sref=messageTemplate.chooseSku() value=templateName><i class=\"fa fa-edit text-navy\"></i></a></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.message_template_code></span></label><input type=text class=form-control ng-model=vm.template.templateCode required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.template_name></span></label><!--<input type=\"text\" class=\"form-control\" name=\"roldCode\"\n                 ng-model=\"vm.template.templateName\" required\n          />--><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateName ng-model=vm.template.templateName readonly> <span class=input-group-btn><button id=templateNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'templateName\')\" value=templateName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.template_type></span></label><select ng-model=vm.template.templateType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.templateTypeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.message_template_content></span></label><!--<input type=\"text\" class=\"form-control\"\n                 ng-model=\"vm.template.templateContent\" required\n          />--><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateContent ng-model=vm.template.templateContent required readonly> <span class=input-group-btn><button id=templateContentBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'templateContent\')\" value=templateContent><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.message_template_malfunctionLeve></span></label><select ng-model=vm.template.malfunctionLeve class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.malfunctionLeveList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=distribution.description></span></label><!--<select ng-model=\"vm.template.description\" class=\"form-control\">\n            <option ng-repeat=\"x in vm.roleTypes\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>--><div class=input-group><input type=text class=form-control name=roleDescription id=field_description ng-model=vm.template.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=distribution.linkAddress></span></label><!--<select ng-model=\"vm.template.description\" class=\"form-control\">\n            <option ng-repeat=\"x in vm.roleTypes\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>--><div class=input-group><input type=text class=form-control name=linkAddress ng-model=vm.template.linkAddress readonly> <span class=input-group-btn><button id=linkAddressBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'linkAddress\')\" value=linkAddress><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_templateContent style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_templateContent></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'templateContent\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_templateName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_templateName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'templateName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_linkAddress style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_linkAddress></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'linkAddress\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!--<div class=\"modal fade\" id=\"localeModal__templateName2\"\n     style=\"z-index: 2040; position: absolute; display: none;\"\n     data-keyboard=\"false\"><div class=\"modal-dialog\">\n  <div class=\"modal-content\"><div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button>\n  </div>\n    <div class=\"modal-body\" id=\"localeModelBody_templateName\">\n    <div class=\"form-group\"></div>\n    <label class=\"control-label\">English</label><input type=\"text\" class=\"form-control\" name=\"rn_en_GB\" ng-model=\"vm.template.__tls.templateName.en_GB\">\n    <div class=\"form-group\"></div><label class=\"control-label\">泰文</label><input type=\"text\" class=\"form-control\" name=\"rn_th_TH\" ng-model=\"vm.template.__tls.templateName.th_TH\">\n    <div class=\"form-group\"></div><label class=\"control-label\">简体中文</label><input type=\"text\" class=\"form-control\" name=\"rn_zh_CN\" ng-model=\"vm.template.__tls.templateName.zh_CN\">\n    <div class=\"form-group\"></div><label class=\"control-label\">繁体中文</label><input type=\"text\" class=\"form-control\" name=\"rn_zh_HK\" ng-model=\"vm.template.__tls.templateName.zh_HK\">\n  </div>\n    <div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\"><span translate=\"btnTypeName.cancel\"></span></button><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.localeSure()\">\n    <span translate=\"btnTypeName.save\"></span></button>\n    </div>\n  </div>\n</div>\n</div>-->");
$templateCache.put("app/messageTemplate/chooseSku-dialog.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=distribution.chooseProduct></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-6><label class=\"col-md-6 control-label\" style=padding-top:5px><span translate=dvmSku.productName></span>：</label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.sku.productName class=form-control></div></div><div class=col-md-6><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.search()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><!--<input type=\"checkbox\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.isAllSelected\">--></th><th><span translate=command.productCode></span></th><th><span translate=dvmSku.productName></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.sku.resources track by resource.productId\"><td><input type=radio ng-model=$parent.vm.selectParent name=parentOrganization ng-value=resource></td><td>{{resource.productCode}}</td><td>{{resource.productName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveParent()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div>");
$templateCache.put("app/messageTemplate/editChooseSku-dialog.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=distribution.chooseProduct></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-6><label class=\"col-md-6 control-label\" style=padding-top:5px><span translate=dvmSku.productName></span>：</label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.sku.productName class=form-control></div></div><div class=col-md-6><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.search()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><!--<input type=\"checkbox\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.isAllSelected\">--></th><th><span translate=command.productCode></span></th><th><span translate=dvmSku.productName></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.sku.resources track by resource.productId\"><td><input type=radio ng-model=$parent.vm.selectedEditParent name=parentOrganization ng-value=resource></td><td>{{resource.productCode}}</td><td>{{resource.productName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveEditParent()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button> <!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div>");
$templateCache.put("app/messageTemplate/editMessageTemplate.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.edit()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=btnTypeName.edit></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=dvmSku.productName></span></label><!--<input type=\"text\" class=\"form-control\" name=\"roldCode\"\n                 ng-model=\"vm.template.skuId\" required\n          />--><div class=input-group><input type=hidden class=form-control name=roleDescription readonly ng-model=vm.template.productId> <input type=text class=form-control name=roleDescription readonly ng-model=vm.template.productName> <span class=input-group-btn><a class=\"btn btn-default\" type=button ui-sref=messageTemplate.editChooseSku() value=templateName><i class=\"fa fa-edit text-navy\"></i></a></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.message_template_code></span></label><input type=text class=form-control required ng-model=vm.template.templateCode></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.template_name></span></label><!--<input type=\"text\" class=\"form-control\" name=\"roldCode\"\n                 ng-model=\"vm.template.templateName\" required\n          />--><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateName ng-model=vm.template.templateName readonly> <span class=input-group-btn><button id=templateNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'templateName\')\" value=templateName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.template_type></span></label><select ng-model=vm.template.templateType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.templateTypeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.message_template_content></span></label><!--<input type=\"text\" class=\"form-control\"\n                 ng-model=\"vm.template.templateContent\" required\n          />--><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateContent ng-model=vm.template.templateContent readonly> <span class=input-group-btn><button id=templateContentBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'templateContent\')\" value=templateContent><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=distribution.message_template_malfunctionLeve></span></label><select ng-model=vm.template.malfunctionLeve class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.malfunctionLeveList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=distribution.description></span></label><!--<select ng-model=\"vm.template.description\" class=\"form-control\">\n            <option ng-repeat=\"x in vm.roleTypes\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>--><div class=input-group><input type=text class=form-control name=roleDescription id=field_description ng-model=vm.template.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=distribution.linkAddress></span></label><!--<select ng-model=\"vm.template.description\" class=\"form-control\">\n            <option ng-repeat=\"x in vm.roleTypes\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>--><div class=input-group><input type=text class=form-control name=linkAddress ng-model=vm.template.linkAddress readonly> <span class=input-group-btn><button id=linkAddressBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'linkAddress\')\" value=linkAddress><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_templateContent style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_templateContent></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'templateContent\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_templateName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_templateName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'templateName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_linkAddress style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_linkAddress></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'linkAddress\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!--<div class=\"modal fade\" id=\"localeModal__templateName2\"\n     style=\"z-index: 2040; position: absolute; display: none;\"\n     data-keyboard=\"false\"><div class=\"modal-dialog\">\n  <div class=\"modal-content\"><div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button>\n  </div>\n    <div class=\"modal-body\" id=\"localeModelBody_templateName\">\n    <div class=\"form-group\"></div>\n    <label class=\"control-label\">English</label><input type=\"text\" class=\"form-control\" name=\"rn_en_GB\" ng-model=\"vm.template.__tls.templateName.en_GB\">\n    <div class=\"form-group\"></div><label class=\"control-label\">泰文</label><input type=\"text\" class=\"form-control\" name=\"rn_th_TH\" ng-model=\"vm.template.__tls.templateName.th_TH\">\n    <div class=\"form-group\"></div><label class=\"control-label\">简体中文</label><input type=\"text\" class=\"form-control\" name=\"rn_zh_CN\" ng-model=\"vm.template.__tls.templateName.zh_CN\">\n    <div class=\"form-group\"></div><label class=\"control-label\">繁体中文</label><input type=\"text\" class=\"form-control\" name=\"rn_zh_HK\" ng-model=\"vm.template.__tls.templateName.zh_HK\">\n  </div>\n    <div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\"><span translate=\"btnTypeName.cancel\"></span></button><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.localeSure()\">\n    <span translate=\"btnTypeName.save\"></span></button>\n    </div>\n  </div>\n</div>\n</div>-->");
$templateCache.put("app/messageTemplate/messageTemplate.html","<div class=row><alert-error></alert-error></div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=distribution.message_templates></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=distribution.template_type></span></label><div class=col-lg-8><select ng-model=vm.template.templateType class=form-control required><option value={{x.value}}></option><option ng-repeat=\"x in vm.templateTypeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=distribution.message_template_code></span></label><div class=col-lg-8><input type=text ng-model=vm.template.templateCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=distribution.message_template_malfunctionLeve></span></label><div class=col-lg-8><select ng-model=vm.template.malfunctionLeve class=form-control required><option value={{x.value}}></option><option ng-repeat=\"x in vm.malfunctionLeveList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=distribution.template_name></span></label><div class=col-lg-8><input type=text ng-model=vm.template.templateName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmSku.productName></span></label><div class=col-lg-8><input type=text ng-model=vm.template.productName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=messageTemplateNew translate=btnTypeName.create></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=hr-line-dashed></div><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th width=10% translate=btnTypeName.operation></th><th width=20% translate=distribution.message_template_code></th><th width=20% translate=distribution.message_template_content></th><th width=10% translate=distribution.template_type></th><th width=20% translate=distribution.template_name></th><th width=10% translate=distribution.description></th><th width=10% translate=dvmSku.productName></th></tr></thead><tbody><tr ng-repeat=\"template in vm.templates \"><td><!--<a ui-sref=\"line({headerId:header.headerId})\"><i class=\"fa fa-desktop text-navy\">查看</i></a>--> <a ui-sref=messageTemplateEdit({id:template.templateId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteTemp(template.templateId)><i class=\"fa fa-times text-warning\"><span translate=btnTypeName.del></span></i></a><!--<a ui-sref=\"interfaceAuth({headerId:header.headerId})\" ><i class=\"fa fa-users text-navy\">授权</i></a>--></td><td style=width:150px;word-wrap:break-word;max-width:100px>{{template.templateCode}}</td><td>{{template.templateContent}}</td><td>{{template.templateType}}</td><td>{{template.templateName}}</td><td>{{template.description}}</td><td>{{template.productName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/metrics/metrics.html","<div style=overflow:auto><h2>Application Metrics</h2><p><button type=button class=\"btn btn-primary\" ng-click=vm.refresh()><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class=row ng-hide=vm.updatingMetrics><div class=col-md-4><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=0 max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=success><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=0 max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=success><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=0 max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=success><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=col-md-4><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=hand ng-click=vm.refreshThreadDumpData() data-toggle=modal data-target=#threadDump><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=0 value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=success><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=0 value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=warning><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=0 value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=warning><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=0 value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=success><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=col-md-4><b>Garbage collections</b><div class=row><div class=col-md-9>Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=row><div class=col-md-9>Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=row><div class=col-md-9>Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=row><div class=col-md-9>Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=vm.updatingMetrics>Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>Code</th><th>Count</th><th class=text-right>Mean</th><th class=text-right><span>Average</span> (1 min)</th><th class=text-right><span>Average</span> (5 min)</th><th class=text-right><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min=0 max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=success><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min=0 max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=success><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min=0 max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=success><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=text-right>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>Service name</th><th class=text-right>Count</th><th class=text-right>Mean</th><th class=text-right>Min</th><th class=text-right>p50</th><th class=text-right>p75</th><th class=text-right>p95</th><th class=text-right>p99</th><th class=text-right>Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.metrics.timers\"><td>{{k}}</td><td class=text-right>{{v.count}}</td><td class=text-right>{{v.mean * 1000 | number:0}}</td><td class=text-right>{{v.min * 1000 | number:0}}</td><td class=text-right>{{v.p50 * 1000 | number:0}}</td><td class=text-right>{{v.p75 * 1000 | number:0}}</td><td class=text-right>{{v.p95 * 1000 | number:0}}</td><td class=text-right>{{v.p99 * 1000 | number:0}}</td><td class=text-right>{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=table-responsive ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=text-right>Count</th><th class=text-right>Mean</th><th class=text-right>Min</th><th class=text-right>p50</th><th class=text-right>p75</th><th class=text-right>p95</th><th class=text-right>p99</th><th class=text-right>Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=0 max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=success><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=text-right>{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=text-right>{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=text-right>{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=text-right>{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=text-right>{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=text-right>{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=text-right>{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=text-right>{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=modal-header><button type=button class=close ng-click=vm.cancel()>&times;</button><h4 class=modal-title>Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=badge>{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=badge>{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=badge>{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=badge>{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=badge>{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=voffset2>&nbsp;</div>Filter <input type=text ng-model=threadDumpFilter class=form-control><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=label ng-class=vm.getLabelClass(v.threadState)>{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=!show>Show StackTrace</span> <span ng-show=show>Hide StackTrace</span></a></h5><div class=well ng-show=show><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=voffset1></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=text-right>Blocked Time</th><th class=text-right>Blocked Count</th><th class=text-right>Waited Time</th><th class=text-right>Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=modal-footer><button type=button class=\"btn btn-default pull-left\" data-dismiss=modal ng-click=vm.cancel()>Done</button></div>");
$templateCache.put("app/modifyPwd/modifyPwd.html","<div class=row><alert-error></alert-error></div><div class=ibox-title><h5><span translate=password.pswdModifyTitle></span></h5><!--<div class=\"ibox-tools\">\n    <a class=\"collapse-link\">\n      <i class=\"fa fa-chevron-up\"></i>\n    </a>\n    <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n      <i class=\"fa fa-wrench\"></i>\n    </a>\n    <ul class=\"dropdown-menu dropdown-user\">\n      <li><a href=\"#\">Config option 1</a>\n      </li>\n      <li><a href=\"#\">Config option 2</a>\n      </li>\n    </ul>\n    <a class=\"close-link\">\n      <i class=\"fa fa-times\"></i>\n    </a>\n  </div>--></div><div class=ibox-content><form class=form-horizontal name=form ng-submit=vm.modifyPwd()><!--<div class=\"form-group\">\n          <div class=\"row\">\n            <div class=\"col-lg-6\">\n              <label class=\"col-lg-4 control-label\"><span translate=\"password.srcPswd\"></span></label>\n              <div class=\"col-lg-8\">\n                  <input type=\"password\" class=\"form-control\" ng-model=\"vm.oldPwd\" required />\n              </div>\n            </div>\n            <div class=\"col-lg-6\">\n            </div>\n          </div>\n        </div>--><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\"><span translate=password.newPswd></span></label><div class=col-lg-8><input id=pwdInput type=password class=form-control ng-model=vm.newPwd required placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" ng-pattern=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/ ></div></div><div class=col-lg-6></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\"><span translate=password.confirmPswd></span></label><div class=col-lg-8><input id=pwdInputConfirm type=password class=form-control ng-model=vm.reNewPwd required placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" ng-pattern=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/ ></div></div><div class=col-lg-6></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\"></label><div class=col-lg-8><button type=submit ng-disabled=form.$invalid class=\"btn btn-primary\"><span translate=btnTypeName.save></span></button> <button type=button ng-click=vm.showOrHidePwd() class=\"btn btn-warning\"><span ng-if=vm.showPwdEnabled translate=btnTypeName.showPwd></span> <span ng-if=!vm.showPwdEnabled translate=btnTypeName.hidePwd></span></button></div></div></div></div></form></div>");
$templateCache.put("app/moduleFirmware/addGroups.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addGroup()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span>{{ vm.group.groupId ? \'编辑hwpn\' : \'新增hwpn\' }}</span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>hwpn</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.group.hwpn required autocomplete=off ng-readonly=vm.skuCodeReadOnly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>hwpn名称</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.group.hwpnName required autocomplete=off ng-readonly=vm.skuCodeReadOnly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span>说明</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.group.note></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/moduleFirmware/addModuleFirmware.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addFirmware()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span>{{vm.sku.id ? \'模块固件管理-\' + vm.sku.hwpnName +\'-编辑固件\' : \'模块固件管理-\' + vm.sku.hwpnName +\'-新增固件\'}}</span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><!-- <label class=\"control-label\" for=\"field_skuCode\"><span style=\"color: red\">*</span><span >导入配置文件</span></label> --><div class=input-group><input type=file accept=application/json name=configModuleFiles id=configModuleFiles ng-model=vm.configModuleFiles onchange=angular.element(this).scope().vm.upConfigModuleFiles(this) style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span>导入配置文件</span></a></div></div></div><div class=col-md-6><div class=form-group style=position:relative><!-- <label class=\"control-label\" for=\"field_skuCode\"><span style=\"color: red\">*</span><span >导入资源包</span></label> --><div><input type=file name=moduleResourceFile id=moduleResourceFile ng-model=vm.moduleResourceFile onchange=angular.element(this).scope().vm.upModuleResourceFile(this) style=\"opacity: 0; position: absolute; z-index: -1; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\" ng-click=vm.verifyData()><span ng-if=!vm.btnStatus>导入资源包</span><span ng-if=vm.btnStatus>重新上传</span></a> <span ng-if=vm.btnStatus style=\"color:red;position: absolute;right: 10px;top: 50%;transform: translateY(-50%)\">:资源包已导入</span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级包版本号</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.firmwareVersion required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级包名称</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.firmwareName required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级组件名称(组件号+组件名称)</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.component required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>part号+part名称</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.part required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>分包大小(KB)</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.subPackageSize required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>下载地址最大长度</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.downloadUrlType required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>是否为必升版本</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.forceUpdate required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>是否静默下载</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.isSilentDownload required ng-readonly=vm.readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>升级包优先级(数字越小优先级越高)</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.priority required ng-readonly=vm.readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span>包下载到那里</span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.config.downloadLocation required ng-readonly=vm.readonly></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/moduleFirmware/lookModuleFirmwareList.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  table td {\n    max-width: 300px;\n    word-wrap: break-word;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  table td:hover {\n    white-space: normal;\n    overflow: auto;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span>{{ \'模块固件管理-\'+ vm.sku.hwpnName + \'-历史固件列表\' }}</span></h5></div><div class=ibox-content><!-- <form class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-lg-4\">\n                  <label class=\"col-lg-4 control-label\"><span >组件号</span></label>\n                  <div class=\"col-lg-8\">\n                    <input type=\"text\" ng-model=\"vm.sku.componentNumber\" class=\"form-control\">\n                  </div>\n                </div>\n                <div class=\"col-lg-4\">\n                  <label class=\"col-lg-4 control-label\"><span >part号</span></label>\n                  <div class=\"col-lg-8\">\n                    <input type=\"text\" ng-model=\"vm.sku.partNumber\" class=\"form-control\">\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-lg-4\"></div>\n                <div class=\"col-lg-4\"></div>\n                <div class=\"col-lg-4\">\n                  <div class=\"col-lg-8 pull-right m-t-n-xs\">\n                    <button class=\"btn btn-white\" type=\"reset\" ng-click=\"vm.resetSku()\"><span translate=\"btnTypeName.reset\"></span></button>\n                    <button class=\"btn btn-w-m btn-primary\" type=\"button\" ng-click=\"vm.search()\"><span translate=\"btnTypeName.search\"></span></button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </form> --><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><!-- <th><span translate=\"btnTypeName.operation\"></span></th> --><th><span>升级组件号</span></th><th><span>升级组件名称</span></th><th><span>升级组件part号</span></th><th><span>升级组件part名称</span></th><th><span>版本</span></th><th><span>优先级</span></th><th><span>大小</span></th><th><span>更新日期</span></th><th><span>更新人(账号)</span></th><th><span>配置文件</span></th><th><span>动作</span></th></tr></thead><tbody style=\"border-top: none\"><tr ng-repeat=\"item in vm.firmwareList track by $index\"><!-- <td> --><!-- <a ui-sref=\"deviceFirmware.firmwareListEdit({id: 123})\"><i class=\"fa fa-edit text-navy\"><span translate=\"btnTypeName.edit\"></span></i></a>\n                    <a ui-sref=\"deviceFirmware.edit({groupId: vm.sku.groupId})\"><i class=\"fa fa-eye text-navy\">查看历史版本</i></a>\n                    <a ng-click=\"vm.deleteSku(sku)\"><i class=\"fa fa-times text-navy\"><span translate=\"btnTypeName.del\"></span></i></a> --><!-- </td> --><td>{{item.componentNumber}}</td><td>{{item.componentName}}</td><td>{{item.partNumber}}</td><td>{{item.partName}}</td><td>{{item.versionNumber}}</td><td>{{item.priority}}</td><td>{{item.versionSize}}</td><td>{{item.lastUpdateDate}}</td><td>{{item.partyName}}</td><td>{{item.configurationFile}}</td><td><div><button id=moduleNotifyPublicBtn{{item.firmwareId}} class=\"btn bg-primary\" translate=firmware.notifyPublic ng-disabled=\"{{item.isPublic==\'Y\'}}\" ng-click=vm.changePublic(item)></button></div></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/moduleFirmware/moduleFirmware.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  .table tr {\n    display: flex;\n  }\n\n  .table tr td,\n  .table tr th {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n  }\n\n  .sweet-alert p {\n    color: #797979;\n    font-size: 16px;\n    text-align: center;\n    font-weight: 300;\n    position: relative;\n    text-align: inherit;\n    float: none;\n    margin: 0;\n    padding: 0;\n    word-wrap: break-word;\n    line-height: normal;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><!-- <h5><span translate=\"deviceFirmware.deviceFirmware\"></span></h5> --><h5><span>模块固件管理</span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span>hwpn</span></label><div class=col-lg-8><input type=text ng-model=vm.hwpn.hwpn class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span>hwpn名称</span></label><div class=col-lg-8><input type=text ng-model=vm.hwpn.hwpnName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><!-- <div class=\"col-lg-4 pull-right m-t-n-xs\">\n                    <button class=\"btn btn-w-m btn-danger\" ng-click=\"vm.deleteSkus()\"><span translate=\"btnTypeName.del\"></span></button>\n                  </div> --><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=moduleFirmware.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetSku()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=\"margin-top:40px; overflow: auto\"><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span>hwpn</span></th><th><span>hwpn名称</span></th><th><span>说明</span></th></tr></thead><tbody style=\"border-top: none\"><tr ng-repeat=\"sku in vm.skus track by $index\"><td><a ui-sref=\"moduleFirmware.edit({groupId: sku.groupId, hwpn: sku.hwpnNumber, hwpnName: sku.hwpnName, note: sku.note})\"><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ui-sref=\"moduleFirmware.info({groupId: sku.groupId, hwpnName: sku.hwpnName})\"><i class=\"fa fa-eye text-navy\" translate=btnTypeName.view></i></a> <a ng-click=vm.deleteSku(sku)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td title={{sku.hwpnNumber}}>{{sku.hwpnNumber}}</td><td title={{sku.hwpnName}}>{{sku.hwpnName}}</td><td title={{sku.note}}>{{sku.note}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/moduleFirmware/moduleFirmwareList.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  table td {\n    max-width: 200px;\n    word-wrap: break-word;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  table td::-webkit-scrollbar {\n    display: none;\n  }\n\n  table td:hover {\n    white-space: normal;\n    overflow: auto;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span>{{ \'模块固件管理-\'+ vm.sku.hwpnName }}</span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span>组件号</span></label><div class=col-lg-8><input type=text ng-model=vm.sku.componentNumber class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span>part号</span></label><div class=col-lg-8><input type=text ng-model=vm.sku.partNumber class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=\"moduleFirmware.addFirmware({groupId: vm.sku.groupId, hwpnName: vm.sku.hwpnName})\"><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetSku()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><p style=\"margin: 8px 0;color: red\">当前最新固件信息：</p><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span>升级组件号</span></th><th><span>升级组件名称</span></th><th><span>升级组件part号</span></th><th><span>升级组件part名称</span></th><th><span>版本</span></th><th><span>优先级</span></th><th><span>大小</span></th><th><span>更新日期</span></th><th><span>更新人(账号)</span></th><th><span>配置文件</span></th><th><span>动作</span></th></tr></thead><tbody style=\"border-top: none\"><tr ng-repeat=\"item in vm.firmwareList track by $index\"><td><a ui-sref=\"moduleFirmware.editFirmware({id: item.firmwareId, configurationFile: item.configurationFile, groupId: vm.sku.groupId, hwpnName: vm.sku.hwpnName})\"><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ui-sref=\"moduleFirmware.lookFirmwareList({id: vm.sku.groupId, hwpnName: vm.sku.hwpnName, componentNumber: item.componentNumber, partNumber: item.partNumber })\"><i class=\"fa fa-eye text-navy\">查看历史版本</i></a> <a ng-click=vm.deleteSku(item)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{item.componentNumber}}</td><td>{{item.componentName}}</td><td>{{item.partNumber}}</td><td>{{item.partName}}</td><td>{{item.versionNumber}}</td><td>{{item.priority}}</td><td>{{item.versionSize}}</td><td>{{item.lastUpdateDate}}</td><td>{{item.partyName}}</td><td>{{item.configurationFile}}</td><td><div><button id=notifyPublicBtn{{item.firmwareId}} class=\"btn bg-primary\" translate=firmware.notifyPublic ng-disabled=\"item.isPublic==\'Y\'\" ng-click=vm.changePublic(item)></button></div></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/preferences/preferences.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>首选项设置</h5><!-- <div class=\"ibox-tools\">\n            <a class=\"collapse-link\">\n              <i class=\"fa fa-chevron-up\"></i>\n            </a>\n            <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n              <i class=\"fa fa-wrench\"></i>\n            </a>\n            <ul class=\"dropdown-menu dropdown-user\">\n              <li><a href=\"#\">Config option 1</a>\n              </li>\n              <li><a href=\"#\">Config option 2</a>\n              </li>\n            </ul>\n            <a class=\"close-link\">\n              <i class=\"fa fa-times\"></i>\n            </a>\n          </div>--></div><div class=ibox-content><form class=form-horizontal><div class=row><div class=\"col-md-6 options_div\" value=timeZone><label class=control-label>时区</label><select class=form-control ng-model=vm.timeZone.preferencesValue><option ng-repeat=\"tz in vm.timezones\" value={{tz.value}}>{{tz.meaning}}</option></select></div></div><div class=row><div class=\"col-md-6 options_div\" value=locale><label class=control-label>语言</label><select class=form-control ng-model=vm.locale.preferencesValue><option ng-repeat=\"tz in vm.locales\" value={{tz.value}}>{{tz.meaning}}</option></select></div></div></form></div><div class=ibox-footer><button type=button class=\"btn btn-primary\" ng-click=vm.saveData()><span class=\"glyphicon glyphicon-save\"></span>保存</button><!--<button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.getCode()\">\n            <span class=\"glyphicon glyphicon-save\"></span>测试时区\n          </button>--></div></div></div></div></div>");
$templateCache.put("app/prompt/prompt-dialog.html","<form name=editForm role=form novalidate ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=prompt.createOrEditPrompt></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=promptCode>*<span translate=prompt.code></span></label><input type=text class=form-control name=promptCode id=promptCode ng-model=vm.prompt.promptCode required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=lang>*<span translate=prompt.lang></span></label><!--<input type=\"text\" class=\"form-control\" name=\"lang\" id=\"lang\"--><!--ng-model=\"vm.prompt.lang\"/>--><select class=form-control ng-model=vm.prompt.lang name=lang id=lang required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.langValue\" value={{x.langCode}}>{{x.description}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=description><span translate=prompt.dec></span></label><input type=text class=form-control name=description id=description ng-model=vm.prompt.description></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/prompt/promptIndex.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><!--<div class=\"wrapper wrapper-content animated fadeInRight\">\n  <div class=\"row\">--><div class=row><alert-error></alert-error></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=prompt.promptTitle></span></h5></div><div class=ibox-content><div class=widget-body><div><form><div class=row><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px><span translate=prompt.code></span></label><div class=\"col-md-9 input-group date\"><input type=text translate-attr=\"{placeholder : \'sysConfig.fuzzyQuery\'}\" ng-model=vm.searchPrompt.promptCode class=form-control></div></div><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px><span translate=prompt.lang></span></label><div class=\"col-md-9 input-group date\"><select class=form-control ng-model=vm.searchPrompt.lang><option ng-repeat=\"x in vm.langValue\" value={{x.langCode}}>{{x.description}}</option></select></div></div></div><br><div class=row><div class=col-md-5><label class=\"col-md-3 control-label\" style=padding-top:5px><span translate=prompt.dec></span></label><div class=\"col-md-9 input-group date\"><input type=text translate-attr=\"{placeholder : \'sysConfig.fuzzyQuery\'}\" ng-model=vm.searchPrompt.description class=form-control></div></div><div class=col-md-5><div class=\"col-md-offset-3 col-md-9\"><button class=\"btn btn-white\" type=button ng-click=vm.clear()><span translate=btnTypeName.reset></span></button> <button type=submit class=\"btn btn-w-m btn-primary\" ng-click=vm.search()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ui-sref=promptIndex.add><span translate=btnTypeName.create></span></button></div></div></div></form><div class=table-responsive style=\"margin-top: 50px\"><table class=\"table table-striped\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=lookup.number></span></th><th><span translate=prompt.code></span></th><th><span translate=prompt.lang></span></th><th><span translate=prompt.dec></span></th></tr></thead><tbody><tr ng-repeat=\"prompt in vm.prompts\"><td><a ui-sref=promptIndex.edit({promptId:prompt.promptId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deletePrompt(prompt)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{$index+1}}</td><td>{{prompt.promptCode}}</td><td><select ng-model=prompt.lang disabled><option ng-repeat=\"x in vm.langValue\" value={{x.langCode}}>{{x.description}}</option></select></td><td>{{prompt.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div><!--</div>\n</div>-->");
$templateCache.put("app/remind/remind-edit.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>用户管理</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">发送对象</label><div class=col-lg-8><select class=form-control id=target name=target ng-model=vm.remind.target ng-options=\"e.id as e.name for e in vm.target\"><option value=\"\">请选择</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">发送时间</label><div class=col-lg-8><p class=input-group><input type=text class=form-control uib-datepicker-popup name=sendTime id=sendTime ng-model=vm.remind.sendTime datepicker-options=vm.dateOptions is-open=vm.isSendTime> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.sendTime()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">megId</label><div class=col-lg-8><input type=text id=megId name=megId ng-model=vm.remind.megId class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">内容</label><div class=col-lg-8><input type=text id=info name=info ng-model=vm.remind.info class=form-control></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/remind/remind-new.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>用户管理</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">发送对象</label><div class=col-lg-8><select class=form-control id=target name=target ng-model=vm.remind.target ng-options=\"e.id as e.name for e in vm.target\"><option value=\"\">请选择</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">发送时间</label><div class=col-lg-8><p class=input-group><input type=text class=form-control uib-datepicker-popup name=sendTime id=sendTime ng-model=vm.remind.sendTime datepicker-options=vm.dateOptions is-open=vm.isSendTime> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.sendTime()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">megId</label><div class=col-lg-8><input type=text id=megId name=megId ng-model=vm.remind.megId class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">内容</label><div class=col-lg-8><input type=text id=info name=info ng-model=vm.remind.info class=form-control></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/remind/remind.html","<div><div class=ibox-title><h2>推送信息管理</h2></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">范围</label><div class=col-lg-8><input type=text id=searchTarget class=form-control ng-model=vm.remind.target></div></div><div class=col-lg-4><div class=col-lg-8><button class=\"btn btn-white\" type=reset id=searchReset>重置</button> <button class=\"btn btn-w-m btn-primary\" type=button id=searchBtn ng-click=vm.loadSearch()>搜索</button></div></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=remind.new()>新增</a></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>操作</th><th>序号</th><th>范围</th><th>发送时间</th><th>megId</th><th>内容</th><th>状态</th></tr></thead><tbody><tr ng-repeat=\"remind in vm.reminds track by remind.id\"><td><a ui-sref=remind.edit({id:remind.id})><i class=\"fa fa-sign-in text-info\">编辑</i></a></td><td ng-bind=$index+1>1</td><td ng-bind=remind.target></td><td ng-bind=remind.sendTime></td><td ng-bind=remind.megId></td><td ng-bind=remind.info></td><td ng-bind=remind.state></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/resource/resource-detail.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><div><alert-error></alert-error><h2><span><span translate=resource.srcName></span>:{{vm.resource.name}}</span></h2><div class=ibox-content><form class=form-horizontal name=resourceForm role=form novalidate><div class=row><div class=form-group><label class=\"col-lg-2 control-label\">*<span translate=resource.srcName></span></label><div class=col-lg-6><div class=input-group><input type=text readonly ng-model=vm.resource.name class=form-control required> <span class=input-group-btn><button id=nameLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showNameLocale() value=name><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=form-group><label class=\"col-lg-2 control-label\">*<span translate=resource.srcUrl></span></label><div class=col-lg-6><input type=text ng-model=vm.resource.url class=form-control required></div></div><div class=form-group><label class=\"col-lg-2 control-label\"><span translate=resource.srcType></span></label><div class=col-lg-6><!--<input type=\"text\" ng-model=\"vm.resource.type\" class=\"form-control\"/>--><lookup-select lookup-value=vm.resource.type lookup-type=SYS.RESOURCE_TYPE></lookup-select></div></div><div class=form-group><label class=\"col-lg-2 control-label\"><span translate=resource.srcDec></span></label><div class=col-lg-6><div class=input-group><input type=text readonly ng-model=vm.resource.description class=form-control> <span class=input-group-btn><button id=decLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showDecLocale() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=form-group><label class=\"col-lg-2 control-label\"><span translate=resource.needLogin></span></label><div class=col-lg-6><input type=checkbox name=loginRequire id=field_loginRequire ng-model=vm.resource.loginRequire ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></div></div><div class=form-group><label class=\"col-lg-2 control-label\"><span translate=resource.accessCheck></span></label><div class=col-lg-6><input type=checkbox name=accessCheck id=field_accessCheck ng-model=vm.resource.accessCheck ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></div></div></div><div class=row><div class=col-lg-4 style=margin-top:10px><button type=button class=\"btn btn-default\" ng-click=vm.reBack()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-disabled=resourceForm.$invalid||vm.isSaving ng-click=vm.saveOrUpdate()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button> <button type=button class=\"btn btn-danger\" ng-disabled=vm.isSaving ng-show=\"vm.editOrCreate==\'Edit\'\" ng-click=vm.remove()><span class=\"glyphicon glyphicon-trash\"></span>&nbsp;<span translate=btnTypeName.del></span></button></div></div></form><br><br><div class=ibox-content ng-if=\"vm.editOrCreate==\'Edit\'\"><div class=row><h2><span><span translate=permission.accessPermission></span></span></h2></div><br><div class=row><button type=button class=\"btn btn-primary\" ui-sref=resource.addPermission({id:vm.resource.resourceId})><span translate=btnTypeName.create></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.savePermission()><span translate=btnTypeName.save></span></button> <button type=button class=\"btn btn-danger\" ng-click=vm.deletePermission()><span translate=btnTypeName.del></span></button></div><br><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox ng-click=vm.toggleAll() ng-model=vm.isAllSelected>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=permission.displayName></span></th><th><span translate=permission.description></span></th><th><span translate=permission.service></span></th><th><span translate=permission.resource></span></th><th><span translate=permission.action></span></th><th><span translate=permission.level></span></th><th><span translate=permission.enable></span></th><th><span translate=permission.isPublic></span></th><th><span translate=permission.isCustom></span></th></tr></thead><tbody><tr ng-repeat=\"permission in vm.permissions|filter:vm.isNotDelete\"><td><input type=checkbox ng-model=permission.deleteFlag ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">&nbsp;&nbsp; <a ng-click=vm.viewPermission(permission)><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.check></span></i></a></td><td ng-bind=permission.displayName ng-class=\"{fontred:permission.isDelete==\'Y\'}\"></td><td ng-bind=permission.description></td><td ng-bind=permission.service></td><td ng-bind=permission.resource></td><td ng-bind=permission.action></td><td><select ng-model=permission.level disabled><option ng-repeat=\"x in vm.levelList\" value={{x.value}}>{{x.meaning}}</option></select></td><td ng-bind=permission.enable></td><td ng-bind=permission.isPublic></td><td ng-bind=permission.isCustom></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=nameLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=nameLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.nameLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=decLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=decLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.decLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/resource/resource.html","<div class=row><alert-error></alert-error></div><div class=ibox-title><h5><span translate=resource.srcTitle></span></h5></div><div class=ibox-content><div><div class=container-fluid><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=resource.srcName></span></label><div class=col-lg-6><input type=text id=name class=form-control ng-model=vm.condition.name></div><button class=\"col-lg-3 btn btn-w-m btn-primary\" type=button id=searchBtn ng-click=vm.loadByName()><span translate=btnTypeName.search></span></button></div><div class=col-lg-6><button class=\"btn btn-primary\" ui-sref=resource.new><span class=\"glyphicon glyphicon-plus\"></span> <span translate=btnTypeName.create></span></button></div></div></div><br><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=resource.srcName></span></th><th><span translate=resource.srcUrl></span></th><th><span translate=resource.srcType></span></th><th><span translate=resource.needLogin></span></th><th><span translate=resource.accessCheck></span></th><th><span translate=resource.srcDec></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.resources track by resource.resourceId\"><td><a ui-sref=resource.detail({id:resource.resourceId})>{{resource.name}}</a></td><td>{{resource.url}}</td><td>{{resource.type}}</td><td>{{resource.loginRequire}}</td><td>{{resource.accessCheck}}</td><td>{{resource.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/roleClientManager/addClient-dialog.html","<style>.toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n  #toast-container {\n    z-index: 99999;\n  }</style><div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=roleManage.bindClient></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-6><label class=\"col-md-6 control-label\" style=padding-top:5px><span translate=roleManage.appName></span>：</label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.function.appName class=form-control></div></div><div class=col-md-6><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.search()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox ng-click=vm.toggleAll() ng-model=vm.isAllSelected></th><th><span translate=roleManage.appName></span></th><th><span translate=roleManage.appAuzMode></span></th><th><span translate=roleManage.appId></span></th><th><span translate=roleManage.appSecret></span></th><!--<th>普通角色</th>--><th><span translate=roleManage.clientType></span></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.resources track by resource.id\"><td><input type=checkbox ng-model=resource.addFlag ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td>{{resource.appName}}</td><td><span ng-repeat=\"x in vm.appAddAuzModeList\" ng-if=\"resource.appAuzMode==x.value\">{{x.meaning}}</span></td><td>{{resource.appId}}</td><td>{{resource.appSecret}}</td><td><span ng-if=\"resource.clientType==\'in\'\"><span translate=roleManage.in></span> </span><span ng-if=\"resource.clientType==\'out\'\"><span translate=roleManage.out></span></span></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.save() ng-disabled=vm.enabled><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div>");
$templateCache.put("app/roleClientManager/addRoleClient.html","<style>.toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n  #toast-container {\n    z-index: 99999;\n  }</style><form name=addForm role=form novalidate ng-submit=vm.add() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=roleManage.addRoleTitle></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_roldCode><font color=red>*</font><span translate=roleManage.roleCode></span></label><input type=text class=form-control name=roldCode id=field_roldCode ng-model=vm.role.roleCode required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleType><font color=red>*</font><span translate=roleManage.roleType></span></label><select id=field_roleType ng-model=vm.role.roleType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.roleTypes\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleName><font color=red>*</font><span translate=roleManage.roleName></span></label><div class=input-group><input type=text class=form-control name=roleName id=field_roleName required ng-model=vm.role.roleName readonly> <span class=input-group-btn><button id=roleNameLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showRoleNameLocale() value=roleName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleDescription><span translate=roleManage.roleDec></span></label><div class=input-group><input type=text class=form-control name=roleDescription id=field_roleDescription ng-model=vm.role.roleDescription readonly> <span class=input-group-btn><button id=roleDecLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showRoleDecLocale() value=roleDescription><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=roleNameLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=roleNameLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.roleNameLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=roleDecLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=roleDecLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.roleDecLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/roleClientManager/editRoleClient.html","<style>.toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n  #toast-container {\n    z-index: 99999;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.update() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=roleManage.editRoleTitle></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><input type=hidden class=form-control ng-model=vm.role.roleId><label class=control-label for=field_roleCode><font color=red>*</font><span translate=roleManage.roleCode></span></label><input type=text class=form-control name=roleCode id=field_roleCode ng-model=vm.role.roleCode disabled required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleType><font color=red>*</font><span translate=roleManage.roleType></span></label><select disabled id=field_roleType ng-model=vm.role.roleType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.roleTypes\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleName><font color=red>*</font><span translate=roleManage.roleName></span></label><div class=input-group><input type=text class=form-control name=roleName id=field_roleName ng-model=vm.role.roleName readonly required> <span class=input-group-btn><button id=roleNameLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showRoleNameLocale() value=roleName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleDescription><span translate=roleManage.roleDec></span></label><div class=input-group><input type=text class=form-control name=roleDescription id=field_roleDescription ng-model=vm.role.roleDescription readonly> <span class=input-group-btn><button id=roleDecLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showRoleDecLocale() value=roleDescription><i class=\"fa fa-globe\"></i></button></span></div></div></div><!-- <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\" for=\"field_roleDescription\">普通角色</label><br/>\n          <input type=\"checkbox\" name=\"awesome\" ng-model=\"vm.ordinaryRole\" ng-change=\"vm.changRole(vm.role.roleId)\">\n        </div>\n      </div>--></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=roleNameLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=roleNameLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.roleNameLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=roleDecLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=roleDecLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.roleDecLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/roleClientManager/roleClientManage.html","<!--<div>--><!--<h3>角色管理</h3>--><!--</div>--><!--<style>\n  select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n</style>--><style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=roleManage.roleClientTitle></span></h5><!--<div class=\"ibox-tools\">\n          <a class=\"collapse-link\">\n            <i class=\"fa fa-chevron-up\"></i>\n          </a>\n          <a class=\"dropdown-toggle\" data-toggle=\"dropdown\">\n            <i class=\"fa fa-wrench\"></i>\n          </a>\n          <ul class=\"dropdown-menu dropdown-user\">\n            <li><a href=\"#\">Config option 1</a>\n            </li>\n            <li><a href=\"#\">Config option 2</a>\n            </li>\n          </ul>\n          <a class=\"close-link\">\n            <i class=\"fa fa-times\"></i>\n          </a>\n        </div>--></div><div class=ibox-content><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=roleManage.roleCode></span></label><div class=col-lg-8><input type=text ng-model=vm.role.roleCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=roleManage.roleName></span></label><div class=col-lg-8><input type=text ng-model=vm.role.roleName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=roleManage.roleDec></span></label><div class=col-lg-8><input type=text ng-model=vm.role.roleDescription class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-6 pull-right\"><a class=\"btn btn-w-m btn-info\" ui-sref=roleClient.add><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.queryRole()><span translate=btnTypeName.search></span></button></div></div></div></div></form><p></p><p></p><div class=row><div class=col-md-12><div class=row><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=lookup.number></span></th><th><span translate=roleManage.roleCode></span></th><th><span translate=roleManage.roleName></span></th><th><span translate=roleManage.roleDec></span></th><!--<th>普通角色</th>--><th><span translate=roleManage.roleType></span></th></tr></thead><tbody><tr ng-repeat=\"role in vm.roles\"><td><a ui-sref=roleGrantClient({roleId:role.roleId})><i class=\"fa fa-sitemap text-navy\"><span translate=btnTypeName.clientDistribute></span></i></a> <a ui-sref=roleClient.edit({roleId:role.roleId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteRole(role)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{$index+1}}</td><td>{{role.roleCode}}</td><td>{{role.roleName}}</td><td>{{role.roleDescription}}</td><td><span ng-if=\"role.roleType==\'in\'\"><span translate=roleManage.in></span> </span><span ng-if=\"role.roleType==\'out\'\"><span translate=roleManage.out></span></span></td><!--<td ng-show=\"role.isOrdinary==\'true\'\">普通角色</td>\n                <td ng-show=\"role.isOrdinary==\'false\'\">非普通角色</td>--></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div></div>");
$templateCache.put("app/roleClientManager/roleGrantManage.html","<!--<div>--><!--<h3>角色管理</h3>--><!--</div>--><style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=roleManage.client></span></h5><!--<div class=\"ibox-tools\">\n          <a class=\"collapse-link\">\n            <i class=\"fa fa-chevron-up\"></i>\n          </a>\n          <a class=\"dropdown-toggle\" data-toggle=\"dropdown\">\n            <i class=\"fa fa-wrench\"></i>\n          </a>\n          <ul class=\"dropdown-menu dropdown-user\">\n            <li><a href=\"#\">Config option 1</a>\n            </li>\n            <li><a href=\"#\">Config option 2</a>\n            </li>\n          </ul>\n          <a class=\"close-link\">\n            <i class=\"fa fa-times\"></i>\n          </a>\n        </div>--></div><div class=ibox-content><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=roleManage.appAuzMode></span></label><div class=col-lg-8><select class=form-control ng-model=vm.role.appAuzMode><option value=\"\"></option><option ng-repeat=\"x in vm.applicationClientList\" value={{x.value}}>{{x.name}}</option></select><!-- <select class=\"form-control\" ng-model=\"vm.role.appAuzMode\">\n                    <option value=\"\"></option>\n                    <option value=\"authorization_code\">translate-attr=\"{value : \'appAuth.authorizationCode\'}\"</option>\n                    <option value=\"implicit\"><a translate=\"appAuth.implicit\"></a></option>\n                    <option value=\"client_credentials\"><span translate=\"appAuth.clientCredentials\"></span></option>\n                  </select>--></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=roleManage.appName></span></label><div class=col-lg-8><input type=text ng-model=vm.role.appName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-6 pull-right\"><a class=\"btn btn-w-m btn-info\" ui-sref=roleGrantClient.addClient({id:vm.role.roleId})><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.loadAllClient()><span translate=btnTypeName.search></span></button></div></div></div></div></form><p></p><p></p><div class=row><div class=col-md-12><div class=row><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=lookup.number></span></th><th><span translate=roleManage.appName></span></th><th><span translate=roleManage.appAuzMode></span></th><th><span translate=roleManage.appId></span></th><th><span translate=roleManage.appSecret></span></th><!--<th>普通角色</th>--><th><span translate=roleManage.clientType></span></th></tr></thead><tbody><tr ng-repeat=\"role in vm.role.clientList\"><td><a ng-click=vm.deleteClientById(role.grantAuthClientId)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{$index+1}}</td><td>{{role.appName}}</td><td><span ng-repeat=\"x in vm.appAuzModeList\" ng-if=\"role.appAuzMode==x.value\">{{x.meaning}}</span></td><td>{{role.appId}}</td><td>{{role.appSecret}}</td><td><span ng-if=\"role.clientType==\'in\'\"><span translate=roleManage.in></span> </span><span ng-if=\"role.clientType==\'out\'\"><span translate=roleManage.out></span></span></td><!--<td ng-show=\"role.isOrdinary==\'true\'\">普通角色</td>\n                <td ng-show=\"role.isOrdinary==\'false\'\">非普通角色</td>--></tr></tbody></table></div><!--<div class=\"text-center\">\n            <item-count page=\"vm.page\" total=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\"></item-count>\n            <uib-pagination class=\"pagination-sm\"\n                            total-items=\"vm.totalItems\"\n                            ng-model=\"vm.page\"\n                            ng-change=\"vm.pageChanged()\"></uib-pagination>\n          </div>--></div></div></div></div></div></div>");
$templateCache.put("app/roleManager/addRole.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  #toast-container {\n    z-index: 1100;\n  }</style><form name=addForm role=form novalidate ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=roleManage.addRoleTitle></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_roldCode><span style=\"color: red\">*</span><span translate=roleManage.roleCode></span></label><input type=text class=form-control name=roldCode id=field_roldCode ng-model=vm.role.roleCode required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleType><span style=\"color: red\">*</span> <span translate=roleManage.roleType></span></label><select id=field_roleType ng-model=vm.role.attribute1 class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.roleTypes\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleName><span style=\"color: red\">*</span><span translate=roleManage.roleName></span></label><div class=input-group><input type=text class=form-control name=roleName id=field_roleName ng-model=vm.role.roleName readonly required> <span class=input-group-btn><button id=roleNameLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showRoleNameLocale() value=roleName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleDescription><span translate=roleManage.roleDec></span></label><div class=input-group><input type=text class=form-control name=roleDescription id=field_roleDescription ng-model=vm.role.roleDescription readonly> <span class=input-group-btn><button id=roleDecLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showRoleDecLocale() value=roleDescription><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=roleNameLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=roleNameLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.roleNameLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=roleDecLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=roleDecLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.roleDecLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/roleManager/editRole.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.update()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=roleManage.editRoleTitle></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><input type=hidden class=form-control ng-model=vm.role.roleId><label class=control-label for=field_roleCode><span style=\"color: red\">*</span><span translate=roleManage.roleCode></span></label><input type=text class=form-control name=roleCode id=field_roleCode ng-model=vm.role.roleCode required ng-disabled=vm.role.roleId></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleType><span style=\"color: red\">*</span><span translate=roleManage.roleType></span></label><select id=field_roleType ng-model=vm.role.attribute1 class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.roleTypes\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleName><span translate=roleManage.roleName></span></label><div class=input-group><input type=text class=form-control name=roleName id=field_roleName ng-model=vm.role.roleName readonly> <span class=input-group-btn><button id=roleNameLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showRoleNameLocale() value=roleName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_roleDescription><span translate=roleManage.roleDec></span></label><div class=input-group><input type=text class=form-control name=roleDescription id=field_roleDescription ng-model=vm.role.roleDescription readonly> <span class=input-group-btn><button id=roleDecLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showRoleDecLocale() value=roleDescription><i class=\"fa fa-globe\"></i></button></span></div></div></div><!-- <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\" for=\"field_roleDescription\">普通角色</label><br/>\n          <input type=\"checkbox\" name=\"awesome\" ng-model=\"vm.ordinaryRole\" ng-change=\"vm.changRole(vm.role.roleId)\">\n        </div>\n      </div>--></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=roleNameLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=roleNameLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.roleNameLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=roleDecLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=roleDecLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.roleDecLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/roleManager/roleManage.html","<!--<div>--><!--<h3>角色管理</h3>--><!--</div>--><style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=roleManage.roleTitle></span></h5><!--<div class=\"ibox-tools\">\n          <a class=\"collapse-link\">\n            <i class=\"fa fa-chevron-up\"></i>\n          </a>\n          <a class=\"dropdown-toggle\" data-toggle=\"dropdown\">\n            <i class=\"fa fa-wrench\"></i>\n          </a>\n          <ul class=\"dropdown-menu dropdown-user\">\n            <li><a href=\"#\">Config option 1</a>\n            </li>\n            <li><a href=\"#\">Config option 2</a>\n            </li>\n          </ul>\n          <a class=\"close-link\">\n            <i class=\"fa fa-times\"></i>\n          </a>\n        </div>--></div><div class=ibox-content><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=roleManage.roleCode></span></label><div class=col-lg-8><input type=text ng-model=vm.role.roleCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=roleManage.roleName></span></label><div class=col-lg-8><input type=text ng-model=vm.role.roleName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=roleManage.roleDec></span></label><div class=col-lg-8><input type=text ng-model=vm.role.roleDescription class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-8><div class=\"col-lg-10 pull-right\"><button class=\"btn btn-w-m btn-info\" ui-sref=role.add><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-primary\" ui-sref=rolePermission><span translate=permission.permissionAssignment></span></button></div></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.queryRole()><span translate=btnTypeName.search></span></button></div></div></div><div class=row><div class=col-lg-4></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.saveAuthority()><span translate=btnTypeName.save></span></button></div></div></div></div></form><p></p><p></p><div class=row><div class=col-md-7><div class=row><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=lookup.number></span></th><th><span translate=roleManage.roleCode></span></th><th><span translate=roleManage.roleName></span></th><th><span translate=roleManage.roleDec></span></th><!--<th>普通角色</th>--><th><span translate=roleManage.roleType></span></th></tr></thead><tbody><tr ng-repeat=\"role in vm.roles\"><td><a ng-click=vm.selectRole(role)><i class=\"fa fa-sitemap text-navy\"><span translate=btnTypeName.funcDistribute></span></i></a> <a ui-sref=role.edit({roleId:role.roleId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteRole(role)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{$index+1}}</td><td>{{role.roleCode}}</td><td style=\"color: {{vm.currentRole != role.roleId ? \'none;\' : \'red;\'}}\">{{role.roleName}}</td><td>{{role.roleDescription}}</td><td><select ng-model=role.attribute1 disabled><option ng-repeat=\"x in vm.roleTypes\" value={{x.value}}>{{x.meaning}}</option></select></td><!--<td ng-show=\"role.isOrdinary==\'true\'\">普通角色</td>\n                <td ng-show=\"role.isOrdinary==\'false\'\">非普通角色</td>--></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div><div class=col-md-5><div js-tree=vm.treeConfig ng-model=vm.jsTreeData tree=vm.treeInstance></div></div></div></div></div></div></div>");
$templateCache.put("app/schedule/schedule-edit.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>日程编辑</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">megId</label><div class=col-lg-8><input type=text id=info name=info ng-model=vm.schedule.info class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">类型</label><div class=col-lg-8><input type=text id=state name=state ng-model=vm.schedule.state class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">url</label><div class=col-lg-8><input type=text id=url name=url ng-model=vm.schedule.url class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">试卷id</label><div class=col-lg-8><input type=text id=paperId name=paperId ng-model=vm.schedule.paperId class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人</label><div class=col-lg-8><input type=text id=perName name=perName ng-model=vm.schedule.perName class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人2</label><div class=col-lg-8><input type=text id=perName2 name=perName2 ng-model=vm.schedule.perName2 class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人介绍</label><div class=col-lg-8><input type=text id=perTitle name=perTitle ng-model=vm.schedule.perTitle class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人介绍2</label><div class=col-lg-8><input type=text id=perTitle2 name=perTitle2 ng-model=vm.schedule.perTitle2 class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人照片</label><div class=col-lg-8><input type=text id=perPhoto name=perPhoto ng-model=vm.schedule.perPhoto class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">地点</label><div class=col-lg-8><input type=text id=place name=place ng-model=vm.schedule.place class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">序号</label><div class=col-lg-8><input type=text id=orderNum name=orderNum ng-model=vm.schedule.orderNum class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">时间</label><div class=col-lg-8><input type=text id=time name=time ng-model=vm.schedule.time class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">会议内容</label><div class=col-lg-8><input type=text id=profile name=profile ng-model=vm.schedule.profile class=form-control></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/schedule/schedule-new.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>日程新建</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">megId</label><div class=col-lg-8><input type=text id=info name=info ng-model=vm.schedule.info class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">类型</label><div class=col-lg-8><input type=text id=state name=state ng-model=vm.schedule.state class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">url</label><div class=col-lg-8><input type=text id=url name=url ng-model=vm.schedule.url class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">试卷id</label><div class=col-lg-8><input type=text id=paperId name=paperId ng-model=vm.schedule.paperId class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人</label><div class=col-lg-8><input type=text id=perName name=perName ng-model=vm.schedule.perName class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人2</label><div class=col-lg-8><input type=text id=perName2 name=perName2 ng-model=vm.schedule.perName2 class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人介绍</label><div class=col-lg-8><input type=text id=perTitle name=perTitle ng-model=vm.schedule.perTitle class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人介绍2</label><div class=col-lg-8><input type=text id=perTitle2 name=perTitle2 ng-model=vm.schedule.perTitle2 class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">演讲人照片</label><div class=col-lg-8><input type=text id=perPhoto name=perPhoto ng-model=vm.schedule.perPhoto class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">地点</label><div class=col-lg-8><input type=text id=place name=place ng-model=vm.schedule.place class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">序号</label><div class=col-lg-8><input type=text id=orderNum name=orderNum ng-model=vm.schedule.orderNum class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">时间</label><div class=col-lg-8><input type=text id=time name=time ng-model=vm.schedule.time class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">会议内容</label><div class=col-lg-8><input type=text id=profile name=profile ng-model=vm.schedule.profile class=form-control></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/schedule/schedule.html","<div><div class=ibox-title><h2>会议日程</h2></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">题目</label><div class=col-lg-8><input type=text id=searchInfo class=form-control ng-model=vm.schedule.info></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">地点</label><div class=col-lg-8><input type=text id=searchPlace class=form-control ng-model=vm.schedule.place></div></div><div class=col-lg-4><div class=col-lg-8><button class=\"btn btn-white\" type=reset id=searchReset>重置</button> <button class=\"btn btn-w-m btn-primary\" type=button id=searchBtn ng-click=vm.loadSearch()>搜索</button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>操作</th><th>序号</th><th>题目</th><!--<th>类型</th>--><!--<th>URL</th>--><!--<th>试卷id</th>--><th>演讲人1</th><th>介绍</th><th>演讲人2</th><th>介绍</th><!--<th>照片</th>--><th>地点</th><!--<th>序号</th>--><th>时间</th><!--<th>内容</th>--></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules track by schedule.id\"><td><a ui-sref=schedule.edit({id:schedule.id})><i class=\"fa fa-edit text-primary\">编辑</i></a></td><td ng-bind=$index+1>1</td><td ng-bind=schedule.info></td><!--<td ng-bind=\"schedule.state\"></td>--><!--<td ng-bind=\"schedule.url\"></td>--><!--<td ng-bind=\"schedule.paperId\"></td>--><td ng-bind=schedule.perName></td><td ng-bind=schedule.perTitle></td><td ng-bind=schedule.perName2></td><td ng-bind=schedule.perTitle2></td><!--<td ng-bind=\"schedule.perPhoto\"></td>--><td ng-bind=schedule.place></td><!--<td ng-bind=\"schedule.orderNum\"></td>--><td ng-bind=schedule.time></td><!--<td ng-bind=\"schedule.profile\"></td>--></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/sysConfig/sysConfig-dialog.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><div class=modal-header><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=sysConfig.createOrEditSystemConfig></span></h4></div><div class=modal-body><form name=editForm role=form novalidate ng-submit=vm.save()><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_configKey><span translate=sysConfig.configurationItem></span></label><input type=text class=form-control name=configKey id=field_configKey ng-model=vm.sysConfig.configKey ng-readonly=vm.isSystem></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_configValue><span translate=sysConfig.configurationValue></span></label><input type=text class=form-control name=configValue id=field_configValue ng-model=vm.sysConfig.configValue></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_configDesc><span translate=sysConfig.configurationDescription></span></label><div class=input-group><input type=text class=form-control name=configDesc id=field_configDesc ng-model=vm.sysConfig.configDesc readonly> <span class=input-group-btn><button id=configDescBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'configDesc\')\" value=configDesc><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_configLevel><span translate=sysConfig.configurationLevel></span></label><select id=field_configLevel class=form-control ng-model=vm.sysConfig.configLevel ng-options=\"level for level in vm.configLevelType\" required ng-readonly=vm.isSystem></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_enableFlag><span translate=sysConfig.enable></span></label><input type=checkbox name=enableFlag id=field_enableFlag ng-model=vm.sysConfig.enable ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></div></div></div></form></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=vm.save()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div><div class=\"modal fade\" id=localeModal_configDesc style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_configDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'configDesc\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/sysConfig/sysConfig.html","<div class=ibox-title><h5><span translate=sysConfig.title></span></h5></div><div class=ibox-content><div><div class=container-fluid><form><div class=row><div class=col-md-5><label class=\"col-md-offset-1 col-md-2 control-label m-t-xs\" for=configKey><span translate=sysConfig.configKey></span></label><div class=col-md-8><input type=text id=configKey translate-attr=\"{placeholder : \'sysConfig.fuzzyQuery\'}\" ng-model=vm.searchConfig.configKey class=\"form-control col-md-5\"></div></div><div class=col-md-5><label class=\"col-md-offset-1 col-md-2 control-label m-t-xs\" for=description><span translate=sysConfig.description></span></label><div class=col-md-8><input type=text id=description translate-attr=\"{placeholder : \'sysConfig.fuzzyQuery\'}\" ng-model=vm.searchConfig.configDesc class=\"form-control col-md-5\"></div></div></div><br><div class=row><div class=\"col-md-8 col-md-offset-4\"><div class=\"col-md-offset-3 col-md-9 input-group\"><button class=\"btn btn-primary btn-w-m\" type=button ng-click=vm.clear()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-primary btn-w-m\" ng-click=vm.search() style=\"margin-left: 5%\"><span translate=btnTypeName.check></span></button> <button class=\"btn btn-primary btn-w-m\" style=\"margin-left: 5%\" type=button ui-sref=sysConfig.new><span translate=btnTypeName.create></span></button></div></div></div></form></div><br><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=sysConfig.operation></span></th><th><span translate=sysConfig.configurationItem></span></th><th style=\"width: 40%\"><span translate=sysConfig.configurationValue></span></th><th><span translate=sysConfig.configurationDescription></span></th><th><span translate=sysConfig.configurationLevel></span></th><th><span translate=sysConfig.enable></span></th></tr></thead><tbody><tr ng-repeat=\"sysconfig in vm.sysConfigs track by sysconfig.id\"><td><a ui-sref=sysConfig.edit({id:sysconfig.id})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.remove(sysconfig)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{sysconfig.configKey}}</td><td style=\"word-wrap: break-word; word-break:break-all\">{{sysconfig.configValue}}</td><td>{{sysconfig.configDesc}}</td><td>{{sysconfig.configLevel}}</td><td>{{sysconfig.enable}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/thirdparty/thirdparty-detail.html","<div><alert-error></alert-error><h2><span>{{vm.thirdparty.appName}}</span></h2><dl class=dl-horizontal><dt><span translate=thirdParty.appCode></span></dt><dd>{{vm.thirdparty.appCode}}</dd><dt><span translate=thirdParty.appDec></span></dt><dd>{{vm.thirdparty.appDesc}}</dd><dt><span translate=thirdParty.appIcon></span></dt><dd>{{vm.thirdparty.appIcon}}</dd><dt><span translate=thirdParty.appKey></span></dt><dd>{{vm.thirdparty.appKey}}</dd><dt><span translate=thirdParty.appSecret></span></dt><dd>{{vm.thirdparty.appSecret}}</dd><dt><span translate=thirdParty.expiredTime></span></dt><dd>{{vm.thirdparty.expiredDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate=thirdParty.mainPage></span></dt><dd>{{vm.thirdparty.appHomepage}}</dd><dt><span translate=thirdParty.isPay></span></dt><dd>{{vm.thirdparty.freeFlag}}</dd><dt><span translate=header.whetherEffective></span></dt><dd>{{vm.thirdparty.enableFlag}}</dd></dl><button type=submit ui-sref=thirdparty class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button></div>");
$templateCache.put("app/thirdparty/thirdparty-dialog.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=thirdParty.createOrEditTitle></span></h4></div><div class=modal-body><!--<jhi-alert-error></jhi-alert-error>--><div class=form-group ng-show=vm.thirdparty.id><label for=id>ID</label><input type=text class=form-control id=id name=id ng-model=vm.thirdparty.id readonly></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_appName><font color=red>*</font><span translate=thirdParty.appName></span></label><div class=input-group><input type=text class=form-control name=appName id=field_appName ng-model=vm.thirdparty.appName readonly required> <span class=input-group-btn><button id=appNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'appName\')\" value=appName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_appCode><font color=red>*</font><span translate=thirdParty.appCode></span></label><input type=text class=form-control name=appCode id=field_appCode ng-model=vm.thirdparty.appCode required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_appDesc><span translate=thirdParty.appDec></span></label><div class=input-group><input type=text class=form-control name=appDesc id=field_appDesc ng-model=vm.thirdparty.appDesc readonly> <span class=input-group-btn><button id=appDescBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'appDesc\')\" value=appDesc><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_appIcon><span translate=thirdParty.appIcon></span></label><input type=text class=form-control name=appIcon id=field_appIcon ng-model=vm.thirdparty.appIcon></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_appKey><font color=red>*</font><span translate=thirdParty.appKey></span></label><input type=text class=form-control name=appKey id=field_appKey ng-model=vm.thirdparty.appKey required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_appSecret><font color=red>*</font><span translate=thirdParty.appSecret></span></label><input type=text class=form-control name=appSecret id=field_appSecret required ng-model=vm.thirdparty.appSecret></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_expiredDate><font color=red>*</font><span translate=thirdParty.expiredTime></span></label><p class=\"input-group date form_date\"><input type=text class=form-control name=start id=field_expiredDate ng-model=vm.thirdparty.expiredDate readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p><!-- <p class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd HH:mm:ss\" name=\"expiredDate\" id=\"field_expiredDate2\"\n                   ng-model=\"vm.thirdparty.expiredDate\" datepicker-options=\"vm.dateOptions\" is-open=\"vm.isOpen\"/>\n            &lt;!&ndash;<input type=\"text\" required class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd HH:mm:ss\" name=\"expiredDate\" id=\"field_expiredDate\"\n                   ng-model=\"vm.thirdparty.expiredDate\" datepicker-options=\"vm.dateOptions\" is-open=\"vm.isStartOpen\"/>&ndash;&gt;\n          <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.popupOpen()\">\n              <i class=\"glyphicon glyphicon-calendar\"></i></button>\n          </span>\n          </p>--></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_appHomepage><span translate=thirdParty.mainPage></span></label><input type=text class=form-control name=appName id=field_appHomepage ng-model=vm.thirdparty.appHomepage></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_freeFlag><span translate=thirdParty.isPay></span></label><input type=checkbox name=freeFlag id=field_freeFlag ng-model=vm.thirdparty.freeFlag ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_enableFlag><span translate=header.whetherEffective></span></label><input type=checkbox name=enableFlag id=field_enableFlag ng-model=vm.thirdparty.enableFlag ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><div class=\"modal fade\" id=localeModal_appName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_appName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'appName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_appDesc style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_appDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'appDesc\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/thirdparty/thirdparty.html","<div class=row><alert-error></alert-error></div><div class=ibox-content><div><h2><span translate=thirdParty.title></span></h2><div class=container-fluid><div class=row><div class=\"col-xs-8 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=thirdparty.new><span class=\"glyphicon glyphicon-plus\"></span> <span translate=thirdParty.createNewApp></span></button> <a class=\"btn btn-w-m btn-info\" ng-click=vm.redisInit()><span translate=btnTypeName.redisInitLoad></span></a> <a class=\"btn btn-w-m btn-warning\" ng-click=vm.keyReset()><span translate=btnTypeName.keyResetInit></span></a></div></div></div><br><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th style=\"width: 10%\"><span translate=btnTypeName.operation></span></th><th style=\"width: 10%\"><span translate=thirdParty.appName></span></th><th style=\"width: 10%\"><span translate=thirdParty.appDec></span></th><th style=\"width: 10%\"><span translate=thirdParty.appCode></span></th><th style=\"width: 10%\"><span translate=thirdParty.appIcon></span></th><th style=\"width: 10%\"><span translate=thirdParty.appKey></span></th><th style=\"width: 10%\"><span translate=thirdParty.isPay></span></th><th style=\"width: 10%\"><span translate=thirdParty.expiredTime></span></th><th style=\"width: 10%\"><span translate=header.whetherEffective></span></th><th style=\"width: 10%\"><span translate=thirdParty.mainPage></span></th></tr></thead><tbody><tr ng-repeat=\"thirdparty in vm.thirdpartys track by thirdparty.id\"><td class=text-left><div class=\"btn-group flex-btn-group-container\"><a ui-sref=thirdparty.edit({id:thirdparty.id})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a></div></td><td><a ui-sref=thirdparty-detail({id:thirdparty.id})>{{thirdparty.appName}}</a></td><td>{{thirdparty.appDesc}}</td><td>{{thirdparty.appCode}}</td><td>{{thirdparty.appIcon}}</td><td>{{thirdparty.appKey}}</td><td>{{thirdparty.freeFlag}}</td><td>{{thirdparty.expiredDate}}</td><td>{{thirdparty.enableFlag}}</td><td>{{thirdparty.appHomePage}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/tpl/deleteConfirmComponent.html","<div class=modal-header><h3 class=modal-title>删除确认</h3></div><div class=modal-body>是否确认删除选定项？</div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=$ctrl.ok()>确认</button> <button class=\"btn btn-info\" type=button ng-click=$ctrl.cancel()>取消</button></div>");
$templateCache.put("app/tpl/permission-area.html","<div class=form-inline><div class=\"multiple-select-box form-control ui-select-container ui-select-multiple ui-select-bootstrap m-b text-left\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=-1 type=button role=button draggable=true aria-disabled=false ng-repeat=\"data in vm.permissionData\"><i class={{data.dataIcon}}></i>{{data.dataValue}}</span></div><i class=\"fa fa-edit\"></i> <a href=\"\" ng-click=vm.open() translate=appEdition.visible_scope></a></div>");
$templateCache.put("app/tpl/permission-selector.html","<div class=ibox-content><div class=modal-header translate=appEdition.range></div><div class=modal-body><div class=row><div class=\"col-md-offset-1 col-md-10\"><ui-select multiple sortable ng-model=vm.selectedData theme=bootstrap class=\"form-control m-b\" title=输入搜索条件 on-select=\"vm.onSelectCallback($item, $model)\" on-remove=\"vm.onRemoveCallback($item, $model)\" reset-search-input=true remove-selected=false><ui-select-match><i class={{$item.dataIcon}}></i> {{$item.dataValue}}</ui-select-match><ui-select-choices repeat=\"data in vm.searchData\" refresh=vm.permissionAutocomplete($select.search) refresh-delay=500><i class={{data.dataIcon}}></i> {{data.dataValue}}</ui-select-choices></ui-select></div></div><div class=row></div><div class=row><uib-tabset active=activeForm><uib-tab index=0 heading={{vm.department}} select=vm.selectOrg()><div class=\"row corp-tree\"><div class=col-md-12><div js-tree=vm.treeConfig ng-model=vm.jsTreeData tree=vm.treeInstance tree-events-obj=vm.deptTreeEventsObj></div></div></div></uib-tab><uib-tab index=1 heading={{vm.tag}} select=vm.selectTag()><div class=\"row corp-tree\"><div class=col-md-12><div class=\"form-group m-t\"><h3 translate=appEdition.my_tag></h3><div class=table-responsive><table class=\"table table table-hover table-striped\"><tbody><tr ng-repeat=\"tag in vm.allTransferedTags\"><td width=80%><a href=\"\" ng-click=vm.tagDetail()><i class=\"fa fa-tag\"></i>{{tag.dataValue}}</a></td><td width=20% align=right><input type=checkbox ng-click=vm.checkedData(tag,$event) ng-model=tag.checked ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab index=2 heading={{vm.member}} select=vm.selectDetail()><div class=row><div class=\"col-md-5 corp-tree\"><div js-tree=vm.detailTreeConfig ng-model=vm.jsMemberTreeData tree=vm.memberTreetailInstance tree-events-obj=vm.memberTreeEventsObj></div></div><div class=col-md-7><div class=table-responsive><table class=\"table table-striped\"><tbody><tr ng-show=vm.isSpinnerShow><td colspan=6><div class=spiner-example><div class=\"sk-spinner sk-spinner-pulse\"></div></div></td></tr><tr ng-show=vm.isStaffShow><td align=left width=40% translate=appEdition.job_number></td><td align=left width=40% translate=userManage.name></td><td align=right width=20% translate=btnTypeName.choose></td></tr><tr ng-repeat=\"staff in vm.allTransferedStaffs track by staff.dataId\" ng-show=vm.isStaffShow><td align=left width=40%>{{staff.dataId}}</td><td align=left width=40%>{{staff.dataValue}}</td><td align=right width=20%><input type=checkbox ng-click=vm.checkedData(staff,$event) ng-model=staff.checked ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td></tr></tbody></table></div><div class=\"text-center m-b\"><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></uib-tab></uib-tabset></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-primary\" ng-click=vm.close()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=appEdition.confirm></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=appEdition.close></span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div></div>");
$templateCache.put("app/tpl/staff-permission-area.html","<div class=form-inline><!--<div\n      class=\"multiple-select-box form-control ui-select-container ui-select-multiple ui-select-bootstrap m-b text-left \">\n      <span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" role=\"button\"\n            draggable=\"false\"\n            aria-disabled=\"false\" ng-repeat=\"data in vm.permissionData\">\n        {{data.dataValue}}  {{data.dataId}}\n        &lt;!&ndash;<input type=\"text\" class=\"form-control\" ng-model=\"{{data.dataValue}}\" disabled/>&ndash;&gt;\n      </span>\n\n    </div>--><!--<i class=\"fa fa-edit\"></i> <a href=\"\" ng-click=\"vm.open()\">选择主管</a>--> <a class=\"btn btn-w-m btn-info\" ng-click=vm.open()>新增管理员</a></div>");
$templateCache.put("app/tpl/staff-permission-selector.html","<div class=ibox-content><div class=modal-header>选择范围</div><div class=modal-body><div class=row><div class=\"col-md-offset-1 col-md-10\"><ui-select multiple sortable limit=1 ng-model=vm.selectedData theme=bootstrap class=\"form-control m-b\" title=输入搜索条件 on-select=\"vm.onSelectCallback($item, $model)\" on-remove=\"vm.onRemoveCallback($item, $model)\" reset-search-input=true remove-selected=false><ui-select-match><i class={{$item.dataIcon}}></i> {{$item.dataValue}}</ui-select-match><ui-select-choices repeat=\"data in vm.searchData\" refresh=vm.permissionAutocomplete($select.search) refresh-delay=500><i class={{data.dataIcon}}></i> {{data.dataValue}}</ui-select-choices></ui-select></div></div><div class=row></div><div class=row><uib-tabset active=activeForm><!--<uib-tab index=\"0\" heading=\"部门\" select=\"vm.selectOrg()\">\n          <div class=\"row corp-tree\">\n            <div class=\"col-md-12\"> <div js-tree=\"vm.treeConfig\" ng-model=\"vm.jsTreeData\" tree=\"vm.treeInstance\"\n                                         tree-events-obj=\"vm.deptTreeEventsObj\"></div></div>\n          </div>\n\n        </uib-tab>\n        <uib-tab index=\"1\" heading=\"标签\" select=\"vm.selectTag()\">\n          <div class=\"row corp-tree\">\n            <div class=\"col-md-12\">\n              <div class=\"form-group m-t\">\n                <h3>我的标签</h3>\n                <div class=\"table-responsive\">\n                  <table class=\"table table table-hover table-striped\">\n                    <tbody>\n                    <tr ng-repeat=\"tag in vm.allTransferedTags\">\n                      <td width=\"80%\"><a href=\"\" ng-click=\"vm.tagDetail()\"> <i class=\"fa fa-tag\"></i>{{tag.dataValue}}</a></td>\n                      <td width=\"20%\" align=\"right\"><input type=\"checkbox\" ng-click=\"vm.checkedData(tag,$event)\"  ng-model=\"tag.checked\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"/> </td>\n                    </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </uib-tab>--><uib-tab index=2 heading=成员 select=vm.selectDetail()><div class=row><div class=\"col-md-5 corp-tree\"><div js-tree=vm.detailTreeConfig ng-model=vm.jsMemberTreeData tree=vm.memberTreetailInstance tree-events-obj=vm.memberTreeEventsObj></div></div><div class=col-md-7><div class=table-responsive><table class=\"table table-striped\"><tbody><tr ng-show=vm.isSpinnerShow><td colspan=6><div class=spiner-example><div class=\"sk-spinner sk-spinner-pulse\"></div></div></td></tr><tr ng-show=vm.isStaffShow><td align=left width=40%>工号</td><td align=left width=40%>姓名</td><td align=right width=20%>选择</td></tr><tr ng-repeat=\"staff in vm.allTransferedStaffs track by staff.dataId\" ng-show=vm.isStaffShow><td align=left width=40%>{{staff.dataId}}</td><td align=left width=40%>{{staff.dataValue}}</td><td align=right width=20%><input type=radio ng-click=vm.checkedData(staff,$event) ng-model=staff.checked></td></tr></tbody></table></div><div class=\"text-center m-b\"><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></uib-tab></uib-tabset></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-primary\" ng-click=vm.close()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 确定</span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span>关闭</span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div></div>");
$templateCache.put("app/tpl/tag-permission-area.html","<!--<div class=\"form-inline\">--><!--<div\n      class=\"multiple-select-box form-control ui-select-container ui-select-multiple ui-select-bootstrap m-b text-left \">\n      <span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" role=\"button\"\n            draggable=\"true\"\n            aria-disabled=\"false\" ng-repeat=\"data in vm.permissionData\">\n        <i class=\"{{data.dataIcon}}\"></i>{{data.dataValue}}</span>\n    </div>--> <a href=\"\" class=\"btn btn-primary\" ng-click=vm.open()>新增成员</a> <!--</div>-->");
$templateCache.put("app/tpl/tag-permission-selector.html","<div class=ibox-content><div class=modal-header>选择范围</div><div class=modal-body><div class=row><div class=\"col-md-offset-1 col-md-10\"><ui-select multiple sortable ng-model=vm.selectedData theme=bootstrap class=\"form-control m-b\" title=输入搜索条件 on-select=\"vm.onSelectCallback($item, $model)\" on-remove=\"vm.onRemoveCallback($item, $model)\" reset-search-input=true remove-selected=false><ui-select-match><i class={{$item.dataIcon}}></i> {{$item.dataValue}}</ui-select-match><ui-select-choices repeat=\"data in vm.searchData track by $index\" refresh=vm.permissionAutocomplete($select.search) refresh-delay=500><i class={{data.dataIcon}}></i> {{data.dataValue}}</ui-select-choices></ui-select></div></div><div class=row></div><div class=row><uib-tabset active=activeForm><uib-tab index=0 heading=部门 select=vm.selectOrg()><div class=\"row corp-tree\"><div class=col-md-12><div js-tree=vm.treeConfig ng-model=vm.jsTreeData tree=vm.treeInstance tree-events-obj=vm.deptTreeEventsObj></div></div></div></uib-tab><!--<uib-tab index=\"1\" heading=\"标签\" select=\"vm.selectTag()\">\n          <div class=\"row corp-tree\">\n            <div class=\"col-md-12\">\n              <div class=\"form-group m-t\">\n                <h3>我的标签</h3>\n                <div class=\"table-responsive\">\n                  <table class=\"table table table-hover table-striped\">\n                    <tbody>\n                    <tr ng-repeat=\"tag in vm.allTransferedTags\">\n                      <td width=\"80%\"><a href=\"\" ng-click=\"vm.tagDetail()\"> <i class=\"fa fa-tag\"></i>{{tag.dataValue}}</a></td>\n                      <td width=\"20%\" align=\"right\"><input type=\"checkbox\" ng-click=\"vm.checkedData(tag,$event)\"  ng-model=\"tag.checked\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"/> </td>\n                    </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </uib-tab>--><uib-tab index=2 heading=成员 select=vm.selectDetail()><div class=row><div class=\"col-md-5 corp-tree\"><div js-tree=vm.detailTreeConfig ng-model=vm.jsMemberTreeData tree=vm.memberTreetailInstance tree-events-obj=vm.memberTreeEventsObj></div></div><div class=col-md-7><div class=table-responsive><table class=\"table table-striped\"><tbody><tr ng-show=vm.isSpinnerShow><td colspan=6><div class=spiner-example><div class=\"sk-spinner sk-spinner-pulse\"></div></div></td></tr><tr ng-show=vm.isStaffShow><td align=left width=40%>工号</td><td align=left width=40%>姓名</td><td align=right width=20%>选择</td></tr><tr ng-repeat=\"staff in vm.allTransferedStaffs track by staff.dataId\" ng-show=vm.isStaffShow><td align=left width=40%>{{staff.dataId}}</td><td align=left width=40%>{{staff.dataValue}}</td><td align=right width=20%><input type=checkbox ng-click=vm.checkedData(staff,$event) ng-model=staff.checked ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td></tr></tbody></table></div><div class=\"text-center m-b\"><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></uib-tab></uib-tabset></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-primary\" ng-click=vm.close()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 确定</span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span>关闭</span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div></div>");
$templateCache.put("app/umEditor/imgModal.html","<style>.modal_body{\n    height: 450px;padding: 0;\n  }\n\n  .tag_list{\n    float:left;\n    width: 15%;\n    height: 100%;\n    padding-top: 10px;\n  }\n  .modal_content{\n    float:right;width: 85%;height: 100%;border-left: 1px solid #e7e7eb;\n  }\n  .local_upload{\n    border-bottom: 1px solid #e7e7eb; height: 50px\n  }\n  .local_btn{\n    float: right;margin-top: 10px;margin-right: 30px;\n  }\n  .show_list{\n    height: 350px;\n    padding: 20px 20px 20px 0;/*上右下左*/\n    /*border-bottom: 1px solid #e7e7eb;*/\n  }\n\n  .modal_content ul{\n    list-style-type: none\n  }\n\n  .tag_list ul{\n  }\n\n  .li_item {\n    position: relative;\n    margin-right: 11px;\n    margin-bottom: 10px;\n    float: left;\n    border: 1px solid #E1E1EC;\n    width: 119px;\n    cursor: pointer;\n    /*text-align: center*/\n  }\n\n  .show_item{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .item_style{\n    width:117px;\n    height: 117px;\n    /*border-bottom:1px solid #e7e7eb;*/\n  }\n  .item_name_style{\n    height: 20px;\n    text-align: center;\n    /*   display: flex;\n       align-items: center;\n       justify-content: center;\n       word-break: break-all;*/\n    border-top: 1px solid #E1E1EC;\n    overflow: hidden;\n\n  }\n  .selected_item {\n    border: 1px solid #1094fa;\n    background-image: url(./assets/images/umEdit/selected.png);\n    background-repeat:no-repeat;\n    /*background-image: url(../images/success.gif)\\9;*/\n    background-position: 100% 100%;\n  }\n  .selected_tag_query{\n    background-color: #f4f5f9;\n  }\n  .page_query{\n    display: inline-block;\n    float: right;\n    margin: 8px 10px;\n    border-radius: 4px;\n  }\n  .selectMedia{\n    margin-top: 10px;\n    height: 40px;\n    padding-left: 20px;\n    border-bottom: 1px solid #e7e7eb;\n  }\n  .select_tag_List{\n    float: left;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    /*width: 80px;*/\n  }\n  .selected_group{\n    background-color: #f4f5f9;\n  }\n  .selected_image{\n    border: 1px solid #1094fa;\n    background-image: url(./assets/images/umEdit/success.png);\n    background-repeat:no-repeat;\n    /*background-image: url(../images/success.gif)\\9;*/\n    background-position: 100% 100%;\n  }\n\n\n\n  .page_nav_area {\n    letter-spacing: 4px;\n    *letter-spacing: normal;\n  }\n  .page_nav_area, .goto_area {\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 12px;\n  }\n  .goto_area {\n    margin-left: 8px;\n  }\n\n  .btn.page_prev, .btn.page_next {\n    position: relative;\n    font-size: 0;\n    letter-spacing: -5px;\n    background-color: #fff;\n    background-image: -moz-linear-gradient(top,#fff 0,#fff 100%);\n    background-image: -webkit-gradient(linear,0 0,0 100%,from(#fff),to(#fff));\n    background-image: -webkit-linear-gradient(top,#fff 0,#fff 100%);\n    background-image: -o-linear-gradient(top,#fff 0,#fff 100%);\n    background-image: linear-gradient(to bottom,#fff 0,#fff 100%);\n    border-color: #e6e7ec;\n    color: #222;\n    height: 30px;\n    line-height: 30px;\n    *line-height: 28px;\n    width: auto;\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n\n  .btn.page_prev .arrow, .btn.page_next .arrow {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -6px;\n    margin-left: -3px;\n  }\n  .page_prev .arrow {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    border-width: 6px;\n    border-style: dashed;\n    border-color: transparent;\n    border-left-width: 0;\n    border-right-color: #919191;\n    border-right-style: solid;\n  }\n  .page_next .arrow {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    border-width: 6px;\n    border-style: dashed;\n    border-color: transparent;\n    border-right-width: 0;\n    border-left-color: #919191;\n    border-left-style: solid;\n  }\n  .page_num {\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 14px;\n    *margin-right: 4px;\n    letter-spacing: normal;\n  }\n  .goto_area {\n    margin-left: 8px;\n  }\n  .goto_area input[type=\"text\"] {\n    vertical-align: middle;\n    width: 75px;\n    height: 30px;\n    line-height: 22px;\n    padding: 4px 0;\n    border: 1px solid #e7e7eb;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n    border-radius: 3px;\n    -moz-border-radius: 3px;\n    -webkit-border-radius: 3px;\n    text-align: center;\n    font-size: 14px;\n    margin-right: 4px;\n  }\n  /*.pagination*/ .btn {\n    min-width: 0;\n  }\n  .btn.page_first, .btn.page_last, .btn.page_go {\n    background-color: #fff;\n    background-image: -moz-linear-gradient(top,#fff 0,#fff 100%);\n    background-image: -webkit-gradient(linear,0 0,0 100%,from(#fff),to(#fff));\n    background-image: -webkit-linear-gradient(top,#fff 0,#fff 100%);\n    background-image: -o-linear-gradient(top,#fff 0,#fff 100%);\n    background-image: linear-gradient(to bottom,#fff 0,#fff 100%);\n    border-color: #e6e7ec;\n    color: #222;\n    height: 30px;\n    width: auto;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .modal-backdrop {\n    z-index: 2040 !important;\n  }\n\n  .modal {\n    z-index: 2050 !important;\n  }</style><div class=modal-header><button type=button class=close ng-click=$ctrl.cancel() data-dismiss=modal aria-hidden=true>&times;</button><h4 class=modal-title id=modalTitle>选择图片</h4></div><div class=\"modal-body modal_body\"><div id=groupList class=tag_list><div ng-repeat=\"item in $ctrl.groupData\"><div ng-class=\"{true:\'selected_group\',false:\'\'}[item.id==$ctrl.currentGroup]\"><a class=font1 id={{item.id}} style=\"margin: 0 20px\" ng-click=$ctrl.selectedGroup(item.id)>{{item.groupName}}({{item.attachmentCount}})</a></div></div><div style=\"padding: 5px 20px\"><a uib-popover-template=$ctrl.dynamicPopover.templateUrl popover-placement=bottom popover-is-open=$ctrl.isOpen class=font1 type=button>+新建分组</a></div><script type=text/ng-template id=popover.html><div>创建分组</div>\n      <div class=\"form-group\">\n        <input type=\"text\" ng-model=\"$ctrl.groupName\" class=\"form-control\" maxlength=\"30\">\n      </div>\n      <div class=\"form-group\" style=\"text-align: center;\">\n        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addTag()\">确定</button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.closeAddTag()\">取消</button>\n      </div></script></div><div id=modalContent class=modal_content><div id=localUpLoad class=local_upload><input type=file name=picture id=picture ng-model=$ctrl.picture accept=image/* onchange=angular.element(this).scope().$ctrl.upLoadImage() style=\"display: none\"> <button type=button ng-click=\"$ctrl.localUpLoad(\'picture\')\" class=\"btn btn-primary local_btn\">本地上传</button></div><div class=show_list><ul id=showList><li ng-repeat=\"item in $ctrl.imageData\" class=li_item ng-class=\"{\'selected_image\':item.selectFlag}\" ng-click=$ctrl.selectPicture($index)><div class=show_item id={{item.attachmentId}}><img class=item_style ng-src={{item.attachmentUrl}} alt=还没有上传图片哦！> <img ng-show=item.selectStatus class=selected_style ng-src=assets/images/umEdit/selected.png></div><div class=item_name_style><span>{{item.attachmentName}}</span></div></li></ul></div><div style=\"height: 45px;text-align: right;padding-right: 20px\" ng-show=\"$ctrl.sumPage>1\"><span class=page_nav_area><!--<a href=\"javascript:void(0);\" class=\"btn page_first\" style=\"display: none;\"></a>--> <a href=javascript:void(0); class=\"btn page_prev\" ng-show=\"$ctrl.curPage>1\" ng-click=$ctrl.prevPage()><i class=arrow></i></a> <span class=page_num><label>{{$ctrl.curPage}}</label><span class=num_gap>/</span><label>{{$ctrl.sumPage}}</label></span><a href=javascript:void(0); class=\"btn page_next\" ng-show=\"$ctrl.curPage<$ctrl.sumPage\" ng-click=$ctrl.nextPage()><i class=arrow></i></a><!--<a href=\"javascript:void(0);\" class=\"btn page_last\" style=\"display: none;\"></a>--> </span><span class=goto_area><input type=text ng-model=$ctrl.targetPage> <a href=javascript:void(0); class=\"btn page_go\" ng-click=$ctrl.skipPage()>跳转</a></span></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$ctrl.cancel() data-dismiss=modal id=closeBtn><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=button class=\"btn btn-primary\" ng-click=$ctrl.ok()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;确定</button></div>");
$templateCache.put("app/umEditor/perview.html","<p ng-bind-html=vm.perview></p>");
$templateCache.put("app/umEditor/popover.html","<div><input type=text></div>");
$templateCache.put("app/umEditor/selectSendPerson.html","<style>.modal_body{\n    padding:0;\n  }</style><form><div class=modal_body><div class=row><div class=col-lg-3><div class=corp-tree><uib-tabset active=activeForm><uib-tab index=0 heading=组织架构 select=vm.selectOrg()><div js-tree=vm.treeConfig ng-model=vm.jsTreeData tree=vm.treeInstance tree-events-obj=vm.treeEventsObj></div></uib-tab></uib-tabset></div></div><div class=col-lg-9><div class=content ng-show=vm.isOrgShow><div id=org-views ui-view=\"\" class=ng-scope><fieldset class=ng-scope><h2>{{vm.currentDept.deptName}}</h2></fieldset></div><div><table class=\"table table-striped\"><thead><tr><th width=10%>操作</th><th width=20%>姓名</th><th width=20%>账号</th><th width=20%>手机</th><th width=20%>邮箱</th><th width=10%>状态</th></tr></thead><tbody><tr ng-show=vm.isSpinnerShow><td colspan=6><div class=spiner-example><div class=\"sk-spinner sk-spinner-pulse\"></div></div></td></tr><tr ng-repeat=\"staff in vm.staffs track by staff.userId\" ng-show=vm.isStaffShow><td><input type=checkbox ng-checked=vm.isChecked(staff.userName) ng-click=vm.updateSelection($event,staff.userName)></td><td>{{staff.userName}}</td><td>{{staff.accountNumber}}</td><td>{{staff.mobile}}</td><td>{{staff.email}}</td><td>{{staff.empStatus}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;发送</button></div></div></div></div></form>");
$templateCache.put("app/umEditor/umeditor.html","<style>.ueditor {\n    width: 100%;\n    margin-bottom: 1.25rem;\n  }\n  .edui-editor {\n    width: 100% !important;\n  }\n  .ueditorForm {\n    max-width: 1500px;\n  }\n\n  .edui-editor-iframeholder {\n    min-height: 450px !important;\n    width: 100% !important;\n  }\n\n  .edui-editor-bottomContainer {\n    display: none !important;\n  }\n\n  .ibox-content {\n    border: 1px solid gainsboro;\n    /*padding-top: 50px;*/\n  }\n\n  .font1 {\n    line-height: 1.6;\n    font-family: \"Helvetica Neue\",\"Hiragino Sans GB\",\"Microsoft YaHei\",\"\\9ED1\\4F53\",Arial,sans-serif;\n    color: #222;\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .font2 {\n    line-height: 1.6;\n    font-family: \"Helvetica Neue\",\"Hiragino Sans GB\",\"Microsoft YaHei\",\"\\9ED1\\4F53\",Arial,sans-serif;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 400;\n  }\n  .font3 {\n    line-height: 1.6;\n    font-family: \"Helvetica Neue\",\"Hiragino Sans GB\",\"Microsoft YaHei\",\"\\9ED1\\4F53\",Arial,sans-serif;\n    color: #222;\n    font-size: 12px;\n    font-weight: 300;\n  }\n\n  /*右侧*/\n  .tpl_list {\n    border: 1px solid #e7e7eb;\n    border-top-width: 0;\n    padding-left: 0;\n    list-style-type: none;\n  }\n  .tpl_item {\n    border-top: 1px solid #e7e7eb;\n    background-color: #fff;\n    text-align: left;\n    padding-left: 20px;\n    line-height: 50px;\n    cursor: pointer;\n  }\n  .tpl_item:hover {\n    border: 1px solid #43b548;\n    margin: 0 -1px -1px;\n    position: relative;\n    z-index: 1;\n    color: #43b548;\n    zoom: 1;\n  }\n\n\n  /*左侧添加图文*/\n  .item_default{\n    color: #c0c0c0;\n    text-align: center;\n    height: 88px;\n    font-weight: 400;\n    font-style: normal;\n    background-color: #ececec;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .item_other{\n    width: 51%;\n    height: 70px;\n    float: right;\n    color: #c0c0c0;\n    text-align: center;\n    font-weight: 400;\n    font-style: normal;\n    background-color: #ececec;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .item_other img{\n    height: 70px;\n    width: 100%;\n  }\n\n  .item_default img{\n    height: 88px;\n    width: 100%;\n  }\n  .create_access_primary {\n    display: block;\n    border: 2px dotted #d9dadc;\n    line-height: 60px;\n    font-size: 0;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  .appmsg_add {\n    margin: 0;\n    border-top-width: 0;\n    line-height: 90px;\n  }\n  .imgTitle {\n    padding-right: 10px;\n  }\n  .image_text_opereate{\n    font-size: 14px;\n    padding-top: 0;\n    line-height: 28px;\n    position: absolute;\n    bottom: -10px;\n    left: 0;\n    right: 0;\n    background: rgba(0,0,0,0.6)!important;\n  }\n  .image_text_title{\n    font-size: 14px;\n    padding-top: 0;\n    /*line-height: 28px;*/\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: rgba(0,0,0,0.6)!important;\n    word-break: break-all;\n    max-height: 30%;\n    overflow: hidden;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 0 8px;\n    color: #fff;\n  }\n  .image_text_title_other{\n    width: 40%;\n    float: left;\n    word-break: break-all;\n    max-height: 90%;\n    overflow: hidden;\n  }\n  .image_text_first{\n    position:relative;\n    height: 108px;\n    border: 1px solid #e7e7eb;\n    cursor: pointer;\n    padding: 10px;\n  }\n  .image_text_other{\n    position:relative;\n    height:95px;\n    border: 1px solid #e7e7eb;\n    cursor: pointer;\n    padding: 10px;\n  }\n.select_image_text{\n  border: 2px solid #43b548\n}</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>图文编辑</h5></div><div class=\"ibox-content col-lg-12\"><input type=file id=coverImg accept=image/* style=\"display: none\"><div class=col-lg-2 style=width:220px><div style=\"padding: 10px 20px 0\"><h4 class=font1>图文列表</h4></div><div style=\"padding: 20px\"><div id=imageTextList><div index={{$index}} id=imageText{{item}} ng-repeat=\"item in vm.articleArr\" ng-class=\"{\'image_text_first\':$index==0,\'image_text_other\':$index!=0,\'select_image_text\':item==vm.curShowCount}\" ng-click=vm.imageTextSelected(item) ng-mouseover=vm.onMouseOverImageText(item) ng-mouseout=vm.onMouseOutImageText()><!--repeatFinish=\"vm.imageTextSelected(item)\"--><h4 name=imageTextTitle ng-class=\"{true:\'image_text_title font2\',false:\'image_text_title_other font1\'}[$index==0]\"><p name=title>标题:{{vm.articles[item].contentTitle}}</p></h4><h4 class=image_text_opereate style=\"z-index: 99\" ng-show=\"vm.show==item\" id=opreate{{item}}><a class=font2 name=down href=javascript:void(0); ng-click=vm.imageTextDown($index) ng-show=\"$index<vm.articleArr.length-1\" style=\"float: left\" title=向下><img ng-src=assets/images/umEdit/down.png> </a><a class=font2 name=up href=javascript:void(0); ng-click=vm.imageTextUp($index) ng-show=\"$index>0\" style=\"float: left\" title=向上><img ng-src=assets/images/umEdit/up.png> </a><a class=font2 name=delete href=javascript:void(0); ng-click=vm.imageTextDel($index) ng-show=\"$index>0\" style=\"float: right\" title=删除><img ng-src=assets/images/umEdit/delete.png></a></h4><div name=imageTextCover ng-class=\"{true:\'item_default\',false:\'item_other\'}[$index==0]\"><img ng-src=assets/images/umEdit/picture.png name=coverImg ng-if=\"vm.articles[item].contentCover==null\"> <img ngf-src=vm.articles[item].contentCover name=coverImg ng-if=\"vm.articles[item].contentCover!=null\"></div></div></div><a ng-click=vm.addImageText() id=imageTextAdd title=添加一篇图文 class=\"create_access_primary appmsg_add\" id=js_add_appmsg href=javascript:void(0);><img class=imgTitle ng-src=assets/images/umEdit/cc-plus.png></a></div></div><div class=col-lg-7><form class=\"form-horizontal ng-pristine ng-valid ueditorForm\" id=form><div class=form-group><div class=row><div class=col-lg-12><label class=\"col-lg-1 control-label\">标题</label><div class=col-lg-11><input type=text name=title ng-model=vm.article.contentTitle ng-change=vm.titleInput() class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false placeholder=请输入文章标题></div></div></div></div><div class=form-group><div class=row><div class=col-lg-12><label class=\"col-lg-1 control-label\">作者</label><div class=col-lg-11><input type=text name=author ng-model=vm.article.contentAuthor class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false placeholder=请输入文章作者></div></div></div></div><div class=form-group><div class=row><div class=col-lg-12><label class=\"col-lg-1 control-label\">正文</label><div class=col-lg-11><div id=myUeditor class=ueditor ng-model=\"vm.article.contentBody  \"></div></div></div></div></div><div class=form-group><div class=row><div class=col-lg-12><div class=col-lg-1></div><label class=col-lg-2><input type=checkbox name=isShowContentSourceUrl ng-model=vm.article.isShowContentSourceUrl> <span class=font1>原文链接</span></label></div></div><div class=row ng-show=vm.article.isShowContentSourceUrl><div class=col-lg-12><label class=\"col-lg-1 control-label\"></label><div class=col-lg-8><input type=text name=contentSourceUrl ng-model=vm.article.contentSourceUrl maxlength=200 class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-12><div class=col-lg-1></div><label class=col-lg-3>模版</label><div class=col-lg-8><select class=form-control id=userRole name=userRole ng-model=vm.article.templateId ng-options=\"e.id as e.templateName for e in vm.templates\" required><option value=\"\">请选择</option></select></div></div></div><div class=row><div class=col-lg-12><div class=col-lg-1></div><label class=col-lg-4><span class=font1>发布样式编辑器</span></label></div></div><div class=row><div class=col-lg-12><div class=col-lg-1></div><label class=col-lg-6><span class=font1>{{vm.coverRemark}}</span></label></div></div><div class=row><div class=col-lg-12><label class=\"col-lg-1 control-label\"></label><div class=col-lg-8><button type=button ng-click=\"vm.localUpLoad(\'coverImg\')\" class=\"btn btn-primary\">本地上传</button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.insertImage(\'cover\')\">从图片库中选取</button></div></div></div><div class=row><div class=col-lg-12><label class=\"col-lg-1 control-label\"></label><div class=col-lg-8><input type=hidden name=cover ng-model=vm.article.contentCover> <img width=100px height=100px name=coverImg ngf-src=vm.article.contentCover> <span name=coverDescription></span></div></div></div></div><div class=form-group><div class=row><div class=col-lg-12><label class=\"col-lg-1 control-label\">摘要</label><div class=col-lg-11><textarea cols=30 rows=5 id=subject ng-model=vm.article.contentSubject class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false placeholder=请输入文章摘要100字以内></textarea></div></div></div></div><div class=form-group><div class=row><div class=col-lg-12><label class=\"col-lg-1 control-label\"></label><div class=\"col-lg-11 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ng-click=vm.submitEdit()>保存</a> <a class=\"btn btn-w-m btn-info\" ng-click=vm.send(vm.article)>发布</a> <a class=\"btn btn-w-m btn-info\" ng-click=vm.perview()>预览</a></div></div></div></div></form></div><div class=col-lg-2><div style=\"max-width: 200px\"><div style=\"padding: 10px 20px 0\"><h4 class=c>多媒体</h4></div><div style=\"padding: 20px\"><ul class=tpl_list id=multiMediaList><li class=\"tpl_item img\" ng-click=\"vm.insertImage(\'content\')\"><img class=imgTitle ng-src=assets/images/umEdit/picture.png> 图片</li><li class=tpl_item ng-click=vm.insertRedio(this) data-toggle=modal data-target=#mediaModal2><img class=imgTitle ng-src=assets/images/umEdit/radio.png> 视频</li><li class=tpl_item ng-click=vm.insertMusic(this) data-toggle=modal data-target=#mediaModal3><img class=imgTitle ng-src=assets/images/umEdit/music.png> 音乐</li><li class=tpl_item ng-click=vm.insertVote(this) data-toggle=modal data-target=#mediaModal4><img class=imgTitle ng-src=assets/images/umEdit/vote.png> 投票</li></ul></div></div></div></div></div></div></div></div>");
$templateCache.put("app/wecorpAgent/wecorpAgent.html","<style>.agent-detail{\n  border-bottom: 1px solid #C8CACD;\n  padding: 17px 0 12px;\n  display: inline-block;\n  width: 950px;\n  text-align: left;\n}\n.agent-detailtitle{\n  padding-left: 20px;\n  color: #000;\n  vertical-align: top;\n  line-height: 34px;\n  display: inline-block!important;\n  font-size: 14px;\n}\n.agent-detail-logo{\n  width:80px;\n  height:80px;\n}\n.agent-detailcontent-onlyread{\n  padding-left: 20px;\n  color: #000;\n  vertical-align: top;\n  line-height: 34px;\n  display: inline-block!important;\n  font-size: 14px;\n}</style><alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>微信企业号应用管理</h5></div><div class=ibox-content><ul ng-repeat=\"agent in vm.agent\" style=\"list-style: none;text-align: center;overflow: auto\"><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>应用logo</span></div><div class=col-lg-2 style=\"width: 110px\"><img id=logo-url alt=image class=\"img-circle agent-detail-logo\" ng-src={{agent.square_logo_url}} ng-show=!vm.isfile> <img id=logo-file class=\"img-circle agent-detail-logo\" ngf-src=vm.file ng-show=vm.isfile></div><div class=col-lg-4><div class=form-group><div class=col-lg-10><input type=file ng-model=vm.file ngf-select name=file accept=image/* ng-change=vm.chooseImage()></div><div class=col-lg-10><button type=button style=\"margin-top: 10px;padding:3px 5px 3px\" class=\"btn btn-primary\" ng-click=vm.cancelChooseImage() ng-show=vm.isfile>撤消</button></div></div></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>应用名称</span></div><div class=col-lg-8><input type=text ng-model=agent.name class=form-control></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>应用类型</span></div><div class=col-lg-8><select class=form-control ng-model=agent.type ng-options=\"x.code as x.name for x in vm.agentType\" class=form-control ng-selected=\"x.code==agent.type\" disabled></select></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>应用ID</span></div><div class=col-lg-8><span class=agent-detailcontent-onlyread>{{agent.agentid}}</span></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>应用描述</span></div><div class=col-lg-8><input type=text ng-model=agent.description class=form-control></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>Token</span></div><div class=col-lg-8><input type=text ng-model=agent.token class=form-control></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>EncodingAESKey</span></div><div class=col-lg-8><input type=text ng-model=agent.encodingAesKey class=form-control></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>可信域名</span></div><div class=col-lg-8><input type=text ng-model=agent.redirect_domain class=form-control></div></div></li><li class=agent-detail ng-if=\" agent.type == 2 \"><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>主页URL</span></div><div class=col-lg-8><input type=text ng-model=agent.home_url class=form-control></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>是否接受用户变更通知</span></div><div class=col-lg-8><select class=form-control ng-model=agent.isreportuser ng-options=\"x.code as x.name for x in vm.reportuserFlag\" class=form-control ng-selected=\"x.code==agent.isreportuser\"></select></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>是否上报用户进入应用事件</span></div><div class=col-lg-8><select class=form-control ng-model=agent.isreportenter ng-options=\"x.code as x.name for x in vm.reportenterFlag\" class=form-control ng-selected=\"x.code==agent.isreportenter\"></select></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>企业应用是否打开地理位置上报</span></div><div class=col-lg-8><select class=form-control ng-model=agent.report_location_flag ng-options=\"x.code as x.name for x in vm.reportLocationFlag\" class=form-control ng-selected=\"x.code==agent.report_location_flag\"></select></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>关联会话url</span></div><div class=col-lg-8><input type=text ng-model=agent.chat_extension_url class=form-control></div></div></li><li class=agent-detail><div class=col-lg-8><div class=col-lg-3><span class=agent-detailtitle>自定义菜单</span></div><div class=col-lg-8><button type=button class=\"btn btn-primary\" ng-click=vm.setCustomMenu(vm.wecorpAgent)>设置</button></div></div></li></ul><div class=form-group ng-if=\"vm.showSubmintButtonFlag == true\"><div class=row><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel() style=\"margin-right: 30px\">&nbsp;&nbsp;Cancel&nbsp;&nbsp;</button> <button type=button class=\"btn btn-primary\" ng-click=vm.save()>保存</button></div></div></div></div></div></div></div>");
$templateCache.put("app/wecorpAgent/wecorpAgentCustomMenu.html","<style>.custom_menu_preview_wrap {\n    width: 392px;\n    height: 642px;\n    margin: 30px auto;\n    position: relative;\n    background: url(https://res.wx.qq.com/mmocbiz/zh_CN/tmt/pc/dist/img/dev/custom_menu_bg_3fcfc347.png) 0 0 no-repeat;\n  }\n  .custom_menu_preview_content {\n    height: 438px;\n    top: 82px;\n    left: 22px;\n    width: 318px;\n  }\n  .custom_menu_preview_menu{\n    padding-top: 84px;\n    padding-left: 9px;\n  }\n  .custom_menu_preview_bar {\n    /*position: absolute;*/\n    height: 40px;\n    bottom: 81px;\n    right: 22px;\n    width: 272px;\n    margin-left: 60px;\n    display: flex;\n  }\n  .custom_menu_preview_item {\n    /*width: 90px;*/\n    /*position: relative;*/\n    text-align: center;\n    cursor: pointer;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    float: left;\n    height: 40px;\n    padding-top: 8px;\n    font-size: 14px;\n    display: inline-block;\n    border-left:1px solid #ccc\n  }\n  .as-sortable-dragging .custom_menu_preview_item {\n    /*width: 90px;*/\n    /*position: relative;*/\n    text-align: center;\n    cursor: pointer;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    float: left;\n    height: 40px;\n    padding-top: 8px;\n    font-size: 14px;\n    display: inline-block;\n    border:none;\n  }\n  .custom_menu_preview_button {\n    color: #242424;\n  }\n  #horizontal-container {\n    display: inline-block;\n  }\n  .as-sortable-dragging{\n    display: inline-block;\n    border: 1px solid #ccc;\n    margin-left:-5px;\n  }\n  .as-sortable-dragging .custom_menu_preview_float_button_wrap{\n    left:0px;\n    margin-bottom:45px;\n  }\n  .custom_menu_arrow{\n    display: inline-block;\n    position: absolute;\n    bottom: -5px;\n    height: 5px;\n    width: 10px;\n    left: 50%;\n    margin-left: -5px;\n    vertical-align: middle;\n  }\n  .custom_menu_down{\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-color: #ccc transparent transparent;\n    border-width: 5px 5px 0;\n    left: 0;\n    bottom: 0;\n  }\n  .custom_menu_up {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-color: #f1f1f1 transparent transparent;\n    border-width: 5px 5px 0;\n    left: 0;\n    bottom: 1px;\n  }\n  .custom_menu_preview_float_button_wrap.as-sortable-dragging{\n    position: absolute;\n    min-width: 140px;\n    /*left: 50%;*/\n    margin-left: -5px;\n    margin-top:0px;\n    /*bottom: 50px;*/\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    background-color: #f1f1f1;\n    text-align: center;\n  }\n  .custom_menu_preview_float_button_wrap{\n    position: absolute;\n    min-width: 140px;\n    /*left: 50%;*/\n    margin-left: -70px;\n    /*bottom: 50px;*/\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    background-color: #f1f1f1;\n    text-align: center;\n  }\n  .custom_menu_preview_float_button{\n    display: block;\n    color: #242424;\n    padding: 6px 10px;\n    border-top: 1px solid #ccc;\n  }\n\n  .as-sortable-dragging .custom_menu_preview_float_button{\n    /*width: 90px;*/\n    /*position: relative;*/\n    display: block;\n    color: #242424;\n    padding: 6px 10px;\n    border-top:none;\n  }\n\n  .icon {\n    display: inline-block;\n    width: 24px;\n    height: 24px;\n    background-image: url(\"assets/images/wecorp_icon.png\");\n    background-repeat: no-repeat!important;\n  }\n  .icon_arrow_down {\n    width: 8px;\n    height: 8px;\n    background-position: -64px -96px;\n  }\n  .icon_remove, .icon_remove_gray {\n    width: 16px;\n    height: 17px;\n    background-position: -160px -32px;\n  }\n  .icon_add {\n    width: 18px;\n    height: 18px;\n    background-position: 0 0;\n    vertical-align: middle;\n  }\n  .icon_edit_gray {\n    height: 16px;\n    width: 16px;\n    background-position: -192px -33px;\n  }\n  .icon_add_small {\n    width: 14px;\n    height: 14px;\n    background-position: -32px -160px;\n  }\n  .custom_menu_list .icon_remove {\n    margin: 8px 0 0 10px;\n    opacity: 0;\n    filter: alpha(opacity=0);\n  }\n  .custom_menu_name{\n    height: 34px;\n    line-height: 34px;\n    display: inline-block;\n    vertical-align: middle;\n    cursor: pointer;\n    font-size: 14px;\n    padding-left: 4px;\n  }\n\n  .custom_sub_menu_name{\n    height: 34px;\n    line-height: 24px;\n    display: inline-block;\n    vertical-align: middle;\n    cursor: pointer;\n    font-size: 14px;\n  }\n  .menuPageBtn {\n    box-sizing: content-box;\n    display: inline-block;\n    height: 28px;\n    margin: 0;\n    padding: 0 10px;\n    min-width: 30px;\n    text-align: center;\n    font-size: 14px;\n    line-height: 28px;\n    color: #222;\n    border: 1px solid #c8c8c8;\n    border-radius: 2px;\n    background: -moz-linear-gradient(top,#fdfdfd 0,#eff1f4 100%);\n    background: -webkit-linear-gradient(top,#fdfdfd 0,#eff1f4 100%);\n    background: -o-linear-gradient(top,#fdfdfd 0,#eff1f4 100%);\n    background: -ms-linear-gradient(top,#fdfdfd 0,#eff1f4 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#FDFDFD\', endColorstr=\'#EFF1F4\', GradientType=0);\n    background: linear-gradient(top,#fdfdfd 0,#eff1f4 100%);\n    cursor: default;\n    -webkit-user-select: none;\n  }\n  .custom_menu_addName {\n    height: 34px;\n    line-height: 34px;\n    display: inline-block;\n    vertical-align: middle;\n    cursor: pointer;\n  }\n  .btndisabled{\n    background-image:none;\n    background-color:#e3e3e3;\n    pointer-events:none;\n    color: #969696;\n  }\n  .menu-bcackground{\n    background-color: #ffffff;\n  }\n  .menu-bcackground-selected{\n    background-color: #eaeaea;\n  }\n  .menu-width-0{\n    width:0px;\n  }\n  .menu-width-1{\n    width:270px;\n  }\n  .menu-width-2{\n    width:135px;\n  }\n  .menu-width-3{\n    width:92px;\n  }\n\n  .submenu-style--1{\n    margin-top:-51px;\n  }\n  .submenu-style--2{\n    margin-top:-84px;\n  }\n  .submenu-style--3{\n    margin-top:-117px;\n  }\n  .submenu-style--4{\n    margin-top:-150px;\n  }\n  .submenu-style--5{\n    margin-top:-183px;\n  }\n\n\n\n  .submenu-style-1{\n    margin-left:64px;\n  }\n  .submenu-style-2{\n    margin-left:-3px;\n  }\n  .submenu-style-3{\n    margin-left:-28px;\n  }\n\n  .tr-selected{\n    background-color: red;\n  }\n  .tr-unselected{\n  }</style><alert-error></alert-error><div class=row id=menuBody><div class=col-lg-8><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>自定义菜单</h5></div><div class=ibox-content style=\"padding-left: 0;padding-right: 0;padding-top: 10px\"><ul style=\"margin-bottom:0px;list-style: none;text-align: center;overflow: auto;padding-left: 0px;border-bottom: 1px solid #e5e5e5\"><li style=\"list-style: none\"><div class=col-lg-12 style=\"padding-top: 5px;padding-bottom: 10px;width:92%\">可创建最多 3 个一级菜单，每个一级菜单下可创建最多 5 个二级菜单。编辑中的菜单不会马上被用户看到，请放心调试。</div></li><a class=\"menuPageBtn btn_margin_right js_add_menu\" ng-click=vm.addMenu() ng-class=\"{3:\'disabled btndisabled\'}[vm.menus.button.length]\" style=\"margin-bottom: 8px\"><span class=\"icon icon_add\"></span><span class=hide>添加菜单</span></a></ul><ul data-ng-model=vm.menus.button style=\"list-style: none;text-align: left;overflow: auto;padding-left: 0px;color:black\"><li ng-repeat=\"menu in vm.menus.button\" style=\"list-style: none;text-align: left;overflow: auto\"><div ng-init=\"inputShow=false\" class=col-lg-12 style=\"padding-bottom: 5px;padding-top: 5px;border-bottom: 1px solid #e5e5e5\" ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[show]\" ng-mouseenter=\"show = true\" ng-mouseleave=\"show = false\"><span class=\"icon icon_arrow_down\"></span> <span class=custom_menu_name ng-show=\"inputShow == false\">{{menu.name}}</span> <input focus-me={{inputShow}} type=text class=\"custom_menu_input js_add_2_menu js_input_limit\" ng-show=\"inputShow == true\" ng-blur=\"inputShow = false\" ng-model=menu.name style=\"line-height: 24px;font-size: 14px;margin-bottom: 4px;margin-top: 0px;width:130px\"> <a class=\"icon icon_edit_gray js_change_name\" ng-show=\"show == true\" style=\"position: absolute;left: 160px;top: 14px\" ng-click=\"inputShow=true\"></a><select ng-if=\"menu.sub_button==null||menu.sub_button.length==0\" style=\"width: 160px;display: inline-block;position: absolute;right: 250px\" class=form-control ng-model=menu.type ng-options=\"x.code as x.name for x in vm.menuType\" class=form-control ng-selected=\"x.code==menu.type\"></select><div ng-if=\"menu.sub_button==null||menu.sub_button.length==0\" style=\"display: inline-block;position: absolute;right:65px\"><div style=\"display: inline-block;font-size: 14px\">Key:</div><input type=text class=\"custom_menu_input js_add_2_menu js_input_limit\" ng-model=menu.key style=\"line-height: 24px;font-size: 14px;margin-bottom: 4px;margin-top: 0px;width:130px;padding-left: 5px\"></div><a class=\"icon icon_remove float-right js_menu_remove\" ng-show=\"show == true\" style=\"position: absolute;right: 10px;top: 11px\" ng-click=vm.deleteMenu($index,-1)></a></div><ul data-ng-model=menu.sub_button style=\"list-style: none;text-align: left;overflow: auto;padding-left: 15px;color:black\"><li ng-repeat=\"sub_button in menu.sub_button\" style=\"list-style: none;text-align: left;overflow: auto;border-bottom: 1px solid #e5e5e5\"><div class=col-lg-12 ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[show]\" style=\"padding-bottom: 5px;padding-top: 0px\" ng-init=\"inputShow=false\" ng-mouseenter=\"show = true\" ng-mouseleave=\"show = false\"><span class=custom_sub_menu_name style=\"padding-bottom: 8px;padding-top: 8px\" ng-show=\"inputShow == false\">{{sub_button.name}}</span> <input focus-me={{inputShow}} type=text class=\"custom_menu_input js_add_2_menu js_input_limit\" ng-show=\"inputShow == true\" ng-blur=\"inputShow = false\" ng-model=sub_button.name style=\"line-height: 24px;font-size: 14px;margin-bottom: 0px;margin-top: 4px;width:140px\"> <a class=\"icon icon_edit_gray js_change_name\" ng-show=\"show == true\" style=\"position: absolute;left: 160px;top: 11px\" ng-click=\"inputShow=true\"></a><select style=\"width: 160px;display: inline-block;position: absolute;right: 250px;margin-top: 2.5px\" class=form-control ng-model=sub_button.type ng-options=\"x.code as x.name for x in vm.menuType\" class=form-control ng-selected=\"x.code==sub_button.type\"></select><div style=\"display: inline-block;position: absolute;right:65px;margin-top: 5px\"><div style=\"display: inline-block;font-size: 14px\">Key:</div><input type=text class=\"custom_menu_input js_add_2_menu js_input_limit\" ng-model=sub_button.key style=\"line-height: 24px;font-size: 14px;margin-bottom: 4px;margin-top: 0px;width:130px;padding-left: 5px\"></div><a class=\"icon icon_remove float-right js_menu_remove\" ng-show=\"show == true\" style=\"position: absolute;right: 10px;top: 11px\" ng-click=vm.deleteMenu($parent.$index,$index)></a></div></li></ul><div ng-init=\"showedit=false\" ng-show=\"menu.sub_button==null||menu.sub_button.length<5\" ng-click=\"showedit=true\" style=\"padding-left:40px;border-bottom: 1px solid #e5e5e5\"><span ng-show=\"showedit==false\" class=\"icon icon_add_small\" style=\"position: absolute;margin-top: 9px\"></span> <span ng-show=\"showedit==false\" class=\"custom_menu_addName gray\" style=\"margin-left: 25px;font-size: 14px\">添加二级菜单</span><div ng-show=\"showedit==true\" style=\"display: inline-block\">输入菜单名添加子菜单</div><input focus-me={{showedit}} ng-show=\"showedit==true\" type=text class=\"custom_menu_input js_add_2_menu js_input_limit\" ng-blur=\"showedit=false;vm.addSubMenuOperation($index)\" ng-model=vm.addSubMenuName style=\"line-height: 24px;font-size: 14px;margin-bottom: 8px;margin-top: 10px;width: 200px;margin-left: 10px\"></div></li><div ng-show=\"vm.addMenuInputShowFlag == true\" style=\"padding-left:15px;border-bottom: 1px solid #e5e5e5\"><div style=\"display: inline-block\">输入菜单名添加主菜单</div><input focus-me={{vm.addMenuInputShowFlag}} type=text class=\"custom_menu_input js_add_2_menu js_input_limit\" ng-blur=\"vm.addMenuInputShowFlag=false;vm.addMenuOperation()\" ng-model=vm.addMenuName style=\"line-height: 24px;font-size: 14px;margin-bottom: 8px;margin-top: 10px;width: 200px;margin-left: 10px\"></div></ul><div class=form-group><div class=row><div class=text-left style=\"padding-left: 50px\"><a class=\"menuPageBtn btn_margin_right js_add_menu\" ng-class=\'{false:\"btndisabled\",true:\"\"}[vm.saveMenuButtonCanClick]\' ng-click=vm.saveMenu() style=\"margin-bottom: 8px\"><span>保存</span></a> <a class=\"menuPageBtn btn_margin_right js_add_menu\" ng-click=vm.releaseMenu() ng-class=\'{false:\"btndisabled\",true:\"\"}[vm.releaseMenuButtonCanClick]\' style=\"margin-bottom: 8px;margin-left: 5px\"><span>发布</span></a> <a class=\"menuPageBtn btn_margin_right js_add_menu\" ng-click=vm.deleteReleaseMenu() ng-class=\'{false:\"btndisabled\",true:\"\"}[vm.deletereleaseMenuButtonCanClick]\' style=\"margin-bottom: 8px;margin-left: 5px\"><span>清空已发布菜单</span></a> <a class=\"menuPageBtn btn_margin_right js_add_menu\" ng-click=vm.newMenu() style=\"margin-bottom: 8px;margin-left: 5px\"><span>新建</span></a> <input type=text class=\"custom_menu_input js_add_2_menu js_input_limit\" ng-model=vm.menuName style=\"line-height: 24px;font-size: 14px;margin-bottom: 8px;margin-top: 10px;width: 200px;margin-left: 10px\"></div></div></div></div></div></div><div class=col-lg-4 style=\"padding-left: 0\"><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>预览</h5></div><div class=ibox-content style=\"background-color: #f8f8f8\"><div class=mc_content><div class=custom_menu_preview_wrap><div class=custom_menu_preview_menu><div class=\"custom_menu_preview_content js_menu_preview\"></div><div id=menu><div as-sortable=vm.sortableOptions data-ng-model=vm.menus.button class=\"sortable-row custom_menu_preview_bar js_menu_bar custom_menu_count0\"><div ng-repeat=\"menu in vm.menus.button\" ng-click=vm.clickMenu($index) class=custom_menu_preview_item ng-class=\"{0:\'menu-width-0\',1:\'menu-width-1\',2:\'menu-width-2\',3:\'menu-width-3\'}[vm.menus.button.length]\" as-sortable-item><div ng-show=vm.isShowMenu($index,vm.showSubMenu,menu.sub_button) data-ng-model=menu.sub_button as-sortable=vm.sortableOptions1 class=\"sortable-row custom_menu_preview_float_button_wrap js_sub_menu custom_menu_preview_float_button_1\" ng-class=\"{1:{1:\'submenu-style-1 submenu-style--1\',2:\'submenu-style-2 submenu-style--1\',3:\'submenu-style-3 submenu-style--1\'}[vm.menus.button.length],2:{1:\'submenu-style-1 submenu-style--2\',2:\'submenu-style-2 submenu-style--2\',3:\'submenu-style-3 submenu-style--2\'}[vm.menus.button.length],3:{1:\'submenu-style-1 submenu-style--3\',2:\'submenu-style-2 submenu-style--3\',3:\'submenu-style-3 submenu-style--3\'}[vm.menus.button.length],4:{1:\'submenu-style-1 submenu-style--4\',2:\'submenu-style-2 submenu-style--4\',3:\'submenu-style-3 submenu-style--4\'}[vm.menus.button.length],5:{1:\'submenu-style-1 submenu-style--2\',5:\'submenu-style-2 submenu-style--5\',3:\'submenu-style-3 submenu-style--5\'}[vm.menus.button.length]}[menu.sub_button.length]\"><a ng-repeat=\"sub_button in menu.sub_button\" class=\"custom_menu_preview_float_button js_click_menu\" data-id=0-0 href=javascript:; as-sortable-item><div as-sortable-item-handle>{{sub_button.name}}</div></a><span class=custom_menu_arrow><span class=custom_menu_down></span> <span class=custom_menu_up></span></span></div><div as-sortable-item-handle>{{menu.name}}</div></div></div></div></div></div></div></div></div></div></div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>菜单历史记录</h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">菜单名称</label><div class=col-lg-8><input type=text ng-model=vm.agent.menuName class=form-control></div></div><div class=col-lg-8></div></div></div><div class=form-group><div class=row><div class=col-lg-4></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset id=searchReset>重置</button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()>搜索</button></div></div></div></div></form><div class=hr-line-dashed></div><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th>操作</th><th>序号</th><th>菜单名称</th><th>是否使用中</th><th>创建时间</th><th>更新时间</th></tr></thead><tbody><tr ng-repeat=\"menu in vm.menuList \"><td><a ng-show=\"menu.id!=vm.menuSelectedId\" ng-click=vm.editRecord(menu,menu.id)><i class=\"fa fa-edit text-warning\">编辑</i></a> <a ng-show=\"menu.id==vm.menuSelectedId\"><i class=\"fa fa-desktop text-warning\" style=color:red>编辑中</i></a> <a ng-click=vm.deleteRecord(menu.id)><i class=\"fa fa-times text-warning\">删除</i></a></td><td>{{$index+1}}</td><td>{{menu.menuName}}</td><td>{{menu.enableFlag}}</td><td>{{menu.creationDate}}</td><td>{{menu.lastUpdateDate}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/wecorpAgent/wecorpAgentList.html","<alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>微信企业号应用管理</h5></div><div class=ibox-content style=\"display: flex\"><ul class=\"app_box js_myContainer\" style=position:relative;padding:0><li style=\"list-style: none;position: relative;float: left;margin-right:10px;\n        margin-left:10px;margin-bottom: 10px;width: 104px;text-align: center;padding: 48px 6px 20px\" ng-repeat=\"agent in vm.agentList\"><a href=#app/wecorpAgentList/{{agent.agentid}}/wecorpAgent class=\"logo_img border_alpha\"><img alt=image class=img-circle style=width:80px;height:80px ng-src={{agent.square_logo_url}}></a><h3 style=\"width:92px;text-align: center;font-size: 14px;font-weight: 400;overflow: hidden;text-overflow: ellipsis;white-space: nowrap\">{{agent.name}}</h3></li></ul></div></div></div></div>");
$templateCache.put("app/workflowApv/selectInfHeaderModal.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>选择系统</h4></div><div class=modal-body><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>选择</th><th>系统代码</th><th>系统名称</th><!--<th>系统类型</th>--><th>接口类型</th><th>系统地址</th><th>请求方式</th></tr></thead><tbody><tr><td><input type=radio ng-model=$parent.vm.selectedHeaders name=InfHeader ng-value=\"\"></td><td colspan=5>不选择</td></tr><tr ng-repeat=\"header in vm.headers\"><td><input type=radio ng-model=$parent.vm.selectedHeaders name=InfHeader ng-value=header></td><td>{{header.interfaceCode}}</td><td>{{header.name}}</td><!--<td>{{header.systemType.description}}</td>--><td>{{header.interfaceType}}</td><td>{{header.domainUrl}}</td><td>{{header.requestMethod}}</td></tr></tbody></table></div></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-primary\" ng-click=vm.save()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 确定</span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span>关闭</span></button><!--<delete-button confirm=\"vm.deleteFunctionResource()\" confirm-message=\"123\"></delete-button>--></div></div></div>");
$templateCache.put("app/workflowApv/selectInfModal.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>选择接口</h4></div><div class=modal-body><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>选择</th><th>接口代码</th><th>接口名称</th><th>接口地址</th></tr></thead><tbody><tr><td><input type=radio ng-model=$parent.vm.selectedLines name=InfLine ng-value=\"\"></td><td colspan=5>不选择</td></tr><tr ng-repeat=\"line in vm.lines\"><td><input type=radio ng-model=$parent.vm.selectedLines name=InfLine ng-value=line></td><td>{{line.lineCode}}</td><td>{{line.lineName}}</td><td>{{line.iftUrl}}</td></tr></tbody></table></div></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-primary\" ng-click=vm.save()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span> 确定</span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span>关闭</span></button></div></div></div>");
$templateCache.put("app/wxSetMenu/wxSetMenu-edit.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>菜单管理</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">菜单类型</label><div class=col-lg-8><input type=text id=info name=menuType ng-model=vm.menu.menuType class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">菜单名</label><div class=col-lg-8><input type=text id=state name=menuName ng-model=vm.menu.menuName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">上级菜单</label><div class=col-lg-8><select class=form-control id=target name=target ng-model=vm.menu.parentId ng-options=\"e.id as e.menuName for e in vm.menus\"><option value=\"\">请选择</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">资源内容</label><div class=col-lg-8><input type=text id=paperId name=content ng-model=vm.menu.content class=form-control></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/wxSetMenu/wxSetMenu-new.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>菜单管理</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">菜单类型</label><div class=col-lg-8><input type=text id=info name=menuType ng-model=vm.menu.menuType class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">菜单名</label><div class=col-lg-8><input type=text id=state name=menuName ng-model=vm.menu.menuName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">上级菜单</label><div class=col-lg-8><select class=form-control id=target name=target ng-model=vm.menu.parentId ng-options=\"e.id as e.menuName for e in vm.menus\"><option value=\"\">请选择</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">资源内容</label><div class=col-lg-8><input type=text id=paperId name=content ng-model=vm.menu.content class=form-control></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/wxSetMenu/wxSetMenu.html","<div><div class=ibox-title><h2>会议日程</h2></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">菜单名</label><div class=col-lg-8><input type=text id=searchMenuName class=form-control ng-model=vm.menu.menuName></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">上级ID</label><div class=col-lg-8><input type=text id=searchParentId class=form-control ng-model=vm.menu.parentId></div></div><div class=col-lg-4><div class=col-lg-8><button class=\"btn btn-white\" type=reset id=searchReset>重置</button> <button class=\"btn btn-w-m btn-primary\" type=button id=searchBtn ng-click=vm.loadSearch()>搜索</button></div></div></div><div class=row><div class=col-lg-4><div class=col-lg-8><button class=\"btn btn-w-m btn-primary\" type=button id=setMenu ng-click=vm.setMenu()>更新菜单</button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>操作</th><th>序号</th><th>ID</th><th>菜单类型</th><th>菜单名</th><th>上级ID</th><!--<th>资源内容</th>--></tr></thead><tbody><tr ng-repeat=\"menu in vm.menus track by menu.id\"><td><a ui-sref=wxSetMenu.edit({id:menu.id})><i class=\"fa fa-edit text-primary\">编辑</i></a></td><td ng-bind=$index+1>1</td><td ng-bind=menu.id></td><td ng-bind=menu.menuType></td><td ng-bind=menu.menuName></td><td ng-bind=menu.parentId></td><!--<td ng-bind=\"menu.content\"></td>--></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/interfaceManage/addHeader/addHeader.html","<alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=header.systemInformationAdd></span></h5></div><div class=ibox-content><form name=addHeader role=form ng-submit=vm.add()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.systemCode></span></label><div class=col-lg-8><input class=form-control name=interfaceCode type=text ng-model=vm.header.interfaceCode required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.systemName></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.name required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.interfaceType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.interfaceType ng-options=\"a for a in vm.interfaceType\" ng-init=\"vm.header.interfaceType=\'REST\'\"><!--<option value=\"\">REST</option>--></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.systemAddress></span></label><div class=col-lg-8><input type=url ng-model=vm.header.domainUrl class=form-control required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestWays></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.requestMethod ng-options=\"a for a in vm.requestMethod\" ng-init=\"vm.header.requestMethod=\'GET\'\"></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestForm></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.requestFormat ng-options=\"a for a in vm.requestFormat\" ng-init=\"vm.header.requestFormat=\'raw\'\"></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestMessageFormat></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.requestContenttype></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestReceiveType></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.requestAccept></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.whetherEffective></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.enableFlag ng-init=\"vm.header.enableFlag=\'Y\'\"><option ng-repeat=\"x in vm.flag\" value={{x.code}}>{{x.name}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.needToCheck></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.authFlag ng-init=\"vm.header.authFlag=\'N\'\"><option ng-repeat=\"x in vm.flag\" value={{x.code}}>{{x.name}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.checkUsername></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.authUsername></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.checkPassword></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.authPassword></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.soapMessagePrefix></span></label><div class=col-lg-8><textarea class=form-control type=text ng-model=vm.header.bodyHeader></textarea></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.soapMessageSuffix></span></label><div class=col-lg-8><textarea class=form-control type=text ng-model=vm.header.bodyTail></textarea></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.nameSpace></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.namespace></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.mappingClass></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.mapperClass></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.systemType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.systemType name=systemType id=systemType><option ng-repeat=\"x in vm.systemTypes\" value={{x.value}}>{{x.description}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel()>&nbsp;&nbsp;<span translate=btnTypeName.cancer></span>&nbsp;&nbsp;</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">&nbsp;&nbsp;<span translate=btnTypeName.save></span>&nbsp;&nbsp;</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/interfaceManage/addLine/addLine.html","<alert-error></alert-error><!--<div>--><!--<h3>快速编码管理</h3>--><!--</div>--><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=header.interfaceAdd></span></h5></div><div class=ibox-content><form name=addForm role=form ng-submit=vm.add()><div><div class=form-group><input type=hidden class=form-control id=id ng-model=vm.line.headerId></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=line.interfaceCode></span></label><input type=text class=form-control ng-model=vm.line.lineCode required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=lineName><span translate=line.interfaceName></span></label><input type=text class=form-control id=lineName ng-model=vm.line.lineName required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=lineIftUrl><span translate=line.interfaceUrl></span></label><input type=text class=form-control name=appDesc id=lineIftUrl ng-model=vm.line.iftUrl required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=LineEnableFlag><span translate=header.systemInformationAdd></span><span translate=header.whetherEffective></span></label><select class=form-control ng-model=vm.line.enableFlag id=LineEnableFlag ng-init=\"vm.line.enableFlag=\'Y\'\"><option ng-repeat=\"x in vm.flag\" value={{x.code}}>{{x.name}}</option></select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancer></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form></div></div></div></div>");
$templateCache.put("app/interfaceManage/editHeader/editHeader.html","<alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=header.systemInformationEdit></span></h5></div><div class=ibox-content><form class=form-horizontal name=editHeader role=form ng-submit=vm.update()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.systemCode></span></label><div class=col-lg-8><input type=hidden ng-model=vm.header.headerId> <input type=hidden ng-model=vm.header.headerTlId> <input class=form-control type=text ng-model=vm.header.interfaceCode required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.systemName></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.name required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.interfaceType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.interfaceType ng-options=\"a for a in vm.interfaceType\" required><option value=\"\" ng-show=false></option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.systemAddress></span></label><div class=col-lg-8><input type=url ng-model=vm.header.domainUrl class=form-control required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestWays></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.requestMethod ng-options=\"a for a in vm.requestMethod\" required><option value=\"\" ng-show=false></option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestForm></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.requestFormat ng-options=\"a for a in vm.requestFormat\" required><option value=\"\" ng-show=false></option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestMessageFormat></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.requestContenttype></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestReceiveType></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.requestAccept></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.whetherEffective></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.enableFlag><option ng-repeat=\"x in vm.flag\" value={{x.code}}>{{x.name}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.needToCheck></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.authFlag required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.flag\" value={{x.code}}>{{x.name}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.checkUsername></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.authUsername></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.checkPassword></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.authPassword></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.soapMessagePrefix></span></label><div class=col-lg-8><textarea class=form-control type=text ng-model=vm.header.bodyHeader></textarea></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.soapMessageSuffix></span></label><div class=col-lg-8><textarea class=form-control type=text ng-model=vm.header.bodyTail></textarea></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.nameSpace></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.namespace></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.mappingClass></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.mapperClass></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.systemType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.systemType name=systemType id=systemType><option ng-repeat=\"x in vm.systemTypes\" value={{x.value}}>{{x.description}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel()>&nbsp;&nbsp;<span translate=btnTypeName.cancer></span>&nbsp;&nbsp;</button> <button type=submit ng-disabled=\"editHeader.$invalid || vm.isSaving\" class=\"btn btn-primary\">&nbsp;&nbsp;<span translate=btnTypeName.save></span>&nbsp;&nbsp;</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/interfaceManage/editLine/editLine.html","<alert-error></alert-error><!--<div>--><!--<h3>快速编码管理</h3>--><!--</div>--><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=header.editInterface></span></h5></div><div class=ibox-content><form name=editForm role=form ng-submit=vm.update()><div><div class=form-group><input type=hidden class=form-control id=id ng-model=vm.line.lineId></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=lineCode><span translate=header.interfaceCode></span></label><input type=text class=form-control id=lineCode ng-model=vm.line.lineCode required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=lineName><span translate=header.interfaceName></span></label><input type=text class=form-control id=lineName ng-model=vm.line.lineName required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=lineIftUrl><span translate=header.interfaceAddress></span></label><input type=text class=form-control name=appDesc id=lineIftUrl ng-model=vm.line.iftUrl required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=LineEnableFlag><span translate=header.whetherEffective></span></label><select class=form-control ng-model=vm.line.enableFlag id=LineEnableFlag ng-init=\"vm.line.enableFlag=\'Y\'\"><option ng-repeat=\"x in vm.flag\" value={{x.code}}>{{x.name}}</option></select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form></div></div></div></div>");
$templateCache.put("app/interfaceManage/header/header-detail.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"alert alert-danger\" ng-show=\"editForm.domainUrl.$dirty && editForm.domainUrl.$invalid\"><span translate=title.systemAddrWrong></span></div><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=header.interfaceInformation></span></h5></div><div class=ibox-content><form class=form-horizontal name=editForm role=form novalidate ng-submit=vm.update()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=header.systemCode></span></label><div class=col-lg-8><input type=hidden ng-model=vm.header.headerId> <input type=hidden ng-model=vm.header.headerTlId> <input class=form-control type=text ng-model=vm.header.interfaceCode required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=header.systemName></span></label><div class=col-lg-8><div class=input-group><input class=form-control type=text ng-model=vm.header.name readonly required><!--<input type=\"text\" class=\"form-control\" name=\"roleDescription\" readonly\n                           ng-model=\"vm.template.skuName\" required/>--> <span class=input-group-btn><button id=nameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'name\')\" value=name><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=header.interfaceType></span></label><div class=col-lg-8><select ng-model=vm.header.interfaceType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.interfaceTypes\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=header.systemAddress></span></label><div class=col-lg-8><input type=url name=domainUrl ng-model=vm.header.domainUrl class=form-control required placeholder=http/https></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.enableMock></span></label><div class=col-lg-8><select ng-model=vm.header.isMock class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.flags\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.mockAddress></span></label><div class=col-lg-8><input type=url ng-model=vm.header.mockUrl class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><div class=\"col-lg-offset-3 col-lg-8\"><button type=button ladda=vm.syncLoading ng-click=vm.syncLines() class=\"ladda-button btn btn-primary\" data-style=slide-right>{{vm.syncMsg}}</button></div></div><div class=col-lg-6></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=header.requestWays></span></label><div class=col-lg-8><select ng-model=vm.header.requestMethod class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.requestMethods\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=header.requestForm></span></label><div class=col-lg-8><select ng-model=vm.header.requestFormat class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.requestFormats\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestMessageFormat></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.requestContenttype placeholder=application/json></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.requestReceiveType></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.requestAccept placeholder=application/json></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.applyName></span></label><div class=col-lg-8><select class=form-control ng-model=vm.header.thirdpartyId ng-options=\"x.id as x.appName for x in vm.thirdpartys\"><option value=\"\"></option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.needToCheck></span></label><div class=col-lg-8><select ng-model=vm.header.authType class=form-control ng-change=vm.change()><option ng-repeat=\"x in vm.authTypes\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group ng-show=vm.header.isBasic><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.checkUsername></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.authUsername></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.checkPassword></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.authPassword></div></div></div></div><div class=form-group ng-show=vm.header.isAuth><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.tokenAddress></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.accessTokenUrl></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.authorizationMode></span></label><div class=col-lg-8><select ng-model=vm.header.grantType class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.authGrantTypes\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group ng-show=vm.header.isAuth><div class=row><div class=col-lg-6></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.soapMessagePrefix></span></label><div class=col-lg-8><textarea class=form-control type=text ng-model=vm.header.bodyHeader></textarea></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.soapMessageSuffix></span></label><div class=col-lg-8><textarea class=form-control type=text ng-model=vm.header.bodyTail></textarea></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.nameSpace></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.namespace></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=header.mappingClass></span></label><div class=col-lg-8><input class=form-control type=text ng-model=vm.header.mapperClass></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=header.systemType></span></label><!--<div class=\"col-lg-8\" contenteditable=\"false\" ng-if=\"vm.header.systemType==\'IN\'\">\n                    <select disabled=\"true\" class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" ng-model=\"vm.header.systemType\">\n                      <option value=\"IN\" selected=\"selected\">内部</option>\n                    </select>\n                  </div>\n\n                  <div class=\"col-lg-8\" ng-if=\"vm.header.systemType==\'OUT\'\">\n                    <select disabled=\"true\" class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" ng-model=\"vm.header.systemType\">\n                      <option value=\"OUT\">外部</option>\n                    </select>\n                  </div>--><div class=col-lg-8><select ng-model=vm.header.systemType class=form-control ng-change=vm.changeSystem() required ng-disabled=\"vm.header.headerId != null\"><option ng-repeat=\"x in vm.systemTypes\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=header.whetherEffective></span></label><div class=col-lg-8><select ng-model=vm.header.enableFlag class=form-control required ng-init=\"vm.header.enableFlag=\'Y\'\"><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.flags\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group ng-if=vm.show><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=header.thirdType></span></label><div class=col-lg-8><select ng-model=vm.header.thirdType class=form-control required><option value=commercial>commercial</option><option value=residential>residential</option><option value=admin>admin</option></select></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div></div></div></div><div class=\"modal fade\" id=localeModal_name style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_name></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'name\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/interfaceManage/header/header.html","<div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=header.title></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.systemCode></span></label><div class=col-lg-8><input type=text ng-model=vm.header.interfaceCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.systemName></span></label><div class=col-lg-8><input type=text ng-model=vm.header.name class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=header.new><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=hr-line-dashed></div><div class=table-responsive style=width:100%;overflow-x:scroll><table class=\"table table-striped table-hover\" style=width:1600px><thead><tr><th width=15%><span translate=btnTypeName.operation></span></th><th width=5%><span translate=header.sequence></span></th><th width=8%><span translate=header.systemCode></span></th><th width=10%><span translate=header.systemName></span></th><th width=10%><span translate=header.systemType></span></th><th width=10%><span translate=header.interfaceType></span></th><th width=15%><span translate=header.systemAddress></span></th><th width=10%><span translate=header.requestWays></span></th><th width=8%><span translate=header.whetherEffective></span></th><th width=15%><span translate=header.verificationWays></span></th></tr></thead><tbody><tr ng-repeat=\"header in vm.headerAll \"><td><a ui-sref=line({headerId:header.headerId})><i class=\"fa fa-desktop text-navy\"><span translate=btnTypeName.view></span></i></a> <a ui-sref=header.edit({headerId:header.headerId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ui-sref=interfaceAuth({headerId:header.headerId,clientType:header.systemType})><i class=\"fa fa-users text-navy\"><span translate=header.grantAuthorization></span></i></a></td><td>{{$index+1}}</td><td>{{header.interfaceCode}}</td><td>{{header.name}}</td><td>{{header.systemType}}</td><td>{{header.interfaceType}}</td><td>{{header.domainUrl}}</td><td>{{header.requestMethod}}</td><td>{{header.enableFlag}}</td><td>{{header.authType}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/interfaceManage/line/line-detail.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><alert-error></alert-error><!--<div>--><!--<h3>快速编码管理</h3>--><!--</div>--><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=line.editInterfaceTitle></span></h5></div><div class=ibox-content><form name=editForm role=form ng-submit=vm.update()><div><div class=form-group><input type=hidden class=form-control id=id ng-model=vm.line.lineId></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=lineCode><span style=\"color: red\">*</span><span translate=line.interfaceCode></span></label><input type=text class=form-control id=lineCode ng-model=vm.line.lineCode required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=lineName><span style=\"color: red\">*</span><span translate=line.interfaceName></span></label><div class=input-group><input type=text class=form-control id=lineName ng-model=vm.line.lineName required readonly><!--<input type=\"text\" class=\"form-control\" name=\"roleDescription\" readonly\n                           ng-model=\"vm.template.skuName\" required/>--> <span class=input-group-btn><button id=lineNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'lineName\')\" value=name><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=lineIftUrl><span style=\"color: red\">*</span><span translate=line.interfaceUrl></span></label><input type=text class=form-control name=lineIftUrl id=lineIftUrl ng-model=vm.line.iftUrl required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=mockLineUrl><span translate=line.mockAddr></span></label><input type=text class=form-control name=mockLineUrl id=mockLineUrl ng-model=vm.line.mockLineUrl></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=header.enableMock></span></label><lookup-select lookup-value=vm.line.isMockLine lookup-type=SYS.YES_NO></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=LineEnableFlag><span style=\"color: red\">*</span><span translate=header.whetherEffective></span></label><select class=form-control ng-model=vm.line.enableFlag id=LineEnableFlag ng-init=\"vm.line.enableFlag=\'Y\'\"><option ng-repeat=\"x in vm.flags\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=lineObjToArr><span translate=line.objIntoArrayNode></span></label><input type=text class=form-control name=lineObjToArr id=lineObjToArr ng-model=vm.line.objToArr></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div></div></div></div><div class=\"modal fade\" id=localeModal_lineName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_lineName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'lineName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/interfaceManage/line/line.html","<div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=line.lineTitle></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.systemCode></span></label><div class=col-lg-8><input type=text value={{vm.header.interfaceCode}} readonly class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.systemName></span></label><div class=col-lg-8><input type=text value={{vm.header.name}} readonly class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.interfaceType></span></label><div class=col-lg-8><input type=text value={{vm.header.interfaceType}} readonly class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.systemAddress></span></label><div class=col-lg-8><input type=text value={{vm.header.domainUrl}} readonly class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.requestWays></span></label><div class=col-lg-8><input type=text value={{vm.header.requestMethod}} readonly class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.requestForm></span></label><div class=col-lg-8><input type=text value={{vm.header.requestFormat}} readonly class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.requestMessageFormat></span></label><div class=col-lg-8><input type=text value={{vm.header.requestContenttype}} readonly class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.whetherEffective></span></label><div class=col-lg-8><input type=text value={{vm.header.enableFlag}} readonly class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.verificationWays></span></label><div class=col-lg-8><input type=text value={{vm.header.authType}} readonly class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=header.checkUsername></span></label><div class=col-lg-8><input type=text value={{vm.header.auth_username}} readonly class=form-control></div></div></div></div></form><div class=hr-line-dashed></div><form class=form-horizontal><input type=hidden ng-model=vm.line.headerId class=form-control><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=line.interfaceCode></span></label><div class=col-lg-8><input type=text ng-model=vm.line.lineCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=line.interfaceName></span></label><div class=col-lg-8><input type=text ng-model=vm.line.lineName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=button ng-click=vm.reback()><span translate=btnTypeName.cancel></span></button> <a class=\"btn btn-w-m btn-info\" ui-sref=line.new({headerId:vm.header.headerId})><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=hr-line-dashed></div><div class=table-responsive style=width:100%;overflow-x:scroll><table class=\"table table-striped table-hover\" style=width:1300px><thead><tr><th width=10%><span translate=btnTypeName.operation></span></th><th width=5%><span translate=header.sequence></span></th><th width=10%><span translate=line.interfaceCode></span></th><th width=15%><span translate=line.interfaceName></span></th><th width=20%><span translate=line.interfaceUrl></span></th><th width=20%><span translate=line.objIntoArrayNode></span></th><th width=20%><span translate=line.mockAddr></span></th><th width=10%><span translate=header.enableMock></span></th><th width=10%><span translate=header.whetherEffective></span></th></tr></thead><tbody><tr ng-repeat=\"line in vm.lines\"><td><a ui-sref=line.edit({lineId:line.lineId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ui-sref=\"interfaceAuth({headerId:line.headerId,lineId:line.lineId,clientType:vm.header.systemType,authType:\'line\'})\"><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.auth></span></i></a></td><td>{{$index+1}}</td><td>{{line.lineCode}}</td><td>{{line.lineName}}</td><td>{{line.iftUrl}}</td><td>{{line.objToArr}}</td><td>{{line.mockLineUrl}}</td><td>{{line.isMockLine}}</td><td>{{line.enableFlag}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/interfaceTest/test/test.html","<div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>系统接口测试</h5></div><div class=ibox-content><div class=hr-line-dashed></div><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">请求方法</label><div class=col-lg-8><input type=text ng-model=vm.header.requestMethod class=form-control readonly></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">接口类型</label><div class=col-lg-8><input type=text ng-model=vm.header.interfaceType class=form-control readonly></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">系统代码</label><div class=col-lg-8><input type=text ng-model=vm.header.interfaceCode class=form-control readonly></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">接口代码</label><div class=col-lg-8><input type=text ng-model=vm.header.lineCode class=form-control readonly></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">样例参数</label><div class=col-lg-8><input type=hidden ng-model=vm.example.exampleId> <input type=hidden ng-model=vm.example.lineId><textarea class=form-control type=text ng-model=vm.example.inputExample readonly></textarea></div><div class=col-lg-1 ng-if=\"vm.example.inputExample!=null\"><button type=button class=\"btn btn-default\" ng-click=vm.copyInputExample()>使用</button></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">样例输出</label><div class=col-lg-8><input type=hidden ng-model=vm.header.lineId><textarea class=form-control type=text ng-model=vm.example.outputExample readonly></textarea></div></div></div></div><div class=hr-line-dashed></div><div class=form-group><div class=row><div class=col-lg-9><label class=\"col-lg-2 control-label\">请求地址</label><div class=col-lg-10><input type=text value={{vm.header.domainUrl}}{{vm.header.iftUrl}} class=form-control readonly></div></div><div class=col-lg-2><button class=\"btn btn-primary\">&nbsp;&nbsp;Send&nbsp;&nbsp;</button></div></div></div><div class=form-group><div class=row><div class=col-lg-9><label class=\"col-lg-2 control-label\">参数输入</label><div class=col-lg-10><textarea class=form-control type=text ng-model=vm.inputParams></textarea></div></div></div></div><div class=form-group><div class=row><div class=col-lg-9><label class=\"col-lg-2 control-label\">参数输出</label><div class=col-lg-10><textarea class=form-control type=text ng-model=vm.outputParams></textarea><alert-error></alert-error></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel()>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</button> <button type=submit class=\"btn btn-primary\" ng-click=vm.save(vm.example)>&nbsp;&nbsp;Save&nbsp;&nbsp;</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/layouts/error/accessdenied.html","<div class=\"ibox-content animated fadeInDown\"><h3 class=font-bold>权限不足无法访问</h3><div class=error-desc>权限不足无法访问本页面，请联系管理员获得授权<br>可以回到首页:<br><a ui-sref=amain class=\"btn btn-primary m-t\">首页</a></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak><div class=row><div class=col-md-4><span class=\"hipster img-responsive img-rounded\"></span></div><div class=col-md-8><h1 translate=error.title>Error Page!</h1><div ng-show=errorMessage><div class=\"alert alert-danger\">{{errorMessage}}</div></div></div></div></div>");
$templateCache.put("app/layouts/leftnavbar/leftnavbar.html","<nav class=\"navbar-default navbar-static-side\" role=navigation><div class=sidebar-collapse><li class=nav-header style=list-style-type:none><div class=\"dropdown profile-element\"><!--<span>\n                            <img alt=\"image\" class=\"img-circle\" src=\"assets/img/profile_small.jpg\"/>\n                             </span>--> <a data-toggle=dropdown class=dropdown-toggle><span class=clear><span class=\"block m-t-xs\"><strong class=font-bold>{{vm.user.partyAccount}}</strong> </span><span class=\"text-muted text-xs block\">{{vm.role.roleName}} </span></span></a><!--<ul class=\"dropdown-menu animated fadeInRight m-t-xs\">\n          <li><a href=\"profile.html\">Profile</a></li>\n          <li><a href=\"contacts.html\">Contacts</a></li>\n          <li><a href=\"mailbox.html\">Mailbox</a></li>\n          <li class=\"divider\"></li>\n          <li><a href=\"login.html\">Logout</a></li>\n        </ul>--></div><div class=logo-element>IN+</div></li><!--<li class=\"active\">--><!--<a href = \"#\"><i class=\"fa fa-th-large\"></i> <span class=\"nav-label\">Dashboards</span> <span--><!--class=\"fa arrow\"></span></a>--><!--<ul class=\"nav nav-second-level\">--><!--<li><a href=\"#/app/options\">系统设置</a></li>--><!--<li class=\"active\"><a href=\"#/app/thirdparty\">第三方应用</a></li>--><!--<li><a href=\"#/app/promptIndex\">描述维护</a></li>--><!--<li><a href=\"#/app/coding\">快速编码</a></li>--><!--<li><a href=\"#/app/header\">接口管理</a></li>--><!--<li><a href=\"#/app/appedition\">app版本管理</a></li>--><!--<li><a href=\"#/app/metrics\">系统指标</a></li>--><!--<li><a href=\"#/app/user\">用户管理<span class=\"label label-primary pull-right\">NEW</span></a></li>--><!--<li><a href=\"#/app/rolemanager\">角色管理</a></li>--><!--<li><a href=\"#/app/appauth\">app配置</a></li>--><!--<li><a href=\"#/app/interfaceList\">接口测试</a></li>--><!--<li><a href=\"#/app/function\">功能定义</a></li>--><!--<li><a href=\"#/app/resource\">资源定义</a></li>--><!--<li><a href=\"/swagger-ui/index.html\">swagger-ui</a></li>--><!--</ul>--><!--</li>--><!-- --><!--<li>--><!--<a href=\"#\"><i class=\"fa fa-th-large\"></i> <span class=\"nav-label\">Dashboards</span> <span--><!--class=\"fa arrow\"></span></a>--><!--<ul class=\"nav nav-second-level\">--><!--<li><a href=\"#/app/options\">系统设置</a></li>--><!--<li class=\"active\"><a href=\"#/app/thirdparty\">第三方应用</a></li>--><!--<li><a href=\"#/app/promptIndex\">描述维护</a></li>--><!--<li><a href=\"#/app/coding\">快速编码</a></li>--><!--<li><a href=\"#/app/header\">接口管理</a></li>--><!--<li><a href=\"#/app/appedition\">app版本管理</a></li>--><!--<li><a href=\"#/app/metrics\">系统指标</a></li>--><!--<li><a href=\"#/app/user\">用户管理<span class=\"label label-primary pull-right\">NEW</span></a></li>--><!--<li><a href=\"#/app/rolemanager\">角色管理</a></li>--><!--<li><a href=\"#/app/appauth\">app配置</a></li>--><!--<li><a href=\"#/app/interfaceList\">接口测试</a></li>--><!--<li><a href=\"#/app/function\">功能定义</a></li>--><!--<li><a href=\"#/app/resource\">资源定义</a></li>--><!--<li><a href=\"#/app/authority\">权限管理</a></li>--><!--<li><a href=\"/swagger-ui/index.html\">swagger-ui</a></li>--><!--</ul>--><!--</li>--><!--<li class=\"active\">--><!--<a href=\"layouts.html\"><i class=\"fa fa-diamond\"></i> <span class=\"nav-label\">计划任务</span></a>--><!--<ul class=\"nav nav-second-level\">--><!--<li class=\"active\"><a href=\"#/app/taskDetali\">任务明细</a></li>--><!--<li><a href=\"#/app/executionLog\">执行记录<span class=\"label label-primary pull-right\">NEW</span></a></li>--><!--</ul>--><!--</li>--><!--<li class=\"active\" ng-repeat=\"menu in vm.menu\">--><!--<a href=\"\"><i class=\"fa fa-picture-o\"></i> <span class=\"nav-label\">{{menu.text}}</span><span class=\"fa arrow\"></span></a>--><!--<navigation menu=\"menu.children\"></navigation>--><!--&lt;!&ndash;<ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'charts\')}\">&ndash;&gt;--><!--&lt;!&ndash;<li ui-sref-active=\"active\" ng-repeat=\"subMenu in menu.children\"><a ui-sref=\"subMenu.url\">{{subMenu.text}}</a></li>&ndash;&gt;--><!--&lt;!&ndash;</ul>&ndash;&gt;--><!--</li>--><side-navigation></side-navigation></div></nav>");
$templateCache.put("app/layouts/topnavbar/topnavbar.html","<style>.language-select{\n        border: 1px solid;\n        appearance: menulist;\n        -moz-appearance: menulist;\n        -webkit-appearance: menulist;\n        margin-top: 20px;\n        margin-right: 10px;\n        border-radius: 6px;\n        border-color: #1ab394;\n    }</style><div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top\" role=navigation style=\"margin-bottom: 0\"><div class=navbar-header><minimaliza></minimaliza><form role=search class=navbar-form-custom method=post><div class=form-group></div></form></div><div class=\"col-lg-1 col-lg-offset-6\"><select class=language-select ng-model=vm.selectType ng-change=vm.changeLanguage()><option ng-repeat=\"x in vm.languageType\" value={{x.lang}}>{{x.value}}</option></select></div><div class=navbar-collapse><ul class=\"nav navbar-top-links navbar-right\"><li><a href=\"\" ng-click=vm.logout()><i class=\"fa fa-sign-out\"></i><span translate=logout.logout></span></a></li></ul></div></nav></div>");
$templateCache.put("app/lookup/coding/addCoding.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  #toast-container {\n    z-index: 1100;\n  }</style><form name=addForm role=form ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=lookup.addCodeTitle></span></h4></div><div class=modal-body><!--<div class=\"form-group\" ng-show=\"vm.code.codeId\">--><!--<label >ID</label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.code.codeId\" readonly/>--><!--</div>--><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_appName><span style=\"color: red\">*</span><span translate=lookup.code></span></label><input type=text class=form-control name=code id=field_appName ng-model=vm.code.code required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_appCode><span style=\"color: red\">*</span><span translate=lookup.meaning></span></label><div class=input-group><input type=text class=form-control name=description id=field_appCode ng-model=vm.code.description required readonly> <span class=input-group-btn><button id=localeBtn disabled class=\"btn btn-default\" type=button ng-click=vm.show() value=description><i class=\"fa fa-globe\"></i></button></span></div></div><!--<div class=\"form-group\">\n            <label class=\"control-label\" for=\"field_appCode_zh\">编码类型名称_简体中文</label>\n            <input type=\"text\" class=\"form-control\" name=\"zh_CN\" id=\"field_appCode_zh\"\n                   ng-model=\"vm.code.__tls.description.zh_CN\" required\n            />\n          </div>\n          <div class=\"form-group\">\n            <label class=\"control-label\" for=\"field_appCode_en\">编码类型名称_English</label>\n            <input type=\"text\" class=\"form-control\" name=\"en_GB\" id=\"field_appCode_en\"\n                   ng-model=\"vm.code.__tls.description.en_GB\" required\n            />\n          </div>--></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/lookup/coding/coding.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=lookup.title></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=lookup.code></span></label><div class=col-lg-8><input type=text ng-model=vm.code.code class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=lookup.meaning></span></label><div class=col-lg-8><input type=text ng-model=vm.code.description class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=coding.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 25%\"><span translate=btnTypeName.operation></span></th><th style=\"width: 15%\"><span translate=lookup.number></span></th><th style=\"width: 30%\"><span translate=lookup.code></span></th><th style=\"width: 30%\"><span translate=lookup.meaning></span></th></tr></thead><tbody><tr ng-repeat=\"code in vm.result\"><td><a ui-sref=codingValue({codeId:code.codeId})><i class=\"fa fa-desktop text-navy\"><span translate=btnTypeName.check></span></i></a> <a ui-sref=coding.edit({codeId:code.codeId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.delete(code)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{$index+1}}</td><td>{{code.code}}</td><td>{{code.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/lookup/coding/editCoding.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.update()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=lookup.editCodeTitle></span></h4></div><div class=modal-body><!--<div class=\"form-group\" ng-show=\"vm.code.codeId\">--><!--<label >ID</label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.code.codeId\" readonly/>--><!--</div>--><div class=row><div class=col-md-6><div class=form-group><input type=hidden class=form-control ng-model=vm.code.codeId><label class=control-label for=field_appName><span style=\"color: red\">*</span><span translate=lookup.code></span></label><input type=text class=form-control name=code id=field_appName ng-model=vm.code.code required ng-disabled=vm.code.codeId></div></div><!--<div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\" for=\"field_appCode\">编码类型名称</label>\n          <input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_appCode\"\n                 ng-model=\"vm.code.description\"\n            />\n        </div>\n      </div>--></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_appCode><span style=\"color: red\">*</span><span translate=lookup.meaning></span></label><div class=input-group><input type=text class=form-control name=description id=field_appCode ng-model=vm.code.description readonly required> <span class=input-group-btn><button id=localeBtn disabled class=\"btn btn-default\" type=button ng-click=vm.show() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/lookup/codingValue/addCodingValue.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  #toast-container {\n    z-index: 1100;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=lookup.addValueCodeTitle></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><input type=hidden class=form-control ng-model=vm.codeValue.codeId><label class=control-label for=field_value><span style=\"color: red\">*</span><span translate=lookup.valueCode></span></label><input type=text class=form-control name=value id=field_value ng-model=vm.codeValue.value required></div></div><!--<div class=\"col-md-offset-6\"></div>--></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_meaning><span style=\"color: red\">*</span><span translate=lookup.valueMeaning></span></label><div class=input-group><input type=text class=form-control name=meaning id=field_meaning ng-model=vm.codeValue.meaning readonly required> <span class=input-group-btn><button id=meaningLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showMeaningLocale() value=meaning><i class=\"fa fa-globe\"></i></button></span></div></div></div><!--<div class=\"col-md-offset-6\"></div>--></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_description><span translate=lookup.valueDec></span></label><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.codeValue.description readonly> <span class=input-group-btn><button id=decLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showDecLocale() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div><!--<div class=\"col-md-offset-6\"></div>--></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=meaningLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=meaningLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.meaningLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=decLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=decLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.decLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/lookup/codingValue/codingValue.html","<!--<div>--><!--<h3>快速编码管理</h3>--><!--</div>--><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=lookup.codeValueTitle></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=lookup.code></span></label><div class=col-lg-8><input type=text ng-model=vm.code.code class=form-control readonly></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=lookup.meaning></span></label><div class=col-lg-8><input type=text ng-model=vm.code.description class=form-control readonly></div></div></div></div></form><div class=hr-line-dashed></div><form class=form-horizontal><input type=hidden ng-model=vm.code.codeId class=form-control><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=lookup.valueCode></span></label><div class=col-lg-8><input type=text ng-model=vm.codeValue.value class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=lookup.valueMeaning></span></label><div class=col-lg-8><input type=text ng-model=vm.codeValue.meaning class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=button ng-click=vm.reBack()><span translate=btnTypeName.cancel></span></button> <a class=\"btn btn-w-m btn-info\" ui-sref=codingValue.add({codeId:vm.code.codeId})><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=hr-line-dashed></div><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 20%\"><span translate=btnTypeName.operation></span></th><th style=\"width: 10%\"><span translate=lookup.number></span></th><th style=\"width: 20%\"><span translate=lookup.valueCode></span></th><th style=\"width: 25%\"><span translate=lookup.valueMeaning></span></th><th style=\"width: 25%\"><span translate=lookup.valueDec></span></th></tr></thead><tbody><tr ng-repeat=\"value in vm.codeValues\"><td><a ui-sref=codingValue.edit({codeValueId:value.codeValueId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.delete(value)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{$index+1}}</td><td>{{value.value}}</td><td>{{value.meaning}}</td><td>{{value.description}}</td></tr></tbody></table></div></div></div></div></div><!--<script>\n  $(function () {\n    $(\"[data-toggle=\'popover\']\").popover();\n  });\n</script>-->");
$templateCache.put("app/lookup/codingValue/editCodingValue.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.update()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=lookup.editValueCodeTitle></span></h4></div><div class=modal-body><!--<div class=\"form-group\" ng-show=\"vm.code.codeId\">--><!--<label >ID</label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.code.codeId\" readonly/>--><!--</div>--><div class=row><div class=col-md-6><div class=form-group><input type=hidden class=form-control ng-model=vm.codeValue.codeValueId><label class=control-label for=field_value><span style=\"color: red\">*</span><span translate=lookup.valueCode></span></label><input type=text class=form-control name=value id=field_value ng-model=vm.codeValue.value required ng-disabled=vm.codeValue.codeValueId></div></div><!--<div class=\"col-md-offset-6\"></div>--></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_meaning><span style=\"color: red\">*</span><span translate=lookup.valueMeaning></span></label><div class=input-group><input type=text class=form-control name=meaning id=field_meaning ng-model=vm.codeValue.meaning readonly required> <span class=input-group-btn><button id=meaningLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showMeaningLocale() value=meaning><i class=\"fa fa-globe\"></i></button></span></div></div></div><!--<div class=\"col-md-offset-6\"></div>--></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_description><span translate=lookup.valueDec></span></label><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.codeValue.description readonly> <span class=input-group-btn><button id=decLocaleBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showDecLocale() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div><!--<div class=\"col-md-offset-6\"></div>--></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=meaningLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=meaningLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.meaningLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=decLocaleModal style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=decLocaleModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.decLocaleSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/plugin/html/addVersion.html","<style>.toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><style>.sweet-overlay {\n    background-color: black;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n    background-color: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 10000;\n  }\n  .sweet-alert {\n    background-color: white;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    width: 478px;\n    padding: 17px;\n    border-radius: 5px;\n    text-align: center;\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    margin-left: -256px;\n    margin-top: -200px;\n    overflow: hidden;\n    display: none;\n    z-index: 99999;\n  }\n  #toast-container {\n    z-index: 99999;\n  }</style><form name=addForm role=form ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=plugin.addPluginVersion></span></h4></div><div class=modal-body><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=plugin.versionNumber></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=menuVersion ng-model=vm.menuVersion.menuVersion required></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=plugin.versionDesc></span></label><div class=input-group><input type=text class=form-control name=menuDesc id=field_templateName ng-model=vm.menuVersion.menuDesc required readonly> <span class=input-group-btn><button id=menuDescBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'menuDesc\')\" value=menuDesc><i class=\"fa fa-globe\"></i></button></span></div><!--\n          <input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                 ng-model=\"vm.menuVersion.menuDesc\" required >--></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=plugin.pluginResource></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menuVersion.menuResource required></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><font color=red>*</font><span translate=plugin.isGrayscalPlugin></span></label><!--<lookup-select lookup-value=\"vm.key.isMain\" lookup-type=\"SYS.YES_NO\" ng-required=\"true\"></lookup-select>--><select ng-model=vm.menuVersion.attribute1 class=form-control required><option ng-repeat=\"isGrayscal in vm.isGrayscalPlugin\" value={{isGrayscal.value}}>{{isGrayscal.name}}</option></select></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><label class=control-label><span translate=plugin.minAppVersion></span></label></div></div><div class=\"row col-md-offset-4\"><div class=col-md-3><div class=form-group><div class=input-group><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menuVersion.attribute2 required> <span class=help-block><i class=\"fa fa-info-circle\"></i> Android</span></div></div></div><div class=col-md-3><div class=form-group><div class=input-group><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.menuVersion.attribute3 required> <span class=help-block><i class=\"fa fa-info-circle\"></i> IOS</span></div></div></div></div><!--<div class=\"col-md-6\">\n      <label class=\"control-label\"><font color=\"red\">*</font><span translate=\"key.isMain\"></span></label>\n      &lt;!&ndash;<lookup-select lookup-value=\"vm.key.isMain\" lookup-type=\"SYS.YES_NO\" ng-required=\"true\"></lookup-select>&ndash;&gt;\n      <select ng-model=\"vm.menuVersion.attribute1\"  class=\"form-control\" ng-disabled=\"vm.edit\" ng-disabled=\"vm.edit\" required>\n        <option ng-repeat=\"isMain in vm.isMain\" value=\"{{isMain.value}}\">{{isMain.name}}</option>\n      </select>\n    </div>--><!--<div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <label class=\"control-label\" ><span translate=\"plugin.resourceCatalog\"></span></label>\n          <input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                 ng-model=\"vm.menuVersion.menuLocalPath\" ng-required=\"vm.typeFlag\" >\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><span translate=\"plugin.targetPath\"></span></label>\n          <input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                 ng-model=\"vm.menuVersion.menuDestPath\" ng-required=\"vm.typeFlag\">\n        </div>\n      </div>\n    </div>--><!--<div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\" style=\"width: 35%;\">\n        <permission-selector permission-data=\"vm.permissionData\"></permission-selector>\n      </div>\n    </div>--><div class=row><div class=\"col-md-offset-4 col-md-4\" style=\"margin-top: 18px\"><div class=form-group><div class=pull-left><input type=file name=zip id=zip ng-model=vm.zip onchange=angular.element(this).scope().vm.upFile() style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span translate=plugin.importPack></span></a></div></div><div style=\"color:red; margin-top: 34px\">(<span translate=plugin.versionFirst></span>)</div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=submit ng-disabled=\"(addForm.$invalid|| vm.isSaving)\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></form><div class=\"modal fade\" id=localeModal_menuDesc style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_menuDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'menuDesc\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/plugin/html/plugin-detail.html","<style>span {\n    font-size: 15px;\n  }\n\n  .menu-bcackground {\n    background-color: #f3f3f4;\n    width: 80%;\n    margin: 0 auto;\n  }\n\n  .menu-bcackground-selected {\n    background-color: #eaeaea;\n    width: 80%;\n    margin: 0 auto;\n  }\n  div{\n    outline:none;\n  }\n\n  .border {\n    border-bottom: 1px solid #c8cacd;\n    position: relative;\n    left: 26%;\n    width: 53%;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form><div class=modal-header><!--<alert-error></alert-error>--><!--<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button>--><h4 class=modal-title id=myAfwkFunctionspan><span translate=plugin.pluginDetail></span></h4></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'oldFile\' || vm.ischecked==\'oldFile\']\" ng-mouseenter=\"vm.mouseIn = \'oldFile\'\"><div class=row ng-click=\"vm.check(\'oldFile\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=plugin.pluginLogo></span></span></div><div class=col-md-8><div ng-if=\"vm.ischecked==\'oldFile\'\"><input ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=position:absolute;opacity:0;z-index:100;cursor:pointer;width:80px;height:80px type=file></div><div><img style=width:80px;height:80px ngf-src=vm.oldFile></div><div ng-if=\"vm.ischecked==\'oldFile\'\"><div><span translate=plugin.imageSize></span></div><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=button ng-click=vm.submitFile() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></div></div><div class=col-md-1><a><i class=\"fa fa-edit text-navy\"><span translate=plugin.edit></span></i></a></div></div></div><div class=border></div><div class=border></div><div class=modal-body disabled ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'pluginCode\']\"><div class=row ng-click=\"vm.check(\'pluginCodew\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span translate=plugin.pluginCategoryType></span></div><div class=col-md-6><span class=control-span ng-if=\"vm.ischecked!=\'pluginCode\'\">{{vm.menu.pluginCode}}</span></div></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'menuName\']\" ng-mouseenter=\"vm.mouseIn=\'menuName\'\"><div class=row ng-click=\"vm.check(\'menuName\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=plugin.pluginName></span></span></div><div class=col-md-6><span class=control-span ng-if=\"vm.ischecked!=\'menuName\'\">{{vm.menu.menuName}}</span><div ng-if=\"vm.ischecked==\'menuName\'\"><!--<input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                   ng-model=\"vm.menu.menuName\" required>--><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateName ng-model=vm.menu.menuName readonly> <span class=input-group-btn><button id=menuNameBtn class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'menuName\')\" value=menuName><i class=\"fa fa-globe\"></i></button></span></div><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\"><span translate=plugin.edit></span></i></a></div></div></div><!--  <div class=\"border\"></div>\n  <div class=\"modal-body\" ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'appSecret\' || vm.ischecked==\'appSecret\']\" ng-mouseenter=\"vm.mouseIn=\'appSecret\'\">\n    <div class=\"row\" ng-click=\"vm.check(\'menuType\')\">\n      <div class=\"col-md-offset-2 col-md-8\">\n        <div class=\"col-md-4\">\n          <span class=\"control-span\">插件类型</span>\n        </div>\n        <div class=\"col-md-6\">\n          &lt;!&ndash;<span ng-if=\"vm.ischecked!=\'menuType\'\" class=\"control-span\">{{vm.menu.menuType}}</span>&ndash;&gt;\n          <div >\n            <div>\n              <label class=\"radio-inline\">\n                <input type=\"radio\" name=\"chickenEgg\" value=\"ONLINE\" ng-model=\"vm.menu.menuType\" required>\n                在线\n              </label>\n              <label class=\"radio-inline\">\n                <input type=\"radio\" name=\"chickenEgg\" value=\"LOCAL\" ng-model=\"vm.menu.menuType\" required>\n                本地\n              </label>\n              <label class=\"radio-inline\">\n                <input type=\"radio\" name=\"chickenEgg\" value=\"NATIVE\" ng-model=\"vm.menu.menuType\" required>\n                原生\n              </label>\n            </div>\n            <br/>\n            <div ng-if=\"vm.ischecked==\'menuType\'\">\n            <div class=\"border\" style=\"left: 0\"></div>\n            <br/>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.nocheck($event)\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消\n            </button>\n            <button type=\"button\" ng-click=\"vm.save()\" class=\"btn btn-primary\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存\n            </button>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-2\">\n        <a><i class=\"fa fa-edit text-navy\">编辑</i></a>\n      </div>\n    </div>\n  </div>--><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'menuDesc\']\" ng-mouseenter=\"vm.mouseIn=\'menuDesc\'\"><div class=row ng-click=\"vm.check(\'menuDesc\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=plugin.pluginDesc></span></span></div><div class=col-md-6><span class=control-span ng-if=\"vm.ischecked!=\'menuDesc\'\">{{vm.menu.menuDesc}}</span><div ng-if=\"vm.ischecked==\'menuDesc\'\"><!--<textarea ng-model=\"vm.menu.menuDesc\" class=\"form-control\" rows=\"3\" required style=\"resize: none; height: 180px\"></textarea>--><div class=input-group><!--<input type=\"text\" class=\"form-control\" name=\"roleDescription\" id=\"field_menuDesc\"\n                     ng-model=\"vm.plugin.menuDesc\" readonly/>--><textarea ng-model=vm.menu.menuDesc readonly class=form-control rows=3 required style=\"resize: none; height: 180px\"></textarea><span class=input-group-btn><button id=menuDescBtn class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'menuDesc\')\" value=menuDesc><i class=\"fa fa-globe\"></i></button></span></div><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\"><span translate=plugin.edit></span></i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'functionDesc\']\" ng-mouseenter=\"vm.mouseIn=\'functionDesc\'\"><div class=row ng-click=\"vm.check(\'functionDesc\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=plugin.functionIntroduction></span></span></div><div class=col-md-6><span class=control-span ng-if=\"vm.ischecked!=\'functionDesc\'\">{{vm.menu.functionDesc}}</span><div ng-if=\"vm.ischecked==\'functionDesc\'\"><!--<textarea ng-model=\"vm.menu.menuDesc\" class=\"form-control\" rows=\"3\" required style=\"resize: none; height: 180px\"></textarea>--><div class=input-group><!--<input type=\"text\" class=\"form-control\" name=\"roleDescription\" id=\"field_menuDesc\"\n                     ng-model=\"vm.plugin.menuDesc\" readonly/>--><textarea ng-model=vm.menu.functionDesc readonly class=form-control rows=3 required style=\"resize: none; height: 180px\"></textarea><span class=input-group-btn><button id=functionDescBtn class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'functionDesc\')\" value=functionDesc><i class=\"fa fa-globe\"></i></button></span></div><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\"><span translate=plugin.edit></span></i></a></div></div></div><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'categoryId\']\" ng-mouseenter=\"vm.mouseIn=\'categoryId\'\"><div class=row ng-click=\"vm.check(\'categoryId\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span translate=plugin.pluginCategory></span></div><div class=col-md-6><span class=control-span><select ng-model=vm.menu.pluginType class=form-control disabled><option ng-repeat=\"x in vm.pluginTypeList\" value={{x.value}}>{{x.meaning}}</option></select></span></div></div></div></div><!--<div class=\"modal-body\"\n       ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'pluginCode\']\"\n       ng-mouseenter=\"vm.mouseIn=\'pluginCode\'\">\n    <div class=\"row\" ng-click=\"vm.check(\'pluginCode\')\" >\n      <div class=\"col-md-offset-2 col-md-8\">\n        <div class=\"col-md-4\">\n          <span class=\"control-span\"><span translate=\"plugin.pluginCategoryType\"></span></span>\n        </div>\n        <div class=\"col-md-6\">\n          <span class=\"control-span\" ng-if=\"vm.ischecked!=\'pluginCode\'\">{{vm.menu.pluginCode}}</span>\n          <div ng-if=\"vm.ischecked==\'pluginCode\'\">\n            <input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                   ng-model=\"vm.menu.pluginCode\" required disabled>\n\n            &lt;!&ndash;<div class=\"input-group\">\n              <span class=\"control-span\" >\n                <select ng-model=\"vm.menu.pluginCode\" class=\"form-control\">\n                <option ng-repeat=\"x in vm.menuTypeList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n              </select>\n              </span>\n            </div>&ndash;&gt;\n            <br/>\n\n            <div class=\"border\" style=\"left: 0\"></div>\n            <br/>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.nocheck($event)\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"plugin.cancel\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"vm.save()\" class=\"btn btn-primary\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"plugin.save\"></span>\n            </button>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-2\">\n        <a><i class=\"fa fa-edit text-navy\"><span translate=\"plugin.edit\"></span></i></a>\n      </div>\n    </div>\n  </div>--><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'productCode\']\" ng-mouseenter=\"vm.mouseIn=\'productCode\'\" ng-if=\"vm.menu.pluginType==\'PRODUCT\'\"><div class=row ng-click=\"vm.check(\'productCode\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span><span translate=plugin.pluginCode></span></span></div><div class=col-md-6><span class=control-span ng-if=\"vm.ischecked!=\'productCode\'\">{{vm.menu.productCode}}</span><div ng-if=\"vm.ischecked==\'productCode\'\"><select id=field_roleType ng-model=vm.menu.productCode class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.pluginCodeList\" value={{x.productCode}}>{{x.productCode}}</option></select><br><div class=border style=\"left: 0\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event)><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></div></div><div class=col-md-2><a><i class=\"fa fa-edit text-navy\"><span translate=plugin.edit></span></i></a></div></div></div><!-- <div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <label class=\"control-label\"><span translate=\"plugin.pluginCode\"></span></label>\n          <select ng-model=\"vm.plugin.pluginCode\" class=\"form-control\" required>\n            <option ng-repeat=\"x in vm.pluginTypeList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>\n        </div>\n      </div>\n    </div>--><!--<div class=\"border\"></div>\n  &lt;!&ndash;<div class=\"modal-body\"\n       ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'appName\' || vm.ischecked==\'appName\']\"\n       ng-mouseenter=\"vm.mouseIn=\'appName\'\">\n    <div class=\"row\">\n      <div class=\"col-md-offset-3 col-md-6\">\n        <div class=\"col-md-2\">\n          <span class=\"control-span\">可见范围</span>\n        </div>\n        <div class=\"col-md-9\">\n          <span ng-if=\"vm.ischecked!=\'appName\'\" class=\"control-span\">{{vm.menu.menuVisible}}</span>\n\n          <div ng-if=\"vm.ischecked==\'appName\'\">\n            <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #c8cacd;\" name=\"appName\"\n                   ng-model=\"vm.menu.menuVisible\" required>\n            <br/>\n            <permission-selector permission-data=\"vm.permissionData\"></permission-selector>\n            <div class=\"border\" style=\"left: 0\"></div>\n            <br/>\n            <button type=\"button\" class=\"btn btn-default\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消\n            </button>\n            <button type=\"button\"  class=\"btn btn-primary\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存\n            </button>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-1\">\n        <a><i class=\"fa fa-edit text-navy\">编辑</i></a>\n      </div>\n    </div>\n  </div>&ndash;&gt;\n\n  <div class=\"modal-body\"\n       ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'permission\' || vm.ischecked==\'permission\']\"\n       ng-mouseenter=\"vm.mouseIn=\'permission\'\">\n    <div class=\"row\" ng-click=\"vm.check(\'permission\')\">\n      <div class=\"col-md-offset-2 col-md-8\">\n        <div class=\"col-md-4\">\n          <span class=\"control-span\">可见范围</span>\n        </div>\n        <div class=\"col-md-6\">\n          <div ng-if=\"vm.ischecked!=\'permission\'\">\n            <div class=\"multiple-select-box form-control ui-select-container ui-select-multiple ui-select-bootstrap m-b text-left \"  readOnly>\n              <span class=\"ui-select-match-item btn btn-default btn-xs\" draggable=\"true\" aria-disabled=\"false\" ng-repeat=\"data in vm.permissionData\">\n                <i class=\"{{data.dataIcon}}\"></i>{{data.dataValue}}</span>\n            </div>\n          </div>\n          <div ng-if=\"vm.ischecked==\'permission\'\">\n            <permission-selector permission-data=\"vm.permissionData\"></permission-selector>\n            <br/>\n\n            <div class=\"border\" style=\"left: 0\"></div>\n            <br/>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.nocheck($event)\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消\n            </button>\n            <button type=\"button\" ng-click=\"vm.savePermission()\" class=\"btn btn-primary\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存\n            </button>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-2\">\n        <a><i class=\"fa fa-edit text-navy\">编辑</i></a>\n      </div>\n    </div>\n  </div>--><div class=border></div><div class=modal-body ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'status\' || vm.ischecked==\'status\']\" ng-mouseenter=\"vm.mouseIn = \'status\'\"><div class=row ng-click=\"vm.check(\'status\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span translate=plugin.disable></span></div><div class=col-md-6 ng-if=\"vm.ischecked!=\'status\'\"><label><input type=checkbox ng-model=vm.menu.status ngtruevalue=Y ngfalsevalue=N onclick=\"return false\"></label></div><div ng-if=\"vm.ischecked==\'status\'\"><input type=checkbox ng-model=vm.menu.status ngtruevalue=Y ngfalsevalue=N style=\"margin-left: 15px\">&nbsp;&nbsp;<br><br><div class=border style=\"left: 35%;width: 17%\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event) style=\"margin-left: 35%\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></div></div></div><div class=border></div><div class=modal-body ng-if=\"vm.menu.pluginType!=\'PRODUCT\'\" ng-class=\"{\'false\':\'menu-bcackground\',\'true\':\'menu-bcackground-selected\'}[vm.mouseIn==\'isDefault\' || vm.ischecked==\'isDefault\']\" ng-mouseenter=\"vm.mouseIn = \'isDefault\'\"><div class=row ng-click=\"vm.check(\'isDefault\')\"><div class=\"col-md-offset-2 col-md-8\"><div class=col-md-4><span class=control-span translate=plugin.default></span></div><div class=col-md-6 ng-if=\"vm.ischecked!=\'isDefault\'\"><label><input type=checkbox ng-model=vm.menu.isDefault ngtruevalue=Y ngfalsevalue=N onclick=\"return false\"></label></div><div ng-if=\"vm.ischecked==\'isDefault\'\"><input type=checkbox ng-model=vm.menu.isDefault ngtruevalue=Y ngfalsevalue=N style=\"margin-left: 15px\">&nbsp;&nbsp;<br><br><div class=border style=\"left: 35%;width: 17%\"></div><br><button type=button class=\"btn btn-default\" ng-click=vm.nocheck($event) style=\"margin-left: 35%\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=button ng-click=vm.save() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></div></div></div><a style=\"margin-top: 1%; margin-left: 26%\" class=\"btn btn-w-m btn-info\" ui-sref=plugin.addVersion({id:vm.menu.id})><span translate=plugin.add></span></a><table border=1 style=\"width: 53%;margin-left: 26%; margin-top: 6px; text-align:center\"><tr style=\"height: 20px\"><th rowspan=2 style=\"text-align: center\"><span translate=plugin.versionNumber></span></th><th rowspan=2 style=\"text-align: center\"><span translate=plugin.updateDate></span></th><th rowspan=2 style=\"text-align: center\"><span translate=plugin.operation></span></th><th rowspan=2 style=\"text-align: center\"><span translate=distribution.latest></span></th><th rowspan=2 style=\"text-align: center\"><span translate=plugin.grayscalVersion></span></th><th rowspan=2 style=\"text-align: center\"><span translate=plugin.setNewVersion></span></th><th colspan=2 style=\"text-align: center\"><span translate=plugin.minAppVersion></span></th></tr><tr style=\"height: 20px\"><th class=col-xs-1 style=\"text-align: center\">Android</th><th class=col-xs-1 style=\"text-align: center\">IOS</th></tr><tr style=\"height: 40px\" ng-repeat=\"menuV in vm.menuVersions\"><td>{{menuV.menuVersion}}</td><!--<td>{{menuV.serviceNumber}}</td>--><td>{{menuV.creationDate}}</td><td><a ui-sref=plugin.showPluginVersion({id:menuV.id})><i class=\"fa fa-edit text-navy\"><span translate=plugin.check></span></i></a></td><td>{{menuV.isCurrentVersion}}</td><td>{{menuV.attribute1}}</td><td><button ng-hide=\"menuV.attribute1==\'Y\'?false:true\" type=button class=\"btn btn-primary\" ng-click=vm.setNewVersion(menuV)><span translate=plugin.setToNew></span></button></td><td>{{menuV.attribute2}}</td><td>{{menuV.attribute3}}</td></tr></table></form><div class=\"modal fade\" id=localeModal_menuName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_menuName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'menuName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_menuDesc style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_menuDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'menuDesc\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_functionDesc style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_functionDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'functionDesc\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/plugin/html/plugin-new.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=plugin.pluginConfigure></span></h4></div><div class=modal-body><div class=row style=text-align:center><div style=text-align:center><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 60px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile></div><div><span translate=plugin.imageSize></span></div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div><span translate=plugin.startUpload></span></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=plugin.pluginCategoryType></span></label><input type=text class=form-control name=roleDescription ng-model=vm.plugin.pluginCode><!--<select ng-model=\"vm.plugin.p\" class=\"form-control\" required>\n            <option ng-repeat=\"x in vm.menuTypeList\" value=\"{{x.value}}\">{{x.meaning}}</option>\n          </select>--></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><input type=hidden class=form-control ng-model=vm.plugin.Id><label class=control-label><span translate=plugin.pluginName></span></label><div class=input-group><input type=text class=form-control name=roleDescription id=field_templateName ng-model=vm.plugin.menuName readonly> <span class=input-group-btn><button id=menuNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'menuName\')\" value=menuName><i class=\"fa fa-globe\"></i></button></span></div><!--<input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\" id=\"field_appName\" ng-model=\"vm.plugin.menuName\" required>--></div></div></div><input type=text ng-if=false class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=menuIcon ng-model=vm.plugin.pluginType><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=plugin.pluginDesc></span></label><div class=input-group><!--<input type=\"text\" class=\"form-control\" name=\"roleDescription\" id=\"field_menuDesc\"\n                   ng-model=\"vm.plugin.menuDesc\" readonly/>--><textarea ng-model=vm.plugin.menuDesc readonly class=form-control rows=3 required style=\"resize: none; height: 180px\"></textarea><span class=input-group-btn><button id=menuDescBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'menuDesc\')\" value=menuDesc><i class=\"fa fa-globe\"></i></button></span></div><!--<textarea ng-model=\"vm.plugin.menuDesc\" class=\"form-control\" rows=\"3\" required style=\"resize: none; height: 180px\"></textarea>--></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=plugin.functionIntroduction></span></label><div class=input-group><!--<input type=\"text\" class=\"form-control\" name=\"roleDescription\" id=\"field_menuDesc\"\n                   ng-model=\"vm.plugin.menuDesc\" readonly/>--><textarea ng-model=vm.plugin.functionDesc readonly class=form-control rows=3 required style=\"resize: none; height: 180px\"></textarea><span class=input-group-btn><button id=functionDescBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'functionDesc\')\" value=functionDesc><i class=\"fa fa-globe\"></i></button></span></div><!--<textarea ng-model=\"vm.plugin.menuDesc\" class=\"form-control\" rows=\"3\" required style=\"resize: none; height: 180px\"></textarea>--></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label><span translate=plugin.pluginCategory></span></label><select ng-model=vm.plugin.pluginType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.pluginTypeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\" ng-if=\"vm.plugin.pluginType==\'PRODUCT\'\"><div class=form-group><label class=control-label><span translate=plugin.pluginCode></span></label><select ng-model=vm.plugin.productCode class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.pluginCodeList\" value={{x.productCode}}>{{x.productCode}}</option></select></div></div></div><!--<div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <select ng-model=\"vm.plugin.categoryId\" class=\"form-control\"  >\n            <option ng-repeat=\"x in vm.categoryList\" value=\"{{x.id}}\">{{x.categoryName}}</option>\n          </select>\n        </div>\n      </div>\n    </div>--><!--<div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <label class=\"control-label\">插件类型</label>\n          <div>\n              <label class=\"radio-inline\">\n                <input type=\"radio\" name=\"chickenEgg\" value=\"ONLINE\" ng-model=\"vm.menu.menuType\" required>\n                在线\n              </label>\n              <label class=\"radio-inline\">\n                <input type=\"radio\" name=\"chickenEgg\" value=\"LOCAL\" ng-model=\"vm.menu.menuType\" required>\n                本地\n              </label>\n          </div>\n        </div>\n      </div>\n    </div>--><!--<div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\" style=\"width: 40%;\">\n        <permission-selector permission-data=\"vm.permissionData\"></permission-selector>\n      </div>\n    </div>--><div class=row><div ng-if=\"vm.plugin.pluginType!=\'PRODUCT\'\"><div class=\"col-md-offset-4 col-md-2\"><input type=checkbox ng-model=vm.plugin.isDefault ngtruevalue=Y ngfalsevalue=N> &nbsp;&nbsp;<span translate=plugin.default></span></div></div><div ng-if=\"vm.plugin.pluginType==\'PRODUCT\'\"></div></div></div><div class=modal-footer style=text-align:center><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=plugin.save></span></button></div></form><div class=\"modal fade\" id=localeModal_menuName style=\"z-index: 2040\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_menuName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'menuName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_menuDesc style=\"z-index: 2040\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_menuDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'menuDesc\')\"><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_functionDesc style=\"z-index: 2040\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_functionDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'functionDesc\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/plugin/html/plugin.html","<style>.item {\n    float: left;\n    margin-bottom: 10px;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 48px 6px 20px;\n    position: relative;\n    text-align: center;\n    width: 100px;\n  }\n\n  .item_add {\n    height: 80px;\n    left: 50%;\n    margin: -40px 0 0 -40px;\n    padding: 0;\n    position: absolute;\n    top: 50%;\n    width: 80px;\n  }\n\n  .new_app_btn {\n    color: #777;\n    margin: 86px auto 0;\n  }\n\n  .mod-apptype_icon-message {\n    font-size: 0.8em;\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n  }\n\n  .plugin-title {\n    font-size: 2em;\n    font-weight: bold;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=plugin.pluginManagement></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=plugin.pluginName></span></label><div class=col-lg-8><input type=text ng-model=vm.plugin.menuName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=plugin.pluginCategory></span></label><div class=col-lg-8><lookup-select lookup-value=vm.plugin.pluginType lookup-type=IOT.PGM.PLUGIN_TYPE></lookup-select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=hr-line-dashed></div><div class=row><select ng-change=vm.loadAll(vm.plugin) ng-model=vm.plugin.appId class=form-control style=\"width: 30%;float: right;background-color: azure\"><option ng-repeat=\"x in vm.appList\" value={{x.appId}}>{{x.appName}}</option></select><span style=\"float: right;font-size: large;margin-top: 4px;margin-right: 5px\"><span translate=plugin.getClientPlugin></span></span></div><!--ng-if=\"vm.result.length>0\"--><div class=row ng-repeat=\"pluginType in vm.pluginTypeList\"><div><div class=plugin-title><span>{{pluginType.meaning}}</span></div></div><hr><div class=col-lg-offset-1><div ng-if=\"plugin.pluginType==pluginType.value && plugin.status==\'N\'\" class=item ng-repeat=\"plugin in vm.result\" class=col-md-12><a ui-sref=plugin.detail({id:plugin.id})><!--ui-sref=\"menu.detail({id:menu.id})\"--> <img style=width:80px;height:80px ng-src={{plugin.menuIcon}} class=img_logo></a><h3 class=name><span class=mod-apptype_icon-message></span> {{plugin.menuName}}</h3></div></div></div><div><div class=row><div class=item><span class=col-md-12 ng-if=\"vm.result.length>0\"><span translate=plugin.disablePlugin></span></span></div></div><hr><div class=row><div ng-if=\"plugin.status==\'Y\'\" class=item ng-repeat=\"plugin in vm.result\"><a ui-sref=plugin.detail({id:plugin.id})><img style=width:80px;height:80px ng-src={{plugin.menuIcon}} class=img_logo></a><h3 class=name><span class=mod-apptype_icon-message></span> {{plugin.menuName}}</h3><button ng-click=vm.deletePlugin(plugin.id)><span translate=btnTypeName.del></span></button></div></div></div><div class=row><div class=item style=\"left: 11px\"><a class=item_add ui-sref=plugin.newPlugin({appId:vm.plugin.appId})><img style=width:80px;height:80px ng-src={{vm.uploadPic}} class=img_logo></a><div class=new_app_btn><span translate=plugin.addPlugin></span></div></div></div></div></div></div></div>");
$templateCache.put("app/plugin/html/showVersion.html","<form name=editForm role=form novalidate ng-submit=vm.update()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=plugin.pluginDetail></span></h4></div><div class=modal-body><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_appName><span translate=plugin.versionNumber></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName id=field_appName ng-model=vm.version.menuVersion readonly></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><input type=hidden class=form-control ng-model=vm.menu.Id><label class=control-label for=field_appName><span translate=plugin.versionDesc></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.version.menuDesc readonly></div></div></div><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><input type=hidden class=form-control ng-model=vm.menu.Id><label class=control-label for=field_appName><span translate=plugin.pluginResource></span></label><input type=text class=form-control style=\"width:100%;border: 1px solid #c8cacd\" name=appName ng-model=vm.version.menuResource readonly></div></div></div><!--\n    <div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <label class=\"control-label\" for=\"field_appName\"><span translate=\"plugin.resourceCatalog\"></span></label>\n          <input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                 ng-model=\"vm.version.menuLocalPath\" readonly=\"true\">\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        <div class=\"form-group\">\n          <label class=\"control-label\" for=\"field_appName\"><span translate=\"plugin.targetPath\"></span></label>\n          <input type=\"text\" class=\"form-control\" style=\"width:100%;border: 1px solid #c8cacd;\" name=\"appName\"\n                 ng-model=\"vm.version.menuDestPath\" readonly=\"true\">\n        </div>\n      </div>\n    </div>--><!--    <div class=\"row\">\n      <div class=\"col-md-offset-4 col-md-4\">\n        &lt;!&ndash;<div class=\"col-md-2\">\n          <span class=\"control-span\">可见范围</span>\n        </div>&ndash;&gt;\n        <label class=\"control-label\" for=\"field_appName\">可见范围</label>\n        &lt;!&ndash;<div class=\"col-md-9\">&ndash;&gt;\n          &lt;!&ndash;<div ng-if=\"vm.ischecked!=\'permission\'\">&ndash;&gt;\n            <div class=\"multiple-select-box form-control ui-select-container ui-select-multiple ui-select-bootstrap m-b text-left \"  readOnly>\n              <span class=\"ui-select-match-item btn btn-default btn-xs\" draggable=\"true\" aria-disabled=\"false\" ng-repeat=\"data in vm.permissionData\">\n                <i class=\"{{data.dataIcon}}\"></i>{{data.dataValue}}</span>\n            </div>\n          &lt;!&ndash;</div>&ndash;&gt;\n\n          &lt;!&ndash;<div ng-if=\"vm.ischecked==\'permission\'\">\n            <permission-selector permission-data=\"vm.permissionData\"></permission-selector>\n            <br/>\n\n            <div class=\"border\" style=\"left: 0\"></div>\n            <br/>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.nocheck($event)\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消\n            </button>\n            <button type=\"button\" ng-click=\"vm.savePermission()\" class=\"btn btn-primary\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存\n            </button>\n          </div>&ndash;&gt;\n        &lt;!&ndash;</div>&ndash;&gt;\n      </div>\n      &lt;!&ndash;      <div class=\"col-md-1\">\n              <a><i class=\"fa fa-edit text-navy\">编辑</i></a>\n            </div>&ndash;&gt;\n    </div>--></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=plugin.cancel></span></button></div></form>");
$templateCache.put("app/profile/profile/profile-dialog.html","<form name=addForm role=form novalidate ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>编辑或新增维护</h4></div><div class=modal-body><!--<div class=\"form-group\" ng-show=\"vm.code.codeId\">--><!--<label >ID</label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.code.codeId\" readonly/>--><!--</div>--><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_profileName>维护名称</label><input type=text class=form-control name=code id=field_profileName ng-model=vm.profile.profileName required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_profileDesc>维护描述</label><input type=text class=form-control name=description id=field_profileDesc ng-model=vm.profile.description required></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;Cancel</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;Save</button></div></form>");
$templateCache.put("app/profile/profile/profile.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>配置维护管理</h5><!--<div class=\"ibox-tools\">\n            <a class=\"collapse-link\">\n              <i class=\"fa fa-chevron-up\"></i>\n            </a>\n            <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n              <i class=\"fa fa-wrench\"></i>\n            </a>\n            <ul class=\"dropdown-menu dropdown-user\">\n              <li><a href=\"#\">Config option 1</a>\n              </li>\n              <li><a href=\"#\">Config option 2</a>\n              </li>\n            </ul>\n            <a class=\"close-link\">\n              <i class=\"fa fa-times\"></i>\n            </a>\n          </div>--></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">维护名称</label><div class=col-lg-8><input type=text ng-model=vm.code.code class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">维护描述</label><div class=col-lg-8><input type=text ng-model=vm.code.description class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=profile.new>新增</a></div></div><div class=col-lg-4></div><div class=col-lg-4><!--<div class=\"col-lg-8 pull-right m-t-n-xs\">--><!--<button class=\"btn btn-white\" type=\"reset\" id=\"searchReset\">重置</button>--><!--<button class=\"btn btn-w-m btn-primary\" type=\"button\" ng-click=\"vm.search()\">搜索</button>--><!--</div>--></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 10%\">操作</th><th style=\"width: 10%\">名称</th><th style=\"width: 40%\">描述</th></tr></thead><tbody><tr ng-repeat=\"profile in vm.profiles track by profile.profileId\"><td><a ui-sref=profile.edit({id:profile.profileId})><i class=\"fa fa-edit text-navy\">编辑</i></a> <a ui-sref=profileValue({id:profile.profileId})><i class=\"fa fa-edit text-navy\">查看</i></a></td><td ng-bind=profile.profileName></td><td ng-bind=profile.description></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/profile/profileValue/profileValue-dialog.html","<form name=addForm role=form novalidate ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>编辑或新增维护</h4></div><div class=modal-body><!--<div class=\"form-group\" ng-show=\"vm.code.codeId\">--><!--<label >ID</label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.code.codeId\" readonly/>--><!--</div>--><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_valueId>层级</label><select class=form-control ng-model=vm.profileValue.levelId name=valueId id=field_valueId ng-mouseleave=vm.loadValue()><option value=10>全局</option><option value=20>角色</option><option value=30>用户</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_levelValue>层级值</label><select class=form-control ng-model=vm.profileValue.levelValue name=levelValue id=field_levelValue><option ng-repeat=\"x in vm.levels\" value={{x.levelValue}}>{{x.levelName}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_profileValue>配置值</label><input type=text class=form-control name=profileValue id=field_profileValue ng-model=vm.profileValue.profileValue required></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;Cancel</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;Save</button></div></form>");
$templateCache.put("app/profile/profileValue/profileValue.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>配置维护管理</h5><!--<div class=\"ibox-tools\">\n            <a class=\"collapse-link\">\n              <i class=\"fa fa-chevron-up\"></i>\n            </a>\n            <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n              <i class=\"fa fa-wrench\"></i>\n            </a>\n            <ul class=\"dropdown-menu dropdown-user\">\n              <li><a href=\"#\">Config option 1</a>\n              </li>\n              <li><a href=\"#\">Config option 2</a>\n              </li>\n            </ul>\n            <a class=\"close-link\">\n              <i class=\"fa fa-times\"></i>\n            </a>\n          </div>--></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">维护名称</label><div class=col-lg-8><input type=text ng-model=vm.profiles.profileName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">维护描述</label><div class=col-lg-8><input type=text ng-model=vm.profiles.description class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=profileValue.new({profileId:profileValues[0].profileId})>新增</a></div></div><div class=col-lg-4></div><div class=col-lg-4><!--<div class=\"col-lg-8 pull-right m-t-n-xs\">--><!--<button class=\"btn btn-white\" type=\"reset\" id=\"searchReset\">重置</button>--><!--<button class=\"btn btn-w-m btn-primary\" type=\"button\" ng-click=\"vm.search()\">搜索</button>--><!--</div>--></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 10%\">操作</th><th style=\"width: 10%\">层级</th><th style=\"width: 20%\">层级值</th><th style=\"width: 20%\">配置值</th></tr></thead><tbody><tr ng-repeat=\"profileValue in vm.profileValues track by profileValue.profileValueId\"><td><a ui-sref=profileValue.edit({profileId:profileValue.profileValueId})><i class=\"fa fa-edit text-navy\">编辑</i></a></td><td ng-if=\"profileValue.levelId==30\">用户</td><td ng-if=\"profileValue.levelId==20\">角色</td><td ng-if=\"profileValue.levelId==10\">全局</td><td ng-bind=profileValue.levelName></td><td ng-bind=profileValue.profileValue></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/task/executionLog/executionLog.html","<div><h2 translate=task.ip></h2><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=task.name></label><div class=col-lg-6><input type=text id=jobName class=form-control ng-model=vm.job.jobName></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=task.group></label><div class=col-lg-6><input type=text id=jobGroup class=form-control ng-model=vm.job.jobGroup></div></div></div><br><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=task.status></label><div class=col-lg-6><input type=text id=jobStatus class=form-control ng-model=vm.job.jobStatus></div></div><div class=col-lg-6><button class=\"col-lg-offset-5 col-lg-3 btn btn-w-m btn-primary\" type=button id=searchBtn ng-click=vm.loadJobs() translate=btnTypeName.search></button></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th translate=lookup.number></th><th translate=task.name></th><th translate=task.group></th><th translate=task.status></th><th translate=task.summary></th><th translate=task.lt></th><th translate=task.pt></th><th translate=task.nt></th><th translate=task.at></th></tr></thead><tbody><tr ng-repeat=\"job in vm.jobs track by job.jobRunningInfoId\"><td ng-bind=job.jobRunningInfoId></td><td ng-bind=job.jobName></td><td ng-bind=job.jobGroup></td><td ng-bind=job.jobStatus></td><td ng-bind=job.executionSummary></td><td ng-bind=job.previousFireTime></td><td ng-bind=job.scheduledFireTime></td><td ng-bind=job.nextFireTime></td><td ng-bind=job.fireTime></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div>");
$templateCache.put("app/task/taskDetail/ltsJob.html","<div class=row><div><span style=\"display: inline-block;font-size: 30px; margin-left: 2em; margin-top: 2em\">Job platform has been moved to new platform, click button bellow to try better experience...</span></div><span class=\"btn btn-primary\" style=\"display: inline-block;font-size: 30px; margin-left: 2em; margin-top: 2em\"><a ng-href={{vm.ltsJobUrl}} target=_blank style=\"color: #fff\"><span translate=task.ltsJob></span></a></span></div>");
$templateCache.put("app/task/taskDetail/scheduler.html","<div class=row><div class=col-lg-12><div class=ibox-title><h2>用户管理</h2></div><div class=\"ibox float-e-margins\"><div class=ibox-content><div class=container-fluid><div class=row><div class=col-lg-6><h1 style=\"font-size: 100px;margin-left: auto;margin-right: auto\">Standby</h1><button class=\"btn btn-primary\" type=button ng-click=vm.start()><i class=\"glyphicon glyphicon-play-circle\">开始</i></button><br><button class=\"btn btn-danger\" type=button ng-click=vm.standby()><i class=\"glyphicon glyphicon-stop\">停止</i></button><br><button class=\"btn btn-warning\" type=button ng-click=vm.pauseall()><i class=\"glyphicon glyphicon-pause\">暂停所有</i></button><br><button class=\"btn btn-info\" type=button ng-click=vm.resumeall()><i class=\"glyphicon glyphicon-play\">恢复所有</i></button></div><div class=col-lg-6><table class=\"table table-hover\"><tbody ng-repeat=\"scheduler in vm.schedulers track by $index\"><tr><td>Name</td><td ng-bind=scheduler.schedulerName></td></tr><tr><td>Instance Id</td><td ng-bind=scheduler.schedulerInstanceId></td></tr><tr><td>Version</td><td ng-bind=scheduler.version></td></tr><tr><td>Standby</td><td ng-bind=scheduler.inStandbyMode></td></tr><tr><td>Started</td><td ng-bind=scheduler.started></td></tr><tr><td>Running Since</td><td ng-bind=scheduler.runningSince></td></tr><tr><td>Jobs Executed</td><td ng-bind=scheduler.numberOfJobsExecuted></td></tr><tr><td>Job Store Clustered</td><td ng-bind=scheduler.jobStoreClustered></td></tr><tr><td>Suupports Persistence</td><td ng-bind=scheduler.jobStoreSupportsPersistence></td></tr><tr><td>Scheduler Remote</td><td ng-bind=scheduler.schedulerRemote></td></tr></tbody></table></div></div><div class=row><div class=col-lg-12><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox ng-click=updateSelectionAll($event)></th><th>schedname</th><th>instancename</th><th>lastcheckintime</th><th>checkininterval</th></tr></thead><tbody><tr ng-repeat=\"job in vm.jobs track by $index\"><td><input type=checkbox id={{job.jobName}} name={{job.jobGroup}} ng-checked=isSelected(job.jobName) ng-click=updateSelection($event,job.jobName)></td><td ng-bind=job.schedName></td><td ng-bind=job.instanceName></td><td ng-bind=job.lastCheckinTime></td><td ng-bind=job.checkinInterval></td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/task/taskDetail/taskDetail-new-crom.html","<style type=text/css>.text-right{\n    text-align: right;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=task.create_cron></h5></div><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><input name=appId id=appId type=hidden><div class=form-group><div class=row><label class=\"col-lg-2 control-label text-right\" translate=task.name></label><div class=col-lg-4><input name=jobName class=form-control id=jobName type=text ng-model=vm.taskDetail.jobName></div><label class=\"col-lg-2 control-label text-right\" translate=task.group></label><div class=col-lg-4><input name=jobGroup class=form-control id=jobGroup disabled type=text ng-model=vm.taskDetail.jobGroup></div></div></div><!--<div class=\"form-group\">\n            <div class=\"row\">\n              <label class=\"col-lg-2 control-label text-right\" translate=\"task.details\"></label>\n              <div class=\"col-lg-10\">\n                <input name=\"description\" class=\"form-control\" id=\"description\" type=\"text\" ng-model=\"vm.taskDetail.description\">\n              </div>\n            </div>\n          </div>--><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label translate=task.describe></label></div><div class=col-lg-10><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.taskDetail.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div><!--<input name=\"description\" class=\"form-control\" id=\"description\" type=\"text\"  ng-model=\"vm.taskDetail.description\">--></div></div></div><div class=form-group><div class=row><label class=\"col-lg-2 control-label text-right\" translate=dataAnalysis.beginDate></label><div class=col-lg-4><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"yyyy-MM-dd HH:mm:ss\" name=start id=start ng-model=vm.taskDetail.startTime datepicker-options=vm.dateOptions is-open=vm.isStartOpen> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.startOpen()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-lg-2 control-label text-right\" translate=dataAnalysis.endDate></label><div class=col-lg-4><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"yyyy-MM-dd HH:mm:ss\" name=end id=end ng-model=vm.taskDetail.endTime datepicker-options=vm.dateOptions is-open=vm.isEndOpen> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.endOpen()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label translate=task.expression></label></div><div class=col-lg-10><input name=cronExpression class=form-control id=cronExpression type=text ng-model=vm.taskDetail.cronExpression></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label translate=task.service></label></div><div class=col-lg-10><input name=urlValue class=form-control id=requestUrl type=text ng-model=vm.requestUrl.value translate-attr=\"{placeholder : \'task.up\'}\"></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label translate=task.param></label></div><div class=col-lg-10><textarea style=\"resize: none\" rows=3 name=runParams class=form-control id=runParams ng-model=vm.param.value translate-attr=\"{placeholder : \'task.pp\'}\"></textarea></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label>accessTokenUri</label></div><div class=col-lg-10><input style=\"resize: none\" rows=3 name=runParams class=form-control id=accessTokenUri ng-model=vm.accessTokenUri.value placeholder=http:// ></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label>Client Id</label></div><div class=col-lg-10><input style=\"resize: none\" rows=3 name=runParams class=form-control id=clientId ng-model=vm.clientId.value></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label>Client Secret</label></div><div class=col-lg-10><input style=\"resize: none\" rows=3 name=runParams class=form-control id=clientSecret ng-model=vm.clientSecret.value></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"><span translate=btnTypeName.cancel></span> </span>&nbsp;</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"><span translate=btnTypeName.save></span> </span>&nbsp;</button></div></form></div></div></div></div><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/task/taskDetail/taskDetail-new-rest.html","<meta charset=utf-8><link rel=stylesheet type=text/css href=bootstrap.min.css><style type=text/css>.text-right{\n    text-align: right;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><div class=row style=\"width: 800px;margin:0 auto\"><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=task.create_restful></h5></div><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><input name=appId id=appId type=hidden><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label translate=task.name></label></div><div class=col-lg-10><input name=jobName class=form-control id=jobName type=text ng-model=vm.taskDetail.jobName></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label translate=task.describe></label></div><div class=col-lg-10><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.taskDetail.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div><!--<input name=\"description\" class=\"form-control\" id=\"description\" type=\"text\"  ng-model=\"vm.taskDetail.description\">--></div></div></div><div class=form-group><div class=row><label class=\"col-lg-2 control-label text-right\" translate=dataAnalysis.beginDate></label><div class=col-lg-4><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"yyyy-MM-dd HH:mm:ss\" name=start id=start ng-model=vm.taskDetail.startTime datepicker-options=vm.dateOptions is-open=vm.isStartOpen> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.startOpen()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-lg-2 control-label text-right\" translate=dataAnalysis.endDate></label><div class=col-lg-4><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"yyyy-MM-dd HH:mm:ss\" name=end id=end ng-model=vm.taskDetail.endTime datepicker-options=vm.dateOptions is-open=vm.isEndOpen> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.endOpen()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><div class=form-group><div class=row><label class=\"col-lg-2 control-label text-right\" translate=task.repeat></label><div class=col-lg-4><input name=repeatInterval class=form-control id=repeatInterval type=number ng-model=vm.taskDetail.repeatInterval></div><label class=\"col-lg-2 control-label text-right\" translate=task.rt></label><div class=col-lg-4><input name=repeatCount class=form-control id=repeatCount type=number ng-model=vm.taskDetail.repeatCount></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label translate=task.service></label></div><div class=col-lg-10><input name=urlValue class=form-control id=requestUrl type=text ng-model=vm.requestUrl.value translate-attr=\"{placeholder : \'task.up\'}\"></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label translate=task.param></label></div><div class=col-lg-10><textarea style=\"resize: none\" rows=3 name=runParams class=form-control id=runParams ng-model=vm.param.value translate-attr=\"{placeholder : \'task.pp\'}\"></textarea></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label>accessTokenUri</label></div><div class=col-lg-10><input style=\"resize: none\" rows=3 name=runParams class=form-control id=accessTokenUri ng-model=vm.accessTokenUri.value placeholder=http:// ></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label>Client Id</label></div><div class=col-lg-10><input style=\"resize: none\" rows=3 name=runParams class=form-control id=clientId ng-model=vm.clientId.value></div></div></div><div class=form-group><div class=row><div class=\"col-lg-2 text-right\"><label class=control-label>Client Secret</label></div><div class=col-lg-10><input style=\"resize: none\" rows=3 name=runParams class=form-control id=clientSecret ng-model=vm.clientSecret.value></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"><span translate=btnTypeName.cancel></span> </span>&nbsp;</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"><span translate=btnTypeName.save></span></span></button></div></form></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/task/taskDetail/taskDetail-new.html","<div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>新建简单任务</h5></div><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><input name=appId id=appId type=hidden><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">任务名称</label><div class=col-lg-8><input name=jobName class=form-control id=jobName type=text ng-model=vm.taskDetail.jobName></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">任务组</label><div class=col-lg-8><input name=jobGroup class=form-control id=jobGroup type=text disabled ng-model=vm.taskDetail.jobGroup></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">任务描述</label><div class=col-lg-8><input name=description class=form-control id=description type=text ng-model=vm.taskDetail.description></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">任务类名</label><div class=col-lg-8><input name=jobClassName class=form-control id=jobClassName type=text ng-model=vm.taskDetail.jobClassName></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">开始日期</label><div class=col-lg-8><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"yyyy-MM-dd HH:mm:ss\" name=start id=start ng-model=vm.taskDetail.startTime datepicker-options=vm.dateOptions is-open=vm.isStartOpen> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.startOpen()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">结束日期</label><div class=col-lg-8><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"yyyy-MM-dd HH:mm:ss\" name=end id=end ng-model=vm.taskDetail.endTime datepicker-options=vm.dateOptions is-open=vm.isEndOpen> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.endOpen()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">重复间隔</label><div class=col-lg-8><input name=repeatInterval class=form-control id=repeatInterval type=number ng-model=vm.taskDetail.repeatInterval></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">重复次数</label><div class=col-lg-8><input name=repeatCount class=form-control id=repeatCount type=number ng-model=vm.taskDetail.repeatCount></div></div></div></div><div class=table-responsive><div class=form-group><div class=\"row col-lg-5\"><div class=col-lg-6><button class=\"col-lg-1 btn btn-w-m btn-info\" type=button ng-click=vm.addRow()>新建</button></div><div class=col-lg-6><button class=\"col-lg-1 btn btn-w-m btn-info\" type=button ng-click=vm.delRow()>删除</button></div></div></div><table class=\"table table-striped\"><thead><tr><th style=width:15px><input type=checkbox ng-click=vm.updateSelectionAll($event)></th><th>属性名</th><th>属性值</th></tr></thead><tbody><tr ng-repeat=\"data in vm.taskDetail.jobData track by $index\"><td style=width:15px><input type=checkbox ng-checked=vm.isSelected($index) ng-click=updateSelection($event,$index)></td><td><input type=text class=form-control ng-model=data.name></td><td><input type=text class=form-control ng-model=data.value></td></tr></tbody></table></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;取消</button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;保存</button></div></form></div></div></div></div>");
$templateCache.put("app/task/taskDetail/taskDetail-show.html","<div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>任务详情</h5></div><div class=ibox-content><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">任务名称</label><div class=col-lg-8>{{vm.job.jobName}}</div></div><div class=col-lg-6><label class=\"col-lg-4 control-label\">任务组</label><div class=col-lg-8>{{vm.job.jobGroup}}</div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">任务描述</label><div class=col-lg-8>{{vm.job.description}}</div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">任务类名</label><div class=col-lg-8>{{vm.job.jobClassName}}</div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">开始日期</label><div class=col-lg-8>{{vm.job.startTime}}</div></div><div class=col-lg-6><label class=\"col-lg-4 control-label\">结束日期</label><div class=col-lg-8>{{vm.job.endTime}}</div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">上次执行日期</label><div class=col-lg-8>{{vm.job.previousFireTime}}</div></div><div class=col-lg-6><label class=\"col-lg-4 control-label\">实际执行日期</label><div class=col-lg-8>{{vm.job.fireTime}}</div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">计划执行日期</label><div class=col-lg-8>{{vm.job.scheduledFireTime}}</div></div><div class=col-lg-6><label class=\"col-lg-4 control-label\">下次执行日期</label><div class=col-lg-8>{{vm.job.nextFireTime}}</div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">表达式</label><div class=col-lg-8>{{vm.job.cronExpression}}</div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">请求资源</label><div class=col-lg-8>{{vm.requestUrl.value}}</div></div><div class=col-lg-6><label class=\"col-lg-4 control-label\">执行参数</label><div class=col-lg-8>{{vm.param.value}}</div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">Client Id</label><div class=col-lg-8>{{vm.clientId.value}}</div></div><div class=col-lg-6><label class=\"col-lg-4 control-label\">Client Secret</label><div class=col-lg-8>{{vm.clientSecret.value}}</div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-4 control-label\">AccessToken Uri</label><div class=col-lg-8>{{vm.accessTokenUri.value}}</div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>关闭</button></div></div></div></div></div>");
$templateCache.put("app/task/taskDetail/taskDetail.html","<div><h2 translate=task.details></h2><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=task.name></label><div class=col-lg-6><input type=text id=jobName class=form-control ng-model=vm.dto.jobName></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\" translate=task.group></label><div class=col-lg-6><input type=text id=jobGroup class=form-control ng-model=vm.dto.jobGroup></div></div></div><br><div class=row><div class=col-lg-5><button class=\"col-lg-offset-5 col-lg-3 btn btn-primary\" type=button id=searchBtn ng-click=vm.loadJobs()><i class=\"glyphicon glyphicon-search\" translate=btnTypeName.search></i></button></div></div><br><div class=row><div class=col-lg-5><button class=\"col-lg-offset-5 col-lg-3 btn btn-primary\" type=button ui-sref=taskDetail.scheduler><i class=\"glyphicon glyphicon-share-alt\" translate=task.management></i></button></div></div><br><div class=\"row col-lg-10\" style=\"margin-left: 20px\"><button class=\"btn btn-primary\" type=button ui-sref=taskDetail.newRest><i class=\"glyphicon glyphicon-pencil\" translate=task.create_restful></i></button> <button class=\"btn btn-primary\" type=button ui-sref=taskDetail.newCrom><i class=\"glyphicon glyphicon-pencil\" translate=task.create_cron></i></button><!--<button class=\"btn btn-primary\" type=\"button\" ui-sref=\"taskDetail.new\">--><!--<i class=\"glyphicon glyphicon-pencil\"> 新建简单任务</i>--><!--</button>--> <button class=\"btn btn-danger\" type=button ng-click=vm.delJobs()><i class=\"glyphicon glyphicon-remove\" translate=btnTypeName.del></i></button> <button class=\"btn btn-warning\" type=button ng-click=vm.pauseJobs()><i class=\"glyphicon glyphicon-pause\" translate=task.suspend></i></button> <button class=\"btn btn-info\" type=button ng-click=vm.resumeJobs()><i class=\"glyphicon glyphicon-play\" translate=task.regain>恢复</i></button></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox ng-click=vm.updateSelectionAll($event)></th><th translate=task.name></th><th translate=task.status></th><th translate=task.group></th><th translate=task.describe></th><th translate=task.lt></th><th translate=task.pt></th><th translate=task.nt></th><th translate=task.at></th></tr></thead><tbody><tr ng-repeat=\"job in vm.jobs track by $index\"><td width=5%><input type=checkbox id={{job.jobName}} name={{job.jobGroup}} ng-checked=vm.isSelected(job.jobName) ng-click=vm.updateSelection($event,job.jobName)></td><td ng-bind=job.jobName ui-sref=taskDetail.show({jobName:job.jobName}) ng-style=vm.setColor(job.jobStatus) width=10%></td><td ng-bind=job.jobStatus ng-style=vm.setColor(job.jobStatus) width=10%></td><td ng-bind=job.jobGroup width=10%></td><td ng-bind=job.description width=10%></td><td ng-bind=job.previousFireTime width=15%></td><td ng-bind=job.scheduledFireTime width=15%></td><td ng-bind=job.nextFireTime width=15%></td><td ng-bind=job.fireTime width=10%></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div>");
$templateCache.put("app/workflowApv/wfConditionType/editWfConditionType.html","<alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 ng-if=\"vm.editOrCreate==\'create\'\">工作流筛选条件-新增</h5><h5 ng-if=\"vm.editOrCreate==\'edit\'\">工作流筛选条件-修改</h5></div><div class=ibox-content><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">来源系统名称</label><div class=col-lg-8><input type=text ng-model=vm.wfConditionType.apiHeaderName class=form-control readonly></div></div></div></div><div class=hr-line-dashed></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">筛选条件代码</label><div class=col-lg-8><input type=hidden ng-model=vm.wfConditionType.id> <input class=form-control type=text ng-model=vm.wfConditionType.conditionTypeCode required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">筛选条件名称</label><div class=col-lg-8><input class=form-control type=text ng-model=vm.wfConditionType.conditionTypeName required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">获取筛选条件内容接口名称</label><div class=col-lg-8><div class=input-group><input type=text ng-model=vm.wfConditionType.getWfConditionApiName class=form-control readonly> <span class=input-group-btn><button type=button ng-click=vm.goSelectLine() class=\"btn btn-primary glyphicon glyphicon-search\"></button></span></div></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel()>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveOrUpdate()>保存</button></div></div></div></div></div></div></div>");
$templateCache.put("app/workflowApv/wfInt/wfInt.html","<alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>工作流接口状态查询</h5></div><div class=ibox-content><!--<form class=\"form-horizontal\">--><!--<div class=\"form-group\">--><!--<div class=\"row\">--><!--<div class=\"col-lg-4\">--><!--<label class=\"col-lg-4 control-label\">来源系统名称</label>--><!--<div class=\"col-lg-8\">--><!--<input type=\"text\" ng-model=\"vm.wfSource.apiHeaderName\" class=\"form-control\">--><!--</div>--><!--</div>--><!--<div class=\"col-lg-8\">--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<div class=\"row\">--><!--<div class=\"col-lg-4\"></div>--><!--<div class=\"col-lg-4\">--><!--<div class=\"col-lg-8 pull-right m-t-n-xs\">--><!--<button class=\"btn btn-white\" type=\"reset\" id=\"searchReset\">重置</button>--><!--<button class=\"btn btn-w-m btn-primary\" type=\"button\" ng-click=\"vm.search()\">搜索</button>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-4\"></div>--><!--</div>--><!--</div>--><!--</form>--><!--<div class=\"hr-line-dashed\"></div>--><div><table datatable=\"\" dt-options=vm.dtOptions dt-columns=vm.dtColumns class=\"table table-bordered table-striped table-hover\"></table></div></div></div></div></div>");
$templateCache.put("app/workflowApv/wfSource/editWfSource.html","<alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 ng-if=\"vm.editOrCreate==\'create\'\">工作流来源-新增</h5><h5 ng-if=\"vm.editOrCreate==\'edit\'\">工作流来源-修改</h5></div><div class=ibox-content><div class=form-group><div class=row><div class=col-lg-3></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">来源系统名称</label><div class=col-lg-8><!--<select class=\"form-control\" ng-model=\"vm.wfSource.apiHeaderName\"--><!--ng-options=\"a.headerId as a.name for a in vm.sourceName\" required>--><!--</select>--><div class=input-group><input type=text ng-model=vm.wfSource.apiHeaderName class=form-control readonly> <span class=input-group-btn><button type=button ng-click=vm.goSelectHeader() class=\"btn btn-primary glyphicon glyphicon-search\"></button></span></div></div></div><div class=col-lg-3></div></div></div><div class=form-group><div class=row><div class=col-lg-3></div><div class=col-lg-6><label class=\"col-lg-3 control-label\">单据列表接口名称</label><div class=col-lg-8><div class=input-group><input type=text ng-model=vm.wfSource.getWfListApiName class=form-control readonly> <span class=input-group-btn><button type=button ng-click=vm.goSelectLine() class=\"btn btn-primary glyphicon glyphicon-search\"></button></span></div></div></div><div class=col-lg-3></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel()>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveOrUpdate()>保存</button></div></div></div></div></div></div></div>");
$templateCache.put("app/workflowApv/wfSource/wfSourceList.html","<alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>工作流来源管理</h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">来源系统名称</label><div class=col-lg-8><input type=text ng-model=vm.wfSource.apiHeaderName class=form-control></div></div><div class=col-lg-8></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=wfSource.edit>新增</a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset id=searchReset>重置</button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()>搜索</button></div></div></div></div></form><div class=hr-line-dashed></div><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th>操作</th><th>序号</th><th>来源系统名称</th><th>待办列表接口名称</th></tr></thead><tbody><tr ng-repeat=\"wfSource in vm.wfSourceAll \"><td><a ui-sref=wfTemp({sourceId:wfSource.id})><i class=\"fa fa-desktop text-navy\">查看</i></a> <a ui-sref=wfSource.edit({id:wfSource.id})><i class=\"fa fa-edit text-warning\">编辑</i></a> <a ng-click=vm.delete(wfSource.id)><i class=\"fa fa-times text-warning\">删除</i></a></td><td>{{$index+1}}</td><td>{{wfSource.apiHeaderName}}</td><td>{{wfSource.getWfListApiName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/workflowApv/wfTemp/editWfTemp.html","<alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 ng-if=\"vm.editOrCreate==\'create\'\">工作流模板-新增</h5><h5 ng-if=\"vm.editOrCreate==\'edit\'\">工作流模板-修改</h5></div><div class=ibox-content><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">来源系统名称</label><div class=col-lg-8><input type=text ng-model=vm.wfTemp.apiHeaderName class=form-control readonly></div></div></div></div><div class=hr-line-dashed></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">模板代码</label><div class=col-lg-8><input type=hidden ng-model=vm.wfTemp.id> <input class=form-control type=text ng-model=vm.wfTemp.templateCode required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">工作流名称</label><div class=col-lg-8><input class=form-control type=text ng-model=vm.wfTemp.workflowName required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">单据详情接口名称</label><div class=col-lg-8><div class=input-group><input type=text ng-model=vm.wfTemp.getWfDetailApiName class=form-control readonly> <span class=input-group-btn><button type=button ng-click=\"vm.goSelectLine(\'detail\')\" class=\"btn btn-primary glyphicon glyphicon-search\"></button></span></div></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">审批回执接口名称</label><div class=col-lg-8><div class=input-group><input type=text ng-model=vm.wfTemp.setWfStatusApiName class=form-control readonly> <span class=input-group-btn><button type=button ng-click=\"vm.goSelectLine(\'setStatus\')\" class=\"btn btn-primary glyphicon glyphicon-search\"></button></span></div></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\">转发人列表接口名称</label><div class=col-lg-8><div class=input-group><input type=text ng-model=vm.wfTemp.getUserListApiName class=form-control readonly> <span class=input-group-btn><button type=button ng-click=\"vm.goSelectLine(\'userList\')\" class=\"btn btn-primary glyphicon glyphicon-search\"></button></span></div></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button class=\"btn btn-default\" ng-click=vm.cancel()>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveOrUpdate()>保存</button></div></div></div></div></div></div></div>");
$templateCache.put("app/workflowApv/wfTemp/wfTempList.html","<alert-error></alert-error><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>工作流模板管理</h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">来源系统</label><div class=col-lg-8><input type=text ng-model=vm.wfTemp.apiHeaderName class=form-control readonly></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">单据列表接口名称</label><div class=col-lg-8><input type=text ng-model=vm.wfTemp.getWfListApiName class=form-control readonly></div></div></div></div></form><div class=hr-line-dashed></div><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">模板代码</label><div class=col-lg-8><input type=text ng-model=vm.wfTemp.templateCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">工作流名称</label><div class=col-lg-8><input type=text ng-model=vm.wfTemp.workflowName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=wfTemp.edit({sourceId:vm.wfTemp.sourceId})>新增</a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset id=searchReset>重置</button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()>搜索</button></div></div></div></div></form><div class=hr-line-dashed></div><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th>操作</th><th>序号</th><th>模板代码</th><th>工作流名称</th><!--<th>待办列表接口地址</th>--><th>单据详情接口名称</th><!--<th>待办详情接口地址</th>--><th>审批回执接口名称</th><!--<th>审批回执接口地址</th>--><th>转发人列表接口名称</th><!--<th>转发人列表接口地址</th>--><!--<th>是否有效</th>--></tr></thead><tbody><tr ng-repeat=\"wfTemp in vm.wfTempAll \"><td><a ui-sref=wfTemp.edit({id:wfTemp.id,sourceId:vm.wfTemp.sourceId})><i class=\"fa fa-edit text-warning\">编辑</i></a> <a ng-click=vm.delete(wfTemp.id)><i class=\"fa fa-times text-warning\">删除</i></a></td><td>{{$index+1}}</td><td>{{wfTemp.templateCode}}</td><td>{{wfTemp.workflowName}}</td><!--<td>{{wfTemp.wfListItfAddr}}</td>--><td>{{wfTemp.getWfDetailApiName}}</td><!--<td>{{wfTemp.wfDetailItfAddr}}</td>--><td>{{wfTemp.setWfStatusApiName}}</td><!--<td>{{wfTemp.wfActionItfAddr}}</td>--><td>{{wfTemp.getUserListApiName}}</td><!--<td>{{wfTemp.wfForwardListItfAddr}}</td>--></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>工作流筛选条件管理</h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">来源系统</label><div class=col-lg-8><input type=text ng-model=vm.wfTemp.apiHeaderName class=form-control readonly></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">单据列表接口名称</label><div class=col-lg-8><input type=text ng-model=vm.wfTemp.getWfListApiName class=form-control readonly></div></div></div></div></form><div class=hr-line-dashed></div><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">筛选条件代码</label><div class=col-lg-8><input type=text ng-model=vm.wfConditionType.conditionTypeCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">筛选条件名称</label><div class=col-lg-8><input type=text ng-model=vm.wfConditionType.conditionTypeName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=wfTemp.wfConditionTypeEdit({sourceId:vm.wfTemp.sourceId})>新增</a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset>重置</button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchConditionType()>搜索</button></div></div></div></div></form><div class=hr-line-dashed></div><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th>操作</th><th>序号</th><th>筛选条件代码</th><th>筛选条件名称</th><th>获取筛选条件内容接口名称</th></tr></thead><tbody><tr ng-repeat=\"wfConditionType in vm.wfConditionTypeAll \"><td><a ui-sref=wfTemp.wfConditionTypeEdit({id:wfConditionType.id,sourceId:vm.wfTemp.sourceId})><i class=\"fa fa-edit text-warning\">编辑</i></a><!--<a ng-click=\"vm.editConditionType(wfConditionType.id)\"><i class=\"fa fa-edit text-warning\">编辑</i></a>--> <a ng-click=vm.deleteConditionType(wfConditionType.id)><i class=\"fa fa-times text-warning\">删除</i></a></td><td>{{$index+1}}</td><td>{{wfConditionType.conditionTypeCode}}</td><td>{{wfConditionType.conditionTypeName}}</td><td>{{wfConditionType.getWfConditionApiName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.conditionPage total=vm.totalConditionItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalConditionItems ng-model=vm.conditionPage ng-change=vm.conditionPageChanged()></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/cmt/tokenLogon.html","<div class=row><button class=\"btn btn-primary\" style=\"margin: 20px\" ng-click=\"vm.tokenLogon(\'http://www.baidu.com\')\">百度</button></div>");
$templateCache.put("app/iot/portal/admin/cmt/webLogon.html","<style type=text/css>.weblogin-bg{\n    /*background: rgba(0, 255, 255, 0.8) none repeat scroll 0 0;*/\n    top: 40px;\n    height: 500px;\n    position: relative;\n    background: rgba(0, 0, 0, 0) url(\"assets/images/login-bg.jpg\") repeat scroll 0 0 / 100% auto;\n    width: 100%;\n  }\n  .Warning {\n    border: 1px dashed #E3DC89;\n    background: #FFFFCC;\n    margin-top: 5px;\n    padding: 100px;\n    color: #CB2D01;\n\n  }\n  .lobt{\n    margin: 10px;\n  }</style><div class=\"weblogin-bg ng-scope\"><div class=\"middle-box text-center loginscreen animated fadeInDown\" style=\"margin-left: 36%\"><div class=\"col-md-10 col-md-offset-1\"><div class=row><h3>KOHLER</h3><p><span>LOGIN</span></p><form role=form ng-submit=vm.login($event) class=\"ng-pristine ng-invalid ng-invalid-required\"><div class=Warning>是否登录</div><div class=\"m-t col-lg-12\"><!-- <span>{{vm.toUrl}}</span>--> <button class=\"btn btn-primary col-lg-5 lobt\" ng-click=vm.logon()>确定登录</button> <button class=\"btn col-lg-5 lobt\" ng-click=vm.outLogon()>取消登录</button></div></form></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/analysis/html/deviceActivity.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dataAnalysis.deviceActivity></span></h5></div><div class=ibox-content><div class=row style=\"margin-bottom: 50px\"><div class=col-lg-4 style=\"display: flex; flex-direction: column\"><h1 for=\"\">{{vm.totalDevices}}</h1><label for=\"\"><span translate=dataAnalysis.totalDevice></span></label></div><div class=col-lg-4><h1 for=\"\">{{vm.thirtyDaysDevices}}</h1><label for=\"\"><span translate=dataAnalysis.30DaysDevices></span></label></div><div class=col-lg-4><h1 for=\"\">{{vm.sevenDaysDevices}}</h1><label for=\"\"><span translate=dataAnalysis.7DaysDevices></span></label></div></div><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dataAnalysis.provinceCode></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.region><option value=\"\"></option><option ng-repeat=\"x in vm.provinceList\" value={{x.code}}>{{x.province}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=function.moduleType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.moduleType><option value=\"\"></option><option ng-repeat=\"x in vm.moduleList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.product></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.productCode><option value=\"\"></option><option ng-repeat=\"x in vm.products\" value={{x.productCode}}>{{x.productName}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.type></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.productType><option value=\"\"></option><option ng-repeat=\"x in vm.productTypes\" value={{x.productTypeCode}}>{{x.productTypeName}}</option></select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dataAnalysis.deviceStatusCmd></span></label><div class=col-lg-8><input type=text ng-model=vm.deviceActivity.cmdCode class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dataAnalysis.queryType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.queryType><option ng-repeat=\"x in vm.typeList\" value={{x}}>{{x}}</option></select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label text-right\" translate=dataAnalysis.beginDate></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control name=start id=start ng-change=vm.compareDate() ng-model=vm.deviceActivity.startDateTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label text-right\" translate=dataAnalysis.endDate></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control name=end id=end ng-change=vm.compareDate() ng-model=vm.deviceActivity.endDateTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><div class=\"col-lg-12 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchDeviceActivity()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-danger\" type=button ng-click=vm.resetDeviceActivity()><span translate=btnTypeName.reset></span></button></div></div></div></form><div id=eContainerTotal style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie7 style=\"padding-left: 0\"></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/analysis/html/productStatus.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dataAnalysis.productStatus></span></h5></div><div class=ibox-content><div class=row style=\"margin-bottom: 20px\"><div class=col-lg-4 style=\"display: flex; flex-direction: column\"><h1 for=\"\">{{vm.deviceCount}}</h1><label for=\"\"><span translate=dataAnalysis.deviceCount></span></label></div></div><form class=form-horizontal><div class=form-group><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.product></span></label><div class=col-lg-8><select class=form-control ng-model=vm.productStatus.productCode><option value=\"\"></option><option ng-repeat=\"x in vm.products\" value={{x.productCode}}>{{x.productName}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dataAnalysis.statusCode></span></label><div class=col-lg-8><input type=text ng-model=vm.productStatus.cmdCode class=form-control></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label text-right\" translate=dataAnalysis.beginDate></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control name=start id=start ng-change=vm.compareDate() ng-model=vm.productStatus.startDateTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label text-right\" translate=dataAnalysis.endDate></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control name=end id=end ng-change=vm.compareDate() ng-model=vm.productStatus.endDateTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><div class=\"col-lg-12 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchProductStatusCode()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-danger\" type=button ng-click=vm.resetProductStatusCode()><span translate=btnTypeName.reset></span></button></div></div></div></form><div id=eContainerTotal style=\"margin-bottom: 10px;\n              height: 357px;\n              padding-left: 0;\n              margin-top: 20px\"><div id=pie7 style=\"padding-left: 0\"></div></div><div id=pie8 style=\"display: flex;\n              justify-content: space-between;\n              align-items: center;\n              padding-left: 0;\n              height: 357px\"><div id=pie8_morning style=\"width: 32%; height: 100%\"></div><div id=pie8_afternoon style=\"width: 32%; height: 100%\"></div><div id=pie8_evening style=\"width: 32%; height: 100%\"></div></div><div id=statusListView style=\"margin-top: 20px\" ng-show=\"vm.statusDataForList.length > 0\"><div ng-repeat=\"card in vm.statusDataForList\" class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title>{{card.cmdCode}} ({{card.productCode}}) - <span translate=dataAnalysis.deviceCount></span>: {{card.deviceCount}}</h3></div><div class=panel-body><div ng-repeat=\"(time, stats) in card.timeStats\" class=\"panel panel-default\"><div class=panel-heading role=tab id=heading-{{card.cmdCode}}-{{time}}><a role=button data-toggle=collapse href=#collapse-{{card.cmdCode}}-{{time}} aria-expanded=true aria-controls=collapse-{{card.cmdCode}}-{{time}}><h4 class=panel-title><i class=\"fa fa-caret-right\"></i> {{time}}</h4></a></div><div id=collapse-{{card.cmdCode}}-{{time}} class=\"panel-collapse collapse in\" role=tabpanel aria-labelledby=heading-{{card.cmdCode}}-{{time}}><div class=panel-body><table class=\"table table-striped table-bordered\"><thead><tr><th style=\"width: 30%\">参数键 (Param Key)</th><th style=\"width: 30%\">参数值 (Param Value)</th><th style=\"width: 40%\">统计数量 (Count)</th></tr></thead><tbody><tr ng-repeat=\"item in stats\"><td>{{item.paramKey}}</td><td>{{item.paramValue}}</td><td>{{item.count}}</td></tr><tr ng-if=\"stats.length === 0\"><td colspan=3 class=text-center>暂无数据</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/analysis/html/top10commands.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dataAnalysis.top10Commands></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dataAnalysis.provinceCode></span></label><div class=col-lg-8><select class=form-control ng-model=vm.top10Commands.region><option value=\"\"></option><option ng-repeat=\"x in vm.provinceList\" value={{x.code}}>{{x.province}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=function.moduleType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.top10Commands.moduleType><option value=\"\"></option><option ng-repeat=\"x in vm.moduleList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.product></span></label><div class=col-lg-8><select class=form-control ng-model=vm.top10Commands.productCode><option value=\"\"></option><option ng-repeat=\"x in vm.products\" value={{x.productCode}}>{{x.productName}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.type></span></label><div class=col-lg-8><select class=form-control ng-model=vm.top10Commands.productType><option value=\"\"></option><option ng-repeat=\"x in vm.productTypes\" value={{x.productTypeCode}}>{{x.productTypeName}}</option></select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label text-right\" translate=dataAnalysis.beginDate></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control name=start id=start ng-change=vm.compareDate() ng-model=vm.top10Commands.startDateTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label text-right\" translate=dataAnalysis.endDate></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control name=end id=end ng-change=vm.compareDate() ng-model=vm.top10Commands.endDateTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><div class=\"col-lg-12 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchTop10Commands()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-danger\" type=button ng-click=vm.resetTop10Commands()><span translate=btnTypeName.reset></span></button></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=dataAnalysis.commandName></span></th><th><span translate=dataAnalysis.commandCount></span></th></tr></thead><tbody><tr ng-repeat=\"dvmDevice in vm.devices\"><td ng-bind=dvmDevice.cmdCode></td><td ng-bind=dvmDevice.count></td></tr></tbody></table><!-- <div class=\"text-center\">\n              <item-count page=\"vm.page\" total=\"vm.totalDevice\" items-per-page=\"vm.itemsPerPage\"></item-count>\n              <uib-pagination class=\"pagination-sm\"\n                              total-items=\"vm.totalDevice\"\n                              ng-model=\"vm.page\"\n                              ng-change=\"vm.residentialPageChanged()\"></uib-pagination>\n            </div> --></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/analysis/html/userActivity.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dataAnalysis.userActivity></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dataAnalysis.provinceCode></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.region><option value=\"\"></option><option ng-repeat=\"x in vm.provinceList\" value={{x.code}}>{{x.province}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=function.moduleType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.moduleType><option value=\"\"></option><option ng-repeat=\"x in vm.moduleList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.product></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.productCode><option value=\"\"></option><option ng-repeat=\"x in vm.products\" value={{x.productCode}}>{{x.productName}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.type></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.productType><option value=\"\"></option><option ng-repeat=\"x in vm.productTypes\" value={{x.productTypeCode}}>{{x.productTypeName}}</option></select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dataAnalysis.userSendCmd></span></label><div class=col-lg-8><input type=text ng-model=vm.deviceActivity.cmdCode class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dataAnalysis.queryType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.deviceActivity.queryType><option ng-repeat=\"x in vm.typeList\" value={{x}}>{{x}}</option></select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label text-right\" translate=dataAnalysis.beginDate></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control name=start id=start ng-change=vm.compareDate() ng-model=vm.deviceActivity.startDateTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label text-right\" translate=dataAnalysis.endDate></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control name=end id=end ng-change=vm.compareDate() ng-model=vm.deviceActivity.endDateTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><div class=\"col-lg-12 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchDeviceActivity()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-danger\" type=button ng-click=vm.resetDeviceActivity()><span translate=btnTypeName.reset></span></button></div></div></div></form><div id=eContainerTotal style=\"margin-bottom: 10px; height: 357px; padding-left: 0; margin-top: 20px\"><div id=pie7 style=\"padding-left: 0\"></div></div><div style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie8 style=\"padding-left: 0\"></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/analysis/html/userRegion.html","<div class=row><alert-error></alert-error></div><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dataAnalysis.userInformation></span></h5></div><div class=ibox-content><div class=row><div id=eContainerTotal class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie1 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie2 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie3 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><!-- <div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\">\n              <div id=\"pie4\" class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div>\n            </div> --></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ai/html/acquisitionNode-dialog.html","<style>#toast-container{\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=editForm role=form ng-submit=vm.saveSceneProduct()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate={{vm.title}}></span></h4></div><div class=modal-body><div class=form-group><div class=row><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.acquisitionNodeCode></span></label><div><input type=text class=form-control ng-model=vm.acquisitionNode.collectionNodeCode required></div></div><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.product></span></label><div><select ng-if=!vm.edit ng-model=vm.acquisitionNode.productId class=form-control required><option ng-repeat=\"x in vm.products\" value={{x.productId}}>{{x.productName}}</option></select><input ng-if=vm.edit type=text class=form-control ng-model=vm.acquisitionNode.productName disabled></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.cmd></span></label><div><input type=text class=form-control ng-model=vm.acquisitionNode.cmdCode required ng-disabled=vm.edit></div></div><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.parameter></span></label><div><input type=text class=form-control name=cmdCode ng-model=vm.acquisitionNode.paramCode required ng-disabled=vm.edit></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.productProperty></span></label><div><input type=text class=form-control name=propertyCode ng-model=vm.acquisitionNode.propertyCode required ng-disabled=vm.edit></div></div><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.preState></span></label><div><input type=text class=form-control name=cmdCode ng-model=vm.acquisitionNode.preParamValue required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.arriveState></span></label><div><input type=text class=form-control name=cmdCode ng-model=vm.acquisitionNode.arrivalParamValue required></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span> <span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-click=vm.save() ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span> <span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/ai/html/acquisitionNode.html","<style>.td-content{\n    max-width: 150px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=aiConfig.acquisitionNode></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=aiConfig.product></label><div class=col-lg-8><input type=text ng-model=vm.acquisitionNode.productName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=aiConfig.cmd></label><div class=col-lg-8><input type=text ng-model=vm.acquisitionNode.cmdCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=aiConfig.parameter></label><div class=col-lg-8><input type=text ng-model=vm.acquisitionNode.paramCode class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=acquisitionNode.add() translate=btnTypeName.create></a></div></div><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteAcquisitionNodes() translate=btnTypeName.del></a></div></div><div class=col-lg-2></div><div class=col-lg-3><div class=\"pull-right m-t-n-xs col-lg-offset-2\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset() translate=btnTypeName.reset></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search() translate=btnTypeName.search></button></div></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllAcquisitionNode()></th><th translate=btnTypeName.operation></th><th translate=aiConfig.acquisitionNodeCode></th><th translate=aiConfig.product></th><th translate=aiConfig.cmd></th><th translate=aiConfig.parameter></th><th translate=aiConfig.preState></th><th translate=aiConfig.arriveState></th><th translate=aiConfig.productProperty></th></tr></thead><tbody><tr ng-repeat=\"node in vm.acquisitionNodes\"><!--ng-repeat=\"commandSet in vm.result\"--><td><input type=checkbox name=chk_list class=chk_list value={{node.collectionNodeId}} ng-click=vm.checkAcquisitionNode()></td><td><a ui-sref=acquisitionNode.edit({collectionNodeId:node.collectionNodeId})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a> <a ng-click=vm.deleteAcquisitionNode(node.collectionNodeId)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><!-- <td>{{command.cmdId}}</td>--><td>{{node.collectionNodeCode}}</td><td>{{node.productName}}</td><td>{{node.cmdCode}}</td><td>{{node.paramCode}}</td><td>{{node.preParamValue}}</td><td>{{node.arrivalParamValue}}</td><td>{{node.propertyCode}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ai/html/aiAcquisition-dialog.html","<style>#toast-container{\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=editForm role=form ng-submit=vm.saveSceneProduct()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate={{vm.title}}></span></h4></div><div class=modal-body><div class=form-group><div class=row><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.productName></span></label><div><select ng-if=!vm.edit ng-change=vm.changeAcquisitionNode(vm.acquisitionNode) ng-model=vm.acquisitionNode class=form-control required><option ng-repeat=\"x in vm.acquisitionNodes\" value={{x}}>{{x.productName}}</option></select><input ng-if=vm.edit type=text class=form-control ng-model=vm.acquisition.productName disabled></div></div><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.acquisitionNode></span></label><div><input type=text class=form-control ng-model=vm.acquisition.collectionNodeCode required readonly></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.cmdCode></span></label><div><input type=text class=form-control name=cmdCode ng-model=vm.acquisition.cmdCode required ng-disabled=vm.edit></div></div><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.paramCode></span></label><div><input type=text class=form-control name=cmdCode ng-model=vm.acquisition.paramCode required ng-disabled=vm.edit></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.productProperty></span></label><div><input type=text class=form-control name=propertyCode ng-model=vm.acquisition.propertyCode required ng-disabled=vm.edit></div></div><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.dimension></span></label><div><select ng-model=vm.acquisition.influenceDimension class=form-control required><option ng-repeat=\"x in vm.dimensions\" value={{x.dimensionCode}}>{{x.dimensionName}}</option></select></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span> <span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-click=vm.save() ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span> <span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/ai/html/aiAcquisition.html","<style>.td-content{\n    max-width: 150px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=aiConfig.intelligentAcquisition></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=aiConfig.productName></label><div class=col-lg-8><input type=text ng-model=vm.acquisition.productName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=aiConfig.cmdCode></label><div class=col-lg-8><input type=text ng-model=vm.acquisition.cmdCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=aiConfig.dimension></label><div class=col-lg-8><input type=text ng-model=vm.acquisition.influenceDimension class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=aiConfig.paramCode></label><div class=col-lg-8><input type=text ng-model=vm.acquisition.paramCode class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=aiAcquisition.add() translate=btnTypeName.create></a></div></div><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteAcquisitions() translate=btnTypeName.del></a></div></div><div class=col-lg-2></div><div class=col-lg-3><div class=\"pull-right m-t-n-xs col-lg-offset-2\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset() translate=btnTypeName.reset></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search() translate=btnTypeName.search></button></div></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllAcquisition()></th><th translate=btnTypeName.operation></th><th translate=aiConfig.productName></th><th translate=aiConfig.dimension></th><th translate=aiConfig.cmdCode></th><th translate=aiConfig.paramCode></th><th translate=aiConfig.productProperty></th><th translate=aiConfig.acquisitionNode></th></tr></thead><tbody><tr ng-repeat=\"acquisition in vm.acquisitions\"><!--ng-repeat=\"commandSet in vm.result\"--><td><input type=checkbox name=chk_list class=chk_list value={{acquisition.collectionId}} ng-click=vm.checkAcquisition()></td><td><a ui-sref=aiAcquisition.edit({collectionId:acquisition.collectionId})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a> <a ng-click=vm.deleteAcquisition(acquisition.collectionId)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><!-- <td>{{command.cmdId}}</td>--><td>{{acquisition.productName}}</td><td>{{acquisition.influenceDimension}}</td><td>{{acquisition.cmdCode}}</td><td>{{acquisition.paramCode}}</td><td>{{acquisition.propertyCode}}</td><td>{{acquisition.collectionNodeCode}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ai/html/dimension-dialog.html","<style>#toast-container{\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=editForm role=form ng-submit=vm.saveSceneProduct()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate={{vm.title}}></span></h4></div><div class=modal-body><div class=form-group><div class=row><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.dimensionName></span></label><div><input type=text class=form-control name=cmdCode ng-model=vm.dimension.dimensionName></div></div><div class=col-lg-6><label for=\"\"><span style=\"color: red\">*</span><span translate=aiConfig.dimensionCode></span></label><div><input type=text class=form-control name=versionNumber id=versionNumber ng-model=vm.dimension.dimensionCode required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label for=\"\"><span translate=aiConfig.content></span></label><div><input type=text class=form-control name=cmdCode ng-model=vm.dimension.description></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span> <span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-click=vm.save() ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span> <span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/ai/html/dimension.html","<style>.td-content{\n    max-width: 150px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=aiConfig.dimension></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=aiConfig.dimensionName></label><div class=col-lg-8><input type=text ng-model=vm.dimension.dimensionName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=aiConfig.dimensionCode></label><div class=col-lg-8><input type=text ng-model=vm.dimension.dimensionCode class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=dimension.add() translate=btnTypeName.create></a></div></div><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteDimensions() translate=btnTypeName.del></a></div></div><div class=col-lg-2></div><div class=col-lg-3><div class=\"pull-right m-t-n-xs col-lg-offset-2\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset() translate=btnTypeName.reset></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search() translate=btnTypeName.search></button></div></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllDimension()></th><th translate=btnTypeName.operation></th><th translate=aiConfig.dimensionName></th><th translate=aiConfig.dimensionCode></th><th translate=aiConfig.content></th></tr></thead><tbody><tr ng-repeat=\"dimension in vm.dimensions\"><!--ng-repeat=\"commandSet in vm.result\"--><td><input type=checkbox name=chk_list class=chk_list value={{dimension.dimensionNodeId}} ng-click=vm.checkDimension()></td><td><a ui-sref=dimension.edit({dimensionNodeId:dimension.dimensionNodeId})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a> <a ng-click=vm.deleteDimension(dimension.dimensionNodeId)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><!-- <td>{{command.cmdId}}</td>--><td>{{dimension.dimensionName}}</td><td>{{dimension.dimensionCode}}</td><td class=td-content><a ng-click=vm.showContent(dimension)>{{dimension.description}}</a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=contentModal><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=aiConfig.dimensionContent></span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body><span>{{vm.currentContent}}</span></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/b2c/html/application-dialog.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate={{vm.title}}></h4></div><br><br><div class=modal-body><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=application.tenant></span></label><div class=col-lg-6><select ng-model=vm.application.tenantId class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"tenant in vm.tenants\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><font color=red>*</font><span translate=application.project></span></label><div class=col-lg-6><!--<input type=\"text\" id=\"project\" class=\"form-control\" ng-model=\"vm.application.project\" required>--><select class=form-control ng-model=vm.application.project required><option value=\"\" ng-show=false></option><option ng-repeat=\"project in vm.projects\" value={{project}}>{{project}}</option></select></div></div></div><br><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=application.description></span></label><div class=col-lg-6><input type=text class=form-control ng-model=vm.application.description></div></div></div><br><div class=row><button class=\"col-md-offset-10 btn btn-primary\" ng-disabled=\"addForm.$invalid || vm.isSaving\" translate=btnTypeName.save></button></div></div></div></form>");
$templateCache.put("app/iot/portal/admin/b2c/html/application.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5><span translate=application.application></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=application.tenant></span></label><div class=col-lg-6><select ng-model=vm.application.tenantId class=form-control><option></option><option ng-repeat=\"tenant in vm.tenants\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=application.project></span></label><div class=col-lg-6><!--<input type=\"text\" id=\"project\" class=\"form-control\" ng-model=\"vm.application.project\">--><select class=form-control ng-model=vm.application.project><option value=\"\"></option><option ng-repeat=\"project in vm.projects\" value={{project}}>{{project}}</option></select></div></div></div><br></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" type=button ui-sref=b2cApplication.add><span translate=btnTypeName.create></span></button></div></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=application.applicationId></span></th><th><span translate=application.project></span></th><th><span translate=application.tenantId></span></th><th><span translate=application.description></span></th></tr></thead><tbody><tr ng-repeat=\"app in vm.applications\"><!----><td><a ui-sref=b2cApplication.edit({appId:app.appId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.delete(app)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{app.appId}}</td><td>{{app.project}}</td><td>{{app.tenantId}}</td><td>{{app.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/b2c/html/clientDetails-dialog.html","<style>#toast-container {\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay {\n    z-index: 10000;\n  }\n  .sweet-alert {\n    z-index: 99999;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate={{vm.title}}></span></h4></div><div class=modal-body><div class=form-group><label for=id><span translate=clientDetail.clientId></span></label><input type=text class=form-control id=id name=id ng-model=vm.clientDetail.clientId ng-disabled=vm.isEdit></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=clientSecret><font color=red>*</font><span translate=clientDetail.clientSecret></span></label><div class=input-group><input type=password name=clientSecret style=\"display: none\"> <input type=password class=form-control name=clientSecret id=clientSecret ng-model=vm.clientDetail.clientSecret required> <span class=input-group-btn><a class=\"btn btn-default\" type=button value=templateName ng-click=vm.changeSecret()><i class=\"fa fa-eye text-navy\"></i></a></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=resourceIds><font color=red>*</font><span translate=clientDetail.resourceId></span></label><input type=text class=form-control name=resourceIds id=resourceIds ng-model=vm.clientDetail.resourceIds required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_scope><font color=red>*</font><span translate=clientDetail.scope></span></label><input type=text class=form-control name=scope id=field_scope ng-model=vm.clientDetail.scope required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_redirectUri><span translate=clientDetail.redirectUri></span></label><input type=text class=form-control name=webServerRedirectUri id=field_redirectUri ng-model=vm.clientDetail.webServerRedirectUri></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=clientDetail.authorizedGrantTypes></span></label><input ng-model=vm.clientDetail.authorizedGrantTypes class=form-control required style=\"margin-bottom: 5px\"><select id=authorizedGrantTypes ng-model=vm.grantType ng-change=vm.selectTypeChange() class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.typeValues\" value={{x.value}}>{{x.name}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=clientDetail.authorities></span></label><input ng-model=vm.clientDetail.authorities class=form-control required style=\"margin-bottom: 5px\"><select id=authoritie ng-model=vm.auth ng-change=vm.selectChange() class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.roleValues\" value={{x.value}}>{{x.name}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_accessTokenValidity><span translate=clientDetail.accessTokenValidity></span></label><input type=text class=form-control name=accessTokenValidity id=field_accessTokenValidity ng-model=vm.clientDetail.accessTokenValidity></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_refreshTokenValidity><span translate=clientDetail.refreshTokenValidity></span></label><input type=text class=form-control name=refreshTokenValidity id=field_refreshTokenValidity ng-model=vm.clientDetail.refreshTokenValidity></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=clientDetail.autoApprove></span></label><div><span style=\"position:absolute;overflow:hidden;width: 405px\"><select id=autoapprove ng-model=vm.clientDetail.autoapprove class=form-control><option ng-repeat=\"x in vm.autoapprove\" value={{x.value}}>{{x.name}}</option><option value={{vm.clientDetail.scope}}>SCOPE</option></select></span><span style=position:absolute;width:385px><input type=text ng-model=vm.clientDetail.autoapprove class=form-control></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=additionInfo><span translate=clientDetail.additionInfo></span></label><input type=text class=form-control name=additionalInformation id=additionInfo ng-model=vm.clientDetail.additionalInformation></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><font color=red>*</font><span translate=clientDetail.tenantId></span></label><input ng-model=vm.clientDetail.tenantId class=form-control required style=\"margin-bottom: 5px\"><select ng-model=vm.tenantId class=form-control ng-change=vm.selectTenantId()><option value=\"\"></option><option value=* ng-show=vm.shows>{{vm.allTenantId}}</option><option ng-repeat=\"tenant in vm.tenants\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/b2c/html/clientDetails.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=clientDetail.title></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=clientDetail.clientId></span></label><div class=col-lg-6><input type=text ng-model=vm.clientDetail.clientId class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=clientDetail.redirectUri></span></label><div class=col-lg-6><input type=text ng-model=vm.clientDetail.webServerRedirectUri class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=clientDetail.authorities></span></label><div class=col-lg-6><input type=text ng-model=vm.clientDetail.authorities class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=clientDetail.authorizedGrantTypes></span></label><div class=col-lg-6><input type=text ng-model=vm.clientDetail.authorizedGrantTypes class=form-control></div></div></div><br></div><div class=form-group><div class=row><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" type=button ui-sref=b2cClientDetails.add><span translate=btnTypeName.create></span></button></div></div><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:50px;width:100%;overflow:auto><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=clientDetail.clientId></span></th><th><span translate=clientDetail.resourceId></span></th><th><span translate=clientDetail.authorities></span></th><th><span translate=clientDetail.scope></span></th><th><span translate=clientDetail.authorizedGrantTypes></span></th><th><span translate=clientDetail.redirectUri></span></th><th><span translate=clientDetail.accessTokenValidity></span></th><th><span translate=clientDetail.refreshTokenValidity></span></th><th><span translate=clientDetail.autoApprove></span></th><th><span translate=clientDetail.tenantId></span></th></tr></thead><tbody><tr ng-repeat=\"clientDetail in vm.result\"><td><a ui-sref=b2cClientDetails.edit({clientId:clientDetail.clientId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteClient(clientDetail)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{clientDetail.clientId}}</td><td style=\"word-wrap: break-word; word-break:break-all\">{{clientDetail.resourceIds}}</td><td>{{clientDetail.authorities}}</td><td>{{clientDetail.scope}}</td><td style=\"word-wrap: break-word; word-break:break-all\">{{clientDetail.authorizedGrantTypes}}</td><td style=\"word-wrap: break-word; word-break:break-all\">{{clientDetail.webServerRedirectUri}}</td><td>{{clientDetail.accessTokenValidity}}</td><td>{{clientDetail.refreshTokenValidity}}</td><td>{{clientDetail.autoapprove}}</td><td>{{clientDetail.tenantId}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/b2c/html/key-dialog.html","<style>.sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate={{vm.title}}></h4></div><br><br><div class=modal-body><div class=form-group><div class=row><div class=row><div class=col-md-6><label for=keyName class=control-label><font color=red>*</font> <span translate=key.keyName></span></label><input class=form-control maxlength=9 ng-model=vm.key.keyName id=keyName required></div><div class=col-md-6><label for=secretName class=control-label><font color=red>*</font> <span translate=key.secretName></span></label><input class=form-control maxlength=9 ng-model=vm.key.secretName id=secretName required></div></div><br><div class=row><div class=col-md-6><label for=tenantId class=control-label><font color=red>*</font> <span translate=key.tenant></span></label><select ng-model=vm.key.tenantId id=tenantId class=form-control ng-disabled=vm.edit required><option ng-repeat=\"tenant in vm.tenants\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div><div class=col-md-6><label class=control-label><font color=red>*</font><span translate=key.isMain></span></label><!--<lookup-select lookup-value=\"vm.key.isMain\" lookup-type=\"SYS.YES_NO\" ng-required=\"true\"></lookup-select>--><select ng-model=vm.key.isMain class=form-control ng-disabled=vm.edit required><option ng-repeat=\"isMain in vm.isMain\" value={{isMain.value}}>{{isMain.name}}</option></select></div></div><br><div class=row><div class=col-md-6><label for=keySize class=control-label><span translate=key.keySize></span></label><input class=form-control maxlength=5 ng-model=vm.key.keySize id=keySize placeholder=2048></div><div class=col-md-6><label for=description class=control-label><span translate=tenant.description></span></label><input class=form-control ng-model=vm.key.description id=description></div></div></div><br><div class=row><button class=\"col-md-offset-10 btn btn-primary\" ng-disabled=\"addForm.$invalid || vm.isSaving\" translate=btnTypeName.save></button></div></div></div></form>");
$templateCache.put("app/iot/portal/admin/b2c/html/key-resetAES-dialog.html","<style>.sweet-overlay {\n    z-index: 10000;\n  }\n\n  .sweet-alert {\n    z-index: 99999;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=key.refreshRSAofAES></h4></div><br><div class=modal-body><div class=form-group><div class=row><div class=col-lg-10><div class=col-lg-3><label class=control-label style=margin-top:7px><span translate=key.keyRSA></span></label></div><div class=col-lg-9><input class=form-control maxlength=9 ng-model=vm.keyName required></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button class=\"col-md-offset-10 btn btn-primary\" ng-disabled=\"addForm.$invalid || vm.isSaving\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/b2c/html/key.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5 translate=key.key></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=key.tenant></span></label><div class=col-lg-6><select ng-model=vm.key.tenantId class=form-control><option></option><option ng-repeat=\"tenant in vm.tenants\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=key.keyName></span></label><div class=col-lg-6><input type=text id=keyName class=form-control ng-model=vm.key.keyName></div></div></div><br></div><div class=form-group><div class=row><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" ui-sref=key.add><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ui-sref=key.resetAES><span translate=key.refreshRSA></span></button></div></div><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><br><div class=row><table class=\"table table-striped\"><thead><tr><th translate=btnTypeName.operation></th><th translate=key.keyName></th><th translate=key.secretName></th><th translate=key.tenantId></th><th translate=key.isMain></th><th translate=key.keyId></th></tr></thead><tbody><tr ng-repeat=\"key in vm.keys\"><!----><td><a ui-sref=key.edit({id:key.id})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteKey(key)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a> <a ng-click=vm.setMainKey(key)><i class=\"fa fa-send text-navy\"><span translate=key.setMainKey></span></i></a> <a ng-click=vm.refreshKey(key)><i class=\"fa fa-refresh text-navy\"><span translate=key.refreshKey></span></i></a></td><td>{{key.keyName}}</td><td>{{key.secretName}}</td><td>{{key.tenantId}}</td><td><select ng-model=key.isMain disabled><option ng-repeat=\"x in vm.isMains\" value={{x.value}}>{{x.meaning}}</option></select></td><td>{{key.keyId}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/b2c/html/party-dialog.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=userManage.editParty></h4></div><br><br><div class=modal-body><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.userGroup></span></label><div class=col-lg-6><select ng-model=vm.party.userGroupId class=form-control ng-change=vm.changeTenant()><option value=-1></option><option ng-repeat=\"group in vm.groups\" value={{group.groupId}}>{{group.groupName}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=tenant.tenant></span></label><div class=col-lg-6><select ng-model=vm.party.tenantId class=form-control ng-disabled=vm.party.edit required><option ng-repeat=\"tenant in vm.results\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div></div></div><br><div class=row><button class=\"col-md-offset-10 btn btn-primary\" ng-disabled=\"addForm.$invalid || vm.isSaving\" translate=btnTypeName.save></button></div></div></div></form>");
$templateCache.put("app/iot/portal/admin/b2c/html/party.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5><span translate=userManage.rPartyManage></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.userName></span></label><div class=col-lg-6><input type=text class=form-control ng-model=vm.party.partyAccount></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.objectId></span></label><div class=col-lg-6><input type=text class=form-control ng-model=vm.party.objectId></div></div></div><br><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=tenant.tenant></span></label><div class=col-lg-6><select ng-model=vm.party.tenantId class=form-control><option></option><option ng-repeat=\"tenant in vm.results\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div></div><button style=\"margin-right: 15px\" class=\"col-lg-1 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.getResidentialParty()></button> <button style=\"margin-right: 15px\" class=\"col-lg-1 btn btn-w-m btn-info\" type=button translate=btnTypeName.export ng-click=vm.exportExcel()></button></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th translate=btnTypeName.operation></th><th><span translate=userManage.userName></span></th><th><span translate=userManage.telephone></span></th><th><span translate=userManage.email></span></th><th><span translate=userManage.birthday></span></th><th><span translate=userManage.objectId></span></th><th><span translate=tenant.tenantId></span></th><th><span translate=userManage.userGroup></span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><!----><td><a ui-sref=b2cResParty.edit({partyId:party.partyId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteResidentialParty(party)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=party.partyAccount></td><td ng-bind=party.phoneNumber></td><td ng-bind=party.emailAddress></td><td>{{party.birthDate| date:\'yyyy-MM-dd\'}}</td><td ng-bind=party.objectId></td><td ng-bind=party.tenantId></td><td ng-bind=party.userGroup></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/b2c/html/partyGroup-dialog.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate={{vm.title}}></h4></div><br><br><div class=modal-body><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=partyGroup.groupName></span></label><div class=col-lg-6><input type=text maxlength=5 class=form-control ng-model=vm.group.groupName required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font><span translate=tenant.tenant></span></label><div class=col-lg-6><select ng-model=vm.group.tenantId class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"tenant in vm.results\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div></div></div><br><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=partyGroup.description></span></label><div class=col-lg-6><input type=text id=keyName class=form-control ng-model=vm.group.description></div></div></div><br><div class=row><button class=\"col-md-offset-10 btn btn-primary\" ng-disabled=\"addForm.$invalid || vm.isSaving\" translate=btnTypeName.save></button></div></div></div></form>");
$templateCache.put("app/iot/portal/admin/b2c/html/partyGroup.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5><span translate=partyGroup.group></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=tenant.tenant></span></label><div class=col-lg-6><select ng-model=vm.group.tenantId class=form-control><option></option><option ng-repeat=\"tenant in vm.results\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=partyGroup.groupName></span></label><div class=col-lg-6><input type=text class=form-control ng-model=vm.group.groupName></div></div></div><br></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" type=button ui-sref=partyGroup.add><span translate=btnTypeName.create></span></button></div></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=row><table class=\"table table-striped\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=partyGroup.groupName></span></th><th><span translate=tenant.tenant></span></th><th><span translate=partyGroup.description></span></th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><!--  --><td><a ui-sref=partyGroup.edit({groupId:group.groupId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteGroup(group)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{group.groupName}}</td><td>{{group.tenantId}}</td><td>{{group.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/b2c/html/tenant-dialog.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate={{vm.title}}></h4></div><br><br><div class=modal-body><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font> <span translate=tenant.envFlag></span></label><div class=col-lg-6><input type=text id=envFlag class=form-control maxlength=3 ng-model=vm.tenant.envFlag required><!--<lookup-select lookup-value=\"vm.tenant.envFlag\" lookup-type=\"SYS.DATAENVIRONMENT\" required=\"true\"></lookup-select>--></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\" for=version><span translate=tenant.version></span></label><div class=col-lg-6><input type=text id=version class=form-control maxlength=2 ng-model=vm.tenant.version></div></div></div><br><div class=row ng-show=vm.keyShow><div class=col-lg-6><label class=\"col-lg-3 control-label\"><font color=red>*</font> <span translate=tenant.keyName></span></label><div class=col-lg-6><input type=text id=keyName maxlength=9 class=form-control ng-model=vm.tenant.keyName ng-required={{!vm.edit}}></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\" for=secretName><font color=red>*</font> <span translate=tenant.secretName></span></label><div class=col-lg-6><input type=text id=secretName maxlength=9 class=form-control ng-model=vm.tenant.secretName ng-required={{!vm.edit}}></div></div></div><br><div class=row><div class=col-lg-6 ng-show=vm.edit><label class=\"col-lg-3 control-label\"><font color=red>*</font> <span translate=tenant.signKeyId></span></label><div class=col-lg-6><select ng-model=vm.tenant.signKeyId ng-options=\"x.id as x.keyName for x in vm.keys\" class=form-control ng-required=vm.edit></select></div></div><div class=col-lg-6 ng-show=!vm.edit><label class=\"col-lg-3 control-label\"><span translate=key.keySize></span></label><div class=col-lg-6><input maxlength=5 class=form-control ng-model=vm.tenant.keySize placeholder=2048></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=tenant.description></span></label><div class=col-lg-6><input type=text class=form-control ng-model=vm.tenant.description></div></div></div></div><br><div class=row><button class=\"col-md-offset-10 btn btn-primary\" ng-disabled=\"addForm.$invalid || vm.isSaving\" translate=btnTypeName.save></button></div></div></form>");
$templateCache.put("app/iot/portal/admin/b2c/html/tenant.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5><span translate=tenant.tenant></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=tenant.tenant></span></label><div class=col-lg-6><select ng-model=vm.tenant.tenantId class=form-control><option></option><option ng-repeat=\"tenant in vm.results\" value={{tenant.tenantId}}>{{tenant.envFlag +((tenant.version || \"\" ) === \"\" ? (\" (\" + tenant.tenantId +\")\") : (\"/\" + tenant.version + \" (\"+tenant.tenantId+\")\"))}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=tenant.envFlag></span></label><div class=col-lg-6><input type=text id=envFlag class=form-control ng-model=vm.tenant.envFlag></div></div></div><br></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" type=button ui-sref=tenant.add><span translate=btnTypeName.create></span></button></div></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=row><table class=\"table table-striped\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=tenant.tenantId></span></th><th><span translate=tenant.envFlag></span></th><th><span translate=tenant.version></span></th><th><span translate=tenant.keyId></span></th><th><span translate=tenant.description></span></th></tr></thead><tbody><tr ng-repeat=\"tenant in vm.tenants\"><!--  --><td><a ui-sref=tenant.edit({tenantId:tenant.tenantId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteTenant(tenant)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{tenant.tenantId}}</td><td>{{tenant.envFlag}}</td><td>{{tenant.version}}</td><td>{{tenant.keyId}}</td><td>{{tenant.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/ctm/html/gParty.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  .black_overlay{\n\ndisplay: none;\n\nposition: absolute;\n\ntop: 0%;\n\nleft: 0%;\n\nwidth: 100%;\n\nheight: 100%;\n\nbackground-color: #696969;\n\nz-index:1001;\n\n-moz-opacity: 0.9;\n\nopacity:.80;\n\nfilter: alpha(opacity=88);\n\n}\n\n.black_overlay1{\nposition: absolute;\n\ntop: 0%;\n\nleft: 0%;\n\nwidth: 100%;\n\nheight: 100%;\n\nbackground-color: #413f3f;\n\nz-index:1001;\n\nopacity: 0.8;\n\nopacity:.80;\n\nfilter: alpha(opacity=88);\n\n}\n\n.white_content {\n\ndisplay: none;\n\nposition: absolute;\n\ntop: 8%;\n\nleft: 12%;\n\nwidth: 80%;\n\nheight: 45%;\n\npadding: 20px;\n\nborder: 10px solid #ddd;\n\nbackground-color: white;\n\nz-index:1002;\n\noverflow: auto;\n}\n\n.white_content2 {\n\n\n\nposition: absolute;\n\ntop: 15%;\n\nleft: 27%;\n\nwidth: 40%;\n\nheight: 25%;\n\npadding: 20px;\n\nborder: 10px solid #ddd;\n\nbackground-color: white;\n\nz-index:1002;\n\noverflow: auto;\n}\n\n.white_content3 {\n\n  display: none;\n\nposition: absolute;\n\ntop: 15%;\n\nleft: 27%;\n\nwidth: 40%;\n\nheight: 25%;\n\npadding: 20px;\n\nborder: 10px solid #ddd;\n\nbackground-color: white;\n\nz-index:1002;\n\noverflow: auto;\n}\n\n.white_content4 {\nposition: absolute;\n\ntop: 8%;\n\nleft: 11%;\n\nwidth: 80%;\n\nheight: 45%;\n\npadding: 20px;\n\nborder: 10px solid #ddd;\n\nbackground-color: white;\n\n\nz-index:1002;\n\noverflow: auto;\n}\n\n\n.flyover .mask {\n    top: 0;\n    left: 0;\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    opacity: 0.5;\n    background: black;\n    z-index: 1049;\n}\n.flyover .alert{\n    left: 50%;\n    top: 50%;\n    position: fixed;\n    z-index: 1050;\n}\n  #toast-container {\n    z-index: 99999;\n  }</style><div><div class=ibox-title><h5><span></span>工程账号预配置管理</h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=userManage.userName></span></label><div class=col-lg-9><input type=text id=searchPartyName class=form-control ng-model=vm.party.partyAccount></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span></span>楼盘编码 -- 楼盘名称</label><div class=col-lg-6><select id=authorizedGrantTypes ng-model=vm.Code1 ng-change=vm.queryProductCodeList() class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.productCodeList\" value={{x.supplierId}}>{{x.supplierCode}}---{{x.supplierName}}</option></select></div><button class=\"col-lg-1 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.getResidentialParty() ng-disabled=vm.appear5></button></div><button style=\"margin-left: -13px\" class=\"col-lg-1 btn btn-w-m btn-info\" type=button ng-disabled=vm.appear5 onclick=\"document.getElementById(\'light\').style.display=\'block\';document.getElementById(\'fade\').style.display=\'block\'\">生成工程账号</button></div><div ng-show=vm.trigger class=white_content2><div style=\"margin-left: 25%; margin-top: 10%\"><p style=\"margin-left: -14px\">该楼盘编码已存在且楼盘名不一致，是否修改楼盘名</p><p style=\"margin-top: 50px; margin-left: -9px\"><button style=\"height: 30px; width: 100px; margin-left: 20px\" ng-click=vm.tijiao()>确定</button><button style=\"height: 30px; width: 100px; margin-left: 50px\" ng-click=vm.aa() onclick=\"document.getElementById(\'light\').style.display=\'block\';document.getElementById(\'fade\').style.display=\'block\'\">取消</button></p></div></div><div ng-show=vm.appear class=white_content2><div style=\"margin-left: 25%; margin-top: 10%\"><p style=\"margin-left: 35px\">此账号处于交付中，不能删除</p><p style=\"margin-top: 50px\"><button style=\"height: 30px; width: 100px; margin-left: 80px\" ng-click=vm.aa()>确定</button></p></div></div><div ng-show=vm.appear1 class=white_content2><div style=\"margin-left: 25%; margin-top: 10%\"><p style=\"margin-left: 40px\">输入的格式错误,请重新输入</p><p style=\"margin-left: -70px\">(编码只能输入英文或者数字，名称不能有符号，数量不能小于0,大于2000)</p><p style=\"margin-top: 50px; margin-left: -10px\"><button style=\"height: 30px; width: 100px; margin-left: 80px\" ng-click=vm.aa() onclick=\"document.getElementById(\'light\').style.display=\'block\';document.getElementById(\'fade\').style.display=\'block\'\">确定</button></p></div></div><div ng-show=vm.appear2 class=white_content2><div style=\"margin-left: 25%; margin-top: 10%\"><p style=\"margin-left: 40px\">账号正在生成中，请稍等</p><p style=\"margin-top: 50px; margin-left: -10px\"><button style=\"height: 30px; width: 100px; margin-left: 80px\" ng-click=vm.aa()>确定</button></p></div></div><div ng-show=vm.appear3 class=white_content2><div style=\"margin-left: 25%; margin-top: 10%\"><p style=\"margin-left: 7%\">此楼盘已全部激活或者没有该楼盘</p><p style=\"margin-top: 50px; margin-left: -10px\"><button style=\"height: 30px; width: 100px; margin-left: 80px\" ng-click=vm.aa()>确定</button></p></div></div><div id=light2 class=white_content3><div style=\"margin-left: 25%; margin-top: 10%\"><p style=\"margin-left: 100px\">是否确定删除</p><p style=\"margin-top: 50px\"><button style=\"height: 30px; width: 100px; margin-left: 20px\" ng-click=vm.cancel() onclick=\"document.getElementById(\'light2\').style.display=\'none\';document.getElementById(\'fade\').style.display=\'none\'\">确定</button><button style=\"height: 30px; width: 100px; margin-left: 50px\" onclick=\"document.getElementById(\'light2\').style.display=\'none\';document.getElementById(\'fade\').style.display=\'none\'\">取消</button></p></div></div><div id=light class=white_content><div style=\"margin-left: 37%; margin-top: 10%\"><p style=\"font-size: 16px; font-weight: 500; margin-top: 20px\">楼盘编码:<input style=\"margin-left: 10px\" ng-model=vm.dto.supplierCode type=text onchange=test(this.value)></p><p style=\"font-size: 16px; font-weight: 500; margin-top: 20px\">楼盘名称:<input style=\"margin-left: 10px\" ng-model=vm.dto.supplierName></p><p style=\"font-size: 16px; font-weight: 500; margin-top: 20px\">用户数量:<input style=\"margin-left: 10px\" ng-model=vm.dto.supplierNumber onkeyup=\"this.value=this.value.replace(/\\D/g,\'\')\" onafterpaste=\"this.value=this.value.replace(/\\D/g,\'\')\" type=text onchange=test1(this.value)></p><p style=\"margin-top: 20px\"><button style=\"height: 30px; width: 100px; margin-left: 40px\" ng-click=vm.selectCode() onclick=\"document.getElementById(\'light\').style.display=\'none\';document.getElementById(\'fade\').style.display=\'none\'\">提交</button><button style=\"height: 30px; width: 100px; margin-left: 70px\" ng-click=vm.bb() onclick=\"document.getElementById(\'light\').style.display=\'none\';document.getElementById(\'fade\').style.display=\'none\'\">取消</button></p></div></div><div ng-show=vm.appear6 class=black_overlay1><div class=white_content4><div style=\"margin-left: 37%; margin-top: 10%\"><p style=\"font-size: 16px; font-weight: 500; margin-top: 20px; margin-left: -130px;  color: red; font-weight: bold\">楼盘在生成过程中请勿做查询操作，可点击导出工程账号按钮查看生成是否完成</p><p style=\"margin-top: 200px; margin-left: -10px\"><button style=\"height: 30px; width: 100px; margin-left: 80px\" ng-click=vm.cc()>确定</button></p></div></div></div><div class=col-lg-4 style=\"margin-left: -10px; margin-top: 10px\"><label class=\"col-lg-3 control-label\"><span>楼盘编码</span></label><div class=col-lg-9><input type=text id=searchPartyName class=form-control ng-model=vm.party.supplier.supplierCode></div></div><button class=\"col-lg-1 btn btn-w-m btn-primary\" style=\"margin-top: 10px; margin-left: 38.2%\" type=button ng-click=vm.educe() ng-disabled=vm.appear5>导出楼盘详情</button> <button class=\"col-lg-1 btn btn-w-m btn-primary\" style=\"margin-top: -1.8%; margin-left: 83%\" type=button ng-click=vm.queryStatus() ng-disabled=vm.appear4>导出工程账号</button><div class=flyover ng-if=vm.loading><div class=mask></div><div class=\"alert alert-info\"><strong>正在加载，请稍等....</strong></div></div><div id=lights class=white_content><div style=\"margin-left: 35%; margin-top: 10%\"><p style=\"font-size: 16px; font-weight: 500; margin-top: 20px\">用户名称:<input style=\"margin-left: 10px\" readonly ng-model=vm.datas.partyAccount></p><p style=\"font-size: 16px; font-weight: 500; margin-top: 20px\">用户密码:<input style=\"margin-left: 10px\" ng-model=vm.datas.password></p><p style=\"font-size: 16px; font-weight: 500; margin-top: 20px\">账号状态:<select ng-model=vm.datas.status style=\"margin-left: 8px; width: 208px; height: 30px; border:1px solid\"><option value=engineer_status>engineer_status</option><option value=user_status>user_status</option></select></p><p style=\"margin-top: 20px;margin-left: 20px\"><button style=\"height: 30px; width: 100px; margin-left: 20px\" ng-click=vm.renewal()>修改</button><button style=\"height: 30px; width: 100px; margin-left: 50px\" onclick=\"document.getElementById(\'lights\').style.display=\'none\';document.getElementById(\'fade\').style.display=\'none\'\">取消</button></p></div></div><div id=fade class=black_overlay></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=userManage.userName></span></th><th><span>楼盘编码</span></th><th><span>楼盘名称</span></th><th><span>配置状态</span></th><th><span>操作</span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><td ng-bind=party.partyAccount></td><td ng-bind=party.supplier.supplierCode></td><td ng-bind=party.supplier.supplierName></td><td ng-bind=party.attribute2></td><td><button onclick=\"document.getElementById(\'lights\').style.display=\'block\';\n            document.getElementById(\'fade\').style.display=\'block\'\" ng-click=vm.update(party)>编辑</button> <button onclick=\"document.getElementById(\'light2\').style.display=\'block\';\n              document.getElementById(\'fade\').style.display=\'block\'\" ng-click=vm.update(party)>删除</button></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div><script language=javascript type=text/javascript>function test(val){\n     var rex=/^[0-9a-zA-Z_]*$/;\n     if(!rex.test(val)) alert(\"只能输入英文或者数字\")\n\n  }\n\n  function test2(val){\n    var rex=/^[0-9a-zA-Z_]*$/;\n     if(!rex.test2(val)) alert(\"不能输入符号\")\n\n  }\n\n  function test1(val){\n\n     if(val<=0) alert(\"数量不能小于1\")\n\n  }</script>");
$templateCache.put("app/iot/portal/admin/ctm/html/party-edit.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .control-label {\n    margin-top: 7px;\n  }</style><div class=row><div class=col-lg-12><div class=ibox-title><h5><span translate=userManage.partyManage></span></h5></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.loginName></span></label><div class=col-lg-8><span style=\"word-break: break-all;white-space: normal;overflow-y: auto\" class=form-control>{{vm.party.partyAccount}}</span></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.name></span></label><div class=col-lg-8><input type=text id=partyName name=partyName ng-model=vm.party.partyName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.displayName></span></label><div class=col-lg-8><input type=text id=displayName name=displayName ng-model=vm.party.displayName class=form-control required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.mailNickname></span></label><div class=col-lg-8><input type=text id=mailNickname name=mailNickname ng-model=vm.party.mailNickname class=form-control required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.telephone></span></label><div class=col-lg-8><input type=text id=phoneNumber name=phoneNumber ng-model=vm.party.phoneNumber class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.email></span></label><div class=col-lg-8><input type=text id=emailAddress name=emailAddress ng-model=vm.party.emailAddress class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.group></span></label><div class=col-lg-8><span class=form-control>{{vm.party.groupName}}</span></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.timeZone></span></label><div class=col-lg-8><select ng-model=vm.party.timeZone class=form-control><option ng-repeat=\"x in vm.timezones\" value={{x.value}}>{{x.meaning}}</option></select><!--<lookup-select lookup-value=\"vm.party.timeZone\" lookup-type=\"SYS.TIME_ZONE\"></lookup-select>--></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.role></span></label><div class=col-md-8><select ng-model=vm.party.roleId class=form-control ng-options=\"x.roleId as x.roleName for x in vm.roles\" required></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.status></span></label><div class=col-lg-8><select ng-model=vm.party.partyStatus class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.states\" value={{x.value}}>{{x.meaning}}</option></select><!--<select ng-model=\"vm.party.partyStatus\" class=\"form-control\">\n                    <option ng-repeat=\"x in vm.states\" value=\"{{x.value}}\">{{x.meaning}}</option>\n                  </select>--></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.passwordInit></span></label><div class=col-lg-8><input type=password id=passwordInit name=passwordInit ng-model=vm.party.password class=form-control placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\"></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.passwordConfirm></span></label><div class=col-lg-8><input type=password ng-blur=vm.validatePwd() id=passwordConfirm name=passwordConfirm ng-model=vm.party.passwordConfirm class=form-control placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\"></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.location></span></label><div class=col-lg-8><input type=text id=locationAddress name=locationAddress ng-model=vm.party.locationAddress class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.operationType></span></label><div class=col-lg-8><select ng-model=vm.party.operation class=form-control><option></option><option ng-repeat=\"x in vm.operationList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button ng-click=vm.showOrHidePwd() class=\"btn btn-warning\"><span ng-if=vm.showPwdEnabled translate=btnTypeName.showPwd></span> <span ng-if=!vm.showPwdEnabled translate=btnTypeName.hidePwd></span></button> <button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-info\" ng-disabled=!vm.party.operation ng-click=vm.operate()><span class=\"glyphicon glyphicon-hand-right\"></span>&nbsp;<span translate=btnTypeName.operation></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ctm/html/party-new.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .control-label {\n    margin-top: 7px;\n  }</style><div class=row><div class=col-lg-12><div class=ibox-title><h5><span translate=userManage.partyManage></span></h5></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.loginName></span></label><div class=col-lg-4><input type=text id=partyAccount name=partyAccount ng-model=vm.party.partyAccount class=form-control required></div><p style=\"display:inline-block;opacity: 0.7;margin-top: 7px;font-weight: bold;width: 200px\"><span ng-bind=vm.suffix ng-cloak style=\"overflow: hidden;text-overflow: ellipsis;display: block\" data-toggle=tooltip data-placement=top title={{vm.suffix}}></span></p></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.name></span></label><div class=col-lg-8><input type=text id=partyName name=partyName ng-model=vm.party.partyName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.telephone></span></label><div class=col-lg-8><input type=text id=phoneNumber name=phoneNumber ng-model=vm.party.phoneNumber class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.email></span></label><div class=col-lg-8><input type=text id=emailAddress name=emailAddress ng-model=vm.party.emailAddress class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.displayName></span></label><div class=col-lg-8><input type=text id=displayName name=displayName ng-model=vm.party.displayName class=form-control required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span> <span translate=userManage.mailNickname></span></label><div class=col-lg-8><input type=text id=mailNickname name=mailNickname ng-model=vm.party.mailNickname class=form-control required></div></div></div></div><div class=form-group><div class=row><!--<div class=\"col-lg-6\">\n                <label class=\"col-lg-3 control-label\">*<span translate=\"userManage.group\"></span></label>\n                <div class=\"col-lg-8\">\n                  <div class=\"input-group\">\n                    <input type=\"text\" id=\"groupId\" name=\"groupId\" ng-model=\"vm.party.groupName\" class=\"form-control\" readonly required>\n                    <span class=\"input-group-btn\">\n                      <button id=\"groupNameBtn\" disabled class=\"btn btn-default\" value=\"groupName\" type=\"button\" ng-click=\"vm.showGroupNameModel()\"><i class=\"fa fa-globe\"></i></button>\n                    </span>\n                  </div>\n                </div>\n              </div>--><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.group></span></label><div class=col-lg-8><div class=input-group><input type=text id=groupId name=groupId ng-model=vm.party.groupName class=form-control readonly required> <span class=input-group-btn><button type=button ui-sref=party.group class=\"btn btn-primary glyphicon glyphicon-search\"></button></span></div></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.timeZone></span></label><div class=col-lg-8><select ng-model=vm.party.timeZone class=form-control><option ng-repeat=\"x in vm.timezones\" value={{x.value}}>{{x.meaning}}</option></select><!--<lookup-select lookup-value=\"vm.party.timeZone\" lookup-type=\"SYS.TIME_ZONE\"></lookup-select>--></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.role></span></label><div class=col-lg-8><select ng-model=vm.party.roleId class=form-control ng-options=\"x.roleId as x.roleName for x in vm.roles\" required></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.status></span></label><div class=col-md-8><select ng-model=vm.party.partyStatus class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.states\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=\"form-group has-feedback\"><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.passwordInit></span></label><div class=col-lg-8><input type=password id=passwordInit name=passwordInit ng-model=vm.party.password class=form-control placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" required ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\"> <span class=\"glyphicon glyphicon-ok form-control-feedback\" ng-show=\"editForm.passwordInit.$dirty && editForm.passwordInit.$valid\"></span></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: #f00\">*</span><span translate=userManage.passwordConfirm></span></label><div class=col-lg-8><input type=password id=passwordConfirm name=passwordConfirm ng-model=vm.party.passwordConfirm class=form-control placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" required ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\"> <span class=\"glyphicon glyphicon-ok form-control-feedback\" ng-show=\"editForm.passwordConfirm.$dirty && editForm.passwordConfirm.$valid\"></span></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.location></span></label><div class=col-lg-8><input type=text id=locationAddress name=locationAddress ng-model=vm.party.locationAddress class=form-control></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button ng-click=vm.showOrHidePwd() class=\"btn btn-warning\"><span ng-if=vm.showPwdEnabled translate=btnTypeName.showPwd></span> <span ng-if=!vm.showPwdEnabled translate=btnTypeName.hidePwd></span></button> <button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div></div></div></div><!-- groupNameModal --><div class=\"modal fade\" id=groupNameModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=groupNameModalBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.groupNameSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ctm/html/party.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  .red-border {\n    border-color: #f00;\n  }</style><div><div class=ibox-title><h5><span translate=userManage.partyManage></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=userManage.userName></span></label><div class=col-lg-6><input type=text id=searchPartyName class=form-control ng-model=vm.searchPartyName></div><button id=searchBtn class=\"col-lg-1 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.queryPartiesByCondition()></button></div><div class=col-lg-1><div class=\"col-lg-3 pull-right m-t-n-xs\" style=\"margin-top: 0;width: 210%\"><a class=\"btn btn-w-m btn-primary\" ui-sref=party.new() translate=btnTypeName.create></a></div></div><div class=col-lg-1></div><div class=col-lg-1><div class=\"col-lg-3 m-t-n-xs\" style=\"margin-top: 0;width: 150%\"><button class=\"btn btn-w-m btn-primary\" ng-click=vm.exportExcel() translate=btnTypeName.export></button></div></div></div><div class=row style=\"margin-top: 1%\"><div class=col-lg-offset-6><label class=\"col-lg-3 control-label\" for=adminPwd translate=login.adminPwd></label><div class=col-lg-7><input id=adminPwd class=\"form-control red-border\" type=password placeholder=\"{{\'btnTypeName.adminPwd\' | translate}}\" ng-model=vm.adminPwd autocomplete=off></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=userManage.loginName></span></th><th><span translate=userManage.name></span></th><th><span translate=userManage.telephone></span></th><th><span translate=userManage.email></span></th><th><span translate=userManage.role></span></th><th><span translate=userManage.status></span></th><th><span translate=userManage.relation></span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><td><a ui-sref=party.edit({partyId:party.partyId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteParty(party)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=party.partyAccount></td><td ng-bind=party.partyName></td><td ng-bind=party.phoneNumber></td><td ng-bind=party.emailAddress></td><td><select ng-model=party.roleId disabled ng-options=\"x.roleId as x.roleName for x in vm.roles\"></select></td><td><select ng-model=party.partyStatus disabled><option ng-repeat=\"x in vm.states\" value={{x.value}}>{{x.meaning}}</option></select></td><td><a ui-sref=party.relationship({partyId:party.partyId})><i class=\"fa fa-sign-in text-navy\"><span translate=userManage.relation></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/ctm/html/partyRelationship.html","<div><div class=ibox-title><h5><span translate=userManage.commercialUserRelation></span></h5></div><div class=ibox-content><div class=row><ul class=\"nav nav-tabs\" role=tablist id=myTabs><li role=presentation class=active><a href=//#box id=boxTab aria-controls=iot role=tab data-toggle=tab><span translate=userManage.relationBox></span></a></li><li role=presentation><a href=//#device id=deviceTab aria-controls=ble role=tab data-toggle=tab><span translate=userManage.relationDevice></span></a></li></ul></div><div class=tab-content><div role=tabpanel class=\"tab-pane active\" id=box><div style=\"margin-top: 10px\"><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=userManage.boxSerialNumber></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.box.boxSerialNumber></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\">SKU</label><div class=col-lg-8><input type=text class=form-control ng-model=vm.box.skuNumber></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><button class=\"col-lg-4 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.getBoxByPartyId()></button>&nbsp;&nbsp; <button class=\"btn btn-w-m btn-info\" ng-click=vm.returnParty() translate=btnTypeName.return></button></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=userManage.deviceName></span></th><th><span translate=userManage.product></span></th><th>SKU</th><th><span translate=userManage.boxSerialNumber></span></th><th><span translate=userManage.boxFirmwareVersion></span></th><th><span translate=userManage.operateBox></span></th></tr></thead><tbody><tr ng-repeat=\"box in vm.boxes\"><td ng-bind=box.deviceName></td><td ng-bind=box.productName></td><td ng-bind=box.skuNumber></td><td ng-bind=box.boxSerialNumber></td><td ng-bind=box.firmwareVersion></td><td><a ng-click=vm.unbindBox(box.boxId)><i class=\"fa fa-times text-navy\"><span translate=userManage.unbindBox></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page_box total=vm.totalItems_box items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems_box ng-model=vm.page_box ng-change=vm.pageChanged_box(vm.page_box)></uib-pagination></div></div></div><div role=tabpanel class=tab-pane id=device><div style=\"margin-top: 10px\"><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=userManage.deviceSerialNumber></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.device.deviceSerialNumber></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=userManage.product></span></label><div class=col-lg-8><select class=form-control ng-model=vm.device.productCode><option value=\"\"></option><option ng-repeat=\"product in vm.commercialProducts\" value={{product.productCode}} ng-hide=\"product.productCode==\'COM_BOX\'\">{{product.productName}}</option></select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\">SKU</label><div class=col-lg-8><input type=text class=form-control ng-model=vm.device.skuNumber></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><button class=\"col-lg-4 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.getDeviceByPartyId()></button>&nbsp;&nbsp; <button class=\"btn btn-w-m btn-info\" ng-click=vm.returnParty() translate=btnTypeName.return></button></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=userManage.deviceName></span></th><th><span translate=userManage.product></span></th><th>SKU</th><th><span translate=userManage.deviceSerialNumber></span></th><th><span translate=userManage.pcbFirmware></span></th><th><span translate=userManage.iotWifiFirmware></span></th><th><span translate=userManage.iotBleFirmware></span></th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices\"><td ng-bind=device.deviceName></td><td ng-bind=device.productName></td><td ng-bind=device.skuNumber></td><td ng-bind=device.deviceSerialNumber></td><td ng-bind=device.pcbVersion></td><td ng-bind=device.wifiVersion></td><td ng-bind=device.BlueToothVersion></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page_device total=vm.totalItems_device items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems_device ng-model=vm.page_device ng-change=vm.pageChanged_device(vm.page_device)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ctm/html/rParty.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5><span translate=userManage.rPartyManage></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=userManage.userName></span></label><div class=col-lg-9><input type=text id=searchPartyName class=form-control ng-model=vm.party.partyAccount></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.partyNumber></span></label><div class=col-lg-6><input type=text id=searchPartyNumber class=form-control ng-model=vm.party.partyNumber></div><button class=\"col-lg-1 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.getResidentialParty()></button></div><button style=\"margin-left: -13px\" class=\"col-lg-1 btn btn-w-m btn-info\" type=button translate=btnTypeName.export ng-click=vm.exportExcel()></button></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=userManage.userName></span></th><th><span translate=userManage.nickname></span></th><th><span translate=userManage.partyNumber></span></th><th><span translate=userManage.androidVersion></span></th><th><span translate=userManage.iosVersion></span></th><th><span translate=userManage.grayUser></span></th><th><span translate=userManage.organization></span></th><th><span translate=userManage.relation></span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><td><a ng-click=vm.deleteResidentialParty(party)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=party.partyAccount></td><td ng-bind=party.partyName></td><td ng-bind=party.partyNumber></td><td ng-bind=party.androidVersion></td><td ng-bind=party.iosVersion></td><td ng-bind=party.grayUser></td><td><span translate=userManage.org></span></td><td><a ui-sref=rparty.relationship({partyId:party.partyId})><i class=\"fa fa-sign-in text-navy\"><span translate=userManage.relation></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/ctm/html/rPartyRelationship.html","<div><div class=ibox-title><h5><span translate=userManage.residentialUserRelation></span></h5></div><div class=ibox-content><div class=row><ul class=\"nav nav-tabs\" role=tablist id=myTabs><li role=presentation class=active><a href=//#box id=boxTab aria-controls=iot role=tab data-toggle=tab><span translate=userManage.relationBox></span></a></li><li role=presentation><a href=//#device id=deviceTab aria-controls=ble role=tab data-toggle=tab><span translate=userManage.relationDevice></span></a></li><li role=presentation><a href=//#suber id=suberTab aria-controls=suber role=tab data-toggle=tab><span translate=userManage.subUser></span></a></li></ul></div><div class=tab-content><div role=tabpanel class=\"tab-pane active\" id=box><div style=\"margin-top: 10px\"><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=userManage.boxSerialNumber></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.box.boxSerialNumber></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\">SKU</label><div class=col-lg-8><input type=text class=form-control ng-model=vm.box.skuNumber></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><button class=\"col-lg-4 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.getBoxByPartyId()></button>&nbsp;&nbsp; <button class=\"btn btn-w-m btn-info\" ng-click=vm.returnParty() translate=btnTypeName.return></button></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=userManage.deviceId></span></th><th><span translate=userManage.deviceName></span></th><th><span translate=userManage.product></span></th><th>SKU</th><th><span translate=userManage.boxSerialNumber></span></th><th><span translate=userManage.boxFirmwareVersion></span></th><th><span translate=userManage.operateBox></span></th></tr></thead><tbody><tr ng-repeat=\"box in vm.boxes\"><td ng-bind=box.iotDeviceId></td><td ng-bind=box.boxName></td><td ng-bind=box.productName></td><td ng-bind=box.skuNumber></td><td ng-bind=box.boxSerialNumber></td><td ng-bind=box.firmwareVersion></td><td><a ng-click=vm.unbindBox(box.boxId)><i class=\"fa fa-times text-navy\"><span translate=userManage.unbindBox></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page_box total=vm.totalItems_box items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems_box ng-model=vm.page_box ng-change=vm.pageChanged_box(vm.page_box)></uib-pagination></div></div></div><div role=tabpanel class=tab-pane id=device><div style=\"margin-top: 10px\"><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=userManage.deviceSerialNumber></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.device.deviceSerialNumber></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=userManage.product></span></label><div class=col-lg-8><select class=form-control data-ng-model=vm.device.productCode><option value=\"\"></option><option ng-repeat=\"x in vm.rProducts\" value={{x.productCode}}>{{x.productName}}</option></select><!--<lookup-select lookup-value=\"vm.device.productCode\" lookup-type=\"IOT.DVM.RES_DEVICE_TYPE\">\n                                        </lookup-select>--></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\">SKU</label><div class=col-lg-8><input type=text class=form-control ng-model=vm.device.skuNumber></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><button class=\"col-lg-4 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.getDeviceByPartyId()></button>&nbsp;&nbsp; <button class=\"btn btn-w-m btn-info\" ng-click=vm.returnParty() translate=btnTypeName.return></button></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=userManage.deviceName></span></th><th><span translate=userManage.product></span></th><th>SKU</th><th><span translate=userManage.deviceSerialNumber></span></th><th><span translate=userManage.pcbFirmware></span></th><th><span translate=userManage.iotWifiFirmware></span></th><th><span translate=userManage.iotBleFirmware></span></th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices\"><td ng-bind=device.deviceName></td><td ng-bind=device.productName></td><td ng-bind=device.skuNumber></td><td ng-bind=device.deviceSerialNumber></td><td ng-bind=device.pcbVersion></td><td ng-bind=device.wifiVersion></td><td ng-bind=device.BlueToothVersion></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page_device total=vm.totalItems_device items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems_device ng-model=vm.page_device ng-change=vm.pageChanged_device(vm.page_device)></uib-pagination></div></div></div><div role=tabpanel class=tab-pane id=suber><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=userManage.partyName></span></th><th><span translate=userManage.partyAccount></span></th><th><span translate=userManage.partyType></span></th></tr></thead><tbody><tr ng-repeat=\"suber in vm.subers\"><td ng-bind=suber.partyName></td><td ng-bind=suber.partyAccount></td><td ng-bind=suber.partyType></td></tr></tbody></table><!-- <div class=\"text-center\">\n                  <item-count page=\"vm.page_suber\" total=\"vm.totalItems_suber\" items-per-page=\"vm.itemsPerPage\"></item-count>\n                  <uib-pagination class=\"pagination-sm\"\n                                  total-items=\"vm.totalItems_suber\"\n                                  ng-model=\"vm.page_suber\"\n                                  ng-change=\"vm.getSubUserByPartyId()\"></uib-pagination>\n                </div> --></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dataDelivery/html/dataDistrbutionHistory.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=distribution.distributeHistory></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=distribution.distributedEnvironment></span></label><div class=col-lg-8><lookup-select lookup-value=vm.data.dataTo lookup-type=SYS.DATAENVIRONMENT required disable=true></lookup-select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=distribution.dataType></span></label><div class=col-lg-8><lookup-select lookup-value=vm.data.tableCode lookup-type=MASTER.DATA_MOVE_CODE required></lookup-select></div></div><div class=col-lg-2><button class=\"btn btn-w-m btn-info\" ng-click=vm.queryDataDistributionHistory()><span translate=btnTypeName.search></span></button></div></div></div><div class=form-group><div class=row><div class=col-lg-5><label for=start class=\"col-lg-4 control-label\"><span translate=dataAnalysis.beginDate></span></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control id=start name=start ng-model=\"vm.data.beginTime \" ng-change=vm.compareDate() disabled> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span></span> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-5><label for=end class=\"col-lg-4 control-label\"><span translate=dataAnalysis.endDate></span></label><div class=col-lg-8><p class=\"input-group date form_date\"><input type=text class=form-control id=end name=end ng-model=vm.data.endTime ng-change=vm.compareDate() disabled> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span></span> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-2><button class=\"btn btn-w-m btn-primary\" ng-click=vm.reset()><span translate=btnTypeName.reset></span></button></div></div></div></div><div class=row style=\"margin-top: 10px\"></div><div style=\"margin-top: 40px\"><table class=\"table table-responsive\"><thead id=thead><tr><th translate=dataDistribution.distributePerson></th><th translate=dataDistribution.distributeTime></th><th translate=dataDistribution.distributeType></th><th translate=dataDistribution.distributeEnvironment></th><th translate=dataDistribution.distributeSuccess></th><th translate=dataDistribution.distributeFailure></th></tr></thead><tbody id=tbody><tr ng-repeat=\"data in vm.datas\"><!--<td ng-bind=\"data.personName\"></td>\n\n          <td ng-bind=\"data.transferDate\"></td>\n\n          <td ng-bind=\"data.type\"></td>\n\n          <td ng-bind=\"data.aimDatabase\"></td>--><td ng-bind=data.personName></td><td ng-bind=data.transferDate></td><td><select ng-model=data.type disabled><option ng-repeat=\"x in vm.tableType\" value={{x.value}}>{{x.meaning}}</option></select></td><td ng-bind=data.aimDatabase></td><td><a ui-sref=dataHistory.successDetail({id:data.transferId}) ng-click=\"vm.getTableCode(\'1\')\"><i class=\"fa fa-bars text-navy\"><span translate=dataDistribution.successData></span></i></a></td><td><a ui-sref=dataHistory.failDetail({id:data.transferId}) ng-click=\"vm.getTableCode(\'0\')\"><i class=\"fa fa-bars text-navy\"><span translate=dataDistribution.failedData></span></i></a></td></tr></tbody></table></div><div class=row style=\"text-align: center\" id=distributionFailIdList ng-show=\"vm.distributionFailIdList!=null||vm.distributionFailIdList!=undefined\"><label for=\"\"><span translate=dataDistribution.deliveryFailed></span></label><div class=col-lg-12><textarea class=form-group ng-model=vm.distributionFailIdList readonly></textarea></div></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.pageChanged(vm.page)\"></uib-pagination>--></div></div></div>");
$templateCache.put("app/iot/portal/admin/dataDelivery/html/dataDistribution.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=distribution.masterDataDistribution></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=distribution.dataSourceEnvironment></span></label><div class=col-lg-9><!--<lookup-select lookup-value=\"vm.data.dataFrom\" lookup-type=\"SYS.DATAENVIRONMENT\" required=\"false\"></lookup-select>--><lookup-select lookup-value=vm.data.dataFrom lookup-type=SYS.DATAENVIRONMENT required disable=true></lookup-select></div></div><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=distribution.distributionEnvironment></span></label><div class=col-lg-9><lookup-select lookup-value=vm.data.dataTo lookup-type=SYS.DATAENVIRONMENT required disable=true></lookup-select></div></div><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=distribution.dataType></span></label><div class=col-lg-9><lookup-select lookup-value=vm.data.tableCode lookup-type=MASTER.DATA_MOVE_CODE required></lookup-select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label for=start class=\"col-lg-3 control-label\"><span translate=dataAnalysis.beginDate></span></label><div class=col-lg-9><p class=\"input-group date form_date\"><input type=text class=form-control id=start name=start ng-model=\"vm.data.beginTime \" ng-change=vm.compareDate() disabled> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span></span> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-4><label for=end class=\"col-lg-3 control-label\"><span translate=dataAnalysis.endDate></span></label><div class=col-lg-9><p class=\"input-group date form_date\"><input type=text class=form-control id=end name=end ng-model=vm.data.endTime ng-change=vm.compareDate() disabled> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span></span> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=distribution.dataCode></span></label><div class=col-lg-9><input type=text class=form-control name=dataCode id=dataCode ng-model=vm.data.dataCode></div></div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-2 col-md-offset-1\"><a class=\"btn btn-w-m btn-info\" ui-sref=dataHistory><span translate=distribution.distributeHistory></span></a></div><div class=col-lg-2><button class=\"btn btn-w-m btn-danger\" ng-click=vm.beforeDistributeData()><span translate=distribution.masterDataDistribution></span></button></div><div class=col-lg-2></div><div class=col-lg-2><button class=\"btn btn-w-m btn-info\" ng-click=vm.queryDataDistribution()><span translate=btnTypeName.search></span></button></div><div class=col-lg-2><button class=\"btn btn-w-m btn-warning\" ng-click=vm.resetCondition()><span translate=btnTypeName.reset></span></button></div></div><div style=\"margin-top: 40px\"><table class=\"table table-responsive\"><!--<thead id=\"thead\" ng-repeat=\"(key,value) in vm.data\">--><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllData()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th ng-repeat=\"(keyIndex,key) in vm.tableHeader.shows\" translate=dataDistribution.{{key}}></th></tr></thead><tbody><tr ng-repeat=\"field in vm.dataGet\"><td><input type=checkbox name=chk_list class=chk_list value={{field}} ng-click=vm.checkData()></td><td ng-repeat=\"(keyIndex, key) in vm.tableHeader.shows\">{{field[key]}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.totalItems></item-count><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.pageChanged(vm.page)\"></uib-pagination>--></div></div></div>");
$templateCache.put("app/iot/portal/admin/dataDelivery/html/dataHistoryDetail.html","<div><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=dataDistribution.dataDetail></span></h4></div><div class=modal-body><div style=\"margin-top: 40px\"><table class=\"table table-responsive\"><!--<thead id=\"thead\" ng-repeat=\"(key,value) in vm.data\">--><thead><tr><th ng-repeat=\"(keyIndex,key) in vm.tableHeader.shows\" translate=dataDistribution.{{key}} ng-show=\"key!=\'status\'\"></th></tr></thead><tbody><tr ng-repeat=\"field in vm.dataGet\"><td ng-repeat=\"(keyIndex,key) in vm.tableHeader.shows\" ng-show=\"key!=\'status\'\">{{field[key]}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.totalItems></item-count><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.pageChanged(vm.page)\"></uib-pagination>--></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/addDeviceNameList.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addDeviceNameList() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=dvmProduct.deviceNameList></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=dvmSku.productName></span></label><select class=form-control ng-model=vm.deviceNameList.productId ng-disabled=vm.deviceNameList.productId required><option ng-repeat=\"x in vm.products\" value={{x.productId}} ng-selected=\"x.productId == vm.deviceNameList.productId\">{{x.productName}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_deviceName><span style=color:red>*</span> <span translate=dvmProduct.deviceNameList></span></label><div class=input-group><input type=text class=form-control name=deviceNameList id=field_deviceName ng-model=vm.deviceNameList.deviceName required readonly> <span class=input-group-btn><button id=localeBtn_deviceNameList disabled class=\"btn btn-default\" type=button ng-click=vm.showDeviceNameList() value=deviceName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=dvmProduct.desc></span></label><div class=input-group><input type=text class=form-control name=description id=field_desc ng-model=vm.deviceNameList.description readonly> <span class=input-group-btn><button id=localeBtn_description disabled class=\"btn btn-default\" type=button ng-click=vm.showDescription() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_deviceNameList style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_deviceNameList type=hidden></div><div class=modal-body id=localeModalBody_deviceNameList></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureDeviceNameList()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModalBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureDescription()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/addOtherNameList.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addOtherNameList() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=dvmProduct.otherName></span></h4></div><div class=modal-body><div class=row style=\"text-align: center\" ng-if=vm.imgShow><div style=\"text-align: center\"><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 60px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px\" type=file><!--ng-required=\"vm.productType.productTypeImage!=null\" --> <img id=js_avator style=\"width:120px;height:120px; background-color: black\" ngf-src=vm.oldFile><div><span translate=title.uploadPicTip></span></div><!--<div ng-show=\"vm.varMay\" class=\"btn btn-primary\"\n             style=\"margin-top: 0.5em\"\n             ng-click=\"vm.submitFile()\" >\n          <div><span translate=\"btnTypeName.upload\" ></span></div>\n        </div>--></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span> <span translate=dvmProduct.otherType></span></label><!--<lookup-select lookup-value=\"vm.otherNameList.otherType\" lookup-type=\"SYS.OTHER_TYPE\" required=\"true\"  ng-change=\"vm.changeType(vm.otherNameList.otherType)\"></lookup-select>--><select class=form-control ng-model=vm.otherNameList.otherType ng-change=vm.changeType(vm.otherNameList.otherType) ng-disabled=vm.otherNameList.otherNameListId required><option ng-repeat=\"x in vm.otherTypeSource\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6 ng-show=vm.nameShow><div class=form-group><label class=control-label for=field_otherName><span style=color:red>*</span> <span translate=dvmProduct.otherName></span></label><div class=input-group><input type=text class=form-control name=otherNameList id=field_otherName ng-model=vm.otherNameList.otherName required readonly> <span class=input-group-btn><button id=localeBtn_otherNameList disabled class=\"btn btn-default\" type=button ng-click=vm.showOtherNameList() value=otherName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=dvmProduct.desc></span></label><div class=input-group><input type=text class=form-control name=description id=field_desc ng-model=vm.otherNameList.description readonly> <span class=input-group-btn><button id=localeBtn_description disabled class=\"btn btn-default\" type=button ng-click=vm.showDescription() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><!--<div class=\"row\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label class=\"control-label\" for=\"field_desc\"><span translate=\"dvmProduct.desc\"></span></label>\n          <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_desc\"\n                   ng-model=\"vm.otherNameList.description\"  readonly/>\n            <span class=\"input-group-btn\">\n                <button id=\"localeBtn_description\" disabled class=\"btn btn-default\" type=\"button\" ng-click=\"vm.showDescription()\"\n                        value=\"description\"><i class=\"fa fa-globe\"></i></button>\n              </span>\n          </div>\n        </div>\n      </div>\n    </div>--></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_otherNameList style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_otherNameList type=hidden></div><div class=modal-body id=localeModalBody_otherNameList></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureOtherNameList()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModalBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureDescription()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/addProduct.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n\n  #toast-container {\n    z-index: 1100;\n  }</style><form name=addForm role=form ng-submit=vm.addProduct() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=dvmProduct.detail></span></h4></div><div class=modal-body><div class=row style=\"text-align: center; margin-bottom: 10px\"><div class=col-lg-6 style=\"text-align: center\"><label class=control-label><span translate=dvmProduct.productImg></span></label><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 35px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px;top:0px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile><div><span translate=title.uploadPicTip></span></div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div><span translate=btnTypeName.upload></span></div></div></div><div class=col-lg-6 style=\"text-align: center\"><label class=control-label><span translate=dvmProduct.guidanceImg></span></label><input id=uploadGuidanceImg ng-model=vm.guidanceFile ng-change=vm.changeGuidanceFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=guidanceFile size=1 style=\"left:calc(50% - 35px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px;top:0px\" type=file> <img id=js_avatorGuidance style=width:120px;height:120px ngf-src=vm.oldGuidanceFile><div><span translate=title.uploadPicTip></span></div><div ng-show=vm.varGuidanceMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitGuidanceFile()><div><span translate=btnTypeName.upload></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_productCode><span style=color:red>*</span> <span translate=dvmProduct.code></span></label><input type=text class=form-control name=code id=field_productCode ng-model=vm.product.productCode required ng-readonly=vm.CodeEditable></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_productName><span style=color:red>*</span><span translate=dvmProduct.name></span></label><div class=input-group><input type=text class=form-control name=productName id=field_productName ng-model=vm.product.productName required readonly> <span class=input-group-btn><button id=localeBtn_productName disabled class=\"btn btn-default\" type=button ng-click=vm.showProductName() value=productName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span> <span translate=dvmProduct.category></span></label><lookup-select lookup-value=vm.product.referenceSource lookup-type=IOT.DVM.COM_PRODUCT_TYPE required></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span> <span translate=dvmProduct.type></span></label><!-- <lookup-select lookup-value=\"vm.product.productType\" lookup-type=\"IOT.DVM_PRODUCT_TYPE\"></lookup-select>--><select class=form-control ng-model=vm.product.productType ng-change=vm.setProductCmdSetId() required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.productTypes\" value={{x.productTypeCode}} ng-selected=vm.flagProductTypeSelected(x.productTypeName)>{{x.productTypeName}}</option></select></div></div></div><div class=row><div class=col-md-6><label class=control-label><span style=color:#F00>*</span><span translate=dvmProduct.productRegion></span></label><lookup-select lookup-value=vm.product.productRegion lookup-type=IOT.DVM.PRODUCT_REGION required></lookup-select></div><div class=col-md-6><div class=form-group><label class=control-label for=field_guidanceNotes><span translate=dvmProduct.guidanceNotes></span></label><div class=input-group><input type=text class=form-control name=guidanceNotes id=field_guidanceNotes ng-model=vm.product.guidanceNotes readonly> <span class=input-group-btn><button id=localeBtn_guidanceNotes disabled class=\"btn btn-default\" type=button ng-click=vm.showGuidanceNotes() value=guidanceNotes><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=dvmProduct.desc></span></label><div class=input-group><input type=text class=form-control name=description id=field_desc ng-model=vm.product.description readonly> <span class=input-group-btn><button id=localeBtn disabled class=\"btn btn-default\" type=button ng-click=vm.show() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span> <span translate=command.cmdSet></span></label><select class=form-control ng-model=vm.product.cmdSetId required><option value=\"\"></option><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span> <span translate=dvmProduct.productCmdType></span></label><lookup-select lookup-value=vm.product.attribute3 lookup-type=IOT.DVM.PRODUCT_CMD_TYPE required></lookup-select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=voiceCommand><span translate=dvmProduct.voiceCommand></span></label><textarea id=voiceCommand type=text class=form-control rows=10 ng-model=vm.product.voiceCommand></textarea></div></div><div class=col-md-6><div class=form-group><label class=control-label for=contrastCommand><span translate=dvmProduct.contrastCommand></span></label><textarea id=contrastCommand type=text class=form-control rows=10 ng-model=vm.product.contrastCommand></textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_productName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_productName type=hidden></div><div class=modal-body id=localeModelBody_productName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureProductName()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_guidanceNotes style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_guidanceNotes type=hidden></div><div class=modal-body id=localeModelBody_guidanceNotes></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureGuidanceNotes()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/addProductProperty.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-alert {\n    z-index: 2101;\n  }\n  .sweet-overlay {\n    z-index: 2100;\n  }</style><form name=addForm role=form class=.ng-invalid ng-submit=vm.addProperty()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=property.detail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_propertyCode><span style=\"color: red\">*</span><span translate=property.code></span></label><input type=text class=form-control id=field_propertyCode ng-model=vm.property.propertyCode required ng-disabled=vm.property.propertyId></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_propertyName><span style=\"color: red\">*</span><span translate=property.name></span></label><div class=input-group><input type=text class=form-control id=field_propertyName ng-model=vm.property.propertyName required readonly> <span class=input-group-btn><button id=localeBtn_propertyName disabled class=\"btn btn-default\" type=button ng-click=vm.showPropertyName() value=propertyName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=property.type></span></label><lookup-select lookup-value=vm.property.propertyType lookup-type=IOT.DVM_ATTRIBUTE_TYPE required></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=property.unit></span></label><select class=form-control ng-model=vm.property.unitId><option ng-repeat=\"x in vm.units\" value={{x.unitId}}>{{x.unitName}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=property.ruleType></span></label><lookup-select lookup-value=vm.property.parameterType lookup-type=IOT.DVM_ATTRIBUTE_RULE_TYPE required></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.rule></span></label><div class=input-group><input type=text class=form-control id=field_parameterRange ng-model=vm.property.parameterRange readonly translate-attr=\"{placeholder : \'property.separate\'}\"> <span class=input-group-btn><button id=localeBtn_parameterRange disabled class=\"btn btn-default\" type=button ng-click=vm.showParameterRange() value=parameterRange><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.defaultValue></span></label><div class=input-group><input type=text class=form-control id=field_defaultValue ng-model=vm.property.defaultValue readonly> <span class=input-group-btn><button id=localeBtn_defaultValue disabled class=\"btn btn-default\" type=button ng-click=vm.showDefaultValue() value=defaultValue><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=dvmProduct.modifyFlag></span></label><select class=form-control ng-model=vm.property.modifyFlag required ng-disabled=\"vm.product.referenceSource==\'residential\'\"><option ng-repeat=\"x in vm.modifyFlag\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=property.desc></span></label><div class=input-group><input type=text class=form-control name=description id=field_desc ng-model=vm.property.description readonly> <span class=input-group-btn><button id=localeBtn disabled class=\"btn btn-default\" type=button ng-click=vm.show() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_cmdCode><span translate=property.cmdCode></span></label><input type=text class=form-control id=field_cmdCode ng-model=vm.property.cmdCode></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_returnCmdCode><span translate=property.returnCmdCode></span></label><input type=text class=form-control name=returnCmdCode id=field_returnCmdCode ng-model=vm.property.returnCmdCode></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_rangeCode><span translate=property.rangeCode></span></label><input type=text class=form-control name=rangeCode id=field_rangeCode ng-model=vm.property.rangeCode></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.parameter></span></label><input type=text class=form-control ng-model=vm.property.parameter></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.parameterValue></span></label><input type=text class=form-control ng-model=vm.property.parameterValue></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.controlFlag></span></label><lookup-select lookup-value=vm.property.switchFlag lookup-type=SYS.YES_NO required></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.musicUrl></span></label><input type=text class=form-control ng-model=vm.property.attribute1 disabled></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.propertyCategory></span></label><lookup-select lookup-value=vm.property.propertyCategory lookup-type=IOT.DVM_PROPERTY_CATEGORY ng-disabled=false></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span> <span translate=dvmProduct.syncFlag></span></label><lookup-select lookup-value=vm.property.syncFlag lookup-type=SYS.YES_NO required></div></div></div><div class=row><div class=col-md-6></div><!--<div class=\"col-md-2\">--><!--<div class=\"btn btn-primary\" type=\"file\" ng-model=\"vm.file\" translate=\"property.selectMusic\"--><!--ngf-select>--><!--</div>--><!--</div>--><div class=col-md-2></div><div class=col-md-2><input type=file name=music id=music ng-model=vm.file onchange=angular.element(this).scope().vm.uploadMusic() style=\"opacity: 0; position: absolute; z-index: 100; height: 36px; padding-top: 8px\"> <a class=\"btn btn-w-m btn-info\"><span translate=property.musicUpload></span></a></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_propertyName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_propertyName type=hidden></div><div class=modal-body id=localeModelBody_propertyName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSurePropertyName()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_parameterRange style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_parameterRange type=hidden></div><div class=modal-body id=localeModelBody_parameterRange></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureParameterRange()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_defaultValue style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_defaultValue type=hidden></div><div class=modal-body id=localeModelBody_defaultValue></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureDefaultValue()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_currentValue style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_currentValue type=hidden></div><div class=modal-body id=localeModelBody_currentValue></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureCurrentValue()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/addProductType.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  #toast-container {\n    z-index: 1100;\n  }</style><form name=addForm role=form ng-submit=vm.addProductType() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=dvmProduct.productTypeDetail></span></h4></div><div class=modal-body><div class=row style=\"text-align: center\"><div style=\"text-align: center\"><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 60px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px\" type=file><!--ng-required=\"vm.productType.productTypeImage!=null\" --> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile><div><span translate=title.uploadPicTip></span></div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div><span translate=btnTypeName.upload></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_productTypeCode><span style=color:red>*</span> <span translate=dvmProduct.productTypeCode></span></label><input type=text class=form-control name=productTypeCode id=field_productTypeCode ng-model=vm.productType.productTypeCode required ng-readonly=vm.readOnlyCode></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_productTypeName><span style=color:red>*</span> <span translate=dvmProduct.productType></span></label><div class=input-group><input type=text class=form-control name=productType id=field_productTypeName ng-model=vm.productType.productTypeName required readonly> <span class=input-group-btn><button id=localeBtn_productType disabled class=\"btn btn-default\" type=button ng-click=vm.showProductType() value=productTypeName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><input type=hidden ng-model=vm.productType.productTypeImage></div><div class=row><!--<div class=\"col-md-6\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"field_cmdSetId\"><span style=\"color:red\">*</span> <span translate=\"dvmProduct.instruction\"></span></label>--><!--<input type=\"text\" class=\"form-control\" name=\"cmdSetId\" id=\"field_cmdSetId\"--><!--ng-model=\"vm.productType.cmdSetId\" required/>--><!--</div>--><!--</div>--><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=dvmProduct.desc></span></label><div class=input-group><input type=text class=form-control name=description id=field_desc ng-model=vm.productType.description readonly> <span class=input-group-btn><button id=localeBtn_description disabled class=\"btn btn-default\" type=button ng-click=vm.showDescription() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModalBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureDescription()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_productType style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_productType type=hidden></div><div class=modal-body id=localeModalBody_productType></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureProductType()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/addSku.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addSku() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=dvmSku.detail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span translate=dvmSku.code></span></label><input type=text class=form-control name=code id=field_skuCode ng-model=vm.sku.skuNumber required ng-readonly=vm.skuCodeReadOnly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_skuName><span style=\"color: red\">*</span><span translate=dvmSku.name></span></label><div class=input-group><input type=text class=form-control name=skuName id=field_skuName ng-model=vm.sku.skuName required readonly> <span class=input-group-btn><button id=localeBtn_skuName disabled class=\"btn btn-default\" type=button ng-click=vm.showSkuName() value=skuName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_skuCode><span style=\"color: red\">*</span><span translate=dvmSku.productName></span></label><select class=form-control ng-model=vm.sku.productId required ng-disabled=vm.sku.skuId><option ng-repeat=\"x in vm.products\" value={{x.productId}} ng-selected=\"x.productId == vm.sku.productId\">{{x.productName}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=dvmSku.veilFlag></span></label><lookup-select lookup-value=vm.sku.attribute1 lookup-type=IOT.DVM_SKU_VEIL_FLAG required></lookup-select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=dvmSku.skuType></span></label><lookup-select lookup-value=vm.sku.referenceSource lookup-type=IOT.DVM.COM_PRODUCT_TYPE required></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=dvmSku.desc></span></label><div class=input-group><input type=text class=form-control name=description id=field_desc ng-model=vm.sku.description readonly> <span class=input-group-btn><button id=localeBtn disabled class=\"btn btn-default\" type=button ng-click=vm.show() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_skuName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_skuName type=hidden></div><div class=modal-body id=localeModelBody_skuName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureSkuName()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/addSkuProperty.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=dvmSku.chooseProperty></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-6><label class=\"col-md-6 control-label\" style=padding-top:5px><span translate=property.code></span></label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.property.propertyCode class=form-control></div></div><div class=col-md-6><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.searchProperty()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProperty()></th><th><span translate=property.code></span></th><th><span translate=property.name></span></th><th><span translate=property.type></span></th><th><span translate=property.ruleType></span></th></tr></thead><tbody><tr ng-repeat=\"property in vm.properties\"><td><input type=checkbox name=chk_list_add class=chk_list value={{property.propertyId}} ng-click=vm.checkProperty()></td><td>{{property.propertyCode}}</td><td>{{property.propertyName}}</td><td>{{property.propertyAttributeType}}</td><td><select ng-model=property.propertyAttributeRuleType disabled><option ng-repeat=\"x in vm.ruleType\" value={{x.value}}>{{x.meaning}}</option></select></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveProperty()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/comDevConnInfo.html","<style>select {\n        background: none;\n        border: none;\n        appearance: none;\n        -moz-appearance: none;\n        -webkit-appearance: none;\n    }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=row><alert-error></alert-error></div><div class=ibox-title><h5><span translate=deviceMonitor.commercialInfo></span></h5></div><div class=row style=\"margin-top: 6px\"><ul class=\"nav nav-tabs\" role=tablist id=mytab><li role=presentation class=active><a href=//#connectedException id=exceptionConnDevice role=tab data-toggle=tab ng-click=vm.getExcepitons()><span translate=deviceMonitor.exceptionInfo></span></a></li><li role=presentation><a href=//#connectedParty id=partyConnDevice role=tab data-toggle=tab ng-click=vm.getParties()><span translate=infoConnDevice.partyConnected></span></a></li><li role=presentation><a href=//#connectedBox id=boxConnDevice role=tab data-toggle=tab ng-click=vm.getBoxes()><span translate=infoConnDevice.boxConnected></a></li><li role=presentation><a href=//#firmwareVersion id=firmVersion role=tab data-toggle=tab ng-click=vm.getFirmVersions()><span translate=infoConnDevice.firmVersion></a></li></ul></div><div id=tabstrip class=tab-content><div id=connectedException class=\"tab-pane fade in active\"><div style=\"margin-top: 10px\"><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label text-right\"><span translate=dataAnalysis.beginDate></span></label><div class=col-lg-10><p class=\"input-group date form_date\"><input type=text class=form-control name=start id=start ng-model=vm.dvmCommDevice.beginTime ng-change=vm.compareDate() readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label text-right\"><span translate=dataAnalysis.endDate></span></label><div class=col-lg-10><p class=\"input-group date form_date\"><input type=text class=form-control name=end id=end ng-model=vm.dvmCommDevice.endTime ng-change=vm.compareDate() readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div></div><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=deviceMonitor.exceptionDescription></span></label><div class=col-lg-10><input type=text ng-model=vm.dvmCommDevice.exceptionDescription class=form-control></div></div></div><div class=row><div class=\"col-lg-3 col-lg-offset-1\" style=\"margin-top: 10px\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchException()><span translate=btnTypeName.search></span></button></div></div></div></div></div><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=deviceMonitor.processStatus></span></th><th><span translate=deviceMonitor.exceptionDescription></span></th><th><span translate=deviceMonitor.exceptionType></span></th><th><span translate=deviceMonitor.exceptionDate></span></th></tr></thead><tbody><tr ng-repeat=\"CommDevice in vm.exceptions\"><td><select ng-model=CommDevice.processStatus disabled><option ng-repeat=\"y in vm.processStatus\" value={{y.value}}>{{y.meaning}}</option></select></td><td ng-bind=CommDevice.exceptionDescription></td><td><select ng-model=CommDevice.exceptionType disabled><option ng-repeat=\"ste in vm.exceptionType\" value={{ste.value}}>{{ste.meaning}}</option></select></td><td>{{CommDevice.exceptionDate}}</td></tr></tbody></table><div class=text-center><item-count page=vm.exceptionPage total=vm.exceptionsTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.exceptionsTotalItems ng-model=vm.exceptionPage ng-change=vm.commercialExceptionPageChanged(vm.exceptionPage)></uib-pagination></div></div></div><div id=connectedParty class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnDevice.partyName></span></th><th><span translate=infoConnDevice.location></span></th><th><span translate=infoConnDevice.phoneNumber></span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><td ng-bind=party.partyAccount></td><td ng-bind=party.locationAddress></td><td ng-bind=party.phoneNumber></td></tr></tbody></table><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.commercialInfoPartyPageChanged(vm.page)></uib-pagination></div></div></div><div id=connectedBox class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=deviceMonitor.location></span></th><th><span translate=deviceMonitor.skuNumber></span></th><th><span translate=deviceMonitor.boxSerialNumber></span></th></tr></thead><tbody><tr ng-repeat=\"box in vm.boxes\"><td ng-bind=box.location></td><td ng-bind=box.skuNumber></td><td ng-bind=box.boxSerialNumber></td></tr></tbody></table><div class=text-center><item-count page=vm.boxPage total=vm.boxTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.boxTotalItems ng-model=vm.boxPage ng-change=vm.commercialInfoBoxPageChanged(vm.boxPage)></uib-pagination></div></div></div><div id=firmwareVersion class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnDevice.firmwareName></span></th><th><span translate=infoConnDevice.firmVersion></span></th></tr></thead><tbody><tr ng-repeat=\"FirmVersion in vm.firmVersions\"><td ng-bind=FirmVersion.firmwareName></td><td ng-bind=FirmVersion.firmwareVersion></td></tr></tbody></table><div class=text-center><item-count page=vm.firmwarePage total=vm.firmwareTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.firmwareTotalItems ng-model=vm.firmwarePage ng-change=vm.commercialInfoPartyPageChanged(vm.firmwarePage)></uib-pagination></div></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/commBoxLog.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=commBoxLog.boxLog></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=commBoxLog.logTime></span></label><!--<div class=\"col-lg-8\">\n                    <p class=\"input-group\">\n                      <input type=\"text\" class=\"form-control\" uib-datepicker-popup name=\"logTime\"\n                             id=\"field_logTime\" ng-model=\"vm.commBoxLog.logTime\" datepicker-options=\"vm.dateOptions\"\n                             is-open=\"vm.isOpen\"/>\n                      <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.popupOpen()\">\n                          <i class=\"glyphicon glyphicon-calendar\"></i></button>\n                      </span>\n                    </p>\n                  </div>--><div class=col-lg-8><div class=\"input-group date form_date\"><input class=form-control id=field_logTime type=text ng-model=vm.commBoxLog.logTime readonly name=logTime> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.getCommBoxLog()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=commBoxLog.logTime></span></th><th><span translate=commBoxLog.logContent></span></th><th><span translate=commBoxLog.download></span></th></tr></thead><tbody><tr ng-repeat=\"commBoxLog in vm.commBoxLog\"><td>{{commBoxLog.logTime}}</td><td>{{commBoxLog.logContent}}</td><td><a href=http://{{commBoxLog.logUrl}} target=_blank><i class=\"fa fa-edit text-navy\"><span translate=commBoxLog.download></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/commDeviceMonitor.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=row><alert-error></alert-error></div><div class=ibox-title><h5><span translate=deviceMonitor.commercial></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.orgName></span></label><div class=col-lg-8><input type=text ng-model=vm.CommDevice.orgName class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.skuNumber></span></label><div class=col-lg-8><input type=text ng-model=vm.CommDevice.skuNumber class=form-control></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.inException></span></label><div class=col-lg-8><lookup-select lookup-value=vm.CommDevice.inException lookup-type=IOT.DVM.DEVICE_EXCEPTION_STATUS></lookup-select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.iotDeviceId></span></label><div class=col-lg-8><input type=text ng-model=vm.CommDevice.iotDeviceId class=form-control></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.deviceType></span></label><div class=col-lg-8><select class=form-control ng-model=vm.CommDevice.deviceCode><option value=\"\"></option><option ng-repeat=\"product in vm.commercialProducts\" value={{product.productCode}} ng-hide=\"product.productCode==\'COM_BOX\'\">{{product.productName}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.sn></span></label><div class=col-lg-8><input type=text ng-model=vm.CommDevice.deviceSerialNumber class=form-control></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"control-label col-lg-4\"><span translate=deviceMonitor.connectStatus></span></label><div class=col-lg-8><lookup-select lookup-value=vm.CommDevice.connectStatus lookup-type=IOT.DVM.DEVICE_ONOFFLINE_STATUS></lookup-select></div></div><div class=col-lg-5><label class=\"control-label col-lg-4\"><span translate=deviceMonitor.boundStatus></span></label><div class=col-lg-8><lookup-select lookup-value=vm.CommDevice.boundStatus lookup-type=SYS.YES_NO required></lookup-select></div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><div class=\"col-lg-12 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchCommercial()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-info\" type=button ng-click=vm.exportExcel()><span translate=btnTypeName.export></span></button> <button class=\"btn btn-w-m btn-danger\" type=button ng-click=vm.resetCommDevice()><span translate=btnTypeName.reset></span></button></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=deviceMonitor.iotDeviceId></span></th><th><span translate=deviceMonitor.location></span></th><th><span translate=deviceMonitor.orgName></span></th><th><span translate=deviceMonitor.inException></span></th><th><span translate=deviceMonitor.deviceStatus></span></th><th><span translate=deviceMonitor.boundStatus></span></th><th><span translate=deviceMonitor.deviceType></span></th><th><span translate=deviceMonitor.skuNumber></span></th><th><span translate=deviceMonitor.sn></span></th><th><span translate=deviceMonitor.ConnectedInfo></span></th><!--<th><span translate=\"deviceMonitor.log\"></span></th>--></tr></thead><tbody><tr ng-repeat=\"CommDevice in vm.devices\"><td ng-bind=CommDevice.iotDeviceId></td><td ng-bind=CommDevice.location></td><td ng-bind=CommDevice.orgName></td><td><select ng-model=CommDevice.inException disabled><option ng-repeat=\"x in vm.inException\" value={{x.value}}>{{x.meaning}}</option></select></td><td><select ng-model=CommDevice.connectStatus disabled><option ng-repeat=\"sts in vm.connectStatus\" value={{sts.value}}>{{sts.meaning}}</option></select></td><td>{{CommDevice.connectStatus ? \'deviceMonitor.bound\' :\'deviceMonitor.unbound\' | translate}}</td><td ng-bind=CommDevice.deviceType></td><td ng-bind=CommDevice.skuNumber></td><td ng-bind=CommDevice.deviceSerialNumber></td><td><a ui-sref=commDeviceInfo({deviceId:CommDevice.deviceId,boxId:CommDevice.boxId})><i class=\"fa fa-edit text-navy\"><span translate=deviceMonitor.residentialInfo></span></i></a></td><!--<td>--><!--<a ui-sref=\"commDeviceMonitor.view({deviceId:CommDevice.deviceId})\"><i--><!--class=\"fa fa-edit text-navy\"><span--><!--translate=\"deviceMonitor.view\"></span></i></a>--><!--<a ng-click=\"vm.downloadLog(party)\"><i class=\"fa fa-times text-navy\"><span--><!--translate=\"deviceMonitor.download\"></span></i></a>--><!--</td>--></tr></tbody></table><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.commercialPageChanged()></uib-pagination></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/commercialBox.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=boxMonitor.commercial></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=boxMonitor.orgName></span></label><div class=col-lg-8><input type=text ng-model=vm.CommBox.orgName class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=boxMonitor.skuNumber></span></label><div class=col-lg-8><input type=text ng-model=vm.CommBox.skuNumber class=form-control></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=boxMonitor.boxStatus></span></label><div class=col-lg-8><lookup-select lookup-value=vm.CommBox.connectStatus lookup-type=IOT.DVM.DEVICE_ONOFFLINE_STATUS></lookup-select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=boxMonitor.sn></span></label><div class=col-lg-8><input type=text ng-model=vm.CommBox.boxSerialNumber class=form-control></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"control-label col-lg-4\"><span translate=deviceMonitor.boundStatus></span></label><div class=col-lg-8><lookup-select lookup-value=vm.CommBox.boundStatus lookup-type=SYS.YES_NO required></lookup-select></div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><div class=\"col-lg-12 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchCommercialBox()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-info\" type=button ng-click=vm.exportExcel()><span translate=btnTypeName.export></span></button></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=boxMonitor.location></span></th><th><span translate=boxMonitor.orgName></span></th><th><span translate=boxMonitor.boxStatus></span></th><th><span translate=deviceMonitor.boundStatus></span></th><th><span translate=boxMonitor.boxType></span></th><th><span translate=boxMonitor.skuNumber></span></th><th><span translate=boxMonitor.sn></span></th><th><span translate=boxMonitor.ConnectedInfo></span></th><th><span translate=boxMonitor.log></span></th></tr></thead><tbody><tr ng-repeat=\"CommBox in vm.boxes\"><td ng-bind=CommBox.location></td><td ng-bind=CommBox.orgName></td><td><select ng-model=CommBox.connectStatus disabled><option ng-repeat=\"sts in vm.boxStatus\" value={{sts.value}}>{{sts.meaning}}</option></select></td><td>{{CommBox.connectStatus ? \'deviceMonitor.bound\' :\'deviceMonitor.unbound\' | translate}}</td><td ng-bind=CommBox.boxType></td><td ng-bind=CommBox.skuNumber></td><td ng-bind=CommBox.boxSerialNumber></td><td><a ui-sref=commBoxInfo({boxId:CommBox.boxId})><i class=\"fa fa-edit text-navy\"><span translate=boxMonitor.ConnectedInfo></span></i></a></td><td><a ui-sref=commBoxLog({boxId:CommBox.boxId})><i class=\"fa fa-edit text-navy\"><span translate=boxMonitor.view></span></i></a></td></tr></tbody></table><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.commercialBoxPageChanged()></uib-pagination></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/commercialBoxInfo.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=row><alert-error></alert-error></div><div class=ibox-title><h5><span translate=infoConnBox.commercialInfo></span></h5></div><div class=row style=\"margin-top: 6px\"><ul class=\"nav nav-tabs\" role=tablist id=mytab><li role=presentation class=active><a href=//#connectedParty id=partyConnDevice role=tab data-toggle=tab ng-click=vm.getParties()><span translate=infoConnDevice.partyConnected></span></a></li><li role=presentation><a href=//#connectedBox id=boxConnDevice role=tab data-toggle=tab ng-click=vm.getDevices()><span translate=infoConnDevice.deviceConnected></a></li><li role=presentation><a href=//#firmwareVersion id=firmVersion role=tab data-toggle=tab ng-click=vm.getFirmVersions()><span translate=infoConnDevice.firmVersion></a></li></ul></div><div id=tabstrip class=tab-content><div id=connectedParty class=\"tab-pane fade in active\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnBox.partyName></span></th><th><span translate=infoConnBox.location></span></th><th><span translate=infoConnBox.phoneNumber></span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><td ng-bind=party.partyAccount></td><td ng-bind=party.locationAddress></td><td ng-bind=party.phoneNumber></td></tr></tbody></table><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.commercialBoxInfoPartyPageChanged()></uib-pagination></div></div></div><div id=connectedBox class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnBox.location></span></th><th><span translate=infoConnBox.skuNumber></span></th><th><span translate=infoConnBox.deviceSerialNumber></span></th></tr></thead><tbody><tr ng-repeat=\"box in vm.devices\"><td ng-bind=box.location></td><td ng-bind=box.skuNumber></td><td ng-bind=box.deviceSerialNumber></td></tr></tbody></table><div class=text-center><item-count page=vm.devicePage total=vm.deviceTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.devcieTotalItems ng-model=vm.devicePage ng-change=vm.commercialBoxInfoDevPageChanged()></uib-pagination></div></div></div><div id=firmwareVersion class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnDevice.firmwareName></span></th><th><span translate=infoConnDevice.firmVersion></span></th></tr></thead><tbody><tr ng-repeat=\"FirmVersion in vm.firmVersions\"><td ng-bind=FirmVersion.firmwareName></td><td ng-bind=FirmVersion.firmwareVersion></td></tr></tbody></table><div class=text-center><item-count page=vm.firmwarePage total=vm.firmwareTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.firmwareTotalItems ng-model=vm.firmwarePage ng-change=vm.commercialBoxInfoFirmPageChanged()></uib-pagination></div></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/copyProductProperty.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.copyPropertySubmit() style=\"height: 240px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.cancel()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=property.copy></span></h4></div><div class=modal-body><div class=row><div class=form-group><label class=control-label><span translate=property.fromProductCopy></span></label><select class=form-control ng-model=vm.property.oldProductId><option ng-repeat=\"x in vm.products\" value={{x.productId}}>{{x.productName}}</option></select></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.cancel()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/dvm/html/device.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dvmDevice.maintenance></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmDevice.productName></span></label><div class=col-lg-8><input type=text ng-model=vm.device.productName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmDevice.serial></span></label><div class=col-lg-8><input type=text ng-model=vm.device.deviceSerialNumber class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmDevice.referenceSource></span></label><div class=col-lg-8><select ng-model=vm.device.referenceSource class=form-control><option ng-repeat=\"option in vm.referenceSources\" value={{option.value}}>{{option.meaning}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\">SKU</label><div class=col-lg-8><input type=text ng-model=vm.device.skuNumber class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=button ng-click=vm.resetDevice()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><!--<th><span translate=\"dvmDevice.code\"></span></th>--><th><span translate=dvmDevice.serial></span></th><th>SKU</th><th><span translate=dvmDevice.productName></span></th><th><span translate=dvmDevice.properties></span></th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices\"><!--<td>{{device.deviceCode}}</td>--><td>{{device.deviceSerial}}</td><td>{{device.skuNumber}}</td><td>{{device.productName}}</td><td><a ui-sref=dvmDproperty({deviceId:device.deviceId,referenceSource:vm.device.referenceSource})><i class=\"fa fa-edit text-navy\"><span translate=dvmDevice.properties></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/deviceNameList.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dvmProduct.deviceNameListMaintenance></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.code></span></label><div class=col-lg-8><input type=text ng-model=vm.deviceNameList.productCode class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.name></span></label><div class=col-lg-8><input type=text ng-model=vm.deviceNameList.productName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteDeviceNameLists()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-5 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=deviceNameList.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllDeviceNameList()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=dvmProduct.code></span></th><th><span translate=dvmProduct.name></span></th><th><span translate=dvmProduct.deviceNameList></span></th><th><span translate=dvmProduct.desc></span></th></tr></thead><tbody><tr ng-repeat=\"deviceNameList in vm.deviceNameLists\"><td><input type=checkbox name=chk_list class=chk_list value={{deviceNameList.deviceNameListId}} ng-click=vm.checkDeviceNameList()>&nbsp;&nbsp; <a ui-sref=deviceNameList.edit({deviceNameListId:deviceNameList.deviceNameListId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteDeviceNameList(deviceNameList)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{deviceNameList.productCode}}</td><td>{{deviceNameList.productName}}</td><td>{{deviceNameList.deviceName}}</td><td>{{deviceNameList.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/deviceProperty.html","<style>td select {\n    background: none !important;\n    border: none !important;\n    appearance: none !important;\n    cursor: auto !important;\n    -moz-appearance: none !important;\n    -webkit-appearance: none !important;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5>设备属性</h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=property.code></span></label><div class=col-lg-8><input type=text ng-model=vm.property.propertyCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=property.name></span></label><div class=col-lg-8><input type=text ng-model=vm.property.propertyName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetProperty()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=property.code></span></th><th><span translate=property.name></span></th><th><span translate=property.type></span></th><th><span translate=property.ruleType></span></th><th><span translate=dvmProduct.syncFlag></span></th></tr></thead><tbody><tr ng-repeat=\"property in vm.propertys\"><td class=col-md-2><a ui-sref=dvmDproperty.view({deviceId:property.deviceId,propertyId:property.propertyId,referenceSource:property.referenceSource})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.view></span></i></a></td><td>{{property.propertyCode}}</td><td>{{property.propertyName}}</td><td>{{property.propertyType}}</td><td>{{property.parameterType}}</td><td>{{property.parameterType}}</td><td><lookup-select lookup-value=property.syncFlag lookup-type=SYS.YES_NO disable=true></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/onLineRate.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=main.deviceRate></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-2 control-label text-right\" translate=dataAnalysis.beginDate></label><div class=col-lg-10><p class=\"input-group date form_date\"><input type=text class=form-control name=start id=start ng-change=vm.compareDate() ng-model=vm.onLine.beginTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-5><label class=\"col-lg-2 control-label text-right\" translate=dataAnalysis.endDate></label><div class=col-lg-10><p class=\"input-group date form_date\"><input type=text class=form-control name=end id=end ng-change=vm.compareDate() ng-model=vm.onLine.endTime readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div></div></div><div class=form-group><div class=row><div class=col-lg-5></div><div class=col-lg-5><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetOnLine()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div id=eContainerTotal style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie7 style=\"padding-left: 0\"></div></div><div style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie8 style=\"padding-left: 0\"></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/otherNameList.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dvmProduct.otherNameListMaintenance></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.otherName></span></label><div class=col-lg-8><input type=text ng-model=vm.otherNameList.otherName class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.otherType></span></label><div class=col-lg-8><lookup-select lookup-value=vm.otherNameList.otherType lookup-type=SYS.OTHER_TYPE></lookup-select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteOtherNameLists()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-5 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=otherNameList.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllOtherNameList()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=dvmProduct.otherType></span></th><th><span translate=dvmProduct.otherName></span></th><th><span translate=dvmProduct.desc></span></th></tr></thead><tbody><tr ng-repeat=\"otherNameList in vm.otherNameLists\"><td><input type=checkbox name=chk_list class=chk_list value={{otherNameList.otherNameListId}} ng-click=vm.checkOtherNameList()>&nbsp;&nbsp; <a ui-sref=otherNameList.edit({otherNameListId:otherNameList.otherNameListId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteOtherNameList(otherNameList)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><!--<td>{{otherNameList.otherType}}</td>--><td><select ng-model=otherNameList.otherType disabled><option ng-repeat=\"x in vm.otherType\" value={{x.value}}>{{x.meaning}}</option></select></td><td ng-if=\"otherNameList.otherType.indexOf(\'_NAME\') != -1\">{{otherNameList.otherName}}</td><td ng-if=\"otherNameList.otherType.indexOf(\'_ICON\') != -1\"><img style=\"width:40px;height:40px; border-radius:10px; background-color:black\" ngf-src=otherNameList.otherName></td><td>{{otherNameList.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/product.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dvmProduct.maintenance></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.name></span></label><div class=col-lg-8><input type=text ng-model=vm.product.productName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.code></span></label><div class=col-lg-8><input type=text ng-model=vm.product.productCode class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.category></span></label><div class=col-lg-8><lookup-select lookup-value=vm.product.referenceSource lookup-type=IOT.DVM.COM_PRODUCT_TYPE></lookup-select></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.productRegion></span></label><div class=col-lg-8><lookup-select lookup-value=vm.product.productRegion lookup-type=IOT.DVM.PRODUCT_REGION></lookup-select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteProducts()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=dvmproduct.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetProduct()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProduct()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=dvmProduct.cmdSetId></span></th><th><span translate=dvmProduct.code></span></th><th><span translate=dvmProduct.name></span></th><th><span translate=dvmProduct.type></span></th><th><span translate=dvmProduct.category></span></th><th><span translate=dvmProduct.productRegion></span></th><th><span translate=dvmProduct.desc></span></th><th><span translate=dvmProduct.properties></span></th></tr></thead><tbody><tr ng-repeat=\"product in vm.products\"><td><input type=checkbox name=chk_list class=chk_list value={{product.productId}} ng-click=vm.checkProduct()>&nbsp;&nbsp; <a ui-sref=dvmproduct.edit({productId:product.productId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteProduct(product)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{product.cmdSetId}}</td><td>{{product.productCode}}</td><td>{{product.productName}}</td><td>{{product.productType}}</td><td><select ng-model=product.referenceSource disabled><option ng-repeat=\"x in vm.referenceSource\" value={{x.value}}>{{x.meaning}}</option></select></td><td><select ng-model=product.productRegion disabled><option ng-repeat=\"x in vm.productRegion\" value={{x.value}}>{{x.meaning}}</option></select></td><td>{{product.description}}</td><!--fa fa-newspaper-o--><td><a ui-sref=dvmPproperty({productId:product.productId})><i class=\"fa fa-edit text-navy\"><span translate=dvmProduct.properties></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/productProperty.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  .col-md-2 select {\n    background: none !important;\n    border: none !important;\n    appearance: none !important;\n    cursor: auto !important;\n    -moz-appearance: none !important;\n    -webkit-appearance: none !important;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dvmProduct.property></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=property.code></span></label><div class=col-lg-8><input type=text ng-model=vm.property.propertyCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=property.name></span></label><div class=col-lg-8><input type=text ng-model=vm.property.propertyName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.copyProductProperty()><span translate=property.copy></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deletePropertys()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=dvmPproperty.add({propertyId:property.propertyId})><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetProperty()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProperty()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=dvmProduct.name></span></th><th><span translate=property.code></span></th><th><span translate=property.name></span></th><th><span translate=dvmProduct.syncFlag></span></th><th><span translate=property.desc></span></th></tr></thead><tbody><tr ng-repeat=\"property in vm.propertys\"><td class=col-md-2><input type=checkbox name=chk_list class=chk_list value={{property.propertyId}} ng-click=vm.checkProperty()>&nbsp;&nbsp; <a ui-sref=dvmPproperty.edit({propertyId:property.propertyId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteProperty(property)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td class=col-md-2>{{property.productName}}</td><td class=col-md-2>{{property.propertyCode}}</td><td class=col-md-2>{{property.propertyName}}</td><td class=col-md-2><lookup-select lookup-value=property.syncFlag lookup-type=SYS.YES_NO disable=true></td><td class=col-md-2>{{property.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/productType.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dvmProduct.productTypeMaintenance></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.productTypeCode></span></label><div class=col-lg-8><input type=text ng-model=vm.productType.productTypeCode class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.productType></span></label><div class=col-lg-8><input type=text ng-model=vm.productType.productTypeName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteProductTypes()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=productType.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProductType()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=dvmProduct.productTypeCode></span></th><th><span translate=dvmProduct.productType></span></th><!--<th><span translate=\"dvmProduct.instructionSet\"></span></th>--><!--<th><span translate=\"dvmProduct.deviceIdentity\"></span></th>--><th><span translate=dvmProduct.description></span></th><!--<th><span translate=\"dvmProduct.voiceCommand\"></span></th>--></tr></thead><tbody><tr ng-repeat=\"productType in vm.productTypes\"><td><input type=checkbox name=chk_list class=chk_list value={{productType.productTypeId}} ng-click=vm.checkProductType()>&nbsp;&nbsp; <a ui-sref=productType.edit({productTypeId:productType.productTypeId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteProductType(productType)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{productType.productTypeCode}}</td><td>{{productType.productTypeName}}</td><!-- <td>{{productType.cmdSetId}}</td>\n                <td>{{productType.deviceIdentity}}</td>--><td>{{productType.description}}</td><!--<td>{{productType.voiceCommand}}</td>--></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/resBoxLog.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=resBoxLog.boxLog></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=resBoxLog.logTime></span></label><!--<div class=\"col-lg-8\">\n                    <p class=\"input-group\">\n                      <input type=\"text\" class=\"form-control\" uib-datepicker-popup name=\"logTime\"\n                             id=\"field_logTime\" ng-model=\"vm.resBoxLog.logTime\" datepicker-options=\"vm.dateOptions\"\n                             is-open=\"vm.isOpen\"/>\n                      <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.popupOpen()\">\n                          <i class=\"glyphicon glyphicon-calendar\"></i></button>\n                      </span>\n                    </p>\n                  </div>--><div class=col-lg-8><div class=\"input-group date form_date\"><input class=form-control id=field_logTime type=text ng-model=vm.resBoxLog.logTime readonly name=logTime> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=resBoxLog.logTime></span></th><th><span translate=resBoxLog.logContent></span></th><th><span translate=resBoxLog.download></span></th></tr></thead><tbody><tr ng-repeat=\"resBoxLog in vm.resBoxLogs\"><td>{{resBoxLog.logTime}}</td><td>{{resBoxLog.logContent}}</td><td><a href=http://{{resBoxLog.logUrl}} target=_blank><i class=\"fa fa-edit text-navy\"><span translate=resBoxLog.download></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/resDeviceConnectedInfo.html","<style>select {\n        background: none;\n        border: none;\n        appearance: none;\n        -moz-appearance: none;\n        -webkit-appearance: none;\n    }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=row><alert-error></alert-error></div><div class=ibox-title><h5><span translate=deviceMonitor.residentialInfo></span></h5></div><div class=row style=\"margin-top: 6px\"><ul class=\"nav nav-tabs\" role=tablist id=mytab><li role=presentation class=active><a href=//#connectedException id=exceptionInfo role=tab data-toggle=tab ng-click=vm.getExceptions()><span translate=deviceMonitor.exceptionInfo></a></li><li role=presentation><a href=//#connectedParty id=partyConnDevice role=tab data-toggle=tab ng-click=vm.getParties()><span translate=infoConnDevice.partyConnected></a></li><li role=presentation><a href=//#connectedBox id=boxConnDevice role=tab data-toggle=tab ng-click=vm.getBoxes()><span translate=infoConnDevice.boxConnected></a></li><li role=presentation><a href=//#firmwareVersion id=firmVersion role=tab data-toggle=tab ng-click=vm.getFirmVersions()><span translate=infoConnDevice.firmVersion></a></li></ul></div><div id=tabstrip class=tab-content><div id=connectedException class=\"tab-pane fade in active\"><div style=\"margin-top: 10px\"><div class=form-horizontal><div class=form-group><div class=col-lg-6><label class=\"col-lg-2 control-label text-right\"><span translate=dataAnalysis.beginDate></span></label><div class=col-lg-10><p class=\"input-group date form_date\"><input type=text class=form-control name=start id=start ng-model=vm.dvmDeviceInfo.beginTime ng-change=vm.compareDate() readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label text-right\"><span translate=dataAnalysis.endDate></span></label><div class=col-lg-10><p class=\"input-group date form_date\"><input type=text class=form-control name=end id=end ng-model=vm.dvmDeviceInfo.endTime ng-change=vm.compareDate() readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-remove\"></span> </span><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></p></div></div></div><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=deviceMonitor.exceptionDescription></span></label><div class=col-lg-10><input type=text class=form-control ng-model=vm.dvmDeviceInfo.exceptionDescription></div></div></div><div class=row><div class=\"col-lg-3 col-lg-offset-1\" style=\"margin-top: 10px\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchException()><span translate=btnTypeName.search></span></button></div></div></div></div><div class=table-responsive><table class=\"table table-striped\"><thead><th><span translate=deviceMonitor.exceptionDescription></span></th><th><span translate=deviceMonitor.exceptionType></span></th><th><span translate=deviceMonitor.exceptionDate></span></th></thead><tbody><tr ng-repeat=\"exception in vm.exceptions\"><td ng-bind=exception.exceptionDescription></td><td ng-model=exception.exceptionType disabled><select ng-model=exception.exceptionType disabled><option ng-repeat=\"x in vm.exceptionType\" value={{x.value}}>{{x.meaning}}</option></select></td><td>{{exception.exceptionDate | date:\"yyyy-MM-dd\"}}</td></tr></tbody></table><div class=text-center><item-count page=vm.exceptionsPage total=vm.excepitonsTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.excepitonsTotalItems ng-model=vm.exceptionsPage ng-change=vm.residentialExceptionPageChanged()></uib-pagination></div></div></div><div id=connectedParty class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnDevice.partyName></span></th><th><span translate=infoConnDevice.location></span></th><th><span translate=infoConnDevice.phoneNumber></span></th><th><span translate=infoConnDevice.isOwner></span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><td ng-bind=party.partyAccount></td><td ng-bind=party.locationAddress></td><td ng-bind=party.phoneNumber></td><td ng-bind=party.partyType></td></tr></tbody></table><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.residentialInfoPartyPageChanged()></uib-pagination></div></div></div><div id=connectedBox class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=deviceMonitor.boxId></span></th><th><span translate=deviceMonitor.boxName></span></th><th><span translate=deviceMonitor.skuNumber></span></th><th><span translate=deviceMonitor.boxSerialNumber></span></th></tr></thead><tbody><tr ng-repeat=\"box in vm.boxes\"><td ng-bind=box.boxId></td><td ng-bind=box.boxName></td><td ng-bind=box.skuNumber></td><td ng-bind=box.serialNumber></td></tr></tbody></table><div class=text-center><item-count page=vm.boxPage total=vm.boxTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.boxTotalItems ng-model=vm.boxPage ng-change=vm.residentialInfoBoxPageChanged()></uib-pagination></div></div></div><div id=firmwareVersion class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnDevice.firmwareName></span></th><th><span translate=infoConnDevice.firmVersion></span></th><th><span translate=infoConnDevice.hardwareType></span></th><th><span translate=infoConnDevice.componentNumber></span></th><th><span translate=infoConnDevice.partNumber></span></th></tr></thead><tbody><tr ng-repeat=\"FirmVersion in vm.firmVersions\"><td ng-bind=FirmVersion.firmwareName></td><td ng-bind=FirmVersion.firmwareVersion></td><td ng-bind=FirmVersion.hardwareType></td><td ng-bind=FirmVersion.componentNumber></td><td ng-bind=FirmVersion.partNumber></td></tr></tbody></table><div class=text-center><item-count page=vm.firmwarePage total=vm.firmwareTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.firmwareTotalItems ng-model=vm.firmwarePage ng-change=vm.residentialInfoPageChanged()></uib-pagination></div></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/resDeviceMonitor.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=deviceMonitor.residential></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.skuNumber></span></label><div class=col-lg-8><input type=text ng-model=vm.dvmDevice.skuNumber class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.inException></span></label><div class=col-lg-8><lookup-select lookup-value=vm.dvmDevice.inException lookup-type=IOT.DVM.DEVICE_EXCEPTION_STATUS></lookup-select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.product></span></label><div class=col-lg-8><!--<lookup-select lookup-value=\"vm.dvmDevice.deviceCode\"--><!--lookup-type=\"IOT.DVM.RES_DEVICE_TYPE\"></lookup-select>--><select class=form-control ng-model=vm.dvmDevice.deviceCode><option value=\"\"></option><option ng-repeat=\"x in vm.products\" value={{x.productCode}}>{{x.productName}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=deviceMonitor.sn></span></label><div class=col-lg-8><input type=text ng-model=vm.dvmDevice.deviceSerialNumber class=form-control></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"control-label col-lg-4\"><span translate=deviceMonitor.connectStatus></span></label><div class=col-lg-8><lookup-select lookup-value=vm.dvmDevice.connectStatus lookup-type=IOT.DVM.DEVICE_ONOFFLINE_STATUS></lookup-select></div></div><div class=col-lg-5><label class=\"control-label col-lg-4\"><span translate=deviceMonitor.boundStatus></span></label><div class=col-lg-8><lookup-select lookup-value=vm.dvmDevice.boundStatus lookup-type=SYS.YES_NO required></lookup-select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"control-label col-lg-4\"><span translate=deviceMonitor.iotDeviceId></span></label><div class=col-lg-8><input type=text ng-model=vm.dvmDevice.iotDeviceId class=form-control></div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><div class=\"col-lg-12 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.searchResidential()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-info\" type=button ng-click=vm.exportExcel()><span translate=btnTypeName.export></span></button> <button class=\"btn btn-w-m btn-danger\" type=button ng-click=vm.resetDvmDevice()><span translate=btnTypeName.reset></span></button></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=deviceMonitor.iotDeviceId></span></th><th><span translate=deviceMonitor.inException></span></th><th><span translate=deviceMonitor.deviceStatus></span></th><th><span translate=deviceMonitor.boundStatus></span></th><th><span translate=deviceMonitor.deviceType></span></th><th><span translate=deviceMonitor.moduleType></span></th><th><span translate=deviceMonitor.skuNumber></span></th><th><span translate=deviceMonitor.sn></span></th><th><span translate=deviceMonitor.residentialInfo></span></th></tr></thead><tbody><tr ng-repeat=\"dvmDevice in vm.devices\"><td ng-bind=dvmDevice.iotDeviceId></td><td><select ng-model=dvmDevice.inException><option ng-repeat=\"x in vm.inException\" value={{x.value}}>{{x.meaning}}</option></select></td><td><select ng-model=dvmDevice.connectStatus disabled><option ng-repeat=\"st in vm.connectStatus\" value={{st.value}}>{{st.meaning}}</option></select></td><td>{{dvmDevice.connectStatus ? \'deviceMonitor.bound\' :\'deviceMonitor.unbound\' | translate}}</td><td ng-bind=dvmDevice.deviceType></td><td ng-bind=dvmDevice.moduleType></td><td ng-bind=dvmDevice.skuNumber></td><td ng-bind=dvmDevice.deviceSerialNumber></td><td><a ui-sref=resDeviceInfo({deviceId:dvmDevice.deviceId,boxId:dvmDevice.boxId,iotDeviceId:dvmDevice.iotDeviceId})><i class=\"fa fa-edit text-navy\"><span translate=deviceMonitor.residentialInfo></span></i></a></td></tr></tbody></table><div class=text-center><item-count page=vm.page total=vm.totalDevice items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalDevice ng-model=vm.page ng-change=vm.residentialPageChanged()></uib-pagination></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/residentialBox.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=boxMonitor.residential></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=boxMonitor.skuNumber></span></label><div class=col-lg-8><input type=text ng-model=vm.dvmResiBox.skuNumber class=form-control></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=boxMonitor.boxStatus></span></label><div class=col-lg-8><lookup-select lookup-value=vm.dvmResiBox.connectStatus lookup-type=IOT.DVM.BOX_STATUS></lookup-select></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=boxMonitor.sn></span></label><div class=col-lg-8><input type=text ng-model=vm.dvmResiBox.boxSerialNumber class=form-control></div></div><div class=col-lg-5><label class=\"control-label col-lg-4\"><span translate=deviceMonitor.boundStatus></span></label><div class=col-lg-8><lookup-select lookup-value=vm.dvmResiBox.boundStatus lookup-type=SYS.YES_NO required></lookup-select></div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-5 col-lg-offset-1\"><div class=\"col-lg-12 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.getResidentialBox()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-info\" type=button ng-click=vm.exportExcel()><span translate=btnTypeName.export></span></button></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=boxMonitor.location></span></th><th><span translate=boxMonitor.boxStatus></span></th><th><span translate=deviceMonitor.boundStatus></span></th><th><span translate=boxMonitor.boxType></span></th><th><span translate=boxMonitor.skuNumber></span></th><th><span translate=boxMonitor.sn></span></th><th><span translate=boxMonitor.ConnectedInfo></span></th><th><span translate=boxMonitor.log></span></th></tr></thead><tbody><tr ng-repeat=\"ResiBox in vm.boxes\"><td ng-bind=ResiBox.location></td><td><select ng-model=ResiBox.connectStatus disabled><option ng-repeat=\"sts in vm.resBoxStatus\" value={{sts.value}}>{{sts.meaning}}</option></select></td><td>{{ResiBox.connectStatus ? \'deviceMonitor.bound\' :\'deviceMonitor.unbound\' | translate}}</td><td ng-bind=ResiBox.boxType></td><td ng-bind=ResiBox.skuNumber></td><td ng-bind=ResiBox.boxSerialNumber></td><td><a ui-sref=residentialBoxInfo({boxId:ResiBox.boxId})><i class=\"fa fa-edit text-navy\"><span translate=boxMonitor.ConnectedInfo></span></i></a></td><td><a ui-sref=resBoxLog({boxId:ResiBox.boxId})><i class=\"fa fa-edit text-navy\"><span translate=boxMonitor.view></span></i></a></td></tr></tbody></table><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.residentialBoxPageChanged()></uib-pagination></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/residentialBoxInfo.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=row><alert-error></alert-error></div><div class=ibox-title><h5><span translate=infoConnBox.residentialInfo></span></h5></div><div class=row style=\"margin-top: 6px\"><ul class=\"nav nav-tabs\" role=tablist id=mytab><li role=presentation class=active><a href=//#connectedParty id=partyConnDevice role=tab data-toggle=tab ng-click=vm.getParties()><span translate=infoConnDevice.partyConnected></span></a></li><li role=presentation><a href=//#connectedBox id=boxConnDevice role=tab data-toggle=tab ng-click=vm.getDevices()><span translate=infoConnDevice.deviceConnected></a></li><li role=presentation><a href=//#firmwareVersion id=firmVersion role=tab data-toggle=tab ng-click=vm.getFirmVersions()><span translate=infoConnDevice.firmVersion></a></li></ul></div><div id=tabstrip class=tab-content><div id=connectedParty class=\"tab-pane fade in active\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnBox.partyName></span></th><th><span translate=infoConnBox.location></span></th><th><span translate=infoConnBox.phoneNumber></span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><td ng-bind=party.partyAccount></td><td ng-bind=party.locationAddress></td><td ng-bind=party.phoneNumber></td></tr></tbody></table><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.resBoxInfoPartyPageChanged()></uib-pagination></div></div></div><div id=connectedBox class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnBox.deviceName></span></th><th><span translate=infoConnBox.skuNumber></span></th><th><span translate=infoConnBox.deviceSerialNumber></span></th></tr></thead><tbody><tr ng-repeat=\"box in vm.devices\"><td ng-bind=box.deviceName></td><td ng-bind=box.skuNumber></td><td ng-bind=box.deviceSerialNumber></td></tr></tbody></table><div class=text-center><item-count page=vm.devicePage total=vm.deviceTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.deviceTotalItems ng-model=vm.devicePage ng-change=vm.resBoxInfoDevPageChanged()></uib-pagination></div></div></div><div id=firmwareVersion class=\"tab-pane fade\"><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=infoConnDevice.firmwareName></span></th><th><span translate=infoConnDevice.firmVersion></span></th></tr></thead><tbody><tr ng-repeat=\"FirmVersion in vm.firmVersions\"><td ng-bind=FirmVersion.firmwareName></td><td ng-bind=FirmVersion.firmwareVersion></td></tr></tbody></table><div class=text-center><item-count page=vm.firmwarePage total=vm.firmwareTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.firmwareTotalItems ng-model=vm.firmwarePage ng-change=vm.resBoxInfoFirmPageChanged()></uib-pagination></div></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/sku.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dvmSku.maintenance></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmSku.code></span></label><div class=col-lg-8><input type=text ng-model=vm.sku.skuNumber class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmSku.name></span></label><div class=col-lg-8><input type=text ng-model=vm.sku.skuName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteSkus()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=dvmsku.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetSku()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllSku()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=dvmSku.code></span></th><th><span translate=dvmSku.name></span></th><th><span translate=dvmSku.productName></span></th><th><span translate=dvmSku.veilFlag></span></th><th><span translate=dvmSku.desc></span></th><th><span translate=dvmSku.properties></span></th></tr></thead><tbody><tr ng-repeat=\"sku in vm.skus\"><td><input type=checkbox name=chk_list class=chk_list value={{sku.skuId}} ng-click=vm.checkSku()>&nbsp;&nbsp; <a ui-sref=dvmsku.edit({skuId:sku.skuId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteSku(sku)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{sku.skuNumber}}</td><td>{{sku.skuName}}</td><td>{{sku.productName}}</td><td><select ng-model=sku.attribute1 disabled><option ng-repeat=\"ste in vm.veilFlag\" value={{ste.value}}>{{ste.meaning}}</option></select></td><td>{{sku.description}}</td><td><a ui-sref=dvmSproperty({skuId:sku.skuId})><i class=\"fa fa-edit text-navy\"><span translate=dvmSku.properties></span></i></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/skuProperty.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  .col-md-2 select {\n    background: none !important;\n    border: none !important;\n    appearance: none !important;\n    cursor: auto !important;\n    -moz-appearance: none !important;\n    -webkit-appearance: none !important;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=dvmSku.property></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=property.code></span></label><div class=col-lg-8><input type=text ng-model=vm.property.propertyCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=property.name></span></label><div class=col-lg-8><input type=text ng-model=vm.property.propertyName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deletePropertys()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=dvmSproperty.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetProperty()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProperty()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=property.code></span></th><th><span translate=property.name></span></th><th><span translate=property.type></span></th><th><span translate=dvmSku.syncFlag></span></th><th><span translate=property.desc></span></th></tr></thead><tbody><tr ng-repeat=\"property in vm.propertys\"><td class=col-md-2><input type=checkbox name=chk_list class=chk_list value={{property.propertyId}} ng-click=vm.checkProperty()>&nbsp;&nbsp; <a ui-sref=dvmSproperty.edit({propertyId:property.propertyId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteProperty(property)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td class=col-md-2>{{property.propertyCode}}</td><td class=col-md-2>{{property.propertyName}}</td><td class=col-md-2><select ng-model=property.propertyType disabled><option ng-repeat=\"x in vm.attributeType\" value={{x.value}}>{{x.meaning}}</option></select></td><td class=col-md-2><lookup-select lookup-value=property.syncFlag lookup-type=SYS.YES_NO disable=true></td><td class=col-md-2>{{property.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/updateSkuProperty.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form class=.ng-invalid ng-submit=vm.addProperty()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=property.update></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_propertyCode><span style=\"color: red\">*</span><span translate=property.code></span></label><input type=text class=form-control id=field_propertyCode ng-model=vm.property.propertyCode required readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_propertyName><span style=\"color: red\">*</span><span translate=property.name></span></label><div class=input-group><input type=text class=form-control id=field_propertyName ng-model=vm.property.propertyName required readonly> <span class=input-group-btn><button id=localeBtn_propertyName disabled class=\"btn btn-default\" type=button ng-click=vm.showPropertyName() value=propertyName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=property.type></span></label><lookup-select lookup-value=vm.property.propertyType lookup-type=IOT.DVM_ATTRIBUTE_TYPE readonly></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=property.unit></span></label><select class=form-control ng-model=vm.property.unitId><option ng-repeat=\"x in vm.units\" value={{x.unitId}}>{{x.unitName}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=property.ruleType></span></label><lookup-select lookup-value=vm.property.parameterType lookup-type=IOT.DVM_ATTRIBUTE_RULE_TYPE required></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.rule></span></label><div class=input-group><input type=text class=form-control id=field_parameterRange ng-model=vm.property.parameterRange required readonly translate-attr=\"{placeholder : \'property.separate\'}\"> <span class=input-group-btn><button id=localeBtn_parameterRange disabled class=\"btn btn-default\" type=button ng-click=vm.showParameterRange() value=parameterRange><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.defaultValue></span></label><div class=input-group><input type=text class=form-control id=field_defaultValue ng-model=vm.property.defaultValue readonly> <span class=input-group-btn><button id=localeBtn_defaultValue disabled class=\"btn btn-default\" type=button ng-click=vm.showDefaultValue() value=defaultValue><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=property.desc></span></label><div class=input-group><input type=text class=form-control name=description id=field_desc ng-model=vm.property.description readonly> <span class=input-group-btn><button id=localeBtn disabled class=\"btn btn-default\" type=button ng-click=vm.show() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_cmdCode><span translate=property.cmdCode></span></label><input type=text class=form-control name=description id=field_cmdCode ng-model=vm.property.cmdCode></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_returnCmdCode><span translate=property.returnCmdCode></span></label><input type=text class=form-control name=returnCmdCode id=field_returnCmdCode ng-model=vm.property.returnCmdCode></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_rangeCode><span translate=property.rangeCode></span></label><input type=text class=form-control name=rangeCode id=field_rangeCode ng-model=vm.property.rangeCode></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.controlFlag></span></label><lookup-select lookup-value=vm.property.switchFlag lookup-type=SYS.YES_NO required></lookup-select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.parameter></span></label><input type=text class=form-control ng-model=vm.property.parameter ng-disabled=true></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.parameterValue></span></label><input type=text class=form-control ng-model=vm.property.parameterValue ng-disabled=true></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.propertyCategory></span></label><lookup-select lookup-value=vm.property.propertyCategory lookup-type=IOT.DVM_PROPERTY_CATEGORY ng-disabled=false></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span> <span translate=dvmProduct.syncFlag></span></label><lookup-select lookup-value=vm.property.syncFlag lookup-type=SYS.YES_NO required></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_propertyName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_propertyName type=hidden></div><div class=modal-body id=localeModelBody_propertyName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSurePropertyName()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_parameterRange style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_parameterRange type=hidden></div><div class=modal-body id=localeModelBody_parameterRange></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureParameterRange()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_defaultValue style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_defaultValue type=hidden></div><div class=modal-body id=localeModelBody_defaultValue></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureDefaultValue()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_currentValue style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_currentValue type=hidden></div><div class=modal-body id=localeModelBody_currentValue></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureCurrentValue()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/dvm/html/viewDeviceProperty.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-alert {\n    z-index: 2101;\n  }\n  .sweet-overlay {\n    z-index: 2100;\n  }</style><form name=addForm role=form class=.ng-invalid ng-submit=vm.addProperty()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=property.detail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_propertyCode><span translate=property.code></span></label><input type=text class=form-control id=field_propertyCode ng-model=vm.property.propertyCode readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_propertyName><span translate=property.name></span></label><input type=text class=form-control id=field_propertyName ng-model=vm.property.propertyName readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_propertyType><span translate=property.type></span></label><input type=text class=form-control id=field_propertyType ng-model=vm.property.propertyType readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.ruleType></span></label><input type=text class=form-control ng-model=vm.property.parameterType readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.rule></span></label><input type=text class=form-control ng-model=vm.property.parameterRange readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.defaultValue></span></label><input type=text class=form-control ng-model=vm.property.defaultValue readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.currentValue></span></label><input type=text class=form-control ng-model=vm.property.currentValue readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.unit></span></label><input type=text class=form-control ng-model=vm.property.unitName readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.desc></span></label><input type=text class=form-control ng-model=vm.property.description readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_cmdCode><span translate=property.cmdCode></span></label><input type=text class=form-control id=field_cmdCode ng-model=vm.property.cmdCode readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_returnCmdCode><span translate=property.returnCmdCode></span></label><input type=text class=form-control name=returnCmdCode id=field_returnCmdCode ng-model=vm.property.returnCmdCode readonly></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_rangeCode><span translate=property.rangeCode></span></label><input type=text class=form-control name=rangeCode id=field_rangeCode ng-model=vm.property.rangeCode readonly></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.parameter></span></label><input type=text class=form-control ng-model=vm.property.parameter ng-disabled=true></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.parameterValue></span></label><input type=text class=form-control ng-model=vm.property.parameterValue ng-disabled=true></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=property.controlFlag></span></label><lookup-select lookup-value=vm.property.controlFlag lookup-type=SYS.YES_NO required></lookup-select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/idk/html/addIRule.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.saveRule() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=iRule.addRule></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=iRule.ruleType></span></label><lookup-select lookup-value=vm.irule.ruleType lookup-type=SYS.KEY_RULE_TYPE required></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_maximumLength><span style=color:red>*</span><span translate=iRule.maxLength></span></label><input type=number class=form-control name=code id=field_maximumLength ng-model=vm.irule.maximumLength required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_description><span translate=iRule.description></span></label><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.irule.description readonly> <span class=input-group-btn><button id=localeBtn_description disabled class=\"btn btn-default\" type=button ng-click=vm.showDescription() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/idk/html/addIRuleLine.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addRuleLine() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=iRule.addRuleLine></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_ruleCode><span style=color:red>*</span><span translate=iRule.ruleCode></span></label><input type=text class=form-control name=ruleCode id=field_ruleCode ng-model=vm.iRuleLine.ruleCode required ng-readonly=vm.CodeEditable></div></div><div class=col-md-6><div class=form-controle><label class=control-label for=field_ruleNumber><span style=color:red>*</span><span translate=iRule.ruleNumber></label><input type=number class=form-control name=ruleNumber id=field_ruleNumber ng-model=vm.iRuleLine.ruleNumber required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_ruleLength><span style=color:red>*</span><span translate=iRule.ruleLength></span></label><input type=number class=form-control name=ruleLength id=field_ruleLength ng-model=vm.iRuleLine.ruleLength required></div></div><div class=col-md-6><label class=control-label><span style=color:red>*</span><span translate=iRule.valueRange></span></label><select class=form-control ng-model=vm.iRuleLine.valueRange><option ng-repeat=\"x in vm.valueRange\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=row><div class=col-md-6><label class=control-label for=field_ruleValue><span style=color:red ng-show=\"vm.iRuleLine.valueRange!=\'anyvalue\'\">*</span><span translate=iRule.ruleValue></span></label><input type=text class=form-control name=ruleValue id=field_ruleValue ng-model=vm.iRuleLine.ruleValue ng-required=\"vm.iRuleLine.valueRange!=\'anyvalue\'\" ng-disabled=\"vm.iRuleLine.valueRange==\'anyvalue\'\"></div><div class=col-md-6><label class=control-label><span style=color:red>*</span><span translate=iRule.paddingFlag></span></label><lookup-select lookup-value=vm.iRuleLine.paddingFlag lookup-type=SYS.ID_KEY_RULE_PADDING_FLAG required></lookup-select></div></div><div class=row style=\"margin-top: 10px\"><div class=col-md-6><label class=control-label for=field_description><span translate=iRule.description></span></label><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.iRuleLine.description readonly> <span class=input-group-btn><button id=localeBtn_description disabled class=\"btn btn-default\" type=button ng-click=vm.showDescription() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeDescriptionModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=description type=hidden></div><div class=modal-body id=localeDescriptionModalBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureDescription()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/idk/html/idkey-party-edit.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .control-label {\n    margin-top: 7px;\n  }</style><div class=row><div class=col-lg-12><div class=ibox-title><h5><span translate=userManage.idKeyUser></span></h5></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.save()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: red\">*</span><span translate=userManage.loginName></span></label><div class=col-lg-8><input type=text id=partyAccount name=partyAccount ng-model=vm.party.partyAccount class=form-control ng-hide=vm.party.partyId required> <span ng-hide=!vm.party.partyId style=\"word-break: break-all;white-space: normal;overflow-y: auto\" class=form-control>{{vm.party.partyAccount}}</span></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: red\">*</span><span translate=userManage.name></span></label><div class=col-lg-8><input type=text id=partyName name=partyName ng-model=vm.party.partyName class=form-control required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: red\">*</span><span translate=userManage.type></span></label><div class=col-lg-8><select ng-model=vm.party.partyType class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.referenceSources\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: red\">*</span><span translate=userManage.status></span></label><div class=col-lg-8><select ng-model=vm.party.partyStatus class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.states\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: red\" ng-hide=vm.party.partyId>*</span><span translate=userManage.passwordInit></span></label><div class=col-lg-8><input type=password id=passwordInit name=passwordInit ng-model=vm.party.password class=form-control ng-required=!vm.party.partyId placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" ng-pattern=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/ ></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=\"color: red\" ng-hide=vm.party.partyId>*</span><span translate=userManage.passwordConfirm></span></label><div class=col-lg-8><input type=password ng-blur=vm.validatePwd() id=passwordConfirm name=passwordConfirm ng-model=vm.party.passwordConfirm class=form-control ng-required=!vm.party.partyId placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" ng-pattern=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/ ></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button ng-click=vm.showOrHidePwd() class=\"btn btn-warning\"><span ng-if=vm.showPwdEnabled translate=btnTypeName.showPwd></span> <span ng-if=!vm.showPwdEnabled translate=btnTypeName.hidePwd></span></button> <button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/idk/html/idkey-party.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5><span translate=userManage.idKeyUser></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=userManage.name></span></label><div class=col-lg-6><input type=text id=searchPartyAccount class=form-control ng-model=vm.searchPartyAccount></div><button id=searchBtn class=\"col-lg-3 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.queryPartiesByCondition()></button></div><div class=col-lg-1><div class=\"col-lg-3 pull-right m-t-n-xs\" style=\"margin-top: 0;width: 210%\"><a class=\"btn btn-w-m btn-info\" ui-sref=idkparty.new() translate=btnTypeName.create></a></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=userManage.loginName></span></th><th><span translate=userManage.name></span></th><!--<th><span translate=\"userManage.telephone\"></span></th>\n          <th><span translate=\"userManage.email\"></span></th>--><th><span translate=userManage.type></span></th><!--<th><span translate=\"userManage.role\"></span></th>--><th><span translate=userManage.status></span></th></tr></thead><tbody><tr ng-repeat=\"party in vm.parties\"><td><a ui-sref=idkparty.edit({partyId:party.partyId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteParty(party)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=party.partyAccount></td><td ng-bind=party.partyName></td><!--<td ng-bind=\"party.phoneNumber\"></td>\n          <td ng-bind=\"party.emailAddress\"></td>--><td><select ng-model=party.partyType disabled><option ng-repeat=\"x in vm.referenceSources\" value={{x.value}}>{{x.meaning}}</option></select></td><!--<td>\n            <select ng-model=\"party.roleId\" disabled ng-options=\'x.roleId as x.roleName for x in vm.roles\'></select>\n          </td>--><td><select ng-model=party.partyStatus disabled><option ng-repeat=\"x in vm.states\" value={{x.value}}>{{x.meaning}}</option></select></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/idk/html/irule.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=iRule.ruleList></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=iRule.ruleMaintenance></label><div class=col-lg-8><lookup-select lookup-value=vm.irule.ruleType lookup-type=SYS.KEY_RULE_TYPE></lookup-select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=irule.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><!--<button class=\"btn btn-white\" type=\"reset\" ng-click=\"vm.reset()\"><span translate=\"btnTypeName.reset\"></span></button>--> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 18%\"><span translate=btnTypeName.operation></span></th><th style=\"width: 15%\"><span translate=iRule.ruleType></span></th><th style=\"width: 15%\"><span translate=iRule.maxLength></span></th><th style=\"width: 52%\"><span translate=iRule.description></span></th></tr></thead><tbody><tr ng-repeat=\"rule in vm.result\"><td><a ui-sref=irule.ruleLine({ruleHeaderId:rule.ruleHeaderId})><i class=\"fa fa-desktop text-navy\"><span translate=btnTypeName.check></span></i></a> <a ui-sref=irule.edit({ruleHeaderId:rule.ruleHeaderId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteIrules(rule)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{rule.ruleType}}</td><td>{{rule.maximumLength}}</td><td>{{rule.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/idk/html/iruleLine.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=iRule.genRuleList></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=iRule.ruleCode></span></label><div class=col-lg-8><input type=text ng-model=vm.iRuleLine.ruleCode class=form-control></div><!--<input type=\"text\" ng-model=\"vm.irule.ruleType\" class=\"form-control\">--></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=iRule.description></span></label><div class=col-lg-8><input type=text ng-model=vm.iRuleLine.description class=form-control></div><!--<input type=\"text\" ng-model=\"vm.irule.ruleType\" class=\"form-control\">--></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=irule.ruleLine.add({ruleHeaderId:vm.iRuleLine.ruleHeaderId})><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 10%\"><span translate=btnTypeName.operation></span></th><th style=\"width: 10%\"><span translate=iRule.ruleCode></span></th><th style=\"width: 10%\"><span translate=iRule.ruleNumber></span></th><th style=\"width: 10%\"><span translate=iRule.ruleLength></span></th><th style=\"width: 15%\"><span translate=iRule.valueRange></span></th><th style=\"width: 10%\"><span translate=iRule.ruleValue></span></th><th style=\"width: 15%\"><span translate=iRule.paddingFlag></span></th><th style=\"width: 20%\"><span translate=iRule.description></span></th></tr></thead><tbody><tr ng-repeat=\"rule in vm.result\"><td><a ui-sref=irule.ruleLine.edit({ruleHeaderId:rule.ruleHeaderId,ruleLineId:rule.ruleLineId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteIRuleLine(rule)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{rule.ruleCode}}</td><td>{{rule.ruleNumber}}</td><td>{{rule.ruleLength}}</td><td><select ng-model=rule.valueRange disabled><option ng-repeat=\"valueRange in vm.valueRange\" value={{valueRange.value}}>{{valueRange.meaning}}</option></select></td><td>{{rule.ruleValue}}</td><td>{{rule.paddingFlag}}</td><td>{{rule.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/inm/html/addCommand.html","<form name=addForm role=form ng-submit=vm.add()><div class=modal-header><!--    <alert-error></alert-error>--><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=btnTypeName.create></h4></div><div class=modal-body><div class=row><div class=form-group><div class=col-lg-12><font color=red>*</font><label class=control-label for=field_productCode translate=command.productCode></label><select id=field_productCode class=form-control ng-model=vm.command.productCode name=productCode ng-change=vm.changeProduct() ng-options=\"product.productCode as product.productCode for product in vm.products\" required ng-readonly=vm.isSystem></select><!--            <input type=\"text\" class=\"form-control\" name=\"productId\" id=\"productId\"\n                   ng-model=\"vm.command.productId\" hidden=\"true\"/>--></div></div></div><div class=row><div class=col-lg-12><div class=form-group><font color=red>*</font><label class=control-label for=field_cmdCode translate=command.cmdCode></label><input type=text class=form-control name=cmdCode id=field_cmdCode ng-model=vm.command.cmdCode required></div></div></div><div class=row><div class=col-lg-12><div class=form-group><font color=red>*</font><label class=control-label for=field_hasParam translate=command.hasParam></label><select id=field_hasParam class=form-control ng-model=vm.command.hasParam name=hasParam ng-options=\"hasParam as hasParam for hasParam in vm.hasParam\" required ng-readonly=vm.isSystem></select></div></div></div><div class=row><div class=col-md-12><div class=form-group><label class=control-label for=field_cmdParamTemplate translate=command.cmdParamTemplate></label><textarea id=field_cmdParamTemplate rows=4 type=text class=form-control name=cmdParamTemplate ng-model=vm.command.cmdParamTemplate></textarea></div></div></div><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_cmdDefinition translate=command.cmdDefinition></label><textarea rows=4 type=text class=form-control name=cmdDefinition id=field_cmdDefinition ng-model=vm.command.cmdDefinition required></textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\" translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\" translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/inm/html/addCommandParameter.html","<form name=addForm role=form ng-submit=vm.add()><div class=modal-header><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=btnTypeName.create></h4></div><div class=modal-body><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_ParamName translate=command.paramName></label><input type=text class=form-control name=description id=field_ParamName ng-model=vm.commandParam.paramName required></div></div></div><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_Sequence translate=command.sequence></label><select id=field_Sequence class=form-control ng-model=vm.commandParam.sequence name=sequence ng-change=vm.changeSequence() ng-options=\"sequence as sequence for sequence in vm.sequence\" required ng-readonly=vm.isSystem></select></div></div></div><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_ParamDefinition translate=command.paramDefinition></label><textarea rows=4 type=text class=form-control name=\"\" id=field_ParamDefinition ng-model=vm.commandParam.paramDefinition required></textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\" translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\" translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/inm/html/addCommandSet-dialog.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.add()><div class=modal-header><!--    <alert-error></alert-error>--><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=command.addCmdSet></h4></div><br><br><div class=modal-body><div class=row><div class=col-lg-12><div class=form-group><font color=red>*</font><label class=control-label for=field_cmdCode translate=command.cmdSet></label><input type=text class=form-control name=cmdCode id=field_cmdCode ng-model=vm.commandSet.cmdSetId required ng-disabled=\"vm.commandSet.cmdSetId && vm.edit\"></div></div></div><br><div class=row><div class=form-group><div class=col-lg-12><label class=control-label for=field_cmdSetName><font color=red>*</font><span translate=command.cmdSetName></span></label><div class=input-group><input type=text class=form-control disabled style=\"width:100%;border: 1px solid #c8cacd\" name=cmdSetName id=field_cmdSetName ng-model=vm.commandSet.cmdSetName required> <span class=input-group-btn><button id=cmdSetNameBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'cmdSetName\')\" value=cmdSetName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><br><br><div class=row><div class=col-lg-12><div class=form-group><font color=red>*</font><label class=control-label for=field_cmdCode translate=command.deviceIdentity></label><input type=text class=form-control name=cmdCode id=field_deviceIdentity ng-model=vm.commandSet.deviceIdentity required></div></div></div><br><div class=row><div class=col-lg-12><div class=form-group><font color=red>*</font><label class=control-label for=field_vCmdCode translate=command.voiceCommandCode></label><input type=text class=form-control name=cmdCode id=field_vCmdCode ng-model=vm.commandSet.voiceCommandCode required></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\" translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\" translate=btnTypeName.save></span></button></div></form><div class=\"modal fade\" id=localeModal_cmdSetName style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_cmdSetName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=\"vm.localeSure(\'cmdSetName\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/inm/html/commandDescription-dialog.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate={{vm.title}}></h4></div><br><div class=modal-body><div class=row><div class=col-lg-12><div class=form-group><div class=row><div class=col-lg-6><font color=red>*</font><label class=control-label \\ translate=command.product></label><!--<input type=\"text\" class=\"form-control\" name=\"cmdCode\"\n                     ng-model=\"vm.commandDes.productId\" required/>--><select class=form-control ng-model=vm.commandDes.productId ng-options=\"x.productId as x.productCode for x in vm.products\"><!--<option ng-repeat=\"product in vm.products\" value=\"{{product.productId}}\">{{product.productCode}}</option>--></select></div><div class=col-lg-6><font color=red>*</font><label class=control-label translate=command.mbdVersion></label><input type=text class=form-control name=cmdCode ng-model=vm.commandDes.versionMbd required></div></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><div class=row><div class=col-lg-6><font color=red>*</font><label class=control-label translate=command.connectModeType></label><input type=text class=form-control name=cmdCode ng-model=vm.commandDes.connectModeType required></div><div class=col-lg-6><font color=red>*</font><label class=control-label translate=command.connectModeHWPN></label><input type=text class=form-control name=cmdCode ng-model=vm.commandDes.connectModeHwpn required></div></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><div class=row><div class=col-lg-6><font color=red>*</font><label class=control-label translate=command.connectModeVersion></label><input type=text class=form-control name=cmdCode ng-model=vm.commandDes.connectModeVersion required></div><div class=col-lg-6><font color=red>*</font><label class=control-label translate=command.fileVersion></label><input type=text class=form-control name=cmdCode ng-model=vm.commandDes.versionConfiguration required></div></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><div class=row><div class=col-lg-6><font color=red>*</font><label class=control-label translate=command.configFile></label><textarea rows=4 class=form-control ng-model=vm.commandDes.configurationFile required></textarea></div></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\" translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\" translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/inm/html/commandDescription.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  table td{\n    max-width:200px;\n    word-wrap:break-word;\n    text-overflow:ellipsis;\n    white-space:nowrap;\n    overflow:hidden;\n  }\n  table td:hover{\n    white-space:normal;\n    overflow:auto;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=command.commandDes></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.product></label><div class=col-lg-8><!--<input type=\"text\" ng-model=\"vm.commandDes.productId\" class=\"form-control\">--><select class=form-control ng-model=vm.commandDes.productId><option value=\"\"></option><option ng-repeat=\"product in vm.products\" value={{product.productId}}>{{product.productCode}}</option></select></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.mbdVersion></label><div class=col-lg-8><input type=text ng-model=vm.commandDes.versionMbd class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.connectModeType></label><div class=col-lg-8><input type=text ng-model=vm.commandDes.connectModeType class=form-control></div></div></div><br><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.connectModeHWPN></label><div class=col-lg-8><input type=text ng-model=vm.commandDes.connectModeHwpn class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.connectModeVersion></label><div class=col-lg-8><input type=text ng-model=vm.commandDes.connectModeVersion class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.fileVersion></label><div class=col-lg-8><input type=text ng-model=vm.commandDes.versionConfiguration class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=commandDes.add translate=btnTypeName.create></a></div></div><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteAll() translate=btnTypeName.del></a></div></div><div class=col-lg-3><div class=\"pull-right m-t-n-xs col-lg-offset-2\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset() translate=btnTypeName.reset></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search() translate=btnTypeName.search></button></div></div></div></div></form><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAll()></th><th translate=btnTypeName.operation></th><!--   <th width=\"10%\">CMD ID</th>--><th translate=command.product></th><th translate=command.mbdVersion></th><th translate=command.connectModeType></th><th translate=command.connectModeHWPN></th><th translate=command.connectModeVersion></th><th translate=command.fileVersion></th><th translate=command.configFile></th></tr></thead><tbody><tr ng-repeat=\"commandDes in vm.commandDess\"><!----><td><input type=checkbox name=chk_list class=chk_list value={{commandDes.configurationId}} ng-click=vm.checkCommandDes()></td><td><a ui-sref=commandDes.edit({configurationId:commandDes.configurationId})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a> <a ng-click=vm.deleteCmdDes(commandDes)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><td><select ng-model=commandDes.productId ng-options=\"x.productId as x.productCode for x in vm.products\" disabled><!--<option ng-repeat=\"product in vm.products\" value=\"{{product.productId}}\">{{product.productCode}}</option>--></select></td><td>{{commandDes.versionMbd}}</td><td>{{commandDes.connectModeType}}</td><td>{{commandDes.connectModeHwpn}}</td><td>{{commandDes.connectModeVersion}}</td><td>{{commandDes.versionConfiguration}}</td><td>{{commandDes.configurationFile}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/inm/html/commandMaintenance.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=command.commandMaintenance></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.productCode></label><div class=col-lg-8><input type=text ng-model=vm.command.productCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.cmdCode></label><div class=col-lg-8><input type=text ng-model=vm.command.cmdCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.cmdDefinition></label><div class=col-lg-8><input type=text ng-model=vm.command.cmdDefinition class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=commandMaintenance.add() translate=btnTypeName.create></a></div></div><!--<div class=\"col-lg-2\">--><!--<div class=\"col-lg-8  m-t-n-xs\">--><!--<a class=\"btn btn-w-m btn-info\" ui-sref=\"testCommand()\" translate=\"command.test\"></a>--><!--</div>--><!--</div>--><div class=col-lg-2></div><div class=col-lg-3></div><div class=col-lg-3><div class=\"pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset() translate=btnTypeName.reset></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search() translate=btnTypeName.search></button></div></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th width=15% translate=btnTypeName.operation></th><!--   <th width=\"10%\">CMD ID</th>--><th width=10% translate=command.productCode></th><th width=10% translate=command.cmdCode></th><th width=10% translate=command.hasParam></th><th width=25% translate=command.cmdParamTemplate></th><th width=25% translate=command.cmdDefinition></th></tr></thead><tbody><tr ng-repeat=\"command in vm.result\"><td><a ui-sref=commandParameter({cmdId:command.cmdId})><i class=\"fa fa-desktop text-navy\" translate=btnTypeName.view></i></a> <a ui-sref=commandMaintenance.edit({cmdId:command.cmdId})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a> <a ng-click=vm.delete(command)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><!-- <td>{{command.cmdId}}</td>--><td>{{command.productCode}}</td><td>{{command.cmdCode}}</td><td>{{command.hasParam}}</td><td>{{command.cmdParamTemplate}}</td><td>{{command.cmdDefinition}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/inm/html/commandParameter.html","<div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=command.command></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row style=\"padding: 10px\"><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.productCode></label><div class=col-lg-8><input type=text ng-model=vm.command.productCode class=form-control readonly></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.cmdCode></label><div class=col-lg-8><input type=text ng-model=vm.command.cmdCode class=form-control readonly></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.hasParam></label><div class=col-lg-8><input type=text ng-model=vm.command.hasParam class=form-control readonly></div></div></div><div class=row style=\"padding: 10px\"><!--              <div class=\"col-lg-4\">\n                <label class=\"col-lg-4 control-label\">描述</label>\n                <div class=\"col-lg-8\">\n                  <input type=\"text\" ng-model=\"\" class=\"form-control\" readonly>\n                </div>\n              </div>--><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.cmdDefinition></label><div class=col-lg-8><textarea rows=4 type=text class=form-control name=cmdDefinition id=cmdDefinition ng-model=vm.command.cmdDefinition readonly></textarea></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.cmdParamTemplate></label><div class=col-lg-8><textarea rows=4 type=text class=form-control name=cmdParamTemplate id=cmdParamTemplate ng-model=vm.command.cmdParamTemplate readonly></textarea></div></div></div></div></form></div><div class=hr-line-dashed></div><form class=form-horizontal><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.paramName></label><div class=col-lg-8><input type=text ng-model=vm.commandParam.paramName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.paramDefinition></label><div class=col-lg-8><input type=text ng-model=vm.commandParam.paramDefinition class=form-control></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=commandParameter.add() translate=btnTypeName.create></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset() translate=btnTypeName.reset></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search() translate=btnTypeName.search></button></div></div></div></div></form><div class=hr-line-dashed></div><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th translate=btnTypeName.operation></th><!--         <th>id</th>--><th translate=command.paramName></th><th translate=command.sequence></th><th translate=command.paramDefinition></th></tr></thead><tbody><tr ng-repeat=\"value in vm.result\"><td><a ui-sref=commandParameter.edit({paramId:value.paramId})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i> </a><a ng-click=vm.delete(value)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><!--  <td>{{value.paramId}}</td>--><td>{{value.paramName}}</td><td>{{value.sequence}}</td><td>{{value.paramDefinition}}</td></tr></tbody></table><div class=text-center><item-count page=vm.page total=vm.paramTotalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.paramTotalItems ng-model=vm.page ng-change=vm.search(vm.command)></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/inm/html/commandSet.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=command.cmdSetManager></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.cmdSetName></label><div class=col-lg-8><input type=text ng-model=vm.commandSetQuery.cmdSetName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.deviceIdentity></label><div class=col-lg-8><input type=text ng-model=vm.commandSetQuery.deviceIdentity class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=commandSet.add() translate=btnTypeName.create></a></div></div><div class=col-lg-2><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteCmdSets() translate=btnTypeName.del></a></div></div><div class=col-lg-2></div><div class=col-lg-3><div class=\"pull-right m-t-n-xs col-lg-offset-2\"><!--<button class=\"btn btn-white\" type=\"reset\" ng-click=\"vm.reset()\"--><!--translate=\"btnTypeName.reset\"></button>--> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search() translate=btnTypeName.search></button></div></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllCmdSet()></th><th translate=btnTypeName.operation></th><!--   <th width=\"10%\">CMD ID</th>--><th translate=command.cmdSet></th><th translate=command.cmdSetName></th><th translate=command.voiceCommandCode></th><th translate=command.deviceIdentity></th></tr></thead><tbody><tr ng-repeat=\"commandSet in vm.commandSet\"><!--ng-repeat=\"commandSet in vm.result\"--><td><input type=checkbox name=chk_list class=chk_list value={{commandSet.cmdSetId}} ng-click=vm.checkCmdSet()></td><td><a ui-sref=commandSet.add({cmdSetId:commandSet.cmdSetId})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a> <a ng-click=vm.deleteCmdSet(commandSet)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><!-- <td>{{command.cmdId}}</td>--><td>{{commandSet.cmdSetId}}</td><td>{{commandSet.cmdSetName}}</td><td>{{commandSet.voiceCommandCode}}</td><td>{{commandSet.deviceIdentity}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/inm/html/editCommand.html","<form name=editForm role=form novalidate ng-submit=vm.update()><div class=modal-header><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=btnTypeName.edit></h4></div><div class=modal-body><div class=row><div class=form-group><div class=col-lg-12><font color=red>*</font><label class=control-label for=field_productCode translate=command.productCode></label><select id=field_productCode class=form-control ng-model=vm.command.productCode name=productCode ng-change=vm.changeProduct() ng-options=\"product.productCode as product.productCode for product in vm.products\" required ng-readonly=vm.isSystem></select></div></div></div><div class=row><div class=col-lg-12><div class=form-group><font color=red>*</font><label class=control-label for=field_cmdCode translate=command.cmdCode></label><input type=text class=form-control name=cmdCode id=field_cmdCode ng-model=vm.command.cmdCode required ng-readonly=true></div></div></div><div class=row><div class=col-lg-12><div class=form-group><font color=red>*</font><label class=control-label for=field_hasParam translate=command.hasParam></label><select id=field_hasParam class=form-control ng-model=vm.command.hasParam name=hasParam ng-options=\"hasParam as hasParam for hasParam in vm.hasParam\" required ng-readonly=vm.isSystem></select></div></div></div><div class=row><div class=col-md-12><div class=form-group><label class=control-label for=field_cmdParamTemplate translate=command.cmdParamTemplate></label><textarea id=field_cmdParamTemplate rows=4 type=text class=form-control name=cmdParamTemplate ng-model=vm.command.cmdParamTemplate></textarea></div></div></div><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_cmdDefinition translate=command.cmdDefinition></label><textarea rows=4 type=text class=form-control name=cmdDefinition id=field_cmdDefinition ng-model=vm.command.cmdDefinition required></textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\" translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\" translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/inm/html/editCommandParameter.html","<form name=editForm role=form novalidate ng-submit=vm.update()><div class=modal-header><div class=\"alert alert-danger\" ng-show=vm.addError><span>{{vm.errorMsg}}</span></div><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=btnTypeName.edit></h4></div><div class=modal-body><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_ParamName translate=command.paramName></label><input type=text class=form-control name=paramName id=field_ParamName ng-model=vm.commandParam.paramName required readonly></div></div></div><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_Sequence translate=command.sequence></label><select id=field_Sequence class=form-control ng-model=vm.commandParam.sequence name=sequence ng-change=vm.changeSequence() ng-options=\"sequence as sequence for sequence in vm.sequence\" required ng-readonly=vm.isSystem></select></div></div></div><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_ParamDefinition translate=command.paramDefinition></label><textarea rows=4 type=text class=form-control name=paramDefinition id=field_ParamDefinition ng-model=vm.commandParam.paramDefinition required></textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\" translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\" translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/inm/html/testCommand.html","<style type=text/css>.jsonformatter{\n  height: 524px;\n}\ntextarea.jsonformatter-textarea {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n\n  background-color: white;\n  resize: none;\n}\ntextarea.jsonformatter-textarea-rignt {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  resize: none;\n}\ndiv.jsoneditor-frame {\n  color: #1A1A1A;\n  border: 1px solid #C1C1C1;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  position: relative;\n  padding: 0;\n}\ndiv.jsoneditor-menu {\n  background-color: #00a0e9;\n  width: 100%;\n  height: 35px;\n  padding: 10px;\n  margin: 0;\n  overflow: hidden;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: #1A1A1A;\n  border-bottom: 1px solid #C1C1C1;\n}\ndiv.jsonformatter-content {\n  width: 100%;\n  height: 100%;\n  margin: -35px 0 0 0;\n  padding: 35px 0 0 0;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  overflow: hidden;\n}</style><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=command.commandTest></h5></div><div class=row><div class=col-lg-3><select class=form-control ng-model=vm.direction name=direction ng-change=vm.selectDirection()><option translate=command.toDevice value=toDevice></option><option translate=command.toApplication value=toApplication></option></select></div></div><div><form class=form-horizontal><div class=form-group><div id=content-wrapper class=row style=\"padding: 10px; height:600px\"><div id=jsonformatter class=\"col-lg-5 jsonformatter\"><div class=jsoneditor-frame><div class=jsoneditor-menu>{{vm.leftTitle}} <button type=button class=\"col-lg-2 close\" data-dismiss=modal aria-hidden=true ng-click=vm.leftClear() style=\"font-size: 13px\" translate=command.clear></button></div><div class=jsonformatter-content><textarea class=jsonformatter-textarea ng-model=vm.left></textarea></div></div></div><div id=splitter class=col-lg-1><br><br><br><br><br><br><!--                   <span>\n                        <a class=\"navbar-minimalize minimalize-styl-2 btn btn-primary \" href=\"\" ng-click=\"vm.to_device(vm.application)\">\n                          <i class=\"fa fa-arrow-right\" ></i>\n                        </a>\n                   </span>--><br><br><br><br><br><span><a class=\"navbar-minimalize minimalize-styl-2 btn btn-primary\" href=\"\" ng-click=vm.translated(vm.left)><i class=\"fa fa-arrow-right\"></i></a></span></div><div id=jsoneditor class=\"col-lg-5 jsonformatter\"><div class=jsoneditor-frame><div class=jsoneditor-menu>{{vm.rightTitle}} <button type=button class=\"col-lg-2 close\" data-dismiss=modal aria-hidden=true ng-click=vm.rightClear() style=\"font-size: 13px\">清除内容</button></div><div class=jsonformatter-content><textarea class=jsonformatter-textarea-rignt ng-model=vm.right readonly disabled></textarea></div></div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/login/html/login.html","<div class=login-bg><div class=\"middle-box text-center loginscreen animated fadeInDown\" style=\"margin-left: 36%\"><div class=row><div class=\"col-md-10 col-md-offset-1\" style=\"margin-top: 10%\"><div><h1 class=logo-name></h1></div><h3>KOHLER</h3><p></p><p><span translate=login.login></span></p><!--<div class=\"alert alert-danger\" ng-show=\"vm.loginFlag\">\n          <strong><span translate=\"login.loading\"></span></strong>\n        </div>--><div class=m-t ng-show=vm.returnMainPage><button type=submit class=\"btn btn-primary block full-width m-b\" ng-click=vm.login()><span translate=login.returnMainPage></span></button></div><div class=m-t ng-show=vm.loginFlag><button type=submit class=\"btn btn-primary block full-width m-b\" ng-click=vm.login()><span translate=login.loginBtn></span></button></div><!--<div class=\"alert alert-danger\" ng-show=\"vm.authenticationCaptchaError\">\n          <strong><span translate=\"login.loginFailed\"></span></strong> <span translate=\"login.loginFailCaptchaMsg\"></span>\n        </div>\n        <div class=\"alert alert-danger\" ng-show=\"vm.authenticationUserDisableError\">\n          <strong><span translate=\"login.loginFailed\"></span></strong> <span translate=\"login.loginFailUserDisableMsg\"></span>\n        </div>--><!--<form role=\"form\" ng-submit=\"vm.login($event)\">\n\n\n          <select class=\"form-control\"ng-model=\"vm.describe\">\n            <option value=\"1\">AAD登录</option>\n            <option value=\"2\">无</option>\n          </select>\n          <div class=\"input-group m-t\">\n          <span class=\"input-group-addon\">\n            <i class=\"glyphicon glyphicon-user\"></i>\n          </span>\n            <input type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"Username\" required ng-model=\"vm.username\"\n                   oninvalid=\"onInvalid(this)\" oninput=\"noInvalid(this)\">\n          </div>\n          <div class=\"input-group m-t\">\n          <span class=\"input-group-addon\">\n            <i class=\"glyphicon glyphicon-lock\"></i>\n          </span>\n            <input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"Password\" required ng-model=\"vm.password\"\n                   oninvalid=\"onInvalid(this)\" oninput=\"noInvalid(this)\">\n          </div>\n\n          <div class=\"m-t\">\n            <button type=\"submit\" class=\"btn btn-primary block full-width m-b\"><span translate=\"login.loginBtn\"></span></button>\n          </div>\n&lt;!&ndash;          <a ui-sref=\"forgot_password\">\n            <small>Forgot password?</small>\n          </a>&ndash;&gt;\n        </form>--></div></div></div><div class=\"row text-center m-t\"><p class=m-t><font color=white><small>KOHLER &copy; 2017</small> &nbsp;&nbsp; <a target=_blank style=\"color: #fff\" href=https://beian.miit.gov.cn>沪ICP备05026969号-3</a></font></p></div></div><!--<div class=\"login-foot\"></div>--><script></script>");
$templateCache.put("app/iot/portal/admin/login/html/login3.html","<div class=login-bg><div class=\"middle-box text-center loginscreen animated fadeInDown\" style=\"margin-left: 36%\"><div class=row><div class=\"col-md-10 col-md-offset-1\"><div><h1 class=logo-name></h1></div><h3>KOHLER</h3><p></p><p><span translate=login.login></span></p><div class=\"alert alert-danger\" ng-show=vm.authenticationError><strong><span translate=login.loginFailed></span></strong> <span translate=login.loginFailMsg></span></div><div class=\"alert alert-danger\" ng-show=vm.authenticationUserDisableError><strong><span translate=login.loginFailed></span></strong> <span translate=login.loginFailUserDisableMsg></span></div><form role=form ng-submit=vm.login($event)><div class=\"input-group m-t\"><span class=input-group-addon><i class=\"glyphicon glyphicon-user\"></i> </span><input type=text class=form-control id=name placeholder=Username required ng-model=vm.username oninvalid=onInvalid(this) oninput=noInvalid(this)></div><div class=\"input-group m-t\"><span class=input-group-addon><i class=\"glyphicon glyphicon-lock\"></i> </span><input type=password class=form-control id=password placeholder=Password required ng-model=vm.password oninvalid=onInvalid(this) oninput=noInvalid(this)></div><div class=\"input-group m-t\"><!--\n                        <select  ng-model=\"vm.selectType\" ng-options=\"item.value for item in vm.languageType\" ng-change=\"vm.changeLanguage()\"></select>\n            --><select ng-model=vm.selectType ng-change=vm.changeLanguage()><option ng-repeat=\"x in vm.languageType\" value={{x.type}}>{{x.value}}</option></select><span><input type=checkbox ng-model=vm.isSelected>&nbsp;&nbsp;<span translate=login.rememberPassword></span></span></div><div class=m-t><button type=submit class=\"btn btn-primary block full-width m-b\"><span translate=login.loginBtn></span></button></div><!--          <a ui-sref=\"forgot_password\">\n                      <small>Forgot password?</small>\n                    </a>--></form></div></div></div><div class=\"row text-center m-t\"><p class=m-t><font color=white><small>KOHLER &copy; 2017</small></font></p></div></div><!--<div class=\"login-foot\"></div>--><script>function onInvalid(input){\n        var id = input.id;\n        var lang = window.localStorage.lang;\n        if(!input.value){\n            if(lang == \'en_GB\'){\n                document.getElementById(id).setCustomValidity(\'Please enter this field\');\n            } else if(lang == \'zh_CN\') {\n                document.getElementById(id).setCustomValidity(\'请填写此字段\');\n            } else if(lang == \'ko_KR\') {\n                document.getElementById(id).setCustomValidity(\'이 필드를 작성해 주세요\');\n            } else if(lang == \'th_TH\') {\n                document.getElementById(id).setCustomValidity(\'กรุณากรอกข้อมูลลงในฟิลด์นี้\');\n            } else if(lang == \'zh_HK\') {\n                document.getElementById(id).setCustomValidity(\'請填寫此欄位\');\n            }\n        }\n    }\n\n    function noInvalid(input){\n        var id = input.id;\n        document.getElementById(id).setCustomValidity(\'\');\n    }</script>");
$templateCache.put("app/iot/portal/admin/login/html/mainPage.html","<div class=login-bg><div class=\"middle-box text-center loginscreen animated fadeInDown\" style=\"margin-left: 36%\"><div class=row><div class=\"col-md-10 col-md-offset-1\" style=\"margin-top: 10%\"><div><h1 class=logo-name></h1></div><h3>KOHLER</h3><p></p><p><span translate=login.login></span></p><div class=\"alert alert-danger\" ng-show=vm.authenticationError><strong><span translate=login.loginFailed></span></strong> <span translate=login.loginFailServerErrorMsg></span></div><div class=\"alert alert-danger\" ng-show=vm.invalidRequestError><strong><span translate=login.loginFailed></span></strong> <span translate=login.invalidRequestError></span></div><div class=\"alert alert-danger\" ng-show=vm.invalidUserError><strong><span translate=login.loginFailed></span></strong> <span translate=login.invalidUserError></span></div><div class=m-t><button type=submit class=\"btn btn-primary block full-width m-b\" ng-click=vm.login()><span translate=login.loginBtn></span></button></div><!--<div class=\"alert alert-danger\" ng-show=\"vm.authenticationCaptchaError\">\n          <strong><span translate=\"login.loginFailed\"></span></strong> <span translate=\"login.loginFailCaptchaMsg\"></span>\n        </div>\n        <div class=\"alert alert-danger\" ng-show=\"vm.authenticationUserDisableError\">\n          <strong><span translate=\"login.loginFailed\"></span></strong> <span translate=\"login.loginFailUserDisableMsg\"></span>\n        </div>--><!--<form role=\"form\" ng-submit=\"vm.login($event)\">\n\n\n          <select class=\"form-control\"ng-model=\"vm.describe\">\n            <option value=\"1\">AAD登录</option>\n            <option value=\"2\">无</option>\n          </select>\n          <div class=\"input-group m-t\">\n          <span class=\"input-group-addon\">\n            <i class=\"glyphicon glyphicon-user\"></i>\n          </span>\n            <input type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"Username\" required ng-model=\"vm.username\"\n                   oninvalid=\"onInvalid(this)\" oninput=\"noInvalid(this)\">\n          </div>\n          <div class=\"input-group m-t\">\n          <span class=\"input-group-addon\">\n            <i class=\"glyphicon glyphicon-lock\"></i>\n          </span>\n            <input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"Password\" required ng-model=\"vm.password\"\n                   oninvalid=\"onInvalid(this)\" oninput=\"noInvalid(this)\">\n          </div>\n\n          <div class=\"m-t\">\n            <button type=\"submit\" class=\"btn btn-primary block full-width m-b\"><span translate=\"login.loginBtn\"></span></button>\n          </div>\n&lt;!&ndash;          <a ui-sref=\"forgot_password\">\n            <small>Forgot password?</small>\n          </a>&ndash;&gt;\n        </form>--></div></div></div><div class=\"row text-center m-t\"><p class=m-t><font color=white><small>KOHLER &copy; 2017</small> &nbsp;&nbsp; <a target=_blank style=\"color: #fff\" href=https://beian.miit.gov.cn>沪ICP备05026969号-3</a></font></p></div></div><!--<div class=\"login-foot\"></div>--><script>function onInvalid(input) {\n    var id = input.id;\n    var lang = window.localStorage.lang;\n    if (!input.value) {\n      if (lang == \'en_GB\') {\n        document.getElementById(id).setCustomValidity(\'Please enter this field\');\n      } else if (lang == \'zh_CN\') {\n        document.getElementById(id).setCustomValidity(\'请填写此字段\');\n      } else if (lang == \'ko_KR\') {\n        document.getElementById(id).setCustomValidity(\'이 필드를 작성해 주세요\');\n      } else if (lang == \'th_TH\') {\n        document.getElementById(id).setCustomValidity(\'กรุณากรอกข้อมูลลงในฟิลด์นี้\');\n      } else if (lang == \'zh_HK\') {\n        document.getElementById(id).setCustomValidity(\'請填寫此欄位\');\n      }\n    }\n  }\n\n  function noInvalid(input) {\n    var id = input.id;\n    document.getElementById(id).setCustomValidity(\'\');\n  }</script>");
$templateCache.put("app/iot/portal/admin/main/html/main.html","<div class=row><alert-error></alert-error></div><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=main.home></span></h5></div><div class=ibox-content><div class=row><div id=eContainerTotal class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie1 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie2 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie3 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie4 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie5 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie6 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie7 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie8 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ml/html/addmlaction.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addSku() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=ml.actionDetail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=ml.commandCode></span></label><input type=text class=form-control ng-model=vm.sku.commandCode required ng-disabled=vm.sku.actionId></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=ml.sequence></span></label><input type=number class=form-control ng-model=vm.sku.commandSequence required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=ml.commandParam></span></label><input type=text class=form-control ng-model=vm.sku.commandParam></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=ml.commandValue></span></label><input type=text class=form-control ng-model=vm.sku.commandParamValue></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=dvmSku.desc></span></label><input type=text class=form-control name=desc ng-model=vm.sku.description></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/ml/html/addmlattribute.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=ml.chooseProperty></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-6><label class=\"col-md-6 control-label\" style=padding-top:5px><span translate=ml.propertyCode></span></label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.property.propertyCode class=form-control></div></div><div class=col-md-6><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.searchProperty()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProperty()></th><th><span translate=ml.propertyCode></span></th><th><span translate=ml.propertyName></span></th></tr></thead><tbody><tr ng-repeat=\"property in vm.properties\"><td><input type=checkbox name=chk_list_add class=chk_list value={{property.propertyId}} ng-click=vm.checkProperty()></td><td>{{property.propertyCode}}</td><td>{{property.propertyName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveProperty()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button></div></div></div>");
$templateCache.put("app/iot/portal/admin/ml/html/addmlproduct.html","<div class=ibox-content><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=ml.chooseProduct></span></h4></div><div class=modal-body><form><div class=row><div class=col-md-6><label class=\"col-md-6 control-label\" style=padding-top:5px><span translate=ml.productCode></span></label><div class=\"col-md-6 input-group date\"><input type=text ng-model=vm.property.propertyCode class=form-control></div></div><div class=col-md-6><input type=submit class=\"btn btn-w-m btn-primary\" translate-attr=\"{value : \'btnTypeName.search\'}\" ng-click=vm.searchProperty()></div></div></form><div class=row><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProperty()></th><th><span translate=ml.productCode></span></th><th><span translate=ml.productName></span></th></tr></thead><tbody><tr ng-repeat=\"property in vm.properties\"><td><input type=checkbox name=chk_list_add class=chk_list value={{property.productId}} ng-click=vm.checkProperty()></td><td>{{property.productCode}}</td><td>{{property.productName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.saveProperty()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button></div></div></div>");
$templateCache.put("app/iot/portal/admin/ml/html/mlattributeaction.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=ml.attributeAction></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=ml.commandCode></span></label><div class=col-lg-8><input type=text ng-model=vm.property.commandCode class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deletePropertys()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=mlaction.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetProperty()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProperty()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=ml.sequence></span></th><th><span translate=ml.commandCode></span></th><th><span translate=ml.commandParam></span></th><th><span translate=ml.commandValue></span></th><th><span translate=property.desc></span></th></tr></thead><tbody><tr ng-repeat=\"property in vm.propertys\"><td><input type=checkbox name=chk_list class=chk_list value={{property.actionId}} ng-click=vm.checkProperty()>&nbsp;&nbsp; <a ui-sref=mlaction.edit({actionId:property.actionId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteProperty(property)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{property.commandSequence}}</td><td>{{property.commandCode}}</td><td>{{property.commandParam}}</td><td>{{property.commandParamValue}}</td><td>{{property.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ml/html/mlproduct.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=ml.product></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.name></span></label><div class=col-lg-8><input type=text ng-model=vm.product.productName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=dvmProduct.category></span></label><div class=col-lg-8><lookup-select lookup-value=vm.product.referenceSource lookup-type=IOT.DVM.COM_PRODUCT_TYPE></lookup-select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteProducts()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=mlproduct.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetProduct()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProduct()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=dvmProduct.name></span></th><th><span translate=dvmProduct.category></span></th><th><span translate=dvmProduct.desc></span></th></tr></thead><tbody><tr ng-repeat=\"product in vm.products\"><td><input type=checkbox name=chk_list class=chk_list value={{product.productId}} ng-click=vm.checkProduct()>&nbsp;&nbsp;<!--<a ui-sref=\"mlproduct.edit({productId:product.productId})\"><i class=\"fa fa-edit text-navy\"><span translate=\"btnTypeName.edit\"></span></i></a>--> <a ui-sref=mlattribute({productId:product.productId})><i class=\"fa fa-desktop text-navy\"><span translate=btnTypeName.check></span></i></a> <a ng-click=vm.deleteProduct(product)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{product.productName}}</td><td>{{product.referenceSource}}</td><td>{{product.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ml/html/mlproductattribute.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=ml.attribute></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=property.code></span></label><div class=col-lg-8><input type=text ng-model=vm.property.productPropertyCode class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=property.name></span></label><div class=col-lg-8><input type=text ng-model=vm.property.productPropertyName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deletePropertys()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=mlattribute.add({propertyId:property.propertyId})><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetProperty()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProperty()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=property.code></span></th><th><span translate=property.name></span></th><th><span translate=ml.commandCode></span></th><th><span translate=ml.commandParam></span></th><th><span translate=ml.commandValue></span></th><th><span translate=property.desc></span></th></tr></thead><tbody><tr ng-repeat=\"property in vm.propertys\"><td><input type=checkbox name=chk_list class=chk_list value={{property.attributeId}} ng-click=vm.checkProperty()>&nbsp;&nbsp;<!--<a ui-sref=\"dvmPproperty.edit({propertyId:property.propertyId})\"><i class=\"fa fa-edit text-navy\"><span translate=\"btnTypeName.edit\"></span></i></a>--> <a ui-sref=mlaction({attributeId:property.attributeId})><i class=\"fa fa-desktop text-navy\"><span translate=btnTypeName.check></span></i></a> <a ng-click=vm.deleteProperty(property)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{property.productPropertyCode}}</td><td>{{property.productPropertyName}}</td><td>{{property.commandCode}}</td><td>{{property.commandParam}}</td><td>{{property.commandParamValue}}</td><td>{{property.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ogm/html/addGroup.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.saveGroup()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=group.addGroup></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_groupName><span style=color:red>*</span> <span translate=group.groupName></span></label><div class=input-group><input type=text class=form-control name=groupName id=field_groupName ng-model=vm.group.groupName readonly required> <span class=input-group-btn><button id=localeBtn_groupName disabled class=\"btn btn-default\" type=button ng-click=vm.showGroupName() value=groupName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_description><span translate=group.description></span></label><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.group.description readonly> <span class=input-group-btn><button id=localeBtn_description disabled class=\"btn btn-default\" type=button ng-click=vm.showDescription() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.group.groupName.trim() == \'\'\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModalGroupName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldNameGroupName type=hidden></div><div class=modal-body id=localeModelBodyGroupName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureGroupName()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/ogm/html/group-dialog.html","<div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=title.chooseData></h4></div><div class=modal-body><form><div class=form-group><div class=row><div class=col-lg-8><label class=\"col-lg-3 control-label\" translate=group.groupName></label><div class=col-lg-6><input type=text ng-model=vm.searchGroupName class=form-control></div><button id=searchBtn class=\"col-lg-3 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.loadAll()></button></div></div></div></form><div class=table-responsive><table class=\"table table-striped\" width=70%><thead><tr><th translate=btnTypeName.choose></th><th translate=group.groupName></th></tr></thead><tbody><tr><td><input type=radio ng-model=$parent.vm.selectedGroup name=groupDialog ng-value=\"\"></td></tr><tr ng-repeat=\"group in vm.groups\"><td><input type=radio ng-model=$parent.vm.selectedGroup name=groupDialog ng-value=group></td><td>{{group.groupName}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.save()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.okay></span></button></div>");
$templateCache.put("app/iot/portal/admin/ogm/html/group.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=group.groupMaintenance></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\" for=field_groupName><span translate=group.groupName></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.group.groupName id=field_groupName></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=groupHeader.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 20%\"><span translate=btnTypeName.operation></span></th><th style=\"width: 35%\"><span translate=group.groupName></span></th><th style=\"width: 35%\"><span translate=group.description></span></th></tr></thead><tbody><tr ng-repeat=\"group in vm.result\"><td><a ui-sref=groupHeader.edit({groupId:group.groupId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.remove(group)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{group.groupName}}</td><td>{{group.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/permission/html/permission-dialog.html","<style>#toast-container{\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.save()><div class=modal-header><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate={{vm.title}}></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_displayName><font color=red>*</font><span translate=permission.displayName></span></label><input type=text class=form-control name=displayName id=field_displayName ng-model=vm.permission.displayName ng-disabled=vm.isView required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_enable><font color=red>*</font><span translate=permission.enable></span></label><select ng-model=vm.permission.enable name=enable id=field_enable class=form-control ng-disabled=vm.isView required><option ng-repeat=\"x in vm.flagList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_path><font color=red>*</font><span translate=permission.path></span></label><input type=text class=form-control name=path id=field_path ng-model=vm.permission.path ng-disabled=\"vm.isView || vm.isEdit && !vm.isCustom\" required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_method><font color=red>*</font><span translate=permission.method></span></label><input type=text class=form-control name=method id=field_method ng-model=vm.permission.method ng-disabled=\"vm.isView || vm.isEdit && !vm.isCustom\" placeholder=GET,POST,PUT,DELETE,ALL required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_location><font color=red>*</font><span translate=permission.location></span></label><input type=text class=form-control name=location id=field_location ng-model=vm.permission.location ng-disabled=\"vm.isView || vm.isEdit && !vm.isCustom\" required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_description><span translate=permission.description></span></label><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.permission.description readonly> <span class=input-group-btn><button id=descriptionBtn disabled class=\"btn btn-default\" type=button ng-click=\"vm.showLocale(\'description\')\" value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_resource><font color=red>*</font><span translate=permission.resource></span></label><input type=text class=form-control name=resource id=field_resource ng-model=vm.permission.resource ng-disabled=vm.isView required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_action><font color=red>*</font><span translate=permission.action></span></label><input type=text class=form-control name=action id=field_action ng-model=vm.permission.action ng-disabled=vm.isView required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_level><font color=red>*</font><span translate=permission.level></span></label><select ng-model=vm.permission.level name=level id=field_level class=form-control ng-disabled=vm.isView required><option ng-repeat=\"x in vm.levelList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_isPublic><font color=red>*</font><span translate=permission.isPublic></span></label><select ng-model=vm.permission.isPublic name=isPublic id=field_isPublic class=form-control ng-disabled=vm.isView required><option ng-repeat=\"x in vm.flagList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_userLogin><font color=red>*</font><span translate=permission.userLogin></span></label><select ng-model=vm.permission.userLogin name=userLogin id=field_userLogin class=form-control ng-disabled=vm.isView required><option ng-repeat=\"x in vm.flagList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_clientLogin><font color=red>*</font><span translate=permission.clientLogin></span></label><select ng-model=vm.permission.clientLogin name=clientLogin id=field_clientLogin class=form-control ng-disabled=vm.isView required><option ng-repeat=\"x in vm.flagList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-hide=vm.isView ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModelBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-hide=vm.isView ng-click=\"vm.localeSure(\'description\')\"><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/permission/html/permission-reload-dialog.html","<style>#toast-container{\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=reloadForm role=form novalidate ng-submit=vm.save()><div class=modal-header><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate={{vm.title}}></span></h4></div><br><div class=modal-body><div class=form-group><div class=row><div class=col-lg-10><div class=col-lg-5><label class=control-label style=margin-top:7px for=field_override><span translate=permission.overridePermissionTip></span></label></div><div class=col-lg-7><select ng-model=vm.scope.override name=override id=field_override class=form-control required><option ng-repeat=\"x in vm.flagList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"reloadForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/permission/html/permission.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .fontred {\n    color: red;\n  }</style><div><div class=ibox-title><h5><span translate=permission.permissionManage></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.displayName></span></label><div class=col-lg-8><input type=text id=displayName class=form-control ng-model=vm.condition.displayName></div></div><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.service></span></label><div class=col-lg-8><select ng-model=vm.condition.service id=service class=form-control required><option ng-repeat=\"x in vm.serviceList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.resource></span></label><div class=col-lg-8><input type=text id=resource class=form-control ng-model=vm.condition.resource></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.level></span></label><div class=col-lg-8><select ng-model=vm.condition.level id=level class=form-control><option></option><option ng-repeat=\"x in vm.levelList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.path></span></label><div class=col-lg-8><input type=text id=path class=form-control ng-model=vm.condition.path></div></div></div><br></div><div class=form-group><div class=row><div class=col-lg-6><div class=\"col-lg-10 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" type=button ng-click=vm.addPermission()><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ui-sref=permissionScope><span translate=permission.permissionScope></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ui-sref=rolePermission><span translate=permission.permissionAssignment></span></button></div></div><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th translate=btnTypeName.operation></th><th><span translate=permission.displayName></span></th><th><span translate=permission.description></span></th><th><span translate=permission.resource></span></th><th><span translate=permission.action></span></th><th><span translate=permission.level></span></th><th><span translate=permission.enable></span></th><th><span translate=permission.isPublic></span></th><th><span translate=permission.isCustom></span></th></tr></thead><tbody><tr ng-repeat=\"permission in vm.permissions\"><td><a ng-click=vm.editPermission(permission)><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deletePermission(permission)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=permission.displayName ng-class=\"{fontred:permission.isDelete==\'Y\'}\"></td><td ng-bind=permission.description></td><td ng-bind=permission.resource></td><td ng-bind=permission.action></td><td><select ng-model=permission.level disabled><option ng-repeat=\"x in vm.levelList\" value={{x.value}}>{{x.meaning}}</option></select></td><td ng-bind=permission.enable></td><td ng-bind=permission.isPublic></td><td ng-bind=permission.isCustom></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/permission/html/permissionScope-dialog.html","<style>#toast-container{\n    z-index: 99999;\n  }\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=editForm role=form novalidate ng-submit=vm.save()><div class=modal-header><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate={{vm.title}}></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_path><font color=red>*</font><span translate=permission.codePath></span></label><input type=text class=form-control name=path id=field_path ng-model=vm.scope.path required></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_type><font color=red>*</font><span translate=permission.type></span></label><select ng-model=vm.scope.type name=type id=field_type class=form-control required><option ng-repeat=\"x in vm.typeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_ignore><span translate=permission.ignore></span></label><input type=text class=form-control name=ignore id=field_ignore ng-model=vm.scope.ignore placeholder=\"{{\'permission.ignoreTip\' | T}}\"></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/permission/html/permissionScope.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5><span translate=permission.permissionScope></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=permission.service></span></label><div class=col-lg-6><select ng-model=vm.condition.service id=service class=form-control required><option ng-repeat=\"x in vm.serviceList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=permission.type></span></label><div class=col-lg-6><select ng-model=vm.condition.type id=type class=form-control><option></option><option ng-repeat=\"x in vm.typeList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div><br></div><div class=form-group><div class=row><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" type=button ng-click=vm.addScope()><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.reloadPermission()><span translate=permission.scanPermission></span></button></div></div><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllItems()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=permission.codePath></span></th><th><span translate=permission.type></span></th><th><span translate=permission.ignore></span></th></tr></thead><tbody><tr ng-repeat=\"scope in vm.scopes\"><td><input type=checkbox name=chk_list class=chk_list value={{scope.id}} ng-click=vm.checkItem()>&nbsp;&nbsp; <a ng-click=vm.editScope(scope)><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteScope(scope)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=scope.path></td><td><select ng-model=scope.type disabled><option ng-repeat=\"x in vm.typeList\" value={{x.value}}>{{x.meaning}}</option></select></td><td ng-bind=scope.ignore></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/permission/html/resourcePermission-dialog.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div class=modal-header><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=permission.choosePermission></span></h4></div><div class=modal-body><form><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=permission.displayName></span></label><div class=col-lg-8><input type=text id=displayName class=form-control ng-model=vm.condition.displayName></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=permission.service></span></label><div class=col-lg-8><select ng-model=vm.condition.service id=service class=form-control><option></option><option ng-repeat=\"x in vm.serviceList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=permission.resource></span></label><div class=col-lg-8><input type=text id=resource class=form-control ng-model=vm.condition.resource></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=permission.level></span></label><div class=col-lg-8><select ng-model=vm.condition.level id=level class=form-control><option></option><option ng-repeat=\"x in vm.levelList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=permission.path></span></label><div class=col-lg-8><input type=text id=path class=form-control ng-model=vm.condition.path></div></div><div class=col-lg-6><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllItems()></th><th><span translate=permission.displayName></span></th><th><span translate=permission.description></span></th><th><span translate=permission.service></span></th><th><span translate=permission.resource></span></th><th><span translate=permission.action></span></th><th><span translate=permission.level></span></th></tr></thead><tbody><tr ng-repeat=\"permission in vm.permissions\"><td><input type=checkbox name=chk_list class=chk_list value={{permission.id}} ng-click=vm.checkItem()></td><td ng-bind=permission.displayName ng-class=\"{fontred:permission.isDelete==\'Y\'}\"></td><td ng-bind=permission.description></td><td ng-bind=permission.service></td><td ng-bind=permission.resource></td><td ng-bind=permission.action></td><td><select ng-model=permission.level disabled><option ng-repeat=\"x in vm.levelList\" value={{x.value}}>{{x.meaning}}</option></select></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span><span translate=btnTypeName.cancel></span></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.save()><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span><span translate=btnTypeName.save></span></span></button></div>");
$templateCache.put("app/iot/portal/admin/permission/html/rolePermission.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .fontred {\n    color: red;\n  }\n  .borderred {\n    border-color: red;\n  }</style><div><div class=ibox-title><h5><span translate=permission.permissionAssignment></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=roleManage.roleName></span></label><div class=col-lg-6><select ng-model=vm.selectRoleId id=roleId class=form-control ng-class=\"{borderred:vm.roleId!==vm.selectRoleId}\" required><option ng-repeat=\"x in vm.roles\" value={{x.roleId}}>{{x.roleName}} ({{x.roleCode}})</option></select></div><div class=col-lg-4><button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.searchRole()><span translate=permission.searchRole></span></button></div></div><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=permission.source></span></label><div class=col-lg-6><select ng-model=vm.selectCopyRoleId id=copyRoleId class=form-control><option></option><option value=sa translate=permission.superAdmin></option><option value=engr translate=permission.engineer></option><option ng-repeat=\"x in vm.roles|filter:vm.validateRole\" value={{x.roleId}}>{{x.roleName}} ({{x.roleCode}})</option><option value=tourist translate=permission.tourist></option><option value=none translate=permission.accessDenied></option></select></div><div class=col-lg-4><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.copyRole()>{{vm.copyRoleTitle}}</button></div></div></div></div></form><hr style=\"border-top:1px silver dashed\"><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.displayName></span></label><div class=col-lg-8><input type=text id=displayName class=form-control ng-model=vm.condition.displayName></div></div><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.service></span></label><div class=col-lg-8><select ng-model=vm.condition.service id=service class=form-control><option ng-repeat=\"x in vm.serviceList|filter:vm.validateService\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.resource></span></label><div class=col-lg-8><input type=text id=resource class=form-control ng-model=vm.condition.resource></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.level></span></label><div class=col-lg-8><select ng-model=vm.condition.level id=level class=form-control><option></option><option ng-repeat=\"x in vm.levelList\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-4><label class=\"col-lg-3 control-label\"><span translate=permission.path></span></label><div class=col-lg-8><input type=text id=path class=form-control ng-model=vm.condition.path></div></div></div><br></div><div class=form-group><div class=row><div class=col-lg-6><div class=\"col-lg-10 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-info\" type=button ng-click=vm.save()><span translate=btnTypeName.save></span></button></div></div><div class=col-lg-5><div class=\"col-lg-9 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=submit ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-checked=vm.allAssigned ng-click=vm.checkAllItems()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=permission.displayName></span></th><th><span translate=permission.description></span></th><th><span translate=permission.resource></span></th><th><span translate=permission.action></span></th><th><span translate=permission.level></span></th><th><span translate=permission.enable></span></th><th><span translate=permission.isPublic></span></th><th><span translate=permission.isCustom></span></th></tr></thead><tbody><tr ng-repeat=\"permission in vm.permissions\"><td><input type=checkbox name=chk_list class=chk_list value={{permission.id}} ng-checked=permission.assigned ng-click=vm.checkItem()>&nbsp;&nbsp; <a ng-click=vm.viewPermission(permission)><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.check></span></i></a></td><td ng-bind=permission.displayName ng-class=\"{fontred:permission.isDelete==\'Y\'}\"></td><td ng-bind=permission.description></td><td ng-bind=permission.resource></td><td ng-bind=permission.action></td><td><select ng-model=permission.level disabled><option ng-repeat=\"x in vm.levelList\" value={{x.value}}>{{x.meaning}}</option></select></td><td ng-bind=permission.enable></td><td ng-bind=permission.isPublic></td><td ng-bind=permission.isCustom></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/product/html/addProductImageCode.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.creatProductImageCode() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=productImage.clear></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=productImage.productImageCode></span></label><input type=text class=form-control name=imageCode id=productImageCode ng-readonly=vm.isEdit ng-model=vm.productImageDto.imageCode></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=dvmProduct.desc></span></label><div class=input-group><input type=text class=form-control name=description id=field_desc ng-model=vm.productImageDto.description></div></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid \" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/product/html/addProductImageInfo.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addProductImageInfo() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=dvmProduct.otherName></span></h4></div><div class=modal-body><div class=row style=\"text-align: center\"><div style=\"text-align: center\"><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 60px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile><div><span translate=title.uploadPicTip></span></div></div></div><hr width=100% size=1 color=#bbbcbc style=\"FILTER: alpha(opacity=100,finishopacity=0)\"><div class=row><div class=\"col-md-offset-4 col-md-4\"><div class=form-group><label class=control-label for=field_otherName><span style=color:red>*</span> <span translate=dvmProduct.name></span></label><div class=input-group><select class=form-control style=width:200px ng-model=vm.productImageInfoDto.productId ng-show=!vm.isEdit required><option ng-repeat=\"x in vm.otherProductList\" value={{x.productId}}>{{x.productName}}</option></select><input type=text class=form-control name=otherNameList id=field_otherName ng-show=vm.isEdit ng-model=vm.productImageInfoDto.productName required readonly></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/product/html/productImageCode.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=productImage.productImageSetting></span></h5></div><div class=ibox-content><form class=\"form-horizontal ng-pristine ng-valid\"><div class=form-group><div class=row><label class=\"col-lg-2 control-label\"><span translate=productImage.productImageCode></span></label><div class=col-lg-4><input type=text ng-model=vm.imageCode class=form-control></div><div class=\"col-lg-2 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=productImageCode.add()><span translate=btnTypeName.create></span></a></div><div class=\"col-lg-2 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=productImage.search></span></button></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=productImage.operation></span></th><th><span translate=productImage.productImageCode></span></th><th><span translate=productImage.description></span></th><th><span translate=productImage.productImageUp></span></th></tr></thead><tbody><tr ng-repeat=\"imageCodeInfo in vm.imageCodeList\"><td><a ui-sref=productImageCode.edit({imageCode:imageCodeInfo.imageCode})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a> <a ng-click=vm.delProductImageCode(imageCodeInfo)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><td>{{imageCodeInfo.imageCode}}</td><td>{{imageCodeInfo.description}}</td><td><a class=\"btn btn-w-m btn-info\" ui-sref=productImageInfo({imageCode:imageCodeInfo.imageCode})><span translate=productImage.editImage></span></a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.pageSize></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/product/html/productImageInfo.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=productImage.productImageSetting></span></h5></div><div class=ibox-content><form class=\"form-horizontal ng-pristine ng-valid\"><div class=form-group><div class=row><label class=\"col-lg-2 control-label\"><span translate=dvmProduct.name></label><div class=col-lg-4><input type=text ng-model=vm.productName class=form-control></div><div class=\"col-lg-2 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=productImageCode()><span translate=productImage.back></span></a></div><div class=\"col-lg-2 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=productImageInfo.add()><span translate=btnTypeName.create></span></a></div><div class=\"col-lg-2 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=productImage.search></span></button></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><span translate=productImage.operation></span></th><th><span translate=dvmProduct.name></span></th><th><span translate=dvmProduct.productImg></span></th></tr></thead><tbody><tr ng-repeat=\"imageInfo in vm.imageInfoList\"><td><a ui-sref=productImageInfo.edit({productImageId:imageInfo.productImageId})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a> <a ng-click=vm.deleteProductImageInfo(imageInfo.productImageId)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><td>{{imageInfo.productName}}</td><td><img style=\"width:40px;height:40px; border-radius:10px\" ngf-src=imageInfo.imageUrl></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.pageSize></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/actionConfig.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=scene.sceneAction></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"control-label col-lg-4\"><span translate=scene.sceneName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.actionConfig.sceneName disabled></div></div><div class=col-lg-4><label class=\"control-label col-lg-4\"><span translate=ml.productType></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.actionConfig.productTypeName disabled></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"control-label col-lg-4\"><span translate=ml.actionName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.actionConfig.actionName></div></div><div class=col-lg-4><label class=\"control-label col-lg-4\"><span translate=ml.actionCode></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.actionConfig.actionCode></div></div><div class=col-lg-4><label class=\"control-label col-lg-4\"><span translate=ml.actionRecommand></span></label><div class=col-lg-8><select ng-model=vm.actionConfig.recommendFlag class=form-control ng-options=\"x.value as x.name for x in vm.recommand\"></select></div></div></div></div><div class=row><div class=\"col-lg-4 col-lg-offset-9\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.getActionConfig()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-primary\" ng-click=vm.reset()><span translate=btnTypeName.reset></span></button></div></div><hr><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-4 col-lg-offset-1\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=actionConfig.add({scenarioProductId:vm.actionConfig.scenarioProductId})><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteActionConfigs()><span translate=btnTypeName.del></span></button></div></div></div></div><div style=\"margin-top: 40px\"><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllActionConfig()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=ml.actionCode></th><th translate=ml.actionName></th><th translate=ml.actionDesc></th><th translate=ml.actionRecommand></th></thead><tbody><tr ng-repeat=\"actionConfig in vm.actionConfigs\"><td style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{actionConfig.scenarioActionId}} ng-click=vm.checkActionConfig()>&nbsp;&nbsp;</td><td style=\"width: 15%\"><a ui-sref=actionParams({scenarioActionId:actionConfig.scenarioActionId})><i class=\"fa fa-sliders text-navy\"><span translate=ml.actionParams ng-click=vm.getProductNameAndConfigName(actionConfig.actionName)></span></i></a> <a ui-sref=actionConfig.edit({scenarioActionId:actionConfig.scenarioActionId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteActionConfig(actionConfig)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=actionConfig.actionCode></td><td ng-bind=actionConfig.actionName></td><td ng-bind=actionConfig.description></td><td>{{actionConfig.recommendFlag==1?(\'appEdition.yes\' | T):(\'appEdition.no\' | T)}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/actionParams.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=ml.paramList></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.productType></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.actionParam.productTypeName disabled></div></div><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.actionName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.actionParam.actionName disabled></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=property.parameterName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.actionParam.paramName></div></div><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.paramCode></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.actionParam.paramCode></div></div><div class=col-lg-4></div></div></div><div class=row><div class=\"col-lg-1 col-lg-offset-6\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.getActionParam()><span translate=btnTypeName.search></span></button></div></div><hr><div class=row><div class=\"col-lg-4 col-lg-offset-1\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=actionParams.add({scenarioActionId:vm.actionParam.scenarioActionId})><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteActionParams()><span translate=btnTypeName.del></span></button></div></div></div></div><div><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllactionParam()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=ml.paramCode></th><th translate=property.parameterName></th><th translate=property.parameterType></th><th translate=property.parameterRange></th><th translate=property.parameterValue></th><th translate=iRule.description></th></thead><tbody><tr ng-repeat=\"actionParam in vm.actionParams\"><td style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{actionParam.actionParamId}} ng-click=vm.checkactionParam()>&nbsp;&nbsp;</td><td style=\"width: 10%\"><a ui-sref=actionParams.edit({actionParamId:actionParam.actionParamId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteActionParam(actionParam)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=actionParam.paramCode></td><td ng-bind=actionParam.paramName></td><td>{{actionParam.paramType==1?(\'dvmProduct.enum\' | T):(\'dvmProduct.numberScope\' | T)}}</td><td ng-bind=actionParam.paramRange></td><td ng-bind=actionParam.defaultValue></td><td ng-bind=actionParam.description></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/addActionConfig.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n\n  #toast-container {\n    z-index: 1100;\n  }\n\n  form {\n    height: 600px;\n  }</style><form name=editForm role=form ng-submit=vm.saveActionConfig()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=ml.actionConfig></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=ml.actionCode></span></label><input type=text ng-model=vm.actionConfig.actionCode class=form-control required></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=ml.actionName></span></label><div class=input-group><input type=text class=form-control name=actionName id=field_actionConfigName ng-model=vm.actionConfig.actionName required readonly> <span class=input-group-btn><button id=localeBtn_actionConfigName disabled class=\"btn btn-default\" type=button ng-click=vm.showActionConfigName() value=actionName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><label class=control-label><span style=\"color: red\">*</span><span translate=ml.actionRecommand></span></label><select ng-model=vm.actionConfig.recommendFlag class=form-control ng-options=\"x.value as x.name for x in vm.recommand\" required></select></div><div class=col-md-6><div class=form-group><label class=control-label for=field_actionConfigDesc><span translate=ml.actionDesc></span></label><div class=input-group><input type=text class=form-control name=actionDesc id=field_actionConfigDesc ng-model=vm.actionConfig.description readonly> <span class=input-group-btn><button id=localeBtn_actionConfigDesc disabled class=\"btn btn-default\" type=button ng-click=vm.showActionConfigDesc() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><div class=\"modal fade\" id=localeModal_actionConfigName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=ml.actionName></span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_actionConfigName type=hidden></div><div class=modal-body id=localeModelBody_actionConfigName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-click=vm.localeSureActionConfigName()><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_actionConfigDesc style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=ml.actionDesc></span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_actionConfigDesc type=hidden></div><div class=modal-body id=localeModelBody_actionConfigDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureActionConfigDesc()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/addActionParams.html","<style>.modal-backdrop {\n        z-index: 1000;\n    }\n    #toast-container {\n        z-index: 1100;\n    }\n  form{\n    height: 600px;\n  }</style><form name=editForm role=form ng-submit=vm.saveactionParams()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=ml.paramDetail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><label class=control-label><span style=color:red>*</span><span translate=ml.paramCode></span></label><input type=text class=form-control ng-model=vm.actionParam.paramCode required></div><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=property.parameterName></span></label><div class=input-group><input type=text class=form-control name=paramName id=field_paramName ng-model=vm.actionParam.paramName required readonly> <span class=input-group-btn><button id=localBtn_paramName disabled class=\"btn btn-default\" type=button ng-click=vm.showParamName() value=paramName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=property.parameterType></span></label><select ng-model=vm.actionParam.paramType ng-options=\"x.value as x.name for x in vm.paramType\" class=form-control required></select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=property.parameterRange></span></label><input type=text class=form-control ng-model=vm.actionParam.paramRange required><!-- <div class=\"input-group\">\n                            <input type=\"text\" class=\"form-control\" id=\"field_paramValue\" ng-model=\"vm.actionParam.paramRange\" required readonly>\n                            <span class=\"input-group-btn\">\n                                <button id=\"localBtn_paramValue\" disabled class=\"btn btn-default\" type=\"button\" ng-click=\"vm.showParamValue()\" value=\"paramRange\"><i class=\"fa fa-globe\"></i></button>\n                            </span>\n                        </div>--></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=property.parameterValue></span></label><input type=text class=form-control ng-model=vm.actionParam.defaultValue required><!--<div class=\"input-group\">\n                            <input type=\"text\" class=\"form-control\" name=\"paramValue\" id=\"field_paramDefaultValue\"\n                                   ng-model=\"vm.actionParam.defaultValue\" required readonly>\n                            <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" id=\"localBtn_paramDefaultValue\" disabled ng-click=\"vm.showParamDefaultValue()\" value=\"defaultValue\"><i class=\"fa fa-globe\"></i></button>\n                        </span>\n                        </div>--></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=sysConfig.description></span></label><div class=input-group><input type=text class=form-control name=paramValue id=field_paramDesc ng-model=vm.actionParam.description readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" id=localBtn_paramDesc disabled ng-click=vm.showParamDesc() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><div class=row><button class=\"btn btn-default\" type=button ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span><span translate=btnTypeName.cancel></span></button> <button class=\"btn btn-primary\" type=submit ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span><span translate=btnTypeName.save></span></button></div></div></form><!--modal action param name--><div class=\"modal fade\" id=localeModal_actionParamName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=property.parameterName></span> <button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>x</span></button> <input type=hidden id=fieldName_actionParamName></div><div class=modal-body id=localeModelBody_actionParamName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureActionParamName()><span translate=btnTypeName.save></span></button></div></div></div></div><!--modal action param value--><div class=\"modal fade\" id=localeModal_actionParamValue style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=btnTypeName.enterSome></span> <button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>x</span></button> <input type=hidden id=fieldName_actionParamValue></div><div class=modal-body id=localeModelBody_actionParamValue></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureActionParamValue()><span translate=btnTypeName.save></span></button></div></div></div></div><!--modal action param default value--><div class=\"modal fade\" id=localeModal_actionParamDefaultValue style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>x</span></button> <input type=hidden id=fieldName_actionParamDefaultValue></div><div class=modal-body id=localeModelBody_actionParamDefaultValue></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureParamDefaultValue()><span translate=btnTypeName.save></span></button></div></div></div></div><!--modal action param descripiton--><div class=\"modal fade\" id=localeModal_actionParamDesc style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=ml.actionDesc></span> <button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>x</span></button> <input type=hidden id=fieldName_actionParamDesc></div><div class=modal-body id=localeModelBody_actionParamDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureActionParamDesc()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/addIntelligentLinkage.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  #toast-container {\n    z-index: 1100;\n  }</style><form name=addForm role=form ng-submit=vm.addLink() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title><span translate=intelligentLinkage.detail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><label class=control-label><span style=color:red>*</span><span translate=intelligentLinkage.code></span></label><input type=text class=form-control ng-model=vm.link.linkCode required ng-readonly=vm.linkCodeReadOnly></div><div class=col-md-6><div class=form-group><label class=control-label for=field_linkName><span style=\"color: red\">*</span><span translate=intelligentLinkage.name></span></label><div class=input-group><input type=text class=form-control name=linkName id=field_linkName ng-model=vm.link.linkName required readonly> <span class=input-group-btn><button id=localeBtn_linkName disabled class=\"btn btn-default\" type=button ng-click=vm.showLinkName() value=linkName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=intelligentLinkage.linkIdentity></span></label><lookup-select lookup-value=vm.link.attribute1 lookup-type=IOT.SCM_LINK_IDENTITY required></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=dvmProduct.desc></span></label><div class=input-group><input type=text class=form-control name=description id=field_desc ng-model=vm.link.description readonly> <span class=input-group-btn><button id=localeBtn disabled class=\"btn btn-default\" type=button ng-click=vm.show() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName type=hidden></div><div class=modal-body id=localeModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSure()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_linkName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_linkName type=hidden></div><div class=modal-body id=localeModelBody_linkName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureLinkName()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/addIntelligentLinkageSettings.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addLinkSetting() style=\"min-height: 500px\"><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title><span translate=intelligentLinkage.detail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=intelligentLinkage.scope></span></label><lookup-select lookup-value=vm.linkSetting.seasonScope lookup-type=IOT.SCM_INTELLIGENT_LINKAGE_SEASON></lookup-select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_desc><span translate=intelligentLinkage.desc></span></label><input type=text class=form-control name=description id=field_desc ng-model=vm.linkSetting.description></div></div></div><div class=row><div class=col-md-12><div class=form-group><label class=control-label for=field_linkJson><span style=color:red>*</span>JSON</label><textarea class=form-control rows=5 name=linkJson id=field_linkJson ng-model=vm.linkSetting.linkJson required></textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/scm/html/addLinkageCondition.html","<style>.modal-backdrop {\n        z-index: 1000;\n    }\n\n    #toast-container {\n        z-index: 1100;\n    }\n  form{\n    height: 600px;\n  }</style><form name=editForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=intelligentLinkage.linkSetting></span></h4></div><div class=modal-body><div class=row style=\"text-align: center\"><label class=control-label><span translate=scene.linkIcon></span></label><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 35px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px;top:0px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile><div><span translate=title.uploadPicTip></span></div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div><span translate=btnTypeName.upload></span></div></div></div><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span style=\"color: red\">*</span><span translate=scene.cmdSetName></span></label><div class=col-lg-8><select required ng-model=vm.linkageCondition.cmdSetId class=form-control><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span style=\"color: red\">*</span><span translate=scene.cmdSetId></span></label><div class=col-lg-8><input required type=text class=form-control ng-model=vm.linkageCondition.cmdSetId disabled></div></div></div></div></div><div class=modal-footer><!--<div class=\"row\">--> <button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span><span translate=btnTypeName.save></span></button><!-- </div>--></div></form>");
$templateCache.put("app/iot/portal/admin/scm/html/addLinkageProduct.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  #toast-container {\n    z-index: 1100;\n  }</style><form name=editForm role=form ng-submit=vm.saveLinkageProduct()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=scene.sceneInfo></span></h4></div><div class=modal-body><div class=form-group><div class=row style=\"text-align: center\"><label class=control-label><span translate=scene.linkIcon></span></label><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 35px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px;top:0px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile><div><span translate=title.uploadPicTip></span></div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div><span translate=btnTypeName.upload></span></div></div></div><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span style=\"color: red\">*</span><span translate=scene.cmdSetName></span></label><div class=col-lg-8><select required ng-model=vm.linkageProduct.cmdSetId class=form-control><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span style=\"color: red\">*</span><span translate=scene.cmdSetId></span></label><div class=col-lg-8><input required type=text class=form-control ng-model=vm.linkageProduct.cmdSetId disabled></div></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span> <span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span> <span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/scm/html/addProductAction.html","<style>.modal-backdrop {\n        z-index: 1000;\n    }\n    #toast-container {\n        z-index: 1100;\n    }\n  form{\n    height: 600px;\n  }</style><form name=editForm role=form ng-submit=vm.saveProductAction()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=ml.actionConfig></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=ml.actionCode></span></label><input type=text ng-model=vm.productAction.actionCode class=form-control></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=ml.actionName></span></label><div class=input-group><input type=text class=form-control name=actionName id=field_productActionName ng-model=vm.productAction.actionName required readonly> <span class=input-group-btn><button id=localeBtn_productActionName disabled class=\"btn btn-default\" type=button ng-click=vm.showProductActionName() value=actionName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_productActionDesc><span style=\"color: red\">*</span><span translate=ml.actionDesc></span></label><div class=input-group><input type=text class=form-control name=actionDesc id=field_productActionDesc ng-model=vm.productAction.description required readonly> <span class=input-group-btn><button id=localeBtn_productActionDesc disabled class=\"btn btn-default\" type=button ng-click=vm.showProductActionDesc() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><div class=\"modal fade\" id=localeModal_productActionName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=ml.actionName></span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_productActionName type=hidden></div><div class=modal-body id=localeModelBody_productActionName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureProductActionName()><span translate=btnTypeName.save></span></button></div></div></div></div><div class=\"modal fade\" id=localeModal_productActionDesc style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=ml.actionDesc></span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_productActionDesc type=hidden></div><div class=modal-body id=localeModelBody_productActionDesc></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureProductActionDesc()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/addProductActionParams.html","<style>.modal-backdrop {\n        z-index: 1000;\n    }\n    #toast-container {\n        z-index: 1100;\n    }\n    form{\n      height: 600px;\n    }</style><form name=editForm role=form ng-submit=vm.saveactionParams()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=ml.paramDetail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><label class=control-label><span style=color:red>*</span><span translate=ml.paramCode></span></label><input type=text class=form-control ng-model=vm.actionParam.paramCode required></div><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=property.parameterName></span></label><div class=input-group><input type=text class=form-control name=paramName id=field_paramName ng-model=vm.actionParam.paramName required readonly> <span class=input-group-btn><button id=localBtn_paramName disabled class=\"btn btn-default\" type=button ng-click=vm.showParamName() value=paramName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=property.parameterType></span></label><select ng-model=vm.actionParam.paramType ng-options=\"x.value as x.name for x in vm.paramType\" class=form-control required></select></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=property.parameterRange></span></label><input type=text class=form-control ng-model=vm.actionParam.paramRange><!--<div class=\"input-group\">\n                        <input type=\"text\" class=\"form-control\" id=\"field_paramValue\" ng-model=\"vm.actionParam.paramRange\" required readonly>\n                        <span class=\"input-group-btn\">\n                                <button id=\"localBtn_paramValue\" disabled class=\"btn btn-default\" type=\"button\" ng-click=\"vm.showParamValue()\" value=\"paramRange\"><i class=\"fa fa-globe\"></i></button>\n                            </span>\n                    </div>--></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=color:red>*</span><span translate=property.parameterValue></span></label><input type=text class=form-control ng-model=vm.actionParam.defaultValue><!--<div class=\"input-group\">\n                        <input type=\"text\" class=\"form-control\" name=\"paramValue\" id=\"field_paramDefaultValue\"\n                               ng-model=\"vm.actionParam.defaultValue\" required readonly>\n                        <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" id=\"localBtn_paramDefaultValue\" disabled ng-click=\"vm.showParamDefaultValue()\" value=\"defaultValue\"><i class=\"fa fa-globe\"></i></button>\n                        </span>\n                    </div>--></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=sysConfig.description></span></label><div class=input-group><input type=text class=form-control name=paramValue id=field_paramDesc ng-model=vm.actionParam.description readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" id=localBtn_paramDesc disabled ng-click=vm.showParamDesc() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span><span translate=btnTypeName.save></span></button></div></div></form><!--modal action param name--><div class=\"modal fade\" id=localeModal_actionParamName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=property.parameterName></span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>x</span></button> <input type=hidden id=fieldName_actionParamName></div><div class=modal-body id=localeModelBody_actionParamName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureActionParamName()><span translate=btnTypeName.save></span></button></div></div></div></div><!--modal action param value--><!--<div class=\"modal fade\" id=\"localeModal_actionParamValue\" style=\"z-index: 2040; position: absolute;\" data-keyboard=\"false\" ng-init=\"init()\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">x</span></button>\n                <input type=\"hidden\" id=\"fieldName_actionParamValue\"></div>\n            <div class=\"modal-body\" id=\"localeModelBody_actionParamValue\"></div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\"><span translate=\"btnTypeName.cancel\"></span>\n                </button>\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.localeSureActionParamValue()\"><span\n                        translate=\"btnTypeName.save\"></span></button>\n            </div>\n        </div>\n    </div>\n</div>--><!--modal action param default value--><!--<div class=\"modal fade\" id=\"localeModal_actionParamDefaultValue\" style=\"z-index: 2040; position: absolute;\" data-keyboard=\"false\" ng-init=\"init()\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">x</span></button>\n                <input type=\"hidden\" id=\"fieldName_actionParamDefaultValue\"></div>\n            <div class=\"modal-body\" id=\"localeModelBody_actionParamDefaultValue\"></div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\"><span translate=\"btnTypeName.cancel\"></span>\n                </button>\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.localeSureDefaultValue()\"><span\n                        translate=\"btnTypeName.save\"></span></button>\n            </div>\n        </div>\n    </div>\n</div>--><!--modal action param descripiton--><div class=\"modal fade\" id=localeModal_actionParamDesc style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=ml.actionDesc></span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>x</span></button> <input type=hidden id=fieldName_actionParamDesc></div><div class=modal-body id=localeModelBody_actionParamDesc></div><div class=modal-footer><button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureActionParamDesc()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/addSceneProduct.html","<style>#toast-container {\n    z-index: 1200;\n  }</style><form name=editForm role=form ng-submit=vm.saveSceneProduct()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=scene.sceneInfo></span></h4></div><div class=modal-body><div class=form-group><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span style=\"color: red\">*</span><span translate=scene.sceneName></span></label><div class=col-lg-8><select ng-model=vm.sceneProduct.menuId class=form-control required><option ng-repeat=\"x in vm.menus\" value={{x.id}}>{{x.menuName}}</option></select></div></div><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span style=\"color: red\">*</span><span translate=scene.cmdSetName></span></label><div class=col-lg-8><select ng-model=vm.sceneProduct.cmdSetId class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div></div></div><div class=form-gorup><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span style=\"color: red\">*</span><span translate=scene.cmdSetId></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.sceneProduct.cmdSetId disabled required></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span> <span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span> <span translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/scm/html/addSmallParts.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n\n  #toast-container {\n    z-index: 1100;\n  }</style><form name=editForm role=form ng-submit=vm.save()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=plugin.smallPartDetail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label for=\"\" class=control-label><span style=\"color: red\">*</span><span translate=ml.cmdSetName></span></label><select class=form-control ng-model=vm.smallPart.cmdSetId required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.cmdSetNames\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div><div class=col-md-6><div class=form-group><label for=\"\" class=control-label><span style=\"color: red\">*</span><span translate=ml.cmdSetId></span></label><div class=input-group><input type=text class=form-control name=widgetName id=field_widgetName ng-model=vm.smallPart.cmdSetId disabled> <span class=input-group-btn></span></div></div></div></div></div><div class=modal-footer><div class=row><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></div></form>");
$templateCache.put("app/iot/portal/admin/scm/html/addSmallPartsFunction.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n\n  #toast-container {\n    z-index: 1100;\n  }\n  form{\n    height: 600px;\n  }</style><form name=editForm role=form ng-submit=vm.saveFunction()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=plugin.functionManage></span></h4></div><div class=modal-body><div class=row style=\"text-align: center; margin-bottom: 10px\"><label class=control-label><span translate=ml.actionImage></span></label><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 35px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px;top:0px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile><div><span translate=title.uploadPicTip></span></div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div><span translate=btnTypeName.upload></span></div></div></div><div class=row><div class=col-md-6><div class=form-gorup><label for=\"\" class=control-label><span style=\"color: red\">*</span><span translate=ml.actionName></span></label><div class=input-group><input type=text class=form-control name=functionName id=field_functionName ng-model=vm.smallPartFunction.functionName required readonly> <span class=input-group-btn><button id=localeBtn_functionName class=\"btn btn-default\" type=button ng-click=vm.showFunctionName() value=functionName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label for=\"\" class=control-label><span style=\"color: red\">*</span><span translate=command.cmdDefinition></span></label><textarea class=form-control rows=3 ng-model=vm.smallPartFunction.json required></textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><div class=\"modal fade\" id=localeModal_functionName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><span translate=ml.functionName></span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_functionName type=hidden></div><div class=modal-body id=localeModelBody_functionName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-click=vm.localeSureFunctionName()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/cusromizeOneTouchScene-dialog.html","<style>#toast-container {\n    z-index: 1200;\n  }\n\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=editForm role=form ng-submit=vm.submit()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=unifiedStructureProduct.customConfig></span></h4></div><div class=modal-body><div class=form-group><div class=row style=\"text-align: center\" ng-show=vm.imgShow><div class=row><label class=control-label><span ng-show=\"vm.unifiedStructureProduct.type === \'CUSTOM_UNIFIED\'\" translate=unifiedStructureProduct.sceneIcon></span> <span ng-show=\"vm.unifiedStructureProduct.type !== \'CUSTOM_UNIFIED\'\" translate=unifiedStructureProduct.linkIcon></span></label></div><input id=uploadImg ng-model=vm.file ng-change=vm.changeFile() ngf-select accept=image/png,image/jpg,image/jpeg,image/bmp,image/gif name=file size=1 style=\"left:calc(50% - 35px);position:absolute;opacity:0;z-index:100;cursor:pointer;width:120px;height:120px;top:0px\" type=file> <img id=js_avator style=width:120px;height:120px ngf-src=vm.oldFile><div><span ng-show=\"vm.unifiedStructureProduct.type === \'CUSTOM_UNIFIED\'\" translate=unifiedStructureProduct.updateImageTitle1></span> <span ng-show=\"vm.unifiedStructureProduct.type !== \'CUSTOM_UNIFIED\'\" translate=unifiedStructureProduct.updateImageTitle2></span></div><div ng-show=vm.varMay class=\"btn btn-primary\" style=\"margin-top: 0.5em\" ng-click=vm.submitFile()><div><span translate=btnTypeName.upload></span></div></div></div><div class=row><div class=col-lg-6><div class=form-group><label for=\"\" class=control-label><span style=\"color: red\">*</span><span translate=unifiedStructureProduct.type></span></label><!--<lookup-select lookup-value=\"vm.unifiedStructureProduct.type\"\n                           lookup-type=\"SYS.CUSROMIZE_ONE_TOUCH_SCENE\"></lookup-select>--><select ng-model=vm.unifiedStructureProduct.type ng-change=vm.typeChange() class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.types\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-6><div class=form-group><label for=\"\" class=control-label><span style=\"color: red\">*</span><span translate=unifiedStructureProduct.object></span></label><select ng-model=vm.unifiedStructureProduct.objectId class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div></div><div class=row><div class=col-lg-6><div class=form-group><label class=control-label for=field_description><span translate=unifiedStructureProduct.description></span></label><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.unifiedStructureProduct.description readonly> <span class=input-group-btn><button id=localeBtn_description disabled class=\"btn btn-default\" type=button ng-click=vm.showDescription() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span> <span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span> <span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModalBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureDescription()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/cusromizeOneTouchScene.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=unifiedStructureProduct.customConfig></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-md-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=unifiedStructureProduct.type></span></label><div class=col-lg-6><lookup-select lookup-value=vm.unifiedStructureProduct.type lookup-type=SYS.CUSROMIZE_ONE_TOUCH_SCENE></lookup-select></div></div><div class=col-md-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=unifiedStructureProduct.object></span></label><div class=col-lg-6><select class=form-control ng-model=vm.unifiedStructureProduct.objectId><option value=\"\"></option><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div></div></div><div class=row><div class=\"col-lg-4 col-lg-offset-9\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.search()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-primary\" ng-click=vm.reset()><span translate=btnTypeName.reset></span></button></div></div><hr><div class=row><div class=\"col-lg-4 col-lg-offset-2\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=cusromizeOneTouchScene.add()><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteSelects()><span translate=btnTypeName.del></span></button></div></div></div></div><div><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAll()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=unifiedStructureProduct.type></th><th translate=unifiedStructureProduct.object></th><th translate=unifiedStructureProduct.description></th></thead><tbody><tr ng-repeat=\"unifiedStructureProduct in vm.unifiedStructureProducts\"><th style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{unifiedStructureProduct.id}} ng-click=vm.checkUnifiedStruectureProduct()>&nbsp;&nbsp;</th><td style=\"width: 15%\"><a ui-sref=cusromizeOneTouchScene.edit({id:unifiedStructureProduct.id})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteOne(unifiedStructureProduct)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td><!--ng-bind=\"unifiedStructureProduct.type\"--><select data-ng-model=unifiedStructureProduct.type disabled><option ng-repeat=\"x in vm.types\" value={{x.value}}>{{x.meaning}}</option></select></td><td><select data-ng-model=unifiedStructureProduct.objectId disabled><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></td><td ng-bind=unifiedStructureProduct.description></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/intelligentLinkage.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=intelligentLinkage.link></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=intelligentLinkage.name></span></label><div class=col-lg-8><input type=text ng-model=vm.linkage.linkName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=intelligentLinkage.code></span></label><div class=col-lg-8><input type=text ng-model=vm.linkage.linkCode class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteLinkages()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=linkage.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 15%\"><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllLinkage()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th style=\"width: 20%\"><span translate=intelligentLinkage.name></span></th><th style=\"width: 10%\"><span translate=intelligentLinkage.code></span></th><th style=\"width: 5%\"><span translate=intelligentLinkage.linkIdentity></span></th><th style=\"width: 50%\"><span translate=intelligentLinkage.desc></span></th></tr></thead><tbody><tr ng-repeat=\"linkage in vm.linkages\"><td><input type=checkbox name=chk_list class=chk_list value={{linkage.linkId}} ng-click=vm.checkLinkage()>&nbsp;&nbsp; <a ui-sref=linkage.edit({linkId:linkage.linkId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ui-sref=linkageSetting({linkId:linkage.linkId})><i class=\"fa fa-view text-navy\"><span translate=btnTypeName.view></span></i></a> <a ng-click=vm.deleteLinkage(linkage)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{linkage.linkName}}</td><td>{{linkage.linkCode}}</td><td><select ng-model=linkage.attribute1 disabled><option ng-repeat=\"ste in vm.linkIdentitys\" value={{ste.value}}>{{ste.meaning}}</option></select></td><td>{{linkage.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/intelligentLinkageSettings.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=intelligentLinkage.linkSetting></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=intelligentLinkage.seasonScope></span></label><div class=col-lg-8><lookup-select lookup-value=vm.linkageSetting.seasonScope lookup-type=IOT.SCM_INTELLIGENT_LINKAGE_SEASON></lookup-select></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\">Json</label><div class=col-lg-8><input type=text ng-model=vm.linkageSetting.linkJson class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteLinkageSettings()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=linkageSetting.add({linkId:vm.linkageSetting.linkId})><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 20%\"><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllLinkageSettings()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th style=\"width: 10%\"><span translate=intelligentLinkage.scope></span></th><th><div style=\"width: 50% !important\">JSON</div></th><th style=\"width: 20%\"><span translate=intelligentLinkage.desc></span></th></tr></thead><tbody><tr ng-repeat=\"linkage in vm.linkageSettings\"><td><div style=\"width: 100px\"><input type=checkbox name=chk_list class=chk_list value={{linkage.linkSettingId}} ng-click=vm.checkLinkageSetting()>&nbsp;&nbsp; <a ui-sref=linkageSetting.edit({linkId:linkage.linkId,linkSettingId:linkage.linkSettingId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteLinkageSetting(linkage)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></div></td><td><select ng-model=linkage.seasonScope disabled><option ng-repeat=\"seasonScope in vm.lankageSeason\" value={{seasonScope.value}}>{{seasonScope.meaning}}</option></select></td><td style=\"width: 50%\">{{linkage.linkJson}}</td><td>{{linkage.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/linkageCondition.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=ml.linkageCondition></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=scene.cmdSetId></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.linkageCondition.cmdSetId></div></div><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=command.cmdCode></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.linkageCondition.cmdCode></div></div><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.conditionName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.linkageCondition.triggerName></div></div></div></div><div class=row><div class=\"col-lg-4 col-lg-offset-8\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.getLinkageCondition()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-primary\" ng-click=vm.reset()><span translate=btnTypeName.reset></span></button></div></div><hr><div class=row><div class=\"col-lg-4 col-lg-offset-1\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=linkageCondition.add()><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteLinkageConditions()><span translate=btnTypeName.del></span></button></div></div></div></div><div style=\"margin-top: 40px\"><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllLinkageCondition()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=scene.cmdSetName></th><th translate=scene.cmdSetId></th><!--<th translate=\"command.cmdCode\"></th>--><!--<th translate=\"property.parameter\"></th>--><!--<th translate=\"property.parameterValue\"></th>--><!--<th translate=\"ml.actionDesc\"></th>--></thead><tbody><tr ng-repeat=\"linkageCondition in vm.linkageConditions\"><td style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{linkageCondition.linkTriggerId}} ng-click=vm.checkLinkageCondition()></td><td style=\"width: 10%\">&nbsp;&nbsp; <a ui-sref=linkageCondition.edit({linkTriggerId:linkageCondition.linkTriggerId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteLinkageCondition(linkageCondition)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=linkageCondition.cmdSetName></td><td ng-bind=linkageCondition.cmdSetId></td><!--<td ng-bind=\"linkageCondition.cmdCode\"></td>--><!--<td ng-bind=\"linkageCondition.cmdParam\"></td>--><!--<td ng-bind=\"linkageCondition.cmdParamName\"></td>--><!--<td ng-bind=\"linkageCondition.description\"></td>--></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/linkageProduct.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=ml.linkageProduct></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=scene.cmdSetName></span></label><div class=col-lg-8><select ng-model=vm.linkageProduct.cmdSetId class=form-control><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=scene.cmdSetId></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.linkageProduct.cmdSetId></div></div></div></div><div class=row><div class=\"col-lg-4 col-lg-offset-9\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.getLinkageProduct()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-primary\" ng-click=vm.reset()><span translate=btnTypeName.reset></span></button></div></div><hr><div class=row><div class=\"col-lg-4 col-lg-offset-2\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=linkageProduct.add()><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteLinkageProducts()><span translate=btnTypeName.del></span></button></div></div></div></div><div><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllLinkageProduct()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=scene.cmdSetName></th><th translate=scene.cmdSetId></th></thead><tbody><tr ng-repeat=\"linkageProduct in vm.linkageProducts\"><th style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{linkageProduct.linkProductId}} ng-click=vm.checkLinkageProduct()>&nbsp;&nbsp;</th><td style=\"width: 15%\"><!--<a ui-sref=\"productAction({linkProductId:linkageProduct.linkProductId})\"><i\n                            class=\"fa fa-cog text-navy\"><span translate=\"ml.action\"\n                                                               ng-click=\"vm.getProductTypeName(linkageProduct.productTypeName)\"></span></i></a>--> <a ui-sref=linkageProduct.edit({linkProductId:linkageProduct.linkProductId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteLinkageProduct(linkageProduct)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=linkageProduct.cmdSetName></td><td ng-bind=linkageProduct.cmdSetId></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/productAction.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=scene.sceneAction></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"control-label col-lg-4\"><span translate=ml.productType></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.productAction.productTypeName disabled></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><label class=\"control-label col-lg-4\"><span translate=ml.actionName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.productAction.actionName></div></div><div class=col-lg-4><label class=\"control-label col-lg-4\"><span translate=ml.actionCode></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.productAction.actionCode></div></div></div></div><div class=row><div class=\"col-lg-1 col-lg-offset-6\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.getProductAction()><span translate=btnTypeName.search></span></button></div></div><hr><div class=row><div class=\"col-lg-4 col-lg-offset-1\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=productAction.add({linkProductId:vm.productAction.linkProductId})><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteProductActions()><span translate=btnTypeName.del></span></button></div></div></div></div><div style=\"margin-top: 40px\"><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProductAction()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=ml.actionCode></th><th translate=ml.actionName></th><th translate=ml.actionDesc></th></thead><tbody><tr ng-repeat=\"productAction in vm.productActions\"><td style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{productAction.linkActionId}} ng-click=vm.checkProductAction()></td><td style=\"width: 15%\"><a ui-sref=productActionParams({linkActionId:productAction.linkActionId})><i class=\"fa fa-sliders text-navy\"><span translate=ml.actionParams ng-click=vm.getProductAndActionName(productAction.actionName)></span></i></a> <a ui-sref=productAction.edit({linkActionId:productAction.linkActionId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteProductAction(productAction)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=productAction.actionCode></td><td ng-bind=productAction.actionName></td><td ng-bind=productAction.description></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/productActionParams.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=ml.paramList></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.productType></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.productActionParam.productTypeName disabled></div></div><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.actionName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.productActionParam.actionName disabled></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=property.parameterName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.productActionParam.paramName></div></div><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.paramCode></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.productActionParam.paramCode></div></div></div></div><div class=row><div class=\"col-lg-1 col-lg-offset-10\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.getProductActionParam()><span translate=btnTypeName.search></span></button></div></div><hr><div class=row><div class=\"col-lg-4 col-lg-offset-1\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=productActionParams.add({linkActionId:vm.productActionParam.linkActionId})><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteProductActionParams()><span translate=btnTypeName.del></span></button></div></div></div></div><div><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllProductActionParam()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=ml.paramCode></th><th translate=property.parameterName></th><th translate=property.parameterType></th><th translate=property.parameterRange></th><th translate=property.parameterValue></th><th translate=iRule.description></th></thead><tbody><tr ng-repeat=\"productActionParam in vm.productActionParams\"><td style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{productActionParam.linkActionParamId}} ng-click=vm.checkProductActionParam()>&nbsp;&nbsp;</td><td style=\"width: 10%\"><a ui-sref=productActionParams.edit({linkActionParamId:productActionParam.linkActionParamId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteProductActionParam(productActionParam)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=productActionParam.paramCode></td><td ng-bind=productActionParam.paramName></td><td>{{productActionParam.paramType==1?\'枚举\':\'数值范围\'}}</td><td ng-bind=productActionParam.paramRange></td><td ng-bind=productActionParam.defaultValue></td><td ng-bind=productActionParam.description></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/sceneProduct.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=scene.sceneProduct></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=scene.sceneName></span></label><div class=col-lg-8><select ng-model=vm.sceneProduct.menuId class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.menus\" value={{x.id}}>{{x.menuName}}</option></select></div></div><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=scene.cmdSetName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.sceneProduct.cmdSetName></div></div><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=scene.cmdSetId></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.sceneProduct.cmdSetId></div></div></div></div><div class=row><div class=\"col-lg-4 col-lg-offset-9\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.getSceneProduct()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-primary\" ng-click=vm.reset()><span translate=btnTypeName.reset></span></button></div></div><hr><div class=row><div class=\"col-lg-4 col-lg-offset-1\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=sceneProduct.add()><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteSceneProducts()><span translate=btnTypeName.del></span></button></div></div></div></div><div><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllSceneProduct()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=scene.sceneName></th><th translate=scene.cmdSetName></th><th translate=scene.cmdSetId></th></thead><tbody><tr ng-repeat=\"sceneProduct in vm.sceneProducts\"><td style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{sceneProduct.scenarioProductId}} ng-click=vm.checkSceneProduct()></td><td style=\"width: 14%\"><!--<a ui-sref=\"actionConfig({scenarioProductId:sceneProduct.scenarioProductId})\"><i class=\"fa fa-cog text-navy\"><span\n                            translate=\"ml.action\" ng-click=\"vm.getProductTypeName(sceneProduct)\"></span></i></a>--> <a ui-sref=sceneProduct.edit({scenarioProductId:sceneProduct.scenarioProductId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteSceneProduct(sceneProduct)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=sceneProduct.menuName></td><td ng-bind=sceneProduct.cmdSetName></td><td ng-bind=sceneProduct.cmdSetId></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/smallParts.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=plugin.smallPartManage></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.cmdSetName></span></label><div class=col-lg-8><select ng-model=vm.smallPart.cmdSetName class=form-control><option ng-repeat=\"x in vm.cmdSetNames\" value={{x.cmdSetName}}>{{x.cmdSetName}}</option></select></div></div><div class=col-lg-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.cmdSetId></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.smallPart.cmdSetId></div></div></div></div><div class=row><div class=\"col-lg-4 col-lg-offset-8\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.getSmallParts()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-primary\" ng-click=vm.reset()><span translate=btnTypeName.reset></span></button></div></div><hr><div class=row><div class=\"col-lg-5 col-lg-offset-2\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=smallPart.add()><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteSmallPartss()><span translate=btnTypeName.del></span></button></div></div></div></div><div style=\"margin-top: 40px\"><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllSmallParts()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=ml.cmdSetName></th><th translate=ml.cmdSetId></th></thead><tbody><tr ng-repeat=\"smallPart in vm.smallParts\"><!--ng-repeat=\"smallPart in vm.smallParts\"--><td style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{smallPart.widgetId}} ng-click=vm.checkSmallParts()></td><td style=\"width: 20%\"><a ui-sref=smallPartFunction({widgetId:smallPart.widgetId})><i class=\"fa fa-cog text-navy\"><span translate=ml.action ng-click=vm.getProductType(smallPart)></span></i></a> <a ui-sref=smallPart.edit({widgetId:smallPart.widgetId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteSmallParts(smallPart)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=smallPart.cmdSetName></td><td ng-bind=smallPart.cmdSetId></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/smallPartsFunction.html","<div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=plugin.functionManage></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.cmdSetName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.smallPartFunction.cmdSetName disabled></div></div><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.cmdSetName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.smallPartFunction.cmdSetId disabled></div></div><div class=col-lg-4><label for=\"\" class=\"col-lg-4 control-label\"><span translate=ml.actionName></span></label><div class=col-lg-8><input type=text class=form-control ng-model=vm.smallPartFunction.functionName></div></div></div></div><div class=row><div class=\"col-lg-4 col-lg-offset-8\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.getSmallPartFunctions()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-primary\" ng-click=vm.reset()><span translate=btnTypeName.reset></span></button></div></div><hr><div class=row><div class=\"col-lg-5 col-lg-offset-2\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=smallPartFunction.add({widgetId:vm.smallPartFunction.widgetId})><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteSmallPartFunctionss()><span translate=btnTypeName.del></span></button></div></div></div></div><div style=\"margin-top: 40px\"><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllSmallPartFunctions()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=ml.actionName></th><th translate=command.cmdDefinition></th><th translate=dvmProduct.productTypeImg></th></thead><tbody><tr ng-repeat=\"smallPartFunction in vm.smallPartFunctions\"><td style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{smallPartFunction.widgetFunctionId}} ng-click=vm.checkSmallPartFunctions()></td><td style=\"width: 10%\"><a ui-sref=smallPartFunction.edit({widgetFunctionId:smallPartFunction.widgetFunctionId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteSmallPartFunctions(smallPartFunction)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=smallPartFunction.functionName></td><td ng-bind=smallPartFunction.json></td><td><img ng-src={{smallPartFunction.imageUrl}} style=\"width: 30px;height: 30px\"></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/unifiedStructureProduct-dialog.html","<style>#toast-container {\n    z-index: 1200;\n  }\n\n  .modal-backdrop {\n    z-index: 1000;\n  }\n  .sweet-overlay{\n    z-index: 10000;\n  }\n  .sweet-alert{\n    z-index: 99999;\n  }</style><form name=editForm role=form ng-submit=vm.submit()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>x</button><h4 class=modal-title><span translate=unifiedStructureProduct.config></span></h4></div><div class=modal-body><div class=form-group><div class=row><div class=col-lg-6><div class=form-group><label for=\"\" class=control-label><span style=\"color: red\">*</span><span translate=unifiedStructureProduct.type></span></label><lookup-select lookup-value=vm.unifiedStructureProduct.type lookup-type=SCM.UNIFIED.STRUCTURE.TYPE></lookup-select></div></div><div class=col-lg-6><div class=form-group><label for=\"\" class=control-label><span style=\"color: red\">*</span><span translate=unifiedStructureProduct.object></span></label><select ng-model=vm.unifiedStructureProduct.objectId class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div></div><div class=row><div class=col-lg-6><div class=form-group><label class=control-label for=field_description><span translate=unifiedStructureProduct.description></span></label><div class=input-group><input type=text class=form-control name=description id=field_description ng-model=vm.unifiedStructureProduct.description readonly> <span class=input-group-btn><button id=localeBtn_description disabled class=\"btn btn-default\" type=button ng-click=vm.showDescription() value=description><i class=\"fa fa-globe\"></i></button></span></div></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=vm.clear()><span class=\"glyphicon gluphicon-remove\"></span> <span translate=btnTypeName.cancel></span></button> <button type=submit class=\"btn btn-primary\" ng-disabled=editForm.$invalid><span class=\"glyphicon gluphicon-save\"></span> <span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_description style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=localeModalBody_description></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureDescription()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/scm/html/unifiedStructureProduct.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div class=\"animated fadeInRight\"><div class=ibox-title><h5><span translate=unifiedStructureProduct.config></span></h5></div><div class=ibox-content><div class=form-horizontal><div class=form-group><div class=row><div class=col-md-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=unifiedStructureProduct.type></span></label><div class=col-lg-6><lookup-select lookup-value=vm.unifiedStructureProduct.type lookup-type=SCM.UNIFIED.STRUCTURE.TYPE></lookup-select></div></div><div class=col-md-6><label for=\"\" class=\"col-lg-4 control-label\"><span translate=unifiedStructureProduct.object></span></label><div class=col-lg-6><select class=form-control ng-model=vm.unifiedStructureProduct.objectId><option value=\"\"></option><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></div></div></div></div><div class=row><div class=\"col-lg-4 col-lg-offset-9\"><button class=\"btn btn-w-m btn-info\" ng-click=vm.search()><span translate=btnTypeName.search></span></button> <button class=\"btn btn-w-m btn-primary\" ng-click=vm.reset()><span translate=btnTypeName.reset></span></button></div></div><hr><div class=row><div class=\"col-lg-4 col-lg-offset-2\"><button class=\"btn btn-w-m btn-primary\" style=margin-right:40px ui-sref=unifiedStructureProduct.add()><span translate=btnTypeName.create></span></button> <button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteSelects()><span translate=btnTypeName.del></span></button></div></div></div></div><div><table class=\"table table-spriped\"><thead><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAll()></th><th><span translate=btnTypeName.operation class=ng-scope></span></th><th translate=unifiedStructureProduct.type></th><th translate=unifiedStructureProduct.object></th><th translate=unifiedStructureProduct.description></th></thead><tbody><tr ng-repeat=\"unifiedStructureProduct in vm.unifiedStructureProducts\"><th style=\"width: 4%\"><input type=checkbox name=chk_list class=chk_list value={{unifiedStructureProduct.id}} ng-click=vm.checkUnifiedStruectureProduct()>&nbsp;&nbsp;</th><td style=\"width: 15%\"><a ui-sref=unifiedStructureProduct.edit({id:unifiedStructureProduct.id})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteOne(unifiedStructureProduct)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td><!--ng-bind=\"unifiedStructureProduct.type\"--><select data-ng-model=unifiedStructureProduct.type disabled><option ng-repeat=\"x in vm.types\" value={{x.value}}>{{x.meaning}}</option></select></td><td><select data-ng-model=unifiedStructureProduct.objectId disabled><option ng-repeat=\"x in vm.cmdSets\" value={{x.cmdSetId}}>{{x.cmdSetName}}</option></select></td><td ng-bind=unifiedStructureProduct.description></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div>");
$templateCache.put("app/iot/portal/admin/sys/html/RegionAndRepairPhone.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=region.RegionAndRepairPhone></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=region.countryCode></span></label><div class=col-lg-8><select class=form-control ng-model=vm.region.countryCode><option value=\"\"></option><option ng-repeat=\"x in vm.countryRegion\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=region.repairCenter></span></label><div class=col-lg-8><select class=form-control ng-model=vm.region.companyName><option value=\"\"></option><option ng-repeat=\"x in vm.repairCenters\" value={{x.companyName}}>{{x.companyName}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-5><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteRegions()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=servicePhone.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-5><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllRegion()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=region.countryCode></span></th><th><span translate=region.regionCode></span></th><th><span translate=region.repairCenter></span></th></tr></thead><tbody><tr ng-repeat=\"region in vm.regions\"><td><input type=checkbox name=chk_list class=chk_list value={{region.countryServiceCenterId}} ng-click=vm.checkRegion()>&nbsp;&nbsp; <a ui-sref=servicePhone.edit({countryServiceCenterId:region.countryServiceCenterId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteRegion(region)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td><select ng-model=region.countryCode disabled><option ng-repeat=\"country in vm.countryRegion\" value={{country.value}}>{{country.meaning}}</option></select></td><td>{{region.regionCode}}</td><td><a ui-sref=servicePhone.view({serviceCenterId:region.serviceCenterId,isEdit:false})>{{region.companyName}}</a></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/sys/html/addCompanies.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addRepairCenter()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=region.repairCenter></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label for=field_companyName><span style=\"color: red\">*</span><span translate=region.company></span></label><div class=input-group><input type=text class=form-control name=companyName id=field_companyName ng-model=vm.repairCenter.companyName required readonly> <span class=input-group-btn><button id=localeBtn_companyName disabled class=\"btn btn-default\" type=button ng-click=vm.showCompanyName() value=companyName><i class=\"fa fa-globe\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_address><span style=\"color: red\">*</span><span translate=region.location></span></label><div class=input-group><input type=text class=form-control name=address id=field_address ng-model=vm.repairCenter.address required readonly> <span class=input-group-btn><button id=localeBtn_address disabled class=\"btn btn-default\" type=button ng-click=vm.showAddress() value=address><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=region.mailZip></span></label><input type=text class=form-control ng-model=vm.repairCenter.postcode ng-readonly=vm.CodeEditable></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=region.fax></span></label><input type=text class=form-control ng-model=vm.repairCenter.fax ng-readonly=vm.CodeEditable></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=region.email></span></label><input type=text class=form-control ng-model=vm.repairCenter.eMail ng-readonly=vm.CodeEditable></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=region.servicePhone1></span></label><input type=text class=form-control ng-model=vm.repairCenter.servicePhone1 required ng-readonly=vm.CodeEditable></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=region.servicePhone2></span></label><input type=text class=form-control ng-model=vm.repairCenter.servicePhone2 ng-readonly=vm.CodeEditable></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=region.servicePhone3></span></label><input type=text class=form-control ng-model=vm.repairCenter.servicePhone3 ng-readonly=vm.CodeEditable></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span translate=region.servicePhone4></span></label><input type=text class=form-control ng-model=vm.repairCenter.servicePhone4 ng-readonly=vm.CodeEditable></div></div><div class=col-md-6><div class=form-group><label class=control-label><span translate=region.servicePhone5></span></label><input type=text class=form-control ng-model=vm.repairCenter.servicePhone5 ng-readonly=vm.CodeEditable></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\" ng-show=vm.isEdit><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=localeModal_companyName style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_companyName type=hidden></div><div class=modal-body id=localeModelBody_companyName></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureCompanyName()><span translate=btnTypeName.save></span></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=localeModal_address style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_address type=hidden></div><div class=modal-body id=localeModelBody_address></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureAddress()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/sys/html/addCountryAndRegion.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }</style><form name=addForm role=form ng-submit=vm.addRegion()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=region.new></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=region.countryCode></span></label><select class=form-control ng-model=vm.region.countryCode required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.countryRegion\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-md-6><div class=form-group><label class=control-label for=field_regionCode><span translate=region.regionCode></span></label><div class=input-group><input type=text class=form-control name=regionCode id=field_regionCode ng-model=vm.region.regionCode readonly> <span class=input-group-btn><button id=localeBtn_regionCode disabled class=\"btn btn-default\" type=button ng-click=vm.showRegion() value=regionCode><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=region.repairCenter></span></label><select class=form-control ng-model=vm.region.serviceCenterId required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.repairCenters\" value={{x.serviceCenterId}} ng-selected=\"vm.region.serviceCenterId==x.serviceCenterId\">{{x.companyName}}</option></select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!--Model--><div class=\"modal fade\" id=localeModal_regionCode style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <input id=fieldName_regionCode type=hidden></div><div class=modal-body id=localeModelBody_regionCode></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.localeSureRegionCode()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/sys/html/addUnit.html","<style>.modal-backdrop {\n    z-index: 1000;\n  }\n  #toast-container {\n    z-index: 1100;\n  }\n  .sweet-alert{\n    z-index: 1099;\n  }</style><form name=addForm role=form ng-submit=vm.addUnit()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel><span translate=unit.detail></span></h4></div><div class=modal-body><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=unit.code></span></label><input type=text class=form-control ng-model=vm.unit.unitCode required ng-disabled=vm.unit.unitId></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=unit.name></span></label><div class=input-group><input type=text class=form-control name=unitName ng-model=vm.unit.unitName required readonly> <span class=input-group-btn><button id=unitNameBtn disabled class=\"btn btn-default\" type=button ng-click=vm.showUnitName() value=unitName><i class=\"fa fa-globe\"></i></button></span></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=unit.precise></span></label><input type=text class=form-control ng-model=vm.unit.conversionPrecision required></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=unit.mainUnit></span></label><lookup-select lookup-value=vm.unit.primaryFlag lookup-type=SYS.YES_NO></lookup-select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=unit.symbol></span></label><input type=text class=form-control ng-model=vm.unit.unitSymbol required></div></div><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=unit.type></span></label><lookup-select lookup-value=vm.unit.unitType lookup-type=IOT.SYS_UNIT_TYPE></lookup-select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label class=control-label><span style=\"color: red\">*</span><span translate=unit.translated></span></label><input type=text class=form-control ng-model=vm.unit.conversionRule required></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span><span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=addForm.$invalid class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span><span translate=btnTypeName.save></span></button></div></form><!-- Modal --><div class=\"modal fade\" id=unitNameModel style=\"z-index: 2040; position: absolute\" data-keyboard=false ng-init=init()><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body id=unitNameModelBody></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal><span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-primary\" ng-click=vm.unitNameSure()><span translate=btnTypeName.save></span></button></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/sys/html/grayRelease.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .control-label {\n    margin-top: 7px;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=grayRelease.grayRelease></span></h5></div><div class=ibox-content><div class=row><div id=eContainerTotal class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie1 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div><div class=\"col-lg-6 col-md-6\" style=\"margin-bottom: 10px; height: 357px; padding-left: 0\"><div id=pie2 class=\"col-lg-offset-1 col-md-offset-1 col-lg-10 col-md-10\" style=\"padding-left: 0\"></div></div></div><div class=row style=\"margin-top: 20px;margin-bottom: 50px\"><div class=text-center><button type=button ng-click=vm.resetGrayUser() class=\"btn btn-warning\"><span class=\"glyphicon glyphicon-repeat\"></span>&nbsp;<span translate=btnTypeName.reset></span></button> <button type=button ng-click=vm.initData() class=\"btn btn-info\" style=\"margin-left: 5px\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=btnTypeName.flush></span></button></div></div><form name=editStatusForm role=form novalidate ng-submit=vm.updateStatus()><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-3 control-label\"><span translate=grayRelease.status></span></label><div class=col-lg-8><span class=form-control>{{vm.old.statusMeaning}}</span></div></div><div class=col-lg-5><label class=\"col-lg-3 control-label\"><span translate=grayRelease.nextStatus></span></label><div class=col-lg-8><select ng-model=vm.config.status required class=form-control><option value=\"\"></option><option ng-repeat=\"x in vm.nextStatus\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-2><button type=submit ng-disabled=\"editStatusForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form><form name=editPercentageForm role=form novalidate ng-submit=vm.updatePercentage()><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-3 control-label\"><span translate=grayRelease.percentage></span></label><div class=col-lg-8><span class=form-control>{{vm.old.percentage}}</span></div></div><div class=col-lg-5><label class=\"col-lg-3 control-label\"><span translate=grayRelease.nextPercentage></span></label><div class=col-lg-8><input type=number id=percentage name=percentage ng-model=vm.config.percentage required class=form-control max={{vm.old.maxPercentage}} min={{vm.old.minPercentage}} ng-model=/^(\\d|[1-9]\\d|100)$/ ></div></div><div class=col-lg-2><button type=submit ng-disabled=\"editPercentageForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div><div style=margin-left:17px><h4><span translate=grayRelease.baseInfo></span></h4></div><div class=ibox-content><form name=editBaseInfoForm role=form novalidate ng-submit=vm.updateBaseInfo()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.activeUserTotal></span></label><div class=col-lg-8><input type=number id=activeUserTotal name=activeUserTotal ng-model=vm.config.activeUserTotal class=form-control min=1 ng-pattern=/^([1-9]\\d*)$/ ></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.podVersion></span></label><div class=col-lg-8><input type=text id=podVersion name=podVersion ng-model=vm.config.podVersion class=form-control ng-pattern=/^(0|[1-9]\\d*)(\\.(0|[1-9]\\d*))*$/ ></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.appAndroidVersion></span></label><div class=col-lg-8><input type=text id=appAndroidVersion name=appAndroidVersion ng-model=vm.config.appAndroidVersion class=form-control ng-pattern=/^(0|[1-9]\\d*)(\\.(0|[1-9]\\d*))*$/ ></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.appIosVersion></span></label><div class=col-lg-8><input type=text id=appIosVersion name=appIosVersion ng-model=vm.config.appIosVersion class=form-control ng-pattern=/^(0|[1-9]\\d*)(\\.(0|[1-9]\\d*))*$/ ></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.releaseServiceIp></span></label><div class=col-lg-8><input type=text id=releaseServiceIp name=releaseServiceIp ng-model=vm.config.releaseServiceIp class=form-control placeholder=http://{serviceIP}:8080/{serviceId}></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.normalServiceIp></span></label><div class=col-lg-8><input type=text id=normalServiceIp name=normalServiceIp ng-model=vm.config.normalServiceIp class=form-control placeholder=http://{serviceIP}:8080/{serviceId}></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.duration></span></label><div class=col-lg-8><input type=number id=duration name=duration ng-model=vm.config.duration class=form-control min=0 ng-pattern=/^([1-9]\\d*)$/ ></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.defaultEnvFlag></span></label><div class=col-lg-8><input type=text id=defaultEnvFlag name=defaultEnvFlag ng-model=vm.config.defaultEnvFlag class=form-control placeholder=prd></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=submit ng-disabled=\"editBaseInfoForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div><div style=margin-left:17px><h4><span translate=grayRelease.apimConfig></span></h4></div><div class=ibox-content><form name=editApimConfigForm role=form novalidate ng-submit=vm.updateApimConfig()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.tenantId></span></label><div class=col-lg-8><input type=text id=tenantId name=tenantId ng-model=vm.config.tenantId class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.subscriptionId></span></label><div class=col-lg-8><input type=text id=subscriptionId name=subscriptionId ng-model=vm.config.subscriptionId class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.clientId></span></label><div class=col-lg-8><input type=text id=clientId name=clientId ng-model=vm.config.clientId class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.clientSecret></span></label><div class=col-lg-8><input type=password id=clientSecret name=clientSecret ng-model=vm.config.clientSecret class=form-control placeholder=(hidden)></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.resourceGroup></span></label><div class=col-lg-8><input type=text id=resourceGroup name=resourceGroup ng-model=vm.config.resourceGroup class=form-control></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=grayRelease.apiService></span></label><div class=col-lg-8><input type=text id=apiService name=apiService ng-model=vm.config.apiService class=form-control></div></div></div></div><div class=form-group><div class=row style=\"margin-bottom: 50px\"><div class=text-center><button type=submit ng-disabled=\"editApimConfigForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/sys/html/repairCompanies.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=region.repairCompany></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-5><label class=\"col-lg-4 control-label\"><span translate=region.repairCompany></span></label><div class=col-lg-8><input type=text ng-model=vm.repairCenter.companyName class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-5><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteRepairCenters()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=repairCenter.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-5><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllRepairCenters()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=region.company></span></th><th><span translate=region.location></span></th><th><span translate=region.mailZip></span></th><th><span translate=region.fax></span></th><th><span translate=region.email></span></th><th><span translate=region.servicePhone1></span></th></tr></thead><tbody><tr ng-repeat=\"repairCenter in vm.repairCenters\"><td><input type=checkbox name=chk_list class=chk_list value={{repairCenter.serviceCenterId}} ng-click=vm.checkRepairCenter()>&nbsp;&nbsp; <a ui-sref=repairCenter.edit({serviceCenterId:repairCenter.serviceCenterId,isEdit:true})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ui-sref=repairCenter.view({serviceCenterId:repairCenter.serviceCenterId,isEdit:false})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.view></span></i></a> <a ng-click=vm.deleteRepairCenter(repairCenter)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{repairCenter.companyName}}</td><td>{{repairCenter.address}}</td><td>{{repairCenter.postcode}}</td><td>{{repairCenter.fax}}</td><td>{{repairCenter.eMail}}</td><td>{{repairCenter.servicePhone1}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/sys/html/unit.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5><span translate=unit.maintenance></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=unit.name></span></label><div class=col-lg-8><input type=text ng-model=vm.unit.unitName class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\"><span translate=unit.type></span></label><div class=col-lg-8><lookup-select lookup-value=vm.unit.unitType lookup-type=IOT.SYS_UNIT_TYPE></lookup-select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-4><div class=\"col-lg-4 pull-right m-t-n-xs\"><button class=\"btn btn-w-m btn-danger\" ng-click=vm.deleteUnits()><span translate=btnTypeName.del></span></button></div><div class=\"col-lg-4 pull-right m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" ui-sref=sysunit.add()><span translate=btnTypeName.create></span></a></div></div><div class=col-lg-4></div><div class=col-lg-4><div class=\"col-lg-8 pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.resetUnit()><span translate=btnTypeName.reset></span></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search()><span translate=btnTypeName.search></span></button></div></div></div></div></form><div style=margin-top:40px><table class=\"table table-striped table-hover\"><thead><tr><th><input type=checkbox name=chk_all id=chk_all ng-click=vm.checkAllUnit()>&nbsp;&nbsp;&nbsp;&nbsp;<span translate=btnTypeName.operation></span></th><th><span translate=unit.code></span></th><th><span translate=unit.name></span></th><th><span translate=unit.precise></span></th><th><span translate=unit.type></span></th><th><span translate=unit.mainUnit></span></th><th><span translate=unit.symbol></span></th><th><span translate=unit.translated></span></th></tr></thead><tbody><tr ng-repeat=\"unit in vm.units\"><td><input type=checkbox name=chk_list class=chk_list value={{unit.unitId}} ng-click=vm.checkUnit()>&nbsp;&nbsp; <a ui-sref=sysunit.edit({unitId:unit.unitId})><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteUnit(unit)><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td>{{unit.unitCode}}</td><td>{{unit.unitName}}</td><td>{{unit.conversionPrecision}}</td><td><select ng-model=unit.unitType disabled><option ng-repeat=\"x in vm.unitTypes\" value={{x.value}}>{{x.meaning}}</option></select></td><td><select ng-model=unit.primaryFlag disabled><option ng-repeat=\"x in vm.primaryFlagTypes\" value={{x.value}}>{{x.meaning}}</option></select></td><td>{{unit.unitSymbol}}</td><td>{{unit.conversionRule}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged(vm.page)></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/user/html/user-edit.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .control-label {\n    margin-top: 7px;\n  }</style><div class=row><div class=col-lg-12><div class=ibox-title><h5><span translate=userManage.userMange></span></h5></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.saveUser()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span><span translate=userManage.loginName></span></label><div class=col-lg-8><span style=\"word-break: break-all;white-space: normal;overflow-y: auto\" class=form-control>{{vm.user.partyAccount}}</span></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.telephone></span></label><div class=col-lg-8><input type=text id=phoneNumber name=phoneNumber ng-model=vm.user.phoneNumber class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=userManage.displayName></span></label><div class=col-lg-8><input type=text id=displayName name=displayName ng-model=vm.user.displayName class=form-control required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=userManage.mailNickname></span></label><div class=col-lg-8><input type=text id=mailNickname name=mailNickname ng-model=vm.user.mailNickname class=form-control required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span><span translate=userManage.status></span></label><div class=col-lg-8><select ng-model=vm.user.partyStatus class=form-control ng-change=vm.changeUserStatus()><option ng-repeat=\"x in vm.partyStatus\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span><span translate=userManage.role></span></label><div ng-if=\"vm.user.partyAccount != vm.loginName\" class=col-lg-8><select ng-model=vm.user.roleId class=form-control ng-options=\"x.roleId as x.roleName for x in vm.roles\" required><option value=\"\" ng-show=false></option></select></div><div ng-if=\"vm.user.partyAccount == vm.loginName\" class=col-lg-8><table class=col-lg-12><tr ng-repeat=\" x in vm.roles\"><td ng-if=\"vm.user.roleId == x.roleId\"><span class=form-control>{{x.roleName}}</span></td></tr></table></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.passwordInit></span></label><div class=col-lg-8><input type=password id=passwordInit name=passwordInit ng-model=vm.user.password class=form-control placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\"></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.passwordConfirm></span></label><div class=col-lg-8><input type=password id=passwordConfirm ng-blur=vm.validatePwd() name=passwordConfirm ng-model=vm.user.passwordConfirm class=form-control placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\"></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span><span translate=userManage.timeZone></span></label><div class=col-lg-8><select id=field_roleType ng-model=vm.user.timeZone class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.timeZone\" value={{x.value}}>{{x.meaning}}</option></select><!--<lookup-select lookup-value=\"vm.user.timeZone\" lookup-type=\"SYS.TIME_ZONE\" required=\"true\"></lookup-select>--></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.operationType></span></label><div class=col-lg-8><select ng-model=vm.user.operation class=form-control><option></option><option ng-repeat=\"x in vm.operationList\" value={{x.value}}>{{x.meaning}}</option></select></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button ng-click=vm.showOrHidePwd() class=\"btn btn-warning\"><span ng-if=vm.showPwdEnabled translate=btnTypeName.showPwd></span> <span ng-if=!vm.showPwdEnabled translate=btnTypeName.hidePwd></span></button> <button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=button class=\"btn btn-info\" ng-disabled=!vm.user.operation ng-click=vm.operate()><span class=\"glyphicon glyphicon-hand-right\"></span>&nbsp;<span translate=btnTypeName.operation></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/user/html/user-new.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n  .control-label {\n    margin-top: 7px;\n  }</style><div class=row><div class=col-lg-12><div class=ibox-title><h5><span translate=userManage.userMange></span></h5></div><div class=\"ibox float-e-margins\"><div class=ibox-content><form name=editForm role=form novalidate ng-submit=vm.saveUser()><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span>` <span translate=userManage.loginName></span></label><div class=col-lg-4><input type=text id=userName name=userName ng-model=vm.user.partyAccount class=form-control required></div><p style=\"display:inline-block;opacity: 0.7;margin-top: 7px;font-weight: bold;width: 200px\"><span ng-bind=vm.suffix ng-cloak style=\"overflow: hidden;text-overflow: ellipsis;display: block\" data-toggle=tooltip data-placement=top title={{vm.suffix}}></span></p></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span translate=userManage.telephone></span></label><div class=col-lg-8><input type=text id=phoneNumber name=phoneNumber ng-model=vm.user.phoneNumber class=form-control></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=userManage.displayName></span></label><div class=col-lg-8><input type=text id=displayName name=displayName ng-model=vm.user.displayName class=form-control required></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span> <span translate=userManage.mailNickname></span></label><div class=col-lg-8><input type=text id=mailNickname name=mailNickname ng-model=vm.user.mailNickname class=form-control required></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span><span translate=userManage.status></span></label><div class=col-lg-8><select ng-model=vm.user.partyStatus class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.states\" value={{x.value}}>{{x.meaning}}</option></select></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span><span translate=userManage.role></span></label><div class=col-lg-8><select ng-model=vm.user.roleId class=form-control ng-options=\"x.roleId as x.roleName for x in vm.roles\" required><option value=\"\" ng-show=false></option></select></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span><span translate=userManage.passwordInit></span></label><div class=col-lg-8><input type=password id=passwordInit name=passwordInit ng-model=vm.user.password class=form-control placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" required ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\"></div></div><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span><span translate=userManage.passwordConfirm></span></label><div class=col-lg-8><input type=password id=passwordConfirm ng-blur=vm.validatePwd() id=passwordConfirm name=passwordConfirm ng-model=vm.user.passwordConfirm class=form-control placeholder=\"{{\'userManage.passwordRegEx\' | T}}\" required ng-pattern=\"/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/\"></div></div></div></div><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-3 control-label\"><span style=color:red>*</span><span translate=userManage.timeZone></span></label><div class=col-lg-8><select id=field_roleType ng-model=vm.user.timeZone class=form-control required><option value=\"\" ng-show=false></option><option ng-repeat=\"x in vm.timeZone\" value={{x.value}}>{{x.meaning}}</option></select><!--<lookup-select lookup-value=\"vm.user.timeZone\" lookup-type=\"SYS.TIME_ZONE\" required=\"true\"></lookup-select>--></div></div></div></div><div class=form-group><div class=row><div class=text-center><button type=button ng-click=vm.showOrHidePwd() class=\"btn btn-warning\"><span ng-if=vm.showPwdEnabled translate=btnTypeName.showPwd></span> <span ng-if=!vm.showPwdEnabled translate=btnTypeName.hidePwd></span></button> <button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=btnTypeName.save></span></button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/iot/portal/admin/user/html/user.html","<style>select {\n    background: none;\n    border: none;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }</style><div><div class=ibox-title><h5><span translate=userManage.userMange></span></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-6><label class=\"col-lg-2 control-label\"><span translate=userManage.userName></span></label><div class=col-lg-6><input type=text id=searchUserName class=form-control ng-model=vm.searchUserName></div><button id=searchBtn class=\"col-lg-3 btn btn-w-m btn-primary\" type=button translate=btnTypeName.search ng-click=vm.queryUsersByCondition()></button></div><div class=col-lg-6><div class=\"col-lg-3 pull-right m-t-n-xs\" style=\"margin-top: 0px;width: 114%\"><a class=\"btn btn-w-m btn-info\" ui-sref=\"user.new({id:user.partyId })\" translate=btnTypeName.create></a></div></div></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th><span translate=btnTypeName.operation></span></th><th><span translate=userManage.loginName></span></th><th><span translate=userManage.telephone></span></th><th><span translate=userManage.role></span></th><th><span translate=userManage.status></span></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.partyId \"><td><a ui-sref=\"user.edit({partyId :user.partyId })\"><i class=\"fa fa-edit text-navy\"><span translate=btnTypeName.edit></span></i></a> <a ng-click=vm.deleteUser(user) ng-if=\"user.partyAccount != vm.loginName\"><i class=\"fa fa-times text-navy\"><span translate=btnTypeName.del></span></i></a></td><td ng-bind=user.partyAccount></td><td ng-bind=user.phoneNumber></td><td><select ng-model=user.roleId disabled ng-options=\"x.roleId as x.roleName for x in vm.roles\"></select></td><td><select ng-model=user.partyStatus disabled><option ng-repeat=\"x in vm.partyStatus\" value={{x.value}}>{{x.meaning}}</option></select></td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div>");
$templateCache.put("app/iot/portal/admin/inm/jsonTemplate/html/addJsonTemplate.html","<form name=addForm role=form novalidate ng-submit=vm.add()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=btnTypeName.create></h4></div><div class=modal-body><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_Type translate=command.type></label><input type=text class=form-control name=types id=field_Type ng-model=vm.jsonTemplate.type required></div></div></div><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_TemplateJson translate=command.templateJson></label><textarea rows=5 type=text class=form-control name=templateJson id=field_TemplateJson ng-model=vm.jsonTemplate.templateJson required></textarea></div></div></div><div class=row><div class=col-md-12><div class=form-group><font color=red>*</font><label class=control-label for=field_Description translate=command.description></label><textarea rows=2 type=text class=form-control name=description id=field_Description ng-model=vm.jsonTemplate.description required></textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\" translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\" translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/inm/jsonTemplate/html/deleteJsonTemplate.html","<form name=addForm role=form ng-submit=vm.remove()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel>删除</h4></div><div class=modal-body>确认删除？</div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\"></span>取消</button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>确认</button></div></form>");
$templateCache.put("app/iot/portal/admin/inm/jsonTemplate/html/editJsonTemplate.html","<form name=editForm role=form novalidate ng-submit=vm.update()><div class=modal-header><alert-error></alert-error><button type=button class=close data-dismiss=modal aria-hidden=true ng-click=vm.clear()>&times;</button><h4 class=modal-title id=myAfwkFunctionLabel translate=btnTypeName.edit></h4></div><div class=modal-body><div class=row><div class=col-md-12><div class=form-group><span style=color:red>*</span><label class=control-label for=field_Type translate=command.type></label><input type=text class=form-control name=types id=field_Type ng-model=vm.jsonTemplate.type required></div></div></div><div class=row><div class=col-md-12><div class=form-group><span style=color:red>*</span><label class=control-label for=field_TemplateJson translate=command.templateJson></label><textarea rows=5 type=text class=form-control name=templateJson id=field_TemplateJson ng-model=vm.jsonTemplate.templateJson required></textarea></div></div></div><div class=row><div class=col-md-12><div class=form-group>*<label class=control-label for=field_Description translate=command.description></label><textarea rows=2 type=text class=form-control name=description id=field_Description ng-model=vm.jsonTemplate.description required></textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=vm.clear()><span class=\"glyphicon glyphicon-ban-circle\" translate=btnTypeName.cancel></span></button> <button type=submit ng-disabled=\"addForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\" translate=btnTypeName.save></span></button></div></form>");
$templateCache.put("app/iot/portal/admin/inm/jsonTemplate/html/jsonTemplate.html","<div><div class=row><div class=col-lg-12><div class=\"ibox float-e-margins\"><div class=ibox-title><h5 translate=command.template></h5></div><div class=ibox-content><form class=form-horizontal><div class=form-group><div class=row><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.type></label><div class=col-lg-8><input type=text ng-model=vm.jsonTemplate.type class=form-control></div></div><div class=col-lg-4><label class=\"col-lg-4 control-label\" translate=command.description></label><div class=col-lg-8><input type=text ng-model=vm.jsonTemplate.description class=form-control></div></div><div class=col-lg-4><div class=\"pull-right m-t-n-xs\"><button class=\"btn btn-white\" type=reset ng-click=vm.reset() translate=btnTypeName.reset></button> <button class=\"btn btn-w-m btn-primary\" type=button ng-click=vm.search() translate=btnTypeName.search></button></div></div></div></div><div class=form-group><div class=row><div class=col-lg-3><div class=\"col-lg-8 m-t-n-xs\"><a class=\"btn btn-w-m btn-info\" style=\"margin-top: 20px\" ui-sref=jsonTemplate.add() translate=btnTypeName.create></a></div></div></div></div></form><!--<div class=\"hr-line-dashed\"></div>--><div style=margin-top:50px><table class=\"table table-striped table-hover\"><thead><tr><th width=10% translate=btnTypeName.operation></th><th width=5% translate=command.seq></th><th width=5% translate=command.type></th><th translate=command.templateJson></th><th translate=command.description></th></tr></thead><tbody><tr ng-repeat=\"jsonTemplate in vm.result\"><td><a ui-sref=jsonTemplate.edit({templateId:jsonTemplate.templateId})><i class=\"fa fa-edit text-navy\" translate=btnTypeName.edit></i></a> <a ng-click=vm.delete(jsonTemplate)><i class=\"fa fa-times text-navy\" translate=btnTypeName.del></i></a></td><td>{{jsonTemplate.templateId}}</td><td>{{jsonTemplate.type}}</td><td>{{jsonTemplate.templateJson}}</td><td>{{jsonTemplate.description}}</td></tr></tbody></table></div><div class=text-center><item-count page=vm.page total=vm.totalItems items-per-page=vm.itemsPerPage></item-count><uib-pagination class=pagination-sm total-items=vm.totalItems ng-model=vm.page ng-change=vm.pageChanged()></uib-pagination></div></div></div></div></div></div>");}]);